var kJ = Object.defineProperty;
var RJ = (e, t, n) => t in e ? kJ(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var nt = (e, t, n) => RJ(e, typeof t != "symbol" ? t + "" : t, n);
import * as E from "react";
import ye, { createContext as j0, useContext as pa, useState as Uc, useReducer as V8, useRef as Gt, useCallback as Rt, useEffect as mn, useMemo as Nn, forwardRef as xp, Children as PJ, isValidElement as Um, cloneElement as Wm, Component as AJ, createElement as Y8, useLayoutEffect as F0, useImperativeHandle as G8, Fragment as IJ } from "react";
var zO = function(e, t) {
  return zO = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
  }, zO(e, t);
};
function MJ(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  zO(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var En = function() {
  return En = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, En.apply(this, arguments);
};
function xR(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function gs(e, t, n, r) {
  function o(i) {
    return i instanceof n ? i : new n(function(a) {
      a(i);
    });
  }
  return new (n || (n = Promise))(function(i, a) {
    function c(d) {
      try {
        u(r.next(d));
      } catch (f) {
        a(f);
      }
    }
    function l(d) {
      try {
        u(r.throw(d));
      } catch (f) {
        a(f);
      }
    }
    function u(d) {
      d.done ? i(d.value) : o(d.value).then(c, l);
    }
    u((r = r.apply(e, t || [])).next());
  });
}
function vs(e, t) {
  var n = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, r, o, i, a = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return a.next = c(0), a.throw = c(1), a.return = c(2), typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function c(u) {
    return function(d) {
      return l([u, d]);
    };
  }
  function l(u) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, u[0] && (n = 0)), n; ) try {
      if (r = 1, o && (i = u[0] & 2 ? o.return : u[0] ? o.throw || ((i = o.return) && i.call(o), 0) : o.next) && !(i = i.call(o, u[1])).done) return i;
      switch (o = 0, i && (u = [u[0] & 2, i.value]), u[0]) {
        case 0:
        case 1:
          i = u;
          break;
        case 4:
          return n.label++, { value: u[1], done: !1 };
        case 5:
          n.label++, o = u[1], u = [0];
          continue;
        case 7:
          u = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (i = n.trys, !(i = i.length > 0 && i[i.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            n = 0;
            continue;
          }
          if (u[0] === 3 && (!i || u[1] > i[0] && u[1] < i[3])) {
            n.label = u[1];
            break;
          }
          if (u[0] === 6 && n.label < i[1]) {
            n.label = i[1], i = u;
            break;
          }
          if (i && n.label < i[2]) {
            n.label = i[2], n.ops.push(u);
            break;
          }
          i[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      u = t.call(e, n);
    } catch (d) {
      u = [6, d], o = 0;
    } finally {
      r = i = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function NJ(e, t, n) {
  for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function Fi(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") {
    var o = 0;
    for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  }
  return n;
}
var bc = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function HC(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function VC(e, t) {
  return e(t = { exports: {} }, t.exports), t.exports;
}
var hc = VC(function(e, t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  var n = function() {
    function r() {
      var o = this;
      this.locked = /* @__PURE__ */ new Map(), this.addToLocked = function(i, a) {
        var c = o.locked.get(i);
        c === void 0 ? a === void 0 ? o.locked.set(i, []) : o.locked.set(i, [a]) : a !== void 0 && (c.unshift(a), o.locked.set(i, c));
      }, this.isLocked = function(i) {
        return o.locked.has(i);
      }, this.lock = function(i) {
        return new Promise(function(a, c) {
          o.isLocked(i) ? o.addToLocked(i, a) : (o.addToLocked(i), a());
        });
      }, this.unlock = function(i) {
        var a = o.locked.get(i);
        if (a !== void 0 && a.length !== 0) {
          var c = a.pop();
          o.locked.set(i, a), c !== void 0 && setTimeout(c, 0);
        } else o.locked.delete(i);
      };
    }
    return r.getInstance = function() {
      return r.instance === void 0 && (r.instance = new r()), r.instance;
    }, r;
  }();
  t.default = function() {
    return n.getInstance();
  };
});
HC(hc);
var DJ = HC(VC(function(e, t) {
  var n = bc && bc.__awaiter || function(d, f, h, v) {
    return new (h || (h = Promise))(function(y, g) {
      function b(S) {
        try {
          $(v.next(S));
        } catch (O) {
          g(O);
        }
      }
      function x(S) {
        try {
          $(v.throw(S));
        } catch (O) {
          g(O);
        }
      }
      function $(S) {
        S.done ? y(S.value) : new h(function(O) {
          O(S.value);
        }).then(b, x);
      }
      $((v = v.apply(d, f || [])).next());
    });
  }, r = bc && bc.__generator || function(d, f) {
    var h, v, y, g, b = { label: 0, sent: function() {
      if (1 & y[0]) throw y[1];
      return y[1];
    }, trys: [], ops: [] };
    return g = { next: x(0), throw: x(1), return: x(2) }, typeof Symbol == "function" && (g[Symbol.iterator] = function() {
      return this;
    }), g;
    function x($) {
      return function(S) {
        return function(O) {
          if (h) throw new TypeError("Generator is already executing.");
          for (; b; ) try {
            if (h = 1, v && (y = 2 & O[0] ? v.return : O[0] ? v.throw || ((y = v.return) && y.call(v), 0) : v.next) && !(y = y.call(v, O[1])).done) return y;
            switch (v = 0, y && (O = [2 & O[0], y.value]), O[0]) {
              case 0:
              case 1:
                y = O;
                break;
              case 4:
                return b.label++, { value: O[1], done: !1 };
              case 5:
                b.label++, v = O[1], O = [0];
                continue;
              case 7:
                O = b.ops.pop(), b.trys.pop();
                continue;
              default:
                if (y = b.trys, !((y = y.length > 0 && y[y.length - 1]) || O[0] !== 6 && O[0] !== 2)) {
                  b = 0;
                  continue;
                }
                if (O[0] === 3 && (!y || O[1] > y[0] && O[1] < y[3])) {
                  b.label = O[1];
                  break;
                }
                if (O[0] === 6 && b.label < y[1]) {
                  b.label = y[1], y = O;
                  break;
                }
                if (y && b.label < y[2]) {
                  b.label = y[2], b.ops.push(O);
                  break;
                }
                y[2] && b.ops.pop(), b.trys.pop();
                continue;
            }
            O = f.call(d, b);
          } catch (C) {
            O = [6, C], v = 0;
          } finally {
            h = y = 0;
          }
          if (5 & O[0]) throw O[1];
          return { value: O[0] ? O[1] : void 0, done: !0 };
        }([$, S]);
      };
    }
  }, o = bc;
  Object.defineProperty(t, "__esModule", { value: !0 });
  var i = "browser-tabs-lock-key", a = { key: function(d) {
    return n(o, void 0, void 0, function() {
      return r(this, function(f) {
        throw new Error("Unsupported");
      });
    });
  }, getItem: function(d) {
    return n(o, void 0, void 0, function() {
      return r(this, function(f) {
        throw new Error("Unsupported");
      });
    });
  }, clear: function() {
    return n(o, void 0, void 0, function() {
      return r(this, function(d) {
        return [2, window.localStorage.clear()];
      });
    });
  }, removeItem: function(d) {
    return n(o, void 0, void 0, function() {
      return r(this, function(f) {
        throw new Error("Unsupported");
      });
    });
  }, setItem: function(d, f) {
    return n(o, void 0, void 0, function() {
      return r(this, function(h) {
        throw new Error("Unsupported");
      });
    });
  }, keySync: function(d) {
    return window.localStorage.key(d);
  }, getItemSync: function(d) {
    return window.localStorage.getItem(d);
  }, clearSync: function() {
    return window.localStorage.clear();
  }, removeItemSync: function(d) {
    return window.localStorage.removeItem(d);
  }, setItemSync: function(d, f) {
    return window.localStorage.setItem(d, f);
  } };
  function c(d) {
    return new Promise(function(f) {
      return setTimeout(f, d);
    });
  }
  function l(d) {
    for (var f = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", h = "", v = 0; v < d; v++)
      h += f[Math.floor(Math.random() * f.length)];
    return h;
  }
  var u = function() {
    function d(f) {
      this.acquiredIatSet = /* @__PURE__ */ new Set(), this.storageHandler = void 0, this.id = Date.now().toString() + l(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = f, d.waiters === void 0 && (d.waiters = []);
    }
    return d.prototype.acquireLock = function(f, h) {
      return h === void 0 && (h = 5e3), n(this, void 0, void 0, function() {
        var v, y, g, b, x, $, S;
        return r(this, function(O) {
          switch (O.label) {
            case 0:
              v = Date.now() + l(4), y = Date.now() + h, g = i + "-" + f, b = this.storageHandler === void 0 ? a : this.storageHandler, O.label = 1;
            case 1:
              return Date.now() < y ? [4, c(30)] : [3, 8];
            case 2:
              return O.sent(), b.getItemSync(g) !== null ? [3, 5] : (x = this.id + "-" + f + "-" + v, [4, c(Math.floor(25 * Math.random()))]);
            case 3:
              return O.sent(), b.setItemSync(g, JSON.stringify({ id: this.id, iat: v, timeoutKey: x, timeAcquired: Date.now(), timeRefreshed: Date.now() })), [4, c(30)];
            case 4:
              return O.sent(), ($ = b.getItemSync(g)) !== null && (S = JSON.parse($)).id === this.id && S.iat === v ? (this.acquiredIatSet.add(v), this.refreshLockWhileAcquired(g, v), [2, !0]) : [3, 7];
            case 5:
              return d.lockCorrector(this.storageHandler === void 0 ? a : this.storageHandler), [4, this.waitForSomethingToChange(y)];
            case 6:
              O.sent(), O.label = 7;
            case 7:
              return v = Date.now() + l(4), [3, 1];
            case 8:
              return [2, !1];
          }
        });
      });
    }, d.prototype.refreshLockWhileAcquired = function(f, h) {
      return n(this, void 0, void 0, function() {
        var v = this;
        return r(this, function(y) {
          return setTimeout(function() {
            return n(v, void 0, void 0, function() {
              var g, b, x;
              return r(this, function($) {
                switch ($.label) {
                  case 0:
                    return [4, hc.default().lock(h)];
                  case 1:
                    return $.sent(), this.acquiredIatSet.has(h) ? (g = this.storageHandler === void 0 ? a : this.storageHandler, (b = g.getItemSync(f)) === null ? (hc.default().unlock(h), [2]) : ((x = JSON.parse(b)).timeRefreshed = Date.now(), g.setItemSync(f, JSON.stringify(x)), hc.default().unlock(h), this.refreshLockWhileAcquired(f, h), [2])) : (hc.default().unlock(h), [2]);
                }
              });
            });
          }, 1e3), [2];
        });
      });
    }, d.prototype.waitForSomethingToChange = function(f) {
      return n(this, void 0, void 0, function() {
        return r(this, function(h) {
          switch (h.label) {
            case 0:
              return [4, new Promise(function(v) {
                var y = !1, g = Date.now(), b = !1;
                function x() {
                  if (b || (window.removeEventListener("storage", x), d.removeFromWaiting(x), clearTimeout($), b = !0), !y) {
                    y = !0;
                    var S = 50 - (Date.now() - g);
                    S > 0 ? setTimeout(v, S) : v(null);
                  }
                }
                window.addEventListener("storage", x), d.addToWaiting(x);
                var $ = setTimeout(x, Math.max(0, f - Date.now()));
              })];
            case 1:
              return h.sent(), [2];
          }
        });
      });
    }, d.addToWaiting = function(f) {
      this.removeFromWaiting(f), d.waiters !== void 0 && d.waiters.push(f);
    }, d.removeFromWaiting = function(f) {
      d.waiters !== void 0 && (d.waiters = d.waiters.filter(function(h) {
        return h !== f;
      }));
    }, d.notifyWaiters = function() {
      d.waiters !== void 0 && d.waiters.slice().forEach(function(f) {
        return f();
      });
    }, d.prototype.releaseLock = function(f) {
      return n(this, void 0, void 0, function() {
        return r(this, function(h) {
          switch (h.label) {
            case 0:
              return [4, this.releaseLock__private__(f)];
            case 1:
              return [2, h.sent()];
          }
        });
      });
    }, d.prototype.releaseLock__private__ = function(f) {
      return n(this, void 0, void 0, function() {
        var h, v, y, g;
        return r(this, function(b) {
          switch (b.label) {
            case 0:
              return h = this.storageHandler === void 0 ? a : this.storageHandler, v = i + "-" + f, (y = h.getItemSync(v)) === null ? [2] : (g = JSON.parse(y)).id !== this.id ? [3, 2] : [4, hc.default().lock(g.iat)];
            case 1:
              b.sent(), this.acquiredIatSet.delete(g.iat), h.removeItemSync(v), hc.default().unlock(g.iat), d.notifyWaiters(), b.label = 2;
            case 2:
              return [2];
          }
        });
      });
    }, d.lockCorrector = function(f) {
      for (var h = Date.now() - 5e3, v = f, y = [], g = 0; ; ) {
        var b = v.keySync(g);
        if (b === null) break;
        y.push(b), g++;
      }
      for (var x = !1, $ = 0; $ < y.length; $++) {
        var S = y[$];
        if (S.includes(i)) {
          var O = v.getItemSync(S);
          if (O !== null) {
            var C = JSON.parse(O);
            (C.timeRefreshed === void 0 && C.timeAcquired < h || C.timeRefreshed !== void 0 && C.timeRefreshed < h) && (v.removeItemSync(S), x = !0);
          }
        }
      }
      x && d.notifyWaiters();
    }, d.waiters = void 0, d;
  }();
  t.default = u;
}));
const LJ = { timeoutInSeconds: 60 }, K8 = { name: "auth0-spa-js", version: "2.9.0" }, X8 = () => Date.now();
let rr = class BO extends Error {
  constructor(t, n) {
    super(n), this.error = t, this.error_description = n, Object.setPrototypeOf(this, BO.prototype);
  }
  static fromPayload({ error: t, error_description: n }) {
    return new BO(t, n);
  }
}, jJ = class Z8 extends rr {
  constructor(t, n, r, o = null) {
    super(t, n), this.state = r, this.appState = o, Object.setPrototypeOf(this, Z8.prototype);
  }
}, FJ = class J8 extends rr {
  constructor(t, n, r, o, i = null) {
    super(t, n), this.connection = r, this.state = o, this.appState = i, Object.setPrototypeOf(this, J8.prototype);
  }
}, qO = class Q8 extends rr {
  constructor() {
    super("timeout", "Timeout"), Object.setPrototypeOf(this, Q8.prototype);
  }
}, zJ = class e7 extends qO {
  constructor(t) {
    super(), this.popup = t, Object.setPrototypeOf(this, e7.prototype);
  }
}, BJ = class t7 extends rr {
  constructor(t) {
    super("cancelled", "Popup closed"), this.popup = t, Object.setPrototypeOf(this, t7.prototype);
  }
}, qJ = class n7 extends rr {
  constructor(t, n, r) {
    super(t, n), this.mfa_token = r, Object.setPrototypeOf(this, n7.prototype);
  }
}, r7 = class o7 extends rr {
  constructor(t, n) {
    super("missing_refresh_token", `Missing Refresh Token (audience: '${$g(t, ["default"])}', scope: '${$g(n)}')`), this.audience = t, this.scope = n, Object.setPrototypeOf(this, o7.prototype);
  }
}, UJ = class i7 extends rr {
  constructor(t, n) {
    super("missing_scopes", `Missing requested scopes after refresh (audience: '${$g(t, ["default"])}', missing scope: '${$g(n)}')`), this.audience = t, this.scope = n, Object.setPrototypeOf(this, i7.prototype);
  }
}, a7 = class s7 extends rr {
  constructor(t) {
    super("use_dpop_nonce", "Server rejected DPoP proof: wrong nonce"), this.newDpopNonce = t, Object.setPrototypeOf(this, s7.prototype);
  }
};
function $g(e, t = []) {
  return e && !t.includes(e) ? e : "";
}
const Og = () => window.crypto, Ed = () => {
  const e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";
  let t = "";
  return Array.from(Og().getRandomValues(new Uint8Array(43))).forEach((n) => t += e[n % e.length]), t;
}, Lb = (e) => btoa(e), WJ = [{ key: "name", type: ["string"] }, { key: "version", type: ["string", "number"] }, { key: "env", type: ["object"] }], HJ = (e) => Object.keys(e).reduce((t, n) => {
  const r = WJ.find((o) => o.key === n);
  return r && r.type.includes(typeof e[n]) && (t[n] = e[n]), t;
}, {}), UO = (e) => {
  var { clientId: t } = e, n = Fi(e, ["clientId"]);
  return new URLSearchParams(((r) => Object.keys(r).filter((o) => r[o] !== void 0).reduce((o, i) => Object.assign(Object.assign({}, o), { [i]: r[i] }), {}))(Object.assign({ client_id: t }, n))).toString();
}, wR = async (e) => await Og().subtle.digest({ name: "SHA-256" }, new TextEncoder().encode(e)), $R = (e) => ((t) => decodeURIComponent(atob(t).split("").map((n) => "%" + ("00" + n.charCodeAt(0).toString(16)).slice(-2)).join("")))(e.replace(/_/g, "/").replace(/-/g, "+")), OR = (e) => {
  const t = new Uint8Array(e);
  return ((n) => {
    const r = { "+": "-", "/": "_", "=": "" };
    return n.replace(/[+/=]/g, (o) => r[o]);
  })(window.btoa(String.fromCharCode(...Array.from(t))));
}, VJ = new TextEncoder(), YJ = new TextDecoder();
function hf(e) {
  return typeof e == "string" ? VJ.encode(e) : YJ.decode(e);
}
function SR(e) {
  if (typeof e.modulusLength != "number" || e.modulusLength < 2048) throw new KJ(`${e.name} modulusLength must be at least 2048 bits`);
}
async function GJ(e, t, n) {
  if (n.usages.includes("sign") === !1) throw new TypeError('private CryptoKey instances used for signing assertions must include "sign" in their "usages"');
  const r = `${mf(hf(JSON.stringify(e)))}.${mf(hf(JSON.stringify(t)))}`;
  return `${r}.${mf(await crypto.subtle.sign(function(o) {
    switch (o.algorithm.name) {
      case "ECDSA":
        return { name: o.algorithm.name, hash: "SHA-256" };
      case "RSA-PSS":
        return SR(o.algorithm), { name: o.algorithm.name, saltLength: 32 };
      case "RSASSA-PKCS1-v1_5":
        return SR(o.algorithm), { name: o.algorithm.name };
      case "Ed25519":
        return { name: o.algorithm.name };
    }
    throw new Sc();
  }(n), n, hf(r)))}`;
}
let WO;
Uint8Array.prototype.toBase64 ? WO = (e) => (e instanceof ArrayBuffer && (e = new Uint8Array(e)), e.toBase64({ alphabet: "base64url", omitPadding: !0 })) : WO = (t) => {
  t instanceof ArrayBuffer && (t = new Uint8Array(t));
  const n = [];
  for (let r = 0; r < t.byteLength; r += 32768) n.push(String.fromCharCode.apply(null, t.subarray(r, r + 32768)));
  return btoa(n.join("")).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
function mf(e) {
  return WO(e);
}
let Sc = class extends Error {
  constructor(t) {
    var n;
    super(t ?? "operation not supported"), this.name = this.constructor.name, (n = Error.captureStackTrace) === null || n === void 0 || n.call(Error, this, this.constructor);
  }
}, KJ = class extends Error {
  constructor(t) {
    var n;
    super(t), this.name = this.constructor.name, (n = Error.captureStackTrace) === null || n === void 0 || n.call(Error, this, this.constructor);
  }
};
function XJ(e) {
  switch (e.algorithm.name) {
    case "RSA-PSS":
      return function(t) {
        if (t.algorithm.hash.name === "SHA-256") return "PS256";
        throw new Sc("unsupported RsaHashedKeyAlgorithm hash name");
      }(e);
    case "RSASSA-PKCS1-v1_5":
      return function(t) {
        if (t.algorithm.hash.name === "SHA-256") return "RS256";
        throw new Sc("unsupported RsaHashedKeyAlgorithm hash name");
      }(e);
    case "ECDSA":
      return function(t) {
        if (t.algorithm.namedCurve === "P-256") return "ES256";
        throw new Sc("unsupported EcKeyAlgorithm namedCurve");
      }(e);
    case "Ed25519":
      return "Ed25519";
    default:
      throw new Sc("unsupported CryptoKey algorithm name");
  }
}
function c7(e) {
  return e instanceof CryptoKey;
}
function l7(e) {
  return c7(e) && e.type === "public";
}
async function ZJ(e, t, n, r, o, i) {
  const a = e == null ? void 0 : e.privateKey, c = e == null ? void 0 : e.publicKey;
  if (!c7(l = a) || l.type !== "private") throw new TypeError('"keypair.privateKey" must be a private CryptoKey');
  var l;
  if (!l7(c)) throw new TypeError('"keypair.publicKey" must be a public CryptoKey');
  if (c.extractable !== !0) throw new TypeError('"keypair.publicKey.extractable" must be true');
  if (typeof t != "string") throw new TypeError('"htu" must be a string');
  if (typeof n != "string") throw new TypeError('"htm" must be a string');
  if (r !== void 0 && typeof r != "string") throw new TypeError('"nonce" must be a string or undefined');
  if (o !== void 0 && typeof o != "string") throw new TypeError('"accessToken" must be a string or undefined');
  return GJ({ alg: XJ(a), typ: "dpop+jwt", jwk: await u7(c) }, Object.assign(Object.assign({}, i), { iat: Math.floor(Date.now() / 1e3), jti: crypto.randomUUID(), htm: n, nonce: r, htu: t, ath: o ? mf(await crypto.subtle.digest("SHA-256", hf(o))) : void 0 }), a);
}
async function u7(e) {
  const { kty: t, e: n, n: r, x: o, y: i, crv: a } = await crypto.subtle.exportKey("jwk", e);
  return { kty: t, crv: a, e: n, n: r, x: o, y: i };
}
const JJ = ["authorization_code", "refresh_token", "urn:ietf:params:oauth:grant-type:token-exchange"];
function QJ() {
  return async function(e, t) {
    var n;
    let r;
    if (e.length === 0) throw new TypeError('"alg" must be a non-empty string');
    switch (e) {
      case "PS256":
        r = { name: "RSA-PSS", hash: "SHA-256", modulusLength: 2048, publicExponent: new Uint8Array([1, 0, 1]) };
        break;
      case "RS256":
        r = { name: "RSASSA-PKCS1-v1_5", hash: "SHA-256", modulusLength: 2048, publicExponent: new Uint8Array([1, 0, 1]) };
        break;
      case "ES256":
        r = { name: "ECDSA", namedCurve: "P-256" };
        break;
      case "Ed25519":
        r = { name: "Ed25519" };
        break;
      default:
        throw new Sc();
    }
    return crypto.subtle.generateKey(r, (n = t == null ? void 0 : t.extractable) !== null && n !== void 0 && n, ["sign", "verify"]);
  }("ES256", { extractable: !1 });
}
function eQ(e) {
  return async function(t) {
    if (!l7(t)) throw new TypeError('"publicKey" must be a public CryptoKey');
    if (t.extractable !== !0) throw new TypeError('"publicKey.extractable" must be true');
    const n = await u7(t);
    let r;
    switch (n.kty) {
      case "EC":
        r = { crv: n.crv, kty: n.kty, x: n.x, y: n.y };
        break;
      case "OKP":
        r = { crv: n.crv, kty: n.kty, x: n.x };
        break;
      case "RSA":
        r = { e: n.e, kty: n.kty, n: n.n };
        break;
      default:
        throw new Sc("unsupported JWK kty");
    }
    return mf(await crypto.subtle.digest({ name: "SHA-256" }, hf(JSON.stringify(r))));
  }(e.publicKey);
}
function tQ({ keyPair: e, url: t, method: n, nonce: r, accessToken: o }) {
  const i = function(a) {
    const c = new URL(a);
    return c.search = "", c.hash = "", c.href;
  }(t);
  return ZJ(e, i, n, r, o);
}
const nQ = async (e, t) => {
  const n = await fetch(e, t);
  return { ok: n.ok, json: await n.json(), headers: (r = n.headers, [...r].reduce((o, [i, a]) => (o[i] = a, o), {})) };
  var r;
}, rQ = async (e, t, n) => {
  const r = new AbortController();
  let o;
  return t.signal = r.signal, Promise.race([nQ(e, t), new Promise((i, a) => {
    o = setTimeout(() => {
      r.abort(), a(new Error("Timeout when executing 'fetch'"));
    }, n);
  })]).finally(() => {
    clearTimeout(o);
  });
}, oQ = async (e, t, n, r, o, i, a, c) => {
  return l = { auth: { audience: t, scope: n }, timeout: o, fetchUrl: e, fetchOptions: r, useFormData: a, useMrrt: c }, u = i, new Promise(function(d, f) {
    const h = new MessageChannel();
    h.port1.onmessage = function(v) {
      v.data.error ? f(new Error(v.data.error)) : d(v.data), h.port1.close();
    }, u.postMessage(l, [h.port2]);
  });
  var l, u;
}, iQ = async (e, t, n, r, o, i, a = 1e4, c) => o ? oQ(e, t, n, r, a, o, i, c) : rQ(e, r, a);
async function d7(e, t, n, r, o, i, a, c, l, u) {
  if (l) {
    const S = await l.generateProof({ url: e, method: o.method || "GET", nonce: await l.getNonce() });
    o.headers = Object.assign(Object.assign({}, o.headers), { dpop: S });
  }
  let d, f = null;
  for (let S = 0; S < 3; S++) try {
    d = await iQ(e, n, r, o, i, a, t, c), f = null;
    break;
  } catch (O) {
    f = O;
  }
  if (f) throw f;
  const h = d.json, { error: v, error_description: y } = h, g = Fi(h, ["error", "error_description"]), { headers: b, ok: x } = d;
  let $;
  if (l && ($ = b["dpop-nonce"], $ && await l.setNonce($)), !x) {
    const S = y || `HTTP error. Unable to fetch ${e}`;
    if (v === "mfa_required") throw new qJ(v, S, g.mfa_token);
    if (v === "missing_refresh_token") throw new r7(n, r);
    if (v === "use_dpop_nonce") {
      if (!l || !$ || u) throw new a7($);
      return d7(e, t, n, r, o, i, a, c, l, !0);
    }
    throw new rr(v || "request_error", S);
  }
  return g;
}
async function aQ(e, t) {
  var { baseUrl: n, timeout: r, audience: o, scope: i, auth0Client: a, useFormData: c, useMrrt: l, dpop: u } = e, d = Fi(e, ["baseUrl", "timeout", "audience", "scope", "auth0Client", "useFormData", "useMrrt", "dpop"]);
  const f = d.grant_type === "urn:ietf:params:oauth:grant-type:token-exchange", h = d.grant_type === "refresh_token" && l, v = Object.assign(Object.assign(Object.assign(Object.assign({}, d), f && o && { audience: o }), f && i && { scope: i }), h && { audience: o, scope: i }), y = c ? UO(v) : JSON.stringify(v), g = (b = d.grant_type, JJ.includes(b));
  var b;
  return await d7(`${n}/oauth/token`, r, o || "default", i, { method: "POST", body: y, headers: { "Content-Type": c ? "application/x-www-form-urlencoded" : "application/json", "Auth0-Client": btoa(JSON.stringify(HJ(a || K8))) } }, t, c, l, g ? u : void 0);
}
const Hm = (...e) => {
  return (t = e.filter(Boolean).join(" ").trim().split(/\s+/), Array.from(new Set(t))).join(" ");
  var t;
}, Fh = (e, t, n) => {
  let r;
  return n && (r = e[n]), r || (r = e.default), Hm(r, t);
};
let Ma = class HO {
  constructor(t, n = "@@auth0spajs@@", r) {
    this.prefix = n, this.suffix = r, this.clientId = t.clientId, this.scope = t.scope, this.audience = t.audience;
  }
  toKey() {
    return [this.prefix, this.clientId, this.audience, this.scope, this.suffix].filter(Boolean).join("::");
  }
  static fromKey(t) {
    const [n, r, o, i] = t.split("::");
    return new HO({ clientId: r, scope: i, audience: o }, n);
  }
  static fromCacheEntry(t) {
    const { scope: n, audience: r, client_id: o } = t;
    return new HO({ scope: n, audience: r, clientId: o });
  }
}, sQ = class {
  set(t, n) {
    localStorage.setItem(t, JSON.stringify(n));
  }
  get(t) {
    const n = window.localStorage.getItem(t);
    if (n) try {
      return JSON.parse(n);
    } catch {
      return;
    }
  }
  remove(t) {
    localStorage.removeItem(t);
  }
  allKeys() {
    return Object.keys(window.localStorage).filter((t) => t.startsWith("@@auth0spajs@@"));
  }
}, f7 = class {
  constructor() {
    this.enclosedCache = /* @__PURE__ */ function() {
      let t = {};
      return { set(n, r) {
        t[n] = r;
      }, get(n) {
        const r = t[n];
        if (r) return r;
      }, remove(n) {
        delete t[n];
      }, allKeys: () => Object.keys(t) };
    }();
  }
}, cQ = class {
  constructor(t, n, r) {
    this.cache = t, this.keyManifest = n, this.nowProvider = r || X8;
  }
  async setIdToken(t, n, r) {
    var o;
    const i = this.getIdTokenCacheKey(t);
    await this.cache.set(i, { id_token: n, decodedToken: r }), await ((o = this.keyManifest) === null || o === void 0 ? void 0 : o.add(i));
  }
  async getIdToken(t) {
    const n = await this.cache.get(this.getIdTokenCacheKey(t.clientId));
    if (!n && t.scope && t.audience) {
      const r = await this.get(t);
      return !r || !r.id_token || !r.decodedToken ? void 0 : { id_token: r.id_token, decodedToken: r.decodedToken };
    }
    if (n) return { id_token: n.id_token, decodedToken: n.decodedToken };
  }
  async get(t, n = 0, r = !1, o) {
    var i;
    let a = await this.cache.get(t.toKey());
    if (!a) {
      const u = await this.getCacheKeys();
      if (!u) return;
      const d = this.matchExistingCacheKey(t, u);
      if (d && (a = await this.cache.get(d)), !d && r && o !== "cache-only") return this.getEntryWithRefreshToken(t, u);
    }
    if (!a) return;
    const c = await this.nowProvider(), l = Math.floor(c / 1e3);
    return a.expiresAt - n < l ? a.body.refresh_token ? this.modifiedCachedEntry(a, t) : (await this.cache.remove(t.toKey()), void await ((i = this.keyManifest) === null || i === void 0 ? void 0 : i.remove(t.toKey()))) : a.body;
  }
  async modifiedCachedEntry(t, n) {
    return t.body = { refresh_token: t.body.refresh_token, audience: t.body.audience, scope: t.body.scope }, await this.cache.set(n.toKey(), t), { refresh_token: t.body.refresh_token, audience: t.body.audience, scope: t.body.scope };
  }
  async set(t) {
    var n;
    const r = new Ma({ clientId: t.client_id, scope: t.scope, audience: t.audience }), o = await this.wrapCacheEntry(t);
    await this.cache.set(r.toKey(), o), await ((n = this.keyManifest) === null || n === void 0 ? void 0 : n.add(r.toKey()));
  }
  async remove(t, n, r) {
    const o = new Ma({ clientId: t, scope: r, audience: n });
    await this.cache.remove(o.toKey());
  }
  async clear(t) {
    var n;
    const r = await this.getCacheKeys();
    r && (await r.filter((o) => !t || o.includes(t)).reduce(async (o, i) => {
      await o, await this.cache.remove(i);
    }, Promise.resolve()), await ((n = this.keyManifest) === null || n === void 0 ? void 0 : n.clear()));
  }
  async wrapCacheEntry(t) {
    const n = await this.nowProvider();
    return { body: t, expiresAt: Math.floor(n / 1e3) + t.expires_in };
  }
  async getCacheKeys() {
    var t;
    return this.keyManifest ? (t = await this.keyManifest.get()) === null || t === void 0 ? void 0 : t.keys : this.cache.allKeys ? this.cache.allKeys() : void 0;
  }
  getIdTokenCacheKey(t) {
    return new Ma({ clientId: t }, "@@auth0spajs@@", "@@user@@").toKey();
  }
  matchExistingCacheKey(t, n) {
    return n.filter((r) => {
      var o;
      const i = Ma.fromKey(r), a = new Set(i.scope && i.scope.split(" ")), c = ((o = t.scope) === null || o === void 0 ? void 0 : o.split(" ")) || [], l = i.scope && c.reduce((u, d) => u && a.has(d), !0);
      return i.prefix === "@@auth0spajs@@" && i.clientId === t.clientId && i.audience === t.audience && l;
    })[0];
  }
  async getEntryWithRefreshToken(t, n) {
    var r;
    for (const o of n) {
      const i = Ma.fromKey(o);
      if (i.prefix === "@@auth0spajs@@" && i.clientId === t.clientId) {
        const a = await this.cache.get(o);
        if (!((r = a == null ? void 0 : a.body) === null || r === void 0) && r.refresh_token) return this.modifiedCachedEntry(a, t);
      }
    }
  }
  async updateEntry(t, n) {
    var r;
    const o = await this.getCacheKeys();
    if (o) for (const i of o) {
      const a = await this.cache.get(i);
      if (((r = a == null ? void 0 : a.body) === null || r === void 0 ? void 0 : r.refresh_token) === t) {
        const c = Object.assign(Object.assign({}, a.body), { refresh_token: n });
        await this.set(c);
      }
    }
  }
}, lQ = class {
  constructor(t, n, r) {
    this.storage = t, this.clientId = n, this.cookieDomain = r, this.storageKey = `a0.spajs.txs.${this.clientId}`;
  }
  create(t) {
    this.storage.save(this.storageKey, t, { daysUntilExpire: 1, cookieDomain: this.cookieDomain });
  }
  get() {
    return this.storage.get(this.storageKey);
  }
  remove() {
    this.storage.remove(this.storageKey, { cookieDomain: this.cookieDomain });
  }
};
const _d = (e) => typeof e == "number", uQ = ["iss", "aud", "exp", "nbf", "iat", "jti", "azp", "nonce", "auth_time", "at_hash", "c_hash", "acr", "amr", "sub_jwk", "cnf", "sip_from_tag", "sip_date", "sip_callid", "sip_cseq_num", "sip_via_branch", "orig", "dest", "mky", "events", "toe", "txn", "rph", "sid", "vot", "vtm"], dQ = (e) => {
  if (!e.id_token) throw new Error("ID token is required but missing");
  const t = ((i) => {
    const a = i.split("."), [c, l, u] = a;
    if (a.length !== 3 || !c || !l || !u) throw new Error("ID token could not be decoded");
    const d = JSON.parse($R(l)), f = { __raw: i }, h = {};
    return Object.keys(d).forEach((v) => {
      f[v] = d[v], uQ.includes(v) || (h[v] = d[v]);
    }), { encoded: { header: c, payload: l, signature: u }, header: JSON.parse($R(c)), claims: f, user: h };
  })(e.id_token);
  if (!t.claims.iss) throw new Error("Issuer (iss) claim must be a string present in the ID token");
  if (t.claims.iss !== e.iss) throw new Error(`Issuer (iss) claim mismatch in the ID token; expected "${e.iss}", found "${t.claims.iss}"`);
  if (!t.user.sub) throw new Error("Subject (sub) claim must be a string present in the ID token");
  if (t.header.alg !== "RS256") throw new Error(`Signature algorithm of "${t.header.alg}" is not supported. Expected the ID token to be signed with "RS256".`);
  if (!t.claims.aud || typeof t.claims.aud != "string" && !Array.isArray(t.claims.aud)) throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");
  if (Array.isArray(t.claims.aud)) {
    if (!t.claims.aud.includes(e.aud)) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but was not one of "${t.claims.aud.join(", ")}"`);
    if (t.claims.aud.length > 1) {
      if (!t.claims.azp) throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");
      if (t.claims.azp !== e.aud) throw new Error(`Authorized Party (azp) claim mismatch in the ID token; expected "${e.aud}", found "${t.claims.azp}"`);
    }
  } else if (t.claims.aud !== e.aud) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but found "${t.claims.aud}"`);
  if (e.nonce) {
    if (!t.claims.nonce) throw new Error("Nonce (nonce) claim must be a string present in the ID token");
    if (t.claims.nonce !== e.nonce) throw new Error(`Nonce (nonce) claim mismatch in the ID token; expected "${e.nonce}", found "${t.claims.nonce}"`);
  }
  if (e.max_age && !_d(t.claims.auth_time)) throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");
  if (t.claims.exp == null || !_d(t.claims.exp)) throw new Error("Expiration Time (exp) claim must be a number present in the ID token");
  if (!_d(t.claims.iat)) throw new Error("Issued At (iat) claim must be a number present in the ID token");
  const n = e.leeway || 60, r = new Date(e.now || Date.now()), o = /* @__PURE__ */ new Date(0);
  if (o.setUTCSeconds(t.claims.exp + n), r > o) throw new Error(`Expiration Time (exp) claim error in the ID token; current time (${r}) is after expiration time (${o})`);
  if (t.claims.nbf != null && _d(t.claims.nbf)) {
    const i = /* @__PURE__ */ new Date(0);
    if (i.setUTCSeconds(t.claims.nbf - n), r < i) throw new Error(`Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Current time (${r}) is before ${i}`);
  }
  if (t.claims.auth_time != null && _d(t.claims.auth_time)) {
    const i = /* @__PURE__ */ new Date(0);
    if (i.setUTCSeconds(parseInt(t.claims.auth_time) + e.max_age + n), r > i) throw new Error(`Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time (${r}) is after last auth at ${i}`);
  }
  if (e.organization) {
    const i = e.organization.trim();
    if (i.startsWith("org_")) {
      const a = i;
      if (!t.claims.org_id) throw new Error("Organization ID (org_id) claim must be a string present in the ID token");
      if (a !== t.claims.org_id) throw new Error(`Organization ID (org_id) claim mismatch in the ID token; expected "${a}", found "${t.claims.org_id}"`);
    } else {
      const a = i.toLowerCase();
      if (!t.claims.org_name) throw new Error("Organization Name (org_name) claim must be a string present in the ID token");
      if (a !== t.claims.org_name) throw new Error(`Organization Name (org_name) claim mismatch in the ID token; expected "${a}", found "${t.claims.org_name}"`);
    }
  }
  return t;
};
var Cc = VC(function(e, t) {
  var n = bc && bc.__assign || function() {
    return n = Object.assign || function(l) {
      for (var u, d = 1, f = arguments.length; d < f; d++) for (var h in u = arguments[d]) Object.prototype.hasOwnProperty.call(u, h) && (l[h] = u[h]);
      return l;
    }, n.apply(this, arguments);
  };
  function r(l, u) {
    if (!u) return "";
    var d = "; " + l;
    return u === !0 ? d : d + "=" + u;
  }
  function o(l, u, d) {
    return encodeURIComponent(l).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(u).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + function(f) {
      if (typeof f.expires == "number") {
        var h = /* @__PURE__ */ new Date();
        h.setMilliseconds(h.getMilliseconds() + 864e5 * f.expires), f.expires = h;
      }
      return r("Expires", f.expires ? f.expires.toUTCString() : "") + r("Domain", f.domain) + r("Path", f.path) + r("Secure", f.secure) + r("SameSite", f.sameSite);
    }(d);
  }
  function i(l) {
    for (var u = {}, d = l ? l.split("; ") : [], f = /(%[\dA-F]{2})+/gi, h = 0; h < d.length; h++) {
      var v = d[h].split("="), y = v.slice(1).join("=");
      y.charAt(0) === '"' && (y = y.slice(1, -1));
      try {
        u[v[0].replace(f, decodeURIComponent)] = y.replace(f, decodeURIComponent);
      } catch {
      }
    }
    return u;
  }
  function a() {
    return i(document.cookie);
  }
  function c(l, u, d) {
    document.cookie = o(l, u, n({ path: "/" }, d));
  }
  t.__esModule = !0, t.encode = o, t.parse = i, t.getAll = a, t.get = function(l) {
    return a()[l];
  }, t.set = c, t.remove = function(l, u) {
    c(l, "", n(n({}, u), { expires: -1 }));
  };
});
HC(Cc), Cc.encode, Cc.parse, Cc.getAll;
var fQ = Cc.get, p7 = Cc.set, h7 = Cc.remove;
const Ql = { get(e) {
  const t = fQ(e);
  if (t !== void 0) return JSON.parse(t);
}, save(e, t, n) {
  let r = {};
  window.location.protocol === "https:" && (r = { secure: !0, sameSite: "none" }), n != null && n.daysUntilExpire && (r.expires = n.daysUntilExpire), n != null && n.cookieDomain && (r.domain = n.cookieDomain), p7(e, JSON.stringify(t), r);
}, remove(e, t) {
  let n = {};
  t != null && t.cookieDomain && (n.domain = t.cookieDomain), h7(e, n);
} }, pQ = { get(e) {
  return Ql.get(e) || Ql.get(`_legacy_${e}`);
}, save(e, t, n) {
  let r = {};
  window.location.protocol === "https:" && (r = { secure: !0 }), n != null && n.daysUntilExpire && (r.expires = n.daysUntilExpire), n != null && n.cookieDomain && (r.domain = n.cookieDomain), p7(`_legacy_${e}`, JSON.stringify(t), r), Ql.save(e, t, n);
}, remove(e, t) {
  let n = {};
  t != null && t.cookieDomain && (n.domain = t.cookieDomain), h7(e, n), Ql.remove(e, t), Ql.remove(`_legacy_${e}`, t);
} }, hQ = { get(e) {
  if (typeof sessionStorage > "u") return;
  const t = sessionStorage.getItem(e);
  return t != null ? JSON.parse(t) : void 0;
}, save(e, t) {
  sessionStorage.setItem(e, JSON.stringify(t));
}, remove(e) {
  sessionStorage.removeItem(e);
} };
var bs;
(function(e) {
  e.Code = "code", e.ConnectCode = "connect_code";
})(bs || (bs = {}));
function mQ(e, t, n) {
  var r = t === void 0 ? null : t, o = function(l, u) {
    var d = atob(l);
    if (u) {
      for (var f = new Uint8Array(d.length), h = 0, v = d.length; h < v; ++h) f[h] = d.charCodeAt(h);
      return String.fromCharCode.apply(null, new Uint16Array(f.buffer));
    }
    return d;
  }(e, n !== void 0 && n), i = o.indexOf(`
`, 10) + 1, a = o.substring(i) + (r ? "//# sourceMappingURL=" + r : ""), c = new Blob([a], { type: "application/javascript" });
  return URL.createObjectURL(c);
}
var CR, TR, ER, jb, gQ = (CR = "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", TR = null, ER = !1, function(e) {
  return jb = jb || mQ(CR, TR, ER), new Worker(jb, e);
});
const Fb = {};
let vQ = class {
  constructor(t, n) {
    this.cache = t, this.clientId = n, this.manifestKey = this.createManifestKeyFrom(this.clientId);
  }
  async add(t) {
    var n;
    const r = new Set(((n = await this.cache.get(this.manifestKey)) === null || n === void 0 ? void 0 : n.keys) || []);
    r.add(t), await this.cache.set(this.manifestKey, { keys: [...r] });
  }
  async remove(t) {
    const n = await this.cache.get(this.manifestKey);
    if (n) {
      const r = new Set(n.keys);
      return r.delete(t), r.size > 0 ? await this.cache.set(this.manifestKey, { keys: [...r] }) : await this.cache.remove(this.manifestKey);
    }
  }
  get() {
    return this.cache.get(this.manifestKey);
  }
  clear() {
    return this.cache.remove(this.manifestKey);
  }
  createManifestKeyFrom(t) {
    return `@@auth0spajs@@::${t}`;
  }
};
const yQ = { memory: () => new f7().enclosedCache, localstorage: () => new sQ() }, _R = (e) => yQ[e], kR = (e) => {
  const { openUrl: t, onRedirect: n } = e, r = Fi(e, ["openUrl", "onRedirect"]);
  return Object.assign(Object.assign({}, r), { openUrl: t === !1 || t ? t : n });
}, RR = (e, t) => {
  const n = (t == null ? void 0 : t.split(" ")) || [];
  return ((e == null ? void 0 : e.split(" ")) || []).every((r) => n.includes(r));
}, lc = { NONCE: "nonce", KEYPAIR: "keypair" };
let bQ = class {
  constructor(t) {
    this.clientId = t;
  }
  getVersion() {
    return 1;
  }
  createDbHandle() {
    const t = window.indexedDB.open("auth0-spa-js", this.getVersion());
    return new Promise((n, r) => {
      t.onupgradeneeded = () => Object.values(lc).forEach((o) => t.result.createObjectStore(o)), t.onerror = () => r(t.error), t.onsuccess = () => n(t.result);
    });
  }
  async getDbHandle() {
    return this.dbHandle || (this.dbHandle = await this.createDbHandle()), this.dbHandle;
  }
  async executeDbRequest(t, n, r) {
    const o = r((await this.getDbHandle()).transaction(t, n).objectStore(t));
    return new Promise((i, a) => {
      o.onsuccess = () => i(o.result), o.onerror = () => a(o.error);
    });
  }
  buildKey(t) {
    const n = t ? `_${t}` : "auth0";
    return `${this.clientId}::${n}`;
  }
  setNonce(t, n) {
    return this.save(lc.NONCE, this.buildKey(n), t);
  }
  setKeyPair(t) {
    return this.save(lc.KEYPAIR, this.buildKey(), t);
  }
  async save(t, n, r) {
    await this.executeDbRequest(t, "readwrite", (o) => o.put(r, n));
  }
  findNonce(t) {
    return this.find(lc.NONCE, this.buildKey(t));
  }
  findKeyPair() {
    return this.find(lc.KEYPAIR, this.buildKey());
  }
  find(t, n) {
    return this.executeDbRequest(t, "readonly", (r) => r.get(n));
  }
  async deleteBy(t, n) {
    const r = await this.executeDbRequest(t, "readonly", (o) => o.getAllKeys());
    r == null || r.filter(n).map((o) => this.executeDbRequest(t, "readwrite", (i) => i.delete(o)));
  }
  deleteByClientId(t, n) {
    return this.deleteBy(t, (r) => typeof r == "string" && r.startsWith(`${n}::`));
  }
  clearNonces() {
    return this.deleteByClientId(lc.NONCE, this.clientId);
  }
  clearKeyPairs() {
    return this.deleteByClientId(lc.KEYPAIR, this.clientId);
  }
}, xQ = class {
  constructor(t) {
    this.storage = new bQ(t);
  }
  getNonce(t) {
    return this.storage.findNonce(t);
  }
  setNonce(t, n) {
    return this.storage.setNonce(t, n);
  }
  async getOrGenerateKeyPair() {
    let t = await this.storage.findKeyPair();
    return t || (t = await QJ(), await this.storage.setKeyPair(t)), t;
  }
  async generateProof(t) {
    const n = await this.getOrGenerateKeyPair();
    return tQ(Object.assign({ keyPair: n }, t));
  }
  async calculateThumbprint() {
    return eQ(await this.getOrGenerateKeyPair());
  }
  async clear() {
    await Promise.all([this.storage.clearNonces(), this.storage.clearKeyPairs()]);
  }
};
var ru;
(function(e) {
  e.Bearer = "Bearer", e.DPoP = "DPoP";
})(ru || (ru = {}));
let wQ = class {
  constructor(t, n) {
    this.hooks = n, this.config = Object.assign(Object.assign({}, t), { fetch: t.fetch || (typeof window > "u" ? fetch : window.fetch.bind(window)) });
  }
  isAbsoluteUrl(t) {
    return /^(https?:)?\/\//i.test(t);
  }
  buildUrl(t, n) {
    if (n) {
      if (this.isAbsoluteUrl(n)) return n;
      if (t) return `${t.replace(/\/?\/$/, "")}/${n.replace(/^\/+/, "")}`;
    }
    throw new TypeError("`url` must be absolute or `baseUrl` non-empty.");
  }
  getAccessToken(t) {
    return this.config.getAccessToken ? this.config.getAccessToken(t) : this.hooks.getAccessToken(t);
  }
  extractUrl(t) {
    return typeof t == "string" ? t : t instanceof URL ? t.href : t.url;
  }
  buildBaseRequest(t, n) {
    if (!this.config.baseUrl) return new Request(t, n);
    const r = this.buildUrl(this.config.baseUrl, this.extractUrl(t)), o = t instanceof Request ? new Request(r, t) : r;
    return new Request(o, n);
  }
  setAuthorizationHeader(t, n, r = ru.Bearer) {
    t.headers.set("authorization", `${r} ${n}`);
  }
  async setDpopProofHeader(t, n) {
    if (!this.config.dpopNonceId) return;
    const r = await this.hooks.getDpopNonce(), o = await this.hooks.generateDpopProof({ accessToken: n, method: t.method, nonce: r, url: t.url });
    t.headers.set("dpop", o);
  }
  async prepareRequest(t, n) {
    const r = await this.getAccessToken(n);
    let o, i;
    typeof r == "string" ? (o = this.config.dpopNonceId ? ru.DPoP : ru.Bearer, i = r) : (o = r.token_type, i = r.access_token), this.setAuthorizationHeader(t, i, o), o === ru.DPoP && await this.setDpopProofHeader(t, i);
  }
  getHeader(t, n) {
    return Array.isArray(t) ? new Headers(t).get(n) || "" : typeof t.get == "function" ? t.get(n) || "" : t[n] || "";
  }
  hasUseDpopNonceError(t) {
    if (t.status !== 401) return !1;
    const n = this.getHeader(t.headers, "www-authenticate");
    return n.includes("invalid_dpop_nonce") || n.includes("use_dpop_nonce");
  }
  async handleResponse(t, n) {
    const r = this.getHeader(t.headers, "dpop-nonce");
    if (r && await this.hooks.setDpopNonce(r), !this.hasUseDpopNonceError(t)) return t;
    if (!r || !n.onUseDpopNonceError) throw new a7(r);
    return n.onUseDpopNonceError();
  }
  async internalFetchWithAuth(t, n, r, o) {
    const i = this.buildBaseRequest(t, n);
    await this.prepareRequest(i, o);
    const a = await this.config.fetch(i);
    return this.handleResponse(a, r);
  }
  fetchWithAuth(t, n, r) {
    const o = { onUseDpopNonceError: () => this.internalFetchWithAuth(t, n, Object.assign(Object.assign({}, o), { onUseDpopNonceError: void 0 }), r) };
    return this.internalFetchWithAuth(t, n, o, r);
  }
}, $Q = class {
  constructor(t, n) {
    this.myAccountFetcher = t, this.apiBase = n;
  }
  async connectAccount(t) {
    const n = await this.myAccountFetcher.fetchWithAuth(`${this.apiBase}v1/connected-accounts/connect`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(t) });
    return this._handleResponse(n);
  }
  async completeAccount(t) {
    const n = await this.myAccountFetcher.fetchWithAuth(`${this.apiBase}v1/connected-accounts/complete`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(t) });
    return this._handleResponse(n);
  }
  async _handleResponse(t) {
    let n;
    try {
      n = await t.text(), n = JSON.parse(n);
    } catch (r) {
      throw new PR({ type: "invalid_json", status: t.status, title: "Invalid JSON response", detail: n || String(r) });
    }
    if (t.ok) return n;
    throw new PR(n);
  }
}, PR = class m7 extends Error {
  constructor({ type: t, status: n, title: r, detail: o, validation_errors: i }) {
    super(o), this.name = "MyAccountApiError", this.type = t, this.status = n, this.title = r, this.detail = o, this.validation_errors = i, Object.setPrototypeOf(this, m7.prototype);
  }
};
const zb = new DJ();
let OQ = class {
  constructor(t) {
    let n, r;
    if (this.userCache = new f7().enclosedCache, this.activeLockKeys = /* @__PURE__ */ new Set(), this.defaultOptions = { authorizationParams: { scope: "openid profile email" }, useRefreshTokensFallback: !1, useFormData: !0 }, this._releaseLockOnPageHide = async () => {
      const l = Array.from(this.activeLockKeys);
      for (const u of l) await zb.releaseLock(u);
      this.activeLockKeys.clear(), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
    }, this.options = Object.assign(Object.assign(Object.assign({}, this.defaultOptions), t), { authorizationParams: Object.assign(Object.assign({}, this.defaultOptions.authorizationParams), t.authorizationParams) }), typeof window < "u" && (() => {
      if (!Og()) throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");
      if (Og().subtle === void 0) throw new Error(`
      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/main/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.
    `);
    })(), t.cache && t.cacheLocation && console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."), t.cache) r = t.cache;
    else {
      if (n = t.cacheLocation || "memory", !_R(n)) throw new Error(`Invalid cache location "${n}"`);
      r = _R(n)();
    }
    this.httpTimeoutMs = t.httpTimeoutInSeconds ? 1e3 * t.httpTimeoutInSeconds : 1e4, this.cookieStorage = t.legacySameSiteCookie === !1 ? Ql : pQ, this.orgHintCookieName = `auth0.${this.options.clientId}.organization_hint`, this.isAuthenticatedCookieName = ((l) => `auth0.${l}.is.authenticated`)(this.options.clientId), this.sessionCheckExpiryDays = t.sessionCheckExpiryDays || 1;
    const o = t.useCookiesForTransactions ? this.cookieStorage : hQ;
    var i;
    this.scope = ((l, u, ...d) => {
      if (typeof l != "object") return { default: Hm(u, l, ...d) };
      let f = { default: Hm(u, ...d) };
      return Object.keys(l).forEach((h) => {
        const v = l[h];
        f[h] = Hm(u, v, ...d);
      }), f;
    })(this.options.authorizationParams.scope, "openid", this.options.useRefreshTokens ? "offline_access" : ""), this.transactionManager = new lQ(o, this.options.clientId, this.options.cookieDomain), this.nowProvider = this.options.nowProvider || X8, this.cacheManager = new cQ(r, r.allKeys ? void 0 : new vQ(r, this.options.clientId), this.nowProvider), this.dpop = this.options.useDpop ? new xQ(this.options.clientId) : void 0, this.domainUrl = (i = this.options.domain, /^https?:\/\//.test(i) ? i : `https://${i}`), this.tokenIssuer = ((l, u) => l ? l.startsWith("https://") ? l : `https://${l}/` : `${u}/`)(this.options.issuer, this.domainUrl);
    const a = `${this.domainUrl}/me/`, c = this.createFetcher(Object.assign(Object.assign({}, this.options.useDpop && { dpopNonceId: "__auth0_my_account_api__" }), { getAccessToken: () => this.getTokenSilently({ authorizationParams: { scope: "create:me:connected_accounts", audience: a }, detailedResponse: !0 }) }));
    this.myAccountApi = new $Q(c, a), typeof window < "u" && window.Worker && this.options.useRefreshTokens && n === "memory" && (this.options.workerUrl ? this.worker = new Worker(this.options.workerUrl) : this.worker = new gQ());
  }
  _url(t) {
    const n = encodeURIComponent(btoa(JSON.stringify(this.options.auth0Client || K8)));
    return `${this.domainUrl}${t}&auth0Client=${n}`;
  }
  _authorizeUrl(t) {
    return this._url(`/authorize?${UO(t)}`);
  }
  async _verifyIdToken(t, n, r) {
    const o = await this.nowProvider();
    return dQ({ iss: this.tokenIssuer, aud: this.options.clientId, id_token: t, nonce: n, organization: r, leeway: this.options.leeway, max_age: (i = this.options.authorizationParams.max_age, typeof i != "string" ? i : parseInt(i, 10) || void 0), now: o });
    var i;
  }
  _processOrgHint(t) {
    t ? this.cookieStorage.save(this.orgHintCookieName, t, { daysUntilExpire: this.sessionCheckExpiryDays, cookieDomain: this.options.cookieDomain }) : this.cookieStorage.remove(this.orgHintCookieName, { cookieDomain: this.options.cookieDomain });
  }
  async _prepareAuthorizeUrl(t, n, r) {
    var o;
    const i = Lb(Ed()), a = Lb(Ed()), c = Ed(), l = await wR(c), u = OR(l), d = await ((o = this.dpop) === null || o === void 0 ? void 0 : o.calculateThumbprint()), f = ((v, y, g, b, x, $, S, O, C) => Object.assign(Object.assign(Object.assign({ client_id: v.clientId }, v.authorizationParams), g), { scope: Fh(y, g.scope, g.audience), response_type: "code", response_mode: O || "query", state: b, nonce: x, redirect_uri: S || v.authorizationParams.redirect_uri, code_challenge: $, code_challenge_method: "S256", dpop_jkt: C }))(this.options, this.scope, t, i, a, u, t.redirect_uri || this.options.authorizationParams.redirect_uri || r, n == null ? void 0 : n.response_mode, d), h = this._authorizeUrl(f);
    return { nonce: a, code_verifier: c, scope: f.scope, audience: f.audience || "default", redirect_uri: f.redirect_uri, state: i, url: h };
  }
  async loginWithPopup(t, n) {
    var r;
    if (t = t || {}, !(n = n || {}).popup && (n.popup = ((c) => {
      const l = window.screenX + (window.innerWidth - 400) / 2, u = window.screenY + (window.innerHeight - 600) / 2;
      return window.open(c, "auth0:authorize:popup", `left=${l},top=${u},width=400,height=600,resizable,scrollbars=yes,status=1`);
    })(""), !n.popup)) throw new Error("Unable to open a popup for loginWithPopup - window.open returned `null`");
    const o = await this._prepareAuthorizeUrl(t.authorizationParams || {}, { response_mode: "web_message" }, window.location.origin);
    n.popup.location.href = o.url;
    const i = await ((c) => new Promise((l, u) => {
      let d;
      const f = setInterval(() => {
        c.popup && c.popup.closed && (clearInterval(f), clearTimeout(h), window.removeEventListener("message", d, !1), u(new BJ(c.popup)));
      }, 1e3), h = setTimeout(() => {
        clearInterval(f), u(new zJ(c.popup)), window.removeEventListener("message", d, !1);
      }, 1e3 * (c.timeoutInSeconds || 60));
      d = function(v) {
        if (v.data && v.data.type === "authorization_response") {
          if (clearTimeout(h), clearInterval(f), window.removeEventListener("message", d, !1), c.popup.close(), v.data.response.error) return u(rr.fromPayload(v.data.response));
          l(v.data.response);
        }
      }, window.addEventListener("message", d);
    }))(Object.assign(Object.assign({}, n), { timeoutInSeconds: n.timeoutInSeconds || this.options.authorizeTimeoutInSeconds || 60 }));
    if (o.state !== i.state) throw new rr("state_mismatch", "Invalid state");
    const a = ((r = t.authorizationParams) === null || r === void 0 ? void 0 : r.organization) || this.options.authorizationParams.organization;
    await this._requestToken({ audience: o.audience, scope: o.scope, code_verifier: o.code_verifier, grant_type: "authorization_code", code: i.code, redirect_uri: o.redirect_uri }, { nonceIn: o.nonce, organization: a });
  }
  async getUser() {
    var t;
    const n = await this._getIdTokenFromCache();
    return (t = n == null ? void 0 : n.decodedToken) === null || t === void 0 ? void 0 : t.user;
  }
  async getIdTokenClaims() {
    var t;
    const n = await this._getIdTokenFromCache();
    return (t = n == null ? void 0 : n.decodedToken) === null || t === void 0 ? void 0 : t.claims;
  }
  async loginWithRedirect(t = {}) {
    var n;
    const r = kR(t), { openUrl: o, fragment: i, appState: a } = r, c = Fi(r, ["openUrl", "fragment", "appState"]), l = ((n = c.authorizationParams) === null || n === void 0 ? void 0 : n.organization) || this.options.authorizationParams.organization, u = await this._prepareAuthorizeUrl(c.authorizationParams || {}), { url: d } = u, f = Fi(u, ["url"]);
    this.transactionManager.create(Object.assign(Object.assign(Object.assign({}, f), { appState: a, response_type: bs.Code }), l && { organization: l }));
    const h = i ? `${d}#${i}` : d;
    o ? await o(h) : window.location.assign(h);
  }
  async handleRedirectCallback(t = window.location.href) {
    const n = t.split("?").slice(1);
    if (n.length === 0) throw new Error("There are no query params available for parsing.");
    const r = this.transactionManager.get();
    if (!r) throw new rr("missing_transaction", "Invalid state");
    this.transactionManager.remove();
    const o = ((i) => {
      i.indexOf("#") > -1 && (i = i.substring(0, i.indexOf("#")));
      const a = new URLSearchParams(i);
      return { state: a.get("state"), code: a.get("code") || void 0, connect_code: a.get("connect_code") || void 0, error: a.get("error") || void 0, error_description: a.get("error_description") || void 0 };
    })(n.join(""));
    return r.response_type === bs.ConnectCode ? this._handleConnectAccountRedirectCallback(o, r) : this._handleLoginRedirectCallback(o, r);
  }
  async _handleLoginRedirectCallback(t, n) {
    const { code: r, state: o, error: i, error_description: a } = t;
    if (i) throw new jJ(i, a || i, o, n.appState);
    if (!n.code_verifier || n.state && n.state !== o) throw new rr("state_mismatch", "Invalid state");
    const c = n.organization, l = n.nonce, u = n.redirect_uri;
    return await this._requestToken(Object.assign({ audience: n.audience, scope: n.scope, code_verifier: n.code_verifier, grant_type: "authorization_code", code: r }, u ? { redirect_uri: u } : {}), { nonceIn: l, organization: c }), { appState: n.appState, response_type: bs.Code };
  }
  async _handleConnectAccountRedirectCallback(t, n) {
    const { connect_code: r, state: o, error: i, error_description: a } = t;
    if (i) throw new FJ(i, a || i, n.connection, o, n.appState);
    if (!r) throw new rr("missing_connect_code", "Missing connect code");
    if (!(n.code_verifier && n.state && n.auth_session && n.redirect_uri && n.state === o)) throw new rr("state_mismatch", "Invalid state");
    const c = await this.myAccountApi.completeAccount({ auth_session: n.auth_session, connect_code: r, redirect_uri: n.redirect_uri, code_verifier: n.code_verifier });
    return Object.assign(Object.assign({}, c), { appState: n.appState, response_type: bs.ConnectCode });
  }
  async checkSession(t) {
    if (!this.cookieStorage.get(this.isAuthenticatedCookieName)) {
      if (!this.cookieStorage.get("auth0.is.authenticated")) return;
      this.cookieStorage.save(this.isAuthenticatedCookieName, !0, { daysUntilExpire: this.sessionCheckExpiryDays, cookieDomain: this.options.cookieDomain }), this.cookieStorage.remove("auth0.is.authenticated");
    }
    try {
      await this.getTokenSilently(t);
    } catch {
    }
  }
  async getTokenSilently(t = {}) {
    var n, r;
    const o = Object.assign(Object.assign({ cacheMode: "on" }, t), { authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), t.authorizationParams), { scope: Fh(this.scope, (n = t.authorizationParams) === null || n === void 0 ? void 0 : n.scope, ((r = t.authorizationParams) === null || r === void 0 ? void 0 : r.audience) || this.options.authorizationParams.audience) }) }), i = await ((a, c) => {
      let l = Fb[c];
      return l || (l = a().finally(() => {
        delete Fb[c], l = null;
      }), Fb[c] = l), l;
    })(() => this._getTokenSilently(o), `${this.options.clientId}::${o.authorizationParams.audience}::${o.authorizationParams.scope}`);
    return t.detailedResponse ? i : i == null ? void 0 : i.access_token;
  }
  async _getTokenSilently(t) {
    const { cacheMode: n } = t, r = Fi(t, ["cacheMode"]);
    if (n !== "off") {
      const c = await this._getEntryFromCache({ scope: r.authorizationParams.scope, audience: r.authorizationParams.audience || "default", clientId: this.options.clientId, cacheMode: n });
      if (c) return c;
    }
    if (n === "cache-only") return;
    const o = (i = this.options.clientId, a = r.authorizationParams.audience || "default", `auth0.lock.getTokenSilently.${i}.${a}`);
    var i, a;
    if (!await (async (c, l = 3) => {
      for (let u = 0; u < l; u++) if (await c()) return !0;
      return !1;
    })(() => zb.acquireLock(o, 5e3), 10)) throw new qO();
    this.activeLockKeys.add(o), this.activeLockKeys.size === 1 && window.addEventListener("pagehide", this._releaseLockOnPageHide);
    try {
      if (n !== "off") {
        const v = await this._getEntryFromCache({ scope: r.authorizationParams.scope, audience: r.authorizationParams.audience || "default", clientId: this.options.clientId });
        if (v) return v;
      }
      const c = this.options.useRefreshTokens ? await this._getTokenUsingRefreshToken(r) : await this._getTokenFromIFrame(r), { id_token: l, token_type: u, access_token: d, oauthTokenScope: f, expires_in: h } = c;
      return Object.assign(Object.assign({ id_token: l, token_type: u, access_token: d }, f ? { scope: f } : null), { expires_in: h });
    } finally {
      await zb.releaseLock(o), this.activeLockKeys.delete(o), this.activeLockKeys.size === 0 && window.removeEventListener("pagehide", this._releaseLockOnPageHide);
    }
  }
  async getTokenWithPopup(t = {}, n = {}) {
    var r, o;
    const i = Object.assign(Object.assign({}, t), { authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), t.authorizationParams), { scope: Fh(this.scope, (r = t.authorizationParams) === null || r === void 0 ? void 0 : r.scope, ((o = t.authorizationParams) === null || o === void 0 ? void 0 : o.audience) || this.options.authorizationParams.audience) }) });
    return n = Object.assign(Object.assign({}, LJ), n), await this.loginWithPopup(i, n), (await this.cacheManager.get(new Ma({ scope: i.authorizationParams.scope, audience: i.authorizationParams.audience || "default", clientId: this.options.clientId }), void 0, this.options.useMrrt)).access_token;
  }
  async isAuthenticated() {
    return !!await this.getUser();
  }
  _buildLogoutUrl(t) {
    t.clientId !== null ? t.clientId = t.clientId || this.options.clientId : delete t.clientId;
    const n = t.logoutParams || {}, { federated: r } = n, o = Fi(n, ["federated"]), i = r ? "&federated" : "";
    return this._url(`/v2/logout?${UO(Object.assign({ clientId: t.clientId }, o))}`) + i;
  }
  async logout(t = {}) {
    var n;
    const r = kR(t), { openUrl: o } = r, i = Fi(r, ["openUrl"]);
    t.clientId === null ? await this.cacheManager.clear() : await this.cacheManager.clear(t.clientId || this.options.clientId), this.cookieStorage.remove(this.orgHintCookieName, { cookieDomain: this.options.cookieDomain }), this.cookieStorage.remove(this.isAuthenticatedCookieName, { cookieDomain: this.options.cookieDomain }), this.userCache.remove("@@user@@"), await ((n = this.dpop) === null || n === void 0 ? void 0 : n.clear());
    const a = this._buildLogoutUrl(i);
    o ? await o(a) : o !== !1 && window.location.assign(a);
  }
  async _getTokenFromIFrame(t) {
    const n = Object.assign(Object.assign({}, t.authorizationParams), { prompt: "none" }), r = this.cookieStorage.get(this.orgHintCookieName);
    r && !n.organization && (n.organization = r);
    const { url: o, state: i, nonce: a, code_verifier: c, redirect_uri: l, scope: u, audience: d } = await this._prepareAuthorizeUrl(n, { response_mode: "web_message" }, window.location.origin);
    try {
      if (window.crossOriginIsolated) throw new rr("login_required", "The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");
      const f = t.timeoutInSeconds || this.options.authorizeTimeoutInSeconds;
      let h;
      try {
        h = new URL(this.domainUrl).origin;
      } catch {
        h = this.domainUrl;
      }
      const v = await ((g, b, x = 60) => new Promise(($, S) => {
        const O = window.document.createElement("iframe");
        O.setAttribute("width", "0"), O.setAttribute("height", "0"), O.style.display = "none";
        const C = () => {
          window.document.body.contains(O) && (window.document.body.removeChild(O), window.removeEventListener("message", T, !1));
        };
        let T;
        const k = setTimeout(() => {
          S(new qO()), C();
        }, 1e3 * x);
        T = function(I) {
          if (I.origin != b || !I.data || I.data.type !== "authorization_response") return;
          const P = I.source;
          P && P.close(), I.data.response.error ? S(rr.fromPayload(I.data.response)) : $(I.data.response), clearTimeout(k), window.removeEventListener("message", T, !1), setTimeout(C, 2e3);
        }, window.addEventListener("message", T, !1), window.document.body.appendChild(O), O.setAttribute("src", g);
      }))(o, h, f);
      if (i !== v.state) throw new rr("state_mismatch", "Invalid state");
      const y = await this._requestToken(Object.assign(Object.assign({}, t.authorizationParams), { code_verifier: c, code: v.code, grant_type: "authorization_code", redirect_uri: l, timeout: t.authorizationParams.timeout || this.httpTimeoutMs }), { nonceIn: a, organization: n.organization });
      return Object.assign(Object.assign({}, y), { scope: u, oauthTokenScope: y.scope, audience: d });
    } catch (f) {
      throw f.error === "login_required" && this.logout({ openUrl: !1 }), f;
    }
  }
  async _getTokenUsingRefreshToken(t) {
    const n = await this.cacheManager.get(new Ma({ scope: t.authorizationParams.scope, audience: t.authorizationParams.audience || "default", clientId: this.options.clientId }), void 0, this.options.useMrrt);
    if (!(n && n.refresh_token || this.worker)) {
      if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(t);
      throw new r7(t.authorizationParams.audience || "default", t.authorizationParams.scope);
    }
    const r = t.authorizationParams.redirect_uri || this.options.authorizationParams.redirect_uri || window.location.origin, o = typeof t.timeoutInSeconds == "number" ? 1e3 * t.timeoutInSeconds : null, i = ((d, f, h, v) => {
      var y;
      if (d && h && v) {
        if (f.audience !== h) return f.scope;
        const g = v.split(" "), b = ((y = f.scope) === null || y === void 0 ? void 0 : y.split(" ")) || [], x = b.every(($) => g.includes($));
        return g.length >= b.length && x ? v : f.scope;
      }
      return f.scope;
    })(this.options.useMrrt, t.authorizationParams, n == null ? void 0 : n.audience, n == null ? void 0 : n.scope);
    try {
      const d = await this._requestToken(Object.assign(Object.assign(Object.assign({}, t.authorizationParams), { grant_type: "refresh_token", refresh_token: n && n.refresh_token, redirect_uri: r }), o && { timeout: o }), { scopesToRequest: i });
      if (d.refresh_token && this.options.useMrrt && (n != null && n.refresh_token) && await this.cacheManager.updateEntry(n.refresh_token, d.refresh_token), this.options.useMrrt && (a = n == null ? void 0 : n.audience, c = n == null ? void 0 : n.scope, l = t.authorizationParams.audience, u = t.authorizationParams.scope, (a !== l || !RR(u, c)) && !RR(i, d.scope))) {
        if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(t);
        await this.cacheManager.remove(this.options.clientId, t.authorizationParams.audience, t.authorizationParams.scope);
        const f = ((h, v) => {
          const y = (h == null ? void 0 : h.split(" ")) || [], g = (v == null ? void 0 : v.split(" ")) || [];
          return y.filter((b) => g.indexOf(b) == -1).join(",");
        })(i, d.scope);
        throw new UJ(t.authorizationParams.audience || "default", f);
      }
      return Object.assign(Object.assign({}, d), { scope: t.authorizationParams.scope, oauthTokenScope: d.scope, audience: t.authorizationParams.audience || "default" });
    } catch (d) {
      if ((d.message.indexOf("Missing Refresh Token") > -1 || d.message && d.message.indexOf("invalid refresh token") > -1) && this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(t);
      throw d;
    }
    var a, c, l, u;
  }
  async _saveEntryInCache(t) {
    const { id_token: n, decodedToken: r } = t, o = Fi(t, ["id_token", "decodedToken"]);
    this.userCache.set("@@user@@", { id_token: n, decodedToken: r }), await this.cacheManager.setIdToken(this.options.clientId, t.id_token, t.decodedToken), await this.cacheManager.set(o);
  }
  async _getIdTokenFromCache() {
    const t = this.options.authorizationParams.audience || "default", n = this.scope[t], r = await this.cacheManager.getIdToken(new Ma({ clientId: this.options.clientId, audience: t, scope: n })), o = this.userCache.get("@@user@@");
    return r && r.id_token === (o == null ? void 0 : o.id_token) ? o : (this.userCache.set("@@user@@", r), r);
  }
  async _getEntryFromCache({ scope: t, audience: n, clientId: r, cacheMode: o }) {
    const i = await this.cacheManager.get(new Ma({ scope: t, audience: n, clientId: r }), 60, this.options.useMrrt, o);
    if (i && i.access_token) {
      const { token_type: a, access_token: c, oauthTokenScope: l, expires_in: u } = i, d = await this._getIdTokenFromCache();
      return d && Object.assign(Object.assign({ id_token: d.id_token, token_type: a || "Bearer", access_token: c }, l ? { scope: l } : null), { expires_in: u });
    }
  }
  async _requestToken(t, n) {
    const { nonceIn: r, organization: o, scopesToRequest: i } = n || {}, a = await aQ(Object.assign(Object.assign({ baseUrl: this.domainUrl, client_id: this.options.clientId, auth0Client: this.options.auth0Client, useFormData: this.options.useFormData, timeout: this.httpTimeoutMs, useMrrt: this.options.useMrrt, dpop: this.dpop }, t), { scope: i || t.scope }), this.worker), c = await this._verifyIdToken(a.id_token, r, o);
    return await this._saveEntryInCache(Object.assign(Object.assign(Object.assign(Object.assign({}, a), { decodedToken: c, scope: t.scope, audience: t.audience || "default" }), a.scope ? { oauthTokenScope: a.scope } : null), { client_id: this.options.clientId })), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, { daysUntilExpire: this.sessionCheckExpiryDays, cookieDomain: this.options.cookieDomain }), this._processOrgHint(o || c.claims.org_id), Object.assign(Object.assign({}, a), { decodedToken: c });
  }
  async exchangeToken(t) {
    return this._requestToken({ grant_type: "urn:ietf:params:oauth:grant-type:token-exchange", subject_token: t.subject_token, subject_token_type: t.subject_token_type, scope: Fh(this.scope, t.scope, t.audience || this.options.authorizationParams.audience), audience: t.audience || this.options.authorizationParams.audience });
  }
  _assertDpop(t) {
    if (!t) throw new Error("`useDpop` option must be enabled before using DPoP.");
  }
  getDpopNonce(t) {
    return this._assertDpop(this.dpop), this.dpop.getNonce(t);
  }
  setDpopNonce(t, n) {
    return this._assertDpop(this.dpop), this.dpop.setNonce(t, n);
  }
  generateDpopProof(t) {
    return this._assertDpop(this.dpop), this.dpop.generateProof(t);
  }
  createFetcher(t = {}) {
    return new wQ(t, { isDpopEnabled: () => !!this.options.useDpop, getAccessToken: (n) => {
      var r;
      return this.getTokenSilently({ authorizationParams: { scope: (r = n == null ? void 0 : n.scope) === null || r === void 0 ? void 0 : r.join(" "), audience: n == null ? void 0 : n.audience }, detailedResponse: !0 });
    }, getDpopNonce: () => this.getDpopNonce(t.dpopNonceId), setDpopNonce: (n) => this.setDpopNonce(n, t.dpopNonceId), generateDpopProof: (n) => this.generateDpopProof(n) });
  }
  async connectAccountWithRedirect(t) {
    const { openUrl: n, appState: r, connection: o, scopes: i, authorization_params: a, redirectUri: c = this.options.authorizationParams.redirect_uri || window.location.origin } = t;
    if (!o) throw new Error("connection is required");
    const l = Lb(Ed()), u = Ed(), d = await wR(u), f = OR(d), { connect_uri: h, connect_params: v, auth_session: y } = await this.myAccountApi.connectAccount({ connection: o, scopes: i, redirect_uri: c, state: l, code_challenge: f, code_challenge_method: "S256", authorization_params: a });
    this.transactionManager.create({ state: l, code_verifier: u, auth_session: y, redirect_uri: c, appState: r, connection: o, response_type: bs.ConnectCode });
    const g = new URL(h);
    g.searchParams.set("ticket", v.ticket), n ? await n(g.toString()) : window.location.assign(g);
  }
};
var g7 = {
  isAuthenticated: !1,
  isLoading: !0,
  error: void 0,
  user: void 0
}, Wr = function() {
  throw new Error("You forgot to wrap your component in <Auth0Provider>.");
}, SQ = En(En({}, g7), { buildAuthorizeUrl: Wr, buildLogoutUrl: Wr, getAccessTokenSilently: Wr, getAccessTokenWithPopup: Wr, getIdTokenClaims: Wr, loginWithRedirect: Wr, loginWithPopup: Wr, connectAccountWithRedirect: Wr, logout: Wr, handleRedirectCallback: Wr, getDpopNonce: Wr, setDpopNonce: Wr, generateDpopProof: Wr, createFetcher: Wr }), YC = j0(SQ), AR = (
  /** @class */
  function(e) {
    MJ(t, e);
    function t(n, r) {
      var o = e.call(this, r ?? n) || this;
      return o.error = n, o.error_description = r, Object.setPrototypeOf(o, t.prototype), o;
    }
    return t;
  }(Error)
), CQ = /[?&](?:connect_)?code=[^&]+/, TQ = /[?&]state=[^&]+/, EQ = /[?&]error=[^&]+/, _Q = function(e) {
  return e === void 0 && (e = window.location.search), (CQ.test(e) || EQ.test(e)) && TQ.test(e);
}, v7 = function(e) {
  return function(t) {
    if (t instanceof Error)
      return t;
    if (t !== null && typeof t == "object" && "error" in t && typeof t.error == "string") {
      if ("error_description" in t && typeof t.error_description == "string") {
        var n = t;
        return new AR(n.error, n.error_description);
      }
      var r = t;
      return new AR(r.error);
    }
    return new Error(e);
  };
}, IR = v7("Login failed"), Bb = v7("Get access token failed"), y7 = function(e) {
  var t, n;
  e != null && e.redirectUri && (console.warn("Using `redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `redirectUri` will be no longer supported in a future version"), e.authorizationParams = (t = e.authorizationParams) !== null && t !== void 0 ? t : {}, e.authorizationParams.redirect_uri = e.redirectUri, delete e.redirectUri), !((n = e == null ? void 0 : e.authorizationParams) === null || n === void 0) && n.redirectUri && (console.warn("Using `authorizationParams.redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `authorizationParams.redirectUri` will be removed in a future version"), e.authorizationParams.redirect_uri = e.authorizationParams.redirectUri, delete e.authorizationParams.redirectUri);
}, kQ = function(e, t) {
  switch (t.type) {
    case "LOGIN_POPUP_STARTED":
      return En(En({}, e), { isLoading: !0 });
    case "LOGIN_POPUP_COMPLETE":
    case "INITIALISED":
      return En(En({}, e), { isAuthenticated: !!t.user, user: t.user, isLoading: !1, error: void 0 });
    case "HANDLE_REDIRECT_COMPLETE":
    case "GET_ACCESS_TOKEN_COMPLETE":
      return e.user === t.user ? e : En(En({}, e), { isAuthenticated: !!t.user, user: t.user });
    case "LOGOUT":
      return En(En({}, e), { isAuthenticated: !1, user: void 0 });
    case "ERROR":
      return En(En({}, e), { isLoading: !1, error: t.error });
  }
}, RQ = function(e) {
  return y7(e), En(En({}, e), { auth0Client: {
    name: "auth0-react",
    version: "2.9.0"
  } });
}, PQ = function(e) {
  var t;
  window.history.replaceState({}, document.title, (t = e.returnTo) !== null && t !== void 0 ? t : window.location.pathname);
}, wIe = function(e) {
  var t = e.children, n = e.skipRedirectCallback, r = e.onRedirectCallback, o = r === void 0 ? PQ : r, i = e.context, a = i === void 0 ? YC : i, c = xR(e, ["children", "skipRedirectCallback", "onRedirectCallback", "context"]), l = Uc(function() {
    return new OQ(RQ(c));
  })[0], u = V8(kQ, g7), d = u[0], f = u[1], h = Gt(!1), v = Rt(function(A) {
    return f({ type: "ERROR", error: A }), A;
  }, []);
  mn(function() {
    h.current || (h.current = !0, function() {
      return gs(void 0, void 0, void 0, function() {
        var A, D, M, N, L, z, q;
        return vs(this, function(W) {
          switch (W.label) {
            case 0:
              return W.trys.push([0, 7, , 8]), A = void 0, _Q() && !n ? [4, l.handleRedirectCallback()] : [3, 3];
            case 1:
              return D = W.sent(), M = D.appState, N = M === void 0 ? {} : M, L = D.response_type, z = xR(D, ["appState", "response_type"]), [4, l.getUser()];
            case 2:
              return A = W.sent(), N.response_type = L, L === bs.ConnectCode && (N.connectedAccount = z), o(N, A), [3, 6];
            case 3:
              return [4, l.checkSession()];
            case 4:
              return W.sent(), [4, l.getUser()];
            case 5:
              A = W.sent(), W.label = 6;
            case 6:
              return f({ type: "INITIALISED", user: A }), [3, 8];
            case 7:
              return q = W.sent(), v(IR(q)), [3, 8];
            case 8:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }());
  }, [l, o, n, v]);
  var y = Rt(function(A) {
    return y7(A), l.loginWithRedirect(A);
  }, [l]), g = Rt(function(A, D) {
    return gs(void 0, void 0, void 0, function() {
      var M, N;
      return vs(this, function(L) {
        switch (L.label) {
          case 0:
            f({ type: "LOGIN_POPUP_STARTED" }), L.label = 1;
          case 1:
            return L.trys.push([1, 3, , 4]), [4, l.loginWithPopup(A, D)];
          case 2:
            return L.sent(), [3, 4];
          case 3:
            return M = L.sent(), v(IR(M)), [
              2
              /*return*/
            ];
          case 4:
            return [4, l.getUser()];
          case 5:
            return N = L.sent(), f({ type: "LOGIN_POPUP_COMPLETE", user: N }), [
              2
              /*return*/
            ];
        }
      });
    });
  }, [l, v]), b = Rt(function() {
    for (var A = [], D = 0; D < arguments.length; D++)
      A[D] = arguments[D];
    return gs(void 0, NJ([], A), void 0, function(M) {
      return M === void 0 && (M = {}), vs(this, function(N) {
        switch (N.label) {
          case 0:
            return [4, l.logout(M)];
          case 1:
            return N.sent(), (M.openUrl || M.openUrl === !1) && f({ type: "LOGOUT" }), [
              2
              /*return*/
            ];
        }
      });
    });
  }, [l]), x = Rt(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(A) {
      return gs(void 0, void 0, void 0, function() {
        var D, M, N, L;
        return vs(this, function(z) {
          switch (z.label) {
            case 0:
              return z.trys.push([0, 2, 3, 5]), [4, l.getTokenSilently(A)];
            case 1:
              return D = z.sent(), [3, 5];
            case 2:
              throw M = z.sent(), Bb(M);
            case 3:
              return N = f, L = {
                type: "GET_ACCESS_TOKEN_COMPLETE"
              }, [4, l.getUser()];
            case 4:
              return N.apply(void 0, [(L.user = z.sent(), L)]), [
                7
                /*endfinally*/
              ];
            case 5:
              return [2, D];
          }
        });
      });
    },
    [l]
  ), $ = Rt(function(A, D) {
    return gs(void 0, void 0, void 0, function() {
      var M, N, L, z;
      return vs(this, function(q) {
        switch (q.label) {
          case 0:
            return q.trys.push([0, 2, 3, 5]), [4, l.getTokenWithPopup(A, D)];
          case 1:
            return M = q.sent(), [3, 5];
          case 2:
            throw N = q.sent(), Bb(N);
          case 3:
            return L = f, z = {
              type: "GET_ACCESS_TOKEN_COMPLETE"
            }, [4, l.getUser()];
          case 4:
            return L.apply(void 0, [(z.user = q.sent(), z)]), [
              7
              /*endfinally*/
            ];
          case 5:
            return [2, M];
        }
      });
    });
  }, [l]), S = Rt(function(A) {
    return l.connectAccountWithRedirect(A);
  }, [l]), O = Rt(function() {
    return l.getIdTokenClaims();
  }, [l]), C = Rt(function(A) {
    return gs(void 0, void 0, void 0, function() {
      var D, M, N;
      return vs(this, function(L) {
        switch (L.label) {
          case 0:
            return L.trys.push([0, 2, 3, 5]), [4, l.handleRedirectCallback(A)];
          case 1:
            return [2, L.sent()];
          case 2:
            throw D = L.sent(), Bb(D);
          case 3:
            return M = f, N = {
              type: "HANDLE_REDIRECT_COMPLETE"
            }, [4, l.getUser()];
          case 4:
            return M.apply(void 0, [(N.user = L.sent(), N)]), [
              7
              /*endfinally*/
            ];
          case 5:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, [l]), T = Rt(function(A) {
    return l.getDpopNonce(A);
  }, [l]), k = Rt(function(A, D) {
    return l.setDpopNonce(A, D);
  }, [l]), I = Rt(function(A) {
    return l.generateDpopProof(A);
  }, [l]), P = Rt(function(A) {
    return l.createFetcher(A);
  }, [l]), _ = Nn(function() {
    return En(En({}, d), { getAccessTokenSilently: x, getAccessTokenWithPopup: $, getIdTokenClaims: O, loginWithRedirect: y, loginWithPopup: g, connectAccountWithRedirect: S, logout: b, handleRedirectCallback: C, getDpopNonce: T, setDpopNonce: k, generateDpopProof: I, createFetcher: P });
  }, [
    d,
    x,
    $,
    O,
    y,
    g,
    S,
    b,
    C,
    T,
    k,
    I,
    P
  ]);
  return ye.createElement(a.Provider, { value: _ }, t);
}, AQ = function(e) {
  return e === void 0 && (e = YC), pa(e);
}, IQ = function() {
  return ye.createElement(ye.Fragment, null);
}, MQ = function() {
  return gs(void 0, void 0, void 0, function() {
    return vs(this, function(e) {
      return [
        2
        /*return*/
      ];
    });
  });
}, NQ = function() {
  return "".concat(window.location.pathname).concat(window.location.search);
}, $Ie = function(e, t) {
  return t === void 0 && (t = {}), function(r) {
    var o = this, i = t.returnTo, a = i === void 0 ? NQ : i, c = t.onRedirecting, l = c === void 0 ? IQ : c, u = t.onBeforeAuthentication, d = u === void 0 ? MQ : u, f = t.loginOptions, h = t.context, v = h === void 0 ? YC : h, y = AQ(v), g = y.isAuthenticated, b = y.isLoading, x = y.loginWithRedirect;
    return mn(function() {
      if (!(b || g)) {
        var $ = En(En({}, f), { appState: En(En({}, f == null ? void 0 : f.appState), { returnTo: typeof a == "function" ? a() : a }) });
        (function() {
          return gs(o, void 0, void 0, function() {
            return vs(this, function(S) {
              switch (S.label) {
                case 0:
                  return [4, d()];
                case 1:
                  return S.sent(), [4, x($)];
                case 2:
                  return S.sent(), [
                    2
                    /*return*/
                  ];
              }
            });
          });
        })();
      }
    }, [
      b,
      g,
      x,
      d,
      f,
      a
    ]), g ? ye.createElement(e, En({}, r)) : l();
  };
};
const Pf = {
  black: "#000",
  white: "#fff"
}, Al = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, Il = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, Ml = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, Nl = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, Dl = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, kd = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, DQ = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
};
function na(e, ...t) {
  const n = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((r) => n.searchParams.append("args[]", r)), `Minified MUI error #${e}; visit ${n} for the full message.`;
}
const Xo = "$$material";
function Sg() {
  return Sg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Sg.apply(this, arguments);
}
function z0(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var LQ = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, jQ = /* @__PURE__ */ z0(
  function(e) {
    return LQ.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), FQ = !1;
function zQ(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function BQ(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var qQ = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(o) {
      var i;
      r.tags.length === 0 ? r.insertionPoint ? i = r.insertionPoint.nextSibling : r.prepend ? i = r.container.firstChild : i = r.before : i = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(o, i), r.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? !FQ : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(BQ(this));
    var o = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var i = zQ(o);
      try {
        i.insertRule(r, i.cssRules.length);
      } catch {
      }
    } else
      o.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      var o;
      return (o = r.parentNode) == null ? void 0 : o.removeChild(r);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), Er = "-ms-", Cg = "-moz-", Vt = "-webkit-", b7 = "comm", GC = "rule", KC = "decl", UQ = "@import", x7 = "@keyframes", WQ = "@layer", HQ = Math.abs, B0 = String.fromCharCode, VQ = Object.assign;
function YQ(e, t) {
  return pr(e, 0) ^ 45 ? (((t << 2 ^ pr(e, 0)) << 2 ^ pr(e, 1)) << 2 ^ pr(e, 2)) << 2 ^ pr(e, 3) : 0;
}
function w7(e) {
  return e.trim();
}
function GQ(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function Yt(e, t, n) {
  return e.replace(t, n);
}
function VO(e, t) {
  return e.indexOf(t);
}
function pr(e, t) {
  return e.charCodeAt(t) | 0;
}
function Af(e, t, n) {
  return e.slice(t, n);
}
function zi(e) {
  return e.length;
}
function XC(e) {
  return e.length;
}
function zh(e, t) {
  return t.push(e), e;
}
function KQ(e, t) {
  return e.map(t).join("");
}
var q0 = 1, wu = 1, $7 = 0, no = 0, Yn = 0, Vu = "";
function U0(e, t, n, r, o, i, a) {
  return { value: e, root: t, parent: n, type: r, props: o, children: i, line: q0, column: wu, length: a, return: "" };
}
function Rd(e, t) {
  return VQ(U0("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function XQ() {
  return Yn;
}
function ZQ() {
  return Yn = no > 0 ? pr(Vu, --no) : 0, wu--, Yn === 10 && (wu = 1, q0--), Yn;
}
function bo() {
  return Yn = no < $7 ? pr(Vu, no++) : 0, wu++, Yn === 10 && (wu = 1, q0++), Yn;
}
function Zi() {
  return pr(Vu, no);
}
function Vm() {
  return no;
}
function wp(e, t) {
  return Af(Vu, e, t);
}
function If(e) {
  switch (e) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function O7(e) {
  return q0 = wu = 1, $7 = zi(Vu = e), no = 0, [];
}
function S7(e) {
  return Vu = "", e;
}
function Ym(e) {
  return w7(wp(no - 1, YO(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function JQ(e) {
  for (; (Yn = Zi()) && Yn < 33; )
    bo();
  return If(e) > 2 || If(Yn) > 3 ? "" : " ";
}
function QQ(e, t) {
  for (; --t && bo() && !(Yn < 48 || Yn > 102 || Yn > 57 && Yn < 65 || Yn > 70 && Yn < 97); )
    ;
  return wp(e, Vm() + (t < 6 && Zi() == 32 && bo() == 32));
}
function YO(e) {
  for (; bo(); )
    switch (Yn) {
      // ] ) " '
      case e:
        return no;
      // " '
      case 34:
      case 39:
        e !== 34 && e !== 39 && YO(Yn);
        break;
      // (
      case 40:
        e === 41 && YO(e);
        break;
      // \
      case 92:
        bo();
        break;
    }
  return no;
}
function eee(e, t) {
  for (; bo() && e + Yn !== 57; )
    if (e + Yn === 84 && Zi() === 47)
      break;
  return "/*" + wp(t, no - 1) + "*" + B0(e === 47 ? e : bo());
}
function tee(e) {
  for (; !If(Zi()); )
    bo();
  return wp(e, no);
}
function nee(e) {
  return S7(Gm("", null, null, null, [""], e = O7(e), 0, [0], e));
}
function Gm(e, t, n, r, o, i, a, c, l) {
  for (var u = 0, d = 0, f = a, h = 0, v = 0, y = 0, g = 1, b = 1, x = 1, $ = 0, S = "", O = o, C = i, T = r, k = S; b; )
    switch (y = $, $ = bo()) {
      // (
      case 40:
        if (y != 108 && pr(k, f - 1) == 58) {
          VO(k += Yt(Ym($), "&", "&\f"), "&\f") != -1 && (x = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        k += Ym($);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        k += JQ(y);
        break;
      // \
      case 92:
        k += QQ(Vm() - 1, 7);
        continue;
      // /
      case 47:
        switch (Zi()) {
          case 42:
          case 47:
            zh(ree(eee(bo(), Vm()), t, n), l);
            break;
          default:
            k += "/";
        }
        break;
      // {
      case 123 * g:
        c[u++] = zi(k) * x;
      // } ; \0
      case 125 * g:
      case 59:
      case 0:
        switch ($) {
          // \0 }
          case 0:
          case 125:
            b = 0;
          // ;
          case 59 + d:
            x == -1 && (k = Yt(k, /\f/g, "")), v > 0 && zi(k) - f && zh(v > 32 ? NR(k + ";", r, n, f - 1) : NR(Yt(k, " ", "") + ";", r, n, f - 2), l);
            break;
          // @ ;
          case 59:
            k += ";";
          // { rule/at-rule
          default:
            if (zh(T = MR(k, t, n, u, d, o, c, S, O = [], C = [], f), i), $ === 123)
              if (d === 0)
                Gm(k, t, T, T, O, i, f, c, C);
              else
                switch (h === 99 && pr(k, 3) === 110 ? 100 : h) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Gm(e, T, T, r && zh(MR(e, T, T, 0, 0, o, c, S, o, O = [], f), C), o, C, f, c, r ? O : C);
                    break;
                  default:
                    Gm(k, T, T, T, [""], C, 0, c, C);
                }
        }
        u = d = v = 0, g = x = 1, S = k = "", f = a;
        break;
      // :
      case 58:
        f = 1 + zi(k), v = y;
      default:
        if (g < 1) {
          if ($ == 123)
            --g;
          else if ($ == 125 && g++ == 0 && ZQ() == 125)
            continue;
        }
        switch (k += B0($), $ * g) {
          // &
          case 38:
            x = d > 0 ? 1 : (k += "\f", -1);
            break;
          // ,
          case 44:
            c[u++] = (zi(k) - 1) * x, x = 1;
            break;
          // @
          case 64:
            Zi() === 45 && (k += Ym(bo())), h = Zi(), d = f = zi(S = k += tee(Vm())), $++;
            break;
          // -
          case 45:
            y === 45 && zi(k) == 2 && (g = 0);
        }
    }
  return i;
}
function MR(e, t, n, r, o, i, a, c, l, u, d) {
  for (var f = o - 1, h = o === 0 ? i : [""], v = XC(h), y = 0, g = 0, b = 0; y < r; ++y)
    for (var x = 0, $ = Af(e, f + 1, f = HQ(g = a[y])), S = e; x < v; ++x)
      (S = w7(g > 0 ? h[x] + " " + $ : Yt($, /&\f/g, h[x]))) && (l[b++] = S);
  return U0(e, t, n, o === 0 ? GC : c, l, u, d);
}
function ree(e, t, n) {
  return U0(e, t, n, b7, B0(XQ()), Af(e, 2, -2), 0);
}
function NR(e, t, n, r) {
  return U0(e, t, n, KC, Af(e, 0, r), Af(e, r + 1, -1), r);
}
function lu(e, t) {
  for (var n = "", r = XC(e), o = 0; o < r; o++)
    n += t(e[o], o, e, t) || "";
  return n;
}
function oee(e, t, n, r) {
  switch (e.type) {
    case WQ:
      if (e.children.length) break;
    case UQ:
    case KC:
      return e.return = e.return || e.value;
    case b7:
      return "";
    case x7:
      return e.return = e.value + "{" + lu(e.children, r) + "}";
    case GC:
      e.value = e.props.join(",");
  }
  return zi(n = lu(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function iee(e) {
  var t = XC(e);
  return function(n, r, o, i) {
    for (var a = "", c = 0; c < t; c++)
      a += e[c](n, r, o, i) || "";
    return a;
  };
}
function aee(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
var see = function(t, n, r) {
  for (var o = 0, i = 0; o = i, i = Zi(), o === 38 && i === 12 && (n[r] = 1), !If(i); )
    bo();
  return wp(t, no);
}, cee = function(t, n) {
  var r = -1, o = 44;
  do
    switch (If(o)) {
      case 0:
        o === 38 && Zi() === 12 && (n[r] = 1), t[r] += see(no - 1, n, r);
        break;
      case 2:
        t[r] += Ym(o);
        break;
      case 4:
        if (o === 44) {
          t[++r] = Zi() === 58 ? "&\f" : "", n[r] = t[r].length;
          break;
        }
      // fallthrough
      default:
        t[r] += B0(o);
    }
  while (o = bo());
  return t;
}, lee = function(t, n) {
  return S7(cee(O7(t), n));
}, DR = /* @__PURE__ */ new WeakMap(), uee = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, r = t.parent, o = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r) return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !DR.get(r)) && !o) {
      DR.set(t, !0);
      for (var i = [], a = lee(n, i), c = r.props, l = 0, u = 0; l < a.length; l++)
        for (var d = 0; d < c.length; d++, u++)
          t.props[u] = i[l] ? a[l].replace(/&\f/g, c[d]) : c[d] + " " + a[l];
    }
  }
}, dee = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function C7(e, t) {
  switch (YQ(e, t)) {
    // color-adjust
    case 5103:
      return Vt + "print-" + e + e;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Vt + e + e;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Vt + e + Cg + e + Er + e + e;
    // flex, flex-direction
    case 6828:
    case 4268:
      return Vt + e + Er + e + e;
    // order
    case 6165:
      return Vt + e + Er + "flex-" + e + e;
    // align-items
    case 5187:
      return Vt + e + Yt(e, /(\w+).+(:[^]+)/, Vt + "box-$1$2" + Er + "flex-$1$2") + e;
    // align-self
    case 5443:
      return Vt + e + Er + "flex-item-" + Yt(e, /flex-|-self/, "") + e;
    // align-content
    case 4675:
      return Vt + e + Er + "flex-line-pack" + Yt(e, /align-content|flex-|-self/, "") + e;
    // flex-shrink
    case 5548:
      return Vt + e + Er + Yt(e, "shrink", "negative") + e;
    // flex-basis
    case 5292:
      return Vt + e + Er + Yt(e, "basis", "preferred-size") + e;
    // flex-grow
    case 6060:
      return Vt + "box-" + Yt(e, "-grow", "") + Vt + e + Er + Yt(e, "grow", "positive") + e;
    // transition
    case 4554:
      return Vt + Yt(e, /([^-])(transform)/g, "$1" + Vt + "$2") + e;
    // cursor
    case 6187:
      return Yt(Yt(Yt(e, /(zoom-|grab)/, Vt + "$1"), /(image-set)/, Vt + "$1"), e, "") + e;
    // background, background-image
    case 5495:
    case 3959:
      return Yt(e, /(image-set\([^]*)/, Vt + "$1$`$1");
    // justify-content
    case 4968:
      return Yt(Yt(e, /(.+:)(flex-)?(.*)/, Vt + "box-pack:$3" + Er + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Vt + e + e;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Yt(e, /(.+)-inline(.+)/, Vt + "$1$2") + e;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (zi(e) - 1 - t > 6) switch (pr(e, t + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (pr(e, t + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return Yt(e, /(.+:)(.+)-([^]+)/, "$1" + Vt + "$2-$3$1" + Cg + (pr(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        // (s)tretch
        case 115:
          return ~VO(e, "stretch") ? C7(Yt(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    // position: sticky
    case 4949:
      if (pr(e, t + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (pr(e, zi(e) - 3 - (~VO(e, "!important") && 10))) {
        // stic(k)y
        case 107:
          return Yt(e, ":", ":" + Vt) + e;
        // (inline-)?fl(e)x
        case 101:
          return Yt(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Vt + (pr(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Vt + "$2$3$1" + Er + "$2box$3") + e;
      }
      break;
    // writing-mode
    case 5936:
      switch (pr(e, t + 11)) {
        // vertical-l(r)
        case 114:
          return Vt + e + Er + Yt(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        // vertical-r(l)
        case 108:
          return Vt + e + Er + Yt(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        // horizontal(-)tb
        case 45:
          return Vt + e + Er + Yt(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Vt + e + Er + e + e;
  }
  return e;
}
var fee = function(t, n, r, o) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case KC:
      t.return = C7(t.value, t.length);
      break;
    case x7:
      return lu([Rd(t, {
        value: Yt(t.value, "@", "@" + Vt)
      })], o);
    case GC:
      if (t.length) return KQ(t.props, function(i) {
        switch (GQ(i, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return lu([Rd(t, {
              props: [Yt(i, /:(read-\w+)/, ":" + Cg + "$1")]
            })], o);
          // :placeholder
          case "::placeholder":
            return lu([Rd(t, {
              props: [Yt(i, /:(plac\w+)/, ":" + Vt + "input-$1")]
            }), Rd(t, {
              props: [Yt(i, /:(plac\w+)/, ":" + Cg + "$1")]
            }), Rd(t, {
              props: [Yt(i, /:(plac\w+)/, Er + "input-$1")]
            })], o);
        }
        return "";
      });
  }
}, pee = [fee], hee = function(t) {
  var n = t.key;
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(g) {
      var b = g.getAttribute("data-emotion");
      b.indexOf(" ") !== -1 && (document.head.appendChild(g), g.setAttribute("data-s", ""));
    });
  }
  var o = t.stylisPlugins || pee, i = {}, a, c = [];
  a = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(g) {
      for (var b = g.getAttribute("data-emotion").split(" "), x = 1; x < b.length; x++)
        i[b[x]] = !0;
      c.push(g);
    }
  );
  var l, u = [uee, dee];
  {
    var d, f = [oee, aee(function(g) {
      d.insert(g);
    })], h = iee(u.concat(o, f)), v = function(b) {
      return lu(nee(b), h);
    };
    l = function(b, x, $, S) {
      d = $, v(b ? b + "{" + x.styles + "}" : x.styles), S && (y.inserted[x.name] = !0);
    };
  }
  var y = {
    key: n,
    sheet: new qQ({
      key: n,
      container: a,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: i,
    registered: {},
    insert: l
  };
  return y.sheet.hydrate(c), y;
}, Vo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function jn(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Bh = { exports: {} }, Jt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var LR;
function mee() {
  if (LR) return Jt;
  LR = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, v = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, $ = e ? Symbol.for("react.scope") : 60119;
  function S(C) {
    if (typeof C == "object" && C !== null) {
      var T = C.$$typeof;
      switch (T) {
        case t:
          switch (C = C.type, C) {
            case l:
            case u:
            case r:
            case i:
            case o:
            case f:
              return C;
            default:
              switch (C = C && C.$$typeof, C) {
                case c:
                case d:
                case y:
                case v:
                case a:
                  return C;
                default:
                  return T;
              }
          }
        case n:
          return T;
      }
    }
  }
  function O(C) {
    return S(C) === u;
  }
  return Jt.AsyncMode = l, Jt.ConcurrentMode = u, Jt.ContextConsumer = c, Jt.ContextProvider = a, Jt.Element = t, Jt.ForwardRef = d, Jt.Fragment = r, Jt.Lazy = y, Jt.Memo = v, Jt.Portal = n, Jt.Profiler = i, Jt.StrictMode = o, Jt.Suspense = f, Jt.isAsyncMode = function(C) {
    return O(C) || S(C) === l;
  }, Jt.isConcurrentMode = O, Jt.isContextConsumer = function(C) {
    return S(C) === c;
  }, Jt.isContextProvider = function(C) {
    return S(C) === a;
  }, Jt.isElement = function(C) {
    return typeof C == "object" && C !== null && C.$$typeof === t;
  }, Jt.isForwardRef = function(C) {
    return S(C) === d;
  }, Jt.isFragment = function(C) {
    return S(C) === r;
  }, Jt.isLazy = function(C) {
    return S(C) === y;
  }, Jt.isMemo = function(C) {
    return S(C) === v;
  }, Jt.isPortal = function(C) {
    return S(C) === n;
  }, Jt.isProfiler = function(C) {
    return S(C) === i;
  }, Jt.isStrictMode = function(C) {
    return S(C) === o;
  }, Jt.isSuspense = function(C) {
    return S(C) === f;
  }, Jt.isValidElementType = function(C) {
    return typeof C == "string" || typeof C == "function" || C === r || C === u || C === i || C === o || C === f || C === h || typeof C == "object" && C !== null && (C.$$typeof === y || C.$$typeof === v || C.$$typeof === a || C.$$typeof === c || C.$$typeof === d || C.$$typeof === b || C.$$typeof === x || C.$$typeof === $ || C.$$typeof === g);
  }, Jt.typeOf = S, Jt;
}
var Qt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jR;
function gee() {
  return jR || (jR = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, v = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, $ = e ? Symbol.for("react.scope") : 60119;
    function S(G) {
      return typeof G == "string" || typeof G == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      G === r || G === u || G === i || G === o || G === f || G === h || typeof G == "object" && G !== null && (G.$$typeof === y || G.$$typeof === v || G.$$typeof === a || G.$$typeof === c || G.$$typeof === d || G.$$typeof === b || G.$$typeof === x || G.$$typeof === $ || G.$$typeof === g);
    }
    function O(G) {
      if (typeof G == "object" && G !== null) {
        var Se = G.$$typeof;
        switch (Se) {
          case t:
            var ue = G.type;
            switch (ue) {
              case l:
              case u:
              case r:
              case i:
              case o:
              case f:
                return ue;
              default:
                var Q = ue && ue.$$typeof;
                switch (Q) {
                  case c:
                  case d:
                  case y:
                  case v:
                  case a:
                    return Q;
                  default:
                    return Se;
                }
            }
          case n:
            return Se;
        }
      }
    }
    var C = l, T = u, k = c, I = a, P = t, _ = d, A = r, D = y, M = v, N = n, L = i, z = o, q = f, W = !1;
    function U(G) {
      return W || (W = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), K(G) || O(G) === l;
    }
    function K(G) {
      return O(G) === u;
    }
    function Y(G) {
      return O(G) === c;
    }
    function X(G) {
      return O(G) === a;
    }
    function oe(G) {
      return typeof G == "object" && G !== null && G.$$typeof === t;
    }
    function re(G) {
      return O(G) === d;
    }
    function Z(G) {
      return O(G) === r;
    }
    function ce(G) {
      return O(G) === y;
    }
    function fe(G) {
      return O(G) === v;
    }
    function de(G) {
      return O(G) === n;
    }
    function ne(G) {
      return O(G) === i;
    }
    function le(G) {
      return O(G) === o;
    }
    function ve(G) {
      return O(G) === f;
    }
    Qt.AsyncMode = C, Qt.ConcurrentMode = T, Qt.ContextConsumer = k, Qt.ContextProvider = I, Qt.Element = P, Qt.ForwardRef = _, Qt.Fragment = A, Qt.Lazy = D, Qt.Memo = M, Qt.Portal = N, Qt.Profiler = L, Qt.StrictMode = z, Qt.Suspense = q, Qt.isAsyncMode = U, Qt.isConcurrentMode = K, Qt.isContextConsumer = Y, Qt.isContextProvider = X, Qt.isElement = oe, Qt.isForwardRef = re, Qt.isFragment = Z, Qt.isLazy = ce, Qt.isMemo = fe, Qt.isPortal = de, Qt.isProfiler = ne, Qt.isStrictMode = le, Qt.isSuspense = ve, Qt.isValidElementType = S, Qt.typeOf = O;
  }()), Qt;
}
var FR;
function ZC() {
  return FR || (FR = 1, process.env.NODE_ENV === "production" ? Bh.exports = mee() : Bh.exports = gee()), Bh.exports;
}
var qb, zR;
function vee() {
  if (zR) return qb;
  zR = 1;
  var e = ZC(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, n = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, r = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, o = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, i = {};
  i[e.ForwardRef] = r, i[e.Memo] = o;
  function a(y) {
    return e.isMemo(y) ? o : i[y.$$typeof] || t;
  }
  var c = Object.defineProperty, l = Object.getOwnPropertyNames, u = Object.getOwnPropertySymbols, d = Object.getOwnPropertyDescriptor, f = Object.getPrototypeOf, h = Object.prototype;
  function v(y, g, b) {
    if (typeof g != "string") {
      if (h) {
        var x = f(g);
        x && x !== h && v(y, x, b);
      }
      var $ = l(g);
      u && ($ = $.concat(u(g)));
      for (var S = a(y), O = a(g), C = 0; C < $.length; ++C) {
        var T = $[C];
        if (!n[T] && !(b && b[T]) && !(O && O[T]) && !(S && S[T])) {
          var k = d(g, T);
          try {
            c(y, T, k);
          } catch {
          }
        }
      }
    }
    return y;
  }
  return qb = v, qb;
}
var yee = vee();
const bee = /* @__PURE__ */ jn(yee);
var xee = !0;
function wee(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? t.push(e[o] + ";") : r += o + " ";
  }), r;
}
var T7 = function(t, n, r) {
  var o = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  xee === !1) && t.registered[o] === void 0 && (t.registered[o] = n.styles);
}, E7 = function(t, n, r) {
  T7(t, n, r);
  var o = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var i = n;
    do
      t.insert(n === i ? "." + o : "", i, t.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function JC(e) {
  for (var t = 0, n, r = 0, o = e.length; o >= 4; ++r, o -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var _7 = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, $ee = !1, Oee = /[A-Z]|^ms/g, See = /_EMO_([^_]+?)_([^]*?)_EMO_/g, k7 = function(t) {
  return t.charCodeAt(1) === 45;
}, BR = function(t) {
  return t != null && typeof t != "boolean";
}, Ub = /* @__PURE__ */ z0(function(e) {
  return k7(e) ? e : e.replace(Oee, "-$&").toLowerCase();
}), qR = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(See, function(r, o, i) {
          return Bi = {
            name: o,
            styles: i,
            next: Bi
          }, o;
        });
  }
  return _7[t] !== 1 && !k7(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
}, Cee = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Mf(e, t, n) {
  if (n == null)
    return "";
  var r = n;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var o = n;
      if (o.anim === 1)
        return Bi = {
          name: o.name,
          styles: o.styles,
          next: Bi
        }, o.name;
      var i = n;
      if (i.styles !== void 0) {
        var a = i.next;
        if (a !== void 0)
          for (; a !== void 0; )
            Bi = {
              name: a.name,
              styles: a.styles,
              next: Bi
            }, a = a.next;
        var c = i.styles + ";";
        return c;
      }
      return Tee(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var l = Bi, u = n(e);
        return Bi = l, Mf(e, t, u);
      }
      break;
    }
  }
  var d = n;
  return d;
}
function Tee(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      r += Mf(e, t, n[o]) + ";";
  else
    for (var i in n) {
      var a = n[i];
      if (typeof a != "object") {
        var c = a;
        BR(c) && (r += Ub(i) + ":" + qR(i, c) + ";");
      } else {
        if (i === "NO_COMPONENT_SELECTOR" && $ee)
          throw new Error(Cee);
        if (Array.isArray(a) && typeof a[0] == "string" && t == null)
          for (var l = 0; l < a.length; l++)
            BR(a[l]) && (r += Ub(i) + ":" + qR(i, a[l]) + ";");
        else {
          var u = Mf(e, t, a);
          switch (i) {
            case "animation":
            case "animationName": {
              r += Ub(i) + ":" + u + ";";
              break;
            }
            default:
              r += i + "{" + u + "}";
          }
        }
      }
    }
  return r;
}
var UR = /label:\s*([^\s;{]+)\s*(;|$)/g, Bi;
function R7(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var r = !0, o = "";
  Bi = void 0;
  var i = e[0];
  if (i == null || i.raw === void 0)
    r = !1, o += Mf(n, t, i);
  else {
    var a = i;
    o += a[0];
  }
  for (var c = 1; c < e.length; c++)
    if (o += Mf(n, t, e[c]), r) {
      var l = i;
      o += l[c];
    }
  UR.lastIndex = 0;
  for (var u = "", d; (d = UR.exec(o)) !== null; )
    u += "-" + d[1];
  var f = JC(o) + u;
  return {
    name: f,
    styles: o,
    next: Bi
  };
}
var Eee = function(t) {
  return t();
}, P7 = E.useInsertionEffect ? E.useInsertionEffect : !1, _ee = P7 || Eee, WR = P7 || E.useLayoutEffect, QC = /* @__PURE__ */ E.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ hee({
    key: "css"
  }) : null
);
QC.Provider;
var kee = function() {
  return pa(QC);
}, A7 = function(t) {
  return /* @__PURE__ */ xp(function(n, r) {
    var o = pa(QC);
    return t(n, o, r);
  });
}, W0 = /* @__PURE__ */ E.createContext({}), Ree = /* @__PURE__ */ A7(function(e, t) {
  var n = e.styles, r = R7([n], void 0, E.useContext(W0)), o = E.useRef();
  return WR(function() {
    var i = t.key + "-global", a = new t.sheet.constructor({
      key: i,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), c = !1, l = document.querySelector('style[data-emotion="' + i + " " + r.name + '"]');
    return t.sheet.tags.length && (a.before = t.sheet.tags[0]), l !== null && (c = !0, l.setAttribute("data-emotion", i), a.hydrate([l])), o.current = [a, c], function() {
      a.flush();
    };
  }, [t]), WR(function() {
    var i = o.current, a = i[0], c = i[1];
    if (c) {
      i[1] = !1;
      return;
    }
    if (r.next !== void 0 && E7(t, r.next, !0), a.tags.length) {
      var l = a.tags[a.tags.length - 1].nextElementSibling;
      a.before = l, a.flush();
    }
    t.insert("", r, a, !1);
  }, [t, r.name]), null;
});
function $p() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return R7(t);
}
var Qc = function() {
  var t = $p.apply(void 0, arguments), n = "animation-" + t.name;
  return {
    name: n,
    styles: "@keyframes " + n + "{" + t.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, Pee = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Aee = !1, Iee = /[A-Z]|^ms/g, Mee = /_EMO_([^_]+?)_([^]*?)_EMO_/g, I7 = function(t) {
  return t.charCodeAt(1) === 45;
}, HR = function(t) {
  return t != null && typeof t != "boolean";
}, Wb = /* @__PURE__ */ z0(function(e) {
  return I7(e) ? e : e.replace(Iee, "-$&").toLowerCase();
}), VR = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(Mee, function(r, o, i) {
          return qi = {
            name: o,
            styles: i,
            next: qi
          }, o;
        });
  }
  return Pee[t] !== 1 && !I7(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
}, Nee = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Nf(e, t, n) {
  if (n == null)
    return "";
  var r = n;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var o = n;
      if (o.anim === 1)
        return qi = {
          name: o.name,
          styles: o.styles,
          next: qi
        }, o.name;
      var i = n;
      if (i.styles !== void 0) {
        var a = i.next;
        if (a !== void 0)
          for (; a !== void 0; )
            qi = {
              name: a.name,
              styles: a.styles,
              next: qi
            }, a = a.next;
        var c = i.styles + ";";
        return c;
      }
      return Dee(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var l = qi, u = n(e);
        return qi = l, Nf(e, t, u);
      }
      break;
    }
  }
  var d = n;
  if (t == null)
    return d;
  var f = t[d];
  return f !== void 0 ? f : d;
}
function Dee(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      r += Nf(e, t, n[o]) + ";";
  else
    for (var i in n) {
      var a = n[i];
      if (typeof a != "object") {
        var c = a;
        t != null && t[c] !== void 0 ? r += i + "{" + t[c] + "}" : HR(c) && (r += Wb(i) + ":" + VR(i, c) + ";");
      } else {
        if (i === "NO_COMPONENT_SELECTOR" && Aee)
          throw new Error(Nee);
        if (Array.isArray(a) && typeof a[0] == "string" && (t == null || t[a[0]] === void 0))
          for (var l = 0; l < a.length; l++)
            HR(a[l]) && (r += Wb(i) + ":" + VR(i, a[l]) + ";");
        else {
          var u = Nf(e, t, a);
          switch (i) {
            case "animation":
            case "animationName": {
              r += Wb(i) + ":" + u + ";";
              break;
            }
            default:
              r += i + "{" + u + "}";
          }
        }
      }
    }
  return r;
}
var YR = /label:\s*([^\s;\n{]+)\s*(;|$)/g, qi;
function Lee(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var r = !0, o = "";
  qi = void 0;
  var i = e[0];
  if (i == null || i.raw === void 0)
    r = !1, o += Nf(n, t, i);
  else {
    var a = i;
    o += a[0];
  }
  for (var c = 1; c < e.length; c++)
    if (o += Nf(n, t, e[c]), r) {
      var l = i;
      o += l[c];
    }
  YR.lastIndex = 0;
  for (var u = "", d; (d = YR.exec(o)) !== null; )
    u += "-" + d[1];
  var f = JC(o) + u;
  return {
    name: f,
    styles: o,
    next: qi
  };
}
var jee = jQ, Fee = function(t) {
  return t !== "theme";
}, GR = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? jee : Fee;
}, KR = function(t, n, r) {
  var o;
  if (n) {
    var i = n.shouldForwardProp;
    o = t.__emotion_forwardProp && i ? function(a) {
      return t.__emotion_forwardProp(a) && i(a);
    } : i;
  }
  return typeof o != "function" && r && (o = t.__emotion_forwardProp), o;
}, zee = !1, Bee = function(t) {
  var n = t.cache, r = t.serialized, o = t.isStringTag;
  return T7(n, r, o), _ee(function() {
    return E7(n, r, o);
  }), null;
}, qee = function e(t, n) {
  var r = t.__emotion_real === t, o = r && t.__emotion_base || t, i, a;
  n !== void 0 && (i = n.label, a = n.target);
  var c = KR(t, n, r), l = c || GR(o), u = !l("as");
  return function() {
    var d = arguments, f = r && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (i !== void 0 && f.push("label:" + i + ";"), d[0] == null || d[0].raw === void 0)
      f.push.apply(f, d);
    else {
      f.push(d[0][0]);
      for (var h = d.length, v = 1; v < h; v++)
        f.push(d[v], d[0][v]);
    }
    var y = A7(function(g, b, x) {
      var $ = u && g.as || o, S = "", O = [], C = g;
      if (g.theme == null) {
        C = {};
        for (var T in g)
          C[T] = g[T];
        C.theme = E.useContext(W0);
      }
      typeof g.className == "string" ? S = wee(b.registered, O, g.className) : g.className != null && (S = g.className + " ");
      var k = Lee(f.concat(O), b.registered, C);
      S += b.key + "-" + k.name, a !== void 0 && (S += " " + a);
      var I = u && c === void 0 ? GR($) : l, P = {};
      for (var _ in g)
        u && _ === "as" || I(_) && (P[_] = g[_]);
      return P.className = S, x && (P.ref = x), /* @__PURE__ */ E.createElement(E.Fragment, null, /* @__PURE__ */ E.createElement(Bee, {
        cache: b,
        serialized: k,
        isStringTag: typeof $ == "string"
      }), /* @__PURE__ */ E.createElement($, P));
    });
    return y.displayName = i !== void 0 ? i : "Styled(" + (typeof o == "string" ? o : o.displayName || o.name || "Component") + ")", y.defaultProps = t.defaultProps, y.__emotion_real = y, y.__emotion_base = o, y.__emotion_styles = f, y.__emotion_forwardProp = c, Object.defineProperty(y, "toString", {
      value: function() {
        return a === void 0 && zee ? "NO_COMPONENT_SELECTOR" : "." + a;
      }
    }), y.withComponent = function(g, b) {
      return e(g, Sg({}, n, b, {
        shouldForwardProp: KR(y, b, !0)
      })).apply(void 0, f);
    }, y;
  };
}, Uee = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], GO = qee.bind();
Uee.forEach(function(e) {
  GO[e] = GO(e);
});
var Wee = !1, Hee = /[A-Z]|^ms/g, Vee = /_EMO_([^_]+?)_([^]*?)_EMO_/g, M7 = function(t) {
  return t.charCodeAt(1) === 45;
}, XR = function(t) {
  return t != null && typeof t != "boolean";
}, Hb = /* @__PURE__ */ z0(function(e) {
  return M7(e) ? e : e.replace(Hee, "-$&").toLowerCase();
}), ZR = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(Vee, function(r, o, i) {
          return Os = {
            name: o,
            styles: i,
            next: Os
          }, o;
        });
  }
  return _7[t] !== 1 && !M7(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
}, Yee = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Tg(e, t, n) {
  if (n == null)
    return "";
  var r = n;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var o = n;
      if (o.anim === 1)
        return Os = {
          name: o.name,
          styles: o.styles,
          next: Os
        }, o.name;
      var i = n;
      if (i.styles !== void 0) {
        var a = i.next;
        if (a !== void 0)
          for (; a !== void 0; )
            Os = {
              name: a.name,
              styles: a.styles,
              next: Os
            }, a = a.next;
        var c = i.styles + ";";
        return c;
      }
      return Gee(e, t, n);
    }
  }
  var l = n;
  return l;
}
function Gee(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      r += Tg(e, t, n[o]) + ";";
  else
    for (var i in n) {
      var a = n[i];
      if (typeof a != "object") {
        var c = a;
        XR(c) && (r += Hb(i) + ":" + ZR(i, c) + ";");
      } else {
        if (i === "NO_COMPONENT_SELECTOR" && Wee)
          throw new Error(Yee);
        if (Array.isArray(a) && typeof a[0] == "string" && t == null)
          for (var l = 0; l < a.length; l++)
            XR(a[l]) && (r += Hb(i) + ":" + ZR(i, a[l]) + ";");
        else {
          var u = Tg(e, t, a);
          switch (i) {
            case "animation":
            case "animationName": {
              r += Hb(i) + ":" + u + ";";
              break;
            }
            default:
              r += i + "{" + u + "}";
          }
        }
      }
    }
  return r;
}
var JR = /label:\s*([^\s;{]+)\s*(;|$)/g, Os;
function Kee(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var r = !0, o = "";
  Os = void 0;
  var i = e[0];
  if (i == null || i.raw === void 0)
    r = !1, o += Tg(n, t, i);
  else {
    var a = i;
    o += a[0];
  }
  for (var c = 1; c < e.length; c++)
    if (o += Tg(n, t, e[c]), r) {
      var l = i;
      o += l[c];
    }
  JR.lastIndex = 0;
  for (var u = "", d; (d = JR.exec(o)) !== null; )
    u += "-" + d[1];
  var f = JC(o) + u;
  return {
    name: f,
    styles: o,
    next: Os
  };
}
var qh = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Vb, QR;
function Xee() {
  if (QR) return Vb;
  QR = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, c = 0; c < 10; c++)
        a["_" + String.fromCharCode(c)] = c;
      var l = Object.getOwnPropertyNames(a).map(function(d) {
        return a[d];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        u[d] = d;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Vb = o() ? Object.assign : function(i, a) {
    for (var c, l = r(i), u, d = 1; d < arguments.length; d++) {
      c = Object(arguments[d]);
      for (var f in c)
        t.call(c, f) && (l[f] = c[f]);
      if (e) {
        u = e(c);
        for (var h = 0; h < u.length; h++)
          n.call(c, u[h]) && (l[u[h]] = c[u[h]]);
      }
    }
    return l;
  }, Vb;
}
var Yb, eP;
function eT() {
  if (eP) return Yb;
  eP = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Yb = e, Yb;
}
var Gb, tP;
function N7() {
  return tP || (tP = 1, Gb = Function.call.bind(Object.prototype.hasOwnProperty)), Gb;
}
var Kb, nP;
function Zee() {
  if (nP) return Kb;
  nP = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ eT(), n = {}, r = /* @__PURE__ */ N7();
    e = function(i) {
      var a = "Warning: " + i;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function o(i, a, c, l, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in i)
        if (r(i, d)) {
          var f;
          try {
            if (typeof i[d] != "function") {
              var h = Error(
                (l || "React class") + ": " + c + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            f = i[d](a, d, l, c, null, t);
          } catch (y) {
            f = y;
          }
          if (f && !(f instanceof Error) && e(
            (l || "React class") + ": type specification of " + c + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var v = u ? u() : "";
            e(
              "Failed " + c + " type: " + f.message + (v ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Kb = o, Kb;
}
var Xb, rP;
function Jee() {
  if (rP) return Xb;
  rP = 1;
  var e = ZC(), t = Xee(), n = /* @__PURE__ */ eT(), r = /* @__PURE__ */ N7(), o = /* @__PURE__ */ Zee(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(c) {
    var l = "Warning: " + c;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return Xb = function(c, l) {
    var u = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function f(K) {
      var Y = K && (u && K[u] || K[d]);
      if (typeof Y == "function")
        return Y;
    }
    var h = "<<anonymous>>", v = {
      array: x("array"),
      bigint: x("bigint"),
      bool: x("boolean"),
      func: x("function"),
      number: x("number"),
      object: x("object"),
      string: x("string"),
      symbol: x("symbol"),
      any: $(),
      arrayOf: S,
      element: O(),
      elementType: C(),
      instanceOf: T,
      node: _(),
      objectOf: I,
      oneOf: k,
      oneOfType: P,
      shape: D,
      exact: M
    };
    function y(K, Y) {
      return K === Y ? K !== 0 || 1 / K === 1 / Y : K !== K && Y !== Y;
    }
    function g(K, Y) {
      this.message = K, this.data = Y && typeof Y == "object" ? Y : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function b(K) {
      if (process.env.NODE_ENV !== "production")
        var Y = {}, X = 0;
      function oe(Z, ce, fe, de, ne, le, ve) {
        if (de = de || h, le = le || fe, ve !== n) {
          if (l) {
            var G = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw G.name = "Invariant Violation", G;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Se = de + ":" + fe;
            !Y[Se] && // Avoid spamming the console because they are often not actionable except for lib authors
            X < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + le + "` prop on `" + de + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), Y[Se] = !0, X++);
          }
        }
        return ce[fe] == null ? Z ? ce[fe] === null ? new g("The " + ne + " `" + le + "` is marked as required " + ("in `" + de + "`, but its value is `null`.")) : new g("The " + ne + " `" + le + "` is marked as required in " + ("`" + de + "`, but its value is `undefined`.")) : null : K(ce, fe, de, ne, le);
      }
      var re = oe.bind(null, !1);
      return re.isRequired = oe.bind(null, !0), re;
    }
    function x(K) {
      function Y(X, oe, re, Z, ce, fe) {
        var de = X[oe], ne = z(de);
        if (ne !== K) {
          var le = q(de);
          return new g(
            "Invalid " + Z + " `" + ce + "` of type " + ("`" + le + "` supplied to `" + re + "`, expected ") + ("`" + K + "`."),
            { expectedType: K }
          );
        }
        return null;
      }
      return b(Y);
    }
    function $() {
      return b(a);
    }
    function S(K) {
      function Y(X, oe, re, Z, ce) {
        if (typeof K != "function")
          return new g("Property `" + ce + "` of component `" + re + "` has invalid PropType notation inside arrayOf.");
        var fe = X[oe];
        if (!Array.isArray(fe)) {
          var de = z(fe);
          return new g("Invalid " + Z + " `" + ce + "` of type " + ("`" + de + "` supplied to `" + re + "`, expected an array."));
        }
        for (var ne = 0; ne < fe.length; ne++) {
          var le = K(fe, ne, re, Z, ce + "[" + ne + "]", n);
          if (le instanceof Error)
            return le;
        }
        return null;
      }
      return b(Y);
    }
    function O() {
      function K(Y, X, oe, re, Z) {
        var ce = Y[X];
        if (!c(ce)) {
          var fe = z(ce);
          return new g("Invalid " + re + " `" + Z + "` of type " + ("`" + fe + "` supplied to `" + oe + "`, expected a single ReactElement."));
        }
        return null;
      }
      return b(K);
    }
    function C() {
      function K(Y, X, oe, re, Z) {
        var ce = Y[X];
        if (!e.isValidElementType(ce)) {
          var fe = z(ce);
          return new g("Invalid " + re + " `" + Z + "` of type " + ("`" + fe + "` supplied to `" + oe + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return b(K);
    }
    function T(K) {
      function Y(X, oe, re, Z, ce) {
        if (!(X[oe] instanceof K)) {
          var fe = K.name || h, de = U(X[oe]);
          return new g("Invalid " + Z + " `" + ce + "` of type " + ("`" + de + "` supplied to `" + re + "`, expected ") + ("instance of `" + fe + "`."));
        }
        return null;
      }
      return b(Y);
    }
    function k(K) {
      if (!Array.isArray(K))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function Y(X, oe, re, Z, ce) {
        for (var fe = X[oe], de = 0; de < K.length; de++)
          if (y(fe, K[de]))
            return null;
        var ne = JSON.stringify(K, function(ve, G) {
          var Se = q(G);
          return Se === "symbol" ? String(G) : G;
        });
        return new g("Invalid " + Z + " `" + ce + "` of value `" + String(fe) + "` " + ("supplied to `" + re + "`, expected one of " + ne + "."));
      }
      return b(Y);
    }
    function I(K) {
      function Y(X, oe, re, Z, ce) {
        if (typeof K != "function")
          return new g("Property `" + ce + "` of component `" + re + "` has invalid PropType notation inside objectOf.");
        var fe = X[oe], de = z(fe);
        if (de !== "object")
          return new g("Invalid " + Z + " `" + ce + "` of type " + ("`" + de + "` supplied to `" + re + "`, expected an object."));
        for (var ne in fe)
          if (r(fe, ne)) {
            var le = K(fe, ne, re, Z, ce + "." + ne, n);
            if (le instanceof Error)
              return le;
          }
        return null;
      }
      return b(Y);
    }
    function P(K) {
      if (!Array.isArray(K))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var Y = 0; Y < K.length; Y++) {
        var X = K[Y];
        if (typeof X != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + W(X) + " at index " + Y + "."
          ), a;
      }
      function oe(re, Z, ce, fe, de) {
        for (var ne = [], le = 0; le < K.length; le++) {
          var ve = K[le], G = ve(re, Z, ce, fe, de, n);
          if (G == null)
            return null;
          G.data && r(G.data, "expectedType") && ne.push(G.data.expectedType);
        }
        var Se = ne.length > 0 ? ", expected one of type [" + ne.join(", ") + "]" : "";
        return new g("Invalid " + fe + " `" + de + "` supplied to " + ("`" + ce + "`" + Se + "."));
      }
      return b(oe);
    }
    function _() {
      function K(Y, X, oe, re, Z) {
        return N(Y[X]) ? null : new g("Invalid " + re + " `" + Z + "` supplied to " + ("`" + oe + "`, expected a ReactNode."));
      }
      return b(K);
    }
    function A(K, Y, X, oe, re) {
      return new g(
        (K || "React class") + ": " + Y + " type `" + X + "." + oe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + re + "`."
      );
    }
    function D(K) {
      function Y(X, oe, re, Z, ce) {
        var fe = X[oe], de = z(fe);
        if (de !== "object")
          return new g("Invalid " + Z + " `" + ce + "` of type `" + de + "` " + ("supplied to `" + re + "`, expected `object`."));
        for (var ne in K) {
          var le = K[ne];
          if (typeof le != "function")
            return A(re, Z, ce, ne, q(le));
          var ve = le(fe, ne, re, Z, ce + "." + ne, n);
          if (ve)
            return ve;
        }
        return null;
      }
      return b(Y);
    }
    function M(K) {
      function Y(X, oe, re, Z, ce) {
        var fe = X[oe], de = z(fe);
        if (de !== "object")
          return new g("Invalid " + Z + " `" + ce + "` of type `" + de + "` " + ("supplied to `" + re + "`, expected `object`."));
        var ne = t({}, X[oe], K);
        for (var le in ne) {
          var ve = K[le];
          if (r(K, le) && typeof ve != "function")
            return A(re, Z, ce, le, q(ve));
          if (!ve)
            return new g(
              "Invalid " + Z + " `" + ce + "` key `" + le + "` supplied to `" + re + "`.\nBad object: " + JSON.stringify(X[oe], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(K), null, "  ")
            );
          var G = ve(fe, le, re, Z, ce + "." + le, n);
          if (G)
            return G;
        }
        return null;
      }
      return b(Y);
    }
    function N(K) {
      switch (typeof K) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !K;
        case "object":
          if (Array.isArray(K))
            return K.every(N);
          if (K === null || c(K))
            return !0;
          var Y = f(K);
          if (Y) {
            var X = Y.call(K), oe;
            if (Y !== K.entries) {
              for (; !(oe = X.next()).done; )
                if (!N(oe.value))
                  return !1;
            } else
              for (; !(oe = X.next()).done; ) {
                var re = oe.value;
                if (re && !N(re[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function L(K, Y) {
      return K === "symbol" ? !0 : Y ? Y["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && Y instanceof Symbol : !1;
    }
    function z(K) {
      var Y = typeof K;
      return Array.isArray(K) ? "array" : K instanceof RegExp ? "object" : L(Y, K) ? "symbol" : Y;
    }
    function q(K) {
      if (typeof K > "u" || K === null)
        return "" + K;
      var Y = z(K);
      if (Y === "object") {
        if (K instanceof Date)
          return "date";
        if (K instanceof RegExp)
          return "regexp";
      }
      return Y;
    }
    function W(K) {
      var Y = q(K);
      switch (Y) {
        case "array":
        case "object":
          return "an " + Y;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + Y;
        default:
          return Y;
      }
    }
    function U(K) {
      return !K.constructor || !K.constructor.name ? h : K.constructor.name;
    }
    return v.checkPropTypes = o, v.resetWarningCache = o.resetWarningCache, v.PropTypes = v, v;
  }, Xb;
}
var Zb, oP;
function Qee() {
  if (oP) return Zb;
  oP = 1;
  var e = /* @__PURE__ */ eT();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Zb = function() {
    function r(a, c, l, u, d, f) {
      if (f !== e) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, Zb;
}
var iP;
function ete() {
  if (iP) return qh.exports;
  if (iP = 1, process.env.NODE_ENV !== "production") {
    var e = ZC(), t = !0;
    qh.exports = /* @__PURE__ */ Jee()(e.isElement, t);
  } else
    qh.exports = /* @__PURE__ */ Qee()();
  return qh.exports;
}
var tte = /* @__PURE__ */ ete();
const s = /* @__PURE__ */ jn(tte);
var Uh = { exports: {} }, Pd = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aP;
function nte() {
  if (aP) return Pd;
  aP = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(r, o, i) {
    var a = null;
    if (i !== void 0 && (a = "" + i), o.key !== void 0 && (a = "" + o.key), "key" in o) {
      i = {};
      for (var c in o)
        c !== "key" && (i[c] = o[c]);
    } else i = o;
    return o = i.ref, {
      $$typeof: e,
      type: r,
      key: a,
      ref: o !== void 0 ? o : null,
      props: i
    };
  }
  return Pd.Fragment = t, Pd.jsx = n, Pd.jsxs = n, Pd;
}
var Ad = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sP;
function rte() {
  return sP || (sP = 1, process.env.NODE_ENV !== "production" && function() {
    function e(V) {
      if (V == null) return null;
      if (typeof V == "function")
        return V.$$typeof === W ? null : V.displayName || V.name || null;
      if (typeof V == "string") return V;
      switch (V) {
        case T:
          return "Fragment";
        case C:
          return "Portal";
        case I:
          return "Profiler";
        case k:
          return "StrictMode";
        case D:
          return "Suspense";
        case M:
          return "SuspenseList";
      }
      if (typeof V == "object")
        switch (typeof V.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), V.$$typeof) {
          case _:
            return (V.displayName || "Context") + ".Provider";
          case P:
            return (V._context.displayName || "Context") + ".Consumer";
          case A:
            var se = V.render;
            return V = V.displayName, V || (V = se.displayName || se.name || "", V = V !== "" ? "ForwardRef(" + V + ")" : "ForwardRef"), V;
          case N:
            return se = V.displayName || null, se !== null ? se : e(V.type) || "Memo";
          case L:
            se = V._payload, V = V._init;
            try {
              return e(V(se));
            } catch {
            }
        }
      return null;
    }
    function t(V) {
      return "" + V;
    }
    function n(V) {
      try {
        t(V);
        var se = !1;
      } catch {
        se = !0;
      }
      if (se) {
        se = console;
        var we = se.error, J = typeof Symbol == "function" && Symbol.toStringTag && V[Symbol.toStringTag] || V.constructor.name || "Object";
        return we.call(
          se,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          J
        ), t(V);
      }
    }
    function r() {
    }
    function o() {
      if (re === 0) {
        Z = console.log, ce = console.info, fe = console.warn, de = console.error, ne = console.group, le = console.groupCollapsed, ve = console.groupEnd;
        var V = {
          configurable: !0,
          enumerable: !0,
          value: r,
          writable: !0
        };
        Object.defineProperties(console, {
          info: V,
          log: V,
          warn: V,
          error: V,
          group: V,
          groupCollapsed: V,
          groupEnd: V
        });
      }
      re++;
    }
    function i() {
      if (re--, re === 0) {
        var V = { configurable: !0, enumerable: !0, writable: !0 };
        Object.defineProperties(console, {
          log: Y({}, V, { value: Z }),
          info: Y({}, V, { value: ce }),
          warn: Y({}, V, { value: fe }),
          error: Y({}, V, { value: de }),
          group: Y({}, V, { value: ne }),
          groupCollapsed: Y({}, V, { value: le }),
          groupEnd: Y({}, V, { value: ve })
        });
      }
      0 > re && console.error(
        "disabledDepth fell below zero. This is a bug in React. Please file an issue."
      );
    }
    function a(V) {
      if (G === void 0)
        try {
          throw Error();
        } catch (we) {
          var se = we.stack.trim().match(/\n( *(at )?)/);
          G = se && se[1] || "", Se = -1 < we.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < we.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
      return `
` + G + V + Se;
    }
    function c(V, se) {
      if (!V || ue) return "";
      var we = Q.get(V);
      if (we !== void 0) return we;
      ue = !0, we = Error.prepareStackTrace, Error.prepareStackTrace = void 0;
      var J = null;
      J = U.H, U.H = null, o();
      try {
        var he = {
          DetermineComponentFrameRoot: function() {
            try {
              if (se) {
                var Xe = function() {
                  throw Error();
                };
                if (Object.defineProperty(Xe.prototype, "props", {
                  set: function() {
                    throw Error();
                  }
                }), typeof Reflect == "object" && Reflect.construct) {
                  try {
                    Reflect.construct(Xe, []);
                  } catch (Ne) {
                    var Ze = Ne;
                  }
                  Reflect.construct(V, [], Xe);
                } else {
                  try {
                    Xe.call();
                  } catch (Ne) {
                    Ze = Ne;
                  }
                  V.call(Xe.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (Ne) {
                  Ze = Ne;
                }
                (Xe = V()) && typeof Xe.catch == "function" && Xe.catch(function() {
                });
              }
            } catch (Ne) {
              if (Ne && Ze && typeof Ne.stack == "string")
                return [Ne.stack, Ze.stack];
            }
            return [null, null];
          }
        };
        he.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var Te = Object.getOwnPropertyDescriptor(
          he.DetermineComponentFrameRoot,
          "name"
        );
        Te && Te.configurable && Object.defineProperty(
          he.DetermineComponentFrameRoot,
          "name",
          { value: "DetermineComponentFrameRoot" }
        );
        var xe = he.DetermineComponentFrameRoot(), Ae = xe[0], Ce = xe[1];
        if (Ae && Ce) {
          var Ye = Ae.split(`
`), He = Ce.split(`
`);
          for (xe = Te = 0; Te < Ye.length && !Ye[Te].includes(
            "DetermineComponentFrameRoot"
          ); )
            Te++;
          for (; xe < He.length && !He[xe].includes(
            "DetermineComponentFrameRoot"
          ); )
            xe++;
          if (Te === Ye.length || xe === He.length)
            for (Te = Ye.length - 1, xe = He.length - 1; 1 <= Te && 0 <= xe && Ye[Te] !== He[xe]; )
              xe--;
          for (; 1 <= Te && 0 <= xe; Te--, xe--)
            if (Ye[Te] !== He[xe]) {
              if (Te !== 1 || xe !== 1)
                do
                  if (Te--, xe--, 0 > xe || Ye[Te] !== He[xe]) {
                    var Be = `
` + Ye[Te].replace(
                      " at new ",
                      " at "
                    );
                    return V.displayName && Be.includes("<anonymous>") && (Be = Be.replace("<anonymous>", V.displayName)), typeof V == "function" && Q.set(V, Be), Be;
                  }
                while (1 <= Te && 0 <= xe);
              break;
            }
        }
      } finally {
        ue = !1, U.H = J, i(), Error.prepareStackTrace = we;
      }
      return Ye = (Ye = V ? V.displayName || V.name : "") ? a(Ye) : "", typeof V == "function" && Q.set(V, Ye), Ye;
    }
    function l(V) {
      if (V == null) return "";
      if (typeof V == "function") {
        var se = V.prototype;
        return c(
          V,
          !(!se || !se.isReactComponent)
        );
      }
      if (typeof V == "string") return a(V);
      switch (V) {
        case D:
          return a("Suspense");
        case M:
          return a("SuspenseList");
      }
      if (typeof V == "object")
        switch (V.$$typeof) {
          case A:
            return V = c(V.render, !1), V;
          case N:
            return l(V.type);
          case L:
            se = V._payload, V = V._init;
            try {
              return l(V(se));
            } catch {
            }
        }
      return "";
    }
    function u() {
      var V = U.A;
      return V === null ? null : V.getOwner();
    }
    function d(V) {
      if (K.call(V, "key")) {
        var se = Object.getOwnPropertyDescriptor(V, "key").get;
        if (se && se.isReactWarning) return !1;
      }
      return V.key !== void 0;
    }
    function f(V, se) {
      function we() {
        ee || (ee = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          se
        ));
      }
      we.isReactWarning = !0, Object.defineProperty(V, "key", {
        get: we,
        configurable: !0
      });
    }
    function h() {
      var V = e(this.type);
      return be[V] || (be[V] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), V = this.props.ref, V !== void 0 ? V : null;
    }
    function v(V, se, we, J, he, Te) {
      return we = Te.ref, V = {
        $$typeof: O,
        type: V,
        key: se,
        props: Te,
        _owner: he
      }, (we !== void 0 ? we : null) !== null ? Object.defineProperty(V, "ref", {
        enumerable: !1,
        get: h
      }) : Object.defineProperty(V, "ref", { enumerable: !1, value: null }), V._store = {}, Object.defineProperty(V._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(V, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.freeze && (Object.freeze(V.props), Object.freeze(V)), V;
    }
    function y(V, se, we, J, he, Te) {
      if (typeof V == "string" || typeof V == "function" || V === T || V === I || V === k || V === D || V === M || V === z || typeof V == "object" && V !== null && (V.$$typeof === L || V.$$typeof === N || V.$$typeof === _ || V.$$typeof === P || V.$$typeof === A || V.$$typeof === X || V.getModuleId !== void 0)) {
        var xe = se.children;
        if (xe !== void 0)
          if (J)
            if (oe(xe)) {
              for (J = 0; J < xe.length; J++)
                g(xe[J], V);
              Object.freeze && Object.freeze(xe);
            } else
              console.error(
                "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
              );
          else g(xe, V);
      } else
        xe = "", (V === void 0 || typeof V == "object" && V !== null && Object.keys(V).length === 0) && (xe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), V === null ? J = "null" : oe(V) ? J = "array" : V !== void 0 && V.$$typeof === O ? (J = "<" + (e(V.type) || "Unknown") + " />", xe = " Did you accidentally export a JSX literal instead of a component?") : J = typeof V, console.error(
          "React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s",
          J,
          xe
        );
      if (K.call(se, "key")) {
        xe = e(V);
        var Ae = Object.keys(se).filter(function(Ye) {
          return Ye !== "key";
        });
        J = 0 < Ae.length ? "{key: someKey, " + Ae.join(": ..., ") + ": ...}" : "{key: someKey}", Ie[xe + J] || (Ae = 0 < Ae.length ? "{" + Ae.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          J,
          xe,
          Ae,
          xe
        ), Ie[xe + J] = !0);
      }
      if (xe = null, we !== void 0 && (n(we), xe = "" + we), d(se) && (n(se.key), xe = "" + se.key), "key" in se) {
        we = {};
        for (var Ce in se)
          Ce !== "key" && (we[Ce] = se[Ce]);
      } else we = se;
      return xe && f(
        we,
        typeof V == "function" ? V.displayName || V.name || "Unknown" : V
      ), v(V, xe, Te, he, u(), we);
    }
    function g(V, se) {
      if (typeof V == "object" && V && V.$$typeof !== ie) {
        if (oe(V))
          for (var we = 0; we < V.length; we++) {
            var J = V[we];
            b(J) && x(J, se);
          }
        else if (b(V))
          V._store && (V._store.validated = 1);
        else if (V === null || typeof V != "object" ? we = null : (we = q && V[q] || V["@@iterator"], we = typeof we == "function" ? we : null), typeof we == "function" && we !== V.entries && (we = we.call(V), we !== V))
          for (; !(V = we.next()).done; )
            b(V.value) && x(V.value, se);
      }
    }
    function b(V) {
      return typeof V == "object" && V !== null && V.$$typeof === O;
    }
    function x(V, se) {
      if (V._store && !V._store.validated && V.key == null && (V._store.validated = 1, se = $(se), !je[se])) {
        je[se] = !0;
        var we = "";
        V && V._owner != null && V._owner !== u() && (we = null, typeof V._owner.tag == "number" ? we = e(V._owner.type) : typeof V._owner.name == "string" && (we = V._owner.name), we = " It was passed a child from " + we + ".");
        var J = U.getCurrentStack;
        U.getCurrentStack = function() {
          var he = l(V.type);
          return J && (he += J() || ""), he;
        }, console.error(
          'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
          se,
          we
        ), U.getCurrentStack = J;
      }
    }
    function $(V) {
      var se = "", we = u();
      return we && (we = e(we.type)) && (se = `

Check the render method of \`` + we + "`."), se || (V = e(V)) && (se = `

Check the top-level render call using <` + V + ">."), se;
    }
    var S = ye, O = Symbol.for("react.transitional.element"), C = Symbol.for("react.portal"), T = Symbol.for("react.fragment"), k = Symbol.for("react.strict_mode"), I = Symbol.for("react.profiler"), P = Symbol.for("react.consumer"), _ = Symbol.for("react.context"), A = Symbol.for("react.forward_ref"), D = Symbol.for("react.suspense"), M = Symbol.for("react.suspense_list"), N = Symbol.for("react.memo"), L = Symbol.for("react.lazy"), z = Symbol.for("react.offscreen"), q = Symbol.iterator, W = Symbol.for("react.client.reference"), U = S.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, K = Object.prototype.hasOwnProperty, Y = Object.assign, X = Symbol.for("react.client.reference"), oe = Array.isArray, re = 0, Z, ce, fe, de, ne, le, ve;
    r.__reactDisabledLog = !0;
    var G, Se, ue = !1, Q = new (typeof WeakMap == "function" ? WeakMap : Map)(), ie = Symbol.for("react.client.reference"), ee, be = {}, Ie = {}, je = {};
    Ad.Fragment = T, Ad.jsx = function(V, se, we, J, he) {
      return y(V, se, we, !1, J, he);
    }, Ad.jsxs = function(V, se, we, J, he) {
      return y(V, se, we, !0, J, he);
    };
  }()), Ad;
}
var cP;
function ote() {
  return cP || (cP = 1, process.env.NODE_ENV === "production" ? Uh.exports = nte() : Uh.exports = rte()), Uh.exports;
}
var F = ote();
function ite(e) {
  return e == null || Object.keys(e).length === 0;
}
function tT(e) {
  const {
    styles: t,
    defaultTheme: n = {}
  } = e, r = typeof t == "function" ? (o) => t(ite(o) ? n : o) : t;
  return /* @__PURE__ */ F.jsx(Ree, {
    styles: r
  });
}
process.env.NODE_ENV !== "production" && (tT.propTypes = {
  defaultTheme: s.object,
  styles: s.oneOfType([s.array, s.string, s.object, s.func])
});
/**
 * @mui/styled-engine v6.2.1
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function D7(e, t) {
  const n = GO(e, t);
  return process.env.NODE_ENV !== "production" ? (...r) => {
    const o = typeof e == "string" ? `"${e}"` : "component";
    return r.length === 0 ? console.error([`MUI: Seems like you called \`styled(${o})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : r.some((i) => i === void 0) && console.error(`MUI: the styled(${o})(...args) API requires all its args to be defined.`), n(...r);
  } : n;
}
function ate(e, t) {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}
const lP = [];
function uP(e) {
  return lP[0] = e, Kee(lP);
}
function Wi(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function L7(e) {
  if (/* @__PURE__ */ E.isValidElement(e) || !Wi(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = L7(e[n]);
  }), t;
}
function or(e, t, n = {
  clone: !0
}) {
  const r = n.clone ? {
    ...e
  } : e;
  return Wi(e) && Wi(t) && Object.keys(t).forEach((o) => {
    /* @__PURE__ */ E.isValidElement(t[o]) ? r[o] = t[o] : Wi(t[o]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, o) && Wi(e[o]) ? r[o] = or(e[o], t[o], n) : n.clone ? r[o] = Wi(t[o]) ? L7(t[o]) : t[o] : r[o] = t[o];
  }), r;
}
const ste = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, r) => n.val - r.val), t.reduce((n, r) => ({
    ...n,
    [r.key]: r.val
  }), {});
};
function cte(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: r = 5,
    ...o
  } = e, i = ste(t), a = Object.keys(i);
  function c(h) {
    return `@media (min-width:${typeof t[h] == "number" ? t[h] : h}${n})`;
  }
  function l(h) {
    return `@media (max-width:${(typeof t[h] == "number" ? t[h] : h) - r / 100}${n})`;
  }
  function u(h, v) {
    const y = a.indexOf(v);
    return `@media (min-width:${typeof t[h] == "number" ? t[h] : h}${n}) and (max-width:${(y !== -1 && typeof t[a[y]] == "number" ? t[a[y]] : v) - r / 100}${n})`;
  }
  function d(h) {
    return a.indexOf(h) + 1 < a.length ? u(h, a[a.indexOf(h) + 1]) : c(h);
  }
  function f(h) {
    const v = a.indexOf(h);
    return v === 0 ? c(a[1]) : v === a.length - 1 ? l(a[v]) : u(h, a[a.indexOf(h) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: a,
    values: i,
    up: c,
    down: l,
    between: u,
    only: d,
    not: f,
    unit: n,
    ...o
  };
}
function lte(e, t) {
  if (!e.containerQueries)
    return t;
  const n = Object.keys(t).filter((r) => r.startsWith("@container")).sort((r, o) => {
    var a, c;
    const i = /min-width:\s*([0-9.]+)/;
    return +(((a = r.match(i)) == null ? void 0 : a[1]) || 0) - +(((c = o.match(i)) == null ? void 0 : c[1]) || 0);
  });
  return n.length ? n.reduce((r, o) => {
    const i = t[o];
    return delete r[o], r[o] = i, r;
  }, {
    ...t
  }) : t;
}
function ute(e, t) {
  return t === "@" || t.startsWith("@") && (e.some((n) => t.startsWith(`@${n}`)) || !!t.match(/^@\d/));
}
function dte(e, t) {
  const n = t.match(/^@([^/]+)?\/?(.+)?$/);
  if (!n) {
    if (process.env.NODE_ENV !== "production")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The provided shorthand ${`(${t})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.
For example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.` : na(18, `(${t})`));
    return null;
  }
  const [, r, o] = n, i = Number.isNaN(+r) ? r || 0 : +r;
  return e.containerQueries(o).up(i);
}
function fte(e) {
  const t = (i, a) => i.replace("@media", a ? `@container ${a}` : "@container");
  function n(i, a) {
    i.up = (...c) => t(e.breakpoints.up(...c), a), i.down = (...c) => t(e.breakpoints.down(...c), a), i.between = (...c) => t(e.breakpoints.between(...c), a), i.only = (...c) => t(e.breakpoints.only(...c), a), i.not = (...c) => {
      const l = t(e.breakpoints.not(...c), a);
      return l.includes("not all and") ? l.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : l;
    };
  }
  const r = {}, o = (i) => (n(r, i), r);
  return n(o), {
    ...e,
    containerQueries: o
  };
}
const pte = {
  borderRadius: 4
}, Vs = process.env.NODE_ENV !== "production" ? s.oneOfType([s.number, s.string, s.object, s.array]) : {};
function gf(e, t) {
  return t ? or(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const H0 = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, dP = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${H0[e]}px)`
}, hte = {
  containerQueries: (e) => ({
    up: (t) => {
      let n = typeof t == "number" ? t : H0[t] || t;
      return typeof n == "number" && (n = `${n}px`), e ? `@container ${e} (min-width:${n})` : `@container (min-width:${n})`;
    }
  })
};
function xi(e, t, n) {
  const r = e.theme || {};
  if (Array.isArray(t)) {
    const i = r.breakpoints || dP;
    return t.reduce((a, c, l) => (a[i.up(i.keys[l])] = n(t[l]), a), {});
  }
  if (typeof t == "object") {
    const i = r.breakpoints || dP;
    return Object.keys(t).reduce((a, c) => {
      if (ute(i.keys, c)) {
        const l = dte(r.containerQueries ? r : hte, c);
        l && (a[l] = n(t[c], c));
      } else if (Object.keys(i.values || H0).includes(c)) {
        const l = i.up(c);
        a[l] = n(t[c], c);
      } else {
        const l = c;
        a[l] = t[l];
      }
      return a;
    }, {});
  }
  return n(t);
}
function j7(e = {}) {
  var n;
  return ((n = e.keys) == null ? void 0 : n.reduce((r, o) => {
    const i = e.up(o);
    return r[i] = {}, r;
  }, {})) || {};
}
function F7(e, t) {
  return e.reduce((n, r) => {
    const o = n[r];
    return (!o || Object.keys(o).length === 0) && delete n[r], n;
  }, t);
}
function mte(e, ...t) {
  const n = j7(e), r = [n, ...t].reduce((o, i) => or(o, i), {});
  return F7(Object.keys(n), r);
}
function gte(e, t) {
  if (typeof e != "object")
    return {};
  const n = {}, r = Object.keys(t);
  return Array.isArray(e) ? r.forEach((o, i) => {
    i < e.length && (n[o] = !0);
  }) : r.forEach((o) => {
    e[o] != null && (n[o] = !0);
  }), n;
}
function Jb({
  values: e,
  breakpoints: t,
  base: n
}) {
  const r = n || gte(e, t), o = Object.keys(r);
  if (o.length === 0)
    return e;
  let i;
  return o.reduce((a, c, l) => (Array.isArray(e) ? (a[c] = e[l] != null ? e[l] : e[i], i = l) : typeof e == "object" ? (a[c] = e[c] != null ? e[c] : e[i], i = c) : a[c] = e, a), {});
}
function Le(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : na(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function V0(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const r = `vars.${t}`.split(".").reduce((o, i) => o && o[i] ? o[i] : null, e);
    if (r != null)
      return r;
  }
  return t.split(".").reduce((r, o) => r && r[o] != null ? r[o] : null, e);
}
function Eg(e, t, n, r = n) {
  let o;
  return typeof e == "function" ? o = e(n) : Array.isArray(e) ? o = e[n] || r : o = V0(e, n) || r, t && (o = t(o, r, e)), o;
}
function Wn(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: r,
    transform: o
  } = e, i = (a) => {
    if (a[t] == null)
      return null;
    const c = a[t], l = a.theme, u = V0(l, r) || {};
    return xi(a, c, (f) => {
      let h = Eg(u, o, f);
      return f === h && typeof f == "string" && (h = Eg(u, o, `${t}${f === "default" ? "" : Le(f)}`, f)), n === !1 ? h : {
        [n]: h
      };
    });
  };
  return i.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: Vs
  } : {}, i.filterProps = [t], i;
}
function vte(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const yte = {
  m: "margin",
  p: "padding"
}, bte = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, fP = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, xte = vte((e) => {
  if (e.length > 2)
    if (fP[e])
      e = fP[e];
    else
      return [e];
  const [t, n] = e.split(""), r = yte[t], o = bte[n] || "";
  return Array.isArray(o) ? o.map((i) => r + i) : [r + o];
}), Y0 = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], G0 = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], wte = [...Y0, ...G0];
function Op(e, t, n, r) {
  const o = V0(e, t, !0) ?? n;
  return typeof o == "number" || typeof o == "string" ? (i) => typeof i == "string" ? i : (process.env.NODE_ENV !== "production" && typeof i != "number" && console.error(`MUI: Expected ${r} argument to be a number or a string, got ${i}.`), typeof o == "string" ? `calc(${i} * ${o})` : o * i) : Array.isArray(o) ? (i) => {
    if (typeof i == "string")
      return i;
    const a = Math.abs(i);
    process.env.NODE_ENV !== "production" && (Number.isInteger(a) ? a > o.length - 1 && console.error([`MUI: The value provided (${a}) overflows.`, `The supported values are: ${JSON.stringify(o)}.`, `${a} > ${o.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`)));
    const c = o[a];
    return i >= 0 ? c : typeof c == "number" ? -c : `-${c}`;
  } : typeof o == "function" ? o : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${o}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function K0(e) {
  return Op(e, "spacing", 8, "spacing");
}
function Wc(e, t) {
  return typeof t == "string" || t == null ? t : e(t);
}
function $te(e, t) {
  return (n) => e.reduce((r, o) => (r[o] = Wc(t, n), r), {});
}
function Ote(e, t, n, r) {
  if (!t.includes(n))
    return null;
  const o = xte(n), i = $te(o, r), a = e[n];
  return xi(e, a, i);
}
function z7(e, t) {
  const n = K0(e.theme);
  return Object.keys(e).map((r) => Ote(e, t, r, n)).reduce(gf, {});
}
function An(e) {
  return z7(e, Y0);
}
An.propTypes = process.env.NODE_ENV !== "production" ? Y0.reduce((e, t) => (e[t] = Vs, e), {}) : {};
An.filterProps = Y0;
function In(e) {
  return z7(e, G0);
}
In.propTypes = process.env.NODE_ENV !== "production" ? G0.reduce((e, t) => (e[t] = Vs, e), {}) : {};
In.filterProps = G0;
process.env.NODE_ENV !== "production" && wte.reduce((e, t) => (e[t] = Vs, e), {});
function B7(e = 8, t = K0({
  spacing: e
})) {
  if (e.mui)
    return e;
  const n = (...r) => (process.env.NODE_ENV !== "production" && (r.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${r.length}`)), (r.length === 0 ? [1] : r).map((i) => {
    const a = t(i);
    return typeof a == "number" ? `${a}px` : a;
  }).join(" "));
  return n.mui = !0, n;
}
function X0(...e) {
  const t = e.reduce((r, o) => (o.filterProps.forEach((i) => {
    r[i] = o;
  }), r), {}), n = (r) => Object.keys(r).reduce((o, i) => t[i] ? gf(o, t[i](r)) : o, {});
  return n.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((r, o) => Object.assign(r, o.propTypes), {}) : {}, n.filterProps = e.reduce((r, o) => r.concat(o.filterProps), []), n;
}
function Uo(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function ni(e, t) {
  return Wn({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const Ste = ni("border", Uo), Cte = ni("borderTop", Uo), Tte = ni("borderRight", Uo), Ete = ni("borderBottom", Uo), _te = ni("borderLeft", Uo), kte = ni("borderColor"), Rte = ni("borderTopColor"), Pte = ni("borderRightColor"), Ate = ni("borderBottomColor"), Ite = ni("borderLeftColor"), Mte = ni("outline", Uo), Nte = ni("outlineColor"), Z0 = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = Op(e.theme, "shape.borderRadius", 4, "borderRadius"), n = (r) => ({
      borderRadius: Wc(t, r)
    });
    return xi(e, e.borderRadius, n);
  }
  return null;
};
Z0.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: Vs
} : {};
Z0.filterProps = ["borderRadius"];
X0(Ste, Cte, Tte, Ete, _te, kte, Rte, Pte, Ate, Ite, Z0, Mte, Nte);
const J0 = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = Op(e.theme, "spacing", 8, "gap"), n = (r) => ({
      gap: Wc(t, r)
    });
    return xi(e, e.gap, n);
  }
  return null;
};
J0.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: Vs
} : {};
J0.filterProps = ["gap"];
const Q0 = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = Op(e.theme, "spacing", 8, "columnGap"), n = (r) => ({
      columnGap: Wc(t, r)
    });
    return xi(e, e.columnGap, n);
  }
  return null;
};
Q0.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: Vs
} : {};
Q0.filterProps = ["columnGap"];
const ev = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = Op(e.theme, "spacing", 8, "rowGap"), n = (r) => ({
      rowGap: Wc(t, r)
    });
    return xi(e, e.rowGap, n);
  }
  return null;
};
ev.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: Vs
} : {};
ev.filterProps = ["rowGap"];
const Dte = Wn({
  prop: "gridColumn"
}), Lte = Wn({
  prop: "gridRow"
}), jte = Wn({
  prop: "gridAutoFlow"
}), Fte = Wn({
  prop: "gridAutoColumns"
}), zte = Wn({
  prop: "gridAutoRows"
}), Bte = Wn({
  prop: "gridTemplateColumns"
}), qte = Wn({
  prop: "gridTemplateRows"
}), Ute = Wn({
  prop: "gridTemplateAreas"
}), Wte = Wn({
  prop: "gridArea"
});
X0(J0, Q0, ev, Dte, Lte, jte, Fte, zte, Bte, qte, Ute, Wte);
function uu(e, t) {
  return t === "grey" ? t : e;
}
const Hte = Wn({
  prop: "color",
  themeKey: "palette",
  transform: uu
}), Vte = Wn({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: uu
}), Yte = Wn({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: uu
});
X0(Hte, Vte, Yte);
function go(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const Gte = Wn({
  prop: "width",
  transform: go
}), nT = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      var o, i, a, c, l;
      const r = ((a = (i = (o = e.theme) == null ? void 0 : o.breakpoints) == null ? void 0 : i.values) == null ? void 0 : a[n]) || H0[n];
      return r ? ((l = (c = e.theme) == null ? void 0 : c.breakpoints) == null ? void 0 : l.unit) !== "px" ? {
        maxWidth: `${r}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: r
      } : {
        maxWidth: go(n)
      };
    };
    return xi(e, e.maxWidth, t);
  }
  return null;
};
nT.filterProps = ["maxWidth"];
const Kte = Wn({
  prop: "minWidth",
  transform: go
}), Xte = Wn({
  prop: "height",
  transform: go
}), Zte = Wn({
  prop: "maxHeight",
  transform: go
}), Jte = Wn({
  prop: "minHeight",
  transform: go
});
Wn({
  prop: "size",
  cssProperty: "width",
  transform: go
});
Wn({
  prop: "size",
  cssProperty: "height",
  transform: go
});
const Qte = Wn({
  prop: "boxSizing"
});
X0(Gte, nT, Kte, Xte, Zte, Jte, Qte);
const Sp = {
  // borders
  border: {
    themeKey: "borders",
    transform: Uo
  },
  borderTop: {
    themeKey: "borders",
    transform: Uo
  },
  borderRight: {
    themeKey: "borders",
    transform: Uo
  },
  borderBottom: {
    themeKey: "borders",
    transform: Uo
  },
  borderLeft: {
    themeKey: "borders",
    transform: Uo
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: Uo
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Z0
  },
  // palette
  color: {
    themeKey: "palette",
    transform: uu
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: uu
  },
  backgroundColor: {
    themeKey: "palette",
    transform: uu
  },
  // spacing
  p: {
    style: In
  },
  pt: {
    style: In
  },
  pr: {
    style: In
  },
  pb: {
    style: In
  },
  pl: {
    style: In
  },
  px: {
    style: In
  },
  py: {
    style: In
  },
  padding: {
    style: In
  },
  paddingTop: {
    style: In
  },
  paddingRight: {
    style: In
  },
  paddingBottom: {
    style: In
  },
  paddingLeft: {
    style: In
  },
  paddingX: {
    style: In
  },
  paddingY: {
    style: In
  },
  paddingInline: {
    style: In
  },
  paddingInlineStart: {
    style: In
  },
  paddingInlineEnd: {
    style: In
  },
  paddingBlock: {
    style: In
  },
  paddingBlockStart: {
    style: In
  },
  paddingBlockEnd: {
    style: In
  },
  m: {
    style: An
  },
  mt: {
    style: An
  },
  mr: {
    style: An
  },
  mb: {
    style: An
  },
  ml: {
    style: An
  },
  mx: {
    style: An
  },
  my: {
    style: An
  },
  margin: {
    style: An
  },
  marginTop: {
    style: An
  },
  marginRight: {
    style: An
  },
  marginBottom: {
    style: An
  },
  marginLeft: {
    style: An
  },
  marginX: {
    style: An
  },
  marginY: {
    style: An
  },
  marginInline: {
    style: An
  },
  marginInlineStart: {
    style: An
  },
  marginInlineEnd: {
    style: An
  },
  marginBlock: {
    style: An
  },
  marginBlockStart: {
    style: An
  },
  marginBlockEnd: {
    style: An
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: J0
  },
  rowGap: {
    style: ev
  },
  columnGap: {
    style: Q0
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: go
  },
  maxWidth: {
    style: nT
  },
  minWidth: {
    transform: go
  },
  height: {
    transform: go
  },
  maxHeight: {
    transform: go
  },
  minHeight: {
    transform: go
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function ene(...e) {
  const t = e.reduce((r, o) => r.concat(Object.keys(o)), []), n = new Set(t);
  return e.every((r) => n.size === Object.keys(r).length);
}
function tne(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function nne() {
  function e(n, r, o, i) {
    const a = {
      [n]: r,
      theme: o
    }, c = i[n];
    if (!c)
      return {
        [n]: r
      };
    const {
      cssProperty: l = n,
      themeKey: u,
      transform: d,
      style: f
    } = c;
    if (r == null)
      return null;
    if (u === "typography" && r === "inherit")
      return {
        [n]: r
      };
    const h = V0(o, u) || {};
    return f ? f(a) : xi(a, r, (y) => {
      let g = Eg(h, d, y);
      return y === g && typeof y == "string" && (g = Eg(h, d, `${n}${y === "default" ? "" : Le(y)}`, y)), l === !1 ? g : {
        [l]: g
      };
    });
  }
  function t(n) {
    const {
      sx: r,
      theme: o = {}
    } = n || {};
    if (!r)
      return null;
    const i = o.unstable_sxConfig ?? Sp;
    function a(c) {
      let l = c;
      if (typeof c == "function")
        l = c(o);
      else if (typeof c != "object")
        return c;
      if (!l)
        return null;
      const u = j7(o.breakpoints), d = Object.keys(u);
      let f = u;
      return Object.keys(l).forEach((h) => {
        const v = tne(l[h], o);
        if (v != null)
          if (typeof v == "object")
            if (i[h])
              f = gf(f, e(h, v, o, i));
            else {
              const y = xi({
                theme: o
              }, v, (g) => ({
                [h]: g
              }));
              ene(y, v) ? f[h] = t({
                sx: v,
                theme: o
              }) : f = gf(f, y);
            }
          else
            f = gf(f, e(h, v, o, i));
      }), lte(o, F7(d, f));
    }
    return Array.isArray(r) ? r.map(a) : a(r);
  }
  return t;
}
const Ls = nne();
Ls.filterProps = ["sx"];
function rne(e, t) {
  var r;
  const n = this;
  if (n.vars) {
    if (!((r = n.colorSchemes) != null && r[e]) || typeof n.getColorSchemeSelector != "function")
      return {};
    let o = n.getColorSchemeSelector(e);
    return o === "&" ? t : ((o.includes("data-") || o.includes(".")) && (o = `*:where(${o.replace(/\s*&$/, "")}) &`), {
      [o]: t
    });
  }
  return n.palette.mode === e ? t : {};
}
function Cp(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: r = {},
    spacing: o,
    shape: i = {},
    ...a
  } = e, c = cte(n), l = B7(o);
  let u = or({
    breakpoints: c,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...r
    },
    spacing: l,
    shape: {
      ...pte,
      ...i
    }
  }, a);
  return u = fte(u), u.applyStyles = rne, u = t.reduce((d, f) => or(d, f), u), u.unstable_sxConfig = {
    ...Sp,
    ...a == null ? void 0 : a.unstable_sxConfig
  }, u.unstable_sx = function(f) {
    return Ls({
      sx: f,
      theme: this
    });
  }, u;
}
function one(e) {
  return Object.keys(e).length === 0;
}
function rT(e = null) {
  const t = E.useContext(W0);
  return !t || one(t) ? e : t;
}
const ine = Cp();
function Tp(e = ine) {
  return rT(e);
}
function q7({
  styles: e,
  themeId: t,
  defaultTheme: n = {}
}) {
  const r = Tp(n), o = typeof e == "function" ? e(t && r[t] || r) : e;
  return /* @__PURE__ */ F.jsx(tT, {
    styles: o
  });
}
process.env.NODE_ENV !== "production" && (q7.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: s.object,
  /**
   * @ignore
   */
  styles: s.oneOfType([s.array, s.func, s.number, s.object, s.string, s.bool]),
  /**
   * @ignore
   */
  themeId: s.string
});
const ane = (e) => {
  var r;
  const t = {
    systemProps: {},
    otherProps: {}
  }, n = ((r = e == null ? void 0 : e.theme) == null ? void 0 : r.unstable_sxConfig) ?? Sp;
  return Object.keys(e).forEach((o) => {
    n[o] ? t.systemProps[o] = e[o] : t.otherProps[o] = e[o];
  }), t;
};
function tv(e) {
  const {
    sx: t,
    ...n
  } = e, {
    systemProps: r,
    otherProps: o
  } = ane(n);
  let i;
  return Array.isArray(t) ? i = [r, ...t] : typeof t == "function" ? i = (...a) => {
    const c = t(...a);
    return Wi(c) ? {
      ...r,
      ...c
    } : r;
  } : i = {
    ...r,
    ...t
  }, {
    ...o,
    sx: i
  };
}
const pP = (e) => e, sne = () => {
  let e = pP;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = pP;
    }
  };
}, U7 = sne();
function W7(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = W7(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function Ge() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = W7(e)) && (r && (r += " "), r += t);
  return r;
}
function cne(e = {}) {
  const {
    themeId: t,
    defaultTheme: n,
    defaultClassName: r = "MuiBox-root",
    generateClassName: o
  } = e, i = D7("div", {
    shouldForwardProp: (c) => c !== "theme" && c !== "sx" && c !== "as"
  })(Ls);
  return /* @__PURE__ */ E.forwardRef(function(l, u) {
    const d = Tp(n), {
      className: f,
      component: h = "div",
      ...v
    } = tv(l);
    return /* @__PURE__ */ F.jsx(i, {
      as: h,
      ref: u,
      className: Ge(f, o ? o(r) : r),
      theme: t && d[t] || d,
      ...v
    });
  });
}
const lne = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function mt(e, t, n = "Mui") {
  const r = lne[t];
  return r ? `${n}-${r}` : `${U7.generate(e)}-${t}`;
}
function gt(e, t, n = "Mui") {
  const r = {};
  return t.forEach((o) => {
    r[o] = mt(e, o, n);
  }), r;
}
var Wh = { exports: {} }, nn = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hP;
function une() {
  if (hP) return nn;
  hP = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.consumer"), a = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), v = Symbol.for("react.client.reference");
  function y(g) {
    if (typeof g == "object" && g !== null) {
      var b = g.$$typeof;
      switch (b) {
        case e:
          switch (g = g.type, g) {
            case n:
            case o:
            case r:
            case l:
            case u:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case a:
                case c:
                case f:
                case d:
                  return g;
                case i:
                  return g;
                default:
                  return b;
              }
          }
        case t:
          return b;
      }
    }
  }
  return nn.ContextConsumer = i, nn.ContextProvider = a, nn.Element = e, nn.ForwardRef = c, nn.Fragment = n, nn.Lazy = f, nn.Memo = d, nn.Portal = t, nn.Profiler = o, nn.StrictMode = r, nn.Suspense = l, nn.SuspenseList = u, nn.isContextConsumer = function(g) {
    return y(g) === i;
  }, nn.isContextProvider = function(g) {
    return y(g) === a;
  }, nn.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === e;
  }, nn.isForwardRef = function(g) {
    return y(g) === c;
  }, nn.isFragment = function(g) {
    return y(g) === n;
  }, nn.isLazy = function(g) {
    return y(g) === f;
  }, nn.isMemo = function(g) {
    return y(g) === d;
  }, nn.isPortal = function(g) {
    return y(g) === t;
  }, nn.isProfiler = function(g) {
    return y(g) === o;
  }, nn.isStrictMode = function(g) {
    return y(g) === r;
  }, nn.isSuspense = function(g) {
    return y(g) === l;
  }, nn.isSuspenseList = function(g) {
    return y(g) === u;
  }, nn.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === n || g === o || g === r || g === l || g === u || g === h || typeof g == "object" && g !== null && (g.$$typeof === f || g.$$typeof === d || g.$$typeof === a || g.$$typeof === i || g.$$typeof === c || g.$$typeof === v || g.getModuleId !== void 0);
  }, nn.typeOf = y, nn;
}
var rn = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var mP;
function dne() {
  return mP || (mP = 1, process.env.NODE_ENV !== "production" && function() {
    function e(g) {
      if (typeof g == "object" && g !== null) {
        var b = g.$$typeof;
        switch (b) {
          case t:
            switch (g = g.type, g) {
              case r:
              case i:
              case o:
              case u:
              case d:
                return g;
              default:
                switch (g = g && g.$$typeof, g) {
                  case c:
                  case l:
                  case h:
                  case f:
                    return g;
                  case a:
                    return g;
                  default:
                    return b;
                }
            }
          case n:
            return b;
        }
      }
    }
    var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.consumer"), c = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), y = Symbol.for("react.client.reference");
    rn.ContextConsumer = a, rn.ContextProvider = c, rn.Element = t, rn.ForwardRef = l, rn.Fragment = r, rn.Lazy = h, rn.Memo = f, rn.Portal = n, rn.Profiler = i, rn.StrictMode = o, rn.Suspense = u, rn.SuspenseList = d, rn.isContextConsumer = function(g) {
      return e(g) === a;
    }, rn.isContextProvider = function(g) {
      return e(g) === c;
    }, rn.isElement = function(g) {
      return typeof g == "object" && g !== null && g.$$typeof === t;
    }, rn.isForwardRef = function(g) {
      return e(g) === l;
    }, rn.isFragment = function(g) {
      return e(g) === r;
    }, rn.isLazy = function(g) {
      return e(g) === h;
    }, rn.isMemo = function(g) {
      return e(g) === f;
    }, rn.isPortal = function(g) {
      return e(g) === n;
    }, rn.isProfiler = function(g) {
      return e(g) === i;
    }, rn.isStrictMode = function(g) {
      return e(g) === o;
    }, rn.isSuspense = function(g) {
      return e(g) === u;
    }, rn.isSuspenseList = function(g) {
      return e(g) === d;
    }, rn.isValidElementType = function(g) {
      return typeof g == "string" || typeof g == "function" || g === r || g === i || g === o || g === u || g === d || g === v || typeof g == "object" && g !== null && (g.$$typeof === h || g.$$typeof === f || g.$$typeof === c || g.$$typeof === a || g.$$typeof === l || g.$$typeof === y || g.getModuleId !== void 0);
    }, rn.typeOf = e;
  }()), rn;
}
var gP;
function fne() {
  return gP || (gP = 1, process.env.NODE_ENV === "production" ? Wh.exports = /* @__PURE__ */ une() : Wh.exports = /* @__PURE__ */ dne()), Wh.exports;
}
var vP = /* @__PURE__ */ fne();
function H7(e, t = "") {
  return e.displayName || e.name || t;
}
function yP(e, t, n) {
  const r = H7(t);
  return e.displayName || (r !== "" ? `${n}(${r})` : n);
}
function pne(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return H7(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case vP.ForwardRef:
          return yP(e, e.render, "ForwardRef");
        case vP.Memo:
          return yP(e, e.type, "memo");
        default:
          return;
      }
  }
}
function V7(e) {
  const {
    variants: t,
    ...n
  } = e, r = {
    variants: t,
    style: uP(n),
    isProcessed: !0
  };
  return r.style === n || t && t.forEach((o) => {
    typeof o.style != "function" && (o.style = uP(o.style));
  }), r;
}
const hne = Cp();
function Km(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
function mne(e) {
  return e ? (t, n) => n[e] : null;
}
function gne(e, t, n) {
  e.theme = bne(e.theme) ? n : e.theme[t] || e.theme;
}
function Xm(e, t) {
  const n = typeof t == "function" ? t(e) : t;
  if (Array.isArray(n))
    return n.flatMap((r) => Xm(e, r));
  if (Array.isArray(n == null ? void 0 : n.variants)) {
    let r;
    if (n.isProcessed)
      r = n.style;
    else {
      const {
        variants: o,
        ...i
      } = n;
      r = i;
    }
    return Y7(e, n.variants, [r]);
  }
  return n != null && n.isProcessed ? n.style : n;
}
function Y7(e, t, n = []) {
  var o;
  let r;
  e: for (let i = 0; i < t.length; i += 1) {
    const a = t[i];
    if (typeof a.props == "function") {
      if (r ?? (r = {
        ...e,
        ...e.ownerState,
        ownerState: e.ownerState
      }), !a.props(r))
        continue;
    } else
      for (const c in a.props)
        if (e[c] !== a.props[c] && ((o = e.ownerState) == null ? void 0 : o[c]) !== a.props[c])
          continue e;
    typeof a.style == "function" ? (r ?? (r = {
      ...e,
      ...e.ownerState,
      ownerState: e.ownerState
    }), n.push(a.style(r))) : n.push(a.style);
  }
  return n;
}
function G7(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = hne,
    rootShouldForwardProp: r = Km,
    slotShouldForwardProp: o = Km
  } = e;
  function i(c) {
    gne(c, t, n);
  }
  return (c, l = {}) => {
    ate(c, (C) => C.filter((T) => T !== Ls));
    const {
      name: u,
      slot: d,
      skipVariantsResolver: f,
      skipSx: h,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: v = mne(K7(d)),
      ...y
    } = l, g = f !== void 0 ? f : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      d && d !== "Root" && d !== "root" || !1
    ), b = h || !1;
    let x = Km;
    d === "Root" || d === "root" ? x = r : d ? x = o : xne(c) && (x = void 0);
    const $ = D7(c, {
      shouldForwardProp: x,
      label: yne(u, d),
      ...y
    }), S = (C) => {
      if (typeof C == "function" && C.__emotion_real !== C)
        return function(k) {
          return Xm(k, C);
        };
      if (Wi(C)) {
        const T = V7(C);
        return T.variants ? function(I) {
          return Xm(I, T);
        } : T.style;
      }
      return C;
    }, O = (...C) => {
      const T = [], k = C.map(S), I = [];
      if (T.push(i), u && v && I.push(function(D) {
        var z, q;
        const N = (q = (z = D.theme.components) == null ? void 0 : z[u]) == null ? void 0 : q.styleOverrides;
        if (!N)
          return null;
        const L = {};
        for (const W in N)
          L[W] = Xm(D, N[W]);
        return v(D, L);
      }), u && !g && I.push(function(D) {
        var L, z;
        const M = D.theme, N = (z = (L = M == null ? void 0 : M.components) == null ? void 0 : L[u]) == null ? void 0 : z.variants;
        return N ? Y7(D, N) : null;
      }), b || I.push(Ls), Array.isArray(k[0])) {
        const A = k.shift(), D = new Array(T.length).fill(""), M = new Array(I.length).fill("");
        let N;
        N = [...D, ...A, ...M], N.raw = [...D, ...A.raw, ...M], T.unshift(N);
      }
      const P = [...T, ...k, ...I], _ = $(...P);
      return c.muiName && (_.muiName = c.muiName), process.env.NODE_ENV !== "production" && (_.displayName = vne(u, d, c)), _;
    };
    return $.withConfig && (O.withConfig = $.withConfig), O;
  };
}
function vne(e, t, n) {
  return e ? `${e}${Le(t || "")}` : `Styled(${pne(n)})`;
}
function yne(e, t) {
  let n;
  return process.env.NODE_ENV !== "production" && e && (n = `${e}-${K7(t || "Root")}`), n;
}
function bne(e) {
  for (const t in e)
    return !1;
  return !0;
}
function xne(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function K7(e) {
  return e && e.charAt(0).toLowerCase() + e.slice(1);
}
const X7 = G7();
function Df(e, t) {
  const n = {
    ...t
  };
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      const o = r;
      if (o === "components" || o === "slots")
        n[o] = {
          ...e[o],
          ...n[o]
        };
      else if (o === "componentsProps" || o === "slotProps") {
        const i = e[o], a = t[o];
        if (!a)
          n[o] = i || {};
        else if (!i)
          n[o] = a;
        else {
          n[o] = {
            ...a
          };
          for (const c in i)
            if (Object.prototype.hasOwnProperty.call(i, c)) {
              const l = c;
              n[o][l] = Df(i[l], a[l]);
            }
        }
      } else n[o] === void 0 && (n[o] = e[o]);
    }
  return n;
}
function Z7(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  return !t || !t.components || !t.components[n] || !t.components[n].defaultProps ? r : Df(t.components[n].defaultProps, r);
}
function oT({
  props: e,
  name: t,
  defaultTheme: n,
  themeId: r
}) {
  let o = Tp(n);
  return r && (o = o[r] || o), Z7({
    theme: o,
    name: t,
    props: e
  });
}
const Dr = typeof window < "u" ? E.useLayoutEffect : E.useEffect;
function wne(e, t, n, r, o) {
  const [i, a] = E.useState(() => o && n ? n(e).matches : r ? r(e).matches : t);
  return Dr(() => {
    if (!n)
      return;
    const c = n(e), l = () => {
      a(c.matches);
    };
    return l(), c.addEventListener("change", l), () => {
      c.removeEventListener("change", l);
    };
  }, [e, n]), i;
}
const $ne = {
  ...E
}, J7 = $ne.useSyncExternalStore;
function One(e, t, n, r, o) {
  const i = E.useCallback(() => t, [t]), a = E.useMemo(() => {
    if (o && n)
      return () => n(e).matches;
    if (r !== null) {
      const {
        matches: d
      } = r(e);
      return () => d;
    }
    return i;
  }, [i, e, r, o, n]), [c, l] = E.useMemo(() => {
    if (n === null)
      return [i, () => () => {
      }];
    const d = n(e);
    return [() => d.matches, (f) => (d.addEventListener("change", f), () => {
      d.removeEventListener("change", f);
    })];
  }, [i, n, e]);
  return J7(l, c, a);
}
function Q7(e = {}) {
  const {
    themeId: t
  } = e;
  return function(r, o = {}) {
    let i = rT();
    i && t && (i = i[t] || i);
    const a = typeof window < "u" && typeof window.matchMedia < "u", {
      defaultMatches: c = !1,
      matchMedia: l = a ? window.matchMedia : null,
      ssrMatchMedia: u = null,
      noSsr: d = !1
    } = Z7({
      name: "MuiUseMediaQuery",
      props: o,
      theme: i
    });
    process.env.NODE_ENV !== "production" && typeof r == "function" && i === null && console.error(["MUI: The `query` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`));
    let f = typeof r == "function" ? r(i) : r;
    f = f.replace(/^@media( ?)/m, "");
    const v = (J7 !== void 0 ? One : wne)(f, c, l, u, d);
    return process.env.NODE_ENV !== "production" && E.useDebugValue({
      query: f,
      match: v
    }), v;
  };
}
const OIe = Q7();
function eu(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
function iT(e, t = 0, n = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > n) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${n}].`), eu(e, t, n);
}
function Sne(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((r) => r + r)), process.env.NODE_ENV !== "production" && e.length !== e.trim().length && console.error(`MUI: The color: "${e}" is invalid. Make sure the color input doesn't contain leading/trailing space.`), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((r, o) => o < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function js(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return js(Sne(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(n))
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : na(9, e));
  let r = e.substring(t + 1, e.length - 1), o;
  if (n === "color") {
    if (r = r.split(" "), o = r.shift(), r.length === 4 && r[3].charAt(0) === "/" && (r[3] = r[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(o))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${o}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : na(10, o));
  } else
    r = r.split(",");
  return r = r.map((i) => parseFloat(i)), {
    type: n,
    values: r,
    colorSpace: o
  };
}
const Cne = (e) => {
  const t = js(e);
  return t.values.slice(0, 3).map((n, r) => t.type.includes("hsl") && r !== 0 ? `${n}%` : n).join(" ");
}, tf = (e, t) => {
  try {
    return Cne(e);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
};
function nv(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: r
  } = e;
  return t.includes("rgb") ? r = r.map((o, i) => i < 3 ? parseInt(o, 10) : o) : t.includes("hsl") && (r[1] = `${r[1]}%`, r[2] = `${r[2]}%`), t.includes("color") ? r = `${n} ${r.join(" ")}` : r = `${r.join(", ")}`, `${t}(${r})`;
}
function eL(e) {
  e = js(e);
  const {
    values: t
  } = e, n = t[0], r = t[1] / 100, o = t[2] / 100, i = r * Math.min(o, 1 - o), a = (u, d = (u + n / 30) % 12) => o - i * Math.max(Math.min(d - 3, 9 - d, 1), -1);
  let c = "rgb";
  const l = [Math.round(a(0) * 255), Math.round(a(8) * 255), Math.round(a(4) * 255)];
  return e.type === "hsla" && (c += "a", l.push(t[3])), nv({
    type: c,
    values: l
  });
}
function KO(e) {
  e = js(e);
  let t = e.type === "hsl" || e.type === "hsla" ? js(eL(e)).values : e.values;
  return t = t.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function bP(e, t) {
  const n = KO(e), r = KO(t);
  return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
}
function It(e, t) {
  return e = js(e), t = iT(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, nv(e);
}
function Hh(e, t, n) {
  try {
    return It(e, t);
  } catch {
    return e;
  }
}
function Lf(e, t) {
  if (e = js(e), t = iT(t), e.type.includes("hsl"))
    e.values[2] *= 1 - t;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return nv(e);
}
function un(e, t, n) {
  try {
    return Lf(e, t);
  } catch {
    return e;
  }
}
function jf(e, t) {
  if (e = js(e), t = iT(t), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.includes("rgb"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return nv(e);
}
function dn(e, t, n) {
  try {
    return jf(e, t);
  } catch {
    return e;
  }
}
function Tne(e, t = 0.15) {
  return KO(e) > 0.5 ? Lf(e, t) : jf(e, t);
}
function Vh(e, t, n) {
  try {
    return Tne(e, t);
  } catch {
    return e;
  }
}
function $o(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...r) {
    return e(...r) || t(...r);
  };
}
function Ene(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function tL(e, t, n, r, o) {
  const i = e[t], a = o || t;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let c;
  const l = i.type;
  return typeof l == "function" && !Ene(l) && (c = "Did you accidentally use a plain function component for an element instead?"), c !== void 0 ? new Error(`Invalid ${r} \`${a}\` supplied to \`${n}\`. Expected an element that can hold a ref. ${c} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const el = $o(s.element, tL);
el.isRequired = $o(s.element.isRequired, tL);
function _ne(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function kne(e, t, n, r, o) {
  const i = e[t], a = o || t;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let c;
  return typeof i == "function" && !_ne(i) && (c = "Did you accidentally provide a plain function component instead?"), c !== void 0 ? new Error(`Invalid ${r} \`${a}\` supplied to \`${n}\`. Expected an element type that can hold a ref. ${c} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const aT = $o(s.elementType, kne), Rne = "exact-prop: ​";
function Yu(e) {
  return process.env.NODE_ENV === "production" ? e : {
    ...e,
    [Rne]: (t) => {
      const n = Object.keys(t).filter((r) => !e.hasOwnProperty(r));
      return n.length > 0 ? new Error(`The following props are not supported: ${n.map((r) => `\`${r}\``).join(", ")}. Please remove them.`) : null;
    }
  };
}
function ra(e, t, n, r, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = e[t], a = o || t;
  return i == null ? null : i && i.nodeType !== 1 ? new Error(`Invalid ${r} \`${a}\` supplied to \`${n}\`. Expected an HTMLElement.`) : null;
}
const jr = s.oneOfType([s.func, s.object]);
function XO(...e) {
  return e.reduce((t, n) => n == null ? t : function(...o) {
    t.apply(this, o), n.apply(this, o);
  }, () => {
  });
}
function Ep(e, t = 166) {
  let n;
  function r(...o) {
    const i = () => {
      e.apply(this, o);
    };
    clearTimeout(n), n = setTimeout(i, t);
  }
  return r.clear = () => {
    clearTimeout(n);
  }, r;
}
function Zm(e, t) {
  var n, r, o;
  return /* @__PURE__ */ E.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    e.type.muiName ?? ((o = (r = (n = e.type) == null ? void 0 : n._payload) == null ? void 0 : r.value) == null ? void 0 : o.muiName)
  ) !== -1;
}
function Un(e) {
  return e && e.ownerDocument || document;
}
function Oo(e) {
  return Un(e).defaultView || window;
}
function Pne(e, t) {
  if (process.env.NODE_ENV === "production")
    return () => null;
  const n = t ? {
    ...t.propTypes
  } : null;
  return (o) => (i, a, c, l, u, ...d) => {
    const f = u || a, h = n == null ? void 0 : n[f];
    if (h) {
      const v = h(i, a, c, l, u, ...d);
      if (v)
        return v;
    }
    return typeof i[a] < "u" && !i[o] ? new Error(`The prop \`${f}\` of \`${e}\` can only be used together with the \`${o}\` prop.`) : null;
  };
}
function _g(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
let xP = 0;
function Ane(e) {
  const [t, n] = E.useState(e), r = e || t;
  return E.useEffect(() => {
    t == null && (xP += 1, n(`mui-${xP}`));
  }, [t]), r;
}
const Ine = {
  ...E
}, wP = Ine.useId;
function sT(e) {
  if (wP !== void 0) {
    const t = wP();
    return e ?? t;
  }
  return Ane(e);
}
function nL(e, t, n, r, o) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = o || t;
  return typeof e[t] < "u" ? new Error(`The prop \`${i}\` is not supported. Please remove it.`) : null;
}
function Mc({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: o
  } = E.useRef(e !== void 0), [i, a] = E.useState(t), c = o ? e : i;
  if (process.env.NODE_ENV !== "production") {
    E.useEffect(() => {
      o !== (e !== void 0) && console.error([`MUI: A component is changing the ${o ? "" : "un"}controlled ${r} state of ${n} to be ${o ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r, n, e]);
    const {
      current: u
    } = E.useRef(t);
    E.useEffect(() => {
      !o && !Object.is(u, t) && console.error([`MUI: A component is changing the default ${r} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const l = E.useCallback((u) => {
    o || a(u);
  }, []);
  return [c, l];
}
function hr(e) {
  const t = E.useRef(e);
  return Dr(() => {
    t.current = e;
  }), E.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function $n(...e) {
  return E.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      _g(n, t);
    });
  }, e);
}
const $P = {};
function rL(e, t) {
  const n = E.useRef($P);
  return n.current === $P && (n.current = e(t)), n;
}
const Mne = [];
function Nne(e) {
  E.useEffect(e, Mne);
}
class cT {
  constructor() {
    nt(this, "currentId", null);
    nt(this, "clear", () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    });
    nt(this, "disposeEffect", () => this.clear);
  }
  static create() {
    return new cT();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, n();
    }, t);
  }
}
function oL() {
  const e = rL(cT.create).current;
  return Nne(e.disposeEffect), e;
}
function kg(e) {
  try {
    return e.matches(":focus-visible");
  } catch {
    process.env.NODE_ENV !== "production" && !/jsdom/.test(window.navigator.userAgent) && console.warn(["MUI: The `:focus-visible` pseudo class is not supported in this browser.", "Some components rely on this feature to work properly."].join(`
`));
  }
  return !1;
}
function iL(e = window) {
  const t = e.document.documentElement.clientWidth;
  return e.innerWidth - t;
}
const lT = (e) => {
  const t = E.useRef({});
  return E.useEffect(() => {
    t.current = e;
  }), t.current;
}, Dne = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
};
function Lne(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function aL(e, t, n, r) {
  const o = e[t];
  if (o == null || !Number.isInteger(o)) {
    const i = Lne(o);
    return new RangeError(`Invalid ${r} \`${t}\` of type \`${i}\` supplied to \`${n}\`, expected \`integer\`.`);
  }
  return null;
}
function sL(e, t, ...n) {
  return e[t] === void 0 ? null : aL(e, t, ...n);
}
function ZO() {
  return null;
}
sL.isRequired = aL;
ZO.isRequired = ZO;
const rv = process.env.NODE_ENV === "production" ? ZO : sL;
function wt(e, t, n = void 0) {
  const r = {};
  for (const o in e) {
    const i = e[o];
    let a = "", c = !0;
    for (let l = 0; l < i.length; l += 1) {
      const u = i[l];
      u && (a += (c === !0 ? "" : " ") + t(u), c = !1, n && n[u] && (a += " " + n[u]));
    }
    r[o] = a;
  }
  return r;
}
function jne(e) {
  return typeof e == "string";
}
function cL(e, t, n) {
  return e === void 0 || jne(e) ? t : {
    ...t,
    ownerState: {
      ...t.ownerState,
      ...n
    }
  };
}
function vf(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((r) => r.match(/^on[A-Z]/) && typeof e[r] == "function" && !t.includes(r)).forEach((r) => {
    n[r] = e[r];
  }), n;
}
function OP(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function lL(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: r,
    externalForwardedProps: o,
    className: i
  } = e;
  if (!t) {
    const v = Ge(n == null ? void 0 : n.className, i, o == null ? void 0 : o.className, r == null ? void 0 : r.className), y = {
      ...n == null ? void 0 : n.style,
      ...o == null ? void 0 : o.style,
      ...r == null ? void 0 : r.style
    }, g = {
      ...n,
      ...o,
      ...r
    };
    return v.length > 0 && (g.className = v), Object.keys(y).length > 0 && (g.style = y), {
      props: g,
      internalRef: void 0
    };
  }
  const a = vf({
    ...o,
    ...r
  }), c = OP(r), l = OP(o), u = t(a), d = Ge(u == null ? void 0 : u.className, n == null ? void 0 : n.className, i, o == null ? void 0 : o.className, r == null ? void 0 : r.className), f = {
    ...u == null ? void 0 : u.style,
    ...n == null ? void 0 : n.style,
    ...o == null ? void 0 : o.style,
    ...r == null ? void 0 : r.style
  }, h = {
    ...u,
    ...n,
    ...l,
    ...c
  };
  return d.length > 0 && (h.className = d), Object.keys(f).length > 0 && (h.style = f), {
    props: h,
    internalRef: u.ref
  };
}
function uL(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function fr(e) {
  var f;
  const {
    elementType: t,
    externalSlotProps: n,
    ownerState: r,
    skipResolvingSlotProps: o = !1,
    ...i
  } = e, a = o ? {} : uL(n, r), {
    props: c,
    internalRef: l
  } = lL({
    ...i,
    externalSlotProps: a
  }), u = $n(l, a == null ? void 0 : a.ref, (f = e.additionalProps) == null ? void 0 : f.ref);
  return cL(t, {
    ...c,
    ref: u
  }, r);
}
function tl(e) {
  var t;
  return parseInt(E.version, 10) >= 19 ? ((t = e == null ? void 0 : e.props) == null ? void 0 : t.ref) || null : (e == null ? void 0 : e.ref) || null;
}
const uT = /* @__PURE__ */ E.createContext(null);
process.env.NODE_ENV !== "production" && (uT.displayName = "ThemeContext");
function dT() {
  const e = E.useContext(uT);
  return process.env.NODE_ENV !== "production" && E.useDebugValue(e), e;
}
const Fne = typeof Symbol == "function" && Symbol.for, zne = Fne ? Symbol.for("mui.nested") : "__THEME_NESTED__";
function Bne(e, t) {
  if (typeof t == "function") {
    const n = t(e);
    return process.env.NODE_ENV !== "production" && (n || console.error(["MUI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join(`
`))), n;
  }
  return {
    ...e,
    ...t
  };
}
function Rg(e) {
  const {
    children: t,
    theme: n
  } = e, r = dT();
  process.env.NODE_ENV !== "production" && r === null && typeof n == "function" && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const o = E.useMemo(() => {
    const i = r === null ? {
      ...n
    } : Bne(r, n);
    return i != null && (i[zne] = r !== null), i;
  }, [n, r]);
  return /* @__PURE__ */ F.jsx(uT.Provider, {
    value: o,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (Rg.propTypes = {
  /**
   * Your component tree.
   */
  children: s.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: s.oneOfType([s.object, s.func]).isRequired
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (Rg.propTypes = Yu(Rg.propTypes));
const dL = /* @__PURE__ */ E.createContext();
function fL({
  value: e,
  ...t
}) {
  return /* @__PURE__ */ F.jsx(dL.Provider, {
    value: e ?? !0,
    ...t
  });
}
process.env.NODE_ENV !== "production" && (fL.propTypes = {
  children: s.node,
  value: s.bool
});
const Ya = () => E.useContext(dL) ?? !1, pL = /* @__PURE__ */ E.createContext(void 0);
function hL({
  value: e,
  children: t
}) {
  return /* @__PURE__ */ F.jsx(pL.Provider, {
    value: e,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (hL.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: s.node,
  /**
   * @ignore
   */
  value: s.object
});
function qne(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  if (!t || !t.components || !t.components[n])
    return r;
  const o = t.components[n];
  return o.defaultProps ? Df(o.defaultProps, r) : !o.styleOverrides && !o.variants ? Df(o, r) : r;
}
function Une({
  props: e,
  name: t
}) {
  const n = E.useContext(pL);
  return qne({
    props: e,
    name: t,
    theme: {
      components: n
    }
  });
}
const SP = {};
function CP(e, t, n, r = !1) {
  return E.useMemo(() => {
    const o = e && t[e] || t;
    if (typeof n == "function") {
      const i = n(o), a = e ? {
        ...t,
        [e]: i
      } : i;
      return r ? () => a : a;
    }
    return e ? {
      ...t,
      [e]: n
    } : {
      ...t,
      ...n
    };
  }, [e, t, n, r]);
}
function Ff(e) {
  const {
    children: t,
    theme: n,
    themeId: r
  } = e, o = rT(SP), i = dT() || SP;
  process.env.NODE_ENV !== "production" && (o === null && typeof n == "function" || r && o && !o[r] && typeof n == "function") && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const a = CP(r, o, n), c = CP(r, i, n, !0), l = (r ? a[r] : a).direction === "rtl";
  return /* @__PURE__ */ F.jsx(Rg, {
    theme: c,
    children: /* @__PURE__ */ F.jsx(W0.Provider, {
      value: a,
      children: /* @__PURE__ */ F.jsx(fL, {
        value: l,
        children: /* @__PURE__ */ F.jsx(hL, {
          value: r ? a[r].components : a.components,
          children: t
        })
      })
    })
  });
}
process.env.NODE_ENV !== "production" && (Ff.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Your component tree.
   */
  children: s.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: s.oneOfType([s.func, s.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: s.string
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (Ff.propTypes = Yu(Ff.propTypes));
const TP = {
  theme: void 0
};
function Wne(e) {
  let t, n;
  return function(o) {
    let i = t;
    return (i === void 0 || o.theme !== n) && (TP.theme = o.theme, i = V7(e(TP)), t = i, n = o.theme), i;
  };
}
const fT = "mode", pT = "color-scheme", Hne = "data-color-scheme";
function Vne(e) {
  const {
    defaultMode: t = "system",
    defaultLightColorScheme: n = "light",
    defaultDarkColorScheme: r = "dark",
    modeStorageKey: o = fT,
    colorSchemeStorageKey: i = pT,
    attribute: a = Hne,
    colorSchemeNode: c = "document.documentElement",
    nonce: l
  } = e || {};
  let u = "", d = a;
  if (a === "class" && (d = ".%s"), a === "data" && (d = "[data-%s]"), d.startsWith(".")) {
    const h = d.substring(1);
    u += `${c}.classList.remove('${h}'.replace('%s', light), '${h}'.replace('%s', dark));
      ${c}.classList.add('${h}'.replace('%s', colorScheme));`;
  }
  const f = d.match(/\[([^\]]+)\]/);
  if (f) {
    const [h, v] = f[1].split("=");
    v || (u += `${c}.removeAttribute('${h}'.replace('%s', light));
      ${c}.removeAttribute('${h}'.replace('%s', dark));`), u += `
      ${c}.setAttribute('${h}'.replace('%s', colorScheme), ${v ? `${v}.replace('%s', colorScheme)` : '""'});`;
  } else
    u += `${c}.setAttribute('${d}', colorScheme);`;
  return /* @__PURE__ */ F.jsx("script", {
    suppressHydrationWarning: !0,
    nonce: typeof window > "u" ? l : "",
    dangerouslySetInnerHTML: {
      __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${o}') || '${t}';
  const dark = localStorage.getItem('${i}-dark') || '${r}';
  const light = localStorage.getItem('${i}-light') || '${n}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${u}
  }
} catch(e){}})();`
    }
  }, "mui-color-scheme-init");
}
function EP(e) {
  if (typeof window < "u" && typeof window.matchMedia == "function" && e === "system")
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function mL(e, t) {
  if (e.mode === "light" || e.mode === "system" && e.systemMode === "light")
    return t("light");
  if (e.mode === "dark" || e.mode === "system" && e.systemMode === "dark")
    return t("dark");
}
function Yne(e) {
  return mL(e, (t) => {
    if (t === "light")
      return e.lightColorScheme;
    if (t === "dark")
      return e.darkColorScheme;
  });
}
function Qb(e, t) {
  if (typeof window > "u")
    return;
  let n;
  try {
    n = localStorage.getItem(e) || void 0, n || localStorage.setItem(e, t);
  } catch {
  }
  return n || t;
}
function Gne(e) {
  const {
    defaultMode: t = "light",
    defaultLightColorScheme: n,
    defaultDarkColorScheme: r,
    supportedColorSchemes: o = [],
    modeStorageKey: i = fT,
    colorSchemeStorageKey: a = pT,
    storageWindow: c = typeof window > "u" ? void 0 : window,
    noSsr: l = !1
  } = e, u = o.join(","), d = o.length > 1, [f, h] = E.useState(() => {
    const O = Qb(i, t), C = Qb(`${a}-light`, n), T = Qb(`${a}-dark`, r);
    return {
      mode: O,
      systemMode: EP(O),
      lightColorScheme: C,
      darkColorScheme: T
    };
  }), [v, y] = E.useState(l || !d);
  E.useEffect(() => {
    y(!0);
  }, []);
  const g = Yne(f), b = E.useCallback((O) => {
    h((C) => {
      if (O === C.mode)
        return C;
      const T = O ?? t;
      try {
        localStorage.setItem(i, T);
      } catch {
      }
      return {
        ...C,
        mode: T,
        systemMode: EP(T)
      };
    });
  }, [i, t]), x = E.useCallback((O) => {
    O ? typeof O == "string" ? O && !u.includes(O) ? console.error(`\`${O}\` does not exist in \`theme.colorSchemes\`.`) : h((C) => {
      const T = {
        ...C
      };
      return mL(C, (k) => {
        try {
          localStorage.setItem(`${a}-${k}`, O);
        } catch {
        }
        k === "light" && (T.lightColorScheme = O), k === "dark" && (T.darkColorScheme = O);
      }), T;
    }) : h((C) => {
      const T = {
        ...C
      }, k = O.light === null ? n : O.light, I = O.dark === null ? r : O.dark;
      if (k)
        if (!u.includes(k))
          console.error(`\`${k}\` does not exist in \`theme.colorSchemes\`.`);
        else {
          T.lightColorScheme = k;
          try {
            localStorage.setItem(`${a}-light`, k);
          } catch {
          }
        }
      if (I)
        if (!u.includes(I))
          console.error(`\`${I}\` does not exist in \`theme.colorSchemes\`.`);
        else {
          T.darkColorScheme = I;
          try {
            localStorage.setItem(`${a}-dark`, I);
          } catch {
          }
        }
      return T;
    }) : h((C) => {
      try {
        localStorage.setItem(`${a}-light`, n), localStorage.setItem(`${a}-dark`, r);
      } catch {
      }
      return {
        ...C,
        lightColorScheme: n,
        darkColorScheme: r
      };
    });
  }, [u, a, n, r]), $ = E.useCallback((O) => {
    f.mode === "system" && h((C) => {
      const T = O != null && O.matches ? "dark" : "light";
      return C.systemMode === T ? C : {
        ...C,
        systemMode: T
      };
    });
  }, [f.mode]), S = E.useRef($);
  return S.current = $, E.useEffect(() => {
    if (typeof window.matchMedia != "function" || !d)
      return;
    const O = (...T) => S.current(...T), C = window.matchMedia("(prefers-color-scheme: dark)");
    return C.addListener(O), O(C), () => {
      C.removeListener(O);
    };
  }, [d]), E.useEffect(() => {
    if (c && d) {
      const O = (C) => {
        const T = C.newValue;
        typeof C.key == "string" && C.key.startsWith(a) && (!T || u.match(T)) && (C.key.endsWith("light") && x({
          light: T
        }), C.key.endsWith("dark") && x({
          dark: T
        })), C.key === i && (!T || ["light", "dark", "system"].includes(T)) && b(T || t);
      };
      return c.addEventListener("storage", O), () => {
        c.removeEventListener("storage", O);
      };
    }
  }, [x, b, i, a, u, t, c, d]), {
    ...f,
    mode: v ? f.mode : void 0,
    systemMode: v ? f.systemMode : void 0,
    colorScheme: v ? g : void 0,
    setMode: b,
    setColorScheme: x
  };
}
const Kne = "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
function Xne(e) {
  const {
    themeId: t,
    /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */
    theme: n = {},
    modeStorageKey: r = fT,
    colorSchemeStorageKey: o = pT,
    disableTransitionOnChange: i = !1,
    defaultColorScheme: a,
    resolveTheme: c
  } = e, l = {
    allColorSchemes: [],
    colorScheme: void 0,
    darkColorScheme: void 0,
    lightColorScheme: void 0,
    mode: void 0,
    setColorScheme: () => {
    },
    setMode: () => {
    },
    systemMode: void 0
  }, u = /* @__PURE__ */ E.createContext(void 0);
  process.env.NODE_ENV !== "production" && (u.displayName = "ColorSchemeContext");
  const d = () => E.useContext(u) || l, f = {}, h = {};
  function v(x) {
    var we, J, he, Te;
    const {
      children: $,
      theme: S,
      modeStorageKey: O = r,
      colorSchemeStorageKey: C = o,
      disableTransitionOnChange: T = i,
      storageWindow: k = typeof window > "u" ? void 0 : window,
      documentNode: I = typeof document > "u" ? void 0 : document,
      colorSchemeNode: P = typeof document > "u" ? void 0 : document.documentElement,
      disableNestedContext: _ = !1,
      disableStyleSheetGeneration: A = !1,
      defaultMode: D = "system",
      noSsr: M
    } = x, N = E.useRef(!1), L = dT(), z = E.useContext(u), q = !!z && !_, W = E.useMemo(() => S || (typeof n == "function" ? n() : n), [S]), U = W[t], K = U || W, {
      colorSchemes: Y = f,
      components: X = h,
      cssVarPrefix: oe
    } = K, re = Object.keys(Y).filter((xe) => !!Y[xe]).join(","), Z = E.useMemo(() => re.split(","), [re]), ce = typeof a == "string" ? a : a.light, fe = typeof a == "string" ? a : a.dark, de = Y[ce] && Y[fe] ? D : ((J = (we = Y[K.defaultColorScheme]) == null ? void 0 : we.palette) == null ? void 0 : J.mode) || ((he = K.palette) == null ? void 0 : he.mode), {
      mode: ne,
      setMode: le,
      systemMode: ve,
      lightColorScheme: G,
      darkColorScheme: Se,
      colorScheme: ue,
      setColorScheme: Q
    } = Gne({
      supportedColorSchemes: Z,
      defaultLightColorScheme: ce,
      defaultDarkColorScheme: fe,
      modeStorageKey: O,
      colorSchemeStorageKey: C,
      defaultMode: de,
      storageWindow: k,
      noSsr: M
    });
    let ie = ne, ee = ue;
    q && (ie = z.mode, ee = z.colorScheme);
    const be = E.useMemo(() => {
      var Ye;
      const xe = ee || K.defaultColorScheme, Ae = ((Ye = K.generateThemeVars) == null ? void 0 : Ye.call(K)) || K.vars, Ce = {
        ...K,
        components: X,
        colorSchemes: Y,
        cssVarPrefix: oe,
        vars: Ae
      };
      if (typeof Ce.generateSpacing == "function" && (Ce.spacing = Ce.generateSpacing()), xe) {
        const He = Y[xe];
        He && typeof He == "object" && Object.keys(He).forEach((Be) => {
          He[Be] && typeof He[Be] == "object" ? Ce[Be] = {
            ...Ce[Be],
            ...He[Be]
          } : Ce[Be] = He[Be];
        });
      }
      return c ? c(Ce) : Ce;
    }, [K, ee, X, Y, oe]), Ie = K.colorSchemeSelector;
    E.useEffect(() => {
      if (ee && P && Ie && Ie !== "media") {
        const xe = Ie;
        let Ae = Ie;
        if (xe === "class" && (Ae = ".%s"), xe === "data" && (Ae = "[data-%s]"), xe != null && xe.startsWith("data-") && !xe.includes("%s") && (Ae = `[${xe}="%s"]`), Ae.startsWith("."))
          P.classList.remove(...Z.map((Ce) => Ae.substring(1).replace("%s", Ce))), P.classList.add(Ae.substring(1).replace("%s", ee));
        else {
          const Ce = Ae.replace("%s", ee).match(/\[([^\]]+)\]/);
          if (Ce) {
            const [Ye, He] = Ce[1].split("=");
            He || Z.forEach((Be) => {
              P.removeAttribute(Ye.replace(ee, Be));
            }), P.setAttribute(Ye, He ? He.replace(/"|'/g, "") : "");
          } else
            P.setAttribute(Ae, ee);
        }
      }
    }, [ee, Ie, P, Z]), E.useEffect(() => {
      let xe;
      if (T && N.current && I) {
        const Ae = I.createElement("style");
        Ae.appendChild(I.createTextNode(Kne)), I.head.appendChild(Ae), window.getComputedStyle(I.body), xe = setTimeout(() => {
          I.head.removeChild(Ae);
        }, 1);
      }
      return () => {
        clearTimeout(xe);
      };
    }, [ee, T, I]), E.useEffect(() => (N.current = !0, () => {
      N.current = !1;
    }), []);
    const je = E.useMemo(() => ({
      allColorSchemes: Z,
      colorScheme: ee,
      darkColorScheme: Se,
      lightColorScheme: G,
      mode: ie,
      setColorScheme: Q,
      setMode: process.env.NODE_ENV === "production" ? le : (xe) => {
        be.colorSchemeSelector === "media" && console.error(["MUI: The `setMode` function has no effect if `colorSchemeSelector` is `media` (`media` is the default value).", "To toggle the mode manually, please configure `colorSchemeSelector` to use a class or data attribute.", "To learn more, visit https://mui.com/material-ui/customization/css-theme-variables/configuration/#toggling-dark-mode-manually"].join(`
`)), le(xe);
      },
      systemMode: ve
    }), [Z, ee, Se, G, ie, Q, le, ve, be.colorSchemeSelector]);
    let V = !0;
    (A || K.cssVariables === !1 || q && (L == null ? void 0 : L.cssVarPrefix) === oe) && (V = !1);
    const se = /* @__PURE__ */ F.jsxs(E.Fragment, {
      children: [/* @__PURE__ */ F.jsx(Ff, {
        themeId: U ? t : void 0,
        theme: be,
        children: $
      }), V && /* @__PURE__ */ F.jsx(tT, {
        styles: ((Te = be.generateStyleSheets) == null ? void 0 : Te.call(be)) || []
      })]
    });
    return q ? se : /* @__PURE__ */ F.jsx(u.Provider, {
      value: je,
      children: se
    });
  }
  process.env.NODE_ENV !== "production" && (v.propTypes = {
    /**
     * The component tree.
     */
    children: s.node,
    /**
     * The node used to attach the color-scheme attribute
     */
    colorSchemeNode: s.any,
    /**
     * localStorage key used to store `colorScheme`
     */
    colorSchemeStorageKey: s.string,
    /**
     * The default mode when the storage is empty,
     * require the theme to have `colorSchemes` with light and dark.
     */
    defaultMode: s.string,
    /**
     * If `true`, the provider creates its own context and generate stylesheet as if it is a root `CssVarsProvider`.
     */
    disableNestedContext: s.bool,
    /**
     * If `true`, the style sheet won't be generated.
     *
     * This is useful for controlling nested CssVarsProvider behavior.
     */
    disableStyleSheetGeneration: s.bool,
    /**
     * Disable CSS transitions when switching between modes or color schemes.
     */
    disableTransitionOnChange: s.bool,
    /**
     * The document to attach the attribute to.
     */
    documentNode: s.any,
    /**
     * The key in the local storage used to store current color scheme.
     */
    modeStorageKey: s.string,
    /**
     * If `true`, the mode will be the same value as the storage without an extra rerendering after the hydration.
     * You should use this option in conjuction with `InitColorSchemeScript` component.
     */
    noSsr: s.bool,
    /**
     * The window that attaches the 'storage' event listener.
     * @default window
     */
    storageWindow: s.any,
    /**
     * The calculated theme object that will be passed through context.
     */
    theme: s.object
  });
  const y = typeof a == "string" ? a : a.light, g = typeof a == "string" ? a : a.dark;
  return {
    CssVarsProvider: v,
    useColorScheme: d,
    getInitColorSchemeScript: (x) => Vne({
      colorSchemeStorageKey: o,
      defaultLightColorScheme: y,
      defaultDarkColorScheme: g,
      modeStorageKey: r,
      ...x
    })
  };
}
function Zne(e = "") {
  function t(...r) {
    if (!r.length)
      return "";
    const o = r[0];
    return typeof o == "string" && !o.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${o}${t(...r.slice(1))})` : `, ${o}`;
  }
  return (r, ...o) => `var(--${e ? `${e}-` : ""}${r}${t(...o)})`;
}
const _P = (e, t, n, r = []) => {
  let o = e;
  t.forEach((i, a) => {
    a === t.length - 1 ? Array.isArray(o) ? o[Number(i)] = n : o && typeof o == "object" && (o[i] = n) : o && typeof o == "object" && (o[i] || (o[i] = r.includes(i) ? [] : {}), o = o[i]);
  });
}, Jne = (e, t, n) => {
  function r(o, i = [], a = []) {
    Object.entries(o).forEach(([c, l]) => {
      (!n || n && !n([...i, c])) && l != null && (typeof l == "object" && Object.keys(l).length > 0 ? r(l, [...i, c], Array.isArray(l) ? [...a, c] : a) : t([...i, c], l, a));
    });
  }
  r(e);
}, Qne = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((r) => e.includes(r)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function e1(e, t) {
  const {
    prefix: n,
    shouldSkipGeneratingVar: r
  } = t || {}, o = {}, i = {}, a = {};
  return Jne(
    e,
    (c, l, u) => {
      if ((typeof l == "string" || typeof l == "number") && (!r || !r(c, l))) {
        const d = `--${n ? `${n}-` : ""}${c.join("-")}`, f = Qne(c, l);
        Object.assign(o, {
          [d]: f
        }), _P(i, c, `var(${d})`, u), _P(a, c, `var(${d}, ${f})`, u);
      }
    },
    (c) => c[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: o,
    vars: i,
    varsWithDefaults: a
  };
}
function ere(e, t = {}) {
  const {
    getSelector: n = b,
    disableCssColorScheme: r,
    colorSchemeSelector: o
  } = t, {
    colorSchemes: i = {},
    components: a,
    defaultColorScheme: c = "light",
    ...l
  } = e, {
    vars: u,
    css: d,
    varsWithDefaults: f
  } = e1(l, t);
  let h = f;
  const v = {}, {
    [c]: y,
    ...g
  } = i;
  if (Object.entries(g || {}).forEach(([S, O]) => {
    const {
      vars: C,
      css: T,
      varsWithDefaults: k
    } = e1(O, t);
    h = or(h, k), v[S] = {
      css: T,
      vars: C
    };
  }), y) {
    const {
      css: S,
      vars: O,
      varsWithDefaults: C
    } = e1(y, t);
    h = or(h, C), v[c] = {
      css: S,
      vars: O
    };
  }
  function b(S, O) {
    var T, k;
    let C = o;
    if (o === "class" && (C = ".%s"), o === "data" && (C = "[data-%s]"), o != null && o.startsWith("data-") && !o.includes("%s") && (C = `[${o}="%s"]`), S) {
      if (C === "media")
        return e.defaultColorScheme === S ? ":root" : {
          [`@media (prefers-color-scheme: ${((k = (T = i[S]) == null ? void 0 : T.palette) == null ? void 0 : k.mode) || S})`]: {
            ":root": O
          }
        };
      if (C)
        return e.defaultColorScheme === S ? `:root, ${C.replace("%s", String(S))}` : C.replace("%s", String(S));
    }
    return ":root";
  }
  return {
    vars: h,
    generateThemeVars: () => {
      let S = {
        ...u
      };
      return Object.entries(v).forEach(([, {
        vars: O
      }]) => {
        S = or(S, O);
      }), S;
    },
    generateStyleSheets: () => {
      var I, P;
      const S = [], O = e.defaultColorScheme || "light";
      function C(_, A) {
        Object.keys(A).length && S.push(typeof _ == "string" ? {
          [_]: {
            ...A
          }
        } : _);
      }
      C(n(void 0, {
        ...d
      }), d);
      const {
        [O]: T,
        ...k
      } = v;
      if (T) {
        const {
          css: _
        } = T, A = (P = (I = i[O]) == null ? void 0 : I.palette) == null ? void 0 : P.mode, D = !r && A ? {
          colorScheme: A,
          ..._
        } : {
          ..._
        };
        C(n(O, {
          ...D
        }), D);
      }
      return Object.entries(k).forEach(([_, {
        css: A
      }]) => {
        var N, L;
        const D = (L = (N = i[_]) == null ? void 0 : N.palette) == null ? void 0 : L.mode, M = !r && D ? {
          colorScheme: D,
          ...A
        } : {
          ...A
        };
        C(n(_, {
          ...M
        }), M);
      }), S;
    }
  };
}
function tre(e) {
  return function(n) {
    return e === "media" ? (process.env.NODE_ENV !== "production" && n !== "light" && n !== "dark" && console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${n}'.`), `@media (prefers-color-scheme: ${n})`) : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${n}"] &` : e === "class" ? `.${n} &` : e === "data" ? `[data-${n}] &` : `${e.replace("%s", n)} &` : "&";
  };
}
const nre = (e, t) => e.filter((n) => t.includes(n)), Gu = (e, t, n) => {
  const r = e.keys[0];
  Array.isArray(t) ? t.forEach((o, i) => {
    n((a, c) => {
      i <= e.keys.length - 1 && (i === 0 ? Object.assign(a, c) : a[e.up(e.keys[i])] = c);
    }, o);
  }) : t && typeof t == "object" ? (Object.keys(t).length > e.keys.length ? e.keys : nre(e.keys, Object.keys(t))).forEach((i) => {
    if (e.keys.includes(i)) {
      const a = t[i];
      a !== void 0 && n((c, l) => {
        r === i ? Object.assign(c, l) : c[e.up(i)] = l;
      }, a);
    }
  }) : (typeof t == "number" || typeof t == "string") && n((o, i) => {
    Object.assign(o, i);
  }, t);
};
function Pg(e) {
  return `--Grid-${e}Spacing`;
}
function ov(e) {
  return `--Grid-parent-${e}Spacing`;
}
const kP = "--Grid-columns", du = "--Grid-parent-columns", rre = ({
  theme: e,
  ownerState: t
}) => {
  const n = {};
  return Gu(e.breakpoints, t.size, (r, o) => {
    let i = {};
    o === "grow" && (i = {
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: "100%"
    }), o === "auto" && (i = {
      flexBasis: "auto",
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: "none",
      width: "auto"
    }), typeof o == "number" && (i = {
      flexGrow: 0,
      flexBasis: "auto",
      width: `calc(100% * ${o} / var(${du}) - (var(${du}) - ${o}) * (var(${ov("column")}) / var(${du})))`
    }), r(n, i);
  }), n;
}, ore = ({
  theme: e,
  ownerState: t
}) => {
  const n = {};
  return Gu(e.breakpoints, t.offset, (r, o) => {
    let i = {};
    o === "auto" && (i = {
      marginLeft: "auto"
    }), typeof o == "number" && (i = {
      marginLeft: o === 0 ? "0px" : `calc(100% * ${o} / var(${du}) + var(${ov("column")}) * ${o} / var(${du}))`
    }), r(n, i);
  }), n;
}, ire = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {
    [kP]: 12
  };
  return Gu(e.breakpoints, t.columns, (r, o) => {
    const i = o ?? 12;
    r(n, {
      [kP]: i,
      "> *": {
        [du]: i
      }
    });
  }), n;
}, are = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {};
  return Gu(e.breakpoints, t.rowSpacing, (r, o) => {
    var a;
    const i = typeof o == "string" ? o : (a = e.spacing) == null ? void 0 : a.call(e, o);
    r(n, {
      [Pg("row")]: i,
      "> *": {
        [ov("row")]: i
      }
    });
  }), n;
}, sre = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {};
  return Gu(e.breakpoints, t.columnSpacing, (r, o) => {
    var a;
    const i = typeof o == "string" ? o : (a = e.spacing) == null ? void 0 : a.call(e, o);
    r(n, {
      [Pg("column")]: i,
      "> *": {
        [ov("column")]: i
      }
    });
  }), n;
}, cre = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const n = {};
  return Gu(e.breakpoints, t.direction, (r, o) => {
    r(n, {
      flexDirection: o
    });
  }), n;
}, lre = ({
  ownerState: e
}) => ({
  minWidth: 0,
  boxSizing: "border-box",
  ...e.container && {
    display: "flex",
    flexWrap: "wrap",
    ...e.wrap && e.wrap !== "wrap" && {
      flexWrap: e.wrap
    },
    gap: `var(${Pg("row")}) var(${Pg("column")})`
  }
}), ure = (e) => {
  const t = [];
  return Object.entries(e).forEach(([n, r]) => {
    r !== !1 && r !== void 0 && t.push(`grid-${n}-${String(r)}`);
  }), t;
}, dre = (e, t = "xs") => {
  function n(r) {
    return r === void 0 ? !1 : typeof r == "string" && !Number.isNaN(Number(r)) || typeof r == "number" && r > 0;
  }
  if (n(e))
    return [`spacing-${t}-${String(e)}`];
  if (typeof e == "object" && !Array.isArray(e)) {
    const r = [];
    return Object.entries(e).forEach(([o, i]) => {
      n(i) && r.push(`spacing-${o}-${String(i)}`);
    }), r;
  }
  return [];
}, fre = (e) => e === void 0 ? [] : typeof e == "object" ? Object.entries(e).map(([t, n]) => `direction-${t}-${n}`) : [`direction-xs-${String(e)}`], pre = Cp(), hre = X7("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function mre(e) {
  return oT({
    props: e,
    name: "MuiGrid",
    defaultTheme: pre
  });
}
function gre(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = hre,
    useThemeProps: n = mre,
    useTheme: r = Tp,
    componentName: o = "MuiGrid"
  } = e, i = (u, d) => {
    const {
      container: f,
      direction: h,
      spacing: v,
      wrap: y,
      size: g
    } = u, b = {
      root: ["root", f && "container", y !== "wrap" && `wrap-xs-${String(y)}`, ...fre(h), ...ure(g), ...f ? dre(v, d.breakpoints.keys[0]) : []]
    };
    return wt(b, (x) => mt(o, x), {});
  };
  function a(u, d, f = () => !0) {
    const h = {};
    return u === null || (Array.isArray(u) ? u.forEach((v, y) => {
      v !== null && f(v) && d.keys[y] && (h[d.keys[y]] = v);
    }) : typeof u == "object" ? Object.keys(u).forEach((v) => {
      const y = u[v];
      y != null && f(y) && (h[v] = y);
    }) : h[d.keys[0]] = u), h;
  }
  const c = t(ire, sre, are, rre, cre, lre, ore), l = /* @__PURE__ */ E.forwardRef(function(d, f) {
    const h = r(), v = n(d), y = tv(v), {
      className: g,
      children: b,
      columns: x = 12,
      container: $ = !1,
      component: S = "div",
      direction: O = "row",
      wrap: C = "wrap",
      size: T = {},
      offset: k = {},
      spacing: I = 0,
      rowSpacing: P = I,
      columnSpacing: _ = I,
      unstable_level: A = 0,
      ...D
    } = y, M = a(T, h.breakpoints, (Y) => Y !== !1), N = a(k, h.breakpoints), L = d.columns ?? (A ? void 0 : x), z = d.spacing ?? (A ? void 0 : I), q = d.rowSpacing ?? d.spacing ?? (A ? void 0 : P), W = d.columnSpacing ?? d.spacing ?? (A ? void 0 : _), U = {
      ...y,
      level: A,
      columns: L,
      container: $,
      direction: O,
      wrap: C,
      spacing: z,
      rowSpacing: q,
      columnSpacing: W,
      size: M,
      offset: N
    }, K = i(U, h);
    return /* @__PURE__ */ F.jsx(c, {
      ref: f,
      as: S,
      ownerState: U,
      className: Ge(K.root, g),
      ...D,
      children: E.Children.map(b, (Y) => {
        var X;
        return /* @__PURE__ */ E.isValidElement(Y) && Zm(Y, ["Grid"]) && $ && Y.props.container ? /* @__PURE__ */ E.cloneElement(Y, {
          unstable_level: ((X = Y.props) == null ? void 0 : X.unstable_level) ?? A + 1
        }) : Y;
      })
    });
  });
  return process.env.NODE_ENV !== "production" && (l.propTypes = {
    children: s.node,
    className: s.string,
    columns: s.oneOfType([s.arrayOf(s.number), s.number, s.object]),
    columnSpacing: s.oneOfType([s.arrayOf(s.oneOfType([s.number, s.string])), s.number, s.object, s.string]),
    component: s.elementType,
    container: s.bool,
    direction: s.oneOfType([s.oneOf(["column-reverse", "column", "row-reverse", "row"]), s.arrayOf(s.oneOf(["column-reverse", "column", "row-reverse", "row"])), s.object]),
    offset: s.oneOfType([s.string, s.number, s.arrayOf(s.oneOfType([s.string, s.number])), s.object]),
    rowSpacing: s.oneOfType([s.arrayOf(s.oneOfType([s.number, s.string])), s.number, s.object, s.string]),
    size: s.oneOfType([s.string, s.bool, s.number, s.arrayOf(s.oneOfType([s.string, s.bool, s.number])), s.object]),
    spacing: s.oneOfType([s.arrayOf(s.oneOfType([s.number, s.string])), s.number, s.object, s.string]),
    sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
    wrap: s.oneOf(["nowrap", "wrap-reverse", "wrap"])
  }), l.muiName = "Grid", l;
}
const vre = Cp(), yre = X7("div", {
  name: "MuiStack",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function bre(e) {
  return oT({
    props: e,
    name: "MuiStack",
    defaultTheme: vre
  });
}
function xre(e, t) {
  const n = E.Children.toArray(e).filter(Boolean);
  return n.reduce((r, o, i) => (r.push(o), i < n.length - 1 && r.push(/* @__PURE__ */ E.cloneElement(t, {
    key: `separator-${i}`
  })), r), []);
}
const wre = (e) => ({
  row: "Left",
  "row-reverse": "Right",
  column: "Top",
  "column-reverse": "Bottom"
})[e], $re = ({
  ownerState: e,
  theme: t
}) => {
  let n = {
    display: "flex",
    flexDirection: "column",
    ...xi({
      theme: t
    }, Jb({
      values: e.direction,
      breakpoints: t.breakpoints.values
    }), (r) => ({
      flexDirection: r
    }))
  };
  if (e.spacing) {
    const r = K0(t), o = Object.keys(t.breakpoints.values).reduce((l, u) => ((typeof e.spacing == "object" && e.spacing[u] != null || typeof e.direction == "object" && e.direction[u] != null) && (l[u] = !0), l), {}), i = Jb({
      values: e.direction,
      base: o
    }), a = Jb({
      values: e.spacing,
      base: o
    });
    typeof i == "object" && Object.keys(i).forEach((l, u, d) => {
      if (!i[l]) {
        const h = u > 0 ? i[d[u - 1]] : "column";
        i[l] = h;
      }
    }), n = or(n, xi({
      theme: t
    }, a, (l, u) => e.useFlexGap ? {
      gap: Wc(r, l)
    } : {
      // The useFlexGap={false} implement relies on each child to give up control of the margin.
      // We need to reset the margin to avoid double spacing.
      "& > :not(style):not(style)": {
        margin: 0
      },
      "& > :not(style) ~ :not(style)": {
        [`margin${wre(u ? i[u] : e.direction)}`]: Wc(r, l)
      }
    }));
  }
  return n = mte(t.breakpoints, n), n;
};
function Ore(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = yre,
    useThemeProps: n = bre,
    componentName: r = "MuiStack"
  } = e, o = () => wt({
    root: ["root"]
  }, (l) => mt(r, l), {}), i = t($re), a = /* @__PURE__ */ E.forwardRef(function(l, u) {
    const d = n(l), f = tv(d), {
      component: h = "div",
      direction: v = "column",
      spacing: y = 0,
      divider: g,
      children: b,
      className: x,
      useFlexGap: $ = !1,
      ...S
    } = f, O = {
      direction: v,
      spacing: y,
      useFlexGap: $
    }, C = o();
    return /* @__PURE__ */ F.jsx(i, {
      as: h,
      ownerState: O,
      ref: u,
      className: Ge(C.root, x),
      ...S,
      children: g ? xre(b, g) : b
    });
  });
  return process.env.NODE_ENV !== "production" && (a.propTypes = {
    children: s.node,
    direction: s.oneOfType([s.oneOf(["column-reverse", "column", "row-reverse", "row"]), s.arrayOf(s.oneOf(["column-reverse", "column", "row-reverse", "row"])), s.object]),
    divider: s.node,
    spacing: s.oneOfType([s.arrayOf(s.oneOfType([s.number, s.string])), s.number, s.object, s.string]),
    sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
  }), a;
}
function gL() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: Pf.white,
      default: Pf.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const Sre = gL();
function vL() {
  return {
    text: {
      primary: Pf.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: Pf.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const RP = vL();
function PP(e, t, n, r) {
  const o = r.light || r, i = r.dark || r * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = jf(e.main, o) : t === "dark" && (e.dark = Lf(e.main, i)));
}
function Cre(e = "light") {
  return e === "dark" ? {
    main: Ml[200],
    light: Ml[50],
    dark: Ml[400]
  } : {
    main: Ml[700],
    light: Ml[400],
    dark: Ml[800]
  };
}
function Tre(e = "light") {
  return e === "dark" ? {
    main: Il[200],
    light: Il[50],
    dark: Il[400]
  } : {
    main: Il[500],
    light: Il[300],
    dark: Il[700]
  };
}
function Ere(e = "light") {
  return e === "dark" ? {
    main: Al[500],
    light: Al[300],
    dark: Al[700]
  } : {
    main: Al[700],
    light: Al[400],
    dark: Al[800]
  };
}
function _re(e = "light") {
  return e === "dark" ? {
    main: Nl[400],
    light: Nl[300],
    dark: Nl[700]
  } : {
    main: Nl[700],
    light: Nl[500],
    dark: Nl[900]
  };
}
function kre(e = "light") {
  return e === "dark" ? {
    main: Dl[400],
    light: Dl[300],
    dark: Dl[700]
  } : {
    main: Dl[800],
    light: Dl[500],
    dark: Dl[900]
  };
}
function Rre(e = "light") {
  return e === "dark" ? {
    main: kd[400],
    light: kd[300],
    dark: kd[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: kd[500],
    dark: kd[900]
  };
}
function hT(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: r = 0.2,
    ...o
  } = e, i = e.primary || Cre(t), a = e.secondary || Tre(t), c = e.error || Ere(t), l = e.info || _re(t), u = e.success || kre(t), d = e.warning || Rre(t);
  function f(g) {
    const b = bP(g, RP.text.primary) >= n ? RP.text.primary : Sre.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const x = bP(g, b);
      x < 3 && console.error([`MUI: The contrast ratio of ${x}:1 for ${b} on ${g}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return b;
  }
  const h = ({
    color: g,
    name: b,
    mainShade: x = 500,
    lightShade: $ = 300,
    darkShade: S = 700
  }) => {
    if (g = {
      ...g
    }, !g.main && g[x] && (g.main = g[x]), !g.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${b ? ` (${b})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${x}\` property.` : na(11, b ? ` (${b})` : "", x));
    if (typeof g.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${b ? ` (${b})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(g.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : na(12, b ? ` (${b})` : "", JSON.stringify(g.main)));
    return PP(g, "light", $, r), PP(g, "dark", S, r), g.contrastText || (g.contrastText = f(g.main)), g;
  };
  let v;
  return t === "light" ? v = gL() : t === "dark" && (v = vL()), process.env.NODE_ENV !== "production" && (v || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), or({
    // A collection of common colors.
    common: {
      ...Pf
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: h({
      color: i,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: h({
      color: a,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: h({
      color: c,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: h({
      color: d,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: h({
      color: l,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: h({
      color: u,
      name: "success"
    }),
    // The grey colors.
    grey: DQ,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: f,
    // Generate a rich color object.
    augmentColor: h,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: r,
    // The light and dark mode object.
    ...v
  }, o);
}
function Pre(e) {
  const t = {};
  return Object.entries(e).forEach((r) => {
    const [o, i] = r;
    typeof i == "object" && (t[o] = `${i.fontStyle ? `${i.fontStyle} ` : ""}${i.fontVariant ? `${i.fontVariant} ` : ""}${i.fontWeight ? `${i.fontWeight} ` : ""}${i.fontStretch ? `${i.fontStretch} ` : ""}${i.fontSize || ""}${i.lineHeight ? `/${i.lineHeight} ` : ""}${i.fontFamily || ""}`);
  }), t;
}
function Are(e, t) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...t
  };
}
function Ire(e) {
  return Math.round(e * 1e5) / 1e5;
}
const AP = {
  textTransform: "uppercase"
}, IP = '"Roboto", "Helvetica", "Arial", sans-serif';
function yL(e, t) {
  const {
    fontFamily: n = IP,
    // The default font size of the Material Specification.
    fontSize: r = 14,
    // px
    fontWeightLight: o = 300,
    fontWeightRegular: i = 400,
    fontWeightMedium: a = 500,
    fontWeightBold: c = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: l = 16,
    // Apply the CSS properties to all the variants.
    allVariants: u,
    pxToRem: d,
    ...f
  } = typeof t == "function" ? t(e) : t;
  process.env.NODE_ENV !== "production" && (typeof r != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof l != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const h = r / 14, v = d || ((b) => `${b / l * h}rem`), y = (b, x, $, S, O) => ({
    fontFamily: n,
    fontWeight: b,
    fontSize: v(x),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: $,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...n === IP ? {
      letterSpacing: `${Ire(S / x)}em`
    } : {},
    ...O,
    ...u
  }), g = {
    h1: y(o, 96, 1.167, -1.5),
    h2: y(o, 60, 1.2, -0.5),
    h3: y(i, 48, 1.167, 0),
    h4: y(i, 34, 1.235, 0.25),
    h5: y(i, 24, 1.334, 0),
    h6: y(a, 20, 1.6, 0.15),
    subtitle1: y(i, 16, 1.75, 0.15),
    subtitle2: y(a, 14, 1.57, 0.1),
    body1: y(i, 16, 1.5, 0.15),
    body2: y(i, 14, 1.43, 0.15),
    button: y(a, 14, 1.75, 0.4, AP),
    caption: y(i, 12, 1.66, 0.4),
    overline: y(i, 12, 2.66, 1, AP),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return or({
    htmlFontSize: l,
    pxToRem: v,
    fontFamily: n,
    fontSize: r,
    fontWeightLight: o,
    fontWeightRegular: i,
    fontWeightMedium: a,
    fontWeightBold: c,
    ...g
  }, f, {
    clone: !1
    // No need to clone deep
  });
}
const Mre = 0.2, Nre = 0.14, Dre = 0.12;
function yn(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${Mre})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${Nre})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${Dre})`].join(",");
}
const Lre = ["none", yn(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), yn(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), yn(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), yn(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), yn(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), yn(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), yn(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), yn(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), yn(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), yn(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), yn(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), yn(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), yn(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), yn(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), yn(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), yn(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), yn(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), yn(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), yn(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), yn(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), yn(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), yn(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), yn(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), yn(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], jre = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, Fre = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function MP(e) {
  return `${Math.round(e)}ms`;
}
function zre(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.min(Math.round((4 + 15 * t ** 0.25 + t / 5) * 10), 3e3);
}
function Bre(e) {
  const t = {
    ...jre,
    ...e.easing
  }, n = {
    ...Fre,
    ...e.duration
  };
  return {
    getAutoHeightDuration: zre,
    create: (o = ["all"], i = {}) => {
      const {
        duration: a = n.standard,
        easing: c = t.easeInOut,
        delay: l = 0,
        ...u
      } = i;
      if (process.env.NODE_ENV !== "production") {
        const d = (h) => typeof h == "string", f = (h) => !Number.isNaN(parseFloat(h));
        !d(o) && !Array.isArray(o) && console.error('MUI: Argument "props" must be a string or Array.'), !f(a) && !d(a) && console.error(`MUI: Argument "duration" must be a number or a string but found ${a}.`), d(c) || console.error('MUI: Argument "easing" must be a string.'), !f(l) && !d(l) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof i != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(u).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(u).join(",")}].`);
      }
      return (Array.isArray(o) ? o : [o]).map((d) => `${d} ${typeof a == "string" ? a : MP(a)} ${c} ${typeof l == "string" ? l : MP(l)}`).join(",");
    },
    ...e,
    easing: t,
    duration: n
  };
}
const qre = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function Ure(e) {
  return Wi(e) || typeof e > "u" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function bL(e = {}) {
  const t = {
    ...e
  };
  function n(r) {
    const o = Object.entries(r);
    for (let i = 0; i < o.length; i++) {
      const [a, c] = o[i];
      !Ure(c) || a.startsWith("unstable_") ? delete r[a] : Wi(c) && (r[a] = {
        ...c
      }, n(r[a]));
    }
  }
  return n(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function JO(e = {}, ...t) {
  const {
    breakpoints: n,
    mixins: r = {},
    spacing: o,
    palette: i = {},
    transitions: a = {},
    typography: c = {},
    shape: l,
    ...u
  } = e;
  if (e.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : na(20));
  const d = hT(i), f = Cp(e);
  let h = or(f, {
    mixins: Are(f.breakpoints, r),
    palette: d,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: Lre.slice(),
    typography: yL(d, c),
    transitions: Bre(a),
    zIndex: {
      ...qre
    }
  });
  if (h = or(h, u), h = t.reduce((v, y) => or(v, y), h), process.env.NODE_ENV !== "production") {
    const v = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], y = (g, b) => {
      let x;
      for (x in g) {
        const $ = g[x];
        if (v.includes(x) && Object.keys($).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const S = mt("", x);
            console.error([`MUI: The \`${b}\` component increases the CSS specificity of the \`${x}\` internal state.`, "You can not override it like this: ", JSON.stringify(g, null, 2), "", `Instead, you need to use the '&.${S}' syntax:`, JSON.stringify({
              root: {
                [`&.${S}`]: $
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          g[x] = {};
        }
      }
    };
    Object.keys(h.components).forEach((g) => {
      const b = h.components[g].styleOverrides;
      b && g.startsWith("Mui") && y(b, g);
    });
  }
  return h.unstable_sxConfig = {
    ...Sp,
    ...u == null ? void 0 : u.unstable_sxConfig
  }, h.unstable_sx = function(y) {
    return Ls({
      sx: y,
      theme: this
    });
  }, h.toRuntimeSource = bL, h;
}
function QO(e) {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
const Wre = [...Array(25)].map((e, t) => {
  if (t === 0)
    return "none";
  const n = QO(t);
  return `linear-gradient(rgba(255 255 255 / ${n}), rgba(255 255 255 / ${n}))`;
});
function xL(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function wL(e) {
  return e === "dark" ? Wre : [];
}
function Hre(e) {
  const {
    palette: t = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: n,
    overlays: r,
    ...o
  } = e, i = hT(t);
  return {
    palette: i,
    opacity: {
      ...xL(i.mode),
      ...n
    },
    overlays: r || wL(i.mode),
    ...o
  };
}
function Vre(e) {
  var t;
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!((t = e[1]) != null && t.match(/(mode|contrastThreshold|tonalOffset)/));
}
const Yre = (e) => [...[...Array(25)].map((t, n) => `--${e ? `${e}-` : ""}overlays-${n}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], Gre = (e) => (t, n) => {
  const r = e.rootSelector || ":root", o = e.colorSchemeSelector;
  let i = o;
  if (o === "class" && (i = ".%s"), o === "data" && (i = "[data-%s]"), o != null && o.startsWith("data-") && !o.includes("%s") && (i = `[${o}="%s"]`), e.defaultColorScheme === t) {
    if (t === "dark") {
      const a = {};
      return Yre(e.cssVarPrefix).forEach((c) => {
        a[c] = n[c], delete n[c];
      }), i === "media" ? {
        [r]: n,
        "@media (prefers-color-scheme: dark)": {
          [r]: a
        }
      } : i ? {
        [i.replace("%s", t)]: a,
        [`${r}, ${i.replace("%s", t)}`]: n
      } : {
        [r]: {
          ...n,
          ...a
        }
      };
    }
    if (i && i !== "media")
      return `${r}, ${i.replace("%s", String(t))}`;
  } else if (t) {
    if (i === "media")
      return {
        [`@media (prefers-color-scheme: ${String(t)})`]: {
          [r]: n
        }
      };
    if (i)
      return i.replace("%s", String(t));
  }
  return r;
};
function Kre(e, t) {
  t.forEach((n) => {
    e[n] || (e[n] = {});
  });
}
function _e(e, t, n) {
  !e[t] && n && (e[t] = n);
}
function nf(e) {
  return typeof e != "string" || !e.startsWith("hsl") ? e : eL(e);
}
function Ta(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = tf(nf(e[t]), `MUI: Can't create \`palette.${t}Channel\` because \`palette.${t}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${t}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function Xre(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const Ii = (e) => {
  try {
    return e();
  } catch {
  }
}, Zre = (e = "mui") => Zne(e);
function t1(e, t, n, r) {
  if (!t)
    return;
  t = t === !0 ? {} : t;
  const o = r === "dark" ? "dark" : "light";
  if (!n) {
    e[r] = Hre({
      ...t,
      palette: {
        mode: o,
        ...t == null ? void 0 : t.palette
      }
    });
    return;
  }
  const {
    palette: i,
    ...a
  } = JO({
    ...n,
    palette: {
      mode: o,
      ...t == null ? void 0 : t.palette
    }
  });
  return e[r] = {
    ...t,
    palette: i,
    opacity: {
      ...xL(o),
      ...t == null ? void 0 : t.opacity
    },
    overlays: (t == null ? void 0 : t.overlays) || wL(o)
  }, a;
}
function Jre(e = {}, ...t) {
  const {
    colorSchemes: n = {
      light: !0
    },
    defaultColorScheme: r,
    disableCssColorScheme: o = !1,
    cssVarPrefix: i = "mui",
    shouldSkipGeneratingVar: a = Vre,
    colorSchemeSelector: c = n.light && n.dark ? "media" : void 0,
    rootSelector: l = ":root",
    ...u
  } = e, d = Object.keys(n)[0], f = r || (n.light && d !== "light" ? "light" : d), h = Zre(i), {
    [f]: v,
    light: y,
    dark: g,
    ...b
  } = n, x = {
    ...b
  };
  let $ = v;
  if ((f === "dark" && !("dark" in n) || f === "light" && !("light" in n)) && ($ = !0), !$)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`colorSchemes.${f}\` option is either missing or invalid.` : na(21, f));
  const S = t1(x, $, u, f);
  y && !x.light && t1(x, y, void 0, "light"), g && !x.dark && t1(x, g, void 0, "dark");
  let O = {
    defaultColorScheme: f,
    ...S,
    cssVarPrefix: i,
    colorSchemeSelector: c,
    rootSelector: l,
    getCssVar: h,
    colorSchemes: x,
    font: {
      ...Pre(S.typography),
      ...S.font
    },
    spacing: Xre(u.spacing)
  };
  Object.keys(O.colorSchemes).forEach((P) => {
    const _ = O.colorSchemes[P].palette, A = (D) => {
      const M = D.split("-"), N = M[1], L = M[2];
      return h(D, _[N][L]);
    };
    if (_.mode === "light" && (_e(_.common, "background", "#fff"), _e(_.common, "onBackground", "#000")), _.mode === "dark" && (_e(_.common, "background", "#000"), _e(_.common, "onBackground", "#fff")), Kre(_, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), _.mode === "light") {
      _e(_.Alert, "errorColor", un(_.error.light, 0.6)), _e(_.Alert, "infoColor", un(_.info.light, 0.6)), _e(_.Alert, "successColor", un(_.success.light, 0.6)), _e(_.Alert, "warningColor", un(_.warning.light, 0.6)), _e(_.Alert, "errorFilledBg", A("palette-error-main")), _e(_.Alert, "infoFilledBg", A("palette-info-main")), _e(_.Alert, "successFilledBg", A("palette-success-main")), _e(_.Alert, "warningFilledBg", A("palette-warning-main")), _e(_.Alert, "errorFilledColor", Ii(() => _.getContrastText(_.error.main))), _e(_.Alert, "infoFilledColor", Ii(() => _.getContrastText(_.info.main))), _e(_.Alert, "successFilledColor", Ii(() => _.getContrastText(_.success.main))), _e(_.Alert, "warningFilledColor", Ii(() => _.getContrastText(_.warning.main))), _e(_.Alert, "errorStandardBg", dn(_.error.light, 0.9)), _e(_.Alert, "infoStandardBg", dn(_.info.light, 0.9)), _e(_.Alert, "successStandardBg", dn(_.success.light, 0.9)), _e(_.Alert, "warningStandardBg", dn(_.warning.light, 0.9)), _e(_.Alert, "errorIconColor", A("palette-error-main")), _e(_.Alert, "infoIconColor", A("palette-info-main")), _e(_.Alert, "successIconColor", A("palette-success-main")), _e(_.Alert, "warningIconColor", A("palette-warning-main")), _e(_.AppBar, "defaultBg", A("palette-grey-100")), _e(_.Avatar, "defaultBg", A("palette-grey-400")), _e(_.Button, "inheritContainedBg", A("palette-grey-300")), _e(_.Button, "inheritContainedHoverBg", A("palette-grey-A100")), _e(_.Chip, "defaultBorder", A("palette-grey-400")), _e(_.Chip, "defaultAvatarColor", A("palette-grey-700")), _e(_.Chip, "defaultIconColor", A("palette-grey-700")), _e(_.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), _e(_.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), _e(_.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), _e(_.LinearProgress, "primaryBg", dn(_.primary.main, 0.62)), _e(_.LinearProgress, "secondaryBg", dn(_.secondary.main, 0.62)), _e(_.LinearProgress, "errorBg", dn(_.error.main, 0.62)), _e(_.LinearProgress, "infoBg", dn(_.info.main, 0.62)), _e(_.LinearProgress, "successBg", dn(_.success.main, 0.62)), _e(_.LinearProgress, "warningBg", dn(_.warning.main, 0.62)), _e(_.Skeleton, "bg", `rgba(${A("palette-text-primaryChannel")} / 0.11)`), _e(_.Slider, "primaryTrack", dn(_.primary.main, 0.62)), _e(_.Slider, "secondaryTrack", dn(_.secondary.main, 0.62)), _e(_.Slider, "errorTrack", dn(_.error.main, 0.62)), _e(_.Slider, "infoTrack", dn(_.info.main, 0.62)), _e(_.Slider, "successTrack", dn(_.success.main, 0.62)), _e(_.Slider, "warningTrack", dn(_.warning.main, 0.62));
      const D = Vh(_.background.default, 0.8);
      _e(_.SnackbarContent, "bg", D), _e(_.SnackbarContent, "color", Ii(() => _.getContrastText(D))), _e(_.SpeedDialAction, "fabHoverBg", Vh(_.background.paper, 0.15)), _e(_.StepConnector, "border", A("palette-grey-400")), _e(_.StepContent, "border", A("palette-grey-400")), _e(_.Switch, "defaultColor", A("palette-common-white")), _e(_.Switch, "defaultDisabledColor", A("palette-grey-100")), _e(_.Switch, "primaryDisabledColor", dn(_.primary.main, 0.62)), _e(_.Switch, "secondaryDisabledColor", dn(_.secondary.main, 0.62)), _e(_.Switch, "errorDisabledColor", dn(_.error.main, 0.62)), _e(_.Switch, "infoDisabledColor", dn(_.info.main, 0.62)), _e(_.Switch, "successDisabledColor", dn(_.success.main, 0.62)), _e(_.Switch, "warningDisabledColor", dn(_.warning.main, 0.62)), _e(_.TableCell, "border", dn(Hh(_.divider, 1), 0.88)), _e(_.Tooltip, "bg", Hh(_.grey[700], 0.92));
    }
    if (_.mode === "dark") {
      _e(_.Alert, "errorColor", dn(_.error.light, 0.6)), _e(_.Alert, "infoColor", dn(_.info.light, 0.6)), _e(_.Alert, "successColor", dn(_.success.light, 0.6)), _e(_.Alert, "warningColor", dn(_.warning.light, 0.6)), _e(_.Alert, "errorFilledBg", A("palette-error-dark")), _e(_.Alert, "infoFilledBg", A("palette-info-dark")), _e(_.Alert, "successFilledBg", A("palette-success-dark")), _e(_.Alert, "warningFilledBg", A("palette-warning-dark")), _e(_.Alert, "errorFilledColor", Ii(() => _.getContrastText(_.error.dark))), _e(_.Alert, "infoFilledColor", Ii(() => _.getContrastText(_.info.dark))), _e(_.Alert, "successFilledColor", Ii(() => _.getContrastText(_.success.dark))), _e(_.Alert, "warningFilledColor", Ii(() => _.getContrastText(_.warning.dark))), _e(_.Alert, "errorStandardBg", un(_.error.light, 0.9)), _e(_.Alert, "infoStandardBg", un(_.info.light, 0.9)), _e(_.Alert, "successStandardBg", un(_.success.light, 0.9)), _e(_.Alert, "warningStandardBg", un(_.warning.light, 0.9)), _e(_.Alert, "errorIconColor", A("palette-error-main")), _e(_.Alert, "infoIconColor", A("palette-info-main")), _e(_.Alert, "successIconColor", A("palette-success-main")), _e(_.Alert, "warningIconColor", A("palette-warning-main")), _e(_.AppBar, "defaultBg", A("palette-grey-900")), _e(_.AppBar, "darkBg", A("palette-background-paper")), _e(_.AppBar, "darkColor", A("palette-text-primary")), _e(_.Avatar, "defaultBg", A("palette-grey-600")), _e(_.Button, "inheritContainedBg", A("palette-grey-800")), _e(_.Button, "inheritContainedHoverBg", A("palette-grey-700")), _e(_.Chip, "defaultBorder", A("palette-grey-700")), _e(_.Chip, "defaultAvatarColor", A("palette-grey-300")), _e(_.Chip, "defaultIconColor", A("palette-grey-300")), _e(_.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), _e(_.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), _e(_.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), _e(_.LinearProgress, "primaryBg", un(_.primary.main, 0.5)), _e(_.LinearProgress, "secondaryBg", un(_.secondary.main, 0.5)), _e(_.LinearProgress, "errorBg", un(_.error.main, 0.5)), _e(_.LinearProgress, "infoBg", un(_.info.main, 0.5)), _e(_.LinearProgress, "successBg", un(_.success.main, 0.5)), _e(_.LinearProgress, "warningBg", un(_.warning.main, 0.5)), _e(_.Skeleton, "bg", `rgba(${A("palette-text-primaryChannel")} / 0.13)`), _e(_.Slider, "primaryTrack", un(_.primary.main, 0.5)), _e(_.Slider, "secondaryTrack", un(_.secondary.main, 0.5)), _e(_.Slider, "errorTrack", un(_.error.main, 0.5)), _e(_.Slider, "infoTrack", un(_.info.main, 0.5)), _e(_.Slider, "successTrack", un(_.success.main, 0.5)), _e(_.Slider, "warningTrack", un(_.warning.main, 0.5));
      const D = Vh(_.background.default, 0.98);
      _e(_.SnackbarContent, "bg", D), _e(_.SnackbarContent, "color", Ii(() => _.getContrastText(D))), _e(_.SpeedDialAction, "fabHoverBg", Vh(_.background.paper, 0.15)), _e(_.StepConnector, "border", A("palette-grey-600")), _e(_.StepContent, "border", A("palette-grey-600")), _e(_.Switch, "defaultColor", A("palette-grey-300")), _e(_.Switch, "defaultDisabledColor", A("palette-grey-600")), _e(_.Switch, "primaryDisabledColor", un(_.primary.main, 0.55)), _e(_.Switch, "secondaryDisabledColor", un(_.secondary.main, 0.55)), _e(_.Switch, "errorDisabledColor", un(_.error.main, 0.55)), _e(_.Switch, "infoDisabledColor", un(_.info.main, 0.55)), _e(_.Switch, "successDisabledColor", un(_.success.main, 0.55)), _e(_.Switch, "warningDisabledColor", un(_.warning.main, 0.55)), _e(_.TableCell, "border", un(Hh(_.divider, 1), 0.68)), _e(_.Tooltip, "bg", Hh(_.grey[700], 0.92));
    }
    Ta(_.background, "default"), Ta(_.background, "paper"), Ta(_.common, "background"), Ta(_.common, "onBackground"), Ta(_, "divider"), Object.keys(_).forEach((D) => {
      const M = _[D];
      D !== "tonalOffset" && M && typeof M == "object" && (M.main && _e(_[D], "mainChannel", tf(nf(M.main))), M.light && _e(_[D], "lightChannel", tf(nf(M.light))), M.dark && _e(_[D], "darkChannel", tf(nf(M.dark))), M.contrastText && _e(_[D], "contrastTextChannel", tf(nf(M.contrastText))), D === "text" && (Ta(_[D], "primary"), Ta(_[D], "secondary")), D === "action" && (M.active && Ta(_[D], "active"), M.selected && Ta(_[D], "selected")));
    });
  }), O = t.reduce((P, _) => or(P, _), O);
  const C = {
    prefix: i,
    disableCssColorScheme: o,
    shouldSkipGeneratingVar: a,
    getSelector: Gre(O)
  }, {
    vars: T,
    generateThemeVars: k,
    generateStyleSheets: I
  } = ere(O, C);
  return O.vars = T, Object.entries(O.colorSchemes[O.defaultColorScheme]).forEach(([P, _]) => {
    O[P] = _;
  }), O.generateThemeVars = k, O.generateStyleSheets = I, O.generateSpacing = function() {
    return B7(u.spacing, K0(this));
  }, O.getColorSchemeSelector = tre(c), O.spacing = O.generateSpacing(), O.shouldSkipGeneratingVar = a, O.unstable_sxConfig = {
    ...Sp,
    ...u == null ? void 0 : u.unstable_sxConfig
  }, O.unstable_sx = function(_) {
    return Ls({
      sx: _,
      theme: this
    });
  }, O.toRuntimeSource = bL, O;
}
function NP(e, t, n) {
  e.colorSchemes && n && (e.colorSchemes[t] = {
    ...n !== !0 && n,
    palette: hT({
      ...n === !0 ? {} : n.palette,
      mode: t
    })
    // cast type to skip module augmentation test
  });
}
function mT(e = {}, ...t) {
  const {
    palette: n,
    cssVariables: r = !1,
    colorSchemes: o = n ? void 0 : {
      light: !0
    },
    defaultColorScheme: i = n == null ? void 0 : n.mode,
    ...a
  } = e, c = i || "light", l = o == null ? void 0 : o[c], u = {
    ...o,
    ...n ? {
      [c]: {
        ...typeof l != "boolean" && l,
        palette: n
      }
    } : void 0
  };
  if (r === !1) {
    if (!("colorSchemes" in e))
      return JO(e, ...t);
    let d = n;
    "palette" in e || u[c] && (u[c] !== !0 ? d = u[c].palette : c === "dark" && (d = {
      mode: "dark"
    }));
    const f = JO({
      ...e,
      palette: d
    }, ...t);
    return f.defaultColorScheme = c, f.colorSchemes = u, f.palette.mode === "light" && (f.colorSchemes.light = {
      ...u.light !== !0 && u.light,
      palette: f.palette
    }, NP(f, "dark", u.dark)), f.palette.mode === "dark" && (f.colorSchemes.dark = {
      ...u.dark !== !0 && u.dark,
      palette: f.palette
    }, NP(f, "light", u.light)), f;
  }
  return !n && !("light" in u) && c === "light" && (u.light = !0), Jre({
    ...a,
    colorSchemes: u,
    defaultColorScheme: c,
    ...typeof r != "boolean" && r
  }, ...t);
}
function Qre(e) {
  return String(e).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function eoe(e) {
  return parseFloat(e);
}
const iv = mT();
function Fr() {
  const e = Tp(iv);
  return process.env.NODE_ENV !== "production" && E.useDebugValue(e), e[Xo] || e;
}
function Ga({
  props: e,
  name: t
}) {
  return oT({
    props: e,
    name: t,
    defaultTheme: iv,
    themeId: Xo
  });
}
function av(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const ar = (e) => av(e) && e !== "classes", Pe = G7({
  themeId: Xo,
  defaultTheme: iv,
  rootShouldForwardProp: ar
});
function DP({
  theme: e,
  ...t
}) {
  const n = Xo in e ? e[Xo] : void 0;
  return /* @__PURE__ */ F.jsx(Ff, {
    ...t,
    themeId: n ? Xo : void 0,
    theme: n || e
  });
}
const Yh = {
  attribute: "data-mui-color-scheme",
  colorSchemeStorageKey: "mui-color-scheme",
  defaultLightColorScheme: "light",
  defaultDarkColorScheme: "dark",
  modeStorageKey: "mui-mode"
}, {
  CssVarsProvider: toe,
  useColorScheme: SIe,
  getInitColorSchemeScript: CIe
} = Xne({
  themeId: Xo,
  // @ts-ignore ignore module augmentation tests
  theme: () => mT({
    cssVariables: !0
  }),
  colorSchemeStorageKey: Yh.colorSchemeStorageKey,
  modeStorageKey: Yh.modeStorageKey,
  defaultColorScheme: {
    light: Yh.defaultLightColorScheme,
    dark: Yh.defaultDarkColorScheme
  },
  resolveTheme: (e) => {
    const t = {
      ...e,
      typography: yL(e.palette, e.typography)
    };
    return t.unstable_sx = function(r) {
      return Ls({
        sx: r,
        theme: this
      });
    }, t;
  }
}), noe = toe;
function TIe({
  theme: e,
  ...t
}) {
  return typeof e == "function" ? /* @__PURE__ */ F.jsx(DP, {
    theme: e,
    ...t
  }) : "colorSchemes" in (Xo in e ? e[Xo] : e) ? /* @__PURE__ */ F.jsx(noe, {
    theme: e,
    ...t
  }) : /* @__PURE__ */ F.jsx(DP, {
    theme: e,
    ...t
  });
}
function $L(e) {
  return /* @__PURE__ */ F.jsx(q7, {
    ...e,
    defaultTheme: iv,
    themeId: Xo
  });
}
process.env.NODE_ENV !== "production" && ($L.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: s.oneOfType([s.array, s.func, s.number, s.object, s.string, s.bool])
});
function gT(e) {
  return function(n) {
    return (
      // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
      /* @__PURE__ */ F.jsx($L, {
        styles: typeof e == "function" ? (r) => e({
          theme: r,
          ...n
        }) : e
      })
    );
  };
}
function roe() {
  return tv;
}
const ct = Wne;
process.env.NODE_ENV !== "production" && (s.node, s.object.isRequired);
function $t(e) {
  return Une(e);
}
function ooe(e) {
  return mt("MuiSvgIcon", e);
}
gt("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const ioe = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: r
  } = e, o = {
    root: ["root", t !== "inherit" && `color${Le(t)}`, `fontSize${Le(n)}`]
  };
  return wt(o, ooe, r);
}, aoe = Pe("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${Le(n.color)}`], t[`fontSize${Le(n.fontSize)}`]];
  }
})(ct(({
  theme: e
}) => {
  var t, n, r, o, i, a, c, l, u, d, f, h, v, y;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    flexShrink: 0,
    transition: (o = (t = e.transitions) == null ? void 0 : t.create) == null ? void 0 : o.call(t, "fill", {
      duration: (r = (n = (e.vars ?? e).transitions) == null ? void 0 : n.duration) == null ? void 0 : r.shorter
    }),
    variants: [
      {
        props: (g) => !g.hasSvgAsChild,
        style: {
          // the <svg> will define the property that has `currentColor`
          // for example heroicons uses fill="none" and stroke="currentColor"
          fill: "currentColor"
        }
      },
      {
        props: {
          fontSize: "inherit"
        },
        style: {
          fontSize: "inherit"
        }
      },
      {
        props: {
          fontSize: "small"
        },
        style: {
          fontSize: ((a = (i = e.typography) == null ? void 0 : i.pxToRem) == null ? void 0 : a.call(i, 20)) || "1.25rem"
        }
      },
      {
        props: {
          fontSize: "medium"
        },
        style: {
          fontSize: ((l = (c = e.typography) == null ? void 0 : c.pxToRem) == null ? void 0 : l.call(c, 24)) || "1.5rem"
        }
      },
      {
        props: {
          fontSize: "large"
        },
        style: {
          fontSize: ((d = (u = e.typography) == null ? void 0 : u.pxToRem) == null ? void 0 : d.call(u, 35)) || "2.1875rem"
        }
      },
      // TODO v5 deprecate color prop, v6 remove for sx
      ...Object.entries((e.vars ?? e).palette).filter(([, g]) => g && g.main).map(([g]) => {
        var b, x;
        return {
          props: {
            color: g
          },
          style: {
            color: (x = (b = (e.vars ?? e).palette) == null ? void 0 : b[g]) == null ? void 0 : x.main
          }
        };
      }),
      {
        props: {
          color: "action"
        },
        style: {
          color: (h = (f = (e.vars ?? e).palette) == null ? void 0 : f.action) == null ? void 0 : h.active
        }
      },
      {
        props: {
          color: "disabled"
        },
        style: {
          color: (y = (v = (e.vars ?? e).palette) == null ? void 0 : v.action) == null ? void 0 : y.disabled
        }
      },
      {
        props: {
          color: "inherit"
        },
        style: {
          color: void 0
        }
      }
    ]
  };
})), zf = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: o,
    className: i,
    color: a = "inherit",
    component: c = "svg",
    fontSize: l = "medium",
    htmlColor: u,
    inheritViewBox: d = !1,
    titleAccess: f,
    viewBox: h = "0 0 24 24",
    ...v
  } = r, y = /* @__PURE__ */ E.isValidElement(o) && o.type === "svg", g = {
    ...r,
    color: a,
    component: c,
    fontSize: l,
    instanceFontSize: t.fontSize,
    inheritViewBox: d,
    viewBox: h,
    hasSvgAsChild: y
  }, b = {};
  d || (b.viewBox = h);
  const x = ioe(g);
  return /* @__PURE__ */ F.jsxs(aoe, {
    as: c,
    className: Ge(x.root, i),
    focusable: "false",
    color: u,
    "aria-hidden": f ? void 0 : !0,
    role: f ? "img" : void 0,
    ref: n,
    ...b,
    ...v,
    ...y && o.props,
    ownerState: g,
    children: [y ? o.props.children : o, f ? /* @__PURE__ */ F.jsx("title", {
      children: f
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (zf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: s.oneOfType([s.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: s.oneOfType([s.oneOf(["inherit", "large", "medium", "small"]), s.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: s.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: s.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: s.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: s.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: s.string
});
zf && (zf.muiName = "SvgIcon");
function Oi(e, t) {
  function n(r, o) {
    return /* @__PURE__ */ F.jsx(zf, {
      "data-testid": `${t}Icon`,
      ref: o,
      ...r,
      children: e
    });
  }
  return process.env.NODE_ENV !== "production" && (n.displayName = `${t}Icon`), n.muiName = zf.muiName, /* @__PURE__ */ E.memo(/* @__PURE__ */ E.forwardRef(n));
}
var Gh = { exports: {} }, on = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var LP;
function soe() {
  if (LP) return on;
  LP = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.consumer"), a = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), v = Symbol.for("react.client.reference");
  function y(g) {
    if (typeof g == "object" && g !== null) {
      var b = g.$$typeof;
      switch (b) {
        case e:
          switch (g = g.type, g) {
            case n:
            case o:
            case r:
            case l:
            case u:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case a:
                case c:
                case f:
                case d:
                  return g;
                case i:
                  return g;
                default:
                  return b;
              }
          }
        case t:
          return b;
      }
    }
  }
  return on.ContextConsumer = i, on.ContextProvider = a, on.Element = e, on.ForwardRef = c, on.Fragment = n, on.Lazy = f, on.Memo = d, on.Portal = t, on.Profiler = o, on.StrictMode = r, on.Suspense = l, on.SuspenseList = u, on.isContextConsumer = function(g) {
    return y(g) === i;
  }, on.isContextProvider = function(g) {
    return y(g) === a;
  }, on.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === e;
  }, on.isForwardRef = function(g) {
    return y(g) === c;
  }, on.isFragment = function(g) {
    return y(g) === n;
  }, on.isLazy = function(g) {
    return y(g) === f;
  }, on.isMemo = function(g) {
    return y(g) === d;
  }, on.isPortal = function(g) {
    return y(g) === t;
  }, on.isProfiler = function(g) {
    return y(g) === o;
  }, on.isStrictMode = function(g) {
    return y(g) === r;
  }, on.isSuspense = function(g) {
    return y(g) === l;
  }, on.isSuspenseList = function(g) {
    return y(g) === u;
  }, on.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === n || g === o || g === r || g === l || g === u || g === h || typeof g == "object" && g !== null && (g.$$typeof === f || g.$$typeof === d || g.$$typeof === a || g.$$typeof === i || g.$$typeof === c || g.$$typeof === v || g.getModuleId !== void 0);
  }, on.typeOf = y, on;
}
var an = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jP;
function coe() {
  return jP || (jP = 1, process.env.NODE_ENV !== "production" && function() {
    function e(g) {
      if (typeof g == "object" && g !== null) {
        var b = g.$$typeof;
        switch (b) {
          case t:
            switch (g = g.type, g) {
              case r:
              case i:
              case o:
              case u:
              case d:
                return g;
              default:
                switch (g = g && g.$$typeof, g) {
                  case c:
                  case l:
                  case h:
                  case f:
                    return g;
                  case a:
                    return g;
                  default:
                    return b;
                }
            }
          case n:
            return b;
        }
      }
    }
    var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.consumer"), c = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), y = Symbol.for("react.client.reference");
    an.ContextConsumer = a, an.ContextProvider = c, an.Element = t, an.ForwardRef = l, an.Fragment = r, an.Lazy = h, an.Memo = f, an.Portal = n, an.Profiler = i, an.StrictMode = o, an.Suspense = u, an.SuspenseList = d, an.isContextConsumer = function(g) {
      return e(g) === a;
    }, an.isContextProvider = function(g) {
      return e(g) === c;
    }, an.isElement = function(g) {
      return typeof g == "object" && g !== null && g.$$typeof === t;
    }, an.isForwardRef = function(g) {
      return e(g) === l;
    }, an.isFragment = function(g) {
      return e(g) === r;
    }, an.isLazy = function(g) {
      return e(g) === h;
    }, an.isMemo = function(g) {
      return e(g) === f;
    }, an.isPortal = function(g) {
      return e(g) === n;
    }, an.isProfiler = function(g) {
      return e(g) === i;
    }, an.isStrictMode = function(g) {
      return e(g) === o;
    }, an.isSuspense = function(g) {
      return e(g) === u;
    }, an.isSuspenseList = function(g) {
      return e(g) === d;
    }, an.isValidElementType = function(g) {
      return typeof g == "string" || typeof g == "function" || g === r || g === i || g === o || g === u || g === d || g === v || typeof g == "object" && g !== null && (g.$$typeof === h || g.$$typeof === f || g.$$typeof === c || g.$$typeof === a || g.$$typeof === l || g.$$typeof === y || g.getModuleId !== void 0);
    }, an.typeOf = e;
  }()), an;
}
var FP;
function loe() {
  return FP || (FP = 1, process.env.NODE_ENV === "production" ? Gh.exports = /* @__PURE__ */ soe() : Gh.exports = /* @__PURE__ */ coe()), Gh.exports;
}
var sv = /* @__PURE__ */ loe();
function OL(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
function eS(e, t) {
  return eS = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, eS(e, t);
}
function SL(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, eS(e, t);
}
var Kh = { exports: {} }, xr = {};
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zP;
function uoe() {
  if (zP) return xr;
  zP = 1;
  var e = ye;
  function t(l) {
    var u = "https://react.dev/errors/" + l;
    if (1 < arguments.length) {
      u += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var d = 2; d < arguments.length; d++)
        u += "&args[]=" + encodeURIComponent(arguments[d]);
    }
    return "Minified React error #" + l + "; visit " + u + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function n() {
  }
  var r = {
    d: {
      f: n,
      r: function() {
        throw Error(t(522));
      },
      D: n,
      C: n,
      L: n,
      m: n,
      X: n,
      S: n,
      M: n
    },
    p: 0,
    findDOMNode: null
  }, o = Symbol.for("react.portal");
  function i(l, u, d) {
    var f = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: o,
      key: f == null ? null : "" + f,
      children: l,
      containerInfo: u,
      implementation: d
    };
  }
  var a = e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function c(l, u) {
    if (l === "font") return "";
    if (typeof u == "string")
      return u === "use-credentials" ? u : "";
  }
  return xr.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = r, xr.createPortal = function(l, u) {
    var d = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!u || u.nodeType !== 1 && u.nodeType !== 9 && u.nodeType !== 11)
      throw Error(t(299));
    return i(l, u, null, d);
  }, xr.flushSync = function(l) {
    var u = a.T, d = r.p;
    try {
      if (a.T = null, r.p = 2, l) return l();
    } finally {
      a.T = u, r.p = d, r.d.f();
    }
  }, xr.preconnect = function(l, u) {
    typeof l == "string" && (u ? (u = u.crossOrigin, u = typeof u == "string" ? u === "use-credentials" ? u : "" : void 0) : u = null, r.d.C(l, u));
  }, xr.prefetchDNS = function(l) {
    typeof l == "string" && r.d.D(l);
  }, xr.preinit = function(l, u) {
    if (typeof l == "string" && u && typeof u.as == "string") {
      var d = u.as, f = c(d, u.crossOrigin), h = typeof u.integrity == "string" ? u.integrity : void 0, v = typeof u.fetchPriority == "string" ? u.fetchPriority : void 0;
      d === "style" ? r.d.S(
        l,
        typeof u.precedence == "string" ? u.precedence : void 0,
        {
          crossOrigin: f,
          integrity: h,
          fetchPriority: v
        }
      ) : d === "script" && r.d.X(l, {
        crossOrigin: f,
        integrity: h,
        fetchPriority: v,
        nonce: typeof u.nonce == "string" ? u.nonce : void 0
      });
    }
  }, xr.preinitModule = function(l, u) {
    if (typeof l == "string")
      if (typeof u == "object" && u !== null) {
        if (u.as == null || u.as === "script") {
          var d = c(
            u.as,
            u.crossOrigin
          );
          r.d.M(l, {
            crossOrigin: d,
            integrity: typeof u.integrity == "string" ? u.integrity : void 0,
            nonce: typeof u.nonce == "string" ? u.nonce : void 0
          });
        }
      } else u == null && r.d.M(l);
  }, xr.preload = function(l, u) {
    if (typeof l == "string" && typeof u == "object" && u !== null && typeof u.as == "string") {
      var d = u.as, f = c(d, u.crossOrigin);
      r.d.L(l, d, {
        crossOrigin: f,
        integrity: typeof u.integrity == "string" ? u.integrity : void 0,
        nonce: typeof u.nonce == "string" ? u.nonce : void 0,
        type: typeof u.type == "string" ? u.type : void 0,
        fetchPriority: typeof u.fetchPriority == "string" ? u.fetchPriority : void 0,
        referrerPolicy: typeof u.referrerPolicy == "string" ? u.referrerPolicy : void 0,
        imageSrcSet: typeof u.imageSrcSet == "string" ? u.imageSrcSet : void 0,
        imageSizes: typeof u.imageSizes == "string" ? u.imageSizes : void 0,
        media: typeof u.media == "string" ? u.media : void 0
      });
    }
  }, xr.preloadModule = function(l, u) {
    if (typeof l == "string")
      if (u) {
        var d = c(u.as, u.crossOrigin);
        r.d.m(l, {
          as: typeof u.as == "string" && u.as !== "script" ? u.as : void 0,
          crossOrigin: d,
          integrity: typeof u.integrity == "string" ? u.integrity : void 0
        });
      } else r.d.m(l);
  }, xr.requestFormReset = function(l) {
    r.d.r(l);
  }, xr.unstable_batchedUpdates = function(l, u) {
    return l(u);
  }, xr.useFormState = function(l, u, d) {
    return a.H.useFormState(l, u, d);
  }, xr.useFormStatus = function() {
    return a.H.useHostTransitionStatus();
  }, xr.version = "19.0.0", xr;
}
var wr = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var BP;
function doe() {
  return BP || (BP = 1, process.env.NODE_ENV !== "production" && function() {
    function e() {
    }
    function t(f) {
      return "" + f;
    }
    function n(f, h, v) {
      var y = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
      try {
        t(y);
        var g = !1;
      } catch {
        g = !0;
      }
      return g && (console.error(
        "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
        typeof Symbol == "function" && Symbol.toStringTag && y[Symbol.toStringTag] || y.constructor.name || "Object"
      ), t(y)), {
        $$typeof: u,
        key: y == null ? null : "" + y,
        children: f,
        containerInfo: h,
        implementation: v
      };
    }
    function r(f, h) {
      if (f === "font") return "";
      if (typeof h == "string")
        return h === "use-credentials" ? h : "";
    }
    function o(f) {
      return f === null ? "`null`" : f === void 0 ? "`undefined`" : f === "" ? "an empty string" : 'something with type "' + typeof f + '"';
    }
    function i(f) {
      return f === null ? "`null`" : f === void 0 ? "`undefined`" : f === "" ? "an empty string" : typeof f == "string" ? JSON.stringify(f) : typeof f == "number" ? "`" + f + "`" : 'something with type "' + typeof f + '"';
    }
    function a() {
      var f = d.H;
      return f === null && console.error(
        `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
      ), f;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var c = ye, l = {
      d: {
        f: e,
        r: function() {
          throw Error(
            "Invalid form element. requestFormReset must be passed a form that was rendered by React."
          );
        },
        D: e,
        C: e,
        L: e,
        m: e,
        X: e,
        S: e,
        M: e
      },
      p: 0,
      findDOMNode: null
    }, u = Symbol.for("react.portal"), d = c.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    typeof Map == "function" && Map.prototype != null && typeof Map.prototype.forEach == "function" && typeof Set == "function" && Set.prototype != null && typeof Set.prototype.clear == "function" && typeof Set.prototype.forEach == "function" || console.error(
      "React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"
    ), wr.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = l, wr.createPortal = function(f, h) {
      var v = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
      if (!h || h.nodeType !== 1 && h.nodeType !== 9 && h.nodeType !== 11)
        throw Error("Target container is not a DOM element.");
      return n(f, h, null, v);
    }, wr.flushSync = function(f) {
      var h = d.T, v = l.p;
      try {
        if (d.T = null, l.p = 2, f)
          return f();
      } finally {
        d.T = h, l.p = v, l.d.f() && console.error(
          "flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."
        );
      }
    }, wr.preconnect = function(f, h) {
      typeof f == "string" && f ? h != null && typeof h != "object" ? console.error(
        "ReactDOM.preconnect(): Expected the `options` argument (second) to be an object but encountered %s instead. The only supported option at this time is `crossOrigin` which accepts a string.",
        i(h)
      ) : h != null && typeof h.crossOrigin != "string" && console.error(
        "ReactDOM.preconnect(): Expected the `crossOrigin` option (second argument) to be a string but encountered %s instead. Try removing this option or passing a string value instead.",
        o(h.crossOrigin)
      ) : console.error(
        "ReactDOM.preconnect(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
        o(f)
      ), typeof f == "string" && (h ? (h = h.crossOrigin, h = typeof h == "string" ? h === "use-credentials" ? h : "" : void 0) : h = null, l.d.C(f, h));
    }, wr.prefetchDNS = function(f) {
      if (typeof f != "string" || !f)
        console.error(
          "ReactDOM.prefetchDNS(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
          o(f)
        );
      else if (1 < arguments.length) {
        var h = arguments[1];
        typeof h == "object" && h.hasOwnProperty("crossOrigin") ? console.error(
          "ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. It looks like the you are attempting to set a crossOrigin property for this DNS lookup hint. Browsers do not perform DNS queries using CORS and setting this attribute on the resource hint has no effect. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.",
          i(h)
        ) : console.error(
          "ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.",
          i(h)
        );
      }
      typeof f == "string" && l.d.D(f);
    }, wr.preinit = function(f, h) {
      if (typeof f == "string" && f ? h == null || typeof h != "object" ? console.error(
        "ReactDOM.preinit(): Expected the `options` argument (second) to be an object with an `as` property describing the type of resource to be preinitialized but encountered %s instead.",
        i(h)
      ) : h.as !== "style" && h.as !== "script" && console.error(
        'ReactDOM.preinit(): Expected the `as` property in the `options` argument (second) to contain a valid value describing the type of resource to be preinitialized but encountered %s instead. Valid values for `as` are "style" and "script".',
        i(h.as)
      ) : console.error(
        "ReactDOM.preinit(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
        o(f)
      ), typeof f == "string" && h && typeof h.as == "string") {
        var v = h.as, y = r(v, h.crossOrigin), g = typeof h.integrity == "string" ? h.integrity : void 0, b = typeof h.fetchPriority == "string" ? h.fetchPriority : void 0;
        v === "style" ? l.d.S(
          f,
          typeof h.precedence == "string" ? h.precedence : void 0,
          {
            crossOrigin: y,
            integrity: g,
            fetchPriority: b
          }
        ) : v === "script" && l.d.X(f, {
          crossOrigin: y,
          integrity: g,
          fetchPriority: b,
          nonce: typeof h.nonce == "string" ? h.nonce : void 0
        });
      }
    }, wr.preinitModule = function(f, h) {
      var v = "";
      if (typeof f == "string" && f || (v += " The `href` argument encountered was " + o(f) + "."), h !== void 0 && typeof h != "object" ? v += " The `options` argument encountered was " + o(h) + "." : h && "as" in h && h.as !== "script" && (v += " The `as` option encountered was " + i(h.as) + "."), v)
        console.error(
          "ReactDOM.preinitModule(): Expected up to two arguments, a non-empty `href` string and, optionally, an `options` object with a valid `as` property.%s",
          v
        );
      else
        switch (v = h && typeof h.as == "string" ? h.as : "script", v) {
          case "script":
            break;
          default:
            v = i(v), console.error(
              'ReactDOM.preinitModule(): Currently the only supported "as" type for this function is "script" but received "%s" instead. This warning was generated for `href` "%s". In the future other module types will be supported, aligning with the import-attributes proposal. Learn more here: (https://github.com/tc39/proposal-import-attributes)',
              v,
              f
            );
        }
      typeof f == "string" && (typeof h == "object" && h !== null ? (h.as == null || h.as === "script") && (v = r(
        h.as,
        h.crossOrigin
      ), l.d.M(f, {
        crossOrigin: v,
        integrity: typeof h.integrity == "string" ? h.integrity : void 0,
        nonce: typeof h.nonce == "string" ? h.nonce : void 0
      })) : h == null && l.d.M(f));
    }, wr.preload = function(f, h) {
      var v = "";
      if (typeof f == "string" && f || (v += " The `href` argument encountered was " + o(f) + "."), h == null || typeof h != "object" ? v += " The `options` argument encountered was " + o(h) + "." : typeof h.as == "string" && h.as || (v += " The `as` option encountered was " + o(h.as) + "."), v && console.error(
        'ReactDOM.preload(): Expected two arguments, a non-empty `href` string and an `options` object with an `as` property valid for a `<link rel="preload" as="..." />` tag.%s',
        v
      ), typeof f == "string" && typeof h == "object" && h !== null && typeof h.as == "string") {
        v = h.as;
        var y = r(
          v,
          h.crossOrigin
        );
        l.d.L(f, v, {
          crossOrigin: y,
          integrity: typeof h.integrity == "string" ? h.integrity : void 0,
          nonce: typeof h.nonce == "string" ? h.nonce : void 0,
          type: typeof h.type == "string" ? h.type : void 0,
          fetchPriority: typeof h.fetchPriority == "string" ? h.fetchPriority : void 0,
          referrerPolicy: typeof h.referrerPolicy == "string" ? h.referrerPolicy : void 0,
          imageSrcSet: typeof h.imageSrcSet == "string" ? h.imageSrcSet : void 0,
          imageSizes: typeof h.imageSizes == "string" ? h.imageSizes : void 0,
          media: typeof h.media == "string" ? h.media : void 0
        });
      }
    }, wr.preloadModule = function(f, h) {
      var v = "";
      typeof f == "string" && f || (v += " The `href` argument encountered was " + o(f) + "."), h !== void 0 && typeof h != "object" ? v += " The `options` argument encountered was " + o(h) + "." : h && "as" in h && typeof h.as != "string" && (v += " The `as` option encountered was " + o(h.as) + "."), v && console.error(
        'ReactDOM.preloadModule(): Expected two arguments, a non-empty `href` string and, optionally, an `options` object with an `as` property valid for a `<link rel="modulepreload" as="..." />` tag.%s',
        v
      ), typeof f == "string" && (h ? (v = r(
        h.as,
        h.crossOrigin
      ), l.d.m(f, {
        as: typeof h.as == "string" && h.as !== "script" ? h.as : void 0,
        crossOrigin: v,
        integrity: typeof h.integrity == "string" ? h.integrity : void 0
      })) : l.d.m(f));
    }, wr.requestFormReset = function(f) {
      l.d.r(f);
    }, wr.unstable_batchedUpdates = function(f, h) {
      return f(h);
    }, wr.useFormState = function(f, h, v) {
      return a().useFormState(f, h, v);
    }, wr.useFormStatus = function() {
      return a().useHostTransitionStatus();
    }, wr.version = "19.0.0", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), wr;
}
var qP;
function foe() {
  if (qP) return Kh.exports;
  qP = 1;
  function e() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
      } catch (t) {
        console.error(t);
      }
    }
  }
  return process.env.NODE_ENV === "production" ? (e(), Kh.exports = uoe()) : Kh.exports = doe(), Kh.exports;
}
var nl = foe();
const Xh = /* @__PURE__ */ jn(nl), UP = {
  disabled: !1
};
var poe = process.env.NODE_ENV !== "production" ? s.oneOfType([s.number, s.shape({
  enter: s.number,
  exit: s.number,
  appear: s.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && s.oneOfType([s.string, s.shape({
  enter: s.string,
  exit: s.string,
  active: s.string
}), s.shape({
  enter: s.string,
  enterDone: s.string,
  enterActive: s.string,
  exit: s.string,
  exitDone: s.string,
  exitActive: s.string
})]);
const Ag = ye.createContext(null);
var hoe = function(t) {
  return t.scrollTop;
}, rf = "unmounted", mc = "exited", gc = "entering", tu = "entered", tS = "exiting", Si = /* @__PURE__ */ function(e) {
  SL(t, e);
  function t(r, o) {
    var i;
    i = e.call(this, r, o) || this;
    var a = o, c = a && !a.isMounting ? r.enter : r.appear, l;
    return i.appearStatus = null, r.in ? c ? (l = mc, i.appearStatus = gc) : l = tu : r.unmountOnExit || r.mountOnEnter ? l = rf : l = mc, i.state = {
      status: l
    }, i.nextCallback = null, i;
  }
  t.getDerivedStateFromProps = function(o, i) {
    var a = o.in;
    return a && i.status === rf ? {
      status: mc
    } : null;
  };
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(o) {
    var i = null;
    if (o !== this.props) {
      var a = this.state.status;
      this.props.in ? a !== gc && a !== tu && (i = gc) : (a === gc || a === tu) && (i = tS);
    }
    this.updateStatus(!1, i);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var o = this.props.timeout, i, a, c;
    return i = a = c = o, o != null && typeof o != "number" && (i = o.exit, a = o.enter, c = o.appear !== void 0 ? o.appear : a), {
      exit: i,
      enter: a,
      appear: c
    };
  }, n.updateStatus = function(o, i) {
    if (o === void 0 && (o = !1), i !== null)
      if (this.cancelNextCallback(), i === gc) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var a = this.props.nodeRef ? this.props.nodeRef.current : Xh.findDOMNode(this);
          a && hoe(a);
        }
        this.performEnter(o);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === mc && this.setState({
      status: rf
    });
  }, n.performEnter = function(o) {
    var i = this, a = this.props.enter, c = this.context ? this.context.isMounting : o, l = this.props.nodeRef ? [c] : [Xh.findDOMNode(this), c], u = l[0], d = l[1], f = this.getTimeouts(), h = c ? f.appear : f.enter;
    if (!o && !a || UP.disabled) {
      this.safeSetState({
        status: tu
      }, function() {
        i.props.onEntered(u);
      });
      return;
    }
    this.props.onEnter(u, d), this.safeSetState({
      status: gc
    }, function() {
      i.props.onEntering(u, d), i.onTransitionEnd(h, function() {
        i.safeSetState({
          status: tu
        }, function() {
          i.props.onEntered(u, d);
        });
      });
    });
  }, n.performExit = function() {
    var o = this, i = this.props.exit, a = this.getTimeouts(), c = this.props.nodeRef ? void 0 : Xh.findDOMNode(this);
    if (!i || UP.disabled) {
      this.safeSetState({
        status: mc
      }, function() {
        o.props.onExited(c);
      });
      return;
    }
    this.props.onExit(c), this.safeSetState({
      status: tS
    }, function() {
      o.props.onExiting(c), o.onTransitionEnd(a.exit, function() {
        o.safeSetState({
          status: mc
        }, function() {
          o.props.onExited(c);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(o, i) {
    i = this.setNextCallback(i), this.setState(o, i);
  }, n.setNextCallback = function(o) {
    var i = this, a = !0;
    return this.nextCallback = function(c) {
      a && (a = !1, i.nextCallback = null, o(c));
    }, this.nextCallback.cancel = function() {
      a = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(o, i) {
    this.setNextCallback(i);
    var a = this.props.nodeRef ? this.props.nodeRef.current : Xh.findDOMNode(this), c = o == null && !this.props.addEndListener;
    if (!a || c) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var l = this.props.nodeRef ? [this.nextCallback] : [a, this.nextCallback], u = l[0], d = l[1];
      this.props.addEndListener(u, d);
    }
    o != null && setTimeout(this.nextCallback, o);
  }, n.render = function() {
    var o = this.state.status;
    if (o === rf)
      return null;
    var i = this.props, a = i.children;
    i.in, i.mountOnEnter, i.unmountOnExit, i.appear, i.enter, i.exit, i.timeout, i.addEndListener, i.onEnter, i.onEntering, i.onEntered, i.onExit, i.onExiting, i.onExited, i.nodeRef;
    var c = OL(i, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ ye.createElement(Ag.Provider, {
        value: null
      }, typeof a == "function" ? a(o, c) : ye.cloneElement(ye.Children.only(a), c))
    );
  }, t;
}(ye.Component);
Si.contextType = Ag;
Si.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: s.shape({
    current: typeof Element > "u" ? s.any : function(e, t, n, r, o, i) {
      var a = e[t];
      return s.instanceOf(a && "ownerDocument" in a ? a.ownerDocument.defaultView.Element : Element)(e, t, n, r, o, i);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: s.oneOfType([s.func.isRequired, s.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: s.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: s.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: s.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: s.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: s.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: s.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(t) {
    var n = poe;
    t.addEndListener || (n = n.isRequired);
    for (var r = arguments.length, o = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
      o[i - 1] = arguments[i];
    return n.apply(void 0, [t].concat(o));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: s.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: s.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: s.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: s.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: s.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: s.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: s.func
} : {};
function Ll() {
}
Si.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Ll,
  onEntering: Ll,
  onEntered: Ll,
  onExit: Ll,
  onExiting: Ll,
  onExited: Ll
};
Si.UNMOUNTED = rf;
Si.EXITED = mc;
Si.ENTERING = gc;
Si.ENTERED = tu;
Si.EXITING = tS;
function moe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function vT(e, t) {
  var n = function(i) {
    return t && Um(i) ? t(i) : i;
  }, r = /* @__PURE__ */ Object.create(null);
  return e && PJ.map(e, function(o) {
    return o;
  }).forEach(function(o) {
    r[o.key] = n(o);
  }), r;
}
function goe(e, t) {
  e = e || {}, t = t || {};
  function n(d) {
    return d in t ? t[d] : e[d];
  }
  var r = /* @__PURE__ */ Object.create(null), o = [];
  for (var i in e)
    i in t ? o.length && (r[i] = o, o = []) : o.push(i);
  var a, c = {};
  for (var l in t) {
    if (r[l])
      for (a = 0; a < r[l].length; a++) {
        var u = r[l][a];
        c[r[l][a]] = n(u);
      }
    c[l] = n(l);
  }
  for (a = 0; a < o.length; a++)
    c[o[a]] = n(o[a]);
  return c;
}
function Tc(e, t, n) {
  return n[t] != null ? n[t] : e.props[t];
}
function voe(e, t) {
  return vT(e.children, function(n) {
    return Wm(n, {
      onExited: t.bind(null, n),
      in: !0,
      appear: Tc(n, "appear", e),
      enter: Tc(n, "enter", e),
      exit: Tc(n, "exit", e)
    });
  });
}
function yoe(e, t, n) {
  var r = vT(e.children), o = goe(t, r);
  return Object.keys(o).forEach(function(i) {
    var a = o[i];
    if (Um(a)) {
      var c = i in t, l = i in r, u = t[i], d = Um(u) && !u.props.in;
      l && (!c || d) ? o[i] = Wm(a, {
        onExited: n.bind(null, a),
        in: !0,
        exit: Tc(a, "exit", e),
        enter: Tc(a, "enter", e)
      }) : !l && c && !d ? o[i] = Wm(a, {
        in: !1
      }) : l && c && Um(u) && (o[i] = Wm(a, {
        onExited: n.bind(null, a),
        in: u.props.in,
        exit: Tc(a, "exit", e),
        enter: Tc(a, "enter", e)
      }));
    }
  }), o;
}
var boe = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, xoe = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, yT = /* @__PURE__ */ function(e) {
  SL(t, e);
  function t(r, o) {
    var i;
    i = e.call(this, r, o) || this;
    var a = i.handleExited.bind(moe(i));
    return i.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: a,
      firstRender: !0
    }, i;
  }
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, n.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(o, i) {
    var a = i.children, c = i.handleExited, l = i.firstRender;
    return {
      children: l ? voe(o, c) : yoe(o, a, c),
      firstRender: !1
    };
  }, n.handleExited = function(o, i) {
    var a = vT(this.props.children);
    o.key in a || (o.props.onExited && o.props.onExited(i), this.mounted && this.setState(function(c) {
      var l = Sg({}, c.children);
      return delete l[o.key], {
        children: l
      };
    }));
  }, n.render = function() {
    var o = this.props, i = o.component, a = o.childFactory, c = OL(o, ["component", "childFactory"]), l = this.state.contextValue, u = boe(this.state.children).map(a);
    return delete c.appear, delete c.enter, delete c.exit, i === null ? /* @__PURE__ */ ye.createElement(Ag.Provider, {
      value: l
    }, u) : /* @__PURE__ */ ye.createElement(Ag.Provider, {
      value: l
    }, /* @__PURE__ */ ye.createElement(i, c, u));
  }, t;
}(ye.Component);
yT.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: s.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: s.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: s.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: s.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: s.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: s.func
} : {};
yT.defaultProps = xoe;
const bT = (e) => e.scrollTop;
function $u(e, t) {
  const {
    timeout: n,
    easing: r,
    style: o = {}
  } = e;
  return {
    duration: o.transitionDuration ?? (typeof n == "number" ? n : n[t.mode] || 0),
    easing: o.transitionTimingFunction ?? (typeof r == "object" ? r[t.mode] : r),
    delay: o.transitionDelay
  };
}
function woe(e) {
  return mt("MuiPaper", e);
}
gt("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const $oe = (e) => {
  const {
    square: t,
    elevation: n,
    variant: r,
    classes: o
  } = e, i = {
    root: ["root", r, !t && "rounded", r === "elevation" && `elevation${n}`]
  };
  return wt(i, woe, o);
}, Ooe = Pe("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], !n.square && t.rounded, n.variant === "elevation" && t[`elevation${n.elevation}`]];
  }
})(ct(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  color: (e.vars || e).palette.text.primary,
  transition: e.transitions.create("box-shadow"),
  variants: [{
    props: ({
      ownerState: t
    }) => !t.square,
    style: {
      borderRadius: e.shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: {
      variant: "elevation"
    },
    style: {
      boxShadow: "var(--Paper-shadow)",
      backgroundImage: "var(--Paper-overlay)"
    }
  }]
}))), _p = /* @__PURE__ */ E.forwardRef(function(t, n) {
  var v;
  const r = $t({
    props: t,
    name: "MuiPaper"
  }), o = Fr(), {
    className: i,
    component: a = "div",
    elevation: c = 1,
    square: l = !1,
    variant: u = "elevation",
    ...d
  } = r, f = {
    ...r,
    component: a,
    elevation: c,
    square: l,
    variant: u
  }, h = $oe(f);
  return process.env.NODE_ENV !== "production" && o.shadows[c] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${c}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${c}]\` is defined.`].join(`
`)), /* @__PURE__ */ F.jsx(Ooe, {
    as: a,
    ownerState: f,
    className: Ge(h.root, i),
    ref: n,
    ...d,
    style: {
      ...u === "elevation" && {
        "--Paper-shadow": (o.vars || o).shadows[c],
        ...o.vars && {
          "--Paper-overlay": (v = o.vars.overlays) == null ? void 0 : v[c]
        },
        ...!o.vars && o.palette.mode === "dark" && {
          "--Paper-overlay": `linear-gradient(${It("#fff", QO(c))}, ${It("#fff", QO(c))})`
        }
      },
      ...d.style
    }
  });
});
process.env.NODE_ENV !== "production" && (_p.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: $o(rv, (e) => {
    const {
      elevation: t,
      variant: n
    } = e;
    return t > 0 && n === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${n}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: s.bool,
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: s.oneOfType([s.oneOf(["elevation", "outlined"]), s.string])
});
function Mr(e, t) {
  const {
    className: n,
    elementType: r,
    ownerState: o,
    externalForwardedProps: i,
    internalForwardedProps: a,
    ...c
  } = t, {
    component: l,
    slots: u = {
      [e]: void 0
    },
    slotProps: d = {
      [e]: void 0
    },
    ...f
  } = i, h = u[e] || r, v = uL(d[e], o), {
    props: {
      component: y,
      ...g
    },
    internalRef: b
  } = lL({
    className: n,
    ...c,
    externalForwardedProps: e === "root" ? f : void 0,
    externalSlotProps: v
  }), x = $n(b, v == null ? void 0 : v.ref, t.ref), $ = e === "root" ? y || l : y, S = cL(h, {
    ...e === "root" && !l && !u[e] && a,
    ...e !== "root" && !u[e] && a,
    ...g,
    ...$ && {
      as: $
    },
    ref: x
  }, o);
  return [h, S];
}
class Ig {
  constructor() {
    nt(this, "mountEffect", () => {
      this.shouldMount && !this.didMount && this.ref.current !== null && (this.didMount = !0, this.mounted.resolve());
    });
    this.ref = {
      current: null
    }, this.mounted = null, this.didMount = !1, this.shouldMount = !1, this.setShouldMount = null;
  }
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new Ig();
  }
  static use() {
    const t = rL(Ig.create).current, [n, r] = E.useState(!1);
    return t.shouldMount = n, t.setShouldMount = r, E.useEffect(t.mountEffect, [n]), t;
  }
  mount() {
    return this.mounted || (this.mounted = Coe(), this.shouldMount = !0, this.setShouldMount(this.shouldMount)), this.mounted;
  }
  /* Ripple API */
  start(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.start(...t);
    });
  }
  stop(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.stop(...t);
    });
  }
  pulsate(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.pulsate(...t);
    });
  }
}
function Soe() {
  return Ig.use();
}
function Coe() {
  let e, t;
  const n = new Promise((r, o) => {
    e = r, t = o;
  });
  return n.resolve = e, n.reject = t, n;
}
function CL(e) {
  const {
    className: t,
    classes: n,
    pulsate: r = !1,
    rippleX: o,
    rippleY: i,
    rippleSize: a,
    in: c,
    onExited: l,
    timeout: u
  } = e, [d, f] = E.useState(!1), h = Ge(t, n.ripple, n.rippleVisible, r && n.ripplePulsate), v = {
    width: a,
    height: a,
    top: -(a / 2) + i,
    left: -(a / 2) + o
  }, y = Ge(n.child, d && n.childLeaving, r && n.childPulsate);
  return !c && !d && f(!0), E.useEffect(() => {
    if (!c && l != null) {
      const g = setTimeout(l, u);
      return () => {
        clearTimeout(g);
      };
    }
  }, [l, c, u]), /* @__PURE__ */ F.jsx("span", {
    className: h,
    style: v,
    children: /* @__PURE__ */ F.jsx("span", {
      className: y
    })
  });
}
process.env.NODE_ENV !== "production" && (CL.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object.isRequired,
  className: s.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: s.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: s.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: s.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: s.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: s.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: s.number,
  /**
   * exit delay
   */
  timeout: s.number.isRequired
});
const qo = gt("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), nS = 550, Toe = 80, Eoe = Qc`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`, _oe = Qc`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`, koe = Qc`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`, Roe = Pe("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), Poe = Pe(CL, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${qo.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${Eoe};
    animation-duration: ${nS}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  &.${qo.ripplePulsate} {
    animation-duration: ${({
  theme: e
}) => e.transitions.duration.shorter}ms;
  }

  & .${qo.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${qo.childLeaving} {
    opacity: 0;
    animation-name: ${_oe};
    animation-duration: ${nS}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  & .${qo.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${koe};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`, TL = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: o = !1,
    classes: i = {},
    className: a,
    ...c
  } = r, [l, u] = E.useState([]), d = E.useRef(0), f = E.useRef(null);
  E.useEffect(() => {
    f.current && (f.current(), f.current = null);
  }, [l]);
  const h = E.useRef(!1), v = oL(), y = E.useRef(null), g = E.useRef(null), b = E.useCallback((O) => {
    const {
      pulsate: C,
      rippleX: T,
      rippleY: k,
      rippleSize: I,
      cb: P
    } = O;
    u((_) => [..._, /* @__PURE__ */ F.jsx(Poe, {
      classes: {
        ripple: Ge(i.ripple, qo.ripple),
        rippleVisible: Ge(i.rippleVisible, qo.rippleVisible),
        ripplePulsate: Ge(i.ripplePulsate, qo.ripplePulsate),
        child: Ge(i.child, qo.child),
        childLeaving: Ge(i.childLeaving, qo.childLeaving),
        childPulsate: Ge(i.childPulsate, qo.childPulsate)
      },
      timeout: nS,
      pulsate: C,
      rippleX: T,
      rippleY: k,
      rippleSize: I
    }, d.current)]), d.current += 1, f.current = P;
  }, [i]), x = E.useCallback((O = {}, C = {}, T = () => {
  }) => {
    const {
      pulsate: k = !1,
      center: I = o || C.pulsate,
      fakeElement: P = !1
      // For test purposes
    } = C;
    if ((O == null ? void 0 : O.type) === "mousedown" && h.current) {
      h.current = !1;
      return;
    }
    (O == null ? void 0 : O.type) === "touchstart" && (h.current = !0);
    const _ = P ? null : g.current, A = _ ? _.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let D, M, N;
    if (I || O === void 0 || O.clientX === 0 && O.clientY === 0 || !O.clientX && !O.touches)
      D = Math.round(A.width / 2), M = Math.round(A.height / 2);
    else {
      const {
        clientX: L,
        clientY: z
      } = O.touches && O.touches.length > 0 ? O.touches[0] : O;
      D = Math.round(L - A.left), M = Math.round(z - A.top);
    }
    if (I)
      N = Math.sqrt((2 * A.width ** 2 + A.height ** 2) / 3), N % 2 === 0 && (N += 1);
    else {
      const L = Math.max(Math.abs((_ ? _.clientWidth : 0) - D), D) * 2 + 2, z = Math.max(Math.abs((_ ? _.clientHeight : 0) - M), M) * 2 + 2;
      N = Math.sqrt(L ** 2 + z ** 2);
    }
    O != null && O.touches ? y.current === null && (y.current = () => {
      b({
        pulsate: k,
        rippleX: D,
        rippleY: M,
        rippleSize: N,
        cb: T
      });
    }, v.start(Toe, () => {
      y.current && (y.current(), y.current = null);
    })) : b({
      pulsate: k,
      rippleX: D,
      rippleY: M,
      rippleSize: N,
      cb: T
    });
  }, [o, b, v]), $ = E.useCallback(() => {
    x({}, {
      pulsate: !0
    });
  }, [x]), S = E.useCallback((O, C) => {
    if (v.clear(), (O == null ? void 0 : O.type) === "touchend" && y.current) {
      y.current(), y.current = null, v.start(0, () => {
        S(O, C);
      });
      return;
    }
    y.current = null, u((T) => T.length > 0 ? T.slice(1) : T), f.current = C;
  }, [v]);
  return E.useImperativeHandle(n, () => ({
    pulsate: $,
    start: x,
    stop: S
  }), [$, x, S]), /* @__PURE__ */ F.jsx(Roe, {
    className: Ge(qo.root, i.root, a),
    ref: g,
    ...c,
    children: /* @__PURE__ */ F.jsx(yT, {
      component: null,
      exit: !0,
      children: l
    })
  });
});
process.env.NODE_ENV !== "production" && (TL.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string
});
function Aoe(e) {
  return mt("MuiButtonBase", e);
}
const Ioe = gt("MuiButtonBase", ["root", "disabled", "focusVisible"]), Moe = (e) => {
  const {
    disabled: t,
    focusVisible: n,
    focusVisibleClassName: r,
    classes: o
  } = e, a = wt({
    root: ["root", t && "disabled", n && "focusVisible"]
  }, Aoe, o);
  return n && r && (a.root += ` ${r}`), a;
}, Noe = Pe("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${Ioe.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), oa = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: o,
    centerRipple: i = !1,
    children: a,
    className: c,
    component: l = "button",
    disabled: u = !1,
    disableRipple: d = !1,
    disableTouchRipple: f = !1,
    focusRipple: h = !1,
    focusVisibleClassName: v,
    LinkComponent: y = "a",
    onBlur: g,
    onClick: b,
    onContextMenu: x,
    onDragLeave: $,
    onFocus: S,
    onFocusVisible: O,
    onKeyDown: C,
    onKeyUp: T,
    onMouseDown: k,
    onMouseLeave: I,
    onMouseUp: P,
    onTouchEnd: _,
    onTouchMove: A,
    onTouchStart: D,
    tabIndex: M = 0,
    TouchRippleProps: N,
    touchRippleRef: L,
    type: z,
    ...q
  } = r, W = E.useRef(null), U = Soe(), K = $n(U.ref, L), [Y, X] = E.useState(!1);
  u && Y && X(!1), E.useImperativeHandle(o, () => ({
    focusVisible: () => {
      X(!0), W.current.focus();
    }
  }), []);
  const oe = U.shouldMount && !d && !u;
  E.useEffect(() => {
    Y && h && !d && U.pulsate();
  }, [d, h, Y, U]);
  const re = Ea(U, "start", k, f), Z = Ea(U, "stop", x, f), ce = Ea(U, "stop", $, f), fe = Ea(U, "stop", P, f), de = Ea(U, "stop", (se) => {
    Y && se.preventDefault(), I && I(se);
  }, f), ne = Ea(U, "start", D, f), le = Ea(U, "stop", _, f), ve = Ea(U, "stop", A, f), G = Ea(U, "stop", (se) => {
    kg(se.target) || X(!1), g && g(se);
  }, !1), Se = hr((se) => {
    W.current || (W.current = se.currentTarget), kg(se.target) && (X(!0), O && O(se)), S && S(se);
  }), ue = () => {
    const se = W.current;
    return l && l !== "button" && !(se.tagName === "A" && se.href);
  }, Q = hr((se) => {
    h && !se.repeat && Y && se.key === " " && U.stop(se, () => {
      U.start(se);
    }), se.target === se.currentTarget && ue() && se.key === " " && se.preventDefault(), C && C(se), se.target === se.currentTarget && ue() && se.key === "Enter" && !u && (se.preventDefault(), b && b(se));
  }), ie = hr((se) => {
    h && se.key === " " && Y && !se.defaultPrevented && U.stop(se, () => {
      U.pulsate(se);
    }), T && T(se), b && se.target === se.currentTarget && ue() && se.key === " " && !se.defaultPrevented && b(se);
  });
  let ee = l;
  ee === "button" && (q.href || q.to) && (ee = y);
  const be = {};
  ee === "button" ? (be.type = z === void 0 ? "button" : z, be.disabled = u) : (!q.href && !q.to && (be.role = "button"), u && (be["aria-disabled"] = u));
  const Ie = $n(n, W), je = {
    ...r,
    centerRipple: i,
    component: l,
    disabled: u,
    disableRipple: d,
    disableTouchRipple: f,
    focusRipple: h,
    tabIndex: M,
    focusVisible: Y
  }, V = Moe(je);
  return /* @__PURE__ */ F.jsxs(Noe, {
    as: ee,
    className: Ge(V.root, c),
    ownerState: je,
    onBlur: G,
    onClick: b,
    onContextMenu: Z,
    onFocus: Se,
    onKeyDown: Q,
    onKeyUp: ie,
    onMouseDown: re,
    onMouseLeave: de,
    onMouseUp: fe,
    onDragLeave: ce,
    onTouchEnd: le,
    onTouchMove: ve,
    onTouchStart: ne,
    ref: Ie,
    tabIndex: u ? -1 : M,
    type: z,
    ...be,
    ...q,
    children: [a, oe ? /* @__PURE__ */ F.jsx(TL, {
      ref: K,
      center: i,
      ...N
    }) : null]
  });
});
function Ea(e, t, n, r = !1) {
  return hr((o) => (n && n(o), r || e[t](o), !0));
}
process.env.NODE_ENV !== "production" && (oa.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: jr,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: s.bool,
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: aT,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: s.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: s.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: s.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: s.string,
  /**
   * @ignore
   */
  href: s.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: s.elementType,
  /**
   * @ignore
   */
  onBlur: s.func,
  /**
   * @ignore
   */
  onClick: s.func,
  /**
   * @ignore
   */
  onContextMenu: s.func,
  /**
   * @ignore
   */
  onDragLeave: s.func,
  /**
   * @ignore
   */
  onFocus: s.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: s.func,
  /**
   * @ignore
   */
  onKeyDown: s.func,
  /**
   * @ignore
   */
  onKeyUp: s.func,
  /**
   * @ignore
   */
  onMouseDown: s.func,
  /**
   * @ignore
   */
  onMouseLeave: s.func,
  /**
   * @ignore
   */
  onMouseUp: s.func,
  /**
   * @ignore
   */
  onTouchEnd: s.func,
  /**
   * @ignore
   */
  onTouchMove: s.func,
  /**
   * @ignore
   */
  onTouchStart: s.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * @default 0
   */
  tabIndex: s.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: s.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: s.oneOfType([s.func, s.shape({
    current: s.shape({
      pulsate: s.func.isRequired,
      start: s.func.isRequired,
      stop: s.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: s.oneOfType([s.oneOf(["button", "reset", "submit"]), s.string])
});
function Doe(e) {
  return typeof e.main == "string";
}
function Loe(e, t = []) {
  if (!Doe(e))
    return !1;
  for (const n of t)
    if (!e.hasOwnProperty(n) || typeof e[n] != "string")
      return !1;
  return !0;
}
function Dn(e = []) {
  return ([, t]) => t && Loe(t, e);
}
function joe(e) {
  return mt("MuiIconButton", e);
}
const Foe = gt("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]), zoe = (e) => {
  const {
    classes: t,
    disabled: n,
    color: r,
    edge: o,
    size: i
  } = e, a = {
    root: ["root", n && "disabled", r !== "default" && `color${Le(r)}`, o && `edge${Le(o)}`, `size${Le(i)}`]
  };
  return wt(a, joe, t);
}, Boe = Pe(oa, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "default" && t[`color${Le(n.color)}`], n.edge && t[`edge${Le(n.edge)}`], t[`size${Le(n.size)}`]];
  }
})(ct(({
  theme: e
}) => ({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: (t) => !t.disableRipple,
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : It(e.palette.action.active, e.palette.action.hoverOpacity),
      "&:hover": {
        backgroundColor: "var(--IconButton-hoverBg)",
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }]
})), ct(({
  theme: e
}) => ({
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, ...Object.entries(e.palette).filter(Dn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  })), ...Object.entries(e.palette).filter(Dn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${(e.vars || e).palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : It((e.vars || e).palette[t].main, e.palette.action.hoverOpacity)
    }
  })), {
    props: {
      size: "small"
    },
    style: {
      padding: 5,
      fontSize: e.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      padding: 12,
      fontSize: e.typography.pxToRem(28)
    }
  }],
  [`&.${Foe.disabled}`]: {
    backgroundColor: "transparent",
    color: (e.vars || e).palette.action.disabled
  }
}))), xT = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: o = !1,
    children: i,
    className: a,
    color: c = "default",
    disabled: l = !1,
    disableFocusRipple: u = !1,
    size: d = "medium",
    ...f
  } = r, h = {
    ...r,
    edge: o,
    color: c,
    disabled: l,
    disableFocusRipple: u,
    size: d
  }, v = zoe(h);
  return /* @__PURE__ */ F.jsx(Boe, {
    className: Ge(v.root, a),
    centerRipple: !0,
    focusRipple: !u,
    disabled: l,
    ref: n,
    ...f,
    ownerState: h,
    children: i
  });
});
process.env.NODE_ENV !== "production" && (xT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: $o(s.node, (e) => E.Children.toArray(e.children).some((n) => /* @__PURE__ */ E.isValidElement(n) && n.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: s.oneOfType([s.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: s.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: s.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: s.oneOf(["end", "start", !1]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["small", "medium", "large"]), s.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const qoe = Oi(/* @__PURE__ */ F.jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
function Uoe(e) {
  return mt("MuiTypography", e);
}
gt("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const Woe = {
  primary: !0,
  secondary: !0,
  error: !0,
  info: !0,
  success: !0,
  warning: !0,
  textPrimary: !0,
  textSecondary: !0,
  textDisabled: !0
}, Hoe = roe(), Voe = (e) => {
  const {
    align: t,
    gutterBottom: n,
    noWrap: r,
    paragraph: o,
    variant: i,
    classes: a
  } = e, c = {
    root: ["root", i, e.align !== "inherit" && `align${Le(t)}`, n && "gutterBottom", r && "noWrap", o && "paragraph"]
  };
  return wt(c, Uoe, a);
}, Yoe = Pe("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.variant && t[n.variant], n.align !== "inherit" && t[`align${Le(n.align)}`], n.noWrap && t.noWrap, n.gutterBottom && t.gutterBottom, n.paragraph && t.paragraph];
  }
})(ct(({
  theme: e
}) => {
  var t;
  return {
    margin: 0,
    variants: [{
      props: {
        variant: "inherit"
      },
      style: {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit",
        lineHeight: "inherit",
        letterSpacing: "inherit"
      }
    }, ...Object.entries(e.typography).filter(([n, r]) => n !== "inherit" && r && typeof r == "object").map(([n, r]) => ({
      props: {
        variant: n
      },
      style: r
    })), ...Object.entries(e.palette).filter(Dn()).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        color: (e.vars || e).palette[n].main
      }
    })), ...Object.entries(((t = e.palette) == null ? void 0 : t.text) || {}).filter(([, n]) => typeof n == "string").map(([n]) => ({
      props: {
        color: `text${Le(n)}`
      },
      style: {
        color: (e.vars || e).palette.text[n]
      }
    })), {
      props: ({
        ownerState: n
      }) => n.align !== "inherit",
      style: {
        textAlign: "var(--Typography-textAlign)"
      }
    }, {
      props: ({
        ownerState: n
      }) => n.noWrap,
      style: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, {
      props: ({
        ownerState: n
      }) => n.gutterBottom,
      style: {
        marginBottom: "0.35em"
      }
    }, {
      props: ({
        ownerState: n
      }) => n.paragraph,
      style: {
        marginBottom: 16
      }
    }]
  };
})), WP = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, Jm = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const {
    color: r,
    ...o
  } = $t({
    props: t,
    name: "MuiTypography"
  }), i = !Woe[r], a = Hoe({
    ...o,
    ...i && {
      color: r
    }
  }), {
    align: c = "inherit",
    className: l,
    component: u,
    gutterBottom: d = !1,
    noWrap: f = !1,
    paragraph: h = !1,
    variant: v = "body1",
    variantMapping: y = WP,
    ...g
  } = a, b = {
    ...a,
    align: c,
    color: r,
    className: l,
    component: u,
    gutterBottom: d,
    noWrap: f,
    paragraph: h,
    variant: v,
    variantMapping: y
  }, x = u || (h ? "p" : y[v] || WP[v]) || "span", $ = Voe(b);
  return /* @__PURE__ */ F.jsx(Yoe, {
    as: x,
    ref: n,
    className: Ge($.root, l),
    ...g,
    ownerState: b,
    style: {
      ...c !== "inherit" && {
        "--Typography-textAlign": c
      },
      ...g.style
    }
  });
});
process.env.NODE_ENV !== "production" && (Jm.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: s.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary", "success", "error", "info", "warning", "textPrimary", "textSecondary", "textDisabled"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: s.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: s.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   * @deprecated Use the `component` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  paragraph: s.bool,
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: s.oneOfType([s.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), s.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: s.object
});
function HP(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function Goe(e = {}) {
  const {
    ignoreAccents: t = !0,
    ignoreCase: n = !0,
    limit: r,
    matchFrom: o = "any",
    stringify: i,
    trim: a = !1
  } = e;
  return (c, {
    inputValue: l,
    getOptionLabel: u
  }) => {
    let d = a ? l.trim() : l;
    n && (d = d.toLowerCase()), t && (d = HP(d));
    const f = d ? c.filter((h) => {
      let v = (i || u)(h);
      return n && (v = v.toLowerCase()), t && (v = HP(v)), o === "start" ? v.startsWith(d) : v.includes(d);
    }) : c;
    return typeof r == "number" ? f.slice(0, r) : f;
  };
}
const Koe = Goe(), VP = 5, Xoe = (e) => {
  var t;
  return e.current !== null && ((t = e.current.parentElement) == null ? void 0 : t.contains(document.activeElement));
}, Zoe = [];
function Joe(e) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox: t = Xoe,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix: n = "Mui",
    autoComplete: r = !1,
    autoHighlight: o = !1,
    autoSelect: i = !1,
    blurOnSelect: a = !1,
    clearOnBlur: c = !e.freeSolo,
    clearOnEscape: l = !1,
    componentName: u = "useAutocomplete",
    defaultValue: d = e.multiple ? Zoe : null,
    disableClearable: f = !1,
    disableCloseOnSelect: h = !1,
    disabled: v,
    disabledItemsFocusable: y = !1,
    disableListWrap: g = !1,
    filterOptions: b = Koe,
    filterSelectedOptions: x = !1,
    freeSolo: $ = !1,
    getOptionDisabled: S,
    getOptionKey: O,
    getOptionLabel: C = (Fe) => Fe.label ?? Fe,
    groupBy: T,
    handleHomeEndKeys: k = !e.freeSolo,
    id: I,
    includeInputInList: P = !1,
    inputValue: _,
    isOptionEqualToValue: A = (Fe, Ee) => Fe === Ee,
    multiple: D = !1,
    onChange: M,
    onClose: N,
    onHighlightChange: L,
    onInputChange: z,
    onOpen: q,
    open: W,
    openOnFocus: U = !1,
    options: K,
    readOnly: Y = !1,
    selectOnFocus: X = !e.freeSolo,
    value: oe
  } = e, re = sT(I);
  let Z = C;
  Z = (Fe) => {
    const Ee = C(Fe);
    if (typeof Ee != "string") {
      if (process.env.NODE_ENV !== "production") {
        const et = Ee === void 0 ? "undefined" : `${typeof Ee} (${Ee})`;
        console.error(`MUI: The \`getOptionLabel\` method of ${u} returned ${et} instead of a string for ${JSON.stringify(Fe)}.`);
      }
      return String(Ee);
    }
    return Ee;
  };
  const ce = E.useRef(!1), fe = E.useRef(!0), de = E.useRef(null), ne = E.useRef(null), [le, ve] = E.useState(null), [G, Se] = E.useState(-1), ue = o ? 0 : -1, Q = E.useRef(ue), [ie, ee] = Mc({
    controlled: oe,
    default: d,
    name: u
  }), [be, Ie] = Mc({
    controlled: _,
    default: "",
    name: u,
    state: "inputValue"
  }), [je, V] = E.useState(!1), se = E.useCallback((Fe, Ee, et) => {
    if (!(D ? ie.length < Ee.length : Ee !== null) && !c)
      return;
    let bt;
    if (D)
      bt = "";
    else if (Ee == null)
      bt = "";
    else {
      const Xt = Z(Ee);
      bt = typeof Xt == "string" ? Xt : "";
    }
    be !== bt && (Ie(bt), z && z(Fe, bt, et));
  }, [Z, be, D, z, Ie, c, ie]), [we, J] = Mc({
    controlled: W,
    default: !1,
    name: u,
    state: "open"
  }), [he, Te] = E.useState(!0), xe = !D && ie != null && be === Z(ie), Ae = we && !Y, Ce = Ae ? b(
    K.filter((Fe) => !(x && (D ? ie : [ie]).some((Ee) => Ee !== null && A(Fe, Ee)))),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: xe && he ? "" : be,
      getOptionLabel: Z
    }
  ) : [], Ye = lT({
    filteredOptions: Ce,
    value: ie,
    inputValue: be
  });
  E.useEffect(() => {
    const Fe = ie !== Ye.value;
    je && !Fe || $ && !Fe || se(null, ie, "reset");
  }, [ie, se, je, Ye.value, $]);
  const He = we && Ce.length > 0 && !Y, Be = hr((Fe) => {
    Fe === -1 ? de.current.focus() : le.querySelector(`[data-tag-index="${Fe}"]`).focus();
  });
  E.useEffect(() => {
    D && G > ie.length - 1 && (Se(-1), Be(-1));
  }, [ie, D, G, Be]);
  function Xe(Fe, Ee) {
    if (!ne.current || Fe < 0 || Fe >= Ce.length)
      return -1;
    let et = Fe;
    for (; ; ) {
      const yt = ne.current.querySelector(`[data-option-index="${et}"]`), bt = y ? !1 : !yt || yt.disabled || yt.getAttribute("aria-disabled") === "true";
      if (yt && yt.hasAttribute("tabindex") && !bt)
        return et;
      if (Ee === "next" ? et = (et + 1) % Ce.length : et = (et - 1 + Ce.length) % Ce.length, et === Fe)
        return -1;
    }
  }
  const Ze = hr(({
    event: Fe,
    index: Ee,
    reason: et = "auto"
  }) => {
    if (Q.current = Ee, Ee === -1 ? de.current.removeAttribute("aria-activedescendant") : de.current.setAttribute("aria-activedescendant", `${re}-option-${Ee}`), L && L(Fe, Ee === -1 ? null : Ce[Ee], et), !ne.current)
      return;
    const yt = ne.current.querySelector(`[role="option"].${n}-focused`);
    yt && (yt.classList.remove(`${n}-focused`), yt.classList.remove(`${n}-focusVisible`));
    let bt = ne.current;
    if (ne.current.getAttribute("role") !== "listbox" && (bt = ne.current.parentElement.querySelector('[role="listbox"]')), !bt)
      return;
    if (Ee === -1) {
      bt.scrollTop = 0;
      return;
    }
    const Xt = ne.current.querySelector(`[data-option-index="${Ee}"]`);
    if (Xt && (Xt.classList.add(`${n}-focused`), et === "keyboard" && Xt.classList.add(`${n}-focusVisible`), bt.scrollHeight > bt.clientHeight && et !== "mouse" && et !== "touch")) {
      const Wt = Xt, vr = bt.clientHeight + bt.scrollTop, ai = Wt.offsetTop + Wt.offsetHeight;
      ai > vr ? bt.scrollTop = ai - bt.clientHeight : Wt.offsetTop - Wt.offsetHeight * (T ? 1.3 : 0) < bt.scrollTop && (bt.scrollTop = Wt.offsetTop - Wt.offsetHeight * (T ? 1.3 : 0));
    }
  }), Ne = hr(({
    event: Fe,
    diff: Ee,
    direction: et = "next",
    reason: yt = "auto"
  }) => {
    if (!Ae)
      return;
    const Xt = Xe((() => {
      const Wt = Ce.length - 1;
      if (Ee === "reset")
        return ue;
      if (Ee === "start")
        return 0;
      if (Ee === "end")
        return Wt;
      const vr = Q.current + Ee;
      return vr < 0 ? vr === -1 && P ? -1 : g && Q.current !== -1 || Math.abs(Ee) > 1 ? 0 : Wt : vr > Wt ? vr === Wt + 1 && P ? -1 : g || Math.abs(Ee) > 1 ? Wt : 0 : vr;
    })(), et);
    if (Ze({
      index: Xt,
      reason: yt,
      event: Fe
    }), r && Ee !== "reset")
      if (Xt === -1)
        de.current.value = be;
      else {
        const Wt = Z(Ce[Xt]);
        de.current.value = Wt, Wt.toLowerCase().indexOf(be.toLowerCase()) === 0 && be.length > 0 && de.current.setSelectionRange(be.length, Wt.length);
      }
  }), $e = () => {
    const Fe = (Ee, et) => {
      const yt = Ee ? Z(Ee) : "", bt = et ? Z(et) : "";
      return yt === bt;
    };
    if (Q.current !== -1 && Ye.filteredOptions && Ye.filteredOptions.length !== Ce.length && Ye.inputValue === be && (D ? ie.length === Ye.value.length && Ye.value.every((Ee, et) => Z(ie[et]) === Z(Ee)) : Fe(Ye.value, ie))) {
      const Ee = Ye.filteredOptions[Q.current];
      if (Ee)
        return Ce.findIndex((et) => Z(et) === Z(Ee));
    }
    return -1;
  }, Ue = E.useCallback(() => {
    if (!Ae)
      return;
    const Fe = $e();
    if (Fe !== -1) {
      Q.current = Fe;
      return;
    }
    const Ee = D ? ie[0] : ie;
    if (Ce.length === 0 || Ee == null) {
      Ne({
        diff: "reset"
      });
      return;
    }
    if (ne.current) {
      if (Ee != null) {
        const et = Ce[Q.current];
        if (D && et && ie.findIndex((bt) => A(et, bt)) !== -1)
          return;
        const yt = Ce.findIndex((bt) => A(bt, Ee));
        yt === -1 ? Ne({
          diff: "reset"
        }) : Ze({
          index: yt
        });
        return;
      }
      if (Q.current >= Ce.length - 1) {
        Ze({
          index: Ce.length - 1
        });
        return;
      }
      Ze({
        index: Q.current
      });
    }
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    Ce.length,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    D ? !1 : ie,
    x,
    Ne,
    Ze,
    Ae,
    be,
    D
  ]), Ke = hr((Fe) => {
    _g(ne, Fe), Fe && Ue();
  });
  process.env.NODE_ENV !== "production" && E.useEffect(() => {
    (!de.current || de.current.nodeName !== "INPUT") && (de.current && de.current.nodeName === "TEXTAREA" ? console.warn([`A textarea element was provided to ${u} where input was expected.`, "This is not a supported scenario but it may work under certain conditions.", "A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).", "Make sure to test keyboard navigation and add custom event handlers if necessary."].join(`
`)) : console.error([`MUI: Unable to find the input element. It was resolved to ${de.current} while an HTMLInputElement was expected.`, `Instead, ${u} expects an input element.`, "", u === "useAutocomplete" ? "Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed." : "Make sure you have customized the input component correctly."].join(`
`)));
  }, [u]), E.useEffect(() => {
    Ue();
  }, [Ue]);
  const Me = (Fe) => {
    we || (J(!0), Te(!0), q && q(Fe));
  }, We = (Fe, Ee) => {
    we && (J(!1), N && N(Fe, Ee));
  }, at = (Fe, Ee, et, yt) => {
    if (D) {
      if (ie.length === Ee.length && ie.every((bt, Xt) => bt === Ee[Xt]))
        return;
    } else if (ie === Ee)
      return;
    M && M(Fe, Ee, et, yt), ee(Ee);
  }, Je = E.useRef(!1), ke = (Fe, Ee, et = "selectOption", yt = "options") => {
    let bt = et, Xt = Ee;
    if (D) {
      if (Xt = Array.isArray(ie) ? ie.slice() : [], process.env.NODE_ENV !== "production") {
        const vr = Xt.filter((ai) => A(Ee, ai));
        vr.length > 1 && console.error([`MUI: The \`isOptionEqualToValue\` method of ${u} does not handle the arguments correctly.`, `The component expects a single value to match a given option but found ${vr.length} matches.`].join(`
`));
      }
      const Wt = Xt.findIndex((vr) => A(Ee, vr));
      Wt === -1 ? Xt.push(Ee) : yt !== "freeSolo" && (Xt.splice(Wt, 1), bt = "removeOption");
    }
    se(Fe, Xt, bt), at(Fe, Xt, bt, {
      option: Ee
    }), !h && (!Fe || !Fe.ctrlKey && !Fe.metaKey) && We(Fe, bt), (a === !0 || a === "touch" && Je.current || a === "mouse" && !Je.current) && de.current.blur();
  };
  function Qe(Fe, Ee) {
    if (Fe === -1)
      return -1;
    let et = Fe;
    for (; ; ) {
      if (Ee === "next" && et === ie.length || Ee === "previous" && et === -1)
        return -1;
      const yt = le.querySelector(`[data-tag-index="${et}"]`);
      if (!yt || !yt.hasAttribute("tabindex") || yt.disabled || yt.getAttribute("aria-disabled") === "true")
        et += Ee === "next" ? 1 : -1;
      else
        return et;
    }
  }
  const ot = (Fe, Ee) => {
    if (!D)
      return;
    be === "" && We(Fe, "toggleInput");
    let et = G;
    G === -1 ? be === "" && Ee === "previous" && (et = ie.length - 1) : (et += Ee === "next" ? 1 : -1, et < 0 && (et = 0), et === ie.length && (et = -1)), et = Qe(et, Ee), Se(et), Be(et);
  }, Mt = (Fe) => {
    ce.current = !0, Ie(""), z && z(Fe, "", "clear"), at(Fe, D ? [] : null, "clear");
  }, Pt = (Fe) => (Ee) => {
    if (Fe.onKeyDown && Fe.onKeyDown(Ee), !Ee.defaultMuiPrevented && (G !== -1 && !["ArrowLeft", "ArrowRight"].includes(Ee.key) && (Se(-1), Be(-1)), Ee.which !== 229))
      switch (Ee.key) {
        case "Home":
          Ae && k && (Ee.preventDefault(), Ne({
            diff: "start",
            direction: "next",
            reason: "keyboard",
            event: Ee
          }));
          break;
        case "End":
          Ae && k && (Ee.preventDefault(), Ne({
            diff: "end",
            direction: "previous",
            reason: "keyboard",
            event: Ee
          }));
          break;
        case "PageUp":
          Ee.preventDefault(), Ne({
            diff: -VP,
            direction: "previous",
            reason: "keyboard",
            event: Ee
          }), Me(Ee);
          break;
        case "PageDown":
          Ee.preventDefault(), Ne({
            diff: VP,
            direction: "next",
            reason: "keyboard",
            event: Ee
          }), Me(Ee);
          break;
        case "ArrowDown":
          Ee.preventDefault(), Ne({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: Ee
          }), Me(Ee);
          break;
        case "ArrowUp":
          Ee.preventDefault(), Ne({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: Ee
          }), Me(Ee);
          break;
        case "ArrowLeft":
          ot(Ee, "previous");
          break;
        case "ArrowRight":
          ot(Ee, "next");
          break;
        case "Enter":
          if (Q.current !== -1 && Ae) {
            const et = Ce[Q.current], yt = S ? S(et) : !1;
            if (Ee.preventDefault(), yt)
              return;
            ke(Ee, et, "selectOption"), r && de.current.setSelectionRange(de.current.value.length, de.current.value.length);
          } else $ && be !== "" && xe === !1 && (D && Ee.preventDefault(), ke(Ee, be, "createOption", "freeSolo"));
          break;
        case "Escape":
          Ae ? (Ee.preventDefault(), Ee.stopPropagation(), We(Ee, "escape")) : l && (be !== "" || D && ie.length > 0) && (Ee.preventDefault(), Ee.stopPropagation(), Mt(Ee));
          break;
        case "Backspace":
          if (D && !Y && be === "" && ie.length > 0) {
            const et = G === -1 ? ie.length - 1 : G, yt = ie.slice();
            yt.splice(et, 1), at(Ee, yt, "removeOption", {
              option: ie[et]
            });
          }
          break;
        case "Delete":
          if (D && !Y && be === "" && ie.length > 0 && G !== -1) {
            const et = G, yt = ie.slice();
            yt.splice(et, 1), at(Ee, yt, "removeOption", {
              option: ie[et]
            });
          }
          break;
      }
  }, On = (Fe) => {
    V(!0), U && !ce.current && Me(Fe);
  }, Hn = (Fe) => {
    if (t(ne)) {
      de.current.focus();
      return;
    }
    V(!1), fe.current = !0, ce.current = !1, i && Q.current !== -1 && Ae ? ke(Fe, Ce[Q.current], "blur") : i && $ && be !== "" ? ke(Fe, be, "blur", "freeSolo") : c && se(Fe, ie, "blur"), We(Fe, "blur");
  }, gn = (Fe) => {
    const Ee = Fe.target.value;
    be !== Ee && (Ie(Ee), Te(!1), z && z(Fe, Ee, "input")), Ee === "" ? !f && !D && at(Fe, null, "clear") : Me(Fe);
  }, Kn = (Fe) => {
    const Ee = Number(Fe.currentTarget.getAttribute("data-option-index"));
    Q.current !== Ee && Ze({
      event: Fe,
      index: Ee,
      reason: "mouse"
    });
  }, To = (Fe) => {
    Ze({
      event: Fe,
      index: Number(Fe.currentTarget.getAttribute("data-option-index")),
      reason: "touch"
    }), Je.current = !0;
  }, _i = (Fe) => {
    const Ee = Number(Fe.currentTarget.getAttribute("data-option-index"));
    ke(Fe, Ce[Ee], "selectOption"), Je.current = !1;
  }, dd = (Fe) => (Ee) => {
    const et = ie.slice();
    et.splice(Fe, 1), at(Ee, et, "removeOption", {
      option: ie[Fe]
    });
  }, pl = (Fe) => {
    we ? We(Fe, "toggleInput") : Me(Fe);
  }, Zp = (Fe) => {
    Fe.currentTarget.contains(Fe.target) && Fe.target.getAttribute("id") !== re && Fe.preventDefault();
  }, Zs = (Fe) => {
    Fe.currentTarget.contains(Fe.target) && (de.current.focus(), X && fe.current && de.current.selectionEnd - de.current.selectionStart === 0 && de.current.select(), fe.current = !1);
  }, er = (Fe) => {
    !v && (be === "" || !we) && pl(Fe);
  };
  let Rn = $ && be.length > 0;
  Rn = Rn || (D ? ie.length > 0 : ie !== null);
  let ii = Ce;
  if (T) {
    const Fe = /* @__PURE__ */ new Map();
    let Ee = !1;
    ii = Ce.reduce((et, yt, bt) => {
      const Xt = T(yt);
      return et.length > 0 && et[et.length - 1].group === Xt ? et[et.length - 1].options.push(yt) : (process.env.NODE_ENV !== "production" && (Fe.get(Xt) && !Ee && (console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${u} returns duplicated headers.`, "You can solve the issue by sorting the options with the output of `groupBy`."), Ee = !0), Fe.set(Xt, !0)), et.push({
        key: bt,
        index: bt,
        group: Xt,
        options: [yt]
      })), et;
    }, []);
  }
  return v && je && Hn(), {
    getRootProps: (Fe = {}) => ({
      "aria-owns": He ? `${re}-listbox` : null,
      ...Fe,
      onKeyDown: Pt(Fe),
      onMouseDown: Zp,
      onClick: Zs
    }),
    getInputLabelProps: () => ({
      id: `${re}-label`,
      htmlFor: re
    }),
    getInputProps: () => ({
      id: re,
      value: be,
      onBlur: Hn,
      onFocus: On,
      onChange: gn,
      onMouseDown: er,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      "aria-activedescendant": Ae ? "" : null,
      "aria-autocomplete": r ? "both" : "list",
      "aria-controls": He ? `${re}-listbox` : void 0,
      "aria-expanded": He,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: "off",
      ref: de,
      autoCapitalize: "none",
      spellCheck: "false",
      role: "combobox",
      disabled: v
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: Mt
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: pl
    }),
    getTagProps: ({
      index: Fe
    }) => ({
      key: Fe,
      "data-tag-index": Fe,
      tabIndex: -1,
      ...!Y && {
        onDelete: dd(Fe)
      }
    }),
    getListboxProps: () => ({
      role: "listbox",
      id: `${re}-listbox`,
      "aria-labelledby": `${re}-label`,
      ref: Ke,
      onMouseDown: (Fe) => {
        Fe.preventDefault();
      }
    }),
    getOptionProps: ({
      index: Fe,
      option: Ee
    }) => {
      const et = (D ? ie : [ie]).some((bt) => bt != null && A(Ee, bt)), yt = S ? S(Ee) : !1;
      return {
        key: (O == null ? void 0 : O(Ee)) ?? Z(Ee),
        tabIndex: -1,
        role: "option",
        id: `${re}-option-${Fe}`,
        onMouseMove: Kn,
        onClick: _i,
        onTouchStart: To,
        "data-option-index": Fe,
        "aria-disabled": yt,
        "aria-selected": et
      };
    },
    id: re,
    inputValue: be,
    value: ie,
    dirty: Rn,
    expanded: Ae && le,
    popupOpen: Ae,
    focused: je || G !== -1,
    anchorEl: le,
    setAnchorEl: ve,
    focusedTag: G,
    groupedOptions: ii
  };
}
var eo = "top", Jo = "bottom", Qo = "right", to = "left", wT = "auto", kp = [eo, Jo, Qo, to], Ou = "start", Bf = "end", Qoe = "clippingParents", EL = "viewport", Id = "popper", eie = "reference", YP = /* @__PURE__ */ kp.reduce(function(e, t) {
  return e.concat([t + "-" + Ou, t + "-" + Bf]);
}, []), _L = /* @__PURE__ */ [].concat(kp, [wT]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Ou, t + "-" + Bf]);
}, []), tie = "beforeRead", nie = "read", rie = "afterRead", oie = "beforeMain", iie = "main", aie = "afterMain", sie = "beforeWrite", cie = "write", lie = "afterWrite", uie = [tie, nie, rie, oie, iie, aie, sie, cie, lie];
function ia(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function So(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Hc(e) {
  var t = So(e).Element;
  return e instanceof t || e instanceof Element;
}
function Zo(e) {
  var t = So(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function $T(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = So(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function die(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, o = t.attributes[n] || {}, i = t.elements[n];
    !Zo(i) || !ia(i) || (Object.assign(i.style, r), Object.keys(o).forEach(function(a) {
      var c = o[a];
      c === !1 ? i.removeAttribute(a) : i.setAttribute(a, c === !0 ? "" : c);
    }));
  });
}
function fie(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var o = t.elements[r], i = t.attributes[r] || {}, a = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), c = a.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !Zo(o) || !ia(o) || (Object.assign(o.style, c), Object.keys(i).forEach(function(l) {
        o.removeAttribute(l);
      }));
    });
  };
}
const pie = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: die,
  effect: fie,
  requires: ["computeStyles"]
};
function Ji(e) {
  return e.split("-")[0];
}
var Nc = Math.max, Mg = Math.min, Su = Math.round;
function rS() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function kL() {
  return !/^((?!chrome|android).)*safari/i.test(rS());
}
function Cu(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), o = 1, i = 1;
  t && Zo(e) && (o = e.offsetWidth > 0 && Su(r.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && Su(r.height) / e.offsetHeight || 1);
  var a = Hc(e) ? So(e) : window, c = a.visualViewport, l = !kL() && n, u = (r.left + (l && c ? c.offsetLeft : 0)) / o, d = (r.top + (l && c ? c.offsetTop : 0)) / i, f = r.width / o, h = r.height / i;
  return {
    width: f,
    height: h,
    top: d,
    right: u + f,
    bottom: d + h,
    left: u,
    x: u,
    y: d
  };
}
function OT(e) {
  var t = Cu(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function RL(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && $T(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Ba(e) {
  return So(e).getComputedStyle(e);
}
function hie(e) {
  return ["table", "td", "th"].indexOf(ia(e)) >= 0;
}
function Ys(e) {
  return ((Hc(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function cv(e) {
  return ia(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    ($T(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Ys(e)
  );
}
function GP(e) {
  return !Zo(e) || // https://github.com/popperjs/popper-core/issues/837
  Ba(e).position === "fixed" ? null : e.offsetParent;
}
function mie(e) {
  var t = /firefox/i.test(rS()), n = /Trident/i.test(rS());
  if (n && Zo(e)) {
    var r = Ba(e);
    if (r.position === "fixed")
      return null;
  }
  var o = cv(e);
  for ($T(o) && (o = o.host); Zo(o) && ["html", "body"].indexOf(ia(o)) < 0; ) {
    var i = Ba(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function Rp(e) {
  for (var t = So(e), n = GP(e); n && hie(n) && Ba(n).position === "static"; )
    n = GP(n);
  return n && (ia(n) === "html" || ia(n) === "body" && Ba(n).position === "static") ? t : n || mie(e) || t;
}
function ST(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function yf(e, t, n) {
  return Nc(e, Mg(t, n));
}
function gie(e, t, n) {
  var r = yf(e, t, n);
  return r > n ? n : r;
}
function PL() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function AL(e) {
  return Object.assign({}, PL(), e);
}
function IL(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var vie = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, AL(typeof t != "number" ? t : IL(t, kp));
};
function yie(e) {
  var t, n = e.state, r = e.name, o = e.options, i = n.elements.arrow, a = n.modifiersData.popperOffsets, c = Ji(n.placement), l = ST(c), u = [to, Qo].indexOf(c) >= 0, d = u ? "height" : "width";
  if (!(!i || !a)) {
    var f = vie(o.padding, n), h = OT(i), v = l === "y" ? eo : to, y = l === "y" ? Jo : Qo, g = n.rects.reference[d] + n.rects.reference[l] - a[l] - n.rects.popper[d], b = a[l] - n.rects.reference[l], x = Rp(i), $ = x ? l === "y" ? x.clientHeight || 0 : x.clientWidth || 0 : 0, S = g / 2 - b / 2, O = f[v], C = $ - h[d] - f[y], T = $ / 2 - h[d] / 2 + S, k = yf(O, T, C), I = l;
    n.modifiersData[r] = (t = {}, t[I] = k, t.centerOffset = k - T, t);
  }
}
function bie(e) {
  var t = e.state, n = e.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || RL(t.elements.popper, o) && (t.elements.arrow = o));
}
const xie = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: yie,
  effect: bie,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Tu(e) {
  return e.split("-")[1];
}
var wie = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function $ie(e, t) {
  var n = e.x, r = e.y, o = t.devicePixelRatio || 1;
  return {
    x: Su(n * o) / o || 0,
    y: Su(r * o) / o || 0
  };
}
function KP(e) {
  var t, n = e.popper, r = e.popperRect, o = e.placement, i = e.variation, a = e.offsets, c = e.position, l = e.gpuAcceleration, u = e.adaptive, d = e.roundOffsets, f = e.isFixed, h = a.x, v = h === void 0 ? 0 : h, y = a.y, g = y === void 0 ? 0 : y, b = typeof d == "function" ? d({
    x: v,
    y: g
  }) : {
    x: v,
    y: g
  };
  v = b.x, g = b.y;
  var x = a.hasOwnProperty("x"), $ = a.hasOwnProperty("y"), S = to, O = eo, C = window;
  if (u) {
    var T = Rp(n), k = "clientHeight", I = "clientWidth";
    if (T === So(n) && (T = Ys(n), Ba(T).position !== "static" && c === "absolute" && (k = "scrollHeight", I = "scrollWidth")), T = T, o === eo || (o === to || o === Qo) && i === Bf) {
      O = Jo;
      var P = f && T === C && C.visualViewport ? C.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        T[k]
      );
      g -= P - r.height, g *= l ? 1 : -1;
    }
    if (o === to || (o === eo || o === Jo) && i === Bf) {
      S = Qo;
      var _ = f && T === C && C.visualViewport ? C.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        T[I]
      );
      v -= _ - r.width, v *= l ? 1 : -1;
    }
  }
  var A = Object.assign({
    position: c
  }, u && wie), D = d === !0 ? $ie({
    x: v,
    y: g
  }, So(n)) : {
    x: v,
    y: g
  };
  if (v = D.x, g = D.y, l) {
    var M;
    return Object.assign({}, A, (M = {}, M[O] = $ ? "0" : "", M[S] = x ? "0" : "", M.transform = (C.devicePixelRatio || 1) <= 1 ? "translate(" + v + "px, " + g + "px)" : "translate3d(" + v + "px, " + g + "px, 0)", M));
  }
  return Object.assign({}, A, (t = {}, t[O] = $ ? g + "px" : "", t[S] = x ? v + "px" : "", t.transform = "", t));
}
function Oie(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, i = n.adaptive, a = i === void 0 ? !0 : i, c = n.roundOffsets, l = c === void 0 ? !0 : c, u = {
    placement: Ji(t.placement),
    variation: Tu(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, KP(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: a,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, KP(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const Sie = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Oie,
  data: {}
};
var Zh = {
  passive: !0
};
function Cie(e) {
  var t = e.state, n = e.instance, r = e.options, o = r.scroll, i = o === void 0 ? !0 : o, a = r.resize, c = a === void 0 ? !0 : a, l = So(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && u.forEach(function(d) {
    d.addEventListener("scroll", n.update, Zh);
  }), c && l.addEventListener("resize", n.update, Zh), function() {
    i && u.forEach(function(d) {
      d.removeEventListener("scroll", n.update, Zh);
    }), c && l.removeEventListener("resize", n.update, Zh);
  };
}
const Tie = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Cie,
  data: {}
};
var Eie = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Qm(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return Eie[t];
  });
}
var _ie = {
  start: "end",
  end: "start"
};
function XP(e) {
  return e.replace(/start|end/g, function(t) {
    return _ie[t];
  });
}
function CT(e) {
  var t = So(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function TT(e) {
  return Cu(Ys(e)).left + CT(e).scrollLeft;
}
function kie(e, t) {
  var n = So(e), r = Ys(e), o = n.visualViewport, i = r.clientWidth, a = r.clientHeight, c = 0, l = 0;
  if (o) {
    i = o.width, a = o.height;
    var u = kL();
    (u || !u && t === "fixed") && (c = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: c + TT(e),
    y: l
  };
}
function Rie(e) {
  var t, n = Ys(e), r = CT(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, i = Nc(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), a = Nc(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), c = -r.scrollLeft + TT(e), l = -r.scrollTop;
  return Ba(o || n).direction === "rtl" && (c += Nc(n.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: a,
    x: c,
    y: l
  };
}
function ET(e) {
  var t = Ba(e), n = t.overflow, r = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function ML(e) {
  return ["html", "body", "#document"].indexOf(ia(e)) >= 0 ? e.ownerDocument.body : Zo(e) && ET(e) ? e : ML(cv(e));
}
function bf(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = ML(e), o = r === ((n = e.ownerDocument) == null ? void 0 : n.body), i = So(r), a = o ? [i].concat(i.visualViewport || [], ET(r) ? r : []) : r, c = t.concat(a);
  return o ? c : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    c.concat(bf(cv(a)))
  );
}
function oS(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Pie(e, t) {
  var n = Cu(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function ZP(e, t, n) {
  return t === EL ? oS(kie(e, n)) : Hc(t) ? Pie(t, n) : oS(Rie(Ys(e)));
}
function Aie(e) {
  var t = bf(cv(e)), n = ["absolute", "fixed"].indexOf(Ba(e).position) >= 0, r = n && Zo(e) ? Rp(e) : e;
  return Hc(r) ? t.filter(function(o) {
    return Hc(o) && RL(o, r) && ia(o) !== "body";
  }) : [];
}
function Iie(e, t, n, r) {
  var o = t === "clippingParents" ? Aie(e) : [].concat(t), i = [].concat(o, [n]), a = i[0], c = i.reduce(function(l, u) {
    var d = ZP(e, u, r);
    return l.top = Nc(d.top, l.top), l.right = Mg(d.right, l.right), l.bottom = Mg(d.bottom, l.bottom), l.left = Nc(d.left, l.left), l;
  }, ZP(e, a, r));
  return c.width = c.right - c.left, c.height = c.bottom - c.top, c.x = c.left, c.y = c.top, c;
}
function NL(e) {
  var t = e.reference, n = e.element, r = e.placement, o = r ? Ji(r) : null, i = r ? Tu(r) : null, a = t.x + t.width / 2 - n.width / 2, c = t.y + t.height / 2 - n.height / 2, l;
  switch (o) {
    case eo:
      l = {
        x: a,
        y: t.y - n.height
      };
      break;
    case Jo:
      l = {
        x: a,
        y: t.y + t.height
      };
      break;
    case Qo:
      l = {
        x: t.x + t.width,
        y: c
      };
      break;
    case to:
      l = {
        x: t.x - n.width,
        y: c
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var u = o ? ST(o) : null;
  if (u != null) {
    var d = u === "y" ? "height" : "width";
    switch (i) {
      case Ou:
        l[u] = l[u] - (t[d] / 2 - n[d] / 2);
        break;
      case Bf:
        l[u] = l[u] + (t[d] / 2 - n[d] / 2);
        break;
    }
  }
  return l;
}
function qf(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = r === void 0 ? e.placement : r, i = n.strategy, a = i === void 0 ? e.strategy : i, c = n.boundary, l = c === void 0 ? Qoe : c, u = n.rootBoundary, d = u === void 0 ? EL : u, f = n.elementContext, h = f === void 0 ? Id : f, v = n.altBoundary, y = v === void 0 ? !1 : v, g = n.padding, b = g === void 0 ? 0 : g, x = AL(typeof b != "number" ? b : IL(b, kp)), $ = h === Id ? eie : Id, S = e.rects.popper, O = e.elements[y ? $ : h], C = Iie(Hc(O) ? O : O.contextElement || Ys(e.elements.popper), l, d, a), T = Cu(e.elements.reference), k = NL({
    reference: T,
    element: S,
    strategy: "absolute",
    placement: o
  }), I = oS(Object.assign({}, S, k)), P = h === Id ? I : T, _ = {
    top: C.top - P.top + x.top,
    bottom: P.bottom - C.bottom + x.bottom,
    left: C.left - P.left + x.left,
    right: P.right - C.right + x.right
  }, A = e.modifiersData.offset;
  if (h === Id && A) {
    var D = A[o];
    Object.keys(_).forEach(function(M) {
      var N = [Qo, Jo].indexOf(M) >= 0 ? 1 : -1, L = [eo, Jo].indexOf(M) >= 0 ? "y" : "x";
      _[M] += D[L] * N;
    });
  }
  return _;
}
function Mie(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, o = n.boundary, i = n.rootBoundary, a = n.padding, c = n.flipVariations, l = n.allowedAutoPlacements, u = l === void 0 ? _L : l, d = Tu(r), f = d ? c ? YP : YP.filter(function(y) {
    return Tu(y) === d;
  }) : kp, h = f.filter(function(y) {
    return u.indexOf(y) >= 0;
  });
  h.length === 0 && (h = f);
  var v = h.reduce(function(y, g) {
    return y[g] = qf(e, {
      placement: g,
      boundary: o,
      rootBoundary: i,
      padding: a
    })[Ji(g)], y;
  }, {});
  return Object.keys(v).sort(function(y, g) {
    return v[y] - v[g];
  });
}
function Nie(e) {
  if (Ji(e) === wT)
    return [];
  var t = Qm(e);
  return [XP(e), t, XP(t)];
}
function Die(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var o = n.mainAxis, i = o === void 0 ? !0 : o, a = n.altAxis, c = a === void 0 ? !0 : a, l = n.fallbackPlacements, u = n.padding, d = n.boundary, f = n.rootBoundary, h = n.altBoundary, v = n.flipVariations, y = v === void 0 ? !0 : v, g = n.allowedAutoPlacements, b = t.options.placement, x = Ji(b), $ = x === b, S = l || ($ || !y ? [Qm(b)] : Nie(b)), O = [b].concat(S).reduce(function(re, Z) {
      return re.concat(Ji(Z) === wT ? Mie(t, {
        placement: Z,
        boundary: d,
        rootBoundary: f,
        padding: u,
        flipVariations: y,
        allowedAutoPlacements: g
      }) : Z);
    }, []), C = t.rects.reference, T = t.rects.popper, k = /* @__PURE__ */ new Map(), I = !0, P = O[0], _ = 0; _ < O.length; _++) {
      var A = O[_], D = Ji(A), M = Tu(A) === Ou, N = [eo, Jo].indexOf(D) >= 0, L = N ? "width" : "height", z = qf(t, {
        placement: A,
        boundary: d,
        rootBoundary: f,
        altBoundary: h,
        padding: u
      }), q = N ? M ? Qo : to : M ? Jo : eo;
      C[L] > T[L] && (q = Qm(q));
      var W = Qm(q), U = [];
      if (i && U.push(z[D] <= 0), c && U.push(z[q] <= 0, z[W] <= 0), U.every(function(re) {
        return re;
      })) {
        P = A, I = !1;
        break;
      }
      k.set(A, U);
    }
    if (I)
      for (var K = y ? 3 : 1, Y = function(Z) {
        var ce = O.find(function(fe) {
          var de = k.get(fe);
          if (de)
            return de.slice(0, Z).every(function(ne) {
              return ne;
            });
        });
        if (ce)
          return P = ce, "break";
      }, X = K; X > 0; X--) {
        var oe = Y(X);
        if (oe === "break") break;
      }
    t.placement !== P && (t.modifiersData[r]._skip = !0, t.placement = P, t.reset = !0);
  }
}
const Lie = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Die,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function JP(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function QP(e) {
  return [eo, Qo, Jo, to].some(function(t) {
    return e[t] >= 0;
  });
}
function jie(e) {
  var t = e.state, n = e.name, r = t.rects.reference, o = t.rects.popper, i = t.modifiersData.preventOverflow, a = qf(t, {
    elementContext: "reference"
  }), c = qf(t, {
    altBoundary: !0
  }), l = JP(a, r), u = JP(c, o, i), d = QP(l), f = QP(u);
  t.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: u,
    isReferenceHidden: d,
    hasPopperEscaped: f
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": f
  });
}
const Fie = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: jie
};
function zie(e, t, n) {
  var r = Ji(e), o = [to, eo].indexOf(r) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, a = i[0], c = i[1];
  return a = a || 0, c = (c || 0) * o, [to, Qo].indexOf(r) >= 0 ? {
    x: c,
    y: a
  } : {
    x: a,
    y: c
  };
}
function Bie(e) {
  var t = e.state, n = e.options, r = e.name, o = n.offset, i = o === void 0 ? [0, 0] : o, a = _L.reduce(function(d, f) {
    return d[f] = zie(f, t.rects, i), d;
  }, {}), c = a[t.placement], l = c.x, u = c.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += u), t.modifiersData[r] = a;
}
const qie = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Bie
};
function Uie(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = NL({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const Wie = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Uie,
  data: {}
};
function Hie(e) {
  return e === "x" ? "y" : "x";
}
function Vie(e) {
  var t = e.state, n = e.options, r = e.name, o = n.mainAxis, i = o === void 0 ? !0 : o, a = n.altAxis, c = a === void 0 ? !1 : a, l = n.boundary, u = n.rootBoundary, d = n.altBoundary, f = n.padding, h = n.tether, v = h === void 0 ? !0 : h, y = n.tetherOffset, g = y === void 0 ? 0 : y, b = qf(t, {
    boundary: l,
    rootBoundary: u,
    padding: f,
    altBoundary: d
  }), x = Ji(t.placement), $ = Tu(t.placement), S = !$, O = ST(x), C = Hie(O), T = t.modifiersData.popperOffsets, k = t.rects.reference, I = t.rects.popper, P = typeof g == "function" ? g(Object.assign({}, t.rects, {
    placement: t.placement
  })) : g, _ = typeof P == "number" ? {
    mainAxis: P,
    altAxis: P
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, P), A = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, D = {
    x: 0,
    y: 0
  };
  if (T) {
    if (i) {
      var M, N = O === "y" ? eo : to, L = O === "y" ? Jo : Qo, z = O === "y" ? "height" : "width", q = T[O], W = q + b[N], U = q - b[L], K = v ? -I[z] / 2 : 0, Y = $ === Ou ? k[z] : I[z], X = $ === Ou ? -I[z] : -k[z], oe = t.elements.arrow, re = v && oe ? OT(oe) : {
        width: 0,
        height: 0
      }, Z = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : PL(), ce = Z[N], fe = Z[L], de = yf(0, k[z], re[z]), ne = S ? k[z] / 2 - K - de - ce - _.mainAxis : Y - de - ce - _.mainAxis, le = S ? -k[z] / 2 + K + de + fe + _.mainAxis : X + de + fe + _.mainAxis, ve = t.elements.arrow && Rp(t.elements.arrow), G = ve ? O === "y" ? ve.clientTop || 0 : ve.clientLeft || 0 : 0, Se = (M = A == null ? void 0 : A[O]) != null ? M : 0, ue = q + ne - Se - G, Q = q + le - Se, ie = yf(v ? Mg(W, ue) : W, q, v ? Nc(U, Q) : U);
      T[O] = ie, D[O] = ie - q;
    }
    if (c) {
      var ee, be = O === "x" ? eo : to, Ie = O === "x" ? Jo : Qo, je = T[C], V = C === "y" ? "height" : "width", se = je + b[be], we = je - b[Ie], J = [eo, to].indexOf(x) !== -1, he = (ee = A == null ? void 0 : A[C]) != null ? ee : 0, Te = J ? se : je - k[V] - I[V] - he + _.altAxis, xe = J ? je + k[V] + I[V] - he - _.altAxis : we, Ae = v && J ? gie(Te, je, xe) : yf(v ? Te : se, je, v ? xe : we);
      T[C] = Ae, D[C] = Ae - je;
    }
    t.modifiersData[r] = D;
  }
}
const Yie = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Vie,
  requiresIfExists: ["offset"]
};
function Gie(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Kie(e) {
  return e === So(e) || !Zo(e) ? CT(e) : Gie(e);
}
function Xie(e) {
  var t = e.getBoundingClientRect(), n = Su(t.width) / e.offsetWidth || 1, r = Su(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function Zie(e, t, n) {
  n === void 0 && (n = !1);
  var r = Zo(t), o = Zo(t) && Xie(t), i = Ys(t), a = Cu(e, o, n), c = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((ia(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  ET(i)) && (c = Kie(t)), Zo(t) ? (l = Cu(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : i && (l.x = TT(i))), {
    x: a.left + c.scrollLeft - l.x,
    y: a.top + c.scrollTop - l.y,
    width: a.width,
    height: a.height
  };
}
function Jie(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function o(i) {
    n.add(i.name);
    var a = [].concat(i.requires || [], i.requiresIfExists || []);
    a.forEach(function(c) {
      if (!n.has(c)) {
        var l = t.get(c);
        l && o(l);
      }
    }), r.push(i);
  }
  return e.forEach(function(i) {
    n.has(i.name) || o(i);
  }), r;
}
function Qie(e) {
  var t = Jie(e);
  return uie.reduce(function(n, r) {
    return n.concat(t.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function eae(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function tae(e) {
  var t = e.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var eA = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function tA() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function nae(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, o = t.defaultOptions, i = o === void 0 ? eA : o;
  return function(c, l, u) {
    u === void 0 && (u = i);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, eA, i),
      modifiersData: {},
      elements: {
        reference: c,
        popper: l
      },
      attributes: {},
      styles: {}
    }, f = [], h = !1, v = {
      state: d,
      setOptions: function(x) {
        var $ = typeof x == "function" ? x(d.options) : x;
        g(), d.options = Object.assign({}, i, d.options, $), d.scrollParents = {
          reference: Hc(c) ? bf(c) : c.contextElement ? bf(c.contextElement) : [],
          popper: bf(l)
        };
        var S = Qie(tae([].concat(r, d.options.modifiers)));
        return d.orderedModifiers = S.filter(function(O) {
          return O.enabled;
        }), y(), v.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var x = d.elements, $ = x.reference, S = x.popper;
          if (tA($, S)) {
            d.rects = {
              reference: Zie($, Rp(S), d.options.strategy === "fixed"),
              popper: OT(S)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(_) {
              return d.modifiersData[_.name] = Object.assign({}, _.data);
            });
            for (var O = 0; O < d.orderedModifiers.length; O++) {
              if (d.reset === !0) {
                d.reset = !1, O = -1;
                continue;
              }
              var C = d.orderedModifiers[O], T = C.fn, k = C.options, I = k === void 0 ? {} : k, P = C.name;
              typeof T == "function" && (d = T({
                state: d,
                options: I,
                name: P,
                instance: v
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: eae(function() {
        return new Promise(function(b) {
          v.forceUpdate(), b(d);
        });
      }),
      destroy: function() {
        g(), h = !0;
      }
    };
    if (!tA(c, l))
      return v;
    v.setOptions(u).then(function(b) {
      !h && u.onFirstUpdate && u.onFirstUpdate(b);
    });
    function y() {
      d.orderedModifiers.forEach(function(b) {
        var x = b.name, $ = b.options, S = $ === void 0 ? {} : $, O = b.effect;
        if (typeof O == "function") {
          var C = O({
            state: d,
            name: x,
            instance: v,
            options: S
          }), T = function() {
          };
          f.push(C || T);
        }
      });
    }
    function g() {
      f.forEach(function(b) {
        return b();
      }), f = [];
    }
    return v;
  };
}
var rae = [Tie, Wie, Sie, pie, qie, Lie, Yie, xie, Fie], oae = /* @__PURE__ */ nae({
  defaultModifiers: rae
});
function iae(e) {
  return typeof e == "function" ? e() : e;
}
const Uf = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const {
    children: r,
    container: o,
    disablePortal: i = !1
  } = t, [a, c] = E.useState(null), l = $n(/* @__PURE__ */ E.isValidElement(r) ? tl(r) : null, n);
  if (Dr(() => {
    i || c(iae(o) || document.body);
  }, [o, i]), Dr(() => {
    if (a && !i)
      return _g(n, a), () => {
        _g(n, null);
      };
  }, [n, a, i]), i) {
    if (/* @__PURE__ */ E.isValidElement(r)) {
      const u = {
        ref: l
      };
      return /* @__PURE__ */ E.cloneElement(r, u);
    }
    return r;
  }
  return a && /* @__PURE__ */ nl.createPortal(r, a);
});
process.env.NODE_ENV !== "production" && (Uf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: s.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: s.oneOfType([ra, s.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: s.bool
});
process.env.NODE_ENV !== "production" && (Uf.propTypes = Yu(Uf.propTypes));
function aae(e) {
  return mt("MuiPopper", e);
}
gt("MuiPopper", ["root"]);
function sae(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function Ng(e) {
  return typeof e == "function" ? e() : e;
}
function lv(e) {
  return e.nodeType !== void 0;
}
function cae(e) {
  return !lv(e);
}
const lae = (e) => {
  const {
    classes: t
  } = e;
  return wt({
    root: ["root"]
  }, aae, t);
}, uae = {}, dae = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const {
    anchorEl: r,
    children: o,
    direction: i,
    disablePortal: a,
    modifiers: c,
    open: l,
    placement: u,
    popperOptions: d,
    popperRef: f,
    slotProps: h = {},
    slots: v = {},
    TransitionProps: y,
    // @ts-ignore internal logic
    ownerState: g,
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...b
  } = t, x = E.useRef(null), $ = $n(x, n), S = E.useRef(null), O = $n(S, f), C = E.useRef(O);
  Dr(() => {
    C.current = O;
  }, [O]), E.useImperativeHandle(f, () => S.current, []);
  const T = sae(u, i), [k, I] = E.useState(T), [P, _] = E.useState(Ng(r));
  E.useEffect(() => {
    S.current && S.current.forceUpdate();
  }), E.useEffect(() => {
    r && _(Ng(r));
  }, [r]), Dr(() => {
    if (!P || !l)
      return;
    const L = (W) => {
      I(W.placement);
    };
    if (process.env.NODE_ENV !== "production" && P && lv(P) && P.nodeType === 1) {
      const W = P.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && W.top === 0 && W.left === 0 && W.right === 0 && W.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let z = [{
      name: "preventOverflow",
      options: {
        altBoundary: a
      }
    }, {
      name: "flip",
      options: {
        altBoundary: a
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: W
      }) => {
        L(W);
      }
    }];
    c != null && (z = z.concat(c)), d && d.modifiers != null && (z = z.concat(d.modifiers));
    const q = oae(P, x.current, {
      placement: T,
      ...d,
      modifiers: z
    });
    return C.current(q), () => {
      q.destroy(), C.current(null);
    };
  }, [P, a, c, l, d, T]);
  const A = {
    placement: k
  };
  y !== null && (A.TransitionProps = y);
  const D = lae(t), M = v.root ?? "div", N = fr({
    elementType: M,
    externalSlotProps: h.root,
    externalForwardedProps: b,
    additionalProps: {
      role: "tooltip",
      ref: $
    },
    ownerState: t,
    className: D.root
  });
  return /* @__PURE__ */ F.jsx(M, {
    ...N,
    children: typeof o == "function" ? o(A) : o
  });
}), DL = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const {
    anchorEl: r,
    children: o,
    container: i,
    direction: a = "ltr",
    disablePortal: c = !1,
    keepMounted: l = !1,
    modifiers: u,
    open: d,
    placement: f = "bottom",
    popperOptions: h = uae,
    popperRef: v,
    style: y,
    transition: g = !1,
    slotProps: b = {},
    slots: x = {},
    ...$
  } = t, [S, O] = E.useState(!0), C = () => {
    O(!1);
  }, T = () => {
    O(!0);
  };
  if (!l && !d && (!g || S))
    return null;
  let k;
  if (i)
    k = i;
  else if (r) {
    const _ = Ng(r);
    k = _ && lv(_) ? Un(_).body : Un(null).body;
  }
  const I = !d && l && (!g || S) ? "none" : void 0, P = g ? {
    in: d,
    onEnter: C,
    onExited: T
  } : void 0;
  return /* @__PURE__ */ F.jsx(Uf, {
    disablePortal: c,
    container: k,
    children: /* @__PURE__ */ F.jsx(dae, {
      anchorEl: r,
      direction: a,
      disablePortal: c,
      modifiers: u,
      ref: n,
      open: g ? !S : d,
      placement: f,
      popperOptions: h,
      popperRef: v,
      slotProps: b,
      slots: x,
      ...$,
      style: {
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: I,
        ...y
      },
      TransitionProps: P,
      children: o
    })
  });
});
process.env.NODE_ENV !== "production" && (DL.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: $o(s.oneOfType([ra, s.object, s.func]), (e) => {
    if (e.open) {
      const t = Ng(e.anchorEl);
      if (t && lv(t) && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || cae(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: s.oneOfType([s.node, s.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: s.oneOfType([ra, s.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: s.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: s.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: s.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: s.arrayOf(s.shape({
    data: s.object,
    effect: s.func,
    enabled: s.bool,
    fn: s.func,
    name: s.any,
    options: s.object,
    phase: s.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: s.arrayOf(s.string),
    requiresIfExists: s.arrayOf(s.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: s.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: s.shape({
    modifiers: s.array,
    onFirstUpdate: s.func,
    placement: s.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: s.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: jr,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: s.shape({
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: s.shape({
    root: s.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: s.bool
});
const fae = Pe(DL, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), uv = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = Ya(), o = $t({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: i,
    component: a,
    components: c,
    componentsProps: l,
    container: u,
    disablePortal: d,
    keepMounted: f,
    modifiers: h,
    open: v,
    placement: y,
    popperOptions: g,
    popperRef: b,
    transition: x,
    slots: $,
    slotProps: S,
    ...O
  } = o, C = ($ == null ? void 0 : $.root) ?? (c == null ? void 0 : c.Root), T = {
    anchorEl: i,
    container: u,
    disablePortal: d,
    keepMounted: f,
    modifiers: h,
    open: v,
    placement: y,
    popperOptions: g,
    popperRef: b,
    transition: x,
    ...O
  };
  return /* @__PURE__ */ F.jsx(fae, {
    as: a,
    direction: r ? "rtl" : "ltr",
    slots: {
      root: C
    },
    slotProps: S ?? l,
    ...T,
    ref: n
  });
});
process.env.NODE_ENV !== "production" && (uv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: s.oneOfType([ra, s.object, s.func]),
  /**
   * Popper render function or node.
   */
  children: s.oneOfType([s.node, s.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  components: s.shape({
    Root: s.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  componentsProps: s.shape({
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: s.oneOfType([ra, s.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: s.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: s.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: s.arrayOf(s.shape({
    data: s.object,
    effect: s.func,
    enabled: s.bool,
    fn: s.func,
    name: s.any,
    options: s.object,
    phase: s.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: s.arrayOf(s.string),
    requiresIfExists: s.arrayOf(s.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: s.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: s.shape({
    modifiers: s.array,
    onFirstUpdate: s.func,
    placement: s.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: s.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: jr,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: s.shape({
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: s.shape({
    root: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: s.bool
});
function pae(e) {
  return mt("MuiListSubheader", e);
}
gt("MuiListSubheader", ["root", "colorPrimary", "colorInherit", "gutters", "inset", "sticky"]);
const hae = (e) => {
  const {
    classes: t,
    color: n,
    disableGutters: r,
    inset: o,
    disableSticky: i
  } = e, a = {
    root: ["root", n !== "default" && `color${Le(n)}`, !r && "gutters", o && "inset", !i && "sticky"]
  };
  return wt(a, pae, t);
}, mae = Pe("li", {
  name: "MuiListSubheader",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "default" && t[`color${Le(n.color)}`], !n.disableGutters && t.gutters, n.inset && t.inset, !n.disableSticky && t.sticky];
  }
})(ct(({
  theme: e
}) => ({
  boxSizing: "border-box",
  lineHeight: "48px",
  listStyle: "none",
  color: (e.vars || e).palette.text.secondary,
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(14),
  variants: [{
    props: {
      color: "primary"
    },
    style: {
      color: (e.vars || e).palette.primary.main
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.inset,
    style: {
      paddingLeft: 72
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableSticky,
    style: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: (e.vars || e).palette.background.paper
    }
  }]
}))), Dg = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiListSubheader"
  }), {
    className: o,
    color: i = "default",
    component: a = "li",
    disableGutters: c = !1,
    disableSticky: l = !1,
    inset: u = !1,
    ...d
  } = r, f = {
    ...r,
    color: i,
    component: a,
    disableGutters: c,
    disableSticky: l,
    inset: u
  }, h = hae(f);
  return /* @__PURE__ */ F.jsx(mae, {
    as: a,
    className: Ge(h.root, o),
    ref: n,
    ownerState: f,
    ...d
  });
});
Dg && (Dg.muiSkipListHighlight = !0);
process.env.NODE_ENV !== "production" && (Dg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */
  color: s.oneOf(["default", "inherit", "primary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */
  disableGutters: s.bool,
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */
  disableSticky: s.bool,
  /**
   * If `true`, the List Subheader is indented.
   * @default false
   */
  inset: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const gae = Oi(/* @__PURE__ */ F.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function vae(e) {
  return mt("MuiChip", e);
}
const Dt = gt("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorDefault", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), yae = (e) => {
  const {
    classes: t,
    disabled: n,
    size: r,
    color: o,
    iconColor: i,
    onDelete: a,
    clickable: c,
    variant: l
  } = e, u = {
    root: ["root", l, n && "disabled", `size${Le(r)}`, `color${Le(o)}`, c && "clickable", c && `clickableColor${Le(o)}`, a && "deletable", a && `deletableColor${Le(o)}`, `${l}${Le(o)}`],
    label: ["label", `label${Le(r)}`],
    avatar: ["avatar", `avatar${Le(r)}`, `avatarColor${Le(o)}`],
    icon: ["icon", `icon${Le(r)}`, `iconColor${Le(i)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${Le(r)}`, `deleteIconColor${Le(o)}`, `deleteIcon${Le(l)}Color${Le(o)}`]
  };
  return wt(u, vae, t);
}, bae = Pe("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      color: r,
      iconColor: o,
      clickable: i,
      onDelete: a,
      size: c,
      variant: l
    } = n;
    return [{
      [`& .${Dt.avatar}`]: t.avatar
    }, {
      [`& .${Dt.avatar}`]: t[`avatar${Le(c)}`]
    }, {
      [`& .${Dt.avatar}`]: t[`avatarColor${Le(r)}`]
    }, {
      [`& .${Dt.icon}`]: t.icon
    }, {
      [`& .${Dt.icon}`]: t[`icon${Le(c)}`]
    }, {
      [`& .${Dt.icon}`]: t[`iconColor${Le(o)}`]
    }, {
      [`& .${Dt.deleteIcon}`]: t.deleteIcon
    }, {
      [`& .${Dt.deleteIcon}`]: t[`deleteIcon${Le(c)}`]
    }, {
      [`& .${Dt.deleteIcon}`]: t[`deleteIconColor${Le(r)}`]
    }, {
      [`& .${Dt.deleteIcon}`]: t[`deleteIcon${Le(l)}Color${Le(r)}`]
    }, t.root, t[`size${Le(c)}`], t[`color${Le(r)}`], i && t.clickable, i && r !== "default" && t[`clickableColor${Le(r)})`], a && t.deletable, a && r !== "default" && t[`deletableColor${Le(r)}`], t[l], t[`${l}${Le(r)}`]];
  }
})(ct(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[700] : e.palette.grey[300];
  return {
    maxWidth: "100%",
    fontFamily: e.typography.fontFamily,
    fontSize: e.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (e.vars || e).palette.text.primary,
    backgroundColor: (e.vars || e).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: e.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${Dt.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${Dt.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : t,
      fontSize: e.typography.pxToRem(12)
    },
    [`& .${Dt.avatarColorPrimary}`]: {
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: (e.vars || e).palette.primary.dark
    },
    [`& .${Dt.avatarColorSecondary}`]: {
      color: (e.vars || e).palette.secondary.contrastText,
      backgroundColor: (e.vars || e).palette.secondary.dark
    },
    [`& .${Dt.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: e.typography.pxToRem(10)
    },
    [`& .${Dt.icon}`]: {
      marginLeft: 5,
      marginRight: -6
    },
    [`& .${Dt.deleteIcon}`]: {
      WebkitTapHighlightColor: "transparent",
      color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)` : It(e.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : It(e.palette.text.primary, 0.4)
      }
    },
    variants: [{
      props: {
        size: "small"
      },
      style: {
        height: 24,
        [`& .${Dt.icon}`]: {
          fontSize: 18,
          marginLeft: 4,
          marginRight: -4
        },
        [`& .${Dt.deleteIcon}`]: {
          fontSize: 16,
          marginRight: 4,
          marginLeft: -4
        }
      }
    }, ...Object.entries(e.palette).filter(Dn(["contrastText"])).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        backgroundColor: (e.vars || e).palette[n].main,
        color: (e.vars || e).palette[n].contrastText,
        [`& .${Dt.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[n].contrastTextChannel} / 0.7)` : It(e.palette[n].contrastText, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[n].contrastText
          }
        }
      }
    })), {
      props: (n) => n.iconColor === n.color,
      style: {
        [`& .${Dt.icon}`]: {
          color: e.vars ? e.vars.palette.Chip.defaultIconColor : t
        }
      }
    }, {
      props: (n) => n.iconColor === n.color && n.color !== "default",
      style: {
        [`& .${Dt.icon}`]: {
          color: "inherit"
        }
      }
    }, {
      props: {
        onDelete: !0
      },
      style: {
        [`&.${Dt.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : It(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        }
      }
    }, ...Object.entries(e.palette).filter(Dn(["dark"])).map(([n]) => ({
      props: {
        color: n,
        onDelete: !0
      },
      style: {
        [`&.${Dt.focusVisible}`]: {
          background: (e.vars || e).palette[n].dark
        }
      }
    })), {
      props: {
        clickable: !0
      },
      style: {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : It(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
        },
        [`&.${Dt.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : It(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[1]
        }
      }
    }, ...Object.entries(e.palette).filter(Dn(["dark"])).map(([n]) => ({
      props: {
        color: n,
        clickable: !0
      },
      style: {
        [`&:hover, &.${Dt.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette[n].dark
        }
      }
    })), {
      props: {
        variant: "outlined"
      },
      style: {
        backgroundColor: "transparent",
        border: e.vars ? `1px solid ${e.vars.palette.Chip.defaultBorder}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[700]}`,
        [`&.${Dt.clickable}:hover`]: {
          backgroundColor: (e.vars || e).palette.action.hover
        },
        [`&.${Dt.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette.action.focus
        },
        [`& .${Dt.avatar}`]: {
          marginLeft: 4
        },
        [`& .${Dt.avatarSmall}`]: {
          marginLeft: 2
        },
        [`& .${Dt.icon}`]: {
          marginLeft: 4
        },
        [`& .${Dt.iconSmall}`]: {
          marginLeft: 2
        },
        [`& .${Dt.deleteIcon}`]: {
          marginRight: 5
        },
        [`& .${Dt.deleteIconSmall}`]: {
          marginRight: 3
        }
      }
    }, ...Object.entries(e.palette).filter(Dn()).map(([n]) => ({
      props: {
        variant: "outlined",
        color: n
      },
      style: {
        color: (e.vars || e).palette[n].main,
        border: `1px solid ${e.vars ? `rgba(${e.vars.palette[n].mainChannel} / 0.7)` : It(e.palette[n].main, 0.7)}`,
        [`&.${Dt.clickable}:hover`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[n].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : It(e.palette[n].main, e.palette.action.hoverOpacity)
        },
        [`&.${Dt.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[n].mainChannel} / ${e.vars.palette.action.focusOpacity})` : It(e.palette[n].main, e.palette.action.focusOpacity)
        },
        [`& .${Dt.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[n].mainChannel} / 0.7)` : It(e.palette[n].main, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[n].main
          }
        }
      }
    }))]
  };
})), xae = Pe("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      size: r
    } = n;
    return [t.label, t[`label${Le(r)}`]];
  }
})({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      variant: "outlined"
    },
    style: {
      paddingLeft: 11,
      paddingRight: 11
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      paddingLeft: 8,
      paddingRight: 8
    }
  }, {
    props: {
      size: "small",
      variant: "outlined"
    },
    style: {
      paddingLeft: 7,
      paddingRight: 7
    }
  }]
});
function nA(e) {
  return e.key === "Backspace" || e.key === "Delete";
}
const LL = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiChip"
  }), {
    avatar: o,
    className: i,
    clickable: a,
    color: c = "default",
    component: l,
    deleteIcon: u,
    disabled: d = !1,
    icon: f,
    label: h,
    onClick: v,
    onDelete: y,
    onKeyDown: g,
    onKeyUp: b,
    size: x = "medium",
    variant: $ = "filled",
    tabIndex: S,
    skipFocusWhenDisabled: O = !1,
    // TODO v6: Rename to `focusableWhenDisabled`.
    ...C
  } = r, T = E.useRef(null), k = $n(T, n), I = (U) => {
    U.stopPropagation(), y && y(U);
  }, P = (U) => {
    U.currentTarget === U.target && nA(U) && U.preventDefault(), g && g(U);
  }, _ = (U) => {
    U.currentTarget === U.target && y && nA(U) && y(U), b && b(U);
  }, A = a !== !1 && v ? !0 : a, D = A || y ? oa : l || "div", M = {
    ...r,
    component: D,
    disabled: d,
    size: x,
    color: c,
    iconColor: /* @__PURE__ */ E.isValidElement(f) && f.props.color || c,
    onDelete: !!y,
    clickable: A,
    variant: $
  }, N = yae(M), L = D === oa ? {
    component: l || "div",
    focusVisibleClassName: N.focusVisible,
    ...y && {
      disableRipple: !0
    }
  } : {};
  let z = null;
  y && (z = u && /* @__PURE__ */ E.isValidElement(u) ? /* @__PURE__ */ E.cloneElement(u, {
    className: Ge(u.props.className, N.deleteIcon),
    onClick: I
  }) : /* @__PURE__ */ F.jsx(gae, {
    className: Ge(N.deleteIcon),
    onClick: I
  }));
  let q = null;
  o && /* @__PURE__ */ E.isValidElement(o) && (q = /* @__PURE__ */ E.cloneElement(o, {
    className: Ge(N.avatar, o.props.className)
  }));
  let W = null;
  return f && /* @__PURE__ */ E.isValidElement(f) && (W = /* @__PURE__ */ E.cloneElement(f, {
    className: Ge(N.icon, f.props.className)
  })), process.env.NODE_ENV !== "production" && q && W && console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one."), /* @__PURE__ */ F.jsxs(bae, {
    as: D,
    className: Ge(N.root, i),
    disabled: A && d ? !0 : void 0,
    onClick: v,
    onKeyDown: P,
    onKeyUp: _,
    ref: k,
    tabIndex: O && d ? -1 : S,
    ownerState: M,
    ...L,
    ...C,
    children: [q || W, /* @__PURE__ */ F.jsx(xae, {
      className: Ge(N.label),
      ownerState: M,
      children: h
    }), z]
  });
});
process.env.NODE_ENV !== "production" && (LL.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: s.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: nL,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: s.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: s.oneOfType([s.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: s.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * Icon element.
   */
  icon: s.element,
  /**
   * The content of the component.
   */
  label: s.node,
  /**
   * @ignore
   */
  onClick: s.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: s.func,
  /**
   * @ignore
   */
  onKeyDown: s.func,
  /**
   * @ignore
   */
  onKeyUp: s.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["medium", "small"]), s.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * @ignore
   */
  tabIndex: s.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: s.oneOfType([s.oneOf(["filled", "outlined"]), s.string])
});
function Jh(e) {
  return parseInt(e, 10) || 0;
}
const wae = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function $ae(e) {
  return e == null || Object.keys(e).length === 0 || e.outerHeightStyle === 0 && !e.overflowing;
}
const jL = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const {
    onChange: r,
    maxRows: o,
    minRows: i = 1,
    style: a,
    value: c,
    ...l
  } = t, {
    current: u
  } = E.useRef(c != null), d = E.useRef(null), f = $n(n, d), h = E.useRef(null), v = E.useRef(null), y = E.useCallback(() => {
    const x = d.current, S = Oo(x).getComputedStyle(x);
    if (S.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    const O = v.current;
    O.style.width = S.width, O.value = x.value || t.placeholder || "x", O.value.slice(-1) === `
` && (O.value += " ");
    const C = S.boxSizing, T = Jh(S.paddingBottom) + Jh(S.paddingTop), k = Jh(S.borderBottomWidth) + Jh(S.borderTopWidth), I = O.scrollHeight;
    O.value = "x";
    const P = O.scrollHeight;
    let _ = I;
    i && (_ = Math.max(Number(i) * P, _)), o && (_ = Math.min(Number(o) * P, _)), _ = Math.max(_, P);
    const A = _ + (C === "border-box" ? T + k : 0), D = Math.abs(_ - I) <= 1;
    return {
      outerHeightStyle: A,
      overflowing: D
    };
  }, [o, i, t.placeholder]), g = E.useCallback(() => {
    const x = y();
    if ($ae(x))
      return;
    const $ = x.outerHeightStyle, S = d.current;
    h.current !== $ && (h.current = $, S.style.height = `${$}px`), S.style.overflow = x.overflowing ? "hidden" : "";
  }, [y]);
  Dr(() => {
    const x = () => {
      g();
    };
    let $;
    const S = () => {
      cancelAnimationFrame($), $ = requestAnimationFrame(() => {
        x();
      });
    }, O = Ep(x), C = d.current, T = Oo(C);
    T.addEventListener("resize", O);
    let k;
    return typeof ResizeObserver < "u" && (k = new ResizeObserver(process.env.NODE_ENV === "test" ? S : x), k.observe(C)), () => {
      O.clear(), cancelAnimationFrame($), T.removeEventListener("resize", O), k && k.disconnect();
    };
  }, [y, g]), Dr(() => {
    g();
  });
  const b = (x) => {
    u || g(), r && r(x);
  };
  return /* @__PURE__ */ F.jsxs(E.Fragment, {
    children: [/* @__PURE__ */ F.jsx("textarea", {
      value: c,
      onChange: b,
      ref: f,
      rows: i,
      style: a,
      ...l
    }), /* @__PURE__ */ F.jsx("textarea", {
      "aria-hidden": !0,
      className: t.className,
      readOnly: !0,
      ref: v,
      tabIndex: -1,
      style: {
        ...wae.shadow,
        ...a,
        paddingTop: 0,
        paddingBottom: 0
      }
    })]
  });
});
process.env.NODE_ENV !== "production" && (jL.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: s.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: s.oneOfType([s.number, s.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: s.oneOfType([s.number, s.string]),
  /**
   * @ignore
   */
  onChange: s.func,
  /**
   * @ignore
   */
  placeholder: s.string,
  /**
   * @ignore
   */
  style: s.object,
  /**
   * @ignore
   */
  value: s.oneOfType([s.arrayOf(s.string), s.number, s.string])
});
function Dc(e) {
  return typeof e == "string";
}
function Ku({
  props: e,
  states: t,
  muiFormControl: n
}) {
  return t.reduce((r, o) => (r[o] = e[o], n && typeof e[o] > "u" && (r[o] = n[o]), r), {});
}
const dv = /* @__PURE__ */ E.createContext(void 0);
process.env.NODE_ENV !== "production" && (dv.displayName = "FormControlContext");
function Gs() {
  return E.useContext(dv);
}
function rA(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
function Lg(e, t = !1) {
  return e && (rA(e.value) && e.value !== "" || t && rA(e.defaultValue) && e.defaultValue !== "");
}
function Oae(e) {
  return e.startAdornment;
}
function Sae(e) {
  return mt("MuiInputBase", e);
}
const ho = gt("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]);
var oA;
const fv = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.formControl && t.formControl, n.startAdornment && t.adornedStart, n.endAdornment && t.adornedEnd, n.error && t.error, n.size === "small" && t.sizeSmall, n.multiline && t.multiline, n.color && t[`color${Le(n.color)}`], n.fullWidth && t.fullWidth, n.hiddenLabel && t.hiddenLabel];
}, pv = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.input, n.size === "small" && t.inputSizeSmall, n.multiline && t.inputMultiline, n.type === "search" && t.inputTypeSearch, n.startAdornment && t.inputAdornedStart, n.endAdornment && t.inputAdornedEnd, n.hiddenLabel && t.inputHiddenLabel];
}, Cae = (e) => {
  const {
    classes: t,
    color: n,
    disabled: r,
    error: o,
    endAdornment: i,
    focused: a,
    formControl: c,
    fullWidth: l,
    hiddenLabel: u,
    multiline: d,
    readOnly: f,
    size: h,
    startAdornment: v,
    type: y
  } = e, g = {
    root: ["root", `color${Le(n)}`, r && "disabled", o && "error", l && "fullWidth", a && "focused", c && "formControl", h && h !== "medium" && `size${Le(h)}`, d && "multiline", v && "adornedStart", i && "adornedEnd", u && "hiddenLabel", f && "readOnly"],
    input: ["input", r && "disabled", y === "search" && "inputTypeSearch", d && "inputMultiline", h === "small" && "inputSizeSmall", u && "inputHiddenLabel", v && "inputAdornedStart", i && "inputAdornedEnd", f && "readOnly"]
  };
  return wt(g, Sae, t);
}, hv = Pe("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: fv
})(ct(({
  theme: e
}) => ({
  ...e.typography.body1,
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${ho.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      padding: "4px 0 5px"
    }
  }, {
    props: ({
      ownerState: t,
      size: n
    }) => t.multiline && n === "small",
    style: {
      paddingTop: 1
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      width: "100%"
    }
  }]
}))), mv = Pe("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: pv
})(ct(({
  theme: e
}) => {
  const t = e.palette.mode === "light", n = {
    color: "currentColor",
    ...e.vars ? {
      opacity: e.vars.opacity.inputPlaceholder
    } : {
      opacity: t ? 0.42 : 0.5
    },
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }, r = {
    opacity: "0 !important"
  }, o = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: t ? 0.42 : 0.5
  };
  return {
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    "&::-webkit-input-placeholder": n,
    "&::-moz-placeholder": n,
    // Firefox 19+
    "&::-ms-input-placeholder": n,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${ho.formControl} &`]: {
      "&::-webkit-input-placeholder": r,
      "&::-moz-placeholder": r,
      // Firefox 19+
      "&::-ms-input-placeholder": r,
      // Edge
      "&:focus::-webkit-input-placeholder": o,
      "&:focus::-moz-placeholder": o,
      // Firefox 19+
      "&:focus::-ms-input-placeholder": o
      // Edge
    },
    [`&.${ho.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    variants: [{
      props: ({
        ownerState: i
      }) => !i.disableInjectingGlobalStyles,
      style: {
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&:-webkit-autofill": {
          animationDuration: "5000s",
          animationName: "mui-auto-fill"
        }
      }
    }, {
      props: {
        size: "small"
      },
      style: {
        paddingTop: 1
      }
    }, {
      props: ({
        ownerState: i
      }) => i.multiline,
      style: {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
      }
    }, {
      props: {
        type: "search"
      },
      style: {
        MozAppearance: "textfield"
        // Improve type search style.
      }
    }]
  };
})), iA = gT({
  "@keyframes mui-auto-fill": {
    from: {
      display: "block"
    }
  },
  "@keyframes mui-auto-fill-cancel": {
    from: {
      display: "block"
    }
  }
}), gv = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiInputBase"
  }), {
    "aria-describedby": o,
    autoComplete: i,
    autoFocus: a,
    className: c,
    color: l,
    components: u = {},
    componentsProps: d = {},
    defaultValue: f,
    disabled: h,
    disableInjectingGlobalStyles: v,
    endAdornment: y,
    error: g,
    fullWidth: b = !1,
    id: x,
    inputComponent: $ = "input",
    inputProps: S = {},
    inputRef: O,
    margin: C,
    maxRows: T,
    minRows: k,
    multiline: I = !1,
    name: P,
    onBlur: _,
    onChange: A,
    onClick: D,
    onFocus: M,
    onKeyDown: N,
    onKeyUp: L,
    placeholder: z,
    readOnly: q,
    renderSuffix: W,
    rows: U,
    size: K,
    slotProps: Y = {},
    slots: X = {},
    startAdornment: oe,
    type: re = "text",
    value: Z,
    ...ce
  } = r, fe = S.value != null ? S.value : Z, {
    current: de
  } = E.useRef(fe != null), ne = E.useRef(), le = E.useCallback((He) => {
    process.env.NODE_ENV !== "production" && He && He.nodeName !== "INPUT" && !He.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), ve = $n(ne, O, S.ref, le), [G, Se] = E.useState(!1), ue = Gs();
  process.env.NODE_ENV !== "production" && E.useEffect(() => {
    if (ue)
      return ue.registerEffect();
  }, [ue]);
  const Q = Ku({
    props: r,
    muiFormControl: ue,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  Q.focused = ue ? ue.focused : G, E.useEffect(() => {
    !ue && h && G && (Se(!1), _ && _());
  }, [ue, h, G, _]);
  const ie = ue && ue.onFilled, ee = ue && ue.onEmpty, be = E.useCallback((He) => {
    Lg(He) ? ie && ie() : ee && ee();
  }, [ie, ee]);
  Dr(() => {
    de && be({
      value: fe
    });
  }, [fe, be, de]);
  const Ie = (He) => {
    M && M(He), S.onFocus && S.onFocus(He), ue && ue.onFocus ? ue.onFocus(He) : Se(!0);
  }, je = (He) => {
    _ && _(He), S.onBlur && S.onBlur(He), ue && ue.onBlur ? ue.onBlur(He) : Se(!1);
  }, V = (He, ...Be) => {
    if (!de) {
      const Xe = He.target || ne.current;
      if (Xe == null)
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : na(1));
      be({
        value: Xe.value
      });
    }
    S.onChange && S.onChange(He, ...Be), A && A(He, ...Be);
  };
  E.useEffect(() => {
    be(ne.current);
  }, []);
  const se = (He) => {
    ne.current && He.currentTarget === He.target && ne.current.focus(), D && D(He);
  };
  let we = $, J = S;
  I && we === "input" && (U ? (process.env.NODE_ENV !== "production" && (k || T) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), J = {
    type: void 0,
    minRows: U,
    maxRows: U,
    ...J
  }) : J = {
    type: void 0,
    maxRows: T,
    minRows: k,
    ...J
  }, we = jL);
  const he = (He) => {
    be(He.animationName === "mui-auto-fill-cancel" ? ne.current : {
      value: "x"
    });
  };
  E.useEffect(() => {
    ue && ue.setAdornedStart(!!oe);
  }, [ue, oe]);
  const Te = {
    ...r,
    color: Q.color || "primary",
    disabled: Q.disabled,
    endAdornment: y,
    error: Q.error,
    focused: Q.focused,
    formControl: ue,
    fullWidth: b,
    hiddenLabel: Q.hiddenLabel,
    multiline: I,
    size: Q.size,
    startAdornment: oe,
    type: re
  }, xe = Cae(Te), Ae = X.root || u.Root || hv, Ce = Y.root || d.root || {}, Ye = X.input || u.Input || mv;
  return J = {
    ...J,
    ...Y.input ?? d.input
  }, /* @__PURE__ */ F.jsxs(E.Fragment, {
    children: [!v && typeof iA == "function" && // For Emotion/Styled-components, InputGlobalStyles will be a function
    // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
    (oA || (oA = /* @__PURE__ */ F.jsx(iA, {}))), /* @__PURE__ */ F.jsxs(Ae, {
      ...Ce,
      ref: n,
      onClick: se,
      ...ce,
      ...!Dc(Ae) && {
        ownerState: {
          ...Te,
          ...Ce.ownerState
        }
      },
      className: Ge(xe.root, Ce.className, c, q && "MuiInputBase-readOnly"),
      children: [oe, /* @__PURE__ */ F.jsx(dv.Provider, {
        value: null,
        children: /* @__PURE__ */ F.jsx(Ye, {
          "aria-invalid": Q.error,
          "aria-describedby": o,
          autoComplete: i,
          autoFocus: a,
          defaultValue: f,
          disabled: Q.disabled,
          id: x,
          onAnimationStart: he,
          name: P,
          placeholder: z,
          readOnly: q,
          required: Q.required,
          rows: U,
          value: fe,
          onKeyDown: N,
          onKeyUp: L,
          type: re,
          ...J,
          ...!Dc(Ye) && {
            as: we,
            ownerState: {
              ...Te,
              ...J.ownerState
            }
          },
          ref: ve,
          className: Ge(xe.input, J.className, q && "MuiInputBase-readOnly"),
          onBlur: je,
          onChange: V,
          onFocus: Ie
        })
      }), y, W ? W({
        ...Q,
        startAdornment: oe
      }) : null]
    })]
  });
});
process.env.NODE_ENV !== "production" && (gv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": s.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: s.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    Input: s.elementType,
    Root: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: s.shape({
    input: s.object,
    root: s.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: s.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: s.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: s.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: s.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The id of the `input` element.
   */
  id: s.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: aT,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: jr,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: s.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: s.oneOfType([s.number, s.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: s.oneOfType([s.number, s.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: s.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: s.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: s.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * @ignore
   */
  onClick: s.func,
  /**
   * @ignore
   */
  onFocus: s.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: s.func,
  /**
   * @ignore
   */
  onKeyDown: s.func,
  /**
   * @ignore
   */
  onKeyUp: s.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: s.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: s.bool,
  /**
   * @ignore
   */
  renderSuffix: s.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: s.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: s.oneOfType([s.number, s.string]),
  /**
   * The size of the component.
   */
  size: s.oneOfType([s.oneOf(["medium", "small"]), s.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: s.shape({
    input: s.object,
    root: s.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: s.shape({
    input: s.elementType,
    root: s.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: s.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: s.any
});
function Tae(e) {
  return mt("MuiInput", e);
}
const xs = {
  ...ho,
  ...gt("MuiInput", ["root", "underline", "input"])
};
function Eae(e) {
  return mt("MuiOutlinedInput", e);
}
const zo = {
  ...ho,
  ...gt("MuiOutlinedInput", ["root", "notchedOutline", "input"])
};
function _ae(e) {
  return mt("MuiFilledInput", e);
}
const mo = {
  ...ho,
  ...gt("MuiFilledInput", ["root", "underline", "input", "adornedStart", "adornedEnd", "sizeSmall", "multiline", "hiddenLabel"])
}, FL = Oi(/* @__PURE__ */ F.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function kae(e) {
  return mt("MuiAutocomplete", e);
}
const kt = gt("MuiAutocomplete", ["root", "expanded", "fullWidth", "focused", "focusVisible", "tag", "tagSizeSmall", "tagSizeMedium", "hasPopupIcon", "hasClearIcon", "inputRoot", "input", "inputFocused", "endAdornment", "clearIndicator", "popupIndicator", "popupIndicatorOpen", "popper", "popperDisablePortal", "paper", "listbox", "loading", "noOptions", "option", "groupLabel", "groupUl"]);
var aA, sA;
const Rae = (e) => {
  const {
    classes: t,
    disablePortal: n,
    expanded: r,
    focused: o,
    fullWidth: i,
    hasClearIcon: a,
    hasPopupIcon: c,
    inputFocused: l,
    popupOpen: u,
    size: d
  } = e, f = {
    root: ["root", r && "expanded", o && "focused", i && "fullWidth", a && "hasClearIcon", c && "hasPopupIcon"],
    inputRoot: ["inputRoot"],
    input: ["input", l && "inputFocused"],
    tag: ["tag", `tagSize${Le(d)}`],
    endAdornment: ["endAdornment"],
    clearIndicator: ["clearIndicator"],
    popupIndicator: ["popupIndicator", u && "popupIndicatorOpen"],
    popper: ["popper", n && "popperDisablePortal"],
    paper: ["paper"],
    listbox: ["listbox"],
    loading: ["loading"],
    noOptions: ["noOptions"],
    option: ["option"],
    groupLabel: ["groupLabel"],
    groupUl: ["groupUl"]
  };
  return wt(f, kae, t);
}, Pae = Pe("div", {
  name: "MuiAutocomplete",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      fullWidth: r,
      hasClearIcon: o,
      hasPopupIcon: i,
      inputFocused: a,
      size: c
    } = n;
    return [{
      [`& .${kt.tag}`]: t.tag
    }, {
      [`& .${kt.tag}`]: t[`tagSize${Le(c)}`]
    }, {
      [`& .${kt.inputRoot}`]: t.inputRoot
    }, {
      [`& .${kt.input}`]: t.input
    }, {
      [`& .${kt.input}`]: a && t.inputFocused
    }, t.root, r && t.fullWidth, i && t.hasPopupIcon, o && t.hasClearIcon];
  }
})({
  [`&.${kt.focused} .${kt.clearIndicator}`]: {
    visibility: "visible"
  },
  /* Avoid double tap issue on iOS */
  "@media (pointer: fine)": {
    [`&:hover .${kt.clearIndicator}`]: {
      visibility: "visible"
    }
  },
  [`& .${kt.tag}`]: {
    margin: 3,
    maxWidth: "calc(100% - 6px)"
  },
  [`& .${kt.inputRoot}`]: {
    [`.${kt.hasPopupIcon}&, .${kt.hasClearIcon}&`]: {
      paddingRight: 30
    },
    [`.${kt.hasPopupIcon}.${kt.hasClearIcon}&`]: {
      paddingRight: 56
    },
    [`& .${kt.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${xs.root}`]: {
    paddingBottom: 1,
    "& .MuiInput-input": {
      padding: "4px 4px 4px 0px"
    }
  },
  [`& .${xs.root}.${ho.sizeSmall}`]: {
    [`& .${xs.input}`]: {
      padding: "2px 4px 3px 0"
    }
  },
  [`& .${zo.root}`]: {
    padding: 9,
    [`.${kt.hasPopupIcon}&, .${kt.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${kt.hasPopupIcon}.${kt.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${kt.input}`]: {
      padding: "7.5px 4px 7.5px 5px"
    },
    [`& .${kt.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${zo.root}.${ho.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${kt.input}`]: {
      padding: "2.5px 4px 2.5px 8px"
    }
  },
  [`& .${mo.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${kt.hasPopupIcon}&, .${kt.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${kt.hasPopupIcon}.${kt.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${mo.input}`]: {
      padding: "7px 4px"
    },
    [`& .${kt.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${mo.root}.${ho.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${mo.input}`]: {
      padding: "2.5px 4px"
    }
  },
  [`& .${ho.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${mo.root}.${ho.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${kt.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${mo.root}.${ho.hiddenLabel}.${ho.sizeSmall}`]: {
    [`& .${kt.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${kt.input}`]: {
    flexGrow: 1,
    textOverflow: "ellipsis",
    opacity: 0
  },
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      [`& .${kt.tag}`]: {
        margin: 2,
        maxWidth: "calc(100% - 4px)"
      }
    }
  }, {
    props: {
      inputFocused: !0
    },
    style: {
      [`& .${kt.input}`]: {
        opacity: 1
      }
    }
  }, {
    props: {
      multiple: !0
    },
    style: {
      [`& .${kt.inputRoot}`]: {
        flexWrap: "wrap"
      }
    }
  }]
}), Aae = Pe("div", {
  name: "MuiAutocomplete",
  slot: "EndAdornment",
  overridesResolver: (e, t) => t.endAdornment
})({
  // We use a position absolute to support wrapping tags.
  position: "absolute",
  right: 0,
  top: "50%",
  transform: "translate(0, -50%)"
}), Iae = Pe(xT, {
  name: "MuiAutocomplete",
  slot: "ClearIndicator",
  overridesResolver: (e, t) => t.clearIndicator
})({
  marginRight: -2,
  padding: 4,
  visibility: "hidden"
}), Mae = Pe(xT, {
  name: "MuiAutocomplete",
  slot: "PopupIndicator",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.popupIndicator, n.popupOpen && t.popupIndicatorOpen];
  }
})({
  padding: 2,
  marginRight: -2,
  variants: [{
    props: {
      popupOpen: !0
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}), Nae = Pe(uv, {
  name: "MuiAutocomplete",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${kt.option}`]: t.option
    }, t.popper, n.disablePortal && t.popperDisablePortal];
  }
})(ct(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.modal,
  variants: [{
    props: {
      disablePortal: !0
    },
    style: {
      position: "absolute"
    }
  }]
}))), Dae = Pe(_p, {
  name: "MuiAutocomplete",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})(ct(({
  theme: e
}) => ({
  ...e.typography.body1,
  overflow: "auto"
}))), Lae = Pe("div", {
  name: "MuiAutocomplete",
  slot: "Loading",
  overridesResolver: (e, t) => t.loading
})(ct(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
}))), jae = Pe("div", {
  name: "MuiAutocomplete",
  slot: "NoOptions",
  overridesResolver: (e, t) => t.noOptions
})(ct(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
}))), Fae = Pe("ul", {
  name: "MuiAutocomplete",
  slot: "Listbox",
  overridesResolver: (e, t) => t.listbox
})(ct(({
  theme: e
}) => ({
  listStyle: "none",
  margin: 0,
  padding: "8px 0",
  maxHeight: "40vh",
  overflow: "auto",
  position: "relative",
  [`& .${kt.option}`]: {
    minHeight: 48,
    display: "flex",
    overflow: "hidden",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: 6,
    boxSizing: "border-box",
    outline: "0",
    WebkitTapHighlightColor: "transparent",
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [e.breakpoints.up("sm")]: {
      minHeight: "auto"
    },
    [`&.${kt.focused}`]: {
      backgroundColor: (e.vars || e).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`&.${kt.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : It(e.palette.primary.main, e.palette.action.selectedOpacity),
      [`&.${kt.focused}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : It(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: (e.vars || e).palette.action.selected
        }
      },
      [`&.${kt.focusVisible}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : It(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
      }
    }
  }
}))), zae = Pe(Dg, {
  name: "MuiAutocomplete",
  slot: "GroupLabel",
  overridesResolver: (e, t) => t.groupLabel
})(ct(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  top: -8
}))), Bae = Pe("ul", {
  name: "MuiAutocomplete",
  slot: "GroupUl",
  overridesResolver: (e, t) => t.groupUl
})({
  padding: 0,
  [`& .${kt.option}`]: {
    paddingLeft: 24
  }
}), qae = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiAutocomplete"
  }), {
    autoComplete: o = !1,
    autoHighlight: i = !1,
    autoSelect: a = !1,
    blurOnSelect: c = !1,
    ChipProps: l,
    className: u,
    clearIcon: d = aA || (aA = /* @__PURE__ */ F.jsx(qoe, {
      fontSize: "small"
    })),
    clearOnBlur: f = !r.freeSolo,
    clearOnEscape: h = !1,
    clearText: v = "Clear",
    closeText: y = "Close",
    componentsProps: g,
    defaultValue: b = r.multiple ? [] : null,
    disableClearable: x = !1,
    disableCloseOnSelect: $ = !1,
    disabled: S = !1,
    disabledItemsFocusable: O = !1,
    disableListWrap: C = !1,
    disablePortal: T = !1,
    filterOptions: k,
    filterSelectedOptions: I = !1,
    forcePopupIcon: P = "auto",
    freeSolo: _ = !1,
    fullWidth: A = !1,
    getLimitTagsText: D = (Lt) => `+${Lt}`,
    getOptionDisabled: M,
    getOptionKey: N,
    getOptionLabel: L,
    isOptionEqualToValue: z,
    groupBy: q,
    handleHomeEndKeys: W = !r.freeSolo,
    id: U,
    includeInputInList: K = !1,
    inputValue: Y,
    limitTags: X = -1,
    ListboxComponent: oe,
    ListboxProps: re,
    loading: Z = !1,
    loadingText: ce = "Loading…",
    multiple: fe = !1,
    noOptionsText: de = "No options",
    onChange: ne,
    onClose: le,
    onHighlightChange: ve,
    onInputChange: G,
    onOpen: Se,
    open: ue,
    openOnFocus: Q = !1,
    openText: ie = "Open",
    options: ee,
    PaperComponent: be,
    PopperComponent: Ie,
    popupIcon: je = sA || (sA = /* @__PURE__ */ F.jsx(FL, {})),
    readOnly: V = !1,
    renderGroup: se,
    renderInput: we,
    renderOption: J,
    renderTags: he,
    selectOnFocus: Te = !r.freeSolo,
    size: xe = "medium",
    slots: Ae = {},
    slotProps: Ce = {},
    value: Ye,
    ...He
  } = r, {
    getRootProps: Be,
    getInputProps: Xe,
    getInputLabelProps: Ze,
    getPopupIndicatorProps: Ne,
    getClearProps: $e,
    getTagProps: Ue,
    getListboxProps: Ke,
    getOptionProps: Me,
    value: We,
    dirty: at,
    expanded: Je,
    id: ke,
    popupOpen: Qe,
    focused: ot,
    focusedTag: Mt,
    anchorEl: Pt,
    setAnchorEl: On,
    inputValue: Hn,
    groupedOptions: gn
  } = Joe({
    ...r,
    componentName: "Autocomplete"
  }), Kn = !x && !S && at && !V, To = (!_ || P === !0) && P !== !1, {
    onMouseDown: _i
  } = Xe(), {
    ref: dd,
    ...pl
  } = Ke(), Zs = L || ((Lt) => Lt.label ?? Lt), er = {
    ...r,
    disablePortal: T,
    expanded: Je,
    focused: ot,
    fullWidth: A,
    getOptionLabel: Zs,
    hasClearIcon: Kn,
    hasPopupIcon: To,
    inputFocused: Mt === -1,
    popupOpen: Qe,
    size: xe
  }, Rn = Rae(er), ii = {
    slots: {
      paper: be,
      popper: Ie,
      ...Ae
    },
    slotProps: {
      chip: l,
      listbox: re,
      ...g,
      ...Ce
    }
  }, [Fe, Ee] = Mr("listbox", {
    elementType: Fae,
    externalForwardedProps: ii,
    ownerState: er,
    className: Rn.listbox,
    additionalProps: pl,
    ref: dd
  }), [et, yt] = Mr("paper", {
    elementType: _p,
    externalForwardedProps: ii,
    ownerState: er,
    className: Rn.paper
  }), [bt, Xt] = Mr("popper", {
    elementType: uv,
    externalForwardedProps: ii,
    ownerState: er,
    className: Rn.popper,
    additionalProps: {
      disablePortal: T,
      style: {
        width: Pt ? Pt.clientWidth : null
      },
      role: "presentation",
      anchorEl: Pt,
      open: Qe
    }
  });
  let Wt;
  if (fe && We.length > 0) {
    const Lt = (Eo) => ({
      className: Rn.tag,
      disabled: S,
      ...Ue(Eo)
    });
    he ? Wt = he(We, Lt, er) : Wt = We.map((Eo, ki) => {
      const {
        key: Qs,
        ...Ty
      } = Lt({
        index: ki
      });
      return /* @__PURE__ */ F.jsx(LL, {
        label: Zs(Eo),
        size: xe,
        ...Ty,
        ...ii.slotProps.chip
      }, Qs);
    });
  }
  if (X > -1 && Array.isArray(Wt)) {
    const Lt = Wt.length - X;
    !ot && Lt > 0 && (Wt = Wt.splice(0, X), Wt.push(/* @__PURE__ */ F.jsx("span", {
      className: Rn.tag,
      children: D(Lt)
    }, Wt.length)));
  }
  const ai = se || ((Lt) => /* @__PURE__ */ F.jsxs("li", {
    children: [/* @__PURE__ */ F.jsx(zae, {
      className: Rn.groupLabel,
      ownerState: er,
      component: "div",
      children: Lt.group
    }), /* @__PURE__ */ F.jsx(Bae, {
      className: Rn.groupUl,
      ownerState: er,
      children: Lt.children
    })]
  }, Lt.key)), hl = J || ((Lt, Eo) => {
    const {
      key: ki,
      ...Qs
    } = Lt;
    return /* @__PURE__ */ F.jsx("li", {
      ...Qs,
      children: Zs(Eo)
    }, ki);
  }), Jp = (Lt, Eo) => {
    const ki = Me({
      option: Lt,
      index: Eo
    });
    return hl({
      ...ki,
      className: Rn.option
    }, Lt, {
      selected: ki["aria-selected"],
      index: Eo,
      inputValue: Hn
    }, er);
  }, ml = ii.slotProps.clearIndicator, gl = ii.slotProps.popupIndicator, vl = (Lt) => /* @__PURE__ */ F.jsx(Nae, {
    as: bt,
    ...Xt,
    children: /* @__PURE__ */ F.jsx(Dae, {
      as: et,
      ...yt,
      children: Lt
    })
  });
  let Js = null;
  return gn.length > 0 ? Js = vl(
    // TODO v7: remove `as` prop and move ListboxComponentProp to externalForwardedProps or remove ListboxComponentProp entirely
    // https://github.com/mui/material-ui/pull/43994#issuecomment-2401945800
    /* @__PURE__ */ F.jsx(Fe, {
      as: oe,
      ...Ee,
      children: gn.map((Lt, Eo) => q ? ai({
        key: Lt.key,
        group: Lt.group,
        children: Lt.options.map((ki, Qs) => Jp(ki, Lt.index + Qs))
      }) : Jp(Lt, Eo))
    })
  ) : Z && gn.length === 0 ? Js = vl(/* @__PURE__ */ F.jsx(Lae, {
    className: Rn.loading,
    ownerState: er,
    children: ce
  })) : gn.length === 0 && !_ && !Z && (Js = vl(/* @__PURE__ */ F.jsx(jae, {
    className: Rn.noOptions,
    ownerState: er,
    role: "presentation",
    onMouseDown: (Lt) => {
      Lt.preventDefault();
    },
    children: de
  }))), /* @__PURE__ */ F.jsxs(E.Fragment, {
    children: [/* @__PURE__ */ F.jsx(Pae, {
      ref: n,
      className: Ge(Rn.root, u),
      ownerState: er,
      ...Be(He),
      children: we({
        id: ke,
        disabled: S,
        fullWidth: !0,
        size: xe === "small" ? "small" : void 0,
        InputLabelProps: Ze(),
        InputProps: {
          ref: On,
          className: Rn.inputRoot,
          startAdornment: Wt,
          onMouseDown: (Lt) => {
            Lt.target === Lt.currentTarget && _i(Lt);
          },
          ...(Kn || To) && {
            endAdornment: /* @__PURE__ */ F.jsxs(Aae, {
              className: Rn.endAdornment,
              ownerState: er,
              children: [Kn ? /* @__PURE__ */ F.jsx(Iae, {
                ...$e(),
                "aria-label": v,
                title: v,
                ownerState: er,
                ...ml,
                className: Ge(Rn.clearIndicator, ml == null ? void 0 : ml.className),
                children: d
              }) : null, To ? /* @__PURE__ */ F.jsx(Mae, {
                ...Ne(),
                disabled: S,
                "aria-label": Qe ? y : ie,
                title: Qe ? y : ie,
                ownerState: er,
                ...gl,
                className: Ge(Rn.popupIndicator, gl == null ? void 0 : gl.className),
                children: je
              }) : null]
            })
          }
        },
        inputProps: {
          className: Rn.input,
          disabled: S,
          readOnly: V,
          ...Xe()
        }
      })
    }), Pt ? Js : null]
  });
});
process.env.NODE_ENV !== "production" && (qae.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the portion of the selected suggestion that the user hasn't typed,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */
  autoComplete: s.bool,
  /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */
  autoHighlight: s.bool,
  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   *
   * When using the `freeSolo` mode, the typed value will be the input value
   * if the Autocomplete loses focus without highlighting an option.
   * @default false
   */
  autoSelect: s.bool,
  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */
  blurOnSelect: s.oneOfType([s.oneOf(["mouse", "touch"]), s.bool]),
  /**
   * Props applied to the [`Chip`](https://mui.com/material-ui/api/chip/) element.
   * @deprecated Use `slotProps.chip` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ChipProps: s.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */
  clearIcon: s.node,
  /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set it to `true` if you want to help the user enter a new value.
   * Set it to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */
  clearOnBlur: s.bool,
  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */
  clearOnEscape: s.bool,
  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Clear'
   */
  clearText: s.string,
  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: s.string,
  /**
   * The props used for each slot inside.
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: s.shape({
    clearIndicator: s.object,
    paper: s.object,
    popper: s.object,
    popupIndicator: s.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */
  defaultValue: $o(s.any, (e) => e.multiple && e.defaultValue !== void 0 && !Array.isArray(e.defaultValue) ? new Error(["MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.", `However, ${e.defaultValue} was provided.`].join(`
`)) : null),
  /**
   * If `true`, the input can't be cleared.
   * @default false
   */
  disableClearable: s.bool,
  /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */
  disableCloseOnSelect: s.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: s.bool,
  /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */
  disableListWrap: s.bool,
  /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: s.bool,
  /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */
  filterOptions: s.func,
  /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */
  filterSelectedOptions: s.bool,
  /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */
  forcePopupIcon: s.oneOfType([s.oneOf(["auto"]), s.bool]),
  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */
  freeSolo: s.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */
  getLimitTagsText: s.func,
  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: s.func,
  /**
   * Used to determine the key for a given option.
   * This can be useful when the labels of options are not unique (since labels are used as keys by default).
   *
   * @param {Value} option The option to get the key for.
   * @returns {string | number}
   */
  getOptionKey: s.func,
  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */
  getOptionLabel: s.func,
  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} options The options to group.
   * @returns {string}
   */
  groupBy: s.func,
  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */
  handleHomeEndKeys: s.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */
  id: s.string,
  /**
   * If `true`, the highlight can move to the input.
   * @default false
   */
  includeInputInList: s.bool,
  /**
   * The input value.
   */
  inputValue: s.string,
  /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */
  isOptionEqualToValue: s.func,
  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */
  limitTags: rv,
  /**
   * The component used to render the listbox.
   * @default 'ul'
   * @deprecated Use `slotProps.listbox.component` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxComponent: s.elementType,
  /**
   * Props applied to the Listbox element.
   * @deprecated Use `slotProps.listbox` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxProps: s.object,
  /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, for example `options` are empty).
   * @default false
   */
  loading: s.bool,
  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Loading…'
   */
  loadingText: s.node,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: s.bool,
  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'No options'
   */
  noOptionsText: s.node,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */
  onChange: s.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */
  onClose: s.func,
  /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`, `"touch"`.
   */
  onHighlightChange: s.func,
  /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`, `"blur"`, `"selectOption"`, `"removeOption"`
   */
  onInputChange: s.func,
  /**
   * @ignore
   */
  onKeyDown: s.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool,
  /**
   * If `true`, the popup will open on input focus.
   * @default false
   */
  openOnFocus: s.bool,
  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Open'
   */
  openText: s.string,
  /**
   * A list of options that will be shown in the Autocomplete.
   */
  options: s.array.isRequired,
  /**
   * The component used to render the body of the popup.
   * @default Paper
   * @deprecated Use `slots.paper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PaperComponent: s.elementType,
  /**
   * The component used to position the popup.
   * @default Popper
   * @deprecated Use `slots.popper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: s.elementType,
  /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */
  popupIcon: s.node,
  /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */
  readOnly: s.bool,
  /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */
  renderGroup: s.func,
  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: s.func.isRequired,
  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderOption: s.func,
  /**
   * Render the selected value.
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderTags: s.func,
  /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */
  selectOnFocus: s.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["small", "medium"]), s.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    chip: s.oneOfType([s.func, s.object]),
    clearIndicator: s.oneOfType([s.func, s.object]),
    listbox: s.oneOfType([s.func, s.object]),
    paper: s.oneOfType([s.func, s.object]),
    popper: s.oneOfType([s.func, s.object]),
    popupIndicator: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    listbox: s.elementType,
    paper: s.elementType,
    popper: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */
  value: $o(s.any, (e) => e.multiple && e.value !== void 0 && !Array.isArray(e.value) ? new Error(["MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.", `However, ${e.value} was provided.`].join(`
`)) : null)
});
const Uae = Oi(/* @__PURE__ */ F.jsx("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");
function Wae(e) {
  return mt("MuiAvatar", e);
}
gt("MuiAvatar", ["root", "colorDefault", "circular", "rounded", "square", "img", "fallback"]);
const Hae = (e) => {
  const {
    classes: t,
    variant: n,
    colorDefault: r
  } = e;
  return wt({
    root: ["root", n, r && "colorDefault"],
    img: ["img"],
    fallback: ["fallback"]
  }, Wae, t);
}, Vae = Pe("div", {
  name: "MuiAvatar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], n.colorDefault && t.colorDefault];
  }
})(ct(({
  theme: e
}) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: 40,
  height: 40,
  fontFamily: e.typography.fontFamily,
  fontSize: e.typography.pxToRem(20),
  lineHeight: 1,
  borderRadius: "50%",
  overflow: "hidden",
  userSelect: "none",
  variants: [{
    props: {
      variant: "rounded"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius
    }
  }, {
    props: {
      variant: "square"
    },
    style: {
      borderRadius: 0
    }
  }, {
    props: {
      colorDefault: !0
    },
    style: {
      color: (e.vars || e).palette.background.default,
      ...e.vars ? {
        backgroundColor: e.vars.palette.Avatar.defaultBg
      } : {
        backgroundColor: e.palette.grey[400],
        ...e.applyStyles("dark", {
          backgroundColor: e.palette.grey[600]
        })
      }
    }
  }]
}))), Yae = Pe("img", {
  name: "MuiAvatar",
  slot: "Img",
  overridesResolver: (e, t) => t.img
})({
  width: "100%",
  height: "100%",
  textAlign: "center",
  // Handle non-square image.
  objectFit: "cover",
  // Hide alt text.
  color: "transparent",
  // Hide the image broken icon, only works on Chrome.
  textIndent: 1e4
}), Gae = Pe(Uae, {
  name: "MuiAvatar",
  slot: "Fallback",
  overridesResolver: (e, t) => t.fallback
})({
  width: "75%",
  height: "75%"
});
function Kae({
  crossOrigin: e,
  referrerPolicy: t,
  src: n,
  srcSet: r
}) {
  const [o, i] = E.useState(!1);
  return E.useEffect(() => {
    if (!n && !r)
      return;
    i(!1);
    let a = !0;
    const c = new Image();
    return c.onload = () => {
      a && i("loaded");
    }, c.onerror = () => {
      a && i("error");
    }, c.crossOrigin = e, c.referrerPolicy = t, c.src = n, r && (c.srcset = r), () => {
      a = !1;
    };
  }, [e, t, n, r]), o;
}
const Xae = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiAvatar"
  }), {
    alt: o,
    children: i,
    className: a,
    component: c = "div",
    slots: l = {},
    slotProps: u = {},
    imgProps: d,
    sizes: f,
    src: h,
    srcSet: v,
    variant: y = "circular",
    ...g
  } = r;
  let b = null;
  const x = {
    ...r,
    component: c,
    variant: y
  }, $ = Kae({
    ...d,
    ...typeof u.img == "function" ? u.img(x) : u.img,
    src: h,
    srcSet: v
  }), S = h || v, O = S && $ !== "error";
  x.colorDefault = !O, delete x.ownerState;
  const C = Hae(x), [T, k] = Mr("img", {
    className: C.img,
    elementType: Yae,
    externalForwardedProps: {
      slots: l,
      slotProps: {
        img: {
          ...d,
          ...u.img
        }
      }
    },
    additionalProps: {
      alt: o,
      src: h,
      srcSet: v,
      sizes: f
    },
    ownerState: x
  });
  return O ? b = /* @__PURE__ */ F.jsx(T, {
    ...k
  }) : i || i === 0 ? b = i : S && o ? b = o[0] : b = /* @__PURE__ */ F.jsx(Gae, {
    ownerState: x,
    className: C.fallback
  }), /* @__PURE__ */ F.jsx(Vae, {
    as: c,
    className: Ge(C.root, a),
    ref: n,
    ...g,
    ownerState: x,
    children: b
  });
});
process.env.NODE_ENV !== "production" && (Xae.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */
  alt: s.string,
  /**
   * Used to render icon or text elements inside the Avatar if `src` is not set.
   * This can be an element, or just a string.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attributes) applied to the `img` element if the component is used to display an image.
   * It can be used to listen for the loading error event.
   * @deprecated Use `slotProps.img` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  imgProps: s.object,
  /**
   * The `sizes` attribute for the `img` element.
   */
  sizes: s.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    img: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    img: s.elementType
  }),
  /**
   * The `src` attribute for the `img` element.
   */
  src: s.string,
  /**
   * The `srcSet` attribute for the `img` element.
   * Use this attribute for responsive image display.
   */
  srcSet: s.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The shape of the avatar.
   * @default 'circular'
   */
  variant: s.oneOfType([s.oneOf(["circular", "rounded", "square"]), s.string])
});
const Zae = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, zL = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = Fr(), o = {
    enter: r.transitions.duration.enteringScreen,
    exit: r.transitions.duration.leavingScreen
  }, {
    addEndListener: i,
    appear: a = !0,
    children: c,
    easing: l,
    in: u,
    onEnter: d,
    onEntered: f,
    onEntering: h,
    onExit: v,
    onExited: y,
    onExiting: g,
    style: b,
    timeout: x = o,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: $ = Si,
    ...S
  } = t, O = E.useRef(null), C = $n(O, tl(c), n), T = (N) => (L) => {
    if (N) {
      const z = O.current;
      L === void 0 ? N(z) : N(z, L);
    }
  }, k = T(h), I = T((N, L) => {
    bT(N);
    const z = $u({
      style: b,
      timeout: x,
      easing: l
    }, {
      mode: "enter"
    });
    N.style.webkitTransition = r.transitions.create("opacity", z), N.style.transition = r.transitions.create("opacity", z), d && d(N, L);
  }), P = T(f), _ = T(g), A = T((N) => {
    const L = $u({
      style: b,
      timeout: x,
      easing: l
    }, {
      mode: "exit"
    });
    N.style.webkitTransition = r.transitions.create("opacity", L), N.style.transition = r.transitions.create("opacity", L), v && v(N);
  }), D = T(y), M = (N) => {
    i && i(O.current, N);
  };
  return /* @__PURE__ */ F.jsx($, {
    appear: a,
    in: u,
    nodeRef: O,
    onEnter: I,
    onEntered: P,
    onEntering: k,
    onExit: A,
    onExited: D,
    onExiting: _,
    addEndListener: M,
    timeout: x,
    ...S,
    children: (N, L) => /* @__PURE__ */ E.cloneElement(c, {
      style: {
        opacity: 0,
        visibility: N === "exited" && !u ? "hidden" : void 0,
        ...Zae[N],
        ...b,
        ...c.props.style
      },
      ref: C,
      ...L
    })
  });
});
process.env.NODE_ENV !== "production" && (zL.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: s.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: s.bool,
  /**
   * A single child content element.
   */
  children: el.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: s.oneOfType([s.shape({
    enter: s.string,
    exit: s.string
  }), s.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: s.bool,
  /**
   * @ignore
   */
  onEnter: s.func,
  /**
   * @ignore
   */
  onEntered: s.func,
  /**
   * @ignore
   */
  onEntering: s.func,
  /**
   * @ignore
   */
  onExit: s.func,
  /**
   * @ignore
   */
  onExited: s.func,
  /**
   * @ignore
   */
  onExiting: s.func,
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: s.oneOfType([s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })])
});
function Jae(e) {
  return mt("MuiBackdrop", e);
}
gt("MuiBackdrop", ["root", "invisible"]);
const Qae = (e) => {
  const {
    ownerState: t,
    ...n
  } = e;
  return n;
}, ese = (e) => {
  const {
    classes: t,
    invisible: n
  } = e;
  return wt({
    root: ["root", n && "invisible"]
  }, Jae, t);
}, tse = Pe("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.invisible && t.invisible];
  }
})({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent",
  variants: [{
    props: {
      invisible: !0
    },
    style: {
      backgroundColor: "transparent"
    }
  }]
}), BL = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: o,
    className: i,
    component: a = "div",
    invisible: c = !1,
    open: l,
    components: u = {},
    componentsProps: d = {},
    slotProps: f = {},
    slots: h = {},
    TransitionComponent: v,
    transitionDuration: y,
    ...g
  } = r, b = {
    ...r,
    component: a,
    invisible: c
  }, x = ese(b), $ = {
    transition: v,
    root: u.Root,
    ...h
  }, S = {
    ...d,
    ...f
  }, O = {
    slots: $,
    slotProps: S
  }, [C, T] = Mr("root", {
    elementType: tse,
    externalForwardedProps: O,
    className: Ge(x.root, i),
    ownerState: b
  }), [k, I] = Mr("transition", {
    elementType: zL,
    externalForwardedProps: O,
    ownerState: b
  }), P = Qae(I);
  return /* @__PURE__ */ F.jsx(k, {
    in: l,
    timeout: y,
    ...g,
    ...P,
    children: /* @__PURE__ */ F.jsx(C, {
      "aria-hidden": !0,
      ...T,
      classes: x,
      ref: n,
      children: o
    })
  });
});
process.env.NODE_ENV !== "production" && (BL.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    Root: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: s.shape({
    root: s.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: s.bool,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    root: s.oneOfType([s.func, s.object]),
    transition: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    root: s.elementType,
    transition: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: s.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: s.oneOfType([s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })])
});
function nse(e) {
  const {
    badgeContent: t,
    invisible: n = !1,
    max: r = 99,
    showZero: o = !1
  } = e, i = lT({
    badgeContent: t,
    max: r
  });
  let a = n;
  n === !1 && t === 0 && !o && (a = !0);
  const {
    badgeContent: c,
    max: l = r
  } = a ? i : e, u = c && Number(c) > l ? `${l}+` : c;
  return {
    badgeContent: c,
    invisible: a,
    max: l,
    displayValue: u
  };
}
function rse(e) {
  return mt("MuiBadge", e);
}
const us = gt("MuiBadge", [
  "root",
  "badge",
  "dot",
  "standard",
  "anchorOriginTopRight",
  "anchorOriginBottomRight",
  "anchorOriginTopLeft",
  "anchorOriginBottomLeft",
  "invisible",
  "colorError",
  "colorInfo",
  "colorPrimary",
  "colorSecondary",
  "colorSuccess",
  "colorWarning",
  "overlapRectangular",
  "overlapCircular",
  // TODO: v6 remove the overlap value from these class keys
  "anchorOriginTopLeftCircular",
  "anchorOriginTopLeftRectangular",
  "anchorOriginTopRightCircular",
  "anchorOriginTopRightRectangular",
  "anchorOriginBottomLeftCircular",
  "anchorOriginBottomLeftRectangular",
  "anchorOriginBottomRightCircular",
  "anchorOriginBottomRightRectangular"
]), n1 = 10, r1 = 4, ose = (e) => {
  const {
    color: t,
    anchorOrigin: n,
    invisible: r,
    overlap: o,
    variant: i,
    classes: a = {}
  } = e, c = {
    root: ["root"],
    badge: ["badge", i, r && "invisible", `anchorOrigin${Le(n.vertical)}${Le(n.horizontal)}`, `anchorOrigin${Le(n.vertical)}${Le(n.horizontal)}${Le(o)}`, `overlap${Le(o)}`, t !== "default" && `color${Le(t)}`]
  };
  return wt(c, rse, a);
}, ise = Pe("span", {
  name: "MuiBadge",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  position: "relative",
  display: "inline-flex",
  // For correct alignment with the text.
  verticalAlign: "middle",
  flexShrink: 0
}), ase = Pe("span", {
  name: "MuiBadge",
  slot: "Badge",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.badge, t[n.variant], t[`anchorOrigin${Le(n.anchorOrigin.vertical)}${Le(n.anchorOrigin.horizontal)}${Le(n.overlap)}`], n.color !== "default" && t[`color${Le(n.color)}`], n.invisible && t.invisible];
  }
})(ct(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "center",
  alignContent: "center",
  alignItems: "center",
  position: "absolute",
  boxSizing: "border-box",
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(12),
  minWidth: n1 * 2,
  lineHeight: 1,
  padding: "0 6px",
  height: n1 * 2,
  borderRadius: n1,
  zIndex: 1,
  // Render the badge on top of potential ripples.
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeInOut,
    duration: e.transitions.duration.enteringScreen
  }),
  variants: [...Object.entries(e.palette).filter(Dn(["contrastText"])).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      backgroundColor: (e.vars || e).palette[t].main,
      color: (e.vars || e).palette[t].contrastText
    }
  })), {
    props: {
      variant: "dot"
    },
    style: {
      borderRadius: r1,
      height: r1 * 2,
      minWidth: r1 * 2,
      padding: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "right" && t.overlap === "rectangular",
    style: {
      top: 0,
      right: 0,
      transform: "scale(1) translate(50%, -50%)",
      transformOrigin: "100% 0%",
      [`&.${us.invisible}`]: {
        transform: "scale(0) translate(50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "right" && t.overlap === "rectangular",
    style: {
      bottom: 0,
      right: 0,
      transform: "scale(1) translate(50%, 50%)",
      transformOrigin: "100% 100%",
      [`&.${us.invisible}`]: {
        transform: "scale(0) translate(50%, 50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "left" && t.overlap === "rectangular",
    style: {
      top: 0,
      left: 0,
      transform: "scale(1) translate(-50%, -50%)",
      transformOrigin: "0% 0%",
      [`&.${us.invisible}`]: {
        transform: "scale(0) translate(-50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "left" && t.overlap === "rectangular",
    style: {
      bottom: 0,
      left: 0,
      transform: "scale(1) translate(-50%, 50%)",
      transformOrigin: "0% 100%",
      [`&.${us.invisible}`]: {
        transform: "scale(0) translate(-50%, 50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "right" && t.overlap === "circular",
    style: {
      top: "14%",
      right: "14%",
      transform: "scale(1) translate(50%, -50%)",
      transformOrigin: "100% 0%",
      [`&.${us.invisible}`]: {
        transform: "scale(0) translate(50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "right" && t.overlap === "circular",
    style: {
      bottom: "14%",
      right: "14%",
      transform: "scale(1) translate(50%, 50%)",
      transformOrigin: "100% 100%",
      [`&.${us.invisible}`]: {
        transform: "scale(0) translate(50%, 50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "left" && t.overlap === "circular",
    style: {
      top: "14%",
      left: "14%",
      transform: "scale(1) translate(-50%, -50%)",
      transformOrigin: "0% 0%",
      [`&.${us.invisible}`]: {
        transform: "scale(0) translate(-50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "left" && t.overlap === "circular",
    style: {
      bottom: "14%",
      left: "14%",
      transform: "scale(1) translate(-50%, 50%)",
      transformOrigin: "0% 100%",
      [`&.${us.invisible}`]: {
        transform: "scale(0) translate(-50%, 50%)"
      }
    }
  }, {
    props: {
      invisible: !0
    },
    style: {
      transition: e.transitions.create("transform", {
        easing: e.transitions.easing.easeInOut,
        duration: e.transitions.duration.leavingScreen
      })
    }
  }]
})));
function cA(e) {
  return {
    vertical: (e == null ? void 0 : e.vertical) ?? "top",
    horizontal: (e == null ? void 0 : e.horizontal) ?? "right"
  };
}
const sse = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiBadge"
  }), {
    anchorOrigin: o,
    className: i,
    classes: a,
    component: c,
    components: l = {},
    componentsProps: u = {},
    children: d,
    overlap: f = "rectangular",
    color: h = "default",
    invisible: v = !1,
    max: y = 99,
    badgeContent: g,
    slots: b,
    slotProps: x,
    showZero: $ = !1,
    variant: S = "standard",
    ...O
  } = r, {
    badgeContent: C,
    invisible: T,
    max: k,
    displayValue: I
  } = nse({
    max: y,
    invisible: v,
    badgeContent: g,
    showZero: $
  }), P = lT({
    anchorOrigin: cA(o),
    color: h,
    overlap: f,
    variant: S,
    badgeContent: g
  }), _ = T || C == null && S !== "dot", {
    color: A = h,
    overlap: D = f,
    anchorOrigin: M,
    variant: N = S
  } = _ ? P : r, L = cA(M), z = N !== "dot" ? I : void 0, q = {
    ...r,
    badgeContent: C,
    invisible: _,
    max: k,
    displayValue: z,
    showZero: $,
    anchorOrigin: L,
    color: A,
    overlap: D,
    variant: N
  }, W = ose(q), U = (b == null ? void 0 : b.root) ?? l.Root ?? ise, K = (b == null ? void 0 : b.badge) ?? l.Badge ?? ase, Y = (x == null ? void 0 : x.root) ?? u.root, X = (x == null ? void 0 : x.badge) ?? u.badge, oe = fr({
    elementType: U,
    externalSlotProps: Y,
    externalForwardedProps: O,
    additionalProps: {
      ref: n,
      as: c
    },
    ownerState: q,
    className: Ge(Y == null ? void 0 : Y.className, W.root, i)
  }), re = fr({
    elementType: K,
    externalSlotProps: X,
    ownerState: q,
    className: Ge(W.badge, X == null ? void 0 : X.className)
  });
  return /* @__PURE__ */ F.jsxs(U, {
    ...oe,
    children: [d, /* @__PURE__ */ F.jsx(K, {
      ...re,
      children: z
    })]
  });
});
process.env.NODE_ENV !== "production" && (sse.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The anchor of the badge.
   * @default {
   *   vertical: 'top',
   *   horizontal: 'right',
   * }
   */
  anchorOrigin: s.shape({
    horizontal: s.oneOf(["left", "right"]),
    vertical: s.oneOf(["bottom", "top"])
  }),
  /**
   * The content rendered within the badge.
   */
  badgeContent: s.node,
  /**
   * The badge will be added relative to this node.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: s.oneOfType([s.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    Badge: s.elementType,
    Root: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: s.shape({
    badge: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * If `true`, the badge is invisible.
   * @default false
   */
  invisible: s.bool,
  /**
   * Max count to show.
   * @default 99
   */
  max: s.number,
  /**
   * Wrapped shape the badge should overlap.
   * @default 'rectangular'
   */
  overlap: s.oneOf(["circular", "rectangular"]),
  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   * @default false
   */
  showZero: s.bool,
  /**
   * The props used for each slot inside the Badge.
   * @default {}
   */
  slotProps: s.shape({
    badge: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside the Badge.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: s.shape({
    badge: s.elementType,
    root: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: s.oneOfType([s.oneOf(["dot", "standard"]), s.string])
});
const cse = gt("MuiBox", ["root"]), lse = mT(), use = cne({
  themeId: Xo,
  defaultTheme: lse,
  defaultClassName: cse.root,
  generateClassName: U7.generate
});
process.env.NODE_ENV !== "production" && (use.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: s.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function dse(e) {
  return mt("MuiButton", e);
}
const jl = gt("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge"]), qL = /* @__PURE__ */ E.createContext({});
process.env.NODE_ENV !== "production" && (qL.displayName = "ButtonGroupContext");
const UL = /* @__PURE__ */ E.createContext(void 0);
process.env.NODE_ENV !== "production" && (UL.displayName = "ButtonGroupButtonContext");
const fse = (e) => {
  const {
    color: t,
    disableElevation: n,
    fullWidth: r,
    size: o,
    variant: i,
    classes: a
  } = e, c = {
    root: ["root", i, `${i}${Le(t)}`, `size${Le(o)}`, `${i}Size${Le(o)}`, `color${Le(t)}`, n && "disableElevation", r && "fullWidth"],
    label: ["label"],
    startIcon: ["icon", "startIcon", `iconSize${Le(o)}`],
    endIcon: ["icon", "endIcon", `iconSize${Le(o)}`]
  }, l = wt(c, dse, a);
  return {
    ...a,
    // forward the focused, disabled, etc. classes to the ButtonBase
    ...l
  };
}, WL = [{
  props: {
    size: "small"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 18
    }
  }
}, {
  props: {
    size: "medium"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 20
    }
  }
}, {
  props: {
    size: "large"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 22
    }
  }
}], pse = Pe(oa, {
  shouldForwardProp: (e) => ar(e) || e === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`${n.variant}${Le(n.color)}`], t[`size${Le(n.size)}`], t[`${n.variant}Size${Le(n.size)}`], n.color === "inherit" && t.colorInherit, n.disableElevation && t.disableElevation, n.fullWidth && t.fullWidth];
  }
})(ct(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[300] : e.palette.grey[800], n = e.palette.mode === "light" ? e.palette.grey.A100 : e.palette.grey[700];
  return {
    ...e.typography.button,
    minWidth: 64,
    padding: "6px 16px",
    border: 0,
    borderRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: e.transitions.duration.short
    }),
    "&:hover": {
      textDecoration: "none"
    },
    [`&.${jl.disabled}`]: {
      color: (e.vars || e).palette.action.disabled
    },
    variants: [{
      props: {
        variant: "contained"
      },
      style: {
        color: "var(--variant-containedColor)",
        backgroundColor: "var(--variant-containedBg)",
        boxShadow: (e.vars || e).shadows[2],
        "&:hover": {
          boxShadow: (e.vars || e).shadows[4],
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            boxShadow: (e.vars || e).shadows[2]
          }
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[8]
        },
        [`&.${jl.focusVisible}`]: {
          boxShadow: (e.vars || e).shadows[6]
        },
        [`&.${jl.disabled}`]: {
          color: (e.vars || e).palette.action.disabled,
          boxShadow: (e.vars || e).shadows[0],
          backgroundColor: (e.vars || e).palette.action.disabledBackground
        }
      }
    }, {
      props: {
        variant: "outlined"
      },
      style: {
        padding: "5px 15px",
        border: "1px solid currentColor",
        borderColor: "var(--variant-outlinedBorder, currentColor)",
        backgroundColor: "var(--variant-outlinedBg)",
        color: "var(--variant-outlinedColor)",
        [`&.${jl.disabled}`]: {
          border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
        }
      }
    }, {
      props: {
        variant: "text"
      },
      style: {
        padding: "6px 8px",
        color: "var(--variant-textColor)",
        backgroundColor: "var(--variant-textBg)"
      }
    }, ...Object.entries(e.palette).filter(Dn()).map(([r]) => ({
      props: {
        color: r
      },
      style: {
        "--variant-textColor": (e.vars || e).palette[r].main,
        "--variant-outlinedColor": (e.vars || e).palette[r].main,
        "--variant-outlinedBorder": e.vars ? `rgba(${e.vars.palette[r].mainChannel} / 0.5)` : It(e.palette[r].main, 0.5),
        "--variant-containedColor": (e.vars || e).palette[r].contrastText,
        "--variant-containedBg": (e.vars || e).palette[r].main,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": (e.vars || e).palette[r].dark,
            "--variant-textBg": e.vars ? `rgba(${e.vars.palette[r].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : It(e.palette[r].main, e.palette.action.hoverOpacity),
            "--variant-outlinedBorder": (e.vars || e).palette[r].main,
            "--variant-outlinedBg": e.vars ? `rgba(${e.vars.palette[r].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : It(e.palette[r].main, e.palette.action.hoverOpacity)
          }
        }
      }
    })), {
      props: {
        color: "inherit"
      },
      style: {
        color: "inherit",
        borderColor: "currentColor",
        "--variant-containedBg": e.vars ? e.vars.palette.Button.inheritContainedBg : t,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": e.vars ? e.vars.palette.Button.inheritContainedHoverBg : n,
            "--variant-textBg": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : It(e.palette.text.primary, e.palette.action.hoverOpacity),
            "--variant-outlinedBg": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : It(e.palette.text.primary, e.palette.action.hoverOpacity)
          }
        }
      }
    }, {
      props: {
        size: "small",
        variant: "text"
      },
      style: {
        padding: "4px 5px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "text"
      },
      style: {
        padding: "8px 11px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "outlined"
      },
      style: {
        padding: "3px 9px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "outlined"
      },
      style: {
        padding: "7px 21px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "contained"
      },
      style: {
        padding: "4px 10px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "contained"
      },
      style: {
        padding: "8px 22px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        disableElevation: !0
      },
      style: {
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none"
        },
        [`&.${jl.focusVisible}`]: {
          boxShadow: "none"
        },
        "&:active": {
          boxShadow: "none"
        },
        [`&.${jl.disabled}`]: {
          boxShadow: "none"
        }
      }
    }, {
      props: {
        fullWidth: !0
      },
      style: {
        width: "100%"
      }
    }]
  };
})), hse = Pe("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.startIcon, t[`iconSize${Le(n.size)}`]];
  }
})({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginLeft: -2
    }
  }, ...WL]
}), mse = Pe("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.endIcon, t[`iconSize${Le(n.size)}`]];
  }
})({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginRight: -2
    }
  }, ...WL]
}), gse = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = E.useContext(qL), o = E.useContext(UL), i = Df(r, t), a = $t({
    props: i,
    name: "MuiButton"
  }), {
    children: c,
    color: l = "primary",
    component: u = "button",
    className: d,
    disabled: f = !1,
    disableElevation: h = !1,
    disableFocusRipple: v = !1,
    endIcon: y,
    focusVisibleClassName: g,
    fullWidth: b = !1,
    size: x = "medium",
    startIcon: $,
    type: S,
    variant: O = "text",
    ...C
  } = a, T = {
    ...a,
    color: l,
    component: u,
    disabled: f,
    disableElevation: h,
    disableFocusRipple: v,
    fullWidth: b,
    size: x,
    type: S,
    variant: O
  }, k = fse(T), I = $ && /* @__PURE__ */ F.jsx(hse, {
    className: k.startIcon,
    ownerState: T,
    children: $
  }), P = y && /* @__PURE__ */ F.jsx(mse, {
    className: k.endIcon,
    ownerState: T,
    children: y
  }), _ = o || "";
  return /* @__PURE__ */ F.jsxs(pse, {
    ownerState: T,
    className: Ge(r.className, k.root, d, _),
    component: u,
    disabled: f,
    focusRipple: !v,
    focusVisibleClassName: Ge(k.focusVisible, g),
    ref: n,
    type: S,
    ...C,
    classes: k,
    children: [I, c, P]
  });
});
process.env.NODE_ENV !== "production" && (gse.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: s.oneOfType([s.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: s.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: s.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: s.bool,
  /**
   * Element placed after the children.
   */
  endIcon: s.node,
  /**
   * @ignore
   */
  focusVisibleClassName: s.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: s.string,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["small", "medium", "large"]), s.string]),
  /**
   * Element placed before the children.
   */
  startIcon: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * @ignore
   */
  type: s.oneOfType([s.oneOf(["button", "reset", "submit"]), s.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: s.oneOfType([s.oneOf(["contained", "outlined", "text"]), s.string])
});
function vse(e) {
  return mt("PrivateSwitchBase", e);
}
gt("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const yse = (e) => {
  const {
    classes: t,
    checked: n,
    disabled: r,
    edge: o
  } = e, i = {
    root: ["root", n && "checked", r && "disabled", o && `edge${Le(o)}`],
    input: ["input"]
  };
  return wt(i, vse, t);
}, bse = Pe(oa)({
  padding: 9,
  borderRadius: "50%",
  variants: [{
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: ({
      edge: e,
      ownerState: t
    }) => e === "start" && t.size !== "small",
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }, {
    props: ({
      edge: e,
      ownerState: t
    }) => e === "end" && t.size !== "small",
    style: {
      marginRight: -12
    }
  }]
}), xse = Pe("input", {
  shouldForwardProp: ar
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), _T = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const {
    autoFocus: r,
    checked: o,
    checkedIcon: i,
    className: a,
    defaultChecked: c,
    disabled: l,
    disableFocusRipple: u = !1,
    edge: d = !1,
    icon: f,
    id: h,
    inputProps: v,
    inputRef: y,
    name: g,
    onBlur: b,
    onChange: x,
    onFocus: $,
    readOnly: S,
    required: O = !1,
    tabIndex: C,
    type: T,
    value: k,
    ...I
  } = t, [P, _] = Mc({
    controlled: o,
    default: !!c,
    name: "SwitchBase",
    state: "checked"
  }), A = Gs(), D = (U) => {
    $ && $(U), A && A.onFocus && A.onFocus(U);
  }, M = (U) => {
    b && b(U), A && A.onBlur && A.onBlur(U);
  }, N = (U) => {
    if (U.nativeEvent.defaultPrevented)
      return;
    const K = U.target.checked;
    _(K), x && x(U, K);
  };
  let L = l;
  A && typeof L > "u" && (L = A.disabled);
  const z = T === "checkbox" || T === "radio", q = {
    ...t,
    checked: P,
    disabled: L,
    disableFocusRipple: u,
    edge: d
  }, W = yse(q);
  return /* @__PURE__ */ F.jsxs(bse, {
    component: "span",
    className: Ge(W.root, a),
    centerRipple: !0,
    focusRipple: !u,
    disabled: L,
    tabIndex: null,
    role: void 0,
    onFocus: D,
    onBlur: M,
    ownerState: q,
    ref: n,
    ...I,
    children: [/* @__PURE__ */ F.jsx(xse, {
      autoFocus: r,
      checked: o,
      defaultChecked: c,
      className: W.input,
      disabled: L,
      id: z ? h : void 0,
      name: g,
      onChange: N,
      readOnly: S,
      ref: y,
      required: O,
      ownerState: q,
      tabIndex: C,
      type: T,
      ...T === "checkbox" && k === void 0 ? {} : {
        value: k
      },
      ...v
    }), P ? i : f]
  });
});
process.env.NODE_ENV !== "production" && (_T.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: s.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: s.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: s.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * @ignore
   */
  defaultChecked: s.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: s.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: s.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: s.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: s.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: s.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: jr,
  /*
   * @ignore
   */
  name: s.string,
  /**
   * @ignore
   */
  onBlur: s.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: s.func,
  /**
   * @ignore
   */
  onFocus: s.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: s.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.object,
  /**
   * @ignore
   */
  tabIndex: s.oneOfType([s.number, s.string]),
  /**
   * The input component prop `type`.
   */
  type: s.string.isRequired,
  /**
   * The value of the component.
   */
  value: s.any
});
const wse = Oi(/* @__PURE__ */ F.jsx("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"), $se = Oi(/* @__PURE__ */ F.jsx("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"), Ose = Oi(/* @__PURE__ */ F.jsx("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function Sse(e) {
  return mt("MuiCheckbox", e);
}
const o1 = gt("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]), Cse = (e) => {
  const {
    classes: t,
    indeterminate: n,
    color: r,
    size: o
  } = e, i = {
    root: ["root", n && "indeterminate", `color${Le(r)}`, `size${Le(o)}`]
  }, a = wt(i, Sse, t);
  return {
    ...t,
    // forward the disabled and checked classes to the SwitchBase
    ...a
  };
}, Tse = Pe(_T, {
  shouldForwardProp: (e) => ar(e) || e === "classes",
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.indeterminate && t.indeterminate, t[`size${Le(n.size)}`], n.color !== "default" && t[`color${Le(n.color)}`]];
  }
})(ct(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  variants: [{
    props: {
      color: "default",
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : It(e.palette.action.active, e.palette.action.hoverOpacity)
      }
    }
  }, ...Object.entries(e.palette).filter(Dn()).map(([t]) => ({
    props: {
      color: t,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : It(e.palette[t].main, e.palette.action.hoverOpacity)
      }
    }
  })), ...Object.entries(e.palette).filter(Dn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${o1.checked}, &.${o1.indeterminate}`]: {
        color: (e.vars || e).palette[t].main
      },
      [`&.${o1.disabled}`]: {
        color: (e.vars || e).palette.action.disabled
      }
    }
  })), {
    // Should be last to override other colors
    props: {
      disableRipple: !1
    },
    style: {
      // Reset on touch devices, it doesn't add specificity
      "&:hover": {
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }]
}))), Ese = /* @__PURE__ */ F.jsx($se, {}), _se = /* @__PURE__ */ F.jsx(wse, {}), kse = /* @__PURE__ */ F.jsx(Ose, {}), Rse = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiCheckbox"
  }), {
    checkedIcon: o = Ese,
    color: i = "primary",
    icon: a = _se,
    indeterminate: c = !1,
    indeterminateIcon: l = kse,
    inputProps: u,
    size: d = "medium",
    disableRipple: f = !1,
    className: h,
    ...v
  } = r, y = c ? l : a, g = c ? l : o, b = {
    ...r,
    disableRipple: f,
    color: i,
    indeterminate: c,
    size: d
  }, x = Cse(b);
  return /* @__PURE__ */ F.jsx(Tse, {
    type: "checkbox",
    inputProps: {
      "data-indeterminate": c,
      ...u
    },
    icon: /* @__PURE__ */ E.cloneElement(y, {
      fontSize: y.props.fontSize ?? d
    }),
    checkedIcon: /* @__PURE__ */ E.cloneElement(g, {
      fontSize: g.props.fontSize ?? d
    }),
    ownerState: b,
    ref: n,
    className: Ge(x.root, h),
    disableRipple: f,
    ...v,
    classes: x
  });
});
process.env.NODE_ENV !== "production" && (Rse.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: s.bool,
  /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */
  checkedIcon: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: s.oneOfType([s.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: s.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: s.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */
  icon: s.node,
  /**
   * The id of the `input` element.
   */
  id: s.string,
  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */
  indeterminate: s.bool,
  /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */
  indeterminateIcon: s.node,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: jr,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: s.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: s.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["medium", "small"]), s.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: s.any
});
function Pse(e) {
  return mt("MuiCircularProgress", e);
}
gt("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
const ds = 44, iS = Qc`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`, aS = Qc`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`, Ase = typeof iS != "string" ? $p`
        animation: ${iS} 1.4s linear infinite;
      ` : null, Ise = typeof aS != "string" ? $p`
        animation: ${aS} 1.4s ease-in-out infinite;
      ` : null, Mse = (e) => {
  const {
    classes: t,
    variant: n,
    color: r,
    disableShrink: o
  } = e, i = {
    root: ["root", n, `color${Le(r)}`],
    svg: ["svg"],
    circle: ["circle", `circle${Le(n)}`, o && "circleDisableShrink"]
  };
  return wt(i, Pse, t);
}, Nse = Pe("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`color${Le(n.color)}`]];
  }
})(ct(({
  theme: e
}) => ({
  display: "inline-block",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("transform")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: Ase || {
      animation: `${iS} 1.4s linear infinite`
    }
  }, ...Object.entries(e.palette).filter(Dn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  }))]
}))), Dse = Pe("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
  overridesResolver: (e, t) => t.svg
})({
  display: "block"
  // Keeps the progress centered
}), Lse = Pe("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.circle, t[`circle${Le(n.variant)}`], n.disableShrink && t.circleDisableShrink];
  }
})(ct(({
  theme: e
}) => ({
  stroke: "currentColor",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("stroke-dashoffset")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: {
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: "80px, 200px",
      strokeDashoffset: 0
      // Add the unit to fix a Edge 16 and below bug.
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" && !t.disableShrink,
    style: Ise || {
      // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
      animation: `${aS} 1.4s ease-in-out infinite`
    }
  }]
}))), jse = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiCircularProgress"
  }), {
    className: o,
    color: i = "primary",
    disableShrink: a = !1,
    size: c = 40,
    style: l,
    thickness: u = 3.6,
    value: d = 0,
    variant: f = "indeterminate",
    ...h
  } = r, v = {
    ...r,
    color: i,
    disableShrink: a,
    size: c,
    thickness: u,
    value: d,
    variant: f
  }, y = Mse(v), g = {}, b = {}, x = {};
  if (f === "determinate") {
    const $ = 2 * Math.PI * ((ds - u) / 2);
    g.strokeDasharray = $.toFixed(3), x["aria-valuenow"] = Math.round(d), g.strokeDashoffset = `${((100 - d) / 100 * $).toFixed(3)}px`, b.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ F.jsx(Nse, {
    className: Ge(y.root, o),
    style: {
      width: c,
      height: c,
      ...b,
      ...l
    },
    ownerState: v,
    ref: n,
    role: "progressbar",
    ...x,
    ...h,
    children: /* @__PURE__ */ F.jsx(Dse, {
      className: y.svg,
      ownerState: v,
      viewBox: `${ds / 2} ${ds / 2} ${ds} ${ds}`,
      children: /* @__PURE__ */ F.jsx(Lse, {
        className: y.circle,
        style: g,
        ownerState: v,
        cx: ds,
        cy: ds,
        r: (ds - u) / 2,
        fill: "none",
        strokeWidth: u
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (jse.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: s.oneOfType([s.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: $o(s.bool, (e) => e.disableShrink && e.variant && e.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */
  size: s.oneOfType([s.number, s.string]),
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: s.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: s.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: s.oneOf(["determinate", "indeterminate"])
});
function lA(e) {
  return e.substring(2).toLowerCase();
}
function Fse(e, t) {
  return t.documentElement.clientWidth < e.clientX || t.documentElement.clientHeight < e.clientY;
}
function sS(e) {
  const {
    children: t,
    disableReactTree: n = !1,
    mouseEvent: r = "onClick",
    onClickAway: o,
    touchEvent: i = "onTouchEnd"
  } = e, a = E.useRef(!1), c = E.useRef(null), l = E.useRef(!1), u = E.useRef(!1);
  E.useEffect(() => (setTimeout(() => {
    l.current = !0;
  }, 0), () => {
    l.current = !1;
  }), []);
  const d = $n(tl(t), c), f = hr((y) => {
    const g = u.current;
    u.current = !1;
    const b = Un(c.current);
    if (!l.current || !c.current || "clientX" in y && Fse(y, b))
      return;
    if (a.current) {
      a.current = !1;
      return;
    }
    let x;
    y.composedPath ? x = y.composedPath().includes(c.current) : x = !b.documentElement.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      y.target
    ) || c.current.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      y.target
    ), !x && (n || !g) && o(y);
  }), h = (y) => (g) => {
    u.current = !0;
    const b = t.props[y];
    b && b(g);
  }, v = {
    ref: d
  };
  return i !== !1 && (v[i] = h(i)), E.useEffect(() => {
    if (i !== !1) {
      const y = lA(i), g = Un(c.current), b = () => {
        a.current = !0;
      };
      return g.addEventListener(y, f), g.addEventListener("touchmove", b), () => {
        g.removeEventListener(y, f), g.removeEventListener("touchmove", b);
      };
    }
  }, [f, i]), r !== !1 && (v[r] = h(r)), E.useEffect(() => {
    if (r !== !1) {
      const y = lA(r), g = Un(c.current);
      return g.addEventListener(y, f), () => {
        g.removeEventListener(y, f);
      };
    }
  }, [f, r]), /* @__PURE__ */ E.cloneElement(t, v);
}
process.env.NODE_ENV !== "production" && (sS.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The wrapped element.
   */
  children: el.isRequired,
  /**
   * If `true`, the React tree is ignored and only the DOM tree is considered.
   * This prop changes how portaled elements are handled.
   * @default false
   */
  disableReactTree: s.bool,
  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   * @default 'onClick'
   */
  mouseEvent: s.oneOf(["onClick", "onMouseDown", "onMouseUp", "onPointerDown", "onPointerUp", !1]),
  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: s.func.isRequired,
  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   * @default 'onTouchEnd'
   */
  touchEvent: s.oneOf(["onTouchEnd", "onTouchStart", !1])
});
process.env.NODE_ENV !== "production" && (sS.propTypes = Yu(sS.propTypes));
const cS = typeof gT({}) == "function", zse = (e, t) => ({
  WebkitFontSmoothing: "antialiased",
  // Antialiasing.
  MozOsxFontSmoothing: "grayscale",
  // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: "border-box",
  // Fix font resize problem in iOS
  WebkitTextSizeAdjust: "100%",
  // When used under CssVarsProvider, colorScheme should not be applied dynamically because it will generate the stylesheet twice for server-rendered applications.
  ...t && !e.vars && {
    colorScheme: e.palette.mode
  }
}), Bse = (e) => ({
  color: (e.vars || e).palette.text.primary,
  ...e.typography.body1,
  backgroundColor: (e.vars || e).palette.background.default,
  "@media print": {
    // Save printer ink.
    backgroundColor: (e.vars || e).palette.common.white
  }
}), HL = (e, t = !1) => {
  var i, a;
  const n = {};
  t && e.colorSchemes && typeof e.getColorSchemeSelector == "function" && Object.entries(e.colorSchemes).forEach(([c, l]) => {
    var d, f;
    const u = e.getColorSchemeSelector(c);
    u.startsWith("@") ? n[u] = {
      ":root": {
        colorScheme: (d = l.palette) == null ? void 0 : d.mode
      }
    } : n[u.replace(/\s*&/, "")] = {
      colorScheme: (f = l.palette) == null ? void 0 : f.mode
    };
  });
  let r = {
    html: zse(e, t),
    "*, *::before, *::after": {
      boxSizing: "inherit"
    },
    "strong, b": {
      fontWeight: e.typography.fontWeightBold
    },
    body: {
      margin: 0,
      // Remove the margin in all browsers.
      ...Bse(e),
      // Add support for document.body.requestFullScreen().
      // Other elements, if background transparent, are not supported.
      "&::backdrop": {
        backgroundColor: (e.vars || e).palette.background.default
      }
    },
    ...n
  };
  const o = (a = (i = e.components) == null ? void 0 : i.MuiCssBaseline) == null ? void 0 : a.styleOverrides;
  return o && (r = [r, o]), r;
}, eg = "mui-ecs", qse = (e) => {
  const t = HL(e, !1), n = Array.isArray(t) ? t[0] : t;
  return !e.vars && n && (n.html[`:root:has(${eg})`] = {
    colorScheme: e.palette.mode
  }), e.colorSchemes && Object.entries(e.colorSchemes).forEach(([r, o]) => {
    var a, c;
    const i = e.getColorSchemeSelector(r);
    i.startsWith("@") ? n[i] = {
      [`:root:not(:has(.${eg}))`]: {
        colorScheme: (a = o.palette) == null ? void 0 : a.mode
      }
    } : n[i.replace(/\s*&/, "")] = {
      [`&:not(:has(.${eg}))`]: {
        colorScheme: (c = o.palette) == null ? void 0 : c.mode
      }
    };
  }), t;
}, Use = gT(cS ? ({
  theme: e,
  enableColorScheme: t
}) => HL(e, t) : ({
  theme: e
}) => qse(e));
function Wse(e) {
  const t = $t({
    props: e,
    name: "MuiCssBaseline"
  }), {
    children: n,
    enableColorScheme: r = !1
  } = t;
  return /* @__PURE__ */ F.jsxs(E.Fragment, {
    children: [cS && /* @__PURE__ */ F.jsx(Use, {
      enableColorScheme: r
    }), !cS && !r && /* @__PURE__ */ F.jsx("span", {
      className: eg,
      style: {
        display: "none"
      }
    }), n]
  });
}
process.env.NODE_ENV !== "production" && (Wse.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * You can wrap a node.
   */
  children: s.node,
  /**
   * Enable `color-scheme` CSS property to use `theme.palette.mode`.
   * For more details, check out https://developer.mozilla.org/en-US/docs/Web/CSS/color-scheme
   * For browser support, check out https://caniuse.com/?search=color-scheme
   * @default false
   */
  enableColorScheme: s.bool
});
function Hse(e) {
  const t = Un(e);
  return t.body === e ? Oo(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function xf(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function uA(e) {
  return parseInt(Oo(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function Vse(e) {
  const n = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].includes(e.tagName), r = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return n || r;
}
function dA(e, t, n, r, o) {
  const i = [t, n, ...r];
  [].forEach.call(e.children, (a) => {
    const c = !i.includes(a), l = !Vse(a);
    c && l && xf(a, o);
  });
}
function i1(e, t) {
  let n = -1;
  return e.some((r, o) => t(r) ? (n = o, !0) : !1), n;
}
function Yse(e, t) {
  const n = [], r = e.container;
  if (!t.disableScrollLock) {
    if (Hse(r)) {
      const a = iL(Oo(r));
      n.push({
        value: r.style.paddingRight,
        property: "padding-right",
        el: r
      }), r.style.paddingRight = `${uA(r) + a}px`;
      const c = Un(r).querySelectorAll(".mui-fixed");
      [].forEach.call(c, (l) => {
        n.push({
          value: l.style.paddingRight,
          property: "padding-right",
          el: l
        }), l.style.paddingRight = `${uA(l) + a}px`;
      });
    }
    let i;
    if (r.parentNode instanceof DocumentFragment)
      i = Un(r).body;
    else {
      const a = r.parentElement, c = Oo(r);
      i = (a == null ? void 0 : a.nodeName) === "HTML" && c.getComputedStyle(a).overflowY === "scroll" ? a : r;
    }
    n.push({
      value: i.style.overflow,
      property: "overflow",
      el: i
    }, {
      value: i.style.overflowX,
      property: "overflow-x",
      el: i
    }, {
      value: i.style.overflowY,
      property: "overflow-y",
      el: i
    }), i.style.overflow = "hidden";
  }
  return () => {
    n.forEach(({
      value: i,
      el: a,
      property: c
    }) => {
      i ? a.style.setProperty(c, i) : a.style.removeProperty(c);
    });
  };
}
function Gse(e) {
  const t = [];
  return [].forEach.call(e.children, (n) => {
    n.getAttribute("aria-hidden") === "true" && t.push(n);
  }), t;
}
class Kse {
  constructor() {
    this.modals = [], this.containers = [];
  }
  add(t, n) {
    let r = this.modals.indexOf(t);
    if (r !== -1)
      return r;
    r = this.modals.length, this.modals.push(t), t.modalRef && xf(t.modalRef, !1);
    const o = Gse(n);
    dA(n, t.mount, t.modalRef, o, !0);
    const i = i1(this.containers, (a) => a.container === n);
    return i !== -1 ? (this.containers[i].modals.push(t), r) : (this.containers.push({
      modals: [t],
      container: n,
      restore: null,
      hiddenSiblings: o
    }), r);
  }
  mount(t, n) {
    const r = i1(this.containers, (i) => i.modals.includes(t)), o = this.containers[r];
    o.restore || (o.restore = Yse(o, n));
  }
  remove(t, n = !0) {
    const r = this.modals.indexOf(t);
    if (r === -1)
      return r;
    const o = i1(this.containers, (a) => a.modals.includes(t)), i = this.containers[o];
    if (i.modals.splice(i.modals.indexOf(t), 1), this.modals.splice(r, 1), i.modals.length === 0)
      i.restore && i.restore(), t.modalRef && xf(t.modalRef, n), dA(i.container, t.mount, t.modalRef, i.hiddenSiblings, !1), this.containers.splice(o, 1);
    else {
      const a = i.modals[i.modals.length - 1];
      a.modalRef && xf(a.modalRef, !1);
    }
    return r;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
const Xse = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function Zse(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function Jse(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (r) => e.ownerDocument.querySelector(`input[type="radio"]${r}`);
  let n = t(`[name="${e.name}"]:checked`);
  return n || (n = t(`[name="${e.name}"]`)), n !== e;
}
function Qse(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || Jse(e));
}
function ece(e) {
  const t = [], n = [];
  return Array.from(e.querySelectorAll(Xse)).forEach((r, o) => {
    const i = Zse(r);
    i === -1 || !Qse(r) || (i === 0 ? t.push(r) : n.push({
      documentOrder: o,
      tabIndex: i,
      node: r
    }));
  }), n.sort((r, o) => r.tabIndex === o.tabIndex ? r.documentOrder - o.documentOrder : r.tabIndex - o.tabIndex).map((r) => r.node).concat(t);
}
function tce() {
  return !0;
}
function jg(e) {
  const {
    children: t,
    disableAutoFocus: n = !1,
    disableEnforceFocus: r = !1,
    disableRestoreFocus: o = !1,
    getTabbable: i = ece,
    isEnabled: a = tce,
    open: c
  } = e, l = E.useRef(!1), u = E.useRef(null), d = E.useRef(null), f = E.useRef(null), h = E.useRef(null), v = E.useRef(!1), y = E.useRef(null), g = $n(tl(t), y), b = E.useRef(null);
  E.useEffect(() => {
    !c || !y.current || (v.current = !n);
  }, [n, c]), E.useEffect(() => {
    if (!c || !y.current)
      return;
    const S = Un(y.current);
    return y.current.contains(S.activeElement) || (y.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), y.current.setAttribute("tabIndex", "-1")), v.current && y.current.focus()), () => {
      o || (f.current && f.current.focus && (l.current = !0, f.current.focus()), f.current = null);
    };
  }, [c]), E.useEffect(() => {
    if (!c || !y.current)
      return;
    const S = Un(y.current), O = (k) => {
      b.current = k, !(r || !a() || k.key !== "Tab") && S.activeElement === y.current && k.shiftKey && (l.current = !0, d.current && d.current.focus());
    }, C = () => {
      var P, _;
      const k = y.current;
      if (k === null)
        return;
      if (!S.hasFocus() || !a() || l.current) {
        l.current = !1;
        return;
      }
      if (k.contains(S.activeElement) || r && S.activeElement !== u.current && S.activeElement !== d.current)
        return;
      if (S.activeElement !== h.current)
        h.current = null;
      else if (h.current !== null)
        return;
      if (!v.current)
        return;
      let I = [];
      if ((S.activeElement === u.current || S.activeElement === d.current) && (I = i(y.current)), I.length > 0) {
        const A = !!((P = b.current) != null && P.shiftKey && ((_ = b.current) == null ? void 0 : _.key) === "Tab"), D = I[0], M = I[I.length - 1];
        typeof D != "string" && typeof M != "string" && (A ? M.focus() : D.focus());
      } else
        k.focus();
    };
    S.addEventListener("focusin", C), S.addEventListener("keydown", O, !0);
    const T = setInterval(() => {
      S.activeElement && S.activeElement.tagName === "BODY" && C();
    }, 50);
    return () => {
      clearInterval(T), S.removeEventListener("focusin", C), S.removeEventListener("keydown", O, !0);
    };
  }, [n, r, o, a, c, i]);
  const x = (S) => {
    f.current === null && (f.current = S.relatedTarget), v.current = !0, h.current = S.target;
    const O = t.props.onFocus;
    O && O(S);
  }, $ = (S) => {
    f.current === null && (f.current = S.relatedTarget), v.current = !0;
  };
  return /* @__PURE__ */ F.jsxs(E.Fragment, {
    children: [/* @__PURE__ */ F.jsx("div", {
      tabIndex: c ? 0 : -1,
      onFocus: $,
      ref: u,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ E.cloneElement(t, {
      ref: g,
      onFocus: x
    }), /* @__PURE__ */ F.jsx("div", {
      tabIndex: c ? 0 : -1,
      onFocus: $,
      ref: d,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (jg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: el,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: s.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: s.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: s.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: s.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: s.func,
  /**
   * If `true`, focus is locked.
   */
  open: s.bool.isRequired
});
process.env.NODE_ENV !== "production" && (jg.propTypes = Yu(jg.propTypes));
function nce(e) {
  return typeof e == "function" ? e() : e;
}
function rce(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const fA = () => {
}, Qh = new Kse();
function oce(e) {
  const {
    container: t,
    disableEscapeKeyDown: n = !1,
    disableScrollLock: r = !1,
    closeAfterTransition: o = !1,
    onTransitionEnter: i,
    onTransitionExited: a,
    children: c,
    onClose: l,
    open: u,
    rootRef: d
  } = e, f = E.useRef({}), h = E.useRef(null), v = E.useRef(null), y = $n(v, d), [g, b] = E.useState(!u), x = rce(c);
  let $ = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && ($ = !1);
  const S = () => Un(h.current), O = () => (f.current.modalRef = v.current, f.current.mount = h.current, f.current), C = () => {
    Qh.mount(O(), {
      disableScrollLock: r
    }), v.current && (v.current.scrollTop = 0);
  }, T = hr(() => {
    const L = nce(t) || S().body;
    Qh.add(O(), L), v.current && C();
  }), k = () => Qh.isTopModal(O()), I = hr((L) => {
    h.current = L, L && (u && k() ? C() : v.current && xf(v.current, $));
  }), P = E.useCallback(() => {
    Qh.remove(O(), $);
  }, [$]);
  E.useEffect(() => () => {
    P();
  }, [P]), E.useEffect(() => {
    u ? T() : (!x || !o) && P();
  }, [u, P, x, o, T]);
  const _ = (L) => (z) => {
    var q;
    (q = L.onKeyDown) == null || q.call(L, z), !(z.key !== "Escape" || z.which === 229 || // Wait until IME is settled.
    !k()) && (n || (z.stopPropagation(), l && l(z, "escapeKeyDown")));
  }, A = (L) => (z) => {
    var q;
    (q = L.onClick) == null || q.call(L, z), z.target === z.currentTarget && l && l(z, "backdropClick");
  };
  return {
    getRootProps: (L = {}) => {
      const z = vf(e);
      delete z.onTransitionEnter, delete z.onTransitionExited;
      const q = {
        ...z,
        ...L
      };
      return {
        /*
         * Marking an element with the role presentation indicates to assistive technology
         * that this element should be ignored; it exists to support the web application and
         * is not meant for humans to interact with directly.
         * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
         */
        role: "presentation",
        ...q,
        onKeyDown: _(q),
        ref: y
      };
    },
    getBackdropProps: (L = {}) => {
      const z = L;
      return {
        "aria-hidden": !0,
        ...z,
        onClick: A(z),
        open: u
      };
    },
    getTransitionProps: () => {
      const L = () => {
        b(!1), i && i();
      }, z = () => {
        b(!0), a && a(), o && P();
      };
      return {
        onEnter: XO(L, (c == null ? void 0 : c.props.onEnter) ?? fA),
        onExited: XO(z, (c == null ? void 0 : c.props.onExited) ?? fA)
      };
    },
    rootRef: y,
    portalRef: I,
    isTopModal: k,
    exited: g,
    hasTransition: x
  };
}
function ice(e) {
  return mt("MuiModal", e);
}
gt("MuiModal", ["root", "hidden", "backdrop"]);
const ace = (e) => {
  const {
    open: t,
    exited: n,
    classes: r
  } = e;
  return wt({
    root: ["root", !t && n && "hidden"],
    backdrop: ["backdrop"]
  }, ice, r);
}, sce = Pe("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.open && n.exited && t.hidden];
  }
})(ct(({
  theme: e
}) => ({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  variants: [{
    props: ({
      ownerState: t
    }) => !t.open && t.exited,
    style: {
      visibility: "hidden"
    }
  }]
}))), cce = Pe(BL, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, t) => t.backdrop
})({
  zIndex: -1
}), kT = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: o = cce,
    BackdropProps: i,
    classes: a,
    className: c,
    closeAfterTransition: l = !1,
    children: u,
    container: d,
    component: f,
    components: h = {},
    componentsProps: v = {},
    disableAutoFocus: y = !1,
    disableEnforceFocus: g = !1,
    disableEscapeKeyDown: b = !1,
    disablePortal: x = !1,
    disableRestoreFocus: $ = !1,
    disableScrollLock: S = !1,
    hideBackdrop: O = !1,
    keepMounted: C = !1,
    onBackdropClick: T,
    onClose: k,
    onTransitionEnter: I,
    onTransitionExited: P,
    open: _,
    slotProps: A = {},
    slots: D = {},
    // eslint-disable-next-line react/prop-types
    theme: M,
    ...N
  } = r, L = {
    ...r,
    closeAfterTransition: l,
    disableAutoFocus: y,
    disableEnforceFocus: g,
    disableEscapeKeyDown: b,
    disablePortal: x,
    disableRestoreFocus: $,
    disableScrollLock: S,
    hideBackdrop: O,
    keepMounted: C
  }, {
    getRootProps: z,
    getBackdropProps: q,
    getTransitionProps: W,
    portalRef: U,
    isTopModal: K,
    exited: Y,
    hasTransition: X
  } = oce({
    ...L,
    rootRef: n
  }), oe = {
    ...L,
    exited: Y
  }, re = ace(oe), Z = {};
  if (u.props.tabIndex === void 0 && (Z.tabIndex = "-1"), X) {
    const {
      onEnter: G,
      onExited: Se
    } = W();
    Z.onEnter = G, Z.onExited = Se;
  }
  const ce = {
    ...N,
    slots: {
      root: h.Root,
      backdrop: h.Backdrop,
      ...D
    },
    slotProps: {
      ...v,
      ...A
    }
  }, [fe, de] = Mr("root", {
    elementType: sce,
    externalForwardedProps: ce,
    getSlotProps: z,
    additionalProps: {
      ref: n,
      as: f
    },
    ownerState: oe,
    className: Ge(c, re == null ? void 0 : re.root, !oe.open && oe.exited && (re == null ? void 0 : re.hidden))
  }), [ne, le] = Mr("backdrop", {
    elementType: o,
    externalForwardedProps: ce,
    additionalProps: i,
    getSlotProps: (G) => q({
      ...G,
      onClick: (Se) => {
        T && T(Se), G != null && G.onClick && G.onClick(Se);
      }
    }),
    className: Ge(i == null ? void 0 : i.className, re == null ? void 0 : re.backdrop),
    ownerState: oe
  }), ve = $n(i == null ? void 0 : i.ref, le.ref);
  return !C && !_ && (!X || Y) ? null : /* @__PURE__ */ F.jsx(Uf, {
    ref: U,
    container: d,
    disablePortal: x,
    children: /* @__PURE__ */ F.jsxs(fe, {
      ...de,
      children: [!O && o ? /* @__PURE__ */ F.jsx(ne, {
        ...le,
        ref: ve
      }) : null, /* @__PURE__ */ F.jsx(jg, {
        disableEnforceFocus: g,
        disableAutoFocus: y,
        disableRestoreFocus: $,
        isEnabled: K,
        open: _,
        children: /* @__PURE__ */ E.cloneElement(u, Z)
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (kT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: s.elementType,
  /**
   * Props applied to the [`Backdrop`](https://mui.com/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: s.object,
  /**
   * A single child content element.
   */
  children: el.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: s.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    Backdrop: s.elementType,
    Root: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: s.shape({
    backdrop: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: s.oneOfType([ra, s.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: s.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: s.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: s.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: s.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: s.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: s.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: s.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: s.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: s.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: s.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: s.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: s.shape({
    backdrop: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: s.shape({
    backdrop: s.elementType,
    root: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function lce(e) {
  return mt("MuiDivider", e);
}
const pA = gt("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), uce = (e) => {
  const {
    absolute: t,
    children: n,
    classes: r,
    flexItem: o,
    light: i,
    orientation: a,
    textAlign: c,
    variant: l
  } = e;
  return wt({
    root: ["root", t && "absolute", l, i && "light", a === "vertical" && "vertical", o && "flexItem", n && "withChildren", n && a === "vertical" && "withChildrenVertical", c === "right" && a !== "vertical" && "textAlignRight", c === "left" && a !== "vertical" && "textAlignLeft"],
    wrapper: ["wrapper", a === "vertical" && "wrapperVertical"]
  }, lce, r);
}, dce = Pe("div", {
  name: "MuiDivider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.absolute && t.absolute, t[n.variant], n.light && t.light, n.orientation === "vertical" && t.vertical, n.flexItem && t.flexItem, n.children && t.withChildren, n.children && n.orientation === "vertical" && t.withChildrenVertical, n.textAlign === "right" && n.orientation !== "vertical" && t.textAlignRight, n.textAlign === "left" && n.orientation !== "vertical" && t.textAlignLeft];
  }
})(ct(({
  theme: e
}) => ({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: (e.vars || e).palette.divider,
  borderBottomWidth: "thin",
  variants: [{
    props: {
      absolute: !0
    },
    style: {
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%"
    }
  }, {
    props: {
      light: !0
    },
    style: {
      borderColor: e.vars ? `rgba(${e.vars.palette.dividerChannel} / 0.08)` : It(e.palette.divider, 0.08)
    }
  }, {
    props: {
      variant: "inset"
    },
    style: {
      marginLeft: 72
    }
  }, {
    props: {
      variant: "middle",
      orientation: "horizontal"
    },
    style: {
      marginLeft: e.spacing(2),
      marginRight: e.spacing(2)
    }
  }, {
    props: {
      variant: "middle",
      orientation: "vertical"
    },
    style: {
      marginTop: e.spacing(1),
      marginBottom: e.spacing(1)
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      borderBottomWidth: 0,
      borderRightWidth: "thin"
    }
  }, {
    props: {
      flexItem: !0
    },
    style: {
      alignSelf: "stretch",
      height: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.children,
    style: {
      display: "flex",
      textAlign: "center",
      border: 0,
      borderTopStyle: "solid",
      borderLeftStyle: "solid",
      "&::before, &::after": {
        content: '""',
        alignSelf: "center"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.children && t.orientation !== "vertical",
    style: {
      "&::before, &::after": {
        width: "100%",
        borderTop: `thin solid ${(e.vars || e).palette.divider}`,
        borderTopStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.orientation === "vertical" && t.children,
    style: {
      flexDirection: "column",
      "&::before, &::after": {
        height: "100%",
        borderLeft: `thin solid ${(e.vars || e).palette.divider}`,
        borderLeftStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.textAlign === "right" && t.orientation !== "vertical",
    style: {
      "&::before": {
        width: "90%"
      },
      "&::after": {
        width: "10%"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.textAlign === "left" && t.orientation !== "vertical",
    style: {
      "&::before": {
        width: "10%"
      },
      "&::after": {
        width: "90%"
      }
    }
  }]
}))), fce = Pe("span", {
  name: "MuiDivider",
  slot: "Wrapper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.wrapper, n.orientation === "vertical" && t.wrapperVertical];
  }
})(ct(({
  theme: e
}) => ({
  display: "inline-block",
  paddingLeft: `calc(${e.spacing(1)} * 1.2)`,
  paddingRight: `calc(${e.spacing(1)} * 1.2)`,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      paddingTop: `calc(${e.spacing(1)} * 1.2)`,
      paddingBottom: `calc(${e.spacing(1)} * 1.2)`
    }
  }]
}))), lS = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiDivider"
  }), {
    absolute: o = !1,
    children: i,
    className: a,
    orientation: c = "horizontal",
    component: l = i || c === "vertical" ? "div" : "hr",
    flexItem: u = !1,
    light: d = !1,
    role: f = l !== "hr" ? "separator" : void 0,
    textAlign: h = "center",
    variant: v = "fullWidth",
    ...y
  } = r, g = {
    ...r,
    absolute: o,
    component: l,
    flexItem: u,
    light: d,
    orientation: c,
    role: f,
    textAlign: h,
    variant: v
  }, b = uce(g);
  return /* @__PURE__ */ F.jsx(dce, {
    as: l,
    className: Ge(b.root, a),
    role: f,
    ref: n,
    ownerState: g,
    "aria-orientation": f === "separator" && (l !== "hr" || c === "vertical") ? c : void 0,
    ...y,
    children: i ? /* @__PURE__ */ F.jsx(fce, {
      className: b.wrapper,
      ownerState: g,
      children: i
    }) : null
  });
});
lS && (lS.muiSkipListHighlight = !0);
process.env.NODE_ENV !== "production" && (lS.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: s.bool,
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: s.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  light: s.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: s.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  role: s.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: s.oneOf(["center", "left", "right"]),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: s.oneOfType([s.oneOf(["fullWidth", "inset", "middle"]), s.string])
});
function pce(e, t, n) {
  const r = t.getBoundingClientRect(), o = n && n.getBoundingClientRect(), i = Oo(t);
  let a;
  if (t.fakeTransform)
    a = t.fakeTransform;
  else {
    const u = i.getComputedStyle(t);
    a = u.getPropertyValue("-webkit-transform") || u.getPropertyValue("transform");
  }
  let c = 0, l = 0;
  if (a && a !== "none" && typeof a == "string") {
    const u = a.split("(")[1].split(")")[0].split(",");
    c = parseInt(u[4], 10), l = parseInt(u[5], 10);
  }
  return e === "left" ? o ? `translateX(${o.right + c - r.left}px)` : `translateX(${i.innerWidth + c - r.left}px)` : e === "right" ? o ? `translateX(-${r.right - o.left - c}px)` : `translateX(-${r.left + r.width - c}px)` : e === "up" ? o ? `translateY(${o.bottom + l - r.top}px)` : `translateY(${i.innerHeight + l - r.top}px)` : o ? `translateY(-${r.top - o.top + r.height - l}px)` : `translateY(-${r.top + r.height - l}px)`;
}
function VL(e) {
  return typeof e == "function" ? e() : e;
}
function em(e, t, n) {
  const r = VL(n), o = pce(e, t, r);
  o && (t.style.webkitTransform = o, t.style.transform = o);
}
const YL = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = Fr(), o = {
    enter: r.transitions.easing.easeOut,
    exit: r.transitions.easing.sharp
  }, i = {
    enter: r.transitions.duration.enteringScreen,
    exit: r.transitions.duration.leavingScreen
  }, {
    addEndListener: a,
    appear: c = !0,
    children: l,
    container: u,
    direction: d = "down",
    easing: f = o,
    in: h,
    onEnter: v,
    onEntered: y,
    onEntering: g,
    onExit: b,
    onExited: x,
    onExiting: $,
    style: S,
    timeout: O = i,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: C = Si,
    ...T
  } = t, k = E.useRef(null), I = $n(tl(l), k, n), P = (W) => (U) => {
    W && (U === void 0 ? W(k.current) : W(k.current, U));
  }, _ = P((W, U) => {
    em(d, W, u), bT(W), v && v(W, U);
  }), A = P((W, U) => {
    const K = $u({
      timeout: O,
      style: S,
      easing: f
    }, {
      mode: "enter"
    });
    W.style.webkitTransition = r.transitions.create("-webkit-transform", {
      ...K
    }), W.style.transition = r.transitions.create("transform", {
      ...K
    }), W.style.webkitTransform = "none", W.style.transform = "none", g && g(W, U);
  }), D = P(y), M = P($), N = P((W) => {
    const U = $u({
      timeout: O,
      style: S,
      easing: f
    }, {
      mode: "exit"
    });
    W.style.webkitTransition = r.transitions.create("-webkit-transform", U), W.style.transition = r.transitions.create("transform", U), em(d, W, u), b && b(W);
  }), L = P((W) => {
    W.style.webkitTransition = "", W.style.transition = "", x && x(W);
  }), z = (W) => {
    a && a(k.current, W);
  }, q = E.useCallback(() => {
    k.current && em(d, k.current, u);
  }, [d, u]);
  return E.useEffect(() => {
    if (h || d === "down" || d === "right")
      return;
    const W = Ep(() => {
      k.current && em(d, k.current, u);
    }), U = Oo(k.current);
    return U.addEventListener("resize", W), () => {
      W.clear(), U.removeEventListener("resize", W);
    };
  }, [d, h, u]), E.useEffect(() => {
    h || q();
  }, [h, q]), /* @__PURE__ */ F.jsx(C, {
    nodeRef: k,
    onEnter: _,
    onEntered: D,
    onEntering: A,
    onExit: N,
    onExited: L,
    onExiting: M,
    addEndListener: z,
    appear: c,
    in: h,
    timeout: O,
    ...T,
    children: (W, U) => /* @__PURE__ */ E.cloneElement(l, {
      ref: I,
      style: {
        visibility: W === "exited" && !h ? "hidden" : void 0,
        ...S,
        ...l.props.style
      },
      ...U
    })
  });
});
process.env.NODE_ENV !== "production" && (YL.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: s.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: s.bool,
  /**
   * A single child content element.
   */
  children: el.isRequired,
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the container the Slide is transitioning from.
   */
  container: $o(s.oneOfType([ra, s.func]), (e) => {
    if (e.open) {
      const t = VL(e.container);
      if (t && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `container` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `container` prop provided to the component is invalid.", "It should be an HTML element instance."].join(`
`));
    }
    return null;
  }),
  /**
   * Direction the child node will enter from.
   * @default 'down'
   */
  direction: s.oneOf(["down", "left", "right", "up"]),
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   * @default {
   *   enter: theme.transitions.easing.easeOut,
   *   exit: theme.transitions.easing.sharp,
   * }
   */
  easing: s.oneOfType([s.shape({
    enter: s.string,
    exit: s.string
  }), s.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: s.bool,
  /**
   * @ignore
   */
  onEnter: s.func,
  /**
   * @ignore
   */
  onEntered: s.func,
  /**
   * @ignore
   */
  onEntering: s.func,
  /**
   * @ignore
   */
  onExit: s.func,
  /**
   * @ignore
   */
  onExited: s.func,
  /**
   * @ignore
   */
  onExiting: s.func,
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: s.oneOfType([s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })])
});
function hce(e) {
  return mt("MuiDrawer", e);
}
gt("MuiDrawer", ["root", "docked", "paper", "paperAnchorLeft", "paperAnchorRight", "paperAnchorTop", "paperAnchorBottom", "paperAnchorDockedLeft", "paperAnchorDockedRight", "paperAnchorDockedTop", "paperAnchorDockedBottom", "modal"]);
const GL = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, (n.variant === "permanent" || n.variant === "persistent") && t.docked, t.modal];
}, mce = (e) => {
  const {
    classes: t,
    anchor: n,
    variant: r
  } = e, o = {
    root: ["root"],
    docked: [(r === "permanent" || r === "persistent") && "docked"],
    modal: ["modal"],
    paper: ["paper", `paperAnchor${Le(n)}`, r !== "temporary" && `paperAnchorDocked${Le(n)}`]
  };
  return wt(o, hce, t);
}, gce = Pe(kT, {
  name: "MuiDrawer",
  slot: "Root",
  overridesResolver: GL
})(ct(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.drawer
}))), hA = Pe("div", {
  shouldForwardProp: ar,
  name: "MuiDrawer",
  slot: "Docked",
  skipVariantsResolver: !1,
  overridesResolver: GL
})({
  flex: "0 0 auto"
}), vce = Pe(_p, {
  name: "MuiDrawer",
  slot: "Paper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.paper, t[`paperAnchor${Le(n.anchor)}`], n.variant !== "temporary" && t[`paperAnchorDocked${Le(n.anchor)}`]];
  }
})(ct(({
  theme: e
}) => ({
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  flex: "1 0 auto",
  zIndex: (e.vars || e).zIndex.drawer,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  // temporary style
  position: "fixed",
  top: 0,
  // We disable the focus ring for mouse, touch and keyboard users.
  // At some point, it would be better to keep it for keyboard users.
  // :focus-ring CSS pseudo-class will help.
  outline: 0,
  variants: [{
    props: {
      anchor: "left"
    },
    style: {
      left: 0
    }
  }, {
    props: {
      anchor: "top"
    },
    style: {
      top: 0,
      left: 0,
      right: 0,
      height: "auto",
      maxHeight: "100%"
    }
  }, {
    props: {
      anchor: "right"
    },
    style: {
      right: 0
    }
  }, {
    props: {
      anchor: "bottom"
    },
    style: {
      top: "auto",
      left: 0,
      bottom: 0,
      right: 0,
      height: "auto",
      maxHeight: "100%"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchor === "left" && t.variant !== "temporary",
    style: {
      borderRight: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchor === "top" && t.variant !== "temporary",
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchor === "right" && t.variant !== "temporary",
    style: {
      borderLeft: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchor === "bottom" && t.variant !== "temporary",
    style: {
      borderTop: `1px solid ${(e.vars || e).palette.divider}`
    }
  }]
}))), KL = {
  left: "right",
  right: "left",
  top: "down",
  bottom: "up"
};
function yce(e) {
  return ["left", "right"].includes(e);
}
function bce({
  direction: e
}, t) {
  return e === "rtl" && yce(t) ? KL[t] : t;
}
const xce = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiDrawer"
  }), o = Fr(), i = Ya(), a = {
    enter: o.transitions.duration.enteringScreen,
    exit: o.transitions.duration.leavingScreen
  }, {
    anchor: c = "left",
    BackdropProps: l,
    children: u,
    className: d,
    elevation: f = 16,
    hideBackdrop: h = !1,
    ModalProps: {
      BackdropProps: v,
      ...y
    } = {},
    onClose: g,
    open: b = !1,
    PaperProps: x = {},
    SlideProps: $,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: S = YL,
    transitionDuration: O = a,
    variant: C = "temporary",
    ...T
  } = r, k = E.useRef(!1);
  E.useEffect(() => {
    k.current = !0;
  }, []);
  const I = bce({
    direction: i ? "rtl" : "ltr"
  }, c), _ = {
    ...r,
    anchor: c,
    elevation: f,
    open: b,
    variant: C,
    ...T
  }, A = mce(_), D = /* @__PURE__ */ F.jsx(vce, {
    elevation: C === "temporary" ? f : 0,
    square: !0,
    ...x,
    className: Ge(A.paper, x.className),
    ownerState: _,
    children: u
  });
  if (C === "permanent")
    return /* @__PURE__ */ F.jsx(hA, {
      className: Ge(A.root, A.docked, d),
      ownerState: _,
      ref: n,
      ...T,
      children: D
    });
  const M = /* @__PURE__ */ F.jsx(S, {
    in: b,
    direction: KL[I],
    timeout: O,
    appear: k.current,
    ...$,
    children: D
  });
  return C === "persistent" ? /* @__PURE__ */ F.jsx(hA, {
    className: Ge(A.root, A.docked, d),
    ownerState: _,
    ref: n,
    ...T,
    children: M
  }) : /* @__PURE__ */ F.jsx(gce, {
    BackdropProps: {
      ...l,
      ...v,
      transitionDuration: O
    },
    className: Ge(A.root, A.modal, d),
    open: b,
    ownerState: _,
    onClose: g,
    hideBackdrop: h,
    ref: n,
    ...T,
    ...y,
    children: M
  });
});
process.env.NODE_ENV !== "production" && (xce.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Side from which the drawer will appear.
   * @default 'left'
   */
  anchor: s.oneOf(["bottom", "left", "right", "top"]),
  /**
   * @ignore
   */
  BackdropProps: s.object,
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The elevation of the drawer.
   * @default 16
   */
  elevation: rv,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: s.bool,
  /**
   * Props applied to the [`Modal`](https://mui.com/material-ui/api/modal/) element.
   * @default {}
   */
  ModalProps: s.object,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: s.func,
  /**
   * If `true`, the component is shown.
   * @default false
   */
  open: s.bool,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   * @default {}
   */
  PaperProps: s.object,
  /**
   * Props applied to the [`Slide`](https://mui.com/material-ui/api/slide/) element.
   */
  SlideProps: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: s.oneOfType([s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })]),
  /**
   * The variant to use.
   * @default 'temporary'
   */
  variant: s.oneOf(["permanent", "persistent", "temporary"])
});
const wce = (e) => {
  const {
    classes: t,
    disableUnderline: n,
    startAdornment: r,
    endAdornment: o,
    size: i,
    hiddenLabel: a,
    multiline: c
  } = e, l = {
    root: ["root", !n && "underline", r && "adornedStart", o && "adornedEnd", i === "small" && `size${Le(i)}`, a && "hiddenLabel", c && "multiline"],
    input: ["input"]
  }, u = wt(l, _ae, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...u
  };
}, $ce = Pe(hv, {
  shouldForwardProp: (e) => ar(e) || e === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...fv(e, t), !n.disableUnderline && t.underline];
  }
})(ct(({
  theme: e
}) => {
  const t = e.palette.mode === "light", n = t ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", r = t ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", o = t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", i = t ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    position: "relative",
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : o,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r
      }
    },
    [`&.${mo.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : r
    },
    [`&.${mo.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : i
    },
    variants: [{
      props: ({
        ownerState: a
      }) => !a.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${mo.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${mo.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : n}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${mo.disabled}, .${mo.error}):before`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
        },
        [`&.${mo.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(e.palette).filter(Dn()).map(([a]) => {
      var c;
      return {
        props: {
          disableUnderline: !1,
          color: a
        },
        style: {
          "&::after": {
            borderBottom: `2px solid ${(c = (e.vars || e).palette[a]) == null ? void 0 : c.main}`
          }
        }
      };
    }), {
      props: ({
        ownerState: a
      }) => a.startAdornment,
      style: {
        paddingLeft: 12
      }
    }, {
      props: ({
        ownerState: a
      }) => a.endAdornment,
      style: {
        paddingRight: 12
      }
    }, {
      props: ({
        ownerState: a
      }) => a.multiline,
      style: {
        padding: "25px 12px 8px"
      }
    }, {
      props: ({
        ownerState: a,
        size: c
      }) => a.multiline && c === "small",
      style: {
        paddingTop: 21,
        paddingBottom: 4
      }
    }, {
      props: ({
        ownerState: a
      }) => a.multiline && a.hiddenLabel,
      style: {
        paddingTop: 16,
        paddingBottom: 17
      }
    }, {
      props: ({
        ownerState: a
      }) => a.multiline && a.hiddenLabel && a.size === "small",
      style: {
        paddingTop: 8,
        paddingBottom: 9
      }
    }]
  };
})), Oce = Pe(mv, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: pv
})(ct(({
  theme: e
}) => ({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  ...!e.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
      caretColor: e.palette.mode === "light" ? null : "#fff",
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    }
  },
  ...e.vars && {
    "&:-webkit-autofill": {
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    },
    [e.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hiddenLabel,
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: ({
      ownerState: t
    }) => t.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.endAdornment,
    style: {
      paddingRight: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hiddenLabel && t.size === "small",
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }, {
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    }
  }]
}))), Wf = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiFilledInput"
  }), {
    disableUnderline: o = !1,
    components: i = {},
    componentsProps: a,
    fullWidth: c = !1,
    hiddenLabel: l,
    // declare here to prevent spreading to DOM
    inputComponent: u = "input",
    multiline: d = !1,
    slotProps: f,
    slots: h = {},
    type: v = "text",
    ...y
  } = r, g = {
    ...r,
    disableUnderline: o,
    fullWidth: c,
    inputComponent: u,
    multiline: d,
    type: v
  }, b = wce(r), x = {
    root: {
      ownerState: g
    },
    input: {
      ownerState: g
    }
  }, $ = f ?? a ? or(x, f ?? a) : x, S = h.root ?? i.Root ?? $ce, O = h.input ?? i.Input ?? Oce;
  return /* @__PURE__ */ F.jsx(gv, {
    slots: {
      root: S,
      input: O
    },
    slotProps: $,
    fullWidth: c,
    inputComponent: u,
    multiline: d,
    ref: n,
    type: v,
    ...y,
    classes: b
  });
});
process.env.NODE_ENV !== "production" && (Wf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: s.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary"]), s.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    Input: s.elementType,
    Root: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: s.shape({
    input: s.object,
    root: s.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: s.bool,
  /**
   * If `true`, the input will not have an underline.
   * @default false
   */
  disableUnderline: s.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: s.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: s.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: s.bool,
  /**
   * The id of the `input` element.
   */
  id: s.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: s.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: jr,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: s.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: s.oneOfType([s.number, s.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: s.oneOfType([s.number, s.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: s.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: s.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: s.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: s.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: s.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: s.oneOfType([s.number, s.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: s.shape({
    input: s.object,
    root: s.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: s.shape({
    input: s.elementType,
    root: s.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: s.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: s.any
});
Wf && (Wf.muiName = "Input");
function Sce(e) {
  return mt("MuiFormControl", e);
}
gt("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
const Cce = (e) => {
  const {
    classes: t,
    margin: n,
    fullWidth: r
  } = e, o = {
    root: ["root", n !== "none" && `margin${Le(n)}`, r && "fullWidth"]
  };
  return wt(o, Sce, t);
}, Tce = Pe("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`margin${Le(n.margin)}`], n.fullWidth && t.fullWidth];
  }
})({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top",
  // Fix alignment issue on Safari.
  variants: [{
    props: {
      margin: "normal"
    },
    style: {
      marginTop: 16,
      marginBottom: 8
    }
  }, {
    props: {
      margin: "dense"
    },
    style: {
      marginTop: 8,
      marginBottom: 4
    }
  }, {
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }]
}), XL = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiFormControl"
  }), {
    children: o,
    className: i,
    color: a = "primary",
    component: c = "div",
    disabled: l = !1,
    error: u = !1,
    focused: d,
    fullWidth: f = !1,
    hiddenLabel: h = !1,
    margin: v = "none",
    required: y = !1,
    size: g = "medium",
    variant: b = "outlined",
    ...x
  } = r, $ = {
    ...r,
    color: a,
    component: c,
    disabled: l,
    error: u,
    fullWidth: f,
    hiddenLabel: h,
    margin: v,
    required: y,
    size: g,
    variant: b
  }, S = Cce($), [O, C] = E.useState(() => {
    let N = !1;
    return o && E.Children.forEach(o, (L) => {
      if (!Zm(L, ["Input", "Select"]))
        return;
      const z = Zm(L, ["Select"]) ? L.props.input : L;
      z && Oae(z.props) && (N = !0);
    }), N;
  }), [T, k] = E.useState(() => {
    let N = !1;
    return o && E.Children.forEach(o, (L) => {
      Zm(L, ["Input", "Select"]) && (Lg(L.props, !0) || Lg(L.props.inputProps, !0)) && (N = !0);
    }), N;
  }), [I, P] = E.useState(!1);
  l && I && P(!1);
  const _ = d !== void 0 && !l ? d : I;
  let A;
  const D = E.useRef(!1);
  process.env.NODE_ENV !== "production" && (A = () => (D.current && console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join(`
`)), D.current = !0, () => {
    D.current = !1;
  }));
  const M = E.useMemo(() => ({
    adornedStart: O,
    setAdornedStart: C,
    color: a,
    disabled: l,
    error: u,
    filled: T,
    focused: _,
    fullWidth: f,
    hiddenLabel: h,
    size: g,
    onBlur: () => {
      P(!1);
    },
    onEmpty: () => {
      k(!1);
    },
    onFilled: () => {
      k(!0);
    },
    onFocus: () => {
      P(!0);
    },
    registerEffect: A,
    required: y,
    variant: b
  }), [O, a, l, u, T, _, f, h, A, y, g, b]);
  return /* @__PURE__ */ F.jsx(dv.Provider, {
    value: M,
    children: /* @__PURE__ */ F.jsx(Tce, {
      as: c,
      ownerState: $,
      className: Ge(S.root, i),
      ref: n,
      ...x,
      children: o
    })
  });
});
process.env.NODE_ENV !== "production" && (XL.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: s.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: s.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: s.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: s.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: s.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["medium", "small"]), s.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: s.oneOf(["filled", "outlined", "standard"])
});
function Ece(e) {
  return mt("MuiFormHelperText", e);
}
const mA = gt("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]);
var gA;
const _ce = (e) => {
  const {
    classes: t,
    contained: n,
    size: r,
    disabled: o,
    error: i,
    filled: a,
    focused: c,
    required: l
  } = e, u = {
    root: ["root", o && "disabled", i && "error", r && `size${Le(r)}`, n && "contained", c && "focused", a && "filled", l && "required"]
  };
  return wt(u, Ece, t);
}, kce = Pe("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.size && t[`size${Le(n.size)}`], n.contained && t.contained, n.filled && t.filled];
  }
})(ct(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  ...e.typography.caption,
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${mA.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${mA.error}`]: {
    color: (e.vars || e).palette.error.main
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginTop: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => t.contained,
    style: {
      marginLeft: 14,
      marginRight: 14
    }
  }]
}))), ZL = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiFormHelperText"
  }), {
    children: o,
    className: i,
    component: a = "p",
    disabled: c,
    error: l,
    filled: u,
    focused: d,
    margin: f,
    required: h,
    variant: v,
    ...y
  } = r, g = Gs(), b = Ku({
    props: r,
    muiFormControl: g,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), x = {
    ...r,
    component: a,
    contained: b.variant === "filled" || b.variant === "outlined",
    variant: b.variant,
    size: b.size,
    disabled: b.disabled,
    error: b.error,
    filled: b.filled,
    focused: b.focused,
    required: b.required
  };
  delete x.ownerState;
  const $ = _ce(x);
  return /* @__PURE__ */ F.jsx(kce, {
    as: a,
    className: Ge($.root, i),
    ref: n,
    ...y,
    ownerState: x,
    children: o === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      gA || (gA = /* @__PURE__ */ F.jsx("span", {
        className: "notranslate",
        "aria-hidden": !0,
        children: "​"
      }))
    ) : o
  });
});
process.env.NODE_ENV !== "production" && (ZL.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: s.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: s.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: s.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: s.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: s.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   */
  variant: s.oneOfType([s.oneOf(["filled", "outlined", "standard"]), s.string])
});
function Rce(e) {
  return mt("MuiFormLabel", e);
}
const wf = gt("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]), Pce = (e) => {
  const {
    classes: t,
    color: n,
    focused: r,
    disabled: o,
    error: i,
    filled: a,
    required: c
  } = e, l = {
    root: ["root", `color${Le(n)}`, o && "disabled", i && "error", a && "filled", r && "focused", c && "required"],
    asterisk: ["asterisk", i && "error"]
  };
  return wt(l, Rce, t);
}, Ace = Pe("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color === "secondary" && t.colorSecondary, n.filled && t.filled];
  }
})(ct(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  ...e.typography.body1,
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  variants: [...Object.entries(e.palette).filter(Dn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${wf.focused}`]: {
        color: (e.vars || e).palette[t].main
      }
    }
  })), {
    props: {},
    style: {
      [`&.${wf.disabled}`]: {
        color: (e.vars || e).palette.text.disabled
      },
      [`&.${wf.error}`]: {
        color: (e.vars || e).palette.error.main
      }
    }
  }]
}))), Ice = Pe("span", {
  name: "MuiFormLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(ct(({
  theme: e
}) => ({
  [`&.${wf.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}))), JL = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiFormLabel"
  }), {
    children: o,
    className: i,
    color: a,
    component: c = "label",
    disabled: l,
    error: u,
    filled: d,
    focused: f,
    required: h,
    ...v
  } = r, y = Gs(), g = Ku({
    props: r,
    muiFormControl: y,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), b = {
    ...r,
    color: g.color || "primary",
    component: c,
    disabled: g.disabled,
    error: g.error,
    filled: g.filled,
    focused: g.focused,
    required: g.required
  }, x = Pce(b);
  return /* @__PURE__ */ F.jsxs(Ace, {
    as: c,
    ownerState: b,
    className: Ge(x.root, i),
    ref: n,
    ...v,
    children: [o, g.required && /* @__PURE__ */ F.jsxs(Ice, {
      ownerState: b,
      "aria-hidden": !0,
      className: x.asterisk,
      children: [" ", "*"]
    })]
  });
});
process.env.NODE_ENV !== "production" && (JL.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: s.oneOfType([s.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: s.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: s.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: s.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: s.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const QL = gre({
  createStyledComponent: Pe("div", {
    name: "MuiGrid2",
    slot: "Root",
    overridesResolver: (e, t) => {
      const {
        ownerState: n
      } = e;
      return [t.root, n.container && t.container];
    }
  }),
  componentName: "MuiGrid2",
  useThemeProps: (e) => $t({
    props: e,
    name: "MuiGrid2"
  }),
  useTheme: Fr
});
process.env.NODE_ENV !== "production" && (QL.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * The number of columns.
   * @default 12
   */
  columns: s.oneOfType([s.arrayOf(s.number), s.number, s.object]),
  /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  columnSpacing: s.oneOfType([s.arrayOf(s.oneOfType([s.number, s.string])), s.number, s.object, s.string]),
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  container: s.bool,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */
  direction: s.oneOfType([s.oneOf(["column-reverse", "column", "row-reverse", "row"]), s.arrayOf(s.oneOf(["column-reverse", "column", "row-reverse", "row"])), s.object]),
  /**
   * Defines the offset value for the type `item` components.
   */
  offset: s.oneOfType([s.string, s.number, s.arrayOf(s.oneOfType([s.string, s.number])), s.object]),
  /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  rowSpacing: s.oneOfType([s.arrayOf(s.oneOfType([s.number, s.string])), s.number, s.object, s.string]),
  /**
   * Defines the size of the the type `item` components.
   */
  size: s.oneOfType([s.string, s.bool, s.number, s.arrayOf(s.oneOfType([s.string, s.bool, s.number])), s.object]),
  /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */
  spacing: s.oneOfType([s.arrayOf(s.oneOfType([s.number, s.string])), s.number, s.object, s.string]),
  /**
   * @ignore
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * @internal
   * The level of the grid starts from `0` and increases when the grid nests
   * inside another grid. Nesting is defined as a container Grid being a direct
   * child of a container Grid.
   *
   * ```js
   * <Grid container> // level 0
   *   <Grid container> // level 1
   *     <Grid container> // level 2
   * ```
   *
   * Only consecutive grid is considered nesting. A grid container will start at
   * `0` if there are non-Grid container element above it.
   *
   * ```js
   * <Grid container> // level 0
   *   <div>
   *     <Grid container> // level 0
   * ```
   *
   * ```js
   * <Grid container> // level 0
   *   <Grid>
   *     <Grid container> // level 0
   * ```
   */
  unstable_level: s.number,
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */
  wrap: s.oneOf(["nowrap", "wrap-reverse", "wrap"])
});
if (process.env.NODE_ENV !== "production") {
  const e = QL, t = Pne("Grid2", e);
  e.propTypes = {
    // eslint-disable-next-line react/forbid-foreign-prop-types
    ...e.propTypes,
    direction: t("container"),
    spacing: t("container"),
    wrap: t("container")
  };
}
function uS(e) {
  return `scale(${e}, ${e ** 2})`;
}
const Mce = {
  entering: {
    opacity: 1,
    transform: uS(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, a1 = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), Fg = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const {
    addEndListener: r,
    appear: o = !0,
    children: i,
    easing: a,
    in: c,
    onEnter: l,
    onEntered: u,
    onEntering: d,
    onExit: f,
    onExited: h,
    onExiting: v,
    style: y,
    timeout: g = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: b = Si,
    ...x
  } = t, $ = oL(), S = E.useRef(), O = Fr(), C = E.useRef(null), T = $n(C, tl(i), n), k = (L) => (z) => {
    if (L) {
      const q = C.current;
      z === void 0 ? L(q) : L(q, z);
    }
  }, I = k(d), P = k((L, z) => {
    bT(L);
    const {
      duration: q,
      delay: W,
      easing: U
    } = $u({
      style: y,
      timeout: g,
      easing: a
    }, {
      mode: "enter"
    });
    let K;
    g === "auto" ? (K = O.transitions.getAutoHeightDuration(L.clientHeight), S.current = K) : K = q, L.style.transition = [O.transitions.create("opacity", {
      duration: K,
      delay: W
    }), O.transitions.create("transform", {
      duration: a1 ? K : K * 0.666,
      delay: W,
      easing: U
    })].join(","), l && l(L, z);
  }), _ = k(u), A = k(v), D = k((L) => {
    const {
      duration: z,
      delay: q,
      easing: W
    } = $u({
      style: y,
      timeout: g,
      easing: a
    }, {
      mode: "exit"
    });
    let U;
    g === "auto" ? (U = O.transitions.getAutoHeightDuration(L.clientHeight), S.current = U) : U = z, L.style.transition = [O.transitions.create("opacity", {
      duration: U,
      delay: q
    }), O.transitions.create("transform", {
      duration: a1 ? U : U * 0.666,
      delay: a1 ? q : q || U * 0.333,
      easing: W
    })].join(","), L.style.opacity = 0, L.style.transform = uS(0.75), f && f(L);
  }), M = k(h), N = (L) => {
    g === "auto" && $.start(S.current || 0, L), r && r(C.current, L);
  };
  return /* @__PURE__ */ F.jsx(b, {
    appear: o,
    in: c,
    nodeRef: C,
    onEnter: P,
    onEntered: _,
    onEntering: I,
    onExit: D,
    onExited: M,
    onExiting: A,
    addEndListener: N,
    timeout: g === "auto" ? null : g,
    ...x,
    children: (L, z) => /* @__PURE__ */ E.cloneElement(i, {
      style: {
        opacity: 0,
        transform: uS(0.75),
        visibility: L === "exited" && !c ? "hidden" : void 0,
        ...Mce[L],
        ...y,
        ...i.props.style
      },
      ref: T,
      ...z
    })
  });
});
process.env.NODE_ENV !== "production" && (Fg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: s.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: s.bool,
  /**
   * A single child content element.
   */
  children: el.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: s.oneOfType([s.shape({
    enter: s.string,
    exit: s.string
  }), s.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: s.bool,
  /**
   * @ignore
   */
  onEnter: s.func,
  /**
   * @ignore
   */
  onEntered: s.func,
  /**
   * @ignore
   */
  onEntering: s.func,
  /**
   * @ignore
   */
  onExit: s.func,
  /**
   * @ignore
   */
  onExited: s.func,
  /**
   * @ignore
   */
  onExiting: s.func,
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: s.oneOfType([s.oneOf(["auto"]), s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })])
});
Fg && (Fg.muiSupportAuto = !0);
const EIe = Q7({
  themeId: Xo
});
function Nce(e) {
  return mt("MuiIcon", e);
}
gt("MuiIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const Dce = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: r
  } = e, o = {
    root: ["root", t !== "inherit" && `color${Le(t)}`, `fontSize${Le(n)}`]
  };
  return wt(o, Nce, r);
}, Lce = Pe("span", {
  name: "MuiIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${Le(n.color)}`], t[`fontSize${Le(n.fontSize)}`]];
  }
})(ct(({
  theme: e
}) => ({
  userSelect: "none",
  width: "1em",
  height: "1em",
  // Chrome fix for https://issues.chromium.org/issues/41375697
  // To remove at some point.
  overflow: "hidden",
  display: "inline-block",
  // allow overflow hidden to take action
  textAlign: "center",
  // support non-square icon
  flexShrink: 0,
  variants: [{
    props: {
      fontSize: "inherit"
    },
    style: {
      fontSize: "inherit"
    }
  }, {
    props: {
      fontSize: "small"
    },
    style: {
      fontSize: e.typography.pxToRem(20)
    }
  }, {
    props: {
      fontSize: "medium"
    },
    style: {
      fontSize: e.typography.pxToRem(24)
    }
  }, {
    props: {
      fontSize: "large"
    },
    style: {
      fontSize: e.typography.pxToRem(36)
    }
  }, {
    props: {
      color: "action"
    },
    style: {
      color: (e.vars || e).palette.action.active
    }
  }, {
    props: {
      color: "disabled"
    },
    style: {
      color: (e.vars || e).palette.action.disabled
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      color: void 0
    }
  }, ...Object.entries(e.palette).filter(Dn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  }))]
}))), dS = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiIcon"
  }), {
    baseClassName: o = "material-icons",
    className: i,
    color: a = "inherit",
    component: c = "span",
    fontSize: l = "medium",
    ...u
  } = r, d = {
    ...r,
    baseClassName: o,
    color: a,
    component: c,
    fontSize: l
  }, f = Dce(d);
  return /* @__PURE__ */ F.jsx(Lce, {
    as: c,
    className: Ge(
      o,
      // Prevent the translation of the text content.
      // The font relies on the exact text content to render the icon.
      "notranslate",
      f.root,
      i
    ),
    ownerState: d,
    "aria-hidden": !0,
    ref: n,
    ...u
  });
});
process.env.NODE_ENV !== "production" && (dS.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The base class applied to the icon. Defaults to 'material-icons', but can be changed to any
   * other base class that suits the icon font you're using (for example material-icons-rounded, fas, etc).
   * @default 'material-icons'
   */
  baseClassName: s.string,
  /**
   * The name of the icon font ligature.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'inherit'
   */
  color: s.oneOfType([s.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: s.oneOfType([s.oneOf(["inherit", "large", "medium", "small"]), s.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
dS && (dS.muiName = "Icon");
const jce = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, o = wt({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, Tae, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...o
  };
}, Fce = Pe(hv, {
  shouldForwardProp: (e) => ar(e) || e === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...fv(e, t), !n.disableUnderline && t.underline];
  }
})(ct(({
  theme: e
}) => {
  let n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (n = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), {
    position: "relative",
    variants: [{
      props: ({
        ownerState: r
      }) => r.formControl,
      style: {
        "label + &": {
          marginTop: 16
        }
      }
    }, {
      props: ({
        ownerState: r
      }) => !r.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${xs.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${xs.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${n}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${xs.disabled}, .${xs.error}):before`]: {
          borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${n}`
          }
        },
        [`&.${xs.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(e.palette).filter(Dn()).map(([r]) => ({
      props: {
        color: r,
        disableUnderline: !1
      },
      style: {
        "&::after": {
          borderBottom: `2px solid ${(e.vars || e).palette[r].main}`
        }
      }
    }))]
  };
})), zce = Pe(mv, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: pv
})({}), Hf = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiInput"
  }), {
    disableUnderline: o = !1,
    components: i = {},
    componentsProps: a,
    fullWidth: c = !1,
    inputComponent: l = "input",
    multiline: u = !1,
    slotProps: d,
    slots: f = {},
    type: h = "text",
    ...v
  } = r, y = jce(r), b = {
    root: {
      ownerState: {
        disableUnderline: o
      }
    }
  }, x = d ?? a ? or(d ?? a, b) : b, $ = f.root ?? i.Root ?? Fce, S = f.input ?? i.Input ?? zce;
  return /* @__PURE__ */ F.jsx(gv, {
    slots: {
      root: $,
      input: S
    },
    slotProps: x,
    fullWidth: c,
    inputComponent: l,
    multiline: u,
    ref: n,
    type: h,
    ...v,
    classes: y
  });
});
process.env.NODE_ENV !== "production" && (Hf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: s.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary"]), s.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    Input: s.elementType,
    Root: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: s.shape({
    input: s.object,
    root: s.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: s.bool,
  /**
   * If `true`, the `input` will not have an underline.
   * @default false
   */
  disableUnderline: s.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: s.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: s.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The id of the `input` element.
   */
  id: s.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: s.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: jr,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: s.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: s.oneOfType([s.number, s.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: s.oneOfType([s.number, s.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: s.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: s.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: s.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: s.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: s.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: s.oneOfType([s.number, s.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: s.shape({
    input: s.object,
    root: s.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: s.shape({
    input: s.elementType,
    root: s.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: s.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: s.any
});
Hf && (Hf.muiName = "Input");
function Bce(e) {
  return mt("MuiInputLabel", e);
}
gt("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]);
const qce = (e) => {
  const {
    classes: t,
    formControl: n,
    size: r,
    shrink: o,
    disableAnimation: i,
    variant: a,
    required: c
  } = e, l = {
    root: ["root", n && "formControl", !i && "animated", o && "shrink", r && r !== "normal" && `size${Le(r)}`, a],
    asterisk: [c && "asterisk"]
  }, u = wt(l, Bce, t);
  return {
    ...t,
    // forward the focused, disabled, etc. classes to the FormLabel
    ...u
  };
}, Uce = Pe(JL, {
  shouldForwardProp: (e) => ar(e) || e === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${wf.asterisk}`]: t.asterisk
    }, t.root, n.formControl && t.formControl, n.size === "small" && t.sizeSmall, n.shrink && t.shrink, !n.disableAnimation && t.animated, n.focused && t.focused, t[n.variant]];
  }
})(ct(({
  theme: e
}) => ({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%",
  variants: [{
    props: ({
      ownerState: t
    }) => t.formControl,
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: "translate(0, 20px) scale(1)"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      // Compensation for the `Input.inputSizeSmall` style.
      transform: "translate(0, 17px) scale(1)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.shrink,
    style: {
      transform: "translate(0, -1.5px) scale(0.75)",
      transformOrigin: "top left",
      maxWidth: "133%"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableAnimation,
    style: {
      transition: e.transitions.create(["color", "transform", "max-width"], {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(12px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "filled",
      size: "small"
    },
    style: {
      transform: "translate(12px, 13px) scale(1)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: n
    }) => t === "filled" && n.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      transform: "translate(12px, 7px) scale(0.75)",
      maxWidth: "calc(133% - 24px)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: n,
      size: r
    }) => t === "filled" && n.shrink && r === "small",
    style: {
      transform: "translate(12px, 4px) scale(0.75)"
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(14px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "outlined",
      size: "small"
    },
    style: {
      transform: "translate(14px, 9px) scale(1)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: n
    }) => t === "outlined" && n.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      // Theoretically, we should have (8+5)*2/0.75 = 34px
      // but it feels a better when it bleeds a bit on the left, so 32px.
      maxWidth: "calc(133% - 32px)",
      transform: "translate(14px, -9px) scale(0.75)"
    }
  }]
}))), ej = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    name: "MuiInputLabel",
    props: t
  }), {
    disableAnimation: o = !1,
    margin: i,
    shrink: a,
    variant: c,
    className: l,
    ...u
  } = r, d = Gs();
  let f = a;
  typeof f > "u" && d && (f = d.filled || d.focused || d.adornedStart);
  const h = Ku({
    props: r,
    muiFormControl: d,
    states: ["size", "variant", "required", "focused"]
  }), v = {
    ...r,
    disableAnimation: o,
    formControl: d,
    shrink: f,
    size: h.size,
    variant: h.variant,
    required: h.required,
    focused: h.focused
  }, y = qce(v);
  return /* @__PURE__ */ F.jsx(Uce, {
    "data-shrink": f,
    ref: n,
    className: Ge(y.root, l),
    ...u,
    ownerState: v,
    classes: y
  });
});
process.env.NODE_ENV !== "production" && (ej.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: s.oneOfType([s.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), s.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: s.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: s.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: s.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: s.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: s.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: s.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: s.bool,
  /**
   * The size of the component.
   * @default 'normal'
   */
  size: s.oneOfType([s.oneOf(["normal", "small"]), s.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The variant to use.
   */
  variant: s.oneOf(["filled", "outlined", "standard"])
});
const Eu = /* @__PURE__ */ E.createContext({});
process.env.NODE_ENV !== "production" && (Eu.displayName = "ListContext");
function Wce(e) {
  return mt("MuiList", e);
}
gt("MuiList", ["root", "padding", "dense", "subheader"]);
const Hce = (e) => {
  const {
    classes: t,
    disablePadding: n,
    dense: r,
    subheader: o
  } = e;
  return wt({
    root: ["root", !n && "padding", r && "dense", o && "subheader"]
  }, Wce, t);
}, Vce = Pe("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disablePadding && t.padding, n.dense && t.dense, n.subheader && t.subheader];
  }
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative",
  variants: [{
    props: ({
      ownerState: e
    }) => !e.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: e
    }) => e.subheader,
    style: {
      paddingTop: 0
    }
  }]
}), tj = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiList"
  }), {
    children: o,
    className: i,
    component: a = "ul",
    dense: c = !1,
    disablePadding: l = !1,
    subheader: u,
    ...d
  } = r, f = E.useMemo(() => ({
    dense: c
  }), [c]), h = {
    ...r,
    component: a,
    dense: c,
    disablePadding: l
  }, v = Hce(h);
  return /* @__PURE__ */ F.jsx(Eu.Provider, {
    value: f,
    children: /* @__PURE__ */ F.jsxs(Vce, {
      as: a,
      className: Ge(v.root, i),
      ref: n,
      ownerState: h,
      ...d,
      children: [u, o]
    })
  });
});
process.env.NODE_ENV !== "production" && (tj.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: s.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: s.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function Yce(e) {
  return mt("MuiListItemButton", e);
}
const Md = gt("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]), Gce = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.alignItems === "flex-start" && t.alignItemsFlexStart, n.divider && t.divider, !n.disableGutters && t.gutters];
}, Kce = (e) => {
  const {
    alignItems: t,
    classes: n,
    dense: r,
    disabled: o,
    disableGutters: i,
    divider: a,
    selected: c
  } = e, u = wt({
    root: ["root", r && "dense", !i && "gutters", a && "divider", o && "disabled", t === "flex-start" && "alignItemsFlexStart", c && "selected"]
  }, Yce, n);
  return {
    ...n,
    ...u
  };
}, Xce = Pe(oa, {
  shouldForwardProp: (e) => ar(e) || e === "classes",
  name: "MuiListItemButton",
  slot: "Root",
  overridesResolver: Gce
})(ct(({
  theme: e
}) => ({
  display: "flex",
  flexGrow: 1,
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minWidth: 0,
  boxSizing: "border-box",
  textAlign: "left",
  paddingTop: 8,
  paddingBottom: 8,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Md.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : It(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${Md.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : It(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${Md.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : It(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : It(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${Md.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${Md.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: {
      alignItems: "flex-start"
    },
    style: {
      alignItems: "flex-start"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.dense,
    style: {
      paddingTop: 4,
      paddingBottom: 4
    }
  }]
}))), Zce = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiListItemButton"
  }), {
    alignItems: o = "center",
    autoFocus: i = !1,
    component: a = "div",
    children: c,
    dense: l = !1,
    disableGutters: u = !1,
    divider: d = !1,
    focusVisibleClassName: f,
    selected: h = !1,
    className: v,
    ...y
  } = r, g = E.useContext(Eu), b = E.useMemo(() => ({
    dense: l || g.dense || !1,
    alignItems: o,
    disableGutters: u
  }), [o, g.dense, l, u]), x = E.useRef(null);
  Dr(() => {
    i && (x.current ? x.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a ListItemButton whose component has not been rendered."));
  }, [i]);
  const $ = {
    ...r,
    alignItems: o,
    dense: b.dense,
    disableGutters: u,
    divider: d,
    selected: h
  }, S = Kce($), O = $n(x, n);
  return /* @__PURE__ */ F.jsx(Eu.Provider, {
    value: b,
    children: /* @__PURE__ */ F.jsx(Xce, {
      ref: O,
      href: y.href || y.to,
      component: (y.href || y.to) && a === "div" ? "button" : a,
      focusVisibleClassName: Ge(S.focusVisible, f),
      ownerState: $,
      className: Ge(S.root, v),
      ...y,
      classes: S,
      children: c
    })
  });
});
process.env.NODE_ENV !== "production" && (Zce.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: s.oneOf(["center", "flex-start"]),
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: s.bool,
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: s.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: s.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: s.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: s.string,
  /**
   * @ignore
   */
  href: s.string,
  /**
   * Use to apply selected styling.
   * @default false
   */
  selected: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
const vA = gt("MuiListItemIcon", ["root", "alignItemsFlexStart"]), yA = gt("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]);
function s1(e, t, n) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : n ? null : e.firstChild;
}
function bA(e, t, n) {
  return e === t ? n ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : n ? null : e.lastChild;
}
function nj(e, t) {
  if (t === void 0)
    return !0;
  let n = e.innerText;
  return n === void 0 && (n = e.textContent), n = n.trim().toLowerCase(), n.length === 0 ? !1 : t.repeating ? n[0] === t.keys[0] : n.startsWith(t.keys.join(""));
}
function Nd(e, t, n, r, o, i) {
  let a = !1, c = o(e, t, t ? n : !1);
  for (; c; ) {
    if (c === e.firstChild) {
      if (a)
        return !1;
      a = !0;
    }
    const l = r ? !1 : c.disabled || c.getAttribute("aria-disabled") === "true";
    if (!c.hasAttribute("tabindex") || !nj(c, i) || l)
      c = o(e, c, n);
    else
      return c.focus(), !0;
  }
  return !1;
}
const rj = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: r,
    autoFocus: o = !1,
    autoFocusItem: i = !1,
    children: a,
    className: c,
    disabledItemsFocusable: l = !1,
    disableListWrap: u = !1,
    onKeyDown: d,
    variant: f = "selectedMenu",
    ...h
  } = t, v = E.useRef(null), y = E.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  Dr(() => {
    o && v.current.focus();
  }, [o]), E.useImperativeHandle(r, () => ({
    adjustStyleForScrollbar: (S, {
      direction: O
    }) => {
      const C = !v.current.style.width;
      if (S.clientHeight < v.current.clientHeight && C) {
        const T = `${iL(Oo(S))}px`;
        v.current.style[O === "rtl" ? "paddingLeft" : "paddingRight"] = T, v.current.style.width = `calc(100% + ${T})`;
      }
      return v.current;
    }
  }), []);
  const g = (S) => {
    const O = v.current, C = S.key;
    if (S.ctrlKey || S.metaKey || S.altKey) {
      d && d(S);
      return;
    }
    const k = Un(O).activeElement;
    if (C === "ArrowDown")
      S.preventDefault(), Nd(O, k, u, l, s1);
    else if (C === "ArrowUp")
      S.preventDefault(), Nd(O, k, u, l, bA);
    else if (C === "Home")
      S.preventDefault(), Nd(O, null, u, l, s1);
    else if (C === "End")
      S.preventDefault(), Nd(O, null, u, l, bA);
    else if (C.length === 1) {
      const I = y.current, P = C.toLowerCase(), _ = performance.now();
      I.keys.length > 0 && (_ - I.lastTime > 500 ? (I.keys = [], I.repeating = !0, I.previousKeyMatched = !0) : I.repeating && P !== I.keys[0] && (I.repeating = !1)), I.lastTime = _, I.keys.push(P);
      const A = k && !I.repeating && nj(k, I);
      I.previousKeyMatched && (A || Nd(O, k, !1, l, s1, I)) ? S.preventDefault() : I.previousKeyMatched = !1;
    }
    d && d(S);
  }, b = $n(v, n);
  let x = -1;
  E.Children.forEach(a, (S, O) => {
    if (!/* @__PURE__ */ E.isValidElement(S)) {
      x === O && (x += 1, x >= a.length && (x = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && sv.isFragment(S) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), S.props.disabled || (f === "selectedMenu" && S.props.selected || x === -1) && (x = O), x === O && (S.props.disabled || S.props.muiSkipListHighlight || S.type.muiSkipListHighlight) && (x += 1, x >= a.length && (x = -1));
  });
  const $ = E.Children.map(a, (S, O) => {
    if (O === x) {
      const C = {};
      return i && (C.autoFocus = !0), S.props.tabIndex === void 0 && f === "selectedMenu" && (C.tabIndex = 0), /* @__PURE__ */ E.cloneElement(S, C);
    }
    return S;
  });
  return /* @__PURE__ */ F.jsx(tj, {
    role: "menu",
    ref: b,
    className: c,
    onKeyDown: g,
    tabIndex: o ? 0 : -1,
    ...h,
    children: $
  });
});
process.env.NODE_ENV !== "production" && (rj.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: s.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: s.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: s.node,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: s.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: s.bool,
  /**
   * @ignore
   */
  onKeyDown: s.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: s.oneOf(["menu", "selectedMenu"])
});
function Jce(e) {
  return mt("MuiPopover", e);
}
gt("MuiPopover", ["root", "paper"]);
function xA(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.height / 2 : t === "bottom" && (n = e.height), n;
}
function wA(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.width / 2 : t === "right" && (n = e.width), n;
}
function $A(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function tg(e) {
  return typeof e == "function" ? e() : e;
}
const Qce = (e) => {
  const {
    classes: t
  } = e;
  return wt({
    root: ["root"],
    paper: ["paper"]
  }, Jce, t);
}, ele = Pe(kT, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), oj = Pe(_p, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), ij = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiPopover"
  }), {
    action: o,
    anchorEl: i,
    anchorOrigin: a = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: c,
    anchorReference: l = "anchorEl",
    children: u,
    className: d,
    container: f,
    elevation: h = 8,
    marginThreshold: v = 16,
    open: y,
    PaperProps: g = {},
    slots: b = {},
    slotProps: x = {},
    transformOrigin: $ = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: S = Fg,
    transitionDuration: O = "auto",
    TransitionProps: {
      onEntering: C,
      ...T
    } = {},
    disableScrollLock: k = !1,
    ...I
  } = r, P = (x == null ? void 0 : x.paper) ?? g, _ = E.useRef(), A = {
    ...r,
    anchorOrigin: a,
    anchorReference: l,
    elevation: h,
    marginThreshold: v,
    externalPaperSlotProps: P,
    transformOrigin: $,
    TransitionComponent: S,
    transitionDuration: O,
    TransitionProps: T
  }, D = Qce(A), M = E.useCallback(() => {
    if (l === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (c || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), c;
    const le = tg(i), ve = le && le.nodeType === 1 ? le : Un(_.current).body, G = ve.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const Se = ve.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && Se.top === 0 && Se.left === 0 && Se.right === 0 && Se.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: G.top + xA(G, a.vertical),
      left: G.left + wA(G, a.horizontal)
    };
  }, [i, a.horizontal, a.vertical, c, l]), N = E.useCallback((le) => ({
    vertical: xA(le, $.vertical),
    horizontal: wA(le, $.horizontal)
  }), [$.horizontal, $.vertical]), L = E.useCallback((le) => {
    const ve = {
      width: le.offsetWidth,
      height: le.offsetHeight
    }, G = N(ve);
    if (l === "none")
      return {
        top: null,
        left: null,
        transformOrigin: $A(G)
      };
    const Se = M();
    let ue = Se.top - G.vertical, Q = Se.left - G.horizontal;
    const ie = ue + ve.height, ee = Q + ve.width, be = Oo(tg(i)), Ie = be.innerHeight - v, je = be.innerWidth - v;
    if (v !== null && ue < v) {
      const V = ue - v;
      ue -= V, G.vertical += V;
    } else if (v !== null && ie > Ie) {
      const V = ie - Ie;
      ue -= V, G.vertical += V;
    }
    if (process.env.NODE_ENV !== "production" && ve.height > Ie && ve.height && Ie && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${ve.height - Ie}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), v !== null && Q < v) {
      const V = Q - v;
      Q -= V, G.horizontal += V;
    } else if (ee > je) {
      const V = ee - je;
      Q -= V, G.horizontal += V;
    }
    return {
      top: `${Math.round(ue)}px`,
      left: `${Math.round(Q)}px`,
      transformOrigin: $A(G)
    };
  }, [i, l, M, N, v]), [z, q] = E.useState(y), W = E.useCallback(() => {
    const le = _.current;
    if (!le)
      return;
    const ve = L(le);
    ve.top !== null && le.style.setProperty("top", ve.top), ve.left !== null && (le.style.left = ve.left), le.style.transformOrigin = ve.transformOrigin, q(!0);
  }, [L]);
  E.useEffect(() => (k && window.addEventListener("scroll", W), () => window.removeEventListener("scroll", W)), [i, k, W]);
  const U = (le, ve) => {
    C && C(le, ve), W();
  }, K = () => {
    q(!1);
  };
  E.useEffect(() => {
    y && W();
  }), E.useImperativeHandle(o, () => y ? {
    updatePosition: () => {
      W();
    }
  } : null, [y, W]), E.useEffect(() => {
    if (!y)
      return;
    const le = Ep(() => {
      W();
    }), ve = Oo(i);
    return ve.addEventListener("resize", le), () => {
      le.clear(), ve.removeEventListener("resize", le);
    };
  }, [i, y, W]);
  let Y = O;
  O === "auto" && !S.muiSupportAuto && (Y = void 0);
  const X = f || (i ? Un(tg(i)).body : void 0), oe = {
    slots: b,
    slotProps: {
      ...x,
      paper: P
    }
  }, [re, Z] = Mr("paper", {
    elementType: oj,
    externalForwardedProps: oe,
    additionalProps: {
      elevation: h,
      className: Ge(D.paper, P == null ? void 0 : P.className),
      style: z ? P.style : {
        ...P.style,
        opacity: 0
      }
    },
    ownerState: A
  }), [ce, {
    slotProps: fe,
    ...de
  }] = Mr("root", {
    elementType: ele,
    externalForwardedProps: oe,
    additionalProps: {
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: X,
      open: y
    },
    ownerState: A,
    className: Ge(D.root, d)
  }), ne = $n(_, Z.ref);
  return /* @__PURE__ */ F.jsx(ce, {
    ...de,
    ...!Dc(ce) && {
      slotProps: fe,
      disableScrollLock: k
    },
    ...I,
    ref: n,
    children: /* @__PURE__ */ F.jsx(S, {
      appear: !0,
      in: y,
      onEntering: U,
      onExited: K,
      timeout: Y,
      ...T,
      children: /* @__PURE__ */ F.jsx(re, {
        ...Z,
        ref: ne,
        children: u
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (ij.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: jr,
  /**
   * An HTML element, [PopoverVirtualElement](https://mui.com/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: $o(s.oneOfType([ra, s.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const t = tg(e.anchorEl);
      if (t && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: s.shape({
    horizontal: s.oneOfType([s.oneOf(["center", "left", "right"]), s.number]).isRequired,
    vertical: s.oneOfType([s.oneOf(["bottom", "center", "top"]), s.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: s.shape({
    left: s.number.isRequired,
    top: s.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: s.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slotProps.root.slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slotProps.root.slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: s.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.root.slotProps.backdrop` instead.
   */
  BackdropProps: s.object,
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: s.oneOfType([ra, s.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: s.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: rv,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: s.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: s.shape({
    component: aT
  }),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    paper: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    paper: s.elementType,
    root: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: s.shape({
    horizontal: s.oneOfType([s.oneOf(["center", "left", "right"]), s.number]).isRequired,
    vertical: s.oneOfType([s.oneOf(["bottom", "center", "top"]), s.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: s.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: s.oneOfType([s.oneOf(["auto"]), s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: s.object
});
function tle(e) {
  return mt("MuiMenu", e);
}
gt("MuiMenu", ["root", "paper", "list"]);
const nle = {
  vertical: "top",
  horizontal: "right"
}, rle = {
  vertical: "top",
  horizontal: "left"
}, ole = (e) => {
  const {
    classes: t
  } = e;
  return wt({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, tle, t);
}, ile = Pe(ij, {
  shouldForwardProp: (e) => ar(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), ale = Pe(oj, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), sle = Pe(rj, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), aj = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiMenu"
  }), {
    autoFocus: o = !0,
    children: i,
    className: a,
    disableAutoFocusItem: c = !1,
    MenuListProps: l = {},
    onClose: u,
    open: d,
    PaperProps: f = {},
    PopoverClasses: h,
    transitionDuration: v = "auto",
    TransitionProps: {
      onEntering: y,
      ...g
    } = {},
    variant: b = "selectedMenu",
    slots: x = {},
    slotProps: $ = {},
    ...S
  } = r, O = Ya(), C = {
    ...r,
    autoFocus: o,
    disableAutoFocusItem: c,
    MenuListProps: l,
    onEntering: y,
    PaperProps: f,
    transitionDuration: v,
    TransitionProps: g,
    variant: b
  }, T = ole(C), k = o && !c && d, I = E.useRef(null), P = (z, q) => {
    I.current && I.current.adjustStyleForScrollbar(z, {
      direction: O ? "rtl" : "ltr"
    }), y && y(z, q);
  }, _ = (z) => {
    z.key === "Tab" && (z.preventDefault(), u && u(z, "tabKeyDown"));
  };
  let A = -1;
  E.Children.map(i, (z, q) => {
    /* @__PURE__ */ E.isValidElement(z) && (process.env.NODE_ENV !== "production" && sv.isFragment(z) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), z.props.disabled || (b === "selectedMenu" && z.props.selected || A === -1) && (A = q));
  });
  const D = x.paper ?? ale, M = $.paper ?? f, N = fr({
    elementType: x.root,
    externalSlotProps: $.root,
    ownerState: C,
    className: [T.root, a]
  }), L = fr({
    elementType: D,
    externalSlotProps: M,
    ownerState: C,
    className: T.paper
  });
  return /* @__PURE__ */ F.jsx(ile, {
    onClose: u,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: O ? "right" : "left"
    },
    transformOrigin: O ? nle : rle,
    slots: {
      paper: D,
      root: x.root
    },
    slotProps: {
      root: N,
      paper: L
    },
    open: d,
    ref: n,
    transitionDuration: v,
    TransitionProps: {
      onEntering: P,
      ...g
    },
    ownerState: C,
    ...S,
    classes: h,
    children: /* @__PURE__ */ F.jsx(sle, {
      onKeyDown: _,
      actions: I,
      autoFocus: o && (A === -1 || c),
      autoFocusItem: k,
      variant: b,
      ...l,
      className: Ge(T.list, l.className),
      children: i
    })
  });
});
process.env.NODE_ENV !== "production" && (aj.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: s.oneOfType([ra, s.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: s.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: s.bool,
  /**
   * Props applied to the [`MenuList`](https://mui.com/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: s.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: s.object,
  /**
   * `classes` prop applied to the [`Popover`](https://mui.com/material-ui/api/popover/) element.
   */
  PopoverClasses: s.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    paper: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    paper: s.elementType,
    root: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: s.oneOfType([s.oneOf(["auto"]), s.number, s.shape({
    appear: s.number,
    enter: s.number,
    exit: s.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: s.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: s.oneOf(["menu", "selectedMenu"])
});
function cle(e) {
  return mt("MuiMenuItem", e);
}
const Dd = gt("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), lle = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.divider && t.divider, !n.disableGutters && t.gutters];
}, ule = (e) => {
  const {
    disabled: t,
    dense: n,
    divider: r,
    disableGutters: o,
    selected: i,
    classes: a
  } = e, l = wt({
    root: ["root", n && "dense", t && "disabled", !o && "gutters", r && "divider", i && "selected"]
  }, cle, a);
  return {
    ...a,
    ...l
  };
}, dle = Pe(oa, {
  shouldForwardProp: (e) => ar(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: lle
})(ct(({
  theme: e
}) => ({
  ...e.typography.body1,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap",
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Dd.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : It(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${Dd.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : It(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${Dd.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : It(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : It(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${Dd.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${Dd.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${pA.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${pA.inset}`]: {
    marginLeft: 52
  },
  [`& .${yA.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${yA.inset}`]: {
    paddingLeft: 36
  },
  [`& .${vA.root}`]: {
    minWidth: 36
  },
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.dense,
    style: {
      [e.breakpoints.up("sm")]: {
        minHeight: "auto"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.dense,
    style: {
      minHeight: 32,
      // https://m2.material.io/components/menus#specs > Dense
      paddingTop: 4,
      paddingBottom: 4,
      ...e.typography.body2,
      [`& .${vA.root} svg`]: {
        fontSize: "1.25rem"
      }
    }
  }]
}))), fle = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiMenuItem"
  }), {
    autoFocus: o = !1,
    component: i = "li",
    dense: a = !1,
    divider: c = !1,
    disableGutters: l = !1,
    focusVisibleClassName: u,
    role: d = "menuitem",
    tabIndex: f,
    className: h,
    ...v
  } = r, y = E.useContext(Eu), g = E.useMemo(() => ({
    dense: a || y.dense || !1,
    disableGutters: l
  }), [y.dense, a, l]), b = E.useRef(null);
  Dr(() => {
    o && (b.current ? b.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [o]);
  const x = {
    ...r,
    dense: g.dense,
    divider: c,
    disableGutters: l
  }, $ = ule(r), S = $n(b, n);
  let O;
  return r.disabled || (O = f !== void 0 ? f : -1), /* @__PURE__ */ F.jsx(Eu.Provider, {
    value: g,
    children: /* @__PURE__ */ F.jsx(dle, {
      ref: S,
      role: d,
      tabIndex: O,
      component: i,
      focusVisibleClassName: Ge($.focusVisible, u),
      className: Ge($.root, h),
      ...v,
      ownerState: x,
      classes: $
    })
  });
});
process.env.NODE_ENV !== "production" && (fle.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: s.bool,
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: s.bool,
  /**
   * @ignore
   */
  disabled: s.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: s.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: s.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: s.string,
  /**
   * @ignore
   */
  role: s.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: s.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * @default 0
   */
  tabIndex: s.number
});
function ple(e) {
  return mt("MuiNativeSelect", e);
}
const RT = gt("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), hle = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: r,
    multiple: o,
    open: i,
    error: a
  } = e, c = {
    select: ["select", n, r && "disabled", o && "multiple", a && "error"],
    icon: ["icon", `icon${Le(n)}`, i && "iconOpen", r && "disabled"]
  };
  return wt(c, ple, t);
}, sj = Pe("select")(({
  theme: e
}) => ({
  // Reset
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  // Reset
  borderRadius: 0,
  cursor: "pointer",
  "&:focus": {
    // Reset Chrome style
    borderRadius: 0
  },
  [`&.${RT.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (e.vars || e).palette.background.paper
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.variant !== "filled" && t.variant !== "outlined",
    style: {
      // Bump specificity to allow extending custom inputs
      "&&&": {
        paddingRight: 24,
        minWidth: 16
        // So it doesn't collapse.
      }
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      "&&&": {
        paddingRight: 32
      }
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius,
      "&:focus": {
        borderRadius: (e.vars || e).shape.borderRadius
        // Reset the reset for Chrome style
      },
      "&&&": {
        paddingRight: 32
      }
    }
  }]
})), mle = Pe(sj, {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: ar,
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.select, t[n.variant], n.error && t.error, {
      [`&.${RT.multiple}`]: t.multiple
    }];
  }
})({}), cj = Pe("svg")(({
  theme: e
}) => ({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  // Center vertically, height is 1em
  top: "calc(50% - .5em)",
  // Don't block pointer events on the select under the icon.
  pointerEvents: "none",
  color: (e.vars || e).palette.action.active,
  [`&.${RT.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.open,
    style: {
      transform: "rotate(180deg)"
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      right: 7
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      right: 7
    }
  }]
})), gle = Pe(cj, {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${Le(n.variant)}`], n.open && t.iconOpen];
  }
})({}), lj = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const {
    className: r,
    disabled: o,
    error: i,
    IconComponent: a,
    inputRef: c,
    variant: l = "standard",
    ...u
  } = t, d = {
    ...t,
    disabled: o,
    variant: l,
    error: i
  }, f = hle(d);
  return /* @__PURE__ */ F.jsxs(E.Fragment, {
    children: [/* @__PURE__ */ F.jsx(mle, {
      ownerState: d,
      className: Ge(f.select, r),
      disabled: o,
      ref: c || n,
      ...u
    }), t.multiple ? null : /* @__PURE__ */ F.jsx(gle, {
      as: a,
      ownerState: d,
      className: f.icon
    })]
  });
});
process.env.NODE_ENV !== "production" && (lj.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The CSS class name of the select element.
   */
  className: s.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: s.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: s.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: s.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: jr,
  /**
   * @ignore
   */
  multiple: s.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: s.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * The input value.
   */
  value: s.any,
  /**
   * The variant to use.
   */
  variant: s.oneOf(["standard", "outlined", "filled"])
});
function Vf(e) {
  const {
    children: t,
    defer: n = !1,
    fallback: r = null
  } = e, [o, i] = E.useState(!1);
  return Dr(() => {
    n || i(!0);
  }, [n]), E.useEffect(() => {
    n && i(!0);
  }, [n]), o ? t : r;
}
process.env.NODE_ENV !== "production" && (Vf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * You can wrap a node.
   */
  children: s.node,
  /**
   * If `true`, the component will not only prevent server-side rendering.
   * It will also defer the rendering of the children into a different screen frame.
   * @default false
   */
  defer: s.bool,
  /**
   * The fallback content to display.
   * @default null
   */
  fallback: s.node
});
process.env.NODE_ENV !== "production" && (Vf.propTypes = Yu(Vf.propTypes));
var OA;
const vle = Pe("fieldset", {
  shouldForwardProp: ar
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), yle = Pe("legend", {
  shouldForwardProp: ar
})(ct(({
  theme: e
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: ({
      ownerState: t
    }) => !t.withLabel,
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: e.transitions.create("width", {
        duration: 150,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: ({
      ownerState: t
    }) => t.withLabel,
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: e.transitions.create("max-width", {
        duration: 50,
        easing: e.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.withLabel && t.notched,
    style: {
      maxWidth: "100%",
      transition: e.transitions.create("max-width", {
        duration: 100,
        easing: e.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
})));
function uj(e) {
  const {
    children: t,
    classes: n,
    className: r,
    label: o,
    notched: i,
    ...a
  } = e, c = o != null && o !== "", l = {
    ...e,
    notched: i,
    withLabel: c
  };
  return /* @__PURE__ */ F.jsx(vle, {
    "aria-hidden": !0,
    className: r,
    ownerState: l,
    ...a,
    children: /* @__PURE__ */ F.jsx(yle, {
      ownerState: l,
      children: c ? /* @__PURE__ */ F.jsx("span", {
        children: o
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        OA || (OA = /* @__PURE__ */ F.jsx("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      )
    })
  });
}
process.env.NODE_ENV !== "production" && (uj.propTypes = {
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The label.
   */
  label: s.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: s.bool.isRequired,
  /**
   * @ignore
   */
  style: s.object
});
const ble = (e) => {
  const {
    classes: t
  } = e, r = wt({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, Eae, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...r
  };
}, xle = Pe(hv, {
  shouldForwardProp: (e) => ar(e) || e === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: fv
})(ct(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    position: "relative",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${zo.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${zo.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
      }
    },
    [`&.${zo.focused} .${zo.notchedOutline}`]: {
      borderWidth: 2
    },
    variants: [...Object.entries(e.palette).filter(Dn()).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        [`&.${zo.focused} .${zo.notchedOutline}`]: {
          borderColor: (e.vars || e).palette[n].main
        }
      }
    })), {
      props: {},
      // to overide the above style
      style: {
        [`&.${zo.error} .${zo.notchedOutline}`]: {
          borderColor: (e.vars || e).palette.error.main
        },
        [`&.${zo.disabled} .${zo.notchedOutline}`]: {
          borderColor: (e.vars || e).palette.action.disabled
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.startAdornment,
      style: {
        paddingLeft: 14
      }
    }, {
      props: ({
        ownerState: n
      }) => n.endAdornment,
      style: {
        paddingRight: 14
      }
    }, {
      props: ({
        ownerState: n
      }) => n.multiline,
      style: {
        padding: "16.5px 14px"
      }
    }, {
      props: ({
        ownerState: n,
        size: r
      }) => n.multiline && r === "small",
      style: {
        padding: "8.5px 14px"
      }
    }]
  };
})), wle = Pe(uj, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})(ct(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
})), $le = Pe(mv, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: pv
})(ct(({
  theme: e
}) => ({
  padding: "16.5px 14px",
  ...!e.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
      caretColor: e.palette.mode === "light" ? null : "#fff",
      borderRadius: "inherit"
    }
  },
  ...e.vars && {
    "&:-webkit-autofill": {
      borderRadius: "inherit"
    },
    [e.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      padding: "8.5px 14px"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      padding: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.endAdornment,
    style: {
      paddingRight: 0
    }
  }]
}))), Yf = /* @__PURE__ */ E.forwardRef(function(t, n) {
  var r;
  const o = $t({
    props: t,
    name: "MuiOutlinedInput"
  }), {
    components: i = {},
    fullWidth: a = !1,
    inputComponent: c = "input",
    label: l,
    multiline: u = !1,
    notched: d,
    slots: f = {},
    type: h = "text",
    ...v
  } = o, y = ble(o), g = Gs(), b = Ku({
    props: o,
    muiFormControl: g,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), x = {
    ...o,
    color: b.color || "primary",
    disabled: b.disabled,
    error: b.error,
    focused: b.focused,
    formControl: g,
    fullWidth: a,
    hiddenLabel: b.hiddenLabel,
    multiline: u,
    size: b.size,
    type: h
  }, $ = f.root ?? i.Root ?? xle, S = f.input ?? i.Input ?? $le;
  return /* @__PURE__ */ F.jsx(gv, {
    slots: {
      root: $,
      input: S
    },
    renderSuffix: (O) => /* @__PURE__ */ F.jsx(wle, {
      ownerState: x,
      className: y.notchedOutline,
      label: l != null && l !== "" && b.required ? r || (r = /* @__PURE__ */ F.jsxs(E.Fragment, {
        children: [l, " ", "*"]
      })) : l,
      notched: typeof d < "u" ? d : !!(O.startAdornment || O.filled || O.focused)
    }),
    fullWidth: a,
    inputComponent: c,
    multiline: u,
    ref: n,
    type: h,
    ...v,
    classes: {
      ...y,
      notchedOutline: null
    }
  });
});
process.env.NODE_ENV !== "production" && (Yf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: s.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary"]), s.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    Input: s.elementType,
    Root: s.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: s.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: s.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: s.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The id of the `input` element.
   */
  id: s.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: s.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: jr,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: s.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: s.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: s.oneOfType([s.number, s.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: s.oneOfType([s.number, s.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: s.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: s.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: s.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: s.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: s.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: s.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: s.oneOfType([s.number, s.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: s.shape({
    input: s.elementType,
    root: s.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: s.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: s.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: s.any
});
Yf && (Yf.muiName = "Input");
const Ole = Oi(/* @__PURE__ */ F.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked"), Sle = Oi(/* @__PURE__ */ F.jsx("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked"), Cle = Pe("span", {
  shouldForwardProp: ar
})({
  position: "relative",
  display: "flex"
}), Tle = Pe(Ole)({
  // Scale applied to prevent dot misalignment in Safari
  transform: "scale(1)"
}), Ele = Pe(Sle)(ct(({
  theme: e
}) => ({
  left: 0,
  position: "absolute",
  transform: "scale(0)",
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeIn,
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: {
      checked: !0
    },
    style: {
      transform: "scale(1)",
      transition: e.transitions.create("transform", {
        easing: e.transitions.easing.easeOut,
        duration: e.transitions.duration.shortest
      })
    }
  }]
})));
function PT(e) {
  const {
    checked: t = !1,
    classes: n = {},
    fontSize: r
  } = e, o = {
    ...e,
    checked: t
  };
  return /* @__PURE__ */ F.jsxs(Cle, {
    className: n.root,
    ownerState: o,
    children: [/* @__PURE__ */ F.jsx(Tle, {
      fontSize: r,
      className: n.background,
      ownerState: o
    }), /* @__PURE__ */ F.jsx(Ele, {
      fontSize: r,
      className: n.dot,
      ownerState: o
    })]
  });
}
process.env.NODE_ENV !== "production" && (PT.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: s.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   */
  fontSize: s.oneOf(["small", "medium"])
});
const dj = /* @__PURE__ */ E.createContext(void 0);
process.env.NODE_ENV !== "production" && (dj.displayName = "RadioGroupContext");
function _le() {
  return E.useContext(dj);
}
function kle(e) {
  return mt("MuiRadio", e);
}
const SA = gt("MuiRadio", ["root", "checked", "disabled", "colorPrimary", "colorSecondary", "sizeSmall"]), Rle = (e) => {
  const {
    classes: t,
    color: n,
    size: r
  } = e, o = {
    root: ["root", `color${Le(n)}`, r !== "medium" && `size${Le(r)}`]
  };
  return {
    ...t,
    ...wt(o, kle, t)
  };
}, Ple = Pe(_T, {
  shouldForwardProp: (e) => ar(e) || e === "classes",
  name: "MuiRadio",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.size !== "medium" && t[`size${Le(n.size)}`], t[`color${Le(n.color)}`]];
  }
})(ct(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  [`&.${SA.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  },
  variants: [{
    props: {
      color: "default",
      disabled: !1,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : It(e.palette.action.active, e.palette.action.hoverOpacity)
      }
    }
  }, ...Object.entries(e.palette).filter(Dn()).map(([t]) => ({
    props: {
      color: t,
      disabled: !1,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : It(e.palette[t].main, e.palette.action.hoverOpacity)
      }
    }
  })), ...Object.entries(e.palette).filter(Dn()).map(([t]) => ({
    props: {
      color: t,
      disabled: !1
    },
    style: {
      [`&.${SA.checked}`]: {
        color: (e.vars || e).palette[t].main
      }
    }
  })), {
    // Should be last to override other colors
    props: {
      disableRipple: !1
    },
    style: {
      // Reset on touch devices, it doesn't add specificity
      "&:hover": {
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }]
})));
function Ale(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
const CA = /* @__PURE__ */ F.jsx(PT, {
  checked: !0
}), TA = /* @__PURE__ */ F.jsx(PT, {}), Ile = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiRadio"
  }), {
    checked: o,
    checkedIcon: i = CA,
    color: a = "primary",
    icon: c = TA,
    name: l,
    onChange: u,
    size: d = "medium",
    className: f,
    disabled: h,
    disableRipple: v = !1,
    ...y
  } = r, g = Gs();
  let b = h;
  g && typeof b > "u" && (b = g.disabled), b ?? (b = !1);
  const x = {
    ...r,
    disabled: b,
    disableRipple: v,
    color: a,
    size: d
  }, $ = Rle(x), S = _le();
  let O = o;
  const C = XO(u, S && S.onChange);
  let T = l;
  return S && (typeof O > "u" && (O = Ale(S.value, r.value)), typeof T > "u" && (T = S.name)), /* @__PURE__ */ F.jsx(Ple, {
    type: "radio",
    icon: /* @__PURE__ */ E.cloneElement(c, {
      fontSize: TA.props.fontSize ?? d
    }),
    checkedIcon: /* @__PURE__ */ E.cloneElement(i, {
      fontSize: CA.props.fontSize ?? d
    }),
    disabled: b,
    ownerState: x,
    classes: $,
    name: T,
    checked: O,
    onChange: C,
    ref: n,
    className: Ge($.root, f),
    ...y
  });
});
process.env.NODE_ENV !== "production" && (Ile.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: s.bool,
  /**
   * The icon to display when the component is checked.
   * @default <RadioButtonIcon checked />
   */
  checkedIcon: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: s.oneOfType([s.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * If `true`, the component is disabled.
   */
  disabled: s.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: s.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <RadioButtonIcon />
   */
  icon: s.node,
  /**
   * The id of the `input` element.
   */
  id: s.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: jr,
  /**
   * Name attribute of the `input` element.
   */
  name: s.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: s.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: s.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["medium", "small"]), s.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: s.any
});
function Mle(e) {
  return mt("MuiSelect", e);
}
const Ld = gt("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var EA;
const Nle = Pe(sj, {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [
      // Win specificity over the input base
      {
        [`&.${Ld.select}`]: t.select
      },
      {
        [`&.${Ld.select}`]: t[n.variant]
      },
      {
        [`&.${Ld.error}`]: t.error
      },
      {
        [`&.${Ld.multiple}`]: t.multiple
      }
    ];
  }
})({
  // Win specificity over the input base
  [`&.${Ld.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), Dle = Pe(cj, {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${Le(n.variant)}`], n.open && t.iconOpen];
  }
})({}), Lle = Pe("input", {
  shouldForwardProp: (e) => av(e) && e !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (e, t) => t.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function _A(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
function jle(e) {
  return e == null || typeof e == "string" && !e.trim();
}
const Fle = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: r,
    multiple: o,
    open: i,
    error: a
  } = e, c = {
    select: ["select", n, r && "disabled", o && "multiple", a && "error"],
    icon: ["icon", `icon${Le(n)}`, i && "iconOpen", r && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return wt(c, Mle, t);
}, fj = /* @__PURE__ */ E.forwardRef(function(t, n) {
  var Ne;
  const {
    "aria-describedby": r,
    "aria-label": o,
    autoFocus: i,
    autoWidth: a,
    children: c,
    className: l,
    defaultOpen: u,
    defaultValue: d,
    disabled: f,
    displayEmpty: h,
    error: v = !1,
    IconComponent: y,
    inputRef: g,
    labelId: b,
    MenuProps: x = {},
    multiple: $,
    name: S,
    onBlur: O,
    onChange: C,
    onClose: T,
    onFocus: k,
    onOpen: I,
    open: P,
    readOnly: _,
    renderValue: A,
    required: D,
    SelectDisplayProps: M = {},
    tabIndex: N,
    // catching `type` from Input which makes no sense for SelectInput
    type: L,
    value: z,
    variant: q = "standard",
    ...W
  } = t, [U, K] = Mc({
    controlled: z,
    default: d,
    name: "Select"
  }), [Y, X] = Mc({
    controlled: P,
    default: u,
    name: "Select"
  }), oe = E.useRef(null), re = E.useRef(null), [Z, ce] = E.useState(null), {
    current: fe
  } = E.useRef(P != null), [de, ne] = E.useState(), le = $n(n, g), ve = E.useCallback(($e) => {
    re.current = $e, $e && ce($e);
  }, []), G = Z == null ? void 0 : Z.parentNode;
  E.useImperativeHandle(le, () => ({
    focus: () => {
      re.current.focus();
    },
    node: oe.current,
    value: U
  }), [U]), E.useEffect(() => {
    u && Y && Z && !fe && (ne(a ? null : G.clientWidth), re.current.focus());
  }, [Z, a]), E.useEffect(() => {
    i && re.current.focus();
  }, [i]), E.useEffect(() => {
    if (!b)
      return;
    const $e = Un(re.current).getElementById(b);
    if ($e) {
      const Ue = () => {
        getSelection().isCollapsed && re.current.focus();
      };
      return $e.addEventListener("click", Ue), () => {
        $e.removeEventListener("click", Ue);
      };
    }
  }, [b]);
  const Se = ($e, Ue) => {
    $e ? I && I(Ue) : T && T(Ue), fe || (ne(a ? null : G.clientWidth), X($e));
  }, ue = ($e) => {
    $e.button === 0 && ($e.preventDefault(), re.current.focus(), Se(!0, $e));
  }, Q = ($e) => {
    Se(!1, $e);
  }, ie = E.Children.toArray(c), ee = ($e) => {
    const Ue = ie.find((Ke) => Ke.props.value === $e.target.value);
    Ue !== void 0 && (K(Ue.props.value), C && C($e, Ue));
  }, be = ($e) => (Ue) => {
    let Ke;
    if (Ue.currentTarget.hasAttribute("tabindex")) {
      if ($) {
        Ke = Array.isArray(U) ? U.slice() : [];
        const Me = U.indexOf($e.props.value);
        Me === -1 ? Ke.push($e.props.value) : Ke.splice(Me, 1);
      } else
        Ke = $e.props.value;
      if ($e.props.onClick && $e.props.onClick(Ue), U !== Ke && (K(Ke), C)) {
        const Me = Ue.nativeEvent || Ue, We = new Me.constructor(Me.type, Me);
        Object.defineProperty(We, "target", {
          writable: !0,
          value: {
            value: Ke,
            name: S
          }
        }), C(We, $e);
      }
      $ || Se(!1, Ue);
    }
  }, Ie = ($e) => {
    _ || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].includes($e.key) && ($e.preventDefault(), Se(!0, $e));
  }, je = Z !== null && Y, V = ($e) => {
    !je && O && (Object.defineProperty($e, "target", {
      writable: !0,
      value: {
        value: U,
        name: S
      }
    }), O($e));
  };
  delete W["aria-invalid"];
  let se, we;
  const J = [];
  let he = !1, Te = !1;
  (Lg({
    value: U
  }) || h) && (A ? se = A(U) : he = !0);
  const xe = ie.map(($e) => {
    if (!/* @__PURE__ */ E.isValidElement($e))
      return null;
    process.env.NODE_ENV !== "production" && sv.isFragment($e) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let Ue;
    if ($) {
      if (!Array.isArray(U))
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : na(2));
      Ue = U.some((Ke) => _A(Ke, $e.props.value)), Ue && he && J.push($e.props.children);
    } else
      Ue = _A(U, $e.props.value), Ue && he && (we = $e.props.children);
    return Ue && (Te = !0), /* @__PURE__ */ E.cloneElement($e, {
      "aria-selected": Ue ? "true" : "false",
      onClick: be($e),
      onKeyUp: (Ke) => {
        Ke.key === " " && Ke.preventDefault(), $e.props.onKeyUp && $e.props.onKeyUp(Ke);
      },
      role: "option",
      selected: Ue,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": $e.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  process.env.NODE_ENV !== "production" && E.useEffect(() => {
    if (!Te && !$ && U !== "") {
      const $e = ie.map((Ue) => Ue.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${U}\` for the select ${S ? `(name="${S}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${$e.filter((Ue) => Ue != null).map((Ue) => `\`${Ue}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [Te, ie, $, S, U]), he && ($ ? J.length === 0 ? se = null : se = J.reduce(($e, Ue, Ke) => ($e.push(Ue), Ke < J.length - 1 && $e.push(", "), $e), []) : se = we);
  let Ae = de;
  !a && fe && Z && (Ae = G.clientWidth);
  let Ce;
  typeof N < "u" ? Ce = N : Ce = f ? null : 0;
  const Ye = M.id || (S ? `mui-component-select-${S}` : void 0), He = {
    ...t,
    variant: q,
    value: U,
    open: je,
    error: v
  }, Be = Fle(He), Xe = {
    ...x.PaperProps,
    ...(Ne = x.slotProps) == null ? void 0 : Ne.paper
  }, Ze = sT();
  return /* @__PURE__ */ F.jsxs(E.Fragment, {
    children: [/* @__PURE__ */ F.jsx(Nle, {
      as: "div",
      ref: ve,
      tabIndex: Ce,
      role: "combobox",
      "aria-controls": Ze,
      "aria-disabled": f ? "true" : void 0,
      "aria-expanded": je ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": o,
      "aria-labelledby": [b, Ye].filter(Boolean).join(" ") || void 0,
      "aria-describedby": r,
      "aria-required": D ? "true" : void 0,
      "aria-invalid": v ? "true" : void 0,
      onKeyDown: Ie,
      onMouseDown: f || _ ? null : ue,
      onBlur: V,
      onFocus: k,
      ...M,
      ownerState: He,
      className: Ge(M.className, Be.select, l),
      id: Ye,
      children: jle(se) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        EA || (EA = /* @__PURE__ */ F.jsx("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      ) : se
    }), /* @__PURE__ */ F.jsx(Lle, {
      "aria-invalid": v,
      value: Array.isArray(U) ? U.join(",") : U,
      name: S,
      ref: oe,
      "aria-hidden": !0,
      onChange: ee,
      tabIndex: -1,
      disabled: f,
      className: Be.nativeInput,
      autoFocus: i,
      required: D,
      ...W,
      ownerState: He
    }), /* @__PURE__ */ F.jsx(Dle, {
      as: y,
      className: Be.icon,
      ownerState: He
    }), /* @__PURE__ */ F.jsx(aj, {
      id: `menu-${S || ""}`,
      anchorEl: G,
      open: je,
      onClose: Q,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      ...x,
      MenuListProps: {
        "aria-labelledby": b,
        role: "listbox",
        "aria-multiselectable": $ ? "true" : void 0,
        disableListWrap: !0,
        id: Ze,
        ...x.MenuListProps
      },
      slotProps: {
        ...x.slotProps,
        paper: {
          ...Xe,
          style: {
            minWidth: Ae,
            ...Xe != null ? Xe.style : null
          }
        }
      },
      children: xe
    })]
  });
});
process.env.NODE_ENV !== "production" && (fj.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": s.string,
  /**
   * @ignore
   */
  "aria-label": s.string,
  /**
   * @ignore
   */
  autoFocus: s.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: s.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The CSS class name of the select element.
   */
  className: s.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: s.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: s.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: s.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: s.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: s.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: jr,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: s.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: s.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: s.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: s.string,
  /**
   * @ignore
   */
  onBlur: s.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: s.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: s.func,
  /**
   * @ignore
   */
  onFocus: s.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: s.func,
  /**
   * If `true`, the component is shown.
   */
  open: s.bool,
  /**
   * @ignore
   */
  readOnly: s.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: s.func,
  /**
   * If `true`, the component is required.
   */
  required: s.bool,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: s.object,
  /**
   * @ignore
   */
  tabIndex: s.oneOfType([s.number, s.string]),
  /**
   * @ignore
   */
  type: s.any,
  /**
   * The input value.
   */
  value: s.any,
  /**
   * The variant to use.
   */
  variant: s.oneOf(["standard", "outlined", "filled"])
});
const zle = (e) => {
  const {
    classes: t
  } = e;
  return t;
}, AT = {
  name: "MuiSelect",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => ar(e) && e !== "variant",
  slot: "Root"
}, Ble = Pe(Hf, AT)(""), qle = Pe(Yf, AT)(""), Ule = Pe(Wf, AT)(""), IT = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    name: "MuiSelect",
    props: t
  }), {
    autoWidth: o = !1,
    children: i,
    classes: a = {},
    className: c,
    defaultOpen: l = !1,
    displayEmpty: u = !1,
    IconComponent: d = FL,
    id: f,
    input: h,
    inputProps: v,
    label: y,
    labelId: g,
    MenuProps: b,
    multiple: x = !1,
    native: $ = !1,
    onClose: S,
    onOpen: O,
    open: C,
    renderValue: T,
    SelectDisplayProps: k,
    variant: I = "outlined",
    ...P
  } = r, _ = $ ? lj : fj, A = Gs(), D = Ku({
    props: r,
    muiFormControl: A,
    states: ["variant", "error"]
  }), M = D.variant || I, N = {
    ...r,
    variant: M,
    classes: a
  }, L = zle(N), {
    root: z,
    ...q
  } = L, W = h || {
    standard: /* @__PURE__ */ F.jsx(Ble, {
      ownerState: N
    }),
    outlined: /* @__PURE__ */ F.jsx(qle, {
      label: y,
      ownerState: N
    }),
    filled: /* @__PURE__ */ F.jsx(Ule, {
      ownerState: N
    })
  }[M], U = $n(n, tl(W));
  return /* @__PURE__ */ F.jsx(E.Fragment, {
    children: /* @__PURE__ */ E.cloneElement(W, {
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: _,
      inputProps: {
        children: i,
        error: D.error,
        IconComponent: d,
        variant: M,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: x,
        ...$ ? {
          id: f
        } : {
          autoWidth: o,
          defaultOpen: l,
          displayEmpty: u,
          labelId: g,
          MenuProps: b,
          onClose: S,
          onOpen: O,
          open: C,
          renderValue: T,
          SelectDisplayProps: {
            id: f,
            ...k
          }
        },
        ...v,
        classes: v ? or(q, v.classes) : q,
        ...h ? h.props.inputProps : {}
      },
      ...(x && $ || u) && M === "outlined" ? {
        notched: !0
      } : {},
      ref: U,
      className: Ge(W.props.className, c, L.root),
      // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
      ...!h && {
        variant: M
      },
      ...P
    })
  });
});
process.env.NODE_ENV !== "production" && (IT.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: s.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: s.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: s.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: s.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: s.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: s.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: s.object,
  /**
   * See [OutlinedInput#label](https://mui.com/material-ui/api/outlined-input/#props)
   */
  label: s.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: s.string,
  /**
   * Props applied to the [`Menu`](https://mui.com/material-ui/api/menu/) element.
   */
  MenuProps: s.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: s.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: s.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: s.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: s.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: s.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: s.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: s.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: s.oneOfType([s.oneOf([""]), s.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: s.oneOf(["filled", "outlined", "standard"])
});
IT.muiName = "Select";
function Wle(e) {
  return mt("MuiSkeleton", e);
}
gt("MuiSkeleton", ["root", "text", "rectangular", "rounded", "circular", "pulse", "wave", "withChildren", "fitContent", "heightAuto"]);
const Hle = (e) => {
  const {
    classes: t,
    variant: n,
    animation: r,
    hasChildren: o,
    width: i,
    height: a
  } = e;
  return wt({
    root: ["root", n, r, o && "withChildren", o && !i && "fitContent", o && !a && "heightAuto"]
  }, Wle, t);
}, fS = Qc`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`, pS = Qc`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`, Vle = typeof fS != "string" ? $p`
        animation: ${fS} 2s ease-in-out 0.5s infinite;
      ` : null, Yle = typeof pS != "string" ? $p`
        &::after {
          animation: ${pS} 2s linear 0.5s infinite;
        }
      ` : null, Gle = Pe("span", {
  name: "MuiSkeleton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], n.animation !== !1 && t[n.animation], n.hasChildren && t.withChildren, n.hasChildren && !n.width && t.fitContent, n.hasChildren && !n.height && t.heightAuto];
  }
})(ct(({
  theme: e
}) => {
  const t = Qre(e.shape.borderRadius) || "px", n = eoe(e.shape.borderRadius);
  return {
    display: "block",
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: e.vars ? e.vars.palette.Skeleton.bg : It(e.palette.text.primary, e.palette.mode === "light" ? 0.11 : 0.13),
    height: "1.2em",
    variants: [{
      props: {
        variant: "text"
      },
      style: {
        marginTop: 0,
        marginBottom: 0,
        height: "auto",
        transformOrigin: "0 55%",
        transform: "scale(1, 0.60)",
        borderRadius: `${n}${t}/${Math.round(n / 0.6 * 10) / 10}${t}`,
        "&:empty:before": {
          content: '"\\00a0"'
        }
      }
    }, {
      props: {
        variant: "circular"
      },
      style: {
        borderRadius: "50%"
      }
    }, {
      props: {
        variant: "rounded"
      },
      style: {
        borderRadius: (e.vars || e).shape.borderRadius
      }
    }, {
      props: ({
        ownerState: r
      }) => r.hasChildren,
      style: {
        "& > *": {
          visibility: "hidden"
        }
      }
    }, {
      props: ({
        ownerState: r
      }) => r.hasChildren && !r.width,
      style: {
        maxWidth: "fit-content"
      }
    }, {
      props: ({
        ownerState: r
      }) => r.hasChildren && !r.height,
      style: {
        height: "auto"
      }
    }, {
      props: {
        animation: "pulse"
      },
      style: Vle || {
        animation: `${fS} 2s ease-in-out 0.5s infinite`
      }
    }, {
      props: {
        animation: "wave"
      },
      style: {
        position: "relative",
        overflow: "hidden",
        /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
        WebkitMaskImage: "-webkit-radial-gradient(white, black)",
        "&::after": {
          background: `linear-gradient(
                90deg,
                transparent,
                ${(e.vars || e).palette.action.hover},
                transparent
              )`,
          content: '""',
          position: "absolute",
          transform: "translateX(-100%)",
          bottom: 0,
          left: 0,
          right: 0,
          top: 0
        }
      }
    }, {
      props: {
        animation: "wave"
      },
      style: Yle || {
        "&::after": {
          animation: `${pS} 2s linear 0.5s infinite`
        }
      }
    }]
  };
})), Kle = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiSkeleton"
  }), {
    animation: o = "pulse",
    className: i,
    component: a = "span",
    height: c,
    style: l,
    variant: u = "text",
    width: d,
    ...f
  } = r, h = {
    ...r,
    animation: o,
    component: a,
    variant: u,
    hasChildren: !!f.children
  }, v = Hle(h);
  return /* @__PURE__ */ F.jsx(Gle, {
    as: a,
    ref: n,
    className: Ge(v.root, i),
    ownerState: h,
    ...f,
    style: {
      width: d,
      height: c,
      ...l
    }
  });
});
process.env.NODE_ENV !== "production" && (Kle.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The animation.
   * If `false` the animation effect is disabled.
   * @default 'pulse'
   */
  animation: s.oneOf(["pulse", "wave", !1]),
  /**
   * Optional children to infer width and height from.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * Height of the skeleton.
   * Useful when you don't want to adapt the skeleton to a text element but for instance a card.
   */
  height: s.oneOfType([s.number, s.string]),
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The type of content that will be rendered.
   * @default 'text'
   */
  variant: s.oneOfType([s.oneOf(["circular", "rectangular", "rounded", "text"]), s.string]),
  /**
   * Width of the skeleton.
   * Useful when the skeleton is inside an inline element with no width of its own.
   */
  width: s.oneOfType([s.number, s.string])
});
function Xle(e, t, n = (r, o) => r === o) {
  return e.length === t.length && e.every((r, o) => n(r, t[o]));
}
const Zle = 2;
function Fl(e, t, n, r, o) {
  return n === 1 ? Math.min(e + t, o) : Math.max(e - t, r);
}
function pj(e, t) {
  return e - t;
}
function kA(e, t) {
  const {
    index: n
  } = e.reduce((r, o, i) => {
    const a = Math.abs(t - o);
    return r === null || a < r.distance || a === r.distance ? {
      distance: a,
      index: i
    } : r;
  }, null) ?? {};
  return n;
}
function tm(e, t) {
  if (t.current !== void 0 && e.changedTouches) {
    const n = e;
    for (let r = 0; r < n.changedTouches.length; r += 1) {
      const o = n.changedTouches[r];
      if (o.identifier === t.current)
        return {
          x: o.clientX,
          y: o.clientY
        };
    }
    return !1;
  }
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function zg(e, t, n) {
  return (e - t) * 100 / (n - t);
}
function Jle(e, t, n) {
  return (n - t) * e + t;
}
function Qle(e) {
  if (Math.abs(e) < 1) {
    const n = e.toExponential().split("e-"), r = n[0].split(".")[1];
    return (r ? r.length : 0) + parseInt(n[1], 10);
  }
  const t = e.toString().split(".")[1];
  return t ? t.length : 0;
}
function eue(e, t, n) {
  const r = Math.round((e - n) / t) * t + n;
  return Number(r.toFixed(Qle(t)));
}
function RA({
  values: e,
  newValue: t,
  index: n
}) {
  const r = e.slice();
  return r[n] = t, r.sort(pj);
}
function nm({
  sliderRef: e,
  activeIndex: t,
  setActive: n
}) {
  var o, i, a;
  const r = Un(e.current);
  (!((o = e.current) != null && o.contains(r.activeElement)) || Number((i = r == null ? void 0 : r.activeElement) == null ? void 0 : i.getAttribute("data-index")) !== t) && ((a = e.current) == null || a.querySelector(`[type="range"][data-index="${t}"]`).focus()), n && n(t);
}
function rm(e, t) {
  return typeof e == "number" && typeof t == "number" ? e === t : typeof e == "object" && typeof t == "object" ? Xle(e, t) : !1;
}
const tue = {
  horizontal: {
    offset: (e) => ({
      left: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  "horizontal-reverse": {
    offset: (e) => ({
      right: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  vertical: {
    offset: (e) => ({
      bottom: `${e}%`
    }),
    leap: (e) => ({
      height: `${e}%`
    })
  }
}, nue = (e) => e;
let om;
function PA() {
  return om === void 0 && (typeof CSS < "u" && typeof CSS.supports == "function" ? om = CSS.supports("touch-action", "none") : om = !0), om;
}
function rue(e) {
  const {
    "aria-labelledby": t,
    defaultValue: n,
    disabled: r = !1,
    disableSwap: o = !1,
    isRtl: i = !1,
    marks: a = !1,
    max: c = 100,
    min: l = 0,
    name: u,
    onChange: d,
    onChangeCommitted: f,
    orientation: h = "horizontal",
    rootRef: v,
    scale: y = nue,
    step: g = 1,
    shiftStep: b = 10,
    tabIndex: x,
    value: $
  } = e, S = E.useRef(void 0), [O, C] = E.useState(-1), [T, k] = E.useState(-1), [I, P] = E.useState(!1), _ = E.useRef(0), [A, D] = Mc({
    controlled: $,
    default: n ?? l,
    name: "Slider"
  }), M = d && ((J, he, Te) => {
    const xe = J.nativeEvent || J, Ae = new xe.constructor(xe.type, xe);
    Object.defineProperty(Ae, "target", {
      writable: !0,
      value: {
        value: he,
        name: u
      }
    }), d(Ae, he, Te);
  }), N = Array.isArray(A);
  let L = N ? A.slice().sort(pj) : [A];
  L = L.map((J) => J == null ? l : eu(J, l, c));
  const z = a === !0 && g !== null ? [...Array(Math.floor((c - l) / g) + 1)].map((J, he) => ({
    value: l + g * he
  })) : a || [], q = z.map((J) => J.value), [W, U] = E.useState(-1), K = E.useRef(null), Y = $n(v, K), X = (J) => (he) => {
    var xe;
    const Te = Number(he.currentTarget.getAttribute("data-index"));
    kg(he.target) && U(Te), k(Te), (xe = J == null ? void 0 : J.onFocus) == null || xe.call(J, he);
  }, oe = (J) => (he) => {
    var Te;
    kg(he.target) || U(-1), k(-1), (Te = J == null ? void 0 : J.onBlur) == null || Te.call(J, he);
  }, re = (J, he) => {
    const Te = Number(J.currentTarget.getAttribute("data-index")), xe = L[Te], Ae = q.indexOf(xe);
    let Ce = he;
    if (z && g == null) {
      const Ye = q[q.length - 1];
      Ce > Ye ? Ce = Ye : Ce < q[0] ? Ce = q[0] : Ce = Ce < xe ? q[Ae - 1] : q[Ae + 1];
    }
    if (Ce = eu(Ce, l, c), N) {
      o && (Ce = eu(Ce, L[Te - 1] || -1 / 0, L[Te + 1] || 1 / 0));
      const Ye = Ce;
      Ce = RA({
        values: L,
        newValue: Ce,
        index: Te
      });
      let He = Te;
      o || (He = Ce.indexOf(Ye)), nm({
        sliderRef: K,
        activeIndex: He
      });
    }
    D(Ce), U(Te), M && !rm(Ce, A) && M(J, Ce, Te), f && f(J, Ce);
  }, Z = (J) => (he) => {
    var Te;
    if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "PageUp", "PageDown", "Home", "End"].includes(he.key)) {
      he.preventDefault();
      const xe = Number(he.currentTarget.getAttribute("data-index")), Ae = L[xe];
      let Ce = null;
      if (g != null) {
        const Ye = he.shiftKey ? b : g;
        switch (he.key) {
          case "ArrowUp":
            Ce = Fl(Ae, Ye, 1, l, c);
            break;
          case "ArrowRight":
            Ce = Fl(Ae, Ye, i ? -1 : 1, l, c);
            break;
          case "ArrowDown":
            Ce = Fl(Ae, Ye, -1, l, c);
            break;
          case "ArrowLeft":
            Ce = Fl(Ae, Ye, i ? 1 : -1, l, c);
            break;
          case "PageUp":
            Ce = Fl(Ae, b, 1, l, c);
            break;
          case "PageDown":
            Ce = Fl(Ae, b, -1, l, c);
            break;
          case "Home":
            Ce = l;
            break;
          case "End":
            Ce = c;
            break;
        }
      } else if (z) {
        const Ye = q[q.length - 1], He = q.indexOf(Ae), Be = [i ? "ArrowRight" : "ArrowLeft", "ArrowDown", "PageDown", "Home"], Xe = [i ? "ArrowLeft" : "ArrowRight", "ArrowUp", "PageUp", "End"];
        Be.includes(he.key) ? He === 0 ? Ce = q[0] : Ce = q[He - 1] : Xe.includes(he.key) && (He === q.length - 1 ? Ce = Ye : Ce = q[He + 1]);
      }
      Ce != null && re(he, Ce);
    }
    (Te = J == null ? void 0 : J.onKeyDown) == null || Te.call(J, he);
  };
  Dr(() => {
    var J;
    r && K.current.contains(document.activeElement) && ((J = document.activeElement) == null || J.blur());
  }, [r]), r && O !== -1 && C(-1), r && W !== -1 && U(-1);
  const ce = (J) => (he) => {
    var Te;
    (Te = J.onChange) == null || Te.call(J, he), re(he, he.target.valueAsNumber);
  }, fe = E.useRef(void 0);
  let de = h;
  i && h === "horizontal" && (de += "-reverse");
  const ne = ({
    finger: J,
    move: he = !1
  }) => {
    const {
      current: Te
    } = K, {
      width: xe,
      height: Ae,
      bottom: Ce,
      left: Ye
    } = Te.getBoundingClientRect();
    let He;
    de.startsWith("vertical") ? He = (Ce - J.y) / Ae : He = (J.x - Ye) / xe, de.includes("-reverse") && (He = 1 - He);
    let Be;
    if (Be = Jle(He, l, c), g)
      Be = eue(Be, g, l);
    else {
      const Ze = kA(q, Be);
      Be = q[Ze];
    }
    Be = eu(Be, l, c);
    let Xe = 0;
    if (N) {
      he ? Xe = fe.current : Xe = kA(L, Be), o && (Be = eu(Be, L[Xe - 1] || -1 / 0, L[Xe + 1] || 1 / 0));
      const Ze = Be;
      Be = RA({
        values: L,
        newValue: Be,
        index: Xe
      }), o && he || (Xe = Be.indexOf(Ze), fe.current = Xe);
    }
    return {
      newValue: Be,
      activeIndex: Xe
    };
  }, le = hr((J) => {
    const he = tm(J, S);
    if (!he)
      return;
    if (_.current += 1, J.type === "mousemove" && J.buttons === 0) {
      ve(J);
      return;
    }
    const {
      newValue: Te,
      activeIndex: xe
    } = ne({
      finger: he,
      move: !0
    });
    nm({
      sliderRef: K,
      activeIndex: xe,
      setActive: C
    }), D(Te), !I && _.current > Zle && P(!0), M && !rm(Te, A) && M(J, Te, xe);
  }), ve = hr((J) => {
    const he = tm(J, S);
    if (P(!1), !he)
      return;
    const {
      newValue: Te
    } = ne({
      finger: he,
      move: !0
    });
    C(-1), J.type === "touchend" && k(-1), f && f(J, Te), S.current = void 0, Se();
  }), G = hr((J) => {
    if (r)
      return;
    PA() || J.preventDefault();
    const he = J.changedTouches[0];
    he != null && (S.current = he.identifier);
    const Te = tm(J, S);
    if (Te !== !1) {
      const {
        newValue: Ae,
        activeIndex: Ce
      } = ne({
        finger: Te
      });
      nm({
        sliderRef: K,
        activeIndex: Ce,
        setActive: C
      }), D(Ae), M && !rm(Ae, A) && M(J, Ae, Ce);
    }
    _.current = 0;
    const xe = Un(K.current);
    xe.addEventListener("touchmove", le, {
      passive: !0
    }), xe.addEventListener("touchend", ve, {
      passive: !0
    });
  }), Se = E.useCallback(() => {
    const J = Un(K.current);
    J.removeEventListener("mousemove", le), J.removeEventListener("mouseup", ve), J.removeEventListener("touchmove", le), J.removeEventListener("touchend", ve);
  }, [ve, le]);
  E.useEffect(() => {
    const {
      current: J
    } = K;
    return J.addEventListener("touchstart", G, {
      passive: PA()
    }), () => {
      J.removeEventListener("touchstart", G), Se();
    };
  }, [Se, G]), E.useEffect(() => {
    r && Se();
  }, [r, Se]);
  const ue = (J) => (he) => {
    var Ae;
    if ((Ae = J.onMouseDown) == null || Ae.call(J, he), r || he.defaultPrevented || he.button !== 0)
      return;
    he.preventDefault();
    const Te = tm(he, S);
    if (Te !== !1) {
      const {
        newValue: Ce,
        activeIndex: Ye
      } = ne({
        finger: Te
      });
      nm({
        sliderRef: K,
        activeIndex: Ye,
        setActive: C
      }), D(Ce), M && !rm(Ce, A) && M(he, Ce, Ye);
    }
    _.current = 0;
    const xe = Un(K.current);
    xe.addEventListener("mousemove", le, {
      passive: !0
    }), xe.addEventListener("mouseup", ve);
  }, Q = zg(N ? L[0] : l, l, c), ie = zg(L[L.length - 1], l, c) - Q, ee = (J = {}) => {
    const he = vf(J), Te = {
      onMouseDown: ue(he || {})
    }, xe = {
      ...he,
      ...Te
    };
    return {
      ...J,
      ref: Y,
      ...xe
    };
  }, be = (J) => (he) => {
    var xe;
    (xe = J.onMouseOver) == null || xe.call(J, he);
    const Te = Number(he.currentTarget.getAttribute("data-index"));
    k(Te);
  }, Ie = (J) => (he) => {
    var Te;
    (Te = J.onMouseLeave) == null || Te.call(J, he), k(-1);
  }, je = (J = {}) => {
    const he = vf(J), Te = {
      onMouseOver: be(he || {}),
      onMouseLeave: Ie(he || {})
    };
    return {
      ...J,
      ...he,
      ...Te
    };
  }, V = (J) => ({
    // So the non active thumb doesn't show its label on hover.
    pointerEvents: O !== -1 && O !== J ? "none" : void 0
  });
  let se;
  return h === "vertical" && (se = i ? "vertical-rl" : "vertical-lr"), {
    active: O,
    axis: de,
    axisProps: tue,
    dragging: I,
    focusedThumbIndex: W,
    getHiddenInputProps: (J = {}) => {
      const he = vf(J), Te = {
        onChange: ce(he || {}),
        onFocus: X(he || {}),
        onBlur: oe(he || {}),
        onKeyDown: Z(he || {})
      }, xe = {
        ...he,
        ...Te
      };
      return {
        tabIndex: x,
        "aria-labelledby": t,
        "aria-orientation": h,
        "aria-valuemax": y(c),
        "aria-valuemin": y(l),
        name: u,
        type: "range",
        min: e.min,
        max: e.max,
        step: e.step === null && e.marks ? "any" : e.step ?? void 0,
        disabled: r,
        ...J,
        ...xe,
        style: {
          ...Dne,
          direction: i ? "rtl" : "ltr",
          // So that VoiceOver's focus indicator matches the thumb's dimensions
          width: "100%",
          height: "100%",
          writingMode: se
        }
      };
    },
    getRootProps: ee,
    getThumbProps: je,
    marks: z,
    open: T,
    range: N,
    rootRef: Y,
    trackLeap: ie,
    trackOffset: Q,
    values: L,
    getThumbStyle: V
  };
}
const oue = (e) => !e || !Dc(e);
function iue(e) {
  return mt("MuiSlider", e);
}
const Yo = gt("MuiSlider", ["root", "active", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "disabled", "dragging", "focusVisible", "mark", "markActive", "marked", "markLabel", "markLabelActive", "rail", "sizeSmall", "thumb", "thumbColorPrimary", "thumbColorSecondary", "thumbColorError", "thumbColorSuccess", "thumbColorInfo", "thumbColorWarning", "track", "trackInverted", "trackFalse", "thumbSizeSmall", "valueLabel", "valueLabelOpen", "valueLabelCircle", "valueLabelLabel", "vertical"]), aue = (e) => {
  const {
    open: t
  } = e;
  return {
    offset: Ge(t && Yo.valueLabelOpen),
    circle: Yo.valueLabelCircle,
    label: Yo.valueLabelLabel
  };
};
function hj(e) {
  const {
    children: t,
    className: n,
    value: r
  } = e, o = aue(e);
  return t ? /* @__PURE__ */ E.cloneElement(t, {
    className: Ge(t.props.className)
  }, /* @__PURE__ */ F.jsxs(E.Fragment, {
    children: [t.props.children, /* @__PURE__ */ F.jsx("span", {
      className: Ge(o.offset, n),
      "aria-hidden": !0,
      children: /* @__PURE__ */ F.jsx("span", {
        className: o.circle,
        children: /* @__PURE__ */ F.jsx("span", {
          className: o.label,
          children: r
        })
      })
    })]
  })) : null;
}
process.env.NODE_ENV !== "production" && (hj.propTypes = {
  children: s.element.isRequired,
  className: s.string,
  value: s.node
});
function AA(e) {
  return e;
}
const sue = Pe("span", {
  name: "MuiSlider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`color${Le(n.color)}`], n.size !== "medium" && t[`size${Le(n.size)}`], n.marked && t.marked, n.orientation === "vertical" && t.vertical, n.track === "inverted" && t.trackInverted, n.track === !1 && t.trackFalse];
  }
})(ct(({
  theme: e
}) => ({
  borderRadius: 12,
  boxSizing: "content-box",
  display: "inline-block",
  position: "relative",
  cursor: "pointer",
  touchAction: "none",
  WebkitTapHighlightColor: "transparent",
  "@media print": {
    colorAdjust: "exact"
  },
  [`&.${Yo.disabled}`]: {
    pointerEvents: "none",
    cursor: "default",
    color: (e.vars || e).palette.grey[400]
  },
  [`&.${Yo.dragging}`]: {
    [`& .${Yo.thumb}, & .${Yo.track}`]: {
      transition: "none"
    }
  },
  variants: [...Object.entries(e.palette).filter(Dn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  })), {
    props: {
      orientation: "horizontal"
    },
    style: {
      height: 4,
      width: "100%",
      padding: "13px 0",
      // The primary input mechanism of the device includes a pointing device of limited accuracy.
      "@media (pointer: coarse)": {
        // Reach 42px touch target, about ~8mm on screen.
        padding: "20px 0"
      }
    }
  }, {
    props: {
      orientation: "horizontal",
      size: "small"
    },
    style: {
      height: 2
    }
  }, {
    props: {
      orientation: "horizontal",
      marked: !0
    },
    style: {
      marginBottom: 20
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      width: 4,
      padding: "0 13px",
      // The primary input mechanism of the device includes a pointing device of limited accuracy.
      "@media (pointer: coarse)": {
        // Reach 42px touch target, about ~8mm on screen.
        padding: "0 20px"
      }
    }
  }, {
    props: {
      orientation: "vertical",
      size: "small"
    },
    style: {
      width: 2
    }
  }, {
    props: {
      orientation: "vertical",
      marked: !0
    },
    style: {
      marginRight: 44
    }
  }]
}))), cue = Pe("span", {
  name: "MuiSlider",
  slot: "Rail",
  overridesResolver: (e, t) => t.rail
})({
  display: "block",
  position: "absolute",
  borderRadius: "inherit",
  backgroundColor: "currentColor",
  opacity: 0.38,
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "100%",
      height: "inherit",
      top: "50%",
      transform: "translateY(-50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      width: "inherit",
      left: "50%",
      transform: "translateX(-50%)"
    }
  }, {
    props: {
      track: "inverted"
    },
    style: {
      opacity: 1
    }
  }]
}), lue = Pe("span", {
  name: "MuiSlider",
  slot: "Track",
  overridesResolver: (e, t) => t.track
})(ct(({
  theme: e
}) => ({
  display: "block",
  position: "absolute",
  borderRadius: "inherit",
  border: "1px solid currentColor",
  backgroundColor: "currentColor",
  transition: e.transitions.create(["left", "width", "bottom", "height"], {
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: {
      size: "small"
    },
    style: {
      border: "none"
    }
  }, {
    props: {
      orientation: "horizontal"
    },
    style: {
      height: "inherit",
      top: "50%",
      transform: "translateY(-50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      width: "inherit",
      left: "50%",
      transform: "translateX(-50%)"
    }
  }, {
    props: {
      track: !1
    },
    style: {
      display: "none"
    }
  }, ...Object.entries(e.palette).filter(Dn()).map(([t]) => ({
    props: {
      color: t,
      track: "inverted"
    },
    style: {
      ...e.vars ? {
        backgroundColor: e.vars.palette.Slider[`${t}Track`],
        borderColor: e.vars.palette.Slider[`${t}Track`]
      } : {
        backgroundColor: jf(e.palette[t].main, 0.62),
        borderColor: jf(e.palette[t].main, 0.62),
        ...e.applyStyles("dark", {
          backgroundColor: Lf(e.palette[t].main, 0.5)
        }),
        ...e.applyStyles("dark", {
          borderColor: Lf(e.palette[t].main, 0.5)
        })
      }
    }
  }))]
}))), uue = Pe("span", {
  name: "MuiSlider",
  slot: "Thumb",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.thumb, t[`thumbColor${Le(n.color)}`], n.size !== "medium" && t[`thumbSize${Le(n.size)}`]];
  }
})(ct(({
  theme: e
}) => ({
  position: "absolute",
  width: 20,
  height: 20,
  boxSizing: "border-box",
  borderRadius: "50%",
  outline: 0,
  backgroundColor: "currentColor",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: e.transitions.create(["box-shadow", "left", "bottom"], {
    duration: e.transitions.duration.shortest
  }),
  "&::before": {
    position: "absolute",
    content: '""',
    borderRadius: "inherit",
    width: "100%",
    height: "100%",
    boxShadow: (e.vars || e).shadows[2]
  },
  "&::after": {
    position: "absolute",
    content: '""',
    borderRadius: "50%",
    // 42px is the hit target
    width: 42,
    height: 42,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  },
  [`&.${Yo.disabled}`]: {
    "&:hover": {
      boxShadow: "none"
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      width: 12,
      height: 12,
      "&::before": {
        boxShadow: "none"
      }
    }
  }, {
    props: {
      orientation: "horizontal"
    },
    style: {
      top: "50%",
      transform: "translate(-50%, -50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: "50%",
      transform: "translate(-50%, 50%)"
    }
  }, ...Object.entries(e.palette).filter(Dn()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&:hover, &.${Yo.focusVisible}`]: {
        ...e.vars ? {
          boxShadow: `0px 0px 0px 8px rgba(${e.vars.palette[t].mainChannel} / 0.16)`
        } : {
          boxShadow: `0px 0px 0px 8px ${It(e.palette[t].main, 0.16)}`
        },
        "@media (hover: none)": {
          boxShadow: "none"
        }
      },
      [`&.${Yo.active}`]: {
        ...e.vars ? {
          boxShadow: `0px 0px 0px 14px rgba(${e.vars.palette[t].mainChannel} / 0.16)`
        } : {
          boxShadow: `0px 0px 0px 14px ${It(e.palette[t].main, 0.16)}`
        }
      }
    }
  }))]
}))), mj = Pe(hj, {
  name: "MuiSlider",
  slot: "ValueLabel",
  overridesResolver: (e, t) => t.valueLabel
})(ct(({
  theme: e
}) => ({
  zIndex: 1,
  whiteSpace: "nowrap",
  ...e.typography.body2,
  fontWeight: 500,
  transition: e.transitions.create(["transform"], {
    duration: e.transitions.duration.shortest
  }),
  position: "absolute",
  backgroundColor: (e.vars || e).palette.grey[600],
  borderRadius: 2,
  color: (e.vars || e).palette.common.white,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0.25rem 0.75rem",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      transform: "translateY(-100%) scale(0)",
      top: "-10px",
      transformOrigin: "bottom center",
      "&::before": {
        position: "absolute",
        content: '""',
        width: 8,
        height: 8,
        transform: "translate(-50%, 50%) rotate(45deg)",
        backgroundColor: "inherit",
        bottom: 0,
        left: "50%"
      },
      [`&.${Yo.valueLabelOpen}`]: {
        transform: "translateY(-100%) scale(1)"
      }
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      transform: "translateY(-50%) scale(0)",
      right: "30px",
      top: "50%",
      transformOrigin: "right center",
      "&::before": {
        position: "absolute",
        content: '""',
        width: 8,
        height: 8,
        transform: "translate(-50%, -50%) rotate(45deg)",
        backgroundColor: "inherit",
        right: -8,
        top: "50%"
      },
      [`&.${Yo.valueLabelOpen}`]: {
        transform: "translateY(-50%) scale(1)"
      }
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      fontSize: e.typography.pxToRem(12),
      padding: "0.25rem 0.5rem"
    }
  }, {
    props: {
      orientation: "vertical",
      size: "small"
    },
    style: {
      right: "20px"
    }
  }]
})));
process.env.NODE_ENV !== "production" && (mj.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: s.element.isRequired,
  /**
   * @ignore
   */
  index: s.number.isRequired,
  /**
   * @ignore
   */
  open: s.bool.isRequired,
  /**
   * @ignore
   */
  value: s.node
});
const due = Pe("span", {
  name: "MuiSlider",
  slot: "Mark",
  shouldForwardProp: (e) => av(e) && e !== "markActive",
  overridesResolver: (e, t) => {
    const {
      markActive: n
    } = e;
    return [t.mark, n && t.markActive];
  }
})(ct(({
  theme: e
}) => ({
  position: "absolute",
  width: 2,
  height: 2,
  borderRadius: 1,
  backgroundColor: "currentColor",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      top: "50%",
      transform: "translate(-1px, -50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: "50%",
      transform: "translate(-50%, 1px)"
    }
  }, {
    props: {
      markActive: !0
    },
    style: {
      backgroundColor: (e.vars || e).palette.background.paper,
      opacity: 0.8
    }
  }]
}))), fue = Pe("span", {
  name: "MuiSlider",
  slot: "MarkLabel",
  shouldForwardProp: (e) => av(e) && e !== "markLabelActive",
  overridesResolver: (e, t) => t.markLabel
})(ct(({
  theme: e
}) => ({
  ...e.typography.body2,
  color: (e.vars || e).palette.text.secondary,
  position: "absolute",
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      top: 30,
      transform: "translateX(-50%)",
      "@media (pointer: coarse)": {
        top: 40
      }
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: 36,
      transform: "translateY(50%)",
      "@media (pointer: coarse)": {
        left: 44
      }
    }
  }, {
    props: {
      markLabelActive: !0
    },
    style: {
      color: (e.vars || e).palette.text.primary
    }
  }]
}))), pue = (e) => {
  const {
    disabled: t,
    dragging: n,
    marked: r,
    orientation: o,
    track: i,
    classes: a,
    color: c,
    size: l
  } = e, u = {
    root: ["root", t && "disabled", n && "dragging", r && "marked", o === "vertical" && "vertical", i === "inverted" && "trackInverted", i === !1 && "trackFalse", c && `color${Le(c)}`, l && `size${Le(l)}`],
    rail: ["rail"],
    track: ["track"],
    mark: ["mark"],
    markActive: ["markActive"],
    markLabel: ["markLabel"],
    markLabelActive: ["markLabelActive"],
    valueLabel: ["valueLabel"],
    thumb: ["thumb", t && "disabled", l && `thumbSize${Le(l)}`, c && `thumbColor${Le(c)}`],
    active: ["active"],
    disabled: ["disabled"],
    focusVisible: ["focusVisible"]
  };
  return wt(u, iue, a);
}, hue = ({
  children: e
}) => e, mue = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiSlider"
  }), o = Ya(), {
    "aria-label": i,
    "aria-valuetext": a,
    "aria-labelledby": c,
    // eslint-disable-next-line react/prop-types
    component: l = "span",
    components: u = {},
    componentsProps: d = {},
    color: f = "primary",
    classes: h,
    className: v,
    disableSwap: y = !1,
    disabled: g = !1,
    getAriaLabel: b,
    getAriaValueText: x,
    marks: $ = !1,
    max: S = 100,
    min: O = 0,
    name: C,
    onChange: T,
    onChangeCommitted: k,
    orientation: I = "horizontal",
    shiftStep: P = 10,
    size: _ = "medium",
    step: A = 1,
    scale: D = AA,
    slotProps: M,
    slots: N,
    tabIndex: L,
    track: z = "normal",
    value: q,
    valueLabelDisplay: W = "off",
    valueLabelFormat: U = AA,
    ...K
  } = r, Y = {
    ...r,
    isRtl: o,
    max: S,
    min: O,
    classes: h,
    disabled: g,
    disableSwap: y,
    orientation: I,
    marks: $,
    color: f,
    size: _,
    step: A,
    shiftStep: P,
    scale: D,
    track: z,
    valueLabelDisplay: W,
    valueLabelFormat: U
  }, {
    axisProps: X,
    getRootProps: oe,
    getHiddenInputProps: re,
    getThumbProps: Z,
    open: ce,
    active: fe,
    axis: de,
    focusedThumbIndex: ne,
    range: le,
    dragging: ve,
    marks: G,
    values: Se,
    trackOffset: ue,
    trackLeap: Q,
    getThumbStyle: ie
  } = rue({
    ...Y,
    rootRef: n
  });
  Y.marked = G.length > 0 && G.some((Je) => Je.label), Y.dragging = ve, Y.focusedThumbIndex = ne;
  const ee = pue(Y), be = (N == null ? void 0 : N.root) ?? u.Root ?? sue, Ie = (N == null ? void 0 : N.rail) ?? u.Rail ?? cue, je = (N == null ? void 0 : N.track) ?? u.Track ?? lue, V = (N == null ? void 0 : N.thumb) ?? u.Thumb ?? uue, se = (N == null ? void 0 : N.valueLabel) ?? u.ValueLabel ?? mj, we = (N == null ? void 0 : N.mark) ?? u.Mark ?? due, J = (N == null ? void 0 : N.markLabel) ?? u.MarkLabel ?? fue, he = (N == null ? void 0 : N.input) ?? u.Input ?? "input", Te = (M == null ? void 0 : M.root) ?? d.root, xe = (M == null ? void 0 : M.rail) ?? d.rail, Ae = (M == null ? void 0 : M.track) ?? d.track, Ce = (M == null ? void 0 : M.thumb) ?? d.thumb, Ye = (M == null ? void 0 : M.valueLabel) ?? d.valueLabel, He = (M == null ? void 0 : M.mark) ?? d.mark, Be = (M == null ? void 0 : M.markLabel) ?? d.markLabel, Xe = (M == null ? void 0 : M.input) ?? d.input, Ze = fr({
    elementType: be,
    getSlotProps: oe,
    externalSlotProps: Te,
    externalForwardedProps: K,
    additionalProps: {
      ...oue(be) && {
        as: l
      }
    },
    ownerState: {
      ...Y,
      ...Te == null ? void 0 : Te.ownerState
    },
    className: [ee.root, v]
  }), Ne = fr({
    elementType: Ie,
    externalSlotProps: xe,
    ownerState: Y,
    className: ee.rail
  }), $e = fr({
    elementType: je,
    externalSlotProps: Ae,
    additionalProps: {
      style: {
        ...X[de].offset(ue),
        ...X[de].leap(Q)
      }
    },
    ownerState: {
      ...Y,
      ...Ae == null ? void 0 : Ae.ownerState
    },
    className: ee.track
  }), Ue = fr({
    elementType: V,
    getSlotProps: Z,
    externalSlotProps: Ce,
    ownerState: {
      ...Y,
      ...Ce == null ? void 0 : Ce.ownerState
    },
    className: ee.thumb
  }), Ke = fr({
    elementType: se,
    externalSlotProps: Ye,
    ownerState: {
      ...Y,
      ...Ye == null ? void 0 : Ye.ownerState
    },
    className: ee.valueLabel
  }), Me = fr({
    elementType: we,
    externalSlotProps: He,
    ownerState: Y,
    className: ee.mark
  }), We = fr({
    elementType: J,
    externalSlotProps: Be,
    ownerState: Y,
    className: ee.markLabel
  }), at = fr({
    elementType: he,
    getSlotProps: re,
    externalSlotProps: Xe,
    ownerState: Y
  });
  return /* @__PURE__ */ F.jsxs(be, {
    ...Ze,
    children: [/* @__PURE__ */ F.jsx(Ie, {
      ...Ne
    }), /* @__PURE__ */ F.jsx(je, {
      ...$e
    }), G.filter((Je) => Je.value >= O && Je.value <= S).map((Je, ke) => {
      const Qe = zg(Je.value, O, S), ot = X[de].offset(Qe);
      let Mt;
      return z === !1 ? Mt = Se.includes(Je.value) : Mt = z === "normal" && (le ? Je.value >= Se[0] && Je.value <= Se[Se.length - 1] : Je.value <= Se[0]) || z === "inverted" && (le ? Je.value <= Se[0] || Je.value >= Se[Se.length - 1] : Je.value >= Se[0]), /* @__PURE__ */ F.jsxs(E.Fragment, {
        children: [/* @__PURE__ */ F.jsx(we, {
          "data-index": ke,
          ...Me,
          ...!Dc(we) && {
            markActive: Mt
          },
          style: {
            ...ot,
            ...Me.style
          },
          className: Ge(Me.className, Mt && ee.markActive)
        }), Je.label != null ? /* @__PURE__ */ F.jsx(J, {
          "aria-hidden": !0,
          "data-index": ke,
          ...We,
          ...!Dc(J) && {
            markLabelActive: Mt
          },
          style: {
            ...ot,
            ...We.style
          },
          className: Ge(ee.markLabel, We.className, Mt && ee.markLabelActive),
          children: Je.label
        }) : null]
      }, ke);
    }), Se.map((Je, ke) => {
      const Qe = zg(Je, O, S), ot = X[de].offset(Qe), Mt = W === "off" ? hue : se;
      return (
        /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */
        /* @__PURE__ */ F.jsx(Mt, {
          ...!Dc(Mt) && {
            valueLabelFormat: U,
            valueLabelDisplay: W,
            value: typeof U == "function" ? U(D(Je), ke) : U,
            index: ke,
            open: ce === ke || fe === ke || W === "on",
            disabled: g
          },
          ...Ke,
          children: /* @__PURE__ */ F.jsx(V, {
            "data-index": ke,
            ...Ue,
            className: Ge(ee.thumb, Ue.className, fe === ke && ee.active, ne === ke && ee.focusVisible),
            style: {
              ...ot,
              ...ie(ke),
              ...Ue.style
            },
            children: /* @__PURE__ */ F.jsx(he, {
              "data-index": ke,
              "aria-label": b ? b(ke) : i,
              "aria-valuenow": D(Je),
              "aria-labelledby": c,
              "aria-valuetext": x ? x(D(Je), ke) : a,
              value: Se[ke],
              ...at
            })
          })
        }, ke)
      );
    })]
  });
});
process.env.NODE_ENV !== "production" && (mue.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The label of the slider.
   */
  "aria-label": $o(s.string, (e) => Array.isArray(e.value || e.defaultValue) && e["aria-label"] != null ? new Error("MUI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.") : null),
  /**
   * The id of the element containing a label for the slider.
   */
  "aria-labelledby": s.string,
  /**
   * A string value that provides a user-friendly name for the current value of the slider.
   */
  "aria-valuetext": $o(s.string, (e) => Array.isArray(e.value || e.defaultValue) && e["aria-valuetext"] != null ? new Error("MUI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.") : null),
  /**
   * @ignore
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: s.shape({
    Input: s.elementType,
    Mark: s.elementType,
    MarkLabel: s.elementType,
    Rail: s.elementType,
    Root: s.elementType,
    Thumb: s.elementType,
    Track: s.elementType,
    ValueLabel: s.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: s.shape({
    input: s.oneOfType([s.func, s.object]),
    mark: s.oneOfType([s.func, s.object]),
    markLabel: s.oneOfType([s.func, s.object]),
    rail: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object]),
    thumb: s.oneOfType([s.func, s.object]),
    track: s.oneOfType([s.func, s.object]),
    valueLabel: s.oneOfType([s.func, s.shape({
      children: s.element,
      className: s.string,
      open: s.bool,
      style: s.object,
      value: s.node,
      valueLabelDisplay: s.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.oneOfType([s.arrayOf(s.number), s.number]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, the active thumb doesn't swap when moving pointer over a thumb while dragging another thumb.
   * @default false
   */
  disableSwap: s.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   * This is important for screen reader users.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaLabel: s.func,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   * This is important for screen reader users.
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaValueText: s.func,
  /**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks are spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   * @default false
   */
  marks: s.oneOfType([s.arrayOf(s.shape({
    label: s.node,
    value: s.number.isRequired
  })), s.bool]),
  /**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   * @default 100
   */
  max: s.number,
  /**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   * @default 0
   */
  min: s.number,
  /**
   * Name attribute of the hidden `input` element.
   */
  name: s.string,
  /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {Event} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   * @param {number} activeThumb Index of the currently moved thumb.
   */
  onChange: s.func,
  /**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {React.SyntheticEvent | Event} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   */
  onChangeCommitted: s.func,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: s.oneOf(["horizontal", "vertical"]),
  /**
   * A transformation function, to change the scale of the slider.
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  scale: s.func,
  /**
   * The granularity with which the slider can step through values when using Page Up/Page Down or Shift + Arrow Up/Arrow Down.
   * @default 10
   */
  shiftStep: s.number,
  /**
   * The size of the slider.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["small", "medium"]), s.string]),
  /**
   * The props used for each slot inside the Slider.
   * @default {}
   */
  slotProps: s.shape({
    input: s.oneOfType([s.func, s.object]),
    mark: s.oneOfType([s.func, s.object]),
    markLabel: s.oneOfType([s.func, s.object]),
    rail: s.oneOfType([s.func, s.object]),
    root: s.oneOfType([s.func, s.object]),
    thumb: s.oneOfType([s.func, s.object]),
    track: s.oneOfType([s.func, s.object]),
    valueLabel: s.oneOfType([s.func, s.shape({
      children: s.element,
      className: s.string,
      open: s.bool,
      style: s.object,
      value: s.node,
      valueLabelDisplay: s.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The components used for each slot inside the Slider.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: s.shape({
    input: s.elementType,
    mark: s.elementType,
    markLabel: s.elementType,
    rail: s.elementType,
    root: s.elementType,
    thumb: s.elementType,
    track: s.elementType,
    valueLabel: s.elementType
  }),
  /**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * The `min` prop serves as the origin for the valid values.
   * We recommend (max - min) to be evenly divisible by the step.
   *
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   * @default 1
   */
  step: s.number,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Tab index attribute of the hidden `input` element.
   */
  tabIndex: s.number,
  /**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   * @default 'normal'
   */
  track: s.oneOf(["inverted", "normal", !1]),
  /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */
  value: s.oneOfType([s.arrayOf(s.number), s.number]),
  /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   * @default 'off'
   */
  valueLabelDisplay: s.oneOf(["auto", "off", "on"]),
  /**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  valueLabelFormat: s.oneOfType([s.func, s.string])
});
const gue = Ore({
  createStyledComponent: Pe("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (e, t) => t.root
  }),
  useThemeProps: (e) => $t({
    props: e,
    name: "MuiStack"
  })
});
process.env.NODE_ENV !== "production" && (gue.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */
  direction: s.oneOfType([s.oneOf(["column-reverse", "column", "row-reverse", "row"]), s.arrayOf(s.oneOf(["column-reverse", "column", "row-reverse", "row"])), s.object]),
  /**
   * Add an element between each child.
   */
  divider: s.node,
  /**
   * Defines the space between immediate children.
   * @default 0
   */
  spacing: s.oneOfType([s.arrayOf(s.oneOfType([s.number, s.string])), s.number, s.object, s.string]),
  /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */
  useFlexGap: s.bool
});
function vue(e) {
  return mt("MuiTab", e);
}
const Do = gt("MuiTab", ["root", "labelIcon", "textColorInherit", "textColorPrimary", "textColorSecondary", "selected", "disabled", "fullWidth", "wrapped", "iconWrapper", "icon"]), yue = (e) => {
  const {
    classes: t,
    textColor: n,
    fullWidth: r,
    wrapped: o,
    icon: i,
    label: a,
    selected: c,
    disabled: l
  } = e, u = {
    root: ["root", i && a && "labelIcon", `textColor${Le(n)}`, r && "fullWidth", o && "wrapped", c && "selected", l && "disabled"],
    icon: ["iconWrapper", "icon"]
  };
  return wt(u, vue, t);
}, bue = Pe(oa, {
  name: "MuiTab",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.label && n.icon && t.labelIcon, t[`textColor${Le(n.textColor)}`], n.fullWidth && t.fullWidth, n.wrapped && t.wrapped, {
      [`& .${Do.iconWrapper}`]: t.iconWrapper
    }, {
      [`& .${Do.icon}`]: t.icon
    }];
  }
})(ct(({
  theme: e
}) => ({
  ...e.typography.button,
  maxWidth: 360,
  minWidth: 90,
  position: "relative",
  minHeight: 48,
  flexShrink: 0,
  padding: "12px 16px",
  overflow: "hidden",
  whiteSpace: "normal",
  textAlign: "center",
  lineHeight: 1.25,
  variants: [{
    props: ({
      ownerState: t
    }) => t.label && (t.iconPosition === "top" || t.iconPosition === "bottom"),
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.label && t.iconPosition !== "top" && t.iconPosition !== "bottom",
    style: {
      flexDirection: "row"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.icon && t.label,
    style: {
      minHeight: 72,
      paddingTop: 9,
      paddingBottom: 9
    }
  }, {
    props: ({
      ownerState: t,
      iconPosition: n
    }) => t.icon && t.label && n === "top",
    style: {
      [`& > .${Do.icon}`]: {
        marginBottom: 6
      }
    }
  }, {
    props: ({
      ownerState: t,
      iconPosition: n
    }) => t.icon && t.label && n === "bottom",
    style: {
      [`& > .${Do.icon}`]: {
        marginTop: 6
      }
    }
  }, {
    props: ({
      ownerState: t,
      iconPosition: n
    }) => t.icon && t.label && n === "start",
    style: {
      [`& > .${Do.icon}`]: {
        marginRight: e.spacing(1)
      }
    }
  }, {
    props: ({
      ownerState: t,
      iconPosition: n
    }) => t.icon && t.label && n === "end",
    style: {
      [`& > .${Do.icon}`]: {
        marginLeft: e.spacing(1)
      }
    }
  }, {
    props: {
      textColor: "inherit"
    },
    style: {
      color: "inherit",
      opacity: 0.6,
      // same opacity as theme.palette.text.secondary
      [`&.${Do.selected}`]: {
        opacity: 1
      },
      [`&.${Do.disabled}`]: {
        opacity: (e.vars || e).palette.action.disabledOpacity
      }
    }
  }, {
    props: {
      textColor: "primary"
    },
    style: {
      color: (e.vars || e).palette.text.secondary,
      [`&.${Do.selected}`]: {
        color: (e.vars || e).palette.primary.main
      },
      [`&.${Do.disabled}`]: {
        color: (e.vars || e).palette.text.disabled
      }
    }
  }, {
    props: {
      textColor: "secondary"
    },
    style: {
      color: (e.vars || e).palette.text.secondary,
      [`&.${Do.selected}`]: {
        color: (e.vars || e).palette.secondary.main
      },
      [`&.${Do.disabled}`]: {
        color: (e.vars || e).palette.text.disabled
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      flexShrink: 1,
      flexGrow: 1,
      flexBasis: 0,
      maxWidth: "none"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.wrapped,
    style: {
      fontSize: e.typography.pxToRem(12)
    }
  }]
}))), xue = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiTab"
  }), {
    className: o,
    disabled: i = !1,
    disableFocusRipple: a = !1,
    // eslint-disable-next-line react/prop-types
    fullWidth: c,
    icon: l,
    iconPosition: u = "top",
    // eslint-disable-next-line react/prop-types
    indicator: d,
    label: f,
    onChange: h,
    onClick: v,
    onFocus: y,
    // eslint-disable-next-line react/prop-types
    selected: g,
    // eslint-disable-next-line react/prop-types
    selectionFollowsFocus: b,
    // eslint-disable-next-line react/prop-types
    textColor: x = "inherit",
    value: $,
    wrapped: S = !1,
    ...O
  } = r, C = {
    ...r,
    disabled: i,
    disableFocusRipple: a,
    selected: g,
    icon: !!l,
    iconPosition: u,
    label: !!f,
    fullWidth: c,
    textColor: x,
    wrapped: S
  }, T = yue(C), k = l && f && /* @__PURE__ */ E.isValidElement(l) ? /* @__PURE__ */ E.cloneElement(l, {
    className: Ge(T.icon, l.props.className)
  }) : l, I = (_) => {
    !g && h && h(_, $), v && v(_);
  }, P = (_) => {
    b && !g && h && h(_, $), y && y(_);
  };
  return /* @__PURE__ */ F.jsxs(bue, {
    focusRipple: !a,
    className: Ge(T.root, o),
    ref: n,
    role: "tab",
    "aria-selected": g,
    disabled: i,
    onClick: I,
    onFocus: P,
    ownerState: C,
    tabIndex: g ? 0 : -1,
    ...O,
    children: [u === "top" || u === "start" ? /* @__PURE__ */ F.jsxs(E.Fragment, {
      children: [k, f]
    }) : /* @__PURE__ */ F.jsxs(E.Fragment, {
      children: [f, k]
    }), d]
  });
});
process.env.NODE_ENV !== "production" && (xue.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: nL,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: s.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: s.bool,
  /**
   * The icon to display.
   */
  icon: s.oneOfType([s.element, s.string]),
  /**
   * The position of the icon relative to the label.
   * @default 'top'
   */
  iconPosition: s.oneOf(["bottom", "end", "start", "top"]),
  /**
   * The label element.
   */
  label: s.node,
  /**
   * @ignore
   */
  onChange: s.func,
  /**
   * @ignore
   */
  onClick: s.func,
  /**
   * @ignore
   */
  onFocus: s.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: s.any,
  /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   * @default false
   */
  wrapped: s.bool
});
const wue = Oi(/* @__PURE__ */ F.jsx("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft"), $ue = Oi(/* @__PURE__ */ F.jsx("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");
function Oue(e) {
  return (1 + Math.sin(Math.PI * e - Math.PI / 2)) / 2;
}
function Sue(e, t, n, r = {}, o = () => {
}) {
  const {
    ease: i = Oue,
    duration: a = 300
    // standard
  } = r;
  let c = null;
  const l = t[e];
  let u = !1;
  const d = () => {
    u = !0;
  }, f = (h) => {
    if (u) {
      o(new Error("Animation cancelled"));
      return;
    }
    c === null && (c = h);
    const v = Math.min(1, (h - c) / a);
    if (t[e] = i(v) * (n - l) + l, v >= 1) {
      requestAnimationFrame(() => {
        o(null);
      });
      return;
    }
    requestAnimationFrame(f);
  };
  return l === n ? (o(new Error("Element already at target position")), d) : (requestAnimationFrame(f), d);
}
const Cue = {
  width: 99,
  height: 99,
  position: "absolute",
  top: -9999,
  overflow: "scroll"
};
function gj(e) {
  const {
    onChange: t,
    ...n
  } = e, r = E.useRef(), o = E.useRef(null), i = () => {
    r.current = o.current.offsetHeight - o.current.clientHeight;
  };
  return Dr(() => {
    const a = Ep(() => {
      const l = r.current;
      i(), l !== r.current && t(r.current);
    }), c = Oo(o.current);
    return c.addEventListener("resize", a), () => {
      a.clear(), c.removeEventListener("resize", a);
    };
  }, [t]), E.useEffect(() => {
    i(), t(r.current);
  }, [t]), /* @__PURE__ */ F.jsx("div", {
    style: Cue,
    ...n,
    ref: o
  });
}
process.env.NODE_ENV !== "production" && (gj.propTypes = {
  onChange: s.func.isRequired
});
function Tue(e) {
  return mt("MuiTabScrollButton", e);
}
const Eue = gt("MuiTabScrollButton", ["root", "vertical", "horizontal", "disabled"]), _ue = (e) => {
  const {
    classes: t,
    orientation: n,
    disabled: r
  } = e;
  return wt({
    root: ["root", n, r && "disabled"]
  }, Tue, t);
}, kue = Pe(oa, {
  name: "MuiTabScrollButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.orientation && t[n.orientation]];
  }
})({
  width: 40,
  flexShrink: 0,
  opacity: 0.8,
  [`&.${Eue.disabled}`]: {
    opacity: 0
  },
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      width: "100%",
      height: 40,
      "& svg": {
        transform: "var(--TabScrollButton-svgRotate)"
      }
    }
  }]
}), vj = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiTabScrollButton"
  }), {
    className: o,
    slots: i = {},
    slotProps: a = {},
    direction: c,
    orientation: l,
    disabled: u,
    ...d
  } = r, f = Ya(), h = {
    isRtl: f,
    ...r
  }, v = _ue(h), y = i.StartScrollButtonIcon ?? wue, g = i.EndScrollButtonIcon ?? $ue, b = fr({
    elementType: y,
    externalSlotProps: a.startScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: h
  }), x = fr({
    elementType: g,
    externalSlotProps: a.endScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: h
  });
  return /* @__PURE__ */ F.jsx(kue, {
    component: "div",
    className: Ge(v.root, o),
    ref: n,
    role: null,
    ownerState: h,
    tabIndex: null,
    ...d,
    style: {
      ...d.style,
      ...l === "vertical" && {
        "--TabScrollButton-svgRotate": `rotate(${f ? -90 : 90}deg)`
      }
    },
    children: c === "left" ? /* @__PURE__ */ F.jsx(y, {
      ...b
    }) : /* @__PURE__ */ F.jsx(g, {
      ...x
    })
  });
});
process.env.NODE_ENV !== "production" && (vj.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The direction the button should indicate.
   */
  direction: s.oneOf(["left", "right"]).isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * The component orientation (layout flow direction).
   */
  orientation: s.oneOf(["horizontal", "vertical"]).isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: s.shape({
    endScrollButtonIcon: s.oneOfType([s.func, s.object]),
    startScrollButtonIcon: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    EndScrollButtonIcon: s.elementType,
    StartScrollButtonIcon: s.elementType
  }),
  /**
   * @ignore
   */
  style: s.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function Rue(e) {
  return mt("MuiTabs", e);
}
const c1 = gt("MuiTabs", ["root", "vertical", "flexContainer", "flexContainerVertical", "centered", "scroller", "fixed", "scrollableX", "scrollableY", "hideScrollbar", "scrollButtons", "scrollButtonsHideMobile", "indicator"]), IA = (e, t) => e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : e.firstChild, MA = (e, t) => e === t ? e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : e.lastChild, im = (e, t, n) => {
  let r = !1, o = n(e, t);
  for (; o; ) {
    if (o === e.firstChild) {
      if (r)
        return;
      r = !0;
    }
    const i = o.disabled || o.getAttribute("aria-disabled") === "true";
    if (!o.hasAttribute("tabindex") || i)
      o = n(e, o);
    else {
      o.focus();
      return;
    }
  }
}, Pue = (e) => {
  const {
    vertical: t,
    fixed: n,
    hideScrollbar: r,
    scrollableX: o,
    scrollableY: i,
    centered: a,
    scrollButtonsHideMobile: c,
    classes: l
  } = e;
  return wt({
    root: ["root", t && "vertical"],
    scroller: ["scroller", n && "fixed", r && "hideScrollbar", o && "scrollableX", i && "scrollableY"],
    flexContainer: ["flexContainer", t && "flexContainerVertical", a && "centered"],
    indicator: ["indicator"],
    scrollButtons: ["scrollButtons", c && "scrollButtonsHideMobile"],
    scrollableX: [o && "scrollableX"],
    hideScrollbar: [r && "hideScrollbar"]
  }, Rue, l);
}, Aue = Pe("div", {
  name: "MuiTabs",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${c1.scrollButtons}`]: t.scrollButtons
    }, {
      [`& .${c1.scrollButtons}`]: n.scrollButtonsHideMobile && t.scrollButtonsHideMobile
    }, t.root, n.vertical && t.vertical];
  }
})(ct(({
  theme: e
}) => ({
  overflow: "hidden",
  minHeight: 48,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  display: "flex",
  variants: [{
    props: ({
      ownerState: t
    }) => t.vertical,
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.scrollButtonsHideMobile,
    style: {
      [`& .${c1.scrollButtons}`]: {
        [e.breakpoints.down("sm")]: {
          display: "none"
        }
      }
    }
  }]
}))), Iue = Pe("div", {
  name: "MuiTabs",
  slot: "Scroller",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.scroller, n.fixed && t.fixed, n.hideScrollbar && t.hideScrollbar, n.scrollableX && t.scrollableX, n.scrollableY && t.scrollableY];
  }
})({
  position: "relative",
  display: "inline-block",
  flex: "1 1 auto",
  whiteSpace: "nowrap",
  variants: [{
    props: ({
      ownerState: e
    }) => e.fixed,
    style: {
      overflowX: "hidden",
      width: "100%"
    }
  }, {
    props: ({
      ownerState: e
    }) => e.hideScrollbar,
    style: {
      // Hide dimensionless scrollbar on macOS
      scrollbarWidth: "none",
      // Firefox
      "&::-webkit-scrollbar": {
        display: "none"
        // Safari + Chrome
      }
    }
  }, {
    props: ({
      ownerState: e
    }) => e.scrollableX,
    style: {
      overflowX: "auto",
      overflowY: "hidden"
    }
  }, {
    props: ({
      ownerState: e
    }) => e.scrollableY,
    style: {
      overflowY: "auto",
      overflowX: "hidden"
    }
  }]
}), Mue = Pe("div", {
  name: "MuiTabs",
  slot: "FlexContainer",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.flexContainer, n.vertical && t.flexContainerVertical, n.centered && t.centered];
  }
})({
  display: "flex",
  variants: [{
    props: ({
      ownerState: e
    }) => e.vertical,
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      ownerState: e
    }) => e.centered,
    style: {
      justifyContent: "center"
    }
  }]
}), Nue = Pe("span", {
  name: "MuiTabs",
  slot: "Indicator",
  overridesResolver: (e, t) => t.indicator
})(ct(({
  theme: e
}) => ({
  position: "absolute",
  height: 2,
  bottom: 0,
  width: "100%",
  transition: e.transitions.create(),
  variants: [{
    props: {
      indicatorColor: "primary"
    },
    style: {
      backgroundColor: (e.vars || e).palette.primary.main
    }
  }, {
    props: {
      indicatorColor: "secondary"
    },
    style: {
      backgroundColor: (e.vars || e).palette.secondary.main
    }
  }, {
    props: ({
      ownerState: t
    }) => t.vertical,
    style: {
      height: "100%",
      width: 2,
      right: 0
    }
  }]
}))), Due = Pe(gj)({
  overflowX: "auto",
  overflowY: "hidden",
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Safari + Chrome
  }
}), NA = {};
let DA = !1;
const Lue = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiTabs"
  }), o = Fr(), i = Ya(), {
    "aria-label": a,
    "aria-labelledby": c,
    action: l,
    centered: u = !1,
    children: d,
    className: f,
    component: h = "div",
    allowScrollButtonsMobile: v = !1,
    indicatorColor: y = "primary",
    onChange: g,
    orientation: b = "horizontal",
    ScrollButtonComponent: x = vj,
    scrollButtons: $ = "auto",
    selectionFollowsFocus: S,
    slots: O = {},
    slotProps: C = {},
    TabIndicatorProps: T = {},
    TabScrollButtonProps: k = {},
    textColor: I = "primary",
    value: P,
    variant: _ = "standard",
    visibleScrollbar: A = !1,
    ...D
  } = r, M = _ === "scrollable", N = b === "vertical", L = N ? "scrollTop" : "scrollLeft", z = N ? "top" : "left", q = N ? "bottom" : "right", W = N ? "clientHeight" : "clientWidth", U = N ? "height" : "width", K = {
    ...r,
    component: h,
    allowScrollButtonsMobile: v,
    indicatorColor: y,
    orientation: b,
    vertical: N,
    scrollButtons: $,
    textColor: I,
    variant: _,
    visibleScrollbar: A,
    fixed: !M,
    hideScrollbar: M && !A,
    scrollableX: M && !N,
    scrollableY: M && N,
    centered: u && !M,
    scrollButtonsHideMobile: !v
  }, Y = Pue(K), X = fr({
    elementType: O.StartScrollButtonIcon,
    externalSlotProps: C.startScrollButtonIcon,
    ownerState: K
  }), oe = fr({
    elementType: O.EndScrollButtonIcon,
    externalSlotProps: C.endScrollButtonIcon,
    ownerState: K
  });
  process.env.NODE_ENV !== "production" && u && M && console.error('MUI: You can not use the `centered={true}` and `variant="scrollable"` properties at the same time on a `Tabs` component.');
  const [re, Z] = E.useState(!1), [ce, fe] = E.useState(NA), [de, ne] = E.useState(!1), [le, ve] = E.useState(!1), [G, Se] = E.useState(!1), [ue, Q] = E.useState({
    overflow: "hidden",
    scrollbarWidth: 0
  }), ie = /* @__PURE__ */ new Map(), ee = E.useRef(null), be = E.useRef(null), Ie = () => {
    const Ne = ee.current;
    let $e;
    if (Ne) {
      const Ke = Ne.getBoundingClientRect();
      $e = {
        clientWidth: Ne.clientWidth,
        scrollLeft: Ne.scrollLeft,
        scrollTop: Ne.scrollTop,
        scrollWidth: Ne.scrollWidth,
        top: Ke.top,
        bottom: Ke.bottom,
        left: Ke.left,
        right: Ke.right
      };
    }
    let Ue;
    if (Ne && P !== !1) {
      const Ke = be.current.children;
      if (Ke.length > 0) {
        const Me = Ke[ie.get(P)];
        process.env.NODE_ENV !== "production" && (Me || console.error(["MUI: The `value` provided to the Tabs component is invalid.", `None of the Tabs' children match with "${P}".`, ie.keys ? `You can provide one of the following values: ${Array.from(ie.keys()).join(", ")}.` : null].join(`
`))), Ue = Me ? Me.getBoundingClientRect() : null, process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && !DA && Ue && Ue.width === 0 && Ue.height === 0 && // if the whole Tabs component is hidden, don't warn
        $e.clientWidth !== 0 && ($e = null, console.error(["MUI: The `value` provided to the Tabs component is invalid.", `The Tab with this \`value\` ("${P}") is not part of the document layout.`, "Make sure the tab item is present in the document or that it's not `display: none`."].join(`
`)), DA = !0);
      }
    }
    return {
      tabsMeta: $e,
      tabMeta: Ue
    };
  }, je = hr(() => {
    const {
      tabsMeta: Ne,
      tabMeta: $e
    } = Ie();
    let Ue = 0, Ke;
    N ? (Ke = "top", $e && Ne && (Ue = $e.top - Ne.top + Ne.scrollTop)) : (Ke = i ? "right" : "left", $e && Ne && (Ue = (i ? -1 : 1) * ($e[Ke] - Ne[Ke] + Ne.scrollLeft)));
    const Me = {
      [Ke]: Ue,
      // May be wrong until the font is loaded.
      [U]: $e ? $e[U] : 0
    };
    if (typeof ce[Ke] != "number" || typeof ce[U] != "number")
      fe(Me);
    else {
      const We = Math.abs(ce[Ke] - Me[Ke]), at = Math.abs(ce[U] - Me[U]);
      (We >= 1 || at >= 1) && fe(Me);
    }
  }), V = (Ne, {
    animation: $e = !0
  } = {}) => {
    $e ? Sue(L, ee.current, Ne, {
      duration: o.transitions.duration.standard
    }) : ee.current[L] = Ne;
  }, se = (Ne) => {
    let $e = ee.current[L];
    N ? $e += Ne : $e += Ne * (i ? -1 : 1), V($e);
  }, we = () => {
    const Ne = ee.current[W];
    let $e = 0;
    const Ue = Array.from(be.current.children);
    for (let Ke = 0; Ke < Ue.length; Ke += 1) {
      const Me = Ue[Ke];
      if ($e + Me[W] > Ne) {
        Ke === 0 && ($e = Ne);
        break;
      }
      $e += Me[W];
    }
    return $e;
  }, J = () => {
    se(-1 * we());
  }, he = () => {
    se(we());
  }, Te = E.useCallback((Ne) => {
    Q({
      overflow: null,
      scrollbarWidth: Ne
    });
  }, []), xe = () => {
    const Ne = {};
    Ne.scrollbarSizeListener = M ? /* @__PURE__ */ F.jsx(Due, {
      onChange: Te,
      className: Ge(Y.scrollableX, Y.hideScrollbar)
    }) : null;
    const Ue = M && ($ === "auto" && (de || le) || $ === !0);
    return Ne.scrollButtonStart = Ue ? /* @__PURE__ */ F.jsx(x, {
      slots: {
        StartScrollButtonIcon: O.StartScrollButtonIcon
      },
      slotProps: {
        startScrollButtonIcon: X
      },
      orientation: b,
      direction: i ? "right" : "left",
      onClick: J,
      disabled: !de,
      ...k,
      className: Ge(Y.scrollButtons, k.className)
    }) : null, Ne.scrollButtonEnd = Ue ? /* @__PURE__ */ F.jsx(x, {
      slots: {
        EndScrollButtonIcon: O.EndScrollButtonIcon
      },
      slotProps: {
        endScrollButtonIcon: oe
      },
      orientation: b,
      direction: i ? "left" : "right",
      onClick: he,
      disabled: !le,
      ...k,
      className: Ge(Y.scrollButtons, k.className)
    }) : null, Ne;
  }, Ae = hr((Ne) => {
    const {
      tabsMeta: $e,
      tabMeta: Ue
    } = Ie();
    if (!(!Ue || !$e)) {
      if (Ue[z] < $e[z]) {
        const Ke = $e[L] + (Ue[z] - $e[z]);
        V(Ke, {
          animation: Ne
        });
      } else if (Ue[q] > $e[q]) {
        const Ke = $e[L] + (Ue[q] - $e[q]);
        V(Ke, {
          animation: Ne
        });
      }
    }
  }), Ce = hr(() => {
    M && $ !== !1 && Se(!G);
  });
  E.useEffect(() => {
    const Ne = Ep(() => {
      ee.current && je();
    });
    let $e;
    const Ue = (We) => {
      We.forEach((at) => {
        at.removedNodes.forEach((Je) => {
          $e == null || $e.unobserve(Je);
        }), at.addedNodes.forEach((Je) => {
          $e == null || $e.observe(Je);
        });
      }), Ne(), Ce();
    }, Ke = Oo(ee.current);
    Ke.addEventListener("resize", Ne);
    let Me;
    return typeof ResizeObserver < "u" && ($e = new ResizeObserver(Ne), Array.from(be.current.children).forEach((We) => {
      $e.observe(We);
    })), typeof MutationObserver < "u" && (Me = new MutationObserver(Ue), Me.observe(be.current, {
      childList: !0
    })), () => {
      Ne.clear(), Ke.removeEventListener("resize", Ne), Me == null || Me.disconnect(), $e == null || $e.disconnect();
    };
  }, [je, Ce]), E.useEffect(() => {
    const Ne = Array.from(be.current.children), $e = Ne.length;
    if (typeof IntersectionObserver < "u" && $e > 0 && M && $ !== !1) {
      const Ue = Ne[0], Ke = Ne[$e - 1], Me = {
        root: ee.current,
        threshold: 0.99
      }, We = (Qe) => {
        ne(!Qe[0].isIntersecting);
      }, at = new IntersectionObserver(We, Me);
      at.observe(Ue);
      const Je = (Qe) => {
        ve(!Qe[0].isIntersecting);
      }, ke = new IntersectionObserver(Je, Me);
      return ke.observe(Ke), () => {
        at.disconnect(), ke.disconnect();
      };
    }
  }, [M, $, G, d == null ? void 0 : d.length]), E.useEffect(() => {
    Z(!0);
  }, []), E.useEffect(() => {
    je();
  }), E.useEffect(() => {
    Ae(NA !== ce);
  }, [Ae, ce]), E.useImperativeHandle(l, () => ({
    updateIndicator: je,
    updateScrollButtons: Ce
  }), [je, Ce]);
  const Ye = /* @__PURE__ */ F.jsx(Nue, {
    ...T,
    className: Ge(Y.indicator, T.className),
    ownerState: K,
    style: {
      ...ce,
      ...T.style
    }
  });
  let He = 0;
  const Be = E.Children.map(d, (Ne) => {
    if (!/* @__PURE__ */ E.isValidElement(Ne))
      return null;
    process.env.NODE_ENV !== "production" && sv.isFragment(Ne) && console.error(["MUI: The Tabs component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    const $e = Ne.props.value === void 0 ? He : Ne.props.value;
    ie.set($e, He);
    const Ue = $e === P;
    return He += 1, /* @__PURE__ */ E.cloneElement(Ne, {
      fullWidth: _ === "fullWidth",
      indicator: Ue && !re && Ye,
      selected: Ue,
      selectionFollowsFocus: S,
      onChange: g,
      textColor: I,
      value: $e,
      ...He === 1 && P === !1 && !Ne.props.tabIndex ? {
        tabIndex: 0
      } : {}
    });
  }), Xe = (Ne) => {
    const $e = be.current, Ue = Un($e).activeElement;
    if (Ue.getAttribute("role") !== "tab")
      return;
    let Me = b === "horizontal" ? "ArrowLeft" : "ArrowUp", We = b === "horizontal" ? "ArrowRight" : "ArrowDown";
    switch (b === "horizontal" && i && (Me = "ArrowRight", We = "ArrowLeft"), Ne.key) {
      case Me:
        Ne.preventDefault(), im($e, Ue, MA);
        break;
      case We:
        Ne.preventDefault(), im($e, Ue, IA);
        break;
      case "Home":
        Ne.preventDefault(), im($e, null, IA);
        break;
      case "End":
        Ne.preventDefault(), im($e, null, MA);
        break;
    }
  }, Ze = xe();
  return /* @__PURE__ */ F.jsxs(Aue, {
    className: Ge(Y.root, f),
    ownerState: K,
    ref: n,
    as: h,
    ...D,
    children: [Ze.scrollButtonStart, Ze.scrollbarSizeListener, /* @__PURE__ */ F.jsxs(Iue, {
      className: Y.scroller,
      ownerState: K,
      style: {
        overflow: ue.overflow,
        [N ? `margin${i ? "Left" : "Right"}` : "marginBottom"]: A ? void 0 : -ue.scrollbarWidth
      },
      ref: ee,
      children: [/* @__PURE__ */ F.jsx(Mue, {
        "aria-label": a,
        "aria-labelledby": c,
        "aria-orientation": b === "vertical" ? "vertical" : null,
        className: Y.flexContainer,
        ownerState: K,
        onKeyDown: Xe,
        ref: be,
        role: "tablist",
        children: Be
      }), re && Ye]
    }), Ze.scrollButtonEnd]
  });
});
process.env.NODE_ENV !== "production" && (Lue.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: jr,
  /**
   * If `true`, the scroll buttons aren't forced hidden on mobile.
   * By default the scroll buttons are hidden on mobile and takes precedence over `scrollButtons`.
   * @default false
   */
  allowScrollButtonsMobile: s.bool,
  /**
   * The label for the Tabs as a string.
   */
  "aria-label": s.string,
  /**
   * An id or list of ids separated by a space that label the Tabs.
   */
  "aria-labelledby": s.string,
  /**
   * If `true`, the tabs are centered.
   * This prop is intended for large views.
   * @default false
   */
  centered: s.bool,
  /**
   * The content of the component.
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: s.elementType,
  /**
   * Determines the color of the indicator.
   * @default 'primary'
   */
  indicatorColor: s.oneOfType([s.oneOf(["primary", "secondary"]), s.string]),
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {any} value We default to the index of the child (number)
   */
  onChange: s.func,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: s.oneOf(["horizontal", "vertical"]),
  /**
   * The component used to render the scroll buttons.
   * @default TabScrollButton
   */
  ScrollButtonComponent: s.elementType,
  /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `true` will always present them.
   * - `false` will never present them.
   *
   * By default the scroll buttons are hidden on mobile.
   * This behavior can be disabled with `allowScrollButtonsMobile`.
   * @default 'auto'
   */
  scrollButtons: s.oneOf(["auto", !1, !0]),
  /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */
  selectionFollowsFocus: s.bool,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: s.shape({
    endScrollButtonIcon: s.oneOfType([s.func, s.object]),
    startScrollButtonIcon: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    EndScrollButtonIcon: s.elementType,
    StartScrollButtonIcon: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Props applied to the tab indicator element.
   * @default  {}
   */
  TabIndicatorProps: s.object,
  /**
   * Props applied to the [`TabScrollButton`](https://mui.com/material-ui/api/tab-scroll-button/) element.
   * @default {}
   */
  TabScrollButtonProps: s.object,
  /**
   * Determines the color of the `Tab`.
   * @default 'primary'
   */
  textColor: s.oneOf(["inherit", "primary", "secondary"]),
  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this prop to `false`.
   */
  value: s.any,
  /**
   * Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  - `fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   * @default 'standard'
   */
  variant: s.oneOf(["fullWidth", "scrollable", "standard"]),
  /**
   * If `true`, the scrollbar is visible. It can be useful when displaying
   * a long vertical list of tabs.
   * @default false
   */
  visibleScrollbar: s.bool
});
function jue(e) {
  return mt("MuiTextField", e);
}
gt("MuiTextField", ["root"]);
const Fue = {
  standard: Hf,
  filled: Wf,
  outlined: Yf
}, zue = (e) => {
  const {
    classes: t
  } = e;
  return wt({
    root: ["root"]
  }, jue, t);
}, Bue = Pe(XL, {
  name: "MuiTextField",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), que = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = $t({
    props: t,
    name: "MuiTextField"
  }), {
    autoComplete: o,
    autoFocus: i = !1,
    children: a,
    className: c,
    color: l = "primary",
    defaultValue: u,
    disabled: d = !1,
    error: f = !1,
    FormHelperTextProps: h,
    fullWidth: v = !1,
    helperText: y,
    id: g,
    InputLabelProps: b,
    inputProps: x,
    InputProps: $,
    inputRef: S,
    label: O,
    maxRows: C,
    minRows: T,
    multiline: k = !1,
    name: I,
    onBlur: P,
    onChange: _,
    onFocus: A,
    placeholder: D,
    required: M = !1,
    rows: N,
    select: L = !1,
    SelectProps: z,
    slots: q = {},
    slotProps: W = {},
    type: U,
    value: K,
    variant: Y = "outlined",
    ...X
  } = r, oe = {
    ...r,
    autoFocus: i,
    color: l,
    disabled: d,
    error: f,
    fullWidth: v,
    multiline: k,
    required: M,
    select: L,
    variant: Y
  }, re = zue(oe);
  process.env.NODE_ENV !== "production" && L && !a && console.error("MUI: `children` must be passed when using the `TextField` component with `select`.");
  const Z = sT(g), ce = y && Z ? `${Z}-helper-text` : void 0, fe = O && Z ? `${Z}-label` : void 0, de = Fue[Y], ne = {
    slots: q,
    slotProps: {
      input: $,
      inputLabel: b,
      htmlInput: x,
      formHelperText: h,
      select: z,
      ...W
    }
  }, le = {}, ve = ne.slotProps.inputLabel;
  Y === "outlined" && (ve && typeof ve.shrink < "u" && (le.notched = ve.shrink), le.label = O), L && ((!z || !z.native) && (le.id = void 0), le["aria-describedby"] = void 0);
  const [G, Se] = Mr("input", {
    elementType: de,
    externalForwardedProps: ne,
    additionalProps: le,
    ownerState: oe
  }), [ue, Q] = Mr("inputLabel", {
    elementType: ej,
    externalForwardedProps: ne,
    ownerState: oe
  }), [ie, ee] = Mr("htmlInput", {
    elementType: "input",
    externalForwardedProps: ne,
    ownerState: oe
  }), [be, Ie] = Mr("formHelperText", {
    elementType: ZL,
    externalForwardedProps: ne,
    ownerState: oe
  }), [je, V] = Mr("select", {
    elementType: IT,
    externalForwardedProps: ne,
    ownerState: oe
  }), se = /* @__PURE__ */ F.jsx(G, {
    "aria-describedby": ce,
    autoComplete: o,
    autoFocus: i,
    defaultValue: u,
    fullWidth: v,
    multiline: k,
    name: I,
    rows: N,
    maxRows: C,
    minRows: T,
    type: U,
    value: K,
    id: Z,
    inputRef: S,
    onBlur: P,
    onChange: _,
    onFocus: A,
    placeholder: D,
    inputProps: ee,
    slots: {
      input: q.htmlInput ? ie : void 0
    },
    ...Se
  });
  return /* @__PURE__ */ F.jsxs(Bue, {
    className: Ge(re.root, c),
    disabled: d,
    error: f,
    fullWidth: v,
    ref: n,
    required: M,
    color: l,
    variant: Y,
    ownerState: oe,
    ...X,
    children: [O != null && O !== "" && /* @__PURE__ */ F.jsx(ue, {
      htmlFor: Z,
      id: fe,
      ...Q,
      children: O
    }), L ? /* @__PURE__ */ F.jsx(je, {
      "aria-describedby": ce,
      id: Z,
      labelId: fe,
      value: K,
      input: se,
      ...V,
      children: a
    }) : se, y && /* @__PURE__ */ F.jsx(be, {
      id: ce,
      ...Ie,
      children: y
    })]
  });
});
process.env.NODE_ENV !== "production" && (que.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: s.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: s.bool,
  /**
   * @ignore
   */
  children: s.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * @ignore
   */
  className: s.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: s.oneOfType([s.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), s.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: s.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: s.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: s.bool,
  /**
   * Props applied to the [`FormHelperText`](https://mui.com/material-ui/api/form-helper-text/) element.
   * @deprecated Use `slotProps.formHelperText` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  FormHelperTextProps: s.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: s.bool,
  /**
   * The helper text content.
   */
  helperText: s.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: s.string,
  /**
   * Props applied to the [`InputLabel`](https://mui.com/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   * @deprecated Use `slotProps.inputLabel` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputLabelProps: s.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @deprecated Use `slotProps.htmlInput` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: s.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](https://mui.com/material-ui/api/filled-input/),
   * [`OutlinedInput`](https://mui.com/material-ui/api/outlined-input/) or [`Input`](https://mui.com/material-ui/api/input/)
   * component depending on the `variant` prop value.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputProps: s.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: jr,
  /**
   * The label content.
   */
  label: s.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: s.oneOf(["dense", "none", "normal"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: s.oneOfType([s.number, s.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: s.oneOfType([s.number, s.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: s.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: s.string,
  /**
   * @ignore
   */
  onBlur: s.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: s.func,
  /**
   * @ignore
   */
  onFocus: s.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: s.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: s.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: s.oneOfType([s.number, s.string]),
  /**
   * Render a [`Select`](https://mui.com/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: s.bool,
  /**
   * Props applied to the [`Select`](https://mui.com/material-ui/api/select/) element.
   * @deprecated Use `slotProps.select` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  SelectProps: s.object,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: s.oneOfType([s.oneOf(["medium", "small"]), s.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: s.shape({
    formHelperText: s.oneOfType([s.func, s.object]),
    htmlInput: s.oneOfType([s.func, s.object]),
    input: s.oneOfType([s.func, s.object]),
    inputLabel: s.oneOfType([s.func, s.object]),
    select: s.oneOfType([s.func, s.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: s.shape({
    formHelperText: s.elementType,
    htmlInput: s.elementType,
    input: s.elementType,
    inputLabel: s.elementType,
    select: s.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: s.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: s.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: s.oneOf(["filled", "outlined", "standard"])
});
function Fs(e) {
  function t(n, r) {
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.message = n, this.code = r;
  }
  return t.prototype = new Error(), t.prototype.name = e, t.prototype.constructor = t, t;
}
const Uue = Fs("LaunchDarklyUnexpectedResponseError"), Wue = Fs("LaunchDarklyInvalidEnvironmentIdError"), Hue = Fs("LaunchDarklyInvalidUserError"), Vue = Fs("LaunchDarklyInvalidEventKeyError"), Yue = Fs("LaunchDarklyInvalidArgumentError"), Gue = Fs("LaunchDarklyFlagFetchError");
for (var Mn = { LDUnexpectedResponseError: Uue, LDInvalidEnvironmentIdError: Wue, LDInvalidUserError: Hue, LDInvalidEventKeyError: Vue, LDInvalidArgumentError: Yue, LDInvalidDataError: Fs("LaunchDarklyInvalidDataError"), LDFlagFetchError: Gue, LDTimeoutError: Fs("LaunchDarklyTimeoutError"), isHttpErrorRecoverable: function(e) {
  return !(e >= 400 && e < 500) || e === 400 || e === 408 || e === 429;
} }, Kue = function(e) {
  var t = jA(e), n = t[0], r = t[1];
  return 3 * (n + r) / 4 - r;
}, Xue = function(e) {
  var t, n, r = jA(e), o = r[0], i = r[1], a = new Jue(function(u, d, f) {
    return 3 * (d + f) / 4 - f;
  }(0, o, i)), c = 0, l = i > 0 ? o - 4 : o;
  for (n = 0; n < l; n += 4) t = Bo[e.charCodeAt(n)] << 18 | Bo[e.charCodeAt(n + 1)] << 12 | Bo[e.charCodeAt(n + 2)] << 6 | Bo[e.charCodeAt(n + 3)], a[c++] = t >> 16 & 255, a[c++] = t >> 8 & 255, a[c++] = 255 & t;
  return i === 2 && (t = Bo[e.charCodeAt(n)] << 2 | Bo[e.charCodeAt(n + 1)] >> 4, a[c++] = 255 & t), i === 1 && (t = Bo[e.charCodeAt(n)] << 10 | Bo[e.charCodeAt(n + 1)] << 4 | Bo[e.charCodeAt(n + 2)] >> 2, a[c++] = t >> 8 & 255, a[c++] = 255 & t), a;
}, Zue = function(e) {
  for (var t, n = e.length, r = n % 3, o = [], i = 16383, a = 0, c = n - r; a < c; a += i) o.push(Que(e, a, a + i > c ? c : a + i));
  return r === 1 ? (t = e[n - 1], o.push(Ui[t >> 2] + Ui[t << 4 & 63] + "==")) : r === 2 && (t = (e[n - 2] << 8) + e[n - 1], o.push(Ui[t >> 10] + Ui[t >> 4 & 63] + Ui[t << 2 & 63] + "=")), o.join("");
}, Ui = [], Bo = [], Jue = typeof Uint8Array < "u" ? Uint8Array : Array, LA = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", zl = 0; zl < 64; ++zl) Ui[zl] = LA[zl], Bo[LA.charCodeAt(zl)] = zl;
function jA(e) {
  var t = e.length;
  if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
  var n = e.indexOf("=");
  return n === -1 && (n = t), [n, n === t ? 0 : 4 - n % 4];
}
function Que(e, t, n) {
  for (var r, o, i = [], a = t; a < n; a += 3) r = (e[a] << 16 & 16711680) + (e[a + 1] << 8 & 65280) + (255 & e[a + 2]), i.push(Ui[(o = r) >> 18 & 63] + Ui[o >> 12 & 63] + Ui[o >> 6 & 63] + Ui[63 & o]);
  return i.join("");
}
Bo[45] = 62, Bo[95] = 63;
var ede = { byteLength: Kue, toByteArray: Xue, fromByteArray: Zue }, FA = Array.isArray, zA = Object.keys, tde = Object.prototype.hasOwnProperty, nde = function e(t, n) {
  if (t === n) return !0;
  if (t && n && typeof t == "object" && typeof n == "object") {
    var r, o, i, a = FA(t), c = FA(n);
    if (a && c) {
      if ((o = t.length) != n.length) return !1;
      for (r = o; r-- != 0; ) if (!e(t[r], n[r])) return !1;
      return !0;
    }
    if (a != c) return !1;
    var l = t instanceof Date, u = n instanceof Date;
    if (l != u) return !1;
    if (l && u) return t.getTime() == n.getTime();
    var d = t instanceof RegExp, f = n instanceof RegExp;
    if (d != f) return !1;
    if (d && f) return t.toString() == n.toString();
    var h = zA(t);
    if ((o = h.length) !== zA(n).length) return !1;
    for (r = o; r-- != 0; ) if (!tde.call(n, h[r])) return !1;
    for (r = o; r-- != 0; ) if (!e(t[i = h[r]], n[i])) return !1;
    return !0;
  }
  return t != t && n != n;
};
const rde = ["key", "ip", "country", "email", "firstName", "lastName", "avatar", "name"];
function BA(e) {
  const t = unescape(encodeURIComponent(e));
  return ede.fromByteArray(function(n) {
    const r = [];
    for (let o = 0; o < n.length; o++) r.push(n.charCodeAt(o));
    return r;
  }(t));
}
function l1(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
var u1, St = { appendUrlPath: function(e, t) {
  return (e.endsWith("/") ? e.substring(0, e.length - 1) : e) + (t.startsWith("/") ? "" : "/") + t;
}, base64URLEncode: function(e) {
  return BA(e).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}, btoa: BA, clone: function(e) {
  return JSON.parse(JSON.stringify(e));
}, deepEquals: function(e, t) {
  return nde(e, t);
}, extend: function(...e) {
  return e.reduce((t, n) => ({ ...t, ...n }), {});
}, getLDUserAgentString: function(e) {
  const t = e.version || "?";
  return e.userAgent + "/" + t;
}, objectHasOwnProperty: l1, onNextTick: function(e) {
  setTimeout(e, 0);
}, sanitizeContext: function(e) {
  if (!e) return e;
  let t;
  return e.kind !== null && e.kind !== void 0 || rde.forEach((n) => {
    const r = e[n];
    r !== void 0 && typeof r != "string" && (t = t || { ...e }, t[n] = String(r));
  }), t || e;
}, transformValuesToVersionedValues: function(e) {
  const t = {};
  for (const n in e) l1(e, n) && (t[n] = { value: e[n], version: 0 });
  return t;
}, transformVersionedValuesToValues: function(e) {
  const t = {};
  for (const n in e) l1(e, n) && (t[n] = e[n].value);
  return t;
}, wrapPromiseCallback: function(e, t) {
  const n = e.then((r) => (t && setTimeout(() => {
    t(null, r);
  }, 0), r), (r) => {
    if (!t) return Promise.reject(r);
    setTimeout(() => {
      t(r, null);
    }, 0);
  });
  return t ? void 0 : n;
} }, ode = new Uint8Array(16);
function qA() {
  if (!u1 && !(u1 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return u1(ode);
}
var ide = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function Bg(e) {
  return typeof e == "string" && ide.test(e);
}
for (var UA, d1, ur = [], f1 = 0; f1 < 256; ++f1) ur.push((f1 + 256).toString(16).substr(1));
function ng(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = (ur[e[t + 0]] + ur[e[t + 1]] + ur[e[t + 2]] + ur[e[t + 3]] + "-" + ur[e[t + 4]] + ur[e[t + 5]] + "-" + ur[e[t + 6]] + ur[e[t + 7]] + "-" + ur[e[t + 8]] + ur[e[t + 9]] + "-" + ur[e[t + 10]] + ur[e[t + 11]] + ur[e[t + 12]] + ur[e[t + 13]] + ur[e[t + 14]] + ur[e[t + 15]]).toLowerCase();
  if (!Bg(n)) throw TypeError("Stringified UUID is invalid");
  return n;
}
var p1 = 0, h1 = 0;
function yj(e) {
  if (!Bg(e)) throw TypeError("Invalid UUID");
  var t, n = new Uint8Array(16);
  return n[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, n[1] = t >>> 16 & 255, n[2] = t >>> 8 & 255, n[3] = 255 & t, n[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, n[5] = 255 & t, n[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, n[7] = 255 & t, n[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, n[9] = 255 & t, n[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, n[11] = t / 4294967296 & 255, n[12] = t >>> 24 & 255, n[13] = t >>> 16 & 255, n[14] = t >>> 8 & 255, n[15] = 255 & t, n;
}
function bj(e, t, n) {
  function r(o, i, a, c) {
    if (typeof o == "string" && (o = function(d) {
      d = unescape(encodeURIComponent(d));
      for (var f = [], h = 0; h < d.length; ++h) f.push(d.charCodeAt(h));
      return f;
    }(o)), typeof i == "string" && (i = yj(i)), i.length !== 16) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var l = new Uint8Array(16 + o.length);
    if (l.set(i), l.set(o, i.length), (l = n(l))[6] = 15 & l[6] | t, l[8] = 63 & l[8] | 128, a) {
      c = c || 0;
      for (var u = 0; u < 16; ++u) a[c + u] = l[u];
      return a;
    }
    return ng(l);
  }
  try {
    r.name = e;
  } catch {
  }
  return r.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", r.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8", r;
}
function WA(e) {
  return 14 + (e + 64 >>> 9 << 4) + 1;
}
function Ss(e, t) {
  var n = (65535 & e) + (65535 & t);
  return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
}
function vv(e, t, n, r, o, i) {
  return Ss((a = Ss(Ss(t, e), Ss(r, i))) << (c = o) | a >>> 32 - c, n);
  var a, c;
}
function $r(e, t, n, r, o, i, a) {
  return vv(t & n | ~t & r, e, t, o, i, a);
}
function Or(e, t, n, r, o, i, a) {
  return vv(t & r | n & ~r, e, t, o, i, a);
}
function Sr(e, t, n, r, o, i, a) {
  return vv(t ^ n ^ r, e, t, o, i, a);
}
function Cr(e, t, n, r, o, i, a) {
  return vv(n ^ (t | ~r), e, t, o, i, a);
}
var ade = bj("v3", 48, function(e) {
  if (typeof e == "string") {
    var t = unescape(encodeURIComponent(e));
    e = new Uint8Array(t.length);
    for (var n = 0; n < t.length; ++n) e[n] = t.charCodeAt(n);
  }
  return function(r) {
    for (var o = [], i = 32 * r.length, a = "0123456789abcdef", c = 0; c < i; c += 8) {
      var l = r[c >> 5] >>> c % 32 & 255, u = parseInt(a.charAt(l >>> 4 & 15) + a.charAt(15 & l), 16);
      o.push(u);
    }
    return o;
  }(function(r, o) {
    r[o >> 5] |= 128 << o % 32, r[WA(o) - 1] = o;
    for (var i = 1732584193, a = -271733879, c = -1732584194, l = 271733878, u = 0; u < r.length; u += 16) {
      var d = i, f = a, h = c, v = l;
      i = $r(i, a, c, l, r[u], 7, -680876936), l = $r(l, i, a, c, r[u + 1], 12, -389564586), c = $r(c, l, i, a, r[u + 2], 17, 606105819), a = $r(a, c, l, i, r[u + 3], 22, -1044525330), i = $r(i, a, c, l, r[u + 4], 7, -176418897), l = $r(l, i, a, c, r[u + 5], 12, 1200080426), c = $r(c, l, i, a, r[u + 6], 17, -1473231341), a = $r(a, c, l, i, r[u + 7], 22, -45705983), i = $r(i, a, c, l, r[u + 8], 7, 1770035416), l = $r(l, i, a, c, r[u + 9], 12, -1958414417), c = $r(c, l, i, a, r[u + 10], 17, -42063), a = $r(a, c, l, i, r[u + 11], 22, -1990404162), i = $r(i, a, c, l, r[u + 12], 7, 1804603682), l = $r(l, i, a, c, r[u + 13], 12, -40341101), c = $r(c, l, i, a, r[u + 14], 17, -1502002290), i = Or(i, a = $r(a, c, l, i, r[u + 15], 22, 1236535329), c, l, r[u + 1], 5, -165796510), l = Or(l, i, a, c, r[u + 6], 9, -1069501632), c = Or(c, l, i, a, r[u + 11], 14, 643717713), a = Or(a, c, l, i, r[u], 20, -373897302), i = Or(i, a, c, l, r[u + 5], 5, -701558691), l = Or(l, i, a, c, r[u + 10], 9, 38016083), c = Or(c, l, i, a, r[u + 15], 14, -660478335), a = Or(a, c, l, i, r[u + 4], 20, -405537848), i = Or(i, a, c, l, r[u + 9], 5, 568446438), l = Or(l, i, a, c, r[u + 14], 9, -1019803690), c = Or(c, l, i, a, r[u + 3], 14, -187363961), a = Or(a, c, l, i, r[u + 8], 20, 1163531501), i = Or(i, a, c, l, r[u + 13], 5, -1444681467), l = Or(l, i, a, c, r[u + 2], 9, -51403784), c = Or(c, l, i, a, r[u + 7], 14, 1735328473), i = Sr(i, a = Or(a, c, l, i, r[u + 12], 20, -1926607734), c, l, r[u + 5], 4, -378558), l = Sr(l, i, a, c, r[u + 8], 11, -2022574463), c = Sr(c, l, i, a, r[u + 11], 16, 1839030562), a = Sr(a, c, l, i, r[u + 14], 23, -35309556), i = Sr(i, a, c, l, r[u + 1], 4, -1530992060), l = Sr(l, i, a, c, r[u + 4], 11, 1272893353), c = Sr(c, l, i, a, r[u + 7], 16, -155497632), a = Sr(a, c, l, i, r[u + 10], 23, -1094730640), i = Sr(i, a, c, l, r[u + 13], 4, 681279174), l = Sr(l, i, a, c, r[u], 11, -358537222), c = Sr(c, l, i, a, r[u + 3], 16, -722521979), a = Sr(a, c, l, i, r[u + 6], 23, 76029189), i = Sr(i, a, c, l, r[u + 9], 4, -640364487), l = Sr(l, i, a, c, r[u + 12], 11, -421815835), c = Sr(c, l, i, a, r[u + 15], 16, 530742520), i = Cr(i, a = Sr(a, c, l, i, r[u + 2], 23, -995338651), c, l, r[u], 6, -198630844), l = Cr(l, i, a, c, r[u + 7], 10, 1126891415), c = Cr(c, l, i, a, r[u + 14], 15, -1416354905), a = Cr(a, c, l, i, r[u + 5], 21, -57434055), i = Cr(i, a, c, l, r[u + 12], 6, 1700485571), l = Cr(l, i, a, c, r[u + 3], 10, -1894986606), c = Cr(c, l, i, a, r[u + 10], 15, -1051523), a = Cr(a, c, l, i, r[u + 1], 21, -2054922799), i = Cr(i, a, c, l, r[u + 8], 6, 1873313359), l = Cr(l, i, a, c, r[u + 15], 10, -30611744), c = Cr(c, l, i, a, r[u + 6], 15, -1560198380), a = Cr(a, c, l, i, r[u + 13], 21, 1309151649), i = Cr(i, a, c, l, r[u + 4], 6, -145523070), l = Cr(l, i, a, c, r[u + 11], 10, -1120210379), c = Cr(c, l, i, a, r[u + 2], 15, 718787259), a = Cr(a, c, l, i, r[u + 9], 21, -343485551), i = Ss(i, d), a = Ss(a, f), c = Ss(c, h), l = Ss(l, v);
    }
    return [i, a, c, l];
  }(function(r) {
    if (r.length === 0) return [];
    for (var o = 8 * r.length, i = new Uint32Array(WA(o)), a = 0; a < o; a += 8) i[a >> 5] |= (255 & r[a / 8]) << a % 32;
    return i;
  }(e), 8 * e.length));
}), sde = ade;
function cde(e, t, n, r) {
  switch (e) {
    case 0:
      return t & n ^ ~t & r;
    case 1:
    case 3:
      return t ^ n ^ r;
    case 2:
      return t & n ^ t & r ^ n & r;
  }
}
function m1(e, t) {
  return e << t | e >>> 32 - t;
}
var lde = bj("v5", 80, function(e) {
  var t = [1518500249, 1859775393, 2400959708, 3395469782], n = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof e == "string") {
    var r = unescape(encodeURIComponent(e));
    e = [];
    for (var o = 0; o < r.length; ++o) e.push(r.charCodeAt(o));
  } else Array.isArray(e) || (e = Array.prototype.slice.call(e));
  e.push(128);
  for (var i = e.length / 4 + 2, a = Math.ceil(i / 16), c = new Array(a), l = 0; l < a; ++l) {
    for (var u = new Uint32Array(16), d = 0; d < 16; ++d) u[d] = e[64 * l + 4 * d] << 24 | e[64 * l + 4 * d + 1] << 16 | e[64 * l + 4 * d + 2] << 8 | e[64 * l + 4 * d + 3];
    c[l] = u;
  }
  c[a - 1][14] = 8 * (e.length - 1) / Math.pow(2, 32), c[a - 1][14] = Math.floor(c[a - 1][14]), c[a - 1][15] = 8 * (e.length - 1) & 4294967295;
  for (var f = 0; f < a; ++f) {
    for (var h = new Uint32Array(80), v = 0; v < 16; ++v) h[v] = c[f][v];
    for (var y = 16; y < 80; ++y) h[y] = m1(h[y - 3] ^ h[y - 8] ^ h[y - 14] ^ h[y - 16], 1);
    for (var g = n[0], b = n[1], x = n[2], $ = n[3], S = n[4], O = 0; O < 80; ++O) {
      var C = Math.floor(O / 20), T = m1(g, 5) + cde(C, b, x, $) + S + t[C] + h[O] >>> 0;
      S = $, $ = x, x = m1(b, 30) >>> 0, b = g, g = T;
    }
    n[0] = n[0] + g >>> 0, n[1] = n[1] + b >>> 0, n[2] = n[2] + x >>> 0, n[3] = n[3] + $ >>> 0, n[4] = n[4] + S >>> 0;
  }
  return [n[0] >> 24 & 255, n[0] >> 16 & 255, n[0] >> 8 & 255, 255 & n[0], n[1] >> 24 & 255, n[1] >> 16 & 255, n[1] >> 8 & 255, 255 & n[1], n[2] >> 24 & 255, n[2] >> 16 & 255, n[2] >> 8 & 255, 255 & n[2], n[3] >> 24 & 255, n[3] >> 16 & 255, n[3] >> 8 & 255, 255 & n[3], n[4] >> 24 & 255, n[4] >> 16 & 255, n[4] >> 8 & 255, 255 & n[4]];
}), ude = lde, MT = Object.freeze({ __proto__: null, v1: function(e, t, n) {
  var r = t && n || 0, o = t || new Array(16), i = (e = e || {}).node || UA, a = e.clockseq !== void 0 ? e.clockseq : d1;
  if (i == null || a == null) {
    var c = e.random || (e.rng || qA)();
    i == null && (i = UA = [1 | c[0], c[1], c[2], c[3], c[4], c[5]]), a == null && (a = d1 = 16383 & (c[6] << 8 | c[7]));
  }
  var l = e.msecs !== void 0 ? e.msecs : Date.now(), u = e.nsecs !== void 0 ? e.nsecs : h1 + 1, d = l - p1 + (u - h1) / 1e4;
  if (d < 0 && e.clockseq === void 0 && (a = a + 1 & 16383), (d < 0 || l > p1) && e.nsecs === void 0 && (u = 0), u >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  p1 = l, h1 = u, d1 = a;
  var f = (1e4 * (268435455 & (l += 122192928e5)) + u) % 4294967296;
  o[r++] = f >>> 24 & 255, o[r++] = f >>> 16 & 255, o[r++] = f >>> 8 & 255, o[r++] = 255 & f;
  var h = l / 4294967296 * 1e4 & 268435455;
  o[r++] = h >>> 8 & 255, o[r++] = 255 & h, o[r++] = h >>> 24 & 15 | 16, o[r++] = h >>> 16 & 255, o[r++] = a >>> 8 | 128, o[r++] = 255 & a;
  for (var v = 0; v < 6; ++v) o[r + v] = i[v];
  return t || ng(o);
}, v3: sde, v4: function(e, t, n) {
  var r = (e = e || {}).random || (e.rng || qA)();
  if (r[6] = 15 & r[6] | 64, r[8] = 63 & r[8] | 128, t) {
    n = n || 0;
    for (var o = 0; o < 16; ++o) t[n + o] = r[o];
    return t;
  }
  return ng(r);
}, v5: ude, NIL: "00000000-0000-0000-0000-000000000000", version: function(e) {
  if (!Bg(e)) throw TypeError("Invalid UUID");
  return parseInt(e.substr(14, 1), 16);
}, validate: Bg, stringify: ng, parse: yj });
const jd = ["debug", "info", "warn", "error", "none"];
var NT = { commonBasicLogger: function(e, t) {
  if (e && e.destination && typeof e.destination != "function") throw new Error("destination for basicLogger was set to a non-function");
  function n(u) {
    return function(d) {
      console && console[u] && console[u].call(console, d);
    };
  }
  const r = e && e.destination ? [e.destination, e.destination, e.destination, e.destination] : [n("log"), n("info"), n("warn"), n("error")], o = !(!e || !e.destination), i = e && e.prefix !== void 0 && e.prefix !== null ? e.prefix : "[LaunchDarkly] ";
  let a = 1;
  if (e && e.level) for (let u = 0; u < jd.length; u++) jd[u] === e.level && (a = u);
  function c(u, d, f) {
    if (f.length < 1) return;
    let h;
    const v = o ? d + ": " + i : i;
    if (f.length !== 1 && t) {
      const y = [...f];
      y[0] = v + y[0], h = t(...y);
    } else h = v + f[0];
    try {
      r[u](h);
    } catch (y) {
      console && console.log && console.log("[LaunchDarkly] Configured logger's " + d + " method threw an exception: " + y);
    }
  }
  const l = {};
  for (let u = 0; u < jd.length; u++) {
    const d = jd[u];
    if (d !== "none") if (u < a) l[d] = () => {
    };
    else {
      const f = u;
      l[d] = function() {
        c(f, d, arguments);
      };
    }
  }
  return l;
}, validateLogger: function(e) {
  jd.forEach((t) => {
    if (t !== "none" && (!e[t] || typeof e[t] != "function")) throw new Error("Provided logger instance must support logger." + t + "(...) method");
  });
} };
function am(e) {
  return e && e.message ? e.message : typeof e == "string" || e instanceof String ? e : JSON.stringify(e);
}
const Bl = " Please see https://docs.launchdarkly.com/sdk/client-side/javascript#initialize-the-client for instructions on SDK initialization.";
var pt = { bootstrapInvalid: function() {
  return "LaunchDarkly bootstrap data is not available because the back end could not read the flags.";
}, bootstrapOldFormat: function() {
  return "LaunchDarkly client was initialized with bootstrap data that did not include flag metadata. Events may not be sent correctly." + Bl;
}, clientInitialized: function() {
  return "LaunchDarkly client initialized";
}, clientNotReady: function() {
  return "LaunchDarkly client is not ready";
}, debugEnqueueingEvent: function(e) {
  return 'enqueueing "' + e + '" event';
}, debugPostingDiagnosticEvent: function(e) {
  return "sending diagnostic event (" + e.kind + ")";
}, debugPostingEvents: function(e) {
  return "sending " + e + " events";
}, debugStreamDelete: function(e) {
  return 'received streaming deletion for flag "' + e + '"';
}, debugStreamDeleteIgnored: function(e) {
  return 'received streaming deletion for flag "' + e + '" but ignored due to version check';
}, debugStreamPatch: function(e) {
  return 'received streaming update for flag "' + e + '"';
}, debugStreamPatchIgnored: function(e) {
  return 'received streaming update for flag "' + e + '" but ignored due to version check';
}, debugStreamPing: function() {
  return "received ping message from stream";
}, debugPolling: function(e) {
  return "polling for feature flags at " + e;
}, debugStreamPut: function() {
  return "received streaming update for all flags";
}, deprecated: function(e, t) {
  return t ? '"' + e + '" is deprecated, please use "' + t + '"' : '"' + e + '" is deprecated';
}, environmentNotFound: function() {
  return "Environment not found. Double check that you specified a valid environment/client-side ID." + Bl;
}, environmentNotSpecified: function() {
  return "No environment/client-side ID was specified." + Bl;
}, errorFetchingFlags: function(e) {
  return "Error fetching flag settings: " + am(e);
}, eventCapacityExceeded: function() {
  return "Exceeded event queue capacity. Increase capacity to avoid dropping events.";
}, eventWithoutContext: function() {
  return "Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/sdk/features/identify#javascript";
}, httpErrorMessage: function(e, t, n) {
  return "Received error " + e + (e === 401 ? " (invalid SDK key)" : "") + " for " + t + " - " + (Mn.isHttpErrorRecoverable(e) ? n : "giving up permanently");
}, httpUnavailable: function() {
  return "Cannot make HTTP requests in this environment." + Bl;
}, identifyDisabled: function() {
  return "identify() has no effect here; it must be called on the main client instance";
}, inspectorMethodError: (e, t) => `an inspector: "${t}" of type: "${e}" generated an exception`, invalidContentType: function(e) {
  return 'Expected application/json content type but got "' + e + '"';
}, invalidData: function() {
  return "Invalid data received from LaunchDarkly; connection may have been interrupted";
}, invalidInspector: (e, t) => `an inspector: "${t}" of an invalid type (${e}) was configured`, invalidKey: function() {
  return "Event key must be a string";
}, invalidMetricValue: (e) => `The track function was called with a non-numeric "metricValue" (${e}), only numeric metric values are supported.`, invalidContext: function() {
  return "Invalid context specified." + Bl;
}, invalidTagValue: (e) => `Config option "${e}" must only contain letters, numbers, ., _ or -.`, localStorageUnavailable: function(e) {
  return "local storage is unavailable: " + am(e);
}, networkError: (e) => "network error" + (e ? " (" + e + ")" : ""), optionBelowMinimum: (e, t, n) => 'Config option "' + e + '" was set to ' + t + ", changing to minimum value of " + n, streamClosing: function() {
  return "Closing stream connection";
}, streamConnecting: function(e) {
  return "Opening stream connection to " + e;
}, streamError: function(e, t) {
  return "Error on stream connection: " + am(e) + ", will continue retrying after " + t + " milliseconds.";
}, tagValueTooLong: (e) => `Value of "${e}" was longer than 64 characters and was discarded.`, unknownCustomEventKey: function(e) {
  return 'Custom event "' + e + '" does not exist';
}, unknownOption: (e) => 'Ignoring unknown config option "' + e + '"', contextNotSpecified: function() {
  return "No context specified." + Bl;
}, unrecoverableStreamError: (e) => `Error on stream connection ${am(e)}, giving up permanently`, wrongOptionType: (e, t, n) => 'Config option "' + e + '" should be of type ' + t + ", got " + n + ", using default value", wrongOptionTypeBoolean: (e, t) => 'Config option "' + e + '" should be a boolean, got ' + t + ", converting to boolean" };
const { validateLogger: dde } = NT, HA = { baseUrl: { default: "https://app.launchdarkly.com" }, streamUrl: { default: "https://clientstream.launchdarkly.com" }, eventsUrl: { default: "https://events.launchdarkly.com" }, sendEvents: { default: !0 }, streaming: { type: "boolean" }, sendLDHeaders: { default: !0 }, requestHeaderTransform: { type: "function" }, sendEventsOnlyForVariation: { default: !1 }, useReport: { default: !1 }, evaluationReasons: { default: !1 }, eventCapacity: { default: 100, minimum: 1 }, flushInterval: { default: 2e3, minimum: 2e3 }, samplingInterval: { default: 0, minimum: 0 }, streamReconnectDelay: { default: 1e3, minimum: 0 }, allAttributesPrivate: { default: !1 }, privateAttributes: { default: [] }, bootstrap: { type: "string|object" }, diagnosticRecordingInterval: { default: 9e5, minimum: 2e3 }, diagnosticOptOut: { default: !1 }, wrapperName: { type: "string" }, wrapperVersion: { type: "string" }, stateProvider: { type: "object" }, application: { validator: function(e, t, n) {
  const r = {};
  return t.id && (r.id = VA(`${e}.id`, t.id, n)), t.version && (r.version = VA(`${e}.version`, t.version, n)), r;
} }, inspectors: { default: [] } }, fde = /^(\w|\.|-)+$/;
function g1(e) {
  return e && e.replace(/\/+$/, "");
}
function VA(e, t, n) {
  if (typeof t == "string" && t.match(fde)) {
    if (!(t.length > 64)) return t;
    n.warn(pt.tagValueTooLong(e));
  } else n.warn(pt.invalidTagValue(e));
}
var DT = { baseOptionDefs: HA, validate: function(e, t, n, r) {
  const o = St.extend({ logger: { default: r } }, HA, n), i = {};
  function a(l) {
    St.onNextTick(() => {
      t && t.maybeReportError(new Mn.LDInvalidArgumentError(l));
    });
  }
  let c = St.extend({}, e || {});
  return function(l) {
    const u = l;
    Object.keys(i).forEach((d) => {
      if (u[d] !== void 0) {
        const f = i[d];
        r && r.warn(pt.deprecated(d, f)), f && (u[f] === void 0 && (u[f] = u[d]), delete u[d]);
      }
    });
  }(c), c = function(l) {
    const u = St.extend({}, l);
    return Object.keys(o).forEach((d) => {
      u[d] !== void 0 && u[d] !== null || (u[d] = o[d] && o[d].default);
    }), u;
  }(c), c = function(l) {
    const u = St.extend({}, l), d = (f) => {
      if (f === null) return "any";
      if (f === void 0) return;
      if (Array.isArray(f)) return "array";
      const h = typeof f;
      return h === "boolean" || h === "string" || h === "number" || h === "function" ? h : "object";
    };
    return Object.keys(l).forEach((f) => {
      const h = l[f];
      if (h != null) {
        const v = o[f];
        if (v === void 0) a(pt.unknownOption(f));
        else {
          const y = v.type || d(v.default), g = v.validator;
          if (g) {
            const b = g(f, l[f], r);
            b !== void 0 ? u[f] = b : delete u[f];
          } else if (y !== "any") {
            const b = y.split("|"), x = d(h);
            b.indexOf(x) < 0 ? y === "boolean" ? (u[f] = !!h, a(pt.wrongOptionTypeBoolean(f, x))) : (a(pt.wrongOptionType(f, y, x)), u[f] = v.default) : x === "number" && v.minimum !== void 0 && h < v.minimum && (a(pt.optionBelowMinimum(f, h, v.minimum)), u[f] = v.minimum);
          }
        }
      }
    }), u.baseUrl = g1(u.baseUrl), u.streamUrl = g1(u.streamUrl), u.eventsUrl = g1(u.eventsUrl), u;
  }(c), dde(c.logger), c;
}, getTags: function(e) {
  const t = {};
  return e && (e.application && e.application.id !== void 0 && e.application.id !== null && (t["application-id"] = [e.application.id]), e.application && e.application.version !== void 0 && e.application.id !== null && (t["application-version"] = [e.application.version])), t;
} };
const { getLDUserAgentString: pde } = St;
var LT = { getLDHeaders: function(e, t) {
  if (t && !t.sendLDHeaders) return {};
  const n = {};
  n[e.userAgentHeaderName || "User-Agent"] = pde(e), t && t.wrapperName && (n["X-LaunchDarkly-Wrapper"] = t.wrapperVersion ? t.wrapperName + "/" + t.wrapperVersion : t.wrapperName);
  const r = DT.getTags(t), o = Object.keys(r);
  return o.length && (n["x-launchdarkly-tags"] = o.sort().map((i) => Array.isArray(r[i]) ? r[i].sort().map((a) => `${i}/${a}`) : [`${i}/${r[i]}`]).reduce((i, a) => i.concat(a), []).join(" ")), n;
}, transformHeaders: function(e, t) {
  return t && t.requestHeaderTransform ? t.requestHeaderTransform({ ...e }) : e;
} };
const { v1: hde } = MT, { getLDHeaders: mde, transformHeaders: gde } = LT;
var xj = function(e, t, n) {
  const r = St.extend({ "Content-Type": "application/json" }, mde(e, n)), o = {};
  return o.sendEvents = (i, a, c) => {
    if (!e.httpRequest) return Promise.resolve();
    const l = JSON.stringify(i), u = c ? null : hde();
    return function d(f) {
      const h = c ? r : St.extend({}, r, { "X-LaunchDarkly-Event-Schema": "4", "X-LaunchDarkly-Payload-ID": u });
      return e.httpRequest("POST", a, gde(h, n), l).promise.then((v) => {
        if (v) return v.status >= 400 && Mn.isHttpErrorRecoverable(v.status) && f ? d(!1) : function(y) {
          const g = { status: y.status }, b = y.header("date");
          if (b) {
            const x = Date.parse(b);
            x && (g.serverTime = x);
          }
          return g;
        }(v);
      }).catch(() => f ? d(!1) : Promise.reject());
    }(!0).catch(() => {
    });
  }, o;
};
const { commonBasicLogger: vde } = NT;
function YA(e) {
  return typeof e == "string" && e !== "kind" && e.match(/^(\w|\.|-)+$/);
}
function GA(e) {
  return e.includes("%") || e.includes(":") ? e.replace(/%/g, "%25").replace(/:/g, "%3A") : e;
}
var yv = { checkContext: function(e, t) {
  if (e) {
    if (t && (e.kind === void 0 || e.kind === null)) return e.key !== void 0 && e.key !== null;
    const n = e.key, r = e.kind === void 0 ? "user" : e.kind, o = YA(r), i = r === "multi" || n != null && n !== "";
    if (r === "multi") {
      const a = Object.keys(e).filter((c) => c !== "kind");
      return i && a.every((c) => YA(c)) && a.every((c) => {
        const l = e[c].key;
        return l != null && l !== "";
      });
    }
    return i && o;
  }
  return !1;
}, getContextKeys: function(e, t = vde()) {
  if (!e) return;
  const n = {}, { kind: r, key: o } = e;
  switch (r) {
    case void 0:
      n.user = `${o}`;
      break;
    case "multi":
      Object.entries(e).filter(([i]) => i !== "kind").forEach(([i, a]) => {
        a && a.key && (n[i] = a.key);
      });
      break;
    case null:
      t.warn(`null is not a valid context kind: ${e}`);
      break;
    case "":
      t.warn(`'' is not a valid context kind: ${e}`);
      break;
    default:
      n[r] = `${o}`;
  }
  return n;
}, getContextKinds: function(e) {
  return e ? e.kind === null || e.kind === void 0 ? ["user"] : e.kind !== "multi" ? [e.kind] : Object.keys(e).filter((t) => t !== "kind") : [];
}, getCanonicalKey: function(e) {
  if (e) {
    if ((e.kind === void 0 || e.kind === null || e.kind === "user") && e.key) return e.key;
    if (e.kind !== "multi" && e.key) return `${e.kind}:${GA(e.key)}`;
    if (e.kind === "multi") return Object.keys(e).sort().filter((t) => t !== "kind").map((t) => `${t}:${GA(e[t].key)}`).join(":");
  }
} };
const { getContextKinds: yde } = yv;
var bde = function() {
  const e = {};
  let t = 0, n = 0, r = {}, o = {};
  return e.summarizeEvent = (i) => {
    if (i.kind === "feature") {
      const a = i.key + ":" + (i.variation !== null && i.variation !== void 0 ? i.variation : "") + ":" + (i.version !== null && i.version !== void 0 ? i.version : ""), c = r[a];
      let l = o[i.key];
      l || (l = /* @__PURE__ */ new Set(), o[i.key] = l), function(u) {
        return u.context ? yde(u.context) : u.contextKeys ? Object.keys(u.contextKeys) : [];
      }(i).forEach((u) => l.add(u)), c ? c.count = c.count + 1 : r[a] = { count: 1, key: i.key, version: i.version, variation: i.variation, value: i.value, default: i.default }, (t === 0 || i.creationDate < t) && (t = i.creationDate), i.creationDate > n && (n = i.creationDate);
    }
  }, e.getSummary = () => {
    const i = {};
    let a = !0;
    for (const c of Object.values(r)) {
      let l = i[c.key];
      l || (l = { default: c.default, counters: [], contextKinds: [...o[c.key]] }, i[c.key] = l);
      const u = { value: c.value, count: c.count };
      c.variation !== void 0 && c.variation !== null && (u.variation = c.variation), c.version !== void 0 && c.version !== null ? u.version = c.version : u.unknown = !0, l.counters.push(u), a = !1;
    }
    return a ? null : { startDate: t, endDate: n, features: i };
  }, e.clearSummary = () => {
    t = 0, n = 0, r = {}, o = {};
  }, e;
};
function wj(e) {
  return e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function KA(e) {
  return (e.startsWith("/") ? e.substring(1) : e).split("/").map((t) => t.indexOf("~") >= 0 ? t.replace(/~1/g, "/").replace(/~0/g, "~") : t);
}
function XA(e) {
  return !e.startsWith("/");
}
function ZA(e, t) {
  const n = XA(e), r = XA(t);
  if (n && r) return e === t;
  if (n) {
    const o = KA(t);
    return o.length === 1 && e === o[0];
  }
  if (r) {
    const o = KA(e);
    return o.length === 1 && t === o[0];
  }
  return e === t;
}
function JA(e) {
  return `/${wj(e)}`;
}
var v1 = { cloneExcluding: function(e, t) {
  const n = [], r = {}, o = [];
  for (n.push(...Object.keys(e).map((i) => ({ key: i, ptr: JA(i), source: e, parent: r, visited: [e] }))); n.length; ) {
    const i = n.pop();
    if (t.some((a) => ZA(a, i.ptr))) o.push(i.ptr);
    else {
      const a = i.source[i.key];
      if (a === null) i.parent[i.key] = a;
      else if (Array.isArray(a)) i.parent[i.key] = [...a];
      else if (typeof a == "object") {
        if (i.visited.includes(a)) continue;
        i.parent[i.key] = {}, n.push(...Object.keys(a).map((c) => {
          return { key: c, ptr: (l = i.ptr, u = wj(c), `${l}/${u}`), source: a, parent: i.parent[i.key], visited: [...i.visited, a] };
          var l, u;
        }));
      } else i.parent[i.key] = a;
    }
  }
  return { cloned: r, excluded: o.sort() };
}, compare: ZA, literalToReference: JA }, xde = function(e) {
  const t = {}, n = e.allAttributesPrivate, r = e.privateAttributes || [], o = ["key", "kind", "_meta", "anonymous"], i = ["name", "ip", "firstName", "lastName", "email", "avatar", "country"], a = (c, l) => {
    if (typeof c != "object" || c === null || Array.isArray(c)) return;
    const { cloned: u, excluded: d } = v1.cloneExcluding(c, ((f, h) => (n || h && f.anonymous ? Object.keys(f) : [...r, ...f._meta && f._meta.privateAttributes || []]).filter((v) => !o.some((y) => v1.compare(v, y))))(c, l));
    return u.key = String(u.key), d.length && (u._meta || (u._meta = {}), u._meta.redactedAttributes = d), u._meta && (delete u._meta.privateAttributes, Object.keys(u._meta).length === 0 && delete u._meta), u.anonymous !== void 0 && (u.anonymous = !!u.anonymous), u;
  };
  return t.filter = (c, l = !1) => c.kind === void 0 || c.kind === null ? a(((u) => {
    const d = { ...u.custom || {}, kind: "user", key: u.key };
    u.anonymous !== void 0 && (d.anonymous = !!u.anonymous);
    for (const f of i) delete d[f], u[f] !== void 0 && u[f] !== null && (d[f] = String(u[f]));
    return u.privateAttributeNames !== void 0 && u.privateAttributeNames !== null && (d._meta = d._meta || {}, d._meta.privateAttributes = u.privateAttributeNames.map((f) => f.startsWith("/") ? v1.literalToReference(f) : f)), d;
  })(c), l) : c.kind === "multi" ? ((u, d) => {
    const f = { kind: u.kind }, h = Object.keys(u);
    for (const v of h) if (v !== "kind") {
      const y = a(u[v], d);
      y && (f[v] = y);
    }
    return f;
  })(c, l) : a(c, l), t;
};
const { getContextKeys: wde } = yv;
var $de = function(e, t, n, r = null, o = null, i = null) {
  const a = {}, c = i || xj(e, n, t), l = St.appendUrlPath(t.eventsUrl, "/events/bulk/" + n), u = bde(), d = xde(t), f = t.samplingInterval, h = t.eventCapacity, v = t.flushInterval, y = t.logger;
  let g, b = [], x = 0, $ = !1, S = !1;
  function O() {
    return f === 0 || Math.floor(Math.random() * f) === 0;
  }
  function C(k) {
    const I = St.extend({}, k);
    return k.kind === "identify" ? I.context = d.filter(k.context) : k.kind === "feature" ? I.context = d.filter(k.context, !0) : (I.contextKeys = wde(k.context, y), delete I.context), k.kind === "feature" && (delete I.trackEvents, delete I.debugEventsUntilDate), I;
  }
  function T(k) {
    b.length < h ? (b.push(k), S = !1) : (S || (S = !0, y.warn(pt.eventCapacityExceeded())), r && r.incrementDroppedEvents());
  }
  return a.enqueue = function(k) {
    if ($) return;
    let I = !1, P = !1;
    var _;
    if (u.summarizeEvent(k), k.kind === "feature" ? O() && (I = !!k.trackEvents, P = !!(_ = k).debugEventsUntilDate && _.debugEventsUntilDate > x && _.debugEventsUntilDate > (/* @__PURE__ */ new Date()).getTime()) : I = O(), I && T(C(k)), P) {
      const A = St.extend({}, k, { kind: "debug" });
      A.context = d.filter(A.context), delete A.trackEvents, delete A.debugEventsUntilDate, T(A);
    }
  }, a.flush = function() {
    if ($) return Promise.resolve();
    const k = b, I = u.getSummary();
    return u.clearSummary(), I && (I.kind = "summary", k.push(I)), r && r.setEventsInLastBatch(k.length), k.length === 0 ? Promise.resolve() : (b = [], y.debug(pt.debugPostingEvents(k.length)), c.sendEvents(k, l).then((P) => {
      P && (P.serverTime && (x = P.serverTime), Mn.isHttpErrorRecoverable(P.status) || ($ = !0), P.status >= 400 && St.onNextTick(() => {
        o.maybeReportError(new Mn.LDUnexpectedResponseError(pt.httpErrorMessage(P.status, "event posting", "some events were dropped")));
      }));
    }));
  }, a.start = function() {
    const k = () => {
      a.flush(), g = setTimeout(k, v);
    };
    g = setTimeout(k, v);
  }, a.stop = function() {
    clearTimeout(g);
  }, a;
}, Ode = function(e) {
  const t = {}, n = {};
  return t.on = function(r, o, i) {
    n[r] = n[r] || [], n[r] = n[r].concat({ handler: o, context: i });
  }, t.off = function(r, o, i) {
    if (n[r]) for (let a = 0; a < n[r].length; a++) n[r][a].handler === o && n[r][a].context === i && (n[r] = n[r].slice(0, a).concat(n[r].slice(a + 1)));
  }, t.emit = function(r) {
    if (!n[r]) return;
    const o = n[r].slice(0);
    for (let i = 0; i < o.length; i++) o[i].handler.apply(o[i].context, Array.prototype.slice.call(arguments, 1));
  }, t.getEvents = function() {
    return Object.keys(n);
  }, t.getEventListenerCount = function(r) {
    return n[r] ? n[r].length : 0;
  }, t.maybeReportError = function(r) {
    r && (n.error ? this.emit("error", r) : (e || console).error(r.message));
  }, t;
};
const sm = "ready", y1 = "initialized", b1 = "failed";
var Sde = function(e) {
  let t = !1, n = !1, r = null, o = null;
  const i = new Promise((a) => {
    const c = () => {
      e.off(sm, c), a();
    };
    e.on(sm, c);
  }).catch(() => {
  });
  return { getInitializationPromise: () => o || (t ? Promise.resolve() : n ? Promise.reject(r) : (o = new Promise((a, c) => {
    const l = () => {
      e.off(y1, l), a();
    }, u = (d) => {
      e.off(b1, u), c(d);
    };
    e.on(y1, l), e.on(b1, u);
  }), o)), getReadyPromise: () => i, signalSuccess: () => {
    t || n || (t = !0, e.emit(y1), e.emit(sm));
  }, signalFailure: (a) => {
    t || n || (n = !0, r = a, e.emit(b1, a), e.emit(sm)), e.maybeReportError(a);
  } };
}, Cde = function(e, t, n, r) {
  const o = {};
  function i() {
    let a = "";
    const c = r.getContext();
    return c && (a = n || St.btoa(JSON.stringify(c))), "ld:" + t + ":" + a;
  }
  return o.loadFlags = () => e.get(i()).then((a) => {
    if (a == null) return null;
    try {
      let c = JSON.parse(a);
      if (c) {
        const l = c.$schema;
        l === void 0 || l < 1 ? c = St.transformValuesToVersionedValues(c) : delete c.$schema;
      }
      return c;
    } catch {
      return o.clearFlags().then(() => null);
    }
  }), o.saveFlags = (a) => {
    const c = St.extend({}, a, { $schema: 1 });
    return e.set(i(), JSON.stringify(c));
  }, o.clearFlags = () => e.clear(i()), o;
}, Tde = function(e, t) {
  const n = {};
  let r = !1;
  const o = (i) => {
    r || (r = !0, t.warn(pt.localStorageUnavailable(i)));
  };
  return n.isEnabled = () => !!e, n.get = (i) => new Promise((a) => {
    e ? e.get(i).then(a).catch((c) => {
      o(c), a(void 0);
    }) : a(void 0);
  }), n.set = (i, a) => new Promise((c) => {
    e ? e.set(i, a).then(() => c(!0)).catch((l) => {
      o(l), c(!1);
    }) : c(!1);
  }), n.clear = (i) => new Promise((a) => {
    e ? e.clear(i).then(() => a(!0)).catch((c) => {
      o(c), a(!1);
    }) : a(!1);
  }), n;
};
const { appendUrlPath: QA, base64URLEncode: Ede, objectHasOwnProperty: _de } = St, { getLDHeaders: kde, transformHeaders: Rde } = LT, { isHttpErrorRecoverable: Pde } = Mn;
var Ade = function(e, t, n, r) {
  const o = t.streamUrl, i = t.logger, a = {}, c = QA(o, "/eval/" + n), l = t.useReport, u = t.evaluationReasons, d = t.streamReconnectDelay, f = kde(e, t);
  let h, v = !1, y = null, g = null, b = null, x = null, $ = null, S = 0;
  function O() {
    const _ = (A = function() {
      const D = d * Math.pow(2, S);
      return D > 3e4 ? 3e4 : D;
    }(), A - Math.trunc(0.5 * Math.random() * A));
    var A;
    return S += 1, _;
  }
  function C(_) {
    if (_.status && typeof _.status == "number" && !Pde(_.status)) return I(), i.error(pt.unrecoverableStreamError(_)), void (g && (clearTimeout(g), g = null));
    const A = O();
    v || (i.warn(pt.streamError(_, A)), v = !0), P(!1), I(), T(A);
  }
  function T(_) {
    g || (_ ? g = setTimeout(k, _) : k());
  }
  function k() {
    let _;
    g = null;
    let A = "";
    const D = { headers: f, readTimeoutMillis: 3e5 };
    if (e.eventSourceFactory) {
      x != null && (A = "h=" + x), l ? e.eventSourceAllowsReport ? (_ = c, D.method = "REPORT", D.headers["Content-Type"] = "application/json", D.body = JSON.stringify(b)) : (_ = QA(o, "/ping/" + n), A = "") : _ = c + "/" + Ede(JSON.stringify(b)), D.headers = Rde(D.headers, t), u && (A = A + (A ? "&" : "") + "withReasons=true"), _ = _ + (A ? "?" : "") + A, I(), i.info(pt.streamConnecting(_)), h = (/* @__PURE__ */ new Date()).getTime(), y = e.eventSourceFactory(_, D);
      for (const M in $) _de($, M) && y.addEventListener(M, $[M]);
      y.onerror = C, y.onopen = () => {
        S = 0;
      };
    }
  }
  function I() {
    y && (i.info(pt.streamClosing()), y.close(), y = null);
  }
  function P(_) {
    h && r && r.recordStreamInit(h, !_, (/* @__PURE__ */ new Date()).getTime() - h), h = null;
  }
  return a.connect = function(_, A, D) {
    b = _, x = A, $ = {};
    for (const M in D || {}) $[M] = function(N) {
      v = !1, P(!0), D[M] && D[M](N);
    };
    T();
  }, a.disconnect = function() {
    clearTimeout(g), g = null, I();
  }, a.isConnected = function() {
    return !!(y && e.eventSourceIsActive && e.eventSourceIsActive(y));
  }, a;
}, Ide = function(e) {
  let t, n, r, o;
  const i = { addPromise: (a, c) => {
    t = a, n && n(), n = c, a.then((l) => {
      t === a && (r(l), e && e());
    }, (l) => {
      t === a && (o(l), e && e());
    });
  } };
  return i.resultPromise = new Promise((a, c) => {
    r = a, o = c;
  }), i;
};
const { transformHeaders: Mde, getLDHeaders: Nde } = LT, e4 = "application/json";
var Dde = function(e, t, n) {
  const r = t.baseUrl, o = t.useReport, i = t.evaluationReasons, a = t.logger, c = {}, l = {};
  function u(d, f) {
    if (!e.httpRequest) return new Promise((x, $) => {
      $(new Mn.LDFlagFetchError(pt.httpUnavailable()));
    });
    const h = f ? "REPORT" : "GET", v = Nde(e, t);
    f && (v["Content-Type"] = e4);
    let y = l[d];
    y || (y = Ide(() => {
      delete l[d];
    }), l[d] = y);
    const g = e.httpRequest(h, d, Mde(v, t), f), b = g.promise.then((x) => {
      if (x.status === 200) {
        if (x.header("content-type") && x.header("content-type").substring(0, 16) === e4) return JSON.parse(x.body);
        {
          const $ = pt.invalidContentType(x.header("content-type") || "");
          return Promise.reject(new Mn.LDFlagFetchError($));
        }
      }
      return Promise.reject(function($) {
        return $.status === 404 ? new Mn.LDInvalidEnvironmentIdError(pt.environmentNotFound()) : new Mn.LDFlagFetchError(pt.errorFetchingFlags($.statusText || String($.status)));
      }(x));
    }, (x) => Promise.reject(new Mn.LDFlagFetchError(pt.networkError(x))));
    return y.addPromise(b, () => {
      g.cancel && g.cancel();
    }), y.resultPromise;
  }
  return c.fetchJSON = function(d) {
    return u(St.appendUrlPath(r, d), null);
  }, c.fetchFlagSettings = function(d, f) {
    let h, v, y, g = "";
    return o ? (v = [r, "/sdk/evalx/", n, "/context"].join(""), y = JSON.stringify(d)) : (h = St.base64URLEncode(JSON.stringify(d)), v = [r, "/sdk/evalx/", n, "/contexts/", h].join("")), f && (g = "h=" + f), i && (g = g + (g ? "&" : "") + "withReasons=true"), v = v + (g ? "?" : "") + g, a.debug(pt.debugPolling(v)), u(v, y);
  }, c;
}, Lde = function(e, t) {
  const n = {};
  let r;
  return n.setContext = function(o) {
    r = St.sanitizeContext(o), r && t && t(St.clone(r));
  }, n.getContext = function() {
    return r ? St.clone(r) : null;
  }, n;
};
const { v1: jde } = MT, { getContextKinds: Fde } = yv;
var zde = function(e) {
  function t(r) {
    return r == null || r === "user" ? "ld:$anonUserId" : `ld:$contextKey:${r}`;
  }
  function n(r, o) {
    return o.key !== null && o.key !== void 0 ? (o.key = o.key.toString(), Promise.resolve(o)) : o.anonymous ? function(i) {
      return e.get(t(i));
    }(r).then((i) => {
      if (i) return o.key = i, o;
      {
        const a = jde();
        return o.key = a, function(c, l) {
          return e.set(t(l), c);
        }(a, r).then(() => o);
      }
    }) : Promise.reject(new Mn.LDInvalidUserError(pt.invalidContext()));
  }
  this.processContext = (r) => {
    if (!r) return Promise.reject(new Mn.LDInvalidUserError(pt.contextNotSpecified()));
    const o = St.clone(r);
    if (r.kind === "multi") {
      const i = Fde(o);
      return Promise.all(i.map((a) => n(a, o[a]))).then(() => o);
    }
    return n(r.kind, o);
  };
};
const { v1: Bde } = MT, { baseOptionDefs: x1 } = DT, { appendUrlPath: qde } = St;
var w1 = { DiagnosticId: function(e) {
  const t = { diagnosticId: Bde() };
  return e && (t.sdkKeySuffix = e.length > 6 ? e.substring(e.length - 6) : e), t;
}, DiagnosticsAccumulator: function(e) {
  let t, n, r, o;
  function i(a) {
    t = a, n = 0, r = 0, o = [];
  }
  return i(e), { getProps: () => ({ dataSinceDate: t, droppedEvents: n, eventsInLastBatch: r, streamInits: o }), setProps: (a) => {
    t = a.dataSinceDate, n = a.droppedEvents || 0, r = a.eventsInLastBatch || 0, o = a.streamInits || [];
  }, incrementDroppedEvents: () => {
    n++;
  }, setEventsInLastBatch: (a) => {
    r = a;
  }, recordStreamInit: (a, c, l) => {
    const u = { timestamp: a, failed: c, durationMillis: l };
    o.push(u);
  }, reset: i };
}, DiagnosticsManager: function(e, t, n, r, o, i, a) {
  const c = !!e.diagnosticUseCombinedEvent, l = "ld:" + o + ":$diagnostics", u = qde(i.eventsUrl, "/events/diagnostic/" + o), d = i.diagnosticRecordingInterval, f = n;
  let h, v, y = !!i.streaming;
  const g = {};
  function b() {
    return { sdk: S(), configuration: O(), platform: e.diagnosticPlatformData };
  }
  function x(C) {
    i.logger && i.logger.debug(pt.debugPostingDiagnosticEvent(C)), r.sendEvents(C, u, !0).then(() => {
    }).catch(() => {
    });
  }
  function $() {
    x(function() {
      const C = (/* @__PURE__ */ new Date()).getTime();
      let T = { kind: c ? "diagnostic-combined" : "diagnostic", id: a, creationDate: C, ...f.getProps() };
      return c && (T = { ...T, ...b() }), f.reset(C), T;
    }()), v = setTimeout($, d), h = (/* @__PURE__ */ new Date()).getTime(), c && function() {
      if (t.isEnabled()) {
        const C = { ...f.getProps() };
        t.set(l, JSON.stringify(C));
      }
    }();
  }
  function S() {
    const C = { ...e.diagnosticSdkData };
    return i.wrapperName && (C.wrapperName = i.wrapperName), i.wrapperVersion && (C.wrapperVersion = i.wrapperVersion), C;
  }
  function O() {
    return { customBaseURI: i.baseUrl !== x1.baseUrl.default, customStreamURI: i.streamUrl !== x1.streamUrl.default, customEventsURI: i.eventsUrl !== x1.eventsUrl.default, eventsCapacity: i.eventCapacity, eventsFlushIntervalMillis: i.flushInterval, reconnectTimeMillis: i.streamReconnectDelay, streamingDisabled: !y, allAttributesPrivate: !!i.allAttributesPrivate, diagnosticRecordingIntervalMillis: i.diagnosticRecordingInterval, usingSecureMode: !!i.hash, bootstrapMode: !!i.bootstrap, fetchGoalsDisabled: !i.fetchGoals, sendEventsOnlyForVariation: !!i.sendEventsOnlyForVariation };
  }
  return g.start = () => {
    c ? function(C) {
      if (!t.isEnabled()) return C(!1);
      t.get(l).then((T) => {
        if (T) try {
          const k = JSON.parse(T);
          f.setProps(k), h = k.dataSinceDate;
        } catch {
        }
        C(!0);
      }).catch(() => {
        C(!1);
      });
    }((C) => {
      if (C) {
        const T = (h || 0) + d, k = (/* @__PURE__ */ new Date()).getTime();
        k >= T ? $() : v = setTimeout($, T - k);
      } else Math.floor(4 * Math.random()) === 0 ? $() : v = setTimeout($, d);
    }) : (x({ kind: "diagnostic-init", id: a, creationDate: f.getProps().dataSinceDate, ...b() }), v = setTimeout($, d));
  }, g.stop = () => {
    v && clearTimeout(v);
  }, g.setStreaming = (C) => {
    y = C;
  }, g;
} }, Ude = function(e, t) {
  let n = !1;
  const r = { type: e.type, name: e.name, synchronous: e.synchronous, method: (...o) => {
    try {
      e.method(...o);
    } catch {
      n || (n = !0, t.warn(pt.inspectorMethodError(r.type, r.name)));
    }
  } };
  return r;
};
const { onNextTick: cm } = St, Hr = { flagUsed: "flag-used", flagDetailsChanged: "flag-details-changed", flagDetailChanged: "flag-detail-changed", clientIdentityChanged: "client-identity-changed" };
Object.freeze(Hr);
var Wde = { InspectorTypes: Hr, InspectorManager: function(e, t) {
  const n = {}, r = { [Hr.flagUsed]: [], [Hr.flagDetailsChanged]: [], [Hr.flagDetailChanged]: [], [Hr.clientIdentityChanged]: [] }, o = { [Hr.flagUsed]: [], [Hr.flagDetailsChanged]: [], [Hr.flagDetailChanged]: [], [Hr.clientIdentityChanged]: [] }, i = e && e.map((a) => Ude(a, t));
  return i && i.forEach((a) => {
    Object.prototype.hasOwnProperty.call(r, a.type) && !a.synchronous ? r[a.type].push(a) : Object.prototype.hasOwnProperty.call(o, a.type) && a.synchronous ? o[a.type].push(a) : t.warn(pt.invalidInspector(a.type, a.name));
  }), n.hasListeners = (a) => r[a] && r[a].length || o[a] && o[a].length, n.onFlagUsed = (a, c, l) => {
    const u = Hr.flagUsed;
    o[u].length && o[u].forEach((d) => d.method(a, c, l)), r[u].length && cm(() => {
      r[u].forEach((d) => d.method(a, c, l));
    });
  }, n.onFlags = (a) => {
    const c = Hr.flagDetailsChanged;
    o[c].length && o[c].forEach((l) => l.method(a)), r[c].length && cm(() => {
      r[c].forEach((l) => l.method(a));
    });
  }, n.onFlagChanged = (a, c) => {
    const l = Hr.flagDetailChanged;
    o[l].length && o[l].forEach((u) => u.method(a, c)), r[l].length && cm(() => {
      r[l].forEach((u) => u.method(a, c));
    });
  }, n.onIdentityChanged = (a) => {
    const c = Hr.clientIdentityChanged;
    o[c].length && o[c].forEach((l) => l.method(a)), r[c].length && cm(() => {
      r[c].forEach((l) => l.method(a));
    });
  }, n;
} };
const { LDTimeoutError: Hde } = Mn;
var Vde = function(e, t) {
  return new Promise((n, r) => {
    setTimeout(() => {
      r(new Hde(`${t} timed out after ${e} seconds.`));
    }, 1e3 * e);
  });
};
const { commonBasicLogger: t4 } = NT, { checkContext: Yde, getContextKeys: Gde } = yv, { InspectorTypes: lm, InspectorManager: Kde } = Wde, um = "change", n4 = "internal-change";
var $j = { initialize: function(e, t, n, r, o) {
  const i = function() {
    return n && n.logger ? n.logger : o && o.logger && o.logger.default || t4("warn");
  }(), a = Ode(i), c = Sde(a), l = DT.validate(n, a, o, i), u = Kde(l.inspectors, i), d = l.sendEvents;
  let f = e, h = l.hash;
  const v = Tde(r.localStorage, i), y = xj(r, f, l), g = l.sendEvents && !l.diagnosticOptOut, b = g ? w1.DiagnosticId(f) : null, x = g ? w1.DiagnosticsAccumulator((/* @__PURE__ */ new Date()).getTime()) : null, $ = g ? w1.DiagnosticsManager(r, v, x, y, f, l, b) : null, S = Ade(r, l, f, x), O = l.eventProcessor || $de(r, l, f, x, a, y), C = Dde(r, l, f);
  let T, k, I, P = {}, _ = l.streaming, A = !1, D = !1, M = !0;
  const N = l.stateProvider, L = Lde(null, function(Q) {
    (function(ie) {
      N || ie && W({ kind: "identify", context: ie, creationDate: (/* @__PURE__ */ new Date()).getTime() });
    })(Q), u.hasListeners(lm.clientIdentityChanged) && u.onIdentityChanged(L.getContext());
  }), z = new zde(v), q = v.isEnabled() ? Cde(v, f, h, L) : null;
  function W(Q) {
    f && (N && N.enqueueEvent && N.enqueueEvent(Q) || (Q.context ? (M = !1, !d || D || r.isDoNotTrack() || (i.debug(pt.debugEnqueueingEvent(Q.kind)), O.enqueue(Q))) : M && (i.warn(pt.eventWithoutContext()), M = !1)));
  }
  function U(Q, ie) {
    u.hasListeners(lm.flagDetailChanged) && u.onFlagChanged(Q.key, re(ie));
  }
  function K() {
    u.hasListeners(lm.flagDetailsChanged) && u.onFlags(Object.entries(P).map(([Q, ie]) => ({ key: Q, detail: re(ie) })).reduce((Q, ie) => (Q[ie.key] = ie.detail, Q), {}));
  }
  function Y(Q, ie, ee, be) {
    const Ie = L.getContext(), je = /* @__PURE__ */ new Date(), V = { kind: "feature", key: Q, context: Ie, value: ie ? ie.value : null, variation: ie ? ie.variationIndex : null, default: ee, creationDate: je.getTime() }, se = P[Q];
    se && (V.version = se.flagVersion ? se.flagVersion : se.version, V.trackEvents = se.trackEvents, V.debugEventsUntilDate = se.debugEventsUntilDate), (be || se && se.trackReason) && ie && (V.reason = ie.reason), W(V);
  }
  function X(Q) {
    return Yde(Q, !1) ? Promise.resolve(Q) : Promise.reject(new Mn.LDInvalidUserError(pt.invalidContext()));
  }
  function oe(Q, ie, ee, be, Ie, je) {
    var we;
    let V, se;
    return P && St.objectHasOwnProperty(P, Q) && P[Q] && !P[Q].deleted ? (se = P[Q], V = re(se), se.value !== null && se.value !== void 0 || (V.value = ie)) : V = { value: ie, variationIndex: null, reason: { kind: "ERROR", errorKind: "FLAG_NOT_FOUND" } }, ee && (Ie || ((we = se == null ? void 0 : se.prerequisites) == null || we.forEach((J) => {
      oe(J, void 0, ee, !1, !1, !1);
    })), Y(Q, V, ie, be)), !Ie && je && function(J, he) {
      u.hasListeners(lm.flagUsed) && u.onFlagUsed(J, he, L.getContext());
    }(Q, V), V;
  }
  function re(Q) {
    return { value: Q.value, variationIndex: Q.variation === void 0 ? null : Q.variation, reason: Q.reason || null };
  }
  function Z() {
    if (k = !0, !L.getContext()) return;
    const Q = (ie) => {
      try {
        return JSON.parse(ie);
      } catch {
        return void a.maybeReportError(new Mn.LDInvalidDataError(pt.invalidData()));
      }
    };
    S.connect(L.getContext(), h, { ping: function() {
      i.debug(pt.debugStreamPing());
      const ie = L.getContext();
      C.fetchFlagSettings(ie, h).then((ee) => {
        St.deepEquals(ie, L.getContext()) && fe(ee || {});
      }).catch((ee) => {
        a.maybeReportError(new Mn.LDFlagFetchError(pt.errorFetchingFlags(ee)));
      });
    }, put: function(ie) {
      const ee = Q(ie.data);
      ee && (i.debug(pt.debugStreamPut()), fe(ee));
    }, patch: function(ie) {
      const ee = Q(ie.data);
      if (!ee) return;
      const be = P[ee.key];
      if (!be || !be.version || !ee.version || be.version < ee.version) {
        i.debug(pt.debugStreamPatch(ee.key));
        const Ie = {}, je = St.extend({}, ee);
        delete je.key, P[ee.key] = je;
        const V = re(je);
        Ie[ee.key] = be ? { previous: be.value, current: V } : { current: V }, U(ee, je), de(Ie);
      } else i.debug(pt.debugStreamPatchIgnored(ee.key));
    }, delete: function(ie) {
      const ee = Q(ie.data);
      if (ee) if (!P[ee.key] || P[ee.key].version < ee.version) {
        i.debug(pt.debugStreamDelete(ee.key));
        const be = {};
        P[ee.key] && !P[ee.key].deleted && (be[ee.key] = { previous: P[ee.key].value }), P[ee.key] = { version: ee.version, deleted: !0 }, U(ee, P[ee.key]), de(be);
      } else i.debug(pt.debugStreamDeleteIgnored(ee.key));
    } });
  }
  function ce() {
    k && (S.disconnect(), k = !1);
  }
  function fe(Q) {
    const ie = {};
    if (!Q) return Promise.resolve();
    for (const ee in P) St.objectHasOwnProperty(P, ee) && P[ee] && (Q[ee] && !St.deepEquals(Q[ee].value, P[ee].value) ? ie[ee] = { previous: P[ee].value, current: re(Q[ee]) } : Q[ee] && !Q[ee].deleted || (ie[ee] = { previous: P[ee].value }));
    for (const ee in Q) St.objectHasOwnProperty(Q, ee) && Q[ee] && (!P[ee] || P[ee].deleted) && (ie[ee] = { current: re(Q[ee]) });
    return P = { ...Q }, K(), de(ie).catch(() => {
    });
  }
  function de(Q) {
    const ie = Object.keys(Q);
    if (ie.length > 0) {
      const ee = {};
      ie.forEach((be) => {
        const Ie = Q[be].current, je = Ie ? Ie.value : void 0, V = Q[be].previous;
        a.emit(um + ":" + be, je, V), ee[be] = Ie ? { current: je, previous: V } : { previous: V };
      }), a.emit(um, ee), a.emit(n4, P), l.sendEventsOnlyForVariation || N || ie.forEach((be) => {
        Y(be, Q[be].current);
      });
    }
    return T && q ? q.saveFlags(P) : Promise.resolve();
  }
  function ne() {
    const Q = _ || I && _ === void 0;
    Q && !k ? Z() : !Q && k && ce(), $ && $.setStreaming(Q);
  }
  function le(Q) {
    return Q === um || Q.substr(0, 7) === um + ":";
  }
  if (typeof l.bootstrap == "string" && l.bootstrap.toUpperCase() === "LOCALSTORAGE" && (q ? T = !0 : i.warn(pt.localStorageUnavailable())), typeof l.bootstrap == "object" && (P = function(Q) {
    const ie = Object.keys(Q), ee = "$flagsState", be = "$valid", Ie = Q[ee];
    !Ie && ie.length && i.warn(pt.bootstrapOldFormat()), Q[be] === !1 && i.warn(pt.bootstrapInvalid());
    const je = {};
    return ie.forEach((V) => {
      if (V !== ee && V !== be) {
        let se = { value: Q[V] };
        Ie && Ie[V] ? se = St.extend(se, Ie[V]) : se.version = 0, je[V] = se;
      }
    }), je;
  }(l.bootstrap)), N) {
    const Q = N.getInitialState();
    Q ? ve(Q) : N.on("init", ve), N.on("update", function(ie) {
      ie.context && L.setContext(ie.context), ie.flags && fe(ie.flags);
    });
  } else (function() {
    return e ? z.processContext(t).then(X).then((Q) => (L.setContext(Q), typeof l.bootstrap == "object" ? G() : T ? q.loadFlags().then((ie) => ie == null ? (P = {}, C.fetchFlagSettings(L.getContext(), h).then((ee) => fe(ee || {})).then(G).catch((ee) => {
      Se(new Mn.LDFlagFetchError(pt.errorFetchingFlags(ee)));
    })) : (P = ie, St.onNextTick(G), C.fetchFlagSettings(L.getContext(), h).then((ee) => fe(ee)).catch((ee) => a.maybeReportError(ee)))) : C.fetchFlagSettings(L.getContext(), h).then((ie) => {
      P = ie || {}, K(), G();
    }).catch((ie) => {
      P = {}, Se(ie);
    }))) : Promise.reject(new Mn.LDInvalidEnvironmentIdError(pt.environmentNotSpecified()));
  })().catch(Se);
  function ve(Q) {
    f = Q.environment, L.setContext(Q.context), P = { ...Q.flags }, St.onNextTick(G);
  }
  function G() {
    i.info(pt.clientInitialized()), A = !0, ne(), c.signalSuccess();
  }
  function Se(Q) {
    c.signalFailure(Q);
  }
  return { client: { waitForInitialization: function(Q = void 0) {
    if (Q != null) {
      if (typeof Q == "number") return function(ie) {
        ie > 5 && i.warn("The waitForInitialization function was called with a timeout greater than 5 seconds. We recommend a timeout of 5 seconds or less.");
        const ee = c.getInitializationPromise(), be = Vde(ie, "waitForInitialization");
        return Promise.race([be, ee]).catch((Ie) => {
          throw Ie instanceof Mn.LDTimeoutError && i.error(`waitForInitialization error: ${Ie}`), Ie;
        });
      }(Q);
      i.warn("The waitForInitialization method was provided with a non-numeric timeout.");
    }
    return i.warn("The waitForInitialization function was called without a timeout specified. In a future version a default timeout will be applied."), c.getInitializationPromise();
  }, waitUntilReady: () => c.getReadyPromise(), identify: function(Q, ie, ee) {
    if (D) return St.wrapPromiseCallback(Promise.resolve({}), ee);
    if (N) return i.warn(pt.identifyDisabled()), St.wrapPromiseCallback(Promise.resolve(St.transformVersionedValuesToValues(P)), ee);
    const be = T && q ? q.clearFlags() : Promise.resolve();
    return St.wrapPromiseCallback(be.then(() => z.processContext(Q)).then(X).then((Ie) => C.fetchFlagSettings(Ie, ie).then((je) => {
      const V = St.transformVersionedValuesToValues(je);
      return L.setContext(Ie), h = ie, je ? fe(je).then(() => V) : V;
    })).then((Ie) => (k && Z(), Ie)).catch((Ie) => (a.maybeReportError(Ie), Promise.reject(Ie))), ee);
  }, getContext: function() {
    return L.getContext();
  }, variation: function(Q, ie) {
    return oe(Q, ie, !0, !1, !1, !0).value;
  }, variationDetail: function(Q, ie) {
    return oe(Q, ie, !0, !0, !1, !0);
  }, track: function(Q, ie, ee) {
    if (typeof Q != "string") return void a.maybeReportError(new Mn.LDInvalidEventKeyError(pt.unknownCustomEventKey(Q)));
    ee !== void 0 && typeof ee != "number" && i.warn(pt.invalidMetricValue(typeof ee)), r.customEventFilter && !r.customEventFilter(Q) && i.warn(pt.unknownCustomEventKey(Q));
    const be = L.getContext(), Ie = { kind: "custom", key: Q, context: be, url: r.getCurrentUrl(), creationDate: (/* @__PURE__ */ new Date()).getTime() };
    be && be.anonymous && (Ie.contextKind = be.anonymous ? "anonymousUser" : "user"), ie != null && (Ie.data = ie), ee != null && (Ie.metricValue = ee), W(Ie);
  }, on: function(Q, ie, ee) {
    le(Q) ? (I = !0, A && ne(), a.on(Q, ie, ee)) : a.on(...arguments);
  }, off: function(Q) {
    if (a.off(...arguments), le(Q)) {
      let ie = !1;
      a.getEvents().forEach((ee) => {
        le(ee) && a.getEventListenerCount(ee) > 0 && (ie = !0);
      }), ie || (I = !1, k && _ === void 0 && ce());
    }
  }, setStreaming: function(Q) {
    const ie = Q === null ? void 0 : Q;
    ie !== _ && (_ = ie, ne());
  }, flush: function(Q) {
    return St.wrapPromiseCallback(d ? O.flush() : Promise.resolve(), Q);
  }, allFlags: function() {
    const Q = {};
    if (!P) return Q;
    for (const ie in P) St.objectHasOwnProperty(P, ie) && !P[ie].deleted && (Q[ie] = oe(ie, null, !l.sendEventsOnlyForVariation, !1, !0, !1).value);
    return Q;
  }, close: function(Q) {
    if (D) return St.wrapPromiseCallback(Promise.resolve(), Q);
    const ie = () => {
      D = !0, P = {};
    }, ee = Promise.resolve().then(() => {
      if (ce(), $ && $.stop(), d) return O.stop(), O.flush();
    }).then(ie).catch(ie);
    return St.wrapPromiseCallback(ee, Q);
  } }, options: l, emitter: a, ident: L, logger: i, requestor: C, start: function() {
    d && ($ && $.start(), O.start());
  }, enqueueEvent: W, getFlagsInternal: function() {
    return P;
  }, getEnvironmentId: () => f, internalChangeEventName: n4 };
}, commonBasicLogger: t4, errors: Mn, messages: pt, utils: St, getContextKeys: Gde }, Xde = $j.initialize, Zde = $j.errors;
function Jde(e, t, n) {
  return (t = function(r) {
    var o = function(i, a) {
      if (typeof i != "object" || !i) return i;
      var c = i[Symbol.toPrimitive];
      if (c !== void 0) {
        var l = c.call(i, a || "default");
        if (typeof l != "object") return l;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (a === "string" ? String : Number)(i);
    }(r, "string");
    return typeof o == "symbol" ? o : o + "";
  }(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function r4(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function o4(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? r4(Object(n), !0).forEach(function(r) {
      Jde(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : r4(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var i4 = { promise: Promise.resolve({ status: 200, header: function() {
  return null;
}, body: null }) };
function Qde(e, t, n, r, o) {
  if (o && !function() {
    var u = window.navigator && window.navigator.userAgent;
    if (u) {
      var d = u.match(/Chrom(e|ium)\/([0-9]+)\./);
      if (d) return parseInt(d[2], 10) < 73;
    }
    return !0;
  }()) return i4;
  var i = new window.XMLHttpRequest();
  for (var a in i.open(e, t, !o), n || {}) Object.prototype.hasOwnProperty.call(n, a) && i.setRequestHeader(a, n[a]);
  if (o) {
    try {
      i.send(r);
    } catch {
    }
    return i4;
  }
  var c, l = new Promise(function(u, d) {
    i.addEventListener("load", function() {
      c || u({ status: i.status, header: function(f) {
        return i.getResponseHeader(f);
      }, body: i.responseText });
    }), i.addEventListener("error", function() {
      c || d(new Error());
    }), i.send(r);
  });
  return { promise: l, cancel: function() {
    c = !0, i.abort();
  } };
}
var $1 = (e) => {
  if (typeof e != "string") throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};
function efe(e, t, n, r) {
  var o, i, a = ((e.kind === "substring" || e.kind === "regex") && r.includes("/") ? t : t.replace(r, "")).replace(n, "");
  switch (e.kind) {
    case "exact":
      i = t, o = new RegExp("^" + $1(e.url) + "/?$");
      break;
    case "canonical":
      i = a, o = new RegExp("^" + $1(e.url) + "/?$");
      break;
    case "substring":
      i = a, o = new RegExp(".*" + $1(e.substring) + ".*$");
      break;
    case "regex":
      i = a, o = new RegExp(e.pattern);
      break;
    default:
      return !1;
  }
  return o.test(i);
}
function a4(e, t) {
  for (var n = {}, r = null, o = [], i = 0; i < e.length; i++) for (var a = e[i], c = a.urls || [], l = 0; l < c.length; l++) if (efe(c[l], window.location.href, window.location.search, window.location.hash)) {
    a.kind === "pageview" ? t("pageview", a) : (o.push(a), t("click_pageview", a));
    break;
  }
  return o.length > 0 && (r = function(u) {
    for (var d = function(h, v) {
      for (var y = [], g = 0; g < v.length; g++) for (var b = h.target, x = v[g], $ = x.selector, S = document.querySelectorAll($); b && S.length > 0; ) {
        for (var O = 0; O < S.length; O++) b === S[O] && y.push(x);
        b = b.parentNode;
      }
      return y;
    }(u, o), f = 0; f < d.length; f++) t("click", d[f]);
  }, document.addEventListener("click", r)), n.dispose = function() {
    document.removeEventListener("click", r);
  }, n;
}
function tfe(e, t) {
  var n, r;
  function o() {
    r && r.dispose(), n && n.length && (r = a4(n, i));
  }
  function i(a, c) {
    var l = e.ident.getContext(), u = { kind: a, key: c.key, data: null, url: window.location.href, creationDate: (/* @__PURE__ */ new Date()).getTime(), context: l };
    return a === "click" && (u.selector = c.selector), e.enqueueEvent(u);
  }
  return e.requestor.fetchJSON("/sdk/goals/" + e.getEnvironmentId()).then(function(a) {
    a && a.length > 0 && (r = a4(n = a, i), function(c, l) {
      var u, d = window.location.href;
      function f() {
        (u = window.location.href) !== d && (d = u, l());
      }
      (function h(v, y) {
        v(), setTimeout(function() {
          h(v, y);
        }, y);
      })(f, c), window.history && window.history.pushState ? window.addEventListener("popstate", f) : window.addEventListener("hashchange", f);
    }(300, o)), t();
  }).catch(function(a) {
    e.emitter.maybeReportError(new Zde.LDUnexpectedResponseError((a && a.message, a.message))), t();
  }), {};
}
var dm = "goalsReady", nfe = { fetchGoals: { default: !0 }, hash: { type: "string" }, eventProcessor: { type: "object" }, eventUrlTransformer: { type: "function" }, disableSyncEventPost: { default: !1 } };
function rfe(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = function(d) {
    var f, h = { userAgentHeaderName: "X-LaunchDarkly-User-Agent", synchronousFlush: !1 };
    if (window.XMLHttpRequest) {
      var v = d && d.disableSyncEventPost;
      h.httpRequest = function(x, $, S, O) {
        var C = h.synchronousFlush & !v;
        return h.synchronousFlush = !1, Qde(x, $, S, O, C);
      };
    }
    h.httpAllowsPost = function() {
      return f === void 0 && (f = !!window.XMLHttpRequest && "withCredentials" in new window.XMLHttpRequest()), f;
    }, h.httpFallbackPing = function(x) {
      new window.Image().src = x;
    };
    var y, g = d && d.eventUrlTransformer;
    h.getCurrentUrl = function() {
      return g ? g(window.location.href) : window.location.href;
    }, h.isDoNotTrack = function() {
      var x;
      return (x = window.navigator && window.navigator.doNotTrack !== void 0 ? window.navigator.doNotTrack : window.navigator && window.navigator.msDoNotTrack !== void 0 ? window.navigator.msDoNotTrack : window.doNotTrack) === 1 || x === !0 || x === "1" || x === "yes";
    };
    try {
      window.localStorage && (h.localStorage = { get: function(x) {
        return new Promise(function($) {
          $(window.localStorage.getItem(x));
        });
      }, set: function(x, $) {
        return new Promise(function(S) {
          window.localStorage.setItem(x, $), S();
        });
      }, clear: function(x) {
        return new Promise(function($) {
          window.localStorage.removeItem(x), $();
        });
      } });
    } catch {
      h.localStorage = null;
    }
    if (d && d.useReport && typeof window.EventSourcePolyfill == "function" && window.EventSourcePolyfill.supportedOptions && window.EventSourcePolyfill.supportedOptions.method ? (h.eventSourceAllowsReport = !0, y = window.EventSourcePolyfill) : (h.eventSourceAllowsReport = !1, y = window.EventSource), window.EventSource) {
      var b = 3e5;
      h.eventSourceFactory = function(x, $) {
        var S = o4(o4({}, { heartbeatTimeout: b, silentTimeout: b, skipDefaultHeaders: !0 }), $);
        return new y(x, S);
      }, h.eventSourceIsActive = function(x) {
        return x.readyState === window.EventSource.OPEN || x.readyState === window.EventSource.CONNECTING;
      };
    }
    return h.userAgent = "JSClient", h.version = "3.5.0", h.diagnosticSdkData = { name: "js-client-sdk", version: "3.5.0" }, h.diagnosticPlatformData = { name: "JS" }, h.diagnosticUseCombinedEvent = !0, h;
  }(n), o = Xde(e, t, n, r, nfe), i = o.client, a = o.options, c = o.emitter, l = new Promise(function(d) {
    var f = c.on(dm, function() {
      c.off(dm, f), d();
    });
  });
  i.waitUntilGoalsReady = function() {
    return l;
  }, a.fetchGoals ? tfe(o, function() {
    return c.emit(dm);
  }) : c.emit(dm), document.readyState !== "complete" ? window.addEventListener("load", o.start) : o.start();
  var u = function() {
    r.synchronousFlush = !0, i.flush().catch(function() {
    }), r.synchronousFlush = !1;
  };
  return document.addEventListener("visibilitychange", function() {
    document.visibilityState === "hidden" && u();
  }), window.addEventListener("pagehide", u), i;
}
var O1, s4;
function ofe() {
  if (s4) return O1;
  s4 = 1;
  var e = 1 / 0, t = "[object Symbol]", n = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, r = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, o = "\\ud800-\\udfff", i = "\\u0300-\\u036f\\ufe20-\\ufe23", a = "\\u20d0-\\u20f0", c = "\\u2700-\\u27bf", l = "a-z\\xdf-\\xf6\\xf8-\\xff", u = "\\xac\\xb1\\xd7\\xf7", d = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", f = "\\u2000-\\u206f", h = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", v = "A-Z\\xc0-\\xd6\\xd8-\\xde", y = "\\ufe0e\\ufe0f", g = u + d + f + h, b = "['’]", x = "[" + o + "]", $ = "[" + g + "]", S = "[" + i + a + "]", O = "\\d+", C = "[" + c + "]", T = "[" + l + "]", k = "[^" + o + g + O + c + l + v + "]", I = "\\ud83c[\\udffb-\\udfff]", P = "(?:" + S + "|" + I + ")", _ = "[^" + o + "]", A = "(?:\\ud83c[\\udde6-\\uddff]){2}", D = "[\\ud800-\\udbff][\\udc00-\\udfff]", M = "[" + v + "]", N = "\\u200d", L = "(?:" + T + "|" + k + ")", z = "(?:" + M + "|" + k + ")", q = "(?:" + b + "(?:d|ll|m|re|s|t|ve))?", W = "(?:" + b + "(?:D|LL|M|RE|S|T|VE))?", U = P + "?", K = "[" + y + "]?", Y = "(?:" + N + "(?:" + [_, A, D].join("|") + ")" + K + U + ")*", X = K + U + Y, oe = "(?:" + [C, A, D].join("|") + ")" + X, re = "(?:" + [_ + S + "?", S, A, D, x].join("|") + ")", Z = RegExp(b, "g"), ce = RegExp(S, "g"), fe = RegExp(I + "(?=" + I + ")|" + re + X, "g"), de = RegExp([
    M + "?" + T + "+" + q + "(?=" + [$, M, "$"].join("|") + ")",
    z + "+" + W + "(?=" + [$, M + L, "$"].join("|") + ")",
    M + "?" + L + "+" + q,
    M + "+" + W,
    O,
    oe
  ].join("|"), "g"), ne = RegExp("[" + N + o + i + a + y + "]"), le = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, ve = {
    // Latin-1 Supplement block.
    À: "A",
    Á: "A",
    Â: "A",
    Ã: "A",
    Ä: "A",
    Å: "A",
    à: "a",
    á: "a",
    â: "a",
    ã: "a",
    ä: "a",
    å: "a",
    Ç: "C",
    ç: "c",
    Ð: "D",
    ð: "d",
    È: "E",
    É: "E",
    Ê: "E",
    Ë: "E",
    è: "e",
    é: "e",
    ê: "e",
    ë: "e",
    Ì: "I",
    Í: "I",
    Î: "I",
    Ï: "I",
    ì: "i",
    í: "i",
    î: "i",
    ï: "i",
    Ñ: "N",
    ñ: "n",
    Ò: "O",
    Ó: "O",
    Ô: "O",
    Õ: "O",
    Ö: "O",
    Ø: "O",
    ò: "o",
    ó: "o",
    ô: "o",
    õ: "o",
    ö: "o",
    ø: "o",
    Ù: "U",
    Ú: "U",
    Û: "U",
    Ü: "U",
    ù: "u",
    ú: "u",
    û: "u",
    ü: "u",
    Ý: "Y",
    ý: "y",
    ÿ: "y",
    Æ: "Ae",
    æ: "ae",
    Þ: "Th",
    þ: "th",
    ß: "ss",
    // Latin Extended-A block.
    Ā: "A",
    Ă: "A",
    Ą: "A",
    ā: "a",
    ă: "a",
    ą: "a",
    Ć: "C",
    Ĉ: "C",
    Ċ: "C",
    Č: "C",
    ć: "c",
    ĉ: "c",
    ċ: "c",
    č: "c",
    Ď: "D",
    Đ: "D",
    ď: "d",
    đ: "d",
    Ē: "E",
    Ĕ: "E",
    Ė: "E",
    Ę: "E",
    Ě: "E",
    ē: "e",
    ĕ: "e",
    ė: "e",
    ę: "e",
    ě: "e",
    Ĝ: "G",
    Ğ: "G",
    Ġ: "G",
    Ģ: "G",
    ĝ: "g",
    ğ: "g",
    ġ: "g",
    ģ: "g",
    Ĥ: "H",
    Ħ: "H",
    ĥ: "h",
    ħ: "h",
    Ĩ: "I",
    Ī: "I",
    Ĭ: "I",
    Į: "I",
    İ: "I",
    ĩ: "i",
    ī: "i",
    ĭ: "i",
    į: "i",
    ı: "i",
    Ĵ: "J",
    ĵ: "j",
    Ķ: "K",
    ķ: "k",
    ĸ: "k",
    Ĺ: "L",
    Ļ: "L",
    Ľ: "L",
    Ŀ: "L",
    Ł: "L",
    ĺ: "l",
    ļ: "l",
    ľ: "l",
    ŀ: "l",
    ł: "l",
    Ń: "N",
    Ņ: "N",
    Ň: "N",
    Ŋ: "N",
    ń: "n",
    ņ: "n",
    ň: "n",
    ŋ: "n",
    Ō: "O",
    Ŏ: "O",
    Ő: "O",
    ō: "o",
    ŏ: "o",
    ő: "o",
    Ŕ: "R",
    Ŗ: "R",
    Ř: "R",
    ŕ: "r",
    ŗ: "r",
    ř: "r",
    Ś: "S",
    Ŝ: "S",
    Ş: "S",
    Š: "S",
    ś: "s",
    ŝ: "s",
    ş: "s",
    š: "s",
    Ţ: "T",
    Ť: "T",
    Ŧ: "T",
    ţ: "t",
    ť: "t",
    ŧ: "t",
    Ũ: "U",
    Ū: "U",
    Ŭ: "U",
    Ů: "U",
    Ű: "U",
    Ų: "U",
    ũ: "u",
    ū: "u",
    ŭ: "u",
    ů: "u",
    ű: "u",
    ų: "u",
    Ŵ: "W",
    ŵ: "w",
    Ŷ: "Y",
    ŷ: "y",
    Ÿ: "Y",
    Ź: "Z",
    Ż: "Z",
    Ž: "Z",
    ź: "z",
    ż: "z",
    ž: "z",
    Ĳ: "IJ",
    ĳ: "ij",
    Œ: "Oe",
    œ: "oe",
    ŉ: "'n",
    ſ: "ss"
  }, G = typeof Vo == "object" && Vo && Vo.Object === Object && Vo, Se = typeof self == "object" && self && self.Object === Object && self, ue = G || Se || Function("return this")();
  function Q(ke, Qe, ot, Mt) {
    for (var Pt = -1, On = ke ? ke.length : 0; ++Pt < On; )
      ot = Qe(ot, ke[Pt], Pt, ke);
    return ot;
  }
  function ie(ke) {
    return ke.split("");
  }
  function ee(ke) {
    return ke.match(n) || [];
  }
  function be(ke) {
    return function(Qe) {
      return ke == null ? void 0 : ke[Qe];
    };
  }
  var Ie = be(ve);
  function je(ke) {
    return ne.test(ke);
  }
  function V(ke) {
    return le.test(ke);
  }
  function se(ke) {
    return je(ke) ? we(ke) : ie(ke);
  }
  function we(ke) {
    return ke.match(fe) || [];
  }
  function J(ke) {
    return ke.match(de) || [];
  }
  var he = Object.prototype, Te = he.toString, xe = ue.Symbol, Ae = xe ? xe.prototype : void 0, Ce = Ae ? Ae.toString : void 0;
  function Ye(ke, Qe, ot) {
    var Mt = -1, Pt = ke.length;
    Qe < 0 && (Qe = -Qe > Pt ? 0 : Pt + Qe), ot = ot > Pt ? Pt : ot, ot < 0 && (ot += Pt), Pt = Qe > ot ? 0 : ot - Qe >>> 0, Qe >>>= 0;
    for (var On = Array(Pt); ++Mt < Pt; )
      On[Mt] = ke[Mt + Qe];
    return On;
  }
  function He(ke) {
    if (typeof ke == "string")
      return ke;
    if ($e(ke))
      return Ce ? Ce.call(ke) : "";
    var Qe = ke + "";
    return Qe == "0" && 1 / ke == -e ? "-0" : Qe;
  }
  function Be(ke, Qe, ot) {
    var Mt = ke.length;
    return ot = ot === void 0 ? Mt : ot, !Qe && ot >= Mt ? ke : Ye(ke, Qe, ot);
  }
  function Xe(ke) {
    return function(Qe) {
      Qe = Ue(Qe);
      var ot = je(Qe) ? se(Qe) : void 0, Mt = ot ? ot[0] : Qe.charAt(0), Pt = ot ? Be(ot, 1).join("") : Qe.slice(1);
      return Mt[ke]() + Pt;
    };
  }
  function Ze(ke) {
    return function(Qe) {
      return Q(Je(We(Qe).replace(Z, "")), ke, "");
    };
  }
  function Ne(ke) {
    return !!ke && typeof ke == "object";
  }
  function $e(ke) {
    return typeof ke == "symbol" || Ne(ke) && Te.call(ke) == t;
  }
  function Ue(ke) {
    return ke == null ? "" : He(ke);
  }
  var Ke = Ze(function(ke, Qe, ot) {
    return Qe = Qe.toLowerCase(), ke + (ot ? Me(Qe) : Qe);
  });
  function Me(ke) {
    return at(Ue(ke).toLowerCase());
  }
  function We(ke) {
    return ke = Ue(ke), ke && ke.replace(r, Ie).replace(ce, "");
  }
  var at = Xe("toUpperCase");
  function Je(ke, Qe, ot) {
    return ke = Ue(ke), Qe = Qe, Qe === void 0 ? V(ke) ? J(ke) : ee(ke) : ke.match(Qe) || [];
  }
  return O1 = Ke, O1;
}
var ife = ofe();
const Oj = /* @__PURE__ */ jn(ife), afe = () => j0({ flags: {}, flagKeyMap: {}, ldClient: void 0 }), Pp = { useCamelCaseFlagKeys: !0, sendEventsOnFlagRead: !0, reactContext: afe() }, fm = (e) => {
  var t;
  return (t = e.context) != null ? t : e.user;
}, hS = (e) => {
  const t = {};
  for (const n in e) n.indexOf("$") !== 0 && (t[Oj(n)] = e[n]);
  return t;
}, sfe = (e, t) => {
  const n = {};
  for (const r in e) t && t[r] === void 0 || (n[r] = e[r].current);
  return n;
}, S1 = (e, t) => {
  const n = e.allFlags();
  return t ? Object.keys(t).reduce((r, o) => (r[o] = Object.prototype.hasOwnProperty.call(n, o) ? n[o] : t[o], r), {}) : n;
};
function C1(e, t, n = Pp, r) {
  const o = function(l, u) {
    return u === void 0 ? l : Object.keys(u).reduce((d, f) => (mS(l, f) && (d[f] = l[f]), d), {});
  }(t, r), { useCamelCaseFlagKeys: i = !0 } = n, [a, c = {}] = i ? function(l) {
    const u = {}, d = {};
    for (const f in l) {
      if (f.indexOf("$") === 0) continue;
      const h = Oj(f);
      u[h] = l[f], d[h] = f;
    }
    return [u, d];
  }(o) : [o];
  return { flags: n.sendEventsOnFlagRead ? cfe(e, a, c, i) : a, flagKeyMap: c };
}
function mS(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function cfe(e, t, n, r) {
  return new Proxy(t, { get(o, i, a) {
    const c = Reflect.get(o, i, a), l = r && mS(n, i) || mS(o, i);
    if (typeof i == "symbol" || !l) return c;
    if (c === void 0) return;
    const u = r ? n[i] : i;
    return e.variation(u, c);
  } });
}
hS.camelCaseKeys = hS;
const lfe = { wrapperName: "react-client-sdk", wrapperVersion: "3.6.1", sendEventsOnlyForVariation: !0 };
var ufe = Object.defineProperty, dfe = Object.defineProperties, ffe = Object.getOwnPropertyDescriptors, c4 = Object.getOwnPropertySymbols, pfe = Object.prototype.hasOwnProperty, hfe = Object.prototype.propertyIsEnumerable, l4 = (e, t, n) => t in e ? ufe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, fo = (e, t) => {
  for (var n in t || (t = {})) pfe.call(t, n) && l4(e, n, t[n]);
  if (c4) for (var n of c4(t)) hfe.call(t, n) && l4(e, n, t[n]);
  return e;
}, Fd = (e, t) => dfe(e, ffe(t)), T1 = (e, t, n) => new Promise((r, o) => {
  var i = (l) => {
    try {
      c(n.next(l));
    } catch (u) {
      o(u);
    }
  }, a = (l) => {
    try {
      c(n.throw(l));
    } catch (u) {
      o(u);
    }
  }, c = (l) => l.done ? r(l.value) : Promise.resolve(l.value).then(i, a);
  c((n = n.apply(e, t)).next());
});
let mfe = class extends AJ {
  constructor(t) {
    super(t), this.getReactOptions = () => fo(fo({}, Pp), this.props.reactOptions), this.subscribeToChanges = (r) => {
      const { flags: o } = this.props;
      r.on("change", (i) => {
        const a = this.getReactOptions(), c = sfe(i, o), l = fo(fo({}, this.state.unproxiedFlags), c);
        Object.keys(c).length > 0 && this.setState((u) => fo(Fd(fo({}, u), { unproxiedFlags: l }), C1(r, l, a, o)));
      });
    }, this.onFailed = (r, o) => {
      this.setState((i) => Fd(fo({}, i), { error: o }));
    }, this.onReady = (r, o, i) => {
      const a = S1(r, i);
      this.setState((c) => fo(Fd(fo({}, c), { unproxiedFlags: a }), C1(r, a, o, i)));
    }, this.prepareLDClient = () => T1(this, null, function* () {
      var r;
      const { clientSideID: o, flags: i, options: a } = this.props;
      let c = yield this.props.ldClient;
      const l = this.getReactOptions();
      let u, d = this.state.unproxiedFlags;
      if (c) d = S1(c, i);
      else {
        const f = (r = fm(this.props)) != null ? r : { anonymous: !0, kind: "user" };
        c = rfe(o, f, fo(fo({}, lfe), a));
        try {
          yield c.waitForInitialization(this.props.timeout), d = S1(c, i);
        } catch (h) {
          u = h, u != null && u.name.toLowerCase().includes("timeout") && (c.on("failed", this.onFailed), c.on("ready", () => {
            this.onReady(c, l, i);
          }));
        }
      }
      this.setState((f) => Fd(fo(Fd(fo({}, f), { unproxiedFlags: d }), C1(c, d, l, i)), { ldClient: c, error: u })), this.subscribeToChanges(c);
    });
    const { options: n } = t;
    if (this.state = { flags: {}, unproxiedFlags: {}, flagKeyMap: {} }, n) {
      const { bootstrap: r } = n;
      if (r && r !== "localStorage") {
        const { useCamelCaseFlagKeys: o } = this.getReactOptions();
        this.state = { flags: o ? hS(r) : r, unproxiedFlags: r, flagKeyMap: {} };
      }
    }
  }
  componentDidMount() {
    return T1(this, null, function* () {
      const { deferInitialization: t } = this.props;
      t && !fm(this.props) || (yield this.prepareLDClient());
    });
  }
  componentDidUpdate(t) {
    return T1(this, null, function* () {
      const { deferInitialization: n } = this.props, r = !fm(t) && fm(this.props);
      n && r && (yield this.prepareLDClient());
    });
  }
  render() {
    const { flags: t, flagKeyMap: n, ldClient: r, error: o } = this.state, { reactContext: i } = this.getReactOptions();
    return ye.createElement(i.Provider, { value: { flags: t, flagKeyMap: n, ldClient: r, error: o } }, this.props.children);
  }
};
var gfe = Object.defineProperty, vfe = Object.defineProperties, yfe = Object.getOwnPropertyDescriptors, u4 = Object.getOwnPropertySymbols, bfe = Object.prototype.hasOwnProperty, xfe = Object.prototype.propertyIsEnumerable, d4 = (e, t, n) => t in e ? gfe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, zd = (e, t) => {
  for (var n in t || (t = {})) bfe.call(t, n) && d4(e, n, t[n]);
  if (u4) for (var n of u4(t)) xfe.call(t, n) && d4(e, n, t[n]);
  return e;
};
function kIe(e) {
  return function(t) {
    const { reactOptions: n } = e, r = zd(zd({}, Pp), n), o = (i = zd({}, e), vfe(i, yfe({ reactOptions: r })));
    var i;
    function a(c) {
      return E.createElement(mfe, zd({}, o), E.createElement(t, zd({}, c)));
    }
    return bee(a, t), a;
  };
}
const RIe = (e) => {
  const { flags: t } = pa(e ?? Pp.reactContext);
  return t;
}, PIe = (e) => {
  const { ldClient: t } = pa(Pp.reactContext);
  return t;
}, Sj = ye.createContext(null), AIe = () => ye.useContext(Sj), IIe = (e) => {
  const { children: t, ...n } = e;
  return ye.createElement(Sj.Provider, { value: n }, t);
}, Cj = Object.fromEntries ? Object.fromEntries : (e) => {
  if (!e || !e[Symbol.iterator])
    throw new Error("Object.fromEntries() requires a single iterable argument");
  const t = {};
  return Object.keys(e).forEach((n) => {
    const [r, o] = e[n];
    t[r] = o;
  }), t;
};
function zs(e) {
  return Object.keys(e);
}
function Ec(e, t) {
  if (!e)
    throw new Error(t);
}
function jT(e, t) {
  return t;
}
const FT = (e) => {
  const t = e.length;
  let n = 0, r = "";
  for (; n < t; n++) {
    const o = e[n];
    if (o == null)
      continue;
    let i;
    switch (typeof o) {
      case "boolean":
        break;
      case "object": {
        if (Array.isArray(o))
          i = FT(o);
        else {
          Ec(!jT(o, !1)), process.env.NODE_ENV !== "production" && o.styles !== void 0 && o.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), i = "";
          for (const a in o)
            o[a] && a && (i && (i += " "), i += a);
        }
        break;
      }
      default:
        i = o;
    }
    i && (r && (r += " "), r += i);
  }
  return r;
};
function wfe(e) {
  for (var t = 0, n, r = 0, o = e.length; o >= 4; ++r, o -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var $fe = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function Ofe(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var f4 = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Sfe = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Cfe = /[A-Z]|^ms/g, Tj = /_EMO_([^_]+?)_([^]*?)_EMO_/g, zT = function(t) {
  return t.charCodeAt(1) === 45;
}, p4 = function(t) {
  return t != null && typeof t != "boolean";
}, E1 = /* @__PURE__ */ Ofe(function(e) {
  return zT(e) ? e : e.replace(Cfe, "-$&").toLowerCase();
}), qg = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(Tj, function(r, o, i) {
          return Da = {
            name: o,
            styles: i,
            next: Da
          }, o;
        });
  }
  return $fe[t] !== 1 && !zT(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var Tfe = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, Efe = ["normal", "none", "initial", "inherit", "unset"], _fe = qg, kfe = /^-ms-/, Rfe = /-(.)/g, h4 = {};
  qg = function(t, n) {
    if (t === "content" && (typeof n != "string" || Efe.indexOf(n) === -1 && !Tfe.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var r = _fe(t, n);
    return r !== "" && !zT(t) && t.indexOf("-") !== -1 && h4[t] === void 0 && (h4[t] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + t.replace(kfe, "ms-").replace(Rfe, function(o, i) {
      return i.toUpperCase();
    }) + "?")), r;
  };
}
var Ej = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Ug(e, t, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(Ej);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return Da = {
          name: n.name,
          styles: n.styles,
          next: Da
        }, n.name;
      if (n.styles !== void 0) {
        var r = n.next;
        if (r !== void 0)
          for (; r !== void 0; )
            Da = {
              name: r.name,
              styles: r.styles,
              next: Da
            }, r = r.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return Pfe(e, t, n);
    }
    case "function": {
      process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var i = [], a = n.replace(Tj, function(l, u, d) {
          var f = "animation" + i.length;
          return i.push("const " + f + " = keyframes`" + d.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + f + "}";
        });
        i.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(i, ["`" + a + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + a + "`"));
      }
      break;
  }
  if (t == null)
    return n;
  var c = t[n];
  return c !== void 0 ? c : n;
}
function Pfe(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      r += Ug(e, t, n[o]) + ";";
  else
    for (var i in n) {
      var a = n[i];
      if (typeof a != "object")
        t != null && t[a] !== void 0 ? r += i + "{" + t[a] + "}" : p4(a) && (r += E1(i) + ":" + qg(i, a) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(Ej);
        if (Array.isArray(a) && typeof a[0] == "string" && (t == null || t[a[0]] === void 0))
          for (var c = 0; c < a.length; c++)
            p4(a[c]) && (r += E1(i) + ":" + qg(i, a[c]) + ";");
        else {
          var l = Ug(e, t, a);
          switch (i) {
            case "animation":
            case "animationName": {
              r += E1(i) + ":" + l + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(Sfe), r += i + "{" + l + "}";
          }
        }
      }
    }
  return r;
}
var m4 = /label:\s*([^\s;\n{]+)\s*(;|$)/g, _j;
process.env.NODE_ENV !== "production" && (_j = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var Da, Afe = function(t, n, r) {
  if (t.length === 1 && typeof t[0] == "object" && t[0] !== null && t[0].styles !== void 0)
    return t[0];
  var o = !0, i = "";
  Da = void 0;
  var a = t[0];
  a == null || a.raw === void 0 ? (o = !1, i += Ug(r, n, a)) : (process.env.NODE_ENV !== "production" && a[0] === void 0 && console.error(f4), i += a[0]);
  for (var c = 1; c < t.length; c++)
    i += Ug(r, n, t[c]), o && (process.env.NODE_ENV !== "production" && a[c] === void 0 && console.error(f4), i += a[c]);
  var l;
  process.env.NODE_ENV !== "production" && (i = i.replace(_j, function(h) {
    return l = h, "";
  })), m4.lastIndex = 0;
  for (var u = "", d; (d = m4.exec(i)) !== null; )
    u += "-" + // $FlowFixMe we know it's not null
    d[1];
  var f = wfe(i) + u;
  return process.env.NODE_ENV !== "production" ? {
    name: f,
    styles: i,
    map: l,
    next: Da,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: f,
    styles: i,
    next: Da
  };
};
function Ife(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? t.push(e[o] + ";") : r += o + " ";
  }), r;
}
var Mfe = function(t, n, r) {
  var o = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  t.registered[o] === void 0 && (t.registered[o] = n.styles);
}, Nfe = function(t, n, r) {
  Mfe(t, n);
  var o = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var i = n;
    do
      t.insert(n === i ? "." + o : "", i, t.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function Dfe(e, t) {
  var n;
  const r = Gt();
  return (!r.current || t.length !== ((n = r.current.prevDeps) === null || n === void 0 ? void 0 : n.length) || r.current.prevDeps.map((o, i) => o === t[i]).indexOf(!1) >= 0) && (r.current = {
    v: e(),
    prevDeps: [...t]
  }), r.current.v;
}
function Lfe(e) {
  return e instanceof Object && !("styles" in e) && !("length" in e) && !("__emotion_styles" in e);
}
const { createCssAndCx: jfe } = /* @__PURE__ */ (() => {
  function e(n, r, o) {
    const i = [], a = Ife(n, i, o);
    return i.length < 2 ? o : a + r(i);
  }
  function t(n) {
    const { cache: r } = n, o = (...a) => {
      const c = Afe(a, r.registered);
      Nfe(r, c);
      const l = `${r.key}-${c.name}`;
      e: {
        const u = a[0];
        if (!Lfe(u))
          break e;
        g4.saveClassNameCSSObjectMapping(r, l, u);
      }
      return l;
    };
    return { css: o, cx: (...a) => {
      const c = FT(a), l = g4.fixClassName(r, c, o);
      return e(r.registered, o, l);
    } };
  }
  return { createCssAndCx: t };
})();
function kj(e) {
  const { useCache: t } = e;
  function n() {
    const r = t(), { css: o, cx: i } = Dfe(() => jfe({ cache: r }), [r]);
    return { css: o, cx: i };
  }
  return { useCssAndCx: n };
}
const g4 = /* @__PURE__ */ (() => {
  const e = /* @__PURE__ */ new WeakMap();
  return {
    saveClassNameCSSObjectMapping: (t, n, r) => {
      let o = e.get(t);
      o === void 0 && (o = /* @__PURE__ */ new Map(), e.set(t, o)), o.set(n, r);
    },
    fixClassName: /* @__PURE__ */ (() => {
      function t(n) {
        let r = !1;
        return n.map(([o, i]) => {
          if (i === void 0)
            return o;
          let a;
          if (r)
            a = {
              "&&": i
            };
          else {
            a = o;
            for (const c in i)
              if (c.startsWith("@media")) {
                r = !0;
                break;
              }
          }
          return a;
        });
      }
      return (n, r, o) => {
        const i = e.get(n);
        return FT(t(r.split(" ").map((a) => [
          a,
          i == null ? void 0 : i.get(a)
        ])).map((a) => typeof a == "string" ? a : o(a)));
      };
    })()
  };
})();
function Bs(e) {
  if (!(e instanceof Object) || typeof e == "function")
    return e;
  const t = [];
  for (const n in e) {
    const r = e[n], o = typeof r;
    if (!(o === "string" || o === "number" && !isNaN(r) || o === "boolean" || r === void 0 || r === null))
      return e;
    t.push(`${n}:${o}_${r}`);
  }
  return "xSqLiJdLMd9s" + t.join("|");
}
function BT(e, t, n) {
  if (!(t instanceof Object))
    return e;
  const r = {};
  return zs(e).forEach((o) => r[o] = n(e[o], t[o])), zs(t).forEach((o) => {
    if (o in e)
      return;
    const i = t[o];
    typeof i == "string" && (r[o] = i);
  }), r;
}
const Rj = ({ classes: e, theme: t, muiStyleOverridesParams: n, css: r, cx: o, name: i }) => {
  var a, c;
  e: {
    if (i === "makeStyle no name") {
      i = void 0;
      break e;
    }
    if (n !== void 0 && i === void 0)
      throw new Error("To use muiStyleOverridesParams, you must specify a name using .withName('MyComponent')");
  }
  let l;
  try {
    l = i === void 0 ? void 0 : ((c = (a = t.components) === null || a === void 0 ? void 0 : a[
      i
      /*example*/
    ]) === null || c === void 0 ? void 0 : c.styleOverrides) || void 0;
  } catch {
  }
  const u = Nn(() => {
    if (l === void 0)
      return;
    const d = {};
    for (const f in l) {
      const h = l[f];
      h instanceof Object && (d[f] = r(typeof h == "function" ? h({
        theme: t,
        ownerState: n == null ? void 0 : n.ownerState,
        ...n == null ? void 0 : n.props
      }) : h));
    }
    return d;
  }, [
    l,
    Bs(n == null ? void 0 : n.props),
    Bs(n == null ? void 0 : n.ownerState),
    r
  ]);
  return e = Nn(() => BT(e, u, o), [e, u, o]), { classes: e };
};
let Ffe = 0;
function Pj(e) {
  const { useTheme: t, cache: n } = e, { useCache: r } = Aj({ cacheProvidedAtInception: n }), { useCssAndCx: o } = kj({ useCache: r });
  function i(c) {
    const { name: l, uniqId: u = `${Ffe++}` } = c ?? {}, d = typeof l != "object" ? l : Object.keys(l)[0];
    return function(f) {
      const h = typeof f == "function" ? f : () => f;
      return function(y, g) {
        const b = t();
        let { css: x, cx: $ } = o();
        const S = r();
        let O = Nn(() => {
          const C = {}, T = typeof Proxy < "u" && new Proxy({}, {
            get: (P, _) => (typeof _ == "symbol" && Ec(!1), C[_] = `${S.key}-${u}${d !== void 0 ? `-${d}` : ""}-${_}-ref`)
          }), k = h(b, y, T || {}), I = Cj(zs(k).map((P) => {
            const _ = k[P];
            return _.label || (_.label = `${d !== void 0 ? `${d}-` : ""}${P}`), [
              P,
              `${x(_)}${jT(P, P in C) ? ` ${C[P]}` : ""}`
            ];
          }));
          return zs(C).forEach((P) => {
            P in I || (I[P] = C[P]);
          }), I;
        }, [S, x, $, b, Bs(y)]);
        {
          const C = g == null ? void 0 : g.props.classes;
          O = Nn(() => BT(O, C, $), [O, Bs(C), $]);
        }
        {
          const C = Rj({
            classes: O,
            css: x,
            cx: $,
            name: d ?? "makeStyle no name",
            idOfUseStyles: u,
            muiStyleOverridesParams: g,
            // NOTE: If it's not a Mui Theme the plugin is resilient, it will not crash
            theme: b
          });
          C.classes !== void 0 && (O = C.classes), C.css !== void 0 && (x = C.css), C.cx !== void 0 && ($ = C.cx);
        }
        return {
          classes: O,
          theme: b,
          css: x,
          cx: $
        };
      };
    };
  }
  function a() {
    const c = t(), { css: l, cx: u } = o();
    return { theme: c, css: l, cx: u };
  }
  return { makeStyles: i, useStyles: a };
}
const zfe = j0(void 0), { createUseCache: Aj } = /* @__PURE__ */ (() => {
  function e() {
    return pa(zfe);
  }
  function t(n) {
    const { cacheProvidedAtInception: r } = n;
    function o() {
      var i;
      const a = kee(), c = e(), l = (i = r ?? c) !== null && i !== void 0 ? i : a;
      if (l === null)
        throw new Error([
          "In order to get SSR working with tss-react you need to explicitly provide an Emotion cache.",
          "MUI users be aware: This is not an error strictly related to tss-react, with or without tss-react,",
          "MUI needs an Emotion cache to be provided for SSR to work.",
          "Here is the MUI documentation related to SSR setup: https://mui.com/material-ui/guides/server-rendering/",
          "TSS provides helper that makes the process of setting up SSR easier: https://docs.tss-react.dev/ssr"
        ].join(`
`));
      return l;
    }
    return { useCache: o };
  }
  return { createUseCache: t };
})();
function v4(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function Bfe(e) {
  const { useTheme: t, cache: n } = e, { makeStyles: r } = Pj({ useTheme: t, cache: n });
  function o(i, a, c) {
    const l = typeof i == "string" ? (() => {
      const v = i, y = function({ children: g, ...b }) {
        return Y8(v, b, g);
      };
      return Object.defineProperty(y, "name", {
        value: v4(v)
      }), y;
    })() : i, u = (() => {
      {
        const { name: y } = c ?? {};
        if (y !== void 0)
          return typeof y != "object" ? y : Object.keys(y)[0];
      }
      let v;
      e: {
        const y = l.displayName;
        if (typeof y != "string" || y === "")
          break e;
        v = y;
      }
      e: {
        if (v !== void 0)
          break e;
        const y = l.name;
        if (typeof y != "string" || y === "")
          break e;
        v = y;
      }
      if (v !== void 0)
        return v = v.replace(/\$/g, "usd"), v = v.replace(/\(/g, "_").replace(/\)/g, "_"), v = v.replace(/[^a-zA-Z0-9-_]/g, "_"), v;
    })(), d = r({ ...c, name: u })(typeof a == "function" ? (v, y, g) => b4(a(v, y, g)) : b4(a));
    function f(v) {
      for (const y in v)
        if (y !== "root")
          return !0;
      return !1;
    }
    const h = xp(function(v, y) {
      const { className: g, classes: b, ...x } = v, { classes: $, cx: S } = d(v, { props: v }), O = S($.root, g);
      return Ij.set($, {
        ...$,
        root: O
      }), ye.createElement(l, { ref: y, className: f($) ? g : O, ...typeof i == "string" ? {} : { classes: $ }, ...x });
    });
    return u !== void 0 && (h.displayName = `${v4(u)}WithStyles`, Object.defineProperty(h, "name", { value: h.displayName })), h;
  }
  return o.getClasses = qfe, { withStyles: o };
}
const Ij = /* @__PURE__ */ new WeakMap(), y4 = "getClasses should only be used in conjunction with withStyles";
function qfe(e) {
  const t = e.classes;
  if (t === void 0)
    throw new Error(y4);
  const n = Ij.get(t);
  if (n === void 0)
    throw new Error(y4);
  return n;
}
function b4(e) {
  const t = {}, n = {};
  return Object.keys(e).forEach((r) => (r.startsWith("@media") ? n : t)[r] = e[r]), Object.keys(n).forEach((r) => {
    const o = n[r];
    Object.keys(o).forEach((i) => {
      var a;
      return t[i] = {
        ...(a = t[i]) !== null && a !== void 0 ? a : {},
        [r]: o[i]
      };
    });
  }), t;
}
const Ufe = !(typeof document == "object" && typeof (document == null ? void 0 : document.getElementById) == "function") && !(typeof jest < "u") && !(typeof mocha < "u") && !(typeof __vitest_worker__ < "u");
function Mj(e) {
  Nj = 0, ys.splice(0, ys.length);
  const { useContext: t, usePlugin: n, cache: r } = e, { useCache: o } = Aj({ cacheProvidedAtInception: r }), { useCssAndCx: i } = kj({ useCache: o });
  return { tss: rg({
    useContext: t,
    useCache: o,
    useCssAndCx: i,
    usePlugin: n ?? (({ classes: l, cx: u, css: d }) => ({ classes: l, cx: u, css: d })),
    name: void 0,
    doesUseNestedSelectors: !1
  }) };
}
let Nj = 0;
const ys = [];
function rg(e) {
  const { useContext: t, useCache: n, useCssAndCx: r, usePlugin: o, name: i, doesUseNestedSelectors: a } = e;
  return {
    withParams: () => rg({ ...e }),
    withName: (c) => rg({
      ...e,
      name: typeof c != "object" ? c : Object.keys(c)[0]
    }),
    withNestedSelectors: () => rg({
      ...e,
      doesUseNestedSelectors: !0
    }),
    create: (c) => {
      const l = `x${Nj++}`;
      if (i !== void 0)
        for (; ; ) {
          const d = ys.find((f) => f.name === i);
          if (d === void 0)
            break;
          ys.splice(ys.indexOf(d), 1);
        }
      const u = typeof c == "function" ? c : () => c;
      return function(f) {
        var h, v, y;
        const { classesOverrides: g, ...b } = f ?? {}, x = t(), { css: $, cx: S } = r(), O = n(), C = () => {
          const I = {}, P = u({
            ...f,
            ...x,
            ...a ? {
              classes: typeof Proxy > "u" ? {} : new Proxy({}, {
                get: (A, D) => {
                  if (typeof D == "symbol" && Ec(!1), Ufe && i === void 0)
                    throw new Error([
                      "tss-react: In SSR setups, in order to use nested selectors, you must also give a unique name to the useStyle function.",
                      'Solution: Use tss.withName("ComponentName").withNestedSelectors<...>()... to set a name.'
                    ].join(`
`));
                  e: {
                    if (i === void 0)
                      break e;
                    let M = ys.find((N) => N.name === i && N.idOfUseStyles === l);
                    M === void 0 && (M = { name: i, idOfUseStyles: l, nestedSelectorRuleNames: /* @__PURE__ */ new Set() }, ys.push(M)), M.nestedSelectorRuleNames.add(D);
                  }
                  e: {
                    if (i === void 0 || !(ys.find((N) => N.name === i && N.idOfUseStyles !== l && N.nestedSelectorRuleNames.has(D)) !== void 0))
                      break e;
                    throw new Error([
                      `tss-react: There are in your codebase two different useStyles named "${i}" that`,
                      `both use use the nested selector ${D}.
`,
                      `This may lead to CSS class name collisions, causing nested selectors to target elements outside of the intended scope.
`,
                      `Solution: Ensure each useStyles using nested selectors has a unique name.
`,
                      'Use: tss.withName("UniqueName").withNestedSelectors<...>()...'
                    ].join(" "));
                  }
                  return I[D] = `${O.key}-${i !== void 0 ? i : l}-${D}-ref`;
                }
              })
            } : {}
          });
          let _ = Cj(zs(P).map((A) => {
            const D = P[A];
            return D.label || (D.label = `${i !== void 0 ? `${i}-` : ""}${A}`), [
              A,
              `${$(D)}${jT(A, A in I) ? ` ${I[A]}` : ""}`
            ];
          }));
          return zs(I).forEach((A) => {
            A in _ || (_[A] = I[A]);
          }), _ = BT(_, g, S), _;
        }, T = Wfe({
          cache: O,
          cssObjectByRuleNameOrGetCssObjectByRuleName: c,
          classesOverridesRef: Bs(g),
          paramsAndPluginParamsRef: Bs(b),
          idOfUseStyles: l,
          context: x,
          getClasses: C
        }), k = o({
          classes: T,
          css: $,
          cx: S,
          idOfUseStyles: l,
          name: i,
          ...x,
          ...b
        });
        return {
          classes: (h = k.classes) !== null && h !== void 0 ? h : T,
          css: (v = k.css) !== null && v !== void 0 ? v : $,
          cx: (y = k.cx) !== null && y !== void 0 ? y : S,
          ...x
        };
      };
    }
  };
}
const pm = /* @__PURE__ */ new WeakMap();
function Wfe(e) {
  const { cache: t, cssObjectByRuleNameOrGetCssObjectByRuleName: n, classesOverridesRef: r, paramsAndPluginParamsRef: o, idOfUseStyles: i, context: a, getClasses: c } = e;
  e: {
    const u = pm.get(t);
    if (u === void 0)
      break e;
    const d = u.get(n);
    if (d === void 0)
      break e;
    const f = d.get(r);
    if (f === void 0)
      break e;
    const h = f.get(o);
    if (h === void 0)
      break e;
    const v = h.find(({ context: y }) => {
      if (y === a)
        return !0;
      if (zs(y).length !== zs(a).length)
        return !1;
      for (const g in y)
        if (Bs(y[g]) !== Bs(a[g]))
          return !1;
      return !0;
    });
    if (v === void 0)
      break e;
    if ((v == null ? void 0 : v.idOfUseStyles) !== i) {
      h.splice(h.indexOf(v), 1);
      break e;
    }
    return v.result;
  }
  const l = c();
  {
    pm.has(t) || pm.set(t, /* @__PURE__ */ new WeakMap());
    const u = pm.get(t);
    Ec(u !== void 0), u.has(n) || u.set(n, /* @__PURE__ */ new Map());
    const d = u.get(n);
    Ec(d !== void 0), d.has(r) || (d.size > 200 && d.clear(), d.set(r, /* @__PURE__ */ new Map()));
    const f = d.get(r);
    if (Ec(f !== void 0), !f.has(o)) {
      e: {
        const v = typeof o == "string" ? 257 : 5;
        if (f.size < v)
          break e;
        f.clear();
      }
      f.set(o, []);
    }
    let h = f.get(o);
    Ec(h !== void 0), h.length > 5 && (h = []), h.push({ idOfUseStyles: i, context: a, result: l });
  }
  return l;
}
function Hfe(e) {
  return {
    ...Pj(e),
    ...Bfe(e)
  };
}
const { tss: Vfe } = Mj({
  useContext: () => ({})
});
Vfe.create({});
const { makeStyles: MIe, withStyles: NIe } = Hfe({
  useTheme: Fr
}), { tss: Yfe } = Mj({
  useContext: function() {
    return { theme: Fr() };
  },
  usePlugin: Rj
});
Yfe.create({});
const Dj = 6048e5, Gfe = 864e5, Lj = 6e4, jj = 36e5, Kfe = 1e3, x4 = Symbol.for("constructDateFrom");
function cn(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && x4 in e ? e[x4](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function st(e, t) {
  return cn(t || e, e);
}
function Vc(e, t, n) {
  const r = st(e, n == null ? void 0 : n.in);
  return isNaN(t) ? cn((n == null ? void 0 : n.in) || e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function bv(e, t, n) {
  const r = st(e, n == null ? void 0 : n.in);
  if (isNaN(t)) return cn(e, NaN);
  if (!t)
    return r;
  const o = r.getDate(), i = cn(e, r.getTime());
  i.setMonth(r.getMonth() + t + 1, 0);
  const a = i.getDate();
  return o >= a ? i : (r.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    o
  ), r);
}
function Fj(e, t, n) {
  return cn(e, +st(e) + t);
}
function Xfe(e, t, n) {
  return Fj(e, t * jj);
}
let Zfe = {};
function rl() {
  return Zfe;
}
function aa(e, t) {
  var c, l, u, d;
  const n = rl(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((d = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : d.weekStartsOn) ?? 0, o = st(e, t == null ? void 0 : t.in), i = o.getDay(), a = (i < r ? 7 : 0) + i - r;
  return o.setDate(o.getDate() - a), o.setHours(0, 0, 0, 0), o;
}
function Yc(e, t) {
  return aa(e, { ...t, weekStartsOn: 1 });
}
function zj(e, t) {
  const n = st(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = cn(n, 0);
  o.setFullYear(r + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const i = Yc(o), a = cn(n, 0);
  a.setFullYear(r, 0, 4), a.setHours(0, 0, 0, 0);
  const c = Yc(a);
  return n.getTime() >= i.getTime() ? r + 1 : n.getTime() >= c.getTime() ? r : r - 1;
}
function Wg(e) {
  const t = st(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function Xu(e, ...t) {
  const n = cn.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function _u(e, t) {
  const n = st(e, t == null ? void 0 : t.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Bj(e, t, n) {
  const [r, o] = Xu(
    n == null ? void 0 : n.in,
    e,
    t
  ), i = _u(r), a = _u(o), c = +i - Wg(i), l = +a - Wg(a);
  return Math.round((c - l) / Gfe);
}
function Jfe(e, t) {
  const n = zj(e, t), r = cn(e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), Yc(r);
}
function Qfe(e, t, n) {
  const r = st(e, n == null ? void 0 : n.in);
  return r.setTime(r.getTime() + t * Lj), r;
}
function epe(e, t, n) {
  return Fj(e, t * 1e3);
}
function qT(e, t, n) {
  return Vc(e, t * 7, n);
}
function UT(e, t, n) {
  return bv(e, t * 12, n);
}
function tpe(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = cn.bind(null, o));
    const i = st(o, r);
    (!n || n < i || isNaN(+i)) && (n = i);
  }), cn(r, n || NaN);
}
function npe(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = cn.bind(null, o));
    const i = st(o, r);
    (!n || n > i || isNaN(+i)) && (n = i);
  }), cn(r, n || NaN);
}
function qj(e, t, n) {
  const [r, o] = Xu(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return +_u(r) == +_u(o);
}
function Uj(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Wj(e) {
  return !(!Uj(e) && typeof e != "number" || isNaN(+st(e)));
}
function rpe(e, t, n) {
  const [r, o] = Xu(
    n == null ? void 0 : n.in,
    e,
    t
  ), i = r.getFullYear() - o.getFullYear(), a = r.getMonth() - o.getMonth();
  return i * 12 + a;
}
function w4(e, t) {
  const n = st(e, t == null ? void 0 : t.in);
  return n.setHours(23, 59, 59, 999), n;
}
function Hj(e, t) {
  const n = st(e, t == null ? void 0 : t.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function Vj(e, t) {
  const n = st(e, t == null ? void 0 : t.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function gS(e, t) {
  const n = st(e, t == null ? void 0 : t.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function WT(e, t) {
  const n = st(e, t == null ? void 0 : t.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function HT(e, t) {
  var c, l, u, d;
  const n = rl(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((d = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : d.weekStartsOn) ?? 0, o = st(e, t == null ? void 0 : t.in), i = o.getDay(), a = (i < r ? -7 : 0) + 6 - (i - r);
  return o.setDate(o.getDate() + a), o.setHours(23, 59, 59, 999), o;
}
function ope(e, t) {
  return HT(e, { ...t, weekStartsOn: 1 });
}
const ipe = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, ape = (e, t, n) => {
  let r;
  const o = ipe[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function _1(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const spe = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, cpe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, lpe = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, upe = {
  date: _1({
    formats: spe,
    defaultWidth: "full"
  }),
  time: _1({
    formats: cpe,
    defaultWidth: "full"
  }),
  dateTime: _1({
    formats: lpe,
    defaultWidth: "full"
  })
}, dpe = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, fpe = (e, t, n, r) => dpe[e];
function Bd(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, c = n != null && n.width ? String(n.width) : a;
      o = e.formattingValues[c] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, c = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[c] || e.values[a];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[i];
  };
}
const ppe = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, hpe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, mpe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, gpe = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, vpe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, ype = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, bpe = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, xpe = {
  ordinalNumber: bpe,
  era: Bd({
    values: ppe,
    defaultWidth: "wide"
  }),
  quarter: Bd({
    values: hpe,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Bd({
    values: mpe,
    defaultWidth: "wide"
  }),
  day: Bd({
    values: gpe,
    defaultWidth: "wide"
  }),
  dayPeriod: Bd({
    values: vpe,
    defaultWidth: "wide",
    formattingValues: ype,
    defaultFormattingWidth: "wide"
  })
};
function qd(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(o);
    if (!i)
      return null;
    const a = i[0], c = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(c) ? $pe(c, (f) => f.test(a)) : (
      // [TODO] -- I challenge you to fix the type
      wpe(c, (f) => f.test(a))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(l) : l, u = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(u)
    ) : u;
    const d = t.slice(a.length);
    return { value: u, rest: d };
  };
}
function wpe(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function $pe(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function Ope(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const o = r[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let a = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    const c = t.slice(o.length);
    return { value: a, rest: c };
  };
}
const Spe = /^(\d+)(th|st|nd|rd)?/i, Cpe = /\d+/i, Tpe = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Epe = {
  any: [/^b/i, /^(a|c)/i]
}, _pe = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, kpe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Rpe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Ppe = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Ape = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Ipe = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Mpe = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Npe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Dpe = {
  ordinalNumber: Ope({
    matchPattern: Spe,
    parsePattern: Cpe,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: qd({
    matchPatterns: Tpe,
    defaultMatchWidth: "wide",
    parsePatterns: Epe,
    defaultParseWidth: "any"
  }),
  quarter: qd({
    matchPatterns: _pe,
    defaultMatchWidth: "wide",
    parsePatterns: kpe,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: qd({
    matchPatterns: Rpe,
    defaultMatchWidth: "wide",
    parsePatterns: Ppe,
    defaultParseWidth: "any"
  }),
  day: qd({
    matchPatterns: Ape,
    defaultMatchWidth: "wide",
    parsePatterns: Ipe,
    defaultParseWidth: "any"
  }),
  dayPeriod: qd({
    matchPatterns: Mpe,
    defaultMatchWidth: "any",
    parsePatterns: Npe,
    defaultParseWidth: "any"
  })
}, Zu = {
  code: "en-US",
  formatDistance: ape,
  formatLong: upe,
  formatRelative: fpe,
  localize: xpe,
  match: Dpe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Lpe(e, t) {
  const n = st(e, t == null ? void 0 : t.in);
  return Bj(n, WT(n)) + 1;
}
function VT(e, t) {
  const n = st(e, t == null ? void 0 : t.in), r = +Yc(n) - +Jfe(n);
  return Math.round(r / Dj) + 1;
}
function YT(e, t) {
  var d, f, h, v;
  const n = st(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = rl(), i = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((f = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : f.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((v = (h = o.locale) == null ? void 0 : h.options) == null ? void 0 : v.firstWeekContainsDate) ?? 1, a = cn((t == null ? void 0 : t.in) || e, 0);
  a.setFullYear(r + 1, 0, i), a.setHours(0, 0, 0, 0);
  const c = aa(a, t), l = cn((t == null ? void 0 : t.in) || e, 0);
  l.setFullYear(r, 0, i), l.setHours(0, 0, 0, 0);
  const u = aa(l, t);
  return +n >= +c ? r + 1 : +n >= +u ? r : r - 1;
}
function jpe(e, t) {
  var c, l, u, d;
  const n = rl(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((l = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((d = (u = n.locale) == null ? void 0 : u.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, o = YT(e, t), i = cn((t == null ? void 0 : t.in) || e, 0);
  return i.setFullYear(o, 0, r), i.setHours(0, 0, 0, 0), aa(i, t);
}
function xv(e, t) {
  const n = st(e, t == null ? void 0 : t.in), r = +aa(n, t) - +jpe(n, t);
  return Math.round(r / Dj) + 1;
}
function tn(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const fs = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return tn(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : tn(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return tn(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return tn(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return tn(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return tn(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return tn(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return tn(o, t.length);
  }
}, ql = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, $4 = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return fs.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = YT(e, r), i = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const a = i % 100;
      return tn(a, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : tn(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = zj(e);
    return tn(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return tn(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return tn(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return tn(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return fs.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return tn(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = xv(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : tn(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = VT(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : tn(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : fs.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = Lpe(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : tn(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return tn(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return tn(i, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      // 2
      case "i":
        return String(o);
      // 02
      case "ii":
        return tn(o, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = ql.noon : r === 0 ? o = ql.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = ql.evening : r >= 12 ? o = ql.afternoon : r >= 4 ? o = ql.morning : o = ql.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return fs.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : fs.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : tn(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : tn(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : fs.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : fs.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return fs.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return S4(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return vc(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return vc(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return S4(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return vc(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return vc(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + O4(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + vc(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + O4(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + vc(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return tn(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return tn(+e, t.length);
  }
};
function O4(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? n + String(o) : n + String(o) + t + tn(i, 2);
}
function S4(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + tn(Math.abs(e) / 60, 2) : vc(e, t);
}
function vc(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = tn(Math.trunc(r / 60), 2), i = tn(r % 60, 2);
  return n + o + t + i;
}
const C4 = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, Yj = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, Fpe = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return C4(e, t);
  let i;
  switch (r) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", C4(r, t)).replace("{{time}}", Yj(o, t));
}, Gf = {
  p: Yj,
  P: Fpe
}, zpe = /^D+$/, Bpe = /^Y+$/, qpe = ["D", "DD", "YY", "YYYY"];
function Gj(e) {
  return zpe.test(e);
}
function Kj(e) {
  return Bpe.test(e);
}
function vS(e, t, n) {
  const r = Upe(e, t, n);
  if (console.warn(r), qpe.includes(e)) throw new RangeError(r);
}
function Upe(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Wpe = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Hpe = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Vpe = /^'([^]*?)'?$/, Ype = /''/g, Gpe = /[a-zA-Z]/;
function Xj(e, t, n) {
  var d, f, h, v, y, g, b, x;
  const r = rl(), o = (n == null ? void 0 : n.locale) ?? r.locale ?? Zu, i = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((f = (d = n == null ? void 0 : n.locale) == null ? void 0 : d.options) == null ? void 0 : f.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((v = (h = r.locale) == null ? void 0 : h.options) == null ? void 0 : v.firstWeekContainsDate) ?? 1, a = (n == null ? void 0 : n.weekStartsOn) ?? ((g = (y = n == null ? void 0 : n.locale) == null ? void 0 : y.options) == null ? void 0 : g.weekStartsOn) ?? r.weekStartsOn ?? ((x = (b = r.locale) == null ? void 0 : b.options) == null ? void 0 : x.weekStartsOn) ?? 0, c = st(e, n == null ? void 0 : n.in);
  if (!Wj(c))
    throw new RangeError("Invalid time value");
  let l = t.match(Hpe).map(($) => {
    const S = $[0];
    if (S === "p" || S === "P") {
      const O = Gf[S];
      return O($, o.formatLong);
    }
    return $;
  }).join("").match(Wpe).map(($) => {
    if ($ === "''")
      return { isToken: !1, value: "'" };
    const S = $[0];
    if (S === "'")
      return { isToken: !1, value: Kpe($) };
    if ($4[S])
      return { isToken: !0, value: $ };
    if (S.match(Gpe))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + S + "`"
      );
    return { isToken: !1, value: $ };
  });
  o.localize.preprocessor && (l = o.localize.preprocessor(c, l));
  const u = {
    firstWeekContainsDate: i,
    weekStartsOn: a,
    locale: o
  };
  return l.map(($) => {
    if (!$.isToken) return $.value;
    const S = $.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && Kj(S) || !(n != null && n.useAdditionalDayOfYearTokens) && Gj(S)) && vS(S, t, String(e));
    const O = $4[S[0]];
    return O(c, S, o.localize, u);
  }).join("");
}
function Kpe(e) {
  const t = e.match(Vpe);
  return t ? t[1].replace(Ype, "'") : e;
}
function Xpe(e, t) {
  return st(e, t == null ? void 0 : t.in).getDate();
}
function DIe(e, t) {
  return st(e, t == null ? void 0 : t.in).getDay();
}
function Zj(e, t) {
  const n = st(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = n.getMonth(), i = cn(n, 0);
  return i.setFullYear(r, o + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function LIe(e, t) {
  const r = st(e, t == null ? void 0 : t.in).getFullYear();
  return r % 400 === 0 || r % 4 === 0 && r % 100 !== 0;
}
function Zpe() {
  return Object.assign({}, rl());
}
function Jpe(e, t) {
  return st(e, t == null ? void 0 : t.in).getHours();
}
function Qpe(e, t) {
  const n = st(e, t == null ? void 0 : t.in).getDay();
  return n === 0 ? 7 : n;
}
function ehe(e) {
  return st(e).getMilliseconds();
}
function the(e, t) {
  return st(e, t == null ? void 0 : t.in).getMinutes();
}
function nhe(e, t) {
  return st(e, t == null ? void 0 : t.in).getMonth();
}
function rhe(e) {
  return st(e).getSeconds();
}
function ohe(e, t) {
  return st(e, t == null ? void 0 : t.in).getFullYear();
}
function og(e, t) {
  return +st(e) > +st(t);
}
function ig(e, t) {
  return +st(e) < +st(t);
}
function ihe(e, t) {
  return +st(e) == +st(t);
}
function ahe(e, t) {
  const n = she(t) ? new t(0) : cn(t, 0);
  return n.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), n.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), n;
}
function she(e) {
  var t;
  return typeof e == "function" && ((t = e.prototype) == null ? void 0 : t.constructor) === e;
}
const che = 10;
class Jj {
  constructor() {
    nt(this, "subPriority", 0);
  }
  validate(t, n) {
    return !0;
  }
}
class lhe extends Jj {
  constructor(t, n, r, o, i) {
    super(), this.value = t, this.validateValue = n, this.setValue = r, this.priority = o, i && (this.subPriority = i);
  }
  validate(t, n) {
    return this.validateValue(t, this.value, n);
  }
  set(t, n, r) {
    return this.setValue(t, n, this.value, r);
  }
}
class uhe extends Jj {
  constructor(n, r) {
    super();
    nt(this, "priority", che);
    nt(this, "subPriority", -1);
    this.context = n || ((o) => cn(r, o));
  }
  set(n, r) {
    return r.timestampIsSet ? n : cn(n, ahe(n, this.context));
  }
}
class Kt {
  run(t, n, r, o) {
    const i = this.parse(t, n, r, o);
    return i ? {
      setter: new lhe(
        i.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: i.rest
    } : null;
  }
  validate(t, n, r) {
    return !0;
  }
}
class dhe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 140);
    nt(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return o.era(n, { width: "abbreviated" }) || o.era(n, { width: "narrow" });
      // A, B
      case "GGGGG":
        return o.era(n, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return o.era(n, { width: "wide" }) || o.era(n, { width: "abbreviated" }) || o.era(n, { width: "narrow" });
    }
  }
  set(n, r, o) {
    return r.era = o, n.setFullYear(o, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
const Bn = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Hi = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function qn(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function _n(e, t) {
  const n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function Vi(e, t) {
  const n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  const r = n[1] === "+" ? 1 : -1, o = n[2] ? parseInt(n[2], 10) : 0, i = n[3] ? parseInt(n[3], 10) : 0, a = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (o * jj + i * Lj + a * Kfe),
    rest: t.slice(n[0].length)
  };
}
function Qj(e) {
  return _n(Bn.anyDigitsSigned, e);
}
function Ln(e, t) {
  switch (e) {
    case 1:
      return _n(Bn.singleDigit, t);
    case 2:
      return _n(Bn.twoDigits, t);
    case 3:
      return _n(Bn.threeDigits, t);
    case 4:
      return _n(Bn.fourDigits, t);
    default:
      return _n(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function Hg(e, t) {
  switch (e) {
    case 1:
      return _n(Bn.singleDigitSigned, t);
    case 2:
      return _n(Bn.twoDigitsSigned, t);
    case 3:
      return _n(Bn.threeDigitsSigned, t);
    case 4:
      return _n(Bn.fourDigitsSigned, t);
    default:
      return _n(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function GT(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function eF(e, t) {
  const n = t > 0, r = n ? t : 1 - t;
  let o;
  if (r <= 50)
    o = e || 100;
  else {
    const i = r + 50, a = Math.trunc(i / 100) * 100, c = e >= i % 100;
    o = e + a - (c ? 100 : 0);
  }
  return n ? o : 1 - o;
}
function tF(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class fhe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 130);
    nt(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, r, o) {
    const i = (a) => ({
      year: a,
      isTwoDigitYear: r === "yy"
    });
    switch (r) {
      case "y":
        return qn(Ln(4, n), i);
      case "yo":
        return qn(
          o.ordinalNumber(n, {
            unit: "year"
          }),
          i
        );
      default:
        return qn(Ln(r.length, n), i);
    }
  }
  validate(n, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(n, r, o) {
    const i = n.getFullYear();
    if (o.isTwoDigitYear) {
      const c = eF(
        o.year,
        i
      );
      return n.setFullYear(c, 0, 1), n.setHours(0, 0, 0, 0), n;
    }
    const a = !("era" in r) || r.era === 1 ? o.year : 1 - o.year;
    return n.setFullYear(a, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class phe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 130);
    nt(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    const i = (a) => ({
      year: a,
      isTwoDigitYear: r === "YY"
    });
    switch (r) {
      case "Y":
        return qn(Ln(4, n), i);
      case "Yo":
        return qn(
          o.ordinalNumber(n, {
            unit: "year"
          }),
          i
        );
      default:
        return qn(Ln(r.length, n), i);
    }
  }
  validate(n, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(n, r, o, i) {
    const a = YT(n, i);
    if (o.isTwoDigitYear) {
      const l = eF(
        o.year,
        a
      );
      return n.setFullYear(
        l,
        0,
        i.firstWeekContainsDate
      ), n.setHours(0, 0, 0, 0), aa(n, i);
    }
    const c = !("era" in r) || r.era === 1 ? o.year : 1 - o.year;
    return n.setFullYear(c, 0, i.firstWeekContainsDate), n.setHours(0, 0, 0, 0), aa(n, i);
  }
}
class hhe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 130);
    nt(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r) {
    return Hg(r === "R" ? 4 : r.length, n);
  }
  set(n, r, o) {
    const i = cn(n, 0);
    return i.setFullYear(o, 0, 4), i.setHours(0, 0, 0, 0), Yc(i);
  }
}
class mhe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 130);
    nt(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, r) {
    return Hg(r === "u" ? 4 : r.length, n);
  }
  set(n, r, o) {
    return n.setFullYear(o, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class ghe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 120);
    nt(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return Ln(r.length, n);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return o.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return o.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return o.quarter(n, {
          width: "wide",
          context: "formatting"
        }) || o.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 4;
  }
  set(n, r, o) {
    return n.setMonth((o - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class vhe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 120);
    nt(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return Ln(r.length, n);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return o.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return o.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return o.quarter(n, {
          width: "wide",
          context: "standalone"
        }) || o.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 4;
  }
  set(n, r, o) {
    return n.setMonth((o - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class yhe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    nt(this, "priority", 110);
  }
  parse(n, r, o) {
    const i = (a) => a - 1;
    switch (r) {
      // 1, 2, ..., 12
      case "M":
        return qn(
          _n(Bn.month, n),
          i
        );
      // 01, 02, ..., 12
      case "MM":
        return qn(Ln(2, n), i);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return qn(
          o.ordinalNumber(n, {
            unit: "month"
          }),
          i
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return o.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(n, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return o.month(n, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return o.month(n, { width: "wide", context: "formatting" }) || o.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, o) {
    return n.setMonth(o, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class bhe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 110);
    nt(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    const i = (a) => a - 1;
    switch (r) {
      // 1, 2, ..., 12
      case "L":
        return qn(
          _n(Bn.month, n),
          i
        );
      // 01, 02, ..., 12
      case "LL":
        return qn(Ln(2, n), i);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return qn(
          o.ordinalNumber(n, {
            unit: "month"
          }),
          i
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return o.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(n, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return o.month(n, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return o.month(n, { width: "wide", context: "standalone" }) || o.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, o) {
    return n.setMonth(o, 1), n.setHours(0, 0, 0, 0), n;
  }
}
function xhe(e, t, n) {
  const r = st(e, n == null ? void 0 : n.in), o = xv(r, n) - t;
  return r.setDate(r.getDate() - o * 7), st(r, n == null ? void 0 : n.in);
}
class whe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 100);
    nt(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "w":
        return _n(Bn.week, n);
      case "wo":
        return o.ordinalNumber(n, { unit: "week" });
      default:
        return Ln(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 53;
  }
  set(n, r, o, i) {
    return aa(xhe(n, o, i), i);
  }
}
function $he(e, t, n) {
  const r = st(e, n == null ? void 0 : n.in), o = VT(r, n) - t;
  return r.setDate(r.getDate() - o * 7), r;
}
class Ohe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 100);
    nt(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "I":
        return _n(Bn.week, n);
      case "Io":
        return o.ordinalNumber(n, { unit: "week" });
      default:
        return Ln(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 53;
  }
  set(n, r, o) {
    return Yc($he(n, o));
  }
}
const She = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Che = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class The extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 90);
    nt(this, "subPriority", 1);
    nt(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "d":
        return _n(Bn.date, n);
      case "do":
        return o.ordinalNumber(n, { unit: "date" });
      default:
        return Ln(r.length, n);
    }
  }
  validate(n, r) {
    const o = n.getFullYear(), i = tF(o), a = n.getMonth();
    return i ? r >= 1 && r <= Che[a] : r >= 1 && r <= She[a];
  }
  set(n, r, o) {
    return n.setDate(o), n.setHours(0, 0, 0, 0), n;
  }
}
class Ehe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 90);
    nt(this, "subpriority", 1);
    nt(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    switch (r) {
      case "D":
      case "DD":
        return _n(Bn.dayOfYear, n);
      case "Do":
        return o.ordinalNumber(n, { unit: "date" });
      default:
        return Ln(r.length, n);
    }
  }
  validate(n, r) {
    const o = n.getFullYear();
    return tF(o) ? r >= 1 && r <= 366 : r >= 1 && r <= 365;
  }
  set(n, r, o) {
    return n.setMonth(0, o), n.setHours(0, 0, 0, 0), n;
  }
}
function KT(e, t, n) {
  var f, h, v, y;
  const r = rl(), o = (n == null ? void 0 : n.weekStartsOn) ?? ((h = (f = n == null ? void 0 : n.locale) == null ? void 0 : f.options) == null ? void 0 : h.weekStartsOn) ?? r.weekStartsOn ?? ((y = (v = r.locale) == null ? void 0 : v.options) == null ? void 0 : y.weekStartsOn) ?? 0, i = st(e, n == null ? void 0 : n.in), a = i.getDay(), l = (t % 7 + 7) % 7, u = 7 - o, d = t < 0 || t > 6 ? t - (a + u) % 7 : (l + u) % 7 - (a + u) % 7;
  return Vc(i, d, n);
}
class _he extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 90);
    nt(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return o.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return o.day(n, { width: "wide", context: "formatting" }) || o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, o, i) {
    return n = KT(n, o, i), n.setHours(0, 0, 0, 0), n;
  }
}
class khe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 90);
    nt(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o, i) {
    const a = (c) => {
      const l = Math.floor((c - 1) / 7) * 7;
      return (c + i.weekStartsOn + 6) % 7 + l;
    };
    switch (r) {
      // 3
      case "e":
      case "ee":
        return qn(Ln(r.length, n), a);
      // 3rd
      case "eo":
        return qn(
          o.ordinalNumber(n, {
            unit: "day"
          }),
          a
        );
      // Tue
      case "eee":
        return o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return o.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return o.day(n, { width: "wide", context: "formatting" }) || o.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(n, { width: "short", context: "formatting" }) || o.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, o, i) {
    return n = KT(n, o, i), n.setHours(0, 0, 0, 0), n;
  }
}
class Rhe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 90);
    nt(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(n, r, o, i) {
    const a = (c) => {
      const l = Math.floor((c - 1) / 7) * 7;
      return (c + i.weekStartsOn + 6) % 7 + l;
    };
    switch (r) {
      // 3
      case "c":
      case "cc":
        return qn(Ln(r.length, n), a);
      // 3rd
      case "co":
        return qn(
          o.ordinalNumber(n, {
            unit: "day"
          }),
          a
        );
      // Tue
      case "ccc":
        return o.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(n, { width: "short", context: "standalone" }) || o.day(n, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return o.day(n, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return o.day(n, { width: "short", context: "standalone" }) || o.day(n, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return o.day(n, { width: "wide", context: "standalone" }) || o.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(n, { width: "short", context: "standalone" }) || o.day(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 6;
  }
  set(n, r, o, i) {
    return n = KT(n, o, i), n.setHours(0, 0, 0, 0), n;
  }
}
function Phe(e, t, n) {
  const r = st(e, n == null ? void 0 : n.in), o = Qpe(r, n), i = t - o;
  return Vc(r, i, n);
}
class Ahe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 90);
    nt(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, r, o) {
    const i = (a) => a === 0 ? 7 : a;
    switch (r) {
      // 2
      case "i":
      case "ii":
        return Ln(r.length, n);
      // 2nd
      case "io":
        return o.ordinalNumber(n, { unit: "day" });
      // Tue
      case "iii":
        return qn(
          o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      // T
      case "iiiii":
        return qn(
          o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      // Tu
      case "iiiiii":
        return qn(
          o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
      // Tuesday
      case "iiii":
      default:
        return qn(
          o.day(n, {
            width: "wide",
            context: "formatting"
          }) || o.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(n, {
            width: "short",
            context: "formatting"
          }) || o.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          i
        );
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 7;
  }
  set(n, r, o) {
    return n = Phe(n, o), n.setHours(0, 0, 0, 0), n;
  }
}
class Ihe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 80);
    nt(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "a":
      case "aa":
      case "aaa":
        return o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return o.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, o) {
    return n.setHours(GT(o), 0, 0, 0), n;
  }
}
class Mhe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 80);
    nt(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "b":
      case "bb":
      case "bbb":
        return o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return o.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, o) {
    return n.setHours(GT(o), 0, 0, 0), n;
  }
}
class Nhe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 80);
    nt(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "B":
      case "BB":
      case "BBB":
        return o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return o.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, r, o) {
    return n.setHours(GT(o), 0, 0, 0), n;
  }
}
class Dhe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 70);
    nt(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "h":
        return _n(Bn.hour12h, n);
      case "ho":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return Ln(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 12;
  }
  set(n, r, o) {
    const i = n.getHours() >= 12;
    return i && o < 12 ? n.setHours(o + 12, 0, 0, 0) : !i && o === 12 ? n.setHours(0, 0, 0, 0) : n.setHours(o, 0, 0, 0), n;
  }
}
class Lhe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 70);
    nt(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "H":
        return _n(Bn.hour23h, n);
      case "Ho":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return Ln(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 23;
  }
  set(n, r, o) {
    return n.setHours(o, 0, 0, 0), n;
  }
}
class jhe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 70);
    nt(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "K":
        return _n(Bn.hour11h, n);
      case "Ko":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return Ln(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 11;
  }
  set(n, r, o) {
    return n.getHours() >= 12 && o < 12 ? n.setHours(o + 12, 0, 0, 0) : n.setHours(o, 0, 0, 0), n;
  }
}
class Fhe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 70);
    nt(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "k":
        return _n(Bn.hour24h, n);
      case "ko":
        return o.ordinalNumber(n, { unit: "hour" });
      default:
        return Ln(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 1 && r <= 24;
  }
  set(n, r, o) {
    const i = o <= 24 ? o % 24 : o;
    return n.setHours(i, 0, 0, 0), n;
  }
}
class zhe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 60);
    nt(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "m":
        return _n(Bn.minute, n);
      case "mo":
        return o.ordinalNumber(n, { unit: "minute" });
      default:
        return Ln(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 59;
  }
  set(n, r, o) {
    return n.setMinutes(o, 0, 0), n;
  }
}
class Bhe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 50);
    nt(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r, o) {
    switch (r) {
      case "s":
        return _n(Bn.second, n);
      case "so":
        return o.ordinalNumber(n, { unit: "second" });
      default:
        return Ln(r.length, n);
    }
  }
  validate(n, r) {
    return r >= 0 && r <= 59;
  }
  set(n, r, o) {
    return n.setSeconds(o, 0), n;
  }
}
class qhe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 30);
    nt(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, r) {
    const o = (i) => Math.trunc(i * Math.pow(10, -r.length + 3));
    return qn(Ln(r.length, n), o);
  }
  set(n, r, o) {
    return n.setMilliseconds(o), n;
  }
}
class Uhe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 10);
    nt(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(n, r) {
    switch (r) {
      case "X":
        return Vi(
          Hi.basicOptionalMinutes,
          n
        );
      case "XX":
        return Vi(Hi.basic, n);
      case "XXXX":
        return Vi(
          Hi.basicOptionalSeconds,
          n
        );
      case "XXXXX":
        return Vi(
          Hi.extendedOptionalSeconds,
          n
        );
      case "XXX":
      default:
        return Vi(Hi.extended, n);
    }
  }
  set(n, r, o) {
    return r.timestampIsSet ? n : cn(
      n,
      n.getTime() - Wg(n) - o
    );
  }
}
class Whe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 10);
    nt(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(n, r) {
    switch (r) {
      case "x":
        return Vi(
          Hi.basicOptionalMinutes,
          n
        );
      case "xx":
        return Vi(Hi.basic, n);
      case "xxxx":
        return Vi(
          Hi.basicOptionalSeconds,
          n
        );
      case "xxxxx":
        return Vi(
          Hi.extendedOptionalSeconds,
          n
        );
      case "xxx":
      default:
        return Vi(Hi.extended, n);
    }
  }
  set(n, r, o) {
    return r.timestampIsSet ? n : cn(
      n,
      n.getTime() - Wg(n) - o
    );
  }
}
class Hhe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 40);
    nt(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return Qj(n);
  }
  set(n, r, o) {
    return [cn(n, o * 1e3), { timestampIsSet: !0 }];
  }
}
class Vhe extends Kt {
  constructor() {
    super(...arguments);
    nt(this, "priority", 20);
    nt(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return Qj(n);
  }
  set(n, r, o) {
    return [cn(n, o), { timestampIsSet: !0 }];
  }
}
const Yhe = {
  G: new dhe(),
  y: new fhe(),
  Y: new phe(),
  R: new hhe(),
  u: new mhe(),
  Q: new ghe(),
  q: new vhe(),
  M: new yhe(),
  L: new bhe(),
  w: new whe(),
  I: new Ohe(),
  d: new The(),
  D: new Ehe(),
  E: new _he(),
  e: new khe(),
  c: new Rhe(),
  i: new Ahe(),
  a: new Ihe(),
  b: new Mhe(),
  B: new Nhe(),
  h: new Dhe(),
  H: new Lhe(),
  K: new jhe(),
  k: new Fhe(),
  m: new zhe(),
  s: new Bhe(),
  S: new qhe(),
  X: new Uhe(),
  x: new Whe(),
  t: new Hhe(),
  T: new Vhe()
}, Ghe = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Khe = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Xhe = /^'([^]*?)'?$/, Zhe = /''/g, Jhe = /\S/, Qhe = /[a-zA-Z]/;
function eme(e, t, n, r) {
  var b, x, $, S, O, C, T, k;
  const o = () => cn((r == null ? void 0 : r.in) || n, NaN), i = Zpe(), a = (r == null ? void 0 : r.locale) ?? i.locale ?? Zu, c = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((x = (b = r == null ? void 0 : r.locale) == null ? void 0 : b.options) == null ? void 0 : x.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((S = ($ = i.locale) == null ? void 0 : $.options) == null ? void 0 : S.firstWeekContainsDate) ?? 1, l = (r == null ? void 0 : r.weekStartsOn) ?? ((C = (O = r == null ? void 0 : r.locale) == null ? void 0 : O.options) == null ? void 0 : C.weekStartsOn) ?? i.weekStartsOn ?? ((k = (T = i.locale) == null ? void 0 : T.options) == null ? void 0 : k.weekStartsOn) ?? 0;
  if (!t)
    return e ? o() : st(n, r == null ? void 0 : r.in);
  const u = {
    firstWeekContainsDate: c,
    weekStartsOn: l,
    locale: a
  }, d = [new uhe(r == null ? void 0 : r.in, n)], f = t.match(Khe).map((I) => {
    const P = I[0];
    if (P in Gf) {
      const _ = Gf[P];
      return _(I, a.formatLong);
    }
    return I;
  }).join("").match(Ghe), h = [];
  for (let I of f) {
    !(r != null && r.useAdditionalWeekYearTokens) && Kj(I) && vS(I, t, e), !(r != null && r.useAdditionalDayOfYearTokens) && Gj(I) && vS(I, t, e);
    const P = I[0], _ = Yhe[P];
    if (_) {
      const { incompatibleTokens: A } = _;
      if (Array.isArray(A)) {
        const M = h.find(
          (N) => A.includes(N.token) || N.token === P
        );
        if (M)
          throw new RangeError(
            `The format string mustn't contain \`${M.fullToken}\` and \`${I}\` at the same time`
          );
      } else if (_.incompatibleTokens === "*" && h.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${I}\` and any other token at the same time`
        );
      h.push({ token: P, fullToken: I });
      const D = _.run(
        e,
        I,
        a.match,
        u
      );
      if (!D)
        return o();
      d.push(D.setter), e = D.rest;
    } else {
      if (P.match(Qhe))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + P + "`"
        );
      if (I === "''" ? I = "'" : P === "'" && (I = tme(I)), e.indexOf(I) === 0)
        e = e.slice(I.length);
      else
        return o();
    }
  }
  if (e.length > 0 && Jhe.test(e))
    return o();
  const v = d.map((I) => I.priority).sort((I, P) => P - I).filter((I, P, _) => _.indexOf(I) === P).map(
    (I) => d.filter((P) => P.priority === I).sort((P, _) => _.subPriority - P.subPriority)
  ).map((I) => I[0]);
  let y = st(n, r == null ? void 0 : r.in);
  if (isNaN(+y)) return o();
  const g = {};
  for (const I of v) {
    if (!I.validate(y, u))
      return o();
    const P = I.set(y, g, u);
    Array.isArray(P) ? (y = P[0], Object.assign(g, P[1])) : y = P;
  }
  return y;
}
function tme(e) {
  return e.match(Xhe)[1].replace(Zhe, "'");
}
function T4(e, t) {
  const n = st(e, t == null ? void 0 : t.in);
  return n.setMinutes(0, 0, 0), n;
}
function nme(e, t, n) {
  const [r, o] = Xu(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return +T4(r) == +T4(o);
}
function nF(e, t, n) {
  const [r, o] = Xu(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear() && r.getMonth() === o.getMonth();
}
function rF(e, t, n) {
  const [r, o] = Xu(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear();
}
function rme(e, t, n) {
  const r = +st(e, n == null ? void 0 : n.in), [o, i] = [
    +st(t.start, n == null ? void 0 : n.in),
    +st(t.end, n == null ? void 0 : n.in)
  ].sort((a, c) => a - c);
  return r >= o && r <= i;
}
function jIe(e, t, n) {
  return Vc(e, -t, n);
}
function oF(e, t, n) {
  const r = st(e, n == null ? void 0 : n.in), o = r.getFullYear(), i = r.getDate(), a = cn(e, 0);
  a.setFullYear(o, t, 15), a.setHours(0, 0, 0, 0);
  const c = Zj(a);
  return r.setMonth(t, Math.min(i, c)), r;
}
function ome(e, t, n) {
  const r = st(e, n == null ? void 0 : n.in);
  return r.setDate(t), r;
}
function ime(e, t, n) {
  const r = st(e, n == null ? void 0 : n.in);
  return r.setHours(t), r;
}
function ame(e, t, n) {
  const r = st(e, n == null ? void 0 : n.in);
  return r.setMilliseconds(t), r;
}
function sme(e, t, n) {
  const r = st(e, n == null ? void 0 : n.in);
  return r.setMinutes(t), r;
}
function cme(e, t, n) {
  const r = st(e, n == null ? void 0 : n.in);
  return r.setSeconds(t), r;
}
function iF(e, t, n) {
  const r = st(e, n == null ? void 0 : n.in);
  return isNaN(+r) ? cn(e, NaN) : (r.setFullYear(t), r);
}
function FIe(e, t, n) {
  return bv(e, -t, n);
}
function zIe(e, t, n) {
  return qT(e, -t, n);
}
function BIe(e, t, n) {
  return UT(e, -t, n);
}
var k1, E4;
function lme() {
  if (E4) return k1;
  E4 = 1;
  function e(t, n, r, o) {
    var i = -1, a = t == null ? 0 : t.length;
    for (o && a && (r = t[++i]); ++i < a; )
      r = n(r, t[i], i, t);
    return r;
  }
  return k1 = e, k1;
}
var R1, _4;
function ume() {
  if (_4) return R1;
  _4 = 1;
  function e(t) {
    return function(n) {
      return t == null ? void 0 : t[n];
    };
  }
  return R1 = e, R1;
}
var P1, k4;
function dme() {
  if (k4) return P1;
  k4 = 1;
  var e = ume(), t = {
    // Latin-1 Supplement block.
    À: "A",
    Á: "A",
    Â: "A",
    Ã: "A",
    Ä: "A",
    Å: "A",
    à: "a",
    á: "a",
    â: "a",
    ã: "a",
    ä: "a",
    å: "a",
    Ç: "C",
    ç: "c",
    Ð: "D",
    ð: "d",
    È: "E",
    É: "E",
    Ê: "E",
    Ë: "E",
    è: "e",
    é: "e",
    ê: "e",
    ë: "e",
    Ì: "I",
    Í: "I",
    Î: "I",
    Ï: "I",
    ì: "i",
    í: "i",
    î: "i",
    ï: "i",
    Ñ: "N",
    ñ: "n",
    Ò: "O",
    Ó: "O",
    Ô: "O",
    Õ: "O",
    Ö: "O",
    Ø: "O",
    ò: "o",
    ó: "o",
    ô: "o",
    õ: "o",
    ö: "o",
    ø: "o",
    Ù: "U",
    Ú: "U",
    Û: "U",
    Ü: "U",
    ù: "u",
    ú: "u",
    û: "u",
    ü: "u",
    Ý: "Y",
    ý: "y",
    ÿ: "y",
    Æ: "Ae",
    æ: "ae",
    Þ: "Th",
    þ: "th",
    ß: "ss",
    // Latin Extended-A block.
    Ā: "A",
    Ă: "A",
    Ą: "A",
    ā: "a",
    ă: "a",
    ą: "a",
    Ć: "C",
    Ĉ: "C",
    Ċ: "C",
    Č: "C",
    ć: "c",
    ĉ: "c",
    ċ: "c",
    č: "c",
    Ď: "D",
    Đ: "D",
    ď: "d",
    đ: "d",
    Ē: "E",
    Ĕ: "E",
    Ė: "E",
    Ę: "E",
    Ě: "E",
    ē: "e",
    ĕ: "e",
    ė: "e",
    ę: "e",
    ě: "e",
    Ĝ: "G",
    Ğ: "G",
    Ġ: "G",
    Ģ: "G",
    ĝ: "g",
    ğ: "g",
    ġ: "g",
    ģ: "g",
    Ĥ: "H",
    Ħ: "H",
    ĥ: "h",
    ħ: "h",
    Ĩ: "I",
    Ī: "I",
    Ĭ: "I",
    Į: "I",
    İ: "I",
    ĩ: "i",
    ī: "i",
    ĭ: "i",
    į: "i",
    ı: "i",
    Ĵ: "J",
    ĵ: "j",
    Ķ: "K",
    ķ: "k",
    ĸ: "k",
    Ĺ: "L",
    Ļ: "L",
    Ľ: "L",
    Ŀ: "L",
    Ł: "L",
    ĺ: "l",
    ļ: "l",
    ľ: "l",
    ŀ: "l",
    ł: "l",
    Ń: "N",
    Ņ: "N",
    Ň: "N",
    Ŋ: "N",
    ń: "n",
    ņ: "n",
    ň: "n",
    ŋ: "n",
    Ō: "O",
    Ŏ: "O",
    Ő: "O",
    ō: "o",
    ŏ: "o",
    ő: "o",
    Ŕ: "R",
    Ŗ: "R",
    Ř: "R",
    ŕ: "r",
    ŗ: "r",
    ř: "r",
    Ś: "S",
    Ŝ: "S",
    Ş: "S",
    Š: "S",
    ś: "s",
    ŝ: "s",
    ş: "s",
    š: "s",
    Ţ: "T",
    Ť: "T",
    Ŧ: "T",
    ţ: "t",
    ť: "t",
    ŧ: "t",
    Ũ: "U",
    Ū: "U",
    Ŭ: "U",
    Ů: "U",
    Ű: "U",
    Ų: "U",
    ũ: "u",
    ū: "u",
    ŭ: "u",
    ů: "u",
    ű: "u",
    ų: "u",
    Ŵ: "W",
    ŵ: "w",
    Ŷ: "Y",
    ŷ: "y",
    Ÿ: "Y",
    Ź: "Z",
    Ż: "Z",
    Ž: "Z",
    ź: "z",
    ż: "z",
    ž: "z",
    Ĳ: "IJ",
    ĳ: "ij",
    Œ: "Oe",
    œ: "oe",
    ŉ: "'n",
    ſ: "s"
  }, n = e(t);
  return P1 = n, P1;
}
var A1, R4;
function aF() {
  if (R4) return A1;
  R4 = 1;
  var e = typeof Vo == "object" && Vo && Vo.Object === Object && Vo;
  return A1 = e, A1;
}
var I1, P4;
function ha() {
  if (P4) return I1;
  P4 = 1;
  var e = aF(), t = typeof self == "object" && self && self.Object === Object && self, n = e || t || Function("return this")();
  return I1 = n, I1;
}
var M1, A4;
function Ju() {
  if (A4) return M1;
  A4 = 1;
  var e = ha(), t = e.Symbol;
  return M1 = t, M1;
}
var N1, I4;
function Ap() {
  if (I4) return N1;
  I4 = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length, i = Array(o); ++r < o; )
      i[r] = n(t[r], r, t);
    return i;
  }
  return N1 = e, N1;
}
var D1, M4;
function Ci() {
  if (M4) return D1;
  M4 = 1;
  var e = Array.isArray;
  return D1 = e, D1;
}
var L1, N4;
function fme() {
  if (N4) return L1;
  N4 = 1;
  var e = Ju(), t = Object.prototype, n = t.hasOwnProperty, r = t.toString, o = e ? e.toStringTag : void 0;
  function i(a) {
    var c = n.call(a, o), l = a[o];
    try {
      a[o] = void 0;
      var u = !0;
    } catch {
    }
    var d = r.call(a);
    return u && (c ? a[o] = l : delete a[o]), d;
  }
  return L1 = i, L1;
}
var j1, D4;
function pme() {
  if (D4) return j1;
  D4 = 1;
  var e = Object.prototype, t = e.toString;
  function n(r) {
    return t.call(r);
  }
  return j1 = n, j1;
}
var F1, L4;
function Qu() {
  if (L4) return F1;
  L4 = 1;
  var e = Ju(), t = fme(), n = pme(), r = "[object Null]", o = "[object Undefined]", i = e ? e.toStringTag : void 0;
  function a(c) {
    return c == null ? c === void 0 ? o : r : i && i in Object(c) ? t(c) : n(c);
  }
  return F1 = a, F1;
}
var z1, j4;
function Ka() {
  if (j4) return z1;
  j4 = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return z1 = e, z1;
}
var B1, F4;
function wv() {
  if (F4) return B1;
  F4 = 1;
  var e = Qu(), t = Ka(), n = "[object Symbol]";
  function r(o) {
    return typeof o == "symbol" || t(o) && e(o) == n;
  }
  return B1 = r, B1;
}
var q1, z4;
function sF() {
  if (z4) return q1;
  z4 = 1;
  var e = Ju(), t = Ap(), n = Ci(), r = wv(), o = 1 / 0, i = e ? e.prototype : void 0, a = i ? i.toString : void 0;
  function c(l) {
    if (typeof l == "string")
      return l;
    if (n(l))
      return t(l, c) + "";
    if (r(l))
      return a ? a.call(l) : "";
    var u = l + "";
    return u == "0" && 1 / l == -o ? "-0" : u;
  }
  return q1 = c, q1;
}
var U1, B4;
function ed() {
  if (B4) return U1;
  B4 = 1;
  var e = sF();
  function t(n) {
    return n == null ? "" : e(n);
  }
  return U1 = t, U1;
}
var W1, q4;
function hme() {
  if (q4) return W1;
  q4 = 1;
  var e = dme(), t = ed(), n = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, r = "\\u0300-\\u036f", o = "\\ufe20-\\ufe2f", i = "\\u20d0-\\u20ff", a = r + o + i, c = "[" + a + "]", l = RegExp(c, "g");
  function u(d) {
    return d = t(d), d && d.replace(n, e).replace(l, "");
  }
  return W1 = u, W1;
}
var H1, U4;
function mme() {
  if (U4) return H1;
  U4 = 1;
  var e = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
  function t(n) {
    return n.match(e) || [];
  }
  return H1 = t, H1;
}
var V1, W4;
function gme() {
  if (W4) return V1;
  W4 = 1;
  var e = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
  function t(n) {
    return e.test(n);
  }
  return V1 = t, V1;
}
var Y1, H4;
function vme() {
  if (H4) return Y1;
  H4 = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", n = "\\ufe20-\\ufe2f", r = "\\u20d0-\\u20ff", o = t + n + r, i = "\\u2700-\\u27bf", a = "a-z\\xdf-\\xf6\\xf8-\\xff", c = "\\xac\\xb1\\xd7\\xf7", l = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", u = "\\u2000-\\u206f", d = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", f = "A-Z\\xc0-\\xd6\\xd8-\\xde", h = "\\ufe0e\\ufe0f", v = c + l + u + d, y = "['’]", g = "[" + v + "]", b = "[" + o + "]", x = "\\d+", $ = "[" + i + "]", S = "[" + a + "]", O = "[^" + e + v + x + i + a + f + "]", C = "\\ud83c[\\udffb-\\udfff]", T = "(?:" + b + "|" + C + ")", k = "[^" + e + "]", I = "(?:\\ud83c[\\udde6-\\uddff]){2}", P = "[\\ud800-\\udbff][\\udc00-\\udfff]", _ = "[" + f + "]", A = "\\u200d", D = "(?:" + S + "|" + O + ")", M = "(?:" + _ + "|" + O + ")", N = "(?:" + y + "(?:d|ll|m|re|s|t|ve))?", L = "(?:" + y + "(?:D|LL|M|RE|S|T|VE))?", z = T + "?", q = "[" + h + "]?", W = "(?:" + A + "(?:" + [k, I, P].join("|") + ")" + q + z + ")*", U = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", K = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Y = q + z + W, X = "(?:" + [$, I, P].join("|") + ")" + Y, oe = RegExp([
    _ + "?" + S + "+" + N + "(?=" + [g, _, "$"].join("|") + ")",
    M + "+" + L + "(?=" + [g, _ + D, "$"].join("|") + ")",
    _ + "?" + D + "+" + N,
    _ + "+" + L,
    K,
    U,
    x,
    X
  ].join("|"), "g");
  function re(Z) {
    return Z.match(oe) || [];
  }
  return Y1 = re, Y1;
}
var G1, V4;
function yme() {
  if (V4) return G1;
  V4 = 1;
  var e = mme(), t = gme(), n = ed(), r = vme();
  function o(i, a, c) {
    return i = n(i), a = c ? void 0 : a, a === void 0 ? t(i) ? r(i) : e(i) : i.match(a) || [];
  }
  return G1 = o, G1;
}
var K1, Y4;
function XT() {
  if (Y4) return K1;
  Y4 = 1;
  var e = lme(), t = hme(), n = yme(), r = "['’]", o = RegExp(r, "g");
  function i(a) {
    return function(c) {
      return e(n(t(c).replace(o, "")), a, "");
    };
  }
  return K1 = i, K1;
}
var X1, G4;
function bme() {
  if (G4) return X1;
  G4 = 1;
  var e = XT(), t = e(function(n, r, o) {
    return n + (o ? "_" : "") + r.toLowerCase();
  });
  return X1 = t, X1;
}
var xme = bme();
const qIe = /* @__PURE__ */ jn(xme);
var Z1, K4;
function cF() {
  if (K4) return Z1;
  K4 = 1;
  function e(t, n, r) {
    var o = -1, i = t.length;
    n < 0 && (n = -n > i ? 0 : i + n), r = r > i ? i : r, r < 0 && (r += i), i = n > r ? 0 : r - n >>> 0, n >>>= 0;
    for (var a = Array(i); ++o < i; )
      a[o] = t[o + n];
    return a;
  }
  return Z1 = e, Z1;
}
var J1, X4;
function lF() {
  if (X4) return J1;
  X4 = 1;
  var e = cF();
  function t(n, r, o) {
    var i = n.length;
    return o = o === void 0 ? i : o, !r && o >= i ? n : e(n, r, o);
  }
  return J1 = t, J1;
}
var Q1, Z4;
function $v() {
  if (Z4) return Q1;
  Z4 = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", n = "\\ufe20-\\ufe2f", r = "\\u20d0-\\u20ff", o = t + n + r, i = "\\ufe0e\\ufe0f", a = "\\u200d", c = RegExp("[" + a + e + o + i + "]");
  function l(u) {
    return c.test(u);
  }
  return Q1 = l, Q1;
}
var ex, J4;
function wme() {
  if (J4) return ex;
  J4 = 1;
  function e(t) {
    return t.split("");
  }
  return ex = e, ex;
}
var tx, Q4;
function $me() {
  if (Q4) return tx;
  Q4 = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", n = "\\ufe20-\\ufe2f", r = "\\u20d0-\\u20ff", o = t + n + r, i = "\\ufe0e\\ufe0f", a = "[" + e + "]", c = "[" + o + "]", l = "\\ud83c[\\udffb-\\udfff]", u = "(?:" + c + "|" + l + ")", d = "[^" + e + "]", f = "(?:\\ud83c[\\udde6-\\uddff]){2}", h = "[\\ud800-\\udbff][\\udc00-\\udfff]", v = "\\u200d", y = u + "?", g = "[" + i + "]?", b = "(?:" + v + "(?:" + [d, f, h].join("|") + ")" + g + y + ")*", x = g + y + b, $ = "(?:" + [d + c + "?", c, f, h, a].join("|") + ")", S = RegExp(l + "(?=" + l + ")|" + $ + x, "g");
  function O(C) {
    return C.match(S) || [];
  }
  return tx = O, tx;
}
var nx, e5;
function uF() {
  if (e5) return nx;
  e5 = 1;
  var e = wme(), t = $v(), n = $me();
  function r(o) {
    return t(o) ? n(o) : e(o);
  }
  return nx = r, nx;
}
var rx, t5;
function Ome() {
  if (t5) return rx;
  t5 = 1;
  var e = lF(), t = $v(), n = uF(), r = ed();
  function o(i) {
    return function(a) {
      a = r(a);
      var c = t(a) ? n(a) : void 0, l = c ? c[0] : a.charAt(0), u = c ? e(c, 1).join("") : a.slice(1);
      return l[i]() + u;
    };
  }
  return rx = o, rx;
}
var ox, n5;
function dF() {
  if (n5) return ox;
  n5 = 1;
  var e = Ome(), t = e("toUpperCase");
  return ox = t, ox;
}
var ix, r5;
function fF() {
  if (r5) return ix;
  r5 = 1;
  var e = ed(), t = dF();
  function n(r) {
    return t(e(r).toLowerCase());
  }
  return ix = n, ix;
}
var Sme = fF();
const UIe = /* @__PURE__ */ jn(Sme);
function Ov() {
  return typeof window < "u";
}
function pF(e) {
  return hF(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function td(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Cme(e) {
  var t;
  return (t = (hF(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function hF(e) {
  return Ov() ? e instanceof Node || e instanceof td(e).Node : !1;
}
function kr(e) {
  return Ov() ? e instanceof Element || e instanceof td(e).Element : !1;
}
function ZT(e) {
  return Ov() ? e instanceof HTMLElement || e instanceof td(e).HTMLElement : !1;
}
function yS(e) {
  return !Ov() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof td(e).ShadowRoot;
}
function Tme() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ax(e) {
  return ["html", "body", "#document"].includes(pF(e));
}
function mF(e) {
  return td(e).getComputedStyle(e);
}
function Eme(e) {
  if (pF(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    yS(e) && e.host || // Fallback.
    Cme(e)
  );
  return yS(t) ? t.host : t;
}
function bS(e) {
  let t = e.activeElement;
  for (; ((n = t) == null || (n = n.shadowRoot) == null ? void 0 : n.activeElement) != null; ) {
    var n;
    t = t.shadowRoot.activeElement;
  }
  return t;
}
function ku(e, t) {
  if (!e || !t)
    return !1;
  const n = t.getRootNode == null ? void 0 : t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && yS(n)) {
    let r = t;
    for (; r; ) {
      if (e === r)
        return !0;
      r = r.parentNode || r.host;
    }
  }
  return !1;
}
function gF() {
  const e = navigator.userAgentData;
  return e != null && e.platform ? e.platform : navigator.platform;
}
function vF() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: n,
      version: r
    } = t;
    return n + "/" + r;
  }).join(" ") : navigator.userAgent;
}
function _me(e) {
  return Rme() ? !1 : !o5() && e.width === 0 && e.height === 0 || o5() && e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "touch";
}
function yF() {
  return /apple/i.test(navigator.vendor);
}
function o5() {
  const e = /android/i;
  return e.test(gF()) || e.test(vF());
}
function kme() {
  return gF().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function Rme() {
  return vF().includes("jsdom/");
}
function xS(e, t) {
  const n = ["mouse", "pen"];
  return n.push("", void 0), n.includes(e);
}
function Pme(e) {
  return "nativeEvent" in e;
}
function Ame(e) {
  return e.matches("html,body");
}
function Cs(e) {
  return (e == null ? void 0 : e.ownerDocument) || document;
}
function sx(e, t) {
  if (t == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(t);
  const n = e;
  return n.target != null && t.contains(n.target);
}
function nu(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
const Ime = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function Mme(e) {
  return ZT(e) && e.matches(Ime);
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var Nme = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], wS = /* @__PURE__ */ Nme.join(","), bF = typeof Element > "u", Kf = bF ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Vg = !bF && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, Yg = function e(t, n) {
  var r;
  n === void 0 && (n = !0);
  var o = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), i = o === "" || o === "true", a = i || n && t && e(t.parentNode);
  return a;
}, Dme = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, Lme = function(t, n, r) {
  if (Yg(t))
    return [];
  var o = Array.prototype.slice.apply(t.querySelectorAll(wS));
  return n && Kf.call(t, wS) && o.unshift(t), o = o.filter(r), o;
}, jme = function e(t, n, r) {
  for (var o = [], i = Array.from(t); i.length; ) {
    var a = i.shift();
    if (!Yg(a, !1))
      if (a.tagName === "SLOT") {
        var c = a.assignedElements(), l = c.length ? c : a.children, u = e(l, !0, r);
        r.flatten ? o.push.apply(o, u) : o.push({
          scopeParent: a,
          candidates: u
        });
      } else {
        var d = Kf.call(a, wS);
        d && r.filter(a) && (n || !t.includes(a)) && o.push(a);
        var f = a.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(a), h = !Yg(f, !1) && (!r.shadowRootFilter || r.shadowRootFilter(a));
        if (f && h) {
          var v = e(f === !0 ? a.children : f.children, !0, r);
          r.flatten ? o.push.apply(o, v) : o.push({
            scopeParent: a,
            candidates: v
          });
        } else
          i.unshift.apply(i, a.children);
      }
  }
  return o;
}, xF = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, wF = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || Dme(t)) && !xF(t) ? 0 : t.tabIndex;
}, Fme = function(t, n) {
  var r = wF(t);
  return r < 0 && n && !xF(t) ? 0 : r;
}, zme = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, $F = function(t) {
  return t.tagName === "INPUT";
}, Bme = function(t) {
  return $F(t) && t.type === "hidden";
}, qme = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, Ume = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, Wme = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || Vg(t), r = function(c) {
    return n.querySelectorAll('input[type="radio"][name="' + c + '"]');
  }, o;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    o = r(window.CSS.escape(t.name));
  else
    try {
      o = r(t.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var i = Ume(o, t.form);
  return !i || i === t;
}, Hme = function(t) {
  return $F(t) && t.type === "radio";
}, Vme = function(t) {
  return Hme(t) && !Wme(t);
}, Yme = function(t) {
  var n, r = t && Vg(t), o = (n = r) === null || n === void 0 ? void 0 : n.host, i = !1;
  if (r && r !== t) {
    var a, c, l;
    for (i = !!((a = o) !== null && a !== void 0 && (c = a.ownerDocument) !== null && c !== void 0 && c.contains(o) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !i && o; ) {
      var u, d, f;
      r = Vg(o), o = (u = r) === null || u === void 0 ? void 0 : u.host, i = !!((d = o) !== null && d !== void 0 && (f = d.ownerDocument) !== null && f !== void 0 && f.contains(o));
    }
  }
  return i;
}, i5 = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, o = n.height;
  return r === 0 && o === 0;
}, Gme = function(t, n) {
  var r = n.displayCheck, o = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var i = Kf.call(t, "details>summary:first-of-type"), a = i ? t.parentElement : t;
  if (Kf.call(a, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof o == "function") {
      for (var c = t; t; ) {
        var l = t.parentElement, u = Vg(t);
        if (l && !l.shadowRoot && o(l) === !0)
          return i5(t);
        t.assignedSlot ? t = t.assignedSlot : !l && u !== t.ownerDocument ? t = u.host : t = l;
      }
      t = c;
    }
    if (Yme(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return i5(t);
  return !1;
}, Kme = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var o = n.children.item(r);
          if (o.tagName === "LEGEND")
            return Kf.call(n, "fieldset[disabled] *") ? !0 : !o.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Xme = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Yg(n) || Bme(n) || Gme(n, t) || // For a details element with a summary, the summary element gets the focus
  qme(n) || Kme(n));
}, a5 = function(t, n) {
  return !(Vme(n) || wF(n) < 0 || !Xme(t, n));
}, Zme = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, Jme = function e(t) {
  var n = [], r = [];
  return t.forEach(function(o, i) {
    var a = !!o.scopeParent, c = a ? o.scopeParent : o, l = Fme(c, a), u = a ? e(o.candidates) : c;
    l === 0 ? a ? n.push.apply(n, u) : n.push(c) : r.push({
      documentOrder: i,
      tabIndex: l,
      item: o,
      isScope: a,
      content: u
    });
  }), r.sort(zme).reduce(function(o, i) {
    return i.isScope ? o.push.apply(o, i.content) : o.push(i.content), o;
  }, []).concat(n);
}, OF = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = jme([t], n.includeContainer, {
    filter: a5.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: Zme
  }) : r = Lme(t, n.includeContainer, a5.bind(null, n)), Jme(r);
};
const Ru = Math.min, Lc = Math.max, Gg = Math.round, hm = Math.floor, qs = (e) => ({
  x: e,
  y: e
}), Qme = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, ege = {
  start: "end",
  end: "start"
};
function $S(e, t, n) {
  return Lc(e, Ru(t, n));
}
function Ip(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Gc(e) {
  return e.split("-")[0];
}
function Mp(e) {
  return e.split("-")[1];
}
function SF(e) {
  return e === "x" ? "y" : "x";
}
function JT(e) {
  return e === "y" ? "height" : "width";
}
function Sv(e) {
  return ["top", "bottom"].includes(Gc(e)) ? "y" : "x";
}
function QT(e) {
  return SF(Sv(e));
}
function tge(e, t, n) {
  n === void 0 && (n = !1);
  const r = Mp(e), o = QT(e), i = JT(o);
  let a = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = Kg(a)), [a, Kg(a)];
}
function nge(e) {
  const t = Kg(e);
  return [OS(e), t, OS(t)];
}
function OS(e) {
  return e.replace(/start|end/g, (t) => ege[t]);
}
function rge(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? i : a;
    default:
      return [];
  }
}
function oge(e, t, n, r) {
  const o = Mp(e);
  let i = rge(Gc(e), n === "start", r);
  return o && (i = i.map((a) => a + "-" + o), t && (i = i.concat(i.map(OS)))), i;
}
function Kg(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Qme[t]);
}
function ige(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function CF(e) {
  return typeof e != "number" ? ige(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Xg(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function s5(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const i = Sv(t), a = QT(t), c = JT(a), l = Gc(t), u = i === "y", d = r.x + r.width / 2 - o.width / 2, f = r.y + r.height / 2 - o.height / 2, h = r[c] / 2 - o[c] / 2;
  let v;
  switch (l) {
    case "top":
      v = {
        x: d,
        y: r.y - o.height
      };
      break;
    case "bottom":
      v = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      v = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      v = {
        x: r.x - o.width,
        y: f
      };
      break;
    default:
      v = {
        x: r.x,
        y: r.y
      };
  }
  switch (Mp(t)) {
    case "start":
      v[a] -= h * (n && u ? -1 : 1);
      break;
    case "end":
      v[a] += h * (n && u ? -1 : 1);
      break;
  }
  return v;
}
const age = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: a
  } = n, c = i.filter(Boolean), l = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let u = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: d,
    y: f
  } = s5(u, r, l), h = r, v = {}, y = 0;
  for (let g = 0; g < c.length; g++) {
    const {
      name: b,
      fn: x
    } = c[g], {
      x: $,
      y: S,
      data: O,
      reset: C
    } = await x({
      x: d,
      y: f,
      initialPlacement: r,
      placement: h,
      strategy: o,
      middlewareData: v,
      rects: u,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = $ ?? d, f = S ?? f, v = {
      ...v,
      [b]: {
        ...v[b],
        ...O
      }
    }, C && y <= 50 && (y++, typeof C == "object" && (C.placement && (h = C.placement), C.rects && (u = C.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : C.rects), {
      x: d,
      y: f
    } = s5(u, h, l)), g = -1);
  }
  return {
    x: d,
    y: f,
    placement: h,
    strategy: o,
    middlewareData: v
  };
};
async function TF(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: a,
    elements: c,
    strategy: l
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: f = "floating",
    altBoundary: h = !1,
    padding: v = 0
  } = Ip(t, e), y = CF(v), b = c[h ? f === "floating" ? "reference" : "floating" : f], x = Xg(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(b))) == null || n ? b : b.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(c.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: l
  })), $ = f === "floating" ? {
    ...a.floating,
    x: r,
    y: o
  } : a.reference, S = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c.floating)), O = await (i.isElement == null ? void 0 : i.isElement(S)) ? await (i.getScale == null ? void 0 : i.getScale(S)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, C = Xg(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: $,
    offsetParent: S,
    strategy: l
  }) : $);
  return {
    top: (x.top - C.top + y.top) / O.y,
    bottom: (C.bottom - x.bottom + y.bottom) / O.y,
    left: (x.left - C.left + y.left) / O.x,
    right: (C.right - x.right + y.right) / O.x
  };
}
const sge = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: a,
      elements: c,
      middlewareData: l
    } = t, {
      element: u,
      padding: d = 0
    } = Ip(e, t) || {};
    if (u == null)
      return {};
    const f = CF(d), h = {
      x: n,
      y: r
    }, v = QT(o), y = JT(v), g = await a.getDimensions(u), b = v === "y", x = b ? "top" : "left", $ = b ? "bottom" : "right", S = b ? "clientHeight" : "clientWidth", O = i.reference[y] + i.reference[v] - h[v] - i.floating[y], C = h[v] - i.reference[v], T = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(u));
    let k = T ? T[S] : 0;
    (!k || !await (a.isElement == null ? void 0 : a.isElement(T))) && (k = c.floating[S] || i.floating[y]);
    const I = O / 2 - C / 2, P = k / 2 - g[y] / 2 - 1, _ = Ru(f[x], P), A = Ru(f[$], P), D = _, M = k - g[y] - A, N = k / 2 - g[y] / 2 + I, L = $S(D, N, M), z = !l.arrow && Mp(o) != null && N !== L && i.reference[y] / 2 - (N < D ? _ : A) - g[y] / 2 < 0, q = z ? N < D ? N - D : N - M : 0;
    return {
      [v]: h[v] + q,
      data: {
        [v]: L,
        centerOffset: N - L - q,
        ...z && {
          alignmentOffset: q
        }
      },
      reset: z
    };
  }
}), cge = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: i,
        rects: a,
        initialPlacement: c,
        platform: l,
        elements: u
      } = t, {
        mainAxis: d = !0,
        crossAxis: f = !0,
        fallbackPlacements: h,
        fallbackStrategy: v = "bestFit",
        fallbackAxisSideDirection: y = "none",
        flipAlignment: g = !0,
        ...b
      } = Ip(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const x = Gc(o), $ = Gc(c) === c, S = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), O = h || ($ || !g ? [Kg(c)] : nge(c));
      !h && y !== "none" && O.push(...oge(c, g, y, S));
      const C = [c, ...O], T = await TF(t, b), k = [];
      let I = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (d && k.push(T[x]), f) {
        const D = tge(o, a, S);
        k.push(T[D[0]], T[D[1]]);
      }
      if (I = [...I, {
        placement: o,
        overflows: k
      }], !k.every((D) => D <= 0)) {
        var P, _;
        const D = (((P = i.flip) == null ? void 0 : P.index) || 0) + 1, M = C[D];
        if (M)
          return {
            data: {
              index: D,
              overflows: I
            },
            reset: {
              placement: M
            }
          };
        let N = (_ = I.filter((L) => L.overflows[0] <= 0).sort((L, z) => L.overflows[1] - z.overflows[1])[0]) == null ? void 0 : _.placement;
        if (!N)
          switch (v) {
            case "bestFit": {
              var A;
              const L = (A = I.map((z) => [z.placement, z.overflows.filter((q) => q > 0).reduce((q, W) => q + W, 0)]).sort((z, q) => z[1] - q[1])[0]) == null ? void 0 : A[0];
              L && (N = L);
              break;
            }
            case "initialPlacement":
              N = c;
              break;
          }
        if (o !== N)
          return {
            reset: {
              placement: N
            }
          };
      }
      return {};
    }
  };
};
async function lge(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), a = Gc(n), c = Mp(n), l = Sv(n) === "y", u = ["left", "top"].includes(a) ? -1 : 1, d = i && l ? -1 : 1, f = Ip(t, e);
  let {
    mainAxis: h,
    crossAxis: v,
    alignmentAxis: y
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...f
  };
  return c && typeof y == "number" && (v = c === "end" ? y * -1 : y), l ? {
    x: v * d,
    y: h * u
  } : {
    x: h * u,
    y: v * d
  };
}
const uge = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: i,
        placement: a,
        middlewareData: c
      } = t, l = await lge(t, e);
      return a === ((n = c.offset) == null ? void 0 : n.placement) && (r = c.arrow) != null && r.alignmentOffset ? {} : {
        x: o + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
}, dge = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: a = !1,
        limiter: c = {
          fn: (b) => {
            let {
              x,
              y: $
            } = b;
            return {
              x,
              y: $
            };
          }
        },
        ...l
      } = Ip(e, t), u = {
        x: n,
        y: r
      }, d = await TF(t, l), f = Sv(Gc(o)), h = SF(f);
      let v = u[h], y = u[f];
      if (i) {
        const b = h === "y" ? "top" : "left", x = h === "y" ? "bottom" : "right", $ = v + d[b], S = v - d[x];
        v = $S($, v, S);
      }
      if (a) {
        const b = f === "y" ? "top" : "left", x = f === "y" ? "bottom" : "right", $ = y + d[b], S = y - d[x];
        y = $S($, y, S);
      }
      const g = c.fn({
        ...t,
        [h]: v,
        [f]: y
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r
        }
      };
    }
  };
};
function nd(e) {
  return EF(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function xo(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Xa(e) {
  var t;
  return (t = (EF(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function EF(e) {
  return e instanceof Node || e instanceof xo(e).Node;
}
function sa(e) {
  return e instanceof Element || e instanceof xo(e).Element;
}
function ca(e) {
  return e instanceof HTMLElement || e instanceof xo(e).HTMLElement;
}
function c5(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof xo(e).ShadowRoot;
}
function Np(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = wi(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function fge(e) {
  return ["table", "td", "th"].includes(nd(e));
}
function eE(e) {
  const t = tE(), n = wi(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function pge(e) {
  let t = Us(e);
  for (; ca(t) && !Pu(t); ) {
    if (eE(t))
      return t;
    t = Us(t);
  }
  return null;
}
function tE() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Pu(e) {
  return ["html", "body", "#document"].includes(nd(e));
}
function wi(e) {
  return xo(e).getComputedStyle(e);
}
function Cv(e) {
  return sa(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function Us(e) {
  if (nd(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    c5(e) && e.host || // Fallback.
    Xa(e)
  );
  return c5(t) ? t.host : t;
}
function _F(e) {
  const t = Us(e);
  return Pu(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : ca(t) && Np(t) ? t : _F(t);
}
function Ps(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = _F(e), i = o === ((r = e.ownerDocument) == null ? void 0 : r.body), a = xo(o);
  return i ? t.concat(a, a.visualViewport || [], Np(o) ? o : [], a.frameElement && n ? Ps(a.frameElement) : []) : t.concat(o, Ps(o, [], n));
}
function kF(e) {
  const t = wi(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = ca(e), i = o ? e.offsetWidth : n, a = o ? e.offsetHeight : r, c = Gg(n) !== i || Gg(r) !== a;
  return c && (n = i, r = a), {
    width: n,
    height: r,
    $: c
  };
}
function nE(e) {
  return sa(e) ? e : e.contextElement;
}
function fu(e) {
  const t = nE(e);
  if (!ca(t))
    return qs(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = kF(t);
  let a = (i ? Gg(n.width) : n.width) / r, c = (i ? Gg(n.height) : n.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: a,
    y: c
  };
}
const hge = /* @__PURE__ */ qs(0);
function RF(e) {
  const t = xo(e);
  return !tE() || !t.visualViewport ? hge : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function mge(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== xo(e) ? !1 : t;
}
function Kc(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), i = nE(e);
  let a = qs(1);
  t && (r ? sa(r) && (a = fu(r)) : a = fu(e));
  const c = mge(i, n, r) ? RF(i) : qs(0);
  let l = (o.left + c.x) / a.x, u = (o.top + c.y) / a.y, d = o.width / a.x, f = o.height / a.y;
  if (i) {
    const h = xo(i), v = r && sa(r) ? xo(r) : r;
    let y = h, g = y.frameElement;
    for (; g && r && v !== y; ) {
      const b = fu(g), x = g.getBoundingClientRect(), $ = wi(g), S = x.left + (g.clientLeft + parseFloat($.paddingLeft)) * b.x, O = x.top + (g.clientTop + parseFloat($.paddingTop)) * b.y;
      l *= b.x, u *= b.y, d *= b.x, f *= b.y, l += S, u += O, y = xo(g), g = y.frameElement;
    }
  }
  return Xg({
    width: d,
    height: f,
    x: l,
    y: u
  });
}
const gge = [":popover-open", ":modal"];
function rE(e) {
  return gge.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function vge(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const i = o === "fixed", a = Xa(r), c = t ? rE(t.floating) : !1;
  if (r === a || c && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = qs(1);
  const d = qs(0), f = ca(r);
  if ((f || !f && !i) && ((nd(r) !== "body" || Np(a)) && (l = Cv(r)), ca(r))) {
    const h = Kc(r);
    u = fu(r), d.x = h.x + r.clientLeft, d.y = h.y + r.clientTop;
  }
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - l.scrollLeft * u.x + d.x,
    y: n.y * u.y - l.scrollTop * u.y + d.y
  };
}
function yge(e) {
  return Array.from(e.getClientRects());
}
function PF(e) {
  return Kc(Xa(e)).left + Cv(e).scrollLeft;
}
function bge(e) {
  const t = Xa(e), n = Cv(e), r = e.ownerDocument.body, o = Lc(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = Lc(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + PF(e);
  const c = -n.scrollTop;
  return wi(r).direction === "rtl" && (a += Lc(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: a,
    y: c
  };
}
function xge(e, t) {
  const n = xo(e), r = Xa(e), o = n.visualViewport;
  let i = r.clientWidth, a = r.clientHeight, c = 0, l = 0;
  if (o) {
    i = o.width, a = o.height;
    const u = tE();
    (!u || u && t === "fixed") && (c = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: c,
    y: l
  };
}
function wge(e, t) {
  const n = Kc(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, i = ca(e) ? fu(e) : qs(1), a = e.clientWidth * i.x, c = e.clientHeight * i.y, l = o * i.x, u = r * i.y;
  return {
    width: a,
    height: c,
    x: l,
    y: u
  };
}
function l5(e, t, n) {
  let r;
  if (t === "viewport")
    r = xge(e, n);
  else if (t === "document")
    r = bge(Xa(e));
  else if (sa(t))
    r = wge(t, n);
  else {
    const o = RF(e);
    r = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return Xg(r);
}
function AF(e, t) {
  const n = Us(e);
  return n === t || !sa(n) || Pu(n) ? !1 : wi(n).position === "fixed" || AF(n, t);
}
function $ge(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = Ps(e, [], !1).filter((c) => sa(c) && nd(c) !== "body"), o = null;
  const i = wi(e).position === "fixed";
  let a = i ? Us(e) : e;
  for (; sa(a) && !Pu(a); ) {
    const c = wi(a), l = eE(a);
    !l && c.position === "fixed" && (o = null), (i ? !l && !o : !l && c.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || Np(a) && !l && AF(e, a)) ? r = r.filter((d) => d !== a) : o = c, a = Us(a);
  }
  return t.set(e, r), r;
}
function Oge(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const a = [...n === "clippingAncestors" ? rE(t) ? [] : $ge(t, this._c) : [].concat(n), r], c = a[0], l = a.reduce((u, d) => {
    const f = l5(t, d, o);
    return u.top = Lc(f.top, u.top), u.right = Ru(f.right, u.right), u.bottom = Ru(f.bottom, u.bottom), u.left = Lc(f.left, u.left), u;
  }, l5(t, c, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function Sge(e) {
  const {
    width: t,
    height: n
  } = kF(e);
  return {
    width: t,
    height: n
  };
}
function Cge(e, t, n) {
  const r = ca(t), o = Xa(t), i = n === "fixed", a = Kc(e, !0, i, t);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = qs(0);
  if (r || !r && !i)
    if ((nd(t) !== "body" || Np(o)) && (c = Cv(t)), r) {
      const f = Kc(t, !0, i, t);
      l.x = f.x + t.clientLeft, l.y = f.y + t.clientTop;
    } else o && (l.x = PF(o));
  const u = a.left + c.scrollLeft - l.x, d = a.top + c.scrollTop - l.y;
  return {
    x: u,
    y: d,
    width: a.width,
    height: a.height
  };
}
function cx(e) {
  return wi(e).position === "static";
}
function u5(e, t) {
  return !ca(e) || wi(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function IF(e, t) {
  const n = xo(e);
  if (rE(e))
    return n;
  if (!ca(e)) {
    let o = Us(e);
    for (; o && !Pu(o); ) {
      if (sa(o) && !cx(o))
        return o;
      o = Us(o);
    }
    return n;
  }
  let r = u5(e, t);
  for (; r && fge(r) && cx(r); )
    r = u5(r, t);
  return r && Pu(r) && cx(r) && !eE(r) ? n : r || pge(e) || n;
}
const Tge = async function(e) {
  const t = this.getOffsetParent || IF, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: Cge(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Ege(e) {
  return wi(e).direction === "rtl";
}
const _ge = {
  convertOffsetParentRelativeRectToViewportRelativeRect: vge,
  getDocumentElement: Xa,
  getClippingRect: Oge,
  getOffsetParent: IF,
  getElementRects: Tge,
  getClientRects: yge,
  getDimensions: Sge,
  getScale: fu,
  isElement: sa,
  isRTL: Ege
};
function kge(e, t) {
  let n = null, r;
  const o = Xa(e);
  function i() {
    var c;
    clearTimeout(r), (c = n) == null || c.disconnect(), n = null;
  }
  function a(c, l) {
    c === void 0 && (c = !1), l === void 0 && (l = 1), i();
    const {
      left: u,
      top: d,
      width: f,
      height: h
    } = e.getBoundingClientRect();
    if (c || t(), !f || !h)
      return;
    const v = hm(d), y = hm(o.clientWidth - (u + f)), g = hm(o.clientHeight - (d + h)), b = hm(u), $ = {
      rootMargin: -v + "px " + -y + "px " + -g + "px " + -b + "px",
      threshold: Lc(0, Ru(1, l)) || 1
    };
    let S = !0;
    function O(C) {
      const T = C[0].intersectionRatio;
      if (T !== l) {
        if (!S)
          return a();
        T ? a(!1, T) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      S = !1;
    }
    try {
      n = new IntersectionObserver(O, {
        ...$,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(O, $);
    }
    n.observe(e);
  }
  return a(!0), i;
}
function WIe(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, u = nE(e), d = o || i ? [...u ? Ps(u) : [], ...Ps(t)] : [];
  d.forEach((x) => {
    o && x.addEventListener("scroll", n, {
      passive: !0
    }), i && x.addEventListener("resize", n);
  });
  const f = u && c ? kge(u, n) : null;
  let h = -1, v = null;
  a && (v = new ResizeObserver((x) => {
    let [$] = x;
    $ && $.target === u && v && (v.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var S;
      (S = v) == null || S.observe(t);
    })), n();
  }), u && !l && v.observe(u), v.observe(t));
  let y, g = l ? Kc(e) : null;
  l && b();
  function b() {
    const x = Kc(e);
    g && (x.x !== g.x || x.y !== g.y || x.width !== g.width || x.height !== g.height) && n(), g = x, y = requestAnimationFrame(b);
  }
  return n(), () => {
    var x;
    d.forEach(($) => {
      o && $.removeEventListener("scroll", n), i && $.removeEventListener("resize", n);
    }), f == null || f(), (x = v) == null || x.disconnect(), v = null, l && cancelAnimationFrame(y);
  };
}
const Rge = uge, Pge = dge, Age = cge, d5 = sge, Ige = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: _ge,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return age(e, t, {
    ...o,
    platform: i
  });
};
var ag = typeof document < "u" ? F0 : mn;
function Zg(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!Zg(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && e.$$typeof) && !Zg(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function MF(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function f5(e, t) {
  const n = MF(e);
  return Math.round(t * n) / n;
}
function lx(e) {
  const t = E.useRef(e);
  return ag(() => {
    t.current = e;
  }), t;
}
function Mge(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: a
    } = {},
    transform: c = !0,
    whileElementsMounted: l,
    open: u
  } = e, [d, f] = E.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, v] = E.useState(r);
  Zg(h, r) || v(r);
  const [y, g] = E.useState(null), [b, x] = E.useState(null), $ = E.useCallback((W) => {
    W !== T.current && (T.current = W, g(W));
  }, []), S = E.useCallback((W) => {
    W !== k.current && (k.current = W, x(W));
  }, []), O = i || y, C = a || b, T = E.useRef(null), k = E.useRef(null), I = E.useRef(d), P = l != null, _ = lx(l), A = lx(o), D = lx(u), M = E.useCallback(() => {
    if (!T.current || !k.current)
      return;
    const W = {
      placement: t,
      strategy: n,
      middleware: h
    };
    A.current && (W.platform = A.current), Ige(T.current, k.current, W).then((U) => {
      const K = {
        ...U,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: D.current !== !1
      };
      N.current && !Zg(I.current, K) && (I.current = K, nl.flushSync(() => {
        f(K);
      }));
    });
  }, [h, t, n, A, D]);
  ag(() => {
    u === !1 && I.current.isPositioned && (I.current.isPositioned = !1, f((W) => ({
      ...W,
      isPositioned: !1
    })));
  }, [u]);
  const N = E.useRef(!1);
  ag(() => (N.current = !0, () => {
    N.current = !1;
  }), []), ag(() => {
    if (O && (T.current = O), C && (k.current = C), O && C) {
      if (_.current)
        return _.current(O, C, M);
      M();
    }
  }, [O, C, M, _, P]);
  const L = E.useMemo(() => ({
    reference: T,
    floating: k,
    setReference: $,
    setFloating: S
  }), [$, S]), z = E.useMemo(() => ({
    reference: O,
    floating: C
  }), [O, C]), q = E.useMemo(() => {
    const W = {
      position: n,
      left: 0,
      top: 0
    };
    if (!z.floating)
      return W;
    const U = f5(z.floating, d.x), K = f5(z.floating, d.y);
    return c ? {
      ...W,
      transform: "translate(" + U + "px, " + K + "px)",
      ...MF(z.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: U,
      top: K
    };
  }, [n, c, z.floating, d.x, d.y]);
  return E.useMemo(() => ({
    ...d,
    update: M,
    refs: L,
    elements: z,
    floatingStyles: q
  }), [d, M, L, z, q]);
}
const Nge = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? d5({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? d5({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, HIe = (e, t) => ({
  ...Rge(e),
  options: [e, t]
}), VIe = (e, t) => ({
  ...Pge(e),
  options: [e, t]
}), YIe = (e, t) => ({
  ...Age(e),
  options: [e, t]
}), GIe = (e, t) => ({
  ...Nge(e),
  options: [e, t]
}), NF = {
  ...E
}, Dge = NF.useInsertionEffect, Lge = Dge || ((e) => e());
function Na(e) {
  const t = E.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return Lge(() => {
    t.current = e;
  }), E.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
var gr = typeof document < "u" ? F0 : mn;
function Jg() {
  return Jg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Jg.apply(this, arguments);
}
let p5 = !1, jge = 0;
const h5 = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + jge++
);
function Fge() {
  const [e, t] = E.useState(() => p5 ? h5() : void 0);
  return gr(() => {
    e == null && t(h5());
  }, []), E.useEffect(() => {
    p5 = !0;
  }, []), e;
}
const zge = NF.useId, Tv = zge || Fge;
let Xf;
process.env.NODE_ENV !== "production" && (Xf = /* @__PURE__ */ new Set());
function Bge() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const o = "Floating UI: " + n.join(" ");
  if (!((e = Xf) != null && e.has(o))) {
    var i;
    (i = Xf) == null || i.add(o), console.warn(o);
  }
}
function qge() {
  for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  const o = "Floating UI: " + n.join(" ");
  if (!((e = Xf) != null && e.has(o))) {
    var i;
    (i = Xf) == null || i.add(o), console.error(o);
  }
}
const KIe = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const {
    context: {
      placement: r,
      elements: {
        floating: o
      },
      middlewareData: {
        arrow: i,
        shift: a
      }
    },
    width: c = 14,
    height: l = 7,
    tipRadius: u = 0,
    strokeWidth: d = 0,
    staticOffset: f,
    stroke: h,
    d: v,
    style: {
      transform: y,
      ...g
    } = {},
    ...b
  } = t;
  process.env.NODE_ENV !== "production" && (n || Bge("The `ref` prop is required for `FloatingArrow`."));
  const x = Tv(), [$, S] = E.useState(!1);
  if (gr(() => {
    if (!o) return;
    mF(o).direction === "rtl" && S(!0);
  }, [o]), !o)
    return null;
  const [O, C] = r.split("-"), T = O === "top" || O === "bottom";
  let k = f;
  (T && a != null && a.x || !T && a != null && a.y) && (k = null);
  const I = d * 2, P = I / 2, _ = c / 2 * (u / -8 + 1), A = l / 2 * u / 4, D = !!v, M = k && C === "end" ? "bottom" : "top";
  let N = k && C === "end" ? "right" : "left";
  k && $ && (N = C === "end" ? "left" : "right");
  const L = (i == null ? void 0 : i.x) != null ? k || i.x : "", z = (i == null ? void 0 : i.y) != null ? k || i.y : "", q = v || "M0,0" + (" H" + c) + (" L" + (c - _) + "," + (l - A)) + (" Q" + c / 2 + "," + l + " " + _ + "," + (l - A)) + " Z", W = {
    top: D ? "rotate(180deg)" : "",
    left: D ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: D ? "" : "rotate(180deg)",
    right: D ? "rotate(-90deg)" : "rotate(90deg)"
  }[O];
  return /* @__PURE__ */ E.createElement("svg", Jg({}, b, {
    "aria-hidden": !0,
    ref: n,
    width: D ? c : c + I,
    height: c,
    viewBox: "0 0 " + c + " " + (l > c ? l : c),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [N]: L,
      [M]: z,
      [O]: T || D ? "100%" : "calc(100% - " + I / 2 + "px)",
      transform: [W, y].filter((U) => !!U).join(" "),
      ...g
    }
  }), I > 0 && /* @__PURE__ */ E.createElement("path", {
    clipPath: "url(#" + x + ")",
    fill: "none",
    stroke: h,
    strokeWidth: I + (v ? 0 : 1),
    d: q
  }), /* @__PURE__ */ E.createElement("path", {
    stroke: I && !v ? b.fill : "none",
    d: q
  }), /* @__PURE__ */ E.createElement("clipPath", {
    id: x
  }, /* @__PURE__ */ E.createElement("rect", {
    x: -P,
    y: P * (D ? -1 : 1),
    width: c + I,
    height: c
  })));
});
function Uge() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var r;
      (r = e.get(t)) == null || r.forEach((o) => o(n));
    },
    on(t, n) {
      e.set(t, [...e.get(t) || [], n]);
    },
    off(t, n) {
      var r;
      e.set(t, ((r = e.get(t)) == null ? void 0 : r.filter((o) => o !== n)) || []);
    }
  };
}
const Wge = /* @__PURE__ */ E.createContext(null), Hge = /* @__PURE__ */ E.createContext(null), oE = () => {
  var e;
  return ((e = E.useContext(Wge)) == null ? void 0 : e.id) || null;
}, iE = () => E.useContext(Hge);
function Dp(e) {
  return "data-floating-ui-" + e;
}
function _c(e) {
  const t = Gt(e);
  return gr(() => {
    t.current = e;
  }), t;
}
const m5 = /* @__PURE__ */ Dp("safe-polygon");
function sg(e, t, n) {
  return n && !xS(n) ? 0 : typeof e == "number" ? e : e == null ? void 0 : e[t];
}
function XIe(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: o,
    events: i,
    elements: a
  } = e, {
    enabled: c = !0,
    delay: l = 0,
    handleClose: u = null,
    mouseOnly: d = !1,
    restMs: f = 0,
    move: h = !0
  } = t, v = iE(), y = oE(), g = _c(u), b = _c(l), x = _c(n), $ = E.useRef(), S = E.useRef(-1), O = E.useRef(), C = E.useRef(-1), T = E.useRef(!0), k = E.useRef(!1), I = E.useRef(() => {
  }), P = E.useRef(!1), _ = E.useCallback(() => {
    var q;
    const W = (q = o.current.openEvent) == null ? void 0 : q.type;
    return (W == null ? void 0 : W.includes("mouse")) && W !== "mousedown";
  }, [o]);
  E.useEffect(() => {
    if (!c) return;
    function q(W) {
      let {
        open: U
      } = W;
      U || (clearTimeout(S.current), clearTimeout(C.current), T.current = !0, P.current = !1);
    }
    return i.on("openchange", q), () => {
      i.off("openchange", q);
    };
  }, [c, i]), E.useEffect(() => {
    if (!c || !g.current || !n) return;
    function q(U) {
      _() && r(!1, U, "hover");
    }
    const W = Cs(a.floating).documentElement;
    return W.addEventListener("mouseleave", q), () => {
      W.removeEventListener("mouseleave", q);
    };
  }, [a.floating, n, r, c, g, _]);
  const A = E.useCallback(function(q, W, U) {
    W === void 0 && (W = !0), U === void 0 && (U = "hover");
    const K = sg(b.current, "close", $.current);
    K && !O.current ? (clearTimeout(S.current), S.current = window.setTimeout(() => r(!1, q, U), K)) : W && (clearTimeout(S.current), r(!1, q, U));
  }, [b, r]), D = Na(() => {
    I.current(), O.current = void 0;
  }), M = Na(() => {
    if (k.current) {
      const q = Cs(a.floating).body;
      q.style.pointerEvents = "", q.removeAttribute(m5), k.current = !1;
    }
  }), N = Na(() => o.current.openEvent ? ["click", "mousedown"].includes(o.current.openEvent.type) : !1);
  E.useEffect(() => {
    if (!c) return;
    function q(Y) {
      if (clearTimeout(S.current), T.current = !1, d && !xS($.current) || f > 0 && !sg(b.current, "open"))
        return;
      const X = sg(b.current, "open", $.current);
      X ? S.current = window.setTimeout(() => {
        x.current || r(!0, Y, "hover");
      }, X) : n || r(!0, Y, "hover");
    }
    function W(Y) {
      if (N()) return;
      I.current();
      const X = Cs(a.floating);
      if (clearTimeout(C.current), P.current = !1, g.current && o.current.floatingContext) {
        n || clearTimeout(S.current), O.current = g.current({
          ...o.current.floatingContext,
          tree: v,
          x: Y.clientX,
          y: Y.clientY,
          onClose() {
            M(), D(), N() || A(Y, !0, "safe-polygon");
          }
        });
        const re = O.current;
        X.addEventListener("mousemove", re), I.current = () => {
          X.removeEventListener("mousemove", re);
        };
        return;
      }
      ($.current === "touch" ? !ku(a.floating, Y.relatedTarget) : !0) && A(Y);
    }
    function U(Y) {
      N() || o.current.floatingContext && (g.current == null || g.current({
        ...o.current.floatingContext,
        tree: v,
        x: Y.clientX,
        y: Y.clientY,
        onClose() {
          M(), D(), N() || A(Y);
        }
      })(Y));
    }
    if (kr(a.domReference)) {
      var K;
      const Y = a.domReference;
      return n && Y.addEventListener("mouseleave", U), (K = a.floating) == null || K.addEventListener("mouseleave", U), h && Y.addEventListener("mousemove", q, {
        once: !0
      }), Y.addEventListener("mouseenter", q), Y.addEventListener("mouseleave", W), () => {
        var X;
        n && Y.removeEventListener("mouseleave", U), (X = a.floating) == null || X.removeEventListener("mouseleave", U), h && Y.removeEventListener("mousemove", q), Y.removeEventListener("mouseenter", q), Y.removeEventListener("mouseleave", W);
      };
    }
  }, [a, c, e, d, f, h, A, D, M, r, n, x, v, b, g, o, N]), gr(() => {
    var q;
    if (c && n && (q = g.current) != null && q.__options.blockPointerEvents && _()) {
      k.current = !0;
      const U = a.floating;
      if (kr(a.domReference) && U) {
        var W;
        const K = Cs(a.floating).body;
        K.setAttribute(m5, "");
        const Y = a.domReference, X = v == null || (W = v.nodesRef.current.find((oe) => oe.id === y)) == null || (W = W.context) == null ? void 0 : W.elements.floating;
        return X && (X.style.pointerEvents = ""), K.style.pointerEvents = "none", Y.style.pointerEvents = "auto", U.style.pointerEvents = "auto", () => {
          K.style.pointerEvents = "", Y.style.pointerEvents = "", U.style.pointerEvents = "";
        };
      }
    }
  }, [c, n, y, a, v, g, _]), gr(() => {
    n || ($.current = void 0, P.current = !1, D(), M());
  }, [n, D, M]), E.useEffect(() => () => {
    D(), clearTimeout(S.current), clearTimeout(C.current), M();
  }, [c, a.domReference, D, M]);
  const L = E.useMemo(() => {
    function q(W) {
      $.current = W.pointerType;
    }
    return {
      onPointerDown: q,
      onPointerEnter: q,
      onMouseMove(W) {
        const {
          nativeEvent: U
        } = W;
        function K() {
          !T.current && !x.current && r(!0, U, "hover");
        }
        d && !xS($.current) || n || f === 0 || P.current && W.movementX ** 2 + W.movementY ** 2 < 2 || (clearTimeout(C.current), $.current === "touch" ? K() : (P.current = !0, C.current = window.setTimeout(K, f)));
      }
    };
  }, [d, r, n, x, f]), z = E.useMemo(() => ({
    onMouseEnter() {
      clearTimeout(S.current);
    },
    onMouseLeave(q) {
      N() || A(q.nativeEvent, !1);
    }
  }), [A, N]);
  return E.useMemo(() => c ? {
    reference: L,
    floating: z
  } : {}, [c, L, z]);
}
const SS = () => {
}, DF = /* @__PURE__ */ E.createContext({
  delay: 0,
  initialDelay: 0,
  timeoutMs: 0,
  currentId: null,
  setCurrentId: SS,
  setState: SS,
  isInstantPhase: !1
}), Vge = () => E.useContext(DF);
function ZIe(e) {
  const {
    children: t,
    delay: n,
    timeoutMs: r = 0
  } = e, [o, i] = E.useReducer((l, u) => ({
    ...l,
    ...u
  }), {
    delay: n,
    timeoutMs: r,
    initialDelay: n,
    currentId: null,
    isInstantPhase: !1
  }), a = E.useRef(null), c = E.useCallback((l) => {
    i({
      currentId: l
    });
  }, []);
  return gr(() => {
    o.currentId ? a.current === null ? a.current = o.currentId : o.isInstantPhase || i({
      isInstantPhase: !0
    }) : (o.isInstantPhase && i({
      isInstantPhase: !1
    }), a.current = null);
  }, [o.currentId, o.isInstantPhase]), /* @__PURE__ */ E.createElement(DF.Provider, {
    value: E.useMemo(() => ({
      ...o,
      setState: i,
      setCurrentId: c
    }), [o, c])
  }, t);
}
function JIe(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    floatingId: o
  } = e, {
    id: i,
    enabled: a = !0
  } = t, c = i ?? o, l = Vge(), {
    currentId: u,
    setCurrentId: d,
    initialDelay: f,
    setState: h,
    timeoutMs: v
  } = l;
  return gr(() => {
    a && u && (h({
      delay: {
        open: 1,
        close: sg(f, "close")
      }
    }), u !== c && r(!1));
  }, [a, c, r, h, u, f]), gr(() => {
    function y() {
      r(!1), h({
        delay: f,
        currentId: null
      });
    }
    if (a && u && !n && u === c) {
      if (v) {
        const g = window.setTimeout(y, v);
        return () => {
          clearTimeout(g);
        };
      }
      y();
    }
  }, [a, n, h, u, c, r, f, v]), gr(() => {
    a && (d === SS || !n || d(c));
  }, [a, n, d, c]), l;
}
function ux(e, t) {
  let n = e.filter((o) => {
    var i;
    return o.parentId === t && ((i = o.context) == null ? void 0 : i.open);
  }), r = n;
  for (; r.length; )
    r = e.filter((o) => {
      var i;
      return (i = r) == null ? void 0 : i.some((a) => {
        var c;
        return o.parentId === a.id && ((c = o.context) == null ? void 0 : c.open);
      });
    }), n = n.concat(r);
  return n;
}
const LF = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function jF(e, t) {
  const n = OF(e, LF());
  t === "prev" && n.reverse();
  const r = n.indexOf(bS(Cs(e)));
  return n.slice(r + 1)[0];
}
function Yge() {
  return jF(document.body, "next");
}
function Gge() {
  return jF(document.body, "prev");
}
function dx(e, t) {
  const n = t || e.currentTarget, r = e.relatedTarget;
  return !r || !ku(n, r);
}
function Kge(e) {
  OF(e, LF()).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function g5(e) {
  e.querySelectorAll("[data-tabindex]").forEach((n) => {
    const r = n.dataset.tabindex;
    delete n.dataset.tabindex, r ? n.setAttribute("tabindex", r) : n.removeAttribute("tabindex");
  });
}
const FF = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
};
let Xge;
function v5(e) {
  e.key === "Tab" && (e.target, clearTimeout(Xge));
}
const y5 = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const [r, o] = E.useState();
  gr(() => (yF() && o("button"), document.addEventListener("keydown", v5), () => {
    document.removeEventListener("keydown", v5);
  }), []);
  const i = {
    ref: n,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: r,
    "aria-hidden": r ? void 0 : !0,
    [Dp("focus-guard")]: "",
    style: FF
  };
  return /* @__PURE__ */ E.createElement("span", Jg({}, t, i));
}), zF = /* @__PURE__ */ E.createContext(null), b5 = /* @__PURE__ */ Dp("portal");
function Zge(e) {
  e === void 0 && (e = {});
  const {
    id: t,
    root: n
  } = e, r = Tv(), o = Jge(), [i, a] = E.useState(null), c = E.useRef(null);
  return gr(() => () => {
    i == null || i.remove(), queueMicrotask(() => {
      c.current = null;
    });
  }, [i]), gr(() => {
    if (!r || c.current) return;
    const l = t ? document.getElementById(t) : null;
    if (!l) return;
    const u = document.createElement("div");
    u.id = r, u.setAttribute(b5, ""), l.appendChild(u), c.current = u, a(u);
  }, [t, r]), gr(() => {
    if (n === null || !r || c.current) return;
    let l = n || (o == null ? void 0 : o.portalNode);
    l && !kr(l) && (l = l.current), l = l || document.body;
    let u = null;
    t && (u = document.createElement("div"), u.id = t, l.appendChild(u));
    const d = document.createElement("div");
    d.id = r, d.setAttribute(b5, ""), l = u || l, l.appendChild(d), c.current = d, a(d);
  }, [t, n, r, o]), i;
}
function QIe(e) {
  const {
    children: t,
    id: n,
    root: r,
    preserveTabOrder: o = !0
  } = e, i = Zge({
    id: n,
    root: r
  }), [a, c] = E.useState(null), l = E.useRef(null), u = E.useRef(null), d = E.useRef(null), f = E.useRef(null), h = a == null ? void 0 : a.modal, v = a == null ? void 0 : a.open, y = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!a && // Guards are only for non-modal focus management.
    !a.modal && // Don't render if unmount is transitioning.
    a.open && o && !!(r || i)
  );
  return E.useEffect(() => {
    if (!i || !o || h)
      return;
    function g(b) {
      i && dx(b) && (b.type === "focusin" ? g5 : Kge)(i);
    }
    return i.addEventListener("focusin", g, !0), i.addEventListener("focusout", g, !0), () => {
      i.removeEventListener("focusin", g, !0), i.removeEventListener("focusout", g, !0);
    };
  }, [i, o, h]), E.useEffect(() => {
    i && (v || g5(i));
  }, [v, i]), /* @__PURE__ */ E.createElement(zF.Provider, {
    value: E.useMemo(() => ({
      preserveTabOrder: o,
      beforeOutsideRef: l,
      afterOutsideRef: u,
      beforeInsideRef: d,
      afterInsideRef: f,
      portalNode: i,
      setFocusManagerState: c
    }), [o, i])
  }, y && i && /* @__PURE__ */ E.createElement(y5, {
    "data-type": "outside",
    ref: l,
    onFocus: (g) => {
      if (dx(g, i)) {
        var b;
        (b = d.current) == null || b.focus();
      } else {
        const x = Gge() || (a == null ? void 0 : a.refs.domReference.current);
        x == null || x.focus();
      }
    }
  }), y && i && /* @__PURE__ */ E.createElement("span", {
    "aria-owns": i.id,
    style: FF
  }), i && /* @__PURE__ */ nl.createPortal(t, i), y && i && /* @__PURE__ */ E.createElement(y5, {
    "data-type": "outside",
    ref: u,
    onFocus: (g) => {
      if (dx(g, i)) {
        var b;
        (b = f.current) == null || b.focus();
      } else {
        const x = Yge() || (a == null ? void 0 : a.refs.domReference.current);
        x == null || x.focus(), a != null && a.closeOnFocusOut && (a == null || a.onOpenChange(!1, g.nativeEvent, "focus-out"));
      }
    }
  }));
}
const Jge = () => E.useContext(zF), Qge = "data-floating-ui-focusable", e0e = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, t0e = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, x5 = (e) => {
  var t, n;
  return {
    escapeKey: typeof e == "boolean" ? e : (t = e == null ? void 0 : e.escapeKey) != null ? t : !1,
    outsidePress: typeof e == "boolean" ? e : (n = e == null ? void 0 : e.outsidePress) != null ? n : !0
  };
};
function e9e(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    elements: o,
    dataRef: i
  } = e, {
    enabled: a = !0,
    escapeKey: c = !0,
    outsidePress: l = !0,
    outsidePressEvent: u = "pointerdown",
    referencePress: d = !1,
    referencePressEvent: f = "pointerdown",
    ancestorScroll: h = !1,
    bubbles: v,
    capture: y
  } = t, g = iE(), b = Na(typeof l == "function" ? l : () => !1), x = typeof l == "function" ? b : l, $ = E.useRef(!1), S = E.useRef(!1), {
    escapeKey: O,
    outsidePress: C
  } = x5(v), {
    escapeKey: T,
    outsidePress: k
  } = x5(y), I = E.useRef(!1), P = Na((L) => {
    var z;
    if (!n || !a || !c || L.key !== "Escape" || I.current)
      return;
    const q = (z = i.current.floatingContext) == null ? void 0 : z.nodeId, W = g ? ux(g.nodesRef.current, q) : [];
    if (!O && (L.stopPropagation(), W.length > 0)) {
      let U = !0;
      if (W.forEach((K) => {
        var Y;
        if ((Y = K.context) != null && Y.open && !K.context.dataRef.current.__escapeKeyBubbles) {
          U = !1;
          return;
        }
      }), !U)
        return;
    }
    r(!1, Pme(L) ? L.nativeEvent : L, "escape-key");
  }), _ = Na((L) => {
    var z;
    const q = () => {
      var W;
      P(L), (W = nu(L)) == null || W.removeEventListener("keydown", q);
    };
    (z = nu(L)) == null || z.addEventListener("keydown", q);
  }), A = Na((L) => {
    var z;
    const q = $.current;
    $.current = !1;
    const W = S.current;
    if (S.current = !1, u === "click" && W || q || typeof x == "function" && !x(L))
      return;
    const U = nu(L), K = "[" + Dp("inert") + "]", Y = Cs(o.floating).querySelectorAll(K);
    let X = kr(U) ? U : null;
    for (; X && !ax(X); ) {
      const ce = Eme(X);
      if (ax(ce) || !kr(ce))
        break;
      X = ce;
    }
    if (Y.length && kr(U) && !Ame(U) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !ku(U, o.floating) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(Y).every((ce) => !ku(X, ce)))
      return;
    if (ZT(U) && N) {
      const ce = ax(U), fe = mF(U), de = /auto|scroll/, ne = ce || de.test(fe.overflowX), le = ce || de.test(fe.overflowY), ve = ne && U.clientWidth > 0 && U.scrollWidth > U.clientWidth, G = le && U.clientHeight > 0 && U.scrollHeight > U.clientHeight, Se = fe.direction === "rtl", ue = G && (Se ? L.offsetX <= U.offsetWidth - U.clientWidth : L.offsetX > U.clientWidth), Q = ve && L.offsetY > U.clientHeight;
      if (ue || Q)
        return;
    }
    const oe = (z = i.current.floatingContext) == null ? void 0 : z.nodeId, re = g && ux(g.nodesRef.current, oe).some((ce) => {
      var fe;
      return sx(L, (fe = ce.context) == null ? void 0 : fe.elements.floating);
    });
    if (sx(L, o.floating) || sx(L, o.domReference) || re)
      return;
    const Z = g ? ux(g.nodesRef.current, oe) : [];
    if (Z.length > 0) {
      let ce = !0;
      if (Z.forEach((fe) => {
        var de;
        if ((de = fe.context) != null && de.open && !fe.context.dataRef.current.__outsidePressBubbles) {
          ce = !1;
          return;
        }
      }), !ce)
        return;
    }
    r(!1, L, "outside-press");
  }), D = Na((L) => {
    var z;
    const q = () => {
      var W;
      A(L), (W = nu(L)) == null || W.removeEventListener(u, q);
    };
    (z = nu(L)) == null || z.addEventListener(u, q);
  });
  E.useEffect(() => {
    if (!n || !a)
      return;
    i.current.__escapeKeyBubbles = O, i.current.__outsidePressBubbles = C;
    let L = -1;
    function z(Y) {
      r(!1, Y, "ancestor-scroll");
    }
    function q() {
      window.clearTimeout(L), I.current = !0;
    }
    function W() {
      L = window.setTimeout(
        () => {
          I.current = !1;
        },
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        Tme() ? 5 : 0
      );
    }
    const U = Cs(o.floating);
    c && (U.addEventListener("keydown", T ? _ : P, T), U.addEventListener("compositionstart", q), U.addEventListener("compositionend", W)), x && U.addEventListener(u, k ? D : A, k);
    let K = [];
    return h && (kr(o.domReference) && (K = Ps(o.domReference)), kr(o.floating) && (K = K.concat(Ps(o.floating))), !kr(o.reference) && o.reference && o.reference.contextElement && (K = K.concat(Ps(o.reference.contextElement)))), K = K.filter((Y) => {
      var X;
      return Y !== ((X = U.defaultView) == null ? void 0 : X.visualViewport);
    }), K.forEach((Y) => {
      Y.addEventListener("scroll", z, {
        passive: !0
      });
    }), () => {
      c && (U.removeEventListener("keydown", T ? _ : P, T), U.removeEventListener("compositionstart", q), U.removeEventListener("compositionend", W)), x && U.removeEventListener(u, k ? D : A, k), K.forEach((Y) => {
        Y.removeEventListener("scroll", z);
      }), window.clearTimeout(L);
    };
  }, [i, o, c, x, u, n, r, h, a, O, C, P, T, _, A, k, D]), E.useEffect(() => {
    $.current = !1;
  }, [x, u]);
  const M = E.useMemo(() => ({
    onKeyDown: P,
    ...d && {
      [e0e[f]]: (L) => {
        r(!1, L.nativeEvent, "reference-press");
      },
      ...f !== "click" && {
        onClick(L) {
          r(!1, L.nativeEvent, "reference-press");
        }
      }
    }
  }), [P, r, d, f]), N = E.useMemo(() => ({
    onKeyDown: P,
    onMouseDown() {
      S.current = !0;
    },
    onMouseUp() {
      S.current = !0;
    },
    [t0e[u]]: () => {
      $.current = !0;
    }
  }), [P, u]);
  return E.useMemo(() => a ? {
    reference: M,
    floating: N
  } : {}, [a, M, N]);
}
function n0e(e) {
  const {
    open: t = !1,
    onOpenChange: n,
    elements: r
  } = e, o = Tv(), i = E.useRef({}), [a] = E.useState(() => Uge()), c = oE() != null;
  if (process.env.NODE_ENV !== "production") {
    const v = r.reference;
    v && !kr(v) && qge("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [l, u] = E.useState(r.reference), d = Na((v, y, g) => {
    i.current.openEvent = v ? y : void 0, a.emit("openchange", {
      open: v,
      event: y,
      reason: g,
      nested: c
    }), n == null || n(v, y, g);
  }), f = E.useMemo(() => ({
    setPositionReference: u
  }), []), h = E.useMemo(() => ({
    reference: l || r.reference || null,
    floating: r.floating || null,
    domReference: r.reference
  }), [l, r.reference, r.floating]);
  return E.useMemo(() => ({
    dataRef: i,
    open: t,
    onOpenChange: d,
    elements: h,
    events: a,
    floatingId: o,
    refs: f
  }), [t, d, h, a, o, f]);
}
function t9e(e) {
  e === void 0 && (e = {});
  const {
    nodeId: t
  } = e, n = n0e({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), r = e.rootContext || n, o = r.elements, [i, a] = E.useState(null), [c, l] = E.useState(null), d = (o == null ? void 0 : o.domReference) || i, f = E.useRef(null), h = iE();
  gr(() => {
    d && (f.current = d);
  }, [d]);
  const v = Mge({
    ...e,
    elements: {
      ...o,
      ...c && {
        reference: c
      }
    }
  }), y = E.useCallback((S) => {
    const O = kr(S) ? {
      getBoundingClientRect: () => S.getBoundingClientRect(),
      contextElement: S
    } : S;
    l(O), v.refs.setReference(O);
  }, [v.refs]), g = E.useCallback((S) => {
    (kr(S) || S === null) && (f.current = S, a(S)), (kr(v.refs.reference.current) || v.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    S !== null && !kr(S)) && v.refs.setReference(S);
  }, [v.refs]), b = E.useMemo(() => ({
    ...v.refs,
    setReference: g,
    setPositionReference: y,
    domReference: f
  }), [v.refs, g, y]), x = E.useMemo(() => ({
    ...v.elements,
    domReference: d
  }), [v.elements, d]), $ = E.useMemo(() => ({
    ...v,
    ...r,
    refs: b,
    elements: x,
    nodeId: t
  }), [v, b, x, t, r]);
  return gr(() => {
    r.dataRef.current.floatingContext = $;
    const S = h == null ? void 0 : h.nodesRef.current.find((O) => O.id === t);
    S && (S.context = $);
  }), E.useMemo(() => ({
    ...v,
    context: $,
    refs: b,
    elements: x
  }), [v, b, x, $]);
}
function n9e(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    events: o,
    dataRef: i,
    elements: a
  } = e, {
    enabled: c = !0,
    visibleOnly: l = !0
  } = t, u = E.useRef(!1), d = E.useRef(), f = E.useRef(!0);
  E.useEffect(() => {
    if (!c) return;
    const v = td(a.domReference);
    function y() {
      !n && ZT(a.domReference) && a.domReference === bS(Cs(a.domReference)) && (u.current = !0);
    }
    function g() {
      f.current = !0;
    }
    return v.addEventListener("blur", y), v.addEventListener("keydown", g, !0), () => {
      v.removeEventListener("blur", y), v.removeEventListener("keydown", g, !0);
    };
  }, [a.domReference, n, c]), E.useEffect(() => {
    if (!c) return;
    function v(y) {
      let {
        reason: g
      } = y;
      (g === "reference-press" || g === "escape-key") && (u.current = !0);
    }
    return o.on("openchange", v), () => {
      o.off("openchange", v);
    };
  }, [o, c]), E.useEffect(() => () => {
    clearTimeout(d.current);
  }, []);
  const h = E.useMemo(() => ({
    onPointerDown(v) {
      _me(v.nativeEvent) || (f.current = !1);
    },
    onMouseLeave() {
      u.current = !1;
    },
    onFocus(v) {
      if (u.current) return;
      const y = nu(v.nativeEvent);
      if (l && kr(y))
        try {
          if (yF() && kme()) throw Error();
          if (!y.matches(":focus-visible")) return;
        } catch {
          if (!f.current && !Mme(y))
            return;
        }
      r(!0, v.nativeEvent, "focus");
    },
    onBlur(v) {
      u.current = !1;
      const y = v.relatedTarget, g = v.nativeEvent, b = kr(y) && y.hasAttribute(Dp("focus-guard")) && y.getAttribute("data-type") === "outside";
      d.current = window.setTimeout(() => {
        var x;
        const $ = bS(a.domReference ? a.domReference.ownerDocument : document);
        !y && $ === a.domReference || ku((x = i.current.floatingContext) == null ? void 0 : x.refs.floating.current, $) || ku(a.domReference, $) || b || r(!1, g, "focus");
      });
    }
  }), [i, a.domReference, r, l]);
  return E.useMemo(() => c ? {
    reference: h
  } : {}, [c, h]);
}
const w5 = "active", $5 = "selected";
function fx(e, t, n) {
  const r = /* @__PURE__ */ new Map(), o = n === "item";
  let i = e;
  if (o && e) {
    const {
      [w5]: a,
      [$5]: c,
      ...l
    } = e;
    i = l;
  }
  return {
    ...n === "floating" && {
      tabIndex: -1,
      [Qge]: ""
    },
    ...i,
    ...t.map((a) => {
      const c = a ? a[n] : null;
      return typeof c == "function" ? e ? c(e) : null : c;
    }).concat(e).reduce((a, c) => (c && Object.entries(c).forEach((l) => {
      let [u, d] = l;
      if (!(o && [w5, $5].includes(u)))
        if (u.indexOf("on") === 0) {
          if (r.has(u) || r.set(u, []), typeof d == "function") {
            var f;
            (f = r.get(u)) == null || f.push(d), a[u] = function() {
              for (var h, v = arguments.length, y = new Array(v), g = 0; g < v; g++)
                y[g] = arguments[g];
              return (h = r.get(u)) == null ? void 0 : h.map((b) => b(...y)).find((b) => b !== void 0);
            };
          }
        } else
          a[u] = d;
    }), a), {})
  };
}
function r9e(e) {
  e === void 0 && (e = []);
  const t = e.map((c) => c == null ? void 0 : c.reference), n = e.map((c) => c == null ? void 0 : c.floating), r = e.map((c) => c == null ? void 0 : c.item), o = E.useCallback(
    (c) => fx(c, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), i = E.useCallback(
    (c) => fx(c, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), a = E.useCallback(
    (c) => fx(c, e, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  );
  return E.useMemo(() => ({
    getReferenceProps: o,
    getFloatingProps: i,
    getItemProps: a
  }), [o, i, a]);
}
const r0e = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function o9e(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    open: r,
    floatingId: o
  } = e, {
    enabled: i = !0,
    role: a = "dialog"
  } = t, c = (n = r0e.get(a)) != null ? n : a, l = Tv(), d = oE() != null, f = E.useMemo(() => c === "tooltip" || a === "label" ? {
    ["aria-" + (a === "label" ? "labelledby" : "describedby")]: r ? o : void 0
  } : {
    "aria-expanded": r ? "true" : "false",
    "aria-haspopup": c === "alertdialog" ? "dialog" : c,
    "aria-controls": r ? o : void 0,
    ...c === "listbox" && {
      role: "combobox"
    },
    ...c === "menu" && {
      id: l
    },
    ...c === "menu" && d && {
      role: "menuitem"
    },
    ...a === "select" && {
      "aria-autocomplete": "none"
    },
    ...a === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [c, o, d, r, l, a]), h = E.useMemo(() => {
    const y = {
      id: o,
      ...c && {
        role: c
      }
    };
    return c === "tooltip" || a === "label" ? y : {
      ...y,
      ...c === "menu" && {
        "aria-labelledby": l
      }
    };
  }, [c, o, l, a]), v = E.useCallback((y) => {
    let {
      active: g,
      selected: b
    } = y;
    const x = {
      role: "option",
      ...g && {
        id: o + "-option"
      }
    };
    switch (a) {
      case "select":
        return {
          ...x,
          "aria-selected": g && b
        };
      case "combobox":
        return {
          ...x,
          ...g && {
            "aria-selected": !0
          }
        };
    }
    return {};
  }, [o, a]);
  return E.useMemo(() => i ? {
    reference: f,
    floating: h,
    item: v
  } : {}, [i, f, h, v]);
}
const O5 = (e) => e.replace(/[A-Z]+(?![a-z])|[A-Z]/g, (t, n) => (n ? "-" : "") + t.toLowerCase());
function Ul(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function o0e(e, t) {
  const [n, r] = E.useState(e);
  return e && !n && r(!0), E.useEffect(() => {
    if (!e && n) {
      const o = setTimeout(() => r(!1), t);
      return () => clearTimeout(o);
    }
  }, [e, n, t]), n;
}
function i0e(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    elements: {
      floating: r
    }
  } = e, {
    duration: o = 250
  } = t, a = (typeof o == "number" ? o : o.close) || 0, [c, l] = E.useState("unmounted"), u = o0e(n, a);
  return !u && c === "close" && l("unmounted"), gr(() => {
    if (r) {
      if (n) {
        l("initial");
        const d = requestAnimationFrame(() => {
          l("open");
        });
        return () => {
          cancelAnimationFrame(d);
        };
      }
      l("close");
    }
  }, [n, r]), {
    isMounted: u,
    status: c
  };
}
function i9e(e, t) {
  t === void 0 && (t = {});
  const {
    initial: n = {
      opacity: 0
    },
    open: r,
    close: o,
    common: i,
    duration: a = 250
  } = t, c = e.placement, l = c.split("-")[0], u = E.useMemo(() => ({
    side: l,
    placement: c
  }), [l, c]), d = typeof a == "number", f = (d ? a : a.open) || 0, h = (d ? a : a.close) || 0, [v, y] = E.useState(() => ({
    ...Ul(i, u),
    ...Ul(n, u)
  })), {
    isMounted: g,
    status: b
  } = i0e(e, {
    duration: a
  }), x = _c(n), $ = _c(r), S = _c(o), O = _c(i);
  return gr(() => {
    const C = Ul(x.current, u), T = Ul(S.current, u), k = Ul(O.current, u), I = Ul($.current, u) || Object.keys(C).reduce((P, _) => (P[_] = "", P), {});
    if (b === "initial" && y((P) => ({
      transitionProperty: P.transitionProperty,
      ...k,
      ...C
    })), b === "open" && y({
      transitionProperty: Object.keys(I).map(O5).join(","),
      transitionDuration: f + "ms",
      ...k,
      ...I
    }), b === "close") {
      const P = T || C;
      y({
        transitionProperty: Object.keys(P).map(O5).join(","),
        transitionDuration: h + "ms",
        ...k,
        ...P
      });
    }
  }, [h, S, x, $, O, f, b, u]), {
    isMounted: g,
    styles: v
  };
}
function Qg() {
  return Qg = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Qg.apply(null, arguments);
}
function a0e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.includes(r)) continue;
    n[r] = e[r];
  }
  return n;
}
const s0e = ["localeText"], CS = /* @__PURE__ */ E.createContext(null);
process.env.NODE_ENV !== "production" && (CS.displayName = "MuiPickersAdapterContext");
const c0e = function(t) {
  const {
    localeText: n
  } = t, r = a0e(t, s0e), {
    utils: o,
    localeText: i
  } = E.useContext(CS) ?? {
    utils: void 0,
    localeText: void 0
  }, a = Ga({
    // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
    // We will then merge this theme value with our value manually
    props: r,
    name: "MuiLocalizationProvider"
  }), {
    children: c,
    dateAdapter: l,
    dateFormats: u,
    dateLibInstance: d,
    adapterLocale: f,
    localeText: h
  } = a, v = E.useMemo(() => Qg({}, h, i, n), [h, i, n]), y = E.useMemo(() => {
    if (!l)
      return o || null;
    const x = new l({
      locale: f,
      formats: u,
      instance: d
    });
    if (!x.isMUIAdapter)
      throw new Error(["MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`", "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`", "More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation"].join(`
`));
    return x;
  }, [l, f, u, d, o]), g = E.useMemo(() => y ? {
    minDate: y.date("1900-01-01T00:00:00.000"),
    maxDate: y.date("2099-12-31T00:00:00.000")
  } : null, [y]), b = E.useMemo(() => ({
    utils: y,
    defaultDates: g,
    localeText: v
  }), [g, y, v]);
  return /* @__PURE__ */ F.jsx(CS.Provider, {
    value: b,
    children: c
  });
};
process.env.NODE_ENV !== "production" && (c0e.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Locale for the date library you are using
   */
  adapterLocale: s.any,
  children: s.node,
  /**
   * Date library adapter class function.
   * @see See the localization provider {@link https://mui.com/x/react-date-pickers/getting-started/#setup-your-date-library-adapter date adapter setup section} for more details.
   */
  dateAdapter: s.func,
  /**
   * Formats that are used for any child pickers
   */
  dateFormats: s.shape({
    dayOfMonth: s.string,
    dayOfMonthFull: s.string,
    fullDate: s.string,
    fullTime: s.string,
    fullTime12h: s.string,
    fullTime24h: s.string,
    hours12h: s.string,
    hours24h: s.string,
    keyboardDate: s.string,
    keyboardDateTime: s.string,
    keyboardDateTime12h: s.string,
    keyboardDateTime24h: s.string,
    meridiem: s.string,
    minutes: s.string,
    month: s.string,
    monthShort: s.string,
    normalDate: s.string,
    normalDateWithWeekday: s.string,
    seconds: s.string,
    shortDate: s.string,
    weekday: s.string,
    weekdayShort: s.string,
    year: s.string
  }),
  /**
   * Date library instance you are using, if it has some global overrides
   * ```jsx
   * dateLibInstance={momentTimeZone}
   * ```
   */
  dateLibInstance: s.any,
  /**
   * Locale for components texts
   */
  localeText: s.object
});
const S5 = /* @__PURE__ */ new Set();
function Ev(e, t = "warning") {
  if (process.env.NODE_ENV === "production")
    return;
  const n = Array.isArray(e) ? e.join(`
`) : e;
  S5.has(n) || (S5.add(n), t === "error" ? console.error(n) : console.warn(n));
}
const l0e = {
  // Year
  y: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  yy: "year",
  yyy: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  yyyy: "year",
  // Month
  M: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  MM: "month",
  MMMM: {
    sectionType: "month",
    contentType: "letter"
  },
  MMM: {
    sectionType: "month",
    contentType: "letter"
  },
  L: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  LL: "month",
  LLL: {
    sectionType: "month",
    contentType: "letter"
  },
  LLLL: {
    sectionType: "month",
    contentType: "letter"
  },
  // Day of the month
  d: {
    sectionType: "day",
    contentType: "digit",
    maxLength: 2
  },
  dd: "day",
  do: {
    sectionType: "day",
    contentType: "digit-with-letter"
  },
  // Day of the week
  E: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  EEEEE: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  i: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  ii: "weekDay",
  iii: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  iiii: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  // eslint-disable-next-line id-denylist
  e: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  ee: "weekDay",
  eee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  eeeeee: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  c: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 1
  },
  cc: "weekDay",
  ccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  cccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  ccccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  cccccc: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  // Meridiem
  a: "meridiem",
  aa: "meridiem",
  aaa: "meridiem",
  // Hours
  H: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  HH: "hours",
  h: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  hh: "hours",
  // Minutes
  m: {
    sectionType: "minutes",
    contentType: "digit",
    maxLength: 2
  },
  mm: "minutes",
  // Seconds
  s: {
    sectionType: "seconds",
    contentType: "digit",
    maxLength: 2
  },
  ss: "seconds"
}, u0e = {
  year: "yyyy",
  month: "LLLL",
  monthShort: "MMM",
  dayOfMonth: "d",
  dayOfMonthFull: "do",
  weekday: "EEEE",
  weekdayShort: "EEEEEE",
  hours24h: "HH",
  hours12h: "hh",
  meridiem: "aa",
  minutes: "mm",
  seconds: "ss",
  fullDate: "PP",
  keyboardDate: "P",
  shortDate: "MMM d",
  normalDate: "d MMMM",
  normalDateWithWeekday: "EEE, MMM d",
  fullTime: "p",
  fullTime12h: "hh:mm aa",
  fullTime24h: "HH:mm",
  keyboardDateTime: "P p",
  keyboardDateTime12h: "P hh:mm aa",
  keyboardDateTime24h: "P HH:mm"
};
class d0e {
  constructor(t) {
    this.isMUIAdapter = !0, this.isTimezoneCompatible = !1, this.lib = void 0, this.locale = void 0, this.formats = void 0, this.formatTokenMap = l0e, this.escapedCharacters = {
      start: "'",
      end: "'"
    }, this.longFormatters = void 0, this.date = (a) => typeof a > "u" ? /* @__PURE__ */ new Date() : a === null ? null : new Date(a), this.getInvalidDate = () => /* @__PURE__ */ new Date("Invalid Date"), this.getTimezone = () => "default", this.setTimezone = (a) => a, this.toJsDate = (a) => a, this.getCurrentLocaleCode = () => this.locale.code, this.is12HourCycleInCurrentLocale = () => /a/.test(this.locale.formatLong.time({
      width: "short"
    })), this.expandFormat = (a) => {
      const c = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
      return a.match(c).map((l) => {
        const u = l[0];
        if (u === "p" || u === "P") {
          const d = this.longFormatters[u];
          return d(l, this.locale.formatLong);
        }
        return l;
      }).join("");
    }, this.formatNumber = (a) => a, this.getDayOfWeek = (a) => a.getDay() + 1;
    const {
      locale: n,
      formats: r,
      longFormatters: o,
      lib: i
    } = t;
    this.locale = n, this.formats = Qg({}, u0e, r), this.longFormatters = o, this.lib = i || "date-fns";
  }
}
class a9e extends d0e {
  constructor({
    locale: t,
    formats: n
  } = {}) {
    if (process.env.NODE_ENV !== "production") {
      if (typeof Vc != "function")
        throw new Error(["MUI: The `date-fns` package v2.x is not compatible with this adapter.", "Please, install v3.x or v4.x of the package or use the `AdapterDateFns` instead."].join(`
`));
      if (!Gf)
        throw new Error("MUI: The minimum supported `date-fns` package version compatible with this adapter is `3.2.x`.");
    }
    super({
      locale: t ?? Zu,
      formats: n,
      longFormatters: Gf
    }), this.parse = (r, o) => r === "" ? null : eme(r, o, /* @__PURE__ */ new Date(), {
      locale: this.locale
    }), this.isValid = (r) => r == null ? !1 : Wj(r), this.format = (r, o) => this.formatByString(r, this.formats[o]), this.formatByString = (r, o) => Xj(r, o, {
      locale: this.locale
    }), this.isEqual = (r, o) => r === null && o === null ? !0 : r === null || o === null ? !1 : ihe(r, o), this.isSameYear = (r, o) => rF(r, o), this.isSameMonth = (r, o) => nF(r, o), this.isSameDay = (r, o) => qj(r, o), this.isSameHour = (r, o) => nme(r, o), this.isAfter = (r, o) => og(r, o), this.isAfterYear = (r, o) => og(r, gS(o)), this.isAfterDay = (r, o) => og(r, w4(o)), this.isBefore = (r, o) => ig(r, o), this.isBeforeYear = (r, o) => ig(r, this.startOfYear(o)), this.isBeforeDay = (r, o) => ig(r, this.startOfDay(o)), this.isWithinRange = (r, [o, i]) => rme(r, {
      start: o,
      end: i
    }), this.startOfYear = (r) => WT(r), this.startOfMonth = (r) => Vj(r), this.startOfWeek = (r) => aa(r, {
      locale: this.locale
    }), this.startOfDay = (r) => _u(r), this.endOfYear = (r) => gS(r), this.endOfMonth = (r) => Hj(r), this.endOfWeek = (r) => HT(r, {
      locale: this.locale
    }), this.endOfDay = (r) => w4(r), this.addYears = (r, o) => UT(r, o), this.addMonths = (r, o) => bv(r, o), this.addWeeks = (r, o) => qT(r, o), this.addDays = (r, o) => Vc(r, o), this.addHours = (r, o) => Xfe(r, o), this.addMinutes = (r, o) => Qfe(r, o), this.addSeconds = (r, o) => epe(r, o), this.getYear = (r) => ohe(r), this.getMonth = (r) => nhe(r), this.getDate = (r) => Xpe(r), this.getHours = (r) => Jpe(r), this.getMinutes = (r) => the(r), this.getSeconds = (r) => rhe(r), this.getMilliseconds = (r) => ehe(r), this.setYear = (r, o) => iF(r, o), this.setMonth = (r, o) => oF(r, o), this.setDate = (r, o) => ome(r, o), this.setHours = (r, o) => ime(r, o), this.setMinutes = (r, o) => sme(r, o), this.setSeconds = (r, o) => cme(r, o), this.setMilliseconds = (r, o) => ame(r, o), this.getDaysInMonth = (r) => Zj(r), this.getWeekArray = (r) => {
      const o = this.startOfWeek(this.startOfMonth(r)), i = this.endOfWeek(this.endOfMonth(r));
      let a = 0, c = o;
      const l = [];
      for (; this.isBefore(c, i); ) {
        const u = Math.floor(a / 7);
        l[u] = l[u] || [], l[u].push(c), c = this.addDays(c, 1), a += 1;
      }
      return l;
    }, this.getWeekNumber = (r) => xv(r, {
      locale: this.locale
    }), this.getYearRange = ([r, o]) => {
      const i = this.startOfYear(r), a = this.endOfYear(o), c = [];
      let l = i;
      for (; this.isBefore(l, a); )
        c.push(l), l = this.addYears(l, 1);
      return c;
    };
  }
}
/*!
 * Cropper.js v1.6.2
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2024-04-21T07:43:05.335Z
 */
function C5(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function BF(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? C5(Object(n), !0).forEach(function(r) {
      m0e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : C5(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function f0e(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function qF(e) {
  var t = f0e(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function TS(e) {
  "@babel/helpers - typeof";
  return TS = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, TS(e);
}
function p0e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function T5(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, qF(r.key), r);
  }
}
function h0e(e, t, n) {
  return t && T5(e.prototype, t), n && T5(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function m0e(e, t, n) {
  return t = qF(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function UF(e) {
  return g0e(e) || v0e(e) || y0e(e) || b0e();
}
function g0e(e) {
  if (Array.isArray(e)) return ES(e);
}
function v0e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function y0e(e, t) {
  if (e) {
    if (typeof e == "string") return ES(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ES(e, t);
  }
}
function ES(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function b0e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var _v = typeof window < "u" && typeof window.document < "u", la = _v ? window : {}, aE = _v && la.document.documentElement ? "ontouchstart" in la.document.documentElement : !1, sE = _v ? "PointerEvent" in la : !1, bn = "cropper", cE = "all", WF = "crop", HF = "move", VF = "zoom", uc = "e", dc = "w", Wl = "s", ps = "n", Ud = "ne", Wd = "nw", Hd = "se", Vd = "sw", _S = "".concat(bn, "-crop"), E5 = "".concat(bn, "-disabled"), Kr = "".concat(bn, "-hidden"), _5 = "".concat(bn, "-hide"), x0e = "".concat(bn, "-invisible"), e0 = "".concat(bn, "-modal"), kS = "".concat(bn, "-move"), Zf = "".concat(bn, "Action"), mm = "".concat(bn, "Preview"), lE = "crop", YF = "move", GF = "none", RS = "crop", PS = "cropend", AS = "cropmove", IS = "cropstart", k5 = "dblclick", w0e = aE ? "touchstart" : "mousedown", $0e = aE ? "touchmove" : "mousemove", O0e = aE ? "touchend touchcancel" : "mouseup", R5 = sE ? "pointerdown" : w0e, P5 = sE ? "pointermove" : $0e, A5 = sE ? "pointerup pointercancel" : O0e, I5 = "ready", M5 = "resize", N5 = "wheel", MS = "zoom", D5 = "image/jpeg", S0e = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/, C0e = /^data:/, T0e = /^data:image\/jpeg;base64,/, E0e = /^img|canvas$/i, KF = 200, XF = 100, L5 = {
  // Define the view mode of the cropper
  viewMode: 0,
  // 0, 1, 2, 3
  // Define the dragging mode of the cropper
  dragMode: lE,
  // 'crop', 'move' or 'none'
  // Define the initial aspect ratio of the crop box
  initialAspectRatio: NaN,
  // Define the aspect ratio of the crop box
  aspectRatio: NaN,
  // An object with the previous cropping result data
  data: null,
  // A selector for adding extra containers to preview
  preview: "",
  // Re-render the cropper when resize the window
  responsive: !0,
  // Restore the cropped area after resize the window
  restore: !0,
  // Check if the current image is a cross-origin image
  checkCrossOrigin: !0,
  // Check the current image's Exif Orientation information
  checkOrientation: !0,
  // Show the black modal
  modal: !0,
  // Show the dashed lines for guiding
  guides: !0,
  // Show the center indicator for guiding
  center: !0,
  // Show the white modal to highlight the crop box
  highlight: !0,
  // Show the grid background
  background: !0,
  // Enable to crop the image automatically when initialize
  autoCrop: !0,
  // Define the percentage of automatic cropping area when initializes
  autoCropArea: 0.8,
  // Enable to move the image
  movable: !0,
  // Enable to rotate the image
  rotatable: !0,
  // Enable to scale the image
  scalable: !0,
  // Enable to zoom the image
  zoomable: !0,
  // Enable to zoom the image by dragging touch
  zoomOnTouch: !0,
  // Enable to zoom the image by wheeling mouse
  zoomOnWheel: !0,
  // Define zoom ratio when zoom the image by wheeling mouse
  wheelZoomRatio: 0.1,
  // Enable to move the crop box
  cropBoxMovable: !0,
  // Enable to resize the crop box
  cropBoxResizable: !0,
  // Toggle drag mode between "crop" and "move" when click twice on the cropper
  toggleDragModeOnDblclick: !0,
  // Size limitation
  minCanvasWidth: 0,
  minCanvasHeight: 0,
  minCropBoxWidth: 0,
  minCropBoxHeight: 0,
  minContainerWidth: KF,
  minContainerHeight: XF,
  // Shortcuts of events
  ready: null,
  cropstart: null,
  cropmove: null,
  cropend: null,
  crop: null,
  zoom: null
}, _0e = '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>', k0e = Number.isNaN || la.isNaN;
function Ft(e) {
  return typeof e == "number" && !k0e(e);
}
var j5 = function(t) {
  return t > 0 && t < 1 / 0;
};
function px(e) {
  return typeof e > "u";
}
function Xc(e) {
  return TS(e) === "object" && e !== null;
}
var R0e = Object.prototype.hasOwnProperty;
function ou(e) {
  if (!Xc(e))
    return !1;
  try {
    var t = e.constructor, n = t.prototype;
    return t && n && R0e.call(n, "isPrototypeOf");
  } catch {
    return !1;
  }
}
function Yr(e) {
  return typeof e == "function";
}
var P0e = Array.prototype.slice;
function ZF(e) {
  return Array.from ? Array.from(e) : P0e.call(e);
}
function Gn(e, t) {
  return e && Yr(t) && (Array.isArray(e) || Ft(e.length) ? ZF(e).forEach(function(n, r) {
    t.call(e, n, r, e);
  }) : Xc(e) && Object.keys(e).forEach(function(n) {
    t.call(e, e[n], n, e);
  })), e;
}
var wn = Object.assign || function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
    r[o - 1] = arguments[o];
  return Xc(t) && r.length > 0 && r.forEach(function(i) {
    Xc(i) && Object.keys(i).forEach(function(a) {
      t[a] = i[a];
    });
  }), t;
}, A0e = /\.\d*(?:0|9){12}\d*$/;
function pu(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e11;
  return A0e.test(e) ? Math.round(e * t) / t : e;
}
var I0e = /^width|height|left|top|marginLeft|marginTop$/;
function Ts(e, t) {
  var n = e.style;
  Gn(t, function(r, o) {
    I0e.test(o) && Ft(r) && (r = "".concat(r, "px")), n[o] = r;
  });
}
function M0e(e, t) {
  return e.classList ? e.classList.contains(t) : e.className.indexOf(t) > -1;
}
function nr(e, t) {
  if (t) {
    if (Ft(e.length)) {
      Gn(e, function(r) {
        nr(r, t);
      });
      return;
    }
    if (e.classList) {
      e.classList.add(t);
      return;
    }
    var n = e.className.trim();
    n ? n.indexOf(t) < 0 && (e.className = "".concat(n, " ").concat(t)) : e.className = t;
  }
}
function Qi(e, t) {
  if (t) {
    if (Ft(e.length)) {
      Gn(e, function(n) {
        Qi(n, t);
      });
      return;
    }
    if (e.classList) {
      e.classList.remove(t);
      return;
    }
    e.className.indexOf(t) >= 0 && (e.className = e.className.replace(t, ""));
  }
}
function iu(e, t, n) {
  if (t) {
    if (Ft(e.length)) {
      Gn(e, function(r) {
        iu(r, t, n);
      });
      return;
    }
    n ? nr(e, t) : Qi(e, t);
  }
}
var N0e = /([a-z\d])([A-Z])/g;
function uE(e) {
  return e.replace(N0e, "$1-$2").toLowerCase();
}
function NS(e, t) {
  return Xc(e[t]) ? e[t] : e.dataset ? e.dataset[t] : e.getAttribute("data-".concat(uE(t)));
}
function Jf(e, t, n) {
  Xc(n) ? e[t] = n : e.dataset ? e.dataset[t] = n : e.setAttribute("data-".concat(uE(t)), n);
}
function D0e(e, t) {
  if (Xc(e[t]))
    try {
      delete e[t];
    } catch {
      e[t] = void 0;
    }
  else if (e.dataset)
    try {
      delete e.dataset[t];
    } catch {
      e.dataset[t] = void 0;
    }
  else
    e.removeAttribute("data-".concat(uE(t)));
}
var JF = /\s\s*/, QF = function() {
  var e = !1;
  if (_v) {
    var t = !1, n = function() {
    }, r = Object.defineProperty({}, "once", {
      get: function() {
        return e = !0, t;
      },
      /**
       * This setter can fix a `TypeError` in strict mode
       * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
       * @param {boolean} value - The value to set
       */
      set: function(i) {
        t = i;
      }
    });
    la.addEventListener("test", n, r), la.removeEventListener("test", n, r);
  }
  return e;
}();
function di(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, o = n;
  t.trim().split(JF).forEach(function(i) {
    if (!QF) {
      var a = e.listeners;
      a && a[i] && a[i][n] && (o = a[i][n], delete a[i][n], Object.keys(a[i]).length === 0 && delete a[i], Object.keys(a).length === 0 && delete e.listeners);
    }
    e.removeEventListener(i, o, r);
  });
}
function Fo(e, t, n) {
  var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, o = n;
  t.trim().split(JF).forEach(function(i) {
    if (r.once && !QF) {
      var a = e.listeners, c = a === void 0 ? {} : a;
      o = function() {
        delete c[i][n], e.removeEventListener(i, o, r);
        for (var u = arguments.length, d = new Array(u), f = 0; f < u; f++)
          d[f] = arguments[f];
        n.apply(e, d);
      }, c[i] || (c[i] = {}), c[i][n] && e.removeEventListener(i, c[i][n], r), c[i][n] = o, e.listeners = c;
    }
    e.addEventListener(i, o, r);
  });
}
function hu(e, t, n) {
  var r;
  return Yr(Event) && Yr(CustomEvent) ? r = new CustomEvent(t, {
    detail: n,
    bubbles: !0,
    cancelable: !0
  }) : (r = document.createEvent("CustomEvent"), r.initCustomEvent(t, !0, !0, n)), e.dispatchEvent(r);
}
function ez(e) {
  var t = e.getBoundingClientRect();
  return {
    left: t.left + (window.pageXOffset - document.documentElement.clientLeft),
    top: t.top + (window.pageYOffset - document.documentElement.clientTop)
  };
}
var hx = la.location, L0e = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
function F5(e) {
  var t = e.match(L0e);
  return t !== null && (t[1] !== hx.protocol || t[2] !== hx.hostname || t[3] !== hx.port);
}
function z5(e) {
  var t = "timestamp=".concat((/* @__PURE__ */ new Date()).getTime());
  return e + (e.indexOf("?") === -1 ? "?" : "&") + t;
}
function $f(e) {
  var t = e.rotate, n = e.scaleX, r = e.scaleY, o = e.translateX, i = e.translateY, a = [];
  Ft(o) && o !== 0 && a.push("translateX(".concat(o, "px)")), Ft(i) && i !== 0 && a.push("translateY(".concat(i, "px)")), Ft(t) && t !== 0 && a.push("rotate(".concat(t, "deg)")), Ft(n) && n !== 1 && a.push("scaleX(".concat(n, ")")), Ft(r) && r !== 1 && a.push("scaleY(".concat(r, ")"));
  var c = a.length ? a.join(" ") : "none";
  return {
    WebkitTransform: c,
    msTransform: c,
    transform: c
  };
}
function j0e(e) {
  var t = BF({}, e), n = 0;
  return Gn(e, function(r, o) {
    delete t[o], Gn(t, function(i) {
      var a = Math.abs(r.startX - i.startX), c = Math.abs(r.startY - i.startY), l = Math.abs(r.endX - i.endX), u = Math.abs(r.endY - i.endY), d = Math.sqrt(a * a + c * c), f = Math.sqrt(l * l + u * u), h = (f - d) / d;
      Math.abs(h) > Math.abs(n) && (n = h);
    });
  }), n;
}
function gm(e, t) {
  var n = e.pageX, r = e.pageY, o = {
    endX: n,
    endY: r
  };
  return t ? o : BF({
    startX: n,
    startY: r
  }, o);
}
function F0e(e) {
  var t = 0, n = 0, r = 0;
  return Gn(e, function(o) {
    var i = o.startX, a = o.startY;
    t += i, n += a, r += 1;
  }), t /= r, n /= r, {
    pageX: t,
    pageY: n
  };
}
function Es(e) {
  var t = e.aspectRatio, n = e.height, r = e.width, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "contain", i = j5(r), a = j5(n);
  if (i && a) {
    var c = n * t;
    o === "contain" && c > r || o === "cover" && c < r ? n = r / t : r = n * t;
  } else i ? n = r / t : a && (r = n * t);
  return {
    width: r,
    height: n
  };
}
function z0e(e) {
  var t = e.width, n = e.height, r = e.degree;
  if (r = Math.abs(r) % 180, r === 90)
    return {
      width: n,
      height: t
    };
  var o = r % 90 * Math.PI / 180, i = Math.sin(o), a = Math.cos(o), c = t * a + n * i, l = t * i + n * a;
  return r > 90 ? {
    width: l,
    height: c
  } : {
    width: c,
    height: l
  };
}
function B0e(e, t, n, r) {
  var o = t.aspectRatio, i = t.naturalWidth, a = t.naturalHeight, c = t.rotate, l = c === void 0 ? 0 : c, u = t.scaleX, d = u === void 0 ? 1 : u, f = t.scaleY, h = f === void 0 ? 1 : f, v = n.aspectRatio, y = n.naturalWidth, g = n.naturalHeight, b = r.fillColor, x = b === void 0 ? "transparent" : b, $ = r.imageSmoothingEnabled, S = $ === void 0 ? !0 : $, O = r.imageSmoothingQuality, C = O === void 0 ? "low" : O, T = r.maxWidth, k = T === void 0 ? 1 / 0 : T, I = r.maxHeight, P = I === void 0 ? 1 / 0 : I, _ = r.minWidth, A = _ === void 0 ? 0 : _, D = r.minHeight, M = D === void 0 ? 0 : D, N = document.createElement("canvas"), L = N.getContext("2d"), z = Es({
    aspectRatio: v,
    width: k,
    height: P
  }), q = Es({
    aspectRatio: v,
    width: A,
    height: M
  }, "cover"), W = Math.min(z.width, Math.max(q.width, y)), U = Math.min(z.height, Math.max(q.height, g)), K = Es({
    aspectRatio: o,
    width: k,
    height: P
  }), Y = Es({
    aspectRatio: o,
    width: A,
    height: M
  }, "cover"), X = Math.min(K.width, Math.max(Y.width, i)), oe = Math.min(K.height, Math.max(Y.height, a)), re = [-X / 2, -oe / 2, X, oe];
  return N.width = pu(W), N.height = pu(U), L.fillStyle = x, L.fillRect(0, 0, W, U), L.save(), L.translate(W / 2, U / 2), L.rotate(l * Math.PI / 180), L.scale(d, h), L.imageSmoothingEnabled = S, L.imageSmoothingQuality = C, L.drawImage.apply(L, [e].concat(UF(re.map(function(Z) {
    return Math.floor(pu(Z));
  })))), L.restore(), N;
}
var tz = String.fromCharCode;
function q0e(e, t, n) {
  var r = "";
  n += t;
  for (var o = t; o < n; o += 1)
    r += tz(e.getUint8(o));
  return r;
}
var U0e = /^data:.*,/;
function W0e(e) {
  var t = e.replace(U0e, ""), n = atob(t), r = new ArrayBuffer(n.length), o = new Uint8Array(r);
  return Gn(o, function(i, a) {
    o[a] = n.charCodeAt(a);
  }), r;
}
function H0e(e, t) {
  for (var n = [], r = 8192, o = new Uint8Array(e); o.length > 0; )
    n.push(tz.apply(null, ZF(o.subarray(0, r)))), o = o.subarray(r);
  return "data:".concat(t, ";base64,").concat(btoa(n.join("")));
}
function V0e(e) {
  var t = new DataView(e), n;
  try {
    var r, o, i;
    if (t.getUint8(0) === 255 && t.getUint8(1) === 216)
      for (var a = t.byteLength, c = 2; c + 1 < a; ) {
        if (t.getUint8(c) === 255 && t.getUint8(c + 1) === 225) {
          o = c;
          break;
        }
        c += 1;
      }
    if (o) {
      var l = o + 4, u = o + 10;
      if (q0e(t, l, 4) === "Exif") {
        var d = t.getUint16(u);
        if (r = d === 18761, (r || d === 19789) && t.getUint16(u + 2, r) === 42) {
          var f = t.getUint32(u + 4, r);
          f >= 8 && (i = u + f);
        }
      }
    }
    if (i) {
      var h = t.getUint16(i, r), v, y;
      for (y = 0; y < h; y += 1)
        if (v = i + y * 12 + 2, t.getUint16(v, r) === 274) {
          v += 8, n = t.getUint16(v, r), t.setUint16(v, 1, r);
          break;
        }
    }
  } catch {
    n = 1;
  }
  return n;
}
function Y0e(e) {
  var t = 0, n = 1, r = 1;
  switch (e) {
    // Flip horizontal
    case 2:
      n = -1;
      break;
    // Rotate left 180°
    case 3:
      t = -180;
      break;
    // Flip vertical
    case 4:
      r = -1;
      break;
    // Flip vertical and rotate right 90°
    case 5:
      t = 90, r = -1;
      break;
    // Rotate right 90°
    case 6:
      t = 90;
      break;
    // Flip horizontal and rotate right 90°
    case 7:
      t = 90, n = -1;
      break;
    // Rotate left 90°
    case 8:
      t = -90;
      break;
  }
  return {
    rotate: t,
    scaleX: n,
    scaleY: r
  };
}
var G0e = {
  render: function() {
    this.initContainer(), this.initCanvas(), this.initCropBox(), this.renderCanvas(), this.cropped && this.renderCropBox();
  },
  initContainer: function() {
    var t = this.element, n = this.options, r = this.container, o = this.cropper, i = Number(n.minContainerWidth), a = Number(n.minContainerHeight);
    nr(o, Kr), Qi(t, Kr);
    var c = {
      width: Math.max(r.offsetWidth, i >= 0 ? i : KF),
      height: Math.max(r.offsetHeight, a >= 0 ? a : XF)
    };
    this.containerData = c, Ts(o, {
      width: c.width,
      height: c.height
    }), nr(t, Kr), Qi(o, Kr);
  },
  // Canvas (image wrapper)
  initCanvas: function() {
    var t = this.containerData, n = this.imageData, r = this.options.viewMode, o = Math.abs(n.rotate) % 180 === 90, i = o ? n.naturalHeight : n.naturalWidth, a = o ? n.naturalWidth : n.naturalHeight, c = i / a, l = t.width, u = t.height;
    t.height * c > t.width ? r === 3 ? l = t.height * c : u = t.width / c : r === 3 ? u = t.width / c : l = t.height * c;
    var d = {
      aspectRatio: c,
      naturalWidth: i,
      naturalHeight: a,
      width: l,
      height: u
    };
    this.canvasData = d, this.limited = r === 1 || r === 2, this.limitCanvas(!0, !0), d.width = Math.min(Math.max(d.width, d.minWidth), d.maxWidth), d.height = Math.min(Math.max(d.height, d.minHeight), d.maxHeight), d.left = (t.width - d.width) / 2, d.top = (t.height - d.height) / 2, d.oldLeft = d.left, d.oldTop = d.top, this.initialCanvasData = wn({}, d);
  },
  limitCanvas: function(t, n) {
    var r = this.options, o = this.containerData, i = this.canvasData, a = this.cropBoxData, c = r.viewMode, l = i.aspectRatio, u = this.cropped && a;
    if (t) {
      var d = Number(r.minCanvasWidth) || 0, f = Number(r.minCanvasHeight) || 0;
      c > 1 ? (d = Math.max(d, o.width), f = Math.max(f, o.height), c === 3 && (f * l > d ? d = f * l : f = d / l)) : c > 0 && (d ? d = Math.max(d, u ? a.width : 0) : f ? f = Math.max(f, u ? a.height : 0) : u && (d = a.width, f = a.height, f * l > d ? d = f * l : f = d / l));
      var h = Es({
        aspectRatio: l,
        width: d,
        height: f
      });
      d = h.width, f = h.height, i.minWidth = d, i.minHeight = f, i.maxWidth = 1 / 0, i.maxHeight = 1 / 0;
    }
    if (n)
      if (c > (u ? 0 : 1)) {
        var v = o.width - i.width, y = o.height - i.height;
        i.minLeft = Math.min(0, v), i.minTop = Math.min(0, y), i.maxLeft = Math.max(0, v), i.maxTop = Math.max(0, y), u && this.limited && (i.minLeft = Math.min(a.left, a.left + (a.width - i.width)), i.minTop = Math.min(a.top, a.top + (a.height - i.height)), i.maxLeft = a.left, i.maxTop = a.top, c === 2 && (i.width >= o.width && (i.minLeft = Math.min(0, v), i.maxLeft = Math.max(0, v)), i.height >= o.height && (i.minTop = Math.min(0, y), i.maxTop = Math.max(0, y))));
      } else
        i.minLeft = -i.width, i.minTop = -i.height, i.maxLeft = o.width, i.maxTop = o.height;
  },
  renderCanvas: function(t, n) {
    var r = this.canvasData, o = this.imageData;
    if (n) {
      var i = z0e({
        width: o.naturalWidth * Math.abs(o.scaleX || 1),
        height: o.naturalHeight * Math.abs(o.scaleY || 1),
        degree: o.rotate || 0
      }), a = i.width, c = i.height, l = r.width * (a / r.naturalWidth), u = r.height * (c / r.naturalHeight);
      r.left -= (l - r.width) / 2, r.top -= (u - r.height) / 2, r.width = l, r.height = u, r.aspectRatio = a / c, r.naturalWidth = a, r.naturalHeight = c, this.limitCanvas(!0, !1);
    }
    (r.width > r.maxWidth || r.width < r.minWidth) && (r.left = r.oldLeft), (r.height > r.maxHeight || r.height < r.minHeight) && (r.top = r.oldTop), r.width = Math.min(Math.max(r.width, r.minWidth), r.maxWidth), r.height = Math.min(Math.max(r.height, r.minHeight), r.maxHeight), this.limitCanvas(!1, !0), r.left = Math.min(Math.max(r.left, r.minLeft), r.maxLeft), r.top = Math.min(Math.max(r.top, r.minTop), r.maxTop), r.oldLeft = r.left, r.oldTop = r.top, Ts(this.canvas, wn({
      width: r.width,
      height: r.height
    }, $f({
      translateX: r.left,
      translateY: r.top
    }))), this.renderImage(t), this.cropped && this.limited && this.limitCropBox(!0, !0);
  },
  renderImage: function(t) {
    var n = this.canvasData, r = this.imageData, o = r.naturalWidth * (n.width / n.naturalWidth), i = r.naturalHeight * (n.height / n.naturalHeight);
    wn(r, {
      width: o,
      height: i,
      left: (n.width - o) / 2,
      top: (n.height - i) / 2
    }), Ts(this.image, wn({
      width: r.width,
      height: r.height
    }, $f(wn({
      translateX: r.left,
      translateY: r.top
    }, r)))), t && this.output();
  },
  initCropBox: function() {
    var t = this.options, n = this.canvasData, r = t.aspectRatio || t.initialAspectRatio, o = Number(t.autoCropArea) || 0.8, i = {
      width: n.width,
      height: n.height
    };
    r && (n.height * r > n.width ? i.height = i.width / r : i.width = i.height * r), this.cropBoxData = i, this.limitCropBox(!0, !0), i.width = Math.min(Math.max(i.width, i.minWidth), i.maxWidth), i.height = Math.min(Math.max(i.height, i.minHeight), i.maxHeight), i.width = Math.max(i.minWidth, i.width * o), i.height = Math.max(i.minHeight, i.height * o), i.left = n.left + (n.width - i.width) / 2, i.top = n.top + (n.height - i.height) / 2, i.oldLeft = i.left, i.oldTop = i.top, this.initialCropBoxData = wn({}, i);
  },
  limitCropBox: function(t, n) {
    var r = this.options, o = this.containerData, i = this.canvasData, a = this.cropBoxData, c = this.limited, l = r.aspectRatio;
    if (t) {
      var u = Number(r.minCropBoxWidth) || 0, d = Number(r.minCropBoxHeight) || 0, f = c ? Math.min(o.width, i.width, i.width + i.left, o.width - i.left) : o.width, h = c ? Math.min(o.height, i.height, i.height + i.top, o.height - i.top) : o.height;
      u = Math.min(u, o.width), d = Math.min(d, o.height), l && (u && d ? d * l > u ? d = u / l : u = d * l : u ? d = u / l : d && (u = d * l), h * l > f ? h = f / l : f = h * l), a.minWidth = Math.min(u, f), a.minHeight = Math.min(d, h), a.maxWidth = f, a.maxHeight = h;
    }
    n && (c ? (a.minLeft = Math.max(0, i.left), a.minTop = Math.max(0, i.top), a.maxLeft = Math.min(o.width, i.left + i.width) - a.width, a.maxTop = Math.min(o.height, i.top + i.height) - a.height) : (a.minLeft = 0, a.minTop = 0, a.maxLeft = o.width - a.width, a.maxTop = o.height - a.height));
  },
  renderCropBox: function() {
    var t = this.options, n = this.containerData, r = this.cropBoxData;
    (r.width > r.maxWidth || r.width < r.minWidth) && (r.left = r.oldLeft), (r.height > r.maxHeight || r.height < r.minHeight) && (r.top = r.oldTop), r.width = Math.min(Math.max(r.width, r.minWidth), r.maxWidth), r.height = Math.min(Math.max(r.height, r.minHeight), r.maxHeight), this.limitCropBox(!1, !0), r.left = Math.min(Math.max(r.left, r.minLeft), r.maxLeft), r.top = Math.min(Math.max(r.top, r.minTop), r.maxTop), r.oldLeft = r.left, r.oldTop = r.top, t.movable && t.cropBoxMovable && Jf(this.face, Zf, r.width >= n.width && r.height >= n.height ? HF : cE), Ts(this.cropBox, wn({
      width: r.width,
      height: r.height
    }, $f({
      translateX: r.left,
      translateY: r.top
    }))), this.cropped && this.limited && this.limitCanvas(!0, !0), this.disabled || this.output();
  },
  output: function() {
    this.preview(), hu(this.element, RS, this.getData());
  }
}, K0e = {
  initPreview: function() {
    var t = this.element, n = this.crossOrigin, r = this.options.preview, o = n ? this.crossOriginUrl : this.url, i = t.alt || "The image to preview", a = document.createElement("img");
    if (n && (a.crossOrigin = n), a.src = o, a.alt = i, this.viewBox.appendChild(a), this.viewBoxImage = a, !!r) {
      var c = r;
      typeof r == "string" ? c = t.ownerDocument.querySelectorAll(r) : r.querySelector && (c = [r]), this.previews = c, Gn(c, function(l) {
        var u = document.createElement("img");
        Jf(l, mm, {
          width: l.offsetWidth,
          height: l.offsetHeight,
          html: l.innerHTML
        }), n && (u.crossOrigin = n), u.src = o, u.alt = i, u.style.cssText = 'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"', l.innerHTML = "", l.appendChild(u);
      });
    }
  },
  resetPreview: function() {
    Gn(this.previews, function(t) {
      var n = NS(t, mm);
      Ts(t, {
        width: n.width,
        height: n.height
      }), t.innerHTML = n.html, D0e(t, mm);
    });
  },
  preview: function() {
    var t = this.imageData, n = this.canvasData, r = this.cropBoxData, o = r.width, i = r.height, a = t.width, c = t.height, l = r.left - n.left - t.left, u = r.top - n.top - t.top;
    !this.cropped || this.disabled || (Ts(this.viewBoxImage, wn({
      width: a,
      height: c
    }, $f(wn({
      translateX: -l,
      translateY: -u
    }, t)))), Gn(this.previews, function(d) {
      var f = NS(d, mm), h = f.width, v = f.height, y = h, g = v, b = 1;
      o && (b = h / o, g = i * b), i && g > v && (b = v / i, y = o * b, g = v), Ts(d, {
        width: y,
        height: g
      }), Ts(d.getElementsByTagName("img")[0], wn({
        width: a * b,
        height: c * b
      }, $f(wn({
        translateX: -l * b,
        translateY: -u * b
      }, t))));
    }));
  }
}, X0e = {
  bind: function() {
    var t = this.element, n = this.options, r = this.cropper;
    Yr(n.cropstart) && Fo(t, IS, n.cropstart), Yr(n.cropmove) && Fo(t, AS, n.cropmove), Yr(n.cropend) && Fo(t, PS, n.cropend), Yr(n.crop) && Fo(t, RS, n.crop), Yr(n.zoom) && Fo(t, MS, n.zoom), Fo(r, R5, this.onCropStart = this.cropStart.bind(this)), n.zoomable && n.zoomOnWheel && Fo(r, N5, this.onWheel = this.wheel.bind(this), {
      passive: !1,
      capture: !0
    }), n.toggleDragModeOnDblclick && Fo(r, k5, this.onDblclick = this.dblclick.bind(this)), Fo(t.ownerDocument, P5, this.onCropMove = this.cropMove.bind(this)), Fo(t.ownerDocument, A5, this.onCropEnd = this.cropEnd.bind(this)), n.responsive && Fo(window, M5, this.onResize = this.resize.bind(this));
  },
  unbind: function() {
    var t = this.element, n = this.options, r = this.cropper;
    Yr(n.cropstart) && di(t, IS, n.cropstart), Yr(n.cropmove) && di(t, AS, n.cropmove), Yr(n.cropend) && di(t, PS, n.cropend), Yr(n.crop) && di(t, RS, n.crop), Yr(n.zoom) && di(t, MS, n.zoom), di(r, R5, this.onCropStart), n.zoomable && n.zoomOnWheel && di(r, N5, this.onWheel, {
      passive: !1,
      capture: !0
    }), n.toggleDragModeOnDblclick && di(r, k5, this.onDblclick), di(t.ownerDocument, P5, this.onCropMove), di(t.ownerDocument, A5, this.onCropEnd), n.responsive && di(window, M5, this.onResize);
  }
}, Z0e = {
  resize: function() {
    if (!this.disabled) {
      var t = this.options, n = this.container, r = this.containerData, o = n.offsetWidth / r.width, i = n.offsetHeight / r.height, a = Math.abs(o - 1) > Math.abs(i - 1) ? o : i;
      if (a !== 1) {
        var c, l;
        t.restore && (c = this.getCanvasData(), l = this.getCropBoxData()), this.render(), t.restore && (this.setCanvasData(Gn(c, function(u, d) {
          c[d] = u * a;
        })), this.setCropBoxData(Gn(l, function(u, d) {
          l[d] = u * a;
        })));
      }
    }
  },
  dblclick: function() {
    this.disabled || this.options.dragMode === GF || this.setDragMode(M0e(this.dragBox, _S) ? YF : lE);
  },
  wheel: function(t) {
    var n = this, r = Number(this.options.wheelZoomRatio) || 0.1, o = 1;
    this.disabled || (t.preventDefault(), !this.wheeling && (this.wheeling = !0, setTimeout(function() {
      n.wheeling = !1;
    }, 50), t.deltaY ? o = t.deltaY > 0 ? 1 : -1 : t.wheelDelta ? o = -t.wheelDelta / 120 : t.detail && (o = t.detail > 0 ? 1 : -1), this.zoom(-o * r, t)));
  },
  cropStart: function(t) {
    var n = t.buttons, r = t.button;
    if (!(this.disabled || (t.type === "mousedown" || t.type === "pointerdown" && t.pointerType === "mouse") && // No primary button (Usually the left button)
    (Ft(n) && n !== 1 || Ft(r) && r !== 0 || t.ctrlKey))) {
      var o = this.options, i = this.pointers, a;
      t.changedTouches ? Gn(t.changedTouches, function(c) {
        i[c.identifier] = gm(c);
      }) : i[t.pointerId || 0] = gm(t), Object.keys(i).length > 1 && o.zoomable && o.zoomOnTouch ? a = VF : a = NS(t.target, Zf), S0e.test(a) && hu(this.element, IS, {
        originalEvent: t,
        action: a
      }) !== !1 && (t.preventDefault(), this.action = a, this.cropping = !1, a === WF && (this.cropping = !0, nr(this.dragBox, e0)));
    }
  },
  cropMove: function(t) {
    var n = this.action;
    if (!(this.disabled || !n)) {
      var r = this.pointers;
      t.preventDefault(), hu(this.element, AS, {
        originalEvent: t,
        action: n
      }) !== !1 && (t.changedTouches ? Gn(t.changedTouches, function(o) {
        wn(r[o.identifier] || {}, gm(o, !0));
      }) : wn(r[t.pointerId || 0] || {}, gm(t, !0)), this.change(t));
    }
  },
  cropEnd: function(t) {
    if (!this.disabled) {
      var n = this.action, r = this.pointers;
      t.changedTouches ? Gn(t.changedTouches, function(o) {
        delete r[o.identifier];
      }) : delete r[t.pointerId || 0], n && (t.preventDefault(), Object.keys(r).length || (this.action = ""), this.cropping && (this.cropping = !1, iu(this.dragBox, e0, this.cropped && this.options.modal)), hu(this.element, PS, {
        originalEvent: t,
        action: n
      }));
    }
  }
}, J0e = {
  change: function(t) {
    var n = this.options, r = this.canvasData, o = this.containerData, i = this.cropBoxData, a = this.pointers, c = this.action, l = n.aspectRatio, u = i.left, d = i.top, f = i.width, h = i.height, v = u + f, y = d + h, g = 0, b = 0, x = o.width, $ = o.height, S = !0, O;
    !l && t.shiftKey && (l = f && h ? f / h : 1), this.limited && (g = i.minLeft, b = i.minTop, x = g + Math.min(o.width, r.width, r.left + r.width), $ = b + Math.min(o.height, r.height, r.top + r.height));
    var C = a[Object.keys(a)[0]], T = {
      x: C.endX - C.startX,
      y: C.endY - C.startY
    }, k = function(P) {
      switch (P) {
        case uc:
          v + T.x > x && (T.x = x - v);
          break;
        case dc:
          u + T.x < g && (T.x = g - u);
          break;
        case ps:
          d + T.y < b && (T.y = b - d);
          break;
        case Wl:
          y + T.y > $ && (T.y = $ - y);
          break;
      }
    };
    switch (c) {
      // Move crop box
      case cE:
        u += T.x, d += T.y;
        break;
      // Resize crop box
      case uc:
        if (T.x >= 0 && (v >= x || l && (d <= b || y >= $))) {
          S = !1;
          break;
        }
        k(uc), f += T.x, f < 0 && (c = dc, f = -f, u -= f), l && (h = f / l, d += (i.height - h) / 2);
        break;
      case ps:
        if (T.y <= 0 && (d <= b || l && (u <= g || v >= x))) {
          S = !1;
          break;
        }
        k(ps), h -= T.y, d += T.y, h < 0 && (c = Wl, h = -h, d -= h), l && (f = h * l, u += (i.width - f) / 2);
        break;
      case dc:
        if (T.x <= 0 && (u <= g || l && (d <= b || y >= $))) {
          S = !1;
          break;
        }
        k(dc), f -= T.x, u += T.x, f < 0 && (c = uc, f = -f, u -= f), l && (h = f / l, d += (i.height - h) / 2);
        break;
      case Wl:
        if (T.y >= 0 && (y >= $ || l && (u <= g || v >= x))) {
          S = !1;
          break;
        }
        k(Wl), h += T.y, h < 0 && (c = ps, h = -h, d -= h), l && (f = h * l, u += (i.width - f) / 2);
        break;
      case Ud:
        if (l) {
          if (T.y <= 0 && (d <= b || v >= x)) {
            S = !1;
            break;
          }
          k(ps), h -= T.y, d += T.y, f = h * l;
        } else
          k(ps), k(uc), T.x >= 0 ? v < x ? f += T.x : T.y <= 0 && d <= b && (S = !1) : f += T.x, T.y <= 0 ? d > b && (h -= T.y, d += T.y) : (h -= T.y, d += T.y);
        f < 0 && h < 0 ? (c = Vd, h = -h, f = -f, d -= h, u -= f) : f < 0 ? (c = Wd, f = -f, u -= f) : h < 0 && (c = Hd, h = -h, d -= h);
        break;
      case Wd:
        if (l) {
          if (T.y <= 0 && (d <= b || u <= g)) {
            S = !1;
            break;
          }
          k(ps), h -= T.y, d += T.y, f = h * l, u += i.width - f;
        } else
          k(ps), k(dc), T.x <= 0 ? u > g ? (f -= T.x, u += T.x) : T.y <= 0 && d <= b && (S = !1) : (f -= T.x, u += T.x), T.y <= 0 ? d > b && (h -= T.y, d += T.y) : (h -= T.y, d += T.y);
        f < 0 && h < 0 ? (c = Hd, h = -h, f = -f, d -= h, u -= f) : f < 0 ? (c = Ud, f = -f, u -= f) : h < 0 && (c = Vd, h = -h, d -= h);
        break;
      case Vd:
        if (l) {
          if (T.x <= 0 && (u <= g || y >= $)) {
            S = !1;
            break;
          }
          k(dc), f -= T.x, u += T.x, h = f / l;
        } else
          k(Wl), k(dc), T.x <= 0 ? u > g ? (f -= T.x, u += T.x) : T.y >= 0 && y >= $ && (S = !1) : (f -= T.x, u += T.x), T.y >= 0 ? y < $ && (h += T.y) : h += T.y;
        f < 0 && h < 0 ? (c = Ud, h = -h, f = -f, d -= h, u -= f) : f < 0 ? (c = Hd, f = -f, u -= f) : h < 0 && (c = Wd, h = -h, d -= h);
        break;
      case Hd:
        if (l) {
          if (T.x >= 0 && (v >= x || y >= $)) {
            S = !1;
            break;
          }
          k(uc), f += T.x, h = f / l;
        } else
          k(Wl), k(uc), T.x >= 0 ? v < x ? f += T.x : T.y >= 0 && y >= $ && (S = !1) : f += T.x, T.y >= 0 ? y < $ && (h += T.y) : h += T.y;
        f < 0 && h < 0 ? (c = Wd, h = -h, f = -f, d -= h, u -= f) : f < 0 ? (c = Vd, f = -f, u -= f) : h < 0 && (c = Ud, h = -h, d -= h);
        break;
      // Move canvas
      case HF:
        this.move(T.x, T.y), S = !1;
        break;
      // Zoom canvas
      case VF:
        this.zoom(j0e(a), t), S = !1;
        break;
      // Create crop box
      case WF:
        if (!T.x || !T.y) {
          S = !1;
          break;
        }
        O = ez(this.cropper), u = C.startX - O.left, d = C.startY - O.top, f = i.minWidth, h = i.minHeight, T.x > 0 ? c = T.y > 0 ? Hd : Ud : T.x < 0 && (u -= f, c = T.y > 0 ? Vd : Wd), T.y < 0 && (d -= h), this.cropped || (Qi(this.cropBox, Kr), this.cropped = !0, this.limited && this.limitCropBox(!0, !0));
        break;
    }
    S && (i.width = f, i.height = h, i.left = u, i.top = d, this.action = c, this.renderCropBox()), Gn(a, function(I) {
      I.startX = I.endX, I.startY = I.endY;
    });
  }
}, Q0e = {
  // Show the crop box manually
  crop: function() {
    return this.ready && !this.cropped && !this.disabled && (this.cropped = !0, this.limitCropBox(!0, !0), this.options.modal && nr(this.dragBox, e0), Qi(this.cropBox, Kr), this.setCropBoxData(this.initialCropBoxData)), this;
  },
  // Reset the image and crop box to their initial states
  reset: function() {
    return this.ready && !this.disabled && (this.imageData = wn({}, this.initialImageData), this.canvasData = wn({}, this.initialCanvasData), this.cropBoxData = wn({}, this.initialCropBoxData), this.renderCanvas(), this.cropped && this.renderCropBox()), this;
  },
  // Clear the crop box
  clear: function() {
    return this.cropped && !this.disabled && (wn(this.cropBoxData, {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    }), this.cropped = !1, this.renderCropBox(), this.limitCanvas(!0, !0), this.renderCanvas(), Qi(this.dragBox, e0), nr(this.cropBox, Kr)), this;
  },
  /**
   * Replace the image's src and rebuild the cropper
   * @param {string} url - The new URL.
   * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
   * @returns {Cropper} this
   */
  replace: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return !this.disabled && t && (this.isImg && (this.element.src = t), n ? (this.url = t, this.image.src = t, this.ready && (this.viewBoxImage.src = t, Gn(this.previews, function(r) {
      r.getElementsByTagName("img")[0].src = t;
    }))) : (this.isImg && (this.replaced = !0), this.options.data = null, this.uncreate(), this.load(t))), this;
  },
  // Enable (unfreeze) the cropper
  enable: function() {
    return this.ready && this.disabled && (this.disabled = !1, Qi(this.cropper, E5)), this;
  },
  // Disable (freeze) the cropper
  disable: function() {
    return this.ready && !this.disabled && (this.disabled = !0, nr(this.cropper, E5)), this;
  },
  /**
   * Destroy the cropper and remove the instance from the image
   * @returns {Cropper} this
   */
  destroy: function() {
    var t = this.element;
    return t[bn] ? (t[bn] = void 0, this.isImg && this.replaced && (t.src = this.originalUrl), this.uncreate(), this) : this;
  },
  /**
   * Move the canvas with relative offsets
   * @param {number} offsetX - The relative offset distance on the x-axis.
   * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
   * @returns {Cropper} this
   */
  move: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t, r = this.canvasData, o = r.left, i = r.top;
    return this.moveTo(px(t) ? t : o + Number(t), px(n) ? n : i + Number(n));
  },
  /**
   * Move the canvas to an absolute point
   * @param {number} x - The x-axis coordinate.
   * @param {number} [y=x] - The y-axis coordinate.
   * @returns {Cropper} this
   */
  moveTo: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t, r = this.canvasData, o = !1;
    return t = Number(t), n = Number(n), this.ready && !this.disabled && this.options.movable && (Ft(t) && (r.left = t, o = !0), Ft(n) && (r.top = n, o = !0), o && this.renderCanvas(!0)), this;
  },
  /**
   * Zoom the canvas with a relative ratio
   * @param {number} ratio - The target ratio.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoom: function(t, n) {
    var r = this.canvasData;
    return t = Number(t), t < 0 ? t = 1 / (1 - t) : t = 1 + t, this.zoomTo(r.width * t / r.naturalWidth, null, n);
  },
  /**
   * Zoom the canvas to an absolute ratio
   * @param {number} ratio - The target ratio.
   * @param {Object} pivot - The zoom pivot point coordinate.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoomTo: function(t, n, r) {
    var o = this.options, i = this.canvasData, a = i.width, c = i.height, l = i.naturalWidth, u = i.naturalHeight;
    if (t = Number(t), t >= 0 && this.ready && !this.disabled && o.zoomable) {
      var d = l * t, f = u * t;
      if (hu(this.element, MS, {
        ratio: t,
        oldRatio: a / l,
        originalEvent: r
      }) === !1)
        return this;
      if (r) {
        var h = this.pointers, v = ez(this.cropper), y = h && Object.keys(h).length ? F0e(h) : {
          pageX: r.pageX,
          pageY: r.pageY
        };
        i.left -= (d - a) * ((y.pageX - v.left - i.left) / a), i.top -= (f - c) * ((y.pageY - v.top - i.top) / c);
      } else ou(n) && Ft(n.x) && Ft(n.y) ? (i.left -= (d - a) * ((n.x - i.left) / a), i.top -= (f - c) * ((n.y - i.top) / c)) : (i.left -= (d - a) / 2, i.top -= (f - c) / 2);
      i.width = d, i.height = f, this.renderCanvas(!0);
    }
    return this;
  },
  /**
   * Rotate the canvas with a relative degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotate: function(t) {
    return this.rotateTo((this.imageData.rotate || 0) + Number(t));
  },
  /**
   * Rotate the canvas to an absolute degree
   * @param {number} degree - The rotate degree.
   * @returns {Cropper} this
   */
  rotateTo: function(t) {
    return t = Number(t), Ft(t) && this.ready && !this.disabled && this.options.rotatable && (this.imageData.rotate = t % 360, this.renderCanvas(!0, !0)), this;
  },
  /**
   * Scale the image on the x-axis.
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @returns {Cropper} this
   */
  scaleX: function(t) {
    var n = this.imageData.scaleY;
    return this.scale(t, Ft(n) ? n : 1);
  },
  /**
   * Scale the image on the y-axis.
   * @param {number} scaleY - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scaleY: function(t) {
    var n = this.imageData.scaleX;
    return this.scale(Ft(n) ? n : 1, t);
  },
  /**
   * Scale the image
   * @param {number} scaleX - The scale ratio on the x-axis.
   * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
   * @returns {Cropper} this
   */
  scale: function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : t, r = this.imageData, o = !1;
    return t = Number(t), n = Number(n), this.ready && !this.disabled && this.options.scalable && (Ft(t) && (r.scaleX = t, o = !0), Ft(n) && (r.scaleY = n, o = !0), o && this.renderCanvas(!0, !0)), this;
  },
  /**
   * Get the cropped area position and size data (base on the original image)
   * @param {boolean} [rounded=false] - Indicate if round the data values or not.
   * @returns {Object} The result cropped data.
   */
  getData: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, n = this.options, r = this.imageData, o = this.canvasData, i = this.cropBoxData, a;
    if (this.ready && this.cropped) {
      a = {
        x: i.left - o.left,
        y: i.top - o.top,
        width: i.width,
        height: i.height
      };
      var c = r.width / r.naturalWidth;
      if (Gn(a, function(d, f) {
        a[f] = d / c;
      }), t) {
        var l = Math.round(a.y + a.height), u = Math.round(a.x + a.width);
        a.x = Math.round(a.x), a.y = Math.round(a.y), a.width = u - a.x, a.height = l - a.y;
      }
    } else
      a = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      };
    return n.rotatable && (a.rotate = r.rotate || 0), n.scalable && (a.scaleX = r.scaleX || 1, a.scaleY = r.scaleY || 1), a;
  },
  /**
   * Set the cropped area position and size with new data
   * @param {Object} data - The new data.
   * @returns {Cropper} this
   */
  setData: function(t) {
    var n = this.options, r = this.imageData, o = this.canvasData, i = {};
    if (this.ready && !this.disabled && ou(t)) {
      var a = !1;
      n.rotatable && Ft(t.rotate) && t.rotate !== r.rotate && (r.rotate = t.rotate, a = !0), n.scalable && (Ft(t.scaleX) && t.scaleX !== r.scaleX && (r.scaleX = t.scaleX, a = !0), Ft(t.scaleY) && t.scaleY !== r.scaleY && (r.scaleY = t.scaleY, a = !0)), a && this.renderCanvas(!0, !0);
      var c = r.width / r.naturalWidth;
      Ft(t.x) && (i.left = t.x * c + o.left), Ft(t.y) && (i.top = t.y * c + o.top), Ft(t.width) && (i.width = t.width * c), Ft(t.height) && (i.height = t.height * c), this.setCropBoxData(i);
    }
    return this;
  },
  /**
   * Get the container size data.
   * @returns {Object} The result container data.
   */
  getContainerData: function() {
    return this.ready ? wn({}, this.containerData) : {};
  },
  /**
   * Get the image position and size data.
   * @returns {Object} The result image data.
   */
  getImageData: function() {
    return this.sized ? wn({}, this.imageData) : {};
  },
  /**
   * Get the canvas position and size data.
   * @returns {Object} The result canvas data.
   */
  getCanvasData: function() {
    var t = this.canvasData, n = {};
    return this.ready && Gn(["left", "top", "width", "height", "naturalWidth", "naturalHeight"], function(r) {
      n[r] = t[r];
    }), n;
  },
  /**
   * Set the canvas position and size with new data.
   * @param {Object} data - The new canvas data.
   * @returns {Cropper} this
   */
  setCanvasData: function(t) {
    var n = this.canvasData, r = n.aspectRatio;
    return this.ready && !this.disabled && ou(t) && (Ft(t.left) && (n.left = t.left), Ft(t.top) && (n.top = t.top), Ft(t.width) ? (n.width = t.width, n.height = t.width / r) : Ft(t.height) && (n.height = t.height, n.width = t.height * r), this.renderCanvas(!0)), this;
  },
  /**
   * Get the crop box position and size data.
   * @returns {Object} The result crop box data.
   */
  getCropBoxData: function() {
    var t = this.cropBoxData, n;
    return this.ready && this.cropped && (n = {
      left: t.left,
      top: t.top,
      width: t.width,
      height: t.height
    }), n || {};
  },
  /**
   * Set the crop box position and size with new data.
   * @param {Object} data - The new crop box data.
   * @returns {Cropper} this
   */
  setCropBoxData: function(t) {
    var n = this.cropBoxData, r = this.options.aspectRatio, o, i;
    return this.ready && this.cropped && !this.disabled && ou(t) && (Ft(t.left) && (n.left = t.left), Ft(t.top) && (n.top = t.top), Ft(t.width) && t.width !== n.width && (o = !0, n.width = t.width), Ft(t.height) && t.height !== n.height && (i = !0, n.height = t.height), r && (o ? n.height = n.width / r : i && (n.width = n.height * r)), this.renderCropBox()), this;
  },
  /**
   * Get a canvas drawn the cropped image.
   * @param {Object} [options={}] - The config options.
   * @returns {HTMLCanvasElement} - The result canvas.
   */
  getCroppedCanvas: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!this.ready || !window.HTMLCanvasElement)
      return null;
    var n = this.canvasData, r = B0e(this.image, this.imageData, n, t);
    if (!this.cropped)
      return r;
    var o = this.getData(t.rounded), i = o.x, a = o.y, c = o.width, l = o.height, u = r.width / Math.floor(n.naturalWidth);
    u !== 1 && (i *= u, a *= u, c *= u, l *= u);
    var d = c / l, f = Es({
      aspectRatio: d,
      width: t.maxWidth || 1 / 0,
      height: t.maxHeight || 1 / 0
    }), h = Es({
      aspectRatio: d,
      width: t.minWidth || 0,
      height: t.minHeight || 0
    }, "cover"), v = Es({
      aspectRatio: d,
      width: t.width || (u !== 1 ? r.width : c),
      height: t.height || (u !== 1 ? r.height : l)
    }), y = v.width, g = v.height;
    y = Math.min(f.width, Math.max(h.width, y)), g = Math.min(f.height, Math.max(h.height, g));
    var b = document.createElement("canvas"), x = b.getContext("2d");
    b.width = pu(y), b.height = pu(g), x.fillStyle = t.fillColor || "transparent", x.fillRect(0, 0, y, g);
    var $ = t.imageSmoothingEnabled, S = $ === void 0 ? !0 : $, O = t.imageSmoothingQuality;
    x.imageSmoothingEnabled = S, O && (x.imageSmoothingQuality = O);
    var C = r.width, T = r.height, k = i, I = a, P, _, A, D, M, N;
    k <= -c || k > C ? (k = 0, P = 0, A = 0, M = 0) : k <= 0 ? (A = -k, k = 0, P = Math.min(C, c + k), M = P) : k <= C && (A = 0, P = Math.min(c, C - k), M = P), P <= 0 || I <= -l || I > T ? (I = 0, _ = 0, D = 0, N = 0) : I <= 0 ? (D = -I, I = 0, _ = Math.min(T, l + I), N = _) : I <= T && (D = 0, _ = Math.min(l, T - I), N = _);
    var L = [k, I, P, _];
    if (M > 0 && N > 0) {
      var z = y / c;
      L.push(A * z, D * z, M * z, N * z);
    }
    return x.drawImage.apply(x, [r].concat(UF(L.map(function(q) {
      return Math.floor(pu(q));
    })))), b;
  },
  /**
   * Change the aspect ratio of the crop box.
   * @param {number} aspectRatio - The new aspect ratio.
   * @returns {Cropper} this
   */
  setAspectRatio: function(t) {
    var n = this.options;
    return !this.disabled && !px(t) && (n.aspectRatio = Math.max(0, t) || NaN, this.ready && (this.initCropBox(), this.cropped && this.renderCropBox())), this;
  },
  /**
   * Change the drag mode.
   * @param {string} mode - The new drag mode.
   * @returns {Cropper} this
   */
  setDragMode: function(t) {
    var n = this.options, r = this.dragBox, o = this.face;
    if (this.ready && !this.disabled) {
      var i = t === lE, a = n.movable && t === YF;
      t = i || a ? t : GF, n.dragMode = t, Jf(r, Zf, t), iu(r, _S, i), iu(r, kS, a), n.cropBoxMovable || (Jf(o, Zf, t), iu(o, _S, i), iu(o, kS, a));
    }
    return this;
  }
}, eve = la.Cropper, nz = /* @__PURE__ */ function() {
  function e(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (p0e(this, e), !t || !E0e.test(t.tagName))
      throw new Error("The first argument is required and must be an <img> or <canvas> element.");
    this.element = t, this.options = wn({}, L5, ou(n) && n), this.cropped = !1, this.disabled = !1, this.pointers = {}, this.ready = !1, this.reloading = !1, this.replaced = !1, this.sized = !1, this.sizing = !1, this.init();
  }
  return h0e(e, [{
    key: "init",
    value: function() {
      var n = this.element, r = n.tagName.toLowerCase(), o;
      if (!n[bn]) {
        if (n[bn] = this, r === "img") {
          if (this.isImg = !0, o = n.getAttribute("src") || "", this.originalUrl = o, !o)
            return;
          o = n.src;
        } else r === "canvas" && window.HTMLCanvasElement && (o = n.toDataURL());
        this.load(o);
      }
    }
  }, {
    key: "load",
    value: function(n) {
      var r = this;
      if (n) {
        this.url = n, this.imageData = {};
        var o = this.element, i = this.options;
        if (!i.rotatable && !i.scalable && (i.checkOrientation = !1), !i.checkOrientation || !window.ArrayBuffer) {
          this.clone();
          return;
        }
        if (C0e.test(n)) {
          T0e.test(n) ? this.read(W0e(n)) : this.clone();
          return;
        }
        var a = new XMLHttpRequest(), c = this.clone.bind(this);
        this.reloading = !0, this.xhr = a, a.onabort = c, a.onerror = c, a.ontimeout = c, a.onprogress = function() {
          a.getResponseHeader("content-type") !== D5 && a.abort();
        }, a.onload = function() {
          r.read(a.response);
        }, a.onloadend = function() {
          r.reloading = !1, r.xhr = null;
        }, i.checkCrossOrigin && F5(n) && o.crossOrigin && (n = z5(n)), a.open("GET", n, !0), a.responseType = "arraybuffer", a.withCredentials = o.crossOrigin === "use-credentials", a.send();
      }
    }
  }, {
    key: "read",
    value: function(n) {
      var r = this.options, o = this.imageData, i = V0e(n), a = 0, c = 1, l = 1;
      if (i > 1) {
        this.url = H0e(n, D5);
        var u = Y0e(i);
        a = u.rotate, c = u.scaleX, l = u.scaleY;
      }
      r.rotatable && (o.rotate = a), r.scalable && (o.scaleX = c, o.scaleY = l), this.clone();
    }
  }, {
    key: "clone",
    value: function() {
      var n = this.element, r = this.url, o = n.crossOrigin, i = r;
      this.options.checkCrossOrigin && F5(r) && (o || (o = "anonymous"), i = z5(r)), this.crossOrigin = o, this.crossOriginUrl = i;
      var a = document.createElement("img");
      o && (a.crossOrigin = o), a.src = i || r, a.alt = n.alt || "The image to crop", this.image = a, a.onload = this.start.bind(this), a.onerror = this.stop.bind(this), nr(a, _5), n.parentNode.insertBefore(a, n.nextSibling);
    }
  }, {
    key: "start",
    value: function() {
      var n = this, r = this.image;
      r.onload = null, r.onerror = null, this.sizing = !0;
      var o = la.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(la.navigator.userAgent), i = function(u, d) {
        wn(n.imageData, {
          naturalWidth: u,
          naturalHeight: d,
          aspectRatio: u / d
        }), n.initialImageData = wn({}, n.imageData), n.sizing = !1, n.sized = !0, n.build();
      };
      if (r.naturalWidth && !o) {
        i(r.naturalWidth, r.naturalHeight);
        return;
      }
      var a = document.createElement("img"), c = document.body || document.documentElement;
      this.sizingImage = a, a.onload = function() {
        i(a.width, a.height), o || c.removeChild(a);
      }, a.src = r.src, o || (a.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;", c.appendChild(a));
    }
  }, {
    key: "stop",
    value: function() {
      var n = this.image;
      n.onload = null, n.onerror = null, n.parentNode.removeChild(n), this.image = null;
    }
  }, {
    key: "build",
    value: function() {
      if (!(!this.sized || this.ready)) {
        var n = this.element, r = this.options, o = this.image, i = n.parentNode, a = document.createElement("div");
        a.innerHTML = _0e;
        var c = a.querySelector(".".concat(bn, "-container")), l = c.querySelector(".".concat(bn, "-canvas")), u = c.querySelector(".".concat(bn, "-drag-box")), d = c.querySelector(".".concat(bn, "-crop-box")), f = d.querySelector(".".concat(bn, "-face"));
        this.container = i, this.cropper = c, this.canvas = l, this.dragBox = u, this.cropBox = d, this.viewBox = c.querySelector(".".concat(bn, "-view-box")), this.face = f, l.appendChild(o), nr(n, Kr), i.insertBefore(c, n.nextSibling), Qi(o, _5), this.initPreview(), this.bind(), r.initialAspectRatio = Math.max(0, r.initialAspectRatio) || NaN, r.aspectRatio = Math.max(0, r.aspectRatio) || NaN, r.viewMode = Math.max(0, Math.min(3, Math.round(r.viewMode))) || 0, nr(d, Kr), r.guides || nr(d.getElementsByClassName("".concat(bn, "-dashed")), Kr), r.center || nr(d.getElementsByClassName("".concat(bn, "-center")), Kr), r.background && nr(c, "".concat(bn, "-bg")), r.highlight || nr(f, x0e), r.cropBoxMovable && (nr(f, kS), Jf(f, Zf, cE)), r.cropBoxResizable || (nr(d.getElementsByClassName("".concat(bn, "-line")), Kr), nr(d.getElementsByClassName("".concat(bn, "-point")), Kr)), this.render(), this.ready = !0, this.setDragMode(r.dragMode), r.autoCrop && this.crop(), this.setData(r.data), Yr(r.ready) && Fo(n, I5, r.ready, {
          once: !0
        }), hu(n, I5);
      }
    }
  }, {
    key: "unbuild",
    value: function() {
      if (this.ready) {
        this.ready = !1, this.unbind(), this.resetPreview();
        var n = this.cropper.parentNode;
        n && n.removeChild(this.cropper), Qi(this.element, Kr);
      }
    }
  }, {
    key: "uncreate",
    value: function() {
      this.ready ? (this.unbuild(), this.ready = !1, this.cropped = !1) : this.sizing ? (this.sizingImage.onload = null, this.sizing = !1, this.sized = !1) : this.reloading ? (this.xhr.onabort = null, this.xhr.abort()) : this.image && this.stop();
    }
    /**
     * Get the no conflict cropper class.
     * @returns {Cropper} The cropper class.
     */
  }], [{
    key: "noConflict",
    value: function() {
      return window.Cropper = eve, e;
    }
    /**
     * Change the default options.
     * @param {Object} options - The new default options.
     */
  }, {
    key: "setDefaults",
    value: function(n) {
      wn(L5, ou(n) && n);
    }
  }]);
}();
wn(nz.prototype, G0e, K0e, X0e, Z0e, J0e, Q0e);
var xc = function() {
  return xc = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    return e;
  }, xc.apply(this, arguments);
};
function mx(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") {
    var o = 0;
    for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  }
  return n;
}
var tve = ["aspectRatio", "autoCrop", "autoCropArea", "background", "center", "checkCrossOrigin", "checkOrientation", "cropBoxMovable", "cropBoxResizable", "data", "dragMode", "guides", "highlight", "initialAspectRatio", "minCanvasHeight", "minCanvasWidth", "minContainerHeight", "minContainerWidth", "minCropBoxHeight", "minCropBoxWidth", "modal", "movable", "preview", "responsive", "restore", "rotatable", "scalable", "toggleDragModeOnDblclick", "viewMode", "wheelZoomRatio", "zoomOnTouch", "zoomOnWheel", "zoomable", "cropstart", "cropmove", "cropend", "crop", "zoom", "ready"], nve = { opacity: 0, maxWidth: "100%" }, s9e = ye.forwardRef(function(e, t) {
  var n = mx(e, []), r = n.dragMode, o = r === void 0 ? "crop" : r, i = n.src, a = n.style, c = n.className, l = n.crossOrigin, u = n.scaleX, d = n.scaleY, f = n.enable, h = n.zoomTo, v = n.rotateTo, y = n.alt, g = y === void 0 ? "picture" : y, b = n.ready, x = n.onInitialized, $ = mx(n, ["dragMode", "src", "style", "className", "crossOrigin", "scaleX", "scaleY", "enable", "zoomTo", "rotateTo", "alt", "ready", "onInitialized"]), S = { scaleY: d, scaleX: u, enable: f, zoomTo: h, rotateTo: v }, O = function() {
    for (var T = [], k = 0; k < arguments.length; k++) T[k] = arguments[k];
    var I = Gt(null);
    return ye.useEffect(function() {
      T.forEach(function(P) {
        P && (typeof P == "function" ? P(I.current) : P.current = I.current);
      });
    }, [T]), I;
  }(t, Gt(null));
  mn(function() {
    var T;
    !((T = O.current) === null || T === void 0) && T.cropper && typeof h == "number" && O.current.cropper.zoomTo(h);
  }, [n.zoomTo]), mn(function() {
    var T;
    !((T = O.current) === null || T === void 0) && T.cropper && i !== void 0 && O.current.cropper.reset().clear().replace(i);
  }, [i]), mn(function() {
    if (O.current !== null) {
      var T = new nz(O.current, xc(xc({ dragMode: o }, $), { ready: function(k) {
        k.currentTarget !== null && function(I, P) {
          P === void 0 && (P = {});
          var _ = P.enable, A = _ === void 0 || _, D = P.scaleX, M = D === void 0 ? 1 : D, N = P.scaleY, L = N === void 0 ? 1 : N, z = P.zoomTo, q = z === void 0 ? 0 : z, W = P.rotateTo;
          A ? I.enable() : I.disable(), I.scaleX(M), I.scaleY(L), W !== void 0 && I.rotateTo(W), q > 0 && I.zoomTo(q);
        }(k.currentTarget.cropper, S), b && b(k);
      } }));
      x && x(T);
    }
    return function() {
      var k, I;
      (I = (k = O.current) === null || k === void 0 ? void 0 : k.cropper) === null || I === void 0 || I.destroy();
    };
  }, [O]);
  var C = function(T) {
    return tve.reduce(function(k, I) {
      var P = k, _ = I;
      return P[_], mx(P, [typeof _ == "symbol" ? _ : _ + ""]);
    }, T);
  }(xc(xc({}, $), { crossOrigin: l, src: i, alt: g }));
  return ye.createElement("div", { style: a, className: c }, ye.createElement("img", xc({}, C, { style: nve, ref: O })));
}), rve = dF();
const c9e = /* @__PURE__ */ jn(rve);
var gx, B5;
function ove() {
  if (B5) return gx;
  B5 = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return gx = e, gx;
}
var vx, q5;
function Lp() {
  if (q5) return vx;
  q5 = 1;
  function e(t, n) {
    return t === n || t !== t && n !== n;
  }
  return vx = e, vx;
}
var yx, U5;
function kv() {
  if (U5) return yx;
  U5 = 1;
  var e = Lp();
  function t(n, r) {
    for (var o = n.length; o--; )
      if (e(n[o][0], r))
        return o;
    return -1;
  }
  return yx = t, yx;
}
var bx, W5;
function ive() {
  if (W5) return bx;
  W5 = 1;
  var e = kv(), t = Array.prototype, n = t.splice;
  function r(o) {
    var i = this.__data__, a = e(i, o);
    if (a < 0)
      return !1;
    var c = i.length - 1;
    return a == c ? i.pop() : n.call(i, a, 1), --this.size, !0;
  }
  return bx = r, bx;
}
var xx, H5;
function ave() {
  if (H5) return xx;
  H5 = 1;
  var e = kv();
  function t(n) {
    var r = this.__data__, o = e(r, n);
    return o < 0 ? void 0 : r[o][1];
  }
  return xx = t, xx;
}
var wx, V5;
function sve() {
  if (V5) return wx;
  V5 = 1;
  var e = kv();
  function t(n) {
    return e(this.__data__, n) > -1;
  }
  return wx = t, wx;
}
var $x, Y5;
function cve() {
  if (Y5) return $x;
  Y5 = 1;
  var e = kv();
  function t(n, r) {
    var o = this.__data__, i = e(o, n);
    return i < 0 ? (++this.size, o.push([n, r])) : o[i][1] = r, this;
  }
  return $x = t, $x;
}
var Ox, G5;
function Rv() {
  if (G5) return Ox;
  G5 = 1;
  var e = ove(), t = ive(), n = ave(), r = sve(), o = cve();
  function i(a) {
    var c = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++c < l; ) {
      var u = a[c];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, Ox = i, Ox;
}
var Sx, K5;
function lve() {
  if (K5) return Sx;
  K5 = 1;
  var e = Rv();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return Sx = t, Sx;
}
var Cx, X5;
function uve() {
  if (X5) return Cx;
  X5 = 1;
  function e(t) {
    var n = this.__data__, r = n.delete(t);
    return this.size = n.size, r;
  }
  return Cx = e, Cx;
}
var Tx, Z5;
function dve() {
  if (Z5) return Tx;
  Z5 = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return Tx = e, Tx;
}
var Ex, J5;
function fve() {
  if (J5) return Ex;
  J5 = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Ex = e, Ex;
}
var _x, Q5;
function Za() {
  if (Q5) return _x;
  Q5 = 1;
  function e(t) {
    var n = typeof t;
    return t != null && (n == "object" || n == "function");
  }
  return _x = e, _x;
}
var kx, eI;
function rz() {
  if (eI) return kx;
  eI = 1;
  var e = Qu(), t = Za(), n = "[object AsyncFunction]", r = "[object Function]", o = "[object GeneratorFunction]", i = "[object Proxy]";
  function a(c) {
    if (!t(c))
      return !1;
    var l = e(c);
    return l == r || l == o || l == n || l == i;
  }
  return kx = a, kx;
}
var Rx, tI;
function pve() {
  if (tI) return Rx;
  tI = 1;
  var e = ha(), t = e["__core-js_shared__"];
  return Rx = t, Rx;
}
var Px, nI;
function hve() {
  if (nI) return Px;
  nI = 1;
  var e = pve(), t = function() {
    var r = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  }();
  function n(r) {
    return !!t && t in r;
  }
  return Px = n, Px;
}
var Ax, rI;
function oz() {
  if (rI) return Ax;
  rI = 1;
  var e = Function.prototype, t = e.toString;
  function n(r) {
    if (r != null) {
      try {
        return t.call(r);
      } catch {
      }
      try {
        return r + "";
      } catch {
      }
    }
    return "";
  }
  return Ax = n, Ax;
}
var Ix, oI;
function mve() {
  if (oI) return Ix;
  oI = 1;
  var e = rz(), t = hve(), n = Za(), r = oz(), o = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, a = Function.prototype, c = Object.prototype, l = a.toString, u = c.hasOwnProperty, d = RegExp(
    "^" + l.call(u).replace(o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!n(h) || t(h))
      return !1;
    var v = e(h) ? d : i;
    return v.test(r(h));
  }
  return Ix = f, Ix;
}
var Mx, iI;
function gve() {
  if (iI) return Mx;
  iI = 1;
  function e(t, n) {
    return t == null ? void 0 : t[n];
  }
  return Mx = e, Mx;
}
var Nx, aI;
function ol() {
  if (aI) return Nx;
  aI = 1;
  var e = mve(), t = gve();
  function n(r, o) {
    var i = t(r, o);
    return e(i) ? i : void 0;
  }
  return Nx = n, Nx;
}
var Dx, sI;
function dE() {
  if (sI) return Dx;
  sI = 1;
  var e = ol(), t = ha(), n = e(t, "Map");
  return Dx = n, Dx;
}
var Lx, cI;
function Pv() {
  if (cI) return Lx;
  cI = 1;
  var e = ol(), t = e(Object, "create");
  return Lx = t, Lx;
}
var jx, lI;
function vve() {
  if (lI) return jx;
  lI = 1;
  var e = Pv();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return jx = t, jx;
}
var Fx, uI;
function yve() {
  if (uI) return Fx;
  uI = 1;
  function e(t) {
    var n = this.has(t) && delete this.__data__[t];
    return this.size -= n ? 1 : 0, n;
  }
  return Fx = e, Fx;
}
var zx, dI;
function bve() {
  if (dI) return zx;
  dI = 1;
  var e = Pv(), t = "__lodash_hash_undefined__", n = Object.prototype, r = n.hasOwnProperty;
  function o(i) {
    var a = this.__data__;
    if (e) {
      var c = a[i];
      return c === t ? void 0 : c;
    }
    return r.call(a, i) ? a[i] : void 0;
  }
  return zx = o, zx;
}
var Bx, fI;
function xve() {
  if (fI) return Bx;
  fI = 1;
  var e = Pv(), t = Object.prototype, n = t.hasOwnProperty;
  function r(o) {
    var i = this.__data__;
    return e ? i[o] !== void 0 : n.call(i, o);
  }
  return Bx = r, Bx;
}
var qx, pI;
function wve() {
  if (pI) return qx;
  pI = 1;
  var e = Pv(), t = "__lodash_hash_undefined__";
  function n(r, o) {
    var i = this.__data__;
    return this.size += this.has(r) ? 0 : 1, i[r] = e && o === void 0 ? t : o, this;
  }
  return qx = n, qx;
}
var Ux, hI;
function $ve() {
  if (hI) return Ux;
  hI = 1;
  var e = vve(), t = yve(), n = bve(), r = xve(), o = wve();
  function i(a) {
    var c = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++c < l; ) {
      var u = a[c];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, Ux = i, Ux;
}
var Wx, mI;
function Ove() {
  if (mI) return Wx;
  mI = 1;
  var e = $ve(), t = Rv(), n = dE();
  function r() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (n || t)(),
      string: new e()
    };
  }
  return Wx = r, Wx;
}
var Hx, gI;
function Sve() {
  if (gI) return Hx;
  gI = 1;
  function e(t) {
    var n = typeof t;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
  }
  return Hx = e, Hx;
}
var Vx, vI;
function Av() {
  if (vI) return Vx;
  vI = 1;
  var e = Sve();
  function t(n, r) {
    var o = n.__data__;
    return e(r) ? o[typeof r == "string" ? "string" : "hash"] : o.map;
  }
  return Vx = t, Vx;
}
var Yx, yI;
function Cve() {
  if (yI) return Yx;
  yI = 1;
  var e = Av();
  function t(n) {
    var r = e(this, n).delete(n);
    return this.size -= r ? 1 : 0, r;
  }
  return Yx = t, Yx;
}
var Gx, bI;
function Tve() {
  if (bI) return Gx;
  bI = 1;
  var e = Av();
  function t(n) {
    return e(this, n).get(n);
  }
  return Gx = t, Gx;
}
var Kx, xI;
function Eve() {
  if (xI) return Kx;
  xI = 1;
  var e = Av();
  function t(n) {
    return e(this, n).has(n);
  }
  return Kx = t, Kx;
}
var Xx, wI;
function _ve() {
  if (wI) return Xx;
  wI = 1;
  var e = Av();
  function t(n, r) {
    var o = e(this, n), i = o.size;
    return o.set(n, r), this.size += o.size == i ? 0 : 1, this;
  }
  return Xx = t, Xx;
}
var Zx, $I;
function fE() {
  if ($I) return Zx;
  $I = 1;
  var e = Ove(), t = Cve(), n = Tve(), r = Eve(), o = _ve();
  function i(a) {
    var c = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++c < l; ) {
      var u = a[c];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, Zx = i, Zx;
}
var Jx, OI;
function kve() {
  if (OI) return Jx;
  OI = 1;
  var e = Rv(), t = dE(), n = fE(), r = 200;
  function o(i, a) {
    var c = this.__data__;
    if (c instanceof e) {
      var l = c.__data__;
      if (!t || l.length < r - 1)
        return l.push([i, a]), this.size = ++c.size, this;
      c = this.__data__ = new n(l);
    }
    return c.set(i, a), this.size = c.size, this;
  }
  return Jx = o, Jx;
}
var Qx, SI;
function pE() {
  if (SI) return Qx;
  SI = 1;
  var e = Rv(), t = lve(), n = uve(), r = dve(), o = fve(), i = kve();
  function a(c) {
    var l = this.__data__ = new e(c);
    this.size = l.size;
  }
  return a.prototype.clear = t, a.prototype.delete = n, a.prototype.get = r, a.prototype.has = o, a.prototype.set = i, Qx = a, Qx;
}
var ew, CI;
function Rve() {
  if (CI) return ew;
  CI = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length; ++r < o && n(t[r], r, t) !== !1; )
      ;
    return t;
  }
  return ew = e, ew;
}
var tw, TI;
function iz() {
  if (TI) return tw;
  TI = 1;
  var e = ol(), t = function() {
    try {
      var n = e(Object, "defineProperty");
      return n({}, "", {}), n;
    } catch {
    }
  }();
  return tw = t, tw;
}
var nw, EI;
function hE() {
  if (EI) return nw;
  EI = 1;
  var e = iz();
  function t(n, r, o) {
    r == "__proto__" && e ? e(n, r, {
      configurable: !0,
      enumerable: !0,
      value: o,
      writable: !0
    }) : n[r] = o;
  }
  return nw = t, nw;
}
var rw, _I;
function mE() {
  if (_I) return rw;
  _I = 1;
  var e = hE(), t = Lp(), n = Object.prototype, r = n.hasOwnProperty;
  function o(i, a, c) {
    var l = i[a];
    (!(r.call(i, a) && t(l, c)) || c === void 0 && !(a in i)) && e(i, a, c);
  }
  return rw = o, rw;
}
var ow, kI;
function jp() {
  if (kI) return ow;
  kI = 1;
  var e = mE(), t = hE();
  function n(r, o, i, a) {
    var c = !i;
    i || (i = {});
    for (var l = -1, u = o.length; ++l < u; ) {
      var d = o[l], f = a ? a(i[d], r[d], d, i, r) : void 0;
      f === void 0 && (f = r[d]), c ? t(i, d, f) : e(i, d, f);
    }
    return i;
  }
  return ow = n, ow;
}
var iw, RI;
function Pve() {
  if (RI) return iw;
  RI = 1;
  function e(t, n) {
    for (var r = -1, o = Array(t); ++r < t; )
      o[r] = n(r);
    return o;
  }
  return iw = e, iw;
}
var aw, PI;
function Ave() {
  if (PI) return aw;
  PI = 1;
  var e = Qu(), t = Ka(), n = "[object Arguments]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return aw = r, aw;
}
var sw, AI;
function gE() {
  if (AI) return sw;
  AI = 1;
  var e = Ave(), t = Ka(), n = Object.prototype, r = n.hasOwnProperty, o = n.propertyIsEnumerable, i = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(a) {
    return t(a) && r.call(a, "callee") && !o.call(a, "callee");
  };
  return sw = i, sw;
}
var of = { exports: {} }, cw, II;
function Ive() {
  if (II) return cw;
  II = 1;
  function e() {
    return !1;
  }
  return cw = e, cw;
}
of.exports;
var MI;
function vE() {
  return MI || (MI = 1, function(e, t) {
    var n = ha(), r = Ive(), o = t && !t.nodeType && t, i = o && !0 && e && !e.nodeType && e, a = i && i.exports === o, c = a ? n.Buffer : void 0, l = c ? c.isBuffer : void 0, u = l || r;
    e.exports = u;
  }(of, of.exports)), of.exports;
}
var lw, NI;
function Iv() {
  if (NI) return lw;
  NI = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function n(r, o) {
    var i = typeof r;
    return o = o ?? e, !!o && (i == "number" || i != "symbol" && t.test(r)) && r > -1 && r % 1 == 0 && r < o;
  }
  return lw = n, lw;
}
var uw, DI;
function yE() {
  if (DI) return uw;
  DI = 1;
  var e = 9007199254740991;
  function t(n) {
    return typeof n == "number" && n > -1 && n % 1 == 0 && n <= e;
  }
  return uw = t, uw;
}
var dw, LI;
function Mve() {
  if (LI) return dw;
  LI = 1;
  var e = Qu(), t = yE(), n = Ka(), r = "[object Arguments]", o = "[object Array]", i = "[object Boolean]", a = "[object Date]", c = "[object Error]", l = "[object Function]", u = "[object Map]", d = "[object Number]", f = "[object Object]", h = "[object RegExp]", v = "[object Set]", y = "[object String]", g = "[object WeakMap]", b = "[object ArrayBuffer]", x = "[object DataView]", $ = "[object Float32Array]", S = "[object Float64Array]", O = "[object Int8Array]", C = "[object Int16Array]", T = "[object Int32Array]", k = "[object Uint8Array]", I = "[object Uint8ClampedArray]", P = "[object Uint16Array]", _ = "[object Uint32Array]", A = {};
  A[$] = A[S] = A[O] = A[C] = A[T] = A[k] = A[I] = A[P] = A[_] = !0, A[r] = A[o] = A[b] = A[i] = A[x] = A[a] = A[c] = A[l] = A[u] = A[d] = A[f] = A[h] = A[v] = A[y] = A[g] = !1;
  function D(M) {
    return n(M) && t(M.length) && !!A[e(M)];
  }
  return dw = D, dw;
}
var fw, jI;
function Mv() {
  if (jI) return fw;
  jI = 1;
  function e(t) {
    return function(n) {
      return t(n);
    };
  }
  return fw = e, fw;
}
var af = { exports: {} };
af.exports;
var FI;
function bE() {
  return FI || (FI = 1, function(e, t) {
    var n = aF(), r = t && !t.nodeType && t, o = r && !0 && e && !e.nodeType && e, i = o && o.exports === r, a = i && n.process, c = function() {
      try {
        var l = o && o.require && o.require("util").types;
        return l || a && a.binding && a.binding("util");
      } catch {
      }
    }();
    e.exports = c;
  }(af, af.exports)), af.exports;
}
var pw, zI;
function az() {
  if (zI) return pw;
  zI = 1;
  var e = Mve(), t = Mv(), n = bE(), r = n && n.isTypedArray, o = r ? t(r) : e;
  return pw = o, pw;
}
var hw, BI;
function sz() {
  if (BI) return hw;
  BI = 1;
  var e = Pve(), t = gE(), n = Ci(), r = vE(), o = Iv(), i = az(), a = Object.prototype, c = a.hasOwnProperty;
  function l(u, d) {
    var f = n(u), h = !f && t(u), v = !f && !h && r(u), y = !f && !h && !v && i(u), g = f || h || v || y, b = g ? e(u.length, String) : [], x = b.length;
    for (var $ in u)
      (d || c.call(u, $)) && !(g && // Safari 9 has enumerable `arguments.length` in strict mode.
      ($ == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && ($ == "offset" || $ == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      y && ($ == "buffer" || $ == "byteLength" || $ == "byteOffset") || // Skip index properties.
      o($, x))) && b.push($);
    return b;
  }
  return hw = l, hw;
}
var mw, qI;
function xE() {
  if (qI) return mw;
  qI = 1;
  var e = Object.prototype;
  function t(n) {
    var r = n && n.constructor, o = typeof r == "function" && r.prototype || e;
    return n === o;
  }
  return mw = t, mw;
}
var gw, UI;
function cz() {
  if (UI) return gw;
  UI = 1;
  function e(t, n) {
    return function(r) {
      return t(n(r));
    };
  }
  return gw = e, gw;
}
var vw, WI;
function Nve() {
  if (WI) return vw;
  WI = 1;
  var e = cz(), t = e(Object.keys, Object);
  return vw = t, vw;
}
var yw, HI;
function Dve() {
  if (HI) return yw;
  HI = 1;
  var e = xE(), t = Nve(), n = Object.prototype, r = n.hasOwnProperty;
  function o(i) {
    if (!e(i))
      return t(i);
    var a = [];
    for (var c in Object(i))
      r.call(i, c) && c != "constructor" && a.push(c);
    return a;
  }
  return yw = o, yw;
}
var bw, VI;
function Fp() {
  if (VI) return bw;
  VI = 1;
  var e = rz(), t = yE();
  function n(r) {
    return r != null && t(r.length) && !e(r);
  }
  return bw = n, bw;
}
var xw, YI;
function rd() {
  if (YI) return xw;
  YI = 1;
  var e = sz(), t = Dve(), n = Fp();
  function r(o) {
    return n(o) ? e(o) : t(o);
  }
  return xw = r, xw;
}
var ww, GI;
function Lve() {
  if (GI) return ww;
  GI = 1;
  var e = jp(), t = rd();
  function n(r, o) {
    return r && e(o, t(o), r);
  }
  return ww = n, ww;
}
var $w, KI;
function jve() {
  if (KI) return $w;
  KI = 1;
  function e(t) {
    var n = [];
    if (t != null)
      for (var r in Object(t))
        n.push(r);
    return n;
  }
  return $w = e, $w;
}
var Ow, XI;
function Fve() {
  if (XI) return Ow;
  XI = 1;
  var e = Za(), t = xE(), n = jve(), r = Object.prototype, o = r.hasOwnProperty;
  function i(a) {
    if (!e(a))
      return n(a);
    var c = t(a), l = [];
    for (var u in a)
      u == "constructor" && (c || !o.call(a, u)) || l.push(u);
    return l;
  }
  return Ow = i, Ow;
}
var Sw, ZI;
function Nv() {
  if (ZI) return Sw;
  ZI = 1;
  var e = sz(), t = Fve(), n = Fp();
  function r(o) {
    return n(o) ? e(o, !0) : t(o);
  }
  return Sw = r, Sw;
}
var Cw, JI;
function zve() {
  if (JI) return Cw;
  JI = 1;
  var e = jp(), t = Nv();
  function n(r, o) {
    return r && e(o, t(o), r);
  }
  return Cw = n, Cw;
}
var sf = { exports: {} };
sf.exports;
var QI;
function Bve() {
  return QI || (QI = 1, function(e, t) {
    var n = ha(), r = t && !t.nodeType && t, o = r && !0 && e && !e.nodeType && e, i = o && o.exports === r, a = i ? n.Buffer : void 0, c = a ? a.allocUnsafe : void 0;
    function l(u, d) {
      if (d)
        return u.slice();
      var f = u.length, h = c ? c(f) : new u.constructor(f);
      return u.copy(h), h;
    }
    e.exports = l;
  }(sf, sf.exports)), sf.exports;
}
var Tw, e9;
function qve() {
  if (e9) return Tw;
  e9 = 1;
  function e(t, n) {
    var r = -1, o = t.length;
    for (n || (n = Array(o)); ++r < o; )
      n[r] = t[r];
    return n;
  }
  return Tw = e, Tw;
}
var Ew, t9;
function Uve() {
  if (t9) return Ew;
  t9 = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length, i = 0, a = []; ++r < o; ) {
      var c = t[r];
      n(c, r, t) && (a[i++] = c);
    }
    return a;
  }
  return Ew = e, Ew;
}
var _w, n9;
function lz() {
  if (n9) return _w;
  n9 = 1;
  function e() {
    return [];
  }
  return _w = e, _w;
}
var kw, r9;
function wE() {
  if (r9) return kw;
  r9 = 1;
  var e = Uve(), t = lz(), n = Object.prototype, r = n.propertyIsEnumerable, o = Object.getOwnPropertySymbols, i = o ? function(a) {
    return a == null ? [] : (a = Object(a), e(o(a), function(c) {
      return r.call(a, c);
    }));
  } : t;
  return kw = i, kw;
}
var Rw, o9;
function Wve() {
  if (o9) return Rw;
  o9 = 1;
  var e = jp(), t = wE();
  function n(r, o) {
    return e(r, t(r), o);
  }
  return Rw = n, Rw;
}
var Pw, i9;
function $E() {
  if (i9) return Pw;
  i9 = 1;
  function e(t, n) {
    for (var r = -1, o = n.length, i = t.length; ++r < o; )
      t[i + r] = n[r];
    return t;
  }
  return Pw = e, Pw;
}
var Aw, a9;
function OE() {
  if (a9) return Aw;
  a9 = 1;
  var e = cz(), t = e(Object.getPrototypeOf, Object);
  return Aw = t, Aw;
}
var Iw, s9;
function uz() {
  if (s9) return Iw;
  s9 = 1;
  var e = $E(), t = OE(), n = wE(), r = lz(), o = Object.getOwnPropertySymbols, i = o ? function(a) {
    for (var c = []; a; )
      e(c, n(a)), a = t(a);
    return c;
  } : r;
  return Iw = i, Iw;
}
var Mw, c9;
function Hve() {
  if (c9) return Mw;
  c9 = 1;
  var e = jp(), t = uz();
  function n(r, o) {
    return e(r, t(r), o);
  }
  return Mw = n, Mw;
}
var Nw, l9;
function dz() {
  if (l9) return Nw;
  l9 = 1;
  var e = $E(), t = Ci();
  function n(r, o, i) {
    var a = o(r);
    return t(r) ? a : e(a, i(r));
  }
  return Nw = n, Nw;
}
var Dw, u9;
function fz() {
  if (u9) return Dw;
  u9 = 1;
  var e = dz(), t = wE(), n = rd();
  function r(o) {
    return e(o, n, t);
  }
  return Dw = r, Dw;
}
var Lw, d9;
function pz() {
  if (d9) return Lw;
  d9 = 1;
  var e = dz(), t = uz(), n = Nv();
  function r(o) {
    return e(o, n, t);
  }
  return Lw = r, Lw;
}
var jw, f9;
function Vve() {
  if (f9) return jw;
  f9 = 1;
  var e = ol(), t = ha(), n = e(t, "DataView");
  return jw = n, jw;
}
var Fw, p9;
function Yve() {
  if (p9) return Fw;
  p9 = 1;
  var e = ol(), t = ha(), n = e(t, "Promise");
  return Fw = n, Fw;
}
var zw, h9;
function hz() {
  if (h9) return zw;
  h9 = 1;
  var e = ol(), t = ha(), n = e(t, "Set");
  return zw = n, zw;
}
var Bw, m9;
function Gve() {
  if (m9) return Bw;
  m9 = 1;
  var e = ol(), t = ha(), n = e(t, "WeakMap");
  return Bw = n, Bw;
}
var qw, g9;
function Dv() {
  if (g9) return qw;
  g9 = 1;
  var e = Vve(), t = dE(), n = Yve(), r = hz(), o = Gve(), i = Qu(), a = oz(), c = "[object Map]", l = "[object Object]", u = "[object Promise]", d = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", v = a(e), y = a(t), g = a(n), b = a(r), x = a(o), $ = i;
  return (e && $(new e(new ArrayBuffer(1))) != h || t && $(new t()) != c || n && $(n.resolve()) != u || r && $(new r()) != d || o && $(new o()) != f) && ($ = function(S) {
    var O = i(S), C = O == l ? S.constructor : void 0, T = C ? a(C) : "";
    if (T)
      switch (T) {
        case v:
          return h;
        case y:
          return c;
        case g:
          return u;
        case b:
          return d;
        case x:
          return f;
      }
    return O;
  }), qw = $, qw;
}
var Uw, v9;
function Kve() {
  if (v9) return Uw;
  v9 = 1;
  var e = Object.prototype, t = e.hasOwnProperty;
  function n(r) {
    var o = r.length, i = new r.constructor(o);
    return o && typeof r[0] == "string" && t.call(r, "index") && (i.index = r.index, i.input = r.input), i;
  }
  return Uw = n, Uw;
}
var Ww, y9;
function mz() {
  if (y9) return Ww;
  y9 = 1;
  var e = ha(), t = e.Uint8Array;
  return Ww = t, Ww;
}
var Hw, b9;
function SE() {
  if (b9) return Hw;
  b9 = 1;
  var e = mz();
  function t(n) {
    var r = new n.constructor(n.byteLength);
    return new e(r).set(new e(n)), r;
  }
  return Hw = t, Hw;
}
var Vw, x9;
function Xve() {
  if (x9) return Vw;
  x9 = 1;
  var e = SE();
  function t(n, r) {
    var o = r ? e(n.buffer) : n.buffer;
    return new n.constructor(o, n.byteOffset, n.byteLength);
  }
  return Vw = t, Vw;
}
var Yw, w9;
function Zve() {
  if (w9) return Yw;
  w9 = 1;
  var e = /\w*$/;
  function t(n) {
    var r = new n.constructor(n.source, e.exec(n));
    return r.lastIndex = n.lastIndex, r;
  }
  return Yw = t, Yw;
}
var Gw, $9;
function Jve() {
  if ($9) return Gw;
  $9 = 1;
  var e = Ju(), t = e ? e.prototype : void 0, n = t ? t.valueOf : void 0;
  function r(o) {
    return n ? Object(n.call(o)) : {};
  }
  return Gw = r, Gw;
}
var Kw, O9;
function Qve() {
  if (O9) return Kw;
  O9 = 1;
  var e = SE();
  function t(n, r) {
    var o = r ? e(n.buffer) : n.buffer;
    return new n.constructor(o, n.byteOffset, n.length);
  }
  return Kw = t, Kw;
}
var Xw, S9;
function eye() {
  if (S9) return Xw;
  S9 = 1;
  var e = SE(), t = Xve(), n = Zve(), r = Jve(), o = Qve(), i = "[object Boolean]", a = "[object Date]", c = "[object Map]", l = "[object Number]", u = "[object RegExp]", d = "[object Set]", f = "[object String]", h = "[object Symbol]", v = "[object ArrayBuffer]", y = "[object DataView]", g = "[object Float32Array]", b = "[object Float64Array]", x = "[object Int8Array]", $ = "[object Int16Array]", S = "[object Int32Array]", O = "[object Uint8Array]", C = "[object Uint8ClampedArray]", T = "[object Uint16Array]", k = "[object Uint32Array]";
  function I(P, _, A) {
    var D = P.constructor;
    switch (_) {
      case v:
        return e(P);
      case i:
      case a:
        return new D(+P);
      case y:
        return t(P, A);
      case g:
      case b:
      case x:
      case $:
      case S:
      case O:
      case C:
      case T:
      case k:
        return o(P, A);
      case c:
        return new D();
      case l:
      case f:
        return new D(P);
      case u:
        return n(P);
      case d:
        return new D();
      case h:
        return r(P);
    }
  }
  return Xw = I, Xw;
}
var Zw, C9;
function tye() {
  if (C9) return Zw;
  C9 = 1;
  var e = Za(), t = Object.create, n = /* @__PURE__ */ function() {
    function r() {
    }
    return function(o) {
      if (!e(o))
        return {};
      if (t)
        return t(o);
      r.prototype = o;
      var i = new r();
      return r.prototype = void 0, i;
    };
  }();
  return Zw = n, Zw;
}
var Jw, T9;
function nye() {
  if (T9) return Jw;
  T9 = 1;
  var e = tye(), t = OE(), n = xE();
  function r(o) {
    return typeof o.constructor == "function" && !n(o) ? e(t(o)) : {};
  }
  return Jw = r, Jw;
}
var Qw, E9;
function rye() {
  if (E9) return Qw;
  E9 = 1;
  var e = Dv(), t = Ka(), n = "[object Map]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return Qw = r, Qw;
}
var e2, _9;
function oye() {
  if (_9) return e2;
  _9 = 1;
  var e = rye(), t = Mv(), n = bE(), r = n && n.isMap, o = r ? t(r) : e;
  return e2 = o, e2;
}
var t2, k9;
function iye() {
  if (k9) return t2;
  k9 = 1;
  var e = Dv(), t = Ka(), n = "[object Set]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return t2 = r, t2;
}
var n2, R9;
function aye() {
  if (R9) return n2;
  R9 = 1;
  var e = iye(), t = Mv(), n = bE(), r = n && n.isSet, o = r ? t(r) : e;
  return n2 = o, n2;
}
var r2, P9;
function sye() {
  if (P9) return r2;
  P9 = 1;
  var e = pE(), t = Rve(), n = mE(), r = Lve(), o = zve(), i = Bve(), a = qve(), c = Wve(), l = Hve(), u = fz(), d = pz(), f = Dv(), h = Kve(), v = eye(), y = nye(), g = Ci(), b = vE(), x = oye(), $ = Za(), S = aye(), O = rd(), C = Nv(), T = 1, k = 2, I = 4, P = "[object Arguments]", _ = "[object Array]", A = "[object Boolean]", D = "[object Date]", M = "[object Error]", N = "[object Function]", L = "[object GeneratorFunction]", z = "[object Map]", q = "[object Number]", W = "[object Object]", U = "[object RegExp]", K = "[object Set]", Y = "[object String]", X = "[object Symbol]", oe = "[object WeakMap]", re = "[object ArrayBuffer]", Z = "[object DataView]", ce = "[object Float32Array]", fe = "[object Float64Array]", de = "[object Int8Array]", ne = "[object Int16Array]", le = "[object Int32Array]", ve = "[object Uint8Array]", G = "[object Uint8ClampedArray]", Se = "[object Uint16Array]", ue = "[object Uint32Array]", Q = {};
  Q[P] = Q[_] = Q[re] = Q[Z] = Q[A] = Q[D] = Q[ce] = Q[fe] = Q[de] = Q[ne] = Q[le] = Q[z] = Q[q] = Q[W] = Q[U] = Q[K] = Q[Y] = Q[X] = Q[ve] = Q[G] = Q[Se] = Q[ue] = !0, Q[M] = Q[N] = Q[oe] = !1;
  function ie(ee, be, Ie, je, V, se) {
    var we, J = be & T, he = be & k, Te = be & I;
    if (Ie && (we = V ? Ie(ee, je, V, se) : Ie(ee)), we !== void 0)
      return we;
    if (!$(ee))
      return ee;
    var xe = g(ee);
    if (xe) {
      if (we = h(ee), !J)
        return a(ee, we);
    } else {
      var Ae = f(ee), Ce = Ae == N || Ae == L;
      if (b(ee))
        return i(ee, J);
      if (Ae == W || Ae == P || Ce && !V) {
        if (we = he || Ce ? {} : y(ee), !J)
          return he ? l(ee, o(we, ee)) : c(ee, r(we, ee));
      } else {
        if (!Q[Ae])
          return V ? ee : {};
        we = v(ee, Ae, J);
      }
    }
    se || (se = new e());
    var Ye = se.get(ee);
    if (Ye)
      return Ye;
    se.set(ee, we), S(ee) ? ee.forEach(function(Xe) {
      we.add(ie(Xe, be, Ie, Xe, ee, se));
    }) : x(ee) && ee.forEach(function(Xe, Ze) {
      we.set(Ze, ie(Xe, be, Ie, Ze, ee, se));
    });
    var He = Te ? he ? d : u : he ? C : O, Be = xe ? void 0 : He(ee);
    return t(Be || ee, function(Xe, Ze) {
      Be && (Ze = Xe, Xe = ee[Ze]), n(we, Ze, ie(Xe, be, Ie, Ze, ee, se));
    }), we;
  }
  return r2 = ie, r2;
}
var o2, A9;
function CE() {
  if (A9) return o2;
  A9 = 1;
  var e = Ci(), t = wv(), n = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, r = /^\w*$/;
  function o(i, a) {
    if (e(i))
      return !1;
    var c = typeof i;
    return c == "number" || c == "symbol" || c == "boolean" || i == null || t(i) ? !0 : r.test(i) || !n.test(i) || a != null && i in Object(a);
  }
  return o2 = o, o2;
}
var i2, I9;
function cye() {
  if (I9) return i2;
  I9 = 1;
  var e = fE(), t = "Expected a function";
  function n(r, o) {
    if (typeof r != "function" || o != null && typeof o != "function")
      throw new TypeError(t);
    var i = function() {
      var a = arguments, c = o ? o.apply(this, a) : a[0], l = i.cache;
      if (l.has(c))
        return l.get(c);
      var u = r.apply(this, a);
      return i.cache = l.set(c, u) || l, u;
    };
    return i.cache = new (n.Cache || e)(), i;
  }
  return n.Cache = e, i2 = n, i2;
}
var a2, M9;
function lye() {
  if (M9) return a2;
  M9 = 1;
  var e = cye(), t = 500;
  function n(r) {
    var o = e(r, function(a) {
      return i.size === t && i.clear(), a;
    }), i = o.cache;
    return o;
  }
  return a2 = n, a2;
}
var s2, N9;
function uye() {
  if (N9) return s2;
  N9 = 1;
  var e = lye(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, n = /\\(\\)?/g, r = e(function(o) {
    var i = [];
    return o.charCodeAt(0) === 46 && i.push(""), o.replace(t, function(a, c, l, u) {
      i.push(l ? u.replace(n, "$1") : c || a);
    }), i;
  });
  return s2 = r, s2;
}
var c2, D9;
function od() {
  if (D9) return c2;
  D9 = 1;
  var e = Ci(), t = CE(), n = uye(), r = ed();
  function o(i, a) {
    return e(i) ? i : t(i, a) ? [i] : n(r(i));
  }
  return c2 = o, c2;
}
var l2, L9;
function gz() {
  if (L9) return l2;
  L9 = 1;
  function e(t) {
    var n = t == null ? 0 : t.length;
    return n ? t[n - 1] : void 0;
  }
  return l2 = e, l2;
}
var u2, j9;
function id() {
  if (j9) return u2;
  j9 = 1;
  var e = wv(), t = 1 / 0;
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var o = r + "";
    return o == "0" && 1 / r == -t ? "-0" : o;
  }
  return u2 = n, u2;
}
var d2, F9;
function Lv() {
  if (F9) return d2;
  F9 = 1;
  var e = od(), t = id();
  function n(r, o) {
    o = e(o, r);
    for (var i = 0, a = o.length; r != null && i < a; )
      r = r[t(o[i++])];
    return i && i == a ? r : void 0;
  }
  return d2 = n, d2;
}
var f2, z9;
function dye() {
  if (z9) return f2;
  z9 = 1;
  var e = Lv(), t = cF();
  function n(r, o) {
    return o.length < 2 ? r : e(r, t(o, 0, -1));
  }
  return f2 = n, f2;
}
var p2, B9;
function fye() {
  if (B9) return p2;
  B9 = 1;
  var e = od(), t = gz(), n = dye(), r = id();
  function o(i, a) {
    return a = e(a, i), i = n(i, a), i == null || delete i[r(t(a))];
  }
  return p2 = o, p2;
}
var h2, q9;
function pye() {
  if (q9) return h2;
  q9 = 1;
  var e = Qu(), t = OE(), n = Ka(), r = "[object Object]", o = Function.prototype, i = Object.prototype, a = o.toString, c = i.hasOwnProperty, l = a.call(Object);
  function u(d) {
    if (!n(d) || e(d) != r)
      return !1;
    var f = t(d);
    if (f === null)
      return !0;
    var h = c.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && a.call(h) == l;
  }
  return h2 = u, h2;
}
var m2, U9;
function hye() {
  if (U9) return m2;
  U9 = 1;
  var e = pye();
  function t(n) {
    return e(n) ? void 0 : n;
  }
  return m2 = t, m2;
}
var g2, W9;
function mye() {
  if (W9) return g2;
  W9 = 1;
  var e = Ju(), t = gE(), n = Ci(), r = e ? e.isConcatSpreadable : void 0;
  function o(i) {
    return n(i) || t(i) || !!(r && i && i[r]);
  }
  return g2 = o, g2;
}
var v2, H9;
function gye() {
  if (H9) return v2;
  H9 = 1;
  var e = $E(), t = mye();
  function n(r, o, i, a, c) {
    var l = -1, u = r.length;
    for (i || (i = t), c || (c = []); ++l < u; ) {
      var d = r[l];
      o > 0 && i(d) ? o > 1 ? n(d, o - 1, i, a, c) : e(c, d) : a || (c[c.length] = d);
    }
    return c;
  }
  return v2 = n, v2;
}
var y2, V9;
function vye() {
  if (V9) return y2;
  V9 = 1;
  var e = gye();
  function t(n) {
    var r = n == null ? 0 : n.length;
    return r ? e(n, 1) : [];
  }
  return y2 = t, y2;
}
var b2, Y9;
function yye() {
  if (Y9) return b2;
  Y9 = 1;
  function e(t, n, r) {
    switch (r.length) {
      case 0:
        return t.call(n);
      case 1:
        return t.call(n, r[0]);
      case 2:
        return t.call(n, r[0], r[1]);
      case 3:
        return t.call(n, r[0], r[1], r[2]);
    }
    return t.apply(n, r);
  }
  return b2 = e, b2;
}
var x2, G9;
function vz() {
  if (G9) return x2;
  G9 = 1;
  var e = yye(), t = Math.max;
  function n(r, o, i) {
    return o = t(o === void 0 ? r.length - 1 : o, 0), function() {
      for (var a = arguments, c = -1, l = t(a.length - o, 0), u = Array(l); ++c < l; )
        u[c] = a[o + c];
      c = -1;
      for (var d = Array(o + 1); ++c < o; )
        d[c] = a[c];
      return d[o] = i(u), e(r, this, d);
    };
  }
  return x2 = n, x2;
}
var w2, K9;
function bye() {
  if (K9) return w2;
  K9 = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return w2 = e, w2;
}
var $2, X9;
function TE() {
  if (X9) return $2;
  X9 = 1;
  function e(t) {
    return t;
  }
  return $2 = e, $2;
}
var O2, Z9;
function xye() {
  if (Z9) return O2;
  Z9 = 1;
  var e = bye(), t = iz(), n = TE(), r = t ? function(o, i) {
    return t(o, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(i),
      writable: !0
    });
  } : n;
  return O2 = r, O2;
}
var S2, J9;
function wye() {
  if (J9) return S2;
  J9 = 1;
  var e = 800, t = 16, n = Date.now;
  function r(o) {
    var i = 0, a = 0;
    return function() {
      var c = n(), l = t - (c - a);
      if (a = c, l > 0) {
        if (++i >= e)
          return arguments[0];
      } else
        i = 0;
      return o.apply(void 0, arguments);
    };
  }
  return S2 = r, S2;
}
var C2, Q9;
function yz() {
  if (Q9) return C2;
  Q9 = 1;
  var e = xye(), t = wye(), n = t(e);
  return C2 = n, C2;
}
var T2, eM;
function bz() {
  if (eM) return T2;
  eM = 1;
  var e = vye(), t = vz(), n = yz();
  function r(o) {
    return n(t(o, void 0, e), o + "");
  }
  return T2 = r, T2;
}
var E2, tM;
function $ye() {
  if (tM) return E2;
  tM = 1;
  var e = Ap(), t = sye(), n = fye(), r = od(), o = jp(), i = hye(), a = bz(), c = pz(), l = 1, u = 2, d = 4, f = a(function(h, v) {
    var y = {};
    if (h == null)
      return y;
    var g = !1;
    v = e(v, function(x) {
      return x = r(x, h), g || (g = x.length > 1), x;
    }), o(h, c(h), y), g && (y = t(y, l | u | d, i));
    for (var b = v.length; b--; )
      n(y, v[b]);
    return y;
  });
  return E2 = f, E2;
}
var Oye = $ye();
const l9e = /* @__PURE__ */ jn(Oye);
var _2, nM;
function Sye() {
  if (nM) return _2;
  nM = 1;
  function e(t) {
    for (var n = -1, r = t == null ? 0 : t.length, o = 0, i = []; ++n < r; ) {
      var a = t[n];
      a && (i[o++] = a);
    }
    return i;
  }
  return _2 = e, _2;
}
var Cye = Sye();
const u9e = /* @__PURE__ */ jn(Cye);
class cf extends Error {
}
cf.prototype.name = "InvalidTokenError";
function Tye(e) {
  return decodeURIComponent(atob(e).replace(/(.)/g, (t, n) => {
    let r = n.charCodeAt(0).toString(16).toUpperCase();
    return r.length < 2 && (r = "0" + r), "%" + r;
  }));
}
function Eye(e) {
  let t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return Tye(t);
  } catch {
    return atob(t);
  }
}
function d9e(e, t) {
  if (typeof e != "string")
    throw new cf("Invalid token specified: must be a string");
  t || (t = {});
  const n = t.header === !0 ? 0 : 1, r = e.split(".")[n];
  if (typeof r != "string")
    throw new cf(`Invalid token specified: missing part #${n + 1}`);
  let o;
  try {
    o = Eye(r);
  } catch (i) {
    throw new cf(`Invalid token specified: invalid base64 for part #${n + 1} (${i.message})`);
  }
  try {
    return JSON.parse(o);
  } catch (i) {
    throw new cf(`Invalid token specified: invalid json for part #${n + 1} (${i.message})`);
  }
}
var k2, rM;
function _ye() {
  if (rM) return k2;
  rM = 1;
  var e = Ap();
  function t(n, r) {
    return e(r, function(o) {
      return n[o];
    });
  }
  return k2 = t, k2;
}
var R2, oM;
function kye() {
  if (oM) return R2;
  oM = 1;
  var e = _ye(), t = rd();
  function n(r) {
    return r == null ? [] : e(r, t(r));
  }
  return R2 = n, R2;
}
var Rye = kye();
const f9e = /* @__PURE__ */ jn(Rye);
var ft;
(function(e) {
  e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})(ft || (ft = {}));
var pn;
(function(e) {
  e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(pn || (pn = {}));
var mi;
(function(e) {
  e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(mi || (mi = {}));
const iM = 5, Pye = 4;
function Aye(e, t) {
  const n = t.startOfMonth(e), r = n.getDay() > 0 ? n.getDay() : 7, o = t.addDays(e, -r + 1), i = t.addDays(o, iM * 7 - 1);
  return e.getMonth() === i.getMonth() ? iM : Pye;
}
function xz(e, t) {
  const n = t.startOfMonth(e), r = n.getDay();
  return r === 1 ? n : r === 0 ? t.addDays(n, -1 * 6) : t.addDays(n, -1 * (r - 1));
}
function Iye(e, t) {
  const n = xz(e, t), r = Aye(e, t);
  return t.addDays(n, r * 7 - 1);
}
class Ja {
  /**
   * Creates an instance of DateLib.
   *
   * @param options The options for the date library.
   * @param overrides Overrides for the date library functions.
   */
  constructor(t, n) {
    this.Date = Date, this.addDays = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.addDays ? this.overrides.addDays(r, o) : Vc(r, o);
    }, this.addMonths = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.addMonths ? this.overrides.addMonths(r, o) : bv(r, o);
    }, this.addWeeks = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.addWeeks ? this.overrides.addWeeks(r, o) : qT(r, o);
    }, this.addYears = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.addYears ? this.overrides.addYears(r, o) : UT(r, o);
    }, this.differenceInCalendarDays = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(r, o) : Bj(r, o);
    }, this.differenceInCalendarMonths = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(r, o) : rpe(r, o);
    }, this.endOfBroadcastWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(r, this) : Iye(r, this);
    }, this.endOfISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfISOWeek ? this.overrides.endOfISOWeek(r) : ope(r);
    }, this.endOfMonth = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfMonth ? this.overrides.endOfMonth(r) : Hj(r);
    }, this.endOfWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfWeek ? this.overrides.endOfWeek(r, this.options) : HT(r, this.options);
    }, this.endOfYear = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfYear ? this.overrides.endOfYear(r) : gS(r);
    }, this.format = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.format ? this.overrides.format(r, o, this.options) : Xj(r, o, this.options);
    }, this.getISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.getISOWeek ? this.overrides.getISOWeek(r) : VT(r);
    }, this.getWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.getWeek ? this.overrides.getWeek(r, this.options) : xv(r, this.options);
    }, this.isAfter = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.isAfter ? this.overrides.isAfter(r, o) : og(r, o);
    }, this.isBefore = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.isBefore ? this.overrides.isBefore(r, o) : ig(r, o);
    }, this.isDate = (r) => {
      var o;
      return (o = this.overrides) != null && o.isDate ? this.overrides.isDate(r) : Uj(r);
    }, this.isSameDay = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.isSameDay ? this.overrides.isSameDay(r, o) : qj(r, o);
    }, this.isSameMonth = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.isSameMonth ? this.overrides.isSameMonth(r, o) : nF(r, o);
    }, this.isSameYear = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.isSameYear ? this.overrides.isSameYear(r, o) : rF(r, o);
    }, this.max = (r) => {
      var o;
      return (o = this.overrides) != null && o.max ? this.overrides.max(r) : tpe(r);
    }, this.min = (r) => {
      var o;
      return (o = this.overrides) != null && o.min ? this.overrides.min(r) : npe(r);
    }, this.setMonth = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.setMonth ? this.overrides.setMonth(r, o) : oF(r, o);
    }, this.setYear = (r, o) => {
      var i;
      return (i = this.overrides) != null && i.setYear ? this.overrides.setYear(r, o) : iF(r, o);
    }, this.startOfBroadcastWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(r, this) : xz(r, this);
    }, this.startOfDay = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfDay ? this.overrides.startOfDay(r) : _u(r);
    }, this.startOfISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfISOWeek ? this.overrides.startOfISOWeek(r) : Yc(r);
    }, this.startOfMonth = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfMonth ? this.overrides.startOfMonth(r) : Vj(r);
    }, this.startOfWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfWeek ? this.overrides.startOfWeek(r, this.options) : aa(r, this.options);
    }, this.startOfYear = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfYear ? this.overrides.startOfYear(r) : WT(r);
    }, this.options = { locale: Zu, ...t }, this.overrides = n;
  }
}
const il = new Ja();
function Mye(e, t, n = {}) {
  return Object.entries(e).filter(([, o]) => o === !0).reduce((o, [i]) => (n[i] ? o.push(n[i]) : t[pn[i]] ? o.push(t[pn[i]]) : t[mi[i]] && o.push(t[mi[i]]), o), [t[ft.Day]]);
}
function Nye(e) {
  return ye.createElement("button", { ...e });
}
function Dye(e) {
  return ye.createElement("span", { ...e });
}
function Lye(e) {
  const { size: t = 24, orientation: n = "left", className: r } = e;
  return ye.createElement(
    "svg",
    { className: r, width: t, height: t, viewBox: "0 0 24 24" },
    n === "up" && ye.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
    n === "down" && ye.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
    n === "left" && ye.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
    n === "right" && ye.createElement("polygon", { points: "8 18.612 14.1888889 12.5 8 6.37733333 9.91111111 4.5 18 12.5 9.91111111 20.5" })
  );
}
function jye(e) {
  const { day: t, modifiers: n, ...r } = e;
  return ye.createElement("td", { ...r });
}
function Fye(e) {
  const { day: t, modifiers: n, ...r } = e, o = ye.useRef(null);
  return ye.useEffect(() => {
    var i;
    n.focused && ((i = o.current) == null || i.focus());
  }, [n.focused]), ye.createElement("button", { ref: o, ...r });
}
function zye(e) {
  const { options: t, className: n, components: r, classNames: o, ...i } = e, a = [o[ft.Dropdown], n].join(" "), c = t == null ? void 0 : t.find(({ value: l }) => l === i.value);
  return ye.createElement(
    "span",
    { "data-disabled": i.disabled, className: o[ft.DropdownRoot] },
    ye.createElement(r.Select, { className: a, ...i }, t == null ? void 0 : t.map(({ value: l, label: u, disabled: d }) => ye.createElement(r.Option, { key: l, value: l, disabled: d }, u))),
    ye.createElement(
      "span",
      { className: o[ft.CaptionLabel], "aria-hidden": !0 },
      c == null ? void 0 : c.label,
      ye.createElement(r.Chevron, { orientation: "down", size: 18, className: o[ft.Chevron] })
    )
  );
}
function Bye(e) {
  return ye.createElement("div", { ...e });
}
function qye(e) {
  return ye.createElement("div", { ...e });
}
function Uye(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return ye.createElement("div", { ...r }, e.children);
}
function Wye(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return ye.createElement("div", { ...r });
}
function Hye(e) {
  return ye.createElement("table", { ...e });
}
function Vye(e) {
  return ye.createElement("div", { ...e });
}
const wz = j0(void 0);
function zp() {
  const e = pa(wz);
  if (e === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return e;
}
function Yye(e) {
  const { components: t } = zp();
  return ye.createElement(t.Dropdown, { ...e });
}
function Gye(e) {
  const { onPreviousClick: t, onNextClick: n, previousMonth: r, nextMonth: o, ...i } = e, { components: a, classNames: c, labels: { labelPrevious: l, labelNext: u } } = zp();
  return ye.createElement(
    "nav",
    { ...i },
    ye.createElement(
      a.PreviousMonthButton,
      { type: "button", className: c[ft.PreviousMonthButton], tabIndex: r ? void 0 : -1, disabled: r ? void 0 : !0, "aria-label": l(r), onClick: e.onPreviousClick },
      ye.createElement(a.Chevron, { disabled: r ? void 0 : !0, className: c[ft.Chevron], orientation: "left" })
    ),
    ye.createElement(
      a.NextMonthButton,
      { type: "button", className: c[ft.NextMonthButton], tabIndex: o ? void 0 : -1, disabled: o ? void 0 : !0, "aria-label": u(o), onClick: e.onNextClick },
      ye.createElement(a.Chevron, { disabled: o ? void 0 : !0, orientation: "right", className: c[ft.Chevron] })
    )
  );
}
function Kye(e) {
  const { components: t } = zp();
  return ye.createElement(t.Button, { ...e });
}
function Xye(e) {
  return ye.createElement("option", { ...e });
}
function Zye(e) {
  const { components: t } = zp();
  return ye.createElement(t.Button, { ...e });
}
function Jye(e) {
  return ye.createElement("div", { ...e });
}
function Qye(e) {
  return ye.createElement("select", { ...e });
}
function ebe(e) {
  const { week: t, ...n } = e;
  return ye.createElement("tr", { ...n });
}
function tbe(e) {
  return ye.createElement("th", { ...e });
}
function nbe(e) {
  return ye.createElement(
    "thead",
    { "aria-hidden": !0 },
    ye.createElement("tr", { ...e })
  );
}
function rbe(e) {
  const { week: t, ...n } = e;
  return ye.createElement("th", { ...n });
}
function obe(e) {
  return ye.createElement("th", { ...e });
}
function ibe(e) {
  return ye.createElement("tbody", { ...e });
}
function abe(e) {
  const { components: t } = zp();
  return ye.createElement(t.Dropdown, { ...e });
}
const sbe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: Nye,
  CaptionLabel: Dye,
  Chevron: Lye,
  Day: jye,
  DayButton: Fye,
  Dropdown: zye,
  DropdownNav: Bye,
  Footer: qye,
  Month: Uye,
  MonthCaption: Wye,
  MonthGrid: Hye,
  Months: Vye,
  MonthsDropdown: Yye,
  Nav: Gye,
  NextMonthButton: Kye,
  Option: Xye,
  PreviousMonthButton: Zye,
  Root: Jye,
  Select: Qye,
  Week: ebe,
  WeekNumber: rbe,
  WeekNumberHeader: obe,
  Weekday: tbe,
  Weekdays: nbe,
  Weeks: ibe,
  YearsDropdown: abe
}, Symbol.toStringTag, { value: "Module" }));
function cbe(e) {
  return {
    ...sbe,
    ...e
  };
}
function lbe(e) {
  const t = {
    "data-mode": e.mode ?? void 0,
    "data-required": "required" in e ? e.required : void 0,
    "data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
    "data-week-numbers": e.showWeekNumber || void 0,
    "data-broadcast-calendar": e.broadcastCalendar || void 0
  };
  return Object.entries(e).forEach(([n, r]) => {
    n.startsWith("data-") && (t[n] = r);
  }), t;
}
function ube() {
  const e = {};
  for (const t in ft)
    e[ft[t]] = `rdp-${ft[t]}`;
  for (const t in pn)
    e[pn[t]] = `rdp-${pn[t]}`;
  for (const t in mi)
    e[mi[t]] = `rdp-${mi[t]}`;
  return e;
}
function $z(e, t, n) {
  return (n ?? new Ja(t)).format(e, "LLLL y");
}
const dbe = $z;
function fbe(e, t, n) {
  return (n ?? new Ja(t)).format(e, "d");
}
function pbe(e, t) {
  var n;
  return (n = t.localize) == null ? void 0 : n.month(e);
}
function hbe(e) {
  return e < 10 ? `0${e.toLocaleString()}` : `${e.toLocaleString()}`;
}
function mbe() {
  return "";
}
function gbe(e, t, n) {
  return (n ?? new Ja(t)).format(e, "cccccc");
}
function Oz(e) {
  return e.toString();
}
const vbe = Oz, ybe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: $z,
  formatDay: fbe,
  formatMonthCaption: dbe,
  formatMonthDropdown: pbe,
  formatWeekNumber: hbe,
  formatWeekNumberHeader: mbe,
  formatWeekdayName: gbe,
  formatYearCaption: vbe,
  formatYearDropdown: Oz
}, Symbol.toStringTag, { value: "Module" }));
function bbe(e) {
  return e != null && e.formatMonthCaption && !e.formatCaption && (e.formatCaption = e.formatMonthCaption), e != null && e.formatYearCaption && !e.formatYearDropdown && (e.formatYearDropdown = e.formatYearCaption), {
    ...ybe,
    ...e
  };
}
function xbe(e, t, n, r, o) {
  if (!t || !n)
    return;
  const { addMonths: i, startOfMonth: a } = o, c = e.getFullYear(), l = [];
  let u = t;
  for (; l.length < 12; )
    l.push(u.getMonth()), u = i(u, 1);
  return l.sort((h, v) => h - v).map((h) => {
    const v = r.formatMonthDropdown(h, o.options.locale ?? Zu), y = o.Date ? new o.Date(c, h) : new Date(c, h), g = t && y < a(t) || n && y > a(n) || !1;
    return { value: h, label: v, disabled: g };
  });
}
function wbe(e, t = {}, n = {}) {
  let r = { ...t == null ? void 0 : t[ft.Day] };
  return Object.entries(e).filter(([, o]) => o === !0).forEach(([o]) => {
    r = {
      ...r,
      ...n == null ? void 0 : n[o]
    };
  }), r;
}
const P2 = {}, lf = {};
function Of(e, t) {
  try {
    const r = (P2[e] || (P2[e] = new Intl.DateTimeFormat("en-GB", {
      timeZone: e,
      hour: "numeric",
      timeZoneName: "longOffset"
    }).format))(t).split("GMT")[1] || "";
    return r in lf ? lf[r] : aM(r, r.split(":"));
  } catch {
    if (e in lf) return lf[e];
    const n = e == null ? void 0 : e.match($be);
    return n ? aM(e, n.slice(1)) : NaN;
  }
}
const $be = /([+-]\d\d):?(\d\d)?/;
function aM(e, t) {
  const n = +t[0], r = +(t[1] || 0);
  return lf[e] = n > 0 ? n * 60 + r : n * 60 - r;
}
class Yi extends Date {
  //#region static
  constructor(...t) {
    super(), t.length > 1 && typeof t[t.length - 1] == "string" && (this.timeZone = t.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(Of(this.timeZone, this)) ? this.setTime(NaN) : t.length ? typeof t[0] == "number" && (t.length === 1 || t.length === 2 && typeof t[1] != "number") ? this.setTime(t[0]) : typeof t[0] == "string" ? this.setTime(+new Date(t[0])) : t[0] instanceof Date ? this.setTime(+t[0]) : (this.setTime(+new Date(...t)), Sz(this), DS(this)) : this.setTime(Date.now());
  }
  static tz(t, ...n) {
    return n.length ? new Yi(...n, t) : new Yi(Date.now(), t);
  }
  //#endregion
  //#region time zone
  withTimeZone(t) {
    return new Yi(+this, t);
  }
  getTimezoneOffset() {
    return -Of(this.timeZone, this);
  }
  //#endregion
  //#region time
  setTime(t) {
    return Date.prototype.setTime.apply(this, arguments), DS(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new Yi(+new Date(t), this.timeZone);
  }
  //#endregion
}
const sM = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!sM.test(e)) return;
  const t = e.replace(sM, "$1UTC");
  Yi.prototype[t] && (e.startsWith("get") ? Yi.prototype[e] = function() {
    return this.internal[t]();
  } : (Yi.prototype[e] = function() {
    return Date.prototype[t].apply(this.internal, arguments), Obe(this), +this;
  }, Yi.prototype[t] = function() {
    return Date.prototype[t].apply(this, arguments), DS(this), +this;
  }));
});
function DS(e) {
  e.internal.setTime(+e), e.internal.setUTCMinutes(e.internal.getUTCMinutes() - e.getTimezoneOffset());
}
function Obe(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), Sz(e);
}
function Sz(e) {
  const t = Of(e.timeZone, e), n = /* @__PURE__ */ new Date(+e);
  n.setUTCHours(n.getUTCHours() - 1);
  const r = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), o = -(/* @__PURE__ */ new Date(+n)).getTimezoneOffset(), i = r - o, a = Date.prototype.getHours.apply(e) !== e.internal.getUTCHours();
  i && a && e.internal.setUTCMinutes(e.internal.getUTCMinutes() + i);
  const c = r - t;
  c && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + c);
  const l = Of(e.timeZone, e), d = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - l, f = l !== t, h = d - c;
  if (f && h) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + h);
    const v = Of(e.timeZone, e), y = l - v;
    y && (e.internal.setUTCMinutes(e.internal.getUTCMinutes() + y), Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + y));
  }
}
class Gi extends Yi {
  //#region static
  static tz(t, ...n) {
    return n.length ? new Gi(...n, t) : new Gi(Date.now(), t);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [t, n, r] = this.tzComponents(), o = `${t}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + o;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [t, n, r, o] = this.internal.toUTCString().split(" ");
    return `${t == null ? void 0 : t.slice(0, -1)} ${r} ${n} ${o}`;
  }
  toTimeString() {
    const t = this.internal.toUTCString().split(" ")[4], [n, r, o] = this.tzComponents();
    return `${t} GMT${n}${r}${o} (${Sbe(this.timeZone, this)})`;
  }
  toLocaleString(t, n) {
    return Date.prototype.toLocaleString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(t, n) {
    return Date.prototype.toLocaleDateString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(t, n) {
    return Date.prototype.toLocaleTimeString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const t = this.getTimezoneOffset(), n = t > 0 ? "-" : "+", r = String(Math.floor(Math.abs(t) / 60)).padStart(2, "0"), o = String(Math.abs(t) % 60).padStart(2, "0");
    return [n, r, o];
  }
  //#endregion
  withTimeZone(t) {
    return new Gi(+this, t);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new Gi(+new Date(t), this.timeZone);
  }
  //#endregion
}
function Sbe(e, t) {
  return new Intl.DateTimeFormat("en-GB", {
    timeZone: e,
    timeZoneName: "long"
  }).format(t).slice(12);
}
function Cbe(e, t, n, r) {
  const o = n ? Gi.tz(n) : e.Date ? new e.Date() : /* @__PURE__ */ new Date(), i = t ? e.startOfISOWeek(o) : e.startOfWeek(o), a = [];
  for (let c = 0; c < 7; c++) {
    const l = e.addDays(i, c);
    a.push(l);
  }
  return a;
}
function Tbe(e, t, n, r) {
  if (!e || !t)
    return;
  const { startOfYear: o, endOfYear: i, addYears: a, isBefore: c, isSameYear: l } = r, u = o(e), d = i(t), f = [];
  let h = u;
  for (; c(h, d) || l(h, d); )
    f.push(h.getFullYear()), h = a(h, 1);
  return f.map((v) => {
    const y = n.formatYearDropdown(v);
    return {
      value: v,
      label: y,
      disabled: !1
    };
  });
}
function Cz(e, t, n) {
  return (n ?? new Ja(t)).format(e, "LLLL y");
}
const Ebe = Cz;
function _be(e, t, n, r) {
  let o = (r ?? new Ja(n)).format(e, "PPPP");
  return t != null && t.today && (o = `Today, ${o}`), o;
}
function Tz(e, t, n, r) {
  let o = (r ?? new Ja(n)).format(e, "PPPP");
  return t.today && (o = `Today, ${o}`), t.selected && (o = `${o}, selected`), o;
}
const kbe = Tz;
function Rbe() {
  return "";
}
function Pbe(e) {
  return "Choose the Month";
}
function Abe(e) {
  return "Go to the Next Month";
}
function Ibe(e) {
  return "Go to the Previous Month";
}
function Mbe(e, t, n) {
  return (n ?? new Ja(t)).format(e, "cccc");
}
function Nbe(e, t) {
  return `Week ${e}`;
}
function Dbe(e) {
  return "Week Number";
}
function Lbe(e) {
  return "Choose the Year";
}
const jbe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: Ebe,
  labelDay: kbe,
  labelDayButton: Tz,
  labelGrid: Cz,
  labelGridcell: _be,
  labelMonthDropdown: Pbe,
  labelNav: Rbe,
  labelNext: Abe,
  labelPrevious: Ibe,
  labelWeekNumber: Nbe,
  labelWeekNumberHeader: Dbe,
  labelWeekday: Mbe,
  labelYearDropdown: Lbe
}, Symbol.toStringTag, { value: "Module" }));
function Fbe(e, t, n, r) {
  const o = e[0], i = e[e.length - 1], { ISOWeek: a, fixedWeeks: c, broadcastCalendar: l } = n ?? {}, { addDays: u, differenceInCalendarDays: d, differenceInCalendarMonths: f, endOfBroadcastWeek: h, endOfISOWeek: v, endOfMonth: y, endOfWeek: g, isAfter: b, startOfBroadcastWeek: x, startOfISOWeek: $, startOfWeek: S } = r, O = l ? x(o, r) : a ? $(o) : S(o), C = l ? h(i, r) : a ? v(y(i)) : g(y(i)), T = d(C, O), k = f(i, o) + 1, I = [];
  for (let A = 0; A <= T; A++) {
    const D = u(O, A);
    if (t && b(D, t))
      break;
    I.push(D);
  }
  const _ = (l ? 35 : 42) * k;
  if (c && I.length < _) {
    const A = _ - I.length;
    for (let D = 0; D < A; D++) {
      const M = u(I[I.length - 1], 1);
      I.push(M);
    }
  }
  return I;
}
function zbe(e) {
  const t = [];
  return e.reduce((n, r) => {
    const o = [], i = r.weeks.reduce((a, c) => [...a, ...c.days], o);
    return [...n, ...i];
  }, t);
}
function Bbe(e, t, n, r) {
  const { numberOfMonths: o = 1 } = n, i = [];
  for (let a = 0; a < o; a++) {
    const c = r.addMonths(e, a);
    if (t && c > t)
      break;
    i.push(c);
  }
  return i;
}
function cM(e, t) {
  const { month: n, defaultMonth: r, today: o = e.timeZone ? Gi.tz(e.timeZone) : t.Date ? new t.Date() : /* @__PURE__ */ new Date(), numberOfMonths: i = 1, endMonth: a, startMonth: c } = e;
  let l = n || r || o;
  const { differenceInCalendarMonths: u, addMonths: d, startOfMonth: f } = t;
  if (a && u(a, l) < 0) {
    const h = -1 * (i - 1);
    l = d(a, h);
  }
  return c && u(l, c) < 0 && (l = c), f(l);
}
class Ez {
  constructor(t, n, r = il) {
    this.date = t, this.displayMonth = n, this.outside = !!(n && !r.isSameMonth(t, n)), this.dateLib = r;
  }
  /**
   * Check if the day is the same as the given day: considering if it is in the
   * same display month.
   */
  isEqualTo(t) {
    return this.dateLib.isSameDay(t.date, this.date) && this.dateLib.isSameMonth(t.displayMonth, this.displayMonth);
  }
}
class qbe {
  constructor(t, n) {
    this.date = t, this.weeks = n;
  }
}
class Ube {
  constructor(t, n) {
    this.days = n, this.weekNumber = t;
  }
}
function Wbe(e, t, n, r) {
  const { addDays: o, endOfBroadcastWeek: i, endOfISOWeek: a, endOfMonth: c, endOfWeek: l, getISOWeek: u, getWeek: d, startOfBroadcastWeek: f, startOfISOWeek: h, startOfWeek: v } = r, y = e.reduce((g, b) => {
    const x = n.broadcastCalendar ? f(b, r) : n.ISOWeek ? h(b) : v(b), $ = n.broadcastCalendar ? i(b, r) : n.ISOWeek ? a(c(b)) : l(c(b)), S = t.filter((k) => k >= x && k <= $), O = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && S.length < O) {
      const k = t.filter((I) => {
        const P = O - S.length;
        return I > $ && I <= o($, P);
      });
      S.push(...k);
    }
    const C = S.reduce((k, I) => {
      const P = n.ISOWeek ? u(I) : d(I), _ = k.find((D) => D.weekNumber === P), A = new Ez(I, b, r);
      return _ ? _.days.push(A) : k.push(new Ube(P, [A])), k;
    }, []), T = new qbe(b, C);
    return g.push(T), g;
  }, []);
  return n.reverseMonths ? y.reverse() : y;
}
function Hbe(e, t) {
  var g;
  let { startMonth: n, endMonth: r } = e;
  const { startOfYear: o, startOfDay: i, startOfMonth: a, endOfMonth: c, addYears: l, endOfYear: u } = t, { fromYear: d, toYear: f, fromMonth: h, toMonth: v } = e;
  !n && h && (n = h), !n && d && (n = new Date(d, 0, 1)), !r && v && (r = v), !r && f && (r = new Date(f, 11, 31));
  const y = (g = e.captionLayout) == null ? void 0 : g.startsWith("dropdown");
  if (n)
    n = a(n);
  else if (d)
    n = new Date(d, 0, 1);
  else if (!n && y) {
    const b = e.today ?? (e.timeZone ? Gi.tz(e.timeZone) : t.Date ? new t.Date() : /* @__PURE__ */ new Date());
    n = o(l(b, -100));
  }
  if (r)
    r = c(r);
  else if (f)
    r = new Date(f, 11, 31);
  else if (!r && y) {
    const b = e.today ?? (e.timeZone ? Gi.tz(e.timeZone) : t.Date ? new t.Date() : /* @__PURE__ */ new Date());
    r = u(b);
  }
  return [
    n && i(n),
    r && i(r)
  ];
}
function Vbe(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: i = 1 } = n, { startOfMonth: a, addMonths: c, differenceInCalendarMonths: l } = r, u = o ? i : 1, d = a(e);
  if (!t)
    return c(d, u);
  if (!(l(t, e) < i))
    return c(d, u);
}
function Ybe(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: i } = n, { startOfMonth: a, addMonths: c, differenceInCalendarMonths: l } = r, u = o ? i ?? 1 : 1, d = a(e);
  if (!t)
    return c(d, -u);
  if (!(l(d, t) <= 0))
    return c(d, -u);
}
function Gbe(e) {
  const t = [];
  return e.reduce((n, r) => [...n, ...r.weeks], t);
}
function jv(e, t) {
  const [n, r] = Uc(e);
  return [t === void 0 ? n : t, r];
}
function Kbe(e, t) {
  const [n, r] = Hbe(e, t), { startOfMonth: o, endOfMonth: i } = t, a = cM(e, t), [c, l] = jv(a, e.month ? o(e.month) : void 0);
  mn(() => {
    const T = cM(e, t);
    l(T);
  }, [e.timeZone]);
  const u = Bbe(c, r, e, t), d = Fbe(u, e.endMonth ? i(e.endMonth) : void 0, e, t), f = Wbe(u, d, e, t), h = Gbe(f), v = zbe(f), y = Ybe(c, n, e, t), g = Vbe(c, r, e, t), { disableNavigation: b, onMonthChange: x } = e, $ = (T) => h.some((k) => k.days.some((I) => I.isEqualTo(T))), S = (T) => {
    if (b)
      return;
    let k = o(T);
    n && k < o(n) && (k = o(n)), r && k > o(r) && (k = o(r)), l(k), x == null || x(k);
  };
  return {
    months: f,
    weeks: h,
    days: v,
    navStart: n,
    navEnd: r,
    previousMonth: y,
    nextMonth: g,
    goToMonth: S,
    goToDay: (T) => {
      $(T) || S(T.date);
    }
  };
}
function Xbe(e, t, n, r) {
  let o, i = 0, a = !1;
  for (; i < e.length && !a; ) {
    const c = e[i], l = t(c);
    !l[pn.disabled] && !l[pn.hidden] && !l[pn.outside] && (l[pn.focused] || r != null && r.isEqualTo(c) || n(c.date) || l[pn.today]) && (o = c, a = !0), i++;
  }
  return o || (o = e.find((c) => {
    const l = t(c);
    return !l[pn.disabled] && !l[pn.hidden] && !l[pn.outside];
  })), o;
}
function La(e, t, n = !1, r = il) {
  let { from: o, to: i } = e;
  const { differenceInCalendarDays: a, isSameDay: c } = r;
  return o && i ? (a(i, o) < 0 && ([o, i] = [i, o]), a(t, o) >= (n ? 1 : 0) && a(i, t) >= (n ? 1 : 0)) : !n && i ? c(i, t) : !n && o ? c(o, t) : !1;
}
function _z(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function EE(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function kz(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function Rz(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function Pz(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function Az(e, t) {
  return Array.isArray(e) && e.every(t.isDate);
}
function ja(e, t, n = il) {
  const r = Array.isArray(t) ? t : [t], { isSameDay: o, differenceInCalendarDays: i, isAfter: a } = n;
  return r.some((c) => {
    if (typeof c == "boolean")
      return c;
    if (n.isDate(c))
      return o(e, c);
    if (Az(c, n))
      return c.includes(e);
    if (EE(c))
      return La(c, e, !1, n);
    if (Pz(c))
      return Array.isArray(c.dayOfWeek) ? c.dayOfWeek.includes(e.getDay()) : c.dayOfWeek === e.getDay();
    if (_z(c)) {
      const l = i(c.before, e), u = i(c.after, e), d = l > 0, f = u < 0;
      return a(c.before, c.after) ? f && d : d || f;
    }
    return kz(c) ? i(e, c.after) > 0 : Rz(c) ? i(c.before, e) > 0 : typeof c == "function" ? c(e) : !1;
  });
}
function Zbe(e, t, n, r, o, i, a) {
  const { ISOWeek: c, broadcastCalendar: l } = i, { addDays: u, addMonths: d, addWeeks: f, addYears: h, endOfBroadcastWeek: v, endOfISOWeek: y, endOfWeek: g, max: b, min: x, startOfBroadcastWeek: $, startOfISOWeek: S, startOfWeek: O } = a;
  let T = {
    day: u,
    week: f,
    month: d,
    year: h,
    startOfWeek: (k) => l ? $(k, a) : c ? S(k) : O(k),
    endOfWeek: (k) => l ? v(k, a) : c ? y(k) : g(k)
  }[e](n, t === "after" ? 1 : -1);
  return t === "before" && r ? T = b([r, T]) : t === "after" && o && (T = x([o, T])), T;
}
function Iz(e, t, n, r, o, i, a, c = 0) {
  if (c > 365)
    return;
  const l = Zbe(
    e,
    t,
    n.date,
    // should be refDay? or refDay.date?
    r,
    o,
    i,
    a
  ), u = !!(i.disabled && ja(l, i.disabled, a)), d = !!(i.hidden && ja(l, i.hidden, a)), f = l, h = new Ez(l, f, a);
  return !u && !d ? h : Iz(e, t, h, r, o, i, a, c + 1);
}
function Jbe(e, t, n, r, o) {
  const { autoFocus: i } = e, [a, c] = Uc(), l = Xbe(t.days, n, r || (() => !1), a), [u, d] = Uc(i ? l : void 0);
  return {
    isFocusTarget: (g) => !!(l != null && l.isEqualTo(g)),
    setFocused: d,
    focused: u,
    blur: () => {
      c(u), d(void 0);
    },
    moveFocus: (g, b) => {
      if (!u)
        return;
      const x = Iz(g, b, u, t.navStart, t.navEnd, e, o);
      x && (t.goToDay(x), d(x));
    }
  };
}
function Qbe(e, t, n) {
  const { disabled: r, hidden: o, modifiers: i, showOutsideDays: a, broadcastCalendar: c, today: l } = t, { isSameDay: u, isSameMonth: d, startOfMonth: f, isBefore: h, endOfMonth: v, isAfter: y } = n, g = t.startMonth && f(t.startMonth), b = t.endMonth && v(t.endMonth), x = {
    [pn.focused]: [],
    [pn.outside]: [],
    [pn.disabled]: [],
    [pn.hidden]: [],
    [pn.today]: []
  }, $ = {};
  for (const S of e) {
    const { date: O, displayMonth: C } = S, T = !!(C && !d(O, C)), k = !!(g && h(O, g)), I = !!(b && y(O, b)), P = !!(r && ja(O, r, n)), _ = !!(o && ja(O, o, n)) || k || I || // Broadcast calendar will show outside days as default
    !c && !a && T || c && a === !1 && T, A = u(O, l ?? (t.timeZone ? Gi.tz(t.timeZone) : n.Date ? new n.Date() : /* @__PURE__ */ new Date()));
    T && x.outside.push(S), P && x.disabled.push(S), _ && x.hidden.push(S), A && x.today.push(S), i && Object.keys(i).forEach((D) => {
      const M = i == null ? void 0 : i[D];
      M && ja(O, M, n) && ($[D] ? $[D].push(S) : $[D] = [S]);
    });
  }
  return (S) => {
    const O = {
      [pn.focused]: !1,
      [pn.disabled]: !1,
      [pn.hidden]: !1,
      [pn.outside]: !1,
      [pn.today]: !1
    }, C = {};
    for (const T in x) {
      const k = x[T];
      O[T] = k.some((I) => I === S);
    }
    for (const T in $)
      C[T] = $[T].some((k) => k === S);
    return {
      ...O,
      // custom modifiers should override all the previous ones
      ...C
    };
  };
}
function e1e(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [i, a] = jv(n, o ? n : void 0), c = o ? n : i, { isSameDay: l } = t, u = (v) => (c == null ? void 0 : c.some((y) => l(y, v))) ?? !1, { min: d, max: f } = e;
  return {
    selected: c,
    select: (v, y, g) => {
      let b = [...c ?? []];
      if (u(v)) {
        if ((c == null ? void 0 : c.length) === d || r && (c == null ? void 0 : c.length) === 1)
          return;
        b = c == null ? void 0 : c.filter((x) => !l(x, v));
      } else
        (c == null ? void 0 : c.length) === f ? b = [v] : b = [...b, v];
      return o || a(b), o == null || o(b, v, y, g), b;
    },
    isSelected: u
  };
}
function t1e(e, t, n = 0, r = 0, o = !1, i = il) {
  const { from: a, to: c } = t || {}, { isSameDay: l, isAfter: u, isBefore: d } = i;
  let f;
  if (!a && !c)
    f = { from: e, to: n > 0 ? void 0 : e };
  else if (a && !c)
    l(a, e) ? o ? f = { from: a, to: void 0 } : f = void 0 : d(e, a) ? f = { from: e, to: a } : f = { from: a, to: e };
  else if (a && c)
    if (l(a, e) && l(c, e))
      o ? f = { from: a, to: c } : f = void 0;
    else if (l(a, e))
      f = { from: a, to: n > 0 ? void 0 : e };
    else if (l(c, e))
      f = { from: e, to: n > 0 ? void 0 : e };
    else if (d(e, a))
      f = { from: e, to: c };
    else if (u(e, a))
      f = { from: a, to: e };
    else if (u(e, c))
      f = { from: a, to: e };
    else
      throw new Error("Invalid range");
  if (f != null && f.from && (f != null && f.to)) {
    const h = i.differenceInCalendarDays(f.to, f.from);
    r > 0 && h > r ? f = { from: e, to: void 0 } : n > 1 && h < n && (f = { from: e, to: void 0 });
  }
  return f;
}
function n1e(e, t, n = il) {
  const r = Array.isArray(t) ? t : [t];
  let o = e.from;
  const i = n.differenceInCalendarDays(e.to, e.from), a = Math.min(i, 6);
  for (let c = 0; c <= a; c++) {
    if (r.includes(o.getDay()))
      return !0;
    o = n.addDays(o, 1);
  }
  return !1;
}
function lM(e, t, n = il) {
  return La(e, t.from, !1, n) || La(e, t.to, !1, n) || La(t, e.from, !1, n) || La(t, e.to, !1, n);
}
function r1e(e, t, n = il) {
  const r = Array.isArray(t) ? t : [t];
  if (r.filter((c) => typeof c != "function").some((c) => typeof c == "boolean" ? c : n.isDate(c) ? La(e, c, !1, n) : Az(c, n) ? c.some((l) => La(e, l, !1, n)) : EE(c) ? c.from && c.to ? lM(e, { from: c.from, to: c.to }, n) : !1 : Pz(c) ? n1e(e, c.dayOfWeek, n) : _z(c) ? n.isAfter(c.before, c.after) ? lM(e, {
    from: n.addDays(c.after, 1),
    to: n.addDays(c.before, -1)
  }, n) : ja(e.from, c, n) || ja(e.to, c, n) : kz(c) || Rz(c) ? ja(e.from, c, n) || ja(e.to, c, n) : !1))
    return !0;
  const a = r.filter((c) => typeof c == "function");
  if (a.length) {
    let c = e.from;
    const l = n.differenceInCalendarDays(e.to, e.from);
    for (let u = 0; u <= l; u++) {
      if (a.some((d) => d(c)))
        return !0;
      c = n.addDays(c, 1);
    }
  }
  return !1;
}
function o1e(e, t) {
  const { disabled: n, excludeDisabled: r, selected: o, required: i, onSelect: a } = e, [c, l] = jv(o, a ? o : void 0), u = a ? o : c;
  return {
    selected: u,
    select: (h, v, y) => {
      const { min: g, max: b } = e, x = h ? t1e(h, u, g, b, i, t) : void 0;
      return r && n && (x != null && x.from) && x.to && r1e({ from: x.from, to: x.to }, n, t) && (x.from = h, x.to = void 0), a || l(x), a == null || a(x, h, v, y), x;
    },
    isSelected: (h) => u && La(u, h, !1, t)
  };
}
function i1e(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [i, a] = jv(n, o ? n : void 0), c = o ? n : i, { isSameDay: l } = t;
  return {
    selected: c,
    select: (f, h, v) => {
      let y = f;
      return !r && c && c && l(f, c) && (y = void 0), o || a(y), o == null || o(y, f, h, v), y;
    },
    isSelected: (f) => c ? l(c, f) : !1
  };
}
function a1e(e, t) {
  const n = i1e(e, t), r = e1e(e, t), o = o1e(e, t);
  switch (e.mode) {
    case "single":
      return n;
    case "multiple":
      return r;
    case "range":
      return o;
    default:
      return;
  }
}
function p9e(e) {
  const { components: t, formatters: n, labels: r, dateLib: o, locale: i, classNames: a } = Nn(() => {
    const Be = { ...Zu, ...e.locale };
    return {
      dateLib: new Ja({
        locale: Be,
        weekStartsOn: e.broadcastCalendar ? 1 : e.weekStartsOn,
        firstWeekContainsDate: e.firstWeekContainsDate,
        useAdditionalWeekYearTokens: e.useAdditionalWeekYearTokens,
        useAdditionalDayOfYearTokens: e.useAdditionalDayOfYearTokens
      }, e.dateLib),
      components: cbe(e.components),
      formatters: bbe(e.formatters),
      labels: { ...jbe, ...e.labels },
      locale: Be,
      classNames: { ...ube(), ...e.classNames }
    };
  }, [
    e.classNames,
    e.components,
    e.dateLib,
    e.firstWeekContainsDate,
    e.formatters,
    e.labels,
    e.locale,
    e.useAdditionalDayOfYearTokens,
    e.useAdditionalWeekYearTokens,
    e.weekStartsOn,
    e.broadcastCalendar
  ]), { captionLayout: c, mode: l, onDayBlur: u, onDayClick: d, onDayFocus: f, onDayKeyDown: h, onDayMouseEnter: v, onDayMouseLeave: y, onNextClick: g, onPrevClick: b, showWeekNumber: x, styles: $ } = e, { formatCaption: S, formatDay: O, formatMonthDropdown: C, formatWeekNumber: T, formatWeekNumberHeader: k, formatWeekdayName: I, formatYearDropdown: P } = n, _ = Kbe(e, o), { days: A, months: D, navStart: M, navEnd: N, previousMonth: L, nextMonth: z, goToMonth: q } = _, W = Qbe(A, e, o), { isSelected: U, select: K, selected: Y } = a1e(e, o) ?? {}, { blur: X, focused: oe, isFocusTarget: re, moveFocus: Z, setFocused: ce } = Jbe(e, _, W, U ?? (() => !1), o), { labelDayButton: fe, labelGridcell: de, labelGrid: ne, labelMonthDropdown: le, labelNav: ve, labelWeekday: G, labelWeekNumber: Se, labelWeekNumberHeader: ue, labelYearDropdown: Q } = r, ie = Nn(() => Cbe(o, e.ISOWeek, e.timeZone), [o, e.ISOWeek, e.timeZone]), ee = l !== void 0 || d !== void 0, be = Rt(() => {
    L && (q(L), b == null || b(L));
  }, [L, q, b]), Ie = Rt(() => {
    z && (q(z), g == null || g(z));
  }, [q, z, g]), je = Rt((Be, Xe) => (Ze) => {
    Ze.preventDefault(), Ze.stopPropagation(), ce(Be), K == null || K(Be.date, Xe, Ze), d == null || d(Be.date, Xe, Ze);
  }, [K, d, ce]), V = Rt((Be, Xe) => (Ze) => {
    ce(Be), f == null || f(Be.date, Xe, Ze);
  }, [f, ce]), se = Rt((Be, Xe) => (Ze) => {
    X(), u == null || u(Be.date, Xe, Ze);
  }, [X, u]), we = Rt((Be, Xe) => (Ze) => {
    const Ne = {
      ArrowLeft: ["day", e.dir === "rtl" ? "after" : "before"],
      ArrowRight: ["day", e.dir === "rtl" ? "before" : "after"],
      ArrowDown: ["week", "after"],
      ArrowUp: ["week", "before"],
      PageUp: [Ze.shiftKey ? "year" : "month", "before"],
      PageDown: [Ze.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (Ne[Ze.key]) {
      Ze.preventDefault(), Ze.stopPropagation();
      const [$e, Ue] = Ne[Ze.key];
      Z($e, Ue);
    }
    h == null || h(Be.date, Xe, Ze);
  }, [Z, h, e.dir]), J = Rt((Be, Xe) => (Ze) => {
    v == null || v(Be.date, Xe, Ze);
  }, [v]), he = Rt((Be, Xe) => (Ze) => {
    y == null || y(Be.date, Xe, Ze);
  }, [y]), Te = Rt((Be) => (Xe) => {
    const Ze = Number(Xe.target.value), Ne = o.setMonth(o.startOfMonth(Be), Ze);
    q(Ne);
  }, [o, q]), xe = Rt((Be) => (Xe) => {
    const Ze = Number(Xe.target.value), Ne = o.setYear(o.startOfMonth(Be), Ze);
    q(Ne);
  }, [o, q]), { className: Ae, style: Ce } = Nn(() => ({
    className: [a[ft.Root], e.className].filter(Boolean).join(" "),
    style: { ...$ == null ? void 0 : $[ft.Root], ...e.style }
  }), [a, e.className, e.style, $]), Ye = lbe(e), He = {
    dayPickerProps: e,
    selected: Y,
    select: K,
    isSelected: U,
    months: D,
    nextMonth: z,
    previousMonth: L,
    goToMonth: q,
    getModifiers: W,
    components: t,
    classNames: a,
    styles: $,
    labels: r,
    formatters: n
  };
  return ye.createElement(
    wz.Provider,
    { value: He },
    ye.createElement(
      t.Root,
      { className: Ae, style: Ce, dir: e.dir, id: e.id, lang: e.lang, nonce: e.nonce, title: e.title, role: e.role, "aria-label": e["aria-label"], ...Ye },
      ye.createElement(
        t.Months,
        { className: a[ft.Months], style: $ == null ? void 0 : $[ft.Months] },
        !e.hideNavigation && ye.createElement(t.Nav, { className: a[ft.Nav], style: $ == null ? void 0 : $[ft.Nav], "aria-label": ve(), onPreviousClick: be, onNextClick: Ie, previousMonth: L, nextMonth: z }),
        D.map((Be, Xe) => {
          const Ze = xbe(Be.date, M, N, n, o), Ne = Tbe(M, N, n, o);
          return ye.createElement(
            t.Month,
            { className: a[ft.Month], style: $ == null ? void 0 : $[ft.Month], key: Xe, displayIndex: Xe, calendarMonth: Be },
            ye.createElement(t.MonthCaption, { className: a[ft.MonthCaption], style: $ == null ? void 0 : $[ft.MonthCaption], calendarMonth: Be, displayIndex: Xe }, c != null && c.startsWith("dropdown") ? ye.createElement(
              t.DropdownNav,
              { className: a[ft.Dropdowns], style: $ == null ? void 0 : $[ft.Dropdowns] },
              c === "dropdown" || c === "dropdown-months" ? ye.createElement(t.MonthsDropdown, { className: a[ft.MonthsDropdown], "aria-label": le(), classNames: a, components: t, disabled: !!e.disableNavigation, onChange: Te(Be.date), options: Ze, style: $ == null ? void 0 : $[ft.Dropdown], value: Be.date.getMonth() }) : ye.createElement("span", { role: "status", "aria-live": "polite" }, C(Be.date.getMonth(), i)),
              c === "dropdown" || c === "dropdown-years" ? ye.createElement(t.YearsDropdown, { className: a[ft.YearsDropdown], "aria-label": Q(o.options), classNames: a, components: t, disabled: !!e.disableNavigation, onChange: xe(Be.date), options: Ne, style: $ == null ? void 0 : $[ft.Dropdown], value: Be.date.getFullYear() }) : ye.createElement("span", { role: "status", "aria-live": "polite" }, P(Be.date.getFullYear()))
            ) : ye.createElement(t.CaptionLabel, { className: a[ft.CaptionLabel], role: "status", "aria-live": "polite" }, S(Be.date, o.options, o))),
            ye.createElement(
              t.MonthGrid,
              { role: "grid", "aria-multiselectable": l === "multiple" || l === "range", "aria-label": ne(Be.date, o.options, o) || void 0, className: a[ft.MonthGrid], style: $ == null ? void 0 : $[ft.MonthGrid] },
              !e.hideWeekdays && ye.createElement(
                t.Weekdays,
                { className: a[ft.Weekdays], style: $ == null ? void 0 : $[ft.Weekdays] },
                x && ye.createElement(t.WeekNumberHeader, { "aria-label": ue(o.options), className: a[ft.WeekNumberHeader], style: $ == null ? void 0 : $[ft.WeekNumberHeader], scope: "col" }, k()),
                ie.map(($e, Ue) => ye.createElement(t.Weekday, { "aria-label": G($e, o.options, o), className: a[ft.Weekday], key: Ue, style: $ == null ? void 0 : $[ft.Weekday], scope: "col" }, I($e, o.options, o)))
              ),
              ye.createElement(t.Weeks, { className: a[ft.Weeks], style: $ == null ? void 0 : $[ft.Weeks] }, Be.weeks.map(($e, Ue) => ye.createElement(
                t.Week,
                { className: a[ft.Week], key: $e.weekNumber, style: $ == null ? void 0 : $[ft.Week], week: $e },
                x && ye.createElement(t.WeekNumber, { week: $e, style: $ == null ? void 0 : $[ft.WeekNumber], "aria-label": Se($e.weekNumber, {
                  locale: i
                }), className: a[ft.WeekNumber], scope: "row", role: "rowheader" }, T($e.weekNumber)),
                $e.days.map((Ke) => {
                  const { date: Me } = Ke, We = W(Ke);
                  if (We[pn.focused] = !We.hidden && !!(oe != null && oe.isEqualTo(Ke)), We[mi.selected] = !We.disabled && ((U == null ? void 0 : U(Me)) || We.selected), EE(Y)) {
                    const { from: Qe, to: ot } = Y;
                    We[mi.range_start] = !!(Qe && ot && o.isSameDay(Me, Qe)), We[mi.range_end] = !!(Qe && ot && o.isSameDay(Me, ot)), We[mi.range_middle] = La(Y, Me, !0, o);
                  }
                  const at = wbe(We, $, e.modifiersStyles), Je = Mye(We, a, e.modifiersClassNames), ke = !ee && !We.hidden ? de(Me, We, o.options, o) : void 0;
                  return ye.createElement(t.Day, { key: `${o.format(Me, "yyyy-MM-dd")}_${o.format(Ke.displayMonth, "yyyy-MM")}`, day: Ke, modifiers: We, className: Je.join(" "), style: at, role: "gridcell", "aria-selected": We.selected || void 0, "aria-label": ke, "data-day": o.format(Me, "yyyy-MM-dd"), "data-month": Ke.outside ? o.format(Me, "yyyy-MM") : void 0, "data-selected": We.selected || void 0, "data-disabled": We.disabled || void 0, "data-hidden": We.hidden || void 0, "data-outside": Ke.outside || void 0, "data-focused": We.focused || void 0, "data-today": We.today || void 0 }, !We.hidden && ee ? ye.createElement(t.DayButton, { className: a[ft.DayButton], style: $ == null ? void 0 : $[ft.DayButton], type: "button", day: Ke, modifiers: We, disabled: We.disabled || void 0, tabIndex: re(Ke) ? 0 : -1, "aria-label": fe(Me, We, o.options, o), onClick: je(Ke, We), onBlur: se(Ke, We), onFocus: V(Ke, We), onKeyDown: we(Ke, We), onMouseEnter: J(Ke, We), onMouseLeave: he(Ke, We) }, O(Me, o.options, o)) : !We.hidden && O(Ke.date, o.options, o));
                })
              )))
            )
          );
        })
      ),
      e.footer && ye.createElement(t.Footer, { className: a[ft.Footer], style: $ == null ? void 0 : $[ft.Footer], role: "status", "aria-live": "polite" }, e.footer)
    )
  );
}
const s1e = "_root_1p9on_3", c1e = "_day_1p9on_73", l1e = "_day_button_1p9on_79", u1e = "_caption_label_1p9on_100", d1e = "_dropdown_1p9on_111", f1e = "_button_next_1p9on_116", p1e = "_button_previous_1p9on_117", h1e = "_chevron_1p9on_144", m1e = "_nav_1p9on_149", g1e = "_dropdowns_1p9on_158", v1e = "_dropdown_root_1p9on_182", y1e = "_month_caption_1p9on_192", b1e = "_months_1p9on_200", x1e = "_month_grid_1p9on_208", w1e = "_weekday_1p9on_223", $1e = "_week_number_1p9on_232", O1e = "_today_1p9on_244", S1e = "_outside_1p9on_244", C1e = "_selected_1p9on_248", T1e = "_disabled_1p9on_261", E1e = "_hidden_1p9on_265", _1e = "_range_start_1p9on_270", k1e = "_range_middle_1p9on_279", R1e = "_range_end_1p9on_290", P1e = "_focusable_1p9on_304", h9e = {
  root: s1e,
  day: c1e,
  day_button: l1e,
  caption_label: u1e,
  dropdown: d1e,
  button_next: f1e,
  button_previous: p1e,
  chevron: h1e,
  nav: m1e,
  dropdowns: g1e,
  dropdown_root: v1e,
  month_caption: y1e,
  months: b1e,
  month_grid: x1e,
  weekday: w1e,
  week_number: $1e,
  today: O1e,
  outside: S1e,
  selected: C1e,
  disabled: T1e,
  hidden: E1e,
  range_start: _1e,
  range_middle: k1e,
  range_end: R1e,
  focusable: P1e
};
function al(e, t, n, r) {
  function o(i) {
    return i instanceof n ? i : new n(function(a) {
      a(i);
    });
  }
  return new (n || (n = Promise))(function(i, a) {
    function c(d) {
      try {
        u(r.next(d));
      } catch (f) {
        a(f);
      }
    }
    function l(d) {
      try {
        u(r.throw(d));
      } catch (f) {
        a(f);
      }
    }
    function u(d) {
      d.done ? i(d.value) : o(d.value).then(c, l);
    }
    u((r = r.apply(e, t || [])).next());
  });
}
const A1e = /* @__PURE__ */ new Map([
  // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
  ["1km", "application/vnd.1000minds.decision-model+xml"],
  ["3dml", "text/vnd.in3d.3dml"],
  ["3ds", "image/x-3ds"],
  ["3g2", "video/3gpp2"],
  ["3gp", "video/3gp"],
  ["3gpp", "video/3gpp"],
  ["3mf", "model/3mf"],
  ["7z", "application/x-7z-compressed"],
  ["7zip", "application/x-7z-compressed"],
  ["123", "application/vnd.lotus-1-2-3"],
  ["aab", "application/x-authorware-bin"],
  ["aac", "audio/x-acc"],
  ["aam", "application/x-authorware-map"],
  ["aas", "application/x-authorware-seg"],
  ["abw", "application/x-abiword"],
  ["ac", "application/vnd.nokia.n-gage.ac+xml"],
  ["ac3", "audio/ac3"],
  ["acc", "application/vnd.americandynamics.acc"],
  ["ace", "application/x-ace-compressed"],
  ["acu", "application/vnd.acucobol"],
  ["acutc", "application/vnd.acucorp"],
  ["adp", "audio/adpcm"],
  ["aep", "application/vnd.audiograph"],
  ["afm", "application/x-font-type1"],
  ["afp", "application/vnd.ibm.modcap"],
  ["ahead", "application/vnd.ahead.space"],
  ["ai", "application/pdf"],
  ["aif", "audio/x-aiff"],
  ["aifc", "audio/x-aiff"],
  ["aiff", "audio/x-aiff"],
  ["air", "application/vnd.adobe.air-application-installer-package+zip"],
  ["ait", "application/vnd.dvb.ait"],
  ["ami", "application/vnd.amiga.ami"],
  ["amr", "audio/amr"],
  ["apk", "application/vnd.android.package-archive"],
  ["apng", "image/apng"],
  ["appcache", "text/cache-manifest"],
  ["application", "application/x-ms-application"],
  ["apr", "application/vnd.lotus-approach"],
  ["arc", "application/x-freearc"],
  ["arj", "application/x-arj"],
  ["asc", "application/pgp-signature"],
  ["asf", "video/x-ms-asf"],
  ["asm", "text/x-asm"],
  ["aso", "application/vnd.accpac.simply.aso"],
  ["asx", "video/x-ms-asf"],
  ["atc", "application/vnd.acucorp"],
  ["atom", "application/atom+xml"],
  ["atomcat", "application/atomcat+xml"],
  ["atomdeleted", "application/atomdeleted+xml"],
  ["atomsvc", "application/atomsvc+xml"],
  ["atx", "application/vnd.antix.game-component"],
  ["au", "audio/x-au"],
  ["avi", "video/x-msvideo"],
  ["avif", "image/avif"],
  ["aw", "application/applixware"],
  ["azf", "application/vnd.airzip.filesecure.azf"],
  ["azs", "application/vnd.airzip.filesecure.azs"],
  ["azv", "image/vnd.airzip.accelerator.azv"],
  ["azw", "application/vnd.amazon.ebook"],
  ["b16", "image/vnd.pco.b16"],
  ["bat", "application/x-msdownload"],
  ["bcpio", "application/x-bcpio"],
  ["bdf", "application/x-font-bdf"],
  ["bdm", "application/vnd.syncml.dm+wbxml"],
  ["bdoc", "application/x-bdoc"],
  ["bed", "application/vnd.realvnc.bed"],
  ["bh2", "application/vnd.fujitsu.oasysprs"],
  ["bin", "application/octet-stream"],
  ["blb", "application/x-blorb"],
  ["blorb", "application/x-blorb"],
  ["bmi", "application/vnd.bmi"],
  ["bmml", "application/vnd.balsamiq.bmml+xml"],
  ["bmp", "image/bmp"],
  ["book", "application/vnd.framemaker"],
  ["box", "application/vnd.previewsystems.box"],
  ["boz", "application/x-bzip2"],
  ["bpk", "application/octet-stream"],
  ["bpmn", "application/octet-stream"],
  ["bsp", "model/vnd.valve.source.compiled-map"],
  ["btif", "image/prs.btif"],
  ["buffer", "application/octet-stream"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["c", "text/x-c"],
  ["c4d", "application/vnd.clonk.c4group"],
  ["c4f", "application/vnd.clonk.c4group"],
  ["c4g", "application/vnd.clonk.c4group"],
  ["c4p", "application/vnd.clonk.c4group"],
  ["c4u", "application/vnd.clonk.c4group"],
  ["c11amc", "application/vnd.cluetrust.cartomobile-config"],
  ["c11amz", "application/vnd.cluetrust.cartomobile-config-pkg"],
  ["cab", "application/vnd.ms-cab-compressed"],
  ["caf", "audio/x-caf"],
  ["cap", "application/vnd.tcpdump.pcap"],
  ["car", "application/vnd.curl.car"],
  ["cat", "application/vnd.ms-pki.seccat"],
  ["cb7", "application/x-cbr"],
  ["cba", "application/x-cbr"],
  ["cbr", "application/x-cbr"],
  ["cbt", "application/x-cbr"],
  ["cbz", "application/x-cbr"],
  ["cc", "text/x-c"],
  ["cco", "application/x-cocoa"],
  ["cct", "application/x-director"],
  ["ccxml", "application/ccxml+xml"],
  ["cdbcmsg", "application/vnd.contact.cmsg"],
  ["cda", "application/x-cdf"],
  ["cdf", "application/x-netcdf"],
  ["cdfx", "application/cdfx+xml"],
  ["cdkey", "application/vnd.mediastation.cdkey"],
  ["cdmia", "application/cdmi-capability"],
  ["cdmic", "application/cdmi-container"],
  ["cdmid", "application/cdmi-domain"],
  ["cdmio", "application/cdmi-object"],
  ["cdmiq", "application/cdmi-queue"],
  ["cdr", "application/cdr"],
  ["cdx", "chemical/x-cdx"],
  ["cdxml", "application/vnd.chemdraw+xml"],
  ["cdy", "application/vnd.cinderella"],
  ["cer", "application/pkix-cert"],
  ["cfs", "application/x-cfs-compressed"],
  ["cgm", "image/cgm"],
  ["chat", "application/x-chat"],
  ["chm", "application/vnd.ms-htmlhelp"],
  ["chrt", "application/vnd.kde.kchart"],
  ["cif", "chemical/x-cif"],
  ["cii", "application/vnd.anser-web-certificate-issue-initiation"],
  ["cil", "application/vnd.ms-artgalry"],
  ["cjs", "application/node"],
  ["cla", "application/vnd.claymore"],
  ["class", "application/octet-stream"],
  ["clkk", "application/vnd.crick.clicker.keyboard"],
  ["clkp", "application/vnd.crick.clicker.palette"],
  ["clkt", "application/vnd.crick.clicker.template"],
  ["clkw", "application/vnd.crick.clicker.wordbank"],
  ["clkx", "application/vnd.crick.clicker"],
  ["clp", "application/x-msclip"],
  ["cmc", "application/vnd.cosmocaller"],
  ["cmdf", "chemical/x-cmdf"],
  ["cml", "chemical/x-cml"],
  ["cmp", "application/vnd.yellowriver-custom-menu"],
  ["cmx", "image/x-cmx"],
  ["cod", "application/vnd.rim.cod"],
  ["coffee", "text/coffeescript"],
  ["com", "application/x-msdownload"],
  ["conf", "text/plain"],
  ["cpio", "application/x-cpio"],
  ["cpp", "text/x-c"],
  ["cpt", "application/mac-compactpro"],
  ["crd", "application/x-mscardfile"],
  ["crl", "application/pkix-crl"],
  ["crt", "application/x-x509-ca-cert"],
  ["crx", "application/x-chrome-extension"],
  ["cryptonote", "application/vnd.rig.cryptonote"],
  ["csh", "application/x-csh"],
  ["csl", "application/vnd.citationstyles.style+xml"],
  ["csml", "chemical/x-csml"],
  ["csp", "application/vnd.commonspace"],
  ["csr", "application/octet-stream"],
  ["css", "text/css"],
  ["cst", "application/x-director"],
  ["csv", "text/csv"],
  ["cu", "application/cu-seeme"],
  ["curl", "text/vnd.curl"],
  ["cww", "application/prs.cww"],
  ["cxt", "application/x-director"],
  ["cxx", "text/x-c"],
  ["dae", "model/vnd.collada+xml"],
  ["daf", "application/vnd.mobius.daf"],
  ["dart", "application/vnd.dart"],
  ["dataless", "application/vnd.fdsn.seed"],
  ["davmount", "application/davmount+xml"],
  ["dbf", "application/vnd.dbf"],
  ["dbk", "application/docbook+xml"],
  ["dcr", "application/x-director"],
  ["dcurl", "text/vnd.curl.dcurl"],
  ["dd2", "application/vnd.oma.dd2+xml"],
  ["ddd", "application/vnd.fujixerox.ddd"],
  ["ddf", "application/vnd.syncml.dmddf+xml"],
  ["dds", "image/vnd.ms-dds"],
  ["deb", "application/x-debian-package"],
  ["def", "text/plain"],
  ["deploy", "application/octet-stream"],
  ["der", "application/x-x509-ca-cert"],
  ["dfac", "application/vnd.dreamfactory"],
  ["dgc", "application/x-dgc-compressed"],
  ["dic", "text/x-c"],
  ["dir", "application/x-director"],
  ["dis", "application/vnd.mobius.dis"],
  ["disposition-notification", "message/disposition-notification"],
  ["dist", "application/octet-stream"],
  ["distz", "application/octet-stream"],
  ["djv", "image/vnd.djvu"],
  ["djvu", "image/vnd.djvu"],
  ["dll", "application/octet-stream"],
  ["dmg", "application/x-apple-diskimage"],
  ["dmn", "application/octet-stream"],
  ["dmp", "application/vnd.tcpdump.pcap"],
  ["dms", "application/octet-stream"],
  ["dna", "application/vnd.dna"],
  ["doc", "application/msword"],
  ["docm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["dot", "application/msword"],
  ["dotm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["dotx", "application/vnd.openxmlformats-officedocument.wordprocessingml.template"],
  ["dp", "application/vnd.osgi.dp"],
  ["dpg", "application/vnd.dpgraph"],
  ["dra", "audio/vnd.dra"],
  ["drle", "image/dicom-rle"],
  ["dsc", "text/prs.lines.tag"],
  ["dssc", "application/dssc+der"],
  ["dtb", "application/x-dtbook+xml"],
  ["dtd", "application/xml-dtd"],
  ["dts", "audio/vnd.dts"],
  ["dtshd", "audio/vnd.dts.hd"],
  ["dump", "application/octet-stream"],
  ["dvb", "video/vnd.dvb.file"],
  ["dvi", "application/x-dvi"],
  ["dwd", "application/atsc-dwd+xml"],
  ["dwf", "model/vnd.dwf"],
  ["dwg", "image/vnd.dwg"],
  ["dxf", "image/vnd.dxf"],
  ["dxp", "application/vnd.spotfire.dxp"],
  ["dxr", "application/x-director"],
  ["ear", "application/java-archive"],
  ["ecelp4800", "audio/vnd.nuera.ecelp4800"],
  ["ecelp7470", "audio/vnd.nuera.ecelp7470"],
  ["ecelp9600", "audio/vnd.nuera.ecelp9600"],
  ["ecma", "application/ecmascript"],
  ["edm", "application/vnd.novadigm.edm"],
  ["edx", "application/vnd.novadigm.edx"],
  ["efif", "application/vnd.picsel"],
  ["ei6", "application/vnd.pg.osasli"],
  ["elc", "application/octet-stream"],
  ["emf", "image/emf"],
  ["eml", "message/rfc822"],
  ["emma", "application/emma+xml"],
  ["emotionml", "application/emotionml+xml"],
  ["emz", "application/x-msmetafile"],
  ["eol", "audio/vnd.digital-winds"],
  ["eot", "application/vnd.ms-fontobject"],
  ["eps", "application/postscript"],
  ["epub", "application/epub+zip"],
  ["es", "application/ecmascript"],
  ["es3", "application/vnd.eszigno3+xml"],
  ["esa", "application/vnd.osgi.subsystem"],
  ["esf", "application/vnd.epson.esf"],
  ["et3", "application/vnd.eszigno3+xml"],
  ["etx", "text/x-setext"],
  ["eva", "application/x-eva"],
  ["evy", "application/x-envoy"],
  ["exe", "application/octet-stream"],
  ["exi", "application/exi"],
  ["exp", "application/express"],
  ["exr", "image/aces"],
  ["ext", "application/vnd.novadigm.ext"],
  ["ez", "application/andrew-inset"],
  ["ez2", "application/vnd.ezpix-album"],
  ["ez3", "application/vnd.ezpix-package"],
  ["f", "text/x-fortran"],
  ["f4v", "video/mp4"],
  ["f77", "text/x-fortran"],
  ["f90", "text/x-fortran"],
  ["fbs", "image/vnd.fastbidsheet"],
  ["fcdt", "application/vnd.adobe.formscentral.fcdt"],
  ["fcs", "application/vnd.isac.fcs"],
  ["fdf", "application/vnd.fdf"],
  ["fdt", "application/fdt+xml"],
  ["fe_launch", "application/vnd.denovo.fcselayout-link"],
  ["fg5", "application/vnd.fujitsu.oasysgp"],
  ["fgd", "application/x-director"],
  ["fh", "image/x-freehand"],
  ["fh4", "image/x-freehand"],
  ["fh5", "image/x-freehand"],
  ["fh7", "image/x-freehand"],
  ["fhc", "image/x-freehand"],
  ["fig", "application/x-xfig"],
  ["fits", "image/fits"],
  ["flac", "audio/x-flac"],
  ["fli", "video/x-fli"],
  ["flo", "application/vnd.micrografx.flo"],
  ["flv", "video/x-flv"],
  ["flw", "application/vnd.kde.kivio"],
  ["flx", "text/vnd.fmi.flexstor"],
  ["fly", "text/vnd.fly"],
  ["fm", "application/vnd.framemaker"],
  ["fnc", "application/vnd.frogans.fnc"],
  ["fo", "application/vnd.software602.filler.form+xml"],
  ["for", "text/x-fortran"],
  ["fpx", "image/vnd.fpx"],
  ["frame", "application/vnd.framemaker"],
  ["fsc", "application/vnd.fsc.weblaunch"],
  ["fst", "image/vnd.fst"],
  ["ftc", "application/vnd.fluxtime.clip"],
  ["fti", "application/vnd.anser-web-funds-transfer-initiation"],
  ["fvt", "video/vnd.fvt"],
  ["fxp", "application/vnd.adobe.fxp"],
  ["fxpl", "application/vnd.adobe.fxp"],
  ["fzs", "application/vnd.fuzzysheet"],
  ["g2w", "application/vnd.geoplan"],
  ["g3", "image/g3fax"],
  ["g3w", "application/vnd.geospace"],
  ["gac", "application/vnd.groove-account"],
  ["gam", "application/x-tads"],
  ["gbr", "application/rpki-ghostbusters"],
  ["gca", "application/x-gca-compressed"],
  ["gdl", "model/vnd.gdl"],
  ["gdoc", "application/vnd.google-apps.document"],
  ["geo", "application/vnd.dynageo"],
  ["geojson", "application/geo+json"],
  ["gex", "application/vnd.geometry-explorer"],
  ["ggb", "application/vnd.geogebra.file"],
  ["ggt", "application/vnd.geogebra.tool"],
  ["ghf", "application/vnd.groove-help"],
  ["gif", "image/gif"],
  ["gim", "application/vnd.groove-identity-message"],
  ["glb", "model/gltf-binary"],
  ["gltf", "model/gltf+json"],
  ["gml", "application/gml+xml"],
  ["gmx", "application/vnd.gmx"],
  ["gnumeric", "application/x-gnumeric"],
  ["gpg", "application/gpg-keys"],
  ["gph", "application/vnd.flographit"],
  ["gpx", "application/gpx+xml"],
  ["gqf", "application/vnd.grafeq"],
  ["gqs", "application/vnd.grafeq"],
  ["gram", "application/srgs"],
  ["gramps", "application/x-gramps-xml"],
  ["gre", "application/vnd.geometry-explorer"],
  ["grv", "application/vnd.groove-injector"],
  ["grxml", "application/srgs+xml"],
  ["gsf", "application/x-font-ghostscript"],
  ["gsheet", "application/vnd.google-apps.spreadsheet"],
  ["gslides", "application/vnd.google-apps.presentation"],
  ["gtar", "application/x-gtar"],
  ["gtm", "application/vnd.groove-tool-message"],
  ["gtw", "model/vnd.gtw"],
  ["gv", "text/vnd.graphviz"],
  ["gxf", "application/gxf"],
  ["gxt", "application/vnd.geonext"],
  ["gz", "application/gzip"],
  ["gzip", "application/gzip"],
  ["h", "text/x-c"],
  ["h261", "video/h261"],
  ["h263", "video/h263"],
  ["h264", "video/h264"],
  ["hal", "application/vnd.hal+xml"],
  ["hbci", "application/vnd.hbci"],
  ["hbs", "text/x-handlebars-template"],
  ["hdd", "application/x-virtualbox-hdd"],
  ["hdf", "application/x-hdf"],
  ["heic", "image/heic"],
  ["heics", "image/heic-sequence"],
  ["heif", "image/heif"],
  ["heifs", "image/heif-sequence"],
  ["hej2", "image/hej2k"],
  ["held", "application/atsc-held+xml"],
  ["hh", "text/x-c"],
  ["hjson", "application/hjson"],
  ["hlp", "application/winhlp"],
  ["hpgl", "application/vnd.hp-hpgl"],
  ["hpid", "application/vnd.hp-hpid"],
  ["hps", "application/vnd.hp-hps"],
  ["hqx", "application/mac-binhex40"],
  ["hsj2", "image/hsj2"],
  ["htc", "text/x-component"],
  ["htke", "application/vnd.kenameaapp"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["hvd", "application/vnd.yamaha.hv-dic"],
  ["hvp", "application/vnd.yamaha.hv-voice"],
  ["hvs", "application/vnd.yamaha.hv-script"],
  ["i2g", "application/vnd.intergeo"],
  ["icc", "application/vnd.iccprofile"],
  ["ice", "x-conference/x-cooltalk"],
  ["icm", "application/vnd.iccprofile"],
  ["ico", "image/x-icon"],
  ["ics", "text/calendar"],
  ["ief", "image/ief"],
  ["ifb", "text/calendar"],
  ["ifm", "application/vnd.shana.informed.formdata"],
  ["iges", "model/iges"],
  ["igl", "application/vnd.igloader"],
  ["igm", "application/vnd.insors.igm"],
  ["igs", "model/iges"],
  ["igx", "application/vnd.micrografx.igx"],
  ["iif", "application/vnd.shana.informed.interchange"],
  ["img", "application/octet-stream"],
  ["imp", "application/vnd.accpac.simply.imp"],
  ["ims", "application/vnd.ms-ims"],
  ["in", "text/plain"],
  ["ini", "text/plain"],
  ["ink", "application/inkml+xml"],
  ["inkml", "application/inkml+xml"],
  ["install", "application/x-install-instructions"],
  ["iota", "application/vnd.astraea-software.iota"],
  ["ipfix", "application/ipfix"],
  ["ipk", "application/vnd.shana.informed.package"],
  ["irm", "application/vnd.ibm.rights-management"],
  ["irp", "application/vnd.irepository.package+xml"],
  ["iso", "application/x-iso9660-image"],
  ["itp", "application/vnd.shana.informed.formtemplate"],
  ["its", "application/its+xml"],
  ["ivp", "application/vnd.immervision-ivp"],
  ["ivu", "application/vnd.immervision-ivu"],
  ["jad", "text/vnd.sun.j2me.app-descriptor"],
  ["jade", "text/jade"],
  ["jam", "application/vnd.jam"],
  ["jar", "application/java-archive"],
  ["jardiff", "application/x-java-archive-diff"],
  ["java", "text/x-java-source"],
  ["jhc", "image/jphc"],
  ["jisp", "application/vnd.jisp"],
  ["jls", "image/jls"],
  ["jlt", "application/vnd.hp-jlyt"],
  ["jng", "image/x-jng"],
  ["jnlp", "application/x-java-jnlp-file"],
  ["joda", "application/vnd.joost.joda-archive"],
  ["jp2", "image/jp2"],
  ["jpe", "image/jpeg"],
  ["jpeg", "image/jpeg"],
  ["jpf", "image/jpx"],
  ["jpg", "image/jpeg"],
  ["jpg2", "image/jp2"],
  ["jpgm", "video/jpm"],
  ["jpgv", "video/jpeg"],
  ["jph", "image/jph"],
  ["jpm", "video/jpm"],
  ["jpx", "image/jpx"],
  ["js", "application/javascript"],
  ["json", "application/json"],
  ["json5", "application/json5"],
  ["jsonld", "application/ld+json"],
  // https://jsonlines.org/
  ["jsonl", "application/jsonl"],
  ["jsonml", "application/jsonml+json"],
  ["jsx", "text/jsx"],
  ["jxr", "image/jxr"],
  ["jxra", "image/jxra"],
  ["jxrs", "image/jxrs"],
  ["jxs", "image/jxs"],
  ["jxsc", "image/jxsc"],
  ["jxsi", "image/jxsi"],
  ["jxss", "image/jxss"],
  ["kar", "audio/midi"],
  ["karbon", "application/vnd.kde.karbon"],
  ["kdb", "application/octet-stream"],
  ["kdbx", "application/x-keepass2"],
  ["key", "application/x-iwork-keynote-sffkey"],
  ["kfo", "application/vnd.kde.kformula"],
  ["kia", "application/vnd.kidspiration"],
  ["kml", "application/vnd.google-earth.kml+xml"],
  ["kmz", "application/vnd.google-earth.kmz"],
  ["kne", "application/vnd.kinar"],
  ["knp", "application/vnd.kinar"],
  ["kon", "application/vnd.kde.kontour"],
  ["kpr", "application/vnd.kde.kpresenter"],
  ["kpt", "application/vnd.kde.kpresenter"],
  ["kpxx", "application/vnd.ds-keypoint"],
  ["ksp", "application/vnd.kde.kspread"],
  ["ktr", "application/vnd.kahootz"],
  ["ktx", "image/ktx"],
  ["ktx2", "image/ktx2"],
  ["ktz", "application/vnd.kahootz"],
  ["kwd", "application/vnd.kde.kword"],
  ["kwt", "application/vnd.kde.kword"],
  ["lasxml", "application/vnd.las.las+xml"],
  ["latex", "application/x-latex"],
  ["lbd", "application/vnd.llamagraphics.life-balance.desktop"],
  ["lbe", "application/vnd.llamagraphics.life-balance.exchange+xml"],
  ["les", "application/vnd.hhe.lesson-player"],
  ["less", "text/less"],
  ["lgr", "application/lgr+xml"],
  ["lha", "application/octet-stream"],
  ["link66", "application/vnd.route66.link66+xml"],
  ["list", "text/plain"],
  ["list3820", "application/vnd.ibm.modcap"],
  ["listafp", "application/vnd.ibm.modcap"],
  ["litcoffee", "text/coffeescript"],
  ["lnk", "application/x-ms-shortcut"],
  ["log", "text/plain"],
  ["lostxml", "application/lost+xml"],
  ["lrf", "application/octet-stream"],
  ["lrm", "application/vnd.ms-lrm"],
  ["ltf", "application/vnd.frogans.ltf"],
  ["lua", "text/x-lua"],
  ["luac", "application/x-lua-bytecode"],
  ["lvp", "audio/vnd.lucent.voice"],
  ["lwp", "application/vnd.lotus-wordpro"],
  ["lzh", "application/octet-stream"],
  ["m1v", "video/mpeg"],
  ["m2a", "audio/mpeg"],
  ["m2v", "video/mpeg"],
  ["m3a", "audio/mpeg"],
  ["m3u", "text/plain"],
  ["m3u8", "application/vnd.apple.mpegurl"],
  ["m4a", "audio/x-m4a"],
  ["m4p", "application/mp4"],
  ["m4s", "video/iso.segment"],
  ["m4u", "application/vnd.mpegurl"],
  ["m4v", "video/x-m4v"],
  ["m13", "application/x-msmediaview"],
  ["m14", "application/x-msmediaview"],
  ["m21", "application/mp21"],
  ["ma", "application/mathematica"],
  ["mads", "application/mads+xml"],
  ["maei", "application/mmt-aei+xml"],
  ["mag", "application/vnd.ecowin.chart"],
  ["maker", "application/vnd.framemaker"],
  ["man", "text/troff"],
  ["manifest", "text/cache-manifest"],
  ["map", "application/json"],
  ["mar", "application/octet-stream"],
  ["markdown", "text/markdown"],
  ["mathml", "application/mathml+xml"],
  ["mb", "application/mathematica"],
  ["mbk", "application/vnd.mobius.mbk"],
  ["mbox", "application/mbox"],
  ["mc1", "application/vnd.medcalcdata"],
  ["mcd", "application/vnd.mcd"],
  ["mcurl", "text/vnd.curl.mcurl"],
  ["md", "text/markdown"],
  ["mdb", "application/x-msaccess"],
  ["mdi", "image/vnd.ms-modi"],
  ["mdx", "text/mdx"],
  ["me", "text/troff"],
  ["mesh", "model/mesh"],
  ["meta4", "application/metalink4+xml"],
  ["metalink", "application/metalink+xml"],
  ["mets", "application/mets+xml"],
  ["mfm", "application/vnd.mfmp"],
  ["mft", "application/rpki-manifest"],
  ["mgp", "application/vnd.osgeo.mapguide.package"],
  ["mgz", "application/vnd.proteus.magazine"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mie", "application/x-mie"],
  ["mif", "application/vnd.mif"],
  ["mime", "message/rfc822"],
  ["mj2", "video/mj2"],
  ["mjp2", "video/mj2"],
  ["mjs", "application/javascript"],
  ["mk3d", "video/x-matroska"],
  ["mka", "audio/x-matroska"],
  ["mkd", "text/x-markdown"],
  ["mks", "video/x-matroska"],
  ["mkv", "video/x-matroska"],
  ["mlp", "application/vnd.dolby.mlp"],
  ["mmd", "application/vnd.chipnuts.karaoke-mmd"],
  ["mmf", "application/vnd.smaf"],
  ["mml", "text/mathml"],
  ["mmr", "image/vnd.fujixerox.edmics-mmr"],
  ["mng", "video/x-mng"],
  ["mny", "application/x-msmoney"],
  ["mobi", "application/x-mobipocket-ebook"],
  ["mods", "application/mods+xml"],
  ["mov", "video/quicktime"],
  ["movie", "video/x-sgi-movie"],
  ["mp2", "audio/mpeg"],
  ["mp2a", "audio/mpeg"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mp4a", "audio/mp4"],
  ["mp4s", "application/mp4"],
  ["mp4v", "video/mp4"],
  ["mp21", "application/mp21"],
  ["mpc", "application/vnd.mophun.certificate"],
  ["mpd", "application/dash+xml"],
  ["mpe", "video/mpeg"],
  ["mpeg", "video/mpeg"],
  ["mpg", "video/mpeg"],
  ["mpg4", "video/mp4"],
  ["mpga", "audio/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["mpm", "application/vnd.blueice.multipass"],
  ["mpn", "application/vnd.mophun.application"],
  ["mpp", "application/vnd.ms-project"],
  ["mpt", "application/vnd.ms-project"],
  ["mpy", "application/vnd.ibm.minipay"],
  ["mqy", "application/vnd.mobius.mqy"],
  ["mrc", "application/marc"],
  ["mrcx", "application/marcxml+xml"],
  ["ms", "text/troff"],
  ["mscml", "application/mediaservercontrol+xml"],
  ["mseed", "application/vnd.fdsn.mseed"],
  ["mseq", "application/vnd.mseq"],
  ["msf", "application/vnd.epson.msf"],
  ["msg", "application/vnd.ms-outlook"],
  ["msh", "model/mesh"],
  ["msi", "application/x-msdownload"],
  ["msl", "application/vnd.mobius.msl"],
  ["msm", "application/octet-stream"],
  ["msp", "application/octet-stream"],
  ["msty", "application/vnd.muvee.style"],
  ["mtl", "model/mtl"],
  ["mts", "model/vnd.mts"],
  ["mus", "application/vnd.musician"],
  ["musd", "application/mmt-usd+xml"],
  ["musicxml", "application/vnd.recordare.musicxml+xml"],
  ["mvb", "application/x-msmediaview"],
  ["mvt", "application/vnd.mapbox-vector-tile"],
  ["mwf", "application/vnd.mfer"],
  ["mxf", "application/mxf"],
  ["mxl", "application/vnd.recordare.musicxml"],
  ["mxmf", "audio/mobile-xmf"],
  ["mxml", "application/xv+xml"],
  ["mxs", "application/vnd.triscape.mxs"],
  ["mxu", "video/vnd.mpegurl"],
  ["n-gage", "application/vnd.nokia.n-gage.symbian.install"],
  ["n3", "text/n3"],
  ["nb", "application/mathematica"],
  ["nbp", "application/vnd.wolfram.player"],
  ["nc", "application/x-netcdf"],
  ["ncx", "application/x-dtbncx+xml"],
  ["nfo", "text/x-nfo"],
  ["ngdat", "application/vnd.nokia.n-gage.data"],
  ["nitf", "application/vnd.nitf"],
  ["nlu", "application/vnd.neurolanguage.nlu"],
  ["nml", "application/vnd.enliven"],
  ["nnd", "application/vnd.noblenet-directory"],
  ["nns", "application/vnd.noblenet-sealer"],
  ["nnw", "application/vnd.noblenet-web"],
  ["npx", "image/vnd.net-fpx"],
  ["nq", "application/n-quads"],
  ["nsc", "application/x-conference"],
  ["nsf", "application/vnd.lotus-notes"],
  ["nt", "application/n-triples"],
  ["ntf", "application/vnd.nitf"],
  ["numbers", "application/x-iwork-numbers-sffnumbers"],
  ["nzb", "application/x-nzb"],
  ["oa2", "application/vnd.fujitsu.oasys2"],
  ["oa3", "application/vnd.fujitsu.oasys3"],
  ["oas", "application/vnd.fujitsu.oasys"],
  ["obd", "application/x-msbinder"],
  ["obgx", "application/vnd.openblox.game+xml"],
  ["obj", "model/obj"],
  ["oda", "application/oda"],
  ["odb", "application/vnd.oasis.opendocument.database"],
  ["odc", "application/vnd.oasis.opendocument.chart"],
  ["odf", "application/vnd.oasis.opendocument.formula"],
  ["odft", "application/vnd.oasis.opendocument.formula-template"],
  ["odg", "application/vnd.oasis.opendocument.graphics"],
  ["odi", "application/vnd.oasis.opendocument.image"],
  ["odm", "application/vnd.oasis.opendocument.text-master"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogex", "model/vnd.opengex"],
  ["ogg", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["omdoc", "application/omdoc+xml"],
  ["onepkg", "application/onenote"],
  ["onetmp", "application/onenote"],
  ["onetoc", "application/onenote"],
  ["onetoc2", "application/onenote"],
  ["opf", "application/oebps-package+xml"],
  ["opml", "text/x-opml"],
  ["oprc", "application/vnd.palm"],
  ["opus", "audio/ogg"],
  ["org", "text/x-org"],
  ["osf", "application/vnd.yamaha.openscoreformat"],
  ["osfpvg", "application/vnd.yamaha.openscoreformat.osfpvg+xml"],
  ["osm", "application/vnd.openstreetmap.data+xml"],
  ["otc", "application/vnd.oasis.opendocument.chart-template"],
  ["otf", "font/otf"],
  ["otg", "application/vnd.oasis.opendocument.graphics-template"],
  ["oth", "application/vnd.oasis.opendocument.text-web"],
  ["oti", "application/vnd.oasis.opendocument.image-template"],
  ["otp", "application/vnd.oasis.opendocument.presentation-template"],
  ["ots", "application/vnd.oasis.opendocument.spreadsheet-template"],
  ["ott", "application/vnd.oasis.opendocument.text-template"],
  ["ova", "application/x-virtualbox-ova"],
  ["ovf", "application/x-virtualbox-ovf"],
  ["owl", "application/rdf+xml"],
  ["oxps", "application/oxps"],
  ["oxt", "application/vnd.openofficeorg.extension"],
  ["p", "text/x-pascal"],
  ["p7a", "application/x-pkcs7-signature"],
  ["p7b", "application/x-pkcs7-certificates"],
  ["p7c", "application/pkcs7-mime"],
  ["p7m", "application/pkcs7-mime"],
  ["p7r", "application/x-pkcs7-certreqresp"],
  ["p7s", "application/pkcs7-signature"],
  ["p8", "application/pkcs8"],
  ["p10", "application/x-pkcs10"],
  ["p12", "application/x-pkcs12"],
  ["pac", "application/x-ns-proxy-autoconfig"],
  ["pages", "application/x-iwork-pages-sffpages"],
  ["pas", "text/x-pascal"],
  ["paw", "application/vnd.pawaafile"],
  ["pbd", "application/vnd.powerbuilder6"],
  ["pbm", "image/x-portable-bitmap"],
  ["pcap", "application/vnd.tcpdump.pcap"],
  ["pcf", "application/x-font-pcf"],
  ["pcl", "application/vnd.hp-pcl"],
  ["pclxl", "application/vnd.hp-pclxl"],
  ["pct", "image/x-pict"],
  ["pcurl", "application/vnd.curl.pcurl"],
  ["pcx", "image/x-pcx"],
  ["pdb", "application/x-pilot"],
  ["pde", "text/x-processing"],
  ["pdf", "application/pdf"],
  ["pem", "application/x-x509-user-cert"],
  ["pfa", "application/x-font-type1"],
  ["pfb", "application/x-font-type1"],
  ["pfm", "application/x-font-type1"],
  ["pfr", "application/font-tdpfr"],
  ["pfx", "application/x-pkcs12"],
  ["pgm", "image/x-portable-graymap"],
  ["pgn", "application/x-chess-pgn"],
  ["pgp", "application/pgp"],
  ["php", "application/x-httpd-php"],
  ["php3", "application/x-httpd-php"],
  ["php4", "application/x-httpd-php"],
  ["phps", "application/x-httpd-php-source"],
  ["phtml", "application/x-httpd-php"],
  ["pic", "image/x-pict"],
  ["pkg", "application/octet-stream"],
  ["pki", "application/pkixcmp"],
  ["pkipath", "application/pkix-pkipath"],
  ["pkpass", "application/vnd.apple.pkpass"],
  ["pl", "application/x-perl"],
  ["plb", "application/vnd.3gpp.pic-bw-large"],
  ["plc", "application/vnd.mobius.plc"],
  ["plf", "application/vnd.pocketlearn"],
  ["pls", "application/pls+xml"],
  ["pm", "application/x-perl"],
  ["pml", "application/vnd.ctc-posml"],
  ["png", "image/png"],
  ["pnm", "image/x-portable-anymap"],
  ["portpkg", "application/vnd.macports.portpkg"],
  ["pot", "application/vnd.ms-powerpoint"],
  ["potm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["potx", "application/vnd.openxmlformats-officedocument.presentationml.template"],
  ["ppa", "application/vnd.ms-powerpoint"],
  ["ppam", "application/vnd.ms-powerpoint.addin.macroEnabled.12"],
  ["ppd", "application/vnd.cups-ppd"],
  ["ppm", "image/x-portable-pixmap"],
  ["pps", "application/vnd.ms-powerpoint"],
  ["ppsm", "application/vnd.ms-powerpoint.slideshow.macroEnabled.12"],
  ["ppsx", "application/vnd.openxmlformats-officedocument.presentationml.slideshow"],
  ["ppt", "application/powerpoint"],
  ["pptm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["pqa", "application/vnd.palm"],
  ["prc", "application/x-pilot"],
  ["pre", "application/vnd.lotus-freelance"],
  ["prf", "application/pics-rules"],
  ["provx", "application/provenance+xml"],
  ["ps", "application/postscript"],
  ["psb", "application/vnd.3gpp.pic-bw-small"],
  ["psd", "application/x-photoshop"],
  ["psf", "application/x-font-linux-psf"],
  ["pskcxml", "application/pskc+xml"],
  ["pti", "image/prs.pti"],
  ["ptid", "application/vnd.pvi.ptid1"],
  ["pub", "application/x-mspublisher"],
  ["pvb", "application/vnd.3gpp.pic-bw-var"],
  ["pwn", "application/vnd.3m.post-it-notes"],
  ["pya", "audio/vnd.ms-playready.media.pya"],
  ["pyv", "video/vnd.ms-playready.media.pyv"],
  ["qam", "application/vnd.epson.quickanime"],
  ["qbo", "application/vnd.intu.qbo"],
  ["qfx", "application/vnd.intu.qfx"],
  ["qps", "application/vnd.publishare-delta-tree"],
  ["qt", "video/quicktime"],
  ["qwd", "application/vnd.quark.quarkxpress"],
  ["qwt", "application/vnd.quark.quarkxpress"],
  ["qxb", "application/vnd.quark.quarkxpress"],
  ["qxd", "application/vnd.quark.quarkxpress"],
  ["qxl", "application/vnd.quark.quarkxpress"],
  ["qxt", "application/vnd.quark.quarkxpress"],
  ["ra", "audio/x-realaudio"],
  ["ram", "audio/x-pn-realaudio"],
  ["raml", "application/raml+yaml"],
  ["rapd", "application/route-apd+xml"],
  ["rar", "application/x-rar"],
  ["ras", "image/x-cmu-raster"],
  ["rcprofile", "application/vnd.ipunplugged.rcprofile"],
  ["rdf", "application/rdf+xml"],
  ["rdz", "application/vnd.data-vision.rdz"],
  ["relo", "application/p2p-overlay+xml"],
  ["rep", "application/vnd.businessobjects"],
  ["res", "application/x-dtbresource+xml"],
  ["rgb", "image/x-rgb"],
  ["rif", "application/reginfo+xml"],
  ["rip", "audio/vnd.rip"],
  ["ris", "application/x-research-info-systems"],
  ["rl", "application/resource-lists+xml"],
  ["rlc", "image/vnd.fujixerox.edmics-rlc"],
  ["rld", "application/resource-lists-diff+xml"],
  ["rm", "audio/x-pn-realaudio"],
  ["rmi", "audio/midi"],
  ["rmp", "audio/x-pn-realaudio-plugin"],
  ["rms", "application/vnd.jcp.javame.midlet-rms"],
  ["rmvb", "application/vnd.rn-realmedia-vbr"],
  ["rnc", "application/relax-ng-compact-syntax"],
  ["rng", "application/xml"],
  ["roa", "application/rpki-roa"],
  ["roff", "text/troff"],
  ["rp9", "application/vnd.cloanto.rp9"],
  ["rpm", "audio/x-pn-realaudio-plugin"],
  ["rpss", "application/vnd.nokia.radio-presets"],
  ["rpst", "application/vnd.nokia.radio-preset"],
  ["rq", "application/sparql-query"],
  ["rs", "application/rls-services+xml"],
  ["rsa", "application/x-pkcs7"],
  ["rsat", "application/atsc-rsat+xml"],
  ["rsd", "application/rsd+xml"],
  ["rsheet", "application/urc-ressheet+xml"],
  ["rss", "application/rss+xml"],
  ["rtf", "text/rtf"],
  ["rtx", "text/richtext"],
  ["run", "application/x-makeself"],
  ["rusd", "application/route-usd+xml"],
  ["rv", "video/vnd.rn-realvideo"],
  ["s", "text/x-asm"],
  ["s3m", "audio/s3m"],
  ["saf", "application/vnd.yamaha.smaf-audio"],
  ["sass", "text/x-sass"],
  ["sbml", "application/sbml+xml"],
  ["sc", "application/vnd.ibm.secure-container"],
  ["scd", "application/x-msschedule"],
  ["scm", "application/vnd.lotus-screencam"],
  ["scq", "application/scvp-cv-request"],
  ["scs", "application/scvp-cv-response"],
  ["scss", "text/x-scss"],
  ["scurl", "text/vnd.curl.scurl"],
  ["sda", "application/vnd.stardivision.draw"],
  ["sdc", "application/vnd.stardivision.calc"],
  ["sdd", "application/vnd.stardivision.impress"],
  ["sdkd", "application/vnd.solent.sdkm+xml"],
  ["sdkm", "application/vnd.solent.sdkm+xml"],
  ["sdp", "application/sdp"],
  ["sdw", "application/vnd.stardivision.writer"],
  ["sea", "application/octet-stream"],
  ["see", "application/vnd.seemail"],
  ["seed", "application/vnd.fdsn.seed"],
  ["sema", "application/vnd.sema"],
  ["semd", "application/vnd.semd"],
  ["semf", "application/vnd.semf"],
  ["senmlx", "application/senml+xml"],
  ["sensmlx", "application/sensml+xml"],
  ["ser", "application/java-serialized-object"],
  ["setpay", "application/set-payment-initiation"],
  ["setreg", "application/set-registration-initiation"],
  ["sfd-hdstx", "application/vnd.hydrostatix.sof-data"],
  ["sfs", "application/vnd.spotfire.sfs"],
  ["sfv", "text/x-sfv"],
  ["sgi", "image/sgi"],
  ["sgl", "application/vnd.stardivision.writer-global"],
  ["sgm", "text/sgml"],
  ["sgml", "text/sgml"],
  ["sh", "application/x-sh"],
  ["shar", "application/x-shar"],
  ["shex", "text/shex"],
  ["shf", "application/shf+xml"],
  ["shtml", "text/html"],
  ["sid", "image/x-mrsid-image"],
  ["sieve", "application/sieve"],
  ["sig", "application/pgp-signature"],
  ["sil", "audio/silk"],
  ["silo", "model/mesh"],
  ["sis", "application/vnd.symbian.install"],
  ["sisx", "application/vnd.symbian.install"],
  ["sit", "application/x-stuffit"],
  ["sitx", "application/x-stuffitx"],
  ["siv", "application/sieve"],
  ["skd", "application/vnd.koan"],
  ["skm", "application/vnd.koan"],
  ["skp", "application/vnd.koan"],
  ["skt", "application/vnd.koan"],
  ["sldm", "application/vnd.ms-powerpoint.slide.macroenabled.12"],
  ["sldx", "application/vnd.openxmlformats-officedocument.presentationml.slide"],
  ["slim", "text/slim"],
  ["slm", "text/slim"],
  ["sls", "application/route-s-tsid+xml"],
  ["slt", "application/vnd.epson.salt"],
  ["sm", "application/vnd.stepmania.stepchart"],
  ["smf", "application/vnd.stardivision.math"],
  ["smi", "application/smil"],
  ["smil", "application/smil"],
  ["smv", "video/x-smv"],
  ["smzip", "application/vnd.stepmania.package"],
  ["snd", "audio/basic"],
  ["snf", "application/x-font-snf"],
  ["so", "application/octet-stream"],
  ["spc", "application/x-pkcs7-certificates"],
  ["spdx", "text/spdx"],
  ["spf", "application/vnd.yamaha.smaf-phrase"],
  ["spl", "application/x-futuresplash"],
  ["spot", "text/vnd.in3d.spot"],
  ["spp", "application/scvp-vp-response"],
  ["spq", "application/scvp-vp-request"],
  ["spx", "audio/ogg"],
  ["sql", "application/x-sql"],
  ["src", "application/x-wais-source"],
  ["srt", "application/x-subrip"],
  ["sru", "application/sru+xml"],
  ["srx", "application/sparql-results+xml"],
  ["ssdl", "application/ssdl+xml"],
  ["sse", "application/vnd.kodak-descriptor"],
  ["ssf", "application/vnd.epson.ssf"],
  ["ssml", "application/ssml+xml"],
  ["sst", "application/octet-stream"],
  ["st", "application/vnd.sailingtracker.track"],
  ["stc", "application/vnd.sun.xml.calc.template"],
  ["std", "application/vnd.sun.xml.draw.template"],
  ["stf", "application/vnd.wt.stf"],
  ["sti", "application/vnd.sun.xml.impress.template"],
  ["stk", "application/hyperstudio"],
  ["stl", "model/stl"],
  ["stpx", "model/step+xml"],
  ["stpxz", "model/step-xml+zip"],
  ["stpz", "model/step+zip"],
  ["str", "application/vnd.pg.format"],
  ["stw", "application/vnd.sun.xml.writer.template"],
  ["styl", "text/stylus"],
  ["stylus", "text/stylus"],
  ["sub", "text/vnd.dvb.subtitle"],
  ["sus", "application/vnd.sus-calendar"],
  ["susp", "application/vnd.sus-calendar"],
  ["sv4cpio", "application/x-sv4cpio"],
  ["sv4crc", "application/x-sv4crc"],
  ["svc", "application/vnd.dvb.service"],
  ["svd", "application/vnd.svd"],
  ["svg", "image/svg+xml"],
  ["svgz", "image/svg+xml"],
  ["swa", "application/x-director"],
  ["swf", "application/x-shockwave-flash"],
  ["swi", "application/vnd.aristanetworks.swi"],
  ["swidtag", "application/swid+xml"],
  ["sxc", "application/vnd.sun.xml.calc"],
  ["sxd", "application/vnd.sun.xml.draw"],
  ["sxg", "application/vnd.sun.xml.writer.global"],
  ["sxi", "application/vnd.sun.xml.impress"],
  ["sxm", "application/vnd.sun.xml.math"],
  ["sxw", "application/vnd.sun.xml.writer"],
  ["t", "text/troff"],
  ["t3", "application/x-t3vm-image"],
  ["t38", "image/t38"],
  ["taglet", "application/vnd.mynfc"],
  ["tao", "application/vnd.tao.intent-module-archive"],
  ["tap", "image/vnd.tencent.tap"],
  ["tar", "application/x-tar"],
  ["tcap", "application/vnd.3gpp2.tcap"],
  ["tcl", "application/x-tcl"],
  ["td", "application/urc-targetdesc+xml"],
  ["teacher", "application/vnd.smart.teacher"],
  ["tei", "application/tei+xml"],
  ["teicorpus", "application/tei+xml"],
  ["tex", "application/x-tex"],
  ["texi", "application/x-texinfo"],
  ["texinfo", "application/x-texinfo"],
  ["text", "text/plain"],
  ["tfi", "application/thraud+xml"],
  ["tfm", "application/x-tex-tfm"],
  ["tfx", "image/tiff-fx"],
  ["tga", "image/x-tga"],
  ["tgz", "application/x-tar"],
  ["thmx", "application/vnd.ms-officetheme"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["tk", "application/x-tcl"],
  ["tmo", "application/vnd.tmobile-livetv"],
  ["toml", "application/toml"],
  ["torrent", "application/x-bittorrent"],
  ["tpl", "application/vnd.groove-tool-template"],
  ["tpt", "application/vnd.trid.tpt"],
  ["tr", "text/troff"],
  ["tra", "application/vnd.trueapp"],
  ["trig", "application/trig"],
  ["trm", "application/x-msterminal"],
  ["ts", "video/mp2t"],
  ["tsd", "application/timestamped-data"],
  ["tsv", "text/tab-separated-values"],
  ["ttc", "font/collection"],
  ["ttf", "font/ttf"],
  ["ttl", "text/turtle"],
  ["ttml", "application/ttml+xml"],
  ["twd", "application/vnd.simtech-mindmapper"],
  ["twds", "application/vnd.simtech-mindmapper"],
  ["txd", "application/vnd.genomatix.tuxedo"],
  ["txf", "application/vnd.mobius.txf"],
  ["txt", "text/plain"],
  ["u8dsn", "message/global-delivery-status"],
  ["u8hdr", "message/global-headers"],
  ["u8mdn", "message/global-disposition-notification"],
  ["u8msg", "message/global"],
  ["u32", "application/x-authorware-bin"],
  ["ubj", "application/ubjson"],
  ["udeb", "application/x-debian-package"],
  ["ufd", "application/vnd.ufdl"],
  ["ufdl", "application/vnd.ufdl"],
  ["ulx", "application/x-glulx"],
  ["umj", "application/vnd.umajin"],
  ["unityweb", "application/vnd.unity"],
  ["uoml", "application/vnd.uoml+xml"],
  ["uri", "text/uri-list"],
  ["uris", "text/uri-list"],
  ["urls", "text/uri-list"],
  ["usdz", "model/vnd.usdz+zip"],
  ["ustar", "application/x-ustar"],
  ["utz", "application/vnd.uiq.theme"],
  ["uu", "text/x-uuencode"],
  ["uva", "audio/vnd.dece.audio"],
  ["uvd", "application/vnd.dece.data"],
  ["uvf", "application/vnd.dece.data"],
  ["uvg", "image/vnd.dece.graphic"],
  ["uvh", "video/vnd.dece.hd"],
  ["uvi", "image/vnd.dece.graphic"],
  ["uvm", "video/vnd.dece.mobile"],
  ["uvp", "video/vnd.dece.pd"],
  ["uvs", "video/vnd.dece.sd"],
  ["uvt", "application/vnd.dece.ttml+xml"],
  ["uvu", "video/vnd.uvvu.mp4"],
  ["uvv", "video/vnd.dece.video"],
  ["uvva", "audio/vnd.dece.audio"],
  ["uvvd", "application/vnd.dece.data"],
  ["uvvf", "application/vnd.dece.data"],
  ["uvvg", "image/vnd.dece.graphic"],
  ["uvvh", "video/vnd.dece.hd"],
  ["uvvi", "image/vnd.dece.graphic"],
  ["uvvm", "video/vnd.dece.mobile"],
  ["uvvp", "video/vnd.dece.pd"],
  ["uvvs", "video/vnd.dece.sd"],
  ["uvvt", "application/vnd.dece.ttml+xml"],
  ["uvvu", "video/vnd.uvvu.mp4"],
  ["uvvv", "video/vnd.dece.video"],
  ["uvvx", "application/vnd.dece.unspecified"],
  ["uvvz", "application/vnd.dece.zip"],
  ["uvx", "application/vnd.dece.unspecified"],
  ["uvz", "application/vnd.dece.zip"],
  ["vbox", "application/x-virtualbox-vbox"],
  ["vbox-extpack", "application/x-virtualbox-vbox-extpack"],
  ["vcard", "text/vcard"],
  ["vcd", "application/x-cdlink"],
  ["vcf", "text/x-vcard"],
  ["vcg", "application/vnd.groove-vcard"],
  ["vcs", "text/x-vcalendar"],
  ["vcx", "application/vnd.vcx"],
  ["vdi", "application/x-virtualbox-vdi"],
  ["vds", "model/vnd.sap.vds"],
  ["vhd", "application/x-virtualbox-vhd"],
  ["vis", "application/vnd.visionary"],
  ["viv", "video/vnd.vivo"],
  ["vlc", "application/videolan"],
  ["vmdk", "application/x-virtualbox-vmdk"],
  ["vob", "video/x-ms-vob"],
  ["vor", "application/vnd.stardivision.writer"],
  ["vox", "application/x-authorware-bin"],
  ["vrml", "model/vrml"],
  ["vsd", "application/vnd.visio"],
  ["vsf", "application/vnd.vsf"],
  ["vss", "application/vnd.visio"],
  ["vst", "application/vnd.visio"],
  ["vsw", "application/vnd.visio"],
  ["vtf", "image/vnd.valve.source.texture"],
  ["vtt", "text/vtt"],
  ["vtu", "model/vnd.vtu"],
  ["vxml", "application/voicexml+xml"],
  ["w3d", "application/x-director"],
  ["wad", "application/x-doom"],
  ["wadl", "application/vnd.sun.wadl+xml"],
  ["war", "application/java-archive"],
  ["wasm", "application/wasm"],
  ["wav", "audio/x-wav"],
  ["wax", "audio/x-ms-wax"],
  ["wbmp", "image/vnd.wap.wbmp"],
  ["wbs", "application/vnd.criticaltools.wbs+xml"],
  ["wbxml", "application/wbxml"],
  ["wcm", "application/vnd.ms-works"],
  ["wdb", "application/vnd.ms-works"],
  ["wdp", "image/vnd.ms-photo"],
  ["weba", "audio/webm"],
  ["webapp", "application/x-web-app-manifest+json"],
  ["webm", "video/webm"],
  ["webmanifest", "application/manifest+json"],
  ["webp", "image/webp"],
  ["wg", "application/vnd.pmi.widget"],
  ["wgt", "application/widget"],
  ["wks", "application/vnd.ms-works"],
  ["wm", "video/x-ms-wm"],
  ["wma", "audio/x-ms-wma"],
  ["wmd", "application/x-ms-wmd"],
  ["wmf", "image/wmf"],
  ["wml", "text/vnd.wap.wml"],
  ["wmlc", "application/wmlc"],
  ["wmls", "text/vnd.wap.wmlscript"],
  ["wmlsc", "application/vnd.wap.wmlscriptc"],
  ["wmv", "video/x-ms-wmv"],
  ["wmx", "video/x-ms-wmx"],
  ["wmz", "application/x-msmetafile"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["word", "application/msword"],
  ["wpd", "application/vnd.wordperfect"],
  ["wpl", "application/vnd.ms-wpl"],
  ["wps", "application/vnd.ms-works"],
  ["wqd", "application/vnd.wqd"],
  ["wri", "application/x-mswrite"],
  ["wrl", "model/vrml"],
  ["wsc", "message/vnd.wfa.wsc"],
  ["wsdl", "application/wsdl+xml"],
  ["wspolicy", "application/wspolicy+xml"],
  ["wtb", "application/vnd.webturbo"],
  ["wvx", "video/x-ms-wvx"],
  ["x3d", "model/x3d+xml"],
  ["x3db", "model/x3d+fastinfoset"],
  ["x3dbz", "model/x3d+binary"],
  ["x3dv", "model/x3d-vrml"],
  ["x3dvz", "model/x3d+vrml"],
  ["x3dz", "model/x3d+xml"],
  ["x32", "application/x-authorware-bin"],
  ["x_b", "model/vnd.parasolid.transmit.binary"],
  ["x_t", "model/vnd.parasolid.transmit.text"],
  ["xaml", "application/xaml+xml"],
  ["xap", "application/x-silverlight-app"],
  ["xar", "application/vnd.xara"],
  ["xav", "application/xcap-att+xml"],
  ["xbap", "application/x-ms-xbap"],
  ["xbd", "application/vnd.fujixerox.docuworks.binder"],
  ["xbm", "image/x-xbitmap"],
  ["xca", "application/xcap-caps+xml"],
  ["xcs", "application/calendar+xml"],
  ["xdf", "application/xcap-diff+xml"],
  ["xdm", "application/vnd.syncml.dm+xml"],
  ["xdp", "application/vnd.adobe.xdp+xml"],
  ["xdssc", "application/dssc+xml"],
  ["xdw", "application/vnd.fujixerox.docuworks"],
  ["xel", "application/xcap-el+xml"],
  ["xenc", "application/xenc+xml"],
  ["xer", "application/patch-ops-error+xml"],
  ["xfdf", "application/vnd.adobe.xfdf"],
  ["xfdl", "application/vnd.xfdl"],
  ["xht", "application/xhtml+xml"],
  ["xhtml", "application/xhtml+xml"],
  ["xhvml", "application/xv+xml"],
  ["xif", "image/vnd.xiff"],
  ["xl", "application/excel"],
  ["xla", "application/vnd.ms-excel"],
  ["xlam", "application/vnd.ms-excel.addin.macroEnabled.12"],
  ["xlc", "application/vnd.ms-excel"],
  ["xlf", "application/xliff+xml"],
  ["xlm", "application/vnd.ms-excel"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsb", "application/vnd.ms-excel.sheet.binary.macroEnabled.12"],
  ["xlsm", "application/vnd.ms-excel.sheet.macroEnabled.12"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xlt", "application/vnd.ms-excel"],
  ["xltm", "application/vnd.ms-excel.template.macroEnabled.12"],
  ["xltx", "application/vnd.openxmlformats-officedocument.spreadsheetml.template"],
  ["xlw", "application/vnd.ms-excel"],
  ["xm", "audio/xm"],
  ["xml", "application/xml"],
  ["xns", "application/xcap-ns+xml"],
  ["xo", "application/vnd.olpc-sugar"],
  ["xop", "application/xop+xml"],
  ["xpi", "application/x-xpinstall"],
  ["xpl", "application/xproc+xml"],
  ["xpm", "image/x-xpixmap"],
  ["xpr", "application/vnd.is-xpr"],
  ["xps", "application/vnd.ms-xpsdocument"],
  ["xpw", "application/vnd.intercon.formnet"],
  ["xpx", "application/vnd.intercon.formnet"],
  ["xsd", "application/xml"],
  ["xsl", "application/xml"],
  ["xslt", "application/xslt+xml"],
  ["xsm", "application/vnd.syncml+xml"],
  ["xspf", "application/xspf+xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["xvm", "application/xv+xml"],
  ["xvml", "application/xv+xml"],
  ["xwd", "image/x-xwindowdump"],
  ["xyz", "chemical/x-xyz"],
  ["xz", "application/x-xz"],
  ["yaml", "text/yaml"],
  ["yang", "application/yang"],
  ["yin", "application/yin+xml"],
  ["yml", "text/yaml"],
  ["ymp", "text/x-suse-ymp"],
  ["z", "application/x-compress"],
  ["z1", "application/x-zmachine"],
  ["z2", "application/x-zmachine"],
  ["z3", "application/x-zmachine"],
  ["z4", "application/x-zmachine"],
  ["z5", "application/x-zmachine"],
  ["z6", "application/x-zmachine"],
  ["z7", "application/x-zmachine"],
  ["z8", "application/x-zmachine"],
  ["zaz", "application/vnd.zzazz.deck+xml"],
  ["zip", "application/zip"],
  ["zir", "application/vnd.zul"],
  ["zirz", "application/vnd.zul"],
  ["zmm", "application/vnd.handheld-entertainment+xml"],
  ["zsh", "text/x-scriptzsh"]
]);
function Au(e, t, n) {
  const r = I1e(e), { webkitRelativePath: o } = e, i = typeof t == "string" ? t : typeof o == "string" && o.length > 0 ? o : `./${e.name}`;
  return typeof r.path != "string" && uM(r, "path", i), uM(r, "relativePath", i), r;
}
function I1e(e) {
  const { name: t } = e;
  if (t && t.lastIndexOf(".") !== -1 && !e.type) {
    const r = t.split(".").pop().toLowerCase(), o = A1e.get(r);
    o && Object.defineProperty(e, "type", {
      value: o,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
function uM(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !1,
    configurable: !1,
    enumerable: !0
  });
}
const M1e = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  // macOs
  "Thumbs.db"
  // Windows
];
function N1e(e) {
  return al(this, void 0, void 0, function* () {
    return t0(e) && D1e(e.dataTransfer) ? z1e(e.dataTransfer, e.type) : L1e(e) ? j1e(e) : Array.isArray(e) && e.every((t) => "getFile" in t && typeof t.getFile == "function") ? F1e(e) : [];
  });
}
function D1e(e) {
  return t0(e);
}
function L1e(e) {
  return t0(e) && t0(e.target);
}
function t0(e) {
  return typeof e == "object" && e !== null;
}
function j1e(e) {
  return LS(e.target.files).map((t) => Au(t));
}
function F1e(e) {
  return al(this, void 0, void 0, function* () {
    return (yield Promise.all(e.map((n) => n.getFile()))).map((n) => Au(n));
  });
}
function z1e(e, t) {
  return al(this, void 0, void 0, function* () {
    if (e.items) {
      const n = LS(e.items).filter((o) => o.kind === "file");
      if (t !== "drop")
        return n;
      const r = yield Promise.all(n.map(B1e));
      return dM(Mz(r));
    }
    return dM(LS(e.files).map((n) => Au(n)));
  });
}
function dM(e) {
  return e.filter((t) => M1e.indexOf(t.name) === -1);
}
function LS(e) {
  if (e === null)
    return [];
  const t = [];
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    t.push(r);
  }
  return t;
}
function B1e(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return fM(e);
  const t = e.webkitGetAsEntry();
  return t && t.isDirectory ? Nz(t) : fM(e, t);
}
function Mz(e) {
  return e.reduce((t, n) => [
    ...t,
    ...Array.isArray(n) ? Mz(n) : [n]
  ], []);
}
function fM(e, t) {
  var n;
  if (typeof e.getAsFileSystemHandle == "function")
    return e.getAsFileSystemHandle().then((i) => al(this, void 0, void 0, function* () {
      const a = yield i.getFile();
      return a.handle = i, Au(a);
    }));
  const r = e.getAsFile();
  if (!r)
    return Promise.reject(`${e} is not a File`);
  const o = Au(r, (n = t == null ? void 0 : t.fullPath) !== null && n !== void 0 ? n : void 0);
  return Promise.resolve(o);
}
function q1e(e) {
  return al(this, void 0, void 0, function* () {
    return e.isDirectory ? Nz(e) : U1e(e);
  });
}
function Nz(e) {
  const t = e.createReader();
  return new Promise((n, r) => {
    const o = [];
    function i() {
      t.readEntries((a) => al(this, void 0, void 0, function* () {
        if (a.length) {
          const c = Promise.all(a.map(q1e));
          o.push(c), i();
        } else
          try {
            const c = yield Promise.all(o);
            n(c);
          } catch (c) {
            r(c);
          }
      }), (a) => {
        r(a);
      });
    }
    i();
  });
}
function U1e(e) {
  return al(this, void 0, void 0, function* () {
    return new Promise((t, n) => {
      e.file((r) => {
        const o = Au(r, e.fullPath);
        t(o);
      }, (r) => {
        n(r);
      });
    });
  });
}
var vm = {}, pM;
function W1e() {
  return pM || (pM = 1, vm.__esModule = !0, vm.default = function(e, t) {
    if (e && t) {
      var n = Array.isArray(t) ? t : t.split(",");
      if (n.length === 0)
        return !0;
      var r = e.name || "", o = (e.type || "").toLowerCase(), i = o.replace(/\/.*$/, "");
      return n.some(function(a) {
        var c = a.trim().toLowerCase();
        return c.charAt(0) === "." ? r.toLowerCase().endsWith(c) : c.endsWith("/*") ? i === c.replace(/\/.*$/, "") : o === c;
      });
    }
    return !0;
  }), vm;
}
var H1e = W1e();
const A2 = /* @__PURE__ */ jn(H1e);
function hM(e) {
  return G1e(e) || Y1e(e) || Lz(e) || V1e();
}
function V1e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Y1e(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function G1e(e) {
  if (Array.isArray(e)) return jS(e);
}
function mM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function gM(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? mM(Object(n), !0).forEach(function(r) {
      Dz(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : mM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Dz(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Qf(e, t) {
  return Z1e(e) || X1e(e, t) || Lz(e, t) || K1e();
}
function K1e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Lz(e, t) {
  if (e) {
    if (typeof e == "string") return jS(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return jS(e, t);
  }
}
function jS(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function X1e(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], o = !0, i = !1, a, c;
    try {
      for (n = n.call(e); !(o = (a = n.next()).done) && (r.push(a.value), !(t && r.length === t)); o = !0)
        ;
    } catch (l) {
      i = !0, c = l;
    } finally {
      try {
        !o && n.return != null && n.return();
      } finally {
        if (i) throw c;
      }
    }
    return r;
  }
}
function Z1e(e) {
  if (Array.isArray(e)) return e;
}
var J1e = typeof A2 == "function" ? A2 : A2.default, Q1e = "file-invalid-type", exe = "file-too-large", txe = "file-too-small", nxe = "too-many-files", rxe = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = t.split(","), r = n.length > 1 ? "one of ".concat(n.join(", ")) : n[0];
  return {
    code: Q1e,
    message: "File type must be ".concat(r)
  };
}, vM = function(t) {
  return {
    code: exe,
    message: "File is larger than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, yM = function(t) {
  return {
    code: txe,
    message: "File is smaller than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, oxe = {
  code: nxe,
  message: "Too many files"
};
function jz(e, t) {
  var n = e.type === "application/x-moz-file" || J1e(e, t);
  return [n, n ? null : rxe(t)];
}
function Fz(e, t, n) {
  if (wc(e.size))
    if (wc(t) && wc(n)) {
      if (e.size > n) return [!1, vM(n)];
      if (e.size < t) return [!1, yM(t)];
    } else {
      if (wc(t) && e.size < t) return [!1, yM(t)];
      if (wc(n) && e.size > n) return [!1, vM(n)];
    }
  return [!0, null];
}
function wc(e) {
  return e != null;
}
function ixe(e) {
  var t = e.files, n = e.accept, r = e.minSize, o = e.maxSize, i = e.multiple, a = e.maxFiles, c = e.validator;
  return !i && t.length > 1 || i && a >= 1 && t.length > a ? !1 : t.every(function(l) {
    var u = jz(l, n), d = Qf(u, 1), f = d[0], h = Fz(l, r, o), v = Qf(h, 1), y = v[0], g = c ? c(l) : null;
    return f && y && !g;
  });
}
function n0(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function ym(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(t) {
    return t === "Files" || t === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function bM(e) {
  e.preventDefault();
}
function axe(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function sxe(e) {
  return e.indexOf("Edge/") !== -1;
}
function cxe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return axe(e) || sxe(e);
}
function Mi() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    for (var o = arguments.length, i = new Array(o > 1 ? o - 1 : 0), a = 1; a < o; a++)
      i[a - 1] = arguments[a];
    return t.some(function(c) {
      return !n0(r) && c && c.apply(void 0, [r].concat(i)), n0(r);
    });
  };
}
function lxe() {
  return "showOpenFilePicker" in window;
}
function uxe(e) {
  if (wc(e)) {
    var t = Object.entries(e).filter(function(n) {
      var r = Qf(n, 2), o = r[0], i = r[1], a = !0;
      return zz(o) || (console.warn('Skipped "'.concat(o, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), a = !1), (!Array.isArray(i) || !i.every(Bz)) && (console.warn('Skipped "'.concat(o, '" because an invalid file extension was provided.')), a = !1), a;
    }).reduce(function(n, r) {
      var o = Qf(r, 2), i = o[0], a = o[1];
      return gM(gM({}, n), {}, Dz({}, i, a));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: t
    }];
  }
  return e;
}
function dxe(e) {
  if (wc(e))
    return Object.entries(e).reduce(function(t, n) {
      var r = Qf(n, 2), o = r[0], i = r[1];
      return [].concat(hM(t), [o], hM(i));
    }, []).filter(function(t) {
      return zz(t) || Bz(t);
    }).join(",");
}
function fxe(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function pxe(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function zz(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || e === "application/*" || /\w+\/[-+.\w]+/g.test(e);
}
function Bz(e) {
  return /^.*\.[\w]+$/.test(e);
}
var hxe = ["children"], mxe = ["open"], gxe = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], vxe = ["refKey", "onChange", "onClick"];
function yxe(e) {
  return wxe(e) || xxe(e) || qz(e) || bxe();
}
function bxe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function xxe(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function wxe(e) {
  if (Array.isArray(e)) return FS(e);
}
function I2(e, t) {
  return Sxe(e) || Oxe(e, t) || qz(e, t) || $xe();
}
function $xe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function qz(e, t) {
  if (e) {
    if (typeof e == "string") return FS(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return FS(e, t);
  }
}
function FS(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Oxe(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], o = !0, i = !1, a, c;
    try {
      for (n = n.call(e); !(o = (a = n.next()).done) && (r.push(a.value), !(t && r.length === t)); o = !0)
        ;
    } catch (l) {
      i = !0, c = l;
    } finally {
      try {
        !o && n.return != null && n.return();
      } finally {
        if (i) throw c;
      }
    }
    return r;
  }
}
function Sxe(e) {
  if (Array.isArray(e)) return e;
}
function xM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Cn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xM(Object(n), !0).forEach(function(r) {
      zS(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function zS(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function r0(e, t) {
  if (e == null) return {};
  var n = Cxe(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Cxe(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
var _E = /* @__PURE__ */ xp(function(e, t) {
  var n = e.children, r = r0(e, hxe), o = Txe(r), i = o.open, a = r0(o, mxe);
  return G8(t, function() {
    return {
      open: i
    };
  }, [i]), /* @__PURE__ */ ye.createElement(IJ, null, n(Cn(Cn({}, a), {}, {
    open: i
  })));
});
_E.displayName = "Dropzone";
var Uz = {
  disabled: !1,
  getFilesFromEvent: N1e,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !1,
  autoFocus: !1
};
_E.defaultProps = Uz;
_E.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: s.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: s.objectOf(s.arrayOf(s.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: s.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: s.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: s.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: s.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: s.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: s.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: s.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: s.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: s.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: s.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: s.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: s.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: s.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: s.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: s.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: s.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: s.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: s.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: s.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: s.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: s.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: s.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: s.func
};
var BS = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function Txe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = Cn(Cn({}, Uz), e), n = t.accept, r = t.disabled, o = t.getFilesFromEvent, i = t.maxSize, a = t.minSize, c = t.multiple, l = t.maxFiles, u = t.onDragEnter, d = t.onDragLeave, f = t.onDragOver, h = t.onDrop, v = t.onDropAccepted, y = t.onDropRejected, g = t.onFileDialogCancel, b = t.onFileDialogOpen, x = t.useFsAccessApi, $ = t.autoFocus, S = t.preventDropOnDocument, O = t.noClick, C = t.noKeyboard, T = t.noDrag, k = t.noDragEventsBubbling, I = t.onError, P = t.validator, _ = Nn(function() {
    return dxe(n);
  }, [n]), A = Nn(function() {
    return uxe(n);
  }, [n]), D = Nn(function() {
    return typeof b == "function" ? b : wM;
  }, [b]), M = Nn(function() {
    return typeof g == "function" ? g : wM;
  }, [g]), N = Gt(null), L = Gt(null), z = V8(Exe, BS), q = I2(z, 2), W = q[0], U = q[1], K = W.isFocused, Y = W.isFileDialogActive, X = Gt(typeof window < "u" && window.isSecureContext && x && lxe()), oe = function() {
    !X.current && Y && setTimeout(function() {
      if (L.current) {
        var he = L.current.files;
        he.length || (U({
          type: "closeDialog"
        }), M());
      }
    }, 300);
  };
  mn(function() {
    return window.addEventListener("focus", oe, !1), function() {
      window.removeEventListener("focus", oe, !1);
    };
  }, [L, Y, M, X]);
  var re = Gt([]), Z = function(he) {
    N.current && N.current.contains(he.target) || (he.preventDefault(), re.current = []);
  };
  mn(function() {
    return S && (document.addEventListener("dragover", bM, !1), document.addEventListener("drop", Z, !1)), function() {
      S && (document.removeEventListener("dragover", bM), document.removeEventListener("drop", Z));
    };
  }, [N, S]), mn(function() {
    return !r && $ && N.current && N.current.focus(), function() {
    };
  }, [N, $, r]);
  var ce = Rt(function(J) {
    I ? I(J) : console.error(J);
  }, [I]), fe = Rt(function(J) {
    J.preventDefault(), J.persist(), je(J), re.current = [].concat(yxe(re.current), [J.target]), ym(J) && Promise.resolve(o(J)).then(function(he) {
      if (!(n0(J) && !k)) {
        var Te = he.length, xe = Te > 0 && ixe({
          files: he,
          accept: _,
          minSize: a,
          maxSize: i,
          multiple: c,
          maxFiles: l,
          validator: P
        }), Ae = Te > 0 && !xe;
        U({
          isDragAccept: xe,
          isDragReject: Ae,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), u && u(J);
      }
    }).catch(function(he) {
      return ce(he);
    });
  }, [o, u, ce, k, _, a, i, c, l, P]), de = Rt(function(J) {
    J.preventDefault(), J.persist(), je(J);
    var he = ym(J);
    if (he && J.dataTransfer)
      try {
        J.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return he && f && f(J), !1;
  }, [f, k]), ne = Rt(function(J) {
    J.preventDefault(), J.persist(), je(J);
    var he = re.current.filter(function(xe) {
      return N.current && N.current.contains(xe);
    }), Te = he.indexOf(J.target);
    Te !== -1 && he.splice(Te, 1), re.current = he, !(he.length > 0) && (U({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), ym(J) && d && d(J));
  }, [N, d, k]), le = Rt(function(J, he) {
    var Te = [], xe = [];
    J.forEach(function(Ae) {
      var Ce = jz(Ae, _), Ye = I2(Ce, 2), He = Ye[0], Be = Ye[1], Xe = Fz(Ae, a, i), Ze = I2(Xe, 2), Ne = Ze[0], $e = Ze[1], Ue = P ? P(Ae) : null;
      if (He && Ne && !Ue)
        Te.push(Ae);
      else {
        var Ke = [Be, $e];
        Ue && (Ke = Ke.concat(Ue)), xe.push({
          file: Ae,
          errors: Ke.filter(function(Me) {
            return Me;
          })
        });
      }
    }), (!c && Te.length > 1 || c && l >= 1 && Te.length > l) && (Te.forEach(function(Ae) {
      xe.push({
        file: Ae,
        errors: [oxe]
      });
    }), Te.splice(0)), U({
      acceptedFiles: Te,
      fileRejections: xe,
      isDragReject: xe.length > 0,
      type: "setFiles"
    }), h && h(Te, xe, he), xe.length > 0 && y && y(xe, he), Te.length > 0 && v && v(Te, he);
  }, [U, c, _, a, i, l, h, v, y, P]), ve = Rt(function(J) {
    J.preventDefault(), J.persist(), je(J), re.current = [], ym(J) && Promise.resolve(o(J)).then(function(he) {
      n0(J) && !k || le(he, J);
    }).catch(function(he) {
      return ce(he);
    }), U({
      type: "reset"
    });
  }, [o, le, ce, k]), G = Rt(function() {
    if (X.current) {
      U({
        type: "openDialog"
      }), D();
      var J = {
        multiple: c,
        types: A
      };
      window.showOpenFilePicker(J).then(function(he) {
        return o(he);
      }).then(function(he) {
        le(he, null), U({
          type: "closeDialog"
        });
      }).catch(function(he) {
        fxe(he) ? (M(he), U({
          type: "closeDialog"
        })) : pxe(he) ? (X.current = !1, L.current ? (L.current.value = null, L.current.click()) : ce(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : ce(he);
      });
      return;
    }
    L.current && (U({
      type: "openDialog"
    }), D(), L.current.value = null, L.current.click());
  }, [U, D, M, x, le, ce, A, c]), Se = Rt(function(J) {
    !N.current || !N.current.isEqualNode(J.target) || (J.key === " " || J.key === "Enter" || J.keyCode === 32 || J.keyCode === 13) && (J.preventDefault(), G());
  }, [N, G]), ue = Rt(function() {
    U({
      type: "focus"
    });
  }, []), Q = Rt(function() {
    U({
      type: "blur"
    });
  }, []), ie = Rt(function() {
    O || (cxe() ? setTimeout(G, 0) : G());
  }, [O, G]), ee = function(he) {
    return r ? null : he;
  }, be = function(he) {
    return C ? null : ee(he);
  }, Ie = function(he) {
    return T ? null : ee(he);
  }, je = function(he) {
    k && he.stopPropagation();
  }, V = Nn(function() {
    return function() {
      var J = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, he = J.refKey, Te = he === void 0 ? "ref" : he, xe = J.role, Ae = J.onKeyDown, Ce = J.onFocus, Ye = J.onBlur, He = J.onClick, Be = J.onDragEnter, Xe = J.onDragOver, Ze = J.onDragLeave, Ne = J.onDrop, $e = r0(J, gxe);
      return Cn(Cn(zS({
        onKeyDown: be(Mi(Ae, Se)),
        onFocus: be(Mi(Ce, ue)),
        onBlur: be(Mi(Ye, Q)),
        onClick: ee(Mi(He, ie)),
        onDragEnter: Ie(Mi(Be, fe)),
        onDragOver: Ie(Mi(Xe, de)),
        onDragLeave: Ie(Mi(Ze, ne)),
        onDrop: Ie(Mi(Ne, ve)),
        role: typeof xe == "string" && xe !== "" ? xe : "presentation"
      }, Te, N), !r && !C ? {
        tabIndex: 0
      } : {}), $e);
    };
  }, [N, Se, ue, Q, ie, fe, de, ne, ve, C, T, r]), se = Rt(function(J) {
    J.stopPropagation();
  }, []), we = Nn(function() {
    return function() {
      var J = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, he = J.refKey, Te = he === void 0 ? "ref" : he, xe = J.onChange, Ae = J.onClick, Ce = r0(J, vxe), Ye = zS({
        accept: _,
        multiple: c,
        type: "file",
        style: {
          border: 0,
          clip: "rect(0, 0, 0, 0)",
          clipPath: "inset(50%)",
          height: "1px",
          margin: "0 -1px -1px 0",
          overflow: "hidden",
          padding: 0,
          position: "absolute",
          width: "1px",
          whiteSpace: "nowrap"
        },
        onChange: ee(Mi(xe, ve)),
        onClick: ee(Mi(Ae, se)),
        tabIndex: -1
      }, Te, L);
      return Cn(Cn({}, Ye), Ce);
    };
  }, [L, n, c, ve, r]);
  return Cn(Cn({}, W), {}, {
    isFocused: K && !r,
    getRootProps: V,
    getInputProps: we,
    rootRef: N,
    inputRef: L,
    open: ee(G)
  });
}
function Exe(e, t) {
  switch (t.type) {
    case "focus":
      return Cn(Cn({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return Cn(Cn({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return Cn(Cn({}, BS), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return Cn(Cn({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return Cn(Cn({}, e), {}, {
        isDragActive: t.isDragActive,
        isDragAccept: t.isDragAccept,
        isDragReject: t.isDragReject
      });
    case "setFiles":
      return Cn(Cn({}, e), {}, {
        acceptedFiles: t.acceptedFiles,
        fileRejections: t.fileRejections,
        isDragReject: t.isDragReject
      });
    case "reset":
      return Cn({}, BS);
    default:
      return e;
  }
}
function wM() {
}
const Wz = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]", "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[25-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}", [8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468]))\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function kE(e, t) {
  var n = Array.prototype.slice.call(t);
  return n.push(Wz), e.apply(this, n);
}
function qS(e) {
  "@babel/helpers - typeof";
  return qS = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qS(e);
}
function _xe(e, t, n) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function kxe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Rxe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && ep(e, t);
}
function Pxe(e) {
  var t = Vz();
  return function() {
    var r = tp(e), o;
    if (t) {
      var i = tp(this).constructor;
      o = Reflect.construct(r, arguments, i);
    } else
      o = r.apply(this, arguments);
    return Axe(this, o);
  };
}
function Axe(e, t) {
  if (t && (qS(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Hz(e);
}
function Hz(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function US(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return US = function(r) {
    if (r === null || !Ixe(r)) return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(r)) return t.get(r);
      t.set(r, o);
    }
    function o() {
      return cg(r, arguments, tp(this).constructor);
    }
    return o.prototype = Object.create(r.prototype, { constructor: { value: o, enumerable: !1, writable: !0, configurable: !0 } }), ep(o, r);
  }, US(e);
}
function cg(e, t, n) {
  return Vz() ? cg = Reflect.construct : cg = function(o, i, a) {
    var c = [null];
    c.push.apply(c, i);
    var l = Function.bind.apply(o, c), u = new l();
    return a && ep(u, a.prototype), u;
  }, cg.apply(null, arguments);
}
function Vz() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ixe(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function ep(e, t) {
  return ep = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, ep(e, t);
}
function tp(e) {
  return tp = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, tp(e);
}
var Ia = /* @__PURE__ */ function(e) {
  Rxe(n, e);
  var t = Pxe(n);
  function n(r) {
    var o;
    return kxe(this, n), o = t.call(this, r), Object.setPrototypeOf(Hz(o), n.prototype), o.name = o.constructor.name, o;
  }
  return _xe(n);
}(/* @__PURE__ */ US(Error)), RE = 2, Mxe = 17, Nxe = 3, Lr = "0-9０-９٠-٩۰-۹", Dxe = "-‐-―−ー－", Lxe = "／/", jxe = "．.", Fxe = "  ­​⁠　", zxe = "()（）［］\\[\\]", Bxe = "~⁓∼～", vi = "".concat(Dxe).concat(Lxe).concat(jxe).concat(Fxe).concat(zxe).concat(Bxe), Fv = "+＋";
function $M(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var n = e[0].split("."), r = t[0].split("."), o = 0; o < 3; o++) {
    var i = Number(n[o]), a = Number(r[o]);
    if (i > a) return 1;
    if (a > i) return -1;
    if (!isNaN(i) && isNaN(a)) return 1;
    if (isNaN(i) && !isNaN(a)) return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
var qxe = {}.constructor;
function Sf(e) {
  return e != null && e.constructor === qxe;
}
function WS(e) {
  "@babel/helpers - typeof";
  return WS = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, WS(e);
}
function zv(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Uxe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Bv(e, t, n) {
  return t && Uxe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var Wxe = "1.2.0", Hxe = "1.7.35", OM = " ext. ", Vxe = /^\d+$/, ir = /* @__PURE__ */ function() {
  function e(t) {
    zv(this, e), Xxe(t), this.metadata = t, Yz.call(this, t);
  }
  return Bv(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(n) {
        return n !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(n) {
      return this.metadata.countries[n];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(n) {
      return this.getCountryMetadata(n) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(n) {
      if (this.getCountryCodesForCallingCode(n))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[n])
          return !0;
      } else {
        var r = this.countryCallingCodes()[n];
        if (r && r.length === 1 && r[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(n) {
      return this.nonGeographic() ? !!this.nonGeographic()[n] : !this.getCountryCodesForCallingCode(n);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(n, r) {
      if (n && Vxe.test(n) && (r = n, n = null), n && n !== "001") {
        if (!this.hasCountry(n))
          throw new Error("Unknown country: ".concat(n));
        this.numberingPlan = new SM(this.getCountryMetadata(n), this);
      } else if (r) {
        if (!this.hasCallingCode(r))
          throw new Error("Unknown calling code: ".concat(r));
        this.numberingPlan = new SM(this.getNumberingPlanMetadata(r), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(n) {
      var r = this.countryCallingCodes()[n];
      if (r)
        return r.length === 1 && r[0].length === 3 ? void 0 : r;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(n) {
      var r = this.getCountryCodesForCallingCode(n);
      if (r)
        return r[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(n) {
      var r = this.getCountryCodeForCallingCode(n);
      if (r)
        return this.getCountryMetadata(r);
      if (this.nonGeographic()) {
        var o = this.nonGeographic()[n];
        if (o)
          return o;
      } else {
        var i = this.countryCallingCodes()[n];
        if (i && i.length === 1 && i[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(n) {
      return this.numberingPlan.type(n);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(n) {
      return this.selectNumberingPlan(n);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]), e;
}(), SM = /* @__PURE__ */ function() {
  function e(t, n) {
    zv(this, e), this.globalMetadataObject = n, this.metadata = t, Yz.call(this, n.metadata);
  }
  return Bv(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(n) {
      return n[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var n = this, r = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return r.map(function(o) {
        return new Yxe(o, n);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(n) {
      return n[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(n) {
      if (this.hasTypes() && CM(this.types(), n))
        return new Kxe(CM(this.types(), n), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? OM : this.metadata[13] || OM;
    }
  }]), e;
}(), Yxe = /* @__PURE__ */ function() {
  function e(t, n) {
    zv(this, e), this._format = t, this.metadata = n;
  }
  return Bv(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !Gxe.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]), e;
}(), Gxe = /^\(?\$1\)?$/, Kxe = /* @__PURE__ */ function() {
  function e(t, n) {
    zv(this, e), this.type = t, this.metadata = n;
  }
  return Bv(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]), e;
}();
function CM(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function Xxe(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!Sf(e) || !Sf(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(Sf(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + Zxe(e) + ": " + e, "."));
}
var Zxe = function(t) {
  return WS(t);
};
function qv(e, t) {
  if (t = new ir(t), t.hasCountry(e))
    return t.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function Jxe(e, t) {
  return t.countries.hasOwnProperty(e);
}
function Yz(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? $M(t, Wxe) === -1 ? this.v2 = !0 : $M(t, Hxe) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var Qxe = ";ext=", Hl = function(t) {
  return "([".concat(Lr, "]{1,").concat(t, "})");
};
function Gz(e) {
  var t = "20", n = "15", r = "9", o = "6", i = "[  \\t,]*", a = "[:\\.．]?[  \\t,-]*", c = "#?", l = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", u = "(?:[xｘ#＃~～]|int|ｉｎｔ)", d = "[- ]+", f = "[  \\t]*", h = "(?:,{2}|;)", v = Qxe + Hl(t), y = i + l + a + Hl(t) + c, g = i + u + a + Hl(r) + c, b = d + Hl(o) + "#", x = f + h + a + Hl(n) + c, $ = f + "(?:,)+" + a + Hl(r) + c;
  return v + "|" + y + "|" + g + "|" + b + "|" + x + "|" + $;
}
var ewe = "[" + Lr + "]{" + RE + "}", twe = "[" + Fv + "]{0,1}(?:[" + vi + "]*[" + Lr + "]){3,}[" + vi + Lr + "]*", nwe = new RegExp("^[" + Fv + "]{0,1}(?:[" + vi + "]*[" + Lr + "]){1,2}$", "i"), rwe = twe + // Phone number extensions
"(?:" + Gz() + ")?", owe = new RegExp(
  // Either a short two-digit-only phone number
  "^" + ewe + "$|^" + rwe + "$",
  "i"
);
function iwe(e) {
  return e.length >= RE && owe.test(e);
}
function awe(e) {
  return nwe.test(e);
}
var TM = new RegExp("(?:" + Gz() + ")$", "i");
function swe(e) {
  var t = e.search(TM);
  if (t < 0)
    return {};
  for (var n = e.slice(0, t), r = e.match(TM), o = 1; o < r.length; ) {
    if (r[o])
      return {
        number: n,
        ext: r[o]
      };
    o++;
  }
}
function cwe(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = lwe(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function lwe(e, t) {
  if (e) {
    if (typeof e == "string") return EM(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return EM(e, t);
  }
}
function EM(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var uwe = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function Kz(e) {
  return uwe[e];
}
function o0(e) {
  for (var t = "", n = cwe(e.split("")), r; !(r = n()).done; ) {
    var o = r.value, i = Kz(o);
    i && (t += i);
  }
  return t;
}
function dwe(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = fwe(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function fwe(e, t) {
  if (e) {
    if (typeof e == "string") return _M(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _M(e, t);
  }
}
function _M(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function kM(e) {
  for (var t = "", n = dwe(e.split("")), r; !(r = n()).done; ) {
    var o = r.value;
    t += pwe(o, t) || "";
  }
  return t;
}
function pwe(e, t, n) {
  return e === "+" ? t ? void 0 : "+" : Kz(e);
}
function Uv(e, t) {
  return hwe(e, void 0, t);
}
function hwe(e, t, n) {
  var r = n.type(t), o = r && r.possibleLengths() || n.possibleLengths();
  if (!o)
    return "IS_POSSIBLE";
  var i = e.length, a = o[0];
  return a === i ? "IS_POSSIBLE" : a > i ? "TOO_SHORT" : o[o.length - 1] < i ? "TOO_LONG" : o.indexOf(i, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function mwe(e, t, n) {
  if (t === void 0 && (t = {}), n = new ir(n), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    n.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!n.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      n.country(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      n.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (n.possibleLengths())
    return Xz(e.phone || e.nationalNumber, n);
  if (e.countryCallingCode && n.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function Xz(e, t) {
  switch (Uv(e, t)) {
    case "IS_POSSIBLE":
      return !0;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational
    default:
      return !1;
  }
}
function qa(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function gwe(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = vwe(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vwe(e, t) {
  if (e) {
    if (typeof e == "string") return RM(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return RM(e, t);
  }
}
function RM(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var ywe = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function PE(e, t, n) {
  if (t = t || {}, !(!e.country && !e.countryCallingCode)) {
    n = new ir(n), n.selectNumberingPlan(e.country, e.countryCallingCode);
    var r = t.v2 ? e.nationalNumber : e.phone;
    if (qa(r, n.nationalNumberPattern())) {
      if (M2(r, "FIXED_LINE", n))
        return n.type("MOBILE") && n.type("MOBILE").pattern() === "" || !n.type("MOBILE") || M2(r, "MOBILE", n) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var o = gwe(ywe), i; !(i = o()).done; ) {
        var a = i.value;
        if (M2(r, a, n))
          return a;
      }
    }
  }
}
function M2(e, t, n) {
  return t = n.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0 ? !1 : qa(e, t.pattern());
}
function bwe(e, t, n) {
  if (t = t || {}, n = new ir(n), n.selectNumberingPlan(e.country, e.countryCallingCode), n.hasTypes())
    return PE(e, t, n.metadata) !== void 0;
  var r = t.v2 ? e.nationalNumber : e.phone;
  return qa(r, n.nationalNumberPattern());
}
function xwe(e, t, n) {
  var r = new ir(n), o = r.getCountryCodesForCallingCode(e);
  return o ? o.filter(function(i) {
    return wwe(t, i, n);
  }) : [];
}
function wwe(e, t, n) {
  var r = new ir(n);
  return r.selectNumberingPlan(t), r.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
function Zz(e) {
  return e.replace(new RegExp("[".concat(vi, "]+"), "g"), " ").trim();
}
var Jz = /(\$\d)/;
function Qz(e, t, n) {
  var r = n.useInternationalFormat, o = n.withNationalPrefix;
  n.carrierCode, n.metadata;
  var i = e.replace(new RegExp(t.pattern()), r ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    o && t.nationalPrefixFormattingRule() ? t.format().replace(Jz, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return r ? Zz(i) : i;
}
var $we = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function Owe(e, t, n) {
  var r = new ir(n);
  if (r.selectNumberingPlan(e, t), r.defaultIDDPrefix())
    return r.defaultIDDPrefix();
  if ($we.test(r.IDDPrefix()))
    return r.IDDPrefix();
}
function Swe(e) {
  var t = e.number, n = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(n ? ";ext=" + n : "");
}
function Cwe(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Twe(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Twe(e, t) {
  if (e) {
    if (typeof e == "string") return PM(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return PM(e, t);
  }
}
function PM(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function AM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function IM(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? AM(Object(n), !0).forEach(function(r) {
      Ewe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : AM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ewe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var MM = {
  formatExtension: function(t, n, r) {
    return "".concat(t).concat(r.ext()).concat(n);
  }
};
function _we(e, t, n, r) {
  if (n ? n = IM(IM({}, MM), n) : n = MM, r = new ir(r), e.country && e.country !== "001") {
    if (!r.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    r.country(e.country);
  } else if (e.countryCallingCode)
    r.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || "";
  var o = r.countryCallingCode(), i = n.v2 ? e.nationalNumber : e.phone, a;
  switch (t) {
    case "NATIONAL":
      return i ? (a = i0(i, e.carrierCode, "NATIONAL", r, n), N2(a, e.ext, r, n.formatExtension)) : "";
    case "INTERNATIONAL":
      return i ? (a = i0(i, null, "INTERNATIONAL", r, n), a = "+".concat(o, " ").concat(a), N2(a, e.ext, r, n.formatExtension)) : "+".concat(o);
    case "E.164":
      return "+".concat(o).concat(i);
    case "RFC3966":
      return Swe({
        number: "+".concat(o).concat(i),
        ext: e.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case "IDD":
      if (!n.fromCountry)
        return;
      var c = Rwe(i, e.carrierCode, o, n.fromCountry, r);
      return N2(c, e.ext, r, n.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function i0(e, t, n, r, o) {
  var i = kwe(r.formats(), e);
  return i ? Qz(e, i, {
    useInternationalFormat: n === "INTERNATIONAL",
    withNationalPrefix: !(i.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && o && o.nationalPrefix === !1),
    carrierCode: t,
    metadata: r
  }) : e;
}
function kwe(e, t) {
  for (var n = Cwe(e), r; !(r = n()).done; ) {
    var o = r.value;
    if (o.leadingDigitsPatterns().length > 0) {
      var i = o.leadingDigitsPatterns()[o.leadingDigitsPatterns().length - 1];
      if (t.search(i) !== 0)
        continue;
    }
    if (qa(t, o.pattern()))
      return o;
  }
}
function N2(e, t, n, r) {
  return t ? r(e, t, n) : e;
}
function Rwe(e, t, n, r, o) {
  var i = qv(r, o.metadata);
  if (i === n) {
    var a = i0(e, t, "NATIONAL", o);
    return n === "1" ? n + " " + a : a;
  }
  var c = Owe(r, void 0, o.metadata);
  if (c)
    return "".concat(c, " ").concat(n, " ").concat(i0(e, null, "INTERNATIONAL", o));
}
function NM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function DM(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? NM(Object(n), !0).forEach(function(r) {
      Pwe(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : NM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Pwe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Awe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Iwe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Mwe(e, t, n) {
  return t && Iwe(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var eB = /* @__PURE__ */ function() {
  function e(t, n, r) {
    if (Awe(this, e), !t)
      throw new TypeError("`country` or `countryCallingCode` not passed");
    if (!n)
      throw new TypeError("`nationalNumber` not passed");
    if (!r)
      throw new TypeError("`metadata` not passed");
    var o = Dwe(t, r), i = o.country, a = o.countryCallingCode;
    this.country = i, this.countryCallingCode = a, this.nationalNumber = n, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return r;
    };
  }
  return Mwe(e, [{
    key: "setExt",
    value: function(n) {
      this.ext = n;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : xwe(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return mwe(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return bwe(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var n = new ir(this.getMetadata());
      return n.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(n) {
      return this.number === n.number && this.ext === n.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return PE(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(n, r) {
      return _we(this, n, r ? DM(DM({}, r), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(n) {
      return this.format("NATIONAL", n);
    }
  }, {
    key: "formatInternational",
    value: function(n) {
      return this.format("INTERNATIONAL", n);
    }
  }, {
    key: "getURI",
    value: function(n) {
      return this.format("RFC3966", n);
    }
  }]), e;
}(), Nwe = function(t) {
  return /^[A-Z]{2}$/.test(t);
};
function Dwe(e, t) {
  var n, r, o = new ir(t);
  return Nwe(e) ? (n = e, o.selectNumberingPlan(n), r = o.countryCallingCode()) : r = e, {
    country: n,
    countryCallingCode: r
  };
}
var Lwe = new RegExp("([" + Lr + "])");
function tB(e, t, n, r) {
  if (t) {
    var o = new ir(r);
    o.selectNumberingPlan(t, n);
    var i = new RegExp(o.IDDPrefix());
    if (e.search(i) === 0) {
      e = e.slice(e.match(i)[0].length);
      var a = e.match(Lwe);
      if (!(a && a[1] != null && a[1].length > 0 && a[1] === "0"))
        return e;
    }
  }
}
function HS(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var n = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), r = n.exec(e);
    if (r) {
      var o, i, a = r.length - 1, c = a > 0 && r[a];
      if (t.nationalPrefixTransformRule() && c)
        o = e.replace(n, t.nationalPrefixTransformRule()), a > 1 && (i = r[1]);
      else {
        var l = r[0];
        o = e.slice(l.length), c && (i = r[1]);
      }
      var u;
      if (c) {
        var d = e.indexOf(r[1]), f = e.slice(0, d);
        f === t.numberingPlan.nationalPrefix() && (u = t.numberingPlan.nationalPrefix());
      } else
        u = r[0];
      return {
        nationalNumber: o,
        nationalPrefix: u,
        carrierCode: i
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function VS(e, t) {
  var n = HS(e, t), r = n.carrierCode, o = n.nationalNumber;
  if (o !== e) {
    if (!jwe(e, o, t))
      return {
        nationalNumber: e
      };
    if (t.possibleLengths() && !Fwe(o, t))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: o,
    carrierCode: r
  };
}
function jwe(e, t, n) {
  return !(qa(e, n.nationalNumberPattern()) && !qa(t, n.nationalNumberPattern()));
}
function Fwe(e, t) {
  switch (Uv(e, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function nB(e, t, n, r) {
  var o = t ? qv(t, r) : n;
  if (e.indexOf(o) === 0) {
    r = new ir(r), r.selectNumberingPlan(t, n);
    var i = e.slice(o.length), a = VS(i, r), c = a.nationalNumber, l = VS(e, r), u = l.nationalNumber;
    if (!qa(u, r.nationalNumberPattern()) && qa(c, r.nationalNumberPattern()) || Uv(u, r) === "TOO_LONG")
      return {
        countryCallingCode: o,
        number: i
      };
  }
  return {
    number: e
  };
}
function rB(e, t, n, r) {
  if (!e)
    return {};
  var o;
  if (e[0] !== "+") {
    var i = tB(e, t, n, r);
    if (i && i !== e)
      o = !0, e = "+" + i;
    else {
      if (t || n) {
        var a = nB(e, t, n, r), c = a.countryCallingCode, l = a.number;
        if (c)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: c,
            number: l
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  r = new ir(r);
  for (var u = 2; u - 1 <= Nxe && u <= e.length; ) {
    var d = e.slice(1, u);
    if (r.hasCallingCode(d))
      return r.selectNumberingPlan(d), {
        countryCallingCodeSource: o ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: d,
        number: e.slice(u)
      };
    u++;
  }
  return {};
}
function zwe(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Bwe(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Bwe(e, t) {
  if (e) {
    if (typeof e == "string") return LM(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return LM(e, t);
  }
}
function LM(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function oB(e, t) {
  var n = t.countries;
  t.defaultCountry;
  var r = t.metadata;
  r = new ir(r);
  for (var o = zwe(n), i; !(i = o()).done; ) {
    var a = i.value;
    if (r.country(a), r.leadingDigits()) {
      if (e && e.search(r.leadingDigits()) === 0)
        return a;
    } else if (PE({
      phone: e,
      country: a
    }, void 0, r.metadata))
      return a;
  }
}
function iB(e, t) {
  var n = t.nationalNumber, r = t.defaultCountry, o = t.metadata, i = o.getCountryCodesForCallingCode(e);
  if (i)
    return i.length === 1 ? i[0] : oB(n, {
      countries: i,
      defaultCountry: r,
      metadata: o.metadata
    });
}
var aB = "+", qwe = "[\\-\\.\\(\\)]?", jM = "([" + Lr + "]|" + qwe + ")", Uwe = "^\\" + aB + jM + "*[" + Lr + "]" + jM + "*$", Wwe = new RegExp(Uwe, "g"), YS = Lr, Hwe = "[" + YS + "]+((\\-)*[" + YS + "])*", Vwe = "a-zA-Z", Ywe = "[" + Vwe + "]+((\\-)*[" + YS + "])*", Gwe = "^(" + Hwe + "\\.)*" + Ywe + "\\.?$", Kwe = new RegExp(Gwe, "g"), FM = "tel:", GS = ";phone-context=", Xwe = ";isub=";
function Zwe(e) {
  var t = e.indexOf(GS);
  if (t < 0)
    return null;
  var n = t + GS.length;
  if (n >= e.length)
    return "";
  var r = e.indexOf(";", n);
  return r >= 0 ? e.substring(n, r) : e.substring(n);
}
function Jwe(e) {
  return e === null ? !0 : e.length === 0 ? !1 : Wwe.test(e) || Kwe.test(e);
}
function Qwe(e, t) {
  var n = t.extractFormattedPhoneNumber, r = Zwe(e);
  if (!Jwe(r))
    throw new Ia("NOT_A_NUMBER");
  var o;
  if (r === null)
    o = n(e) || "";
  else {
    o = "", r.charAt(0) === aB && (o += r);
    var i = e.indexOf(FM), a;
    i >= 0 ? a = i + FM.length : a = 0;
    var c = e.indexOf(GS);
    o += e.substring(a, c);
  }
  var l = o.indexOf(Xwe);
  if (l > 0 && (o = o.substring(0, l)), o !== "")
    return o;
}
var e2e = 250, t2e = new RegExp("[" + Fv + Lr + "]"), n2e = new RegExp("[^" + Lr + "#]+$");
function r2e(e, t, n) {
  if (t = t || {}, n = new ir(n), t.defaultCountry && !n.hasCountry(t.defaultCountry))
    throw t.v2 ? new Ia("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var r = i2e(e, t.v2, t.extract), o = r.number, i = r.ext, a = r.error;
  if (!o) {
    if (t.v2)
      throw a === "TOO_SHORT" ? new Ia("TOO_SHORT") : new Ia("NOT_A_NUMBER");
    return {};
  }
  var c = s2e(o, t.defaultCountry, t.defaultCallingCode, n), l = c.country, u = c.nationalNumber, d = c.countryCallingCode, f = c.countryCallingCodeSource, h = c.carrierCode;
  if (!n.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new Ia("INVALID_COUNTRY");
    return {};
  }
  if (!u || u.length < RE) {
    if (t.v2)
      throw new Ia("TOO_SHORT");
    return {};
  }
  if (u.length > Mxe) {
    if (t.v2)
      throw new Ia("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var v = new eB(d, u, n.metadata);
    return l && (v.country = l), h && (v.carrierCode = h), i && (v.ext = i), v.__countryCallingCodeSource = f, v;
  }
  var y = (t.extended ? n.hasSelectedNumberingPlan() : l) ? qa(u, n.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: l,
    countryCallingCode: d,
    carrierCode: h,
    valid: y,
    possible: y ? !0 : !!(t.extended === !0 && n.possibleLengths() && Xz(u, n)),
    phone: u,
    ext: i
  } : y ? a2e(l, u, i) : {};
}
function o2e(e, t, n) {
  if (e) {
    if (e.length > e2e) {
      if (n)
        throw new Ia("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var r = e.search(t2e);
    if (!(r < 0))
      return e.slice(r).replace(n2e, "");
  }
}
function i2e(e, t, n) {
  var r = Qwe(e, {
    extractFormattedPhoneNumber: function(a) {
      return o2e(a, n, t);
    }
  });
  if (!r)
    return {};
  if (!iwe(r))
    return awe(r) ? {
      error: "TOO_SHORT"
    } : {};
  var o = swe(r);
  return o.ext ? o : {
    number: r
  };
}
function a2e(e, t, n) {
  var r = {
    country: e,
    phone: t
  };
  return n && (r.ext = n), r;
}
function s2e(e, t, n, r) {
  var o = rB(kM(e), t, n, r.metadata), i = o.countryCallingCodeSource, a = o.countryCallingCode, c = o.number, l;
  if (a)
    r.selectNumberingPlan(a);
  else if (c && (t || n))
    r.selectNumberingPlan(t, n), t && (l = t), a = n || qv(t, r.metadata);
  else return {};
  if (!c)
    return {
      countryCallingCodeSource: i,
      countryCallingCode: a
    };
  var u = VS(kM(c), r), d = u.nationalNumber, f = u.carrierCode, h = iB(a, {
    nationalNumber: d,
    defaultCountry: t,
    metadata: r
  });
  return h && (l = h, h === "001" || r.country(l)), {
    country: l,
    countryCallingCode: a,
    countryCallingCodeSource: i,
    nationalNumber: d,
    carrierCode: f
  };
}
function zM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function BM(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? zM(Object(n), !0).forEach(function(r) {
      c2e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : zM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function c2e(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function l2e(e, t, n) {
  return r2e(e, BM(BM({}, t), {}, {
    v2: !0
  }), n);
}
function qM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function u2e(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? qM(Object(n), !0).forEach(function(r) {
      d2e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : qM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function d2e(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function f2e(e, t) {
  return g2e(e) || m2e(e, t) || h2e(e, t) || p2e();
}
function p2e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function h2e(e, t) {
  if (e) {
    if (typeof e == "string") return UM(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return UM(e, t);
  }
}
function UM(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function m2e(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], o = !0, i = !1, a, c;
    try {
      for (n = n.call(e); !(o = (a = n.next()).done) && (r.push(a.value), !(t && r.length === t)); o = !0)
        ;
    } catch (l) {
      i = !0, c = l;
    } finally {
      try {
        !o && n.return != null && n.return();
      } finally {
        if (i) throw c;
      }
    }
    return r;
  }
}
function g2e(e) {
  if (Array.isArray(e)) return e;
}
function v2e(e) {
  var t = Array.prototype.slice.call(e), n = f2e(t, 4), r = n[0], o = n[1], i = n[2], a = n[3], c, l, u;
  if (typeof r == "string")
    c = r;
  else throw new TypeError("A text for parsing must be a string.");
  if (!o || typeof o == "string")
    a ? (l = i, u = a) : (l = void 0, u = i), o && (l = u2e({
      defaultCountry: o
    }, l));
  else if (Sf(o))
    i ? (l = o, u = i) : u = o;
  else throw new Error("Invalid second argument: ".concat(o));
  return {
    text: c,
    options: l,
    metadata: u
  };
}
function WM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function HM(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? WM(Object(n), !0).forEach(function(r) {
      y2e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : WM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function y2e(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function b2e(e, t, n) {
  t && t.defaultCountry && !Jxe(t.defaultCountry, n) && (t = HM(HM({}, t), {}, {
    defaultCountry: void 0
  }));
  try {
    return l2e(e, t, n);
  } catch (r) {
    if (!(r instanceof Ia)) throw r;
  }
}
function VM(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function YM(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? VM(Object(n), !0).forEach(function(r) {
      x2e(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : VM(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function x2e(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function w2e() {
  var e = v2e(arguments), t = e.text, n = e.options, r = e.metadata;
  n = YM(YM({}, n), {}, {
    extract: !1
  });
  var o = b2e(t, n, r);
  return o && o.isPossible() || !1;
}
function $2e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function O2e(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function S2e(e, t, n) {
  return t && O2e(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var C2e = /* @__PURE__ */ function() {
  function e(t) {
    var n = t.onCountryChange, r = t.onCallingCodeChange;
    $2e(this, e), this.onCountryChange = n, this.onCallingCodeChange = r;
  }
  return S2e(e, [{
    key: "reset",
    value: function(n) {
      var r = n.country, o = n.callingCode;
      this.international = !1, this.missingPlus = !1, this.IDDPrefix = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(r, o);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function() {
      this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberMatchesInput = !0, this.nationalPrefix = void 0, this.carrierCode = void 0, this.complexPrefixBeforeNationalSignificantNumber = void 0;
    }
  }, {
    key: "update",
    value: function(n) {
      for (var r = 0, o = Object.keys(n); r < o.length; r++) {
        var i = o[r];
        this[i] = n[i];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function(n, r) {
      this.setCountry(n), this.setCallingCode(r);
    }
  }, {
    key: "setCountry",
    value: function(n) {
      this.country = n, this.onCountryChange(n);
    }
  }, {
    key: "setCallingCode",
    value: function(n) {
      this.callingCode = n, this.onCallingCodeChange(n, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function(n, r) {
      this.international = !0, this.initCountryAndCallingCode(n, r);
    }
  }, {
    key: "appendDigits",
    value: function(n) {
      this.digits += n;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function(n) {
      this.nationalSignificantNumber += n;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */
  }, {
    key: "getNationalDigits",
    value: function() {
      return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function() {
      return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
    }
  }]), e;
}();
function T2e(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = E2e(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function E2e(e, t) {
  if (e) {
    if (typeof e == "string") return GM(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return GM(e, t);
  }
}
function GM(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var fi = "x", D2 = new RegExp(fi);
function lg(e, t) {
  if (t < 1)
    return "";
  for (var n = ""; t > 1; )
    t & 1 && (n += e), t >>= 1, e += e;
  return n + e;
}
function KM(e, t) {
  return e[t] === ")" && t++, _2e(e.slice(0, t));
}
function _2e(e) {
  for (var t = [], n = 0; n < e.length; )
    e[n] === "(" ? t.push(n) : e[n] === ")" && t.pop(), n++;
  var r = 0, o = "";
  t.push(e.length);
  for (var i = 0, a = t; i < a.length; i++) {
    var c = a[i];
    o += e.slice(r, c), r = c + 1;
  }
  return o;
}
function k2e(e, t, n) {
  for (var r = T2e(n.split("")), o; !(o = r()).done; ) {
    var i = o.value;
    if (e.slice(t + 1).search(D2) < 0)
      return;
    t = e.search(D2), e = e.replace(D2, i);
  }
  return [e, t];
}
function R2e(e, t, n) {
  var r = n.metadata, o = n.shouldTryNationalPrefixFormattingRule, i = n.getSeparatorAfterNationalPrefix, a = new RegExp("^(?:".concat(t.pattern(), ")$"));
  if (a.test(e.nationalSignificantNumber))
    return A2e(e, t, {
      metadata: r,
      shouldTryNationalPrefixFormattingRule: o,
      getSeparatorAfterNationalPrefix: i
    });
}
function P2e(e, t) {
  return Uv(e, t) === "IS_POSSIBLE";
}
function A2e(e, t, n) {
  var r = n.metadata, o = n.shouldTryNationalPrefixFormattingRule, i = n.getSeparatorAfterNationalPrefix;
  if (e.nationalSignificantNumber, e.international, e.nationalPrefix, e.carrierCode, o(t)) {
    var a = XM(e, t, {
      useNationalPrefixFormattingRule: !0,
      getSeparatorAfterNationalPrefix: i,
      metadata: r
    });
    if (a)
      return a;
  }
  return XM(e, t, {
    useNationalPrefixFormattingRule: !1,
    getSeparatorAfterNationalPrefix: i,
    metadata: r
  });
}
function XM(e, t, n) {
  var r = n.metadata, o = n.useNationalPrefixFormattingRule, i = n.getSeparatorAfterNationalPrefix, a = Qz(e.nationalSignificantNumber, t, {
    carrierCode: e.carrierCode,
    useInternationalFormat: e.international,
    withNationalPrefix: o,
    metadata: r
  });
  if (o || (e.nationalPrefix ? a = e.nationalPrefix + i(t) + a : e.complexPrefixBeforeNationalSignificantNumber && (a = e.complexPrefixBeforeNationalSignificantNumber + " " + a)), I2e(a, e))
    return a;
}
function I2e(e, t) {
  return o0(e) === t.getNationalDigits();
}
function M2e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function N2e(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function D2e(e, t, n) {
  return t && N2e(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var L2e = /* @__PURE__ */ function() {
  function e() {
    M2e(this, e);
  }
  return D2e(e, [{
    key: "parse",
    value: function(n) {
      if (this.context = [{
        or: !0,
        instructions: []
      }], this.parsePattern(n), this.context.length !== 1)
        throw new Error("Non-finalized contexts left when pattern parse ended");
      var r = this.context[0], o = r.branches, i = r.instructions;
      if (o)
        return {
          op: "|",
          args: o.concat([L2(i)])
        };
      if (i.length === 0)
        throw new Error("Pattern is required");
      return i.length === 1 ? i[0] : i;
    }
  }, {
    key: "startContext",
    value: function(n) {
      this.context.push(n);
    }
  }, {
    key: "endContext",
    value: function() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function(n) {
      if (!n)
        throw new Error("Pattern is required");
      var r = n.match(z2e);
      if (!r) {
        if (F2e.test(n))
          throw new Error("Illegal characters found in a pattern: ".concat(n));
        this.getContext().instructions = this.getContext().instructions.concat(n.split(""));
        return;
      }
      var o = r[1], i = n.slice(0, r.index), a = n.slice(r.index + o.length);
      switch (o) {
        case "(?:":
          i && this.parsePattern(i), this.startContext({
            or: !0,
            instructions: [],
            branches: []
          });
          break;
        case ")":
          if (!this.getContext().or)
            throw new Error('")" operator must be preceded by "(?:" operator');
          if (i && this.parsePattern(i), this.getContext().instructions.length === 0)
            throw new Error('No instructions found after "|" operator in an "or" group');
          var c = this.getContext(), l = c.branches;
          l.push(L2(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
            op: "|",
            args: l
          });
          break;
        case "|":
          if (!this.getContext().or)
            throw new Error('"|" operator can only be used inside "or" groups');
          if (i && this.parsePattern(i), !this.getContext().branches)
            if (this.context.length === 1)
              this.getContext().branches = [];
            else
              throw new Error('"branches" not found in an "or" group context');
          this.getContext().branches.push(L2(this.getContext().instructions)), this.getContext().instructions = [];
          break;
        case "[":
          i && this.parsePattern(i), this.startContext({
            oneOfSet: !0
          });
          break;
        case "]":
          if (!this.getContext().oneOfSet)
            throw new Error('"]" operator must be preceded by "[" operator');
          this.endContext(), this.getContext().instructions.push({
            op: "[]",
            args: j2e(i)
          });
          break;
        /* istanbul ignore next */
        default:
          throw new Error("Unknown operator: ".concat(o));
      }
      a && this.parsePattern(a);
    }
  }]), e;
}();
function j2e(e) {
  for (var t = [], n = 0; n < e.length; ) {
    if (e[n] === "-") {
      if (n === 0 || n === e.length - 1)
        throw new Error("Couldn't parse a one-of set pattern: ".concat(e));
      for (var r = e[n - 1].charCodeAt(0) + 1, o = e[n + 1].charCodeAt(0) - 1, i = r; i <= o; )
        t.push(String.fromCharCode(i)), i++;
    } else
      t.push(e[n]);
    n++;
  }
  return t;
}
var F2e = /[\(\)\[\]\?\:\|]/, z2e = new RegExp(
  // any of:
  "(\\||\\(\\?\\:|\\)|\\[|\\])"
);
function L2(e) {
  return e.length === 1 ? e[0] : e;
}
function ZM(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = B2e(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function B2e(e, t) {
  if (e) {
    if (typeof e == "string") return JM(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return JM(e, t);
  }
}
function JM(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function q2e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function U2e(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function W2e(e, t, n) {
  return t && U2e(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var H2e = /* @__PURE__ */ function() {
  function e(t) {
    q2e(this, e), this.matchTree = new L2e().parse(t);
  }
  return W2e(e, [{
    key: "match",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = r.allowOverflow;
      if (!n)
        throw new Error("String is required");
      var i = KS(n.split(""), this.matchTree, !0);
      if (i && i.match && delete i.matchedChars, !(i && i.overflow && !o))
        return i;
    }
  }]), e;
}();
function KS(e, t, n) {
  if (typeof t == "string") {
    var r = e.join("");
    return t.indexOf(r) === 0 ? e.length === t.length ? {
      match: !0,
      matchedChars: e
    } : {
      partialMatch: !0
      // matchedChars: characters
    } : r.indexOf(t) === 0 ? n && e.length > t.length ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, t.length)
    } : void 0;
  }
  if (Array.isArray(t)) {
    for (var o = e.slice(), i = 0; i < t.length; ) {
      var a = t[i], c = KS(o, a, n && i === t.length - 1);
      if (c) {
        if (c.overflow)
          return c;
        if (c.match) {
          if (o = o.slice(c.matchedChars.length), o.length === 0)
            return i === t.length - 1 ? {
              match: !0,
              matchedChars: e
            } : {
              partialMatch: !0
              // matchedChars: characters
            };
        } else {
          if (c.partialMatch)
            return {
              partialMatch: !0
              // matchedChars: characters
            };
          throw new Error(`Unsupported match result:
`.concat(JSON.stringify(c, null, 2)));
        }
      } else return;
      i++;
    }
    return n ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, e.length - o.length)
    };
  }
  switch (t.op) {
    case "|":
      for (var l, u = ZM(t.args), d; !(d = u()).done; ) {
        var f = d.value, h = KS(e, f, n);
        if (h) {
          if (h.overflow)
            return h;
          if (h.match)
            return {
              match: !0,
              matchedChars: h.matchedChars
            };
          if (h.partialMatch)
            l = !0;
          else
            throw new Error(`Unsupported match result:
`.concat(JSON.stringify(h, null, 2)));
        }
      }
      return l ? {
        partialMatch: !0
        // matchedChars: ...
      } : void 0;
    case "[]":
      for (var v = ZM(t.args), y; !(y = v()).done; ) {
        var g = y.value;
        if (e[0] === g)
          return e.length === 1 ? {
            match: !0,
            matchedChars: e
          } : n ? {
            overflow: !0
          } : {
            match: !0,
            matchedChars: [g]
          };
      }
      return;
    /* istanbul ignore next */
    default:
      throw new Error("Unsupported instruction tree: ".concat(t));
  }
}
function QM(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = V2e(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function V2e(e, t) {
  if (e) {
    if (typeof e == "string") return eN(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return eN(e, t);
  }
}
function eN(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Y2e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function G2e(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function K2e(e, t, n) {
  return t && G2e(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var XS = "9", X2e = 15, Z2e = lg(XS, X2e), J2e = /[- ]/, Q2e = function() {
  return /\[([^\[\]])*\]/g;
}, e$e = function() {
  return /\d(?=[^,}][^,}])/g;
}, t$e = new RegExp("[" + vi + "]*\\$1[" + vi + "]*(\\$\\d[" + vi + "]*)*$"), tN = 3, n$e = /* @__PURE__ */ function() {
  function e(t) {
    t.state;
    var n = t.metadata;
    Y2e(this, e), this.metadata = n, this.resetFormat();
  }
  return K2e(e, [{
    key: "resetFormat",
    value: function() {
      this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function(n, r) {
      this.resetFormat(), n ? (this.isNANP = n.callingCode() === "1", this.matchingFormats = n.formats(), r.nationalSignificantNumber && this.narrowDownMatchingFormats(r)) : (this.isNANP = void 0, this.matchingFormats = []);
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */
  }, {
    key: "format",
    value: function(n, r) {
      var o = this;
      if (P2e(r.nationalSignificantNumber, this.metadata))
        for (var i = QM(this.matchingFormats), a; !(a = i()).done; ) {
          var c = a.value, l = R2e(r, c, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function(d) {
              return o.shouldTryNationalPrefixFormattingRule(d, {
                international: r.international,
                nationalPrefix: r.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function(d) {
              return o.getSeparatorAfterNationalPrefix(d);
            }
          });
          if (l)
            return this.resetFormat(), this.chosenFormat = c, this.setNationalNumberTemplate(l.replace(/\d/g, fi), r), this.populatedNationalNumberTemplate = l, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(fi), l;
        }
      return this.formatNationalNumberWithNextDigits(n, r);
    }
    // Formats the next phone number digits.
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function(n, r) {
      var o = this.chosenFormat, i = this.chooseFormat(r);
      if (i)
        return i === o ? this.formatNextNationalNumberDigits(n) : this.formatNextNationalNumberDigits(r.getNationalDigits());
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function(n) {
      var r = this, o = n.nationalSignificantNumber, i = n.nationalPrefix, a = n.international, c = o, l = c.length - tN;
      l < 0 && (l = 0), this.matchingFormats = this.matchingFormats.filter(function(u) {
        return r.formatSuits(u, a, i) && r.formatMatches(u, c, l);
      }), this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1 && this.resetFormat();
    }
  }, {
    key: "formatSuits",
    value: function(n, r, o) {
      return !(o && !n.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !n.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !r && !o && n.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
    }
  }, {
    key: "formatMatches",
    value: function(n, r, o) {
      var i = n.leadingDigitsPatterns().length;
      if (i === 0)
        return !0;
      o = Math.min(o, i - 1);
      var a = n.leadingDigitsPatterns()[o];
      if (r.length < tN)
        try {
          return new H2e(a).match(r, {
            allowOverflow: !0
          }) !== void 0;
        } catch (c) {
          return console.error(c), !0;
        }
      return new RegExp("^(".concat(a, ")")).test(r);
    }
  }, {
    key: "getFormatFormat",
    value: function(n, r) {
      return r ? n.internationalFormat() : n.format();
    }
  }, {
    key: "chooseFormat",
    value: function(n) {
      for (var r = this, o = function() {
        var u = a.value;
        return r.chosenFormat === u ? "break" : t$e.test(r.getFormatFormat(u, n.international)) ? r.createTemplateForFormat(u, n) ? (r.chosenFormat = u, "break") : (r.matchingFormats = r.matchingFormats.filter(function(d) {
          return d !== u;
        }), "continue") : "continue";
      }, i = QM(this.matchingFormats.slice()), a; !(a = i()).done; ) {
        var c = o();
        if (c === "break") break;
      }
      return this.chosenFormat || this.resetFormat(), this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function(n, r) {
      if (!(n.pattern().indexOf("|") >= 0)) {
        var o = this.getTemplateForFormat(n, r);
        if (o)
          return this.setNationalNumberTemplate(o, r), !0;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function(n) {
      return this.isNANP || n && n.nationalPrefixFormattingRule() && J2e.test(n.nationalPrefixFormattingRule()) ? " " : "";
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function(n, r) {
      var o = n.IDDPrefix, i = n.missingPlus;
      return o ? r && r.spacing === !1 ? o : o + " " : i ? "" : "+";
    }
  }, {
    key: "getTemplate",
    value: function(n) {
      if (this.template) {
        for (var r = -1, o = 0, i = n.international ? this.getInternationalPrefixBeforeCountryCallingCode(n, {
          spacing: !1
        }) : ""; o < i.length + n.getDigitsWithoutInternationalPrefix().length; )
          r = this.template.indexOf(fi, r + 1), o++;
        return KM(this.template, r + 1);
      }
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function(n, r) {
      this.nationalNumberTemplate = n, this.populatedNationalNumberTemplate = n, this.populatedNationalNumberTemplatePosition = -1, r.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(r).replace(/[\d\+]/g, fi) + lg(fi, r.callingCode.length) + " " + n : this.template = n;
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */
  }, {
    key: "getTemplateForFormat",
    value: function(n, r) {
      var o = r.nationalSignificantNumber, i = r.international, a = r.nationalPrefix, c = r.complexPrefixBeforeNationalSignificantNumber, l = n.pattern();
      l = l.replace(Q2e(), "\\d").replace(e$e(), "\\d");
      var u = Z2e.match(l)[0];
      if (!(o.length > u.length)) {
        var d = new RegExp("^" + l + "$"), f = o.replace(/\d/g, XS);
        d.test(f) && (u = f);
        var h = this.getFormatFormat(n, i), v;
        if (this.shouldTryNationalPrefixFormattingRule(n, {
          international: i,
          nationalPrefix: a
        })) {
          var y = h.replace(Jz, n.nationalPrefixFormattingRule());
          if (o0(n.nationalPrefixFormattingRule()) === (a || "") + o0("$1") && (h = y, v = !0, a))
            for (var g = a.length; g > 0; )
              h = h.replace(/\d/, fi), g--;
        }
        var b = u.replace(new RegExp(l), h).replace(new RegExp(XS, "g"), fi);
        return v || (c ? b = lg(fi, c.length) + " " + b : a && (b = lg(fi, a.length) + this.getSeparatorAfterNationalPrefix(n) + b)), i && (b = Zz(b)), b;
      }
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function(n) {
      var r = k2e(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, n);
      if (!r) {
        this.resetFormat();
        return;
      }
      return this.populatedNationalNumberTemplate = r[0], this.populatedNationalNumberTemplatePosition = r[1], KM(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function(n, r) {
      var o = r.international, i = r.nationalPrefix;
      if (n.nationalPrefixFormattingRule()) {
        var a = n.usesNationalPrefix();
        if (a && i || !a && !o)
          return !0;
      }
    }
  }]), e;
}();
function sB(e, t) {
  return a$e(e) || i$e(e, t) || o$e(e, t) || r$e();
}
function r$e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function o$e(e, t) {
  if (e) {
    if (typeof e == "string") return nN(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return nN(e, t);
  }
}
function nN(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function i$e(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], o = !0, i = !1, a, c;
    try {
      for (n = n.call(e); !(o = (a = n.next()).done) && (r.push(a.value), !(t && r.length === t)); o = !0)
        ;
    } catch (l) {
      i = !0, c = l;
    } finally {
      try {
        !o && n.return != null && n.return();
      } finally {
        if (i) throw c;
      }
    }
    return r;
  }
}
function a$e(e) {
  if (Array.isArray(e)) return e;
}
function s$e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function c$e(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function l$e(e, t, n) {
  return t && c$e(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var u$e = "[" + vi + Lr + "]+", d$e = new RegExp("^" + u$e + "$", "i"), f$e = "(?:[" + Fv + "][" + vi + Lr + "]*|[" + vi + Lr + "]+)", p$e = new RegExp("[^" + vi + Lr + "]+.*$"), h$e = /[^\d\[\]]/, m$e = /* @__PURE__ */ function() {
  function e(t) {
    var n = t.defaultCountry, r = t.defaultCallingCode, o = t.metadata, i = t.onNationalSignificantNumberChange;
    s$e(this, e), this.defaultCountry = n, this.defaultCallingCode = r, this.metadata = o, this.onNationalSignificantNumberChange = i;
  }
  return l$e(e, [{
    key: "input",
    value: function(n, r) {
      var o = y$e(n), i = sB(o, 2), a = i[0], c = i[1], l = o0(a), u;
      return c && (r.digits || (r.startInternationalNumber(), l || (u = !0))), l && this.inputDigits(l, r), {
        digits: l,
        justLeadingPlus: u
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */
  }, {
    key: "inputDigits",
    value: function(n, r) {
      var o = r.digits, i = o.length < 3 && o.length + n.length >= 3;
      if (r.appendDigits(n), i && this.extractIddPrefix(r), this.isWaitingForCountryCallingCode(r)) {
        if (!this.extractCountryCallingCode(r))
          return;
      } else
        r.appendNationalSignificantNumberDigits(n);
      r.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(r.getNationalDigits(), function(a) {
        return r.update(a);
      });
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function(n) {
      var r = n.international, o = n.callingCode;
      return r && !o;
    }
    // Extracts a country calling code from a number
    // being entered in internatonal format.
  }, {
    key: "extractCountryCallingCode",
    value: function(n) {
      var r = rB("+" + n.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), o = r.countryCallingCode, i = r.number;
      if (o)
        return n.setCallingCode(o), n.update({
          nationalSignificantNumber: i
        }), !0;
    }
  }, {
    key: "reset",
    value: function(n) {
      if (n) {
        this.hasSelectedNumberingPlan = !0;
        var r = n._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = r && h$e.test(r);
      } else
        this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */
  }, {
    key: "extractNationalSignificantNumber",
    value: function(n, r) {
      if (this.hasSelectedNumberingPlan) {
        var o = HS(n, this.metadata), i = o.nationalPrefix, a = o.nationalNumber, c = o.carrierCode;
        if (a !== n)
          return this.onExtractedNationalNumber(i, c, a, n, r), !0;
      }
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function(n, r, o) {
      if (!this.hasExtractedNationalSignificantNumber)
        return this.extractNationalSignificantNumber(n, o);
      if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        var i = HS(n, this.metadata), a = i.nationalPrefix, c = i.nationalNumber, l = i.carrierCode;
        if (c !== r)
          return this.onExtractedNationalNumber(a, l, c, n, o), !0;
      }
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function(n, r, o, i, a) {
      var c, l, u = i.lastIndexOf(o);
      if (u >= 0 && u === i.length - o.length) {
        l = !0;
        var d = i.slice(0, u);
        d !== n && (c = d);
      }
      a({
        nationalPrefix: n,
        carrierCode: r,
        nationalSignificantNumber: o,
        nationalSignificantNumberMatchesInput: l,
        complexPrefixBeforeNationalSignificantNumber: c
      }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function(n) {
      if (this.extractAnotherNationalSignificantNumber(n.getNationalDigits(), n.nationalSignificantNumber, function(r) {
        return n.update(r);
      }))
        return !0;
      if (this.extractIddPrefix(n))
        return this.extractCallingCodeAndNationalSignificantNumber(n), !0;
      if (this.fixMissingPlus(n))
        return this.extractCallingCodeAndNationalSignificantNumber(n), !0;
    }
  }, {
    key: "extractIddPrefix",
    value: function(n) {
      var r = n.international, o = n.IDDPrefix, i = n.digits;
      if (n.nationalSignificantNumber, !(r || o)) {
        var a = tB(i, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
        if (a !== void 0 && a !== i)
          return n.update({
            IDDPrefix: i.slice(0, i.length - a.length)
          }), this.startInternationalNumber(n, {
            country: void 0,
            callingCode: void 0
          }), !0;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function(n) {
      if (!n.international) {
        var r = nB(n.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), o = r.countryCallingCode;
        if (r.number, o)
          return n.update({
            missingPlus: !0
          }), this.startInternationalNumber(n, {
            country: n.country,
            callingCode: o
          }), !0;
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function(n, r) {
      var o = r.country, i = r.callingCode;
      n.startInternationalNumber(o, i), n.nationalSignificantNumber && (n.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function(n) {
      this.extractCountryCallingCode(n) && this.extractNationalSignificantNumber(n.getNationalDigits(), function(r) {
        return n.update(r);
      });
    }
  }]), e;
}();
function g$e(e) {
  var t = e.search(f$e);
  if (!(t < 0)) {
    e = e.slice(t);
    var n;
    return e[0] === "+" && (n = !0, e = e.slice(1)), e = e.replace(p$e, ""), n && (e = "+" + e), e;
  }
}
function v$e(e) {
  var t = g$e(e) || "";
  return t[0] === "+" ? [t.slice(1), !0] : [t];
}
function y$e(e) {
  var t = v$e(e), n = sB(t, 2), r = n[0], o = n[1];
  return d$e.test(r) || (r = ""), [r, o];
}
function b$e(e, t) {
  return O$e(e) || $$e(e, t) || w$e(e, t) || x$e();
}
function x$e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function w$e(e, t) {
  if (e) {
    if (typeof e == "string") return rN(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return rN(e, t);
  }
}
function rN(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function $$e(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], o = !0, i = !1, a, c;
    try {
      for (n = n.call(e); !(o = (a = n.next()).done) && (r.push(a.value), !(t && r.length === t)); o = !0)
        ;
    } catch (l) {
      i = !0, c = l;
    } finally {
      try {
        !o && n.return != null && n.return();
      } finally {
        if (i) throw c;
      }
    }
    return r;
  }
}
function O$e(e) {
  if (Array.isArray(e)) return e;
}
function S$e(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function C$e(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function T$e(e, t, n) {
  return t && C$e(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var cB = /* @__PURE__ */ function() {
  function e(t, n) {
    S$e(this, e), this.metadata = new ir(n);
    var r = this.getCountryAndCallingCode(t), o = b$e(r, 2), i = o[0], a = o[1];
    this.defaultCountry = i, this.defaultCallingCode = a, this.reset();
  }
  return T$e(e, [{
    key: "getCountryAndCallingCode",
    value: function(n) {
      var r, o;
      return n && (Sf(n) ? (r = n.defaultCountry, o = n.defaultCallingCode) : r = n), r && !this.metadata.hasCountry(r) && (r = void 0), [r, o];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */
  }, {
    key: "input",
    value: function(n) {
      var r = this.parser.input(n, this.state), o = r.digits, i = r.justLeadingPlus;
      if (i)
        this.formattedOutput = "+";
      else if (o) {
        this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state);
        var a;
        if (this.metadata.hasSelectedNumberingPlan() && (a = this.formatter.format(o, this.state)), a === void 0 && this.parser.reExtractNationalSignificantNumber(this.state)) {
          this.determineTheCountryIfNeeded();
          var c = this.state.getNationalDigits();
          c && (a = this.formatter.format(c, this.state));
        }
        this.formattedOutput = a ? this.getFullNumber(a) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function() {
      var n = this;
      return this.state = new C2e({
        onCountryChange: function(o) {
          n.country = o;
        },
        onCallingCodeChange: function(o, i) {
          n.metadata.selectNumberingPlan(i, o), n.formatter.reset(n.metadata.numberingPlan, n.state), n.parser.reset(n.metadata.numberingPlan);
        }
      }), this.formatter = new n$e({
        state: this.state,
        metadata: this.metadata
      }), this.parser = new m$e({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function() {
          n.determineTheCountryIfNeeded(), n.formatter.reset(n.metadata.numberingPlan, n.state);
        }
      }), this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      }), this.formattedOutput = "", this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */
  }, {
    key: "isInternational",
    value: function() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */
  }, {
    key: "getCallingCode",
    value: function() {
      if (this.isInternational())
        return this.state.callingCode;
    }
    // A legacy alias.
  }, {
    key: "getCountryCallingCode",
    value: function() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */
  }, {
    key: "getCountry",
    value: function() {
      var n = this.state.digits;
      if (n)
        return this._getCountry();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */
  }, {
    key: "_getCountry",
    value: function() {
      var n = this.state.country;
      return n;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function() {
      (!this.state.country || this.isCountryCallingCodeAmbiguous()) && this.determineTheCountry();
    }
    // Prepends `+CountryCode ` in case of an international phone number
  }, {
    key: "getFullNumber",
    value: function(n) {
      var r = this;
      if (this.isInternational()) {
        var o = function(c) {
          return r.formatter.getInternationalPrefixBeforeCountryCallingCode(r.state, {
            spacing: !!c
          }) + c;
        }, i = this.state.callingCode;
        return o(i ? n ? "".concat(i, " ").concat(n) : i : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
      }
      return n;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function() {
      var n = this.state, r = n.nationalSignificantNumber, o = n.complexPrefixBeforeNationalSignificantNumber, i = n.nationalPrefix, a = r, c = o || i;
      return c && (a = c + a), a;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function() {
      var n = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(n ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function() {
      var n = this.getNonFormattedNumber();
      if (n)
        return n.replace(/[\+\d]/g, fi);
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function() {
      var n = this.state.callingCode, r = this.metadata.getCountryCodesForCallingCode(n);
      return r && r.length > 1;
    }
    // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.
  }, {
    key: "determineTheCountry",
    value: function() {
      this.state.setCountry(iB(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        defaultCountry: this.defaultCountry,
        metadata: this.metadata
      }));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */
  }, {
    key: "getNumberValue",
    value: function() {
      var n = this.state, r = n.digits, o = n.callingCode, i = n.country, a = n.nationalSignificantNumber;
      if (r) {
        if (this.isInternational())
          return o ? "+" + o + a : "+" + r;
        if (i || o) {
          var c = i ? this.metadata.countryCallingCode() : o;
          return "+" + c + a;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */
  }, {
    key: "getNumber",
    value: function() {
      var n = this.state, r = n.nationalSignificantNumber, o = n.carrierCode, i = n.callingCode, a = this._getCountry();
      if (r && !(!a && !i)) {
        if (a && a === this.defaultCountry) {
          var c = new ir(this.metadata.metadata);
          c.selectNumberingPlan(a);
          var l = c.numberingPlan.callingCode(), u = this.metadata.getCountryCodesForCallingCode(l);
          if (u.length > 1) {
            var d = oB(r, {
              countries: u,
              defaultCountry: this.defaultCountry,
              metadata: this.metadata.metadata
            });
            d && (a = d);
          }
        }
        var f = new eB(a || i, r, this.metadata.metadata);
        return o && (f.carrierCode = o), f;
      }
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */
  }, {
    key: "isPossible",
    value: function() {
      var n = this.getNumber();
      return n ? n.isPossible() : !1;
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    value: function() {
      var n = this.getNumber();
      return n ? n.isValid() : !1;
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */
  }, {
    key: "getNationalNumber",
    value: function() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */
  }, {
    key: "getChars",
    value: function() {
      return (this.state.international ? "+" : "") + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */
  }, {
    key: "getTemplate",
    value: function() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }
  }]), e;
}();
function E$e(e) {
  return new ir(e).getCountries();
}
function m9e() {
  return kE(w2e, arguments);
}
function ZS(e) {
  return cB.call(this, e, Wz);
}
ZS.prototype = Object.create(cB.prototype, {});
ZS.prototype.constructor = ZS;
function g9e() {
  return kE(E$e, arguments);
}
function v9e() {
  return kE(qv, arguments);
}
function As(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function oN(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function _$e(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const i = oN(o, t);
      return !n && typeof i == "function" && (n = !0), i;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const i = r[o];
          typeof i == "function" ? i() : oN(e[o], null);
        }
      };
  };
}
function sl(...e) {
  return E.useCallback(_$e(...e), e);
}
function k$e(e, t = []) {
  let n = [];
  function r(i, a) {
    const c = E.createContext(a);
    c.displayName = i + "Context";
    const l = n.length;
    n = [...n, a];
    const u = (f) => {
      var x;
      const { scope: h, children: v, ...y } = f, g = ((x = h == null ? void 0 : h[e]) == null ? void 0 : x[l]) || c, b = E.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ F.jsx(g.Provider, { value: b, children: v });
    };
    u.displayName = i + "Provider";
    function d(f, h) {
      var g;
      const v = ((g = h == null ? void 0 : h[e]) == null ? void 0 : g[l]) || c, y = E.useContext(v);
      if (y) return y;
      if (a !== void 0) return a;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return [u, d];
  }
  const o = () => {
    const i = n.map((a) => E.createContext(a));
    return function(c) {
      const l = (c == null ? void 0 : c[e]) || i;
      return E.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: l } }),
        [c, l]
      );
    };
  };
  return o.scopeName = e, [r, R$e(o, ...t)];
}
function R$e(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const a = r.reduce((c, { useScope: l, scopeName: u }) => {
        const f = l(i)[`__scope${u}`];
        return { ...c, ...f };
      }, {});
      return E.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var np = globalThis != null && globalThis.document ? E.useLayoutEffect : () => {
}, P$e = E[" useId ".trim().toString()] || (() => {
}), A$e = 0;
function j2(e) {
  const [t, n] = E.useState(P$e());
  return np(() => {
    e || n((r) => r ?? String(A$e++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var I$e = E[" useInsertionEffect ".trim().toString()] || np;
function M$e({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [o, i, a] = N$e({
    defaultProp: t,
    onChange: n
  }), c = e !== void 0, l = c ? e : o;
  {
    const d = E.useRef(e !== void 0);
    E.useEffect(() => {
      const f = d.current;
      f !== c && console.warn(
        `${r} is changing from ${f ? "controlled" : "uncontrolled"} to ${c ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), d.current = c;
    }, [c, r]);
  }
  const u = E.useCallback(
    (d) => {
      var f;
      if (c) {
        const h = D$e(d) ? d(e) : d;
        h !== e && ((f = a.current) == null || f.call(a, h));
      } else
        i(d);
    },
    [c, e, i, a]
  );
  return [l, u];
}
function N$e({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = E.useState(e), o = E.useRef(n), i = E.useRef(t);
  return I$e(() => {
    i.current = t;
  }, [t]), E.useEffect(() => {
    var a;
    o.current !== n && ((a = i.current) == null || a.call(i, n), o.current = n);
  }, [n, o]), [n, r, i];
}
function D$e(e) {
  return typeof e == "function";
}
// @__NO_SIDE_EFFECTS__
function lB(e) {
  const t = E.forwardRef((n, r) => {
    let { children: o, ...i } = n, a = null, c = !1;
    const l = [];
    iN(o) && typeof bm == "function" && (o = bm(o._payload)), E.Children.forEach(o, (h) => {
      var v;
      if (B$e(h)) {
        c = !0;
        const y = h;
        let g = "child" in y.props ? y.props.child : y.props.children;
        iN(g) && typeof bm == "function" && (g = bm(g._payload)), a = j$e(y, g), l.push((v = a == null ? void 0 : a.props) == null ? void 0 : v.children);
      } else
        l.push(h);
    }), a ? a = E.cloneElement(a, void 0, l) : (
      // A `Slottable` was found but it didn't resolve to a single element (e.g.
      // it wrapped multiple elements, text, or a render-prop `child` that
      // wasn't an element). Don't fall back to treating the `Slottable` wrapper
      // itself as the slot target — throw a descriptive error below instead.
      !c && E.Children.count(o) === 1 && E.isValidElement(o) && (a = o)
    );
    const u = a ? z$e(a) : void 0, d = sl(r, u);
    if (!a) {
      if (o || o === 0)
        throw new Error(
          c ? H$e(e) : W$e(e)
        );
      return o;
    }
    const f = F$e(i, a.props ?? {});
    return a.type !== E.Fragment && (f.ref = r ? d : u), E.cloneElement(a, f);
  });
  return t.displayName = `${e}.Slot`, t;
}
var L$e = Symbol.for("radix.slottable"), j$e = (e, t) => {
  if ("child" in e.props) {
    const n = e.props.child;
    return E.isValidElement(n) ? E.cloneElement(n, void 0, e.props.children(n.props.children)) : null;
  }
  return E.isValidElement(t) ? t : null;
};
function F$e(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...c) => {
      const l = i(...c);
      return o(...c), l;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function z$e(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function B$e(e) {
  return E.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === L$e;
}
var q$e = Symbol.for("react.lazy");
function iN(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === q$e && "_payload" in e && U$e(e._payload);
}
function U$e(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
var W$e = (e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, H$e = (e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, bm = E[" use ".trim().toString()], V$e = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Qa = V$e.reduce((e, t) => {
  const n = /* @__PURE__ */ lB(`Primitive.${t}`), r = E.forwardRef((o, i) => {
    const { asChild: a, ...c } = o, l = a ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ F.jsx(l, { ...c, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function Y$e(e, t) {
  e && nl.flushSync(() => e.dispatchEvent(t));
}
function rp(e) {
  const t = E.useRef(e);
  return E.useEffect(() => {
    t.current = e;
  }), E.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function G$e(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = rp(e);
  E.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var K$e = "DismissableLayer", JS = "dismissableLayer.update", X$e = "dismissableLayer.pointerDownOutside", Z$e = "dismissableLayer.focusOutside", aN, AE = E.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set(),
  // Outside elements that belong to a layer's own dismiss affordance (eg, a
  // dialog overlay). Pressing them should dismiss the layer regardless of
  // whether or not they stop propagation.
  //
  // See https://github.com/radix-ui/primitives/issues/3346
  dismissableSurfaces: /* @__PURE__ */ new Set()
}), uB = E.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      deferPointerDownOutside: r = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: i,
      onFocusOutside: a,
      onInteractOutside: c,
      onDismiss: l,
      ...u
    } = e, d = E.useContext(AE), [f, h] = E.useState(null), v = (f == null ? void 0 : f.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, y] = E.useState({}), g = sl(t, (P) => h(P)), b = Array.from(d.layers), [x] = [...d.layersWithOutsidePointerEventsDisabled].slice(-1), $ = b.indexOf(x), S = f ? b.indexOf(f) : -1, O = d.layersWithOutsidePointerEventsDisabled.size > 0, C = S >= $, T = E.useRef(!1), k = tOe(
      (P) => {
        const _ = P.target;
        if (!(_ instanceof Node))
          return;
        const A = [...d.branches].some(
          (D) => D.contains(_)
        );
        !C || A || (i == null || i(P), c == null || c(P), P.defaultPrevented || l == null || l());
      },
      {
        ownerDocument: v,
        deferPointerDownOutside: r,
        isDeferredPointerDownOutsideRef: T,
        dismissableSurfaces: d.dismissableSurfaces
      }
    ), I = nOe((P) => {
      if (r && T.current)
        return;
      const _ = P.target;
      [...d.branches].some((D) => D.contains(_)) || (a == null || a(P), c == null || c(P), P.defaultPrevented || l == null || l());
    }, v);
    return G$e((P) => {
      S === d.layers.size - 1 && (o == null || o(P), !P.defaultPrevented && l && (P.preventDefault(), l()));
    }, v), E.useEffect(() => {
      if (f)
        return n && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (aN = v.body.style.pointerEvents, v.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(f)), d.layers.add(f), sN(), () => {
          n && (d.layersWithOutsidePointerEventsDisabled.delete(f), d.layersWithOutsidePointerEventsDisabled.size === 0 && (v.body.style.pointerEvents = aN));
        };
    }, [f, v, n, d]), E.useEffect(() => () => {
      f && (d.layers.delete(f), d.layersWithOutsidePointerEventsDisabled.delete(f), sN());
    }, [f, d]), E.useEffect(() => {
      const P = () => y({});
      return document.addEventListener(JS, P), () => document.removeEventListener(JS, P);
    }, []), /* @__PURE__ */ F.jsx(
      Qa.div,
      {
        ...u,
        ref: g,
        style: {
          pointerEvents: O ? C ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: As(e.onFocusCapture, I.onFocusCapture),
        onBlurCapture: As(e.onBlurCapture, I.onBlurCapture),
        onPointerDownCapture: As(
          e.onPointerDownCapture,
          k.onPointerDownCapture
        )
      }
    );
  }
);
uB.displayName = K$e;
var J$e = "DismissableLayerBranch", Q$e = E.forwardRef((e, t) => {
  const n = E.useContext(AE), r = E.useRef(null), o = sl(t, r);
  return E.useEffect(() => {
    const i = r.current;
    if (i)
      return n.branches.add(i), () => {
        n.branches.delete(i);
      };
  }, [n.branches]), /* @__PURE__ */ F.jsx(Qa.div, { ...e, ref: o });
});
Q$e.displayName = J$e;
function eOe() {
  const e = E.useContext(AE), [t, n] = E.useState(null);
  return E.useEffect(() => {
    if (t)
      return e.dismissableSurfaces.add(t), () => {
        e.dismissableSurfaces.delete(t);
      };
  }, [t, e.dismissableSurfaces]), n;
}
function tOe(e, t) {
  const {
    ownerDocument: n = globalThis == null ? void 0 : globalThis.document,
    deferPointerDownOutside: r = !1,
    isDeferredPointerDownOutsideRef: o,
    dismissableSurfaces: i
  } = t, a = rp(e), c = E.useRef(!1), l = E.useRef(!1), u = E.useRef(/* @__PURE__ */ new Map()), d = E.useRef(() => {
  });
  return E.useEffect(() => {
    function f() {
      l.current = !1, o.current = !1, u.current.clear();
    }
    function h() {
      return Array.from(u.current.values()).some(Boolean);
    }
    function v($) {
      if (!l.current)
        return;
      const S = $.target;
      S instanceof Node && [...i].some((C) => C.contains(S)) || u.current.set($.type, !0), $.type === "click" && window.setTimeout(() => {
        l.current && d.current();
      }, 0);
    }
    function y($) {
      l.current && u.current.set($.type, !1);
    }
    const g = ($) => {
      if ($.target && !c.current) {
        let S = function() {
          n.removeEventListener("click", d.current);
          const C = h();
          f(), C || dB(
            X$e,
            a,
            O,
            { discrete: !0 }
          );
        };
        const O = { originalEvent: $ };
        l.current = !0, o.current = r && $.button === 0, u.current.clear(), !r || $.button !== 0 ? S() : (n.removeEventListener("click", d.current), d.current = S, n.addEventListener("click", d.current, { once: !0 }));
      } else
        n.removeEventListener("click", d.current), f();
      c.current = !1;
    }, b = [
      "pointerup",
      "mousedown",
      "mouseup",
      "touchstart",
      "touchend",
      "click"
    ];
    for (const $ of b)
      n.addEventListener($, v, !0), n.addEventListener($, y);
    const x = window.setTimeout(() => {
      n.addEventListener("pointerdown", g);
    }, 0);
    return () => {
      window.clearTimeout(x), n.removeEventListener("pointerdown", g), n.removeEventListener("click", d.current);
      for (const $ of b)
        n.removeEventListener($, v, !0), n.removeEventListener($, y);
    };
  }, [
    n,
    a,
    r,
    o,
    i
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => c.current = !0
  };
}
function nOe(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = rp(e), r = E.useRef(!1);
  return E.useEffect(() => {
    const o = (i) => {
      i.target && !r.current && dB(Z$e, n, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function sN() {
  const e = new CustomEvent(JS);
  document.dispatchEvent(e);
}
function dB(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Y$e(o, i) : o.dispatchEvent(i);
}
var F2 = "focusScope.autoFocusOnMount", z2 = "focusScope.autoFocusOnUnmount", cN = { bubbles: !1, cancelable: !0 }, rOe = "FocusScope", fB = E.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...a
  } = e, [c, l] = E.useState(null), u = rp(o), d = rp(i), f = E.useRef(null), h = sl(t, (g) => l(g)), v = E.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  E.useEffect(() => {
    if (r) {
      let g = function(S) {
        if (v.paused || !c) return;
        const O = S.target;
        c.contains(O) ? f.current = O : ms(f.current, { select: !0 });
      }, b = function(S) {
        if (v.paused || !c) return;
        const O = S.relatedTarget;
        O !== null && (c.contains(O) || ms(f.current, { select: !0 }));
      }, x = function(S) {
        if (document.activeElement === document.body)
          for (const C of S)
            C.removedNodes.length > 0 && ms(c);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", b);
      const $ = new MutationObserver(x);
      return c && $.observe(c, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", b), $.disconnect();
      };
    }
  }, [r, c, v.paused]), E.useEffect(() => {
    if (c) {
      uN.add(v);
      const g = document.activeElement;
      if (!c.contains(g)) {
        const x = new CustomEvent(F2, cN);
        c.addEventListener(F2, u), c.dispatchEvent(x), x.defaultPrevented || (oOe(lOe(pB(c)), { select: !0 }), document.activeElement === g && ms(c));
      }
      return () => {
        c.removeEventListener(F2, u), setTimeout(() => {
          const x = new CustomEvent(z2, cN);
          c.addEventListener(z2, d), c.dispatchEvent(x), x.defaultPrevented || ms(g ?? document.body, { select: !0 }), c.removeEventListener(z2, d), uN.remove(v);
        }, 0);
      };
    }
  }, [c, u, d, v]);
  const y = E.useCallback(
    (g) => {
      if (!n && !r || v.paused) return;
      const b = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, x = document.activeElement;
      if (b && x) {
        const $ = g.currentTarget, [S, O] = iOe($);
        S && O ? !g.shiftKey && x === O ? (g.preventDefault(), n && ms(S, { select: !0 })) : g.shiftKey && x === S && (g.preventDefault(), n && ms(O, { select: !0 })) : x === $ && g.preventDefault();
      }
    },
    [n, r, v.paused]
  );
  return /* @__PURE__ */ F.jsx(Qa.div, { tabIndex: -1, ...a, ref: h, onKeyDown: y });
});
fB.displayName = rOe;
function oOe(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (ms(r, { select: t }), document.activeElement !== n) return;
}
function iOe(e) {
  const t = pB(e), n = lN(t, e), r = lN(t.reverse(), e);
  return [n, r];
}
function pB(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function lN(e, t) {
  for (const n of e)
    if (!aOe(n, { upTo: t })) return n;
}
function aOe(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function sOe(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function ms(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && sOe(e) && t && e.select();
  }
}
var uN = cOe();
function cOe() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = dN(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = dN(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function dN(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function lOe(e) {
  return e.filter((t) => t.tagName !== "A");
}
var uOe = "Portal", hB = E.forwardRef((e, t) => {
  var c;
  const { container: n, ...r } = e, [o, i] = E.useState(!1);
  np(() => i(!0), []);
  const a = n || o && ((c = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : c.body);
  return a ? nl.createPortal(/* @__PURE__ */ F.jsx(Qa.div, { ...r, ref: t }), a) : null;
});
hB.displayName = uOe;
function dOe(e, t) {
  return E.useReducer((n, r) => t[n][r] ?? n, e);
}
var Wv = (e) => {
  const { present: t, children: n } = e, r = fOe(t), o = typeof n == "function" ? n({ present: r.isPresent }) : E.Children.only(n), i = pOe(r.ref, hOe(o));
  return typeof n == "function" || r.isPresent ? E.cloneElement(o, { ref: i }) : null;
};
Wv.displayName = "Presence";
function fOe(e) {
  const [t, n] = E.useState(), r = E.useRef(null), o = E.useRef(e), i = E.useRef("none"), a = e ? "mounted" : "unmounted", [c, l] = dOe(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return E.useEffect(() => {
    const u = xm(r.current);
    i.current = c === "mounted" ? u : "none";
  }, [c]), np(() => {
    const u = r.current, d = o.current;
    if (d !== e) {
      const h = i.current, v = xm(u);
      e ? l("MOUNT") : v === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(d && h !== v ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, l]), np(() => {
    if (t) {
      let u;
      const d = t.ownerDocument.defaultView ?? window, f = (v) => {
        const g = xm(r.current).includes(CSS.escape(v.animationName));
        if (v.target === t && g && (l("ANIMATION_END"), !o.current)) {
          const b = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = d.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = b);
          });
        }
      }, h = (v) => {
        v.target === t && (i.current = xm(r.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        d.clearTimeout(u), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: E.useCallback((u) => {
      r.current = u ? getComputedStyle(u) : null, n(u);
    }, [])
  };
}
function fN(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function pOe(...e) {
  const t = E.useRef(e);
  return t.current = e, E.useCallback((n) => {
    const r = t.current;
    let o = !1;
    const i = r.map((a) => {
      const c = fN(a, n);
      return !o && typeof c == "function" && (o = !0), c;
    });
    if (o)
      return () => {
        for (let a = 0; a < i.length; a++) {
          const c = i[a];
          typeof c == "function" ? c() : fN(r[a], null);
        }
      };
  }, []);
}
function xm(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function hOe(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var wm = 0, Ni = null;
function mOe() {
  E.useEffect(() => {
    Ni || (Ni = { start: pN(), end: pN() });
    const { start: e, end: t } = Ni;
    return document.body.firstElementChild !== e && document.body.insertAdjacentElement("afterbegin", e), document.body.lastElementChild !== t && document.body.insertAdjacentElement("beforeend", t), wm++, () => {
      wm === 1 && (Ni == null || Ni.start.remove(), Ni == null || Ni.end.remove(), Ni = null), wm = Math.max(0, wm - 1);
    };
  }, []);
}
function pN() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var ws = function() {
  return ws = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, ws.apply(this, arguments);
};
function gOe(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function vOe(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, i; r < o; r++)
    (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var ug = "right-scroll-bar-position", dg = "width-before-scroll-bar", yOe = "with-scroll-bars-hidden", bOe = "--removed-body-scroll-bar-size";
function B2(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function xOe(e, t) {
  var n = Uc(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var wOe = typeof window < "u" ? E.useLayoutEffect : E.useEffect, hN = /* @__PURE__ */ new WeakMap();
function $Oe(e, t) {
  var n = xOe(null, function(r) {
    return e.forEach(function(o) {
      return B2(o, r);
    });
  });
  return wOe(function() {
    var r = hN.get(n);
    if (r) {
      var o = new Set(r), i = new Set(e), a = n.current;
      o.forEach(function(c) {
        i.has(c) || B2(c, null);
      }), i.forEach(function(c) {
        o.has(c) || B2(c, a);
      });
    }
    hN.set(n, e);
  }, [e]), n;
}
var a0 = function() {
  return a0 = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, a0.apply(this, arguments);
};
function OOe(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function SOe(e) {
  return e;
}
function COe(e, t) {
  t === void 0 && (t = SOe);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var a = t(i, r);
      return n.push(a), function() {
        n = n.filter(function(c) {
          return c !== a;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(i);
      }
      n = {
        push: function(c) {
          return i(c);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var a = [];
      if (n.length) {
        var c = n;
        n = [], c.forEach(i), a = n;
      }
      var l = function() {
        var d = a;
        a = [], d.forEach(i);
      }, u = function() {
        return Promise.resolve().then(l);
      };
      u(), n = {
        push: function(d) {
          a.push(d), u();
        },
        filter: function(d) {
          return a = a.filter(d), n;
        }
      };
    }
  };
  return o;
}
function TOe(e) {
  e === void 0 && (e = {});
  var t = COe(null);
  return t.options = a0({ async: !0, ssr: !1 }, e), t;
}
var mB = function(e) {
  var t = e.sideCar, n = OOe(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return E.createElement(r, a0({}, n));
};
mB.isSideCarExport = !0;
function EOe(e, t) {
  return e.useMedium(t), mB;
}
var gB = TOe(), q2 = function() {
}, Hv = E.forwardRef(function(e, t) {
  var n = E.useRef(null), r = E.useState({
    onScrollCapture: q2,
    onWheelCapture: q2,
    onTouchMoveCapture: q2
  }), o = r[0], i = r[1], a = e.forwardProps, c = e.children, l = e.className, u = e.removeScrollBar, d = e.enabled, f = e.shards, h = e.sideCar, v = e.noRelative, y = e.noIsolation, g = e.inert, b = e.allowPinchZoom, x = e.as, $ = x === void 0 ? "div" : x, S = e.gapMode, O = gOe(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), C = h, T = $Oe([n, t]), k = ws(ws({}, O), o);
  return E.createElement(
    E.Fragment,
    null,
    d && E.createElement(C, { sideCar: gB, removeScrollBar: u, shards: f, noRelative: v, noIsolation: y, inert: g, setCallbacks: i, allowPinchZoom: !!b, lockRef: n, gapMode: S }),
    a ? E.cloneElement(E.Children.only(c), ws(ws({}, k), { ref: T })) : E.createElement($, ws({}, k, { className: l, ref: T }), c)
  );
});
Hv.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Hv.classNames = {
  fullWidth: dg,
  zeroRight: ug
};
var _Oe = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function kOe() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = _Oe();
  return t && e.setAttribute("nonce", t), e;
}
function ROe(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function POe(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var AOe = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = kOe()) && (ROe(t, n), POe(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, IOe = function() {
  var e = AOe();
  return function(t, n) {
    E.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, vB = function() {
  var e = IOe(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, MOe = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, U2 = function(e) {
  return parseInt(e || "", 10) || 0;
}, NOe = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [U2(n), U2(r), U2(o)];
}, DOe = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return MOe;
  var t = NOe(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, LOe = vB(), mu = "data-scroll-locked", jOe = function(e, t, n, r) {
  var o = e.left, i = e.top, a = e.right, c = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(yOe, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(c, "px ").concat(r, `;
  }
  body[`).concat(mu, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(c, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(c, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(ug, ` {
    right: `).concat(c, "px ").concat(r, `;
  }
  
  .`).concat(dg, ` {
    margin-right: `).concat(c, "px ").concat(r, `;
  }
  
  .`).concat(ug, " .").concat(ug, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(dg, " .").concat(dg, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(mu, `] {
    `).concat(bOe, ": ").concat(c, `px;
  }
`);
}, mN = function() {
  var e = parseInt(document.body.getAttribute(mu) || "0", 10);
  return isFinite(e) ? e : 0;
}, FOe = function() {
  E.useEffect(function() {
    return document.body.setAttribute(mu, (mN() + 1).toString()), function() {
      var e = mN() - 1;
      e <= 0 ? document.body.removeAttribute(mu) : document.body.setAttribute(mu, e.toString());
    };
  }, []);
}, zOe = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  FOe();
  var i = E.useMemo(function() {
    return DOe(o);
  }, [o]);
  return E.createElement(LOe, { styles: jOe(i, !t, o, n ? "" : "!important") });
}, QS = !1;
if (typeof window < "u")
  try {
    var $m = Object.defineProperty({}, "passive", {
      get: function() {
        return QS = !0, !0;
      }
    });
    window.addEventListener("test", $m, $m), window.removeEventListener("test", $m, $m);
  } catch {
    QS = !1;
  }
var Vl = QS ? { passive: !1 } : !1, BOe = function(e) {
  return e.tagName === "TEXTAREA";
}, yB = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !BOe(e) && n[t] === "visible")
  );
}, qOe = function(e) {
  return yB(e, "overflowY");
}, UOe = function(e) {
  return yB(e, "overflowX");
}, gN = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = bB(e, r);
    if (o) {
      var i = xB(e, r), a = i[1], c = i[2];
      if (a > c)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, WOe = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, HOe = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, bB = function(e, t) {
  return e === "v" ? qOe(t) : UOe(t);
}, xB = function(e, t) {
  return e === "v" ? WOe(t) : HOe(t);
}, VOe = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, YOe = function(e, t, n, r, o) {
  var i = VOe(e, window.getComputedStyle(t).direction), a = i * r, c = n.target, l = t.contains(c), u = !1, d = a > 0, f = 0, h = 0;
  do {
    if (!c)
      break;
    var v = xB(e, c), y = v[0], g = v[1], b = v[2], x = g - b - i * y;
    (y || x) && bB(e, c) && (f += x, h += y);
    var $ = c.parentNode;
    c = $ && $.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? $.host : $;
  } while (
    // portaled content
    !l && c !== document.body || // self content
    l && (t.contains(c) || t === c)
  );
  return (d && (Math.abs(f) < 1 || !o) || !d && (Math.abs(h) < 1 || !o)) && (u = !0), u;
}, Om = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, vN = function(e) {
  return [e.deltaX, e.deltaY];
}, yN = function(e) {
  return e && "current" in e ? e.current : e;
}, GOe = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, KOe = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, XOe = 0, Yl = [];
function ZOe(e) {
  var t = E.useRef([]), n = E.useRef([0, 0]), r = E.useRef(), o = E.useState(XOe++)[0], i = E.useState(vB)[0], a = E.useRef(e);
  E.useEffect(function() {
    a.current = e;
  }, [e]), E.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var g = vOe([e.lockRef.current], (e.shards || []).map(yN), !0).filter(Boolean);
      return g.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), g.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var c = E.useCallback(function(g, b) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !a.current.allowPinchZoom;
    var x = Om(g), $ = n.current, S = "deltaX" in g ? g.deltaX : $[0] - x[0], O = "deltaY" in g ? g.deltaY : $[1] - x[1], C, T = g.target, k = Math.abs(S) > Math.abs(O) ? "h" : "v";
    if ("touches" in g && k === "h" && T.type === "range")
      return !1;
    var I = window.getSelection(), P = I && I.anchorNode, _ = P ? P === T || P.contains(T) : !1;
    if (_)
      return !1;
    var A = gN(k, T);
    if (!A)
      return !0;
    if (A ? C = k : (C = k === "v" ? "h" : "v", A = gN(k, T)), !A)
      return !1;
    if (!r.current && "changedTouches" in g && (S || O) && (r.current = C), !C)
      return !0;
    var D = r.current || C;
    return YOe(D, b, g, D === "h" ? S : O, !0);
  }, []), l = E.useCallback(function(g) {
    var b = g;
    if (!(!Yl.length || Yl[Yl.length - 1] !== i)) {
      var x = "deltaY" in b ? vN(b) : Om(b), $ = t.current.filter(function(C) {
        return C.name === b.type && (C.target === b.target || b.target === C.shadowParent) && GOe(C.delta, x);
      })[0];
      if ($ && $.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!$) {
        var S = (a.current.shards || []).map(yN).filter(Boolean).filter(function(C) {
          return C.contains(b.target);
        }), O = S.length > 0 ? c(b, S[0]) : !a.current.noIsolation;
        O && b.cancelable && b.preventDefault();
      }
    }
  }, []), u = E.useCallback(function(g, b, x, $) {
    var S = { name: g, delta: b, target: x, should: $, shadowParent: JOe(x) };
    t.current.push(S), setTimeout(function() {
      t.current = t.current.filter(function(O) {
        return O !== S;
      });
    }, 1);
  }, []), d = E.useCallback(function(g) {
    n.current = Om(g), r.current = void 0;
  }, []), f = E.useCallback(function(g) {
    u(g.type, vN(g), g.target, c(g, e.lockRef.current));
  }, []), h = E.useCallback(function(g) {
    u(g.type, Om(g), g.target, c(g, e.lockRef.current));
  }, []);
  E.useEffect(function() {
    return Yl.push(i), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", l, Vl), document.addEventListener("touchmove", l, Vl), document.addEventListener("touchstart", d, Vl), function() {
      Yl = Yl.filter(function(g) {
        return g !== i;
      }), document.removeEventListener("wheel", l, Vl), document.removeEventListener("touchmove", l, Vl), document.removeEventListener("touchstart", d, Vl);
    };
  }, []);
  var v = e.removeScrollBar, y = e.inert;
  return E.createElement(
    E.Fragment,
    null,
    y ? E.createElement(i, { styles: KOe(o) }) : null,
    v ? E.createElement(zOe, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function JOe(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const QOe = EOe(gB, ZOe);
var wB = E.forwardRef(function(e, t) {
  return E.createElement(Hv, ws({}, e, { ref: t, sideCar: QOe }));
});
wB.classNames = Hv.classNames;
var eSe = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Gl = /* @__PURE__ */ new WeakMap(), Sm = /* @__PURE__ */ new WeakMap(), Cm = {}, W2 = 0, $B = function(e) {
  return e && (e.host || $B(e.parentNode));
}, tSe = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = $B(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, nSe = function(e, t, n, r) {
  var o = tSe(t, Array.isArray(e) ? e : [e]);
  Cm[n] || (Cm[n] = /* @__PURE__ */ new WeakMap());
  var i = Cm[n], a = [], c = /* @__PURE__ */ new Set(), l = new Set(o), u = function(f) {
    !f || c.has(f) || (c.add(f), u(f.parentNode));
  };
  o.forEach(u);
  var d = function(f) {
    !f || l.has(f) || Array.prototype.forEach.call(f.children, function(h) {
      if (c.has(h))
        d(h);
      else
        try {
          var v = h.getAttribute(r), y = v !== null && v !== "false", g = (Gl.get(h) || 0) + 1, b = (i.get(h) || 0) + 1;
          Gl.set(h, g), i.set(h, b), a.push(h), g === 1 && y && Sm.set(h, !0), b === 1 && h.setAttribute(n, "true"), y || h.setAttribute(r, "true");
        } catch (x) {
          console.error("aria-hidden: cannot operate on ", h, x);
        }
    });
  };
  return d(t), c.clear(), W2++, function() {
    a.forEach(function(f) {
      var h = Gl.get(f) - 1, v = i.get(f) - 1;
      Gl.set(f, h), i.set(f, v), h || (Sm.has(f) || f.removeAttribute(r), Sm.delete(f)), v || f.removeAttribute(n);
    }), W2--, W2 || (Gl = /* @__PURE__ */ new WeakMap(), Gl = /* @__PURE__ */ new WeakMap(), Sm = /* @__PURE__ */ new WeakMap(), Cm = {});
  };
}, rSe = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = eSe(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live], script"))), nSe(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, Vv = "Dialog", [OB, y9e] = k$e(Vv), [oSe, Ti] = OB(Vv), SB = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: i,
    modal: a = !0
  } = e, c = E.useRef(null), l = E.useRef(null), [u, d] = M$e({
    prop: r,
    defaultProp: o ?? !1,
    onChange: i,
    caller: Vv
  });
  return /* @__PURE__ */ F.jsx(
    oSe,
    {
      scope: t,
      triggerRef: c,
      contentRef: l,
      contentId: j2(),
      titleId: j2(),
      descriptionId: j2(),
      open: u,
      onOpenChange: d,
      onOpenToggle: E.useCallback(() => d((f) => !f), [d]),
      modal: a,
      children: n
    }
  );
};
SB.displayName = Vv;
var CB = "DialogTrigger", TB = E.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ti(CB, n), i = sl(t, o.triggerRef);
    return /* @__PURE__ */ F.jsx(
      Qa.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.open ? o.contentId : void 0,
        "data-state": ME(o.open),
        ...r,
        ref: i,
        onClick: As(e.onClick, o.onOpenToggle)
      }
    );
  }
);
TB.displayName = CB;
var IE = "DialogPortal", [iSe, EB] = OB(IE, {
  forceMount: void 0
}), _B = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, i = Ti(IE, t);
  return /* @__PURE__ */ F.jsx(iSe, { scope: t, forceMount: n, children: E.Children.map(r, (a) => /* @__PURE__ */ F.jsx(Wv, { present: n || i.open, children: /* @__PURE__ */ F.jsx(hB, { asChild: !0, container: o, children: a }) })) });
};
_B.displayName = IE;
var s0 = "DialogOverlay", kB = E.forwardRef(
  (e, t) => {
    const n = EB(s0, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = Ti(s0, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ F.jsx(Wv, { present: r || i.open, children: /* @__PURE__ */ F.jsx(sSe, { ...o, ref: t }) }) : null;
  }
);
kB.displayName = s0;
var aSe = /* @__PURE__ */ lB("DialogOverlay.RemoveScroll"), sSe = E.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ti(s0, n), i = eOe(), a = sl(t, i);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ F.jsx(wB, { as: aSe, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ F.jsx(
        Qa.div,
        {
          "data-state": ME(o.open),
          ...r,
          ref: a,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Iu = "DialogContent", RB = E.forwardRef(
  (e, t) => {
    const n = EB(Iu, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, i = Ti(Iu, e.__scopeDialog);
    return /* @__PURE__ */ F.jsx(Wv, { present: r || i.open, children: i.modal ? /* @__PURE__ */ F.jsx(cSe, { ...o, ref: t }) : /* @__PURE__ */ F.jsx(lSe, { ...o, ref: t }) });
  }
);
RB.displayName = Iu;
var cSe = E.forwardRef(
  (e, t) => {
    const n = Ti(Iu, e.__scopeDialog), r = E.useRef(null), o = sl(t, n.contentRef, r);
    return E.useEffect(() => {
      const i = r.current;
      if (i) return rSe(i);
    }, []), /* @__PURE__ */ F.jsx(
      PB,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        onCloseAutoFocus: As(e.onCloseAutoFocus, (i) => {
          var a;
          i.preventDefault(), (a = n.triggerRef.current) == null || a.focus();
        }),
        onPointerDownOutside: As(e.onPointerDownOutside, (i) => {
          const a = i.detail.originalEvent, c = a.button === 0 && a.ctrlKey === !0;
          (a.button === 2 || c) && i.preventDefault();
        }),
        onFocusOutside: As(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), lSe = E.forwardRef(
  (e, t) => {
    const n = Ti(Iu, e.__scopeDialog), r = E.useRef(!1), o = E.useRef(!1);
    return /* @__PURE__ */ F.jsx(
      PB,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var a, c;
          (a = e.onCloseAutoFocus) == null || a.call(e, i), i.defaultPrevented || (r.current || (c = n.triggerRef.current) == null || c.focus(), i.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          var l, u;
          (l = e.onInteractOutside) == null || l.call(e, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const a = i.target;
          ((u = n.triggerRef.current) == null ? void 0 : u.contains(a)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), PB = E.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, ...a } = e, c = Ti(Iu, n);
    return mOe(), /* @__PURE__ */ F.jsx(F.Fragment, { children: /* @__PURE__ */ F.jsx(
      fB,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: o,
        onUnmountAutoFocus: i,
        children: /* @__PURE__ */ F.jsx(
          uB,
          {
            role: "dialog",
            id: c.contentId,
            "aria-describedby": c.descriptionId,
            "aria-labelledby": c.titleId,
            "data-state": ME(c.open),
            ...a,
            ref: t,
            deferPointerDownOutside: !0,
            onDismiss: () => c.onOpenChange(!1)
          }
        )
      }
    ) });
  }
), AB = "DialogTitle", IB = E.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ti(AB, n);
    return /* @__PURE__ */ F.jsx(Qa.h2, { id: o.titleId, ...r, ref: t });
  }
);
IB.displayName = AB;
var MB = "DialogDescription", NB = E.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ti(MB, n);
    return /* @__PURE__ */ F.jsx(Qa.p, { id: o.descriptionId, ...r, ref: t });
  }
);
NB.displayName = MB;
var DB = "DialogClose", LB = E.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = Ti(DB, n);
    return /* @__PURE__ */ F.jsx(
      Qa.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: As(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
LB.displayName = DB;
function ME(e) {
  return e ? "open" : "closed";
}
function uSe(e) {
  if (typeof document > "u") return;
  let t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", t.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
const jB = ye.createContext({
  drawerRef: {
    current: null
  },
  overlayRef: {
    current: null
  },
  onPress: () => {
  },
  onRelease: () => {
  },
  onDrag: () => {
  },
  onNestedDrag: () => {
  },
  onNestedOpenChange: () => {
  },
  onNestedRelease: () => {
  },
  openProp: void 0,
  dismissible: !1,
  isOpen: !1,
  isDragging: !1,
  keyboardIsOpen: {
    current: !1
  },
  snapPointsOffset: null,
  snapPoints: null,
  handleOnly: !1,
  modal: !1,
  shouldFade: !1,
  activeSnapPoint: null,
  onOpenChange: () => {
  },
  setActiveSnapPoint: () => {
  },
  closeDrawer: () => {
  },
  direction: "bottom",
  shouldAnimate: {
    current: !0
  },
  shouldScaleBackground: !1,
  setBackgroundColorOnScale: !0,
  noBodyStyles: !1,
  container: null,
  autoFocus: !1
}), ad = () => {
  const e = ye.useContext(jB);
  if (!e)
    throw new Error("useDrawerContext must be used within a Drawer.Root");
  return e;
};
uSe(`[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--initial-transform,100%),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--initial-transform,100%),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-animate=false]{animation:none!important}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(
[data-state=closed]
){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,var(--initial-transform,100%),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,var(--initial-transform,100%),0)}}@keyframes slideFromTop{from{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}}@keyframes slideFromLeft{from{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}}@keyframes slideFromRight{from{transform:translate3d(var(--initial-transform,100%),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(var(--initial-transform,100%),0,0)}}`);
function dSe() {
  const e = navigator.userAgent;
  return typeof window < "u" && (/Firefox/.test(e) && /Mobile/.test(e) || // Android Firefox
  /FxiOS/.test(e));
}
function fSe() {
  return NE(/^Mac/);
}
function pSe() {
  return NE(/^iPhone/);
}
function bN() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function hSe() {
  return NE(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  fSe() && navigator.maxTouchPoints > 1;
}
function FB() {
  return pSe() || hSe();
}
function NE(e) {
  return typeof window < "u" && window.navigator != null ? e.test(window.navigator.platform) : void 0;
}
const mSe = 24, gSe = typeof window < "u" ? F0 : mn;
function xN(...e) {
  return (...t) => {
    for (let n of e)
      typeof n == "function" && n(...t);
  };
}
const H2 = typeof document < "u" && window.visualViewport;
function wN(e) {
  let t = window.getComputedStyle(e);
  return /(auto|scroll)/.test(t.overflow + t.overflowX + t.overflowY);
}
function zB(e) {
  for (wN(e) && (e = e.parentElement); e && !wN(e); )
    e = e.parentElement;
  return e || document.scrollingElement || document.documentElement;
}
const vSe = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let Tm = 0, V2;
function ySe(e = {}) {
  let { isDisabled: t } = e;
  gSe(() => {
    if (!t)
      return Tm++, Tm === 1 && FB() && (V2 = bSe()), () => {
        Tm--, Tm === 0 && (V2 == null || V2());
      };
  }, [
    t
  ]);
}
function bSe() {
  let e, t = 0, n = (f) => {
    e = zB(f.target), !(e === document.documentElement && e === document.body) && (t = f.changedTouches[0].pageY);
  }, r = (f) => {
    if (!e || e === document.documentElement || e === document.body) {
      f.preventDefault();
      return;
    }
    let h = f.changedTouches[0].pageY, v = e.scrollTop, y = e.scrollHeight - e.clientHeight;
    y !== 0 && ((v <= 0 && h > t || v >= y && h < t) && f.preventDefault(), t = h);
  }, o = (f) => {
    let h = f.target;
    eC(h) && h !== document.activeElement && (f.preventDefault(), h.style.transform = "translateY(-2000px)", h.focus(), requestAnimationFrame(() => {
      h.style.transform = "";
    }));
  }, i = (f) => {
    let h = f.target;
    eC(h) && (h.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      h.style.transform = "", H2 && (H2.height < window.innerHeight ? requestAnimationFrame(() => {
        $N(h);
      }) : H2.addEventListener("resize", () => $N(h), {
        once: !0
      }));
    }));
  }, a = () => {
    window.scrollTo(0, 0);
  }, c = window.pageXOffset, l = window.pageYOffset, u = xN(xSe(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let d = xN(Yd(document, "touchstart", n, {
    passive: !1,
    capture: !0
  }), Yd(document, "touchmove", r, {
    passive: !1,
    capture: !0
  }), Yd(document, "touchend", o, {
    passive: !1,
    capture: !0
  }), Yd(document, "focus", i, !0), Yd(window, "scroll", a));
  return () => {
    u(), d(), window.scrollTo(c, l);
  };
}
function xSe(e, t, n) {
  let r = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = r;
  };
}
function Yd(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function $N(e) {
  let t = document.scrollingElement || document.documentElement;
  for (; e && e !== t; ) {
    let n = zB(e);
    if (n !== document.documentElement && n !== document.body && n !== e) {
      let r = n.getBoundingClientRect().top, o = e.getBoundingClientRect().top, i = e.getBoundingClientRect().bottom;
      const a = n.getBoundingClientRect().bottom + mSe;
      i > a && (n.scrollTop += o - r);
    }
    e = n.parentElement;
  }
}
function eC(e) {
  return e instanceof HTMLInputElement && !vSe.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
function wSe(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function $Se(...e) {
  return (t) => e.forEach((n) => wSe(n, t));
}
function BB(...e) {
  return E.useCallback($Se(...e), e);
}
const qB = /* @__PURE__ */ new WeakMap();
function Jn(e, t, n = !1) {
  if (!e || !(e instanceof HTMLElement)) return;
  let r = {};
  Object.entries(t).forEach(([o, i]) => {
    if (o.startsWith("--")) {
      e.style.setProperty(o, i);
      return;
    }
    r[o] = e.style[o], e.style[o] = i;
  }), !n && qB.set(e, r);
}
function OSe(e, t) {
  if (!e || !(e instanceof HTMLElement)) return;
  let n = qB.get(e);
  n && (e.style[t] = n[t]);
}
const Vn = (e) => {
  switch (e) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return e;
  }
};
function Em(e, t) {
  if (!e)
    return null;
  const n = window.getComputedStyle(e), r = (
    // @ts-ignore
    n.transform || n.webkitTransform || n.mozTransform
  );
  let o = r.match(/^matrix3d\((.+)\)$/);
  return o ? parseFloat(o[1].split(", ")[Vn(t) ? 13 : 12]) : (o = r.match(/^matrix\((.+)\)$/), o ? parseFloat(o[1].split(", ")[Vn(t) ? 5 : 4]) : null);
}
function SSe(e) {
  return 8 * (Math.log(e + 1) - 2);
}
function Y2(e, t) {
  if (!e) return () => {
  };
  const n = e.style.cssText;
  return Object.assign(e.style, t), () => {
    e.style.cssText = n;
  };
}
function CSe(...e) {
  return (...t) => {
    for (const n of e)
      typeof n == "function" && n(...t);
  };
}
const Tn = {
  DURATION: 0.5,
  EASE: [
    0.32,
    0.72,
    0,
    1
  ]
}, UB = 0.4, TSe = 0.25, ESe = 100, WB = 8, fc = 16, tC = 26, G2 = "vaul-dragging";
function HB(e) {
  const t = ye.useRef(e);
  return ye.useEffect(() => {
    t.current = e;
  }), ye.useMemo(() => (...n) => t.current == null ? void 0 : t.current.call(t, ...n), []);
}
function _Se({ defaultProp: e, onChange: t }) {
  const n = ye.useState(e), [r] = n, o = ye.useRef(r), i = HB(t);
  return ye.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [
    r,
    o,
    i
  ]), n;
}
function VB({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = _Se({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, a = i ? e : r, c = HB(n), l = ye.useCallback((u) => {
    if (i) {
      const f = typeof u == "function" ? u(e) : u;
      f !== e && c(f);
    } else
      o(u);
  }, [
    i,
    e,
    o,
    c
  ]);
  return [
    a,
    l
  ];
}
function kSe({ activeSnapPointProp: e, setActiveSnapPointProp: t, snapPoints: n, drawerRef: r, overlayRef: o, fadeFromIndex: i, onSnapPointChange: a, direction: c = "bottom", container: l, snapToSequentialPoint: u }) {
  const [d, f] = VB({
    prop: e,
    defaultProp: n == null ? void 0 : n[0],
    onChange: t
  }), [h, v] = ye.useState(typeof window < "u" ? {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  } : void 0);
  ye.useEffect(() => {
    function k() {
      v({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }
    return window.addEventListener("resize", k), () => window.removeEventListener("resize", k);
  }, []);
  const y = ye.useMemo(() => d === (n == null ? void 0 : n[n.length - 1]) || null, [
    n,
    d
  ]), g = ye.useMemo(() => {
    var k;
    return (k = n == null ? void 0 : n.findIndex((I) => I === d)) != null ? k : null;
  }, [
    n,
    d
  ]), b = n && n.length > 0 && (i || i === 0) && !Number.isNaN(i) && n[i] === d || !n, x = ye.useMemo(() => {
    const k = l ? {
      width: l.getBoundingClientRect().width,
      height: l.getBoundingClientRect().height
    } : typeof window < "u" ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: 0,
      height: 0
    };
    var I;
    return (I = n == null ? void 0 : n.map((P) => {
      const _ = typeof P == "string";
      let A = 0;
      if (_ && (A = parseInt(P, 10)), Vn(c)) {
        const M = _ ? A : h ? P * k.height : 0;
        return h ? c === "bottom" ? k.height - M : -k.height + M : M;
      }
      const D = _ ? A : h ? P * k.width : 0;
      return h ? c === "right" ? k.width - D : -k.width + D : D;
    })) != null ? I : [];
  }, [
    n,
    h,
    l
  ]), $ = ye.useMemo(() => g !== null ? x == null ? void 0 : x[g] : null, [
    x,
    g
  ]), S = ye.useCallback((k) => {
    var I;
    const P = (I = x == null ? void 0 : x.findIndex((_) => _ === k)) != null ? I : null;
    a(P), Jn(r.current, {
      transition: `transform ${Tn.DURATION}s cubic-bezier(${Tn.EASE.join(",")})`,
      transform: Vn(c) ? `translate3d(0, ${k}px, 0)` : `translate3d(${k}px, 0, 0)`
    }), x && P !== x.length - 1 && i !== void 0 && P !== i && P < i ? Jn(o.current, {
      transition: `opacity ${Tn.DURATION}s cubic-bezier(${Tn.EASE.join(",")})`,
      opacity: "0"
    }) : Jn(o.current, {
      transition: `opacity ${Tn.DURATION}s cubic-bezier(${Tn.EASE.join(",")})`,
      opacity: "1"
    }), f(n == null ? void 0 : n[Math.max(P, 0)]);
  }, [
    r.current,
    n,
    x,
    i,
    o,
    f
  ]);
  ye.useEffect(() => {
    if (d || e) {
      var k;
      const I = (k = n == null ? void 0 : n.findIndex((P) => P === e || P === d)) != null ? k : -1;
      x && I !== -1 && typeof x[I] == "number" && S(x[I]);
    }
  }, [
    d,
    e,
    n,
    x,
    S
  ]);
  function O({ draggedDistance: k, closeDrawer: I, velocity: P, dismissible: _ }) {
    if (i === void 0) return;
    const A = c === "bottom" || c === "right" ? ($ ?? 0) - k : ($ ?? 0) + k, D = g === i - 1, M = g === 0, N = k > 0;
    if (D && Jn(o.current, {
      transition: `opacity ${Tn.DURATION}s cubic-bezier(${Tn.EASE.join(",")})`
    }), !u && P > 2 && !N) {
      _ ? I() : S(x[0]);
      return;
    }
    if (!u && P > 2 && N && x && n) {
      S(x[n.length - 1]);
      return;
    }
    const L = x == null ? void 0 : x.reduce((q, W) => typeof q != "number" || typeof W != "number" ? q : Math.abs(W - A) < Math.abs(q - A) ? W : q), z = Vn(c) ? window.innerHeight : window.innerWidth;
    if (P > UB && Math.abs(k) < z * 0.4) {
      const q = N ? 1 : -1;
      if (q > 0 && y && n) {
        S(x[n.length - 1]);
        return;
      }
      if (M && q < 0 && _ && I(), g === null) return;
      S(x[g + q]);
      return;
    }
    S(L);
  }
  function C({ draggedDistance: k }) {
    if ($ === null) return;
    const I = c === "bottom" || c === "right" ? $ - k : $ + k;
    (c === "bottom" || c === "right") && I < x[x.length - 1] || (c === "top" || c === "left") && I > x[x.length - 1] || Jn(r.current, {
      transform: Vn(c) ? `translate3d(0, ${I}px, 0)` : `translate3d(${I}px, 0, 0)`
    });
  }
  function T(k, I) {
    if (!n || typeof g != "number" || !x || i === void 0) return null;
    const P = g === i - 1;
    if (g >= i && I)
      return 0;
    if (P && !I) return 1;
    if (!b && !P) return null;
    const A = P ? g + 1 : g - 1, D = P ? x[A] - x[A - 1] : x[A + 1] - x[A], M = k / Math.abs(D);
    return P ? 1 - M : M;
  }
  return {
    isLastSnapPoint: y,
    activeSnapPoint: d,
    shouldFade: b,
    getPercentageDragged: T,
    setActiveSnapPoint: f,
    activeSnapPointIndex: g,
    onRelease: O,
    onDrag: C,
    snapPointsOffset: x
  };
}
const RSe = () => () => {
};
function PSe() {
  const { direction: e, isOpen: t, shouldScaleBackground: n, setBackgroundColorOnScale: r, noBodyStyles: o } = ad(), i = ye.useRef(null), a = Nn(() => document.body.style.backgroundColor, []);
  function c() {
    return (window.innerWidth - tC) / window.innerWidth;
  }
  ye.useEffect(() => {
    if (t && n) {
      i.current && clearTimeout(i.current);
      const l = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
      if (!l) return;
      CSe(r && !o ? Y2(document.body, {
        background: "black"
      }) : RSe, Y2(l, {
        transformOrigin: Vn(e) ? "top" : "left",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${Tn.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${Tn.EASE.join(",")})`
      }));
      const u = Y2(l, {
        borderRadius: `${WB}px`,
        overflow: "hidden",
        ...Vn(e) ? {
          transform: `scale(${c()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
        } : {
          transform: `scale(${c()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
        }
      });
      return () => {
        u(), i.current = window.setTimeout(() => {
          a ? document.body.style.background = a : document.body.style.removeProperty("background");
        }, Tn.DURATION * 1e3);
      };
    }
  }, [
    t,
    n,
    a
  ]);
}
let Gd = null;
function ASe({ isOpen: e, modal: t, nested: n, hasBeenOpened: r, preventScrollRestoration: o, noBodyStyles: i }) {
  const [a, c] = ye.useState(() => typeof window < "u" ? window.location.href : ""), l = ye.useRef(0), u = ye.useCallback(() => {
    if (bN() && Gd === null && e && !i) {
      Gd = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height,
        right: "unset"
      };
      const { scrollX: f, innerHeight: h } = window;
      document.body.style.setProperty("position", "fixed", "important"), Object.assign(document.body.style, {
        top: `${-l.current}px`,
        left: `${-f}px`,
        right: "0px",
        height: "auto"
      }), window.setTimeout(() => window.requestAnimationFrame(() => {
        const v = h - window.innerHeight;
        v && l.current >= h && (document.body.style.top = `${-(l.current + v)}px`);
      }), 300);
    }
  }, [
    e
  ]), d = ye.useCallback(() => {
    if (bN() && Gd !== null && !i) {
      const f = -parseInt(document.body.style.top, 10), h = -parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, Gd), window.requestAnimationFrame(() => {
        if (o && a !== window.location.href) {
          c(window.location.href);
          return;
        }
        window.scrollTo(h, f);
      }), Gd = null;
    }
  }, [
    a
  ]);
  return ye.useEffect(() => {
    function f() {
      l.current = window.scrollY;
    }
    return f(), window.addEventListener("scroll", f), () => {
      window.removeEventListener("scroll", f);
    };
  }, []), ye.useEffect(() => {
    if (t)
      return () => {
        typeof document > "u" || document.querySelector("[data-vaul-drawer]") || d();
      };
  }, [
    t,
    d
  ]), ye.useEffect(() => {
    n || !r || (e ? (!window.matchMedia("(display-mode: standalone)").matches && u(), t || window.setTimeout(() => {
      d();
    }, 500)) : d());
  }, [
    e,
    r,
    a,
    t,
    n,
    u,
    d
  ]), {
    restorePositionSetting: d
  };
}
function YB({ open: e, onOpenChange: t, children: n, onDrag: r, onRelease: o, snapPoints: i, shouldScaleBackground: a = !1, setBackgroundColorOnScale: c = !0, closeThreshold: l = TSe, scrollLockTimeout: u = ESe, dismissible: d = !0, handleOnly: f = !1, fadeFromIndex: h = i && i.length - 1, activeSnapPoint: v, setActiveSnapPoint: y, fixed: g, modal: b = !0, onClose: x, nested: $, noBodyStyles: S = !1, direction: O = "bottom", defaultOpen: C = !1, disablePreventScroll: T = !0, snapToSequentialPoint: k = !1, preventScrollRestoration: I = !1, repositionInputs: P = !0, onAnimationEnd: _, container: A, autoFocus: D = !1 }) {
  var M, N;
  const [L = !1, z] = VB({
    defaultProp: C,
    prop: e,
    onChange: (Me) => {
      t == null || t(Me), !Me && !$ && xe(), setTimeout(() => {
        _ == null || _(Me);
      }, Tn.DURATION * 1e3), Me && !b && typeof window < "u" && window.requestAnimationFrame(() => {
        document.body.style.pointerEvents = "auto";
      }), Me || (document.body.style.pointerEvents = "auto");
    }
  }), [q, W] = ye.useState(!1), [U, K] = ye.useState(!1), [Y, X] = ye.useState(!1), oe = ye.useRef(null), re = ye.useRef(null), Z = ye.useRef(null), ce = ye.useRef(null), fe = ye.useRef(null), de = ye.useRef(!1), ne = ye.useRef(null), le = ye.useRef(0), ve = ye.useRef(!1), G = ye.useRef(!C), Se = ye.useRef(0), ue = ye.useRef(null), Q = ye.useRef(((M = ue.current) == null ? void 0 : M.getBoundingClientRect().height) || 0), ie = ye.useRef(((N = ue.current) == null ? void 0 : N.getBoundingClientRect().width) || 0), ee = ye.useRef(0), be = ye.useCallback((Me) => {
    i && Me === we.length - 1 && (re.current = /* @__PURE__ */ new Date());
  }, []), { activeSnapPoint: Ie, activeSnapPointIndex: je, setActiveSnapPoint: V, onRelease: se, snapPointsOffset: we, onDrag: J, shouldFade: he, getPercentageDragged: Te } = kSe({
    snapPoints: i,
    activeSnapPointProp: v,
    setActiveSnapPointProp: y,
    drawerRef: ue,
    fadeFromIndex: h,
    overlayRef: oe,
    onSnapPointChange: be,
    direction: O,
    container: A,
    snapToSequentialPoint: k
  });
  ySe({
    isDisabled: !L || U || !b || Y || !q || !P || !T
  });
  const { restorePositionSetting: xe } = ASe({
    isOpen: L,
    modal: b,
    nested: $ ?? !1,
    hasBeenOpened: q,
    preventScrollRestoration: I,
    noBodyStyles: S
  });
  function Ae() {
    return (window.innerWidth - tC) / window.innerWidth;
  }
  function Ce(Me) {
    var We, at;
    !d && !i || ue.current && !ue.current.contains(Me.target) || (Q.current = ((We = ue.current) == null ? void 0 : We.getBoundingClientRect().height) || 0, ie.current = ((at = ue.current) == null ? void 0 : at.getBoundingClientRect().width) || 0, K(!0), Z.current = /* @__PURE__ */ new Date(), FB() && window.addEventListener("touchend", () => de.current = !1, {
      once: !0
    }), Me.target.setPointerCapture(Me.pointerId), le.current = Vn(O) ? Me.pageY : Me.pageX);
  }
  function Ye(Me, We) {
    var at;
    let Je = Me;
    const ke = (at = window.getSelection()) == null ? void 0 : at.toString(), Qe = ue.current ? Em(ue.current, O) : null, ot = /* @__PURE__ */ new Date();
    if (Je.tagName === "SELECT" || Je.hasAttribute("data-vaul-no-drag") || Je.closest("[data-vaul-no-drag]"))
      return !1;
    if (O === "right" || O === "left")
      return !0;
    if (re.current && ot.getTime() - re.current.getTime() < 500)
      return !1;
    if (Qe !== null && (O === "bottom" ? Qe > 0 : Qe < 0))
      return !0;
    if (ke && ke.length > 0)
      return !1;
    if (fe.current && ot.getTime() - fe.current.getTime() < u && Qe === 0 || We)
      return fe.current = ot, !1;
    for (; Je; ) {
      if (Je.scrollHeight > Je.clientHeight) {
        if (Je.scrollTop !== 0)
          return fe.current = /* @__PURE__ */ new Date(), !1;
        if (Je.getAttribute("role") === "dialog")
          return !0;
      }
      Je = Je.parentNode;
    }
    return !0;
  }
  function He(Me) {
    if (ue.current && U) {
      const We = O === "bottom" || O === "right" ? 1 : -1, at = (le.current - (Vn(O) ? Me.pageY : Me.pageX)) * We, Je = at > 0, ke = i && !d && !Je;
      if (ke && je === 0) return;
      const Qe = Math.abs(at), ot = document.querySelector("[data-vaul-drawer-wrapper]"), Mt = O === "bottom" || O === "top" ? Q.current : ie.current;
      let Pt = Qe / Mt;
      const On = Te(Qe, Je);
      if (On !== null && (Pt = On), ke && Pt >= 1 || !de.current && !Ye(Me.target, Je)) return;
      if (ue.current.classList.add(G2), de.current = !0, Jn(ue.current, {
        transition: "none"
      }), Jn(oe.current, {
        transition: "none"
      }), i && J({
        draggedDistance: at
      }), Je && !i) {
        const gn = SSe(at), Kn = Math.min(gn * -1, 0) * We;
        Jn(ue.current, {
          transform: Vn(O) ? `translate3d(0, ${Kn}px, 0)` : `translate3d(${Kn}px, 0, 0)`
        });
        return;
      }
      const Hn = 1 - Pt;
      if ((he || h && je === h - 1) && (r == null || r(Me, Pt), Jn(oe.current, {
        opacity: `${Hn}`,
        transition: "none"
      }, !0)), ot && oe.current && a) {
        const gn = Math.min(Ae() + Pt * (1 - Ae()), 1), Kn = 8 - Pt * 8, To = Math.max(0, 14 - Pt * 14);
        Jn(ot, {
          borderRadius: `${Kn}px`,
          transform: Vn(O) ? `scale(${gn}) translate3d(0, ${To}px, 0)` : `scale(${gn}) translate3d(${To}px, 0, 0)`,
          transition: "none"
        }, !0);
      }
      if (!i) {
        const gn = Qe * We;
        Jn(ue.current, {
          transform: Vn(O) ? `translate3d(0, ${gn}px, 0)` : `translate3d(${gn}px, 0, 0)`
        });
      }
    }
  }
  ye.useEffect(() => {
    window.requestAnimationFrame(() => {
      G.current = !0;
    });
  }, []), ye.useEffect(() => {
    var Me;
    function We() {
      if (!ue.current || !P) return;
      const at = document.activeElement;
      if (eC(at) || ve.current) {
        var Je;
        const ke = ((Je = window.visualViewport) == null ? void 0 : Je.height) || 0, Qe = window.innerHeight;
        let ot = Qe - ke;
        const Mt = ue.current.getBoundingClientRect().height || 0, Pt = Mt > Qe * 0.8;
        ee.current || (ee.current = Mt);
        const On = ue.current.getBoundingClientRect().top;
        if (Math.abs(Se.current - ot) > 60 && (ve.current = !ve.current), i && i.length > 0 && we && je) {
          const Hn = we[je] || 0;
          ot += Hn;
        }
        if (Se.current = ot, Mt > ke || ve.current) {
          const Hn = ue.current.getBoundingClientRect().height;
          let gn = Hn;
          Hn > ke && (gn = ke - (Pt ? On : tC)), g ? ue.current.style.height = `${Hn - Math.max(ot, 0)}px` : ue.current.style.height = `${Math.max(gn, ke - On)}px`;
        } else dSe() || (ue.current.style.height = `${ee.current}px`);
        i && i.length > 0 && !ve.current ? ue.current.style.bottom = "0px" : ue.current.style.bottom = `${Math.max(ot, 0)}px`;
      }
    }
    return (Me = window.visualViewport) == null || Me.addEventListener("resize", We), () => {
      var at;
      return (at = window.visualViewport) == null ? void 0 : at.removeEventListener("resize", We);
    };
  }, [
    je,
    i,
    we
  ]);
  function Be(Me) {
    Ze(), x == null || x(), Me || z(!1), setTimeout(() => {
      i && V(i[0]);
    }, Tn.DURATION * 1e3);
  }
  function Xe() {
    if (!ue.current) return;
    const Me = document.querySelector("[data-vaul-drawer-wrapper]"), We = Em(ue.current, O);
    Jn(ue.current, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${Tn.DURATION}s cubic-bezier(${Tn.EASE.join(",")})`
    }), Jn(oe.current, {
      transition: `opacity ${Tn.DURATION}s cubic-bezier(${Tn.EASE.join(",")})`,
      opacity: "1"
    }), a && We && We > 0 && L && Jn(Me, {
      borderRadius: `${WB}px`,
      overflow: "hidden",
      ...Vn(O) ? {
        transform: `scale(${Ae()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top"
      } : {
        transform: `scale(${Ae()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
        transformOrigin: "left"
      },
      transitionProperty: "transform, border-radius",
      transitionDuration: `${Tn.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${Tn.EASE.join(",")})`
    }, !0);
  }
  function Ze() {
    !U || !ue.current || (ue.current.classList.remove(G2), de.current = !1, K(!1), ce.current = /* @__PURE__ */ new Date());
  }
  function Ne(Me) {
    if (!U || !ue.current) return;
    ue.current.classList.remove(G2), de.current = !1, K(!1), ce.current = /* @__PURE__ */ new Date();
    const We = Em(ue.current, O);
    if (!Me || !Ye(Me.target, !1) || !We || Number.isNaN(We) || Z.current === null) return;
    const at = ce.current.getTime() - Z.current.getTime(), Je = le.current - (Vn(O) ? Me.pageY : Me.pageX), ke = Math.abs(Je) / at;
    if (ke > 0.05 && (X(!0), setTimeout(() => {
      X(!1);
    }, 200)), i) {
      se({
        draggedDistance: Je * (O === "bottom" || O === "right" ? 1 : -1),
        closeDrawer: Be,
        velocity: ke,
        dismissible: d
      }), o == null || o(Me, !0);
      return;
    }
    if (O === "bottom" || O === "right" ? Je > 0 : Je < 0) {
      Xe(), o == null || o(Me, !0);
      return;
    }
    if (ke > UB) {
      Be(), o == null || o(Me, !1);
      return;
    }
    var Qe;
    const ot = Math.min((Qe = ue.current.getBoundingClientRect().height) != null ? Qe : 0, window.innerHeight);
    var Mt;
    const Pt = Math.min((Mt = ue.current.getBoundingClientRect().width) != null ? Mt : 0, window.innerWidth), On = O === "left" || O === "right";
    if (Math.abs(We) >= (On ? Pt : ot) * l) {
      Be(), o == null || o(Me, !1);
      return;
    }
    o == null || o(Me, !0), Xe();
  }
  ye.useEffect(() => (L && (Jn(document.documentElement, {
    scrollBehavior: "auto"
  }), re.current = /* @__PURE__ */ new Date()), () => {
    OSe(document.documentElement, "scrollBehavior");
  }), [
    L
  ]);
  function $e(Me) {
    const We = Me ? (window.innerWidth - fc) / window.innerWidth : 1, at = Me ? -fc : 0;
    ne.current && window.clearTimeout(ne.current), Jn(ue.current, {
      transition: `transform ${Tn.DURATION}s cubic-bezier(${Tn.EASE.join(",")})`,
      transform: Vn(O) ? `scale(${We}) translate3d(0, ${at}px, 0)` : `scale(${We}) translate3d(${at}px, 0, 0)`
    }), !Me && ue.current && (ne.current = setTimeout(() => {
      const Je = Em(ue.current, O);
      Jn(ue.current, {
        transition: "none",
        transform: Vn(O) ? `translate3d(0, ${Je}px, 0)` : `translate3d(${Je}px, 0, 0)`
      });
    }, 500));
  }
  function Ue(Me, We) {
    if (We < 0) return;
    const at = (window.innerWidth - fc) / window.innerWidth, Je = at + We * (1 - at), ke = -fc + We * fc;
    Jn(ue.current, {
      transform: Vn(O) ? `scale(${Je}) translate3d(0, ${ke}px, 0)` : `scale(${Je}) translate3d(${ke}px, 0, 0)`,
      transition: "none"
    });
  }
  function Ke(Me, We) {
    const at = Vn(O) ? window.innerHeight : window.innerWidth, Je = We ? (at - fc) / at : 1, ke = We ? -fc : 0;
    We && Jn(ue.current, {
      transition: `transform ${Tn.DURATION}s cubic-bezier(${Tn.EASE.join(",")})`,
      transform: Vn(O) ? `scale(${Je}) translate3d(0, ${ke}px, 0)` : `scale(${Je}) translate3d(${ke}px, 0, 0)`
    });
  }
  return ye.useEffect(() => {
    b || window.requestAnimationFrame(() => {
      document.body.style.pointerEvents = "auto";
    });
  }, [
    b
  ]), /* @__PURE__ */ ye.createElement(SB, {
    defaultOpen: C,
    onOpenChange: (Me) => {
      !d && !Me || (Me ? W(!0) : Be(!0), z(Me));
    },
    open: L
  }, /* @__PURE__ */ ye.createElement(jB.Provider, {
    value: {
      activeSnapPoint: Ie,
      snapPoints: i,
      setActiveSnapPoint: V,
      drawerRef: ue,
      overlayRef: oe,
      onOpenChange: t,
      onPress: Ce,
      onRelease: Ne,
      onDrag: He,
      dismissible: d,
      shouldAnimate: G,
      handleOnly: f,
      isOpen: L,
      isDragging: U,
      shouldFade: he,
      closeDrawer: Be,
      onNestedDrag: Ue,
      onNestedOpenChange: $e,
      onNestedRelease: Ke,
      keyboardIsOpen: ve,
      modal: b,
      snapPointsOffset: we,
      activeSnapPointIndex: je,
      direction: O,
      shouldScaleBackground: a,
      setBackgroundColorOnScale: c,
      noBodyStyles: S,
      container: A,
      autoFocus: D
    }
  }, n));
}
const GB = /* @__PURE__ */ ye.forwardRef(function({ ...e }, t) {
  const { overlayRef: n, snapPoints: r, onRelease: o, shouldFade: i, isOpen: a, modal: c, shouldAnimate: l } = ad(), u = BB(t, n), d = r && r.length > 0;
  if (!c)
    return null;
  const f = ye.useCallback((h) => o(h), [
    o
  ]);
  return /* @__PURE__ */ ye.createElement(kB, {
    onMouseUp: f,
    ref: u,
    "data-vaul-overlay": "",
    "data-vaul-snap-points": a && d ? "true" : "false",
    "data-vaul-snap-points-overlay": a && i ? "true" : "false",
    "data-vaul-animate": l != null && l.current ? "true" : "false",
    ...e
  });
});
GB.displayName = "Drawer.Overlay";
const KB = /* @__PURE__ */ ye.forwardRef(function({ onPointerDownOutside: e, style: t, onOpenAutoFocus: n, ...r }, o) {
  const { drawerRef: i, onPress: a, onRelease: c, onDrag: l, keyboardIsOpen: u, snapPointsOffset: d, activeSnapPointIndex: f, modal: h, isOpen: v, direction: y, snapPoints: g, container: b, handleOnly: x, shouldAnimate: $, autoFocus: S } = ad(), [O, C] = ye.useState(!1), T = BB(o, i), k = ye.useRef(null), I = ye.useRef(null), P = ye.useRef(!1), _ = g && g.length > 0;
  PSe();
  const A = (M, N, L = 0) => {
    if (P.current) return !0;
    const z = Math.abs(M.y), q = Math.abs(M.x), W = q > z, U = [
      "bottom",
      "right"
    ].includes(N) ? 1 : -1;
    if (N === "left" || N === "right") {
      if (!(M.x * U < 0) && q >= 0 && q <= L)
        return W;
    } else if (!(M.y * U < 0) && z >= 0 && z <= L)
      return !W;
    return P.current = !0, !0;
  };
  ye.useEffect(() => {
    _ && window.requestAnimationFrame(() => {
      C(!0);
    });
  }, []);
  function D(M) {
    k.current = null, P.current = !1, c(M);
  }
  return /* @__PURE__ */ ye.createElement(RB, {
    "data-vaul-drawer-direction": y,
    "data-vaul-drawer": "",
    "data-vaul-delayed-snap-points": O ? "true" : "false",
    "data-vaul-snap-points": v && _ ? "true" : "false",
    "data-vaul-custom-container": b ? "true" : "false",
    "data-vaul-animate": $ != null && $.current ? "true" : "false",
    ...r,
    ref: T,
    style: d && d.length > 0 ? {
      "--snap-point-height": `${d[f ?? 0]}px`,
      ...t
    } : t,
    onPointerDown: (M) => {
      x || (r.onPointerDown == null || r.onPointerDown.call(r, M), k.current = {
        x: M.pageX,
        y: M.pageY
      }, a(M));
    },
    onOpenAutoFocus: (M) => {
      n == null || n(M), S || M.preventDefault();
    },
    onPointerDownOutside: (M) => {
      if (e == null || e(M), !h || M.defaultPrevented) {
        M.preventDefault();
        return;
      }
      u.current && (u.current = !1);
    },
    onFocusOutside: (M) => {
      if (!h) {
        M.preventDefault();
        return;
      }
    },
    onPointerMove: (M) => {
      if (I.current = M, x || (r.onPointerMove == null || r.onPointerMove.call(r, M), !k.current)) return;
      const N = M.pageY - k.current.y, L = M.pageX - k.current.x, z = M.pointerType === "touch" ? 10 : 2;
      A({
        x: L,
        y: N
      }, y, z) ? l(M) : (Math.abs(L) > z || Math.abs(N) > z) && (k.current = null);
    },
    onPointerUp: (M) => {
      r.onPointerUp == null || r.onPointerUp.call(r, M), k.current = null, P.current = !1, c(M);
    },
    onPointerOut: (M) => {
      r.onPointerOut == null || r.onPointerOut.call(r, M), D(I.current);
    },
    onContextMenu: (M) => {
      r.onContextMenu == null || r.onContextMenu.call(r, M), I.current && D(I.current);
    }
  });
});
KB.displayName = "Drawer.Content";
const ISe = 250, MSe = 120, XB = /* @__PURE__ */ ye.forwardRef(function({ preventCycle: e = !1, children: t, ...n }, r) {
  const { closeDrawer: o, isDragging: i, snapPoints: a, activeSnapPoint: c, setActiveSnapPoint: l, dismissible: u, handleOnly: d, isOpen: f, onPress: h, onDrag: v } = ad(), y = ye.useRef(null), g = ye.useRef(!1);
  function b() {
    if (g.current) {
      S();
      return;
    }
    window.setTimeout(() => {
      x();
    }, MSe);
  }
  function x() {
    if (i || e || g.current) {
      S();
      return;
    }
    if (S(), !a || a.length === 0) {
      u || o();
      return;
    }
    if (c === a[a.length - 1] && u) {
      o();
      return;
    }
    const C = a.findIndex((k) => k === c);
    if (C === -1) return;
    const T = a[C + 1];
    l(T);
  }
  function $() {
    y.current = window.setTimeout(() => {
      g.current = !0;
    }, ISe);
  }
  function S() {
    y.current && window.clearTimeout(y.current), g.current = !1;
  }
  return /* @__PURE__ */ ye.createElement("div", {
    onClick: b,
    onPointerCancel: S,
    onPointerDown: (O) => {
      d && h(O), $();
    },
    onPointerMove: (O) => {
      d && v(O);
    },
    // onPointerUp is already handled by the content component
    ref: r,
    "data-vaul-drawer-visible": f ? "true" : "false",
    "data-vaul-handle": "",
    "aria-hidden": "true",
    ...n
  }, /* @__PURE__ */ ye.createElement("span", {
    "data-vaul-handle-hitarea": "",
    "aria-hidden": "true"
  }, t));
});
XB.displayName = "Drawer.Handle";
function NSe({ onDrag: e, onOpenChange: t, open: n, ...r }) {
  const { onNestedDrag: o, onNestedOpenChange: i, onNestedRelease: a } = ad();
  if (!o)
    throw new Error("Drawer.NestedRoot must be placed in another drawer");
  return /* @__PURE__ */ ye.createElement(YB, {
    nested: !0,
    open: n,
    onClose: () => {
      i(!1);
    },
    onDrag: (c, l) => {
      o(c, l), e == null || e(c, l);
    },
    onOpenChange: (c) => {
      c && i(c), t == null || t(c);
    },
    onRelease: a,
    ...r
  });
}
function DSe(e) {
  const t = ad(), { container: n = t.container, ...r } = e;
  return /* @__PURE__ */ ye.createElement(_B, {
    container: n,
    ...r
  });
}
const b9e = {
  Root: YB,
  NestedRoot: NSe,
  Content: KB,
  Overlay: GB,
  Trigger: TB,
  Portal: DSe,
  Handle: XB,
  Close: LB,
  Title: IB,
  Description: NB
};
/*!
 * OverlayScrollbars
 * Version: 2.10.1
 *
 * Copyright (c) Rene Haas | KingSora.
 * https://github.com/KingSora
 *
 * Released under the MIT license.
 */
const po = (e, t) => {
  const { o: n, i: r, u: o } = e;
  let i = n, a;
  const c = (d, f) => {
    const h = i, v = d, y = f || (r ? !r(h, v) : h !== v);
    return (y || o) && (i = v, a = h), [i, y, a];
  };
  return [t ? (d) => c(t(i, a), d) : c, (d) => [i, !!d, a]];
}, LSe = typeof window < "u" && typeof HTMLElement < "u" && !!window.document, Jr = LSe ? window : {}, ZB = Math.max, jSe = Math.min, nC = Math.round, c0 = Math.abs, ON = Math.sign, JB = Jr.cancelAnimationFrame, DE = Jr.requestAnimationFrame, l0 = Jr.setTimeout, rC = Jr.clearTimeout, Yv = (e) => typeof Jr[e] < "u" ? Jr[e] : void 0, FSe = Yv("MutationObserver"), SN = Yv("IntersectionObserver"), u0 = Yv("ResizeObserver"), fg = Yv("ScrollTimeline"), LE = (e) => e === void 0, Gv = (e) => e === null, ea = (e) => typeof e == "number", Bp = (e) => typeof e == "string", jE = (e) => typeof e == "boolean", ei = (e) => typeof e == "function", ua = (e) => Array.isArray(e), d0 = (e) => typeof e == "object" && !ua(e) && !Gv(e), FE = (e) => {
  const t = !!e && e.length, n = ea(t) && t > -1 && t % 1 == 0;
  return ua(e) || !ei(e) && n ? t > 0 && d0(e) ? t - 1 in e : !0 : !1;
}, f0 = (e) => !!e && e.constructor === Object, p0 = (e) => e instanceof HTMLElement, Kv = (e) => e instanceof Element;
function sn(e, t) {
  if (FE(e))
    for (let n = 0; n < e.length && t(e[n], n, e) !== !1; n++)
      ;
  else e && sn(Object.keys(e), (n) => t(e[n], n, e));
  return e;
}
const QB = (e, t) => e.indexOf(t) >= 0, op = (e, t) => e.concat(t), kn = (e, t, n) => (!Bp(t) && FE(t) ? Array.prototype.push.apply(e, t) : e.push(t), e), Ks = (e) => Array.from(e || []), zE = (e) => ua(e) ? e : !Bp(e) && FE(e) ? Ks(e) : [e], oC = (e) => !!e && !e.length, iC = (e) => Ks(new Set(e)), wo = (e, t, n) => {
  sn(e, (o) => o ? o.apply(void 0, t || []) : !0), !n && (e.length = 0);
}, eq = "paddingTop", tq = "paddingRight", nq = "paddingLeft", rq = "paddingBottom", oq = "marginLeft", iq = "marginRight", aq = "marginBottom", sq = "overflowX", cq = "overflowY", Xv = "width", Zv = "height", $s = "visible", kc = "hidden", Mu = "scroll", zSe = (e) => {
  const t = String(e || "");
  return t ? t[0].toUpperCase() + t.slice(1) : "";
}, Jv = (e, t, n, r) => {
  if (e && t) {
    let o = !0;
    return sn(n, (i) => {
      const a = e[i], c = t[i];
      a !== c && (o = !1);
    }), o;
  }
  return !1;
}, lq = (e, t) => Jv(e, t, ["w", "h"]), pg = (e, t) => Jv(e, t, ["x", "y"]), BSe = (e, t) => Jv(e, t, ["t", "r", "b", "l"]), jc = () => {
}, ht = (e, ...t) => e.bind(0, ...t), au = (e) => {
  let t;
  const n = e ? l0 : DE, r = e ? rC : JB;
  return [(o) => {
    r(t), t = n(() => o(), ei(e) ? e() : e);
  }, () => r(t)];
}, aC = (e, t) => {
  const { _: n, p: r, v: o, S: i } = t || {};
  let a, c, l, u, d = jc;
  const f = function(b) {
    d(), rC(a), u = a = c = void 0, d = jc, e.apply(this, b);
  }, h = (g) => i && c ? i(c, g) : g, v = () => {
    d !== jc && f(h(l) || l);
  }, y = function() {
    const b = Ks(arguments), x = ei(n) ? n() : n;
    if (ea(x) && x >= 0) {
      const S = ei(r) ? r() : r, O = ea(S) && S >= 0, C = x > 0 ? l0 : DE, T = x > 0 ? rC : JB, I = h(b) || b, P = f.bind(0, I);
      let _;
      d(), o && !u ? (P(), u = !0, _ = C(() => u = void 0, x)) : (_ = C(P, x), O && !a && (a = l0(v, S))), d = () => T(_), c = l = I;
    } else
      f(b);
  };
  return y.m = v, y;
}, uq = (e, t) => Object.prototype.hasOwnProperty.call(e, t), $i = (e) => e ? Object.keys(e) : [], qt = (e, t, n, r, o, i, a) => {
  const c = [t, n, r, o, i, a];
  return (typeof e != "object" || Gv(e)) && !ei(e) && (e = {}), sn(c, (l) => {
    sn(l, (u, d) => {
      const f = l[d];
      if (e === f)
        return !0;
      const h = ua(f);
      if (f && f0(f)) {
        const v = e[d];
        let y = v;
        h && !ua(v) ? y = [] : !h && !f0(v) && (y = {}), e[d] = qt(y, f);
      } else
        e[d] = h ? f.slice() : f;
    });
  }), e;
}, dq = (e, t) => sn(qt({}, e), (n, r, o) => {
  n === void 0 ? delete o[r] : n && f0(n) && (o[r] = dq(n));
}), BE = (e) => !$i(e).length, fq = (e, t, n) => ZB(e, jSe(t, n)), Fc = (e) => iC((ua(e) ? e : (e || "").split(" ")).filter((t) => t)), qE = (e, t) => e && e.getAttribute(t), CN = (e, t) => e && e.hasAttribute(t), ka = (e, t, n) => {
  sn(Fc(t), (r) => {
    e && e.setAttribute(r, String(n || ""));
  });
}, Di = (e, t) => {
  sn(Fc(t), (n) => e && e.removeAttribute(n));
}, Qv = (e, t) => {
  const n = Fc(qE(e, t)), r = ht(ka, e, t), o = (i, a) => {
    const c = new Set(n);
    return sn(Fc(i), (l) => {
      c[a](l);
    }), Ks(c).join(" ");
  };
  return {
    O: (i) => r(o(i, "delete")),
    $: (i) => r(o(i, "add")),
    C: (i) => {
      const a = Fc(i);
      return a.reduce((c, l) => c && n.includes(l), a.length > 0);
    }
  };
}, pq = (e, t, n) => (Qv(e, t).O(n), ht(UE, e, t, n)), UE = (e, t, n) => (Qv(e, t).$(n), ht(pq, e, t, n)), h0 = (e, t, n, r) => (r ? UE : pq)(e, t, n), WE = (e, t, n) => Qv(e, t).C(n), hq = (e) => Qv(e, "class"), mq = (e, t) => {
  hq(e).O(t);
}, HE = (e, t) => (hq(e).$(t), ht(mq, e, t)), gq = (e, t) => {
  const n = t ? Kv(t) && t : document;
  return n ? Ks(n.querySelectorAll(e)) : [];
}, qSe = (e, t) => {
  const n = t ? Kv(t) && t : document;
  return n && n.querySelector(e);
}, sC = (e, t) => Kv(e) && e.matches(t), vq = (e) => sC(e, "body"), cC = (e) => e ? Ks(e.childNodes) : [], ip = (e) => e && e.parentElement, su = (e, t) => Kv(e) && e.closest(t), lC = (e) => document.activeElement, USe = (e, t, n) => {
  const r = su(e, t), o = e && qSe(n, r), i = su(o, t) === r;
  return r && o ? r === e || o === e || i && su(su(e, n), t) !== r : !1;
}, Nu = (e) => {
  sn(zE(e), (t) => {
    const n = ip(t);
    t && n && n.removeChild(t);
  });
}, vo = (e, t) => ht(Nu, e && t && sn(zE(t), (n) => {
  n && e.appendChild(n);
})), gu = (e) => {
  const t = document.createElement("div");
  return ka(t, "class", e), t;
}, yq = (e) => {
  const t = gu();
  return t.innerHTML = e.trim(), sn(cC(t), (n) => Nu(n));
}, TN = (e, t) => e.getPropertyValue(t) || e[t] || "", bq = (e) => {
  const t = e || 0;
  return isFinite(t) ? t : 0;
}, _m = (e) => bq(parseFloat(e || "")), uC = (e) => Math.round(e * 1e4) / 1e4, xq = (e) => `${uC(bq(e))}px`;
function ap(e, t) {
  e && t && sn(t, (n, r) => {
    try {
      const o = e.style, i = Gv(n) || jE(n) ? "" : ea(n) ? xq(n) : n;
      r.indexOf("--") === 0 ? o.setProperty(r, i) : o[r] = i;
    } catch {
    }
  });
}
function Ua(e, t, n) {
  const r = Bp(t);
  let o = r ? "" : {};
  if (e) {
    const i = Jr.getComputedStyle(e, n) || e.style;
    o = r ? TN(i, t) : Ks(t).reduce((a, c) => (a[c] = TN(i, c), a), o);
  }
  return o;
}
const EN = (e, t, n) => {
  const r = t ? `${t}-` : "", o = n ? `-${n}` : "", i = `${r}top${o}`, a = `${r}right${o}`, c = `${r}bottom${o}`, l = `${r}left${o}`, u = Ua(e, [i, a, c, l]);
  return {
    t: _m(u[i]),
    r: _m(u[a]),
    b: _m(u[c]),
    l: _m(u[l])
  };
}, WSe = (e, t) => `translate${d0(e) ? `(${e.x},${e.y})` : `Y(${e})`}`, HSe = (e) => !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length), VSe = {
  w: 0,
  h: 0
}, ey = (e, t) => t ? {
  w: t[`${e}Width`],
  h: t[`${e}Height`]
} : VSe, YSe = (e) => ey("inner", e || Jr), vu = ht(ey, "offset"), wq = ht(ey, "client"), m0 = ht(ey, "scroll"), VE = (e) => {
  const t = parseFloat(Ua(e, Xv)) || 0, n = parseFloat(Ua(e, Zv)) || 0;
  return {
    w: t - nC(t),
    h: n - nC(n)
  };
}, K2 = (e) => e.getBoundingClientRect(), GSe = (e) => !!e && HSe(e), dC = (e) => !!(e && (e[Zv] || e[Xv])), $q = (e, t) => {
  const n = dC(e);
  return !dC(t) && n;
}, _N = (e, t, n, r) => {
  sn(Fc(t), (o) => {
    e && e.removeEventListener(o, n, r);
  });
}, xn = (e, t, n, r) => {
  var o;
  const i = (o = r && r.H) != null ? o : !0, a = r && r.I || !1, c = r && r.A || !1, l = {
    passive: i,
    capture: a
  };
  return ht(wo, Fc(t).map((u) => {
    const d = c ? (f) => {
      _N(e, u, d, a), n && n(f);
    } : n;
    return e && e.addEventListener(u, d, l), ht(_N, e, u, d, a);
  }));
}, Oq = (e) => e.stopPropagation(), fC = (e) => e.preventDefault(), Sq = (e) => Oq(e) || fC(e), Ki = (e, t) => {
  const { x: n, y: r } = ea(t) ? {
    x: t,
    y: t
  } : t || {};
  ea(n) && (e.scrollLeft = n), ea(r) && (e.scrollTop = r);
}, yo = (e) => ({
  x: e.scrollLeft,
  y: e.scrollTop
}), Cq = () => ({
  D: {
    x: 0,
    y: 0
  },
  M: {
    x: 0,
    y: 0
  }
}), KSe = (e, t) => {
  const { D: n, M: r } = e, { w: o, h: i } = t, a = (f, h, v) => {
    let y = ON(f) * v, g = ON(h) * v;
    if (y === g) {
      const b = c0(f), x = c0(h);
      g = b > x ? 0 : g, y = b < x ? 0 : y;
    }
    return y = y === g ? 0 : y, [y + 0, g + 0];
  }, [c, l] = a(n.x, r.x, o), [u, d] = a(n.y, r.y, i);
  return {
    D: {
      x: c,
      y: u
    },
    M: {
      x: l,
      y: d
    }
  };
}, kN = ({ D: e, M: t }) => {
  const n = (r, o) => r === 0 && r <= o;
  return {
    x: n(e.x, t.x),
    y: n(e.y, t.y)
  };
}, RN = ({ D: e, M: t }, n) => {
  const r = (o, i, a) => fq(0, 1, (o - a) / (o - i) || 0);
  return {
    x: r(e.x, t.x, n.x),
    y: r(e.y, t.y, n.y)
  };
}, pC = (e) => {
  e && e.focus && e.focus({
    preventScroll: !0
  });
}, PN = (e, t) => {
  sn(zE(t), e);
}, hC = (e) => {
  const t = /* @__PURE__ */ new Map(), n = (i, a) => {
    if (i) {
      const c = t.get(i);
      PN((l) => {
        c && c[l ? "delete" : "clear"](l);
      }, a);
    } else
      t.forEach((c) => {
        c.clear();
      }), t.clear();
  }, r = (i, a) => {
    if (Bp(i)) {
      const u = t.get(i) || /* @__PURE__ */ new Set();
      return t.set(i, u), PN((d) => {
        ei(d) && u.add(d);
      }, a), ht(n, i, a);
    }
    jE(a) && a && n();
    const c = $i(i), l = [];
    return sn(c, (u) => {
      const d = i[u];
      d && kn(l, r(u, d));
    }), ht(wo, l);
  }, o = (i, a) => {
    sn(Ks(t.get(i)), (c) => {
      a && !oC(a) ? c.apply(0, a) : c();
    });
  };
  return r(e || {}), [r, n, o];
}, Tq = {}, Eq = {}, XSe = (e) => {
  sn(e, (t) => sn(t, (n, r) => {
    Tq[r] = t[r];
  }));
}, _q = (e, t, n) => $i(e).map((r) => {
  const { static: o, instance: i } = e[r], [a, c, l] = n || [], u = n ? i : o;
  if (u) {
    const d = n ? u(a, c, t) : u(t);
    return (l || Eq)[r] = d;
  }
}), qp = (e) => Eq[e], ZSe = "__osOptionsValidationPlugin", sd = "data-overlayscrollbars", hg = "os-environment", km = `${hg}-scrollbar-hidden`, X2 = `${sd}-initialize`, mg = "noClipping", AN = `${sd}-body`, Is = sd, JSe = "host", Ra = `${sd}-viewport`, QSe = sq, eCe = cq, tCe = "arrange", kq = "measuring", nCe = "scrolling", Rq = "scrollbarHidden", rCe = "noContent", mC = `${sd}-padding`, IN = `${sd}-content`, YE = "os-size-observer", oCe = `${YE}-appear`, iCe = `${YE}-listener`, aCe = "os-trinsic-observer", sCe = "os-theme-none", Co = "os-scrollbar", cCe = `${Co}-rtl`, lCe = `${Co}-horizontal`, uCe = `${Co}-vertical`, Pq = `${Co}-track`, GE = `${Co}-handle`, dCe = `${Co}-visible`, fCe = `${Co}-cornerless`, MN = `${Co}-interaction`, NN = `${Co}-unusable`, gC = `${Co}-auto-hide`, DN = `${gC}-hidden`, LN = `${Co}-wheel`, pCe = `${Pq}-interactive`, hCe = `${GE}-interactive`, mCe = "__osSizeObserverPlugin", gCe = (e, t) => {
  const { T: n } = t, [r, o] = e("showNativeOverlaidScrollbars");
  return [r && n.x && n.y, o];
}, Du = (e) => e.indexOf($s) === 0, vCe = (e, t) => {
  const n = (o, i, a, c) => {
    const l = o === $s ? kc : o.replace(`${$s}-`, ""), u = Du(o), d = Du(a);
    return !i && !c ? kc : u && d ? $s : u ? i && c ? l : i ? $s : kc : i ? l : d && c ? $s : kc;
  }, r = {
    x: n(t.x, e.x, t.y, e.y),
    y: n(t.y, e.y, t.x, e.x)
  };
  return {
    k: r,
    R: {
      x: r.x === Mu,
      y: r.y === Mu
    }
  };
}, Aq = "__osScrollbarsHidingPlugin", yCe = "__osClickScrollPlugin", jN = (e) => JSON.stringify(e, (t, n) => {
  if (ei(n))
    throw 0;
  return n;
}), FN = (e, t) => e ? `${t}`.split(".").reduce((n, r) => n && uq(n, r) ? n[r] : void 0, e) : void 0, bCe = {
  paddingAbsolute: !1,
  showNativeOverlaidScrollbars: !1,
  update: {
    elementEvents: [["img", "load"]],
    debounce: [0, 33],
    attributes: null,
    ignoreMutation: null
  },
  overflow: {
    x: "scroll",
    y: "scroll"
  },
  scrollbars: {
    theme: "os-theme-dark",
    visibility: "auto",
    autoHide: "never",
    autoHideDelay: 1300,
    autoHideSuspend: !1,
    dragScroll: !0,
    clickScroll: !1,
    pointers: ["mouse", "touch", "pen"]
  }
}, Iq = (e, t) => {
  const n = {}, r = op($i(t), $i(e));
  return sn(r, (o) => {
    const i = e[o], a = t[o];
    if (d0(i) && d0(a))
      qt(n[o] = {}, Iq(i, a)), BE(n[o]) && delete n[o];
    else if (uq(t, o) && a !== i) {
      let c = !0;
      if (ua(i) || ua(a))
        try {
          jN(i) === jN(a) && (c = !1);
        } catch {
        }
      c && (n[o] = a);
    }
  }), n;
}, zN = (e, t, n) => (r) => [FN(e, r), n || FN(t, r) !== void 0];
let Mq;
const xCe = () => Mq, wCe = (e) => {
  Mq = e;
};
let Z2;
const $Ce = () => {
  const e = (O, C, T) => {
    vo(document.body, O), vo(document.body, O);
    const k = wq(O), I = vu(O), P = VE(C);
    return T && Nu(O), {
      x: I.h - k.h + P.h,
      y: I.w - k.w + P.w
    };
  }, t = (O) => {
    let C = !1;
    const T = HE(O, km);
    try {
      C = Ua(O, "scrollbar-width") === "none" || Ua(O, "display", "::-webkit-scrollbar") === "none";
    } catch {
    }
    return T(), C;
  }, n = `.${hg}{scroll-behavior:auto!important;position:fixed;opacity:0;visibility:hidden;overflow:scroll;height:200px;width:200px;z-index:-1}.${hg} div{width:200%;height:200%;margin:10px 0}.${km}{scrollbar-width:none!important}.${km}::-webkit-scrollbar,.${km}::-webkit-scrollbar-corner{appearance:none!important;display:none!important;width:0!important;height:0!important}`, o = yq(`<div class="${hg}"><div></div><style>${n}</style></div>`)[0], i = o.firstChild, a = o.lastChild, c = xCe();
  c && (a.nonce = c);
  const [l, , u] = hC(), [d, f] = po({
    o: e(o, i),
    i: pg
  }, ht(e, o, i, !0)), [h] = f(), v = t(o), y = {
    x: h.x === 0,
    y: h.y === 0
  }, g = {
    elements: {
      host: null,
      padding: !v,
      viewport: (O) => v && vq(O) && O,
      content: !1
    },
    scrollbars: {
      slot: !0
    },
    cancel: {
      nativeScrollbarsOverlaid: !1,
      body: null
    }
  }, b = qt({}, bCe), x = ht(qt, {}, b), $ = ht(qt, {}, g), S = {
    N: h,
    T: y,
    P: v,
    G: !!fg,
    K: ht(l, "r"),
    Z: $,
    tt: (O) => qt(g, O) && $(),
    nt: x,
    ot: (O) => qt(b, O) && x(),
    st: qt({}, g),
    et: qt({}, b)
  };
  if (Di(o, "style"), Nu(o), xn(Jr, "resize", () => {
    u("r", []);
  }), ei(Jr.matchMedia) && !v && (!y.x || !y.y)) {
    const O = (C) => {
      const T = Jr.matchMedia(`(resolution: ${Jr.devicePixelRatio}dppx)`);
      xn(T, "change", () => {
        C(), O(C);
      }, {
        A: !0
      });
    };
    O(() => {
      const [C, T] = d();
      qt(S.N, C), u("r", [T]);
    });
  }
  return S;
}, ma = () => (Z2 || (Z2 = $Ce()), Z2), OCe = (e, t, n) => {
  let r = !1;
  const o = n ? /* @__PURE__ */ new WeakMap() : !1, i = () => {
    r = !0;
  }, a = (c) => {
    if (o && n) {
      const l = n.map((u) => {
        const [d, f] = u || [];
        return [f && d ? (c || gq)(d, e) : [], f];
      });
      sn(l, (u) => sn(u[0], (d) => {
        const f = u[1], h = o.get(d) || [];
        if (e.contains(d) && f) {
          const y = xn(d, f, (g) => {
            r ? (y(), o.delete(d)) : t(g);
          });
          o.set(d, kn(h, y));
        } else
          wo(h), o.delete(d);
      }));
    }
  };
  return a(), [i, a];
}, BN = (e, t, n, r) => {
  let o = !1;
  const { ct: i, rt: a, lt: c, it: l, ut: u, _t: d } = r || {}, f = aC(() => o && n(!0), {
    _: 33,
    p: 99
  }), [h, v] = OCe(e, f, c), y = i || [], g = a || [], b = op(y, g), x = (S, O) => {
    if (!oC(O)) {
      const C = u || jc, T = d || jc, k = [], I = [];
      let P = !1, _ = !1;
      if (sn(O, (A) => {
        const { attributeName: D, target: M, type: N, oldValue: L, addedNodes: z, removedNodes: q } = A, W = N === "attributes", U = N === "childList", K = e === M, Y = W && D, X = Y && qE(M, D || ""), oe = Bp(X) ? X : null, re = Y && L !== oe, Z = QB(g, D) && re;
        if (t && (U || !K)) {
          const ce = W && re, fe = ce && l && sC(M, l), ne = (fe ? !C(M, D, L, oe) : !W || ce) && !T(A, !!fe, e, r);
          sn(z, (le) => kn(k, le)), sn(q, (le) => kn(k, le)), _ = _ || ne;
        }
        !t && K && re && !C(M, D, L, oe) && (kn(I, D), P = P || Z);
      }), v((A) => iC(k).reduce((D, M) => (kn(D, gq(A, M)), sC(M, A) ? kn(D, M) : D), [])), t)
        return !S && _ && n(!1), [!1];
      if (!oC(I) || P) {
        const A = [iC(I), P];
        return !S && n.apply(0, A), A;
      }
    }
  }, $ = new FSe(ht(x, !1));
  return [() => ($.observe(e, {
    attributes: !0,
    attributeOldValue: !0,
    attributeFilter: b,
    subtree: t,
    childList: t,
    characterData: t
  }), o = !0, () => {
    o && (h(), $.disconnect(), o = !1);
  }), () => {
    if (o)
      return f.m(), x(!0, $.takeRecords());
  }];
}, Nq = (e, t, n) => {
  const { dt: r } = n || {}, o = qp(mCe), [i] = po({
    o: !1,
    u: !0
  });
  return () => {
    const a = [], l = yq(`<div class="${YE}"><div class="${iCe}"></div></div>`)[0], u = l.firstChild, d = (f) => {
      const h = f instanceof ResizeObserverEntry;
      let v = !1, y = !1;
      if (h) {
        const [g, , b] = i(f.contentRect), x = dC(g);
        y = $q(g, b), v = !y && !x;
      } else
        y = f === !0;
      v || t({
        ft: !0,
        dt: y
      });
    };
    if (u0) {
      const f = new u0((h) => d(h.pop()));
      f.observe(u), kn(a, () => {
        f.disconnect();
      });
    } else if (o) {
      const [f, h] = o(u, d, r);
      kn(a, op([HE(l, oCe), xn(l, "animationstart", f)], h));
    } else
      return jc;
    return ht(wo, kn(a, vo(e, l)));
  };
}, SCe = (e, t) => {
  let n;
  const r = (l) => l.h === 0 || l.isIntersecting || l.intersectionRatio > 0, o = gu(aCe), [i] = po({
    o: !1
  }), a = (l, u) => {
    if (l) {
      const d = i(r(l)), [, f] = d;
      return f && !u && t(d) && [d];
    }
  }, c = (l, u) => a(u.pop(), l);
  return [() => {
    const l = [];
    if (SN)
      n = new SN(ht(c, !1), {
        root: e
      }), n.observe(o), kn(l, () => {
        n.disconnect();
      });
    else {
      const u = () => {
        const d = vu(o);
        a(d);
      };
      kn(l, Nq(o, u)()), u();
    }
    return ht(wo, kn(l, vo(e, o)));
  }, () => n && c(!0, n.takeRecords())];
}, CCe = (e, t, n, r) => {
  let o, i, a, c, l, u;
  const d = `[${Is}]`, f = `[${Ra}]`, h = ["id", "class", "style", "open", "wrap", "cols", "rows"], { vt: v, ht: y, U: g, gt: b, bt: x, L: $, wt: S, yt: O, St: C, Ot: T } = e, k = (Z) => Ua(Z, "direction") === "rtl", I = {
    $t: !1,
    F: k(v)
  }, P = ma(), _ = qp(Aq), [A] = po({
    i: lq,
    o: {
      w: 0,
      h: 0
    }
  }, () => {
    const Z = _ && _.V(e, t, I, P, n).X, fe = !(S && $) && WE(y, Is, mg), de = !$ && O(tCe), ne = de && yo(b), le = ne && T(), ve = C(kq, fe), G = de && Z && Z()[0], Se = m0(g), ue = VE(g);
    return G && G(), Ki(b, ne), le && le(), fe && ve(), {
      w: Se.w + ue.w,
      h: Se.h + ue.h
    };
  }), D = aC(r, {
    _: () => o,
    p: () => i,
    S(Z, ce) {
      const [fe] = Z, [de] = ce;
      return [op($i(fe), $i(de)).reduce((ne, le) => (ne[le] = fe[le] || de[le], ne), {})];
    }
  }), M = (Z) => {
    const ce = k(v);
    qt(Z, {
      Ct: u !== ce
    }), qt(I, {
      F: ce
    }), u = ce;
  }, N = (Z, ce) => {
    const [fe, de] = Z, ne = {
      xt: de
    };
    return qt(I, {
      $t: fe
    }), !ce && r(ne), ne;
  }, L = ({ ft: Z, dt: ce }) => {
    const de = !(Z && !ce) && P.P ? D : r, ne = {
      ft: Z || ce,
      dt: ce
    };
    M(ne), de(ne);
  }, z = (Z, ce) => {
    const [, fe] = A(), de = {
      Ht: fe
    };
    return M(de), fe && !ce && (Z ? r : D)(de), de;
  }, q = (Z, ce, fe) => {
    const de = {
      Et: ce
    };
    return M(de), ce && !fe && D(de), de;
  }, [W, U] = x ? SCe(y, N) : [], K = !$ && Nq(y, L, {
    dt: !0
  }), [Y, X] = BN(y, !1, q, {
    rt: h,
    ct: h
  }), oe = $ && u0 && new u0((Z) => {
    const ce = Z[Z.length - 1].contentRect;
    L({
      ft: !0,
      dt: $q(ce, l)
    }), l = ce;
  }), re = aC(() => {
    const [, Z] = A();
    r({
      Ht: Z
    });
  }, {
    _: 222,
    v: !0
  });
  return [() => {
    oe && oe.observe(y);
    const Z = K && K(), ce = W && W(), fe = Y(), de = P.K((ne) => {
      ne ? D({
        zt: ne
      }) : re();
    });
    return () => {
      oe && oe.disconnect(), Z && Z(), ce && ce(), c && c(), fe(), de();
    };
  }, ({ It: Z, At: ce, Dt: fe }) => {
    const de = {}, [ne] = Z("update.ignoreMutation"), [le, ve] = Z("update.attributes"), [G, Se] = Z("update.elementEvents"), [ue, Q] = Z("update.debounce"), ie = Se || ve, ee = ce || fe, be = (Ie) => ei(ne) && ne(Ie);
    if (ie) {
      a && a(), c && c();
      const [Ie, je] = BN(x || g, !0, z, {
        ct: op(h, le || []),
        lt: G,
        it: d,
        _t: (V, se) => {
          const { target: we, attributeName: J } = V;
          return (!se && J && !$ ? USe(we, d, f) : !1) || !!su(we, `.${Co}`) || !!be(V);
        }
      });
      c = Ie(), a = je;
    }
    if (Q)
      if (D.m(), ua(ue)) {
        const Ie = ue[0], je = ue[1];
        o = ea(Ie) && Ie, i = ea(je) && je;
      } else ea(ue) ? (o = ue, i = !1) : (o = !1, i = !1);
    if (ee) {
      const Ie = X(), je = U && U(), V = a && a();
      Ie && qt(de, q(Ie[0], Ie[1], ee)), je && qt(de, N(je[0], ee)), V && qt(de, z(V[0], ee));
    }
    return M(de), de;
  }, I];
}, Dq = (e, t) => ei(t) ? t.apply(0, e) : t, TCe = (e, t, n, r) => {
  const o = LE(r) ? n : r;
  return Dq(e, o) || t.apply(0, e);
}, Lq = (e, t, n, r) => {
  const o = LE(r) ? n : r, i = Dq(e, o);
  return !!i && (p0(i) ? i : t.apply(0, e));
}, ECe = (e, t) => {
  const { nativeScrollbarsOverlaid: n, body: r } = t || {}, { T: o, P: i, Z: a } = ma(), { nativeScrollbarsOverlaid: c, body: l } = a().cancel, u = n ?? c, d = LE(r) ? l : r, f = (o.x || o.y) && u, h = e && (Gv(d) ? !i : d);
  return !!f || !!h;
}, _Ce = (e, t, n, r) => {
  const o = "--os-viewport-percent", i = "--os-scroll-percent", a = "--os-scroll-direction", { Z: c } = ma(), { scrollbars: l } = c(), { slot: u } = l, { vt: d, ht: f, U: h, Mt: v, gt: y, wt: g, L: b } = t, { scrollbars: x } = v ? {} : e, { slot: $ } = x || {}, S = [], O = [], C = [], T = Lq([d, f, h], () => b && g ? d : f, u, $), k = (Y) => {
    if (fg) {
      const X = new fg({
        source: y,
        axis: Y
      });
      return {
        kt: (re) => {
          const Z = re.Tt.animate({
            clear: ["left"],
            [i]: [0, 1]
          }, {
            timeline: X
          });
          return () => Z.cancel();
        }
      };
    }
  }, I = {
    x: k("x"),
    y: k("y")
  }, P = () => {
    const { Rt: Y, Vt: X } = n, oe = (re, Z) => fq(0, 1, re / (re + Z) || 0);
    return {
      x: oe(X.x, Y.x),
      y: oe(X.y, Y.y)
    };
  }, _ = (Y, X, oe) => {
    const re = oe ? HE : mq;
    sn(Y, (Z) => {
      re(Z.Tt, X);
    });
  }, A = (Y, X) => {
    sn(Y, (oe) => {
      const [re, Z] = X(oe);
      ap(re, Z);
    });
  }, D = (Y, X, oe) => {
    const re = jE(oe), Z = re ? oe : !0, ce = re ? !oe : !0;
    Z && _(O, Y, X), ce && _(C, Y, X);
  }, M = () => {
    const Y = P(), X = (oe) => (re) => [re.Tt, {
      [o]: uC(oe) + ""
    }];
    A(O, X(Y.x)), A(C, X(Y.y));
  }, N = () => {
    if (!fg) {
      const { Lt: Y } = n, X = RN(Y, yo(y)), oe = (re) => (Z) => [Z.Tt, {
        [i]: uC(re) + ""
      }];
      A(O, oe(X.x)), A(C, oe(X.y));
    }
  }, L = () => {
    const { Lt: Y } = n, X = kN(Y), oe = (re) => (Z) => [Z.Tt, {
      [a]: re ? "0" : "1"
    }];
    A(O, oe(X.x)), A(C, oe(X.y));
  }, z = () => {
    if (b && !g) {
      const { Rt: Y, Lt: X } = n, oe = kN(X), re = RN(X, yo(y)), Z = (ce) => {
        const { Tt: fe } = ce, de = ip(fe) === h && fe, ne = (le, ve, G) => {
          const Se = ve * le;
          return xq(G ? Se : -Se);
        };
        return [de, de && {
          transform: WSe({
            x: ne(re.x, Y.x, oe.x),
            y: ne(re.y, Y.y, oe.y)
          })
        }];
      };
      A(O, Z), A(C, Z);
    }
  }, q = (Y) => {
    const X = Y ? "x" : "y", re = gu(`${Co} ${Y ? lCe : uCe}`), Z = gu(Pq), ce = gu(GE), fe = {
      Tt: re,
      Ut: Z,
      Pt: ce
    }, de = I[X];
    return kn(Y ? O : C, fe), kn(S, [vo(re, Z), vo(Z, ce), ht(Nu, re), de && de.kt(fe), r(fe, D, Y)]), fe;
  }, W = ht(q, !0), U = ht(q, !1), K = () => (vo(T, O[0].Tt), vo(T, C[0].Tt), ht(wo, S));
  return W(), U(), [{
    Nt: M,
    qt: N,
    Bt: L,
    Ft: z,
    jt: D,
    Yt: {
      Wt: O,
      Xt: W,
      Jt: ht(A, O)
    },
    Gt: {
      Wt: C,
      Xt: U,
      Jt: ht(A, C)
    }
  }, K];
}, kCe = (e, t, n, r) => (o, i, a) => {
  const { ht: c, U: l, L: u, gt: d, Kt: f, Ot: h } = t, { Tt: v, Ut: y, Pt: g } = o, [b, x] = au(333), [$, S] = au(444), O = (k) => {
    ei(d.scrollBy) && d.scrollBy({
      behavior: "smooth",
      left: k.x,
      top: k.y
    });
  }, C = () => {
    const k = "pointerup pointercancel lostpointercapture", I = `client${a ? "X" : "Y"}`, P = a ? Xv : Zv, _ = a ? "left" : "top", A = a ? "w" : "h", D = a ? "x" : "y", M = (L, z) => (q) => {
      const { Rt: W } = n, U = vu(y)[A] - vu(g)[A], Y = z * q / U * W[D];
      Ki(d, {
        [D]: L + Y
      });
    }, N = [];
    return xn(y, "pointerdown", (L) => {
      const z = su(L.target, `.${GE}`) === g, q = z ? g : y, W = e.scrollbars, U = W[z ? "dragScroll" : "clickScroll"], { button: K, isPrimary: Y, pointerType: X } = L, { pointers: oe } = W;
      if (K === 0 && Y && U && (oe || []).includes(X)) {
        wo(N), S();
        const Z = !z && (L.shiftKey || U === "instant"), ce = ht(K2, g), fe = ht(K2, y), de = (se, we) => (se || ce())[_] - (we || fe())[_], ne = nC(K2(d)[P]) / vu(d)[A] || 1, le = M(yo(d)[D], 1 / ne), ve = L[I], G = ce(), Se = fe(), ue = G[P], Q = de(G, Se) + ue / 2, ie = ve - Se[_], ee = z ? 0 : ie - Q, be = (se) => {
          wo(V), q.releasePointerCapture(se.pointerId);
        }, Ie = z || Z, je = h(), V = [xn(f, k, be), xn(f, "selectstart", (se) => fC(se), {
          H: !1
        }), xn(y, k, be), Ie && xn(y, "pointermove", (se) => le(ee + (se[I] - ve))), Ie && (() => {
          const se = yo(d);
          je();
          const we = yo(d), J = {
            x: we.x - se.x,
            y: we.y - se.y
          };
          (c0(J.x) > 3 || c0(J.y) > 3) && (h(), Ki(d, se), O(J), $(je));
        })];
        if (q.setPointerCapture(L.pointerId), Z)
          le(ee);
        else if (!z) {
          const se = qp(yCe);
          if (se) {
            const we = se(le, ee, ue, (J) => {
              J ? je() : kn(V, je);
            });
            kn(V, we), kn(N, ht(we, !0));
          }
        }
      }
    });
  };
  let T = !0;
  return ht(wo, [xn(g, "pointermove pointerleave", r), xn(v, "pointerenter", () => {
    i(MN, !0);
  }), xn(v, "pointerleave pointercancel", () => {
    i(MN, !1);
  }), !u && xn(v, "mousedown", () => {
    const k = lC();
    (CN(k, Ra) || CN(k, Is) || k === document.body) && l0(ht(pC, l), 25);
  }), xn(v, "wheel", (k) => {
    const { deltaX: I, deltaY: P, deltaMode: _ } = k;
    T && _ === 0 && ip(v) === c && O({
      x: I,
      y: P
    }), T = !1, i(LN, !0), b(() => {
      T = !0, i(LN);
    }), fC(k);
  }, {
    H: !1,
    I: !0
  }), xn(v, "pointerdown", ht(xn, f, "click", Sq, {
    A: !0,
    I: !0,
    H: !1
  }), {
    I: !0
  }), C(), x, S]);
}, RCe = (e, t, n, r, o, i) => {
  let a, c, l, u, d, f = jc, h = 0;
  const v = ["mouse", "pen"], y = (X) => v.includes(X.pointerType), [g, b] = au(), [x, $] = au(100), [S, O] = au(100), [C, T] = au(() => h), [k, I] = _Ce(e, o, r, kCe(t, o, r, (X) => y(X) && W())), { ht: P, Qt: _, wt: A } = o, { jt: D, Nt: M, qt: N, Bt: L, Ft: z } = k, q = (X, oe) => {
    if (T(), X)
      D(DN);
    else {
      const re = ht(D, DN, !0);
      h > 0 && !oe ? C(re) : re();
    }
  }, W = () => {
    (l ? !a : !u) && (q(!0), x(() => {
      q(!1);
    }));
  }, U = (X) => {
    D(gC, X, !0), D(gC, X, !1);
  }, K = (X) => {
    y(X) && (a = l, l && q(!0));
  }, Y = [T, $, O, b, () => f(), xn(P, "pointerover", K, {
    A: !0
  }), xn(P, "pointerenter", K), xn(P, "pointerleave", (X) => {
    y(X) && (a = !1, l && q(!1));
  }), xn(P, "pointermove", (X) => {
    y(X) && c && W();
  }), xn(_, "scroll", (X) => {
    g(() => {
      N(), W();
    }), i(X), z();
  })];
  return [() => ht(wo, kn(Y, I())), ({ It: X, Dt: oe, Zt: re, tn: Z }) => {
    const { nn: ce, sn: fe, en: de, cn: ne } = Z || {}, { Ct: le, dt: ve } = re || {}, { F: G } = n, { T: Se } = ma(), { k: ue, rn: Q } = r, [ie, ee] = X("showNativeOverlaidScrollbars"), [be, Ie] = X("scrollbars.theme"), [je, V] = X("scrollbars.visibility"), [se, we] = X("scrollbars.autoHide"), [J, he] = X("scrollbars.autoHideSuspend"), [Te] = X("scrollbars.autoHideDelay"), [xe, Ae] = X("scrollbars.dragScroll"), [Ce, Ye] = X("scrollbars.clickScroll"), [He, Be] = X("overflow"), Xe = ve && !oe, Ze = Q.x || Q.y, Ne = ce || fe || ne || le || oe, $e = de || V || Be, Ue = ie && Se.x && Se.y, Ke = (Me, We, at) => {
      const Je = Me.includes(Mu) && (je === $s || je === "auto" && We === Mu);
      return D(dCe, Je, at), Je;
    };
    if (h = Te, Xe && (J && Ze ? (U(!1), f(), S(() => {
      f = xn(_, "scroll", ht(U, !0), {
        A: !0
      });
    })) : U(!0)), ee && D(sCe, Ue), Ie && (D(d), D(be, !0), d = be), he && !J && U(!0), we && (c = se === "move", l = se === "leave", u = se === "never", q(u, !0)), Ae && D(hCe, xe), Ye && D(pCe, !!Ce), $e) {
      const Me = Ke(He.x, ue.x, !0), We = Ke(He.y, ue.y, !1);
      D(fCe, !(Me && We));
    }
    Ne && (N(), M(), z(), ne && L(), D(NN, !Q.x, !0), D(NN, !Q.y, !1), D(cCe, G && !A));
  }, {}, k];
}, PCe = (e) => {
  const t = ma(), { Z: n, P: r } = t, { elements: o } = n(), { padding: i, viewport: a, content: c } = o, l = p0(e), u = l ? {} : e, { elements: d } = u, { padding: f, viewport: h, content: v } = d || {}, y = l ? e : u.target, g = vq(y), b = y.ownerDocument, x = b.documentElement, $ = () => b.defaultView || Jr, S = ht(TCe, [y]), O = ht(Lq, [y]), C = ht(gu, ""), T = ht(S, C, a), k = ht(O, C, c), I = (ue) => {
    const Q = vu(ue), ie = m0(ue), ee = Ua(ue, sq), be = Ua(ue, cq);
    return ie.w - Q.w > 0 && !Du(ee) || ie.h - Q.h > 0 && !Du(be);
  }, P = T(h), _ = P === y, A = _ && g, D = !_ && k(v), M = !_ && P === D, N = A ? x : P, L = A ? N : y, z = !_ && O(C, i, f), q = !M && D, W = [q, N, z, L].map((ue) => p0(ue) && !ip(ue) && ue), U = (ue) => ue && QB(W, ue), K = !U(N) && I(N) ? N : y, Y = A ? x : N, oe = {
    vt: y,
    ht: L,
    U: N,
    ln: z,
    bt: q,
    gt: Y,
    Qt: A ? b : N,
    an: g ? x : K,
    Kt: b,
    wt: g,
    Mt: l,
    L: _,
    un: $,
    yt: (ue) => WE(N, Ra, ue),
    St: (ue, Q) => h0(N, Ra, ue, Q),
    Ot: () => h0(Y, Ra, nCe, !0)
  }, { vt: re, ht: Z, ln: ce, U: fe, bt: de } = oe, ne = [() => {
    Di(Z, [Is, X2]), Di(re, X2), g && Di(x, [X2, Is]);
  }];
  let le = cC([de, fe, ce, Z, re].find((ue) => ue && !U(ue)));
  const ve = A ? re : de || fe, G = ht(wo, ne);
  return [oe, () => {
    const ue = $(), Q = lC(), ie = (V) => {
      vo(ip(V), cC(V)), Nu(V);
    }, ee = (V) => xn(V, "focusin focusout focus blur", Sq, {
      I: !0,
      H: !1
    }), be = "tabindex", Ie = qE(fe, be), je = ee(Q);
    return ka(Z, Is, _ ? "" : JSe), ka(ce, mC, ""), ka(fe, Ra, ""), ka(de, IN, ""), _ || (ka(fe, be, Ie || "-1"), g && ka(x, AN, "")), vo(ve, le), vo(Z, ce), vo(ce || Z, !_ && fe), vo(fe, de), kn(ne, [je, () => {
      const V = lC(), se = U(fe), we = se && V === fe ? re : V, J = ee(we);
      Di(ce, mC), Di(de, IN), Di(fe, Ra), g && Di(x, AN), Ie ? ka(fe, be, Ie) : Di(fe, be), U(de) && ie(de), se && ie(fe), U(ce) && ie(ce), pC(we), J();
    }]), r && !_ && (UE(fe, Ra, Rq), kn(ne, ht(Di, fe, Ra))), pC(!_ && g && Q === re && ue.top === ue ? fe : Q), je(), le = 0, G;
  }, G];
}, ACe = ({ bt: e }) => ({ Zt: t, _n: n, Dt: r }) => {
  const { xt: o } = t || {}, { $t: i } = n;
  e && (o || r) && ap(e, {
    [Zv]: i && "100%"
  });
}, ICe = ({ ht: e, ln: t, U: n, L: r }, o) => {
  const [i, a] = po({
    i: BSe,
    o: EN()
  }, ht(EN, e, "padding", ""));
  return ({ It: c, Zt: l, _n: u, Dt: d }) => {
    let [f, h] = a(d);
    const { P: v } = ma(), { ft: y, Ht: g, Ct: b } = l || {}, { F: x } = u, [$, S] = c("paddingAbsolute");
    (y || h || (d || g)) && ([f, h] = i(d));
    const C = !r && (S || b || h);
    if (C) {
      const T = !$ || !t && !v, k = f.r + f.l, I = f.t + f.b, P = {
        [iq]: T && !x ? -k : 0,
        [aq]: T ? -I : 0,
        [oq]: T && x ? -k : 0,
        top: T ? -f.t : 0,
        right: T ? x ? -f.r : "auto" : 0,
        left: T ? x ? "auto" : -f.l : 0,
        [Xv]: T && `calc(100% + ${k}px)`
      }, _ = {
        [eq]: T ? f.t : 0,
        [tq]: T ? f.r : 0,
        [rq]: T ? f.b : 0,
        [nq]: T ? f.l : 0
      };
      ap(t || n, P), ap(n, _), qt(o, {
        ln: f,
        dn: !T,
        j: t ? _ : qt({}, P, _)
      });
    }
    return {
      fn: C
    };
  };
}, MCe = (e, t) => {
  const n = ma(), { ht: r, ln: o, U: i, L: a, Qt: c, gt: l, wt: u, St: d, un: f } = e, { P: h } = n, v = u && a, y = ht(ZB, 0), g = {
    display: () => !1,
    direction: (X) => X !== "ltr",
    flexDirection: (X) => X.endsWith("-reverse"),
    writingMode: (X) => X !== "horizontal-tb"
  }, b = $i(g), x = {
    i: lq,
    o: {
      w: 0,
      h: 0
    }
  }, $ = {
    i: pg,
    o: {}
  }, S = (X) => {
    d(kq, !v && X);
  }, O = (X) => {
    if (!b.some((ve) => {
      const G = X[ve];
      return G && g[ve](G);
    }))
      return {
        D: {
          x: 0,
          y: 0
        },
        M: {
          x: 1,
          y: 1
        }
      };
    S(!0);
    const re = yo(l), Z = d(rCe, !0), ce = xn(c, Mu, (ve) => {
      const G = yo(l);
      ve.isTrusted && G.x === re.x && G.y === re.y && Oq(ve);
    }, {
      I: !0,
      A: !0
    });
    Ki(l, {
      x: 0,
      y: 0
    }), Z();
    const fe = yo(l), de = m0(l);
    Ki(l, {
      x: de.w,
      y: de.h
    });
    const ne = yo(l);
    Ki(l, {
      x: ne.x - fe.x < 1 && -de.w,
      y: ne.y - fe.y < 1 && -de.h
    });
    const le = yo(l);
    return Ki(l, re), DE(() => ce()), {
      D: fe,
      M: le
    };
  }, C = (X, oe) => {
    const re = Jr.devicePixelRatio % 1 !== 0 ? 1 : 0, Z = {
      w: y(X.w - oe.w),
      h: y(X.h - oe.h)
    };
    return {
      w: Z.w > re ? Z.w : 0,
      h: Z.h > re ? Z.h : 0
    };
  }, [T, k] = po(x, ht(VE, i)), [I, P] = po(x, ht(m0, i)), [_, A] = po(x), [D] = po($), [M, N] = po(x), [L] = po($), [z] = po({
    i: (X, oe) => Jv(X, oe, b),
    o: {}
  }, () => GSe(i) ? Ua(i, b) : {}), [q, W] = po({
    i: (X, oe) => pg(X.D, oe.D) && pg(X.M, oe.M),
    o: Cq()
  }), U = qp(Aq), K = (X, oe) => `${oe ? QSe : eCe}${zSe(X)}`, Y = (X) => {
    const oe = (Z) => [$s, kc, Mu].map((ce) => K(ce, Z)), re = oe(!0).concat(oe()).join(" ");
    d(re), d($i(X).map((Z) => K(X[Z], Z === "x")).join(" "), !0);
  };
  return ({ It: X, Zt: oe, _n: re, Dt: Z }, { fn: ce }) => {
    const { ft: fe, Ht: de, Ct: ne, dt: le, zt: ve } = oe || {}, G = U && U.V(e, t, re, n, X), { W: Se, X: ue, J: Q } = G || {}, [ie, ee] = gCe(X, n), [be, Ie] = X("overflow"), je = Du(be.x), V = Du(be.y), se = !0;
    let we = k(Z), J = P(Z), he = A(Z), Te = N(Z);
    ee && h && d(Rq, !ie);
    {
      WE(r, Is, mg) && S(!0);
      const [Pt] = ue ? ue() : [], [On] = we = T(Z), [Hn] = J = I(Z), gn = wq(i), Kn = v && YSe(f()), To = {
        w: y(Hn.w + On.w),
        h: y(Hn.h + On.h)
      }, _i = {
        w: y((Kn ? Kn.w : gn.w + y(gn.w - Hn.w)) + On.w),
        h: y((Kn ? Kn.h : gn.h + y(gn.h - Hn.h)) + On.h)
      };
      Pt && Pt(), Te = M(_i), he = _(C(To, _i), Z);
    }
    const [xe, Ae] = Te, [Ce, Ye] = he, [He, Be] = J, [Xe, Ze] = we, [Ne, $e] = D({
      x: Ce.w > 0,
      y: Ce.h > 0
    }), Ue = je && V && (Ne.x || Ne.y) || je && Ne.x && !Ne.y || V && Ne.y && !Ne.x, Ke = ce || ne || ve || Ze || Be || Ae || Ye || Ie || ee || se, Me = vCe(Ne, be), [We, at] = L(Me.k), [Je, ke] = z(Z), Qe = ne || le || ke || $e || Z, [ot, Mt] = Qe ? q(O(Je), Z) : W();
    return Ke && (at && Y(Me.k), Q && Se && ap(i, Q(Me, re, Se(Me, He, Xe)))), S(!1), h0(r, Is, mg, Ue), h0(o, mC, mg, Ue), qt(t, {
      k: We,
      Vt: {
        x: xe.w,
        y: xe.h
      },
      Rt: {
        x: Ce.w,
        y: Ce.h
      },
      rn: Ne,
      Lt: KSe(ot, Ce)
    }), {
      en: at,
      nn: Ae,
      sn: Ye,
      cn: Mt || Ye,
      pn: Qe
    };
  };
}, NCe = (e) => {
  const [t, n, r] = PCe(e), o = {
    ln: {
      t: 0,
      r: 0,
      b: 0,
      l: 0
    },
    dn: !1,
    j: {
      [iq]: 0,
      [aq]: 0,
      [oq]: 0,
      [eq]: 0,
      [tq]: 0,
      [rq]: 0,
      [nq]: 0
    },
    Vt: {
      x: 0,
      y: 0
    },
    Rt: {
      x: 0,
      y: 0
    },
    k: {
      x: kc,
      y: kc
    },
    rn: {
      x: !1,
      y: !1
    },
    Lt: Cq()
  }, { vt: i, gt: a, L: c, Ot: l } = t, { P: u, T: d } = ma(), f = !u && (d.x || d.y), h = [ACe(t), ICe(t, o), MCe(t, o)];
  return [n, (v) => {
    const y = {}, b = f && yo(a), x = b && l();
    return sn(h, ($) => {
      qt(y, $(v, y) || {});
    }), Ki(a, b), x && x(), !c && Ki(i, 0), y;
  }, o, t, r];
}, DCe = (e, t, n, r, o) => {
  let i = !1;
  const a = zN(t, {}), [c, l, u, d, f] = NCe(e), [h, v, y] = CCe(d, u, a, (O) => {
    S({}, O);
  }), [g, b, , x] = RCe(e, t, y, u, d, o), $ = (O) => $i(O).some((C) => !!O[C]), S = (O, C) => {
    if (n())
      return !1;
    const { vn: T, Dt: k, At: I, hn: P } = O, _ = T || {}, A = !!k || !i, D = {
      It: zN(t, _, A),
      vn: _,
      Dt: A
    };
    if (P)
      return b(D), !1;
    const M = C || v(qt({}, D, {
      At: I
    })), N = l(qt({}, D, {
      _n: y,
      Zt: M
    }));
    b(qt({}, D, {
      Zt: M,
      tn: N
    }));
    const L = $(M), z = $(N), q = L || z || !BE(_) || A;
    return i = !0, q && r(O, {
      Zt: M,
      tn: N
    }), q;
  };
  return [() => {
    const { an: O, gt: C, Ot: T } = d, k = yo(O), I = [h(), c(), g()], P = T();
    return Ki(C, k), P(), ht(wo, I);
  }, S, () => ({
    gn: y,
    bn: u
  }), {
    wn: d,
    yn: x
  }, f];
}, KE = /* @__PURE__ */ new WeakMap(), LCe = (e, t) => {
  KE.set(e, t);
}, jCe = (e) => {
  KE.delete(e);
}, jq = (e) => KE.get(e), Xi = (e, t, n) => {
  const { nt: r } = ma(), o = p0(e), i = o ? e : e.target, a = jq(i);
  if (t && !a) {
    let c = !1;
    const l = [], u = {}, d = (_) => {
      const A = dq(_), D = qp(ZSe);
      return D ? D(A, !0) : A;
    }, f = qt({}, r(), d(t)), [h, v, y] = hC(), [g, b, x] = hC(n), $ = (_, A) => {
      x(_, A), y(_, A);
    }, [S, O, C, T, k] = DCe(e, f, () => c, ({ vn: _, Dt: A }, { Zt: D, tn: M }) => {
      const { ft: N, Ct: L, xt: z, Ht: q, Et: W, dt: U } = D, { nn: K, sn: Y, en: X, cn: oe } = M;
      $("updated", [P, {
        updateHints: {
          sizeChanged: !!N,
          directionChanged: !!L,
          heightIntrinsicChanged: !!z,
          overflowEdgeChanged: !!K,
          overflowAmountChanged: !!Y,
          overflowStyleChanged: !!X,
          scrollCoordinatesChanged: !!oe,
          contentMutation: !!q,
          hostMutation: !!W,
          appear: !!U
        },
        changedOptions: _ || {},
        force: !!A
      }]);
    }, (_) => $("scroll", [P, _])), I = (_) => {
      jCe(i), wo(l), c = !0, $("destroyed", [P, _]), v(), b();
    }, P = {
      options(_, A) {
        if (_) {
          const D = A ? r() : {}, M = Iq(f, qt(D, d(_)));
          BE(M) || (qt(f, M), O({
            vn: M
          }));
        }
        return qt({}, f);
      },
      on: g,
      off: (_, A) => {
        _ && A && b(_, A);
      },
      state() {
        const { gn: _, bn: A } = C(), { F: D } = _, { Vt: M, Rt: N, k: L, rn: z, ln: q, dn: W, Lt: U } = A;
        return qt({}, {
          overflowEdge: M,
          overflowAmount: N,
          overflowStyle: L,
          hasOverflow: z,
          scrollCoordinates: {
            start: U.D,
            end: U.M
          },
          padding: q,
          paddingAbsolute: W,
          directionRTL: D,
          destroyed: c
        });
      },
      elements() {
        const { vt: _, ht: A, ln: D, U: M, bt: N, gt: L, Qt: z } = T.wn, { Yt: q, Gt: W } = T.yn, U = (Y) => {
          const { Pt: X, Ut: oe, Tt: re } = Y;
          return {
            scrollbar: re,
            track: oe,
            handle: X
          };
        }, K = (Y) => {
          const { Wt: X, Xt: oe } = Y, re = U(X[0]);
          return qt({}, re, {
            clone: () => {
              const Z = U(oe());
              return O({
                hn: !0
              }), Z;
            }
          });
        };
        return qt({}, {
          target: _,
          host: A,
          padding: D || M,
          viewport: M,
          content: N || M,
          scrollOffsetElement: L,
          scrollEventElement: z,
          scrollbarHorizontal: K(q),
          scrollbarVertical: K(W)
        });
      },
      update: (_) => O({
        Dt: _,
        At: !0
      }),
      destroy: ht(I, !1),
      plugin: (_) => u[$i(_)[0]]
    };
    return kn(l, [k]), LCe(i, P), _q(Tq, Xi, [P, h, u]), ECe(T.wn.wt, !o && e.cancel) ? (I(!0), P) : (kn(l, S()), $("initialized", [P]), P.update(), P);
  }
  return a;
};
Xi.plugin = (e) => {
  const t = ua(e), n = t ? e : [e], r = n.map((o) => _q(o, Xi)[0]);
  return XSe(n), t ? r : r[0];
};
Xi.valid = (e) => {
  const t = e && e.elements, n = ei(t) && t();
  return f0(n) && !!jq(n.target);
};
Xi.env = () => {
  const { N: e, T: t, P: n, G: r, st: o, et: i, Z: a, tt: c, nt: l, ot: u } = ma();
  return qt({}, {
    scrollbarsSize: e,
    scrollbarsOverlaid: t,
    scrollbarsHiding: n,
    scrollTimeline: r,
    staticDefaultInitialization: o,
    staticDefaultOptions: i,
    getDefaultInitialization: a,
    setDefaultInitialization: c,
    getDefaultOptions: l,
    setDefaultOptions: u
  });
};
Xi.nonce = wCe;
const FCe = () => {
  if (typeof window > "u") {
    const u = () => {
    };
    return [u, u];
  }
  let e, t;
  const n = window, r = typeof n.requestIdleCallback == "function", o = n.requestAnimationFrame, i = n.cancelAnimationFrame, a = r ? n.requestIdleCallback : o, c = r ? n.cancelIdleCallback : i, l = () => {
    c(e), i(t);
  };
  return [
    (u, d) => {
      l(), e = a(
        r ? () => {
          l(), t = o(u);
        } : u,
        typeof d == "object" ? d : { timeout: 2233 }
      );
    },
    l
  ];
}, zCe = (e) => {
  const { options: t, events: n, defer: r } = e || {}, [o, i] = Nn(FCe, []), a = Gt(null), c = Gt(r), l = Gt(t), u = Gt(n);
  return mn(() => {
    c.current = r;
  }, [r]), mn(() => {
    const { current: d } = a;
    l.current = t, Xi.valid(d) && d.options(t || {}, !0);
  }, [t]), mn(() => {
    const { current: d } = a;
    u.current = n, Xi.valid(d) && d.on(n || {}, !0);
  }, [n]), mn(
    () => () => {
      var d;
      i(), (d = a.current) == null || d.destroy();
    },
    []
  ), Nn(
    () => [
      (d) => {
        const f = a.current;
        if (Xi.valid(f))
          return;
        const h = c.current, v = l.current || {}, y = u.current || {}, g = () => a.current = Xi(d, v, y);
        h ? o(g, h) : g();
      },
      () => a.current
    ],
    []
  );
}, BCe = (e, t) => {
  const { element: n = "div", options: r, events: o, defer: i, children: a, ...c } = e, l = n, u = Gt(null), d = Gt(null), [f, h] = zCe({ options: r, events: o, defer: i });
  return mn(() => {
    const { current: v } = u, { current: y } = d;
    if (!v)
      return;
    const g = v;
    return f(
      n === "body" ? {
        target: g,
        cancel: {
          body: null
        }
      } : {
        target: g,
        elements: {
          viewport: y,
          content: y
        }
      }
    ), () => {
      var b;
      return (b = h()) == null ? void 0 : b.destroy();
    };
  }, [f, n]), G8(
    t,
    () => ({
      osInstance: h,
      getElement: () => u.current
    }),
    []
  ), // @ts-ignore
  /* @__PURE__ */ ye.createElement(l, { "data-overlayscrollbars-initialize": "", ref: u, ...c }, n === "body" ? a : /* @__PURE__ */ ye.createElement("div", { "data-overlayscrollbars-contents": "", ref: d }, a));
}, x9e = xp(BCe);
function qCe(e) {
  if (Array.isArray(e)) {
    for (var t = 0, n = Array(e.length); t < e.length; t++)
      n[t] = e[t];
    return n;
  } else
    return Array.from(e);
}
var XE = !1;
if (typeof window < "u") {
  var qN = {
    get passive() {
      XE = !0;
    }
  };
  window.addEventListener("testPassive", null, qN), window.removeEventListener("testPassive", null, qN);
}
var g0 = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1), zc = [], v0 = !1, Fq = -1, Cf = void 0, $c = void 0, Tf = void 0, zq = function(t) {
  return zc.some(function(n) {
    return !!(n.options.allowTouchMove && n.options.allowTouchMove(t));
  });
}, y0 = function(t) {
  var n = t || window.event;
  return zq(n.target) || n.touches.length > 1 ? !0 : (n.preventDefault && n.preventDefault(), !1);
}, UCe = function(t) {
  if (Tf === void 0) {
    var n = !!t, r = window.innerWidth - document.documentElement.clientWidth;
    if (n && r > 0) {
      var o = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right"), 10);
      Tf = document.body.style.paddingRight, document.body.style.paddingRight = o + r + "px";
    }
  }
  Cf === void 0 && (Cf = document.body.style.overflow, document.body.style.overflow = "hidden");
}, WCe = function() {
  Tf !== void 0 && (document.body.style.paddingRight = Tf, Tf = void 0), Cf !== void 0 && (document.body.style.overflow = Cf, Cf = void 0);
}, HCe = function() {
  return window.requestAnimationFrame(function() {
    if ($c === void 0) {
      $c = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left
      };
      var t = window, n = t.scrollY, r = t.scrollX, o = t.innerHeight;
      document.body.style.position = "fixed", document.body.style.top = -n, document.body.style.left = -r, setTimeout(function() {
        return window.requestAnimationFrame(function() {
          var i = o - window.innerHeight;
          i && n >= o && (document.body.style.top = -(n + i));
        });
      }, 300);
    }
  });
}, VCe = function() {
  if ($c !== void 0) {
    var t = -parseInt(document.body.style.top, 10), n = -parseInt(document.body.style.left, 10);
    document.body.style.position = $c.position, document.body.style.top = $c.top, document.body.style.left = $c.left, window.scrollTo(n, t), $c = void 0;
  }
}, YCe = function(t) {
  return t ? t.scrollHeight - t.scrollTop <= t.clientHeight : !1;
}, GCe = function(t, n) {
  var r = t.targetTouches[0].clientY - Fq;
  return zq(t.target) ? !1 : n && n.scrollTop === 0 && r > 0 || YCe(n) && r < 0 ? y0(t) : (t.stopPropagation(), !0);
}, w9e = function(t, n) {
  if (!t) {
    console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
    return;
  }
  if (!zc.some(function(o) {
    return o.targetElement === t;
  })) {
    var r = {
      targetElement: t,
      options: {}
    };
    zc = [].concat(qCe(zc), [r]), g0 ? HCe() : UCe(n), g0 && (t.ontouchstart = function(o) {
      o.targetTouches.length === 1 && (Fq = o.targetTouches[0].clientY);
    }, t.ontouchmove = function(o) {
      o.targetTouches.length === 1 && GCe(o, t);
    }, v0 || (document.addEventListener("touchmove", y0, XE ? { passive: !1 } : void 0), v0 = !0));
  }
}, $9e = function(t) {
  if (!t) {
    console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
    return;
  }
  zc = zc.filter(function(n) {
    return n.targetElement !== t;
  }), g0 && (t.ontouchstart = null, t.ontouchmove = null, v0 && zc.length === 0 && (document.removeEventListener("touchmove", y0, XE ? { passive: !1 } : void 0), v0 = !1)), g0 ? VCe() : WCe();
};
const dr = [];
for (let e = 0; e < 256; ++e)
  dr.push((e + 256).toString(16).slice(1));
function KCe(e, t = 0) {
  return (dr[e[t + 0]] + dr[e[t + 1]] + dr[e[t + 2]] + dr[e[t + 3]] + "-" + dr[e[t + 4]] + dr[e[t + 5]] + "-" + dr[e[t + 6]] + dr[e[t + 7]] + "-" + dr[e[t + 8]] + dr[e[t + 9]] + "-" + dr[e[t + 10]] + dr[e[t + 11]] + dr[e[t + 12]] + dr[e[t + 13]] + dr[e[t + 14]] + dr[e[t + 15]]).toLowerCase();
}
let J2;
const XCe = new Uint8Array(16);
function ZCe() {
  if (!J2) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    J2 = crypto.getRandomValues.bind(crypto);
  }
  return J2(XCe);
}
const JCe = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), UN = { randomUUID: JCe };
function O9e(e, t, n) {
  if (UN.randomUUID && !t && !e)
    return UN.randomUUID();
  e = e || {};
  const r = e.random || (e.rng || ZCe)();
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, KCe(r);
}
var Q2, WN;
function QCe() {
  if (WN) return Q2;
  WN = 1;
  var e = "__lodash_hash_undefined__";
  function t(n) {
    return this.__data__.set(n, e), this;
  }
  return Q2 = t, Q2;
}
var e$, HN;
function eTe() {
  if (HN) return e$;
  HN = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return e$ = e, e$;
}
var t$, VN;
function ZE() {
  if (VN) return t$;
  VN = 1;
  var e = fE(), t = QCe(), n = eTe();
  function r(o) {
    var i = -1, a = o == null ? 0 : o.length;
    for (this.__data__ = new e(); ++i < a; )
      this.add(o[i]);
  }
  return r.prototype.add = r.prototype.push = t, r.prototype.has = n, t$ = r, t$;
}
var n$, YN;
function tTe() {
  if (YN) return n$;
  YN = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length; ++r < o; )
      if (n(t[r], r, t))
        return !0;
    return !1;
  }
  return n$ = e, n$;
}
var r$, GN;
function JE() {
  if (GN) return r$;
  GN = 1;
  function e(t, n) {
    return t.has(n);
  }
  return r$ = e, r$;
}
var o$, KN;
function Bq() {
  if (KN) return o$;
  KN = 1;
  var e = ZE(), t = tTe(), n = JE(), r = 1, o = 2;
  function i(a, c, l, u, d, f) {
    var h = l & r, v = a.length, y = c.length;
    if (v != y && !(h && y > v))
      return !1;
    var g = f.get(a), b = f.get(c);
    if (g && b)
      return g == c && b == a;
    var x = -1, $ = !0, S = l & o ? new e() : void 0;
    for (f.set(a, c), f.set(c, a); ++x < v; ) {
      var O = a[x], C = c[x];
      if (u)
        var T = h ? u(C, O, x, c, a, f) : u(O, C, x, a, c, f);
      if (T !== void 0) {
        if (T)
          continue;
        $ = !1;
        break;
      }
      if (S) {
        if (!t(c, function(k, I) {
          if (!n(S, I) && (O === k || d(O, k, l, u, f)))
            return S.push(I);
        })) {
          $ = !1;
          break;
        }
      } else if (!(O === C || d(O, C, l, u, f))) {
        $ = !1;
        break;
      }
    }
    return f.delete(a), f.delete(c), $;
  }
  return o$ = i, o$;
}
var i$, XN;
function nTe() {
  if (XN) return i$;
  XN = 1;
  function e(t) {
    var n = -1, r = Array(t.size);
    return t.forEach(function(o, i) {
      r[++n] = [i, o];
    }), r;
  }
  return i$ = e, i$;
}
var a$, ZN;
function QE() {
  if (ZN) return a$;
  ZN = 1;
  function e(t) {
    var n = -1, r = Array(t.size);
    return t.forEach(function(o) {
      r[++n] = o;
    }), r;
  }
  return a$ = e, a$;
}
var s$, JN;
function rTe() {
  if (JN) return s$;
  JN = 1;
  var e = Ju(), t = mz(), n = Lp(), r = Bq(), o = nTe(), i = QE(), a = 1, c = 2, l = "[object Boolean]", u = "[object Date]", d = "[object Error]", f = "[object Map]", h = "[object Number]", v = "[object RegExp]", y = "[object Set]", g = "[object String]", b = "[object Symbol]", x = "[object ArrayBuffer]", $ = "[object DataView]", S = e ? e.prototype : void 0, O = S ? S.valueOf : void 0;
  function C(T, k, I, P, _, A, D) {
    switch (I) {
      case $:
        if (T.byteLength != k.byteLength || T.byteOffset != k.byteOffset)
          return !1;
        T = T.buffer, k = k.buffer;
      case x:
        return !(T.byteLength != k.byteLength || !A(new t(T), new t(k)));
      case l:
      case u:
      case h:
        return n(+T, +k);
      case d:
        return T.name == k.name && T.message == k.message;
      case v:
      case g:
        return T == k + "";
      case f:
        var M = o;
      case y:
        var N = P & a;
        if (M || (M = i), T.size != k.size && !N)
          return !1;
        var L = D.get(T);
        if (L)
          return L == k;
        P |= c, D.set(T, k);
        var z = r(M(T), M(k), P, _, A, D);
        return D.delete(T), z;
      case b:
        if (O)
          return O.call(T) == O.call(k);
    }
    return !1;
  }
  return s$ = C, s$;
}
var c$, QN;
function oTe() {
  if (QN) return c$;
  QN = 1;
  var e = fz(), t = 1, n = Object.prototype, r = n.hasOwnProperty;
  function o(i, a, c, l, u, d) {
    var f = c & t, h = e(i), v = h.length, y = e(a), g = y.length;
    if (v != g && !f)
      return !1;
    for (var b = v; b--; ) {
      var x = h[b];
      if (!(f ? x in a : r.call(a, x)))
        return !1;
    }
    var $ = d.get(i), S = d.get(a);
    if ($ && S)
      return $ == a && S == i;
    var O = !0;
    d.set(i, a), d.set(a, i);
    for (var C = f; ++b < v; ) {
      x = h[b];
      var T = i[x], k = a[x];
      if (l)
        var I = f ? l(k, T, x, a, i, d) : l(T, k, x, i, a, d);
      if (!(I === void 0 ? T === k || u(T, k, c, l, d) : I)) {
        O = !1;
        break;
      }
      C || (C = x == "constructor");
    }
    if (O && !C) {
      var P = i.constructor, _ = a.constructor;
      P != _ && "constructor" in i && "constructor" in a && !(typeof P == "function" && P instanceof P && typeof _ == "function" && _ instanceof _) && (O = !1);
    }
    return d.delete(i), d.delete(a), O;
  }
  return c$ = o, c$;
}
var l$, eD;
function iTe() {
  if (eD) return l$;
  eD = 1;
  var e = pE(), t = Bq(), n = rTe(), r = oTe(), o = Dv(), i = Ci(), a = vE(), c = az(), l = 1, u = "[object Arguments]", d = "[object Array]", f = "[object Object]", h = Object.prototype, v = h.hasOwnProperty;
  function y(g, b, x, $, S, O) {
    var C = i(g), T = i(b), k = C ? d : o(g), I = T ? d : o(b);
    k = k == u ? f : k, I = I == u ? f : I;
    var P = k == f, _ = I == f, A = k == I;
    if (A && a(g)) {
      if (!a(b))
        return !1;
      C = !0, P = !1;
    }
    if (A && !P)
      return O || (O = new e()), C || c(g) ? t(g, b, x, $, S, O) : n(g, b, k, x, $, S, O);
    if (!(x & l)) {
      var D = P && v.call(g, "__wrapped__"), M = _ && v.call(b, "__wrapped__");
      if (D || M) {
        var N = D ? g.value() : g, L = M ? b.value() : b;
        return O || (O = new e()), S(N, L, x, $, O);
      }
    }
    return A ? (O || (O = new e()), r(g, b, x, $, S, O)) : !1;
  }
  return l$ = y, l$;
}
var u$, tD;
function qq() {
  if (tD) return u$;
  tD = 1;
  var e = iTe(), t = Ka();
  function n(r, o, i, a, c) {
    return r === o ? !0 : r == null || o == null || !t(r) && !t(o) ? r !== r && o !== o : e(r, o, i, a, n, c);
  }
  return u$ = n, u$;
}
var d$, nD;
function aTe() {
  if (nD) return d$;
  nD = 1;
  var e = pE(), t = qq(), n = 1, r = 2;
  function o(i, a, c, l) {
    var u = c.length, d = u, f = !l;
    if (i == null)
      return !d;
    for (i = Object(i); u--; ) {
      var h = c[u];
      if (f && h[2] ? h[1] !== i[h[0]] : !(h[0] in i))
        return !1;
    }
    for (; ++u < d; ) {
      h = c[u];
      var v = h[0], y = i[v], g = h[1];
      if (f && h[2]) {
        if (y === void 0 && !(v in i))
          return !1;
      } else {
        var b = new e();
        if (l)
          var x = l(y, g, v, i, a, b);
        if (!(x === void 0 ? t(g, y, n | r, l, b) : x))
          return !1;
      }
    }
    return !0;
  }
  return d$ = o, d$;
}
var f$, rD;
function Uq() {
  if (rD) return f$;
  rD = 1;
  var e = Za();
  function t(n) {
    return n === n && !e(n);
  }
  return f$ = t, f$;
}
var p$, oD;
function sTe() {
  if (oD) return p$;
  oD = 1;
  var e = Uq(), t = rd();
  function n(r) {
    for (var o = t(r), i = o.length; i--; ) {
      var a = o[i], c = r[a];
      o[i] = [a, c, e(c)];
    }
    return o;
  }
  return p$ = n, p$;
}
var h$, iD;
function Wq() {
  if (iD) return h$;
  iD = 1;
  function e(t, n) {
    return function(r) {
      return r == null ? !1 : r[t] === n && (n !== void 0 || t in Object(r));
    };
  }
  return h$ = e, h$;
}
var m$, aD;
function cTe() {
  if (aD) return m$;
  aD = 1;
  var e = aTe(), t = sTe(), n = Wq();
  function r(o) {
    var i = t(o);
    return i.length == 1 && i[0][2] ? n(i[0][0], i[0][1]) : function(a) {
      return a === o || e(a, o, i);
    };
  }
  return m$ = r, m$;
}
var g$, sD;
function Hq() {
  if (sD) return g$;
  sD = 1;
  var e = Lv();
  function t(n, r, o) {
    var i = n == null ? void 0 : e(n, r);
    return i === void 0 ? o : i;
  }
  return g$ = t, g$;
}
var v$, cD;
function lTe() {
  if (cD) return v$;
  cD = 1;
  function e(t, n) {
    return t != null && n in Object(t);
  }
  return v$ = e, v$;
}
var y$, lD;
function uTe() {
  if (lD) return y$;
  lD = 1;
  var e = od(), t = gE(), n = Ci(), r = Iv(), o = yE(), i = id();
  function a(c, l, u) {
    l = e(l, c);
    for (var d = -1, f = l.length, h = !1; ++d < f; ) {
      var v = i(l[d]);
      if (!(h = c != null && u(c, v)))
        break;
      c = c[v];
    }
    return h || ++d != f ? h : (f = c == null ? 0 : c.length, !!f && o(f) && r(v, f) && (n(c) || t(c)));
  }
  return y$ = a, y$;
}
var b$, uD;
function Vq() {
  if (uD) return b$;
  uD = 1;
  var e = lTe(), t = uTe();
  function n(r, o) {
    return r != null && t(r, o, e);
  }
  return b$ = n, b$;
}
var x$, dD;
function dTe() {
  if (dD) return x$;
  dD = 1;
  var e = qq(), t = Hq(), n = Vq(), r = CE(), o = Uq(), i = Wq(), a = id(), c = 1, l = 2;
  function u(d, f) {
    return r(d) && o(f) ? i(a(d), f) : function(h) {
      var v = t(h, d);
      return v === void 0 && v === f ? n(h, d) : e(f, v, c | l);
    };
  }
  return x$ = u, x$;
}
var w$, fD;
function Yq() {
  if (fD) return w$;
  fD = 1;
  function e(t) {
    return function(n) {
      return n == null ? void 0 : n[t];
    };
  }
  return w$ = e, w$;
}
var $$, pD;
function fTe() {
  if (pD) return $$;
  pD = 1;
  var e = Lv();
  function t(n) {
    return function(r) {
      return e(r, n);
    };
  }
  return $$ = t, $$;
}
var O$, hD;
function pTe() {
  if (hD) return O$;
  hD = 1;
  var e = Yq(), t = fTe(), n = CE(), r = id();
  function o(i) {
    return n(i) ? e(r(i)) : t(i);
  }
  return O$ = o, O$;
}
var S$, mD;
function e3() {
  if (mD) return S$;
  mD = 1;
  var e = cTe(), t = dTe(), n = TE(), r = Ci(), o = pTe();
  function i(a) {
    return typeof a == "function" ? a : a == null ? n : typeof a == "object" ? r(a) ? t(a[0], a[1]) : e(a) : o(a);
  }
  return S$ = i, S$;
}
var C$, gD;
function hTe() {
  if (gD) return C$;
  gD = 1;
  function e(t, n, r, o) {
    for (var i = t.length, a = r + (o ? 1 : -1); o ? a-- : ++a < i; )
      if (n(t[a], a, t))
        return a;
    return -1;
  }
  return C$ = e, C$;
}
var T$, vD;
function mTe() {
  if (vD) return T$;
  vD = 1;
  function e(t) {
    return t !== t;
  }
  return T$ = e, T$;
}
var E$, yD;
function gTe() {
  if (yD) return E$;
  yD = 1;
  function e(t, n, r) {
    for (var o = r - 1, i = t.length; ++o < i; )
      if (t[o] === n)
        return o;
    return -1;
  }
  return E$ = e, E$;
}
var _$, bD;
function vTe() {
  if (bD) return _$;
  bD = 1;
  var e = hTe(), t = mTe(), n = gTe();
  function r(o, i, a) {
    return i === i ? n(o, i, a) : e(o, t, a);
  }
  return _$ = r, _$;
}
var k$, xD;
function Gq() {
  if (xD) return k$;
  xD = 1;
  var e = vTe();
  function t(n, r) {
    var o = n == null ? 0 : n.length;
    return !!o && e(n, r, 0) > -1;
  }
  return k$ = t, k$;
}
var R$, wD;
function Kq() {
  if (wD) return R$;
  wD = 1;
  function e(t, n, r) {
    for (var o = -1, i = t == null ? 0 : t.length; ++o < i; )
      if (r(n, t[o]))
        return !0;
    return !1;
  }
  return R$ = e, R$;
}
var P$, $D;
function yTe() {
  if ($D) return P$;
  $D = 1;
  function e() {
  }
  return P$ = e, P$;
}
var A$, OD;
function bTe() {
  if (OD) return A$;
  OD = 1;
  var e = hz(), t = yTe(), n = QE(), r = 1 / 0, o = e && 1 / n(new e([, -0]))[1] == r ? function(i) {
    return new e(i);
  } : t;
  return A$ = o, A$;
}
var I$, SD;
function xTe() {
  if (SD) return I$;
  SD = 1;
  var e = ZE(), t = Gq(), n = Kq(), r = JE(), o = bTe(), i = QE(), a = 200;
  function c(l, u, d) {
    var f = -1, h = t, v = l.length, y = !0, g = [], b = g;
    if (d)
      y = !1, h = n;
    else if (v >= a) {
      var x = u ? null : o(l);
      if (x)
        return i(x);
      y = !1, h = r, b = new e();
    } else
      b = u ? [] : g;
    e:
      for (; ++f < v; ) {
        var $ = l[f], S = u ? u($) : $;
        if ($ = d || $ !== 0 ? $ : 0, y && S === S) {
          for (var O = b.length; O--; )
            if (b[O] === S)
              continue e;
          u && b.push(S), g.push($);
        } else h(b, S, d) || (b !== g && b.push(S), g.push($));
      }
    return g;
  }
  return I$ = c, I$;
}
var M$, CD;
function wTe() {
  if (CD) return M$;
  CD = 1;
  var e = e3(), t = xTe();
  function n(r, o) {
    return r && r.length ? t(r, e(o, 2)) : [];
  }
  return M$ = n, M$;
}
var $Te = wTe();
const S9e = /* @__PURE__ */ jn($Te);
var uf = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var OTe = uf.exports, TD;
function STe() {
  return TD || (TD = 1, function(e, t) {
    (function() {
      var n, r = "4.17.21", o = 200, i = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a = "Expected a function", c = "Invalid `variable` option passed into `_.template`", l = "__lodash_hash_undefined__", u = 500, d = "__lodash_placeholder__", f = 1, h = 2, v = 4, y = 1, g = 2, b = 1, x = 2, $ = 4, S = 8, O = 16, C = 32, T = 64, k = 128, I = 256, P = 512, _ = 30, A = "...", D = 800, M = 16, N = 1, L = 2, z = 3, q = 1 / 0, W = 9007199254740991, U = 17976931348623157e292, K = NaN, Y = 4294967295, X = Y - 1, oe = Y >>> 1, re = [
        ["ary", k],
        ["bind", b],
        ["bindKey", x],
        ["curry", S],
        ["curryRight", O],
        ["flip", P],
        ["partial", C],
        ["partialRight", T],
        ["rearg", I]
      ], Z = "[object Arguments]", ce = "[object Array]", fe = "[object AsyncFunction]", de = "[object Boolean]", ne = "[object Date]", le = "[object DOMException]", ve = "[object Error]", G = "[object Function]", Se = "[object GeneratorFunction]", ue = "[object Map]", Q = "[object Number]", ie = "[object Null]", ee = "[object Object]", be = "[object Promise]", Ie = "[object Proxy]", je = "[object RegExp]", V = "[object Set]", se = "[object String]", we = "[object Symbol]", J = "[object Undefined]", he = "[object WeakMap]", Te = "[object WeakSet]", xe = "[object ArrayBuffer]", Ae = "[object DataView]", Ce = "[object Float32Array]", Ye = "[object Float64Array]", He = "[object Int8Array]", Be = "[object Int16Array]", Xe = "[object Int32Array]", Ze = "[object Uint8Array]", Ne = "[object Uint8ClampedArray]", $e = "[object Uint16Array]", Ue = "[object Uint32Array]", Ke = /\b__p \+= '';/g, Me = /\b(__p \+=) '' \+/g, We = /(__e\(.*?\)|\b__t\)) \+\n'';/g, at = /&(?:amp|lt|gt|quot|#39);/g, Je = /[&<>"']/g, ke = RegExp(at.source), Qe = RegExp(Je.source), ot = /<%-([\s\S]+?)%>/g, Mt = /<%([\s\S]+?)%>/g, Pt = /<%=([\s\S]+?)%>/g, On = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Hn = /^\w*$/, gn = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Kn = /[\\^$.*+?()[\]{}|]/g, To = RegExp(Kn.source), _i = /^\s+/, dd = /\s/, pl = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Zp = /\{\n\/\* \[wrapped with (.+)\] \*/, Zs = /,? & /, er = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Rn = /[()=,{}\[\]\/\s]/, ii = /\\(\\)?/g, Fe = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Ee = /\w*$/, et = /^[-+]0x[0-9a-f]+$/i, yt = /^0b[01]+$/i, bt = /^\[object .+?Constructor\]$/, Xt = /^0o[0-7]+$/i, Wt = /^(?:0|[1-9]\d*)$/, vr = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, ai = /($^)/, Z3 = /['\n\r\u2028\u2029\\]/g, hl = "\\ud800-\\udfff", Jp = "\\u0300-\\u036f", ml = "\\ufe20-\\ufe2f", gl = "\\u20d0-\\u20ff", vl = Jp + ml + gl, Js = "\\u2700-\\u27bf", Lt = "a-z\\xdf-\\xf6\\xf8-\\xff", Eo = "\\xac\\xb1\\xd7\\xf7", ki = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Qs = "\\u2000-\\u206f", Ty = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", J3 = "A-Z\\xc0-\\xd6\\xd8-\\xde", Q3 = "\\ufe0e\\ufe0f", e_ = Eo + ki + Qs + Ty, Ey = "['’]", kH = "[" + hl + "]", t_ = "[" + e_ + "]", Qp = "[" + vl + "]", n_ = "\\d+", RH = "[" + Js + "]", r_ = "[" + Lt + "]", o_ = "[^" + hl + e_ + n_ + Js + Lt + J3 + "]", _y = "\\ud83c[\\udffb-\\udfff]", PH = "(?:" + Qp + "|" + _y + ")", i_ = "[^" + hl + "]", ky = "(?:\\ud83c[\\udde6-\\uddff]){2}", Ry = "[\\ud800-\\udbff][\\udc00-\\udfff]", yl = "[" + J3 + "]", a_ = "\\u200d", s_ = "(?:" + r_ + "|" + o_ + ")", AH = "(?:" + yl + "|" + o_ + ")", c_ = "(?:" + Ey + "(?:d|ll|m|re|s|t|ve))?", l_ = "(?:" + Ey + "(?:D|LL|M|RE|S|T|VE))?", u_ = PH + "?", d_ = "[" + Q3 + "]?", IH = "(?:" + a_ + "(?:" + [i_, ky, Ry].join("|") + ")" + d_ + u_ + ")*", MH = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", NH = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", f_ = d_ + u_ + IH, DH = "(?:" + [RH, ky, Ry].join("|") + ")" + f_, LH = "(?:" + [i_ + Qp + "?", Qp, ky, Ry, kH].join("|") + ")", jH = RegExp(Ey, "g"), FH = RegExp(Qp, "g"), Py = RegExp(_y + "(?=" + _y + ")|" + LH + f_, "g"), zH = RegExp([
        yl + "?" + r_ + "+" + c_ + "(?=" + [t_, yl, "$"].join("|") + ")",
        AH + "+" + l_ + "(?=" + [t_, yl + s_, "$"].join("|") + ")",
        yl + "?" + s_ + "+" + c_,
        yl + "+" + l_,
        NH,
        MH,
        n_,
        DH
      ].join("|"), "g"), BH = RegExp("[" + a_ + hl + vl + Q3 + "]"), qH = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, UH = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], WH = -1, hn = {};
      hn[Ce] = hn[Ye] = hn[He] = hn[Be] = hn[Xe] = hn[Ze] = hn[Ne] = hn[$e] = hn[Ue] = !0, hn[Z] = hn[ce] = hn[xe] = hn[de] = hn[Ae] = hn[ne] = hn[ve] = hn[G] = hn[ue] = hn[Q] = hn[ee] = hn[je] = hn[V] = hn[se] = hn[he] = !1;
      var fn = {};
      fn[Z] = fn[ce] = fn[xe] = fn[Ae] = fn[de] = fn[ne] = fn[Ce] = fn[Ye] = fn[He] = fn[Be] = fn[Xe] = fn[ue] = fn[Q] = fn[ee] = fn[je] = fn[V] = fn[se] = fn[we] = fn[Ze] = fn[Ne] = fn[$e] = fn[Ue] = !0, fn[ve] = fn[G] = fn[he] = !1;
      var HH = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, VH = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, YH = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, GH = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, KH = parseFloat, XH = parseInt, p_ = typeof Vo == "object" && Vo && Vo.Object === Object && Vo, ZH = typeof self == "object" && self && self.Object === Object && self, cr = p_ || ZH || Function("return this")(), Ay = t && !t.nodeType && t, ec = Ay && !0 && e && !e.nodeType && e, h_ = ec && ec.exports === Ay, Iy = h_ && p_.process, _o = function() {
        try {
          var pe = ec && ec.require && ec.require("util").types;
          return pe || Iy && Iy.binding && Iy.binding("util");
        } catch {
        }
      }(), m_ = _o && _o.isArrayBuffer, g_ = _o && _o.isDate, v_ = _o && _o.isMap, y_ = _o && _o.isRegExp, b_ = _o && _o.isSet, x_ = _o && _o.isTypedArray;
      function io(pe, Re, Oe) {
        switch (Oe.length) {
          case 0:
            return pe.call(Re);
          case 1:
            return pe.call(Re, Oe[0]);
          case 2:
            return pe.call(Re, Oe[0], Oe[1]);
          case 3:
            return pe.call(Re, Oe[0], Oe[1], Oe[2]);
        }
        return pe.apply(Re, Oe);
      }
      function JH(pe, Re, Oe, rt) {
        for (var xt = -1, Ht = pe == null ? 0 : pe.length; ++xt < Ht; ) {
          var Xn = pe[xt];
          Re(rt, Xn, Oe(Xn), pe);
        }
        return rt;
      }
      function ko(pe, Re) {
        for (var Oe = -1, rt = pe == null ? 0 : pe.length; ++Oe < rt && Re(pe[Oe], Oe, pe) !== !1; )
          ;
        return pe;
      }
      function QH(pe, Re) {
        for (var Oe = pe == null ? 0 : pe.length; Oe-- && Re(pe[Oe], Oe, pe) !== !1; )
          ;
        return pe;
      }
      function w_(pe, Re) {
        for (var Oe = -1, rt = pe == null ? 0 : pe.length; ++Oe < rt; )
          if (!Re(pe[Oe], Oe, pe))
            return !1;
        return !0;
      }
      function ts(pe, Re) {
        for (var Oe = -1, rt = pe == null ? 0 : pe.length, xt = 0, Ht = []; ++Oe < rt; ) {
          var Xn = pe[Oe];
          Re(Xn, Oe, pe) && (Ht[xt++] = Xn);
        }
        return Ht;
      }
      function eh(pe, Re) {
        var Oe = pe == null ? 0 : pe.length;
        return !!Oe && bl(pe, Re, 0) > -1;
      }
      function My(pe, Re, Oe) {
        for (var rt = -1, xt = pe == null ? 0 : pe.length; ++rt < xt; )
          if (Oe(Re, pe[rt]))
            return !0;
        return !1;
      }
      function vn(pe, Re) {
        for (var Oe = -1, rt = pe == null ? 0 : pe.length, xt = Array(rt); ++Oe < rt; )
          xt[Oe] = Re(pe[Oe], Oe, pe);
        return xt;
      }
      function ns(pe, Re) {
        for (var Oe = -1, rt = Re.length, xt = pe.length; ++Oe < rt; )
          pe[xt + Oe] = Re[Oe];
        return pe;
      }
      function Ny(pe, Re, Oe, rt) {
        var xt = -1, Ht = pe == null ? 0 : pe.length;
        for (rt && Ht && (Oe = pe[++xt]); ++xt < Ht; )
          Oe = Re(Oe, pe[xt], xt, pe);
        return Oe;
      }
      function eV(pe, Re, Oe, rt) {
        var xt = pe == null ? 0 : pe.length;
        for (rt && xt && (Oe = pe[--xt]); xt--; )
          Oe = Re(Oe, pe[xt], xt, pe);
        return Oe;
      }
      function Dy(pe, Re) {
        for (var Oe = -1, rt = pe == null ? 0 : pe.length; ++Oe < rt; )
          if (Re(pe[Oe], Oe, pe))
            return !0;
        return !1;
      }
      var tV = Ly("length");
      function nV(pe) {
        return pe.split("");
      }
      function rV(pe) {
        return pe.match(er) || [];
      }
      function $_(pe, Re, Oe) {
        var rt;
        return Oe(pe, function(xt, Ht, Xn) {
          if (Re(xt, Ht, Xn))
            return rt = Ht, !1;
        }), rt;
      }
      function th(pe, Re, Oe, rt) {
        for (var xt = pe.length, Ht = Oe + (rt ? 1 : -1); rt ? Ht-- : ++Ht < xt; )
          if (Re(pe[Ht], Ht, pe))
            return Ht;
        return -1;
      }
      function bl(pe, Re, Oe) {
        return Re === Re ? mV(pe, Re, Oe) : th(pe, O_, Oe);
      }
      function oV(pe, Re, Oe, rt) {
        for (var xt = Oe - 1, Ht = pe.length; ++xt < Ht; )
          if (rt(pe[xt], Re))
            return xt;
        return -1;
      }
      function O_(pe) {
        return pe !== pe;
      }
      function S_(pe, Re) {
        var Oe = pe == null ? 0 : pe.length;
        return Oe ? Fy(pe, Re) / Oe : K;
      }
      function Ly(pe) {
        return function(Re) {
          return Re == null ? n : Re[pe];
        };
      }
      function jy(pe) {
        return function(Re) {
          return pe == null ? n : pe[Re];
        };
      }
      function C_(pe, Re, Oe, rt, xt) {
        return xt(pe, function(Ht, Xn, ln) {
          Oe = rt ? (rt = !1, Ht) : Re(Oe, Ht, Xn, ln);
        }), Oe;
      }
      function iV(pe, Re) {
        var Oe = pe.length;
        for (pe.sort(Re); Oe--; )
          pe[Oe] = pe[Oe].value;
        return pe;
      }
      function Fy(pe, Re) {
        for (var Oe, rt = -1, xt = pe.length; ++rt < xt; ) {
          var Ht = Re(pe[rt]);
          Ht !== n && (Oe = Oe === n ? Ht : Oe + Ht);
        }
        return Oe;
      }
      function zy(pe, Re) {
        for (var Oe = -1, rt = Array(pe); ++Oe < pe; )
          rt[Oe] = Re(Oe);
        return rt;
      }
      function aV(pe, Re) {
        return vn(Re, function(Oe) {
          return [Oe, pe[Oe]];
        });
      }
      function T_(pe) {
        return pe && pe.slice(0, R_(pe) + 1).replace(_i, "");
      }
      function ao(pe) {
        return function(Re) {
          return pe(Re);
        };
      }
      function By(pe, Re) {
        return vn(Re, function(Oe) {
          return pe[Oe];
        });
      }
      function fd(pe, Re) {
        return pe.has(Re);
      }
      function E_(pe, Re) {
        for (var Oe = -1, rt = pe.length; ++Oe < rt && bl(Re, pe[Oe], 0) > -1; )
          ;
        return Oe;
      }
      function __(pe, Re) {
        for (var Oe = pe.length; Oe-- && bl(Re, pe[Oe], 0) > -1; )
          ;
        return Oe;
      }
      function sV(pe, Re) {
        for (var Oe = pe.length, rt = 0; Oe--; )
          pe[Oe] === Re && ++rt;
        return rt;
      }
      var cV = jy(HH), lV = jy(VH);
      function uV(pe) {
        return "\\" + GH[pe];
      }
      function dV(pe, Re) {
        return pe == null ? n : pe[Re];
      }
      function xl(pe) {
        return BH.test(pe);
      }
      function fV(pe) {
        return qH.test(pe);
      }
      function pV(pe) {
        for (var Re, Oe = []; !(Re = pe.next()).done; )
          Oe.push(Re.value);
        return Oe;
      }
      function qy(pe) {
        var Re = -1, Oe = Array(pe.size);
        return pe.forEach(function(rt, xt) {
          Oe[++Re] = [xt, rt];
        }), Oe;
      }
      function k_(pe, Re) {
        return function(Oe) {
          return pe(Re(Oe));
        };
      }
      function rs(pe, Re) {
        for (var Oe = -1, rt = pe.length, xt = 0, Ht = []; ++Oe < rt; ) {
          var Xn = pe[Oe];
          (Xn === Re || Xn === d) && (pe[Oe] = d, Ht[xt++] = Oe);
        }
        return Ht;
      }
      function nh(pe) {
        var Re = -1, Oe = Array(pe.size);
        return pe.forEach(function(rt) {
          Oe[++Re] = rt;
        }), Oe;
      }
      function hV(pe) {
        var Re = -1, Oe = Array(pe.size);
        return pe.forEach(function(rt) {
          Oe[++Re] = [rt, rt];
        }), Oe;
      }
      function mV(pe, Re, Oe) {
        for (var rt = Oe - 1, xt = pe.length; ++rt < xt; )
          if (pe[rt] === Re)
            return rt;
        return -1;
      }
      function gV(pe, Re, Oe) {
        for (var rt = Oe + 1; rt--; )
          if (pe[rt] === Re)
            return rt;
        return rt;
      }
      function wl(pe) {
        return xl(pe) ? yV(pe) : tV(pe);
      }
      function si(pe) {
        return xl(pe) ? bV(pe) : nV(pe);
      }
      function R_(pe) {
        for (var Re = pe.length; Re-- && dd.test(pe.charAt(Re)); )
          ;
        return Re;
      }
      var vV = jy(YH);
      function yV(pe) {
        for (var Re = Py.lastIndex = 0; Py.test(pe); )
          ++Re;
        return Re;
      }
      function bV(pe) {
        return pe.match(Py) || [];
      }
      function xV(pe) {
        return pe.match(zH) || [];
      }
      var wV = function pe(Re) {
        Re = Re == null ? cr : $l.defaults(cr.Object(), Re, $l.pick(cr, UH));
        var Oe = Re.Array, rt = Re.Date, xt = Re.Error, Ht = Re.Function, Xn = Re.Math, ln = Re.Object, Uy = Re.RegExp, $V = Re.String, Ro = Re.TypeError, rh = Oe.prototype, OV = Ht.prototype, Ol = ln.prototype, oh = Re["__core-js_shared__"], ih = OV.toString, en = Ol.hasOwnProperty, SV = 0, P_ = function() {
          var p = /[^.]+$/.exec(oh && oh.keys && oh.keys.IE_PROTO || "");
          return p ? "Symbol(src)_1." + p : "";
        }(), ah = Ol.toString, CV = ih.call(ln), TV = cr._, EV = Uy(
          "^" + ih.call(en).replace(Kn, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), sh = h_ ? Re.Buffer : n, os = Re.Symbol, ch = Re.Uint8Array, A_ = sh ? sh.allocUnsafe : n, lh = k_(ln.getPrototypeOf, ln), I_ = ln.create, M_ = Ol.propertyIsEnumerable, uh = rh.splice, N_ = os ? os.isConcatSpreadable : n, pd = os ? os.iterator : n, tc = os ? os.toStringTag : n, dh = function() {
          try {
            var p = ac(ln, "defineProperty");
            return p({}, "", {}), p;
          } catch {
          }
        }(), _V = Re.clearTimeout !== cr.clearTimeout && Re.clearTimeout, kV = rt && rt.now !== cr.Date.now && rt.now, RV = Re.setTimeout !== cr.setTimeout && Re.setTimeout, fh = Xn.ceil, ph = Xn.floor, Wy = ln.getOwnPropertySymbols, PV = sh ? sh.isBuffer : n, D_ = Re.isFinite, AV = rh.join, IV = k_(ln.keys, ln), Zn = Xn.max, yr = Xn.min, MV = rt.now, NV = Re.parseInt, L_ = Xn.random, DV = rh.reverse, Hy = ac(Re, "DataView"), hd = ac(Re, "Map"), Vy = ac(Re, "Promise"), Sl = ac(Re, "Set"), md = ac(Re, "WeakMap"), gd = ac(ln, "create"), hh = md && new md(), Cl = {}, LV = sc(Hy), jV = sc(hd), FV = sc(Vy), zV = sc(Sl), BV = sc(md), mh = os ? os.prototype : n, vd = mh ? mh.valueOf : n, j_ = mh ? mh.toString : n;
        function B(p) {
          if (Pn(p) && !Ot(p) && !(p instanceof jt)) {
            if (p instanceof Po)
              return p;
            if (en.call(p, "__wrapped__"))
              return Fk(p);
          }
          return new Po(p);
        }
        var Tl = /* @__PURE__ */ function() {
          function p() {
          }
          return function(m) {
            if (!Sn(m))
              return {};
            if (I_)
              return I_(m);
            p.prototype = m;
            var w = new p();
            return p.prototype = n, w;
          };
        }();
        function gh() {
        }
        function Po(p, m) {
          this.__wrapped__ = p, this.__actions__ = [], this.__chain__ = !!m, this.__index__ = 0, this.__values__ = n;
        }
        B.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: ot,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: Mt,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: Pt,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: B
          }
        }, B.prototype = gh.prototype, B.prototype.constructor = B, Po.prototype = Tl(gh.prototype), Po.prototype.constructor = Po;
        function jt(p) {
          this.__wrapped__ = p, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Y, this.__views__ = [];
        }
        function qV() {
          var p = new jt(this.__wrapped__);
          return p.__actions__ = zr(this.__actions__), p.__dir__ = this.__dir__, p.__filtered__ = this.__filtered__, p.__iteratees__ = zr(this.__iteratees__), p.__takeCount__ = this.__takeCount__, p.__views__ = zr(this.__views__), p;
        }
        function UV() {
          if (this.__filtered__) {
            var p = new jt(this);
            p.__dir__ = -1, p.__filtered__ = !0;
          } else
            p = this.clone(), p.__dir__ *= -1;
          return p;
        }
        function WV() {
          var p = this.__wrapped__.value(), m = this.__dir__, w = Ot(p), R = m < 0, j = w ? p.length : 0, H = nG(0, j, this.__views__), te = H.start, ae = H.end, me = ae - te, De = R ? ae : te - 1, ze = this.__iteratees__, qe = ze.length, tt = 0, it = yr(me, this.__takeCount__);
          if (!w || !R && j == me && it == me)
            return ck(p, this.__actions__);
          var ut = [];
          e:
            for (; me-- && tt < it; ) {
              De += m;
              for (var _t = -1, dt = p[De]; ++_t < qe; ) {
                var Nt = ze[_t], zt = Nt.iteratee, lo = Nt.type, Ir = zt(dt);
                if (lo == L)
                  dt = Ir;
                else if (!Ir) {
                  if (lo == N)
                    continue e;
                  break e;
                }
              }
              ut[tt++] = dt;
            }
          return ut;
        }
        jt.prototype = Tl(gh.prototype), jt.prototype.constructor = jt;
        function nc(p) {
          var m = -1, w = p == null ? 0 : p.length;
          for (this.clear(); ++m < w; ) {
            var R = p[m];
            this.set(R[0], R[1]);
          }
        }
        function HV() {
          this.__data__ = gd ? gd(null) : {}, this.size = 0;
        }
        function VV(p) {
          var m = this.has(p) && delete this.__data__[p];
          return this.size -= m ? 1 : 0, m;
        }
        function YV(p) {
          var m = this.__data__;
          if (gd) {
            var w = m[p];
            return w === l ? n : w;
          }
          return en.call(m, p) ? m[p] : n;
        }
        function GV(p) {
          var m = this.__data__;
          return gd ? m[p] !== n : en.call(m, p);
        }
        function KV(p, m) {
          var w = this.__data__;
          return this.size += this.has(p) ? 0 : 1, w[p] = gd && m === n ? l : m, this;
        }
        nc.prototype.clear = HV, nc.prototype.delete = VV, nc.prototype.get = YV, nc.prototype.has = GV, nc.prototype.set = KV;
        function va(p) {
          var m = -1, w = p == null ? 0 : p.length;
          for (this.clear(); ++m < w; ) {
            var R = p[m];
            this.set(R[0], R[1]);
          }
        }
        function XV() {
          this.__data__ = [], this.size = 0;
        }
        function ZV(p) {
          var m = this.__data__, w = vh(m, p);
          if (w < 0)
            return !1;
          var R = m.length - 1;
          return w == R ? m.pop() : uh.call(m, w, 1), --this.size, !0;
        }
        function JV(p) {
          var m = this.__data__, w = vh(m, p);
          return w < 0 ? n : m[w][1];
        }
        function QV(p) {
          return vh(this.__data__, p) > -1;
        }
        function eY(p, m) {
          var w = this.__data__, R = vh(w, p);
          return R < 0 ? (++this.size, w.push([p, m])) : w[R][1] = m, this;
        }
        va.prototype.clear = XV, va.prototype.delete = ZV, va.prototype.get = JV, va.prototype.has = QV, va.prototype.set = eY;
        function ya(p) {
          var m = -1, w = p == null ? 0 : p.length;
          for (this.clear(); ++m < w; ) {
            var R = p[m];
            this.set(R[0], R[1]);
          }
        }
        function tY() {
          this.size = 0, this.__data__ = {
            hash: new nc(),
            map: new (hd || va)(),
            string: new nc()
          };
        }
        function nY(p) {
          var m = kh(this, p).delete(p);
          return this.size -= m ? 1 : 0, m;
        }
        function rY(p) {
          return kh(this, p).get(p);
        }
        function oY(p) {
          return kh(this, p).has(p);
        }
        function iY(p, m) {
          var w = kh(this, p), R = w.size;
          return w.set(p, m), this.size += w.size == R ? 0 : 1, this;
        }
        ya.prototype.clear = tY, ya.prototype.delete = nY, ya.prototype.get = rY, ya.prototype.has = oY, ya.prototype.set = iY;
        function rc(p) {
          var m = -1, w = p == null ? 0 : p.length;
          for (this.__data__ = new ya(); ++m < w; )
            this.add(p[m]);
        }
        function aY(p) {
          return this.__data__.set(p, l), this;
        }
        function sY(p) {
          return this.__data__.has(p);
        }
        rc.prototype.add = rc.prototype.push = aY, rc.prototype.has = sY;
        function ci(p) {
          var m = this.__data__ = new va(p);
          this.size = m.size;
        }
        function cY() {
          this.__data__ = new va(), this.size = 0;
        }
        function lY(p) {
          var m = this.__data__, w = m.delete(p);
          return this.size = m.size, w;
        }
        function uY(p) {
          return this.__data__.get(p);
        }
        function dY(p) {
          return this.__data__.has(p);
        }
        function fY(p, m) {
          var w = this.__data__;
          if (w instanceof va) {
            var R = w.__data__;
            if (!hd || R.length < o - 1)
              return R.push([p, m]), this.size = ++w.size, this;
            w = this.__data__ = new ya(R);
          }
          return w.set(p, m), this.size = w.size, this;
        }
        ci.prototype.clear = cY, ci.prototype.delete = lY, ci.prototype.get = uY, ci.prototype.has = dY, ci.prototype.set = fY;
        function F_(p, m) {
          var w = Ot(p), R = !w && cc(p), j = !w && !R && ls(p), H = !w && !R && !j && Rl(p), te = w || R || j || H, ae = te ? zy(p.length, $V) : [], me = ae.length;
          for (var De in p)
            (m || en.call(p, De)) && !(te && // Safari 9 has enumerable `arguments.length` in strict mode.
            (De == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            j && (De == "offset" || De == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            H && (De == "buffer" || De == "byteLength" || De == "byteOffset") || // Skip index properties.
            $a(De, me))) && ae.push(De);
          return ae;
        }
        function z_(p) {
          var m = p.length;
          return m ? p[rb(0, m - 1)] : n;
        }
        function pY(p, m) {
          return Rh(zr(p), oc(m, 0, p.length));
        }
        function hY(p) {
          return Rh(zr(p));
        }
        function Yy(p, m, w) {
          (w !== n && !li(p[m], w) || w === n && !(m in p)) && ba(p, m, w);
        }
        function yd(p, m, w) {
          var R = p[m];
          (!(en.call(p, m) && li(R, w)) || w === n && !(m in p)) && ba(p, m, w);
        }
        function vh(p, m) {
          for (var w = p.length; w--; )
            if (li(p[w][0], m))
              return w;
          return -1;
        }
        function mY(p, m, w, R) {
          return is(p, function(j, H, te) {
            m(R, j, w(j), te);
          }), R;
        }
        function B_(p, m) {
          return p && Pi(m, tr(m), p);
        }
        function gY(p, m) {
          return p && Pi(m, qr(m), p);
        }
        function ba(p, m, w) {
          m == "__proto__" && dh ? dh(p, m, {
            configurable: !0,
            enumerable: !0,
            value: w,
            writable: !0
          }) : p[m] = w;
        }
        function Gy(p, m) {
          for (var w = -1, R = m.length, j = Oe(R), H = p == null; ++w < R; )
            j[w] = H ? n : _b(p, m[w]);
          return j;
        }
        function oc(p, m, w) {
          return p === p && (w !== n && (p = p <= w ? p : w), m !== n && (p = p >= m ? p : m)), p;
        }
        function Ao(p, m, w, R, j, H) {
          var te, ae = m & f, me = m & h, De = m & v;
          if (w && (te = j ? w(p, R, j, H) : w(p)), te !== n)
            return te;
          if (!Sn(p))
            return p;
          var ze = Ot(p);
          if (ze) {
            if (te = oG(p), !ae)
              return zr(p, te);
          } else {
            var qe = br(p), tt = qe == G || qe == Se;
            if (ls(p))
              return dk(p, ae);
            if (qe == ee || qe == Z || tt && !j) {
              if (te = me || tt ? {} : Rk(p), !ae)
                return me ? YY(p, gY(te, p)) : VY(p, B_(te, p));
            } else {
              if (!fn[qe])
                return j ? p : {};
              te = iG(p, qe, ae);
            }
          }
          H || (H = new ci());
          var it = H.get(p);
          if (it)
            return it;
          H.set(p, te), iR(p) ? p.forEach(function(dt) {
            te.add(Ao(dt, m, w, dt, p, H));
          }) : rR(p) && p.forEach(function(dt, Nt) {
            te.set(Nt, Ao(dt, m, w, Nt, p, H));
          });
          var ut = De ? me ? hb : pb : me ? qr : tr, _t = ze ? n : ut(p);
          return ko(_t || p, function(dt, Nt) {
            _t && (Nt = dt, dt = p[Nt]), yd(te, Nt, Ao(dt, m, w, Nt, p, H));
          }), te;
        }
        function vY(p) {
          var m = tr(p);
          return function(w) {
            return q_(w, p, m);
          };
        }
        function q_(p, m, w) {
          var R = w.length;
          if (p == null)
            return !R;
          for (p = ln(p); R--; ) {
            var j = w[R], H = m[j], te = p[j];
            if (te === n && !(j in p) || !H(te))
              return !1;
          }
          return !0;
        }
        function U_(p, m, w) {
          if (typeof p != "function")
            throw new Ro(a);
          return Cd(function() {
            p.apply(n, w);
          }, m);
        }
        function bd(p, m, w, R) {
          var j = -1, H = eh, te = !0, ae = p.length, me = [], De = m.length;
          if (!ae)
            return me;
          w && (m = vn(m, ao(w))), R ? (H = My, te = !1) : m.length >= o && (H = fd, te = !1, m = new rc(m));
          e:
            for (; ++j < ae; ) {
              var ze = p[j], qe = w == null ? ze : w(ze);
              if (ze = R || ze !== 0 ? ze : 0, te && qe === qe) {
                for (var tt = De; tt--; )
                  if (m[tt] === qe)
                    continue e;
                me.push(ze);
              } else H(m, qe, R) || me.push(ze);
            }
          return me;
        }
        var is = gk(Ri), W_ = gk(Xy, !0);
        function yY(p, m) {
          var w = !0;
          return is(p, function(R, j, H) {
            return w = !!m(R, j, H), w;
          }), w;
        }
        function yh(p, m, w) {
          for (var R = -1, j = p.length; ++R < j; ) {
            var H = p[R], te = m(H);
            if (te != null && (ae === n ? te === te && !co(te) : w(te, ae)))
              var ae = te, me = H;
          }
          return me;
        }
        function bY(p, m, w, R) {
          var j = p.length;
          for (w = Tt(w), w < 0 && (w = -w > j ? 0 : j + w), R = R === n || R > j ? j : Tt(R), R < 0 && (R += j), R = w > R ? 0 : sR(R); w < R; )
            p[w++] = m;
          return p;
        }
        function H_(p, m) {
          var w = [];
          return is(p, function(R, j, H) {
            m(R, j, H) && w.push(R);
          }), w;
        }
        function lr(p, m, w, R, j) {
          var H = -1, te = p.length;
          for (w || (w = sG), j || (j = []); ++H < te; ) {
            var ae = p[H];
            m > 0 && w(ae) ? m > 1 ? lr(ae, m - 1, w, R, j) : ns(j, ae) : R || (j[j.length] = ae);
          }
          return j;
        }
        var Ky = vk(), V_ = vk(!0);
        function Ri(p, m) {
          return p && Ky(p, m, tr);
        }
        function Xy(p, m) {
          return p && V_(p, m, tr);
        }
        function bh(p, m) {
          return ts(m, function(w) {
            return Oa(p[w]);
          });
        }
        function ic(p, m) {
          m = ss(m, p);
          for (var w = 0, R = m.length; p != null && w < R; )
            p = p[Ai(m[w++])];
          return w && w == R ? p : n;
        }
        function Y_(p, m, w) {
          var R = m(p);
          return Ot(p) ? R : ns(R, w(p));
        }
        function Pr(p) {
          return p == null ? p === n ? J : ie : tc && tc in ln(p) ? tG(p) : hG(p);
        }
        function Zy(p, m) {
          return p > m;
        }
        function xY(p, m) {
          return p != null && en.call(p, m);
        }
        function wY(p, m) {
          return p != null && m in ln(p);
        }
        function $Y(p, m, w) {
          return p >= yr(m, w) && p < Zn(m, w);
        }
        function Jy(p, m, w) {
          for (var R = w ? My : eh, j = p[0].length, H = p.length, te = H, ae = Oe(H), me = 1 / 0, De = []; te--; ) {
            var ze = p[te];
            te && m && (ze = vn(ze, ao(m))), me = yr(ze.length, me), ae[te] = !w && (m || j >= 120 && ze.length >= 120) ? new rc(te && ze) : n;
          }
          ze = p[0];
          var qe = -1, tt = ae[0];
          e:
            for (; ++qe < j && De.length < me; ) {
              var it = ze[qe], ut = m ? m(it) : it;
              if (it = w || it !== 0 ? it : 0, !(tt ? fd(tt, ut) : R(De, ut, w))) {
                for (te = H; --te; ) {
                  var _t = ae[te];
                  if (!(_t ? fd(_t, ut) : R(p[te], ut, w)))
                    continue e;
                }
                tt && tt.push(ut), De.push(it);
              }
            }
          return De;
        }
        function OY(p, m, w, R) {
          return Ri(p, function(j, H, te) {
            m(R, w(j), H, te);
          }), R;
        }
        function xd(p, m, w) {
          m = ss(m, p), p = Mk(p, m);
          var R = p == null ? p : p[Ai(Mo(m))];
          return R == null ? n : io(R, p, w);
        }
        function G_(p) {
          return Pn(p) && Pr(p) == Z;
        }
        function SY(p) {
          return Pn(p) && Pr(p) == xe;
        }
        function CY(p) {
          return Pn(p) && Pr(p) == ne;
        }
        function wd(p, m, w, R, j) {
          return p === m ? !0 : p == null || m == null || !Pn(p) && !Pn(m) ? p !== p && m !== m : TY(p, m, w, R, wd, j);
        }
        function TY(p, m, w, R, j, H) {
          var te = Ot(p), ae = Ot(m), me = te ? ce : br(p), De = ae ? ce : br(m);
          me = me == Z ? ee : me, De = De == Z ? ee : De;
          var ze = me == ee, qe = De == ee, tt = me == De;
          if (tt && ls(p)) {
            if (!ls(m))
              return !1;
            te = !0, ze = !1;
          }
          if (tt && !ze)
            return H || (H = new ci()), te || Rl(p) ? Ek(p, m, w, R, j, H) : QY(p, m, me, w, R, j, H);
          if (!(w & y)) {
            var it = ze && en.call(p, "__wrapped__"), ut = qe && en.call(m, "__wrapped__");
            if (it || ut) {
              var _t = it ? p.value() : p, dt = ut ? m.value() : m;
              return H || (H = new ci()), j(_t, dt, w, R, H);
            }
          }
          return tt ? (H || (H = new ci()), eG(p, m, w, R, j, H)) : !1;
        }
        function EY(p) {
          return Pn(p) && br(p) == ue;
        }
        function Qy(p, m, w, R) {
          var j = w.length, H = j, te = !R;
          if (p == null)
            return !H;
          for (p = ln(p); j--; ) {
            var ae = w[j];
            if (te && ae[2] ? ae[1] !== p[ae[0]] : !(ae[0] in p))
              return !1;
          }
          for (; ++j < H; ) {
            ae = w[j];
            var me = ae[0], De = p[me], ze = ae[1];
            if (te && ae[2]) {
              if (De === n && !(me in p))
                return !1;
            } else {
              var qe = new ci();
              if (R)
                var tt = R(De, ze, me, p, m, qe);
              if (!(tt === n ? wd(ze, De, y | g, R, qe) : tt))
                return !1;
            }
          }
          return !0;
        }
        function K_(p) {
          if (!Sn(p) || lG(p))
            return !1;
          var m = Oa(p) ? EV : bt;
          return m.test(sc(p));
        }
        function _Y(p) {
          return Pn(p) && Pr(p) == je;
        }
        function kY(p) {
          return Pn(p) && br(p) == V;
        }
        function RY(p) {
          return Pn(p) && Dh(p.length) && !!hn[Pr(p)];
        }
        function X_(p) {
          return typeof p == "function" ? p : p == null ? Ur : typeof p == "object" ? Ot(p) ? Q_(p[0], p[1]) : J_(p) : yR(p);
        }
        function eb(p) {
          if (!Sd(p))
            return IV(p);
          var m = [];
          for (var w in ln(p))
            en.call(p, w) && w != "constructor" && m.push(w);
          return m;
        }
        function PY(p) {
          if (!Sn(p))
            return pG(p);
          var m = Sd(p), w = [];
          for (var R in p)
            R == "constructor" && (m || !en.call(p, R)) || w.push(R);
          return w;
        }
        function tb(p, m) {
          return p < m;
        }
        function Z_(p, m) {
          var w = -1, R = Br(p) ? Oe(p.length) : [];
          return is(p, function(j, H, te) {
            R[++w] = m(j, H, te);
          }), R;
        }
        function J_(p) {
          var m = gb(p);
          return m.length == 1 && m[0][2] ? Ak(m[0][0], m[0][1]) : function(w) {
            return w === p || Qy(w, p, m);
          };
        }
        function Q_(p, m) {
          return yb(p) && Pk(m) ? Ak(Ai(p), m) : function(w) {
            var R = _b(w, p);
            return R === n && R === m ? kb(w, p) : wd(m, R, y | g);
          };
        }
        function xh(p, m, w, R, j) {
          p !== m && Ky(m, function(H, te) {
            if (j || (j = new ci()), Sn(H))
              AY(p, m, te, w, xh, R, j);
            else {
              var ae = R ? R(xb(p, te), H, te + "", p, m, j) : n;
              ae === n && (ae = H), Yy(p, te, ae);
            }
          }, qr);
        }
        function AY(p, m, w, R, j, H, te) {
          var ae = xb(p, w), me = xb(m, w), De = te.get(me);
          if (De) {
            Yy(p, w, De);
            return;
          }
          var ze = H ? H(ae, me, w + "", p, m, te) : n, qe = ze === n;
          if (qe) {
            var tt = Ot(me), it = !tt && ls(me), ut = !tt && !it && Rl(me);
            ze = me, tt || it || ut ? Ot(ae) ? ze = ae : Fn(ae) ? ze = zr(ae) : it ? (qe = !1, ze = dk(me, !0)) : ut ? (qe = !1, ze = fk(me, !0)) : ze = [] : Td(me) || cc(me) ? (ze = ae, cc(ae) ? ze = cR(ae) : (!Sn(ae) || Oa(ae)) && (ze = Rk(me))) : qe = !1;
          }
          qe && (te.set(me, ze), j(ze, me, R, H, te), te.delete(me)), Yy(p, w, ze);
        }
        function ek(p, m) {
          var w = p.length;
          if (w)
            return m += m < 0 ? w : 0, $a(m, w) ? p[m] : n;
        }
        function tk(p, m, w) {
          m.length ? m = vn(m, function(H) {
            return Ot(H) ? function(te) {
              return ic(te, H.length === 1 ? H[0] : H);
            } : H;
          }) : m = [Ur];
          var R = -1;
          m = vn(m, ao(lt()));
          var j = Z_(p, function(H, te, ae) {
            var me = vn(m, function(De) {
              return De(H);
            });
            return { criteria: me, index: ++R, value: H };
          });
          return iV(j, function(H, te) {
            return HY(H, te, w);
          });
        }
        function IY(p, m) {
          return nk(p, m, function(w, R) {
            return kb(p, R);
          });
        }
        function nk(p, m, w) {
          for (var R = -1, j = m.length, H = {}; ++R < j; ) {
            var te = m[R], ae = ic(p, te);
            w(ae, te) && $d(H, ss(te, p), ae);
          }
          return H;
        }
        function MY(p) {
          return function(m) {
            return ic(m, p);
          };
        }
        function nb(p, m, w, R) {
          var j = R ? oV : bl, H = -1, te = m.length, ae = p;
          for (p === m && (m = zr(m)), w && (ae = vn(p, ao(w))); ++H < te; )
            for (var me = 0, De = m[H], ze = w ? w(De) : De; (me = j(ae, ze, me, R)) > -1; )
              ae !== p && uh.call(ae, me, 1), uh.call(p, me, 1);
          return p;
        }
        function rk(p, m) {
          for (var w = p ? m.length : 0, R = w - 1; w--; ) {
            var j = m[w];
            if (w == R || j !== H) {
              var H = j;
              $a(j) ? uh.call(p, j, 1) : ab(p, j);
            }
          }
          return p;
        }
        function rb(p, m) {
          return p + ph(L_() * (m - p + 1));
        }
        function NY(p, m, w, R) {
          for (var j = -1, H = Zn(fh((m - p) / (w || 1)), 0), te = Oe(H); H--; )
            te[R ? H : ++j] = p, p += w;
          return te;
        }
        function ob(p, m) {
          var w = "";
          if (!p || m < 1 || m > W)
            return w;
          do
            m % 2 && (w += p), m = ph(m / 2), m && (p += p);
          while (m);
          return w;
        }
        function At(p, m) {
          return wb(Ik(p, m, Ur), p + "");
        }
        function DY(p) {
          return z_(Pl(p));
        }
        function LY(p, m) {
          var w = Pl(p);
          return Rh(w, oc(m, 0, w.length));
        }
        function $d(p, m, w, R) {
          if (!Sn(p))
            return p;
          m = ss(m, p);
          for (var j = -1, H = m.length, te = H - 1, ae = p; ae != null && ++j < H; ) {
            var me = Ai(m[j]), De = w;
            if (me === "__proto__" || me === "constructor" || me === "prototype")
              return p;
            if (j != te) {
              var ze = ae[me];
              De = R ? R(ze, me, ae) : n, De === n && (De = Sn(ze) ? ze : $a(m[j + 1]) ? [] : {});
            }
            yd(ae, me, De), ae = ae[me];
          }
          return p;
        }
        var ok = hh ? function(p, m) {
          return hh.set(p, m), p;
        } : Ur, jY = dh ? function(p, m) {
          return dh(p, "toString", {
            configurable: !0,
            enumerable: !1,
            value: Pb(m),
            writable: !0
          });
        } : Ur;
        function FY(p) {
          return Rh(Pl(p));
        }
        function Io(p, m, w) {
          var R = -1, j = p.length;
          m < 0 && (m = -m > j ? 0 : j + m), w = w > j ? j : w, w < 0 && (w += j), j = m > w ? 0 : w - m >>> 0, m >>>= 0;
          for (var H = Oe(j); ++R < j; )
            H[R] = p[R + m];
          return H;
        }
        function zY(p, m) {
          var w;
          return is(p, function(R, j, H) {
            return w = m(R, j, H), !w;
          }), !!w;
        }
        function wh(p, m, w) {
          var R = 0, j = p == null ? R : p.length;
          if (typeof m == "number" && m === m && j <= oe) {
            for (; R < j; ) {
              var H = R + j >>> 1, te = p[H];
              te !== null && !co(te) && (w ? te <= m : te < m) ? R = H + 1 : j = H;
            }
            return j;
          }
          return ib(p, m, Ur, w);
        }
        function ib(p, m, w, R) {
          var j = 0, H = p == null ? 0 : p.length;
          if (H === 0)
            return 0;
          m = w(m);
          for (var te = m !== m, ae = m === null, me = co(m), De = m === n; j < H; ) {
            var ze = ph((j + H) / 2), qe = w(p[ze]), tt = qe !== n, it = qe === null, ut = qe === qe, _t = co(qe);
            if (te)
              var dt = R || ut;
            else De ? dt = ut && (R || tt) : ae ? dt = ut && tt && (R || !it) : me ? dt = ut && tt && !it && (R || !_t) : it || _t ? dt = !1 : dt = R ? qe <= m : qe < m;
            dt ? j = ze + 1 : H = ze;
          }
          return yr(H, X);
        }
        function ik(p, m) {
          for (var w = -1, R = p.length, j = 0, H = []; ++w < R; ) {
            var te = p[w], ae = m ? m(te) : te;
            if (!w || !li(ae, me)) {
              var me = ae;
              H[j++] = te === 0 ? 0 : te;
            }
          }
          return H;
        }
        function ak(p) {
          return typeof p == "number" ? p : co(p) ? K : +p;
        }
        function so(p) {
          if (typeof p == "string")
            return p;
          if (Ot(p))
            return vn(p, so) + "";
          if (co(p))
            return j_ ? j_.call(p) : "";
          var m = p + "";
          return m == "0" && 1 / p == -q ? "-0" : m;
        }
        function as(p, m, w) {
          var R = -1, j = eh, H = p.length, te = !0, ae = [], me = ae;
          if (w)
            te = !1, j = My;
          else if (H >= o) {
            var De = m ? null : ZY(p);
            if (De)
              return nh(De);
            te = !1, j = fd, me = new rc();
          } else
            me = m ? [] : ae;
          e:
            for (; ++R < H; ) {
              var ze = p[R], qe = m ? m(ze) : ze;
              if (ze = w || ze !== 0 ? ze : 0, te && qe === qe) {
                for (var tt = me.length; tt--; )
                  if (me[tt] === qe)
                    continue e;
                m && me.push(qe), ae.push(ze);
              } else j(me, qe, w) || (me !== ae && me.push(qe), ae.push(ze));
            }
          return ae;
        }
        function ab(p, m) {
          return m = ss(m, p), p = Mk(p, m), p == null || delete p[Ai(Mo(m))];
        }
        function sk(p, m, w, R) {
          return $d(p, m, w(ic(p, m)), R);
        }
        function $h(p, m, w, R) {
          for (var j = p.length, H = R ? j : -1; (R ? H-- : ++H < j) && m(p[H], H, p); )
            ;
          return w ? Io(p, R ? 0 : H, R ? H + 1 : j) : Io(p, R ? H + 1 : 0, R ? j : H);
        }
        function ck(p, m) {
          var w = p;
          return w instanceof jt && (w = w.value()), Ny(m, function(R, j) {
            return j.func.apply(j.thisArg, ns([R], j.args));
          }, w);
        }
        function sb(p, m, w) {
          var R = p.length;
          if (R < 2)
            return R ? as(p[0]) : [];
          for (var j = -1, H = Oe(R); ++j < R; )
            for (var te = p[j], ae = -1; ++ae < R; )
              ae != j && (H[j] = bd(H[j] || te, p[ae], m, w));
          return as(lr(H, 1), m, w);
        }
        function lk(p, m, w) {
          for (var R = -1, j = p.length, H = m.length, te = {}; ++R < j; ) {
            var ae = R < H ? m[R] : n;
            w(te, p[R], ae);
          }
          return te;
        }
        function cb(p) {
          return Fn(p) ? p : [];
        }
        function lb(p) {
          return typeof p == "function" ? p : Ur;
        }
        function ss(p, m) {
          return Ot(p) ? p : yb(p, m) ? [p] : jk(Zt(p));
        }
        var BY = At;
        function cs(p, m, w) {
          var R = p.length;
          return w = w === n ? R : w, !m && w >= R ? p : Io(p, m, w);
        }
        var uk = _V || function(p) {
          return cr.clearTimeout(p);
        };
        function dk(p, m) {
          if (m)
            return p.slice();
          var w = p.length, R = A_ ? A_(w) : new p.constructor(w);
          return p.copy(R), R;
        }
        function ub(p) {
          var m = new p.constructor(p.byteLength);
          return new ch(m).set(new ch(p)), m;
        }
        function qY(p, m) {
          var w = m ? ub(p.buffer) : p.buffer;
          return new p.constructor(w, p.byteOffset, p.byteLength);
        }
        function UY(p) {
          var m = new p.constructor(p.source, Ee.exec(p));
          return m.lastIndex = p.lastIndex, m;
        }
        function WY(p) {
          return vd ? ln(vd.call(p)) : {};
        }
        function fk(p, m) {
          var w = m ? ub(p.buffer) : p.buffer;
          return new p.constructor(w, p.byteOffset, p.length);
        }
        function pk(p, m) {
          if (p !== m) {
            var w = p !== n, R = p === null, j = p === p, H = co(p), te = m !== n, ae = m === null, me = m === m, De = co(m);
            if (!ae && !De && !H && p > m || H && te && me && !ae && !De || R && te && me || !w && me || !j)
              return 1;
            if (!R && !H && !De && p < m || De && w && j && !R && !H || ae && w && j || !te && j || !me)
              return -1;
          }
          return 0;
        }
        function HY(p, m, w) {
          for (var R = -1, j = p.criteria, H = m.criteria, te = j.length, ae = w.length; ++R < te; ) {
            var me = pk(j[R], H[R]);
            if (me) {
              if (R >= ae)
                return me;
              var De = w[R];
              return me * (De == "desc" ? -1 : 1);
            }
          }
          return p.index - m.index;
        }
        function hk(p, m, w, R) {
          for (var j = -1, H = p.length, te = w.length, ae = -1, me = m.length, De = Zn(H - te, 0), ze = Oe(me + De), qe = !R; ++ae < me; )
            ze[ae] = m[ae];
          for (; ++j < te; )
            (qe || j < H) && (ze[w[j]] = p[j]);
          for (; De--; )
            ze[ae++] = p[j++];
          return ze;
        }
        function mk(p, m, w, R) {
          for (var j = -1, H = p.length, te = -1, ae = w.length, me = -1, De = m.length, ze = Zn(H - ae, 0), qe = Oe(ze + De), tt = !R; ++j < ze; )
            qe[j] = p[j];
          for (var it = j; ++me < De; )
            qe[it + me] = m[me];
          for (; ++te < ae; )
            (tt || j < H) && (qe[it + w[te]] = p[j++]);
          return qe;
        }
        function zr(p, m) {
          var w = -1, R = p.length;
          for (m || (m = Oe(R)); ++w < R; )
            m[w] = p[w];
          return m;
        }
        function Pi(p, m, w, R) {
          var j = !w;
          w || (w = {});
          for (var H = -1, te = m.length; ++H < te; ) {
            var ae = m[H], me = R ? R(w[ae], p[ae], ae, w, p) : n;
            me === n && (me = p[ae]), j ? ba(w, ae, me) : yd(w, ae, me);
          }
          return w;
        }
        function VY(p, m) {
          return Pi(p, vb(p), m);
        }
        function YY(p, m) {
          return Pi(p, _k(p), m);
        }
        function Oh(p, m) {
          return function(w, R) {
            var j = Ot(w) ? JH : mY, H = m ? m() : {};
            return j(w, p, lt(R, 2), H);
          };
        }
        function El(p) {
          return At(function(m, w) {
            var R = -1, j = w.length, H = j > 1 ? w[j - 1] : n, te = j > 2 ? w[2] : n;
            for (H = p.length > 3 && typeof H == "function" ? (j--, H) : n, te && Ar(w[0], w[1], te) && (H = j < 3 ? n : H, j = 1), m = ln(m); ++R < j; ) {
              var ae = w[R];
              ae && p(m, ae, R, H);
            }
            return m;
          });
        }
        function gk(p, m) {
          return function(w, R) {
            if (w == null)
              return w;
            if (!Br(w))
              return p(w, R);
            for (var j = w.length, H = m ? j : -1, te = ln(w); (m ? H-- : ++H < j) && R(te[H], H, te) !== !1; )
              ;
            return w;
          };
        }
        function vk(p) {
          return function(m, w, R) {
            for (var j = -1, H = ln(m), te = R(m), ae = te.length; ae--; ) {
              var me = te[p ? ae : ++j];
              if (w(H[me], me, H) === !1)
                break;
            }
            return m;
          };
        }
        function GY(p, m, w) {
          var R = m & b, j = Od(p);
          function H() {
            var te = this && this !== cr && this instanceof H ? j : p;
            return te.apply(R ? w : this, arguments);
          }
          return H;
        }
        function yk(p) {
          return function(m) {
            m = Zt(m);
            var w = xl(m) ? si(m) : n, R = w ? w[0] : m.charAt(0), j = w ? cs(w, 1).join("") : m.slice(1);
            return R[p]() + j;
          };
        }
        function _l(p) {
          return function(m) {
            return Ny(gR(mR(m).replace(jH, "")), p, "");
          };
        }
        function Od(p) {
          return function() {
            var m = arguments;
            switch (m.length) {
              case 0:
                return new p();
              case 1:
                return new p(m[0]);
              case 2:
                return new p(m[0], m[1]);
              case 3:
                return new p(m[0], m[1], m[2]);
              case 4:
                return new p(m[0], m[1], m[2], m[3]);
              case 5:
                return new p(m[0], m[1], m[2], m[3], m[4]);
              case 6:
                return new p(m[0], m[1], m[2], m[3], m[4], m[5]);
              case 7:
                return new p(m[0], m[1], m[2], m[3], m[4], m[5], m[6]);
            }
            var w = Tl(p.prototype), R = p.apply(w, m);
            return Sn(R) ? R : w;
          };
        }
        function KY(p, m, w) {
          var R = Od(p);
          function j() {
            for (var H = arguments.length, te = Oe(H), ae = H, me = kl(j); ae--; )
              te[ae] = arguments[ae];
            var De = H < 3 && te[0] !== me && te[H - 1] !== me ? [] : rs(te, me);
            if (H -= De.length, H < w)
              return Ok(
                p,
                m,
                Sh,
                j.placeholder,
                n,
                te,
                De,
                n,
                n,
                w - H
              );
            var ze = this && this !== cr && this instanceof j ? R : p;
            return io(ze, this, te);
          }
          return j;
        }
        function bk(p) {
          return function(m, w, R) {
            var j = ln(m);
            if (!Br(m)) {
              var H = lt(w, 3);
              m = tr(m), w = function(ae) {
                return H(j[ae], ae, j);
              };
            }
            var te = p(m, w, R);
            return te > -1 ? j[H ? m[te] : te] : n;
          };
        }
        function xk(p) {
          return wa(function(m) {
            var w = m.length, R = w, j = Po.prototype.thru;
            for (p && m.reverse(); R--; ) {
              var H = m[R];
              if (typeof H != "function")
                throw new Ro(a);
              if (j && !te && _h(H) == "wrapper")
                var te = new Po([], !0);
            }
            for (R = te ? R : w; ++R < w; ) {
              H = m[R];
              var ae = _h(H), me = ae == "wrapper" ? mb(H) : n;
              me && bb(me[0]) && me[1] == (k | S | C | I) && !me[4].length && me[9] == 1 ? te = te[_h(me[0])].apply(te, me[3]) : te = H.length == 1 && bb(H) ? te[ae]() : te.thru(H);
            }
            return function() {
              var De = arguments, ze = De[0];
              if (te && De.length == 1 && Ot(ze))
                return te.plant(ze).value();
              for (var qe = 0, tt = w ? m[qe].apply(this, De) : ze; ++qe < w; )
                tt = m[qe].call(this, tt);
              return tt;
            };
          });
        }
        function Sh(p, m, w, R, j, H, te, ae, me, De) {
          var ze = m & k, qe = m & b, tt = m & x, it = m & (S | O), ut = m & P, _t = tt ? n : Od(p);
          function dt() {
            for (var Nt = arguments.length, zt = Oe(Nt), lo = Nt; lo--; )
              zt[lo] = arguments[lo];
            if (it)
              var Ir = kl(dt), uo = sV(zt, Ir);
            if (R && (zt = hk(zt, R, j, it)), H && (zt = mk(zt, H, te, it)), Nt -= uo, it && Nt < De) {
              var zn = rs(zt, Ir);
              return Ok(
                p,
                m,
                Sh,
                dt.placeholder,
                w,
                zt,
                zn,
                ae,
                me,
                De - Nt
              );
            }
            var ui = qe ? w : this, Ca = tt ? ui[p] : p;
            return Nt = zt.length, ae ? zt = mG(zt, ae) : ut && Nt > 1 && zt.reverse(), ze && me < Nt && (zt.length = me), this && this !== cr && this instanceof dt && (Ca = _t || Od(Ca)), Ca.apply(ui, zt);
          }
          return dt;
        }
        function wk(p, m) {
          return function(w, R) {
            return OY(w, p, m(R), {});
          };
        }
        function Ch(p, m) {
          return function(w, R) {
            var j;
            if (w === n && R === n)
              return m;
            if (w !== n && (j = w), R !== n) {
              if (j === n)
                return R;
              typeof w == "string" || typeof R == "string" ? (w = so(w), R = so(R)) : (w = ak(w), R = ak(R)), j = p(w, R);
            }
            return j;
          };
        }
        function db(p) {
          return wa(function(m) {
            return m = vn(m, ao(lt())), At(function(w) {
              var R = this;
              return p(m, function(j) {
                return io(j, R, w);
              });
            });
          });
        }
        function Th(p, m) {
          m = m === n ? " " : so(m);
          var w = m.length;
          if (w < 2)
            return w ? ob(m, p) : m;
          var R = ob(m, fh(p / wl(m)));
          return xl(m) ? cs(si(R), 0, p).join("") : R.slice(0, p);
        }
        function XY(p, m, w, R) {
          var j = m & b, H = Od(p);
          function te() {
            for (var ae = -1, me = arguments.length, De = -1, ze = R.length, qe = Oe(ze + me), tt = this && this !== cr && this instanceof te ? H : p; ++De < ze; )
              qe[De] = R[De];
            for (; me--; )
              qe[De++] = arguments[++ae];
            return io(tt, j ? w : this, qe);
          }
          return te;
        }
        function $k(p) {
          return function(m, w, R) {
            return R && typeof R != "number" && Ar(m, w, R) && (w = R = n), m = Sa(m), w === n ? (w = m, m = 0) : w = Sa(w), R = R === n ? m < w ? 1 : -1 : Sa(R), NY(m, w, R, p);
          };
        }
        function Eh(p) {
          return function(m, w) {
            return typeof m == "string" && typeof w == "string" || (m = No(m), w = No(w)), p(m, w);
          };
        }
        function Ok(p, m, w, R, j, H, te, ae, me, De) {
          var ze = m & S, qe = ze ? te : n, tt = ze ? n : te, it = ze ? H : n, ut = ze ? n : H;
          m |= ze ? C : T, m &= ~(ze ? T : C), m & $ || (m &= ~(b | x));
          var _t = [
            p,
            m,
            j,
            it,
            qe,
            ut,
            tt,
            ae,
            me,
            De
          ], dt = w.apply(n, _t);
          return bb(p) && Nk(dt, _t), dt.placeholder = R, Dk(dt, p, m);
        }
        function fb(p) {
          var m = Xn[p];
          return function(w, R) {
            if (w = No(w), R = R == null ? 0 : yr(Tt(R), 292), R && D_(w)) {
              var j = (Zt(w) + "e").split("e"), H = m(j[0] + "e" + (+j[1] + R));
              return j = (Zt(H) + "e").split("e"), +(j[0] + "e" + (+j[1] - R));
            }
            return m(w);
          };
        }
        var ZY = Sl && 1 / nh(new Sl([, -0]))[1] == q ? function(p) {
          return new Sl(p);
        } : Mb;
        function Sk(p) {
          return function(m) {
            var w = br(m);
            return w == ue ? qy(m) : w == V ? hV(m) : aV(m, p(m));
          };
        }
        function xa(p, m, w, R, j, H, te, ae) {
          var me = m & x;
          if (!me && typeof p != "function")
            throw new Ro(a);
          var De = R ? R.length : 0;
          if (De || (m &= ~(C | T), R = j = n), te = te === n ? te : Zn(Tt(te), 0), ae = ae === n ? ae : Tt(ae), De -= j ? j.length : 0, m & T) {
            var ze = R, qe = j;
            R = j = n;
          }
          var tt = me ? n : mb(p), it = [
            p,
            m,
            w,
            R,
            j,
            ze,
            qe,
            H,
            te,
            ae
          ];
          if (tt && fG(it, tt), p = it[0], m = it[1], w = it[2], R = it[3], j = it[4], ae = it[9] = it[9] === n ? me ? 0 : p.length : Zn(it[9] - De, 0), !ae && m & (S | O) && (m &= ~(S | O)), !m || m == b)
            var ut = GY(p, m, w);
          else m == S || m == O ? ut = KY(p, m, ae) : (m == C || m == (b | C)) && !j.length ? ut = XY(p, m, w, R) : ut = Sh.apply(n, it);
          var _t = tt ? ok : Nk;
          return Dk(_t(ut, it), p, m);
        }
        function Ck(p, m, w, R) {
          return p === n || li(p, Ol[w]) && !en.call(R, w) ? m : p;
        }
        function Tk(p, m, w, R, j, H) {
          return Sn(p) && Sn(m) && (H.set(m, p), xh(p, m, n, Tk, H), H.delete(m)), p;
        }
        function JY(p) {
          return Td(p) ? n : p;
        }
        function Ek(p, m, w, R, j, H) {
          var te = w & y, ae = p.length, me = m.length;
          if (ae != me && !(te && me > ae))
            return !1;
          var De = H.get(p), ze = H.get(m);
          if (De && ze)
            return De == m && ze == p;
          var qe = -1, tt = !0, it = w & g ? new rc() : n;
          for (H.set(p, m), H.set(m, p); ++qe < ae; ) {
            var ut = p[qe], _t = m[qe];
            if (R)
              var dt = te ? R(_t, ut, qe, m, p, H) : R(ut, _t, qe, p, m, H);
            if (dt !== n) {
              if (dt)
                continue;
              tt = !1;
              break;
            }
            if (it) {
              if (!Dy(m, function(Nt, zt) {
                if (!fd(it, zt) && (ut === Nt || j(ut, Nt, w, R, H)))
                  return it.push(zt);
              })) {
                tt = !1;
                break;
              }
            } else if (!(ut === _t || j(ut, _t, w, R, H))) {
              tt = !1;
              break;
            }
          }
          return H.delete(p), H.delete(m), tt;
        }
        function QY(p, m, w, R, j, H, te) {
          switch (w) {
            case Ae:
              if (p.byteLength != m.byteLength || p.byteOffset != m.byteOffset)
                return !1;
              p = p.buffer, m = m.buffer;
            case xe:
              return !(p.byteLength != m.byteLength || !H(new ch(p), new ch(m)));
            case de:
            case ne:
            case Q:
              return li(+p, +m);
            case ve:
              return p.name == m.name && p.message == m.message;
            case je:
            case se:
              return p == m + "";
            case ue:
              var ae = qy;
            case V:
              var me = R & y;
              if (ae || (ae = nh), p.size != m.size && !me)
                return !1;
              var De = te.get(p);
              if (De)
                return De == m;
              R |= g, te.set(p, m);
              var ze = Ek(ae(p), ae(m), R, j, H, te);
              return te.delete(p), ze;
            case we:
              if (vd)
                return vd.call(p) == vd.call(m);
          }
          return !1;
        }
        function eG(p, m, w, R, j, H) {
          var te = w & y, ae = pb(p), me = ae.length, De = pb(m), ze = De.length;
          if (me != ze && !te)
            return !1;
          for (var qe = me; qe--; ) {
            var tt = ae[qe];
            if (!(te ? tt in m : en.call(m, tt)))
              return !1;
          }
          var it = H.get(p), ut = H.get(m);
          if (it && ut)
            return it == m && ut == p;
          var _t = !0;
          H.set(p, m), H.set(m, p);
          for (var dt = te; ++qe < me; ) {
            tt = ae[qe];
            var Nt = p[tt], zt = m[tt];
            if (R)
              var lo = te ? R(zt, Nt, tt, m, p, H) : R(Nt, zt, tt, p, m, H);
            if (!(lo === n ? Nt === zt || j(Nt, zt, w, R, H) : lo)) {
              _t = !1;
              break;
            }
            dt || (dt = tt == "constructor");
          }
          if (_t && !dt) {
            var Ir = p.constructor, uo = m.constructor;
            Ir != uo && "constructor" in p && "constructor" in m && !(typeof Ir == "function" && Ir instanceof Ir && typeof uo == "function" && uo instanceof uo) && (_t = !1);
          }
          return H.delete(p), H.delete(m), _t;
        }
        function wa(p) {
          return wb(Ik(p, n, qk), p + "");
        }
        function pb(p) {
          return Y_(p, tr, vb);
        }
        function hb(p) {
          return Y_(p, qr, _k);
        }
        var mb = hh ? function(p) {
          return hh.get(p);
        } : Mb;
        function _h(p) {
          for (var m = p.name + "", w = Cl[m], R = en.call(Cl, m) ? w.length : 0; R--; ) {
            var j = w[R], H = j.func;
            if (H == null || H == p)
              return j.name;
          }
          return m;
        }
        function kl(p) {
          var m = en.call(B, "placeholder") ? B : p;
          return m.placeholder;
        }
        function lt() {
          var p = B.iteratee || Ab;
          return p = p === Ab ? X_ : p, arguments.length ? p(arguments[0], arguments[1]) : p;
        }
        function kh(p, m) {
          var w = p.__data__;
          return cG(m) ? w[typeof m == "string" ? "string" : "hash"] : w.map;
        }
        function gb(p) {
          for (var m = tr(p), w = m.length; w--; ) {
            var R = m[w], j = p[R];
            m[w] = [R, j, Pk(j)];
          }
          return m;
        }
        function ac(p, m) {
          var w = dV(p, m);
          return K_(w) ? w : n;
        }
        function tG(p) {
          var m = en.call(p, tc), w = p[tc];
          try {
            p[tc] = n;
            var R = !0;
          } catch {
          }
          var j = ah.call(p);
          return R && (m ? p[tc] = w : delete p[tc]), j;
        }
        var vb = Wy ? function(p) {
          return p == null ? [] : (p = ln(p), ts(Wy(p), function(m) {
            return M_.call(p, m);
          }));
        } : Nb, _k = Wy ? function(p) {
          for (var m = []; p; )
            ns(m, vb(p)), p = lh(p);
          return m;
        } : Nb, br = Pr;
        (Hy && br(new Hy(new ArrayBuffer(1))) != Ae || hd && br(new hd()) != ue || Vy && br(Vy.resolve()) != be || Sl && br(new Sl()) != V || md && br(new md()) != he) && (br = function(p) {
          var m = Pr(p), w = m == ee ? p.constructor : n, R = w ? sc(w) : "";
          if (R)
            switch (R) {
              case LV:
                return Ae;
              case jV:
                return ue;
              case FV:
                return be;
              case zV:
                return V;
              case BV:
                return he;
            }
          return m;
        });
        function nG(p, m, w) {
          for (var R = -1, j = w.length; ++R < j; ) {
            var H = w[R], te = H.size;
            switch (H.type) {
              case "drop":
                p += te;
                break;
              case "dropRight":
                m -= te;
                break;
              case "take":
                m = yr(m, p + te);
                break;
              case "takeRight":
                p = Zn(p, m - te);
                break;
            }
          }
          return { start: p, end: m };
        }
        function rG(p) {
          var m = p.match(Zp);
          return m ? m[1].split(Zs) : [];
        }
        function kk(p, m, w) {
          m = ss(m, p);
          for (var R = -1, j = m.length, H = !1; ++R < j; ) {
            var te = Ai(m[R]);
            if (!(H = p != null && w(p, te)))
              break;
            p = p[te];
          }
          return H || ++R != j ? H : (j = p == null ? 0 : p.length, !!j && Dh(j) && $a(te, j) && (Ot(p) || cc(p)));
        }
        function oG(p) {
          var m = p.length, w = new p.constructor(m);
          return m && typeof p[0] == "string" && en.call(p, "index") && (w.index = p.index, w.input = p.input), w;
        }
        function Rk(p) {
          return typeof p.constructor == "function" && !Sd(p) ? Tl(lh(p)) : {};
        }
        function iG(p, m, w) {
          var R = p.constructor;
          switch (m) {
            case xe:
              return ub(p);
            case de:
            case ne:
              return new R(+p);
            case Ae:
              return qY(p, w);
            case Ce:
            case Ye:
            case He:
            case Be:
            case Xe:
            case Ze:
            case Ne:
            case $e:
            case Ue:
              return fk(p, w);
            case ue:
              return new R();
            case Q:
            case se:
              return new R(p);
            case je:
              return UY(p);
            case V:
              return new R();
            case we:
              return WY(p);
          }
        }
        function aG(p, m) {
          var w = m.length;
          if (!w)
            return p;
          var R = w - 1;
          return m[R] = (w > 1 ? "& " : "") + m[R], m = m.join(w > 2 ? ", " : " "), p.replace(pl, `{
/* [wrapped with ` + m + `] */
`);
        }
        function sG(p) {
          return Ot(p) || cc(p) || !!(N_ && p && p[N_]);
        }
        function $a(p, m) {
          var w = typeof p;
          return m = m ?? W, !!m && (w == "number" || w != "symbol" && Wt.test(p)) && p > -1 && p % 1 == 0 && p < m;
        }
        function Ar(p, m, w) {
          if (!Sn(w))
            return !1;
          var R = typeof m;
          return (R == "number" ? Br(w) && $a(m, w.length) : R == "string" && m in w) ? li(w[m], p) : !1;
        }
        function yb(p, m) {
          if (Ot(p))
            return !1;
          var w = typeof p;
          return w == "number" || w == "symbol" || w == "boolean" || p == null || co(p) ? !0 : Hn.test(p) || !On.test(p) || m != null && p in ln(m);
        }
        function cG(p) {
          var m = typeof p;
          return m == "string" || m == "number" || m == "symbol" || m == "boolean" ? p !== "__proto__" : p === null;
        }
        function bb(p) {
          var m = _h(p), w = B[m];
          if (typeof w != "function" || !(m in jt.prototype))
            return !1;
          if (p === w)
            return !0;
          var R = mb(w);
          return !!R && p === R[0];
        }
        function lG(p) {
          return !!P_ && P_ in p;
        }
        var uG = oh ? Oa : Db;
        function Sd(p) {
          var m = p && p.constructor, w = typeof m == "function" && m.prototype || Ol;
          return p === w;
        }
        function Pk(p) {
          return p === p && !Sn(p);
        }
        function Ak(p, m) {
          return function(w) {
            return w == null ? !1 : w[p] === m && (m !== n || p in ln(w));
          };
        }
        function dG(p) {
          var m = Mh(p, function(R) {
            return w.size === u && w.clear(), R;
          }), w = m.cache;
          return m;
        }
        function fG(p, m) {
          var w = p[1], R = m[1], j = w | R, H = j < (b | x | k), te = R == k && w == S || R == k && w == I && p[7].length <= m[8] || R == (k | I) && m[7].length <= m[8] && w == S;
          if (!(H || te))
            return p;
          R & b && (p[2] = m[2], j |= w & b ? 0 : $);
          var ae = m[3];
          if (ae) {
            var me = p[3];
            p[3] = me ? hk(me, ae, m[4]) : ae, p[4] = me ? rs(p[3], d) : m[4];
          }
          return ae = m[5], ae && (me = p[5], p[5] = me ? mk(me, ae, m[6]) : ae, p[6] = me ? rs(p[5], d) : m[6]), ae = m[7], ae && (p[7] = ae), R & k && (p[8] = p[8] == null ? m[8] : yr(p[8], m[8])), p[9] == null && (p[9] = m[9]), p[0] = m[0], p[1] = j, p;
        }
        function pG(p) {
          var m = [];
          if (p != null)
            for (var w in ln(p))
              m.push(w);
          return m;
        }
        function hG(p) {
          return ah.call(p);
        }
        function Ik(p, m, w) {
          return m = Zn(m === n ? p.length - 1 : m, 0), function() {
            for (var R = arguments, j = -1, H = Zn(R.length - m, 0), te = Oe(H); ++j < H; )
              te[j] = R[m + j];
            j = -1;
            for (var ae = Oe(m + 1); ++j < m; )
              ae[j] = R[j];
            return ae[m] = w(te), io(p, this, ae);
          };
        }
        function Mk(p, m) {
          return m.length < 2 ? p : ic(p, Io(m, 0, -1));
        }
        function mG(p, m) {
          for (var w = p.length, R = yr(m.length, w), j = zr(p); R--; ) {
            var H = m[R];
            p[R] = $a(H, w) ? j[H] : n;
          }
          return p;
        }
        function xb(p, m) {
          if (!(m === "constructor" && typeof p[m] == "function") && m != "__proto__")
            return p[m];
        }
        var Nk = Lk(ok), Cd = RV || function(p, m) {
          return cr.setTimeout(p, m);
        }, wb = Lk(jY);
        function Dk(p, m, w) {
          var R = m + "";
          return wb(p, aG(R, gG(rG(R), w)));
        }
        function Lk(p) {
          var m = 0, w = 0;
          return function() {
            var R = MV(), j = M - (R - w);
            if (w = R, j > 0) {
              if (++m >= D)
                return arguments[0];
            } else
              m = 0;
            return p.apply(n, arguments);
          };
        }
        function Rh(p, m) {
          var w = -1, R = p.length, j = R - 1;
          for (m = m === n ? R : m; ++w < m; ) {
            var H = rb(w, j), te = p[H];
            p[H] = p[w], p[w] = te;
          }
          return p.length = m, p;
        }
        var jk = dG(function(p) {
          var m = [];
          return p.charCodeAt(0) === 46 && m.push(""), p.replace(gn, function(w, R, j, H) {
            m.push(j ? H.replace(ii, "$1") : R || w);
          }), m;
        });
        function Ai(p) {
          if (typeof p == "string" || co(p))
            return p;
          var m = p + "";
          return m == "0" && 1 / p == -q ? "-0" : m;
        }
        function sc(p) {
          if (p != null) {
            try {
              return ih.call(p);
            } catch {
            }
            try {
              return p + "";
            } catch {
            }
          }
          return "";
        }
        function gG(p, m) {
          return ko(re, function(w) {
            var R = "_." + w[0];
            m & w[1] && !eh(p, R) && p.push(R);
          }), p.sort();
        }
        function Fk(p) {
          if (p instanceof jt)
            return p.clone();
          var m = new Po(p.__wrapped__, p.__chain__);
          return m.__actions__ = zr(p.__actions__), m.__index__ = p.__index__, m.__values__ = p.__values__, m;
        }
        function vG(p, m, w) {
          (w ? Ar(p, m, w) : m === n) ? m = 1 : m = Zn(Tt(m), 0);
          var R = p == null ? 0 : p.length;
          if (!R || m < 1)
            return [];
          for (var j = 0, H = 0, te = Oe(fh(R / m)); j < R; )
            te[H++] = Io(p, j, j += m);
          return te;
        }
        function yG(p) {
          for (var m = -1, w = p == null ? 0 : p.length, R = 0, j = []; ++m < w; ) {
            var H = p[m];
            H && (j[R++] = H);
          }
          return j;
        }
        function bG() {
          var p = arguments.length;
          if (!p)
            return [];
          for (var m = Oe(p - 1), w = arguments[0], R = p; R--; )
            m[R - 1] = arguments[R];
          return ns(Ot(w) ? zr(w) : [w], lr(m, 1));
        }
        var xG = At(function(p, m) {
          return Fn(p) ? bd(p, lr(m, 1, Fn, !0)) : [];
        }), wG = At(function(p, m) {
          var w = Mo(m);
          return Fn(w) && (w = n), Fn(p) ? bd(p, lr(m, 1, Fn, !0), lt(w, 2)) : [];
        }), $G = At(function(p, m) {
          var w = Mo(m);
          return Fn(w) && (w = n), Fn(p) ? bd(p, lr(m, 1, Fn, !0), n, w) : [];
        });
        function OG(p, m, w) {
          var R = p == null ? 0 : p.length;
          return R ? (m = w || m === n ? 1 : Tt(m), Io(p, m < 0 ? 0 : m, R)) : [];
        }
        function SG(p, m, w) {
          var R = p == null ? 0 : p.length;
          return R ? (m = w || m === n ? 1 : Tt(m), m = R - m, Io(p, 0, m < 0 ? 0 : m)) : [];
        }
        function CG(p, m) {
          return p && p.length ? $h(p, lt(m, 3), !0, !0) : [];
        }
        function TG(p, m) {
          return p && p.length ? $h(p, lt(m, 3), !0) : [];
        }
        function EG(p, m, w, R) {
          var j = p == null ? 0 : p.length;
          return j ? (w && typeof w != "number" && Ar(p, m, w) && (w = 0, R = j), bY(p, m, w, R)) : [];
        }
        function zk(p, m, w) {
          var R = p == null ? 0 : p.length;
          if (!R)
            return -1;
          var j = w == null ? 0 : Tt(w);
          return j < 0 && (j = Zn(R + j, 0)), th(p, lt(m, 3), j);
        }
        function Bk(p, m, w) {
          var R = p == null ? 0 : p.length;
          if (!R)
            return -1;
          var j = R - 1;
          return w !== n && (j = Tt(w), j = w < 0 ? Zn(R + j, 0) : yr(j, R - 1)), th(p, lt(m, 3), j, !0);
        }
        function qk(p) {
          var m = p == null ? 0 : p.length;
          return m ? lr(p, 1) : [];
        }
        function _G(p) {
          var m = p == null ? 0 : p.length;
          return m ? lr(p, q) : [];
        }
        function kG(p, m) {
          var w = p == null ? 0 : p.length;
          return w ? (m = m === n ? 1 : Tt(m), lr(p, m)) : [];
        }
        function RG(p) {
          for (var m = -1, w = p == null ? 0 : p.length, R = {}; ++m < w; ) {
            var j = p[m];
            R[j[0]] = j[1];
          }
          return R;
        }
        function Uk(p) {
          return p && p.length ? p[0] : n;
        }
        function PG(p, m, w) {
          var R = p == null ? 0 : p.length;
          if (!R)
            return -1;
          var j = w == null ? 0 : Tt(w);
          return j < 0 && (j = Zn(R + j, 0)), bl(p, m, j);
        }
        function AG(p) {
          var m = p == null ? 0 : p.length;
          return m ? Io(p, 0, -1) : [];
        }
        var IG = At(function(p) {
          var m = vn(p, cb);
          return m.length && m[0] === p[0] ? Jy(m) : [];
        }), MG = At(function(p) {
          var m = Mo(p), w = vn(p, cb);
          return m === Mo(w) ? m = n : w.pop(), w.length && w[0] === p[0] ? Jy(w, lt(m, 2)) : [];
        }), NG = At(function(p) {
          var m = Mo(p), w = vn(p, cb);
          return m = typeof m == "function" ? m : n, m && w.pop(), w.length && w[0] === p[0] ? Jy(w, n, m) : [];
        });
        function DG(p, m) {
          return p == null ? "" : AV.call(p, m);
        }
        function Mo(p) {
          var m = p == null ? 0 : p.length;
          return m ? p[m - 1] : n;
        }
        function LG(p, m, w) {
          var R = p == null ? 0 : p.length;
          if (!R)
            return -1;
          var j = R;
          return w !== n && (j = Tt(w), j = j < 0 ? Zn(R + j, 0) : yr(j, R - 1)), m === m ? gV(p, m, j) : th(p, O_, j, !0);
        }
        function jG(p, m) {
          return p && p.length ? ek(p, Tt(m)) : n;
        }
        var FG = At(Wk);
        function Wk(p, m) {
          return p && p.length && m && m.length ? nb(p, m) : p;
        }
        function zG(p, m, w) {
          return p && p.length && m && m.length ? nb(p, m, lt(w, 2)) : p;
        }
        function BG(p, m, w) {
          return p && p.length && m && m.length ? nb(p, m, n, w) : p;
        }
        var qG = wa(function(p, m) {
          var w = p == null ? 0 : p.length, R = Gy(p, m);
          return rk(p, vn(m, function(j) {
            return $a(j, w) ? +j : j;
          }).sort(pk)), R;
        });
        function UG(p, m) {
          var w = [];
          if (!(p && p.length))
            return w;
          var R = -1, j = [], H = p.length;
          for (m = lt(m, 3); ++R < H; ) {
            var te = p[R];
            m(te, R, p) && (w.push(te), j.push(R));
          }
          return rk(p, j), w;
        }
        function $b(p) {
          return p == null ? p : DV.call(p);
        }
        function WG(p, m, w) {
          var R = p == null ? 0 : p.length;
          return R ? (w && typeof w != "number" && Ar(p, m, w) ? (m = 0, w = R) : (m = m == null ? 0 : Tt(m), w = w === n ? R : Tt(w)), Io(p, m, w)) : [];
        }
        function HG(p, m) {
          return wh(p, m);
        }
        function VG(p, m, w) {
          return ib(p, m, lt(w, 2));
        }
        function YG(p, m) {
          var w = p == null ? 0 : p.length;
          if (w) {
            var R = wh(p, m);
            if (R < w && li(p[R], m))
              return R;
          }
          return -1;
        }
        function GG(p, m) {
          return wh(p, m, !0);
        }
        function KG(p, m, w) {
          return ib(p, m, lt(w, 2), !0);
        }
        function XG(p, m) {
          var w = p == null ? 0 : p.length;
          if (w) {
            var R = wh(p, m, !0) - 1;
            if (li(p[R], m))
              return R;
          }
          return -1;
        }
        function ZG(p) {
          return p && p.length ? ik(p) : [];
        }
        function JG(p, m) {
          return p && p.length ? ik(p, lt(m, 2)) : [];
        }
        function QG(p) {
          var m = p == null ? 0 : p.length;
          return m ? Io(p, 1, m) : [];
        }
        function eK(p, m, w) {
          return p && p.length ? (m = w || m === n ? 1 : Tt(m), Io(p, 0, m < 0 ? 0 : m)) : [];
        }
        function tK(p, m, w) {
          var R = p == null ? 0 : p.length;
          return R ? (m = w || m === n ? 1 : Tt(m), m = R - m, Io(p, m < 0 ? 0 : m, R)) : [];
        }
        function nK(p, m) {
          return p && p.length ? $h(p, lt(m, 3), !1, !0) : [];
        }
        function rK(p, m) {
          return p && p.length ? $h(p, lt(m, 3)) : [];
        }
        var oK = At(function(p) {
          return as(lr(p, 1, Fn, !0));
        }), iK = At(function(p) {
          var m = Mo(p);
          return Fn(m) && (m = n), as(lr(p, 1, Fn, !0), lt(m, 2));
        }), aK = At(function(p) {
          var m = Mo(p);
          return m = typeof m == "function" ? m : n, as(lr(p, 1, Fn, !0), n, m);
        });
        function sK(p) {
          return p && p.length ? as(p) : [];
        }
        function cK(p, m) {
          return p && p.length ? as(p, lt(m, 2)) : [];
        }
        function lK(p, m) {
          return m = typeof m == "function" ? m : n, p && p.length ? as(p, n, m) : [];
        }
        function Ob(p) {
          if (!(p && p.length))
            return [];
          var m = 0;
          return p = ts(p, function(w) {
            if (Fn(w))
              return m = Zn(w.length, m), !0;
          }), zy(m, function(w) {
            return vn(p, Ly(w));
          });
        }
        function Hk(p, m) {
          if (!(p && p.length))
            return [];
          var w = Ob(p);
          return m == null ? w : vn(w, function(R) {
            return io(m, n, R);
          });
        }
        var uK = At(function(p, m) {
          return Fn(p) ? bd(p, m) : [];
        }), dK = At(function(p) {
          return sb(ts(p, Fn));
        }), fK = At(function(p) {
          var m = Mo(p);
          return Fn(m) && (m = n), sb(ts(p, Fn), lt(m, 2));
        }), pK = At(function(p) {
          var m = Mo(p);
          return m = typeof m == "function" ? m : n, sb(ts(p, Fn), n, m);
        }), hK = At(Ob);
        function mK(p, m) {
          return lk(p || [], m || [], yd);
        }
        function gK(p, m) {
          return lk(p || [], m || [], $d);
        }
        var vK = At(function(p) {
          var m = p.length, w = m > 1 ? p[m - 1] : n;
          return w = typeof w == "function" ? (p.pop(), w) : n, Hk(p, w);
        });
        function Vk(p) {
          var m = B(p);
          return m.__chain__ = !0, m;
        }
        function yK(p, m) {
          return m(p), p;
        }
        function Ph(p, m) {
          return m(p);
        }
        var bK = wa(function(p) {
          var m = p.length, w = m ? p[0] : 0, R = this.__wrapped__, j = function(H) {
            return Gy(H, p);
          };
          return m > 1 || this.__actions__.length || !(R instanceof jt) || !$a(w) ? this.thru(j) : (R = R.slice(w, +w + (m ? 1 : 0)), R.__actions__.push({
            func: Ph,
            args: [j],
            thisArg: n
          }), new Po(R, this.__chain__).thru(function(H) {
            return m && !H.length && H.push(n), H;
          }));
        });
        function xK() {
          return Vk(this);
        }
        function wK() {
          return new Po(this.value(), this.__chain__);
        }
        function $K() {
          this.__values__ === n && (this.__values__ = aR(this.value()));
          var p = this.__index__ >= this.__values__.length, m = p ? n : this.__values__[this.__index__++];
          return { done: p, value: m };
        }
        function OK() {
          return this;
        }
        function SK(p) {
          for (var m, w = this; w instanceof gh; ) {
            var R = Fk(w);
            R.__index__ = 0, R.__values__ = n, m ? j.__wrapped__ = R : m = R;
            var j = R;
            w = w.__wrapped__;
          }
          return j.__wrapped__ = p, m;
        }
        function CK() {
          var p = this.__wrapped__;
          if (p instanceof jt) {
            var m = p;
            return this.__actions__.length && (m = new jt(this)), m = m.reverse(), m.__actions__.push({
              func: Ph,
              args: [$b],
              thisArg: n
            }), new Po(m, this.__chain__);
          }
          return this.thru($b);
        }
        function TK() {
          return ck(this.__wrapped__, this.__actions__);
        }
        var EK = Oh(function(p, m, w) {
          en.call(p, w) ? ++p[w] : ba(p, w, 1);
        });
        function _K(p, m, w) {
          var R = Ot(p) ? w_ : yY;
          return w && Ar(p, m, w) && (m = n), R(p, lt(m, 3));
        }
        function kK(p, m) {
          var w = Ot(p) ? ts : H_;
          return w(p, lt(m, 3));
        }
        var RK = bk(zk), PK = bk(Bk);
        function AK(p, m) {
          return lr(Ah(p, m), 1);
        }
        function IK(p, m) {
          return lr(Ah(p, m), q);
        }
        function MK(p, m, w) {
          return w = w === n ? 1 : Tt(w), lr(Ah(p, m), w);
        }
        function Yk(p, m) {
          var w = Ot(p) ? ko : is;
          return w(p, lt(m, 3));
        }
        function Gk(p, m) {
          var w = Ot(p) ? QH : W_;
          return w(p, lt(m, 3));
        }
        var NK = Oh(function(p, m, w) {
          en.call(p, w) ? p[w].push(m) : ba(p, w, [m]);
        });
        function DK(p, m, w, R) {
          p = Br(p) ? p : Pl(p), w = w && !R ? Tt(w) : 0;
          var j = p.length;
          return w < 0 && (w = Zn(j + w, 0)), Lh(p) ? w <= j && p.indexOf(m, w) > -1 : !!j && bl(p, m, w) > -1;
        }
        var LK = At(function(p, m, w) {
          var R = -1, j = typeof m == "function", H = Br(p) ? Oe(p.length) : [];
          return is(p, function(te) {
            H[++R] = j ? io(m, te, w) : xd(te, m, w);
          }), H;
        }), jK = Oh(function(p, m, w) {
          ba(p, w, m);
        });
        function Ah(p, m) {
          var w = Ot(p) ? vn : Z_;
          return w(p, lt(m, 3));
        }
        function FK(p, m, w, R) {
          return p == null ? [] : (Ot(m) || (m = m == null ? [] : [m]), w = R ? n : w, Ot(w) || (w = w == null ? [] : [w]), tk(p, m, w));
        }
        var zK = Oh(function(p, m, w) {
          p[w ? 0 : 1].push(m);
        }, function() {
          return [[], []];
        });
        function BK(p, m, w) {
          var R = Ot(p) ? Ny : C_, j = arguments.length < 3;
          return R(p, lt(m, 4), w, j, is);
        }
        function qK(p, m, w) {
          var R = Ot(p) ? eV : C_, j = arguments.length < 3;
          return R(p, lt(m, 4), w, j, W_);
        }
        function UK(p, m) {
          var w = Ot(p) ? ts : H_;
          return w(p, Nh(lt(m, 3)));
        }
        function WK(p) {
          var m = Ot(p) ? z_ : DY;
          return m(p);
        }
        function HK(p, m, w) {
          (w ? Ar(p, m, w) : m === n) ? m = 1 : m = Tt(m);
          var R = Ot(p) ? pY : LY;
          return R(p, m);
        }
        function VK(p) {
          var m = Ot(p) ? hY : FY;
          return m(p);
        }
        function YK(p) {
          if (p == null)
            return 0;
          if (Br(p))
            return Lh(p) ? wl(p) : p.length;
          var m = br(p);
          return m == ue || m == V ? p.size : eb(p).length;
        }
        function GK(p, m, w) {
          var R = Ot(p) ? Dy : zY;
          return w && Ar(p, m, w) && (m = n), R(p, lt(m, 3));
        }
        var KK = At(function(p, m) {
          if (p == null)
            return [];
          var w = m.length;
          return w > 1 && Ar(p, m[0], m[1]) ? m = [] : w > 2 && Ar(m[0], m[1], m[2]) && (m = [m[0]]), tk(p, lr(m, 1), []);
        }), Ih = kV || function() {
          return cr.Date.now();
        };
        function XK(p, m) {
          if (typeof m != "function")
            throw new Ro(a);
          return p = Tt(p), function() {
            if (--p < 1)
              return m.apply(this, arguments);
          };
        }
        function Kk(p, m, w) {
          return m = w ? n : m, m = p && m == null ? p.length : m, xa(p, k, n, n, n, n, m);
        }
        function Xk(p, m) {
          var w;
          if (typeof m != "function")
            throw new Ro(a);
          return p = Tt(p), function() {
            return --p > 0 && (w = m.apply(this, arguments)), p <= 1 && (m = n), w;
          };
        }
        var Sb = At(function(p, m, w) {
          var R = b;
          if (w.length) {
            var j = rs(w, kl(Sb));
            R |= C;
          }
          return xa(p, R, m, w, j);
        }), Zk = At(function(p, m, w) {
          var R = b | x;
          if (w.length) {
            var j = rs(w, kl(Zk));
            R |= C;
          }
          return xa(m, R, p, w, j);
        });
        function Jk(p, m, w) {
          m = w ? n : m;
          var R = xa(p, S, n, n, n, n, n, m);
          return R.placeholder = Jk.placeholder, R;
        }
        function Qk(p, m, w) {
          m = w ? n : m;
          var R = xa(p, O, n, n, n, n, n, m);
          return R.placeholder = Qk.placeholder, R;
        }
        function eR(p, m, w) {
          var R, j, H, te, ae, me, De = 0, ze = !1, qe = !1, tt = !0;
          if (typeof p != "function")
            throw new Ro(a);
          m = No(m) || 0, Sn(w) && (ze = !!w.leading, qe = "maxWait" in w, H = qe ? Zn(No(w.maxWait) || 0, m) : H, tt = "trailing" in w ? !!w.trailing : tt);
          function it(zn) {
            var ui = R, Ca = j;
            return R = j = n, De = zn, te = p.apply(Ca, ui), te;
          }
          function ut(zn) {
            return De = zn, ae = Cd(Nt, m), ze ? it(zn) : te;
          }
          function _t(zn) {
            var ui = zn - me, Ca = zn - De, bR = m - ui;
            return qe ? yr(bR, H - Ca) : bR;
          }
          function dt(zn) {
            var ui = zn - me, Ca = zn - De;
            return me === n || ui >= m || ui < 0 || qe && Ca >= H;
          }
          function Nt() {
            var zn = Ih();
            if (dt(zn))
              return zt(zn);
            ae = Cd(Nt, _t(zn));
          }
          function zt(zn) {
            return ae = n, tt && R ? it(zn) : (R = j = n, te);
          }
          function lo() {
            ae !== n && uk(ae), De = 0, R = me = j = ae = n;
          }
          function Ir() {
            return ae === n ? te : zt(Ih());
          }
          function uo() {
            var zn = Ih(), ui = dt(zn);
            if (R = arguments, j = this, me = zn, ui) {
              if (ae === n)
                return ut(me);
              if (qe)
                return uk(ae), ae = Cd(Nt, m), it(me);
            }
            return ae === n && (ae = Cd(Nt, m)), te;
          }
          return uo.cancel = lo, uo.flush = Ir, uo;
        }
        var ZK = At(function(p, m) {
          return U_(p, 1, m);
        }), JK = At(function(p, m, w) {
          return U_(p, No(m) || 0, w);
        });
        function QK(p) {
          return xa(p, P);
        }
        function Mh(p, m) {
          if (typeof p != "function" || m != null && typeof m != "function")
            throw new Ro(a);
          var w = function() {
            var R = arguments, j = m ? m.apply(this, R) : R[0], H = w.cache;
            if (H.has(j))
              return H.get(j);
            var te = p.apply(this, R);
            return w.cache = H.set(j, te) || H, te;
          };
          return w.cache = new (Mh.Cache || ya)(), w;
        }
        Mh.Cache = ya;
        function Nh(p) {
          if (typeof p != "function")
            throw new Ro(a);
          return function() {
            var m = arguments;
            switch (m.length) {
              case 0:
                return !p.call(this);
              case 1:
                return !p.call(this, m[0]);
              case 2:
                return !p.call(this, m[0], m[1]);
              case 3:
                return !p.call(this, m[0], m[1], m[2]);
            }
            return !p.apply(this, m);
          };
        }
        function eX(p) {
          return Xk(2, p);
        }
        var tX = BY(function(p, m) {
          m = m.length == 1 && Ot(m[0]) ? vn(m[0], ao(lt())) : vn(lr(m, 1), ao(lt()));
          var w = m.length;
          return At(function(R) {
            for (var j = -1, H = yr(R.length, w); ++j < H; )
              R[j] = m[j].call(this, R[j]);
            return io(p, this, R);
          });
        }), Cb = At(function(p, m) {
          var w = rs(m, kl(Cb));
          return xa(p, C, n, m, w);
        }), tR = At(function(p, m) {
          var w = rs(m, kl(tR));
          return xa(p, T, n, m, w);
        }), nX = wa(function(p, m) {
          return xa(p, I, n, n, n, m);
        });
        function rX(p, m) {
          if (typeof p != "function")
            throw new Ro(a);
          return m = m === n ? m : Tt(m), At(p, m);
        }
        function oX(p, m) {
          if (typeof p != "function")
            throw new Ro(a);
          return m = m == null ? 0 : Zn(Tt(m), 0), At(function(w) {
            var R = w[m], j = cs(w, 0, m);
            return R && ns(j, R), io(p, this, j);
          });
        }
        function iX(p, m, w) {
          var R = !0, j = !0;
          if (typeof p != "function")
            throw new Ro(a);
          return Sn(w) && (R = "leading" in w ? !!w.leading : R, j = "trailing" in w ? !!w.trailing : j), eR(p, m, {
            leading: R,
            maxWait: m,
            trailing: j
          });
        }
        function aX(p) {
          return Kk(p, 1);
        }
        function sX(p, m) {
          return Cb(lb(m), p);
        }
        function cX() {
          if (!arguments.length)
            return [];
          var p = arguments[0];
          return Ot(p) ? p : [p];
        }
        function lX(p) {
          return Ao(p, v);
        }
        function uX(p, m) {
          return m = typeof m == "function" ? m : n, Ao(p, v, m);
        }
        function dX(p) {
          return Ao(p, f | v);
        }
        function fX(p, m) {
          return m = typeof m == "function" ? m : n, Ao(p, f | v, m);
        }
        function pX(p, m) {
          return m == null || q_(p, m, tr(m));
        }
        function li(p, m) {
          return p === m || p !== p && m !== m;
        }
        var hX = Eh(Zy), mX = Eh(function(p, m) {
          return p >= m;
        }), cc = G_(/* @__PURE__ */ function() {
          return arguments;
        }()) ? G_ : function(p) {
          return Pn(p) && en.call(p, "callee") && !M_.call(p, "callee");
        }, Ot = Oe.isArray, gX = m_ ? ao(m_) : SY;
        function Br(p) {
          return p != null && Dh(p.length) && !Oa(p);
        }
        function Fn(p) {
          return Pn(p) && Br(p);
        }
        function vX(p) {
          return p === !0 || p === !1 || Pn(p) && Pr(p) == de;
        }
        var ls = PV || Db, yX = g_ ? ao(g_) : CY;
        function bX(p) {
          return Pn(p) && p.nodeType === 1 && !Td(p);
        }
        function xX(p) {
          if (p == null)
            return !0;
          if (Br(p) && (Ot(p) || typeof p == "string" || typeof p.splice == "function" || ls(p) || Rl(p) || cc(p)))
            return !p.length;
          var m = br(p);
          if (m == ue || m == V)
            return !p.size;
          if (Sd(p))
            return !eb(p).length;
          for (var w in p)
            if (en.call(p, w))
              return !1;
          return !0;
        }
        function wX(p, m) {
          return wd(p, m);
        }
        function $X(p, m, w) {
          w = typeof w == "function" ? w : n;
          var R = w ? w(p, m) : n;
          return R === n ? wd(p, m, n, w) : !!R;
        }
        function Tb(p) {
          if (!Pn(p))
            return !1;
          var m = Pr(p);
          return m == ve || m == le || typeof p.message == "string" && typeof p.name == "string" && !Td(p);
        }
        function OX(p) {
          return typeof p == "number" && D_(p);
        }
        function Oa(p) {
          if (!Sn(p))
            return !1;
          var m = Pr(p);
          return m == G || m == Se || m == fe || m == Ie;
        }
        function nR(p) {
          return typeof p == "number" && p == Tt(p);
        }
        function Dh(p) {
          return typeof p == "number" && p > -1 && p % 1 == 0 && p <= W;
        }
        function Sn(p) {
          var m = typeof p;
          return p != null && (m == "object" || m == "function");
        }
        function Pn(p) {
          return p != null && typeof p == "object";
        }
        var rR = v_ ? ao(v_) : EY;
        function SX(p, m) {
          return p === m || Qy(p, m, gb(m));
        }
        function CX(p, m, w) {
          return w = typeof w == "function" ? w : n, Qy(p, m, gb(m), w);
        }
        function TX(p) {
          return oR(p) && p != +p;
        }
        function EX(p) {
          if (uG(p))
            throw new xt(i);
          return K_(p);
        }
        function _X(p) {
          return p === null;
        }
        function kX(p) {
          return p == null;
        }
        function oR(p) {
          return typeof p == "number" || Pn(p) && Pr(p) == Q;
        }
        function Td(p) {
          if (!Pn(p) || Pr(p) != ee)
            return !1;
          var m = lh(p);
          if (m === null)
            return !0;
          var w = en.call(m, "constructor") && m.constructor;
          return typeof w == "function" && w instanceof w && ih.call(w) == CV;
        }
        var Eb = y_ ? ao(y_) : _Y;
        function RX(p) {
          return nR(p) && p >= -W && p <= W;
        }
        var iR = b_ ? ao(b_) : kY;
        function Lh(p) {
          return typeof p == "string" || !Ot(p) && Pn(p) && Pr(p) == se;
        }
        function co(p) {
          return typeof p == "symbol" || Pn(p) && Pr(p) == we;
        }
        var Rl = x_ ? ao(x_) : RY;
        function PX(p) {
          return p === n;
        }
        function AX(p) {
          return Pn(p) && br(p) == he;
        }
        function IX(p) {
          return Pn(p) && Pr(p) == Te;
        }
        var MX = Eh(tb), NX = Eh(function(p, m) {
          return p <= m;
        });
        function aR(p) {
          if (!p)
            return [];
          if (Br(p))
            return Lh(p) ? si(p) : zr(p);
          if (pd && p[pd])
            return pV(p[pd]());
          var m = br(p), w = m == ue ? qy : m == V ? nh : Pl;
          return w(p);
        }
        function Sa(p) {
          if (!p)
            return p === 0 ? p : 0;
          if (p = No(p), p === q || p === -q) {
            var m = p < 0 ? -1 : 1;
            return m * U;
          }
          return p === p ? p : 0;
        }
        function Tt(p) {
          var m = Sa(p), w = m % 1;
          return m === m ? w ? m - w : m : 0;
        }
        function sR(p) {
          return p ? oc(Tt(p), 0, Y) : 0;
        }
        function No(p) {
          if (typeof p == "number")
            return p;
          if (co(p))
            return K;
          if (Sn(p)) {
            var m = typeof p.valueOf == "function" ? p.valueOf() : p;
            p = Sn(m) ? m + "" : m;
          }
          if (typeof p != "string")
            return p === 0 ? p : +p;
          p = T_(p);
          var w = yt.test(p);
          return w || Xt.test(p) ? XH(p.slice(2), w ? 2 : 8) : et.test(p) ? K : +p;
        }
        function cR(p) {
          return Pi(p, qr(p));
        }
        function DX(p) {
          return p ? oc(Tt(p), -W, W) : p === 0 ? p : 0;
        }
        function Zt(p) {
          return p == null ? "" : so(p);
        }
        var LX = El(function(p, m) {
          if (Sd(m) || Br(m)) {
            Pi(m, tr(m), p);
            return;
          }
          for (var w in m)
            en.call(m, w) && yd(p, w, m[w]);
        }), lR = El(function(p, m) {
          Pi(m, qr(m), p);
        }), jh = El(function(p, m, w, R) {
          Pi(m, qr(m), p, R);
        }), jX = El(function(p, m, w, R) {
          Pi(m, tr(m), p, R);
        }), FX = wa(Gy);
        function zX(p, m) {
          var w = Tl(p);
          return m == null ? w : B_(w, m);
        }
        var BX = At(function(p, m) {
          p = ln(p);
          var w = -1, R = m.length, j = R > 2 ? m[2] : n;
          for (j && Ar(m[0], m[1], j) && (R = 1); ++w < R; )
            for (var H = m[w], te = qr(H), ae = -1, me = te.length; ++ae < me; ) {
              var De = te[ae], ze = p[De];
              (ze === n || li(ze, Ol[De]) && !en.call(p, De)) && (p[De] = H[De]);
            }
          return p;
        }), qX = At(function(p) {
          return p.push(n, Tk), io(uR, n, p);
        });
        function UX(p, m) {
          return $_(p, lt(m, 3), Ri);
        }
        function WX(p, m) {
          return $_(p, lt(m, 3), Xy);
        }
        function HX(p, m) {
          return p == null ? p : Ky(p, lt(m, 3), qr);
        }
        function VX(p, m) {
          return p == null ? p : V_(p, lt(m, 3), qr);
        }
        function YX(p, m) {
          return p && Ri(p, lt(m, 3));
        }
        function GX(p, m) {
          return p && Xy(p, lt(m, 3));
        }
        function KX(p) {
          return p == null ? [] : bh(p, tr(p));
        }
        function XX(p) {
          return p == null ? [] : bh(p, qr(p));
        }
        function _b(p, m, w) {
          var R = p == null ? n : ic(p, m);
          return R === n ? w : R;
        }
        function ZX(p, m) {
          return p != null && kk(p, m, xY);
        }
        function kb(p, m) {
          return p != null && kk(p, m, wY);
        }
        var JX = wk(function(p, m, w) {
          m != null && typeof m.toString != "function" && (m = ah.call(m)), p[m] = w;
        }, Pb(Ur)), QX = wk(function(p, m, w) {
          m != null && typeof m.toString != "function" && (m = ah.call(m)), en.call(p, m) ? p[m].push(w) : p[m] = [w];
        }, lt), eZ = At(xd);
        function tr(p) {
          return Br(p) ? F_(p) : eb(p);
        }
        function qr(p) {
          return Br(p) ? F_(p, !0) : PY(p);
        }
        function tZ(p, m) {
          var w = {};
          return m = lt(m, 3), Ri(p, function(R, j, H) {
            ba(w, m(R, j, H), R);
          }), w;
        }
        function nZ(p, m) {
          var w = {};
          return m = lt(m, 3), Ri(p, function(R, j, H) {
            ba(w, j, m(R, j, H));
          }), w;
        }
        var rZ = El(function(p, m, w) {
          xh(p, m, w);
        }), uR = El(function(p, m, w, R) {
          xh(p, m, w, R);
        }), oZ = wa(function(p, m) {
          var w = {};
          if (p == null)
            return w;
          var R = !1;
          m = vn(m, function(H) {
            return H = ss(H, p), R || (R = H.length > 1), H;
          }), Pi(p, hb(p), w), R && (w = Ao(w, f | h | v, JY));
          for (var j = m.length; j--; )
            ab(w, m[j]);
          return w;
        });
        function iZ(p, m) {
          return dR(p, Nh(lt(m)));
        }
        var aZ = wa(function(p, m) {
          return p == null ? {} : IY(p, m);
        });
        function dR(p, m) {
          if (p == null)
            return {};
          var w = vn(hb(p), function(R) {
            return [R];
          });
          return m = lt(m), nk(p, w, function(R, j) {
            return m(R, j[0]);
          });
        }
        function sZ(p, m, w) {
          m = ss(m, p);
          var R = -1, j = m.length;
          for (j || (j = 1, p = n); ++R < j; ) {
            var H = p == null ? n : p[Ai(m[R])];
            H === n && (R = j, H = w), p = Oa(H) ? H.call(p) : H;
          }
          return p;
        }
        function cZ(p, m, w) {
          return p == null ? p : $d(p, m, w);
        }
        function lZ(p, m, w, R) {
          return R = typeof R == "function" ? R : n, p == null ? p : $d(p, m, w, R);
        }
        var fR = Sk(tr), pR = Sk(qr);
        function uZ(p, m, w) {
          var R = Ot(p), j = R || ls(p) || Rl(p);
          if (m = lt(m, 4), w == null) {
            var H = p && p.constructor;
            j ? w = R ? new H() : [] : Sn(p) ? w = Oa(H) ? Tl(lh(p)) : {} : w = {};
          }
          return (j ? ko : Ri)(p, function(te, ae, me) {
            return m(w, te, ae, me);
          }), w;
        }
        function dZ(p, m) {
          return p == null ? !0 : ab(p, m);
        }
        function fZ(p, m, w) {
          return p == null ? p : sk(p, m, lb(w));
        }
        function pZ(p, m, w, R) {
          return R = typeof R == "function" ? R : n, p == null ? p : sk(p, m, lb(w), R);
        }
        function Pl(p) {
          return p == null ? [] : By(p, tr(p));
        }
        function hZ(p) {
          return p == null ? [] : By(p, qr(p));
        }
        function mZ(p, m, w) {
          return w === n && (w = m, m = n), w !== n && (w = No(w), w = w === w ? w : 0), m !== n && (m = No(m), m = m === m ? m : 0), oc(No(p), m, w);
        }
        function gZ(p, m, w) {
          return m = Sa(m), w === n ? (w = m, m = 0) : w = Sa(w), p = No(p), $Y(p, m, w);
        }
        function vZ(p, m, w) {
          if (w && typeof w != "boolean" && Ar(p, m, w) && (m = w = n), w === n && (typeof m == "boolean" ? (w = m, m = n) : typeof p == "boolean" && (w = p, p = n)), p === n && m === n ? (p = 0, m = 1) : (p = Sa(p), m === n ? (m = p, p = 0) : m = Sa(m)), p > m) {
            var R = p;
            p = m, m = R;
          }
          if (w || p % 1 || m % 1) {
            var j = L_();
            return yr(p + j * (m - p + KH("1e-" + ((j + "").length - 1))), m);
          }
          return rb(p, m);
        }
        var yZ = _l(function(p, m, w) {
          return m = m.toLowerCase(), p + (w ? hR(m) : m);
        });
        function hR(p) {
          return Rb(Zt(p).toLowerCase());
        }
        function mR(p) {
          return p = Zt(p), p && p.replace(vr, cV).replace(FH, "");
        }
        function bZ(p, m, w) {
          p = Zt(p), m = so(m);
          var R = p.length;
          w = w === n ? R : oc(Tt(w), 0, R);
          var j = w;
          return w -= m.length, w >= 0 && p.slice(w, j) == m;
        }
        function xZ(p) {
          return p = Zt(p), p && Qe.test(p) ? p.replace(Je, lV) : p;
        }
        function wZ(p) {
          return p = Zt(p), p && To.test(p) ? p.replace(Kn, "\\$&") : p;
        }
        var $Z = _l(function(p, m, w) {
          return p + (w ? "-" : "") + m.toLowerCase();
        }), OZ = _l(function(p, m, w) {
          return p + (w ? " " : "") + m.toLowerCase();
        }), SZ = yk("toLowerCase");
        function CZ(p, m, w) {
          p = Zt(p), m = Tt(m);
          var R = m ? wl(p) : 0;
          if (!m || R >= m)
            return p;
          var j = (m - R) / 2;
          return Th(ph(j), w) + p + Th(fh(j), w);
        }
        function TZ(p, m, w) {
          p = Zt(p), m = Tt(m);
          var R = m ? wl(p) : 0;
          return m && R < m ? p + Th(m - R, w) : p;
        }
        function EZ(p, m, w) {
          p = Zt(p), m = Tt(m);
          var R = m ? wl(p) : 0;
          return m && R < m ? Th(m - R, w) + p : p;
        }
        function _Z(p, m, w) {
          return w || m == null ? m = 0 : m && (m = +m), NV(Zt(p).replace(_i, ""), m || 0);
        }
        function kZ(p, m, w) {
          return (w ? Ar(p, m, w) : m === n) ? m = 1 : m = Tt(m), ob(Zt(p), m);
        }
        function RZ() {
          var p = arguments, m = Zt(p[0]);
          return p.length < 3 ? m : m.replace(p[1], p[2]);
        }
        var PZ = _l(function(p, m, w) {
          return p + (w ? "_" : "") + m.toLowerCase();
        });
        function AZ(p, m, w) {
          return w && typeof w != "number" && Ar(p, m, w) && (m = w = n), w = w === n ? Y : w >>> 0, w ? (p = Zt(p), p && (typeof m == "string" || m != null && !Eb(m)) && (m = so(m), !m && xl(p)) ? cs(si(p), 0, w) : p.split(m, w)) : [];
        }
        var IZ = _l(function(p, m, w) {
          return p + (w ? " " : "") + Rb(m);
        });
        function MZ(p, m, w) {
          return p = Zt(p), w = w == null ? 0 : oc(Tt(w), 0, p.length), m = so(m), p.slice(w, w + m.length) == m;
        }
        function NZ(p, m, w) {
          var R = B.templateSettings;
          w && Ar(p, m, w) && (m = n), p = Zt(p), m = jh({}, m, R, Ck);
          var j = jh({}, m.imports, R.imports, Ck), H = tr(j), te = By(j, H), ae, me, De = 0, ze = m.interpolate || ai, qe = "__p += '", tt = Uy(
            (m.escape || ai).source + "|" + ze.source + "|" + (ze === Pt ? Fe : ai).source + "|" + (m.evaluate || ai).source + "|$",
            "g"
          ), it = "//# sourceURL=" + (en.call(m, "sourceURL") ? (m.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++WH + "]") + `
`;
          p.replace(tt, function(dt, Nt, zt, lo, Ir, uo) {
            return zt || (zt = lo), qe += p.slice(De, uo).replace(Z3, uV), Nt && (ae = !0, qe += `' +
__e(` + Nt + `) +
'`), Ir && (me = !0, qe += `';
` + Ir + `;
__p += '`), zt && (qe += `' +
((__t = (` + zt + `)) == null ? '' : __t) +
'`), De = uo + dt.length, dt;
          }), qe += `';
`;
          var ut = en.call(m, "variable") && m.variable;
          if (!ut)
            qe = `with (obj) {
` + qe + `
}
`;
          else if (Rn.test(ut))
            throw new xt(c);
          qe = (me ? qe.replace(Ke, "") : qe).replace(Me, "$1").replace(We, "$1;"), qe = "function(" + (ut || "obj") + `) {
` + (ut ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (ae ? ", __e = _.escape" : "") + (me ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + qe + `return __p
}`;
          var _t = vR(function() {
            return Ht(H, it + "return " + qe).apply(n, te);
          });
          if (_t.source = qe, Tb(_t))
            throw _t;
          return _t;
        }
        function DZ(p) {
          return Zt(p).toLowerCase();
        }
        function LZ(p) {
          return Zt(p).toUpperCase();
        }
        function jZ(p, m, w) {
          if (p = Zt(p), p && (w || m === n))
            return T_(p);
          if (!p || !(m = so(m)))
            return p;
          var R = si(p), j = si(m), H = E_(R, j), te = __(R, j) + 1;
          return cs(R, H, te).join("");
        }
        function FZ(p, m, w) {
          if (p = Zt(p), p && (w || m === n))
            return p.slice(0, R_(p) + 1);
          if (!p || !(m = so(m)))
            return p;
          var R = si(p), j = __(R, si(m)) + 1;
          return cs(R, 0, j).join("");
        }
        function zZ(p, m, w) {
          if (p = Zt(p), p && (w || m === n))
            return p.replace(_i, "");
          if (!p || !(m = so(m)))
            return p;
          var R = si(p), j = E_(R, si(m));
          return cs(R, j).join("");
        }
        function BZ(p, m) {
          var w = _, R = A;
          if (Sn(m)) {
            var j = "separator" in m ? m.separator : j;
            w = "length" in m ? Tt(m.length) : w, R = "omission" in m ? so(m.omission) : R;
          }
          p = Zt(p);
          var H = p.length;
          if (xl(p)) {
            var te = si(p);
            H = te.length;
          }
          if (w >= H)
            return p;
          var ae = w - wl(R);
          if (ae < 1)
            return R;
          var me = te ? cs(te, 0, ae).join("") : p.slice(0, ae);
          if (j === n)
            return me + R;
          if (te && (ae += me.length - ae), Eb(j)) {
            if (p.slice(ae).search(j)) {
              var De, ze = me;
              for (j.global || (j = Uy(j.source, Zt(Ee.exec(j)) + "g")), j.lastIndex = 0; De = j.exec(ze); )
                var qe = De.index;
              me = me.slice(0, qe === n ? ae : qe);
            }
          } else if (p.indexOf(so(j), ae) != ae) {
            var tt = me.lastIndexOf(j);
            tt > -1 && (me = me.slice(0, tt));
          }
          return me + R;
        }
        function qZ(p) {
          return p = Zt(p), p && ke.test(p) ? p.replace(at, vV) : p;
        }
        var UZ = _l(function(p, m, w) {
          return p + (w ? " " : "") + m.toUpperCase();
        }), Rb = yk("toUpperCase");
        function gR(p, m, w) {
          return p = Zt(p), m = w ? n : m, m === n ? fV(p) ? xV(p) : rV(p) : p.match(m) || [];
        }
        var vR = At(function(p, m) {
          try {
            return io(p, n, m);
          } catch (w) {
            return Tb(w) ? w : new xt(w);
          }
        }), WZ = wa(function(p, m) {
          return ko(m, function(w) {
            w = Ai(w), ba(p, w, Sb(p[w], p));
          }), p;
        });
        function HZ(p) {
          var m = p == null ? 0 : p.length, w = lt();
          return p = m ? vn(p, function(R) {
            if (typeof R[1] != "function")
              throw new Ro(a);
            return [w(R[0]), R[1]];
          }) : [], At(function(R) {
            for (var j = -1; ++j < m; ) {
              var H = p[j];
              if (io(H[0], this, R))
                return io(H[1], this, R);
            }
          });
        }
        function VZ(p) {
          return vY(Ao(p, f));
        }
        function Pb(p) {
          return function() {
            return p;
          };
        }
        function YZ(p, m) {
          return p == null || p !== p ? m : p;
        }
        var GZ = xk(), KZ = xk(!0);
        function Ur(p) {
          return p;
        }
        function Ab(p) {
          return X_(typeof p == "function" ? p : Ao(p, f));
        }
        function XZ(p) {
          return J_(Ao(p, f));
        }
        function ZZ(p, m) {
          return Q_(p, Ao(m, f));
        }
        var JZ = At(function(p, m) {
          return function(w) {
            return xd(w, p, m);
          };
        }), QZ = At(function(p, m) {
          return function(w) {
            return xd(p, w, m);
          };
        });
        function Ib(p, m, w) {
          var R = tr(m), j = bh(m, R);
          w == null && !(Sn(m) && (j.length || !R.length)) && (w = m, m = p, p = this, j = bh(m, tr(m)));
          var H = !(Sn(w) && "chain" in w) || !!w.chain, te = Oa(p);
          return ko(j, function(ae) {
            var me = m[ae];
            p[ae] = me, te && (p.prototype[ae] = function() {
              var De = this.__chain__;
              if (H || De) {
                var ze = p(this.__wrapped__), qe = ze.__actions__ = zr(this.__actions__);
                return qe.push({ func: me, args: arguments, thisArg: p }), ze.__chain__ = De, ze;
              }
              return me.apply(p, ns([this.value()], arguments));
            });
          }), p;
        }
        function eJ() {
          return cr._ === this && (cr._ = TV), this;
        }
        function Mb() {
        }
        function tJ(p) {
          return p = Tt(p), At(function(m) {
            return ek(m, p);
          });
        }
        var nJ = db(vn), rJ = db(w_), oJ = db(Dy);
        function yR(p) {
          return yb(p) ? Ly(Ai(p)) : MY(p);
        }
        function iJ(p) {
          return function(m) {
            return p == null ? n : ic(p, m);
          };
        }
        var aJ = $k(), sJ = $k(!0);
        function Nb() {
          return [];
        }
        function Db() {
          return !1;
        }
        function cJ() {
          return {};
        }
        function lJ() {
          return "";
        }
        function uJ() {
          return !0;
        }
        function dJ(p, m) {
          if (p = Tt(p), p < 1 || p > W)
            return [];
          var w = Y, R = yr(p, Y);
          m = lt(m), p -= Y;
          for (var j = zy(R, m); ++w < p; )
            m(w);
          return j;
        }
        function fJ(p) {
          return Ot(p) ? vn(p, Ai) : co(p) ? [p] : zr(jk(Zt(p)));
        }
        function pJ(p) {
          var m = ++SV;
          return Zt(p) + m;
        }
        var hJ = Ch(function(p, m) {
          return p + m;
        }, 0), mJ = fb("ceil"), gJ = Ch(function(p, m) {
          return p / m;
        }, 1), vJ = fb("floor");
        function yJ(p) {
          return p && p.length ? yh(p, Ur, Zy) : n;
        }
        function bJ(p, m) {
          return p && p.length ? yh(p, lt(m, 2), Zy) : n;
        }
        function xJ(p) {
          return S_(p, Ur);
        }
        function wJ(p, m) {
          return S_(p, lt(m, 2));
        }
        function $J(p) {
          return p && p.length ? yh(p, Ur, tb) : n;
        }
        function OJ(p, m) {
          return p && p.length ? yh(p, lt(m, 2), tb) : n;
        }
        var SJ = Ch(function(p, m) {
          return p * m;
        }, 1), CJ = fb("round"), TJ = Ch(function(p, m) {
          return p - m;
        }, 0);
        function EJ(p) {
          return p && p.length ? Fy(p, Ur) : 0;
        }
        function _J(p, m) {
          return p && p.length ? Fy(p, lt(m, 2)) : 0;
        }
        return B.after = XK, B.ary = Kk, B.assign = LX, B.assignIn = lR, B.assignInWith = jh, B.assignWith = jX, B.at = FX, B.before = Xk, B.bind = Sb, B.bindAll = WZ, B.bindKey = Zk, B.castArray = cX, B.chain = Vk, B.chunk = vG, B.compact = yG, B.concat = bG, B.cond = HZ, B.conforms = VZ, B.constant = Pb, B.countBy = EK, B.create = zX, B.curry = Jk, B.curryRight = Qk, B.debounce = eR, B.defaults = BX, B.defaultsDeep = qX, B.defer = ZK, B.delay = JK, B.difference = xG, B.differenceBy = wG, B.differenceWith = $G, B.drop = OG, B.dropRight = SG, B.dropRightWhile = CG, B.dropWhile = TG, B.fill = EG, B.filter = kK, B.flatMap = AK, B.flatMapDeep = IK, B.flatMapDepth = MK, B.flatten = qk, B.flattenDeep = _G, B.flattenDepth = kG, B.flip = QK, B.flow = GZ, B.flowRight = KZ, B.fromPairs = RG, B.functions = KX, B.functionsIn = XX, B.groupBy = NK, B.initial = AG, B.intersection = IG, B.intersectionBy = MG, B.intersectionWith = NG, B.invert = JX, B.invertBy = QX, B.invokeMap = LK, B.iteratee = Ab, B.keyBy = jK, B.keys = tr, B.keysIn = qr, B.map = Ah, B.mapKeys = tZ, B.mapValues = nZ, B.matches = XZ, B.matchesProperty = ZZ, B.memoize = Mh, B.merge = rZ, B.mergeWith = uR, B.method = JZ, B.methodOf = QZ, B.mixin = Ib, B.negate = Nh, B.nthArg = tJ, B.omit = oZ, B.omitBy = iZ, B.once = eX, B.orderBy = FK, B.over = nJ, B.overArgs = tX, B.overEvery = rJ, B.overSome = oJ, B.partial = Cb, B.partialRight = tR, B.partition = zK, B.pick = aZ, B.pickBy = dR, B.property = yR, B.propertyOf = iJ, B.pull = FG, B.pullAll = Wk, B.pullAllBy = zG, B.pullAllWith = BG, B.pullAt = qG, B.range = aJ, B.rangeRight = sJ, B.rearg = nX, B.reject = UK, B.remove = UG, B.rest = rX, B.reverse = $b, B.sampleSize = HK, B.set = cZ, B.setWith = lZ, B.shuffle = VK, B.slice = WG, B.sortBy = KK, B.sortedUniq = ZG, B.sortedUniqBy = JG, B.split = AZ, B.spread = oX, B.tail = QG, B.take = eK, B.takeRight = tK, B.takeRightWhile = nK, B.takeWhile = rK, B.tap = yK, B.throttle = iX, B.thru = Ph, B.toArray = aR, B.toPairs = fR, B.toPairsIn = pR, B.toPath = fJ, B.toPlainObject = cR, B.transform = uZ, B.unary = aX, B.union = oK, B.unionBy = iK, B.unionWith = aK, B.uniq = sK, B.uniqBy = cK, B.uniqWith = lK, B.unset = dZ, B.unzip = Ob, B.unzipWith = Hk, B.update = fZ, B.updateWith = pZ, B.values = Pl, B.valuesIn = hZ, B.without = uK, B.words = gR, B.wrap = sX, B.xor = dK, B.xorBy = fK, B.xorWith = pK, B.zip = hK, B.zipObject = mK, B.zipObjectDeep = gK, B.zipWith = vK, B.entries = fR, B.entriesIn = pR, B.extend = lR, B.extendWith = jh, Ib(B, B), B.add = hJ, B.attempt = vR, B.camelCase = yZ, B.capitalize = hR, B.ceil = mJ, B.clamp = mZ, B.clone = lX, B.cloneDeep = dX, B.cloneDeepWith = fX, B.cloneWith = uX, B.conformsTo = pX, B.deburr = mR, B.defaultTo = YZ, B.divide = gJ, B.endsWith = bZ, B.eq = li, B.escape = xZ, B.escapeRegExp = wZ, B.every = _K, B.find = RK, B.findIndex = zk, B.findKey = UX, B.findLast = PK, B.findLastIndex = Bk, B.findLastKey = WX, B.floor = vJ, B.forEach = Yk, B.forEachRight = Gk, B.forIn = HX, B.forInRight = VX, B.forOwn = YX, B.forOwnRight = GX, B.get = _b, B.gt = hX, B.gte = mX, B.has = ZX, B.hasIn = kb, B.head = Uk, B.identity = Ur, B.includes = DK, B.indexOf = PG, B.inRange = gZ, B.invoke = eZ, B.isArguments = cc, B.isArray = Ot, B.isArrayBuffer = gX, B.isArrayLike = Br, B.isArrayLikeObject = Fn, B.isBoolean = vX, B.isBuffer = ls, B.isDate = yX, B.isElement = bX, B.isEmpty = xX, B.isEqual = wX, B.isEqualWith = $X, B.isError = Tb, B.isFinite = OX, B.isFunction = Oa, B.isInteger = nR, B.isLength = Dh, B.isMap = rR, B.isMatch = SX, B.isMatchWith = CX, B.isNaN = TX, B.isNative = EX, B.isNil = kX, B.isNull = _X, B.isNumber = oR, B.isObject = Sn, B.isObjectLike = Pn, B.isPlainObject = Td, B.isRegExp = Eb, B.isSafeInteger = RX, B.isSet = iR, B.isString = Lh, B.isSymbol = co, B.isTypedArray = Rl, B.isUndefined = PX, B.isWeakMap = AX, B.isWeakSet = IX, B.join = DG, B.kebabCase = $Z, B.last = Mo, B.lastIndexOf = LG, B.lowerCase = OZ, B.lowerFirst = SZ, B.lt = MX, B.lte = NX, B.max = yJ, B.maxBy = bJ, B.mean = xJ, B.meanBy = wJ, B.min = $J, B.minBy = OJ, B.stubArray = Nb, B.stubFalse = Db, B.stubObject = cJ, B.stubString = lJ, B.stubTrue = uJ, B.multiply = SJ, B.nth = jG, B.noConflict = eJ, B.noop = Mb, B.now = Ih, B.pad = CZ, B.padEnd = TZ, B.padStart = EZ, B.parseInt = _Z, B.random = vZ, B.reduce = BK, B.reduceRight = qK, B.repeat = kZ, B.replace = RZ, B.result = sZ, B.round = CJ, B.runInContext = pe, B.sample = WK, B.size = YK, B.snakeCase = PZ, B.some = GK, B.sortedIndex = HG, B.sortedIndexBy = VG, B.sortedIndexOf = YG, B.sortedLastIndex = GG, B.sortedLastIndexBy = KG, B.sortedLastIndexOf = XG, B.startCase = IZ, B.startsWith = MZ, B.subtract = TJ, B.sum = EJ, B.sumBy = _J, B.template = NZ, B.times = dJ, B.toFinite = Sa, B.toInteger = Tt, B.toLength = sR, B.toLower = DZ, B.toNumber = No, B.toSafeInteger = DX, B.toString = Zt, B.toUpper = LZ, B.trim = jZ, B.trimEnd = FZ, B.trimStart = zZ, B.truncate = BZ, B.unescape = qZ, B.uniqueId = pJ, B.upperCase = UZ, B.upperFirst = Rb, B.each = Yk, B.eachRight = Gk, B.first = Uk, Ib(B, function() {
          var p = {};
          return Ri(B, function(m, w) {
            en.call(B.prototype, w) || (p[w] = m);
          }), p;
        }(), { chain: !1 }), B.VERSION = r, ko(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(p) {
          B[p].placeholder = B;
        }), ko(["drop", "take"], function(p, m) {
          jt.prototype[p] = function(w) {
            w = w === n ? 1 : Zn(Tt(w), 0);
            var R = this.__filtered__ && !m ? new jt(this) : this.clone();
            return R.__filtered__ ? R.__takeCount__ = yr(w, R.__takeCount__) : R.__views__.push({
              size: yr(w, Y),
              type: p + (R.__dir__ < 0 ? "Right" : "")
            }), R;
          }, jt.prototype[p + "Right"] = function(w) {
            return this.reverse()[p](w).reverse();
          };
        }), ko(["filter", "map", "takeWhile"], function(p, m) {
          var w = m + 1, R = w == N || w == z;
          jt.prototype[p] = function(j) {
            var H = this.clone();
            return H.__iteratees__.push({
              iteratee: lt(j, 3),
              type: w
            }), H.__filtered__ = H.__filtered__ || R, H;
          };
        }), ko(["head", "last"], function(p, m) {
          var w = "take" + (m ? "Right" : "");
          jt.prototype[p] = function() {
            return this[w](1).value()[0];
          };
        }), ko(["initial", "tail"], function(p, m) {
          var w = "drop" + (m ? "" : "Right");
          jt.prototype[p] = function() {
            return this.__filtered__ ? new jt(this) : this[w](1);
          };
        }), jt.prototype.compact = function() {
          return this.filter(Ur);
        }, jt.prototype.find = function(p) {
          return this.filter(p).head();
        }, jt.prototype.findLast = function(p) {
          return this.reverse().find(p);
        }, jt.prototype.invokeMap = At(function(p, m) {
          return typeof p == "function" ? new jt(this) : this.map(function(w) {
            return xd(w, p, m);
          });
        }), jt.prototype.reject = function(p) {
          return this.filter(Nh(lt(p)));
        }, jt.prototype.slice = function(p, m) {
          p = Tt(p);
          var w = this;
          return w.__filtered__ && (p > 0 || m < 0) ? new jt(w) : (p < 0 ? w = w.takeRight(-p) : p && (w = w.drop(p)), m !== n && (m = Tt(m), w = m < 0 ? w.dropRight(-m) : w.take(m - p)), w);
        }, jt.prototype.takeRightWhile = function(p) {
          return this.reverse().takeWhile(p).reverse();
        }, jt.prototype.toArray = function() {
          return this.take(Y);
        }, Ri(jt.prototype, function(p, m) {
          var w = /^(?:filter|find|map|reject)|While$/.test(m), R = /^(?:head|last)$/.test(m), j = B[R ? "take" + (m == "last" ? "Right" : "") : m], H = R || /^find/.test(m);
          j && (B.prototype[m] = function() {
            var te = this.__wrapped__, ae = R ? [1] : arguments, me = te instanceof jt, De = ae[0], ze = me || Ot(te), qe = function(Nt) {
              var zt = j.apply(B, ns([Nt], ae));
              return R && tt ? zt[0] : zt;
            };
            ze && w && typeof De == "function" && De.length != 1 && (me = ze = !1);
            var tt = this.__chain__, it = !!this.__actions__.length, ut = H && !tt, _t = me && !it;
            if (!H && ze) {
              te = _t ? te : new jt(this);
              var dt = p.apply(te, ae);
              return dt.__actions__.push({ func: Ph, args: [qe], thisArg: n }), new Po(dt, tt);
            }
            return ut && _t ? p.apply(this, ae) : (dt = this.thru(qe), ut ? R ? dt.value()[0] : dt.value() : dt);
          });
        }), ko(["pop", "push", "shift", "sort", "splice", "unshift"], function(p) {
          var m = rh[p], w = /^(?:push|sort|unshift)$/.test(p) ? "tap" : "thru", R = /^(?:pop|shift)$/.test(p);
          B.prototype[p] = function() {
            var j = arguments;
            if (R && !this.__chain__) {
              var H = this.value();
              return m.apply(Ot(H) ? H : [], j);
            }
            return this[w](function(te) {
              return m.apply(Ot(te) ? te : [], j);
            });
          };
        }), Ri(jt.prototype, function(p, m) {
          var w = B[m];
          if (w) {
            var R = w.name + "";
            en.call(Cl, R) || (Cl[R] = []), Cl[R].push({ name: m, func: w });
          }
        }), Cl[Sh(n, x).name] = [{
          name: "wrapper",
          func: n
        }], jt.prototype.clone = qV, jt.prototype.reverse = UV, jt.prototype.value = WV, B.prototype.at = bK, B.prototype.chain = xK, B.prototype.commit = wK, B.prototype.next = $K, B.prototype.plant = SK, B.prototype.reverse = CK, B.prototype.toJSON = B.prototype.valueOf = B.prototype.value = TK, B.prototype.first = B.prototype.head, pd && (B.prototype[pd] = OK), B;
      }, $l = wV();
      ec ? ((ec.exports = $l)._ = $l, Ay._ = $l) : cr._ = $l;
    }).call(OTe);
  }(uf, uf.exports)), uf.exports;
}
var C9e = STe(), N$, ED;
function CTe() {
  if (ED) return N$;
  ED = 1;
  var e = fF(), t = XT(), n = t(function(r, o, i) {
    return o = o.toLowerCase(), r + (i ? e(o) : o);
  });
  return N$ = n, N$;
}
var TTe = CTe();
const T9e = /* @__PURE__ */ jn(TTe);
var D$, _D;
function ETe() {
  if (_D) return D$;
  _D = 1;
  var e = 9007199254740991, t = Math.floor;
  function n(r, o) {
    var i = "";
    if (!r || o < 1 || o > e)
      return i;
    do
      o % 2 && (i += r), o = t(o / 2), o && (r += r);
    while (o);
    return i;
  }
  return D$ = n, D$;
}
var L$, kD;
function _Te() {
  if (kD) return L$;
  kD = 1;
  var e = Yq(), t = e("length");
  return L$ = t, L$;
}
var j$, RD;
function kTe() {
  if (RD) return j$;
  RD = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", n = "\\ufe20-\\ufe2f", r = "\\u20d0-\\u20ff", o = t + n + r, i = "\\ufe0e\\ufe0f", a = "[" + e + "]", c = "[" + o + "]", l = "\\ud83c[\\udffb-\\udfff]", u = "(?:" + c + "|" + l + ")", d = "[^" + e + "]", f = "(?:\\ud83c[\\udde6-\\uddff]){2}", h = "[\\ud800-\\udbff][\\udc00-\\udfff]", v = "\\u200d", y = u + "?", g = "[" + i + "]?", b = "(?:" + v + "(?:" + [d, f, h].join("|") + ")" + g + y + ")*", x = g + y + b, $ = "(?:" + [d + c + "?", c, f, h, a].join("|") + ")", S = RegExp(l + "(?=" + l + ")|" + $ + x, "g");
  function O(C) {
    for (var T = S.lastIndex = 0; S.test(C); )
      ++T;
    return T;
  }
  return j$ = O, j$;
}
var F$, PD;
function Xq() {
  if (PD) return F$;
  PD = 1;
  var e = _Te(), t = $v(), n = kTe();
  function r(o) {
    return t(o) ? n(o) : e(o);
  }
  return F$ = r, F$;
}
var z$, AD;
function RTe() {
  if (AD) return z$;
  AD = 1;
  var e = ETe(), t = sF(), n = lF(), r = $v(), o = Xq(), i = uF(), a = Math.ceil;
  function c(l, u) {
    u = u === void 0 ? " " : t(u);
    var d = u.length;
    if (d < 2)
      return d ? e(u, l) : u;
    var f = e(u, a(l / o(u)));
    return r(u) ? n(i(f), 0, l).join("") : f.slice(0, l);
  }
  return z$ = c, z$;
}
var B$, ID;
function PTe() {
  if (ID) return B$;
  ID = 1;
  var e = /\s/;
  function t(n) {
    for (var r = n.length; r-- && e.test(n.charAt(r)); )
      ;
    return r;
  }
  return B$ = t, B$;
}
var q$, MD;
function ATe() {
  if (MD) return q$;
  MD = 1;
  var e = PTe(), t = /^\s+/;
  function n(r) {
    return r && r.slice(0, e(r) + 1).replace(t, "");
  }
  return q$ = n, q$;
}
var U$, ND;
function Zq() {
  if (ND) return U$;
  ND = 1;
  var e = ATe(), t = Za(), n = wv(), r = NaN, o = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, a = /^0o[0-7]+$/i, c = parseInt;
  function l(u) {
    if (typeof u == "number")
      return u;
    if (n(u))
      return r;
    if (t(u)) {
      var d = typeof u.valueOf == "function" ? u.valueOf() : u;
      u = t(d) ? d + "" : d;
    }
    if (typeof u != "string")
      return u === 0 ? u : +u;
    u = e(u);
    var f = i.test(u);
    return f || a.test(u) ? c(u.slice(2), f ? 2 : 8) : o.test(u) ? r : +u;
  }
  return U$ = l, U$;
}
var W$, DD;
function ITe() {
  if (DD) return W$;
  DD = 1;
  var e = Zq(), t = 1 / 0, n = 17976931348623157e292;
  function r(o) {
    if (!o)
      return o === 0 ? o : 0;
    if (o = e(o), o === t || o === -t) {
      var i = o < 0 ? -1 : 1;
      return i * n;
    }
    return o === o ? o : 0;
  }
  return W$ = r, W$;
}
var H$, LD;
function MTe() {
  if (LD) return H$;
  LD = 1;
  var e = ITe();
  function t(n) {
    var r = e(n), o = r % 1;
    return r === r ? o ? r - o : r : 0;
  }
  return H$ = t, H$;
}
var V$, jD;
function NTe() {
  if (jD) return V$;
  jD = 1;
  var e = RTe(), t = Xq(), n = MTe(), r = ed();
  function o(i, a, c) {
    i = r(i), a = n(a);
    var l = a ? t(i) : 0;
    return a && l < a ? e(a - l, c) + i : i;
  }
  return V$ = o, V$;
}
var DTe = NTe();
const E9e = /* @__PURE__ */ jn(DTe);
var Y$, FD;
function LTe() {
  if (FD) return Y$;
  FD = 1;
  function e(t, n, r) {
    return t === t && (r !== void 0 && (t = t <= r ? t : r), n !== void 0 && (t = t >= n ? t : n)), t;
  }
  return Y$ = e, Y$;
}
var G$, zD;
function jTe() {
  if (zD) return G$;
  zD = 1;
  var e = LTe(), t = Zq();
  function n(r, o, i) {
    return i === void 0 && (i = o, o = void 0), i !== void 0 && (i = t(i), i = i === i ? i : 0), o !== void 0 && (o = t(o), o = o === o ? o : 0), e(t(r), o, i);
  }
  return G$ = n, G$;
}
var FTe = jTe();
const _9e = /* @__PURE__ */ jn(FTe), cl = "DEFAULT_X_AXIS_KEY", zTe = "DEFAULT_Y_AXIS_KEY", BTe = {
  top: 50,
  bottom: 50,
  left: 50,
  right: 50
};
function ge() {
  return ge = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ge.apply(null, arguments);
}
function Bt(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.includes(r)) continue;
    n[r] = e[r];
  }
  return n;
}
function qTe({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: o
  } = E.useRef(e !== void 0), [i, a] = E.useState(t), c = o ? e : i;
  if (process.env.NODE_ENV !== "production") {
    E.useEffect(() => {
      o !== (e !== void 0) && console.error([`MUI: A component is changing the ${o ? "" : "un"}controlled ${r} state of ${n} to be ${o ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r, n, e]);
    const {
      current: u
    } = E.useRef(t);
    E.useEffect(() => {
      !o && !Object.is(u, t) && console.error([`MUI: A component is changing the default ${r} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const l = E.useCallback((u) => {
    o || a(u);
  }, []);
  return [c, l];
}
const t3 = /* @__PURE__ */ E.createContext({
  isInitialized: !1,
  data: {
    highlightedItem: null,
    setHighlighted: () => {
    },
    clearHighlighted: () => {
    },
    isHighlighted: () => !1,
    isFaded: () => !1
  }
});
process.env.NODE_ENV !== "production" && (t3.displayName = "HighlightedContext");
const UTe = (e, t) => (n) => e ? e.fade === "series" ? n.seriesId === (t == null ? void 0 : t.seriesId) && n.dataIndex !== (t == null ? void 0 : t.dataIndex) : e.fade === "global" ? n.seriesId !== (t == null ? void 0 : t.seriesId) || n.dataIndex !== (t == null ? void 0 : t.dataIndex) : !1 : !1, WTe = (e, t) => (n) => e ? e.highlight === "series" ? n.seriesId === (t == null ? void 0 : t.seriesId) : e.highlight === "item" ? n.dataIndex === (t == null ? void 0 : t.dataIndex) && n.seriesId === (t == null ? void 0 : t.seriesId) : !1 : !1, HTe = ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd", "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf"];
function VTe(e, t, n = HTe) {
  return e.type === "pie" ? ge({}, e, {
    data: e.data.map((r, o) => ge({
      color: n[o % n.length]
    }, r))
  }) : ge({
    color: n[t % n.length]
  }, e);
}
const YTe = ({
  series: e,
  colors: t,
  seriesFormatters: n,
  dataset: r
}) => {
  const o = {};
  e.forEach((a, c) => {
    var d;
    const {
      id: l = `auto-generated-id-${c}`,
      type: u
    } = a;
    if (o[u] === void 0 && (o[u] = {
      series: {},
      seriesOrder: []
    }), ((d = o[u]) == null ? void 0 : d.series[l]) !== void 0)
      throw new Error(`MUI X: series' id "${l}" is not unique.`);
    o[u].series[l] = ge({
      id: l
    }, VTe(a, c, t)), o[u].seriesOrder.push(l);
  });
  const i = {};
  return Object.keys(n).forEach((a) => {
    var l;
    const c = o[a];
    c !== void 0 && (i[a] = ((l = n[a]) == null ? void 0 : l.call(n, c, r)) ?? o[a]);
  }), i;
}, GTe = ["#02B2AF", "#2E96FF", "#B800D8", "#60009B", "#2731C8", "#03008D"], KTe = ["#02B2AF", "#72CCFF", "#DA00FF", "#9001CB", "#2E96FF", "#3B48E0"], XTe = (e) => e === "dark" ? KTe : GTe, n3 = /* @__PURE__ */ E.createContext({
  isInitialized: !1,
  data: {}
});
process.env.NODE_ENV !== "production" && (n3.displayName = "SeriesContext");
const cd = /* @__PURE__ */ E.createContext({
  isInitialized: !1,
  data: {
    colorProcessors: {},
    seriesFormatters: {},
    xExtremumGetters: {},
    yExtremumGetters: {},
    rotationExtremumGetters: {},
    radiusExtremumGetters: {}
  }
});
process.env.NODE_ENV !== "production" && (cd.displayName = "PluginContext");
const BD = (e, t) => t === "x" ? {
  x: e,
  y: null
} : {
  x: null,
  y: e
}, Jq = (e) => {
  var l;
  const {
    axis: t,
    getFilters: n,
    isDefaultAxis: r
  } = e, o = n == null ? void 0 : n({
    currentAxisId: t.id,
    isDefaultAxis: r
  }), i = o ? (l = t.data) == null ? void 0 : l.filter((u, d) => o({
    x: null,
    y: null
  }, d)) : t.data, a = Math.min(...i ?? []), c = Math.max(...i ?? []);
  return [a, c];
}, Qq = (e) => (t) => {
  const {
    series: n,
    axis: r,
    getFilters: o,
    isDefaultAxis: i
  } = t;
  return Object.keys(n).filter((a) => {
    const c = n[a].yAxisId ?? n[a].yAxisKey;
    return c === r.id || i && c === void 0;
  }).reduce((a, c) => {
    const {
      stackedData: l
    } = n[c], u = o == null ? void 0 : o({
      currentAxisId: r.id,
      isDefaultAxis: i,
      seriesXAxisId: n[c].xAxisId ?? n[c].xAxisKey,
      seriesYAxisId: n[c].yAxisId ?? n[c].yAxisKey
    }), [d, f] = (l == null ? void 0 : l.reduce((h, v, y) => u && (!u(BD(v[0], e), y) || !u(BD(v[1], e), y)) ? h : [Math.min(...v, h[0]), Math.max(...v, h[1])], [1 / 0, -1 / 0])) ?? [1 / 0, -1 / 0];
    return [Math.min(d, a[0]), Math.max(f, a[1])];
  }, [1 / 0, -1 / 0]);
}, ZTe = (e) => Object.keys(e.series).some((n) => e.series[n].layout === "horizontal") ? Qq("x")(e) : Jq(e), JTe = (e) => Object.keys(e.series).some((n) => e.series[n].layout === "horizontal") ? Jq(e) : Qq("y")(e);
function Et(e) {
  return function() {
    return e;
  };
}
const qD = Math.abs, Tr = Math.atan2, Pa = Math.cos, QTe = Math.max, K$ = Math.min, Gr = Math.sin, mr = Math.sqrt, _r = 1e-12, Ws = Math.PI, b0 = Ws / 2, Ms = 2 * Ws;
function eEe(e) {
  return e > 1 ? 0 : e < -1 ? Ws : Math.acos(e);
}
function UD(e) {
  return e >= 1 ? b0 : e <= -1 ? -b0 : Math.asin(e);
}
const vC = Math.PI, yC = 2 * vC, yc = 1e-6, tEe = yC - yc;
function eU(e) {
  this._ += e[0];
  for (let t = 1, n = e.length; t < n; ++t)
    this._ += arguments[t] + e[t];
}
function nEe(e) {
  let t = Math.floor(e);
  if (!(t >= 0)) throw new Error(`invalid digits: ${e}`);
  if (t > 15) return eU;
  const n = 10 ** t;
  return function(r) {
    this._ += r[0];
    for (let o = 1, i = r.length; o < i; ++o)
      this._ += Math.round(arguments[o] * n) / n + r[o];
  };
}
class rEe {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? eU : nEe(t);
  }
  moveTo(t, n) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, n) {
    this._append`L${this._x1 = +t},${this._y1 = +n}`;
  }
  quadraticCurveTo(t, n, r, o) {
    this._append`Q${+t},${+n},${this._x1 = +r},${this._y1 = +o}`;
  }
  bezierCurveTo(t, n, r, o, i, a) {
    this._append`C${+t},${+n},${+r},${+o},${this._x1 = +i},${this._y1 = +a}`;
  }
  arcTo(t, n, r, o, i) {
    if (t = +t, n = +n, r = +r, o = +o, i = +i, i < 0) throw new Error(`negative radius: ${i}`);
    let a = this._x1, c = this._y1, l = r - t, u = o - n, d = a - t, f = c - n, h = d * d + f * f;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = n}`;
    else if (h > yc) if (!(Math.abs(f * l - u * d) > yc) || !i)
      this._append`L${this._x1 = t},${this._y1 = n}`;
    else {
      let v = r - a, y = o - c, g = l * l + u * u, b = v * v + y * y, x = Math.sqrt(g), $ = Math.sqrt(h), S = i * Math.tan((vC - Math.acos((g + h - b) / (2 * x * $))) / 2), O = S / $, C = S / x;
      Math.abs(O - 1) > yc && this._append`L${t + O * d},${n + O * f}`, this._append`A${i},${i},0,0,${+(f * v > d * y)},${this._x1 = t + C * l},${this._y1 = n + C * u}`;
    }
  }
  arc(t, n, r, o, i, a) {
    if (t = +t, n = +n, r = +r, a = !!a, r < 0) throw new Error(`negative radius: ${r}`);
    let c = r * Math.cos(o), l = r * Math.sin(o), u = t + c, d = n + l, f = 1 ^ a, h = a ? o - i : i - o;
    this._x1 === null ? this._append`M${u},${d}` : (Math.abs(this._x1 - u) > yc || Math.abs(this._y1 - d) > yc) && this._append`L${u},${d}`, r && (h < 0 && (h = h % yC + yC), h > tEe ? this._append`A${r},${r},0,1,${f},${t - c},${n - l}A${r},${r},0,1,${f},${this._x1 = u},${this._y1 = d}` : h > yc && this._append`A${r},${r},0,${+(h >= vC)},${f},${this._x1 = t + r * Math.cos(i)},${this._y1 = n + r * Math.sin(i)}`);
  }
  rect(t, n, r, o) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}h${r = +r}v${+o}h${-r}Z`;
  }
  toString() {
    return this._;
  }
}
function ty(e) {
  let t = 3;
  return e.digits = function(n) {
    if (!arguments.length) return t;
    if (n == null)
      t = null;
    else {
      const r = Math.floor(n);
      if (!(r >= 0)) throw new RangeError(`invalid digits: ${n}`);
      t = r;
    }
    return e;
  }, () => new rEe(t);
}
function oEe(e) {
  return e.innerRadius;
}
function iEe(e) {
  return e.outerRadius;
}
function aEe(e) {
  return e.startAngle;
}
function sEe(e) {
  return e.endAngle;
}
function cEe(e) {
  return e && e.padAngle;
}
function lEe(e, t, n, r, o, i, a, c) {
  var l = n - e, u = r - t, d = a - o, f = c - i, h = f * l - d * u;
  if (!(h * h < _r))
    return h = (d * (t - i) - f * (e - o)) / h, [e + h * l, t + h * u];
}
function Rm(e, t, n, r, o, i, a) {
  var c = e - n, l = t - r, u = (a ? i : -i) / mr(c * c + l * l), d = u * l, f = -u * c, h = e + d, v = t + f, y = n + d, g = r + f, b = (h + y) / 2, x = (v + g) / 2, $ = y - h, S = g - v, O = $ * $ + S * S, C = o - i, T = h * g - y * v, k = (S < 0 ? -1 : 1) * mr(QTe(0, C * C * O - T * T)), I = (T * S - $ * k) / O, P = (-T * $ - S * k) / O, _ = (T * S + $ * k) / O, A = (-T * $ + S * k) / O, D = I - b, M = P - x, N = _ - b, L = A - x;
  return D * D + M * M > N * N + L * L && (I = _, P = A), {
    cx: I,
    cy: P,
    x01: -d,
    y01: -f,
    x11: I * (o / C - 1),
    y11: P * (o / C - 1)
  };
}
function tU() {
  var e = oEe, t = iEe, n = Et(0), r = null, o = aEe, i = sEe, a = cEe, c = null, l = ty(u);
  function u() {
    var d, f, h = +e.apply(this, arguments), v = +t.apply(this, arguments), y = o.apply(this, arguments) - b0, g = i.apply(this, arguments) - b0, b = qD(g - y), x = g > y;
    if (c || (c = d = l()), v < h && (f = v, v = h, h = f), !(v > _r)) c.moveTo(0, 0);
    else if (b > Ms - _r)
      c.moveTo(v * Pa(y), v * Gr(y)), c.arc(0, 0, v, y, g, !x), h > _r && (c.moveTo(h * Pa(g), h * Gr(g)), c.arc(0, 0, h, g, y, x));
    else {
      var $ = y, S = g, O = y, C = g, T = b, k = b, I = a.apply(this, arguments) / 2, P = I > _r && (r ? +r.apply(this, arguments) : mr(h * h + v * v)), _ = K$(qD(v - h) / 2, +n.apply(this, arguments)), A = _, D = _, M, N;
      if (P > _r) {
        var L = UD(P / h * Gr(I)), z = UD(P / v * Gr(I));
        (T -= L * 2) > _r ? (L *= x ? 1 : -1, O += L, C -= L) : (T = 0, O = C = (y + g) / 2), (k -= z * 2) > _r ? (z *= x ? 1 : -1, $ += z, S -= z) : (k = 0, $ = S = (y + g) / 2);
      }
      var q = v * Pa($), W = v * Gr($), U = h * Pa(C), K = h * Gr(C);
      if (_ > _r) {
        var Y = v * Pa(S), X = v * Gr(S), oe = h * Pa(O), re = h * Gr(O), Z;
        if (b < Ws)
          if (Z = lEe(q, W, oe, re, Y, X, U, K)) {
            var ce = q - Z[0], fe = W - Z[1], de = Y - Z[0], ne = X - Z[1], le = 1 / Gr(eEe((ce * de + fe * ne) / (mr(ce * ce + fe * fe) * mr(de * de + ne * ne))) / 2), ve = mr(Z[0] * Z[0] + Z[1] * Z[1]);
            A = K$(_, (h - ve) / (le - 1)), D = K$(_, (v - ve) / (le + 1));
          } else
            A = D = 0;
      }
      k > _r ? D > _r ? (M = Rm(oe, re, q, W, v, D, x), N = Rm(Y, X, U, K, v, D, x), c.moveTo(M.cx + M.x01, M.cy + M.y01), D < _ ? c.arc(M.cx, M.cy, D, Tr(M.y01, M.x01), Tr(N.y01, N.x01), !x) : (c.arc(M.cx, M.cy, D, Tr(M.y01, M.x01), Tr(M.y11, M.x11), !x), c.arc(0, 0, v, Tr(M.cy + M.y11, M.cx + M.x11), Tr(N.cy + N.y11, N.cx + N.x11), !x), c.arc(N.cx, N.cy, D, Tr(N.y11, N.x11), Tr(N.y01, N.x01), !x))) : (c.moveTo(q, W), c.arc(0, 0, v, $, S, !x)) : c.moveTo(q, W), !(h > _r) || !(T > _r) ? c.lineTo(U, K) : A > _r ? (M = Rm(U, K, Y, X, h, -A, x), N = Rm(q, W, oe, re, h, -A, x), c.lineTo(M.cx + M.x01, M.cy + M.y01), A < _ ? c.arc(M.cx, M.cy, A, Tr(M.y01, M.x01), Tr(N.y01, N.x01), !x) : (c.arc(M.cx, M.cy, A, Tr(M.y01, M.x01), Tr(M.y11, M.x11), !x), c.arc(0, 0, h, Tr(M.cy + M.y11, M.cx + M.x11), Tr(N.cy + N.y11, N.cx + N.x11), x), c.arc(N.cx, N.cy, A, Tr(N.y11, N.x11), Tr(N.y01, N.x01), !x))) : c.arc(0, 0, h, C, O, x);
    }
    if (c.closePath(), d) return c = null, d + "" || null;
  }
  return u.centroid = function() {
    var d = (+e.apply(this, arguments) + +t.apply(this, arguments)) / 2, f = (+o.apply(this, arguments) + +i.apply(this, arguments)) / 2 - Ws / 2;
    return [Pa(f) * d, Gr(f) * d];
  }, u.innerRadius = function(d) {
    return arguments.length ? (e = typeof d == "function" ? d : Et(+d), u) : e;
  }, u.outerRadius = function(d) {
    return arguments.length ? (t = typeof d == "function" ? d : Et(+d), u) : t;
  }, u.cornerRadius = function(d) {
    return arguments.length ? (n = typeof d == "function" ? d : Et(+d), u) : n;
  }, u.padRadius = function(d) {
    return arguments.length ? (r = d == null ? null : typeof d == "function" ? d : Et(+d), u) : r;
  }, u.startAngle = function(d) {
    return arguments.length ? (o = typeof d == "function" ? d : Et(+d), u) : o;
  }, u.endAngle = function(d) {
    return arguments.length ? (i = typeof d == "function" ? d : Et(+d), u) : i;
  }, u.padAngle = function(d) {
    return arguments.length ? (a = typeof d == "function" ? d : Et(+d), u) : a;
  }, u.context = function(d) {
    return arguments.length ? (c = d ?? null, u) : c;
  }, u;
}
function ny(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function nU(e) {
  this._context = e;
}
nU.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function r3(e) {
  return new nU(e);
}
function rU(e) {
  return e[0];
}
function oU(e) {
  return e[1];
}
function iU(e, t) {
  var n = Et(!0), r = null, o = r3, i = null, a = ty(c);
  e = typeof e == "function" ? e : e === void 0 ? rU : Et(e), t = typeof t == "function" ? t : t === void 0 ? oU : Et(t);
  function c(l) {
    var u, d = (l = ny(l)).length, f, h = !1, v;
    for (r == null && (i = o(v = a())), u = 0; u <= d; ++u)
      !(u < d && n(f = l[u], u, l)) === h && ((h = !h) ? i.lineStart() : i.lineEnd()), h && i.point(+e(f, u, l), +t(f, u, l));
    if (v) return i = null, v + "" || null;
  }
  return c.x = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : Et(+l), c) : e;
  }, c.y = function(l) {
    return arguments.length ? (t = typeof l == "function" ? l : Et(+l), c) : t;
  }, c.defined = function(l) {
    return arguments.length ? (n = typeof l == "function" ? l : Et(!!l), c) : n;
  }, c.curve = function(l) {
    return arguments.length ? (o = l, r != null && (i = o(r)), c) : o;
  }, c.context = function(l) {
    return arguments.length ? (l == null ? r = i = null : i = o(r = l), c) : r;
  }, c;
}
function uEe(e, t, n) {
  var r = null, o = Et(!0), i = null, a = r3, c = null, l = ty(u);
  e = typeof e == "function" ? e : e === void 0 ? rU : Et(+e), t = typeof t == "function" ? t : Et(t === void 0 ? 0 : +t), n = typeof n == "function" ? n : n === void 0 ? oU : Et(+n);
  function u(f) {
    var h, v, y, g = (f = ny(f)).length, b, x = !1, $, S = new Array(g), O = new Array(g);
    for (i == null && (c = a($ = l())), h = 0; h <= g; ++h) {
      if (!(h < g && o(b = f[h], h, f)) === x)
        if (x = !x)
          v = h, c.areaStart(), c.lineStart();
        else {
          for (c.lineEnd(), c.lineStart(), y = h - 1; y >= v; --y)
            c.point(S[y], O[y]);
          c.lineEnd(), c.areaEnd();
        }
      x && (S[h] = +e(b, h, f), O[h] = +t(b, h, f), c.point(r ? +r(b, h, f) : S[h], n ? +n(b, h, f) : O[h]));
    }
    if ($) return c = null, $ + "" || null;
  }
  function d() {
    return iU().defined(o).curve(a).context(i);
  }
  return u.x = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : Et(+f), r = null, u) : e;
  }, u.x0 = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : Et(+f), u) : e;
  }, u.x1 = function(f) {
    return arguments.length ? (r = f == null ? null : typeof f == "function" ? f : Et(+f), u) : r;
  }, u.y = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : Et(+f), n = null, u) : t;
  }, u.y0 = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : Et(+f), u) : t;
  }, u.y1 = function(f) {
    return arguments.length ? (n = f == null ? null : typeof f == "function" ? f : Et(+f), u) : n;
  }, u.lineX0 = u.lineY0 = function() {
    return d().x(e).y(t);
  }, u.lineY1 = function() {
    return d().x(e).y(n);
  }, u.lineX1 = function() {
    return d().x(r).y(t);
  }, u.defined = function(f) {
    return arguments.length ? (o = typeof f == "function" ? f : Et(!!f), u) : o;
  }, u.curve = function(f) {
    return arguments.length ? (a = f, i != null && (c = a(i)), u) : a;
  }, u.context = function(f) {
    return arguments.length ? (f == null ? i = c = null : c = a(i = f), u) : i;
  }, u;
}
function dEe(e, t) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function fEe(e) {
  return e;
}
function pEe() {
  var e = fEe, t = dEe, n = null, r = Et(0), o = Et(Ms), i = Et(0);
  function a(c) {
    var l, u = (c = ny(c)).length, d, f, h = 0, v = new Array(u), y = new Array(u), g = +r.apply(this, arguments), b = Math.min(Ms, Math.max(-Ms, o.apply(this, arguments) - g)), x, $ = Math.min(Math.abs(b) / u, i.apply(this, arguments)), S = $ * (b < 0 ? -1 : 1), O;
    for (l = 0; l < u; ++l)
      (O = y[v[l] = l] = +e(c[l], l, c)) > 0 && (h += O);
    for (t != null ? v.sort(function(C, T) {
      return t(y[C], y[T]);
    }) : n != null && v.sort(function(C, T) {
      return n(c[C], c[T]);
    }), l = 0, f = h ? (b - u * S) / h : 0; l < u; ++l, g = x)
      d = v[l], O = y[d], x = g + (O > 0 ? O * f : 0) + S, y[d] = {
        data: c[d],
        index: l,
        value: O,
        startAngle: g,
        endAngle: x,
        padAngle: $
      };
    return y;
  }
  return a.value = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : Et(+c), a) : e;
  }, a.sortValues = function(c) {
    return arguments.length ? (t = c, n = null, a) : t;
  }, a.sort = function(c) {
    return arguments.length ? (n = c, t = null, a) : n;
  }, a.startAngle = function(c) {
    return arguments.length ? (r = typeof c == "function" ? c : Et(+c), a) : r;
  }, a.endAngle = function(c) {
    return arguments.length ? (o = typeof c == "function" ? c : Et(+c), a) : o;
  }, a.padAngle = function(c) {
    return arguments.length ? (i = typeof c == "function" ? c : Et(+c), a) : i;
  }, a;
}
const aU = {
  draw(e, t) {
    const n = mr(t / Ws);
    e.moveTo(n, 0), e.arc(0, 0, n, 0, Ms);
  }
}, hEe = {
  draw(e, t) {
    const n = mr(t / 5) / 2;
    e.moveTo(-3 * n, -n), e.lineTo(-n, -n), e.lineTo(-n, -3 * n), e.lineTo(n, -3 * n), e.lineTo(n, -n), e.lineTo(3 * n, -n), e.lineTo(3 * n, n), e.lineTo(n, n), e.lineTo(n, 3 * n), e.lineTo(-n, 3 * n), e.lineTo(-n, n), e.lineTo(-3 * n, n), e.closePath();
  }
}, sU = mr(1 / 3), mEe = sU * 2, gEe = {
  draw(e, t) {
    const n = mr(t / mEe), r = n * sU;
    e.moveTo(0, -n), e.lineTo(r, 0), e.lineTo(0, n), e.lineTo(-r, 0), e.closePath();
  }
}, vEe = {
  draw(e, t) {
    const n = mr(t), r = -n / 2;
    e.rect(r, r, n, n);
  }
}, yEe = 0.8908130915292852, cU = Gr(Ws / 10) / Gr(7 * Ws / 10), bEe = Gr(Ms / 10) * cU, xEe = -Pa(Ms / 10) * cU, wEe = {
  draw(e, t) {
    const n = mr(t * yEe), r = bEe * n, o = xEe * n;
    e.moveTo(0, -n), e.lineTo(r, o);
    for (let i = 1; i < 5; ++i) {
      const a = Ms * i / 5, c = Pa(a), l = Gr(a);
      e.lineTo(l * n, -c * n), e.lineTo(c * r - l * o, l * r + c * o);
    }
    e.closePath();
  }
}, X$ = mr(3), $Ee = {
  draw(e, t) {
    const n = -mr(t / (X$ * 3));
    e.moveTo(0, n * 2), e.lineTo(-X$ * n, -n), e.lineTo(X$ * n, -n), e.closePath();
  }
}, Lo = -0.5, jo = mr(3) / 2, bC = 1 / mr(12), OEe = (bC / 2 + 1) * 3, SEe = {
  draw(e, t) {
    const n = mr(t / OEe), r = n / 2, o = n * bC, i = r, a = n * bC + n, c = -i, l = a;
    e.moveTo(r, o), e.lineTo(i, a), e.lineTo(c, l), e.lineTo(Lo * r - jo * o, jo * r + Lo * o), e.lineTo(Lo * i - jo * a, jo * i + Lo * a), e.lineTo(Lo * c - jo * l, jo * c + Lo * l), e.lineTo(Lo * r + jo * o, Lo * o - jo * r), e.lineTo(Lo * i + jo * a, Lo * a - jo * i), e.lineTo(Lo * c + jo * l, Lo * l - jo * c), e.closePath();
  }
}, CEe = [
  aU,
  hEe,
  gEe,
  vEe,
  wEe,
  $Ee,
  SEe
];
function TEe(e, t) {
  let n = null, r = ty(o);
  e = typeof e == "function" ? e : Et(e || aU), t = typeof t == "function" ? t : Et(t === void 0 ? 64 : +t);
  function o() {
    let i;
    if (n || (n = i = r()), e.apply(this, arguments).draw(n, +t.apply(this, arguments)), i) return n = null, i + "" || null;
  }
  return o.type = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : Et(i), o) : e;
  }, o.size = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : Et(+i), o) : t;
  }, o.context = function(i) {
    return arguments.length ? (n = i ?? null, o) : n;
  }, o;
}
function WD(e, t, n) {
  e._context.bezierCurveTo(
    e._x1 + e._k * (e._x2 - e._x0),
    e._y1 + e._k * (e._y2 - e._y0),
    e._x2 + e._k * (e._x1 - t),
    e._y2 + e._k * (e._y1 - n),
    e._x2,
    e._y2
  );
}
function o3(e, t) {
  this._context = e, this._k = (1 - t) / 6;
}
o3.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        WD(this, this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2, this._x1 = e, this._y1 = t;
        break;
      case 2:
        this._point = 3;
      // falls through
      default:
        WD(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
(function e(t) {
  function n(r) {
    return new o3(r, t);
  }
  return n.tension = function(r) {
    return e(+r);
  }, n;
})(0);
function EEe(e, t, n) {
  var r = e._x1, o = e._y1, i = e._x2, a = e._y2;
  if (e._l01_a > _r) {
    var c = 2 * e._l01_2a + 3 * e._l01_a * e._l12_a + e._l12_2a, l = 3 * e._l01_a * (e._l01_a + e._l12_a);
    r = (r * c - e._x0 * e._l12_2a + e._x2 * e._l01_2a) / l, o = (o * c - e._y0 * e._l12_2a + e._y2 * e._l01_2a) / l;
  }
  if (e._l23_a > _r) {
    var u = 2 * e._l23_2a + 3 * e._l23_a * e._l12_a + e._l12_2a, d = 3 * e._l23_a * (e._l23_a + e._l12_a);
    i = (i * u + e._x1 * e._l23_2a - t * e._l12_2a) / d, a = (a * u + e._y1 * e._l23_2a - n * e._l12_2a) / d;
  }
  e._context.bezierCurveTo(r, o, i, a, e._x2, e._y2);
}
function lU(e, t) {
  this._context = e, this._alpha = t;
}
lU.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    if (e = +e, t = +t, this._point) {
      var n = this._x2 - e, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(n * n + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
      // falls through
      default:
        EEe(this, e, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = e, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const _Ee = function e(t) {
  function n(r) {
    return t ? new lU(r, t) : new o3(r, 0);
  }
  return n.alpha = function(r) {
    return e(+r);
  }, n;
}(0.5);
function HD(e) {
  return e < 0 ? -1 : 1;
}
function VD(e, t, n) {
  var r = e._x1 - e._x0, o = t - e._x1, i = (e._y1 - e._y0) / (r || o < 0 && -0), a = (n - e._y1) / (o || r < 0 && -0), c = (i * o + a * r) / (r + o);
  return (HD(i) + HD(a)) * Math.min(Math.abs(i), Math.abs(a), 0.5 * Math.abs(c)) || 0;
}
function YD(e, t) {
  var n = e._x1 - e._x0;
  return n ? (3 * (e._y1 - e._y0) / n - t) / 2 : t;
}
function Z$(e, t, n) {
  var r = e._x0, o = e._y0, i = e._x1, a = e._y1, c = (i - r) / 3;
  e._context.bezierCurveTo(r + c, o + c * t, i - c, a - c * n, i, a);
}
function x0(e) {
  this._context = e;
}
x0.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        Z$(this, this._t0, YD(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var n = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, Z$(this, YD(this, n = VD(this, e, t)), n);
          break;
        default:
          Z$(this, this._t0, n = VD(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = n;
    }
  }
};
function uU(e) {
  this._context = new dU(e);
}
(uU.prototype = Object.create(x0.prototype)).point = function(e, t) {
  x0.prototype.point.call(this, t, e);
};
function dU(e) {
  this._context = e;
}
dU.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, n, r, o, i) {
    this._context.bezierCurveTo(t, e, r, n, i, o);
  }
};
function GD(e) {
  return new x0(e);
}
function kEe(e) {
  return new uU(e);
}
function fU(e) {
  this._context = e;
}
fU.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, n = e.length;
    if (n)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), n === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var r = KD(e), o = KD(t), i = 0, a = 1; a < n; ++i, ++a)
          this._context.bezierCurveTo(r[0][i], o[0][i], r[1][i], o[1][i], e[a], t[a]);
    (this._line || this._line !== 0 && n === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function KD(e) {
  var t, n = e.length - 1, r, o = new Array(n), i = new Array(n), a = new Array(n);
  for (o[0] = 0, i[0] = 2, a[0] = e[0] + 2 * e[1], t = 1; t < n - 1; ++t) o[t] = 1, i[t] = 4, a[t] = 4 * e[t] + 2 * e[t + 1];
  for (o[n - 1] = 2, i[n - 1] = 7, a[n - 1] = 8 * e[n - 1] + e[n], t = 1; t < n; ++t) r = o[t] / i[t - 1], i[t] -= r, a[t] -= r * a[t - 1];
  for (o[n - 1] = a[n - 1] / i[n - 1], t = n - 2; t >= 0; --t) o[t] = (a[t] - o[t + 1]) / i[t];
  for (i[n - 1] = (e[n] + o[n - 1]) / 2, t = 0; t < n - 1; ++t) i[t] = 2 * e[t + 1] - o[t + 1];
  return [o, i];
}
function REe(e) {
  return new fU(e);
}
function ry(e, t) {
  this._context = e, this._t = t;
}
ry.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var n = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(n, this._y), this._context.lineTo(n, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function PEe(e) {
  return new ry(e, 0.5);
}
function AEe(e) {
  return new ry(e, 0);
}
function IEe(e) {
  return new ry(e, 1);
}
function Lu(e, t) {
  if ((a = e.length) > 1)
    for (var n = 1, r, o, i = e[t[0]], a, c = i.length; n < a; ++n)
      for (o = i, i = e[t[n]], r = 0; r < c; ++r)
        i[r][1] += i[r][0] = isNaN(o[r][1]) ? o[r][0] : o[r][1];
}
function ju(e) {
  for (var t = e.length, n = new Array(t); --t >= 0; ) n[t] = t;
  return n;
}
function MEe(e, t) {
  return e[t];
}
function NEe(e) {
  const t = [];
  return t.key = e, t;
}
function pU() {
  var e = Et([]), t = ju, n = Lu, r = MEe;
  function o(i) {
    var a = Array.from(e.apply(this, arguments), NEe), c, l = a.length, u = -1, d;
    for (const f of i)
      for (c = 0, ++u; c < l; ++c)
        (a[c][u] = [0, +r(f, a[c].key, u, i)]).data = f;
    for (c = 0, d = ny(t(a)); c < l; ++c)
      a[d[c]].index = c;
    return n(a, d), a;
  }
  return o.keys = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : Et(Array.from(i)), o) : e;
  }, o.value = function(i) {
    return arguments.length ? (r = typeof i == "function" ? i : Et(+i), o) : r;
  }, o.order = function(i) {
    return arguments.length ? (t = i == null ? ju : typeof i == "function" ? i : Et(Array.from(i)), o) : t;
  }, o.offset = function(i) {
    return arguments.length ? (n = i ?? Lu, o) : n;
  }, o;
}
function DEe(e, t) {
  if ((r = e.length) > 0) {
    for (var n, r, o = 0, i = e[0].length, a; o < i; ++o) {
      for (a = n = 0; n < r; ++n) a += e[n][o][1] || 0;
      if (a) for (n = 0; n < r; ++n) e[n][o][1] /= a;
    }
    Lu(e, t);
  }
}
function LEe(e, t) {
  if ((l = e.length) > 0)
    for (var n, r = 0, o, i, a, c, l, u = e[t[0]].length; r < u; ++r)
      for (a = c = 0, n = 0; n < l; ++n)
        (i = (o = e[t[n]][r])[1] - o[0]) > 0 ? (o[0] = a, o[1] = a += i) : i < 0 ? (o[1] = c, o[0] = c += i) : (o[0] = 0, o[1] = i);
}
function jEe(e, t) {
  if ((o = e.length) > 0) {
    for (var n = 0, r = e[t[0]], o, i = r.length; n < i; ++n) {
      for (var a = 0, c = 0; a < o; ++a) c += e[a][n][1] || 0;
      r[n][1] += r[n][0] = -c / 2;
    }
    Lu(e, t);
  }
}
function FEe(e, t) {
  if (!(!((a = e.length) > 0) || !((i = (o = e[t[0]]).length) > 0))) {
    for (var n = 0, r = 1, o, i, a; r < i; ++r) {
      for (var c = 0, l = 0, u = 0; c < a; ++c) {
        for (var d = e[t[c]], f = d[r][1] || 0, h = d[r - 1][1] || 0, v = (f - h) / 2, y = 0; y < c; ++y) {
          var g = e[t[y]], b = g[r][1] || 0, x = g[r - 1][1] || 0;
          v += b - x;
        }
        l += f, u += v * f;
      }
      o[r - 1][1] += o[r - 1][0] = n, l && (n -= u / l);
    }
    o[r - 1][1] += o[r - 1][0] = n, Lu(e, t);
  }
}
function hU(e) {
  var t = e.map(zEe);
  return ju(e).sort(function(n, r) {
    return t[n] - t[r];
  });
}
function zEe(e) {
  for (var t = -1, n = 0, r = e.length, o, i = -1 / 0; ++t < r; ) (o = +e[t][1]) > i && (i = o, n = t);
  return n;
}
function mU(e) {
  var t = e.map(gU);
  return ju(e).sort(function(n, r) {
    return t[n] - t[r];
  });
}
function gU(e) {
  for (var t = 0, n = -1, r = e.length, o; ++n < r; ) (o = +e[n][1]) && (t += o);
  return t;
}
function BEe(e) {
  return mU(e).reverse();
}
function qEe(e) {
  var t = e.length, n, r, o = e.map(gU), i = hU(e), a = 0, c = 0, l = [], u = [];
  for (n = 0; n < t; ++n)
    r = i[n], a < c ? (a += o[r], l.push(r)) : (c += o[r], u.push(r));
  return u.reverse().concat(l);
}
function UEe(e) {
  return ju(e).reverse();
}
const J$ = {
  /**
   * Series order such that the earliest series (according to the maximum value) is at the bottom.
   * */
  appearance: hU,
  /**
   *  Series order such that the smallest series (according to the sum of values) is at the bottom.
   * */
  ascending: mU,
  /**
   * Series order such that the largest series (according to the sum of values) is at the bottom.
   */
  descending: BEe,
  /**
   * Series order such that the earliest series (according to the maximum value) are on the inside and the later series are on the outside. This order is recommended for streamgraphs in conjunction with the wiggle offset. See Stacked Graphs—Geometry & Aesthetics by Byron & Wattenberg for more information.
   */
  insideOut: qEe,
  /**
   * Given series order [0, 1, … n - 1] where n is the number of elements in series. Thus, the stack order is given by the key accessor.
   */
  none: ju,
  /**
   * Reverse of the given series order [n - 1, n - 2, … 0] where n is the number of elements in series. Thus, the stack order is given by the reverse of the key accessor.
   */
  reverse: UEe
}, Q$ = {
  /**
   * Applies a zero baseline and normalizes the values for each point such that the topline is always one.
   * */
  expand: DEe,
  /**
   * Positive values are stacked above zero, negative values are stacked below zero, and zero values are stacked at zero.
   * */
  diverging: LEe,
  /**
   * Applies a zero baseline.
   * */
  none: Lu,
  /**
   * Shifts the baseline down such that the center of the streamgraph is always at zero.
   * */
  silhouette: jEe,
  /**
   * Shifts the baseline so as to minimize the weighted wiggle of layers. This offset is recommended for streamgraphs in conjunction with the inside-out order. See Stacked Graphs—Geometry & Aesthetics by Bryon & Wattenberg for more information.
   * */
  wiggle: FEe
}, vU = (e) => {
  const {
    series: t,
    seriesOrder: n,
    defaultStrategy: r
  } = e, o = [], i = {};
  return n.forEach((a) => {
    const {
      stack: c,
      stackOrder: l,
      stackOffset: u
    } = t[a];
    c === void 0 ? o.push({
      ids: [a],
      stackingOrder: J$.none,
      stackingOffset: Q$.none
    }) : i[c] === void 0 ? (i[c] = o.length, o.push({
      ids: [a],
      stackingOrder: J$[l ?? (r == null ? void 0 : r.stackOrder) ?? "none"],
      stackingOffset: Q$[u ?? (r == null ? void 0 : r.stackOffset) ?? "diverging"]
    })) : (o[i[c]].ids.push(a), l !== void 0 && (o[i[c]].stackingOrder = J$[l]), u !== void 0 && (o[i[c]].stackingOffset = Q$[u]));
  }), o;
};
function yU(e, t) {
  const n = {};
  return Object.keys(e).forEach((r) => {
    n[r] = ge({}, e[r], {
      valueFormatter: e[r].valueFormatter ?? t
    });
  }), n;
}
const WEe = (e, t) => {
  const {
    seriesOrder: n,
    series: r
  } = e, o = vU(e), i = t ?? [];
  n.forEach((c) => {
    const l = r[c].data;
    if (l !== void 0)
      l.forEach((u, d) => {
        i.length <= d ? i.push({
          [c]: u
        }) : i[d][c] = u;
      });
    else if (t === void 0)
      throw new Error([`MUI X: bar series with id='${c}' has no data.`, "Either provide a data property to the series or use the dataset prop."].join(`
`));
  });
  const a = {};
  return o.forEach((c) => {
    const {
      ids: l,
      stackingOffset: u,
      stackingOrder: d
    } = c, f = pU().keys(l.map((h) => {
      const v = r[h].dataKey;
      return r[h].data === void 0 && v !== void 0 ? v : h;
    })).value((h, v) => h[v] ?? 0).order(d).offset(u)(i);
    l.forEach((h, v) => {
      const y = r[h].dataKey;
      a[h] = ge({
        layout: "vertical"
      }, r[h], {
        data: y ? t.map((g) => {
          const b = g[y];
          return typeof b != "number" ? (process.env.NODE_ENV !== "production" && b !== null && Ev([`MUI X: your dataset key "${y}" is used for plotting bars, but contains nonnumerical elements.`, "Bar plots only support numbers and null values."]), 0) : b;
        }) : r[h].data,
        stackedData: f[v].map(([g, b]) => [g, b])
      });
    });
  }), {
    seriesOrder: n,
    stackingGroups: o,
    series: yU(a, (c) => c == null ? "" : c.toLocaleString())
  };
}, HEe = (e, t, n) => {
  const r = e.layout === "vertical", o = r ? t == null ? void 0 : t.colorScale : n == null ? void 0 : n.colorScale, i = r ? n == null ? void 0 : n.colorScale : t == null ? void 0 : t.colorScale, a = r ? t == null ? void 0 : t.data : n == null ? void 0 : n.data;
  return i ? (c) => {
    const l = e.data[c], u = l === null ? e.color : i(l);
    return u === null ? e.color : u;
  } : o && a ? (c) => {
    const l = a[c], u = l === null ? e.color : o(l);
    return u === null ? e.color : u;
  } : () => e.color;
}, VEe = {
  seriesType: "bar",
  seriesFormatter: WEe,
  colorProcessor: HEe,
  xExtremumGetter: ZTe,
  yExtremumGetter: JTe
}, w0 = (e, t) => [t[0] === null ? e[0] : Math.min(e[0], t[0]), t[1] === null ? e[1] : Math.max(e[1], t[1])], YEe = (e) => {
  const {
    series: t,
    axis: n,
    isDefaultAxis: r,
    getFilters: o
  } = e;
  return Object.keys(t).filter((i) => {
    const a = t[i].xAxisId ?? t[i].xAxisKey;
    return a === n.id || a === void 0 && r;
  }).reduce((i, a) => {
    var u;
    const c = o == null ? void 0 : o({
      currentAxisId: n.id,
      isDefaultAxis: r,
      seriesXAxisId: t[a].xAxisId ?? t[a].xAxisKey,
      seriesYAxisId: t[a].yAxisId ?? t[a].yAxisKey
    }), l = (u = t[a].data) == null ? void 0 : u.reduce((d, f, h) => c && !c(f, h) ? d : w0(d, [f.x, f.x]), [1 / 0, -1 / 0]);
    return w0(i, l ?? [1 / 0, -1 / 0]);
  }, [1 / 0, -1 / 0]);
}, GEe = (e) => {
  const {
    series: t,
    axis: n,
    isDefaultAxis: r,
    getFilters: o
  } = e;
  return Object.keys(t).filter((i) => {
    const a = t[i].yAxisId ?? t[i].yAxisKey;
    return a === n.id || a === void 0 && r;
  }).reduce((i, a) => {
    var u;
    const c = o == null ? void 0 : o({
      currentAxisId: n.id,
      isDefaultAxis: r,
      seriesXAxisId: t[a].xAxisId ?? t[a].xAxisKey,
      seriesYAxisId: t[a].yAxisId ?? t[a].yAxisKey
    }), l = (u = t[a].data) == null ? void 0 : u.reduce((d, f, h) => c && !c(f, h) ? d : w0(d, [f.y, f.y]), [1 / 0, -1 / 0]);
    return w0(i, l ?? [1 / 0, -1 / 0]);
  }, [1 / 0, -1 / 0]);
}, KEe = ({
  series: e,
  seriesOrder: t
}, n) => ({
  series: Object.fromEntries(Object.entries(e).map(([o, i]) => {
    const a = i == null ? void 0 : i.datasetKeys, c = ["x", "y", "id"].filter((u) => typeof (a == null ? void 0 : a[u]) != "string");
    if (i != null && i.datasetKeys && c.length > 0)
      throw new Error([`MUI X: scatter series with id='${o}' has incomplete datasetKeys.`, `Properties ${c.map((u) => `"${u}"`).join(", ")} are missing.`].join(`
`));
    const l = a ? (n == null ? void 0 : n.map((u) => ({
      x: u[a.x] ?? null,
      y: u[a.y] ?? null,
      z: a.z && u[a.z],
      id: u[a.id]
    }))) ?? [] : i.data ?? [];
    return [o, ge({}, i, {
      data: l,
      valueFormatter: i.valueFormatter ?? ((u) => `(${u.x}, ${u.y})`)
    })];
  })),
  seriesOrder: t
}), XEe = (e, t, n, r) => {
  const o = r == null ? void 0 : r.colorScale, i = n == null ? void 0 : n.colorScale, a = t == null ? void 0 : t.colorScale;
  return o ? (c) => {
    var d, f;
    if (((d = r == null ? void 0 : r.data) == null ? void 0 : d[c]) !== void 0) {
      const h = o((f = r == null ? void 0 : r.data) == null ? void 0 : f[c]);
      if (h !== null)
        return h;
    }
    const l = e.data[c], u = l === null ? e.color : o(l.z);
    return u === null ? e.color : u;
  } : i ? (c) => {
    const l = e.data[c], u = l === null ? e.color : i(l.y);
    return u === null ? e.color : u;
  } : a ? (c) => {
    const l = e.data[c], u = l === null ? e.color : a(l.x);
    return u === null ? e.color : u;
  } : () => e.color;
}, ZEe = {
  seriesType: "scatter",
  seriesFormatter: KEe,
  colorProcessor: XEe,
  xExtremumGetter: YEe,
  yExtremumGetter: GEe
}, JEe = (e) => {
  const {
    axis: t
  } = e, n = Math.min(...t.data ?? []), r = Math.max(...t.data ?? []);
  return [n, r];
};
function QEe(e, t, n) {
  return t.reduce((r, o, i) => {
    const [a, c] = e(o);
    return n && (!n({
      y: a,
      x: null
    }, i) || !n({
      y: c,
      x: null
    }, i)) ? r : [Math.min(a, c, r[0]), Math.max(a, c, r[1])];
  }, [1 / 0, -1 / 0]);
}
const e3e = (e) => {
  const {
    series: t,
    axis: n,
    isDefaultAxis: r,
    getFilters: o
  } = e;
  return Object.keys(t).filter((i) => {
    const a = t[i].yAxisId ?? t[i].yAxisKey;
    return a === n.id || r && a === void 0;
  }).reduce((i, a) => {
    const {
      area: c,
      stackedData: l
    } = t[a], u = c !== void 0, d = o == null ? void 0 : o({
      currentAxisId: n.id,
      isDefaultAxis: r,
      seriesXAxisId: t[a].xAxisId ?? t[a].xAxisKey,
      seriesYAxisId: t[a].yAxisId ?? t[a].yAxisKey
    }), f = u && n.scaleType !== "log" && typeof t[a].baseline != "string" ? (g) => g : (g) => [g[1], g[1]], h = QEe(f, l, d), [v, y] = h;
    return [Math.min(v, i[0]), Math.max(y, i[1])];
  }, [1 / 0, -1 / 0]);
}, t3e = (e, t) => {
  const {
    seriesOrder: n,
    series: r
  } = e, o = vU(ge({}, e, {
    defaultStrategy: {
      stackOffset: "none"
    }
  })), i = t ?? [];
  n.forEach((c) => {
    const l = r[c].data;
    if (l !== void 0)
      l.forEach((u, d) => {
        i.length <= d ? i.push({
          [c]: u
        }) : i[d][c] = u;
      });
    else if (t === void 0 && process.env.NODE_ENV !== "production")
      throw new Error([`MUI X: line series with id='${c}' has no data.`, "Either provide a data property to the series or use the dataset prop."].join(`
`));
  });
  const a = {};
  return o.forEach((c) => {
    const {
      ids: l,
      stackingOrder: u,
      stackingOffset: d
    } = c, f = pU().keys(l.map((h) => {
      const v = r[h].dataKey;
      return r[h].data === void 0 && v !== void 0 ? v : h;
    })).value((h, v) => h[v] ?? 0).order(u).offset(d)(i);
    l.forEach((h, v) => {
      const y = r[h].dataKey;
      a[h] = ge({}, r[h], {
        data: y ? t.map((g) => {
          const b = g[y];
          return typeof b != "number" ? (process.env.NODE_ENV !== "production" && b !== null && Ev([`MUI X: Your dataset key "${y}" is used for plotting line, but contains nonnumerical elements.`, "Line plots only support numbers and null values."]), null) : b;
        }) : r[h].data,
        stackedData: f[v].map(([g, b]) => [g, b])
      });
    });
  }), {
    seriesOrder: n,
    stackingGroups: o,
    series: yU(a, (c) => c == null ? "" : c.toLocaleString())
  };
}, i3 = (e, t, n) => {
  const r = n == null ? void 0 : n.colorScale, o = t == null ? void 0 : t.colorScale;
  return r ? (i) => {
    const a = e.data[i], c = a === null ? e.color : r(a);
    return c === null ? e.color : c;
  } : o ? (i) => {
    var l;
    const a = (l = t.data) == null ? void 0 : l[i], c = a === null ? e.color : o(a);
    return c === null ? e.color : c;
  } : () => e.color;
}, n3e = {
  seriesType: "line",
  colorProcessor: i3,
  seriesFormatter: t3e,
  xExtremumGetter: JEe,
  yExtremumGetter: e3e
};
function yi(e, t) {
  return typeof e == "function" ? e(t) : e;
}
const r3e = (e = "none") => {
  if (typeof e == "function")
    return e;
  switch (e) {
    case "none":
      return null;
    case "desc":
      return (t, n) => n - t;
    case "asc":
      return (t, n) => t - n;
    default:
      return null;
  }
}, o3e = (e) => {
  const {
    seriesOrder: t,
    series: n
  } = e, r = {};
  return t.forEach((o) => {
    const i = pEe().startAngle(2 * Math.PI * (n[o].startAngle ?? 0) / 360).endAngle(2 * Math.PI * (n[o].endAngle ?? 360) / 360).padAngle(2 * Math.PI * (n[o].paddingAngle ?? 0) / 360).sortValues(r3e(n[o].sortingValues ?? "none"))(n[o].data.map((a) => a.value));
    r[o] = ge({
      valueFormatter: (a) => a.value.toLocaleString()
    }, n[o], {
      data: n[o].data.map((a, c) => ge({}, a, {
        id: a.id ?? `auto-generated-pie-id-${o}-${c}`
      }, i[c])).map((a, c) => {
        var l, u;
        return ge({}, a, {
          formattedValue: ((u = (l = n[o]).valueFormatter) == null ? void 0 : u.call(l, ge({}, a, {
            label: yi(a.label, "arc")
          }), {
            dataIndex: c
          })) ?? a.value.toLocaleString()
        });
      })
    });
  }), {
    seriesOrder: t,
    series: r
  };
}, i3e = (e) => (t) => e.data[t].color, a3e = {
  seriesType: "pie",
  colorProcessor: i3e,
  seriesFormatter: o3e
}, s3e = [VEe, ZEe, n3e, a3e];
function c3e(e) {
  const t = e ?? s3e, n = {}, r = {}, o = {}, i = {}, a = {}, c = {};
  for (let l = 0; l < t.length; l += 1) {
    const u = t[l], d = u.seriesType;
    n[d] = u.seriesFormatter, r[d] = u.colorProcessor, u.xExtremumGetter && (o[d] = u.xExtremumGetter), u.yExtremumGetter && (i[d] = u.yExtremumGetter), u.rotationExtremumGetter && (a[d] = u.rotationExtremumGetter), u.radiusExtremumGetter && (c[d] = u.radiusExtremumGetter);
  }
  return {
    seriesFormatters: n,
    colorProcessors: r,
    xExtremumGetters: o,
    yExtremumGetters: i,
    rotationExtremumGetters: a,
    radiusExtremumGetters: c
  };
}
function l3e(e) {
  const {
    children: t,
    plugins: n
  } = e, r = E.useMemo(() => ({
    isInitialized: !0,
    data: c3e(n)
  }), [n]);
  return /* @__PURE__ */ F.jsx(cd.Provider, {
    value: r,
    children: t
  });
}
function bU(e) {
  const {
    isInitialized: t,
    data: n
  } = E.useContext(cd);
  if (!t)
    throw new Error(["MUI X: Could not find the plugin context.", "It looks like you rendered your component outside of a ChartsContainer parent component."].join(`
`));
  return n.colorProcessors;
}
function u3e(e) {
  const {
    isInitialized: t,
    data: n
  } = E.useContext(cd);
  if (!t)
    throw new Error(["MUI X: Could not find the plugin context.", "It looks like you rendered your component outside of a ChartsContainer parent component."].join(`
`));
  return n.seriesFormatters;
}
function d3e(e) {
  const {
    isInitialized: t,
    data: n
  } = E.useContext(cd);
  if (!t)
    throw new Error(["MUI X: Could not find the plugin context.", "It looks like you rendered your component outside of a ChartsContainer parent component."].join(`
`));
  return n.xExtremumGetters;
}
function f3e(e) {
  const {
    isInitialized: t,
    data: n
  } = E.useContext(cd);
  if (!t)
    throw new Error(["MUI X: Could not find the plugin context.", "It looks like you rendered your component outside of a ChartsContainer parent component."].join(`
`));
  return n.yExtremumGetters;
}
function p3e(e) {
  const {
    series: t,
    dataset: n,
    colors: r = XTe,
    children: o
  } = e, i = u3e(), a = Fr(), c = E.useMemo(() => ({
    isInitialized: !0,
    data: YTe({
      series: t,
      colors: typeof r == "function" ? r(a.palette.mode) : r,
      seriesFormatters: i,
      dataset: n
    })
  }), [t, r, a.palette.mode, i, n]);
  return /* @__PURE__ */ F.jsx(n3.Provider, {
    value: c,
    children: o
  });
}
function es() {
  const {
    isInitialized: e,
    data: t
  } = E.useContext(n3);
  if (!e)
    throw new Error(["MUI X: Could not find the series ref context.", "It looks like you rendered your component outside of a ChartsContainer parent component."].join(`
`));
  return t;
}
function h3e() {
  const e = es();
  return E.useMemo(() => e.pie, [e.pie]);
}
function oy() {
  const e = es();
  return E.useMemo(() => e.line, [e.line]);
}
const m3e = ["highlighted", "faded"], g3e = (e) => {
  const t = e ?? {}, {
    highlighted: n,
    faded: r
  } = t, o = Bt(t, m3e);
  return ge({
    highlight: n,
    fade: r
  }, o);
};
function xU({
  children: e,
  highlightedItem: t,
  onHighlightChange: n
}) {
  const [r, o] = qTe({
    controlled: t,
    default: null,
    name: "HighlightedProvider",
    state: "highlightedItem"
  }), i = es(), a = E.useMemo(() => {
    const u = /* @__PURE__ */ new Map();
    return Object.keys(i).forEach((d) => {
      const f = i[d];
      Object.keys((f == null ? void 0 : f.series) ?? {}).forEach((h) => {
        const v = f == null ? void 0 : f.series[h];
        u.set(h, g3e(v == null ? void 0 : v.highlightScope));
      });
    }), u;
  }, [i]), c = r && r.seriesId ? a.get(r.seriesId) ?? void 0 : void 0, l = E.useMemo(() => ({
    isInitialized: !0,
    data: {
      highlightScope: c,
      highlightedItem: r,
      setHighlighted: (u) => {
        o(u), n == null || n(u);
      },
      clearHighlighted: () => {
        o(null), n == null || n(null);
      },
      isHighlighted: WTe(c, r),
      isFaded: UTe(c, r)
    }
  }), [r, c, o, n]);
  return /* @__PURE__ */ F.jsx(t3.Provider, {
    value: l,
    children: e
  });
}
process.env.NODE_ENV !== "production" && (xU.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: s.node,
  /**
   * The item currently highlighted. Turns highlighting into a controlled prop.
   */
  highlightedItem: s.shape({
    dataIndex: s.number,
    seriesId: s.oneOfType([s.number, s.string])
  }),
  /**
   * The callback fired when the highlighted item changes.
   *
   * @param {HighlightItemData | null} highlightedItem  The newly highlighted item.
   */
  onHighlightChange: s.func
});
function iy() {
  const {
    isInitialized: e,
    data: t
  } = E.useContext(t3);
  if (!e)
    throw new Error(["MUI X: Could not find the highlighted ref context.", "It looks like you rendered your component outside of a ChartsContainer parent component."].join(`
`));
  return t;
}
function ay(e) {
  const t = iy();
  if (!e)
    return {
      isHighlighted: !1,
      isFaded: !1
    };
  const n = t.isHighlighted(e), r = !n && t.isFaded(e);
  return {
    isHighlighted: n,
    isFaded: r
  };
}
function gg(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function v3e(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function a3(e) {
  let t, n, r;
  e.length !== 2 ? (t = gg, n = (c, l) => gg(e(c), l), r = (c, l) => e(c) - l) : (t = e === gg || e === v3e ? e : y3e, n = e, r = e);
  function o(c, l, u = 0, d = c.length) {
    if (u < d) {
      if (t(l, l) !== 0) return d;
      do {
        const f = u + d >>> 1;
        n(c[f], l) < 0 ? u = f + 1 : d = f;
      } while (u < d);
    }
    return u;
  }
  function i(c, l, u = 0, d = c.length) {
    if (u < d) {
      if (t(l, l) !== 0) return d;
      do {
        const f = u + d >>> 1;
        n(c[f], l) <= 0 ? u = f + 1 : d = f;
      } while (u < d);
    }
    return u;
  }
  function a(c, l, u = 0, d = c.length) {
    const f = o(c, l, u, d - 1);
    return f > u && r(c[f - 1], l) > -r(c[f], l) ? f - 1 : f;
  }
  return { left: o, center: a, right: i };
}
function y3e() {
  return 0;
}
function b3e(e) {
  return e === null ? NaN : +e;
}
const x3e = a3(gg), wU = x3e.right;
a3(b3e).center;
class XD extends Map {
  constructor(t, n = O3e) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: n } }), t != null) for (const [r, o] of t) this.set(r, o);
  }
  get(t) {
    return super.get(ZD(this, t));
  }
  has(t) {
    return super.has(ZD(this, t));
  }
  set(t, n) {
    return super.set(w3e(this, t), n);
  }
  delete(t) {
    return super.delete($3e(this, t));
  }
}
function ZD({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : n;
}
function w3e({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) ? e.get(r) : (e.set(r, n), n);
}
function $3e({ _intern: e, _key: t }, n) {
  const r = t(n);
  return e.has(r) && (n = e.get(r), e.delete(r)), n;
}
function O3e(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
const S3e = Math.sqrt(50), C3e = Math.sqrt(10), T3e = Math.sqrt(2);
function $0(e, t, n) {
  const r = (t - e) / Math.max(0, n), o = Math.floor(Math.log10(r)), i = r / Math.pow(10, o), a = i >= S3e ? 10 : i >= C3e ? 5 : i >= T3e ? 2 : 1;
  let c, l, u;
  return o < 0 ? (u = Math.pow(10, -o) / a, c = Math.round(e * u), l = Math.round(t * u), c / u < e && ++c, l / u > t && --l, u = -u) : (u = Math.pow(10, o) * a, c = Math.round(e / u), l = Math.round(t / u), c * u < e && ++c, l * u > t && --l), l < c && 0.5 <= n && n < 2 ? $0(e, t, n * 2) : [c, l, u];
}
function xC(e, t, n) {
  if (t = +t, e = +e, n = +n, !(n > 0)) return [];
  if (e === t) return [e];
  const r = t < e, [o, i, a] = r ? $0(t, e, n) : $0(e, t, n);
  if (!(i >= o)) return [];
  const c = i - o + 1, l = new Array(c);
  if (r)
    if (a < 0) for (let u = 0; u < c; ++u) l[u] = (i - u) / -a;
    else for (let u = 0; u < c; ++u) l[u] = (i - u) * a;
  else if (a < 0) for (let u = 0; u < c; ++u) l[u] = (o + u) / -a;
  else for (let u = 0; u < c; ++u) l[u] = (o + u) * a;
  return l;
}
function wC(e, t, n) {
  return t = +t, e = +e, n = +n, $0(e, t, n)[2];
}
function $C(e, t, n) {
  t = +t, e = +e, n = +n;
  const r = t < e, o = r ? wC(t, e, n) : wC(e, t, n);
  return (r ? -1 : 1) * (o < 0 ? 1 / -o : o);
}
function E3e(e, t, n) {
  e = +e, t = +t, n = (o = arguments.length) < 2 ? (t = e, e = 0, 1) : o < 3 ? 1 : +n;
  for (var r = -1, o = Math.max(0, Math.ceil((t - e) / n)) | 0, i = new Array(o); ++r < o; )
    i[r] = e + r * n;
  return i;
}
function Xs(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
function _3e(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
  }
  return this;
}
const JD = Symbol("implicit");
function O0() {
  var e = new XD(), t = [], n = [], r = JD;
  function o(i) {
    let a = e.get(i);
    if (a === void 0) {
      if (r !== JD) return r;
      e.set(i, a = t.push(i) - 1);
    }
    return n[a % n.length];
  }
  return o.domain = function(i) {
    if (!arguments.length) return t.slice();
    t = [], e = new XD();
    for (const a of i)
      e.has(a) || e.set(a, t.push(a) - 1);
    return o;
  }, o.range = function(i) {
    return arguments.length ? (n = Array.from(i), o) : n.slice();
  }, o.unknown = function(i) {
    return arguments.length ? (r = i, o) : r;
  }, o.copy = function() {
    return O0(t, n).unknown(r);
  }, Xs.apply(o, arguments), o;
}
function s3() {
  var e = O0().unknown(void 0), t = e.domain, n = e.range, r = 0, o = 1, i, a, c = !1, l = 0, u = 0, d = 0.5;
  delete e.unknown;
  function f() {
    var h = t().length, v = o < r, y = v ? o : r, g = v ? r : o;
    i = (g - y) / Math.max(1, h - l + u * 2), c && (i = Math.floor(i)), y += (g - y - i * (h - l)) * d, a = i * (1 - l), c && (y = Math.round(y), a = Math.round(a));
    var b = E3e(h).map(function(x) {
      return y + i * x;
    });
    return n(v ? b.reverse() : b);
  }
  return e.domain = function(h) {
    return arguments.length ? (t(h), f()) : t();
  }, e.range = function(h) {
    return arguments.length ? ([r, o] = h, r = +r, o = +o, f()) : [r, o];
  }, e.rangeRound = function(h) {
    return [r, o] = h, r = +r, o = +o, c = !0, f();
  }, e.bandwidth = function() {
    return a;
  }, e.step = function() {
    return i;
  }, e.round = function(h) {
    return arguments.length ? (c = !!h, f()) : c;
  }, e.padding = function(h) {
    return arguments.length ? (l = Math.min(1, u = +h), f()) : l;
  }, e.paddingInner = function(h) {
    return arguments.length ? (l = Math.min(1, h), f()) : l;
  }, e.paddingOuter = function(h) {
    return arguments.length ? (u = +h, f()) : u;
  }, e.align = function(h) {
    return arguments.length ? (d = Math.max(0, Math.min(1, h)), f()) : d;
  }, e.copy = function() {
    return s3(t(), [r, o]).round(c).paddingInner(l).paddingOuter(u).align(d);
  }, Xs.apply(f(), arguments);
}
function $U(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return $U(t());
  }, e;
}
function k3e() {
  return $U(s3.apply(null, arguments).paddingInner(1));
}
function c3(e, t, n) {
  e.prototype = t.prototype = n, n.constructor = e;
}
function OU(e, t) {
  var n = Object.create(e.prototype);
  for (var r in t) n[r] = t[r];
  return n;
}
function Up() {
}
var sp = 0.7, S0 = 1 / sp, yu = "\\s*([+-]?\\d+)\\s*", cp = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", ta = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", R3e = /^#([0-9a-f]{3,8})$/, P3e = new RegExp(`^rgb\\(${yu},${yu},${yu}\\)$`), A3e = new RegExp(`^rgb\\(${ta},${ta},${ta}\\)$`), I3e = new RegExp(`^rgba\\(${yu},${yu},${yu},${cp}\\)$`), M3e = new RegExp(`^rgba\\(${ta},${ta},${ta},${cp}\\)$`), N3e = new RegExp(`^hsl\\(${cp},${ta},${ta}\\)$`), D3e = new RegExp(`^hsla\\(${cp},${ta},${ta},${cp}\\)$`), QD = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
c3(Up, Hs, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: e6,
  // Deprecated! Use color.formatHex.
  formatHex: e6,
  formatHex8: L3e,
  formatHsl: j3e,
  formatRgb: t6,
  toString: t6
});
function e6() {
  return this.rgb().formatHex();
}
function L3e() {
  return this.rgb().formatHex8();
}
function j3e() {
  return SU(this).formatHsl();
}
function t6() {
  return this.rgb().formatRgb();
}
function Hs(e) {
  var t, n;
  return e = (e + "").trim().toLowerCase(), (t = R3e.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? n6(t) : n === 3 ? new Qr(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? Pm(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? Pm(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = P3e.exec(e)) ? new Qr(t[1], t[2], t[3], 1) : (t = A3e.exec(e)) ? new Qr(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = I3e.exec(e)) ? Pm(t[1], t[2], t[3], t[4]) : (t = M3e.exec(e)) ? Pm(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = N3e.exec(e)) ? i6(t[1], t[2] / 100, t[3] / 100, 1) : (t = D3e.exec(e)) ? i6(t[1], t[2] / 100, t[3] / 100, t[4]) : QD.hasOwnProperty(e) ? n6(QD[e]) : e === "transparent" ? new Qr(NaN, NaN, NaN, 0) : null;
}
function n6(e) {
  return new Qr(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function Pm(e, t, n, r) {
  return r <= 0 && (e = t = n = NaN), new Qr(e, t, n, r);
}
function F3e(e) {
  return e instanceof Up || (e = Hs(e)), e ? (e = e.rgb(), new Qr(e.r, e.g, e.b, e.opacity)) : new Qr();
}
function OC(e, t, n, r) {
  return arguments.length === 1 ? F3e(e) : new Qr(e, t, n, r ?? 1);
}
function Qr(e, t, n, r) {
  this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}
c3(Qr, OC, OU(Up, {
  brighter(e) {
    return e = e == null ? S0 : Math.pow(S0, e), new Qr(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? sp : Math.pow(sp, e), new Qr(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Qr(Bc(this.r), Bc(this.g), Bc(this.b), C0(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: r6,
  // Deprecated! Use color.formatHex.
  formatHex: r6,
  formatHex8: z3e,
  formatRgb: o6,
  toString: o6
}));
function r6() {
  return `#${Rc(this.r)}${Rc(this.g)}${Rc(this.b)}`;
}
function z3e() {
  return `#${Rc(this.r)}${Rc(this.g)}${Rc(this.b)}${Rc((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function o6() {
  const e = C0(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${Bc(this.r)}, ${Bc(this.g)}, ${Bc(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function C0(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function Bc(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function Rc(e) {
  return e = Bc(e), (e < 16 ? "0" : "") + e.toString(16);
}
function i6(e, t, n, r) {
  return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new hi(e, t, n, r);
}
function SU(e) {
  if (e instanceof hi) return new hi(e.h, e.s, e.l, e.opacity);
  if (e instanceof Up || (e = Hs(e)), !e) return new hi();
  if (e instanceof hi) return e;
  e = e.rgb();
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, o = Math.min(t, n, r), i = Math.max(t, n, r), a = NaN, c = i - o, l = (i + o) / 2;
  return c ? (t === i ? a = (n - r) / c + (n < r) * 6 : n === i ? a = (r - t) / c + 2 : a = (t - n) / c + 4, c /= l < 0.5 ? i + o : 2 - i - o, a *= 60) : c = l > 0 && l < 1 ? 0 : a, new hi(a, c, l, e.opacity);
}
function B3e(e, t, n, r) {
  return arguments.length === 1 ? SU(e) : new hi(e, t, n, r ?? 1);
}
function hi(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
c3(hi, B3e, OU(Up, {
  brighter(e) {
    return e = e == null ? S0 : Math.pow(S0, e), new hi(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? sp : Math.pow(sp, e), new hi(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * t, o = 2 * n - r;
    return new Qr(
      eO(e >= 240 ? e - 240 : e + 120, o, r),
      eO(e, o, r),
      eO(e < 120 ? e + 240 : e - 120, o, r),
      this.opacity
    );
  },
  clamp() {
    return new hi(a6(this.h), Am(this.s), Am(this.l), C0(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = C0(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${a6(this.h)}, ${Am(this.s) * 100}%, ${Am(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function a6(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function Am(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function eO(e, t, n) {
  return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
const l3 = (e) => () => e;
function q3e(e, t) {
  return function(n) {
    return e + n * t;
  };
}
function U3e(e, t, n) {
  return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function(r) {
    return Math.pow(e + r * t, n);
  };
}
function W3e(e) {
  return (e = +e) == 1 ? CU : function(t, n) {
    return n - t ? U3e(t, n, e) : l3(isNaN(t) ? n : t);
  };
}
function CU(e, t) {
  var n = t - e;
  return n ? q3e(e, n) : l3(isNaN(e) ? t : e);
}
const s6 = function e(t) {
  var n = W3e(t);
  function r(o, i) {
    var a = n((o = OC(o)).r, (i = OC(i)).r), c = n(o.g, i.g), l = n(o.b, i.b), u = CU(o.opacity, i.opacity);
    return function(d) {
      return o.r = a(d), o.g = c(d), o.b = l(d), o.opacity = u(d), o + "";
    };
  }
  return r.gamma = e, r;
}(1);
function H3e(e, t) {
  t || (t = []);
  var n = e ? Math.min(t.length, e.length) : 0, r = t.slice(), o;
  return function(i) {
    for (o = 0; o < n; ++o) r[o] = e[o] * (1 - i) + t[o] * i;
    return r;
  };
}
function V3e(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function Y3e(e, t) {
  var n = t ? t.length : 0, r = e ? Math.min(n, e.length) : 0, o = new Array(r), i = new Array(n), a;
  for (a = 0; a < r; ++a) o[a] = sy(e[a], t[a]);
  for (; a < n; ++a) i[a] = t[a];
  return function(c) {
    for (a = 0; a < r; ++a) i[a] = o[a](c);
    return i;
  };
}
function TU(e, t) {
  var n = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(r) {
    return n.setTime(e * (1 - r) + t * r), n;
  };
}
function lp(e, t) {
  return e = +e, t = +t, function(n) {
    return e * (1 - n) + t * n;
  };
}
function G3e(e, t) {
  var n = {}, r = {}, o;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (o in t)
    o in e ? n[o] = sy(e[o], t[o]) : r[o] = t[o];
  return function(i) {
    for (o in n) r[o] = n[o](i);
    return r;
  };
}
var SC = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, tO = new RegExp(SC.source, "g");
function K3e(e) {
  return function() {
    return e;
  };
}
function X3e(e) {
  return function(t) {
    return e(t) + "";
  };
}
function EU(e, t) {
  var n = SC.lastIndex = tO.lastIndex = 0, r, o, i, a = -1, c = [], l = [];
  for (e = e + "", t = t + ""; (r = SC.exec(e)) && (o = tO.exec(t)); )
    (i = o.index) > n && (i = t.slice(n, i), c[a] ? c[a] += i : c[++a] = i), (r = r[0]) === (o = o[0]) ? c[a] ? c[a] += o : c[++a] = o : (c[++a] = null, l.push({ i: a, x: lp(r, o) })), n = tO.lastIndex;
  return n < t.length && (i = t.slice(n), c[a] ? c[a] += i : c[++a] = i), c.length < 2 ? l[0] ? X3e(l[0].x) : K3e(t) : (t = l.length, function(u) {
    for (var d = 0, f; d < t; ++d) c[(f = l[d]).i] = f.x(u);
    return c.join("");
  });
}
function sy(e, t) {
  var n = typeof t, r;
  return t == null || n === "boolean" ? l3(t) : (n === "number" ? lp : n === "string" ? (r = Hs(t)) ? (t = r, s6) : EU : t instanceof Hs ? s6 : t instanceof Date ? TU : V3e(t) ? H3e : Array.isArray(t) ? Y3e : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? G3e : lp)(e, t);
}
function _U(e, t) {
  return e = +e, t = +t, function(n) {
    return Math.round(e * (1 - n) + t * n);
  };
}
function Z3e(e) {
  return function() {
    return e;
  };
}
function J3e(e) {
  return +e;
}
var c6 = [0, 1];
function Go(e) {
  return e;
}
function CC(e, t) {
  return (t -= e = +e) ? function(n) {
    return (n - e) / t;
  } : Z3e(isNaN(t) ? NaN : 0.5);
}
function Q3e(e, t) {
  var n;
  return e > t && (n = e, e = t, t = n), function(r) {
    return Math.max(e, Math.min(t, r));
  };
}
function e_e(e, t, n) {
  var r = e[0], o = e[1], i = t[0], a = t[1];
  return o < r ? (r = CC(o, r), i = n(a, i)) : (r = CC(r, o), i = n(i, a)), function(c) {
    return i(r(c));
  };
}
function t_e(e, t, n) {
  var r = Math.min(e.length, t.length) - 1, o = new Array(r), i = new Array(r), a = -1;
  for (e[r] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++a < r; )
    o[a] = CC(e[a], e[a + 1]), i[a] = n(t[a], t[a + 1]);
  return function(c) {
    var l = wU(e, c, 1, r) - 1;
    return i[l](o[l](c));
  };
}
function cy(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function u3() {
  var e = c6, t = c6, n = sy, r, o, i, a = Go, c, l, u;
  function d() {
    var h = Math.min(e.length, t.length);
    return a !== Go && (a = Q3e(e[0], e[h - 1])), c = h > 2 ? t_e : e_e, l = u = null, f;
  }
  function f(h) {
    return h == null || isNaN(h = +h) ? i : (l || (l = c(e.map(r), t, n)))(r(a(h)));
  }
  return f.invert = function(h) {
    return a(o((u || (u = c(t, e.map(r), lp)))(h)));
  }, f.domain = function(h) {
    return arguments.length ? (e = Array.from(h, J3e), d()) : e.slice();
  }, f.range = function(h) {
    return arguments.length ? (t = Array.from(h), d()) : t.slice();
  }, f.rangeRound = function(h) {
    return t = Array.from(h), n = _U, d();
  }, f.clamp = function(h) {
    return arguments.length ? (a = h ? !0 : Go, d()) : a !== Go;
  }, f.interpolate = function(h) {
    return arguments.length ? (n = h, d()) : n;
  }, f.unknown = function(h) {
    return arguments.length ? (i = h, f) : i;
  }, function(h, v) {
    return r = h, o = v, d();
  };
}
function kU() {
  return u3()(Go, Go);
}
function n_e(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function T0(e, t) {
  if ((n = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
  var n, r = e.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +e.slice(n + 1)
  ];
}
function Fu(e) {
  return e = T0(Math.abs(e)), e ? e[1] : NaN;
}
function r_e(e, t) {
  return function(n, r) {
    for (var o = n.length, i = [], a = 0, c = e[0], l = 0; o > 0 && c > 0 && (l + c + 1 > r && (c = Math.max(1, r - l)), i.push(n.substring(o -= c, o + c)), !((l += c + 1) > r)); )
      c = e[a = (a + 1) % e.length];
    return i.reverse().join(t);
  };
}
function o_e(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(n) {
      return e[+n];
    });
  };
}
var i_e = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function up(e) {
  if (!(t = i_e.exec(e))) throw new Error("invalid format: " + e);
  var t;
  return new d3({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
up.prototype = d3.prototype;
function d3(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
d3.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function a_e(e) {
  e: for (var t = e.length, n = 1, r = -1, o; n < t; ++n)
    switch (e[n]) {
      case ".":
        r = o = n;
        break;
      case "0":
        r === 0 && (r = n), o = n;
        break;
      default:
        if (!+e[n]) break e;
        r > 0 && (r = 0);
        break;
    }
  return r > 0 ? e.slice(0, r) + e.slice(o + 1) : e;
}
var RU;
function s_e(e, t) {
  var n = T0(e, t);
  if (!n) return e + "";
  var r = n[0], o = n[1], i = o - (RU = Math.max(-8, Math.min(8, Math.floor(o / 3))) * 3) + 1, a = r.length;
  return i === a ? r : i > a ? r + new Array(i - a + 1).join("0") : i > 0 ? r.slice(0, i) + "." + r.slice(i) : "0." + new Array(1 - i).join("0") + T0(e, Math.max(0, t + i - 1))[0];
}
function l6(e, t) {
  var n = T0(e, t);
  if (!n) return e + "";
  var r = n[0], o = n[1];
  return o < 0 ? "0." + new Array(-o).join("0") + r : r.length > o + 1 ? r.slice(0, o + 1) + "." + r.slice(o + 1) : r + new Array(o - r.length + 2).join("0");
}
const u6 = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: n_e,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => l6(e * 100, t),
  r: l6,
  s: s_e,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function d6(e) {
  return e;
}
var f6 = Array.prototype.map, p6 = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function c_e(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? d6 : r_e(f6.call(e.grouping, Number), e.thousands + ""), n = e.currency === void 0 ? "" : e.currency[0] + "", r = e.currency === void 0 ? "" : e.currency[1] + "", o = e.decimal === void 0 ? "." : e.decimal + "", i = e.numerals === void 0 ? d6 : o_e(f6.call(e.numerals, String)), a = e.percent === void 0 ? "%" : e.percent + "", c = e.minus === void 0 ? "−" : e.minus + "", l = e.nan === void 0 ? "NaN" : e.nan + "";
  function u(f) {
    f = up(f);
    var h = f.fill, v = f.align, y = f.sign, g = f.symbol, b = f.zero, x = f.width, $ = f.comma, S = f.precision, O = f.trim, C = f.type;
    C === "n" ? ($ = !0, C = "g") : u6[C] || (S === void 0 && (S = 12), O = !0, C = "g"), (b || h === "0" && v === "=") && (b = !0, h = "0", v = "=");
    var T = g === "$" ? n : g === "#" && /[boxX]/.test(C) ? "0" + C.toLowerCase() : "", k = g === "$" ? r : /[%p]/.test(C) ? a : "", I = u6[C], P = /[defgprs%]/.test(C);
    S = S === void 0 ? 6 : /[gprs]/.test(C) ? Math.max(1, Math.min(21, S)) : Math.max(0, Math.min(20, S));
    function _(A) {
      var D = T, M = k, N, L, z;
      if (C === "c")
        M = I(A) + M, A = "";
      else {
        A = +A;
        var q = A < 0 || 1 / A < 0;
        if (A = isNaN(A) ? l : I(Math.abs(A), S), O && (A = a_e(A)), q && +A == 0 && y !== "+" && (q = !1), D = (q ? y === "(" ? y : c : y === "-" || y === "(" ? "" : y) + D, M = (C === "s" ? p6[8 + RU / 3] : "") + M + (q && y === "(" ? ")" : ""), P) {
          for (N = -1, L = A.length; ++N < L; )
            if (z = A.charCodeAt(N), 48 > z || z > 57) {
              M = (z === 46 ? o + A.slice(N + 1) : A.slice(N)) + M, A = A.slice(0, N);
              break;
            }
        }
      }
      $ && !b && (A = t(A, 1 / 0));
      var W = D.length + A.length + M.length, U = W < x ? new Array(x - W + 1).join(h) : "";
      switch ($ && b && (A = t(U + A, U.length ? x - M.length : 1 / 0), U = ""), v) {
        case "<":
          A = D + A + M + U;
          break;
        case "=":
          A = D + U + A + M;
          break;
        case "^":
          A = U.slice(0, W = U.length >> 1) + D + A + M + U.slice(W);
          break;
        default:
          A = U + D + A + M;
          break;
      }
      return i(A);
    }
    return _.toString = function() {
      return f + "";
    }, _;
  }
  function d(f, h) {
    var v = u((f = up(f), f.type = "f", f)), y = Math.max(-8, Math.min(8, Math.floor(Fu(h) / 3))) * 3, g = Math.pow(10, -y), b = p6[8 + y / 3];
    return function(x) {
      return v(g * x) + b;
    };
  }
  return {
    format: u,
    formatPrefix: d
  };
}
var Im, f3, PU;
l_e({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function l_e(e) {
  return Im = c_e(e), f3 = Im.format, PU = Im.formatPrefix, Im;
}
function u_e(e) {
  return Math.max(0, -Fu(Math.abs(e)));
}
function d_e(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Fu(t) / 3))) * 3 - Fu(Math.abs(e)));
}
function f_e(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, Fu(t) - Fu(e)) + 1;
}
function p_e(e, t, n, r) {
  var o = $C(e, t, n), i;
  switch (r = up(r ?? ",f"), r.type) {
    case "s": {
      var a = Math.max(Math.abs(e), Math.abs(t));
      return r.precision == null && !isNaN(i = d_e(o, a)) && (r.precision = i), PU(r, a);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(i = f_e(o, Math.max(Math.abs(e), Math.abs(t)))) && (r.precision = i - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(i = u_e(o)) && (r.precision = i - (r.type === "%") * 2);
      break;
    }
  }
  return f3(r);
}
function p3(e) {
  var t = e.domain;
  return e.ticks = function(n) {
    var r = t();
    return xC(r[0], r[r.length - 1], n ?? 10);
  }, e.tickFormat = function(n, r) {
    var o = t();
    return p_e(o[0], o[o.length - 1], n ?? 10, r);
  }, e.nice = function(n) {
    n == null && (n = 10);
    var r = t(), o = 0, i = r.length - 1, a = r[o], c = r[i], l, u, d = 10;
    for (c < a && (u = a, a = c, c = u, u = o, o = i, i = u); d-- > 0; ) {
      if (u = wC(a, c, n), u === l)
        return r[o] = a, r[i] = c, t(r);
      if (u > 0)
        a = Math.floor(a / u) * u, c = Math.ceil(c / u) * u;
      else if (u < 0)
        a = Math.ceil(a * u) / u, c = Math.floor(c * u) / u;
      else
        break;
      l = u;
    }
    return e;
  }, e;
}
function AU() {
  var e = kU();
  return e.copy = function() {
    return cy(e, AU());
  }, Xs.apply(e, arguments), p3(e);
}
function IU(e, t) {
  e = e.slice();
  var n = 0, r = e.length - 1, o = e[n], i = e[r], a;
  return i < o && (a = n, n = r, r = a, a = o, o = i, i = a), e[n] = t.floor(o), e[r] = t.ceil(i), e;
}
function h6(e) {
  return Math.log(e);
}
function m6(e) {
  return Math.exp(e);
}
function h_e(e) {
  return -Math.log(-e);
}
function m_e(e) {
  return -Math.exp(-e);
}
function g_e(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function v_e(e) {
  return e === 10 ? g_e : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function y_e(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function g6(e) {
  return (t, n) => -e(-t, n);
}
function b_e(e) {
  const t = e(h6, m6), n = t.domain;
  let r = 10, o, i;
  function a() {
    return o = y_e(r), i = v_e(r), n()[0] < 0 ? (o = g6(o), i = g6(i), e(h_e, m_e)) : e(h6, m6), t;
  }
  return t.base = function(c) {
    return arguments.length ? (r = +c, a()) : r;
  }, t.domain = function(c) {
    return arguments.length ? (n(c), a()) : n();
  }, t.ticks = (c) => {
    const l = n();
    let u = l[0], d = l[l.length - 1];
    const f = d < u;
    f && ([u, d] = [d, u]);
    let h = o(u), v = o(d), y, g;
    const b = c == null ? 10 : +c;
    let x = [];
    if (!(r % 1) && v - h < b) {
      if (h = Math.floor(h), v = Math.ceil(v), u > 0) {
        for (; h <= v; ++h)
          for (y = 1; y < r; ++y)
            if (g = h < 0 ? y / i(-h) : y * i(h), !(g < u)) {
              if (g > d) break;
              x.push(g);
            }
      } else for (; h <= v; ++h)
        for (y = r - 1; y >= 1; --y)
          if (g = h > 0 ? y / i(-h) : y * i(h), !(g < u)) {
            if (g > d) break;
            x.push(g);
          }
      x.length * 2 < b && (x = xC(u, d, b));
    } else
      x = xC(h, v, Math.min(v - h, b)).map(i);
    return f ? x.reverse() : x;
  }, t.tickFormat = (c, l) => {
    if (c == null && (c = 10), l == null && (l = r === 10 ? "s" : ","), typeof l != "function" && (!(r % 1) && (l = up(l)).precision == null && (l.trim = !0), l = f3(l)), c === 1 / 0) return l;
    const u = Math.max(1, r * c / t.ticks().length);
    return (d) => {
      let f = d / i(Math.round(o(d)));
      return f * r < r - 0.5 && (f *= r), f <= u ? l(d) : "";
    };
  }, t.nice = () => n(IU(n(), {
    floor: (c) => i(Math.floor(o(c))),
    ceil: (c) => i(Math.ceil(o(c)))
  })), t;
}
function MU() {
  const e = b_e(u3()).domain([1, 10]);
  return e.copy = () => cy(e, MU()).base(e.base()), Xs.apply(e, arguments), e;
}
function v6(e) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
  };
}
function x_e(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function w_e(e) {
  return e < 0 ? -e * e : e * e;
}
function $_e(e) {
  var t = e(Go, Go), n = 1;
  function r() {
    return n === 1 ? e(Go, Go) : n === 0.5 ? e(x_e, w_e) : e(v6(n), v6(1 / n));
  }
  return t.exponent = function(o) {
    return arguments.length ? (n = +o, r()) : n;
  }, p3(t);
}
function h3() {
  var e = $_e(u3());
  return e.copy = function() {
    return cy(e, h3()).exponent(e.exponent());
  }, Xs.apply(e, arguments), e;
}
function O_e() {
  return h3.apply(null, arguments).exponent(0.5);
}
function NU() {
  var e = [0.5], t = [0, 1], n, r = 1;
  function o(i) {
    return i != null && i <= i ? t[wU(e, i, 0, r)] : n;
  }
  return o.domain = function(i) {
    return arguments.length ? (e = Array.from(i), r = Math.min(e.length, t.length - 1), o) : e.slice();
  }, o.range = function(i) {
    return arguments.length ? (t = Array.from(i), r = Math.min(e.length, t.length - 1), o) : t.slice();
  }, o.invertExtent = function(i) {
    var a = t.indexOf(i);
    return [e[a - 1], e[a]];
  }, o.unknown = function(i) {
    return arguments.length ? (n = i, o) : n;
  }, o.copy = function() {
    return NU().domain(e).range(t).unknown(n);
  }, Xs.apply(o, arguments);
}
const nO = /* @__PURE__ */ new Date(), rO = /* @__PURE__ */ new Date();
function Qn(e, t, n, r) {
  function o(i) {
    return e(i = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+i)), i;
  }
  return o.floor = (i) => (e(i = /* @__PURE__ */ new Date(+i)), i), o.ceil = (i) => (e(i = new Date(i - 1)), t(i, 1), e(i), i), o.round = (i) => {
    const a = o(i), c = o.ceil(i);
    return i - a < c - i ? a : c;
  }, o.offset = (i, a) => (t(i = /* @__PURE__ */ new Date(+i), a == null ? 1 : Math.floor(a)), i), o.range = (i, a, c) => {
    const l = [];
    if (i = o.ceil(i), c = c == null ? 1 : Math.floor(c), !(i < a) || !(c > 0)) return l;
    let u;
    do
      l.push(u = /* @__PURE__ */ new Date(+i)), t(i, c), e(i);
    while (u < i && i < a);
    return l;
  }, o.filter = (i) => Qn((a) => {
    if (a >= a) for (; e(a), !i(a); ) a.setTime(a - 1);
  }, (a, c) => {
    if (a >= a)
      if (c < 0) for (; ++c <= 0; )
        for (; t(a, -1), !i(a); )
          ;
      else for (; --c >= 0; )
        for (; t(a, 1), !i(a); )
          ;
  }), n && (o.count = (i, a) => (nO.setTime(+i), rO.setTime(+a), e(nO), e(rO), Math.floor(n(nO, rO))), o.every = (i) => (i = Math.floor(i), !isFinite(i) || !(i > 0) ? null : i > 1 ? o.filter(r ? (a) => r(a) % i === 0 : (a) => o.count(0, a) % i === 0) : o)), o;
}
const E0 = Qn(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
E0.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? Qn((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, n) => {
  t.setTime(+t + n * e);
}, (t, n) => (n - t) / e) : E0);
E0.range;
const Fa = 1e3, Ko = Fa * 60, za = Ko * 60, Wa = za * 24, m3 = Wa * 7, y6 = Wa * 30, oO = Wa * 365, Pc = Qn((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * Fa);
}, (e, t) => (t - e) / Fa, (e) => e.getUTCSeconds());
Pc.range;
const g3 = Qn((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Fa);
}, (e, t) => {
  e.setTime(+e + t * Ko);
}, (e, t) => (t - e) / Ko, (e) => e.getMinutes());
g3.range;
const v3 = Qn((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * Ko);
}, (e, t) => (t - e) / Ko, (e) => e.getUTCMinutes());
v3.range;
const y3 = Qn((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Fa - e.getMinutes() * Ko);
}, (e, t) => {
  e.setTime(+e + t * za);
}, (e, t) => (t - e) / za, (e) => e.getHours());
y3.range;
const b3 = Qn((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * za);
}, (e, t) => (t - e) / za, (e) => e.getUTCHours());
b3.range;
const Wp = Qn(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * Ko) / Wa,
  (e) => e.getDate() - 1
);
Wp.range;
const ly = Qn((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Wa, (e) => e.getUTCDate() - 1);
ly.range;
const DU = Qn((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / Wa, (e) => Math.floor(e / Wa));
DU.range;
function ll(e) {
  return Qn((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setDate(t.getDate() + n * 7);
  }, (t, n) => (n - t - (n.getTimezoneOffset() - t.getTimezoneOffset()) * Ko) / m3);
}
const uy = ll(0), _0 = ll(1), S_e = ll(2), C_e = ll(3), zu = ll(4), T_e = ll(5), E_e = ll(6);
uy.range;
_0.range;
S_e.range;
C_e.range;
zu.range;
T_e.range;
E_e.range;
function ul(e) {
  return Qn((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, n) => {
    t.setUTCDate(t.getUTCDate() + n * 7);
  }, (t, n) => (n - t) / m3);
}
const dy = ul(0), k0 = ul(1), __e = ul(2), k_e = ul(3), Bu = ul(4), R_e = ul(5), P_e = ul(6);
dy.range;
k0.range;
__e.range;
k_e.range;
Bu.range;
R_e.range;
P_e.range;
const x3 = Qn((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
x3.range;
const w3 = Qn((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
w3.range;
const Ha = Qn((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
Ha.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Qn((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, n) => {
  t.setFullYear(t.getFullYear() + n * e);
});
Ha.range;
const Va = Qn((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
Va.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Qn((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, n) => {
  t.setUTCFullYear(t.getUTCFullYear() + n * e);
});
Va.range;
function LU(e, t, n, r, o, i) {
  const a = [
    [Pc, 1, Fa],
    [Pc, 5, 5 * Fa],
    [Pc, 15, 15 * Fa],
    [Pc, 30, 30 * Fa],
    [i, 1, Ko],
    [i, 5, 5 * Ko],
    [i, 15, 15 * Ko],
    [i, 30, 30 * Ko],
    [o, 1, za],
    [o, 3, 3 * za],
    [o, 6, 6 * za],
    [o, 12, 12 * za],
    [r, 1, Wa],
    [r, 2, 2 * Wa],
    [n, 1, m3],
    [t, 1, y6],
    [t, 3, 3 * y6],
    [e, 1, oO]
  ];
  function c(u, d, f) {
    const h = d < u;
    h && ([u, d] = [d, u]);
    const v = f && typeof f.range == "function" ? f : l(u, d, f), y = v ? v.range(u, +d + 1) : [];
    return h ? y.reverse() : y;
  }
  function l(u, d, f) {
    const h = Math.abs(d - u) / f, v = a3(([, , b]) => b).right(a, h);
    if (v === a.length) return e.every($C(u / oO, d / oO, f));
    if (v === 0) return E0.every(Math.max($C(u, d, f), 1));
    const [y, g] = a[h / a[v - 1][2] < a[v][2] / h ? v - 1 : v];
    return y.every(g);
  }
  return [c, l];
}
const [A_e, I_e] = LU(Va, w3, dy, DU, b3, v3), [M_e, N_e] = LU(Ha, x3, uy, Wp, y3, g3);
function iO(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function aO(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function Kd(e, t, n) {
  return { y: e, m: t, d: n, H: 0, M: 0, S: 0, L: 0 };
}
function D_e(e) {
  var t = e.dateTime, n = e.date, r = e.time, o = e.periods, i = e.days, a = e.shortDays, c = e.months, l = e.shortMonths, u = Xd(o), d = Zd(o), f = Xd(i), h = Zd(i), v = Xd(a), y = Zd(a), g = Xd(c), b = Zd(c), x = Xd(l), $ = Zd(l), S = {
    a: q,
    A: W,
    b: U,
    B: K,
    c: null,
    d: S6,
    e: S6,
    f: ike,
    g: mke,
    G: vke,
    H: nke,
    I: rke,
    j: oke,
    L: jU,
    m: ake,
    M: ske,
    p: Y,
    q: X,
    Q: E6,
    s: _6,
    S: cke,
    u: lke,
    U: uke,
    V: dke,
    w: fke,
    W: pke,
    x: null,
    X: null,
    y: hke,
    Y: gke,
    Z: yke,
    "%": T6
  }, O = {
    a: oe,
    A: re,
    b: Z,
    B: ce,
    c: null,
    d: C6,
    e: C6,
    f: $ke,
    g: Ake,
    G: Mke,
    H: bke,
    I: xke,
    j: wke,
    L: zU,
    m: Oke,
    M: Ske,
    p: fe,
    q: de,
    Q: E6,
    s: _6,
    S: Cke,
    u: Tke,
    U: Eke,
    V: _ke,
    w: kke,
    W: Rke,
    x: null,
    X: null,
    y: Pke,
    Y: Ike,
    Z: Nke,
    "%": T6
  }, C = {
    a: _,
    A,
    b: D,
    B: M,
    c: N,
    d: $6,
    e: $6,
    f: J_e,
    g: w6,
    G: x6,
    H: O6,
    I: O6,
    j: G_e,
    L: Z_e,
    m: Y_e,
    M: K_e,
    p: P,
    q: V_e,
    Q: eke,
    s: tke,
    S: X_e,
    u: B_e,
    U: q_e,
    V: U_e,
    w: z_e,
    W: W_e,
    x: L,
    X: z,
    y: w6,
    Y: x6,
    Z: H_e,
    "%": Q_e
  };
  S.x = T(n, S), S.X = T(r, S), S.c = T(t, S), O.x = T(n, O), O.X = T(r, O), O.c = T(t, O);
  function T(ne, le) {
    return function(ve) {
      var G = [], Se = -1, ue = 0, Q = ne.length, ie, ee, be;
      for (ve instanceof Date || (ve = /* @__PURE__ */ new Date(+ve)); ++Se < Q; )
        ne.charCodeAt(Se) === 37 && (G.push(ne.slice(ue, Se)), (ee = b6[ie = ne.charAt(++Se)]) != null ? ie = ne.charAt(++Se) : ee = ie === "e" ? " " : "0", (be = le[ie]) && (ie = be(ve, ee)), G.push(ie), ue = Se + 1);
      return G.push(ne.slice(ue, Se)), G.join("");
    };
  }
  function k(ne, le) {
    return function(ve) {
      var G = Kd(1900, void 0, 1), Se = I(G, ne, ve += "", 0), ue, Q;
      if (Se != ve.length) return null;
      if ("Q" in G) return new Date(G.Q);
      if ("s" in G) return new Date(G.s * 1e3 + ("L" in G ? G.L : 0));
      if (le && !("Z" in G) && (G.Z = 0), "p" in G && (G.H = G.H % 12 + G.p * 12), G.m === void 0 && (G.m = "q" in G ? G.q : 0), "V" in G) {
        if (G.V < 1 || G.V > 53) return null;
        "w" in G || (G.w = 1), "Z" in G ? (ue = aO(Kd(G.y, 0, 1)), Q = ue.getUTCDay(), ue = Q > 4 || Q === 0 ? k0.ceil(ue) : k0(ue), ue = ly.offset(ue, (G.V - 1) * 7), G.y = ue.getUTCFullYear(), G.m = ue.getUTCMonth(), G.d = ue.getUTCDate() + (G.w + 6) % 7) : (ue = iO(Kd(G.y, 0, 1)), Q = ue.getDay(), ue = Q > 4 || Q === 0 ? _0.ceil(ue) : _0(ue), ue = Wp.offset(ue, (G.V - 1) * 7), G.y = ue.getFullYear(), G.m = ue.getMonth(), G.d = ue.getDate() + (G.w + 6) % 7);
      } else ("W" in G || "U" in G) && ("w" in G || (G.w = "u" in G ? G.u % 7 : "W" in G ? 1 : 0), Q = "Z" in G ? aO(Kd(G.y, 0, 1)).getUTCDay() : iO(Kd(G.y, 0, 1)).getDay(), G.m = 0, G.d = "W" in G ? (G.w + 6) % 7 + G.W * 7 - (Q + 5) % 7 : G.w + G.U * 7 - (Q + 6) % 7);
      return "Z" in G ? (G.H += G.Z / 100 | 0, G.M += G.Z % 100, aO(G)) : iO(G);
    };
  }
  function I(ne, le, ve, G) {
    for (var Se = 0, ue = le.length, Q = ve.length, ie, ee; Se < ue; ) {
      if (G >= Q) return -1;
      if (ie = le.charCodeAt(Se++), ie === 37) {
        if (ie = le.charAt(Se++), ee = C[ie in b6 ? le.charAt(Se++) : ie], !ee || (G = ee(ne, ve, G)) < 0) return -1;
      } else if (ie != ve.charCodeAt(G++))
        return -1;
    }
    return G;
  }
  function P(ne, le, ve) {
    var G = u.exec(le.slice(ve));
    return G ? (ne.p = d.get(G[0].toLowerCase()), ve + G[0].length) : -1;
  }
  function _(ne, le, ve) {
    var G = v.exec(le.slice(ve));
    return G ? (ne.w = y.get(G[0].toLowerCase()), ve + G[0].length) : -1;
  }
  function A(ne, le, ve) {
    var G = f.exec(le.slice(ve));
    return G ? (ne.w = h.get(G[0].toLowerCase()), ve + G[0].length) : -1;
  }
  function D(ne, le, ve) {
    var G = x.exec(le.slice(ve));
    return G ? (ne.m = $.get(G[0].toLowerCase()), ve + G[0].length) : -1;
  }
  function M(ne, le, ve) {
    var G = g.exec(le.slice(ve));
    return G ? (ne.m = b.get(G[0].toLowerCase()), ve + G[0].length) : -1;
  }
  function N(ne, le, ve) {
    return I(ne, t, le, ve);
  }
  function L(ne, le, ve) {
    return I(ne, n, le, ve);
  }
  function z(ne, le, ve) {
    return I(ne, r, le, ve);
  }
  function q(ne) {
    return a[ne.getDay()];
  }
  function W(ne) {
    return i[ne.getDay()];
  }
  function U(ne) {
    return l[ne.getMonth()];
  }
  function K(ne) {
    return c[ne.getMonth()];
  }
  function Y(ne) {
    return o[+(ne.getHours() >= 12)];
  }
  function X(ne) {
    return 1 + ~~(ne.getMonth() / 3);
  }
  function oe(ne) {
    return a[ne.getUTCDay()];
  }
  function re(ne) {
    return i[ne.getUTCDay()];
  }
  function Z(ne) {
    return l[ne.getUTCMonth()];
  }
  function ce(ne) {
    return c[ne.getUTCMonth()];
  }
  function fe(ne) {
    return o[+(ne.getUTCHours() >= 12)];
  }
  function de(ne) {
    return 1 + ~~(ne.getUTCMonth() / 3);
  }
  return {
    format: function(ne) {
      var le = T(ne += "", S);
      return le.toString = function() {
        return ne;
      }, le;
    },
    parse: function(ne) {
      var le = k(ne += "", !1);
      return le.toString = function() {
        return ne;
      }, le;
    },
    utcFormat: function(ne) {
      var le = T(ne += "", O);
      return le.toString = function() {
        return ne;
      }, le;
    },
    utcParse: function(ne) {
      var le = k(ne += "", !0);
      return le.toString = function() {
        return ne;
      }, le;
    }
  };
}
var b6 = { "-": "", _: " ", 0: "0" }, sr = /^\s*\d+/, L_e = /^%/, j_e = /[\\^$*+?|[\]().{}]/g;
function Ut(e, t, n) {
  var r = e < 0 ? "-" : "", o = (r ? -e : e) + "", i = o.length;
  return r + (i < n ? new Array(n - i + 1).join(t) + o : o);
}
function F_e(e) {
  return e.replace(j_e, "\\$&");
}
function Xd(e) {
  return new RegExp("^(?:" + e.map(F_e).join("|") + ")", "i");
}
function Zd(e) {
  return new Map(e.map((t, n) => [t.toLowerCase(), n]));
}
function z_e(e, t, n) {
  var r = sr.exec(t.slice(n, n + 1));
  return r ? (e.w = +r[0], n + r[0].length) : -1;
}
function B_e(e, t, n) {
  var r = sr.exec(t.slice(n, n + 1));
  return r ? (e.u = +r[0], n + r[0].length) : -1;
}
function q_e(e, t, n) {
  var r = sr.exec(t.slice(n, n + 2));
  return r ? (e.U = +r[0], n + r[0].length) : -1;
}
function U_e(e, t, n) {
  var r = sr.exec(t.slice(n, n + 2));
  return r ? (e.V = +r[0], n + r[0].length) : -1;
}
function W_e(e, t, n) {
  var r = sr.exec(t.slice(n, n + 2));
  return r ? (e.W = +r[0], n + r[0].length) : -1;
}
function x6(e, t, n) {
  var r = sr.exec(t.slice(n, n + 4));
  return r ? (e.y = +r[0], n + r[0].length) : -1;
}
function w6(e, t, n) {
  var r = sr.exec(t.slice(n, n + 2));
  return r ? (e.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function H_e(e, t, n) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(n, n + 6));
  return r ? (e.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function V_e(e, t, n) {
  var r = sr.exec(t.slice(n, n + 1));
  return r ? (e.q = r[0] * 3 - 3, n + r[0].length) : -1;
}
function Y_e(e, t, n) {
  var r = sr.exec(t.slice(n, n + 2));
  return r ? (e.m = r[0] - 1, n + r[0].length) : -1;
}
function $6(e, t, n) {
  var r = sr.exec(t.slice(n, n + 2));
  return r ? (e.d = +r[0], n + r[0].length) : -1;
}
function G_e(e, t, n) {
  var r = sr.exec(t.slice(n, n + 3));
  return r ? (e.m = 0, e.d = +r[0], n + r[0].length) : -1;
}
function O6(e, t, n) {
  var r = sr.exec(t.slice(n, n + 2));
  return r ? (e.H = +r[0], n + r[0].length) : -1;
}
function K_e(e, t, n) {
  var r = sr.exec(t.slice(n, n + 2));
  return r ? (e.M = +r[0], n + r[0].length) : -1;
}
function X_e(e, t, n) {
  var r = sr.exec(t.slice(n, n + 2));
  return r ? (e.S = +r[0], n + r[0].length) : -1;
}
function Z_e(e, t, n) {
  var r = sr.exec(t.slice(n, n + 3));
  return r ? (e.L = +r[0], n + r[0].length) : -1;
}
function J_e(e, t, n) {
  var r = sr.exec(t.slice(n, n + 6));
  return r ? (e.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function Q_e(e, t, n) {
  var r = L_e.exec(t.slice(n, n + 1));
  return r ? n + r[0].length : -1;
}
function eke(e, t, n) {
  var r = sr.exec(t.slice(n));
  return r ? (e.Q = +r[0], n + r[0].length) : -1;
}
function tke(e, t, n) {
  var r = sr.exec(t.slice(n));
  return r ? (e.s = +r[0], n + r[0].length) : -1;
}
function S6(e, t) {
  return Ut(e.getDate(), t, 2);
}
function nke(e, t) {
  return Ut(e.getHours(), t, 2);
}
function rke(e, t) {
  return Ut(e.getHours() % 12 || 12, t, 2);
}
function oke(e, t) {
  return Ut(1 + Wp.count(Ha(e), e), t, 3);
}
function jU(e, t) {
  return Ut(e.getMilliseconds(), t, 3);
}
function ike(e, t) {
  return jU(e, t) + "000";
}
function ake(e, t) {
  return Ut(e.getMonth() + 1, t, 2);
}
function ske(e, t) {
  return Ut(e.getMinutes(), t, 2);
}
function cke(e, t) {
  return Ut(e.getSeconds(), t, 2);
}
function lke(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function uke(e, t) {
  return Ut(uy.count(Ha(e) - 1, e), t, 2);
}
function FU(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? zu(e) : zu.ceil(e);
}
function dke(e, t) {
  return e = FU(e), Ut(zu.count(Ha(e), e) + (Ha(e).getDay() === 4), t, 2);
}
function fke(e) {
  return e.getDay();
}
function pke(e, t) {
  return Ut(_0.count(Ha(e) - 1, e), t, 2);
}
function hke(e, t) {
  return Ut(e.getFullYear() % 100, t, 2);
}
function mke(e, t) {
  return e = FU(e), Ut(e.getFullYear() % 100, t, 2);
}
function gke(e, t) {
  return Ut(e.getFullYear() % 1e4, t, 4);
}
function vke(e, t) {
  var n = e.getDay();
  return e = n >= 4 || n === 0 ? zu(e) : zu.ceil(e), Ut(e.getFullYear() % 1e4, t, 4);
}
function yke(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + Ut(t / 60 | 0, "0", 2) + Ut(t % 60, "0", 2);
}
function C6(e, t) {
  return Ut(e.getUTCDate(), t, 2);
}
function bke(e, t) {
  return Ut(e.getUTCHours(), t, 2);
}
function xke(e, t) {
  return Ut(e.getUTCHours() % 12 || 12, t, 2);
}
function wke(e, t) {
  return Ut(1 + ly.count(Va(e), e), t, 3);
}
function zU(e, t) {
  return Ut(e.getUTCMilliseconds(), t, 3);
}
function $ke(e, t) {
  return zU(e, t) + "000";
}
function Oke(e, t) {
  return Ut(e.getUTCMonth() + 1, t, 2);
}
function Ske(e, t) {
  return Ut(e.getUTCMinutes(), t, 2);
}
function Cke(e, t) {
  return Ut(e.getUTCSeconds(), t, 2);
}
function Tke(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function Eke(e, t) {
  return Ut(dy.count(Va(e) - 1, e), t, 2);
}
function BU(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? Bu(e) : Bu.ceil(e);
}
function _ke(e, t) {
  return e = BU(e), Ut(Bu.count(Va(e), e) + (Va(e).getUTCDay() === 4), t, 2);
}
function kke(e) {
  return e.getUTCDay();
}
function Rke(e, t) {
  return Ut(k0.count(Va(e) - 1, e), t, 2);
}
function Pke(e, t) {
  return Ut(e.getUTCFullYear() % 100, t, 2);
}
function Ake(e, t) {
  return e = BU(e), Ut(e.getUTCFullYear() % 100, t, 2);
}
function Ike(e, t) {
  return Ut(e.getUTCFullYear() % 1e4, t, 4);
}
function Mke(e, t) {
  var n = e.getUTCDay();
  return e = n >= 4 || n === 0 ? Bu(e) : Bu.ceil(e), Ut(e.getUTCFullYear() % 1e4, t, 4);
}
function Nke() {
  return "+0000";
}
function T6() {
  return "%";
}
function E6(e) {
  return +e;
}
function _6(e) {
  return Math.floor(+e / 1e3);
}
var Kl, qU, UU;
Dke({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function Dke(e) {
  return Kl = D_e(e), qU = Kl.format, Kl.parse, UU = Kl.utcFormat, Kl.utcParse, Kl;
}
function Lke(e) {
  return new Date(e);
}
function jke(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function $3(e, t, n, r, o, i, a, c, l, u) {
  var d = kU(), f = d.invert, h = d.domain, v = u(".%L"), y = u(":%S"), g = u("%I:%M"), b = u("%I %p"), x = u("%a %d"), $ = u("%b %d"), S = u("%B"), O = u("%Y");
  function C(T) {
    return (l(T) < T ? v : c(T) < T ? y : a(T) < T ? g : i(T) < T ? b : r(T) < T ? o(T) < T ? x : $ : n(T) < T ? S : O)(T);
  }
  return d.invert = function(T) {
    return new Date(f(T));
  }, d.domain = function(T) {
    return arguments.length ? h(Array.from(T, jke)) : h().map(Lke);
  }, d.ticks = function(T) {
    var k = h();
    return e(k[0], k[k.length - 1], T ?? 10);
  }, d.tickFormat = function(T, k) {
    return k == null ? C : u(k);
  }, d.nice = function(T) {
    var k = h();
    return (!T || typeof T.range != "function") && (T = t(k[0], k[k.length - 1], T ?? 10)), T ? h(IU(k, T)) : d;
  }, d.copy = function() {
    return cy(d, $3(e, t, n, r, o, i, a, c, l, u));
  }, d;
}
function WU() {
  return Xs.apply($3(M_e, N_e, Ha, x3, uy, Wp, y3, g3, Pc, qU).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function Fke() {
  return Xs.apply($3(A_e, I_e, Va, w3, dy, ly, b3, v3, Pc, UU).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function zke() {
  var e = 0, t = 1, n, r, o, i, a = Go, c = !1, l;
  function u(f) {
    return f == null || isNaN(f = +f) ? l : a(o === 0 ? 0.5 : (f = (i(f) - n) * o, c ? Math.max(0, Math.min(1, f)) : f));
  }
  u.domain = function(f) {
    return arguments.length ? ([e, t] = f, n = i(e = +e), r = i(t = +t), o = n === r ? 0 : 1 / (r - n), u) : [e, t];
  }, u.clamp = function(f) {
    return arguments.length ? (c = !!f, u) : c;
  }, u.interpolator = function(f) {
    return arguments.length ? (a = f, u) : a;
  };
  function d(f) {
    return function(h) {
      var v, y;
      return arguments.length ? ([v, y] = h, a = f(v, y), u) : [a(0), a(1)];
    };
  }
  return u.range = d(sy), u.rangeRound = d(_U), u.unknown = function(f) {
    return arguments.length ? (l = f, u) : l;
  }, function(f) {
    return i = f, n = f(e), r = f(t), o = n === r ? 0 : 1 / (r - n), u;
  };
}
function Bke(e, t) {
  return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function HU() {
  var e = p3(zke()(Go));
  return e.copy = function() {
    return Bke(e, HU());
  }, _3e.apply(e, arguments);
}
function qke(e) {
  return e.type === "piecewise" ? NU(e.thresholds, e.colors) : HU([e.min ?? 0, e.max ?? 100], e.color);
}
function R0(e) {
  return e.values ? O0(e.values, e.colors).unknown(e.unknownColor ?? null) : O0(e.colors.map((t, n) => n), e.colors).unknown(e.unknownColor ?? null);
}
function vg(e) {
  return e.type === "ordinal" ? R0(e) : qke(e);
}
const fy = /* @__PURE__ */ E.createContext({
  zAxis: {},
  zAxisIds: []
});
process.env.NODE_ENV !== "production" && (fy.displayName = "ZAxisContext");
function VU(e) {
  const {
    zAxis: t,
    dataset: n,
    children: r
  } = e, o = E.useMemo(() => t == null ? void 0 : t.map((a) => {
    const c = a.dataKey;
    if (c === void 0 || a.data !== void 0)
      return a;
    if (n === void 0)
      throw new Error("MUI X: z-axis uses `dataKey` but no `dataset` is provided.");
    return ge({}, a, {
      data: n.map((l) => l[c])
    });
  }), [t, n]), i = E.useMemo(() => {
    const a = (o == null ? void 0 : o.map((l, u) => ge({
      id: `defaultized-z-axis-${u}`
    }, l))) ?? [], c = {};
    return a.forEach((l) => {
      c[l.id] = ge({}, l, {
        colorScale: l.colorMap && (l.colorMap.type === "ordinal" && l.data ? R0(ge({
          values: l.data
        }, l.colorMap)) : vg(l.colorMap.type === "continuous" ? ge({
          min: l.min,
          max: l.max
        }, l.colorMap) : l.colorMap))
      });
    }), {
      zAxis: c,
      zAxisIds: a.map(({
        id: l
      }) => l)
    };
  }, [o]);
  return /* @__PURE__ */ F.jsx(fy.Provider, {
    value: i,
    children: r
  });
}
process.env.NODE_ENV !== "production" && (VU.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: s.node,
  /**
   * An array of objects that can be used to populate series and axes data using their `dataKey` property.
   */
  dataset: s.arrayOf(s.object),
  /**
   * The configuration of the z-axes.
   */
  zAxis: s.arrayOf(s.shape({
    colorMap: s.oneOfType([s.shape({
      colors: s.arrayOf(s.string).isRequired,
      type: s.oneOf(["ordinal"]).isRequired,
      unknownColor: s.string,
      values: s.arrayOf(s.oneOfType([s.instanceOf(Date), s.number, s.string]).isRequired)
    }), s.shape({
      color: s.oneOfType([s.arrayOf(s.string.isRequired), s.func]).isRequired,
      max: s.oneOfType([s.instanceOf(Date), s.number]),
      min: s.oneOfType([s.instanceOf(Date), s.number]),
      type: s.oneOf(["continuous"]).isRequired
    }), s.shape({
      colors: s.arrayOf(s.string).isRequired,
      thresholds: s.arrayOf(s.oneOfType([s.instanceOf(Date), s.number]).isRequired).isRequired,
      type: s.oneOf(["piecewise"]).isRequired
    })]),
    data: s.array,
    dataKey: s.string,
    id: s.string,
    max: s.number,
    min: s.number
  }))
});
let k6 = 0;
function Uke(e) {
  const [t, n] = E.useState(e), r = t;
  return E.useEffect(() => {
    t == null && (k6 += 1, n(`mui-${k6}`));
  }, [t]), r;
}
const Wke = {
  ...E
}, R6 = Wke.useId;
function YU(e) {
  return R6 !== void 0 ? R6() : Uke(e);
}
const Hke = (e, t, n) => {
  const r = ge({}, BTe, n);
  return E.useMemo(() => ({
    left: r.left,
    top: r.top,
    right: r.right,
    bottom: r.bottom,
    width: Math.max(0, e - r.left - r.right),
    height: Math.max(0, t - r.top - r.bottom)
  }), [e, t, r.top, r.bottom, r.left, r.right]);
}, ld = /* @__PURE__ */ E.createContext({
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  height: 300,
  width: 400,
  chartId: "",
  isPointInside: () => !1
});
process.env.NODE_ENV !== "production" && (ld.displayName = "DrawingContext");
const O3 = /* @__PURE__ */ E.createContext({
  isInitialized: !1,
  data: {
    current: null
  }
});
process.env.NODE_ENV !== "production" && (O3.displayName = "SvgContext");
function Vke(e) {
  const {
    width: t,
    height: n,
    margin: r,
    svgRef: o,
    children: i
  } = e, a = Hke(t, n, r), c = YU(), l = E.useCallback(({
    x: f,
    y: h
  }, v) => {
    if (v != null && v.targetElement && (v != null && v.targetElement.closest("[data-drawing-container]")))
      return !0;
    const y = f >= a.left - 1 && f <= a.left + a.width, g = h >= a.top - 1 && h <= a.top + a.height;
    return (v == null ? void 0 : v.direction) === "x" ? y : ((v == null ? void 0 : v.direction) === "y" || y) && g;
  }, [a]), u = E.useMemo(() => ge({
    chartId: c ?? ""
  }, a, {
    isPointInside: l
  }), [c, a, l]), d = E.useMemo(() => ({
    isInitialized: !0,
    data: o
  }), [o]);
  return /* @__PURE__ */ F.jsx(O3.Provider, {
    value: d,
    children: /* @__PURE__ */ F.jsx(ld.Provider, {
      value: u,
      children: i
    })
  });
}
function ro() {
  const {
    left: e,
    top: t,
    width: n,
    height: r,
    bottom: o,
    right: i,
    isPointInside: a
  } = E.useContext(ld);
  return E.useMemo(() => ({
    left: e,
    top: t,
    width: n,
    height: r,
    bottom: o,
    right: i,
    isPointInside: a
  }), [r, e, t, n, o, i, a]);
}
function GU() {
  const {
    chartId: e
  } = E.useContext(ld);
  return E.useMemo(() => e, [e]);
}
function Zc(e) {
  return e.bandwidth !== void 0;
}
function Yke(e) {
  return e.scaleType === "band";
}
function Gke(e) {
  return e.scaleType === "point";
}
function S3(e) {
  return typeof e == "number" && !Number.isFinite(e);
}
function Kke(e) {
  const {
    tickMaxStep: t,
    tickMinStep: n,
    tickNumber: r,
    range: o,
    domain: i
  } = e, a = n === void 0 ? 999 : Math.floor(Math.abs(i[1] - i[0]) / n), c = t === void 0 ? 2 : Math.ceil(Math.abs(i[1] - i[0]) / t), l = r ?? Math.floor(Math.abs(o[1] - o[0]) / 50);
  return Math.min(a, Math.max(c, l));
}
const sO = {
  start: 0,
  extremities: 0,
  end: 1,
  middle: 0.5
};
function py(e) {
  const {
    scale: t,
    tickNumber: n,
    valueFormatter: r,
    tickInterval: o,
    tickPlacement: i = "extremities",
    tickLabelPlacement: a = "middle"
  } = e;
  return E.useMemo(() => {
    if (Zc(t)) {
      const u = t.domain();
      return t.bandwidth() > 0 ? [...(typeof o == "function" && u.filter(o) || typeof o == "object" && o || u).map((h) => ({
        value: h,
        formattedValue: (r == null ? void 0 : r(h, {
          location: "tick"
        })) ?? `${h}`,
        offset: t(h) - (t.step() - t.bandwidth()) / 2 + sO[i] * t.step(),
        labelOffset: a === "tick" ? 0 : t.step() * (sO[a] - sO[i])
      })), ...i === "extremities" ? [{
        formattedValue: void 0,
        offset: t.range()[1],
        labelOffset: 0
      }] : []] : (typeof o == "function" && u.filter(o) || typeof o == "object" && o || u).map((f) => ({
        value: f,
        formattedValue: (r == null ? void 0 : r(f, {
          location: "tick"
        })) ?? `${f}`,
        offset: t(f),
        labelOffset: 0
      }));
    }
    return t.domain().some(S3) ? [] : (typeof o == "object" ? o : t.ticks(n)).map((u) => ({
      value: u,
      formattedValue: (r == null ? void 0 : r(u, {
        location: "tick"
      })) ?? t.tickFormat(n)(u),
      offset: t(u),
      labelOffset: 0
    }));
  }, [t, o, n, r, i, a]);
}
function Xke(e, t, n) {
  switch (e) {
    case "log":
      return MU(t, n);
    case "pow":
      return h3(t, n);
    case "sqrt":
      return O_e(t, n);
    case "time":
      return WU(t, n);
    case "utc":
      return Fke(t, n);
    default:
      return AU(t, n);
  }
}
const cO = (e, t) => {
  const n = e[1] - e[0], r = t[1] - t[0], o = e[0] - t[0] * n / r, i = e[1] + (100 - t[1]) * n / r;
  return [o, i];
}, Zke = (e, t, n, r, o, i, a) => {
  var v;
  const c = r[t], l = ((v = i[t]) == null ? void 0 : v.series) ?? {}, [u, d] = (c == null ? void 0 : c({
    series: l,
    axis: n,
    axisIndex: o,
    isDefaultAxis: o === 0,
    getFilters: a
  })) ?? [1 / 0, -1 / 0], [f, h] = e;
  return [Math.min(u, f), Math.max(d, h)];
}, Jke = (e, t, n, r, o) => {
  const a = Object.keys(t).reduce((c, l) => Zke(c, l, e, t, n, r, o), [1 / 0, -1 / 0]);
  return Number.isNaN(a[0]) || Number.isNaN(a[1]) ? [1 / 0, -1 / 0] : a;
};
function Qke(e, t, n) {
  if (t === "rotation") {
    const {
      startAngle: o = 0,
      endAngle: i = o + 360
    } = n;
    return n.reverse ? [Math.PI * o / 180, Math.PI * i / 180] : [Math.PI * i / 180, Math.PI * o / 180];
  }
  if (t === "radius") {
    const {
      minRadius: o = 0,
      maxRadius: i = Math.min(e.width, e.height) / 2
    } = n;
    return [o, i];
  }
  const r = t === "x" ? [e.left, e.left + e.width] : [e.top + e.height, e.top];
  return n.reverse ? [r[1], r[0]] : r;
}
const P6 = (e) => (e == null ? void 0 : e[0]) instanceof Date;
function A6(e, t) {
  const n = WU(e.data, t);
  return (r, {
    location: o
  }) => o === "tick" ? n.tickFormat(e.tickNumber)(r) : `${r.toLocaleString()}`;
}
const eRe = 0.2, tRe = 0.1;
function I6({
  drawingArea: e,
  formattedSeries: t,
  axis: n,
  extremumGetters: r,
  axisDirection: o,
  zoomData: i,
  zoomOptions: a,
  getFilters: c
}) {
  const l = {};
  return n.forEach((u, d) => {
    const f = u, h = a == null ? void 0 : a[f.id], v = i == null ? void 0 : i.find(({
      axisId: N
    }) => N === f.id), y = v ? [v.start, v.end] : [0, 100], g = Qke(e, o, f), [b, x] = Jke(
      f,
      r,
      d,
      t,
      v === void 0 && !h ? c : void 0
      // Do not apply filtering if zoom is already defined.
    ), $ = f.data ?? [];
    if (Yke(f)) {
      const N = f.categoryGapRatio ?? eRe, L = f.barGapRatio ?? tRe, z = o === "y" ? [g[1], g[0]] : g, q = cO(z, y);
      if (l[f.id] = ge({
        categoryGapRatio: N,
        barGapRatio: L
      }, f, {
        data: $,
        scale: s3(f.data, q).paddingInner(N).paddingOuter(N / 2),
        tickNumber: f.data.length,
        colorScale: f.colorMap && (f.colorMap.type === "ordinal" ? R0(ge({
          values: f.data
        }, f.colorMap)) : vg(f.colorMap))
      }), P6(f.data)) {
        const W = A6(f, z);
        l[f.id].valueFormatter = f.valueFormatter ?? W;
      }
    }
    if (Gke(f)) {
      const N = o === "y" ? [...g].reverse() : g, L = cO(N, y);
      if (l[f.id] = ge({}, f, {
        data: $,
        scale: k3e(f.data, L),
        tickNumber: f.data.length,
        colorScale: f.colorMap && (f.colorMap.type === "ordinal" ? R0(ge({
          values: f.data
        }, f.colorMap)) : vg(f.colorMap))
      }), P6(f.data)) {
        const z = A6(f, N);
        l[f.id].valueFormatter = f.valueFormatter ?? z;
      }
    }
    if (f.scaleType === "band" || f.scaleType === "point")
      return;
    const S = f.scaleType ?? "linear", O = f.domainLimit ?? "nice", C = [f.min ?? b, f.max ?? x];
    if (typeof O == "function") {
      const {
        min: N,
        max: L
      } = O(b, x);
      C[0] = N, C[1] = L;
    }
    const T = Kke(ge({}, f, {
      range: g,
      domain: C
    })), k = T / ((y[1] - y[0]) / 100), I = cO(g, y), P = Xke(S, C, I), _ = O === "nice" ? P.nice(T) : P, [A, D] = _.domain(), M = [f.min ?? A, f.max ?? D];
    l[f.id] = ge({}, f, {
      data: $,
      scaleType: S,
      scale: _.domain(M),
      tickNumber: k,
      colorScale: f.colorMap && vg(f.colorMap)
    });
  }), {
    axis: l,
    axisIds: n.map(({
      id: u
    }) => u)
  };
}
const C3 = /* @__PURE__ */ E.createContext({
  isInitialized: !1,
  data: {
    xAxis: {},
    yAxis: {},
    xAxisIds: [],
    yAxisIds: []
  }
});
process.env.NODE_ENV !== "production" && (C3.displayName = "CartesianContext");
function nRe(e) {
  const {
    xAxis: t,
    yAxis: n,
    children: r
  } = e, o = es(), i = ro(), a = d3e(), c = f3e(), l = E.useMemo(() => I6({
    drawingArea: i,
    formattedSeries: o,
    axis: t,
    extremumGetters: a,
    axisDirection: "x"
  }), [i, o, t, a]), u = E.useMemo(() => I6({
    drawingArea: i,
    formattedSeries: o,
    axis: n,
    extremumGetters: c,
    axisDirection: "y"
  }), [i, o, n, c]), d = E.useMemo(() => ({
    isInitialized: !0,
    data: {
      xAxis: l.axis,
      yAxis: u.axis,
      xAxisIds: l.axisIds,
      yAxisIds: u.axisIds
    }
  }), [l, u]);
  return /* @__PURE__ */ F.jsx(C3.Provider, {
    value: d,
    children: r
  });
}
const oo = () => {
  const {
    data: e
  } = E.useContext(C3);
  return e;
};
function qu(e) {
  return Zc(e) ? (t) => (e(t) ?? 0) + e.bandwidth() / 2 : (t) => e(t);
}
function T3() {
  const {
    isInitialized: e,
    data: t
  } = E.useContext(O3);
  if (!e)
    throw new Error(["MUI X: Could not find the svg ref context.", "It looks like you rendered your component outside of a ChartsContainer parent component."].join(`
`));
  return t;
}
function KU(e) {
  const {
    id: t,
    offset: n
  } = e, {
    left: r,
    top: o,
    width: i,
    height: a
  } = ro(), c = ge({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, n);
  return /* @__PURE__ */ F.jsx("clipPath", {
    id: t,
    children: /* @__PURE__ */ F.jsx("rect", {
      x: r - c.left,
      y: o - c.top,
      width: i + c.left + c.right,
      height: a + c.top + c.bottom
    })
  });
}
process.env.NODE_ENV !== "production" && (KU.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  id: s.string.isRequired,
  offset: s.shape({
    bottom: s.number,
    left: s.number,
    right: s.number,
    top: s.number
  })
});
function ri(e, t, n = void 0) {
  const r = {};
  for (const o in e) {
    const i = e[o];
    let a = "", c = !0;
    for (let l = 0; l < i.length; l += 1) {
      const u = i[l];
      u && (a += (c === !0 ? "" : " ") + t(u), c = !1, n && n[u] && (a += " " + n[u]));
    }
    r[o] = a;
  }
  return r;
}
const M6 = (e) => e, rRe = () => {
  let e = M6;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = M6;
    }
  };
}, oRe = rRe(), iRe = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function oi(e, t, n = "Mui") {
  const r = iRe[t];
  return r ? `${n}-${r}` : `${oRe.generate(e)}-${t}`;
}
function Ei(e, t, n = "Mui") {
  const r = {};
  return t.forEach((o) => {
    r[o] = oi(e, o, n);
  }), r;
}
function aRe() {
  return typeof window > "u";
}
const pc = {
  widthCache: {},
  cacheCount: 0
}, sRe = 2e3, cRe = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, lRe = ["minWidth", "maxWidth", "width", "minHeight", "maxHeight", "height", "top", "left", "fontSize", "padding", "margin", "paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom"], N6 = "mui_measurement_span";
function XU(e, t) {
  return lRe.indexOf(e) >= 0 && t === +t ? `${t}px` : t;
}
function ZU(e) {
  return e.split("").reduce((r, o) => o === o.toUpperCase() ? [...r, "-", o.toLowerCase()] : [...r, o], []).join("");
}
const uRe = (e) => Object.keys(e).sort().reduce((t, n) => `${t}${ZU(n)}:${XU(n, e[n])};`, "");
let lO;
const dRe = (e, t = {}) => {
  if (e == null || aRe())
    return {
      width: 0,
      height: 0
    };
  const n = `${e}`, r = uRe(t), o = `${n}-${r}`;
  if (pc.widthCache[o])
    return pc.widthCache[o];
  try {
    let i = document.getElementById(N6);
    i === null && (i = document.createElement("span"), i.setAttribute("id", N6), i.setAttribute("aria-hidden", "true"), document.body.appendChild(i));
    const a = ge({}, cRe, t);
    Object.keys(a).map((u) => (i.style[ZU(u)] = XU(u, a[u]), u)), i.textContent = n;
    const c = i.getBoundingClientRect(), l = {
      width: c.width,
      height: c.height
    };
    return pc.widthCache[o] = l, pc.cacheCount + 1 > sRe ? (pc.cacheCount = 0, pc.widthCache = {}) : pc.cacheCount += 1, lO && clearTimeout(lO), lO = setTimeout(() => {
      i.textContent = "";
    }, 0), l;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
};
function E3({
  style: e,
  needsComputation: t,
  text: n
}) {
  return n.split(`
`).map((r) => ge({
    text: r
  }, t ? dRe(r, e) : {
    width: 0,
    height: 0
  }));
}
const fRe = ["x", "y", "style", "text", "ownerState"], pRe = ["angle", "textAnchor", "dominantBaseline"];
function Uu(e) {
  const {
    x: t,
    y: n,
    style: r,
    text: o
  } = e, i = Bt(e, fRe), a = r ?? {}, {
    angle: c,
    textAnchor: l,
    dominantBaseline: u
  } = a, d = Bt(a, pRe), f = E.useMemo(() => E3({
    style: d,
    needsComputation: o.includes(`
`),
    text: o
  }), [d, o]);
  let h;
  switch (u) {
    case "hanging":
      h = 0;
      break;
    case "central":
      h = (f.length - 1) / 2 * -f[0].height;
      break;
    default:
      h = (f.length - 1) * -f[0].height;
      break;
  }
  const v = [];
  return c && v.push(`rotate(${c}, ${t}, ${n})`), /* @__PURE__ */ F.jsx("text", ge({}, i, {
    transform: v.length > 0 ? v.join(" ") : void 0,
    x: t,
    y: n,
    textAnchor: l,
    dominantBaseline: u,
    style: d,
    children: f.map((y, g) => /* @__PURE__ */ F.jsx("tspan", {
      x: t,
      dy: `${g === 0 ? h : f[0].height}px`,
      dominantBaseline: u,
      children: y.text
    }, g))
  }));
}
process.env.NODE_ENV !== "production" && (Uu.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Height of a text line (in `em`).
   */
  lineHeight: s.number,
  /**
   * If `true`, the line width is computed.
   * @default false
   */
  needsComputation: s.bool,
  ownerState: s.any,
  /**
   * Style applied to text elements.
   */
  style: s.object,
  /**
   * Text displayed.
   */
  text: s.string.isRequired
});
function hRe(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
function JU(...e) {
  return E.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      hRe(n, t);
    });
  }, e);
}
function mRe(e) {
  return typeof e == "string";
}
function gRe(e, t, n) {
  return e === void 0 || mRe(e) ? t : {
    ...t,
    ownerState: {
      ...t.ownerState,
      ...n
    }
  };
}
function vRe(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((r) => r.match(/^on[A-Z]/) && typeof e[r] == "function" && !t.includes(r)).forEach((r) => {
    n[r] = e[r];
  }), n;
}
function D6(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function yRe(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: r,
    externalForwardedProps: o,
    className: i
  } = e;
  if (!t) {
    const v = Ge(n == null ? void 0 : n.className, i, o == null ? void 0 : o.className, r == null ? void 0 : r.className), y = {
      ...n == null ? void 0 : n.style,
      ...o == null ? void 0 : o.style,
      ...r == null ? void 0 : r.style
    }, g = {
      ...n,
      ...o,
      ...r
    };
    return v.length > 0 && (g.className = v), Object.keys(y).length > 0 && (g.style = y), {
      props: g,
      internalRef: void 0
    };
  }
  const a = vRe({
    ...o,
    ...r
  }), c = D6(r), l = D6(o), u = t(a), d = Ge(u == null ? void 0 : u.className, n == null ? void 0 : n.className, i, o == null ? void 0 : o.className, r == null ? void 0 : r.className), f = {
    ...u == null ? void 0 : u.style,
    ...n == null ? void 0 : n.style,
    ...o == null ? void 0 : o.style,
    ...r == null ? void 0 : r.style
  }, h = {
    ...u,
    ...n,
    ...l,
    ...c
  };
  return d.length > 0 && (h.className = d), Object.keys(f).length > 0 && (h.style = f), {
    props: h,
    internalRef: u.ref
  };
}
function bRe(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function bi(e) {
  var f;
  const {
    elementType: t,
    externalSlotProps: n,
    ownerState: r,
    skipResolvingSlotProps: o = !1,
    ...i
  } = e, a = o ? {} : bRe(n, r), {
    props: c,
    internalRef: l
  } = yRe({
    ...i,
    externalSlotProps: a
  }), u = JU(l, a == null ? void 0 : a.ref, (f = e.additionalProps) == null ? void 0 : f.ref);
  return gRe(t, {
    ...c,
    ref: u
  }, r);
}
function xRe(e) {
  return e && e.ownerDocument || document;
}
function wRe(e) {
  return xRe(e).defaultView || window;
}
const TC = typeof window < "u" ? E.useLayoutEffect : E.useEffect;
function QU(e) {
  return oi("MuiChartsAxis", e);
}
const Mm = Ei("MuiChartsAxis", ["root", "line", "tickContainer", "tick", "tickLabel", "label", "directionX", "directionY", "top", "bottom", "left", "right"]), eW = Pe("g", {
  name: "MuiChartsAxis",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  [`& .${Mm.tickLabel}`]: ge({}, e.typography.caption, {
    fill: (e.vars || e).palette.text.primary
  }),
  [`& .${Mm.label}`]: ge({}, e.typography.body1, {
    fill: (e.vars || e).palette.text.primary
  }),
  [`& .${Mm.line}`]: {
    stroke: (e.vars || e).palette.text.primary,
    shapeRendering: "crispEdges",
    strokeWidth: 1
  },
  [`& .${Mm.tick}`]: {
    stroke: (e.vars || e).palette.text.primary,
    shapeRendering: "crispEdges"
  }
})), L6 = 5;
function $Re(e, t, n = 0) {
  process.env.NODE_ENV !== "production" && n > 90 && n < -90 && Ev(["MUI X: It seems you applied an angle larger than 90° or smaller than -90° to an axis text.", "This could cause some text overlapping.", "If you encounter a use case where it's needed, please open an issue."]);
  const r = Math.min(Math.abs(n) % 180, Math.abs(Math.abs(n) % 180 - 180) % 180);
  if (r < L6)
    return e;
  if (r > 90 - L6)
    return t;
  const o = r * Math.PI / 180, i = Math.atan2(t, e);
  return o < i ? e / Math.cos(o) : t / Math.sin(o);
}
function ORe(e = !1) {
  const [t, n] = E.useState(!1);
  return TC(() => {
    e || n(!0);
  }, [e]), E.useEffect(() => {
    e && n(!0);
  }, [e]), t;
}
const SRe = ["scale", "tickNumber", "reverse"], CRe = (e) => {
  const {
    classes: t,
    position: n
  } = e;
  return ri({
    root: ["root", "directionX", n],
    line: ["line"],
    tickContainer: ["tickContainer"],
    tick: ["tick"],
    tickLabel: ["tickLabel"],
    label: ["label"]
  }, QU, t);
};
function TRe(e, {
  tickLabelStyle: t,
  tickLabelInterval: n,
  reverse: r,
  isMounted: o
}) {
  const i = e.map((u) => {
    if (!o || u.formattedValue === void 0)
      return ge({}, u, {
        width: 0,
        height: 0
      });
    const d = E3({
      style: t,
      needsComputation: !0,
      text: u.formattedValue
    });
    return ge({}, u, {
      width: Math.max(...d.map((f) => f.width)),
      height: Math.max(d.length * d[0].height)
    });
  });
  if (typeof n == "function")
    return i.map((u, d) => ge({}, u, {
      skipLabel: !n(u.value, d)
    }));
  let a = 0, c = 0;
  const l = r ? -1 : 1;
  return i.map((u, d) => {
    const {
      width: f,
      offset: h,
      labelOffset: v,
      height: y
    } = u, g = $Re(f, y, t == null ? void 0 : t.angle), b = h + v, x = 1.2;
    return a = b - l * (x * g) / 2, d > 0 && l * a < l * c ? ge({}, u, {
      skipLabel: !0
    }) : (c = b + l * (x * g) / 2, u);
  });
}
const ERe = Pe(eW, {
  name: "MuiChartsXAxis",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), _Re = {
  position: "bottom",
  disableLine: !1,
  disableTicks: !1,
  tickSize: 6
};
function EC(e) {
  const {
    xAxisIds: t,
    xAxis: n
  } = oo(), r = n[e.axisId ?? t[0]], {
    scale: o,
    tickNumber: i,
    reverse: a
  } = r, c = Bt(r, SRe), l = ORe(), u = Ga({
    props: ge({}, c, e),
    name: "MuiChartsXAxis"
  }), d = ge({}, _Re, u), {
    position: f,
    disableLine: h,
    disableTicks: v,
    tickLabelStyle: y,
    label: g,
    labelStyle: b,
    tickFontSize: x,
    labelFontSize: $,
    tickSize: S,
    valueFormatter: O,
    slots: C,
    slotProps: T,
    tickInterval: k,
    tickLabelInterval: I,
    tickPlacement: P,
    tickLabelPlacement: _,
    sx: A
  } = d, D = Fr(), M = CRe(ge({}, d, {
    theme: D
  })), {
    left: N,
    top: L,
    width: z,
    height: q,
    isPointInside: W
  } = ro(), U = v ? 4 : S, K = f === "bottom" ? 1 : -1, Y = (C == null ? void 0 : C.axisLine) ?? "line", X = (C == null ? void 0 : C.axisTick) ?? "line", oe = (C == null ? void 0 : C.axisTickLabel) ?? Uu, re = (C == null ? void 0 : C.axisLabel) ?? Uu, Z = bi({
    elementType: oe,
    externalSlotProps: T == null ? void 0 : T.axisTickLabel,
    additionalProps: {
      style: ge({
        textAnchor: "middle",
        dominantBaseline: f === "bottom" ? "hanging" : "auto",
        fontSize: x ?? 12
      }, y)
    },
    className: M.tickLabel,
    ownerState: {}
  }), ce = py({
    scale: o,
    tickNumber: i,
    valueFormatter: O,
    tickInterval: k,
    tickPlacement: P,
    tickLabelPlacement: _
  }), fe = TRe(ce, {
    tickLabelStyle: Z.style,
    tickLabelInterval: I,
    reverse: a,
    isMounted: l
  }), de = {
    x: N + z / 2,
    y: K * (U + 22)
  }, ne = bi({
    elementType: re,
    externalSlotProps: T == null ? void 0 : T.axisLabel,
    additionalProps: {
      style: ge({
        fontSize: $ ?? 14,
        textAnchor: "middle",
        dominantBaseline: f === "bottom" ? "hanging" : "auto"
      }, b)
    },
    ownerState: {}
  }), le = o.domain(), ve = Zc(o);
  return ve && le.length === 0 || !ve && le.some(S3) ? null : /* @__PURE__ */ F.jsxs(ERe, {
    transform: `translate(0, ${f === "bottom" ? L + q : L})`,
    className: M.root,
    sx: A,
    children: [!h && /* @__PURE__ */ F.jsx(Y, ge({
      x1: N,
      x2: N + z,
      className: M.line
    }, T == null ? void 0 : T.axisLine)), fe.map(({
      formattedValue: G,
      offset: Se,
      labelOffset: ue,
      skipLabel: Q
    }, ie) => {
      const ee = ue ?? 0, be = K * (U + 3), Ie = W({
        x: Se,
        y: -1
      }, {
        direction: "x"
      }), je = W({
        x: Se + ee,
        y: -1
      }, {
        direction: "x"
      });
      return /* @__PURE__ */ F.jsxs("g", {
        transform: `translate(${Se}, 0)`,
        className: M.tickContainer,
        children: [!v && Ie && /* @__PURE__ */ F.jsx(X, ge({
          y2: K * U,
          className: M.tick
        }, T == null ? void 0 : T.axisTick)), G !== void 0 && !Q && je && /* @__PURE__ */ F.jsx(oe, ge({
          x: ee,
          y: be
        }, Z, {
          text: G.toString()
        }))]
      }, ie);
    }), g && /* @__PURE__ */ F.jsx("g", {
      className: M.label,
      children: /* @__PURE__ */ F.jsx(re, ge({}, de, ne, {
        text: g
      }))
    })]
  });
}
process.env.NODE_ENV !== "production" && (EC.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The id of the axis to render.
   * If undefined, it will be the first defined axis.
   */
  axisId: s.oneOfType([s.number, s.string]),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * If true, the axis line is disabled.
   * @default false
   */
  disableLine: s.bool,
  /**
   * If true, the ticks are disabled.
   * @default false
   */
  disableTicks: s.bool,
  /**
   * The fill color of the axis text.
   * @default 'currentColor'
   */
  fill: s.string,
  /**
   * The label of the axis.
   */
  label: s.string,
  /**
   * The font size of the axis label.
   * @default 14
   * @deprecated Consider using `labelStyle.fontSize` instead.
   */
  labelFontSize: s.number,
  /**
   * The style applied to the axis label.
   */
  labelStyle: s.object,
  /**
   * Position of the axis.
   */
  position: s.oneOf(["bottom", "top"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: s.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: s.object,
  /**
   * The stroke color of the axis line.
   * @default 'currentColor'
   */
  stroke: s.string,
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The font size of the axis ticks text.
   * @default 12
   * @deprecated Consider using `tickLabelStyle.fontSize` instead.
   */
  tickFontSize: s.number,
  /**
   * Defines which ticks are displayed.
   * Its value can be:
   * - 'auto' In such case the ticks are computed based on axis scale and other parameters.
   * - a filtering function of the form `(value, index) => boolean` which is available only if the axis has "point" scale.
   * - an array containing the values where ticks should be displayed.
   * @see See {@link https://mui.com/x/react-charts/axis/#fixed-tick-positions}
   * @default 'auto'
   */
  tickInterval: s.oneOfType([s.oneOf(["auto"]), s.array, s.func]),
  /**
   * Defines which ticks get its label displayed. Its value can be:
   * - 'auto' In such case, labels are displayed if they do not overlap with the previous one.
   * - a filtering function of the form (value, index) => boolean. Warning: the index is tick index, not data ones.
   * @default 'auto'
   */
  tickLabelInterval: s.oneOfType([s.oneOf(["auto"]), s.func]),
  /**
   * The placement of ticks label. Can be the middle of the band, or the tick position.
   * Only used if scale is 'band'.
   * @default 'middle'
   */
  tickLabelPlacement: s.oneOf(["middle", "tick"]),
  /**
   * The style applied to ticks text.
   */
  tickLabelStyle: s.object,
  /**
   * Maximal step between two ticks.
   * When using time data, the value is assumed to be in ms.
   * Not supported by categorical axis (band, points).
   */
  tickMaxStep: s.number,
  /**
   * Minimal step between two ticks.
   * When using time data, the value is assumed to be in ms.
   * Not supported by categorical axis (band, points).
   */
  tickMinStep: s.number,
  /**
   * The number of ticks. This number is not guaranteed.
   * Not supported by categorical axis (band, points).
   */
  tickNumber: s.number,
  /**
   * The placement of ticks in regard to the band interval.
   * Only used if scale is 'band'.
   * @default 'extremities'
   */
  tickPlacement: s.oneOf(["end", "extremities", "middle", "start"]),
  /**
   * The size of the ticks.
   * @default 6
   */
  tickSize: s.number
});
const kRe = ["scale", "tickNumber"], RRe = (e) => {
  const {
    classes: t,
    position: n
  } = e;
  return ri({
    root: ["root", "directionY", n],
    line: ["line"],
    tickContainer: ["tickContainer"],
    tick: ["tick"],
    tickLabel: ["tickLabel"],
    label: ["label"]
  }, QU, t);
}, PRe = Pe(eW, {
  name: "MuiChartsYAxis",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), ARe = {
  position: "left",
  disableLine: !1,
  disableTicks: !1,
  tickFontSize: 12,
  labelFontSize: 14,
  tickSize: 6
};
function _C(e) {
  const {
    yAxisIds: t,
    yAxis: n
  } = oo(), r = n[e.axisId ?? t[0]], {
    scale: o,
    tickNumber: i
  } = r, a = Bt(r, kRe), c = Ga({
    props: ge({}, a, e),
    name: "MuiChartsYAxis"
  }), l = ge({}, ARe, c), {
    position: u,
    disableLine: d,
    disableTicks: f,
    tickFontSize: h,
    label: v,
    labelFontSize: y,
    labelStyle: g,
    tickLabelStyle: b,
    tickSize: x,
    valueFormatter: $,
    slots: S,
    slotProps: O,
    tickPlacement: C,
    tickLabelPlacement: T,
    tickInterval: k,
    tickLabelInterval: I,
    sx: P
  } = l, _ = Fr(), A = Ya(), D = RRe(ge({}, l, {
    theme: _
  })), {
    left: M,
    top: N,
    width: L,
    height: z,
    isPointInside: q
  } = ro(), W = f ? 4 : x, U = py({
    scale: o,
    tickNumber: i,
    valueFormatter: $,
    tickPlacement: C,
    tickLabelPlacement: T,
    tickInterval: k
  }), K = u === "right" ? 1 : -1, Y = {
    x: K * (h + W + 10),
    y: N + z / 2
  }, X = (S == null ? void 0 : S.axisLine) ?? "line", oe = (S == null ? void 0 : S.axisTick) ?? "line", re = (S == null ? void 0 : S.axisTickLabel) ?? Uu, Z = (S == null ? void 0 : S.axisLabel) ?? Uu, ce = !A && u === "right" || A && u !== "right", fe = bi({
    elementType: re,
    externalSlotProps: O == null ? void 0 : O.axisTickLabel,
    additionalProps: {
      style: ge({
        fontSize: h,
        textAnchor: ce ? "start" : "end",
        dominantBaseline: "central"
      }, b)
    },
    className: D.tickLabel,
    ownerState: {}
  }), de = bi({
    elementType: Z,
    externalSlotProps: O == null ? void 0 : O.axisLabel,
    additionalProps: {
      style: ge({
        fontSize: y,
        angle: K * 90,
        textAnchor: "middle",
        dominantBaseline: "auto"
      }, g)
    },
    ownerState: {}
  }), ne = bi({
    elementType: X,
    externalSlotProps: O == null ? void 0 : O.axisLine,
    additionalProps: {
      strokeLinecap: "square"
    },
    ownerState: {}
  }), le = o.domain(), ve = Zc(o);
  return ve && le.length === 0 || !ve && le.some(S3) ? null : /* @__PURE__ */ F.jsxs(PRe, {
    transform: `translate(${u === "right" ? M + L : M}, 0)`,
    className: D.root,
    sx: P,
    children: [!d && /* @__PURE__ */ F.jsx(X, ge({
      y1: N,
      y2: N + z,
      className: D.line
    }, ne)), U.map(({
      formattedValue: G,
      offset: Se,
      labelOffset: ue,
      value: Q
    }, ie) => {
      const ee = K * (W + 2), be = ue, Ie = typeof I == "function" && !(I != null && I(Q, ie));
      return q({
        x: -1,
        y: Se
      }, {
        direction: "y"
      }) ? /* @__PURE__ */ F.jsxs("g", {
        transform: `translate(0, ${Se})`,
        className: D.tickContainer,
        children: [!f && /* @__PURE__ */ F.jsx(oe, ge({
          x2: K * W,
          className: D.tick
        }, O == null ? void 0 : O.axisTick)), G !== void 0 && !Ie && /* @__PURE__ */ F.jsx(re, ge({
          x: ee,
          y: be,
          text: G.toString()
        }, fe))]
      }, ie) : null;
    }), v && /* @__PURE__ */ F.jsx("g", {
      className: D.label,
      children: /* @__PURE__ */ F.jsx(Z, ge({}, Y, de, {
        text: v
      }))
    })]
  });
}
process.env.NODE_ENV !== "production" && (_C.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The id of the axis to render.
   * If undefined, it will be the first defined axis.
   */
  axisId: s.oneOfType([s.number, s.string]),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * If true, the axis line is disabled.
   * @default false
   */
  disableLine: s.bool,
  /**
   * If true, the ticks are disabled.
   * @default false
   */
  disableTicks: s.bool,
  /**
   * The fill color of the axis text.
   * @default 'currentColor'
   */
  fill: s.string,
  /**
   * The label of the axis.
   */
  label: s.string,
  /**
   * The font size of the axis label.
   * @default 14
   * @deprecated Consider using `labelStyle.fontSize` instead.
   */
  labelFontSize: s.number,
  /**
   * The style applied to the axis label.
   */
  labelStyle: s.object,
  /**
   * Position of the axis.
   */
  position: s.oneOf(["left", "right"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: s.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: s.object,
  /**
   * The stroke color of the axis line.
   * @default 'currentColor'
   */
  stroke: s.string,
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  /**
   * The font size of the axis ticks text.
   * @default 12
   * @deprecated Consider using `tickLabelStyle.fontSize` instead.
   */
  tickFontSize: s.number,
  /**
   * Defines which ticks are displayed.
   * Its value can be:
   * - 'auto' In such case the ticks are computed based on axis scale and other parameters.
   * - a filtering function of the form `(value, index) => boolean` which is available only if the axis has "point" scale.
   * - an array containing the values where ticks should be displayed.
   * @see See {@link https://mui.com/x/react-charts/axis/#fixed-tick-positions}
   * @default 'auto'
   */
  tickInterval: s.oneOfType([s.oneOf(["auto"]), s.array, s.func]),
  /**
   * Defines which ticks get its label displayed. Its value can be:
   * - 'auto' In such case, labels are displayed if they do not overlap with the previous one.
   * - a filtering function of the form (value, index) => boolean. Warning: the index is tick index, not data ones.
   * @default 'auto'
   */
  tickLabelInterval: s.oneOfType([s.oneOf(["auto"]), s.func]),
  /**
   * The placement of ticks label. Can be the middle of the band, or the tick position.
   * Only used if scale is 'band'.
   * @default 'middle'
   */
  tickLabelPlacement: s.oneOf(["middle", "tick"]),
  /**
   * The style applied to ticks text.
   */
  tickLabelStyle: s.object,
  /**
   * Maximal step between two ticks.
   * When using time data, the value is assumed to be in ms.
   * Not supported by categorical axis (band, points).
   */
  tickMaxStep: s.number,
  /**
   * Minimal step between two ticks.
   * When using time data, the value is assumed to be in ms.
   * Not supported by categorical axis (band, points).
   */
  tickMinStep: s.number,
  /**
   * The number of ticks. This number is not guaranteed.
   * Not supported by categorical axis (band, points).
   */
  tickNumber: s.number,
  /**
   * The placement of ticks in regard to the band interval.
   * Only used if scale is 'band'.
   * @default 'extremities'
   */
  tickPlacement: s.oneOf(["end", "extremities", "middle", "start"]),
  /**
   * The size of the ticks.
   * @default 6
   */
  tickSize: s.number
});
const Nm = (e, t) => e == null ? null : typeof e == "object" ? e.axisId ?? t ?? null : e, Dm = (e, t, n) => typeof e == "object" ? ge({}, e, {
  slots: ge({}, t, e == null ? void 0 : e.slots),
  slotProps: ge({}, n, e == null ? void 0 : e.slotProps)
}) : {
  slots: t,
  slotProps: n
};
function _3(e) {
  const {
    topAxis: t,
    leftAxis: n,
    rightAxis: r,
    bottomAxis: o,
    slots: i,
    slotProps: a
  } = e, {
    xAxis: c,
    xAxisIds: l,
    yAxis: u,
    yAxisIds: d
  } = oo(), f = Nm(n === void 0 ? d[0] : n, d[0]), h = Nm(o === void 0 ? l[0] : o, l[0]), v = Nm(t, l[0]), y = Nm(r, d[0]);
  if (v !== null && !c[v])
    throw new Error([`MUI X: id used for top axis "${v}" is not defined.`, `Available ids are: ${l.join(", ")}.`].join(`
`));
  if (f !== null && !u[f])
    throw new Error([`MUI X: id used for left axis "${f}" is not defined.`, `Available ids are: ${d.join(", ")}.`].join(`
`));
  if (y !== null && !u[y])
    throw new Error([`MUI X: id used for right axis "${y}" is not defined.`, `Available ids are: ${d.join(", ")}.`].join(`
`));
  if (h !== null && !c[h])
    throw new Error([`MUI X: id used for bottom axis "${h}" is not defined.`, `Available ids are: ${l.join(", ")}.`].join(`
`));
  const g = Dm(t, i, a), b = Dm(o, i, a), x = Dm(n, i, a), $ = Dm(r, i, a);
  return /* @__PURE__ */ F.jsxs(E.Fragment, {
    children: [v && /* @__PURE__ */ F.jsx(EC, ge({}, g, {
      position: "top",
      axisId: v
    })), h && /* @__PURE__ */ F.jsx(EC, ge({}, b, {
      position: "bottom",
      axisId: h
    })), f && /* @__PURE__ */ F.jsx(_C, ge({}, x, {
      position: "left",
      axisId: f
    })), y && /* @__PURE__ */ F.jsx(_C, ge({}, $, {
      position: "right",
      axisId: y
    }))]
  });
}
process.env.NODE_ENV !== "production" && (_3.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Indicate which axis to display the bottom of the charts.
   * Can be a string (the id of the axis) or an object `ChartsXAxisProps`.
   * @default xAxisIds[0] The id of the first provided axis
   */
  bottomAxis: s.oneOfType([s.object, s.string]),
  /**
   * Indicate which axis to display the left of the charts.
   * Can be a string (the id of the axis) or an object `ChartsYAxisProps`.
   * @default yAxisIds[0] The id of the first provided axis
   */
  leftAxis: s.oneOfType([s.object, s.string]),
  /**
   * Indicate which axis to display the right of the charts.
   * Can be a string (the id of the axis) or an object `ChartsYAxisProps`.
   * @default null
   */
  rightAxis: s.oneOfType([s.object, s.string]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: s.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: s.object,
  /**
   * Indicate which axis to display the top of the charts.
   * Can be a string (the id of the axis) or an object `ChartsXAxisProps`.
   * @default null
   */
  topAxis: s.oneOfType([s.object, s.string])
});
function IRe(e) {
  return oi("MuiChartsGrid", e);
}
const j6 = Ei("MuiChartsGrid", ["root", "line", "horizontalLine", "verticalLine"]), MRe = Pe("g", {
  name: "MuiChartsGrid",
  slot: "Root",
  overridesResolver: (e, t) => [{
    [`&.${j6.verticalLine}`]: t.verticalLine
  }, {
    [`&.${j6.horizontalLine}`]: t.horizontalLine
  }, t.root]
})({}), tW = Pe("line", {
  name: "MuiChartsGrid",
  slot: "Line",
  overridesResolver: (e, t) => t.line
})(({
  theme: e
}) => ({
  stroke: (e.vars || e).palette.divider,
  shapeRendering: "crispEdges",
  strokeWidth: 1
}));
function NRe(e) {
  const {
    axis: t,
    drawingArea: n,
    classes: r
  } = e, {
    scale: o,
    tickNumber: i,
    tickInterval: a
  } = t, c = py({
    scale: o,
    tickNumber: i,
    tickInterval: a
  });
  return /* @__PURE__ */ F.jsx(E.Fragment, {
    children: c.map(({
      value: l,
      offset: u
    }) => /* @__PURE__ */ F.jsx(tW, {
      y1: n.top,
      y2: n.top + n.height,
      x1: u,
      x2: u,
      className: r.verticalLine
    }, `vertical-${l}`))
  });
}
function DRe(e) {
  const {
    axis: t,
    drawingArea: n,
    classes: r
  } = e, {
    scale: o,
    tickNumber: i,
    tickInterval: a
  } = t, c = py({
    scale: o,
    tickNumber: i,
    tickInterval: a
  });
  return /* @__PURE__ */ F.jsx(E.Fragment, {
    children: c.map(({
      value: l,
      offset: u
    }) => /* @__PURE__ */ F.jsx(tW, {
      y1: u,
      y2: u,
      x1: n.left,
      x2: n.left + n.width,
      className: r.horizontalLine
    }, `horizontal-${l}`))
  });
}
const LRe = ["vertical", "horizontal"], jRe = ({
  classes: e
}) => ri({
  root: ["root"],
  verticalLine: ["line", "verticalLine"],
  horizontalLine: ["line", "horizontalLine"]
}, IRe, e);
function nW(e) {
  const t = Ga({
    props: e,
    name: "MuiChartsGrid"
  }), n = ro(), {
    vertical: r,
    horizontal: o
  } = t, i = Bt(t, LRe), {
    xAxis: a,
    xAxisIds: c,
    yAxis: l,
    yAxisIds: u
  } = oo(), d = jRe(t), f = l[u[0]], h = a[c[0]];
  return /* @__PURE__ */ F.jsxs(MRe, ge({}, i, {
    className: d.root,
    children: [r && /* @__PURE__ */ F.jsx(NRe, {
      axis: h,
      drawingArea: n,
      classes: d
    }), o && /* @__PURE__ */ F.jsx(DRe, {
      axis: f,
      drawingArea: n,
      classes: d
    })]
  }));
}
process.env.NODE_ENV !== "production" && (nW.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * Displays horizontal grid.
   */
  horizontal: s.bool,
  /**
   * Displays vertical grid.
   */
  vertical: s.bool
});
const ga = /* @__PURE__ */ E.createContext({
  item: null,
  axis: {
    x: null,
    y: null
  },
  useVoronoiInteraction: !1,
  dispatch: () => null
});
process.env.NODE_ENV !== "production" && (ga.displayName = "InteractionContext");
const FRe = (e, t) => {
  switch (t.type) {
    case "enterItem":
      return ge({}, e, {
        item: t.data
      });
    case "exitChart":
      return e.item === null && e.axis.x === null && e.axis.y === null ? e : ge({}, e, {
        axis: {
          x: null,
          y: null
        },
        item: null
      });
    case "updateVoronoiUsage":
      return ge({}, e, {
        useVoronoiInteraction: t.useVoronoiInteraction
      });
    case "leaveItem":
      return e.item === null || Object.keys(t.data).some((n) => t.data[n] !== e.item[n]) ? e : ge({}, e, {
        item: null
      });
    case "updateAxis":
      return t.data.x === e.axis.x && t.data.y === e.axis.y ? e : ge({}, e, {
        axis: t.data
      });
    default:
      return e;
  }
};
function zRe(e) {
  const {
    children: t
  } = e, [n, r] = E.useReducer(FRe, {
    item: null,
    axis: {
      x: null,
      y: null
    },
    useVoronoiInteraction: !1
  }), o = E.useMemo(() => ge({}, n, {
    dispatch: r
  }), [n]);
  return /* @__PURE__ */ F.jsx(ga.Provider, {
    value: o,
    children: t
  });
}
function BRe(e) {
  if (e === null)
    return {
      getBoundingClientRect: () => ({
        width: 0,
        height: 0,
        x: 0,
        y: 0,
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        toJSON: () => ""
      })
    };
  const {
    x: t,
    y: n
  } = e, r = {
    width: 0,
    height: 0,
    x: t,
    y: n,
    top: n,
    right: t,
    bottom: n,
    left: t
  };
  return {
    getBoundingClientRect: () => ge({}, r, {
      toJSON: () => JSON.stringify(r)
    })
  };
}
function qRe() {
  const e = T3(), [t, n] = E.useState(null);
  return E.useEffect(() => {
    const r = e.current;
    if (r === null)
      return () => {
      };
    const o = (a) => {
      a.pointerType !== "mouse" && n(null);
    }, i = (a) => {
      n({
        x: a.clientX,
        y: a.clientY,
        height: a.height,
        pointerType: a.pointerType
      });
    };
    return r.addEventListener("pointerdown", i), r.addEventListener("pointermove", i), r.addEventListener("pointerup", o), () => {
      r.removeEventListener("pointerdown", i), r.removeEventListener("pointermove", i), r.removeEventListener("pointerup", o);
    };
  }, [e]), t;
}
function URe(e, t) {
  if (e === "item")
    return t !== null;
  const n = t.x !== null, r = t.y !== null;
  return n || r;
}
function WRe(e) {
  return e instanceof Date ? e.toUTCString() : e.toLocaleString();
}
function HRe(e) {
  return oi("MuiChartsTooltip", e);
}
const F6 = Ei("MuiChartsTooltip", ["root", "paper", "table", "row", "cell", "mark", "markCell", "labelCell", "valueCell"]), rW = Pe("div", {
  name: "MuiChartsTooltip",
  slot: "Container",
  overridesResolver: (e, t) => t.paper
})(({
  theme: e
}) => ({
  boxShadow: e.shadows[1],
  backgroundColor: (e.vars || e).palette.background.paper,
  color: (e.vars || e).palette.text.primary,
  transition: e.transitions.create("box-shadow"),
  borderRadius: e.shape.borderRadius
})), oW = Pe("table", {
  name: "MuiChartsTooltip",
  slot: "Table",
  overridesResolver: (e, t) => t.table
})(({
  theme: e
}) => ({
  borderSpacing: 0,
  "& thead td": {
    borderBottom: `solid ${(e.vars || e).palette.divider} 1px`
  }
})), kC = Pe("tr", {
  name: "MuiChartsTooltip",
  slot: "Row",
  overridesResolver: (e, t) => t.row
})(({
  theme: e
}) => ({
  "tr:first-of-type& td": {
    paddingTop: e.spacing(1)
  },
  "tr:last-of-type& td": {
    paddingBottom: e.spacing(1)
  }
})), Ac = Pe("td", {
  name: "MuiChartsTooltip",
  slot: "Cell",
  overridesResolver: (e, t) => t.cell
})(({
  theme: e
}) => ({
  verticalAlign: "middle",
  color: (e.vars || e).palette.text.secondary,
  [`&.${F6.labelCell}`]: {
    paddingLeft: e.spacing(1)
  },
  [`&.${F6.valueCell}`]: {
    paddingLeft: e.spacing(4),
    color: (e.vars || e).palette.text.primary
  },
  "td:first-of-type&": {
    paddingLeft: e.spacing(2)
  },
  "td:last-of-type&": {
    paddingRight: e.spacing(2)
  }
})), iW = Pe("div", {
  name: "MuiChartsTooltip",
  slot: "Mark",
  overridesResolver: (e, t) => t.mark,
  shouldForwardProp: (e) => Km(e) && e !== "color"
})(({
  theme: e,
  color: t
}) => ({
  width: e.spacing(1),
  height: e.spacing(1),
  borderRadius: "50%",
  boxShadow: e.shadows[1],
  background: t,
  borderColor: (e.vars || e).palette.background.paper,
  border: `solid ${(e.vars || e).palette.background.paper} ${e.spacing(0.25)}`,
  boxSizing: "content-box"
}));
function aW(e) {
  var d;
  const {
    series: t,
    itemData: n,
    sx: r,
    classes: o,
    getColor: i
  } = e;
  if (n.dataIndex === void 0 || !t.data[n.dataIndex])
    return null;
  const {
    displayedLabel: a,
    color: c
  } = t.type === "pie" ? {
    color: i(n.dataIndex),
    displayedLabel: yi(t.data[n.dataIndex].label, "tooltip")
  } : {
    color: i(n.dataIndex),
    displayedLabel: yi(t.label, "tooltip")
  }, l = t.type === "pie" ? ge({}, t.data[n.dataIndex], {
    label: yi(t.data[n.dataIndex].label, "tooltip")
  }) : t.data[n.dataIndex], u = (d = t.valueFormatter) == null ? void 0 : d.call(t, l, {
    dataIndex: n.dataIndex
  });
  return /* @__PURE__ */ F.jsx(rW, {
    sx: r,
    className: o.paper,
    children: /* @__PURE__ */ F.jsx(oW, {
      className: o.table,
      children: /* @__PURE__ */ F.jsx("tbody", {
        children: /* @__PURE__ */ F.jsxs(kC, {
          className: o.row,
          children: [/* @__PURE__ */ F.jsx(Ac, {
            className: Ge(o.markCell, o.cell),
            children: /* @__PURE__ */ F.jsx(iW, {
              color: c,
              className: o.mark
            })
          }), /* @__PURE__ */ F.jsx(Ac, {
            className: Ge(o.labelCell, o.cell),
            children: a
          }), /* @__PURE__ */ F.jsx(Ac, {
            className: Ge(o.valueCell, o.cell),
            children: u
          })]
        })
      })
    })
  });
}
process.env.NODE_ENV !== "production" && (aW.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object.isRequired,
  /**
   * Get the color of the item with index `dataIndex`.
   * @param {number} dataIndex The data index of the item.
   * @returns {string} The color to display.
   */
  getColor: s.func.isRequired,
  /**
   * The data used to identify the triggered item.
   */
  itemData: s.shape({
    dataIndex: s.number,
    seriesId: s.oneOfType([s.number, s.string]).isRequired,
    type: s.oneOf(["bar", "line", "pie", "scatter"]).isRequired
  }).isRequired,
  /**
   * The series linked to the triggered axis.
   */
  series: s.object.isRequired,
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function VRe(e) {
  var O;
  const {
    content: t,
    itemData: n,
    sx: r,
    classes: o,
    contentProps: i
  } = e, a = es()[n.type].series[n.seriesId], {
    xAxis: c,
    yAxis: l,
    xAxisIds: u,
    yAxisIds: d
  } = oo(), {
    zAxis: f,
    zAxisIds: h
  } = E.useContext(fy), v = bU(), y = a.xAxisId ?? a.xAxisKey ?? u[0], g = a.yAxisId ?? a.yAxisKey ?? d[0], b = a.zAxisId ?? a.zAxisKey ?? h[0], x = ((O = v[a.type]) == null ? void 0 : O.call(v, a, y && c[y], g && l[g], b && f[b])) ?? (() => ""), $ = t ?? aW, S = bi({
    elementType: $,
    externalSlotProps: i,
    additionalProps: {
      itemData: n,
      series: a,
      sx: r,
      classes: o,
      getColor: x
    },
    ownerState: {}
  });
  return /* @__PURE__ */ F.jsx($, ge({}, S));
}
let z6;
class YRe {
  constructor() {
    if (this.types = /* @__PURE__ */ new Set(), z6)
      throw new Error("You can only create one instance!");
    z6 = this.types;
  }
  addType(t) {
    this.types.add(t);
  }
  getTypes() {
    return this.types;
  }
}
const hy = new YRe();
hy.addType("bar");
hy.addType("line");
hy.addType("scatter");
function sW(e) {
  return hy.getTypes().has(e);
}
function GRe(e) {
  return sW(e.type);
}
function cW(e) {
  const {
    series: t,
    axis: n,
    dataIndex: r,
    axisValue: o,
    sx: i,
    classes: a
  } = e;
  if (r == null)
    return null;
  const c = n.valueFormatter ?? ((l) => n.scaleType === "utc" ? WRe(l) : l.toLocaleString());
  return /* @__PURE__ */ F.jsx(rW, {
    sx: i,
    className: a.paper,
    children: /* @__PURE__ */ F.jsxs(oW, {
      className: a.table,
      children: [o != null && !n.hideTooltip && /* @__PURE__ */ F.jsx("thead", {
        children: /* @__PURE__ */ F.jsx(kC, {
          children: /* @__PURE__ */ F.jsx(Ac, {
            colSpan: 3,
            children: /* @__PURE__ */ F.jsx(Jm, {
              children: c(o, {
                location: "tooltip"
              })
            })
          })
        })
      }), /* @__PURE__ */ F.jsx("tbody", {
        children: t.filter(GRe).map(({
          id: l,
          label: u,
          valueFormatter: d,
          data: f,
          getColor: h
        }) => {
          const v = d(f[r] ?? null, {
            dataIndex: r
          });
          if (v == null)
            return null;
          const y = yi(u, "tooltip"), g = h(r);
          return /* @__PURE__ */ F.jsxs(kC, {
            className: a.row,
            children: [/* @__PURE__ */ F.jsx(Ac, {
              className: Ge(a.markCell, a.cell),
              children: g && /* @__PURE__ */ F.jsx(iW, {
                color: g,
                className: a.mark
              })
            }), /* @__PURE__ */ F.jsx(Ac, {
              className: Ge(a.labelCell, a.cell),
              children: y ? /* @__PURE__ */ F.jsx(Jm, {
                children: y
              }) : null
            }), /* @__PURE__ */ F.jsx(Ac, {
              className: Ge(a.valueCell, a.cell),
              children: /* @__PURE__ */ F.jsx(Jm, {
                children: v
              })
            })]
          }, l);
        })
      })]
    })
  });
}
process.env.NODE_ENV !== "production" && (cW.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The properties of the triggered axis.
   */
  axis: s.object.isRequired,
  /**
   * Data identifying the triggered axis.
   */
  axisData: s.shape({
    x: s.shape({
      index: s.number,
      value: s.oneOfType([s.instanceOf(Date), s.number, s.string]).isRequired
    }),
    y: s.shape({
      index: s.number,
      value: s.oneOfType([s.instanceOf(Date), s.number, s.string]).isRequired
    })
  }).isRequired,
  /**
   * The value associated to the current mouse position.
   */
  axisValue: s.oneOfType([s.instanceOf(Date), s.number, s.string]),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object.isRequired,
  /**
   * The index of the data item triggered.
   */
  dataIndex: s.number,
  /**
   * The series linked to the triggered axis.
   */
  series: s.arrayOf(s.object).isRequired,
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object])
});
function KRe(e) {
  const {
    content: t,
    contentProps: n,
    axisData: r,
    sx: o,
    classes: i
  } = e, a = r.x && r.x.index !== -1, c = a ? r.x && r.x.index : r.y && r.y.index, l = a ? r.x && r.x.value : r.y && r.y.value, {
    xAxisIds: u,
    xAxis: d,
    yAxisIds: f,
    yAxis: h
  } = oo(), {
    zAxisIds: v,
    zAxis: y
  } = E.useContext(fy), g = es(), b = bU(), x = a ? u[0] : f[0], $ = E.useMemo(() => {
    const T = [];
    return Object.keys(g).filter(sW).forEach((k) => {
      g[k].seriesOrder.forEach((I) => {
        var M;
        const P = g[k].series[I], _ = P.xAxisId ?? P.xAxisKey, A = P.yAxisId ?? P.yAxisKey, D = a ? _ : A;
        if (D === void 0 || D === x) {
          const N = g[k].series[I], L = _ ?? u[0], z = A ?? f[0], q = N.zAxisId ?? N.zAxisKey ?? v[0], W = ((M = b[k]) == null ? void 0 : M.call(b, N, d[L], h[z], q && y[q])) ?? (() => "");
          T.push(ge({}, N, {
            getColor: W
          }));
        }
      });
    }), T;
  }, [x, b, a, g, d, u, h, f, y, v]), S = E.useMemo(() => a ? d[x] : h[x], [x, a, d, h]), O = t ?? cW, C = bi({
    elementType: O,
    externalSlotProps: n,
    additionalProps: {
      axisData: r,
      series: $,
      axis: S,
      dataIndex: c,
      axisValue: l,
      sx: o,
      classes: i
    },
    ownerState: {}
  });
  return /* @__PURE__ */ F.jsx(O, ge({}, C));
}
const XRe = (e) => {
  const {
    classes: t
  } = e;
  return ri({
    root: ["root"],
    paper: ["paper"],
    table: ["table"],
    row: ["row"],
    cell: ["cell"],
    mark: ["mark"],
    markCell: ["markCell"],
    labelCell: ["labelCell"],
    valueCell: ["valueCell"]
  }, HRe, t);
}, ZRe = Pe(uv, {
  name: "MuiChartsTooltip",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  pointerEvents: "none",
  zIndex: e.zIndex.modal
}));
function k3(e) {
  const t = Ga({
    props: e,
    name: "MuiChartsTooltip"
  }), {
    trigger: n = "axis",
    itemContent: r,
    axisContent: o,
    slots: i,
    slotProps: a
  } = t, c = qRe(), {
    item: l,
    axis: u
  } = E.useContext(ga), d = n === "item" ? l : u, f = URe(n, d), h = c !== null && f, v = XRe({
    classes: t.classes
  }), y = (i == null ? void 0 : i.popper) ?? ZRe, g = bi({
    elementType: y,
    externalSlotProps: a == null ? void 0 : a.popper,
    additionalProps: {
      open: h,
      placement: (c == null ? void 0 : c.pointerType) === "mouse" ? "right-start" : "top",
      anchorEl: BRe(c),
      modifiers: [{
        name: "offset",
        options: {
          offset: [0, (c == null ? void 0 : c.pointerType) === "touch" ? 40 - c.height : 0]
        }
      }]
    },
    ownerState: {}
  });
  return n === "none" ? null : /* @__PURE__ */ F.jsx(Vf, {
    children: h && /* @__PURE__ */ F.jsx(y, ge({}, g, {
      className: v.root,
      children: n === "item" ? /* @__PURE__ */ F.jsx(VRe, {
        itemData: d,
        content: (i == null ? void 0 : i.itemContent) ?? r,
        contentProps: a == null ? void 0 : a.itemContent,
        sx: {
          mx: 2
        },
        classes: v
      }) : /* @__PURE__ */ F.jsx(KRe, {
        axisData: d,
        content: (i == null ? void 0 : i.axisContent) ?? o,
        contentProps: a == null ? void 0 : a.axisContent,
        sx: {
          mx: 2
        },
        classes: v
      })
    }))
  });
}
process.env.NODE_ENV !== "production" && (k3.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Component to override the tooltip content when trigger is set to 'axis'.
   * @deprecated Use slots.axisContent instead
   */
  axisContent: s.elementType,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * Component to override the tooltip content when trigger is set to 'item'.
   * @deprecated Use slots.itemContent instead
   */
  itemContent: s.elementType,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: s.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: s.object,
  /**
   * Select the kind of tooltip to display
   * - 'item': Shows data about the item below the mouse.
   * - 'axis': Shows values associated with the hovered x value
   * - 'none': Does not display tooltip
   * @default 'axis'
   */
  trigger: s.oneOf(["axis", "item", "none"])
});
const JRe = (e) => {
  const {
    seriesOrder: t,
    series: n
  } = e;
  return t.reduce((r, o) => {
    const i = yi(n[o].label, "legend");
    return i === void 0 || r.push({
      id: o,
      seriesId: o,
      color: n[o].color,
      label: i
    }), r;
  }, []);
}, QRe = (e) => {
  const {
    seriesOrder: t,
    series: n
  } = e;
  return t.reduce((r, o) => {
    const i = yi(n[o].label, "legend");
    return i === void 0 || r.push({
      id: o,
      seriesId: o,
      color: n[o].color,
      label: i
    }), r;
  }, []);
}, ePe = (e) => {
  const {
    seriesOrder: t,
    series: n
  } = e;
  return t.reduce((r, o) => {
    const i = yi(n[o].label, "legend");
    return i === void 0 || r.push({
      id: o,
      seriesId: o,
      color: n[o].color,
      label: i
    }), r;
  }, []);
}, tPe = (e) => {
  const {
    seriesOrder: t,
    series: n
  } = e;
  return t.reduce((r, o) => (n[o].data.forEach((i) => {
    const a = yi(i.label, "legend");
    a !== void 0 && r.push({
      id: i.id,
      seriesId: o,
      color: i.color,
      label: a,
      itemId: i.id
    });
  }), r), []);
}, nPe = {
  bar: JRe,
  scatter: QRe,
  line: ePe,
  pie: tPe
};
function rPe(e) {
  return Object.keys(e).flatMap((t) => {
    const n = nPe[t];
    return n === void 0 ? [] : n(e[t]);
  });
}
function oPe(e) {
  return oi("MuiChartsLegend", e);
}
Ei("MuiChartsLegend", ["root", "series", "itemBackground", "mark", "label", "column", "row"]);
const iPe = ["label"];
function aPe(e, t, n, r, o, i, a) {
  let c = 0, l = 0, u = 0, d = 0, f = 0;
  const h = [0];
  return [e.map((y) => {
    let {
      label: g
    } = y, b = Bt(y, iPe);
    const x = t(g, n), $ = ge({}, b, {
      label: g,
      positionX: c,
      positionY: l,
      innerHeight: x.innerHeight,
      innerWidth: x.innerWidth,
      outerHeight: x.outerHeight,
      outerWidth: x.outerWidth,
      rowIndex: f
    });
    return r === "row" && (c + x.innerWidth > o && (c = 0, l += h[f], f += 1, h.length <= f && h.push(0), $.positionX = c, $.positionY = l, $.rowIndex = f), u = Math.max(u, c + x.outerWidth), d = Math.max(d, l + x.outerHeight), h[f] = Math.max(h[f], x.outerHeight), c += x.outerWidth), r === "column" && (l + x.innerHeight > i && (c = u + a, l = 0, f = 0, $.positionX = c, $.positionY = l, $.rowIndex = f), h.length <= f && h.push(0), u = Math.max(u, c + x.outerWidth), d = Math.max(d, l + x.outerHeight), f += 1, l += x.outerHeight), $;
  }).map((y) => ge({}, y, {
    positionY: y.positionY + (r === "row" ? h[y.rowIndex] / 2 : y.outerHeight / 2)
    // Get the center of the item
  })), u, d];
}
function sPe(e) {
  const t = Ya(), {
    id: n,
    positionY: r,
    label: o,
    positionX: i,
    innerHeight: a,
    innerWidth: c,
    legendWidth: l,
    color: u,
    gapX: d,
    gapY: f,
    itemMarkHeight: h,
    itemMarkWidth: v,
    markGap: y,
    labelStyle: g,
    classes: b,
    onClick: x
  } = e;
  return /* @__PURE__ */ F.jsxs("g", {
    className: Ge(b == null ? void 0 : b.series, `${b == null ? void 0 : b.series}-${n}`),
    transform: `translate(${d + (t ? l - i : i)} ${f + r})`,
    children: [/* @__PURE__ */ F.jsx("rect", {
      x: t ? -(c + 2) : -2,
      y: -h / 2 - 2,
      width: c + 4,
      height: a + 4,
      fill: "transparent",
      className: b == null ? void 0 : b.itemBackground,
      onClick: x,
      style: {
        pointerEvents: x ? "all" : "none",
        cursor: x ? "pointer" : "unset"
      }
    }), /* @__PURE__ */ F.jsx("rect", {
      className: b == null ? void 0 : b.mark,
      x: t ? -v : 0,
      y: -h / 2,
      width: v,
      height: h,
      fill: u,
      style: {
        pointerEvents: "none"
      }
    }), /* @__PURE__ */ F.jsx(Uu, {
      style: ge({
        pointerEvents: "none"
      }, g),
      text: o,
      x: (t ? -1 : 1) * (v + y),
      y: 0
    })]
  });
}
const cPe = ["rotate", "dominantBaseline"], lPe = Pe("g", {
  name: "MuiChartsLegend",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), uPe = (e) => typeof e == "number" ? {
  left: e,
  right: e,
  top: e,
  bottom: e
} : ge({
  left: 0,
  right: 0,
  top: 0,
  bottom: 0
}, e);
function dPe(e) {
  const {
    position: t,
    direction: n,
    itemsToDisplay: r,
    classes: o,
    itemMarkWidth: i = 20,
    itemMarkHeight: a = 20,
    markGap: c = 5,
    itemGap: l = 10,
    padding: u = 10,
    labelStyle: d,
    onItemClick: f
  } = e, h = Fr(), v = ro(), y = E.useMemo(
    () => ge({}, h.typography.subtitle1, {
      color: "inherit",
      dominantBaseline: "central",
      textAnchor: "start",
      fill: (h.vars || h).palette.text.primary,
      lineHeight: 1
    }, d),
    // To say to TS that the dominantBaseline and textAnchor are correct
    [d, h]
  ), g = E.useMemo(() => uPe(u), [u]), b = E.useCallback((_, A = {}) => {
    const D = Bt(A, cPe), M = E3({
      style: D,
      needsComputation: !0,
      text: _
    }), N = {
      innerWidth: i + c + Math.max(...M.map((L) => L.width)),
      innerHeight: Math.max(a, M.length * M[0].height)
    };
    return ge({}, N, {
      outerWidth: N.innerWidth + l,
      outerHeight: N.innerHeight + l
    });
  }, [l, a, i, c]), x = v.left + v.width + v.right, $ = v.top + v.height + v.bottom, S = x - g.left - g.right, O = $ - g.top - g.bottom, [C, T, k] = E.useMemo(() => aPe(r, b, y, n, S, O, l), [r, b, y, n, S, O, l]), I = E.useMemo(() => {
    switch (t.horizontal) {
      case "left":
        return g.left;
      case "right":
        return x - g.right - T;
      default:
        return (x - T) / 2;
    }
  }, [t.horizontal, g.left, g.right, x, T]), P = E.useMemo(() => {
    switch (t.vertical) {
      case "top":
        return g.top;
      case "bottom":
        return $ - g.bottom - k;
      default:
        return ($ - k) / 2;
    }
  }, [t.vertical, g.top, g.bottom, $, k]);
  return /* @__PURE__ */ F.jsx(Vf, {
    children: /* @__PURE__ */ F.jsx(lPe, {
      className: o == null ? void 0 : o.root,
      children: C.map((_, A) => /* @__PURE__ */ Y8(sPe, ge({}, _, {
        key: _.id,
        gapX: I,
        gapY: P,
        legendWidth: T,
        itemMarkHeight: a,
        itemMarkWidth: i,
        markGap: c,
        labelStyle: y,
        classes: o,
        onClick: f ? (D) => f(D, A) : void 0
      })))
    })
  });
}
const fPe = ["drawingArea", "seriesToDisplay", "hidden", "onItemClick"], pPe = (e) => ({
  type: "series",
  color: e.color,
  label: e.label,
  seriesId: e.seriesId,
  itemId: e.itemId
});
function lW(e) {
  const {
    seriesToDisplay: t,
    hidden: n,
    onItemClick: r
  } = e, o = Bt(e, fPe);
  return n ? null : /* @__PURE__ */ F.jsx(dPe, ge({}, o, {
    itemsToDisplay: t,
    onItemClick: r ? (i, a) => r(i, pPe(t[a]), a) : void 0
  }));
}
process.env.NODE_ENV !== "production" && (lW.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The direction of the legend layout.
   * The default depends on the chart.
   */
  direction: s.oneOf(["column", "row"]).isRequired,
  /**
   * @deprecated Use the `useDrawingArea` hook instead.
   */
  drawingArea: s.shape({
    bottom: s.number.isRequired,
    height: s.number.isRequired,
    left: s.number.isRequired,
    right: s.number.isRequired,
    top: s.number.isRequired,
    width: s.number.isRequired
  }).isRequired,
  /**
   * Set to true to hide the legend.
   * @default false
   */
  hidden: s.bool,
  /**
   * Space between two legend items (in px).
   * @default 10
   */
  itemGap: s.number,
  /**
   * Height of the item mark (in px).
   * @default 20
   */
  itemMarkHeight: s.number,
  /**
   * Width of the item mark (in px).
   * @default 20
   */
  itemMarkWidth: s.number,
  /**
   * Style applied to legend labels.
   * @default theme.typography.subtitle1
   */
  labelStyle: s.object,
  /**
   * Space between the mark and the label (in px).
   * @default 5
   */
  markGap: s.number,
  /**
   * Callback fired when a legend item is clicked.
   * @param {React.MouseEvent<SVGRectElement, MouseEvent>} event The click event.
   * @param {SeriesLegendItemContext} legendItem The legend item data.
   * @param {number} index The index of the clicked legend item.
   */
  onItemClick: s.func,
  /**
   * Legend padding (in px).
   * Can either be a single number, or an object with top, left, bottom, right properties.
   * @default 10
   */
  padding: s.oneOfType([s.number, s.shape({
    bottom: s.number,
    left: s.number,
    right: s.number,
    top: s.number
  })]),
  /**
   * The position of the legend.
   */
  position: s.shape({
    horizontal: s.oneOf(["left", "middle", "right"]).isRequired,
    vertical: s.oneOf(["bottom", "middle", "top"]).isRequired
  }).isRequired,
  series: s.object.isRequired,
  seriesToDisplay: s.arrayOf(s.shape({
    color: s.string.isRequired,
    id: s.oneOfType([s.number, s.string]).isRequired,
    itemId: s.oneOfType([s.number, s.string]),
    label: s.string.isRequired,
    maxValue: s.oneOfType([s.instanceOf(Date), s.number]),
    minValue: s.oneOfType([s.instanceOf(Date), s.number]),
    seriesId: s.oneOfType([s.number, s.string])
  })).isRequired
});
const hPe = ["slots", "slotProps"], mPe = (e) => {
  const {
    classes: t,
    direction: n
  } = e;
  return ri({
    root: ["root", n],
    mark: ["mark"],
    label: ["label"],
    series: ["series"],
    itemBackground: ["itemBackground"]
  }, oPe, t);
};
function R3(e) {
  const t = Ga({
    props: e,
    name: "MuiChartsLegend"
  }), n = ge({
    direction: "row"
  }, t, {
    position: ge({
      horizontal: "middle",
      vertical: "top"
    }, t.position)
  }), {
    slots: r,
    slotProps: o
  } = n, i = Bt(n, hPe), a = Fr(), c = mPe(ge({}, n, {
    theme: a
  })), l = ro(), u = es(), d = rPe(u), f = (r == null ? void 0 : r.legend) ?? lW, h = bi({
    elementType: f,
    externalSlotProps: o == null ? void 0 : o.legend,
    additionalProps: ge({}, i, {
      classes: c,
      drawingArea: l,
      series: u,
      seriesToDisplay: d
    }),
    ownerState: {}
  });
  return /* @__PURE__ */ F.jsx(f, ge({}, h));
}
process.env.NODE_ENV !== "production" && (R3.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: s.object,
  /**
   * The direction of the legend layout.
   * The default depends on the chart.
   */
  direction: s.oneOf(["column", "row"]),
  /**
   * Set to true to hide the legend.
   * @default false
   */
  hidden: s.bool,
  /**
   * Space between two legend items (in px).
   * @default 10
   */
  itemGap: s.number,
  /**
   * Height of the item mark (in px).
   * @default 20
   */
  itemMarkHeight: s.number,
  /**
   * Width of the item mark (in px).
   * @default 20
   */
  itemMarkWidth: s.number,
  /**
   * Style applied to legend labels.
   * @default theme.typography.subtitle1
   */
  labelStyle: s.object,
  /**
   * Space between the mark and the label (in px).
   * @default 5
   */
  markGap: s.number,
  /**
   * Callback fired when a legend item is clicked.
   * @param {React.MouseEvent<SVGRectElement, MouseEvent>} event The click event.
   * @param {SeriesLegendItemContext} legendItem The legend item data.
   * @param {number} index The index of the clicked legend item.
   */
  onItemClick: s.func,
  /**
   * Legend padding (in px).
   * Can either be a single number, or an object with top, left, bottom, right properties.
   * @default 10
   */
  padding: s.oneOfType([s.number, s.shape({
    bottom: s.number,
    left: s.number,
    right: s.number,
    top: s.number
  })]),
  /**
   * The position of the legend.
   */
  position: s.shape({
    horizontal: s.oneOf(["left", "middle", "right"]).isRequired,
    vertical: s.oneOf(["bottom", "middle", "top"]).isRequired
  }),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: s.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: s.object
});
const gPe = 10;
function B6(e) {
  const {
    gradientUnits: t,
    isReversed: n,
    gradientId: r,
    size: o,
    direction: i,
    scale: a,
    colorScale: c,
    colorMap: l
  } = e, u = [l.min ?? 0, l.max ?? 100], d = u.map(a).filter((y) => y !== void 0);
  if (d.length !== 2)
    return null;
  const f = typeof u[0] == "number" ? lp(u[0], u[1]) : TU(u[0], u[1]), h = Math.round((Math.max(...d) - Math.min(...d)) / gPe), v = `${u[0]}-${u[1]}-`;
  return /* @__PURE__ */ F.jsx("linearGradient", {
    id: r,
    x1: "0",
    x2: "0",
    y1: "0",
    y2: "0",
    [`${i}${n ? 1 : 2}`]: t === "objectBoundingBox" ? 1 : `${o}px`,
    gradientUnits: t ?? "userSpaceOnUse",
    children: Array.from({
      length: h + 1
    }, (y, g) => {
      const b = f(g / h);
      if (b === void 0)
        return null;
      const x = a(b);
      if (x === void 0)
        return null;
      const $ = n ? 1 - x / o : x / o, S = c(b);
      return S === null ? null : /* @__PURE__ */ F.jsx("stop", {
        offset: $,
        stopColor: S,
        stopOpacity: 1
      }, v + g);
    })
  });
}
function Oc(e, t) {
  if (typeof e == "number")
    return e;
  if (e === "100%")
    return t;
  if (e.endsWith("%")) {
    const n = Number.parseFloat(e.slice(0, e.length - 1));
    if (!Number.isNaN(n))
      return n * t / 100;
  }
  if (e.endsWith("px")) {
    const n = Number.parseFloat(e.slice(0, e.length - 2));
    if (!Number.isNaN(n))
      return n;
  }
  throw new Error(`MUI X: Received an unknown value "${e}". It should be a number, or a string with a percentage value.`);
}
function vPe(e) {
  return oi("MuiChartsAxisHighlight", e);
}
Ei("MuiChartsAxisHighlight", ["root"]);
const yPe = () => ri({
  root: ["root"]
}, vPe), Lm = Pe("path", {
  name: "MuiChartsAxisHighlight",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  pointerEvents: "none",
  variants: [{
    props: {
      axisHighlight: "band"
    },
    style: ge({
      fill: "white",
      fillOpacity: 0.1
    }, e.applyStyles("light", {
      fill: "gray"
    }))
  }, {
    props: {
      axisHighlight: "line"
    },
    style: ge({
      strokeDasharray: "5 2",
      stroke: "#ffffff"
    }, e.applyStyles("light", {
      stroke: "#000000"
    }))
  }]
}));
function P3(e) {
  const {
    x: t,
    y: n
  } = e, {
    xAxisIds: r,
    xAxis: o,
    yAxisIds: i,
    yAxis: a
  } = oo(), c = yPe(), l = r[0], u = i[0], d = o[l].scale, f = a[u].scale, {
    axis: h
  } = E.useContext(ga), v = qu(d), y = qu(f), g = h.x, b = h.y, x = t === "band" && g !== null && Zc(d), $ = n === "band" && b !== null && Zc(f);
  if (process.env.NODE_ENV !== "production") {
    const S = x && d(g.value) === void 0, O = $ && f(b.value) === void 0;
    (S || O) && console.error(["MUI X: The position value provided for the axis is not valid for the current scale.", "This probably means something is wrong with the data passed to the chart.", "The ChartsAxisHighlight component will not be displayed."].join(`
`));
  }
  return /* @__PURE__ */ F.jsxs(E.Fragment, {
    children: [x && d(g.value) !== void 0 && /* @__PURE__ */ F.jsx(
      Lm,
      {
        d: `M ${d(g.value) - (d.step() - d.bandwidth()) / 2} ${f.range()[0]} l ${d.step()} 0 l 0 ${f.range()[1] - f.range()[0]} l ${-d.step()} 0 Z`,
        className: c.root,
        ownerState: {
          axisHighlight: "band"
        }
      }
    ), $ && f(b.value) !== void 0 && /* @__PURE__ */ F.jsx(Lm, {
      d: `M ${d.range()[0]} ${// @ts-expect-error, yScale value is checked in the statement above
      f(b.value) - (f.step() - f.bandwidth()) / 2} l 0 ${f.step()} l ${d.range()[1] - d.range()[0]} 0 l 0 ${-f.step()} Z`,
      className: c.root,
      ownerState: {
        axisHighlight: "band"
      }
    }), t === "line" && h.x !== null && /* @__PURE__ */ F.jsx(Lm, {
      d: `M ${v(h.x.value)} ${f.range()[0]} L ${v(h.x.value)} ${f.range()[1]}`,
      className: c.root,
      ownerState: {
        axisHighlight: "line"
      }
    }), n === "line" && h.y !== null && /* @__PURE__ */ F.jsx(Lm, {
      d: `M ${d.range()[0]} ${y(h.y.value)} L ${d.range()[1]} ${y(h.y.value)}`,
      className: c.root,
      ownerState: {
        axisHighlight: "line"
      }
    })]
  });
}
process.env.NODE_ENV !== "production" && (P3.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  x: s.oneOf(["band", "line", "none"]),
  y: s.oneOf(["band", "line", "none"])
});
function bPe(e, t) {
  const n = e.createSVGPoint();
  return n.x = t.clientX, n.y = t.clientY, n.matrixTransform(e.getScreenCTM().inverse());
}
function uW(e) {
  const {
    onAxisClick: t
  } = e, n = T3(), r = es(), {
    axis: o
  } = E.useContext(ga), {
    xAxisIds: i,
    xAxis: a,
    yAxisIds: c,
    yAxis: l
  } = oo();
  return E.useEffect(() => {
    const u = n.current;
    if (u === null || !t)
      return () => {
      };
    const d = (f) => {
      var x;
      f.preventDefault();
      const h = o.x && o.x.index !== -1, v = h ? i[0] : c[0], y = h ? o.x && o.x.index : o.y && o.y.index;
      if (y == null)
        return;
      const g = {};
      Object.keys(r).filter(($) => ["bar", "line"].includes($)).forEach(($) => {
        var S;
        (S = r[$]) == null || S.seriesOrder.forEach((O) => {
          const C = r[$].series[O], T = C.xAxisId ?? C.xAxisKey, k = C.yAxisId ?? C.yAxisKey, I = h ? T : k;
          (I === void 0 || I === v) && (g[O] = C.data[y]);
        });
      });
      const b = (x = (h ? a : l)[v].data) == null ? void 0 : x[y];
      t(f, {
        dataIndex: y,
        axisValue: b,
        seriesValues: g
      });
    };
    return u.addEventListener("click", d), () => {
      u.removeEventListener("click", d);
    };
  }, [o.x, o.y, t, r, n, a, i, l, c]), /* @__PURE__ */ F.jsx(E.Fragment, {});
}
process.env.NODE_ENV !== "production" && (uW.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The function called for onClick events.
   * The second argument contains information about all line/bar elements at the current mouse position.
   * @param {MouseEvent} event The mouse event recorded on the `<svg/>` element.
   * @param {null | AxisData} data The data about the clicked axis and items associated with it.
   */
  onAxisClick: s.func
});
var A3 = Vp(), Ct = (e) => Hp(e, A3), I3 = Vp();
Ct.write = (e) => Hp(e, I3);
var my = Vp();
Ct.onStart = (e) => Hp(e, my);
var M3 = Vp();
Ct.onFrame = (e) => Hp(e, M3);
var N3 = Vp();
Ct.onFinish = (e) => Hp(e, N3);
var bu = [];
Ct.setTimeout = (e, t) => {
  const n = Ct.now() + t, r = () => {
    const i = bu.findIndex((a) => a.cancel == r);
    ~i && bu.splice(i, 1), ks -= ~i ? 1 : 0;
  }, o = { time: n, handler: e, cancel: r };
  return bu.splice(dW(n), 0, o), ks += 1, fW(), o;
};
var dW = (e) => ~(~bu.findIndex((t) => t.time > e) || ~bu.length);
Ct.cancel = (e) => {
  my.delete(e), M3.delete(e), N3.delete(e), A3.delete(e), I3.delete(e);
};
Ct.sync = (e) => {
  RC = !0, Ct.batchedUpdates(e), RC = !1;
};
Ct.throttle = (e) => {
  let t;
  function n() {
    try {
      e(...t);
    } finally {
      t = null;
    }
  }
  function r(...o) {
    t = o, Ct.onStart(n);
  }
  return r.handler = e, r.cancel = () => {
    my.delete(n), t = null;
  }, r;
};
var D3 = typeof window < "u" ? window.requestAnimationFrame : (
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  () => {
  }
);
Ct.use = (e) => D3 = e;
Ct.now = typeof performance < "u" ? () => performance.now() : Date.now;
Ct.batchedUpdates = (e) => e();
Ct.catch = console.error;
Ct.frameLoop = "always";
Ct.advance = () => {
  Ct.frameLoop !== "demand" ? console.warn(
    "Cannot call the manual advancement of rafz whilst frameLoop is not set as demand"
  ) : hW();
};
var _s = -1, ks = 0, RC = !1;
function Hp(e, t) {
  RC ? (t.delete(e), e(0)) : (t.add(e), fW());
}
function fW() {
  _s < 0 && (_s = 0, Ct.frameLoop !== "demand" && D3(pW));
}
function xPe() {
  _s = -1;
}
function pW() {
  ~_s && (D3(pW), Ct.batchedUpdates(hW));
}
function hW() {
  const e = _s;
  _s = Ct.now();
  const t = dW(_s);
  if (t && (mW(bu.splice(0, t), (n) => n.handler()), ks -= t), !ks) {
    xPe();
    return;
  }
  my.flush(), A3.flush(e ? Math.min(64, _s - e) : 16.667), M3.flush(), I3.flush(), N3.flush();
}
function Vp() {
  let e = /* @__PURE__ */ new Set(), t = e;
  return {
    add(n) {
      ks += t == e && !e.has(n) ? 1 : 0, e.add(n);
    },
    delete(n) {
      return ks -= t == e && e.has(n) ? 1 : 0, e.delete(n);
    },
    flush(n) {
      t.size && (e = /* @__PURE__ */ new Set(), ks -= t.size, mW(t, (r) => r(n) && e.add(r)), ks += e.size, t = e);
    }
  };
}
function mW(e, t) {
  e.forEach((n) => {
    try {
      t(n);
    } catch (r) {
      Ct.catch(r);
    }
  });
}
var wPe = Object.defineProperty, $Pe = (e, t) => {
  for (var n in t)
    wPe(e, n, { get: t[n], enumerable: !0 });
}, ti = {};
$Pe(ti, {
  assign: () => SPe,
  colors: () => Ns,
  createStringInterpolator: () => j3,
  skipAnimation: () => vW,
  to: () => gW,
  willAdvance: () => F3
});
function PC() {
}
var OPe = (e, t, n) => Object.defineProperty(e, t, { value: n, writable: !0, configurable: !0 }), Ve = {
  arr: Array.isArray,
  obj: (e) => !!e && e.constructor.name === "Object",
  fun: (e) => typeof e == "function",
  str: (e) => typeof e == "string",
  num: (e) => typeof e == "number",
  und: (e) => e === void 0
};
function Aa(e, t) {
  if (Ve.arr(e)) {
    if (!Ve.arr(t) || e.length !== t.length)
      return !1;
    for (let n = 0; n < e.length; n++)
      if (e[n] !== t[n])
        return !1;
    return !0;
  }
  return e === t;
}
var vt = (e, t) => e.forEach(t);
function da(e, t, n) {
  if (Ve.arr(e)) {
    for (let r = 0; r < e.length; r++)
      t.call(n, e[r], `${r}`);
    return;
  }
  for (const r in e)
    e.hasOwnProperty(r) && t.call(n, e[r], r);
}
var Nr = (e) => Ve.und(e) ? [] : Ve.arr(e) ? e : [e];
function Ef(e, t) {
  if (e.size) {
    const n = Array.from(e);
    e.clear(), vt(n, t);
  }
}
var df = (e, ...t) => Ef(e, (n) => n(...t)), L3 = () => typeof window > "u" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent), j3, gW, Ns = null, vW = !1, F3 = PC, SPe = (e) => {
  e.to && (gW = e.to), e.now && (Ct.now = e.now), e.colors !== void 0 && (Ns = e.colors), e.skipAnimation != null && (vW = e.skipAnimation), e.createStringInterpolator && (j3 = e.createStringInterpolator), e.requestAnimationFrame && Ct.use(e.requestAnimationFrame), e.batchedUpdates && (Ct.batchedUpdates = e.batchedUpdates), e.willAdvance && (F3 = e.willAdvance), e.frameLoop && (Ct.frameLoop = e.frameLoop);
}, _f = /* @__PURE__ */ new Set(), Ho = [], uO = [], P0 = 0, gy = {
  get idle() {
    return !_f.size && !Ho.length;
  },
  /** Advance the given animation on every frame until idle. */
  start(e) {
    P0 > e.priority ? (_f.add(e), Ct.onStart(CPe)) : (yW(e), Ct(AC));
  },
  /** Advance all animations by the given time. */
  advance: AC,
  /** Call this when an animation's priority changes. */
  sort(e) {
    if (P0)
      Ct.onFrame(() => gy.sort(e));
    else {
      const t = Ho.indexOf(e);
      ~t && (Ho.splice(t, 1), bW(e));
    }
  },
  /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */
  clear() {
    Ho = [], _f.clear();
  }
};
function CPe() {
  _f.forEach(yW), _f.clear(), Ct(AC);
}
function yW(e) {
  Ho.includes(e) || bW(e);
}
function bW(e) {
  Ho.splice(
    TPe(Ho, (t) => t.priority > e.priority),
    0,
    e
  );
}
function AC(e) {
  const t = uO;
  for (let n = 0; n < Ho.length; n++) {
    const r = Ho[n];
    P0 = r.priority, r.idle || (F3(r), r.advance(e), r.idle || t.push(r));
  }
  return P0 = 0, uO = Ho, uO.length = 0, Ho = t, Ho.length > 0;
}
function TPe(e, t) {
  const n = e.findIndex(t);
  return n < 0 ? e.length : n;
}
var EPe = (e, t, n) => Math.min(Math.max(n, e), t), _Pe = {
  transparent: 0,
  aliceblue: 4042850303,
  antiquewhite: 4209760255,
  aqua: 16777215,
  aquamarine: 2147472639,
  azure: 4043309055,
  beige: 4126530815,
  bisque: 4293182719,
  black: 255,
  blanchedalmond: 4293643775,
  blue: 65535,
  blueviolet: 2318131967,
  brown: 2771004159,
  burlywood: 3736635391,
  burntsienna: 3934150143,
  cadetblue: 1604231423,
  chartreuse: 2147418367,
  chocolate: 3530104575,
  coral: 4286533887,
  cornflowerblue: 1687547391,
  cornsilk: 4294499583,
  crimson: 3692313855,
  cyan: 16777215,
  darkblue: 35839,
  darkcyan: 9145343,
  darkgoldenrod: 3095792639,
  darkgray: 2846468607,
  darkgreen: 6553855,
  darkgrey: 2846468607,
  darkkhaki: 3182914559,
  darkmagenta: 2332068863,
  darkolivegreen: 1433087999,
  darkorange: 4287365375,
  darkorchid: 2570243327,
  darkred: 2332033279,
  darksalmon: 3918953215,
  darkseagreen: 2411499519,
  darkslateblue: 1211993087,
  darkslategray: 793726975,
  darkslategrey: 793726975,
  darkturquoise: 13554175,
  darkviolet: 2483082239,
  deeppink: 4279538687,
  deepskyblue: 12582911,
  dimgray: 1768516095,
  dimgrey: 1768516095,
  dodgerblue: 512819199,
  firebrick: 2988581631,
  floralwhite: 4294635775,
  forestgreen: 579543807,
  fuchsia: 4278255615,
  gainsboro: 3705462015,
  ghostwhite: 4177068031,
  gold: 4292280575,
  goldenrod: 3668254975,
  gray: 2155905279,
  green: 8388863,
  greenyellow: 2919182335,
  grey: 2155905279,
  honeydew: 4043305215,
  hotpink: 4285117695,
  indianred: 3445382399,
  indigo: 1258324735,
  ivory: 4294963455,
  khaki: 4041641215,
  lavender: 3873897215,
  lavenderblush: 4293981695,
  lawngreen: 2096890111,
  lemonchiffon: 4294626815,
  lightblue: 2916673279,
  lightcoral: 4034953471,
  lightcyan: 3774873599,
  lightgoldenrodyellow: 4210742015,
  lightgray: 3553874943,
  lightgreen: 2431553791,
  lightgrey: 3553874943,
  lightpink: 4290167295,
  lightsalmon: 4288707327,
  lightseagreen: 548580095,
  lightskyblue: 2278488831,
  lightslategray: 2005441023,
  lightslategrey: 2005441023,
  lightsteelblue: 2965692159,
  lightyellow: 4294959359,
  lime: 16711935,
  limegreen: 852308735,
  linen: 4210091775,
  magenta: 4278255615,
  maroon: 2147483903,
  mediumaquamarine: 1724754687,
  mediumblue: 52735,
  mediumorchid: 3126187007,
  mediumpurple: 2473647103,
  mediumseagreen: 1018393087,
  mediumslateblue: 2070474495,
  mediumspringgreen: 16423679,
  mediumturquoise: 1221709055,
  mediumvioletred: 3340076543,
  midnightblue: 421097727,
  mintcream: 4127193855,
  mistyrose: 4293190143,
  moccasin: 4293178879,
  navajowhite: 4292783615,
  navy: 33023,
  oldlace: 4260751103,
  olive: 2155872511,
  olivedrab: 1804477439,
  orange: 4289003775,
  orangered: 4282712319,
  orchid: 3664828159,
  palegoldenrod: 4008225535,
  palegreen: 2566625535,
  paleturquoise: 2951671551,
  palevioletred: 3681588223,
  papayawhip: 4293907967,
  peachpuff: 4292524543,
  peru: 3448061951,
  pink: 4290825215,
  plum: 3718307327,
  powderblue: 2967529215,
  purple: 2147516671,
  rebeccapurple: 1714657791,
  red: 4278190335,
  rosybrown: 3163525119,
  royalblue: 1097458175,
  saddlebrown: 2336560127,
  salmon: 4202722047,
  sandybrown: 4104413439,
  seagreen: 780883967,
  seashell: 4294307583,
  sienna: 2689740287,
  silver: 3233857791,
  skyblue: 2278484991,
  slateblue: 1784335871,
  slategray: 1887473919,
  slategrey: 1887473919,
  snow: 4294638335,
  springgreen: 16744447,
  steelblue: 1182971135,
  tan: 3535047935,
  teal: 8421631,
  thistle: 3636451583,
  tomato: 4284696575,
  turquoise: 1088475391,
  violet: 4001558271,
  wheat: 4125012991,
  white: 4294967295,
  whitesmoke: 4126537215,
  yellow: 4294902015,
  yellowgreen: 2597139199
}, gi = "[-+]?\\d*\\.?\\d+", A0 = gi + "%";
function vy(...e) {
  return "\\(\\s*(" + e.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var kPe = new RegExp("rgb" + vy(gi, gi, gi)), RPe = new RegExp("rgba" + vy(gi, gi, gi, gi)), PPe = new RegExp("hsl" + vy(gi, A0, A0)), APe = new RegExp(
  "hsla" + vy(gi, A0, A0, gi)
), IPe = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, MPe = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/, NPe = /^#([0-9a-fA-F]{6})$/, DPe = /^#([0-9a-fA-F]{8})$/;
function LPe(e) {
  let t;
  return typeof e == "number" ? e >>> 0 === e && e >= 0 && e <= 4294967295 ? e : null : (t = NPe.exec(e)) ? parseInt(t[1] + "ff", 16) >>> 0 : Ns && Ns[e] !== void 0 ? Ns[e] : (t = kPe.exec(e)) ? (Xl(t[1]) << 24 | // r
  Xl(t[2]) << 16 | // g
  Xl(t[3]) << 8 | // b
  255) >>> // a
  0 : (t = RPe.exec(e)) ? (Xl(t[1]) << 24 | // r
  Xl(t[2]) << 16 | // g
  Xl(t[3]) << 8 | // b
  W6(t[4])) >>> // a
  0 : (t = IPe.exec(e)) ? parseInt(
    t[1] + t[1] + // r
    t[2] + t[2] + // g
    t[3] + t[3] + // b
    "ff",
    // a
    16
  ) >>> 0 : (t = DPe.exec(e)) ? parseInt(t[1], 16) >>> 0 : (t = MPe.exec(e)) ? parseInt(
    t[1] + t[1] + // r
    t[2] + t[2] + // g
    t[3] + t[3] + // b
    t[4] + t[4],
    // a
    16
  ) >>> 0 : (t = PPe.exec(e)) ? (q6(
    U6(t[1]),
    // h
    jm(t[2]),
    // s
    jm(t[3])
    // l
  ) | 255) >>> // a
  0 : (t = APe.exec(e)) ? (q6(
    U6(t[1]),
    // h
    jm(t[2]),
    // s
    jm(t[3])
    // l
  ) | W6(t[4])) >>> // a
  0 : null;
}
function dO(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function q6(e, t, n) {
  const r = n < 0.5 ? n * (1 + t) : n + t - n * t, o = 2 * n - r, i = dO(o, r, e + 1 / 3), a = dO(o, r, e), c = dO(o, r, e - 1 / 3);
  return Math.round(i * 255) << 24 | Math.round(a * 255) << 16 | Math.round(c * 255) << 8;
}
function Xl(e) {
  const t = parseInt(e, 10);
  return t < 0 ? 0 : t > 255 ? 255 : t;
}
function U6(e) {
  return (parseFloat(e) % 360 + 360) % 360 / 360;
}
function W6(e) {
  const t = parseFloat(e);
  return t < 0 ? 0 : t > 1 ? 255 : Math.round(t * 255);
}
function jm(e) {
  const t = parseFloat(e);
  return t < 0 ? 0 : t > 100 ? 1 : t / 100;
}
function H6(e) {
  let t = LPe(e);
  if (t === null)
    return e;
  t = t || 0;
  const n = (t & 4278190080) >>> 24, r = (t & 16711680) >>> 16, o = (t & 65280) >>> 8, i = (t & 255) / 255;
  return `rgba(${n}, ${r}, ${o}, ${i})`;
}
var dp = (e, t, n) => {
  if (Ve.fun(e))
    return e;
  if (Ve.arr(e))
    return dp({
      range: e,
      output: t,
      extrapolate: n
    });
  if (Ve.str(e.output[0]))
    return j3(e);
  const r = e, o = r.output, i = r.range || [0, 1], a = r.extrapolateLeft || r.extrapolate || "extend", c = r.extrapolateRight || r.extrapolate || "extend", l = r.easing || ((u) => u);
  return (u) => {
    const d = FPe(u, i);
    return jPe(
      u,
      i[d],
      i[d + 1],
      o[d],
      o[d + 1],
      l,
      a,
      c,
      r.map
    );
  };
};
function jPe(e, t, n, r, o, i, a, c, l) {
  let u = l ? l(e) : e;
  if (u < t) {
    if (a === "identity")
      return u;
    a === "clamp" && (u = t);
  }
  if (u > n) {
    if (c === "identity")
      return u;
    c === "clamp" && (u = n);
  }
  return r === o ? r : t === n ? e <= t ? r : o : (t === -1 / 0 ? u = -u : n === 1 / 0 ? u = u - t : u = (u - t) / (n - t), u = i(u), r === -1 / 0 ? u = -u : o === 1 / 0 ? u = u + r : u = u * (o - r) + r, u);
}
function FPe(e, t) {
  for (var n = 1; n < t.length - 1 && !(t[n] >= e); ++n)
    ;
  return n - 1;
}
var zPe = (e, t = "end") => (n) => {
  n = t === "end" ? Math.min(n, 0.999) : Math.max(n, 1e-3);
  const r = n * e, o = t === "end" ? Math.floor(r) : Math.ceil(r);
  return EPe(0, 1, o / e);
}, I0 = 1.70158, Fm = I0 * 1.525, V6 = I0 + 1, Y6 = 2 * Math.PI / 3, G6 = 2 * Math.PI / 4.5, zm = (e) => e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375, BPe = {
  linear: (e) => e,
  easeInQuad: (e) => e * e,
  easeOutQuad: (e) => 1 - (1 - e) * (1 - e),
  easeInOutQuad: (e) => e < 0.5 ? 2 * e * e : 1 - Math.pow(-2 * e + 2, 2) / 2,
  easeInCubic: (e) => e * e * e,
  easeOutCubic: (e) => 1 - Math.pow(1 - e, 3),
  easeInOutCubic: (e) => e < 0.5 ? 4 * e * e * e : 1 - Math.pow(-2 * e + 2, 3) / 2,
  easeInQuart: (e) => e * e * e * e,
  easeOutQuart: (e) => 1 - Math.pow(1 - e, 4),
  easeInOutQuart: (e) => e < 0.5 ? 8 * e * e * e * e : 1 - Math.pow(-2 * e + 2, 4) / 2,
  easeInQuint: (e) => e * e * e * e * e,
  easeOutQuint: (e) => 1 - Math.pow(1 - e, 5),
  easeInOutQuint: (e) => e < 0.5 ? 16 * e * e * e * e * e : 1 - Math.pow(-2 * e + 2, 5) / 2,
  easeInSine: (e) => 1 - Math.cos(e * Math.PI / 2),
  easeOutSine: (e) => Math.sin(e * Math.PI / 2),
  easeInOutSine: (e) => -(Math.cos(Math.PI * e) - 1) / 2,
  easeInExpo: (e) => e === 0 ? 0 : Math.pow(2, 10 * e - 10),
  easeOutExpo: (e) => e === 1 ? 1 : 1 - Math.pow(2, -10 * e),
  easeInOutExpo: (e) => e === 0 ? 0 : e === 1 ? 1 : e < 0.5 ? Math.pow(2, 20 * e - 10) / 2 : (2 - Math.pow(2, -20 * e + 10)) / 2,
  easeInCirc: (e) => 1 - Math.sqrt(1 - Math.pow(e, 2)),
  easeOutCirc: (e) => Math.sqrt(1 - Math.pow(e - 1, 2)),
  easeInOutCirc: (e) => e < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * e, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * e + 2, 2)) + 1) / 2,
  easeInBack: (e) => V6 * e * e * e - I0 * e * e,
  easeOutBack: (e) => 1 + V6 * Math.pow(e - 1, 3) + I0 * Math.pow(e - 1, 2),
  easeInOutBack: (e) => e < 0.5 ? Math.pow(2 * e, 2) * ((Fm + 1) * 2 * e - Fm) / 2 : (Math.pow(2 * e - 2, 2) * ((Fm + 1) * (e * 2 - 2) + Fm) + 2) / 2,
  easeInElastic: (e) => e === 0 ? 0 : e === 1 ? 1 : -Math.pow(2, 10 * e - 10) * Math.sin((e * 10 - 10.75) * Y6),
  easeOutElastic: (e) => e === 0 ? 0 : e === 1 ? 1 : Math.pow(2, -10 * e) * Math.sin((e * 10 - 0.75) * Y6) + 1,
  easeInOutElastic: (e) => e === 0 ? 0 : e === 1 ? 1 : e < 0.5 ? -(Math.pow(2, 20 * e - 10) * Math.sin((20 * e - 11.125) * G6)) / 2 : Math.pow(2, -20 * e + 10) * Math.sin((20 * e - 11.125) * G6) / 2 + 1,
  easeInBounce: (e) => 1 - zm(1 - e),
  easeOutBounce: zm,
  easeInOutBounce: (e) => e < 0.5 ? (1 - zm(1 - 2 * e)) / 2 : (1 + zm(2 * e - 1)) / 2,
  steps: zPe
}, fp = Symbol.for("FluidValue.get"), Wu = Symbol.for("FluidValue.observers"), Wo = (e) => !!(e && e[fp]), Xr = (e) => e && e[fp] ? e[fp]() : e, K6 = (e) => e[Wu] || null;
function qPe(e, t) {
  e.eventObserved ? e.eventObserved(t) : e(t);
}
function pp(e, t) {
  const n = e[Wu];
  n && n.forEach((r) => {
    qPe(r, t);
  });
}
var xW = class {
  constructor(e) {
    if (!e && !(e = this.get))
      throw Error("Unknown getter");
    UPe(this, e);
  }
}, UPe = (e, t) => wW(e, fp, t);
function ud(e, t) {
  if (e[fp]) {
    let n = e[Wu];
    n || wW(e, Wu, n = /* @__PURE__ */ new Set()), n.has(t) || (n.add(t), e.observerAdded && e.observerAdded(n.size, t));
  }
  return t;
}
function hp(e, t) {
  const n = e[Wu];
  if (n && n.has(t)) {
    const r = n.size - 1;
    r ? n.delete(t) : e[Wu] = null, e.observerRemoved && e.observerRemoved(r, t);
  }
}
var wW = (e, t, n) => Object.defineProperty(e, t, {
  value: n,
  writable: !0,
  configurable: !0
}), yg = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, WPe = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi, X6 = new RegExp(`(${yg.source})(%|[a-z]+)`, "i"), HPe = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi, yy = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/, $W = (e) => {
  const [t, n] = VPe(e);
  if (!t || L3())
    return e;
  const r = window.getComputedStyle(document.documentElement).getPropertyValue(t);
  if (r)
    return r.trim();
  if (n && n.startsWith("--")) {
    const o = window.getComputedStyle(document.documentElement).getPropertyValue(n);
    return o || e;
  } else {
    if (n && yy.test(n))
      return $W(n);
    if (n)
      return n;
  }
  return e;
}, VPe = (e) => {
  const t = yy.exec(e);
  if (!t)
    return [,];
  const [, n, r] = t;
  return [n, r];
}, fO, YPe = (e, t, n, r, o) => `rgba(${Math.round(t)}, ${Math.round(n)}, ${Math.round(r)}, ${o})`, OW = (e) => {
  fO || (fO = Ns ? (
    // match color names, ignore partial matches
    new RegExp(`(${Object.keys(Ns).join("|")})(?!\\w)`, "g")
  ) : (
    // never match
    /^\b$/
  ));
  const t = e.output.map((i) => Xr(i).replace(yy, $W).replace(WPe, H6).replace(fO, H6)), n = t.map((i) => i.match(yg).map(Number)), o = n[0].map(
    (i, a) => n.map((c) => {
      if (!(a in c))
        throw Error('The arity of each "output" value must be equal');
      return c[a];
    })
  ).map(
    (i) => dp({ ...e, output: i })
  );
  return (i) => {
    var l;
    const a = !X6.test(t[0]) && ((l = t.find((u) => X6.test(u))) == null ? void 0 : l.replace(yg, ""));
    let c = 0;
    return t[0].replace(
      yg,
      () => `${o[c++](i)}${a || ""}`
    ).replace(HPe, YPe);
  };
}, z3 = "react-spring: ", SW = (e) => {
  const t = e;
  let n = !1;
  if (typeof t != "function")
    throw new TypeError(`${z3}once requires a function parameter`);
  return (...r) => {
    n || (t(...r), n = !0);
  };
}, GPe = SW(console.warn);
function KPe() {
  GPe(
    `${z3}The "interpolate" function is deprecated in v9 (use "to" instead)`
  );
}
var XPe = SW(console.warn);
function ZPe() {
  XPe(
    `${z3}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`
  );
}
function by(e) {
  return Ve.str(e) && (e[0] == "#" || /\d/.test(e) || // Do not identify a CSS variable as an AnimatedString if its SSR
  !L3() && yy.test(e) || e in (Ns || {}));
}
var Rs = L3() ? mn : F0, JPe = () => {
  const e = Gt(!1);
  return Rs(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
};
function B3() {
  const e = Uc()[1], t = JPe();
  return () => {
    t.current && e(Math.random());
  };
}
function QPe(e, t) {
  const [n] = Uc(
    () => ({
      inputs: t,
      result: e()
    })
  ), r = Gt(), o = r.current;
  let i = o;
  return i ? t && i.inputs && eAe(t, i.inputs) || (i = {
    inputs: t,
    result: e()
  }) : i = n, mn(() => {
    r.current = i, o == n && (n.inputs = n.result = void 0);
  }, [i]), i.result;
}
function eAe(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
var q3 = (e) => mn(e, tAe), tAe = [];
function IC(e) {
  const t = Gt();
  return mn(() => {
    t.current = e;
  }), t.current;
}
var mp = Symbol.for("Animated:node"), nAe = (e) => !!e && e[mp] === e, Li = (e) => e && e[mp], U3 = (e, t) => OPe(e, mp, t), xy = (e) => e && e[mp] && e[mp].getPayload(), CW = class {
  constructor() {
    U3(this, this);
  }
  /** Get every `AnimatedValue` used by this node. */
  getPayload() {
    return this.payload || [];
  }
}, Yp = class extends CW {
  constructor(e) {
    super(), this._value = e, this.done = !0, this.durationProgress = 0, Ve.num(this._value) && (this.lastPosition = this._value);
  }
  /** @internal */
  static create(e) {
    return new Yp(e);
  }
  getPayload() {
    return [this];
  }
  getValue() {
    return this._value;
  }
  setValue(e, t) {
    return Ve.num(e) && (this.lastPosition = e, t && (e = Math.round(e / t) * t, this.done && (this.lastPosition = e))), this._value === e ? !1 : (this._value = e, !0);
  }
  reset() {
    const { done: e } = this;
    this.done = !1, Ve.num(this._value) && (this.elapsedTime = 0, this.durationProgress = 0, this.lastPosition = this._value, e && (this.lastVelocity = null), this.v0 = null);
  }
}, gp = class extends Yp {
  constructor(e) {
    super(0), this._string = null, this._toString = dp({
      output: [e, e]
    });
  }
  /** @internal */
  static create(e) {
    return new gp(e);
  }
  getValue() {
    const e = this._string;
    return e ?? (this._string = this._toString(this._value));
  }
  setValue(e) {
    if (Ve.str(e)) {
      if (e == this._string)
        return !1;
      this._string = e, this._value = 1;
    } else if (super.setValue(e))
      this._string = null;
    else
      return !1;
    return !0;
  }
  reset(e) {
    e && (this._toString = dp({
      output: [this.getValue(), e]
    })), this._value = 0, super.reset();
  }
}, M0 = { dependencies: null }, wy = class extends CW {
  constructor(e) {
    super(), this.source = e, this.setValue(e);
  }
  getValue(e) {
    const t = {};
    return da(this.source, (n, r) => {
      nAe(n) ? t[r] = n.getValue(e) : Wo(n) ? t[r] = Xr(n) : e || (t[r] = n);
    }), t;
  }
  /** Replace the raw object data */
  setValue(e) {
    this.source = e, this.payload = this._makePayload(e);
  }
  reset() {
    this.payload && vt(this.payload, (e) => e.reset());
  }
  /** Create a payload set. */
  _makePayload(e) {
    if (e) {
      const t = /* @__PURE__ */ new Set();
      return da(e, this._addToPayload, t), Array.from(t);
    }
  }
  /** Add to a payload set. */
  _addToPayload(e) {
    M0.dependencies && Wo(e) && M0.dependencies.add(e);
    const t = xy(e);
    t && vt(t, (n) => this.add(n));
  }
}, TW = class extends wy {
  constructor(e) {
    super(e);
  }
  /** @internal */
  static create(e) {
    return new TW(e);
  }
  getValue() {
    return this.source.map((e) => e.getValue());
  }
  setValue(e) {
    const t = this.getPayload();
    return e.length == t.length ? t.map((n, r) => n.setValue(e[r])).some(Boolean) : (super.setValue(e.map(rAe)), !0);
  }
};
function rAe(e) {
  return (by(e) ? gp : Yp).create(e);
}
function MC(e) {
  const t = Li(e);
  return t ? t.constructor : Ve.arr(e) ? TW : by(e) ? gp : Yp;
}
var Z6 = (e, t) => {
  const n = (
    // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !Ve.fun(e) || e.prototype && e.prototype.isReactComponent
  );
  return xp((r, o) => {
    const i = Gt(null), a = n && // eslint-disable-next-line react-hooks/rules-of-hooks
    Rt(
      (y) => {
        i.current = aAe(o, y);
      },
      [o]
    ), [c, l] = iAe(r, t), u = B3(), d = () => {
      const y = i.current;
      if (n && !y)
        return;
      (y ? t.applyAnimatedValues(y, c.getValue(!0)) : !1) === !1 && u();
    }, f = new oAe(d, l), h = Gt();
    Rs(() => (h.current = f, vt(l, (y) => ud(y, f)), () => {
      h.current && (vt(
        h.current.deps,
        (y) => hp(y, h.current)
      ), Ct.cancel(h.current.update));
    })), mn(d, []), q3(() => () => {
      const y = h.current;
      vt(y.deps, (g) => hp(g, y));
    });
    const v = t.getComponentProps(c.getValue());
    return /* @__PURE__ */ E.createElement(e, { ...v, ref: a });
  });
}, oAe = class {
  constructor(e, t) {
    this.update = e, this.deps = t;
  }
  eventObserved(e) {
    e.type == "change" && Ct.write(this.update);
  }
};
function iAe(e, t) {
  const n = /* @__PURE__ */ new Set();
  return M0.dependencies = n, e.style && (e = {
    ...e,
    style: t.createAnimatedStyle(e.style)
  }), e = new wy(e), M0.dependencies = null, [e, n];
}
function aAe(e, t) {
  return e && (Ve.fun(e) ? e(t) : e.current = t), t;
}
var J6 = Symbol.for("AnimatedComponent"), sAe = (e, {
  applyAnimatedValues: t = () => !1,
  createAnimatedStyle: n = (o) => new wy(o),
  getComponentProps: r = (o) => o
} = {}) => {
  const o = {
    applyAnimatedValues: t,
    createAnimatedStyle: n,
    getComponentProps: r
  }, i = (a) => {
    const c = Q6(a) || "Anonymous";
    return Ve.str(a) ? a = i[a] || (i[a] = Z6(a, o)) : a = a[J6] || (a[J6] = Z6(a, o)), a.displayName = `Animated(${c})`, a;
  };
  return da(e, (a, c) => {
    Ve.arr(e) && (c = Q6(a)), i[c] = i(a);
  }), {
    animated: i
  };
}, Q6 = (e) => Ve.str(e) ? e : e && Ve.str(e.displayName) ? e.displayName : Ve.fun(e) && e.name || null;
function Zr(e, ...t) {
  return Ve.fun(e) ? e(...t) : e;
}
var kf = (e, t) => e === !0 || !!(t && e && (Ve.fun(e) ? e(t) : Nr(e).includes(t))), EW = (e, t) => Ve.obj(e) ? t && e[t] : e, _W = (e, t) => e.default === !0 ? e[t] : e.default ? e.default[t] : void 0, cAe = (e) => e, $y = (e, t = cAe) => {
  let n = lAe;
  e.default && e.default !== !0 && (e = e.default, n = Object.keys(e));
  const r = {};
  for (const o of n) {
    const i = t(e[o], o);
    Ve.und(i) || (r[o] = i);
  }
  return r;
}, lAe = [
  "config",
  "onProps",
  "onStart",
  "onChange",
  "onPause",
  "onResume",
  "onRest"
], uAe = {
  config: 1,
  from: 1,
  to: 1,
  ref: 1,
  loop: 1,
  reset: 1,
  pause: 1,
  cancel: 1,
  reverse: 1,
  immediate: 1,
  default: 1,
  delay: 1,
  onProps: 1,
  onStart: 1,
  onChange: 1,
  onPause: 1,
  onResume: 1,
  onRest: 1,
  onResolve: 1,
  // Transition props
  items: 1,
  trail: 1,
  sort: 1,
  expires: 1,
  initial: 1,
  enter: 1,
  update: 1,
  leave: 1,
  children: 1,
  onDestroyed: 1,
  // Internal props
  keys: 1,
  callId: 1,
  parentId: 1
};
function dAe(e) {
  const t = {};
  let n = 0;
  if (da(e, (r, o) => {
    uAe[o] || (t[o] = r, n++);
  }), n)
    return t;
}
function W3(e) {
  const t = dAe(e);
  if (t) {
    const n = { to: t };
    return da(e, (r, o) => o in t || (n[o] = r)), n;
  }
  return { ...e };
}
function vp(e) {
  return e = Xr(e), Ve.arr(e) ? e.map(vp) : by(e) ? ti.createStringInterpolator({
    range: [0, 1],
    output: [e, e]
  })(1) : e;
}
function kW(e) {
  for (const t in e)
    return !0;
  return !1;
}
function NC(e) {
  return Ve.fun(e) || Ve.arr(e) && Ve.obj(e[0]);
}
function DC(e, t) {
  var n;
  (n = e.ref) == null || n.delete(e), t == null || t.delete(e);
}
function RW(e, t) {
  var n;
  t && e.ref !== t && ((n = e.ref) == null || n.delete(e), t.add(e), e.ref = t);
}
var fAe = {
  default: { tension: 170, friction: 26 },
  gentle: { tension: 120, friction: 14 },
  wobbly: { tension: 180, friction: 12 },
  stiff: { tension: 210, friction: 20 },
  slow: { tension: 280, friction: 60 },
  molasses: { tension: 280, friction: 120 }
}, LC = {
  ...fAe.default,
  mass: 1,
  damping: 1,
  easing: BPe.linear,
  clamp: !1
}, pAe = class {
  constructor() {
    this.velocity = 0, Object.assign(this, LC);
  }
};
function hAe(e, t, n) {
  n && (n = { ...n }, e8(n, t), t = { ...n, ...t }), e8(e, t), Object.assign(e, t);
  for (const a in LC)
    e[a] == null && (e[a] = LC[a]);
  let { frequency: r, damping: o } = e;
  const { mass: i } = e;
  return Ve.und(r) || (r < 0.01 && (r = 0.01), o < 0 && (o = 0), e.tension = Math.pow(2 * Math.PI / r, 2) * i, e.friction = 4 * Math.PI * o * i / r), e;
}
function e8(e, t) {
  if (!Ve.und(t.decay))
    e.duration = void 0;
  else {
    const n = !Ve.und(t.tension) || !Ve.und(t.friction);
    (n || !Ve.und(t.frequency) || !Ve.und(t.damping) || !Ve.und(t.mass)) && (e.duration = void 0, e.decay = void 0), n && (e.frequency = void 0);
  }
}
var t8 = [], mAe = class {
  constructor() {
    this.changed = !1, this.values = t8, this.toValues = null, this.fromValues = t8, this.config = new pAe(), this.immediate = !1;
  }
};
function PW(e, { key: t, props: n, defaultProps: r, state: o, actions: i }) {
  return new Promise((a, c) => {
    let l, u, d = kf(n.cancel ?? (r == null ? void 0 : r.cancel), t);
    if (d)
      v();
    else {
      Ve.und(n.pause) || (o.paused = kf(n.pause, t));
      let y = r == null ? void 0 : r.pause;
      y !== !0 && (y = o.paused || kf(y, t)), l = Zr(n.delay || 0, t), y ? (o.resumeQueue.add(h), i.pause()) : (i.resume(), h());
    }
    function f() {
      o.resumeQueue.add(h), o.timeouts.delete(u), u.cancel(), l = u.time - Ct.now();
    }
    function h() {
      l > 0 && !ti.skipAnimation ? (o.delayed = !0, u = Ct.setTimeout(v, l), o.pauseQueue.add(f), o.timeouts.add(u)) : v();
    }
    function v() {
      o.delayed && (o.delayed = !1), o.pauseQueue.delete(f), o.timeouts.delete(u), e <= (o.cancelId || 0) && (d = !0);
      try {
        i.start({ ...n, callId: e, cancel: d }, a);
      } catch (y) {
        c(y);
      }
    }
  });
}
var H3 = (e, t) => t.length == 1 ? t[0] : t.some((n) => n.cancelled) ? xu(e.get()) : t.every((n) => n.noop) ? AW(e.get()) : pi(
  e.get(),
  t.every((n) => n.finished)
), AW = (e) => ({
  value: e,
  noop: !0,
  finished: !0,
  cancelled: !1
}), pi = (e, t, n = !1) => ({
  value: e,
  finished: t,
  cancelled: n
}), xu = (e) => ({
  value: e,
  cancelled: !0,
  finished: !1
});
function IW(e, t, n, r) {
  const { callId: o, parentId: i, onRest: a } = t, { asyncTo: c, promise: l } = n;
  return !i && e === c && !t.reset ? l : n.promise = (async () => {
    n.asyncId = o, n.asyncTo = e;
    const u = $y(
      t,
      (b, x) => (
        // The `onRest` prop is only called when the `runAsync` promise is resolved.
        x === "onRest" ? void 0 : b
      )
    );
    let d, f;
    const h = new Promise(
      (b, x) => (d = b, f = x)
    ), v = (b) => {
      const x = (
        // The `cancel` prop or `stop` method was used.
        o <= (n.cancelId || 0) && xu(r) || // The async `to` prop was replaced.
        o !== n.asyncId && pi(r, !1)
      );
      if (x)
        throw b.result = x, f(b), b;
    }, y = (b, x) => {
      const $ = new n8(), S = new r8();
      return (async () => {
        if (ti.skipAnimation)
          throw yp(n), S.result = pi(r, !1), f(S), S;
        v($);
        const O = Ve.obj(b) ? { ...b } : { ...x, to: b };
        O.parentId = o, da(u, (T, k) => {
          Ve.und(O[k]) && (O[k] = T);
        });
        const C = await r.start(O);
        return v($), n.paused && await new Promise((T) => {
          n.resumeQueue.add(T);
        }), C;
      })();
    };
    let g;
    if (ti.skipAnimation)
      return yp(n), pi(r, !1);
    try {
      let b;
      Ve.arr(e) ? b = (async (x) => {
        for (const $ of x)
          await y($);
      })(e) : b = Promise.resolve(e(y, r.stop.bind(r))), await Promise.all([b.then(d), h]), g = pi(r.get(), !0, !1);
    } catch (b) {
      if (b instanceof n8)
        g = b.result;
      else if (b instanceof r8)
        g = b.result;
      else
        throw b;
    } finally {
      o == n.asyncId && (n.asyncId = i, n.asyncTo = i ? c : void 0, n.promise = i ? l : void 0);
    }
    return Ve.fun(a) && Ct.batchedUpdates(() => {
      a(g, r, r.item);
    }), g;
  })();
}
function yp(e, t) {
  Ef(e.timeouts, (n) => n.cancel()), e.pauseQueue.clear(), e.resumeQueue.clear(), e.asyncId = e.asyncTo = e.promise = void 0, t && (e.cancelId = t);
}
var n8 = class extends Error {
  constructor() {
    super(
      "An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise."
    );
  }
}, r8 = class extends Error {
  constructor() {
    super("SkipAnimationSignal");
  }
}, jC = (e) => e instanceof V3, gAe = 1, V3 = class extends xW {
  constructor() {
    super(...arguments), this.id = gAe++, this._priority = 0;
  }
  get priority() {
    return this._priority;
  }
  set priority(e) {
    this._priority != e && (this._priority = e, this._onPriorityChange(e));
  }
  /** Get the current value */
  get() {
    const e = Li(this);
    return e && e.getValue();
  }
  /** Create a spring that maps our value to another value */
  to(...e) {
    return ti.to(this, e);
  }
  /** @deprecated Use the `to` method instead. */
  interpolate(...e) {
    return KPe(), ti.to(this, e);
  }
  toJSON() {
    return this.get();
  }
  observerAdded(e) {
    e == 1 && this._attach();
  }
  observerRemoved(e) {
    e == 0 && this._detach();
  }
  /** Called when the first child is added. */
  _attach() {
  }
  /** Called when the last child is removed. */
  _detach() {
  }
  /** Tell our children about our new value */
  _onChange(e, t = !1) {
    pp(this, {
      type: "change",
      parent: this,
      value: e,
      idle: t
    });
  }
  /** Tell our children about our new priority */
  _onPriorityChange(e) {
    this.idle || gy.sort(this), pp(this, {
      type: "priority",
      parent: this,
      priority: e
    });
  }
}, Jc = Symbol.for("SpringPhase"), MW = 1, FC = 2, zC = 4, pO = (e) => (e[Jc] & MW) > 0, hs = (e) => (e[Jc] & FC) > 0, Jd = (e) => (e[Jc] & zC) > 0, o8 = (e, t) => t ? e[Jc] |= FC | MW : e[Jc] &= ~FC, i8 = (e, t) => t ? e[Jc] |= zC : e[Jc] &= ~zC, vAe = class extends V3 {
  constructor(e, t) {
    if (super(), this.animation = new mAe(), this.defaultProps = {}, this._state = {
      paused: !1,
      delayed: !1,
      pauseQueue: /* @__PURE__ */ new Set(),
      resumeQueue: /* @__PURE__ */ new Set(),
      timeouts: /* @__PURE__ */ new Set()
    }, this._pendingCalls = /* @__PURE__ */ new Set(), this._lastCallId = 0, this._lastToId = 0, this._memoizedDuration = 0, !Ve.und(e) || !Ve.und(t)) {
      const n = Ve.obj(e) ? { ...e } : { ...t, from: e };
      Ve.und(n.default) && (n.default = !0), this.start(n);
    }
  }
  /** Equals true when not advancing on each frame. */
  get idle() {
    return !(hs(this) || this._state.asyncTo) || Jd(this);
  }
  get goal() {
    return Xr(this.animation.to);
  }
  get velocity() {
    const e = Li(this);
    return e instanceof Yp ? e.lastVelocity || 0 : e.getPayload().map((t) => t.lastVelocity || 0);
  }
  /**
   * When true, this value has been animated at least once.
   */
  get hasAnimated() {
    return pO(this);
  }
  /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */
  get isAnimating() {
    return hs(this);
  }
  /**
   * When true, all current and future animations are paused.
   */
  get isPaused() {
    return Jd(this);
  }
  /**
   *
   *
   */
  get isDelayed() {
    return this._state.delayed;
  }
  /** Advance the current animation by a number of milliseconds */
  advance(e) {
    let t = !0, n = !1;
    const r = this.animation;
    let { toValues: o } = r;
    const { config: i } = r, a = xy(r.to);
    !a && Wo(r.to) && (o = Nr(Xr(r.to))), r.values.forEach((u, d) => {
      if (u.done)
        return;
      const f = (
        // Animated strings always go from 0 to 1.
        u.constructor == gp ? 1 : a ? a[d].lastPosition : o[d]
      );
      let h = r.immediate, v = f;
      if (!h) {
        if (v = u.lastPosition, i.tension <= 0) {
          u.done = !0;
          return;
        }
        let y = u.elapsedTime += e;
        const g = r.fromValues[d], b = u.v0 != null ? u.v0 : u.v0 = Ve.arr(i.velocity) ? i.velocity[d] : i.velocity;
        let x;
        const $ = i.precision || (g == f ? 5e-3 : Math.min(1, Math.abs(f - g) * 1e-3));
        if (Ve.und(i.duration))
          if (i.decay) {
            const S = i.decay === !0 ? 0.998 : i.decay, O = Math.exp(-(1 - S) * y);
            v = g + b / (1 - S) * (1 - O), h = Math.abs(u.lastPosition - v) <= $, x = b * O;
          } else {
            x = u.lastVelocity == null ? b : u.lastVelocity;
            const S = i.restVelocity || $ / 10, O = i.clamp ? 0 : i.bounce, C = !Ve.und(O), T = g == f ? u.v0 > 0 : g < f;
            let k, I = !1;
            const P = 1, _ = Math.ceil(e / P);
            for (let A = 0; A < _ && (k = Math.abs(x) > S, !(!k && (h = Math.abs(f - v) <= $, h))); ++A) {
              C && (I = v == f || v > f == T, I && (x = -x * O, v = f));
              const D = -i.tension * 1e-6 * (v - f), M = -i.friction * 1e-3 * x, N = (D + M) / i.mass;
              x = x + N * P, v = v + x * P;
            }
          }
        else {
          let S = 1;
          i.duration > 0 && (this._memoizedDuration !== i.duration && (this._memoizedDuration = i.duration, u.durationProgress > 0 && (u.elapsedTime = i.duration * u.durationProgress, y = u.elapsedTime += e)), S = (i.progress || 0) + y / this._memoizedDuration, S = S > 1 ? 1 : S < 0 ? 0 : S, u.durationProgress = S), v = g + i.easing(S) * (f - g), x = (v - u.lastPosition) / e, h = S == 1;
        }
        u.lastVelocity = x, Number.isNaN(v) && (console.warn("Got NaN while animating:", this), h = !0);
      }
      a && !a[d].done && (h = !1), h ? u.done = !0 : t = !1, u.setValue(v, i.round) && (n = !0);
    });
    const c = Li(this), l = c.getValue();
    if (t) {
      const u = Xr(r.to);
      (l !== u || n) && !i.decay ? (c.setValue(u), this._onChange(u)) : n && i.decay && this._onChange(l), this._stop();
    } else n && this._onChange(l);
  }
  /** Set the current value, while stopping the current animation */
  set(e) {
    return Ct.batchedUpdates(() => {
      this._stop(), this._focus(e), this._set(e);
    }), this;
  }
  /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */
  pause() {
    this._update({ pause: !0 });
  }
  /** Resume the animation if paused. */
  resume() {
    this._update({ pause: !1 });
  }
  /** Skip to the end of the current animation. */
  finish() {
    if (hs(this)) {
      const { to: e, config: t } = this.animation;
      Ct.batchedUpdates(() => {
        this._onStart(), t.decay || this._set(e, !1), this._stop();
      });
    }
    return this;
  }
  /** Push props into the pending queue. */
  update(e) {
    return (this.queue || (this.queue = [])).push(e), this;
  }
  start(e, t) {
    let n;
    return Ve.und(e) ? (n = this.queue || [], this.queue = []) : n = [Ve.obj(e) ? e : { ...t, to: e }], Promise.all(
      n.map((r) => this._update(r))
    ).then((r) => H3(this, r));
  }
  /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */
  stop(e) {
    const { to: t } = this.animation;
    return this._focus(this.get()), yp(this._state, e && this._lastCallId), Ct.batchedUpdates(() => this._stop(t, e)), this;
  }
  /** Restart the animation. */
  reset() {
    this._update({ reset: !0 });
  }
  /** @internal */
  eventObserved(e) {
    e.type == "change" ? this._start() : e.type == "priority" && (this.priority = e.priority + 1);
  }
  /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */
  _prepareNode(e) {
    const t = this.key || "";
    let { to: n, from: r } = e;
    n = Ve.obj(n) ? n[t] : n, (n == null || NC(n)) && (n = void 0), r = Ve.obj(r) ? r[t] : r, r == null && (r = void 0);
    const o = { to: n, from: r };
    return pO(this) || (e.reverse && ([n, r] = [r, n]), r = Xr(r), Ve.und(r) ? Li(this) || this._set(n) : this._set(r)), o;
  }
  /** Every update is processed by this method before merging. */
  _update({ ...e }, t) {
    const { key: n, defaultProps: r } = this;
    e.default && Object.assign(
      r,
      $y(
        e,
        (a, c) => /^on/.test(c) ? EW(a, n) : a
      )
    ), s8(this, e, "onProps"), ef(this, "onProps", e, this);
    const o = this._prepareNode(e);
    if (Object.isFrozen(this))
      throw Error(
        "Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?"
      );
    const i = this._state;
    return PW(++this._lastCallId, {
      key: n,
      props: e,
      defaultProps: r,
      state: i,
      actions: {
        pause: () => {
          Jd(this) || (i8(this, !0), df(i.pauseQueue), ef(
            this,
            "onPause",
            pi(this, Qd(this, this.animation.to)),
            this
          ));
        },
        resume: () => {
          Jd(this) && (i8(this, !1), hs(this) && this._resume(), df(i.resumeQueue), ef(
            this,
            "onResume",
            pi(this, Qd(this, this.animation.to)),
            this
          ));
        },
        start: this._merge.bind(this, o)
      }
    }).then((a) => {
      if (e.loop && a.finished && !(t && a.noop)) {
        const c = NW(e);
        if (c)
          return this._update(c, !0);
      }
      return a;
    });
  }
  /** Merge props into the current animation */
  _merge(e, t, n) {
    if (t.cancel)
      return this.stop(!0), n(xu(this));
    const r = !Ve.und(e.to), o = !Ve.und(e.from);
    if (r || o)
      if (t.callId > this._lastToId)
        this._lastToId = t.callId;
      else
        return n(xu(this));
    const { key: i, defaultProps: a, animation: c } = this, { to: l, from: u } = c;
    let { to: d = l, from: f = u } = e;
    o && !r && (!t.default || Ve.und(d)) && (d = f), t.reverse && ([d, f] = [f, d]);
    const h = !Aa(f, u);
    h && (c.from = f), f = Xr(f);
    const v = !Aa(d, l);
    v && this._focus(d);
    const y = NC(t.to), { config: g } = c, { decay: b, velocity: x } = g;
    (r || o) && (g.velocity = 0), t.config && !y && hAe(
      g,
      Zr(t.config, i),
      // Avoid calling the same "config" prop twice.
      t.config !== a.config ? Zr(a.config, i) : void 0
    );
    let $ = Li(this);
    if (!$ || Ve.und(d))
      return n(pi(this, !0));
    const S = (
      // When `reset` is undefined, the `from` prop implies `reset: true`,
      // except for declarative updates. When `reset` is defined, there
      // must exist a value to animate from.
      Ve.und(t.reset) ? o && !t.default : !Ve.und(f) && kf(t.reset, i)
    ), O = S ? f : this.get(), C = vp(d), T = Ve.num(C) || Ve.arr(C) || by(C), k = !y && (!T || kf(a.immediate || t.immediate, i));
    if (v) {
      const A = MC(d);
      if (A !== $.constructor)
        if (k)
          $ = this._set(C);
        else
          throw Error(
            `Cannot animate between ${$.constructor.name} and ${A.name}, as the "to" prop suggests`
          );
    }
    const I = $.constructor;
    let P = Wo(d), _ = !1;
    if (!P) {
      const A = S || !pO(this) && h;
      (v || A) && (_ = Aa(vp(O), C), P = !_), (!Aa(c.immediate, k) && !k || !Aa(g.decay, b) || !Aa(g.velocity, x)) && (P = !0);
    }
    if (_ && hs(this) && (c.changed && !S ? P = !0 : P || this._stop(l)), !y && ((P || Wo(l)) && (c.values = $.getPayload(), c.toValues = Wo(d) ? null : I == gp ? [1] : Nr(C)), c.immediate != k && (c.immediate = k, !k && !S && this._set(l)), P)) {
      const { onRest: A } = c;
      vt(bAe, (M) => s8(this, t, M));
      const D = pi(this, Qd(this, l));
      df(this._pendingCalls, D), this._pendingCalls.add(n), c.changed && Ct.batchedUpdates(() => {
        var M;
        c.changed = !S, A == null || A(D, this), S ? Zr(a.onRest, D) : (M = c.onStart) == null || M.call(c, D, this);
      });
    }
    S && this._set(O), y ? n(IW(t.to, t, this._state, this)) : P ? this._start() : hs(this) && !v ? this._pendingCalls.add(n) : n(AW(O));
  }
  /** Update the `animation.to` value, which might be a `FluidValue` */
  _focus(e) {
    const t = this.animation;
    e !== t.to && (K6(this) && this._detach(), t.to = e, K6(this) && this._attach());
  }
  _attach() {
    let e = 0;
    const { to: t } = this.animation;
    Wo(t) && (ud(t, this), jC(t) && (e = t.priority + 1)), this.priority = e;
  }
  _detach() {
    const { to: e } = this.animation;
    Wo(e) && hp(e, this);
  }
  /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */
  _set(e, t = !0) {
    const n = Xr(e);
    if (!Ve.und(n)) {
      const r = Li(this);
      if (!r || !Aa(n, r.getValue())) {
        const o = MC(n);
        !r || r.constructor != o ? U3(this, o.create(n)) : r.setValue(n), r && Ct.batchedUpdates(() => {
          this._onChange(n, t);
        });
      }
    }
    return Li(this);
  }
  _onStart() {
    const e = this.animation;
    e.changed || (e.changed = !0, ef(
      this,
      "onStart",
      pi(this, Qd(this, e.to)),
      this
    ));
  }
  _onChange(e, t) {
    t || (this._onStart(), Zr(this.animation.onChange, e, this)), Zr(this.defaultProps.onChange, e, this), super._onChange(e, t);
  }
  // This method resets the animation state (even if already animating) to
  // ensure the latest from/to range is used, and it also ensures this spring
  // is added to the frameloop.
  _start() {
    const e = this.animation;
    Li(this).reset(Xr(e.to)), e.immediate || (e.fromValues = e.values.map((t) => t.lastPosition)), hs(this) || (o8(this, !0), Jd(this) || this._resume());
  }
  _resume() {
    ti.skipAnimation ? this.finish() : gy.start(this);
  }
  /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */
  _stop(e, t) {
    if (hs(this)) {
      o8(this, !1);
      const n = this.animation;
      vt(n.values, (o) => {
        o.done = !0;
      }), n.toValues && (n.onChange = n.onPause = n.onResume = void 0), pp(this, {
        type: "idle",
        parent: this
      });
      const r = t ? xu(this.get()) : pi(this.get(), Qd(this, e ?? n.to));
      df(this._pendingCalls, r), n.changed && (n.changed = !1, ef(this, "onRest", r, this));
    }
  }
};
function Qd(e, t) {
  const n = vp(t), r = vp(e.get());
  return Aa(r, n);
}
function NW(e, t = e.loop, n = e.to) {
  const r = Zr(t);
  if (r) {
    const o = r !== !0 && W3(r), i = (o || e).reverse, a = !o || o.reset;
    return bp({
      ...e,
      loop: t,
      // Avoid updating default props when looping.
      default: !1,
      // Never loop the `pause` prop.
      pause: void 0,
      // For the "reverse" prop to loop as expected, the "to" prop
      // must be undefined. The "reverse" prop is ignored when the
      // "to" prop is an array or function.
      to: !i || NC(n) ? n : void 0,
      // Ignore the "from" prop except on reset.
      from: a ? e.from : void 0,
      reset: a,
      // The "loop" prop can return a "useSpring" props object to
      // override any of the original props.
      ...o
    });
  }
}
function bp(e) {
  const { to: t, from: n } = e = W3(e), r = /* @__PURE__ */ new Set();
  return Ve.obj(t) && a8(t, r), Ve.obj(n) && a8(n, r), e.keys = r.size ? Array.from(r) : null, e;
}
function yAe(e) {
  const t = bp(e);
  return Ve.und(t.default) && (t.default = $y(t)), t;
}
function a8(e, t) {
  da(e, (n, r) => n != null && t.add(r));
}
var bAe = [
  "onStart",
  "onRest",
  "onChange",
  "onPause",
  "onResume"
];
function s8(e, t, n) {
  e.animation[n] = t[n] !== _W(t, n) ? EW(t[n], e.key) : void 0;
}
function ef(e, t, ...n) {
  var r, o, i, a;
  (o = (r = e.animation)[t]) == null || o.call(r, ...n), (a = (i = e.defaultProps)[t]) == null || a.call(i, ...n);
}
var xAe = ["onStart", "onChange", "onRest"], wAe = 1, DW = class {
  constructor(e, t) {
    this.id = wAe++, this.springs = {}, this.queue = [], this._lastAsyncId = 0, this._active = /* @__PURE__ */ new Set(), this._changed = /* @__PURE__ */ new Set(), this._started = !1, this._state = {
      paused: !1,
      pauseQueue: /* @__PURE__ */ new Set(),
      resumeQueue: /* @__PURE__ */ new Set(),
      timeouts: /* @__PURE__ */ new Set()
    }, this._events = {
      onStart: /* @__PURE__ */ new Map(),
      onChange: /* @__PURE__ */ new Map(),
      onRest: /* @__PURE__ */ new Map()
    }, this._onFrame = this._onFrame.bind(this), t && (this._flush = t), e && this.start({ default: !0, ...e });
  }
  /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */
  get idle() {
    return !this._state.asyncTo && Object.values(this.springs).every((e) => e.idle && !e.isDelayed && !e.isPaused);
  }
  get item() {
    return this._item;
  }
  set item(e) {
    this._item = e;
  }
  /** Get the current values of our springs */
  get() {
    const e = {};
    return this.each((t, n) => e[n] = t.get()), e;
  }
  /** Set the current values without animating. */
  set(e) {
    for (const t in e) {
      const n = e[t];
      Ve.und(n) || this.springs[t].set(n);
    }
  }
  /** Push an update onto the queue of each value. */
  update(e) {
    return e && this.queue.push(bp(e)), this;
  }
  /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */
  start(e) {
    let { queue: t } = this;
    return e ? t = Nr(e).map(bp) : this.queue = [], this._flush ? this._flush(this, t) : (BW(this, t), BC(this, t));
  }
  /** @internal */
  stop(e, t) {
    if (e !== !!e && (t = e), t) {
      const n = this.springs;
      vt(Nr(t), (r) => n[r].stop(!!e));
    } else
      yp(this._state, this._lastAsyncId), this.each((n) => n.stop(!!e));
    return this;
  }
  /** Freeze the active animation in time */
  pause(e) {
    if (Ve.und(e))
      this.start({ pause: !0 });
    else {
      const t = this.springs;
      vt(Nr(e), (n) => t[n].pause());
    }
    return this;
  }
  /** Resume the animation if paused. */
  resume(e) {
    if (Ve.und(e))
      this.start({ pause: !1 });
    else {
      const t = this.springs;
      vt(Nr(e), (n) => t[n].resume());
    }
    return this;
  }
  /** Call a function once per spring value */
  each(e) {
    da(this.springs, e);
  }
  /** @internal Called at the end of every animation frame */
  _onFrame() {
    const { onStart: e, onChange: t, onRest: n } = this._events, r = this._active.size > 0, o = this._changed.size > 0;
    (r && !this._started || o && !this._started) && (this._started = !0, Ef(e, ([c, l]) => {
      l.value = this.get(), c(l, this, this._item);
    }));
    const i = !r && this._started, a = o || i && n.size ? this.get() : null;
    o && t.size && Ef(t, ([c, l]) => {
      l.value = a, c(l, this, this._item);
    }), i && (this._started = !1, Ef(n, ([c, l]) => {
      l.value = a, c(l, this, this._item);
    }));
  }
  /** @internal */
  eventObserved(e) {
    if (e.type == "change")
      this._changed.add(e.parent), e.idle || this._active.add(e.parent);
    else if (e.type == "idle")
      this._active.delete(e.parent);
    else
      return;
    Ct.onFrame(this._onFrame);
  }
};
function BC(e, t) {
  return Promise.all(t.map((n) => LW(e, n))).then(
    (n) => H3(e, n)
  );
}
async function LW(e, t, n) {
  const { keys: r, to: o, from: i, loop: a, onRest: c, onResolve: l } = t, u = Ve.obj(t.default) && t.default;
  a && (t.loop = !1), o === !1 && (t.to = null), i === !1 && (t.from = null);
  const d = Ve.arr(o) || Ve.fun(o) ? o : void 0;
  d ? (t.to = void 0, t.onRest = void 0, u && (u.onRest = void 0)) : vt(xAe, (g) => {
    const b = t[g];
    if (Ve.fun(b)) {
      const x = e._events[g];
      t[g] = ({ finished: $, cancelled: S }) => {
        const O = x.get(b);
        O ? ($ || (O.finished = !1), S && (O.cancelled = !0)) : x.set(b, {
          value: null,
          finished: $ || !1,
          cancelled: S || !1
        });
      }, u && (u[g] = t[g]);
    }
  });
  const f = e._state;
  t.pause === !f.paused ? (f.paused = t.pause, df(t.pause ? f.pauseQueue : f.resumeQueue)) : f.paused && (t.pause = !0);
  const h = (r || Object.keys(e.springs)).map(
    (g) => e.springs[g].start(t)
  ), v = t.cancel === !0 || _W(t, "cancel") === !0;
  (d || v && f.asyncId) && h.push(
    PW(++e._lastAsyncId, {
      props: t,
      state: f,
      actions: {
        pause: PC,
        resume: PC,
        start(g, b) {
          v ? (yp(f, e._lastAsyncId), b(xu(e))) : (g.onRest = c, b(
            IW(
              d,
              g,
              f,
              e
            )
          ));
        }
      }
    })
  ), f.paused && await new Promise((g) => {
    f.resumeQueue.add(g);
  });
  const y = H3(e, await Promise.all(h));
  if (a && y.finished && !(n && y.noop)) {
    const g = NW(t, a, o);
    if (g)
      return BW(e, [g]), LW(e, g, !0);
  }
  return l && Ct.batchedUpdates(() => l(y, e, e.item)), y;
}
function qC(e, t) {
  const n = { ...e.springs };
  return t && vt(Nr(t), (r) => {
    Ve.und(r.keys) && (r = bp(r)), Ve.obj(r.to) || (r = { ...r, to: void 0 }), zW(n, r, (o) => FW(o));
  }), jW(e, n), n;
}
function jW(e, t) {
  da(t, (n, r) => {
    e.springs[r] || (e.springs[r] = n, ud(n, e));
  });
}
function FW(e, t) {
  const n = new vAe();
  return n.key = e, t && ud(n, t), n;
}
function zW(e, t, n) {
  t.keys && vt(t.keys, (r) => {
    (e[r] || (e[r] = n(r)))._prepareNode(t);
  });
}
function BW(e, t) {
  vt(t, (n) => {
    zW(e.springs, n, (r) => FW(r, e));
  });
}
var Gp = ({
  children: e,
  ...t
}) => {
  const n = pa(N0), r = t.pause || !!n.pause, o = t.immediate || !!n.immediate;
  t = QPe(() => ({ pause: r, immediate: o }), [r, o]);
  const { Provider: i } = N0;
  return /* @__PURE__ */ E.createElement(i, { value: t }, e);
}, N0 = $Ae(Gp, {});
Gp.Provider = N0.Provider;
Gp.Consumer = N0.Consumer;
function $Ae(e, t) {
  return Object.assign(e, E.createContext(t)), e.Provider._context = e, e.Consumer._context = e, e;
}
var qW = () => {
  const e = [], t = function(r) {
    ZPe();
    const o = [];
    return vt(e, (i, a) => {
      if (Ve.und(r))
        o.push(i.start());
      else {
        const c = n(r, i, a);
        c && o.push(i.start(c));
      }
    }), o;
  };
  t.current = e, t.add = function(r) {
    e.includes(r) || e.push(r);
  }, t.delete = function(r) {
    const o = e.indexOf(r);
    ~o && e.splice(o, 1);
  }, t.pause = function() {
    return vt(e, (r) => r.pause(...arguments)), this;
  }, t.resume = function() {
    return vt(e, (r) => r.resume(...arguments)), this;
  }, t.set = function(r) {
    vt(e, (o, i) => {
      const a = Ve.fun(r) ? r(i, o) : r;
      a && o.set(a);
    });
  }, t.start = function(r) {
    const o = [];
    return vt(e, (i, a) => {
      if (Ve.und(r))
        o.push(i.start());
      else {
        const c = this._getProps(r, i, a);
        c && o.push(i.start(c));
      }
    }), o;
  }, t.stop = function() {
    return vt(e, (r) => r.stop(...arguments)), this;
  }, t.update = function(r) {
    return vt(e, (o, i) => o.update(this._getProps(r, o, i))), this;
  };
  const n = function(r, o, i) {
    return Ve.fun(r) ? r(i, o) : r;
  };
  return t._getProps = n, t;
};
function OAe(e, t, n) {
  const r = Ve.fun(t) && t;
  r && !n && (n = []);
  const o = Nn(
    () => r || arguments.length == 3 ? qW() : void 0,
    []
  ), i = Gt(0), a = B3(), c = Nn(
    () => ({
      ctrls: [],
      queue: [],
      flush(x, $) {
        const S = qC(x, $);
        return i.current > 0 && !c.queue.length && !Object.keys(S).some((C) => !x.springs[C]) ? BC(x, $) : new Promise((C) => {
          jW(x, S), c.queue.push(() => {
            C(BC(x, $));
          }), a();
        });
      }
    }),
    []
  ), l = Gt([...c.ctrls]), u = [], d = IC(e) || 0;
  Nn(() => {
    vt(l.current.slice(e, d), (x) => {
      DC(x, o), x.stop(!0);
    }), l.current.length = e, f(d, e);
  }, [e]), Nn(() => {
    f(0, Math.min(d, e));
  }, n);
  function f(x, $) {
    for (let S = x; S < $; S++) {
      const O = l.current[S] || (l.current[S] = new DW(null, c.flush)), C = r ? r(S, O) : t[S];
      C && (u[S] = yAe(C));
    }
  }
  const h = l.current.map((x, $) => qC(x, u[$])), v = pa(Gp), y = IC(v), g = v !== y && kW(v);
  Rs(() => {
    i.current++, c.ctrls = l.current;
    const { queue: x } = c;
    x.length && (c.queue = [], vt(x, ($) => $())), vt(l.current, ($, S) => {
      o == null || o.add($), g && $.start({ default: v });
      const O = u[S];
      O && (RW($, O.ref), $.ref ? $.queue.push(O) : $.start(O));
    });
  }), q3(() => () => {
    vt(c.ctrls, (x) => x.stop(!0));
  });
  const b = h.map((x) => ({ ...x }));
  return o ? [b, o] : b;
}
function UW(e, t) {
  const n = Ve.fun(e), [[r], o] = OAe(
    1,
    n ? e : [e],
    n ? [] : t
  );
  return n || arguments.length == 2 ? [r, o] : r;
}
function Kp(e, t, n) {
  const r = Ve.fun(t) && t, {
    reset: o,
    sort: i,
    trail: a = 0,
    expires: c = !0,
    exitBeforeEnter: l = !1,
    onDestroyed: u,
    ref: d,
    config: f
  } = r ? r() : t, h = Nn(
    () => r || arguments.length == 3 ? qW() : void 0,
    []
  ), v = Nr(e), y = [], g = Gt(null), b = o ? null : g.current;
  Rs(() => {
    g.current = y;
  }), q3(() => (vt(y, (N) => {
    h == null || h.add(N.ctrl), N.ctrl.ref = h;
  }), () => {
    vt(g.current, (N) => {
      N.expired && clearTimeout(N.expirationId), DC(N.ctrl, h), N.ctrl.stop(!0);
    });
  }));
  const x = CAe(v, r ? r() : t, b), $ = o && g.current || [];
  Rs(
    () => vt($, ({ ctrl: N, item: L, key: z }) => {
      DC(N, h), Zr(u, L, z);
    })
  );
  const S = [];
  if (b && vt(b, (N, L) => {
    N.expired ? (clearTimeout(N.expirationId), $.push(N)) : (L = S[L] = x.indexOf(N.key), ~L && (y[L] = N));
  }), vt(v, (N, L) => {
    y[L] || (y[L] = {
      key: x[L],
      item: N,
      phase: "mount",
      ctrl: new DW()
    }, y[L].ctrl.item = N);
  }), S.length) {
    let N = -1;
    const { leave: L } = r ? r() : t;
    vt(S, (z, q) => {
      const W = b[q];
      ~z ? (N = y.indexOf(W), y[N] = { ...W, item: v[z] }) : L && y.splice(++N, 0, W);
    });
  }
  Ve.fun(i) && y.sort((N, L) => i(N.item, L.item));
  let O = -a;
  const C = B3(), T = $y(t), k = /* @__PURE__ */ new Map(), I = Gt(/* @__PURE__ */ new Map()), P = Gt(!1);
  vt(y, (N, L) => {
    const z = N.key, q = N.phase, W = r ? r() : t;
    let U, K;
    const Y = Zr(W.delay || 0, z);
    if (q == "mount")
      U = W.enter, K = "enter";
    else {
      const Z = x.indexOf(z) < 0;
      if (q != "leave")
        if (Z)
          U = W.leave, K = "leave";
        else if (U = W.update)
          K = "update";
        else
          return;
      else if (!Z)
        U = W.enter, K = "enter";
      else
        return;
    }
    if (U = Zr(U, N.item, L), U = Ve.obj(U) ? W3(U) : { to: U }, !U.config) {
      const Z = f || T.config;
      U.config = Zr(Z, N.item, L, K);
    }
    O += a;
    const X = {
      ...T,
      // we need to add our props.delay value you here.
      delay: Y + O,
      ref: d,
      immediate: W.immediate,
      // This prevents implied resets.
      reset: !1,
      // Merge any phase-specific props.
      ...U
    };
    if (K == "enter" && Ve.und(X.from)) {
      const Z = r ? r() : t, ce = Ve.und(Z.initial) || b ? Z.from : Z.initial;
      X.from = Zr(ce, N.item, L);
    }
    const { onResolve: oe } = X;
    X.onResolve = (Z) => {
      Zr(oe, Z);
      const ce = g.current, fe = ce.find((de) => de.key === z);
      if (fe && !(Z.cancelled && fe.phase != "update") && fe.ctrl.idle) {
        const de = ce.every((ne) => ne.ctrl.idle);
        if (fe.phase == "leave") {
          const ne = Zr(c, fe.item);
          if (ne !== !1) {
            const le = ne === !0 ? 0 : ne;
            if (fe.expired = !0, !de && le > 0) {
              le <= 2147483647 && (fe.expirationId = setTimeout(C, le));
              return;
            }
          }
        }
        de && ce.some((ne) => ne.expired) && (I.current.delete(fe), l && (P.current = !0), C());
      }
    };
    const re = qC(N.ctrl, X);
    K === "leave" && l ? I.current.set(N, { phase: K, springs: re, payload: X }) : k.set(N, { phase: K, springs: re, payload: X });
  });
  const _ = pa(Gp), A = IC(_), D = _ !== A && kW(_);
  Rs(() => {
    D && vt(y, (N) => {
      N.ctrl.start({ default: _ });
    });
  }, [_]), vt(k, (N, L) => {
    if (I.current.size) {
      const z = y.findIndex((q) => q.key === L.key);
      y.splice(z, 1);
    }
  }), Rs(
    () => {
      vt(
        I.current.size ? I.current : k,
        ({ phase: N, payload: L }, z) => {
          const { ctrl: q } = z;
          z.phase = N, h == null || h.add(q), D && N == "enter" && q.start({ default: _ }), L && (RW(q, L.ref), (q.ref || h) && !P.current ? q.update(L) : (q.start(L), P.current && (P.current = !1)));
        }
      );
    },
    o ? void 0 : n
  );
  const M = (N) => /* @__PURE__ */ E.createElement(E.Fragment, null, y.map((L, z) => {
    const { springs: q } = k.get(L) || L.ctrl, W = N({ ...q }, L.item, L, z);
    return W && W.type ? /* @__PURE__ */ E.createElement(
      W.type,
      {
        ...W.props,
        key: Ve.str(L.key) || Ve.num(L.key) ? L.key : L.ctrl.id,
        ref: W.ref
      }
    ) : W;
  }));
  return h ? [M, h] : M;
}
var SAe = 1;
function CAe(e, { key: t, keys: n = t }, r) {
  if (n === null) {
    const o = /* @__PURE__ */ new Set();
    return e.map((i) => {
      const a = r && r.find(
        (c) => c.item === i && c.phase !== "leave" && !o.has(c)
      );
      return a ? (o.add(a), a.key) : SAe++;
    });
  }
  return Ve.und(n) ? e : Ve.fun(n) ? e.map(n) : Nr(n);
}
var WW = class extends V3 {
  constructor(e, t) {
    super(), this.source = e, this.idle = !0, this._active = /* @__PURE__ */ new Set(), this.calc = dp(...t);
    const n = this._get(), r = MC(n);
    U3(this, r.create(n));
  }
  advance(e) {
    const t = this._get(), n = this.get();
    Aa(t, n) || (Li(this).setValue(t), this._onChange(t, this.idle)), !this.idle && c8(this._active) && hO(this);
  }
  _get() {
    const e = Ve.arr(this.source) ? this.source.map(Xr) : Nr(Xr(this.source));
    return this.calc(...e);
  }
  _start() {
    this.idle && !c8(this._active) && (this.idle = !1, vt(xy(this), (e) => {
      e.done = !1;
    }), ti.skipAnimation ? (Ct.batchedUpdates(() => this.advance()), hO(this)) : gy.start(this));
  }
  // Observe our sources only when we're observed.
  _attach() {
    let e = 1;
    vt(Nr(this.source), (t) => {
      Wo(t) && ud(t, this), jC(t) && (t.idle || this._active.add(t), e = Math.max(e, t.priority + 1));
    }), this.priority = e, this._start();
  }
  // Stop observing our sources once we have no observers.
  _detach() {
    vt(Nr(this.source), (e) => {
      Wo(e) && hp(e, this);
    }), this._active.clear(), hO(this);
  }
  /** @internal */
  eventObserved(e) {
    e.type == "change" ? e.idle ? this.advance() : (this._active.add(e.parent), this._start()) : e.type == "idle" ? this._active.delete(e.parent) : e.type == "priority" && (this.priority = Nr(this.source).reduce(
      (t, n) => Math.max(t, (jC(n) ? n.priority : 0) + 1),
      0
    ));
  }
};
function TAe(e) {
  return e.idle !== !1;
}
function c8(e) {
  return !e.size || Array.from(e).every(TAe);
}
function hO(e) {
  e.idle || (e.idle = !0, vt(xy(e), (t) => {
    t.done = !0;
  }), pp(e, {
    type: "idle",
    parent: e
  }));
}
var Hu = (e, ...t) => new WW(e, t);
ti.assign({
  createStringInterpolator: OW,
  to: (e, t) => new WW(e, t)
});
var HW = /^--/;
function EAe(e, t) {
  return t == null || typeof t == "boolean" || t === "" ? "" : typeof t == "number" && t !== 0 && !HW.test(e) && !(Rf.hasOwnProperty(e) && Rf[e]) ? t + "px" : ("" + t).trim();
}
var l8 = {};
function _Ae(e, t) {
  if (!e.nodeType || !e.setAttribute)
    return !1;
  const n = e.nodeName === "filter" || e.parentNode && e.parentNode.nodeName === "filter", {
    className: r,
    style: o,
    children: i,
    scrollTop: a,
    scrollLeft: c,
    viewBox: l,
    ...u
  } = t, d = Object.values(u), f = Object.keys(u).map(
    (h) => n || e.hasAttribute(h) ? h : l8[h] || (l8[h] = h.replace(
      /([A-Z])/g,
      // Attributes are written in dash case
      (v) => "-" + v.toLowerCase()
    ))
  );
  i !== void 0 && (e.textContent = i);
  for (const h in o)
    if (o.hasOwnProperty(h)) {
      const v = EAe(h, o[h]);
      HW.test(h) ? e.style.setProperty(h, v) : e.style[h] = v;
    }
  f.forEach((h, v) => {
    e.setAttribute(h, d[v]);
  }), r !== void 0 && (e.className = r), a !== void 0 && (e.scrollTop = a), c !== void 0 && (e.scrollLeft = c), l !== void 0 && e.setAttribute("viewBox", l);
}
var Rf = {
  animationIterationCount: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  // SVG-related properties
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
}, kAe = (e, t) => e + t.charAt(0).toUpperCase() + t.substring(1), RAe = ["Webkit", "Ms", "Moz", "O"];
Rf = Object.keys(Rf).reduce((e, t) => (RAe.forEach((n) => e[kAe(n, t)] = e[t]), e), Rf);
var PAe = /^(matrix|translate|scale|rotate|skew)/, AAe = /^(translate)/, IAe = /^(rotate|skew)/, mO = (e, t) => Ve.num(e) && e !== 0 ? e + t : e, bg = (e, t) => Ve.arr(e) ? e.every((n) => bg(n, t)) : Ve.num(e) ? e === t : parseFloat(e) === t, MAe = class extends wy {
  constructor({ x: e, y: t, z: n, ...r }) {
    const o = [], i = [];
    (e || t || n) && (o.push([e || 0, t || 0, n || 0]), i.push((a) => [
      `translate3d(${a.map((c) => mO(c, "px")).join(",")})`,
      // prettier-ignore
      bg(a, 0)
    ])), da(r, (a, c) => {
      if (c === "transform")
        o.push([a || ""]), i.push((l) => [l, l === ""]);
      else if (PAe.test(c)) {
        if (delete r[c], Ve.und(a))
          return;
        const l = AAe.test(c) ? "px" : IAe.test(c) ? "deg" : "";
        o.push(Nr(a)), i.push(
          c === "rotate3d" ? ([u, d, f, h]) => [
            `rotate3d(${u},${d},${f},${mO(h, l)})`,
            bg(h, 0)
          ] : (u) => [
            `${c}(${u.map((d) => mO(d, l)).join(",")})`,
            bg(u, c.startsWith("scale") ? 1 : 0)
          ]
        );
      }
    }), o.length && (r.transform = new NAe(o, i)), super(r);
  }
}, NAe = class extends xW {
  constructor(e, t) {
    super(), this.inputs = e, this.transforms = t, this._value = null;
  }
  get() {
    return this._value || (this._value = this._get());
  }
  _get() {
    let e = "", t = !0;
    return vt(this.inputs, (n, r) => {
      const o = Xr(n[0]), [i, a] = this.transforms[r](
        Ve.arr(o) ? o : n.map(Xr)
      );
      e += " " + i, t = t && a;
    }), t ? "none" : e;
  }
  // Start observing our inputs once we have an observer.
  observerAdded(e) {
    e == 1 && vt(
      this.inputs,
      (t) => vt(
        t,
        (n) => Wo(n) && ud(n, this)
      )
    );
  }
  // Stop observing our inputs once we have no observers.
  observerRemoved(e) {
    e == 0 && vt(
      this.inputs,
      (t) => vt(
        t,
        (n) => Wo(n) && hp(n, this)
      )
    );
  }
  eventObserved(e) {
    e.type == "change" && (this._value = null), pp(this, e);
  }
}, DAe = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
];
ti.assign({
  batchedUpdates: nl.unstable_batchedUpdates,
  createStringInterpolator: OW,
  colors: _Pe
});
var LAe = sAe(DAe, {
  applyAnimatedValues: _Ae,
  createAnimatedStyle: (e) => new MAe(e),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getComponentProps: ({ scrollTop: e, scrollLeft: t, ...n }) => n
}), dl = LAe.animated;
const Xp = (e) => {
  const {
    dispatch: t
  } = E.useContext(ga), {
    setHighlighted: n,
    clearHighlighted: r
  } = iy();
  return (i) => ({
    onPointerEnter: () => {
      t({
        type: "enterItem",
        data: i
      }), n({
        seriesId: i.seriesId,
        dataIndex: i.dataIndex
      });
    },
    onPointerLeave: (u) => {
      u.currentTarget.hasPointerCapture(u.pointerId) && u.currentTarget.releasePointerCapture(u.pointerId), t({
        type: "leaveItem",
        data: i
      }), r();
    },
    onPointerDown: (u) => {
      u.currentTarget.hasPointerCapture(u.pointerId) && u.currentTarget.releasePointerCapture(u.pointerId);
    }
  });
}, Y3 = /* @__PURE__ */ E.createContext({
  isInitialized: !1,
  data: {
    skipAnimation: void 0
  }
});
process.env.NODE_ENV !== "production" && (Y3.displayName = "AnimationContext");
function jAe(e) {
  const {
    children: t,
    skipAnimation: n
  } = e, r = typeof window > "u" || !(window != null && window.matchMedia), [o, i] = E.useState(r || void 0);
  Rs(() => {
    var u;
    if (r)
      return;
    const c = (d) => {
      const f = d.matches || void 0;
      i(f), ti.assign({
        skipAnimation: f
      });
    }, l = window.matchMedia("(prefers-reduced-motion)");
    return c(l), (u = l == null ? void 0 : l.addEventListener) == null || u.call(l, "change", c), () => {
      var d;
      (d = l == null ? void 0 : l.removeEventListener) == null || d.call(l, "change", c);
    };
  }, []);
  const a = E.useMemo(() => ({
    isInitialized: !0,
    data: {
      // If dev sets `skipAnimation` to true, it will skip all animations.
      // If dev sets `skipAnimation` to false, it will use user's preference.
      skipAnimation: n || o
    }
  }), [o, n]);
  return /* @__PURE__ */ F.jsx(Y3.Provider, {
    value: a,
    children: t
  });
}
function Oy(e) {
  const {
    isInitialized: t,
    data: n
  } = E.useContext(Y3);
  if (!t)
    throw new Error(["MUI X: Could not find the animation ref context.", "It looks like you rendered your component outside of a ChartsContainer parent component."].join(`
`));
  return e || n.skipAnimation;
}
function Zl(e) {
  return e instanceof Date ? e.getTime() : e;
}
const FAe = (e) => {
  const t = T3(), n = ro(), {
    xAxis: r,
    yAxis: o,
    xAxisIds: i,
    yAxisIds: a
  } = oo(), {
    dispatch: c
  } = E.useContext(ga), l = i[0], u = a[0], d = E.useRef({
    isInChart: !1,
    x: -1,
    y: -1
  });
  E.useEffect(() => {
    const f = t.current;
    if (f === null || e)
      return () => {
      };
    function h(b, x) {
      const {
        scale: $,
        data: S,
        reverse: O
      } = b;
      if (!Zc($)) {
        const T = $.invert(x);
        if (S === void 0)
          return {
            value: T,
            index: -1
          };
        const k = Zl(T), I = S == null ? void 0 : S.findIndex((P, _) => {
          const A = Zl(P);
          return A > k && (_ === 0 || Math.abs(k - A) <= Math.abs(k - Zl(S[_ - 1]))) || A <= k && (_ === S.length - 1 || Math.abs(Zl(T) - A) < Math.abs(Zl(T) - Zl(S[_ + 1])));
        });
        return {
          value: I !== void 0 && I >= 0 ? S[I] : T,
          index: I
        };
      }
      const C = $.bandwidth() === 0 ? Math.floor((x - Math.min(...$.range()) + $.step() / 2) / $.step()) : Math.floor((x - Math.min(...$.range())) / $.step());
      if (C < 0 || C >= S.length)
        return null;
      if (O) {
        const T = S.length - 1 - C;
        return {
          index: T,
          value: S[T]
        };
      }
      return {
        index: C,
        value: S[C]
      };
    }
    const v = () => {
      d.current = {
        isInChart: !1,
        x: -1,
        y: -1
      }, c({
        type: "exitChart"
      });
    }, y = (b) => {
      const x = "targetTouches" in b ? b.targetTouches[0] : b, $ = bPe(f, x);
      if (d.current.x = $.x, d.current.y = $.y, !n.isPointInside($, {
        targetElement: b.target
      })) {
        d.current.isInChart && (c({
          type: "exitChart"
        }), d.current.isInChart = !1);
        return;
      }
      d.current.isInChart = !0;
      const S = h(r[l], $.x), O = h(o[u], $.y);
      c({
        type: "updateAxis",
        data: {
          x: S,
          y: O
        }
      });
    }, g = (b) => {
      const x = b.currentTarget;
      x && x.hasPointerCapture(b.pointerId) && x.releasePointerCapture(b.pointerId);
    };
    return f.addEventListener("pointerdown", g), f.addEventListener("pointermove", y), f.addEventListener("pointerout", v), f.addEventListener("pointercancel", v), f.addEventListener("pointerleave", v), () => {
      f.removeEventListener("pointerdown", g), f.removeEventListener("pointermove", y), f.removeEventListener("pointerout", v), f.removeEventListener("pointercancel", v), f.removeEventListener("pointerleave", v);
    };
  }, [t, c, u, o, l, r, e, n]);
}, zAe = ["children", "width", "height", "viewBox", "disableAxisListener", "className", "title", "desc"], BAe = Pe("svg", {
  name: "MuiChartsSurface",
  slot: "Root"
})(() => ({
  // This prevents default touch actions when using the svg on mobile devices.
  // For example, prevent page scroll & zoom.
  touchAction: "none"
})), VW = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = Ga({
    props: t,
    name: "MuiChartsSurface"
  }), {
    children: o,
    width: i,
    height: a,
    viewBox: c,
    disableAxisListener: l = !1,
    className: u,
    title: d,
    desc: f
  } = r, h = Bt(r, zAe), v = ge({
    width: i,
    height: a,
    x: 0,
    y: 0
  }, c);
  return FAe(l), /* @__PURE__ */ F.jsxs(BAe, ge({
    width: i,
    height: a,
    viewBox: `${v.x} ${v.y} ${v.width} ${v.height}`,
    ref: n,
    className: u
  }, h, {
    children: [/* @__PURE__ */ F.jsx("title", {
      children: d
    }), /* @__PURE__ */ F.jsx("desc", {
      children: f
    }), o]
  }));
});
process.env.NODE_ENV !== "production" && (VW.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: s.node,
  className: s.string,
  desc: s.string,
  /**
   * If `true`, the charts will not listen to the mouse move event.
   * It might break interactive features, but will improve performance.
   * @default false
   */
  disableAxisListener: s.bool,
  /**
   * The height of the chart in px.
   */
  height: s.number.isRequired,
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  title: s.string,
  viewBox: s.shape({
    height: s.number,
    width: s.number,
    x: s.number,
    y: s.number
  }),
  /**
   * The width of the chart in px.
   */
  width: s.number.isRequired
});
function u8(e) {
  const {
    isReversed: t,
    gradientId: n,
    size: r,
    direction: o,
    scale: i,
    colorMap: a
  } = e;
  return /* @__PURE__ */ F.jsx("linearGradient", {
    id: n,
    x1: "0",
    x2: "0",
    y1: "0",
    y2: "0",
    [`${o}${t ? 1 : 2}`]: `${r}px`,
    gradientUnits: "userSpaceOnUse",
    children: a.thresholds.map((c, l) => {
      const u = i(c);
      if (u === void 0)
        return null;
      const d = t ? 1 - u / r : u / r;
      return /* @__PURE__ */ F.jsxs(E.Fragment, {
        children: [/* @__PURE__ */ F.jsx("stop", {
          offset: d,
          stopColor: a.colors[l],
          stopOpacity: 1
        }), /* @__PURE__ */ F.jsx("stop", {
          offset: d,
          stopColor: a.colors[l + 1],
          stopOpacity: 1
        })]
      }, c.toString() + l);
    })
  });
}
function G3() {
  const {
    chartId: e
  } = E.useContext(ld);
  return E.useCallback((t, n) => `${e}-gradient-${n}-${t}`, [e]);
}
function qAe() {
  const {
    top: e,
    height: t,
    bottom: n,
    left: r,
    width: o,
    right: i
  } = ro(), a = e + t + n, c = r + o + i, l = G3(), {
    xAxisIds: u,
    xAxis: d,
    yAxisIds: f,
    yAxis: h
  } = oo();
  return /* @__PURE__ */ F.jsxs("defs", {
    children: [f.filter((v) => h[v].colorMap !== void 0).map((v) => {
      const y = l(v, "y"), {
        colorMap: g,
        scale: b,
        colorScale: x,
        reverse: $
      } = h[v];
      return (g == null ? void 0 : g.type) === "piecewise" ? /* @__PURE__ */ F.jsx(u8, {
        isReversed: !$,
        scale: b,
        colorMap: g,
        size: a,
        gradientId: y,
        direction: "y"
      }, y) : (g == null ? void 0 : g.type) === "continuous" ? /* @__PURE__ */ F.jsx(B6, {
        isReversed: !$,
        scale: b,
        colorScale: x,
        colorMap: g,
        size: a,
        gradientId: y,
        direction: "y"
      }, y) : null;
    }), u.filter((v) => d[v].colorMap !== void 0).map((v) => {
      const y = l(v, "x"), {
        colorMap: g,
        scale: b,
        reverse: x,
        colorScale: $
      } = d[v];
      return (g == null ? void 0 : g.type) === "piecewise" ? /* @__PURE__ */ F.jsx(u8, {
        isReversed: x,
        scale: b,
        colorMap: g,
        size: c,
        gradientId: y,
        direction: "x"
      }, y) : (g == null ? void 0 : g.type) === "continuous" ? /* @__PURE__ */ F.jsx(B6, {
        isReversed: x,
        scale: b,
        colorScale: $,
        colorMap: g,
        size: c,
        gradientId: y,
        direction: "x"
      }, y) : null;
    })]
  });
}
const d8 = (e, t, n) => {
  const r = n === "x" ? cl : zTe;
  return [...(e == null ? void 0 : e.map((o, i) => ge({
    id: `defaultized-${n}-axis-${i}`
  }, o))) ?? [], ...e === void 0 || e.findIndex(({
    id: o
  }) => o === r) === -1 ? [{
    id: r,
    scaleType: "linear"
  }] : []].map((o) => {
    const i = o.dataKey;
    if (i === void 0 || o.data !== void 0)
      return o;
    if (t === void 0)
      throw new Error(`MUI X: ${n}-axis uses \`dataKey\` but no \`dataset\` is provided.`);
    return ge({}, o, {
      data: t.map((a) => a[i])
    });
  });
}, UAe = (e, t, n) => {
  const r = E.useMemo(() => d8(e, n, "x"), [e, n]), o = E.useMemo(() => d8(t, n, "y"), [t, n]);
  return [r, o];
}, WAe = ["width", "height", "series", "margin", "xAxis", "yAxis", "zAxis", "colors", "dataset", "sx", "title", "desc", "disableAxisListener", "highlightedItem", "onHighlightChange", "plugins", "children", "skipAnimation"], HAe = (e, t) => {
  const {
    width: n,
    height: r,
    series: o,
    margin: i,
    xAxis: a,
    yAxis: c,
    zAxis: l,
    colors: u,
    dataset: d,
    sx: f,
    title: h,
    desc: v,
    disableAxisListener: y,
    highlightedItem: g,
    onHighlightChange: b,
    plugins: x,
    children: $,
    skipAnimation: S
  } = e, O = Bt(e, WAe), C = E.useRef(null), T = JU(t, C), [k, I] = UAe(a, c, d), P = {
    width: n,
    height: r,
    margin: i,
    svgRef: C
  }, _ = {
    skipAnimation: S
  }, A = {
    plugins: x
  }, D = {
    series: o,
    colors: u,
    dataset: d
  }, M = {
    xAxis: k,
    yAxis: I,
    dataset: d
  }, N = {
    zAxis: l,
    dataset: d
  }, L = {
    highlightedItem: g,
    onHighlightChange: b
  }, z = ge({}, O, {
    width: n,
    height: r,
    ref: T,
    sx: f,
    title: h,
    desc: v,
    disableAxisListener: y
  });
  return {
    children: $,
    drawingProviderProps: P,
    seriesProviderProps: D,
    cartesianProviderProps: M,
    zAxisContextProps: N,
    highlightedProviderProps: L,
    chartsSurfaceProps: z,
    pluginProviderProps: A,
    animationProviderProps: _,
    xAxis: k,
    yAxis: I
  };
}, YW = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const {
    children: r,
    drawingProviderProps: o,
    seriesProviderProps: i,
    cartesianProviderProps: a,
    zAxisContextProps: c,
    highlightedProviderProps: l,
    chartsSurfaceProps: u,
    pluginProviderProps: d,
    animationProviderProps: f
  } = HAe(t, n);
  return /* @__PURE__ */ F.jsx(Vke, ge({}, o, {
    children: /* @__PURE__ */ F.jsx(l3e, ge({}, d, {
      children: /* @__PURE__ */ F.jsx(p3e, ge({}, i, {
        children: /* @__PURE__ */ F.jsx(nRe, ge({}, a, {
          children: /* @__PURE__ */ F.jsx(VU, ge({}, c, {
            children: /* @__PURE__ */ F.jsx(zRe, {
              children: /* @__PURE__ */ F.jsx(xU, ge({}, l, {
                children: /* @__PURE__ */ F.jsxs(VW, ge({}, u, {
                  children: [/* @__PURE__ */ F.jsx(qAe, {}), /* @__PURE__ */ F.jsx(jAe, ge({}, f, {
                    children: r
                  }))]
                }))
              }))
            })
          }))
        }))
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" && (YW.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: s.node,
  className: s.string,
  /**
   * Color palette used to colorize multiple series.
   * @default blueberryTwilightPalette
   */
  colors: s.oneOfType([s.arrayOf(s.string), s.func]),
  /**
   * An array of objects that can be used to populate series and axes data using their `dataKey` property.
   */
  dataset: s.arrayOf(s.object),
  desc: s.string,
  /**
   * If `true`, the charts will not listen to the mouse move event.
   * It might break interactive features, but will improve performance.
   * @default false
   */
  disableAxisListener: s.bool,
  /**
   * The height of the chart in px.
   */
  height: s.number.isRequired,
  /**
   * The item currently highlighted. Turns highlighting into a controlled prop.
   */
  highlightedItem: s.shape({
    dataIndex: s.number,
    seriesId: s.oneOfType([s.number, s.string])
  }),
  /**
   * The margin between the SVG and the drawing area.
   * It's used for leaving some space for extra information such as the x- and y-axis or legend.
   * Accepts an object with the optional properties: `top`, `bottom`, `left`, and `right`.
   * @default object Depends on the charts type.
   */
  margin: s.shape({
    bottom: s.number,
    left: s.number,
    right: s.number,
    top: s.number
  }),
  /**
   * The callback fired when the highlighted item changes.
   *
   * @param {HighlightItemData | null} highlightedItem  The newly highlighted item.
   */
  onHighlightChange: s.func,
  /**
   * An array of plugins defining how to preprocess data.
   * If not provided, the container supports line, bar, scatter and pie charts.
   */
  plugins: s.arrayOf(s.object),
  /**
   * The array of series to display.
   * Each type of series has its own specificity.
   * Please refer to the appropriate docs page to learn more about it.
   */
  series: s.arrayOf(s.object).isRequired,
  /**
   * If `true`, animations are skipped.
   * If unset or `false`, the animations respects the user's `prefers-reduced-motion` setting.
   */
  skipAnimation: s.bool,
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  title: s.string,
  viewBox: s.shape({
    height: s.number,
    width: s.number,
    x: s.number,
    y: s.number
  }),
  /**
   * The width of the chart in px.
   */
  width: s.number.isRequired,
  /**
   * The configuration of the x-axes.
   * If not provided, a default axis config is used.
   * An array of [[AxisConfig]] objects.
   */
  xAxis: s.arrayOf(s.shape({
    classes: s.object,
    colorMap: s.oneOfType([s.shape({
      colors: s.arrayOf(s.string).isRequired,
      type: s.oneOf(["ordinal"]).isRequired,
      unknownColor: s.string,
      values: s.arrayOf(s.oneOfType([s.instanceOf(Date), s.number, s.string]).isRequired)
    }), s.shape({
      color: s.oneOfType([s.arrayOf(s.string.isRequired), s.func]).isRequired,
      max: s.oneOfType([s.instanceOf(Date), s.number]),
      min: s.oneOfType([s.instanceOf(Date), s.number]),
      type: s.oneOf(["continuous"]).isRequired
    }), s.shape({
      colors: s.arrayOf(s.string).isRequired,
      thresholds: s.arrayOf(s.oneOfType([s.instanceOf(Date), s.number]).isRequired).isRequired,
      type: s.oneOf(["piecewise"]).isRequired
    })]),
    data: s.array,
    dataKey: s.string,
    disableLine: s.bool,
    disableTicks: s.bool,
    domainLimit: s.oneOfType([s.oneOf(["nice", "strict"]), s.func]),
    fill: s.string,
    hideTooltip: s.bool,
    id: s.oneOfType([s.number, s.string]),
    label: s.string,
    labelFontSize: s.number,
    labelStyle: s.object,
    max: s.oneOfType([s.instanceOf(Date), s.number]),
    min: s.oneOfType([s.instanceOf(Date), s.number]),
    position: s.oneOf(["bottom", "top"]),
    reverse: s.bool,
    scaleType: s.oneOf(["band", "linear", "log", "point", "pow", "sqrt", "time", "utc"]),
    slotProps: s.object,
    slots: s.object,
    stroke: s.string,
    sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
    tickFontSize: s.number,
    tickInterval: s.oneOfType([s.oneOf(["auto"]), s.array, s.func]),
    tickLabelInterval: s.oneOfType([s.oneOf(["auto"]), s.func]),
    tickLabelPlacement: s.oneOf(["middle", "tick"]),
    tickLabelStyle: s.object,
    tickMaxStep: s.number,
    tickMinStep: s.number,
    tickNumber: s.number,
    tickPlacement: s.oneOf(["end", "extremities", "middle", "start"]),
    tickSize: s.number,
    valueFormatter: s.func
  })),
  /**
   * The configuration of the y-axes.
   * If not provided, a default axis config is used.
   * An array of [[AxisConfig]] objects.
   */
  yAxis: s.arrayOf(s.shape({
    classes: s.object,
    colorMap: s.oneOfType([s.shape({
      colors: s.arrayOf(s.string).isRequired,
      type: s.oneOf(["ordinal"]).isRequired,
      unknownColor: s.string,
      values: s.arrayOf(s.oneOfType([s.instanceOf(Date), s.number, s.string]).isRequired)
    }), s.shape({
      color: s.oneOfType([s.arrayOf(s.string.isRequired), s.func]).isRequired,
      max: s.oneOfType([s.instanceOf(Date), s.number]),
      min: s.oneOfType([s.instanceOf(Date), s.number]),
      type: s.oneOf(["continuous"]).isRequired
    }), s.shape({
      colors: s.arrayOf(s.string).isRequired,
      thresholds: s.arrayOf(s.oneOfType([s.instanceOf(Date), s.number]).isRequired).isRequired,
      type: s.oneOf(["piecewise"]).isRequired
    })]),
    data: s.array,
    dataKey: s.string,
    disableLine: s.bool,
    disableTicks: s.bool,
    domainLimit: s.oneOfType([s.oneOf(["nice", "strict"]), s.func]),
    fill: s.string,
    hideTooltip: s.bool,
    id: s.oneOfType([s.number, s.string]),
    label: s.string,
    labelFontSize: s.number,
    labelStyle: s.object,
    max: s.oneOfType([s.instanceOf(Date), s.number]),
    min: s.oneOfType([s.instanceOf(Date), s.number]),
    position: s.oneOf(["left", "right"]),
    reverse: s.bool,
    scaleType: s.oneOf(["band", "linear", "log", "point", "pow", "sqrt", "time", "utc"]),
    slotProps: s.object,
    slots: s.object,
    stroke: s.string,
    sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
    tickFontSize: s.number,
    tickInterval: s.oneOfType([s.oneOf(["auto"]), s.array, s.func]),
    tickLabelInterval: s.oneOfType([s.oneOf(["auto"]), s.func]),
    tickLabelPlacement: s.oneOf(["middle", "tick"]),
    tickLabelStyle: s.object,
    tickMaxStep: s.number,
    tickMinStep: s.number,
    tickNumber: s.number,
    tickPlacement: s.oneOf(["end", "extremities", "middle", "start"]),
    tickSize: s.number,
    valueFormatter: s.func
  })),
  /**
   * The configuration of the z-axes.
   */
  zAxis: s.arrayOf(s.shape({
    colorMap: s.oneOfType([s.shape({
      colors: s.arrayOf(s.string).isRequired,
      type: s.oneOf(["ordinal"]).isRequired,
      unknownColor: s.string,
      values: s.arrayOf(s.oneOfType([s.instanceOf(Date), s.number, s.string]).isRequired)
    }), s.shape({
      color: s.oneOfType([s.arrayOf(s.string.isRequired), s.func]).isRequired,
      max: s.oneOfType([s.instanceOf(Date), s.number]),
      min: s.oneOfType([s.instanceOf(Date), s.number]),
      type: s.oneOf(["continuous"]).isRequired
    }), s.shape({
      colors: s.arrayOf(s.string).isRequired,
      thresholds: s.arrayOf(s.oneOfType([s.instanceOf(Date), s.number]).isRequired).isRequired,
      type: s.oneOf(["piecewise"]).isRequired
    })]),
    data: s.array,
    dataKey: s.string,
    id: s.string,
    max: s.number,
    min: s.number
  }))
});
const VAe = Pe("div", {
  name: "MuiResponsiveChart",
  slot: "Container"
})(({
  ownerState: e
}) => ({
  width: e.width ?? "100%",
  height: e.height ?? "100%",
  display: "flex",
  position: "relative",
  flexGrow: 1,
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  "&>svg": {
    width: "100%",
    height: "100%"
  }
})), YAe = (e, t, n) => {
  const r = E.useRef({
    displayError: !1,
    initialCompute: !0,
    computeRun: 0
  }), o = E.useRef(null), [i, a] = E.useState(0), [c, l] = E.useState(0), u = E.useCallback(() => {
    const d = o == null ? void 0 : o.current;
    if (!d)
      return {};
    const h = wRe(d).getComputedStyle(d), v = Math.floor(parseFloat(h.height)) || 0, y = Math.floor(parseFloat(h.width)) || 0;
    return a(y), l(v), {
      width: y,
      height: v
    };
  }, []);
  return E.useEffect(() => {
    r.current.displayError = !0;
  }, []), TC(() => {
    if (!n || !r.current.initialCompute || r.current.computeRun > 20)
      return;
    const d = u();
    d.width !== i || d.height !== c ? r.current.computeRun += 1 : r.current.initialCompute && (r.current.initialCompute = !1);
  }, [i, c, u, n]), TC(() => {
    if (e !== void 0 && t !== void 0)
      return () => {
      };
    u();
    const d = o.current;
    if (typeof ResizeObserver > "u")
      return () => {
      };
    let f;
    const h = new ResizeObserver(() => {
      f = requestAnimationFrame(() => {
        u();
      });
    });
    return d && h.observe(d), () => {
      f && cancelAnimationFrame(f), d && h.unobserve(d);
    };
  }, [u, t, e]), process.env.NODE_ENV !== "production" && (r.current.displayError && e === void 0 && i === 0 && (console.error("MUI X: ChartContainer does not have `width` prop, and its container has no `width` defined."), r.current.displayError = !1), r.current.displayError && t === void 0 && c === 0 && (console.error("MUI X: ChartContainer does not have `height` prop, and its container has no `height` defined."), r.current.displayError = !1)), {
    containerRef: o,
    width: e ?? i,
    height: t ?? c
  };
}, GAe = ["width", "height", "resolveSizeBeforeRender", "margin", "children", "series", "colors", "dataset", "desc", "disableAxisListener", "highlightedItem", "onHighlightChange", "plugins", "sx", "title", "viewBox", "xAxis", "yAxis", "zAxis", "skipAnimation"], KAe = (e, t) => {
  const {
    width: n,
    height: r,
    resolveSizeBeforeRender: o,
    margin: i,
    children: a,
    series: c,
    colors: l,
    dataset: u,
    desc: d,
    disableAxisListener: f,
    highlightedItem: h,
    onHighlightChange: v,
    plugins: y,
    sx: g,
    title: b,
    viewBox: x,
    xAxis: $,
    yAxis: S,
    zAxis: O,
    skipAnimation: C
  } = e, T = Bt(e, GAe), {
    containerRef: k,
    width: I,
    height: P
  } = YAe(n, r, o), _ = ge({}, T, {
    ownerState: {
      width: n,
      height: r
    },
    ref: k
  });
  return {
    hasIntrinsicSize: I && P,
    chartContainerProps: {
      margin: i,
      children: a,
      series: c,
      colors: l,
      dataset: u,
      desc: d,
      disableAxisListener: f,
      highlightedItem: h,
      onHighlightChange: v,
      plugins: y,
      sx: g,
      title: b,
      viewBox: x,
      xAxis: $,
      yAxis: S,
      zAxis: O,
      skipAnimation: C,
      width: I,
      height: P,
      ref: t
    },
    resizableChartContainerProps: _
  };
}, K3 = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const {
    hasIntrinsicSize: r,
    chartContainerProps: o,
    resizableChartContainerProps: i
  } = KAe(t, n);
  return /* @__PURE__ */ F.jsx(VAe, ge({}, i, {
    children: r ? /* @__PURE__ */ F.jsx(YW, ge({}, o)) : null
  }));
});
process.env.NODE_ENV !== "production" && (K3.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: s.node,
  className: s.string,
  /**
   * Color palette used to colorize multiple series.
   * @default blueberryTwilightPalette
   */
  colors: s.oneOfType([s.arrayOf(s.string), s.func]),
  /**
   * An array of objects that can be used to populate series and axes data using their `dataKey` property.
   */
  dataset: s.arrayOf(s.object),
  desc: s.string,
  /**
   * If `true`, the charts will not listen to the mouse move event.
   * It might break interactive features, but will improve performance.
   * @default false
   */
  disableAxisListener: s.bool,
  /**
   * The height of the chart in px. If not defined, it takes the height of the parent element.
   */
  height: s.number,
  /**
   * The item currently highlighted. Turns highlighting into a controlled prop.
   */
  highlightedItem: s.shape({
    dataIndex: s.number,
    seriesId: s.oneOfType([s.number, s.string])
  }),
  /**
   * The margin between the SVG and the drawing area.
   * It's used for leaving some space for extra information such as the x- and y-axis or legend.
   * Accepts an object with the optional properties: `top`, `bottom`, `left`, and `right`.
   * @default object Depends on the charts type.
   */
  margin: s.shape({
    bottom: s.number,
    left: s.number,
    right: s.number,
    top: s.number
  }),
  /**
   * The callback fired when the highlighted item changes.
   *
   * @param {HighlightItemData | null} highlightedItem  The newly highlighted item.
   */
  onHighlightChange: s.func,
  /**
   * An array of plugins defining how to preprocess data.
   * If not provided, the container supports line, bar, scatter and pie charts.
   */
  plugins: s.arrayOf(s.object),
  /**
   * The chart will try to wait for the parent container to resolve its size
   * before it renders for the first time.
   *
   * This can be useful in some scenarios where the chart appear to grow after
   * the first render, like when used inside a grid.
   *
   * @default false
   */
  resolveSizeBeforeRender: s.bool,
  /**
   * The array of series to display.
   * Each type of series has its own specificity.
   * Please refer to the appropriate docs page to learn more about it.
   */
  series: s.arrayOf(s.object).isRequired,
  /**
   * If `true`, animations are skipped.
   * If unset or `false`, the animations respects the user's `prefers-reduced-motion` setting.
   */
  skipAnimation: s.bool,
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  title: s.string,
  viewBox: s.shape({
    height: s.number,
    width: s.number,
    x: s.number,
    y: s.number
  }),
  /**
   * The width of the chart in px. If not defined, it takes the width of the parent element.
   */
  width: s.number,
  /**
   * The configuration of the x-axes.
   * If not provided, a default axis config is used.
   * An array of [[AxisConfig]] objects.
   */
  xAxis: s.arrayOf(s.shape({
    classes: s.object,
    colorMap: s.oneOfType([s.shape({
      colors: s.arrayOf(s.string).isRequired,
      type: s.oneOf(["ordinal"]).isRequired,
      unknownColor: s.string,
      values: s.arrayOf(s.oneOfType([s.instanceOf(Date), s.number, s.string]).isRequired)
    }), s.shape({
      color: s.oneOfType([s.arrayOf(s.string.isRequired), s.func]).isRequired,
      max: s.oneOfType([s.instanceOf(Date), s.number]),
      min: s.oneOfType([s.instanceOf(Date), s.number]),
      type: s.oneOf(["continuous"]).isRequired
    }), s.shape({
      colors: s.arrayOf(s.string).isRequired,
      thresholds: s.arrayOf(s.oneOfType([s.instanceOf(Date), s.number]).isRequired).isRequired,
      type: s.oneOf(["piecewise"]).isRequired
    })]),
    data: s.array,
    dataKey: s.string,
    disableLine: s.bool,
    disableTicks: s.bool,
    domainLimit: s.oneOfType([s.oneOf(["nice", "strict"]), s.func]),
    fill: s.string,
    hideTooltip: s.bool,
    id: s.oneOfType([s.number, s.string]),
    label: s.string,
    labelFontSize: s.number,
    labelStyle: s.object,
    max: s.oneOfType([s.instanceOf(Date), s.number]),
    min: s.oneOfType([s.instanceOf(Date), s.number]),
    position: s.oneOf(["bottom", "top"]),
    reverse: s.bool,
    scaleType: s.oneOf(["band", "linear", "log", "point", "pow", "sqrt", "time", "utc"]),
    slotProps: s.object,
    slots: s.object,
    stroke: s.string,
    sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
    tickFontSize: s.number,
    tickInterval: s.oneOfType([s.oneOf(["auto"]), s.array, s.func]),
    tickLabelInterval: s.oneOfType([s.oneOf(["auto"]), s.func]),
    tickLabelPlacement: s.oneOf(["middle", "tick"]),
    tickLabelStyle: s.object,
    tickMaxStep: s.number,
    tickMinStep: s.number,
    tickNumber: s.number,
    tickPlacement: s.oneOf(["end", "extremities", "middle", "start"]),
    tickSize: s.number,
    valueFormatter: s.func
  })),
  /**
   * The configuration of the y-axes.
   * If not provided, a default axis config is used.
   * An array of [[AxisConfig]] objects.
   */
  yAxis: s.arrayOf(s.shape({
    classes: s.object,
    colorMap: s.oneOfType([s.shape({
      colors: s.arrayOf(s.string).isRequired,
      type: s.oneOf(["ordinal"]).isRequired,
      unknownColor: s.string,
      values: s.arrayOf(s.oneOfType([s.instanceOf(Date), s.number, s.string]).isRequired)
    }), s.shape({
      color: s.oneOfType([s.arrayOf(s.string.isRequired), s.func]).isRequired,
      max: s.oneOfType([s.instanceOf(Date), s.number]),
      min: s.oneOfType([s.instanceOf(Date), s.number]),
      type: s.oneOf(["continuous"]).isRequired
    }), s.shape({
      colors: s.arrayOf(s.string).isRequired,
      thresholds: s.arrayOf(s.oneOfType([s.instanceOf(Date), s.number]).isRequired).isRequired,
      type: s.oneOf(["piecewise"]).isRequired
    })]),
    data: s.array,
    dataKey: s.string,
    disableLine: s.bool,
    disableTicks: s.bool,
    domainLimit: s.oneOfType([s.oneOf(["nice", "strict"]), s.func]),
    fill: s.string,
    hideTooltip: s.bool,
    id: s.oneOfType([s.number, s.string]),
    label: s.string,
    labelFontSize: s.number,
    labelStyle: s.object,
    max: s.oneOfType([s.instanceOf(Date), s.number]),
    min: s.oneOfType([s.instanceOf(Date), s.number]),
    position: s.oneOf(["left", "right"]),
    reverse: s.bool,
    scaleType: s.oneOf(["band", "linear", "log", "point", "pow", "sqrt", "time", "utc"]),
    slotProps: s.object,
    slots: s.object,
    stroke: s.string,
    sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
    tickFontSize: s.number,
    tickInterval: s.oneOfType([s.oneOf(["auto"]), s.array, s.func]),
    tickLabelInterval: s.oneOfType([s.oneOf(["auto"]), s.func]),
    tickLabelPlacement: s.oneOf(["middle", "tick"]),
    tickLabelStyle: s.object,
    tickMaxStep: s.number,
    tickMinStep: s.number,
    tickNumber: s.number,
    tickPlacement: s.oneOf(["end", "extremities", "middle", "start"]),
    tickSize: s.number,
    valueFormatter: s.func
  })),
  /**
   * The configuration of the z-axes.
   */
  zAxis: s.arrayOf(s.shape({
    colorMap: s.oneOfType([s.shape({
      colors: s.arrayOf(s.string).isRequired,
      type: s.oneOf(["ordinal"]).isRequired,
      unknownColor: s.string,
      values: s.arrayOf(s.oneOfType([s.instanceOf(Date), s.number, s.string]).isRequired)
    }), s.shape({
      color: s.oneOfType([s.arrayOf(s.string.isRequired), s.func]).isRequired,
      max: s.oneOfType([s.instanceOf(Date), s.number]),
      min: s.oneOfType([s.instanceOf(Date), s.number]),
      type: s.oneOf(["continuous"]).isRequired
    }), s.shape({
      colors: s.arrayOf(s.string).isRequired,
      thresholds: s.arrayOf(s.oneOfType([s.instanceOf(Date), s.number]).isRequired).isRequired,
      type: s.oneOf(["piecewise"]).isRequired
    })]),
    data: s.array,
    dataKey: s.string,
    id: s.string,
    max: s.number,
    min: s.number
  }))
});
const XAe = ["message"], ZAe = Pe("text")(({
  theme: e
}) => ge({}, e.typography.body2, {
  stroke: "none",
  fill: e.palette.text.primary,
  shapeRendering: "crispEdges",
  textAnchor: "middle",
  dominantBaseline: "middle"
}));
function JAe(e) {
  const {
    message: t
  } = e, n = Bt(e, XAe), {
    top: r,
    left: o,
    height: i,
    width: a
  } = ro();
  return /* @__PURE__ */ F.jsx(ZAe, ge({
    x: o + a / 2,
    y: r + i / 2
  }, n, {
    children: t ?? "Loading data…"
  }));
}
const QAe = ["message"], e4e = Pe("text")(({
  theme: e
}) => ge({}, e.typography.body2, {
  stroke: "none",
  fill: e.palette.text.primary,
  shapeRendering: "crispEdges",
  textAnchor: "middle",
  dominantBaseline: "middle"
}));
function t4e(e) {
  const {
    message: t
  } = e, n = Bt(e, QAe), {
    top: r,
    left: o,
    height: i,
    width: a
  } = ro();
  return /* @__PURE__ */ F.jsx(e4e, ge({
    x: o + a / 2,
    y: r + i / 2
  }, n, {
    children: t ?? "No data to display"
  }));
}
function n4e() {
  const e = es();
  return Object.values(e).every((t) => {
    if (!t)
      return !0;
    const {
      series: n,
      seriesOrder: r
    } = t;
    return r.every((o) => n[o].data.length === 0);
  });
}
function GW(e) {
  var n, r, o, i;
  const t = n4e();
  if (e.loading) {
    const a = ((n = e.slots) == null ? void 0 : n.loadingOverlay) ?? JAe;
    return /* @__PURE__ */ F.jsx(a, ge({}, (r = e.slotProps) == null ? void 0 : r.loadingOverlay));
  }
  if (t) {
    const a = ((o = e.slots) == null ? void 0 : o.noDataOverlay) ?? t4e;
    return /* @__PURE__ */ F.jsx(a, ge({}, (i = e.slotProps) == null ? void 0 : i.noDataOverlay));
  }
  return null;
}
function r4e(e) {
  const t = E.useRef({
    currentPath: e,
    previousPath: void 0
  });
  return t.current.currentPath !== e && (t.current = {
    currentPath: e,
    previousPath: t.current.currentPath
  }), t.current;
}
const KW = (e) => {
  const t = r4e(e);
  return E.useMemo(() => t.previousPath ? EU(t.previousPath, t.currentPath) : () => t.currentPath, [t.currentPath, t.previousPath]);
};
function XW(e) {
  return e.replace(" ", "_");
}
function ZW(e) {
  const t = ro(), n = GU(), r = Kp([t], {
    from: (i) => ({
      animatedWidth: i.left
    }),
    enter: (i) => ({
      animatedWidth: i.width + i.left + i.right
    }),
    leave: (i) => ({
      animatedWidth: i.width + i.left + i.right
    }),
    reset: !1,
    immediate: e.skipAnimation
  }), o = XW(`${n}-${e.id}`);
  return /* @__PURE__ */ F.jsxs(E.Fragment, {
    children: [/* @__PURE__ */ F.jsx("clipPath", {
      id: o,
      children: r((i) => /* @__PURE__ */ F.jsx(dl.rect, {
        x: 0,
        y: 0,
        width: i.animatedWidth,
        height: t.top + t.height + t.bottom
      }))
    }), /* @__PURE__ */ F.jsx("g", {
      clipPath: `url(#${o})`,
      children: e.children
    })]
  });
}
const o4e = ["d", "skipAnimation", "ownerState"], i4e = Pe(dl.path, {
  name: "MuiAreaElement",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  ownerState: e
}) => ({
  stroke: "none",
  fill: e.gradientId && `url(#${e.gradientId})` || e.isHighlighted && Hs(e.color).brighter(1).formatHex() || Hs(e.color).brighter(0.5).formatHex(),
  transition: "opacity 0.2s ease-in, fill 0.2s ease-in",
  opacity: e.isFaded ? 0.3 : 1
}));
function JW(e) {
  const {
    d: t,
    skipAnimation: n,
    ownerState: r
  } = e, o = Bt(e, o4e), i = KW(t), a = Kp([i], {
    from: {
      value: 0
    },
    to: {
      value: 1
    },
    enter: {
      value: 1
    },
    reset: !1,
    immediate: n
  });
  return /* @__PURE__ */ F.jsx(ZW, {
    skipAnimation: n,
    id: `${r.id}-area-clip`,
    children: a((c, l) => /* @__PURE__ */ F.jsx(i4e, ge({}, o, {
      ownerState: r,
      d: c.value.to(l)
    })))
  });
}
process.env.NODE_ENV !== "production" && (JW.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  d: s.string.isRequired,
  ownerState: s.shape({
    classes: s.object,
    color: s.string.isRequired,
    gradientId: s.string,
    id: s.oneOfType([s.number, s.string]).isRequired,
    isFaded: s.bool.isRequired,
    isHighlighted: s.bool.isRequired
  }).isRequired,
  /**
   * If `true`, animations are skipped.
   * @default false
   */
  skipAnimation: s.bool
});
const a4e = ["id", "classes", "color", "gradientId", "slots", "slotProps", "onClick"];
function s4e(e) {
  return oi("MuiAreaElement", e);
}
Ei("MuiAreaElement", ["root", "highlighted", "faded"]);
const c4e = (e) => {
  const {
    classes: t,
    id: n,
    isFaded: r,
    isHighlighted: o
  } = e, i = {
    root: ["root", `series-${n}`, o && "highlighted", r && "faded"]
  };
  return ri(i, s4e, t);
};
function QW(e) {
  const {
    id: t,
    classes: n,
    color: r,
    gradientId: o,
    slots: i,
    slotProps: a,
    onClick: c
  } = e, l = Bt(e, a4e), u = Xp(), {
    isFaded: d,
    isHighlighted: f
  } = ay({
    seriesId: t
  }), h = {
    id: t,
    classes: n,
    color: r,
    gradientId: o,
    isFaded: d,
    isHighlighted: f
  }, v = c4e(h), y = (i == null ? void 0 : i.area) ?? JW, g = bi({
    elementType: y,
    externalSlotProps: a == null ? void 0 : a.area,
    additionalProps: ge({}, u({
      type: "line",
      seriesId: t
    }), {
      onClick: c,
      cursor: c ? "pointer" : "unset"
    }),
    className: v.root,
    ownerState: h
  });
  return /* @__PURE__ */ F.jsx(y, ge({}, l, g));
}
process.env.NODE_ENV !== "production" && (QW.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: s.object,
  color: s.string.isRequired,
  d: s.string.isRequired,
  gradientId: s.string,
  id: s.oneOfType([s.number, s.string]).isRequired,
  /**
   * If `true`, animations are skipped.
   * @default false
   */
  skipAnimation: s.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: s.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: s.object
});
function eH(e) {
  switch (e) {
    case "catmullRom":
      return _Ee.alpha(0.5);
    case "linear":
      return r3;
    case "monotoneX":
      return GD;
    case "monotoneY":
      return kEe;
    case "natural":
      return REe;
    case "step":
      return PEe;
    case "stepBefore":
      return AEe;
    case "stepAfter":
      return IEe;
    default:
      return GD;
  }
}
const l4e = ["slots", "slotProps", "onItemClick", "skipAnimation"], u4e = () => {
  const e = oy(), t = oo();
  return E.useMemo(() => {
    if (e === void 0)
      return [];
    const {
      series: r,
      stackingGroups: o
    } = e, {
      xAxis: i,
      yAxis: a,
      xAxisIds: c,
      yAxisIds: l
    } = t, u = c[0], d = l[0];
    return o.flatMap(({
      ids: f
    }) => [...f].reverse().map((h) => {
      const {
        xAxisId: v,
        yAxisId: y,
        xAxisKey: g = u,
        yAxisKey: b = d,
        stackedData: x,
        data: $,
        connectNulls: S,
        baseline: O
      } = r[h], C = v ?? g, T = y ?? b, k = qu(i[C].scale), I = a[T].scale, P = i[C].data, _ = a[T].colorScale && [T, "y"] || i[C].colorScale && [C, "x"] || void 0;
      if (process.env.NODE_ENV !== "production") {
        if (P === void 0)
          throw new Error(`MUI X: ${C === cl ? "The first `xAxis`" : `The x-axis with id "${C}"`} should have data property to be able to display a line plot.`);
        if (P.length < x.length)
          throw new Error(`MUI X: The data length of the x axis (${P.length} items) is lower than the length of series (${x.length} items).`);
      }
      const A = uEe().x((z) => k(z.x)).defined((z, q) => S || $[q] != null).y0((z) => {
        if (typeof O == "number")
          return I(O);
        if (O === "max")
          return I.range()[1];
        if (O === "min")
          return I.range()[0];
        const q = z.y && I(z.y[0]);
        return Number.isNaN(q) ? I.range()[0] : q;
      }).y1((z) => z.y && I(z.y[1])), D = eH(r[h].curve), M = (P == null ? void 0 : P.map((z, q) => ({
        x: z,
        y: x[q]
      }))) ?? [], N = S ? M.filter((z, q) => $[q] != null) : M, L = A.curve(D)(N) || "";
      return ge({}, r[h], {
        gradientUsed: _,
        d: L,
        seriesId: h
      });
    }));
  }, [e, t]);
};
function tH(e) {
  const {
    slots: t,
    slotProps: n,
    onItemClick: r,
    skipAnimation: o
  } = e, i = Bt(e, l4e), a = Oy(o), c = G3(), l = u4e();
  return /* @__PURE__ */ F.jsx("g", ge({}, i, {
    children: l.map(({
      d: u,
      seriesId: d,
      color: f,
      area: h,
      gradientUsed: v
    }) => !!h && /* @__PURE__ */ F.jsx(QW, {
      id: d,
      d: u,
      color: f,
      gradientId: v && c(...v),
      slots: t,
      slotProps: n,
      onClick: r && ((y) => r(y, {
        type: "line",
        seriesId: d
      })),
      skipAnimation: a
    }, d))
  }));
}
process.env.NODE_ENV !== "production" && (tH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Callback fired when a line area item is clicked.
   * @param {React.MouseEvent<SVGPathElement, MouseEvent>} event The event source of the callback.
   * @param {LineItemIdentifier} lineItemIdentifier The line item identifier.
   */
  onItemClick: s.func,
  /**
   * If `true`, animations are skipped.
   * @default false
   */
  skipAnimation: s.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: s.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: s.object
});
const d4e = ["d", "skipAnimation", "ownerState"], f4e = Pe(dl.path, {
  name: "MuiLineElement",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  ownerState: e
}) => ({
  strokeWidth: 2,
  strokeLinejoin: "round",
  fill: "none",
  stroke: e.gradientId && `url(#${e.gradientId})` || e.isHighlighted && Hs(e.color).brighter(0.5).formatHex() || e.color,
  transition: "opacity 0.2s ease-in, stroke 0.2s ease-in",
  opacity: e.isFaded ? 0.3 : 1
}));
function nH(e) {
  const {
    d: t,
    skipAnimation: n,
    ownerState: r
  } = e, o = Bt(e, d4e), i = KW(t), a = Kp([i], {
    from: {
      value: 0
    },
    to: {
      value: 1
    },
    enter: {
      value: 1
    },
    reset: !1,
    immediate: n
  });
  return /* @__PURE__ */ F.jsx(ZW, {
    skipAnimation: n,
    id: `${r.id}-line-clip`,
    children: a((c, l) => /* @__PURE__ */ F.jsx(f4e, ge({}, o, {
      ownerState: r,
      d: c.value.to(l)
    })))
  });
}
process.env.NODE_ENV !== "production" && (nH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  d: s.string.isRequired,
  ownerState: s.shape({
    classes: s.object,
    color: s.string.isRequired,
    gradientId: s.string,
    id: s.oneOfType([s.number, s.string]).isRequired,
    isFaded: s.bool.isRequired,
    isHighlighted: s.bool.isRequired
  }).isRequired,
  /**
   * If `true`, animations are skipped.
   * @default false
   */
  skipAnimation: s.bool
});
const p4e = ["id", "classes", "color", "gradientId", "slots", "slotProps", "onClick"];
function h4e(e) {
  return oi("MuiLineElement", e);
}
Ei("MuiLineElement", ["root", "highlighted", "faded"]);
const m4e = (e) => {
  const {
    classes: t,
    id: n,
    isFaded: r,
    isHighlighted: o
  } = e, i = {
    root: ["root", `series-${n}`, o && "highlighted", r && "faded"]
  };
  return ri(i, h4e, t);
};
function rH(e) {
  const {
    id: t,
    classes: n,
    color: r,
    gradientId: o,
    slots: i,
    slotProps: a,
    onClick: c
  } = e, l = Bt(e, p4e), u = Xp(), {
    isFaded: d,
    isHighlighted: f
  } = ay({
    seriesId: t
  }), h = {
    id: t,
    classes: n,
    color: r,
    gradientId: o,
    isFaded: d,
    isHighlighted: f
  }, v = m4e(h), y = (i == null ? void 0 : i.line) ?? nH, g = bi({
    elementType: y,
    externalSlotProps: a == null ? void 0 : a.line,
    additionalProps: ge({}, u({
      type: "line",
      seriesId: t
    }), {
      onClick: c,
      cursor: c ? "pointer" : "unset"
    }),
    className: v.root,
    ownerState: h
  });
  return /* @__PURE__ */ F.jsx(y, ge({}, l, g));
}
process.env.NODE_ENV !== "production" && (rH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: s.object,
  color: s.string.isRequired,
  d: s.string.isRequired,
  gradientId: s.string,
  id: s.oneOfType([s.number, s.string]).isRequired,
  /**
   * If `true`, animations are skipped.
   * @default false
   */
  skipAnimation: s.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: s.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: s.object
});
const g4e = ["slots", "slotProps", "skipAnimation", "onItemClick"], v4e = () => {
  const e = oy(), t = oo();
  return E.useMemo(() => {
    if (e === void 0)
      return [];
    const {
      series: r,
      stackingGroups: o
    } = e, {
      xAxis: i,
      yAxis: a,
      xAxisIds: c,
      yAxisIds: l
    } = t, u = c[0], d = l[0];
    return o.flatMap(({
      ids: f
    }) => f.flatMap((h) => {
      const {
        xAxisId: v,
        yAxisId: y,
        xAxisKey: g = u,
        yAxisKey: b = d,
        stackedData: x,
        data: $,
        connectNulls: S
      } = r[h], O = v ?? g, C = y ?? b, T = qu(i[O].scale), k = a[C].scale, I = i[O].data, P = a[C].colorScale && [C, "y"] || i[O].colorScale && [O, "x"] || void 0;
      if (process.env.NODE_ENV !== "production") {
        if (I === void 0)
          throw new Error(`MUI X: ${O === cl ? "The first `xAxis`" : `The x-axis with id "${O}"`} should have data property to be able to display a line plot.`);
        if (I.length < x.length)
          throw new Error(`MUI X: The data length of the x axis (${I.length} items) is lower than the length of series (${x.length} items).`);
      }
      const _ = iU().x((N) => T(N.x)).defined((N, L) => S || $[L] != null).y((N) => k(N.y[1])), A = (I == null ? void 0 : I.map((N, L) => ({
        x: N,
        y: x[L]
      }))) ?? [], D = S ? A.filter((N, L) => $[L] != null) : A, M = _.curve(eH(r[h].curve))(D) || "";
      return ge({}, r[h], {
        gradientUsed: P,
        d: M,
        seriesId: h
      });
    }));
  }, [e, t]);
};
function oH(e) {
  const {
    slots: t,
    slotProps: n,
    skipAnimation: r,
    onItemClick: o
  } = e, i = Bt(e, g4e), a = Oy(r), c = G3(), l = v4e();
  return /* @__PURE__ */ F.jsx("g", ge({}, i, {
    children: l.map(({
      d: u,
      seriesId: d,
      color: f,
      gradientUsed: h
    }) => /* @__PURE__ */ F.jsx(rH, {
      id: d,
      d: u,
      color: f,
      gradientId: h && c(...h),
      skipAnimation: a,
      slots: t,
      slotProps: n,
      onClick: o && ((v) => o(v, {
        type: "line",
        seriesId: d
      }))
    }, d))
  }));
}
process.env.NODE_ENV !== "production" && (oH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Callback fired when a line item is clicked.
   * @param {React.MouseEvent<SVGPathElement, MouseEvent>} event The event source of the callback.
   * @param {LineItemIdentifier} lineItemIdentifier The line item identifier.
   */
  onItemClick: s.func,
  /**
   * If `true`, animations are skipped.
   * @default false
   */
  skipAnimation: s.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: s.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: s.object
});
function y4e(e) {
  return oi("MuiMarkElement", e);
}
Ei("MuiMarkElement", ["root", "highlighted", "faded"]);
const iH = (e) => {
  const {
    classes: t,
    id: n,
    isFaded: r,
    isHighlighted: o
  } = e, i = {
    root: ["root", `series-${n}`, o && "highlighted", r && "faded"]
  };
  return ri(i, y4e, t);
}, b4e = ["x", "y", "id", "classes", "color", "dataIndex", "onClick", "skipAnimation", "shape"];
function aH(e) {
  var S;
  const {
    x: t,
    y: n,
    id: r,
    classes: o,
    color: i,
    dataIndex: a,
    onClick: c,
    skipAnimation: l,
    shape: u
  } = e, d = Bt(e, b4e);
  u !== "circle" && Ev([`MUI X: The mark element of your line chart have shape "${u}" which is not supported when using \`experimentalRendering=true\`.`, 'Only "circle" are supported with `experimentalRendering`.'].join(`
`), "error");
  const f = Fr(), h = Xp(), {
    isFaded: v,
    isHighlighted: y
  } = ay({
    seriesId: r
  }), {
    axis: g
  } = E.useContext(ga), b = UW({
    to: {
      x: t,
      y: n
    },
    immediate: l
  }), x = {
    id: r,
    classes: o,
    isHighlighted: ((S = g.x) == null ? void 0 : S.index) === a || y,
    isFaded: v,
    color: i
  }, $ = iH(x);
  return /* @__PURE__ */ F.jsx(dl.circle, ge({}, d, {
    cx: b.x,
    cy: b.y,
    r: 5,
    fill: (f.vars || f).palette.background.paper,
    stroke: i,
    strokeWidth: 2,
    className: $.root,
    onClick: c,
    cursor: c ? "pointer" : "unset"
  }, h({
    type: "line",
    seriesId: r,
    dataIndex: a
  })));
}
process.env.NODE_ENV !== "production" && (aH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: s.object,
  /**
   * The index to the element in the series' data array.
   */
  dataIndex: s.number.isRequired,
  id: s.oneOfType([s.number, s.string]).isRequired,
  /**
   * The shape of the marker.
   */
  shape: s.oneOf(["circle", "cross", "diamond", "square", "star", "triangle", "wye"]).isRequired,
  /**
   * If `true`, animations are skipped.
   * @default false
   */
  skipAnimation: s.bool
});
function x4e(e) {
  return "circle cross diamond square star triangle wye".split(/ /).indexOf(e) || 0;
}
const w4e = ["x", "y", "id", "classes", "color", "shape", "dataIndex", "onClick", "skipAnimation"], $4e = Pe(dl.path, {
  name: "MuiMarkElement",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  ownerState: e,
  theme: t
}) => ({
  fill: (t.vars || t).palette.background.paper,
  stroke: e.color,
  strokeWidth: 2
}));
function sH(e) {
  var $;
  const {
    x: t,
    y: n,
    id: r,
    classes: o,
    color: i,
    shape: a,
    dataIndex: c,
    onClick: l,
    skipAnimation: u
  } = e, d = Bt(e, w4e), f = Xp(), {
    isFaded: h,
    isHighlighted: v
  } = ay({
    seriesId: r
  }), {
    axis: y
  } = E.useContext(ga), g = UW({
    to: {
      x: t,
      y: n
    },
    immediate: u
  }), b = {
    id: r,
    classes: o,
    isHighlighted: (($ = y.x) == null ? void 0 : $.index) === c || v,
    isFaded: h,
    color: i
  }, x = iH(b);
  return /* @__PURE__ */ F.jsx($4e, ge({}, d, {
    style: {
      transform: Hu([g.x, g.y], (S, O) => `translate(${S}px, ${O}px)`),
      transformOrigin: Hu([g.x, g.y], (S, O) => `${S}px ${O}px`)
    },
    ownerState: b,
    className: x.root,
    d: TEe(CEe[x4e(a)])(),
    onClick: l,
    cursor: l ? "pointer" : "unset"
  }, f({
    type: "line",
    seriesId: r,
    dataIndex: c
  })));
}
process.env.NODE_ENV !== "production" && (sH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: s.object,
  /**
   * The index to the element in the series' data array.
   */
  dataIndex: s.number.isRequired,
  id: s.oneOfType([s.number, s.string]).isRequired,
  /**
   * The shape of the marker.
   */
  shape: s.oneOf(["circle", "cross", "diamond", "square", "star", "triangle", "wye"]).isRequired,
  /**
   * If `true`, animations are skipped.
   * @default false
   */
  skipAnimation: s.bool
});
const O4e = ["slots", "slotProps", "skipAnimation", "onItemClick", "experimentalRendering"];
function cH(e) {
  const {
    slots: t,
    slotProps: n,
    skipAnimation: r,
    onItemClick: o,
    experimentalRendering: i
  } = e, a = Bt(e, O4e), c = Oy(r), l = oy(), u = oo(), d = GU(), f = ro(), h = (t == null ? void 0 : t.mark) ?? (i ? aH : sH);
  if (l === void 0)
    return null;
  const {
    series: v,
    stackingGroups: y
  } = l, {
    xAxis: g,
    yAxis: b,
    xAxisIds: x,
    yAxisIds: $
  } = u, S = x[0], O = $[0];
  return /* @__PURE__ */ F.jsx("g", ge({}, a, {
    children: y.flatMap(({
      ids: C
    }) => C.map((T) => {
      const {
        xAxisId: k,
        yAxisId: I,
        xAxisKey: P = S,
        yAxisKey: _ = O,
        stackedData: A,
        data: D,
        showMark: M = !0
      } = v[T];
      if (M === !1)
        return null;
      const N = k ?? P, L = I ?? _, z = qu(g[N].scale), q = b[L].scale, W = g[N].data;
      if (W === void 0)
        throw new Error(`MUI X: ${N === cl ? "The first `xAxis`" : `The x-axis with id "${N}"`} should have data property to be able to display a line plot.`);
      const U = XW(`${d}-${T}-line-clip`), K = i3(v[T], g[N], b[L]);
      return /* @__PURE__ */ F.jsx("g", {
        clipPath: `url(#${U})`,
        children: W == null ? void 0 : W.map((Y, X) => {
          const oe = D[X] == null ? null : A[X][1];
          return {
            x: z(Y),
            y: oe === null ? null : q(oe),
            position: Y,
            value: oe,
            index: X
          };
        }).filter(({
          x: Y,
          y: X,
          index: oe,
          position: re,
          value: Z
        }) => Z === null || X === null || !f.isPointInside({
          x: Y,
          y: X
        }) ? !1 : M === !0 ? !0 : M({
          x: Y,
          y: X,
          index: oe,
          position: re,
          value: Z
        })).map(({
          x: Y,
          y: X,
          index: oe
        }) => /* @__PURE__ */ F.jsx(h, ge({
          id: T,
          dataIndex: oe,
          shape: "circle",
          color: K(oe),
          x: Y,
          y: X,
          skipAnimation: c,
          onClick: o && ((re) => o(re, {
            type: "line",
            seriesId: T,
            dataIndex: oe
          }))
        }, n == null ? void 0 : n.mark), `${T}-${oe}`))
      }, T);
    }))
  }));
}
process.env.NODE_ENV !== "production" && (cH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true` the mark element will only be able to render circle.
   * Giving fewer customization options, but saving around 40ms per 1.000 marks.
   * @default false
   */
  experimentalRendering: s.bool,
  /**
   * Callback fired when a line mark item is clicked.
   * @param {React.MouseEvent<SVGPathElement, MouseEvent>} event The event source of the callback.
   * @param {LineItemIdentifier} lineItemIdentifier The line mark item identifier.
   */
  onItemClick: s.func,
  /**
   * If `true`, animations are skipped.
   * @default false
   */
  skipAnimation: s.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: s.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: s.object
});
const S4e = ["x", "y", "id", "classes", "color"];
function C4e(e) {
  return oi("MuiHighlightElement", e);
}
Ei("MuiHighlightElement", ["root"]);
const T4e = (e) => {
  const {
    classes: t,
    id: n
  } = e, r = {
    root: ["root", `series-${n}`]
  };
  return ri(r, C4e, t);
}, E4e = Pe("circle", {
  name: "MuiHighlightElement",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  ownerState: e
}) => ({
  transform: `translate(${e.x}px, ${e.y}px)`,
  transformOrigin: `${e.x}px ${e.y}px`,
  fill: e.color
}));
function lH(e) {
  const {
    x: t,
    y: n,
    id: r,
    classes: o,
    color: i
  } = e, a = Bt(e, S4e), c = {
    id: r,
    classes: o,
    color: i,
    x: t,
    y: n
  }, l = T4e(c);
  return /* @__PURE__ */ F.jsx(E4e, ge({
    pointerEvents: "none",
    ownerState: c,
    className: l.root,
    cx: 0,
    cy: 0,
    r: a.r === void 0 ? 5 : a.r
  }, a));
}
process.env.NODE_ENV !== "production" && (lH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: s.object,
  id: s.oneOfType([s.number, s.string]).isRequired
});
const _4e = ["slots", "slotProps"];
function uH(e) {
  var $;
  const {
    slots: t,
    slotProps: n
  } = e, r = Bt(e, _4e), o = oy(), i = oo(), a = ro(), {
    axis: c
  } = E.useContext(ga), l = ($ = c.x) == null ? void 0 : $.index;
  if (l === void 0 || o === void 0)
    return null;
  const {
    series: u,
    stackingGroups: d
  } = o, {
    xAxis: f,
    yAxis: h,
    xAxisIds: v,
    yAxisIds: y
  } = i, g = v[0], b = y[0], x = (t == null ? void 0 : t.lineHighlight) ?? lH;
  return /* @__PURE__ */ F.jsx("g", ge({}, r, {
    children: d.flatMap(({
      ids: S
    }) => S.flatMap((O) => {
      const {
        xAxisId: C,
        yAxisId: T,
        xAxisKey: k = g,
        yAxisKey: I = b,
        stackedData: P,
        data: _,
        disableHighlight: A
      } = u[O], D = C ?? k, M = T ?? I;
      if (A || _[l] == null)
        return null;
      const N = qu(f[D].scale), L = h[M].scale, z = f[D].data;
      if (z === void 0)
        throw new Error(`MUI X: ${D === cl ? "The first `xAxis`" : `The x-axis with id "${D}"`} should have data property to be able to display a line plot.`);
      const q = N(z[l]), W = L(P[l][1]);
      if (!a.isPointInside({
        x: q,
        y: W
      }))
        return null;
      const U = i3(u[O], f[D], h[M]);
      return /* @__PURE__ */ F.jsx(x, ge({
        id: O,
        color: U(l),
        x: q,
        y: W
      }, n == null ? void 0 : n.lineHighlight), `${O}`);
    }))
  }));
}
process.env.NODE_ENV !== "production" && (uH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: s.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: s.object
});
const k4e = ["xAxis", "yAxis", "series", "width", "height", "margin", "colors", "dataset", "sx", "tooltip", "onAxisClick", "onAreaClick", "onLineClick", "onMarkClick", "axisHighlight", "disableLineItemHighlight", "legend", "grid", "topAxis", "leftAxis", "rightAxis", "bottomAxis", "children", "slots", "slotProps", "skipAnimation", "loading", "highlightedItem", "onHighlightChange", "className", "experimentalMarkRendering"], R4e = (e) => {
  const {
    xAxis: t,
    yAxis: n,
    series: r,
    width: o,
    height: i,
    margin: a,
    colors: c,
    dataset: l,
    sx: u,
    tooltip: d,
    onAxisClick: f,
    onAreaClick: h,
    onLineClick: v,
    onMarkClick: y,
    axisHighlight: g,
    disableLineItemHighlight: b,
    legend: x,
    grid: $,
    topAxis: S,
    leftAxis: O,
    rightAxis: C,
    bottomAxis: T,
    children: k,
    slots: I,
    slotProps: P,
    skipAnimation: _,
    loading: A,
    highlightedItem: D,
    onHighlightChange: M,
    className: N,
    experimentalMarkRendering: L
  } = e, z = Bt(e, k4e), W = `${YU()}-clip-path`, U = ge({}, z, {
    series: r.map((Se) => ge({
      disableHighlight: !!b,
      type: "line"
    }, Se)),
    width: o,
    height: i,
    margin: a,
    colors: c,
    dataset: l,
    xAxis: t ?? [{
      id: cl,
      scaleType: "point",
      data: Array.from({
        length: Math.max(...r.map((Se) => (Se.data ?? l ?? []).length))
      }, (Se, ue) => ue)
    }],
    yAxis: n,
    sx: u,
    highlightedItem: D,
    onHighlightChange: M,
    disableAxisListener: (d == null ? void 0 : d.trigger) !== "axis" && (g == null ? void 0 : g.x) === "none" && (g == null ? void 0 : g.y) === "none" && !f,
    className: N,
    skipAnimation: _
  }), K = {
    onAxisClick: f
  }, Y = {
    vertical: $ == null ? void 0 : $.vertical,
    horizontal: $ == null ? void 0 : $.horizontal
  }, X = {
    clipPath: `url(#${W})`
  }, oe = {
    id: W
  }, re = {
    slots: I,
    slotProps: P,
    onItemClick: h
  }, Z = {
    slots: I,
    slotProps: P,
    onItemClick: v
  }, ce = {
    slots: I,
    slotProps: P,
    onItemClick: y,
    skipAnimation: _,
    experimentalRendering: L
  }, fe = {
    slots: I,
    slotProps: P,
    loading: A
  }, de = {
    topAxis: S,
    leftAxis: O,
    rightAxis: C,
    bottomAxis: T,
    slots: I,
    slotProps: P
  }, ne = ge({
    x: "line"
  }, g), le = {
    slots: I,
    slotProps: P
  }, ve = ge({}, x, {
    slots: I,
    slotProps: P
  }), G = ge({}, d, {
    slots: I,
    slotProps: P
  });
  return {
    chartContainerProps: U,
    axisClickHandlerProps: K,
    gridProps: Y,
    clipPathProps: oe,
    clipPathGroupProps: X,
    areaPlotProps: re,
    linePlotProps: Z,
    markPlotProps: ce,
    overlayProps: fe,
    chartsAxisProps: de,
    axisHighlightProps: ne,
    lineHighlightPlotProps: le,
    legendProps: ve,
    tooltipProps: G,
    children: k
  };
}, P4e = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = Ga({
    props: t,
    name: "MuiLineChart"
  }), {
    chartContainerProps: o,
    axisClickHandlerProps: i,
    gridProps: a,
    clipPathProps: c,
    clipPathGroupProps: l,
    areaPlotProps: u,
    linePlotProps: d,
    markPlotProps: f,
    overlayProps: h,
    chartsAxisProps: v,
    axisHighlightProps: y,
    lineHighlightPlotProps: g,
    legendProps: b,
    tooltipProps: x,
    children: $
  } = R4e(r);
  return /* @__PURE__ */ F.jsxs(K3, ge({
    ref: n
  }, o, {
    children: [r.onAxisClick && /* @__PURE__ */ F.jsx(uW, ge({}, i)), /* @__PURE__ */ F.jsx(nW, ge({}, a)), /* @__PURE__ */ F.jsxs("g", ge({}, l, {
      children: [/* @__PURE__ */ F.jsx(tH, ge({}, u)), /* @__PURE__ */ F.jsx(oH, ge({}, d)), /* @__PURE__ */ F.jsx(GW, ge({}, h)), /* @__PURE__ */ F.jsx(P3, ge({}, y))]
    })), /* @__PURE__ */ F.jsx(_3, ge({}, v)), /* @__PURE__ */ F.jsx("g", {
      "data-drawing-container": !0,
      children: /* @__PURE__ */ F.jsx(cH, ge({}, f))
    }), /* @__PURE__ */ F.jsx(uH, ge({}, g)), /* @__PURE__ */ F.jsx(R3, ge({}, b)), !r.loading && /* @__PURE__ */ F.jsx(k3, ge({}, x)), /* @__PURE__ */ F.jsx(KU, ge({}, c)), $]
  }));
});
process.env.NODE_ENV !== "production" && (P4e.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The configuration of axes highlight.
   * @see See {@link https://mui.com/x/react-charts/highlighting highlighting docs} for more details.
   * @default { x: 'line' }
   */
  axisHighlight: s.shape({
    x: s.oneOf(["band", "line", "none"]),
    y: s.oneOf(["band", "line", "none"])
  }),
  /**
   * Indicate which axis to display the bottom of the charts.
   * Can be a string (the id of the axis) or an object `ChartsXAxisProps`.
   * @default xAxisIds[0] The id of the first provided axis
   */
  bottomAxis: s.oneOfType([s.object, s.string]),
  children: s.node,
  className: s.string,
  /**
   * Color palette used to colorize multiple series.
   * @default blueberryTwilightPalette
   */
  colors: s.oneOfType([s.arrayOf(s.string), s.func]),
  /**
   * An array of objects that can be used to populate series and axes data using their `dataKey` property.
   */
  dataset: s.arrayOf(s.object),
  desc: s.string,
  /**
   * If `true`, the charts will not listen to the mouse move event.
   * It might break interactive features, but will improve performance.
   * @default false
   */
  disableAxisListener: s.bool,
  /**
   * If `true`, render the line highlight item.
   */
  disableLineItemHighlight: s.bool,
  /**
   * If `true` marks will render `<circle />` instead of `<path />` and drop theme override for faster rendering.
   */
  experimentalMarkRendering: s.bool,
  /**
   * Option to display a cartesian grid in the background.
   */
  grid: s.shape({
    horizontal: s.bool,
    vertical: s.bool
  }),
  /**
   * The height of the chart in px. If not defined, it takes the height of the parent element.
   */
  height: s.number,
  /**
   * The item currently highlighted. Turns highlighting into a controlled prop.
   */
  highlightedItem: s.shape({
    dataIndex: s.number,
    seriesId: s.oneOfType([s.number, s.string])
  }),
  /**
   * Indicate which axis to display the left of the charts.
   * Can be a string (the id of the axis) or an object `ChartsYAxisProps`.
   * @default yAxisIds[0] The id of the first provided axis
   */
  leftAxis: s.oneOfType([s.object, s.string]),
  /**
   * @deprecated Consider using `slotProps.legend` instead.
   */
  legend: s.shape({
    classes: s.object,
    direction: s.oneOf(["column", "row"]),
    hidden: s.bool,
    itemGap: s.number,
    itemMarkHeight: s.number,
    itemMarkWidth: s.number,
    labelStyle: s.object,
    markGap: s.number,
    onItemClick: s.func,
    padding: s.oneOfType([s.number, s.shape({
      bottom: s.number,
      left: s.number,
      right: s.number,
      top: s.number
    })]),
    position: s.shape({
      horizontal: s.oneOf(["left", "middle", "right"]).isRequired,
      vertical: s.oneOf(["bottom", "middle", "top"]).isRequired
    }),
    slotProps: s.object,
    slots: s.object
  }),
  /**
   * If `true`, a loading overlay is displayed.
   * @default false
   */
  loading: s.bool,
  /**
   * The margin between the SVG and the drawing area.
   * It's used for leaving some space for extra information such as the x- and y-axis or legend.
   * Accepts an object with the optional properties: `top`, `bottom`, `left`, and `right`.
   * @default object Depends on the charts type.
   */
  margin: s.shape({
    bottom: s.number,
    left: s.number,
    right: s.number,
    top: s.number
  }),
  /**
   * Callback fired when an area element is clicked.
   */
  onAreaClick: s.func,
  /**
   * The function called for onClick events.
   * The second argument contains information about all line/bar elements at the current mouse position.
   * @param {MouseEvent} event The mouse event recorded on the `<svg/>` element.
   * @param {null | AxisData} data The data about the clicked axis and items associated with it.
   */
  onAxisClick: s.func,
  /**
   * The callback fired when the highlighted item changes.
   *
   * @param {HighlightItemData | null} highlightedItem  The newly highlighted item.
   */
  onHighlightChange: s.func,
  /**
   * Callback fired when a line element is clicked.
   */
  onLineClick: s.func,
  /**
   * Callback fired when a mark element is clicked.
   */
  onMarkClick: s.func,
  /**
   * The chart will try to wait for the parent container to resolve its size
   * before it renders for the first time.
   *
   * This can be useful in some scenarios where the chart appear to grow after
   * the first render, like when used inside a grid.
   *
   * @default false
   */
  resolveSizeBeforeRender: s.bool,
  /**
   * Indicate which axis to display the right of the charts.
   * Can be a string (the id of the axis) or an object `ChartsYAxisProps`.
   * @default null
   */
  rightAxis: s.oneOfType([s.object, s.string]),
  /**
   * The series to display in the line chart.
   * An array of [[LineSeriesType]] objects.
   */
  series: s.arrayOf(s.object).isRequired,
  /**
   * If `true`, animations are skipped.
   * @default false
   */
  skipAnimation: s.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: s.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: s.object,
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  title: s.string,
  /**
   * The configuration of the tooltip.
   * @see See {@link https://mui.com/x/react-charts/tooltip/ tooltip docs} for more details.
   * @default { trigger: 'item' }
   */
  tooltip: s.shape({
    axisContent: s.elementType,
    classes: s.object,
    itemContent: s.elementType,
    slotProps: s.object,
    slots: s.object,
    trigger: s.oneOf(["axis", "item", "none"])
  }),
  /**
   * Indicate which axis to display the top of the charts.
   * Can be a string (the id of the axis) or an object `ChartsXAxisProps`.
   * @default null
   */
  topAxis: s.oneOfType([s.object, s.string]),
  viewBox: s.shape({
    height: s.number,
    width: s.number,
    x: s.number,
    y: s.number
  }),
  /**
   * The width of the chart in px. If not defined, it takes the width of the parent element.
   */
  width: s.number,
  /**
   * The configuration of the x-axes.
   * If not provided, a default axis config is used.
   * An array of [[AxisConfig]] objects.
   */
  xAxis: s.arrayOf(s.shape({
    classes: s.object,
    colorMap: s.oneOfType([s.shape({
      colors: s.arrayOf(s.string).isRequired,
      type: s.oneOf(["ordinal"]).isRequired,
      unknownColor: s.string,
      values: s.arrayOf(s.oneOfType([s.instanceOf(Date), s.number, s.string]).isRequired)
    }), s.shape({
      color: s.oneOfType([s.arrayOf(s.string.isRequired), s.func]).isRequired,
      max: s.oneOfType([s.instanceOf(Date), s.number]),
      min: s.oneOfType([s.instanceOf(Date), s.number]),
      type: s.oneOf(["continuous"]).isRequired
    }), s.shape({
      colors: s.arrayOf(s.string).isRequired,
      thresholds: s.arrayOf(s.oneOfType([s.instanceOf(Date), s.number]).isRequired).isRequired,
      type: s.oneOf(["piecewise"]).isRequired
    })]),
    data: s.array,
    dataKey: s.string,
    disableLine: s.bool,
    disableTicks: s.bool,
    domainLimit: s.oneOfType([s.oneOf(["nice", "strict"]), s.func]),
    fill: s.string,
    hideTooltip: s.bool,
    id: s.oneOfType([s.number, s.string]),
    label: s.string,
    labelFontSize: s.number,
    labelStyle: s.object,
    max: s.oneOfType([s.instanceOf(Date), s.number]),
    min: s.oneOfType([s.instanceOf(Date), s.number]),
    position: s.oneOf(["bottom", "top"]),
    reverse: s.bool,
    scaleType: s.oneOf(["band", "linear", "log", "point", "pow", "sqrt", "time", "utc"]),
    slotProps: s.object,
    slots: s.object,
    stroke: s.string,
    sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
    tickFontSize: s.number,
    tickInterval: s.oneOfType([s.oneOf(["auto"]), s.array, s.func]),
    tickLabelInterval: s.oneOfType([s.oneOf(["auto"]), s.func]),
    tickLabelPlacement: s.oneOf(["middle", "tick"]),
    tickLabelStyle: s.object,
    tickMaxStep: s.number,
    tickMinStep: s.number,
    tickNumber: s.number,
    tickPlacement: s.oneOf(["end", "extremities", "middle", "start"]),
    tickSize: s.number,
    valueFormatter: s.func
  })),
  /**
   * The configuration of the y-axes.
   * If not provided, a default axis config is used.
   * An array of [[AxisConfig]] objects.
   */
  yAxis: s.arrayOf(s.shape({
    classes: s.object,
    colorMap: s.oneOfType([s.shape({
      colors: s.arrayOf(s.string).isRequired,
      type: s.oneOf(["ordinal"]).isRequired,
      unknownColor: s.string,
      values: s.arrayOf(s.oneOfType([s.instanceOf(Date), s.number, s.string]).isRequired)
    }), s.shape({
      color: s.oneOfType([s.arrayOf(s.string.isRequired), s.func]).isRequired,
      max: s.oneOfType([s.instanceOf(Date), s.number]),
      min: s.oneOfType([s.instanceOf(Date), s.number]),
      type: s.oneOf(["continuous"]).isRequired
    }), s.shape({
      colors: s.arrayOf(s.string).isRequired,
      thresholds: s.arrayOf(s.oneOfType([s.instanceOf(Date), s.number]).isRequired).isRequired,
      type: s.oneOf(["piecewise"]).isRequired
    })]),
    data: s.array,
    dataKey: s.string,
    disableLine: s.bool,
    disableTicks: s.bool,
    domainLimit: s.oneOfType([s.oneOf(["nice", "strict"]), s.func]),
    fill: s.string,
    hideTooltip: s.bool,
    id: s.oneOfType([s.number, s.string]),
    label: s.string,
    labelFontSize: s.number,
    labelStyle: s.object,
    max: s.oneOfType([s.instanceOf(Date), s.number]),
    min: s.oneOfType([s.instanceOf(Date), s.number]),
    position: s.oneOf(["left", "right"]),
    reverse: s.bool,
    scaleType: s.oneOf(["band", "linear", "log", "point", "pow", "sqrt", "time", "utc"]),
    slotProps: s.object,
    slots: s.object,
    stroke: s.string,
    sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
    tickFontSize: s.number,
    tickInterval: s.oneOfType([s.oneOf(["auto"]), s.array, s.func]),
    tickLabelInterval: s.oneOfType([s.oneOf(["auto"]), s.func]),
    tickLabelPlacement: s.oneOf(["middle", "tick"]),
    tickLabelStyle: s.object,
    tickMaxStep: s.number,
    tickMinStep: s.number,
    tickNumber: s.number,
    tickPlacement: s.oneOf(["end", "extremities", "middle", "start"]),
    tickSize: s.number,
    valueFormatter: s.func
  }))
});
const A4e = ["classes", "color", "cornerRadius", "dataIndex", "endAngle", "id", "innerRadius", "isFaded", "isHighlighted", "onClick", "outerRadius", "paddingAngle", "startAngle", "highlightScope"];
function I4e(e) {
  return oi("MuiPieArc", e);
}
Ei("MuiPieArc", ["root", "highlighted", "faded"]);
const M4e = (e) => {
  const {
    classes: t,
    id: n,
    isFaded: r,
    isHighlighted: o,
    dataIndex: i
  } = e, a = {
    root: ["root", `series-${n}`, `data-index-${i}`, o && "highlighted", r && "faded"]
  };
  return ri(a, I4e, t);
}, N4e = Pe(dl.path, {
  name: "MuiPieArc",
  slot: "Root",
  overridesResolver: (e, t) => t.arc
})(({
  theme: e
}) => ({
  // Got to move stroke to an element prop instead of style.
  stroke: (e.vars || e).palette.background.paper,
  transition: "opacity 0.2s ease-in, fill 0.2s ease-in, filter 0.2s ease-in"
}));
function dH(e) {
  const {
    classes: t,
    color: n,
    cornerRadius: r,
    dataIndex: o,
    endAngle: i,
    id: a,
    innerRadius: c,
    isFaded: l,
    isHighlighted: u,
    onClick: d,
    outerRadius: f,
    paddingAngle: h,
    startAngle: v
  } = e, y = Bt(e, A4e), g = {
    id: a,
    dataIndex: o,
    classes: t,
    color: n,
    isFaded: l,
    isHighlighted: u
  }, b = M4e(g), x = Xp();
  return /* @__PURE__ */ F.jsx(N4e, ge({
    d: Hu([v, i, h, c, f, r], ($, S, O, C, T, k) => tU().cornerRadius(k)({
      padAngle: O,
      startAngle: $,
      endAngle: S,
      innerRadius: C,
      outerRadius: T
    })),
    visibility: Hu([v, i], ($, S) => $ === S ? "hidden" : "visible"),
    onClick: d,
    cursor: d ? "pointer" : "unset",
    ownerState: g,
    className: b.root,
    fill: g.color,
    opacity: g.isFaded ? 0.3 : 1,
    filter: g.isHighlighted ? "brightness(120%)" : "none",
    strokeWidth: 1,
    strokeLinejoin: "round"
  }, y, x({
    type: "pie",
    seriesId: a,
    dataIndex: o
  })));
}
process.env.NODE_ENV !== "production" && (dH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: s.object,
  dataIndex: s.number.isRequired,
  /**
   * @deprecated Use the `isFaded` or `isHighlighted` props instead.
   */
  highlightScope: s.shape({
    fade: s.oneOf(["global", "none", "series"]),
    faded: s.oneOf(["global", "none", "series"]),
    highlight: s.oneOf(["item", "none", "series"]),
    highlighted: s.oneOf(["item", "none", "series"])
  }),
  id: s.oneOfType([s.number, s.string]).isRequired,
  isFaded: s.bool.isRequired,
  isHighlighted: s.bool.isRequired
});
const D4e = {
  keys: (e) => e.id,
  from: ({
    innerRadius: e,
    outerRadius: t,
    cornerRadius: n,
    startAngle: r,
    endAngle: o,
    paddingAngle: i,
    color: a,
    isFaded: c
  }) => ({
    innerRadius: e,
    outerRadius: (e + t) / 2,
    cornerRadius: n,
    startAngle: (r + o) / 2,
    endAngle: (r + o) / 2,
    paddingAngle: i,
    fill: a,
    opacity: c ? 0.3 : 1
  }),
  leave: ({
    innerRadius: e,
    startAngle: t,
    endAngle: n
  }) => ({
    innerRadius: e,
    outerRadius: e,
    startAngle: (t + n) / 2,
    endAngle: (t + n) / 2
  }),
  enter: ({
    innerRadius: e,
    outerRadius: t,
    startAngle: n,
    endAngle: r
  }) => ({
    innerRadius: e,
    outerRadius: t,
    startAngle: n,
    endAngle: r
  }),
  update: ({
    innerRadius: e,
    outerRadius: t,
    cornerRadius: n,
    startAngle: r,
    endAngle: o,
    paddingAngle: i,
    color: a,
    isFaded: c
  }) => ({
    innerRadius: e,
    outerRadius: t,
    cornerRadius: n,
    startAngle: r,
    endAngle: o,
    paddingAngle: i,
    fill: a,
    opacity: c ? 0.3 : 1
  }),
  config: {
    tension: 120,
    friction: 14,
    clamp: !0
  }
}, L4e = {
  keys: (e) => e.id,
  from: ({
    innerRadius: e,
    outerRadius: t,
    arcLabelRadius: n,
    cornerRadius: r,
    startAngle: o,
    endAngle: i,
    paddingAngle: a
  }) => ({
    innerRadius: e,
    outerRadius: (e + t) / 2,
    cornerRadius: r,
    arcLabelRadius: n,
    startAngle: (o + i) / 2,
    endAngle: (o + i) / 2,
    paddingAngle: a,
    opacity: 0
  }),
  leave: ({
    innerRadius: e,
    startAngle: t,
    endAngle: n
  }) => ({
    innerRadius: e,
    outerRadius: e,
    arcLabelRadius: e,
    startAngle: (t + n) / 2,
    endAngle: (t + n) / 2,
    opacity: 0
  }),
  enter: ({
    innerRadius: e,
    outerRadius: t,
    startAngle: n,
    endAngle: r,
    arcLabelRadius: o
  }) => ({
    innerRadius: e,
    outerRadius: t,
    startAngle: n,
    endAngle: r,
    arcLabelRadius: o,
    opacity: 1
  }),
  update: ({
    innerRadius: e,
    outerRadius: t,
    cornerRadius: n,
    startAngle: r,
    endAngle: o,
    paddingAngle: i,
    arcLabelRadius: a
  }) => ({
    innerRadius: e,
    outerRadius: t,
    cornerRadius: n,
    startAngle: r,
    endAngle: o,
    paddingAngle: i,
    arcLabelRadius: a,
    opacity: 1
  }),
  config: {
    tension: 120,
    friction: 14,
    clamp: !0
  }
};
function fH(e) {
  const {
    id: t,
    data: n,
    faded: r,
    highlighted: o,
    paddingAngle: i = 0,
    innerRadius: a = 0,
    arcLabelRadius: c,
    outerRadius: l,
    cornerRadius: u = 0
  } = e, {
    isFaded: d,
    isHighlighted: f
  } = iy();
  return E.useMemo(() => n.map((v, y) => {
    const g = {
      seriesId: t,
      dataIndex: y
    }, b = f(g), x = !b && d(g), $ = ge({
      additionalRadius: 0
    }, x && r || b && o || {}), S = Math.max(0, Math.PI * ($.paddingAngle ?? i) / 180), O = Math.max(0, $.innerRadius ?? a), C = Math.max(0, $.outerRadius ?? l + $.additionalRadius), T = $.cornerRadius ?? u, k = $.arcLabelRadius ?? c ?? (O + C) / 2;
    return ge({}, v, $, {
      isFaded: x,
      isHighlighted: b,
      paddingAngle: S,
      innerRadius: O,
      outerRadius: C,
      cornerRadius: T,
      arcLabelRadius: k
    });
  }), [u, a, l, i, c, n, r, o, d, f, t]);
}
const j4e = ["slots", "slotProps", "innerRadius", "outerRadius", "cornerRadius", "paddingAngle", "id", "highlighted", "faded", "data", "onItemClick", "skipAnimation"];
function pH(e) {
  const {
    slots: t,
    slotProps: n,
    innerRadius: r = 0,
    outerRadius: o,
    cornerRadius: i = 0,
    paddingAngle: a = 0,
    id: c,
    highlighted: l,
    faded: u = {
      additionalRadius: -5
    },
    data: d,
    onItemClick: f,
    skipAnimation: h
  } = e, v = Bt(e, j4e), y = fH({
    innerRadius: r,
    outerRadius: o,
    cornerRadius: i,
    paddingAngle: a,
    id: c,
    highlighted: l,
    faded: u,
    data: d
  }), g = Kp(y, ge({}, D4e, {
    immediate: h
  })), {
    highlightScope: b
  } = iy();
  if (d.length === 0)
    return null;
  const x = (t == null ? void 0 : t.pieArc) ?? dH;
  return /* @__PURE__ */ F.jsx("g", ge({}, v, {
    children: g(({
      startAngle: $,
      endAngle: S,
      paddingAngle: O,
      innerRadius: C,
      outerRadius: T,
      cornerRadius: k
    }, I, P, _) => /* @__PURE__ */ F.jsx(x, ge({
      startAngle: $,
      endAngle: S,
      paddingAngle: O,
      innerRadius: C,
      outerRadius: T,
      cornerRadius: k,
      id: c,
      color: I.color,
      dataIndex: _,
      highlightScope: b,
      isFaded: I.isFaded,
      isHighlighted: I.isHighlighted,
      onClick: f && ((A) => {
        f(A, {
          type: "pie",
          seriesId: c,
          dataIndex: _
        }, I);
      })
    }, n == null ? void 0 : n.pieArc)))
  }));
}
process.env.NODE_ENV !== "production" && (pH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The radius between circle center and the arc label in px.
   * @default (innerRadius - outerRadius) / 2
   */
  arcLabelRadius: s.number,
  /**
   * The radius applied to arc corners (similar to border radius).
   * @default 0
   */
  cornerRadius: s.number,
  data: s.arrayOf(s.shape({
    color: s.string.isRequired,
    endAngle: s.number.isRequired,
    formattedValue: s.string.isRequired,
    id: s.oneOfType([s.number, s.string]).isRequired,
    index: s.number.isRequired,
    label: s.oneOfType([s.func, s.string]),
    padAngle: s.number.isRequired,
    startAngle: s.number.isRequired,
    value: s.number.isRequired
  })).isRequired,
  /**
   * Override the arc attributes when it is faded.
   * @default { additionalRadius: -5 }
   */
  faded: s.shape({
    additionalRadius: s.number,
    arcLabelRadius: s.number,
    color: s.string,
    cornerRadius: s.number,
    innerRadius: s.number,
    outerRadius: s.number,
    paddingAngle: s.number
  }),
  /**
   * Override the arc attributes when it is highlighted.
   */
  highlighted: s.shape({
    additionalRadius: s.number,
    arcLabelRadius: s.number,
    color: s.string,
    cornerRadius: s.number,
    innerRadius: s.number,
    outerRadius: s.number,
    paddingAngle: s.number
  }),
  id: s.oneOfType([s.number, s.string]).isRequired,
  /**
   * The radius between circle center and the beginning of the arc.
   * @default 0
   */
  innerRadius: s.number,
  /**
   * Callback fired when a pie item is clicked.
   * @param {React.MouseEvent<SVGPathElement, MouseEvent>} event The event source of the callback.
   * @param {PieItemIdentifier} pieItemIdentifier The pie item identifier.
   * @param {DefaultizedPieValueType} item The pie item.
   */
  onItemClick: s.func,
  /**
   * The radius between circle center and the end of the arc.
   */
  outerRadius: s.number.isRequired,
  /**
   * The padding angle (deg) between two arcs.
   * @default 0
   */
  paddingAngle: s.number,
  /**
   * If `true`, animations are skipped.
   * @default false
   */
  skipAnimation: s.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: s.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: s.object
});
const F4e = ["id", "classes", "color", "startAngle", "endAngle", "paddingAngle", "arcLabelRadius", "innerRadius", "outerRadius", "cornerRadius", "formattedArcLabel", "isHighlighted", "isFaded", "style"];
function z4e(e) {
  return oi("MuiPieArcLabel", e);
}
Ei("MuiPieArcLabel", ["root", "highlighted", "faded"]);
const B4e = (e) => {
  const {
    classes: t,
    id: n,
    isFaded: r,
    isHighlighted: o
  } = e, i = {
    root: ["root", `series-${n}`, o && "highlighted", r && "faded"]
  };
  return ri(i, z4e, t);
}, q4e = Pe(dl.text, {
  name: "MuiPieArcLabel",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  fill: (e.vars || e).palette.text.primary,
  textAnchor: "middle",
  dominantBaseline: "middle",
  pointerEvents: "none"
})), f8 = (e, t) => (n, r, o, i, a) => {
  if (!e)
    return 0;
  const [c, l] = tU().cornerRadius(a).centroid({
    padAngle: o,
    startAngle: n,
    endAngle: r,
    innerRadius: i,
    outerRadius: i
  });
  return t === "x" ? c : l;
};
function hH(e) {
  const {
    id: t,
    classes: n,
    color: r,
    startAngle: o,
    endAngle: i,
    paddingAngle: a,
    arcLabelRadius: c,
    cornerRadius: l,
    formattedArcLabel: u,
    isHighlighted: d,
    isFaded: f,
    style: h
  } = e, v = Bt(e, F4e), g = B4e({
    id: t,
    classes: n,
    color: r,
    isFaded: f,
    isHighlighted: d
  });
  return /* @__PURE__ */ F.jsx(q4e, ge({
    className: g.root
  }, v, {
    style: ge({
      x: Hu([o, i, a, c, l], f8(u, "x")),
      y: Hu([o, i, a, c, l], f8(u, "y"))
    }, h),
    children: u
  }));
}
process.env.NODE_ENV !== "production" && (hH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: s.object,
  color: s.string.isRequired,
  formattedArcLabel: s.string,
  id: s.oneOfType([s.number, s.string]).isRequired,
  isFaded: s.bool.isRequired,
  isHighlighted: s.bool.isRequired
});
const U4e = ["arcLabel", "arcLabelMinAngle", "arcLabelRadius", "cornerRadius", "data", "faded", "highlighted", "id", "innerRadius", "outerRadius", "paddingAngle", "skipAnimation", "slotProps", "slots"], W4e = ["startAngle", "endAngle", "paddingAngle", "innerRadius", "outerRadius", "arcLabelRadius", "cornerRadius"], H4e = 180 / Math.PI;
function V4e(e, t, n) {
  var o;
  if (!e || (n.endAngle - n.startAngle) * H4e < t)
    return null;
  switch (e) {
    case "label":
      return yi(n.label, "arc");
    case "value":
      return (o = n.value) == null ? void 0 : o.toString();
    case "formattedValue":
      return n.formattedValue;
    default:
      return e(ge({}, n, {
        label: yi(n.label, "arc")
      }));
  }
}
function mH(e) {
  const {
    arcLabel: t,
    arcLabelMinAngle: n = 0,
    arcLabelRadius: r,
    cornerRadius: o = 0,
    data: i,
    faded: a = {
      additionalRadius: -5
    },
    highlighted: c,
    id: l,
    innerRadius: u,
    outerRadius: d,
    paddingAngle: f = 0,
    skipAnimation: h,
    slotProps: v,
    slots: y
  } = e, g = Bt(e, U4e), b = fH({
    innerRadius: u,
    outerRadius: d,
    arcLabelRadius: r,
    cornerRadius: o,
    paddingAngle: f,
    id: l,
    highlighted: c,
    faded: a,
    data: i
  }), x = Kp(b, ge({}, L4e, {
    immediate: h
  }));
  if (i.length === 0)
    return null;
  const $ = (y == null ? void 0 : y.pieArcLabel) ?? hH;
  return /* @__PURE__ */ F.jsx("g", ge({}, g, {
    children: x((S, O) => {
      let {
        startAngle: C,
        endAngle: T,
        paddingAngle: k,
        innerRadius: I,
        outerRadius: P,
        arcLabelRadius: _,
        cornerRadius: A
      } = S, D = Bt(S, W4e);
      return /* @__PURE__ */ F.jsx($, ge({
        startAngle: C,
        endAngle: T,
        paddingAngle: k,
        innerRadius: I,
        outerRadius: P,
        arcLabelRadius: _,
        cornerRadius: A,
        style: D,
        id: l,
        color: O.color,
        isFaded: O.isFaded,
        isHighlighted: O.isHighlighted,
        formattedArcLabel: V4e(t, n, O)
      }, v == null ? void 0 : v.pieArcLabel));
    })
  }));
}
process.env.NODE_ENV !== "production" && (mH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The label displayed into the arc.
   */
  arcLabel: s.oneOfType([s.oneOf(["formattedValue", "label", "value"]), s.func]),
  /**
   * The minimal angle required to display the arc label.
   * @default 0
   */
  arcLabelMinAngle: s.number,
  /**
   * The radius between circle center and the arc label in px.
   * @default (innerRadius - outerRadius) / 2
   */
  arcLabelRadius: s.number,
  /**
   * The radius applied to arc corners (similar to border radius).
   * @default 0
   */
  cornerRadius: s.number,
  data: s.arrayOf(s.shape({
    color: s.string.isRequired,
    endAngle: s.number.isRequired,
    formattedValue: s.string.isRequired,
    id: s.oneOfType([s.number, s.string]).isRequired,
    index: s.number.isRequired,
    label: s.oneOfType([s.func, s.string]),
    padAngle: s.number.isRequired,
    startAngle: s.number.isRequired,
    value: s.number.isRequired
  })).isRequired,
  /**
   * Override the arc attributes when it is faded.
   * @default { additionalRadius: -5 }
   */
  faded: s.shape({
    additionalRadius: s.number,
    arcLabelRadius: s.number,
    color: s.string,
    cornerRadius: s.number,
    innerRadius: s.number,
    outerRadius: s.number,
    paddingAngle: s.number
  }),
  /**
   * Override the arc attributes when it is highlighted.
   */
  highlighted: s.shape({
    additionalRadius: s.number,
    arcLabelRadius: s.number,
    color: s.string,
    cornerRadius: s.number,
    innerRadius: s.number,
    outerRadius: s.number,
    paddingAngle: s.number
  }),
  id: s.oneOfType([s.number, s.string]).isRequired,
  /**
   * The radius between circle center and the beginning of the arc.
   * @default 0
   */
  innerRadius: s.number,
  /**
   * The radius between circle center and the end of the arc.
   */
  outerRadius: s.number.isRequired,
  /**
   * The padding angle (deg) between two arcs.
   * @default 0
   */
  paddingAngle: s.number,
  /**
   * If `true`, animations are skipped.
   * @default false
   */
  skipAnimation: s.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: s.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: s.object
});
function p8(e, t) {
  const {
    height: n,
    width: r
  } = t, {
    cx: o,
    cy: i
  } = e, a = Math.min(r, n) / 2, c = Oc(o ?? "50%", r), l = Oc(i ?? "50%", n);
  return {
    cx: c,
    cy: l,
    availableRadius: a
  };
}
function gH(e) {
  const {
    skipAnimation: t,
    slots: n,
    slotProps: r,
    onItemClick: o
  } = e, i = h3e(), {
    left: a,
    top: c,
    width: l,
    height: u
  } = E.useContext(ld), d = Oy(t);
  if (i === void 0)
    return null;
  const {
    series: f,
    seriesOrder: h
  } = i;
  return /* @__PURE__ */ F.jsxs("g", {
    children: [h.map((v) => {
      const {
        innerRadius: y,
        outerRadius: g,
        cornerRadius: b,
        paddingAngle: x,
        data: $,
        cx: S,
        cy: O,
        highlighted: C,
        faded: T
      } = f[v], {
        cx: k,
        cy: I,
        availableRadius: P
      } = p8({
        cx: S,
        cy: O
      }, {
        width: l,
        height: u
      }), _ = Oc(g ?? P, P), A = Oc(y ?? 0, P);
      return /* @__PURE__ */ F.jsx("g", {
        transform: `translate(${a + k}, ${c + I})`,
        children: /* @__PURE__ */ F.jsx(pH, {
          innerRadius: A,
          outerRadius: _,
          cornerRadius: b,
          paddingAngle: x,
          id: v,
          data: $,
          skipAnimation: d,
          highlighted: C,
          faded: T,
          onItemClick: o,
          slots: n,
          slotProps: r
        })
      }, v);
    }), h.map((v) => {
      const {
        innerRadius: y,
        outerRadius: g,
        arcLabelRadius: b,
        cornerRadius: x,
        paddingAngle: $,
        arcLabel: S,
        arcLabelMinAngle: O,
        data: C,
        cx: T,
        cy: k
      } = f[v], {
        cx: I,
        cy: P,
        availableRadius: _
      } = p8({
        cx: T,
        cy: k
      }, {
        width: l,
        height: u
      }), A = Oc(g ?? _, _), D = Oc(y ?? 0, _), M = b === void 0 ? (A + D) / 2 : Oc(b, _);
      return /* @__PURE__ */ F.jsx("g", {
        transform: `translate(${a + I}, ${c + P})`,
        children: /* @__PURE__ */ F.jsx(mH, {
          innerRadius: D,
          outerRadius: A ?? _,
          arcLabelRadius: M,
          cornerRadius: x,
          paddingAngle: $,
          id: v,
          data: C,
          skipAnimation: d,
          arcLabel: S,
          arcLabelMinAngle: O,
          slots: n,
          slotProps: r
        })
      }, v);
    })]
  });
}
process.env.NODE_ENV !== "production" && (gH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Callback fired when a pie item is clicked.
   * @param {React.MouseEvent<SVGPathElement, MouseEvent>} event The event source of the callback.
   * @param {PieItemIdentifier} pieItemIdentifier The pie item identifier.
   * @param {DefaultizedPieValueType} item The pie item.
   */
  onItemClick: s.func,
  /**
   * If `true`, animations are skipped.
   * @default false
   */
  skipAnimation: s.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: s.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: s.object
});
const Y4e = ["xAxis", "yAxis", "series", "width", "height", "margin", "colors", "sx", "tooltip", "axisHighlight", "skipAnimation", "legend", "topAxis", "leftAxis", "rightAxis", "bottomAxis", "children", "slots", "slotProps", "onItemClick", "loading", "highlightedItem", "onHighlightChange", "className"], G4e = {
  top: 5,
  bottom: 5,
  left: 5,
  right: 100
}, K4e = {
  top: 5,
  bottom: 5,
  left: 100,
  right: 5
}, X4e = /* @__PURE__ */ E.forwardRef(function(t, n) {
  const r = Ga({
    props: t,
    name: "MuiPieChart"
  }), {
    xAxis: o,
    yAxis: i,
    series: a,
    width: c,
    height: l,
    margin: u,
    colors: d,
    sx: f,
    tooltip: h = {
      trigger: "item"
    },
    axisHighlight: v = {
      x: "none",
      y: "none"
    },
    skipAnimation: y,
    legend: g,
    topAxis: b = null,
    leftAxis: x = null,
    rightAxis: $ = null,
    bottomAxis: S = null,
    children: O,
    slots: C,
    slotProps: T,
    onItemClick: k,
    loading: I,
    highlightedItem: P,
    onHighlightChange: _,
    className: A
  } = r, D = Bt(r, Y4e), M = Ya(), N = ge({}, M ? K4e : G4e, u), L = ge({
    direction: "column",
    position: {
      vertical: "middle",
      horizontal: M ? "left" : "right"
    }
  }, g);
  return /* @__PURE__ */ F.jsxs(K3, ge({}, D, {
    ref: n,
    series: a.map((z) => ge({
      type: "pie"
    }, z)),
    width: c,
    height: l,
    margin: N,
    xAxis: o ?? [{
      id: cl,
      scaleType: "point",
      data: [...new Array(Math.max(...a.map((z) => z.data.length)))].map((z, q) => q)
    }],
    yAxis: i,
    colors: d,
    sx: f,
    disableAxisListener: (h == null ? void 0 : h.trigger) !== "axis" && (v == null ? void 0 : v.x) === "none" && (v == null ? void 0 : v.y) === "none",
    highlightedItem: P,
    onHighlightChange: _,
    className: A,
    skipAnimation: y,
    children: [/* @__PURE__ */ F.jsx(_3, {
      topAxis: b,
      leftAxis: x,
      rightAxis: $,
      bottomAxis: S,
      slots: C,
      slotProps: T
    }), /* @__PURE__ */ F.jsx(gH, {
      slots: C,
      slotProps: T,
      onItemClick: k
    }), /* @__PURE__ */ F.jsx(GW, {
      loading: I,
      slots: C,
      slotProps: T
    }), /* @__PURE__ */ F.jsx(R3, ge({}, L, {
      slots: C,
      slotProps: T
    })), /* @__PURE__ */ F.jsx(P3, ge({}, v)), !I && /* @__PURE__ */ F.jsx(k3, ge({}, h, {
      slots: C,
      slotProps: T
    })), O]
  }));
});
process.env.NODE_ENV !== "production" && (X4e.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The configuration of axes highlight.
   * @see See {@link https://mui.com/x/react-charts/highlighting highlighting docs} for more details.
   * @default { x: 'none', y: 'none' }
   */
  axisHighlight: s.shape({
    x: s.oneOf(["band", "line", "none"]),
    y: s.oneOf(["band", "line", "none"])
  }),
  /**
   * Indicate which axis to display the bottom of the charts.
   * Can be a string (the id of the axis) or an object `ChartsXAxisProps`.
   * @default null
   */
  bottomAxis: s.oneOfType([s.object, s.string]),
  children: s.node,
  className: s.string,
  /**
   * Color palette used to colorize multiple series.
   * @default blueberryTwilightPalette
   */
  colors: s.oneOfType([s.arrayOf(s.string), s.func]),
  /**
   * An array of objects that can be used to populate series and axes data using their `dataKey` property.
   */
  dataset: s.arrayOf(s.object),
  desc: s.string,
  /**
   * If `true`, the charts will not listen to the mouse move event.
   * It might break interactive features, but will improve performance.
   * @default false
   */
  disableAxisListener: s.bool,
  /**
   * The height of the chart in px. If not defined, it takes the height of the parent element.
   */
  height: s.number,
  /**
   * The item currently highlighted. Turns highlighting into a controlled prop.
   */
  highlightedItem: s.shape({
    dataIndex: s.number,
    seriesId: s.oneOfType([s.number, s.string])
  }),
  /**
   * Indicate which axis to display the left of the charts.
   * Can be a string (the id of the axis) or an object `ChartsYAxisProps`.
   * @default null
   */
  leftAxis: s.oneOfType([s.object, s.string]),
  /**
   * The props of the legend.
   * @default { direction: 'column', position: { vertical: 'middle', horizontal: 'right' } }
   * @deprecated Consider using `slotProps.legend` instead.
   */
  legend: s.shape({
    classes: s.object,
    direction: s.oneOf(["column", "row"]),
    hidden: s.bool,
    itemGap: s.number,
    itemMarkHeight: s.number,
    itemMarkWidth: s.number,
    labelStyle: s.object,
    markGap: s.number,
    onItemClick: s.func,
    padding: s.oneOfType([s.number, s.shape({
      bottom: s.number,
      left: s.number,
      right: s.number,
      top: s.number
    })]),
    position: s.shape({
      horizontal: s.oneOf(["left", "middle", "right"]).isRequired,
      vertical: s.oneOf(["bottom", "middle", "top"]).isRequired
    }),
    slotProps: s.object,
    slots: s.object
  }),
  /**
   * If `true`, a loading overlay is displayed.
   * @default false
   */
  loading: s.bool,
  /**
   * The margin between the SVG and the drawing area.
   * It's used for leaving some space for extra information such as the x- and y-axis or legend.
   * Accepts an object with the optional properties: `top`, `bottom`, `left`, and `right`.
   * @default object Depends on the charts type.
   */
  margin: s.shape({
    bottom: s.number,
    left: s.number,
    right: s.number,
    top: s.number
  }),
  /**
   * The callback fired when the highlighted item changes.
   *
   * @param {HighlightItemData | null} highlightedItem  The newly highlighted item.
   */
  onHighlightChange: s.func,
  /**
   * Callback fired when a pie arc is clicked.
   */
  onItemClick: s.func,
  /**
   * The chart will try to wait for the parent container to resolve its size
   * before it renders for the first time.
   *
   * This can be useful in some scenarios where the chart appear to grow after
   * the first render, like when used inside a grid.
   *
   * @default false
   */
  resolveSizeBeforeRender: s.bool,
  /**
   * Indicate which axis to display the right of the charts.
   * Can be a string (the id of the axis) or an object `ChartsYAxisProps`.
   * @default null
   */
  rightAxis: s.oneOfType([s.object, s.string]),
  /**
   * The series to display in the pie chart.
   * An array of [[PieSeriesType]] objects.
   */
  series: s.arrayOf(s.object).isRequired,
  /**
   * If `true`, animations are skipped.
   * If unset or `false`, the animations respects the user's `prefers-reduced-motion` setting.
   */
  skipAnimation: s.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: s.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: s.object,
  sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
  title: s.string,
  /**
   * The configuration of the tooltip.
   * @see See {@link https://mui.com/x/react-charts/tooltip/ tooltip docs} for more details.
   * @default { trigger: 'item' }
   */
  tooltip: s.shape({
    axisContent: s.elementType,
    classes: s.object,
    itemContent: s.elementType,
    slotProps: s.object,
    slots: s.object,
    trigger: s.oneOf(["axis", "item", "none"])
  }),
  /**
   * Indicate which axis to display the top of the charts.
   * Can be a string (the id of the axis) or an object `ChartsXAxisProps`.
   * @default null
   */
  topAxis: s.oneOfType([s.object, s.string]),
  viewBox: s.shape({
    height: s.number,
    width: s.number,
    x: s.number,
    y: s.number
  }),
  /**
   * The width of the chart in px. If not defined, it takes the width of the parent element.
   */
  width: s.number,
  /**
   * The configuration of the x-axes.
   * If not provided, a default axis config is used.
   * An array of [[AxisConfig]] objects.
   */
  xAxis: s.arrayOf(s.shape({
    classes: s.object,
    colorMap: s.oneOfType([s.shape({
      colors: s.arrayOf(s.string).isRequired,
      type: s.oneOf(["ordinal"]).isRequired,
      unknownColor: s.string,
      values: s.arrayOf(s.oneOfType([s.instanceOf(Date), s.number, s.string]).isRequired)
    }), s.shape({
      color: s.oneOfType([s.arrayOf(s.string.isRequired), s.func]).isRequired,
      max: s.oneOfType([s.instanceOf(Date), s.number]),
      min: s.oneOfType([s.instanceOf(Date), s.number]),
      type: s.oneOf(["continuous"]).isRequired
    }), s.shape({
      colors: s.arrayOf(s.string).isRequired,
      thresholds: s.arrayOf(s.oneOfType([s.instanceOf(Date), s.number]).isRequired).isRequired,
      type: s.oneOf(["piecewise"]).isRequired
    })]),
    data: s.array,
    dataKey: s.string,
    disableLine: s.bool,
    disableTicks: s.bool,
    domainLimit: s.oneOfType([s.oneOf(["nice", "strict"]), s.func]),
    fill: s.string,
    hideTooltip: s.bool,
    id: s.oneOfType([s.number, s.string]),
    label: s.string,
    labelFontSize: s.number,
    labelStyle: s.object,
    max: s.oneOfType([s.instanceOf(Date), s.number]),
    min: s.oneOfType([s.instanceOf(Date), s.number]),
    position: s.oneOf(["bottom", "top"]),
    reverse: s.bool,
    scaleType: s.oneOf(["band", "linear", "log", "point", "pow", "sqrt", "time", "utc"]),
    slotProps: s.object,
    slots: s.object,
    stroke: s.string,
    sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
    tickFontSize: s.number,
    tickInterval: s.oneOfType([s.oneOf(["auto"]), s.array, s.func]),
    tickLabelInterval: s.oneOfType([s.oneOf(["auto"]), s.func]),
    tickLabelPlacement: s.oneOf(["middle", "tick"]),
    tickLabelStyle: s.object,
    tickMaxStep: s.number,
    tickMinStep: s.number,
    tickNumber: s.number,
    tickPlacement: s.oneOf(["end", "extremities", "middle", "start"]),
    tickSize: s.number,
    valueFormatter: s.func
  })),
  /**
   * The configuration of the y-axes.
   * If not provided, a default axis config is used.
   * An array of [[AxisConfig]] objects.
   */
  yAxis: s.arrayOf(s.shape({
    classes: s.object,
    colorMap: s.oneOfType([s.shape({
      colors: s.arrayOf(s.string).isRequired,
      type: s.oneOf(["ordinal"]).isRequired,
      unknownColor: s.string,
      values: s.arrayOf(s.oneOfType([s.instanceOf(Date), s.number, s.string]).isRequired)
    }), s.shape({
      color: s.oneOfType([s.arrayOf(s.string.isRequired), s.func]).isRequired,
      max: s.oneOfType([s.instanceOf(Date), s.number]),
      min: s.oneOfType([s.instanceOf(Date), s.number]),
      type: s.oneOf(["continuous"]).isRequired
    }), s.shape({
      colors: s.arrayOf(s.string).isRequired,
      thresholds: s.arrayOf(s.oneOfType([s.instanceOf(Date), s.number]).isRequired).isRequired,
      type: s.oneOf(["piecewise"]).isRequired
    })]),
    data: s.array,
    dataKey: s.string,
    disableLine: s.bool,
    disableTicks: s.bool,
    domainLimit: s.oneOfType([s.oneOf(["nice", "strict"]), s.func]),
    fill: s.string,
    hideTooltip: s.bool,
    id: s.oneOfType([s.number, s.string]),
    label: s.string,
    labelFontSize: s.number,
    labelStyle: s.object,
    max: s.oneOfType([s.instanceOf(Date), s.number]),
    min: s.oneOfType([s.instanceOf(Date), s.number]),
    position: s.oneOf(["left", "right"]),
    reverse: s.bool,
    scaleType: s.oneOf(["band", "linear", "log", "point", "pow", "sqrt", "time", "utc"]),
    slotProps: s.object,
    slots: s.object,
    stroke: s.string,
    sx: s.oneOfType([s.arrayOf(s.oneOfType([s.func, s.object, s.bool])), s.func, s.object]),
    tickFontSize: s.number,
    tickInterval: s.oneOfType([s.oneOf(["auto"]), s.array, s.func]),
    tickLabelInterval: s.oneOfType([s.oneOf(["auto"]), s.func]),
    tickLabelPlacement: s.oneOf(["middle", "tick"]),
    tickLabelStyle: s.object,
    tickMaxStep: s.number,
    tickMinStep: s.number,
    tickNumber: s.number,
    tickPlacement: s.oneOf(["end", "extremities", "middle", "start"]),
    tickSize: s.number,
    valueFormatter: s.func
  }))
});
var gO, h8;
function Z4e() {
  if (h8) return gO;
  h8 = 1;
  var e = mE(), t = od(), n = Iv(), r = Za(), o = id();
  function i(a, c, l, u) {
    if (!r(a))
      return a;
    c = t(c, a);
    for (var d = -1, f = c.length, h = f - 1, v = a; v != null && ++d < f; ) {
      var y = o(c[d]), g = l;
      if (y === "__proto__" || y === "constructor" || y === "prototype")
        return a;
      if (d != h) {
        var b = v[y];
        g = u ? u(b, y, v) : void 0, g === void 0 && (g = r(b) ? b : n(c[d + 1]) ? [] : {});
      }
      e(v, y, g), v = v[y];
    }
    return a;
  }
  return gO = i, gO;
}
var vO, m8;
function J4e() {
  if (m8) return vO;
  m8 = 1;
  var e = Lv(), t = Z4e(), n = od();
  function r(o, i, a) {
    for (var c = -1, l = i.length, u = {}; ++c < l; ) {
      var d = i[c], f = e(o, d);
      a(f, d) && t(u, n(d, o), f);
    }
    return u;
  }
  return vO = r, vO;
}
var yO, g8;
function Q4e() {
  if (g8) return yO;
  g8 = 1;
  var e = J4e(), t = Vq();
  function n(r, o) {
    return e(r, o, function(i, a) {
      return t(r, a);
    });
  }
  return yO = n, yO;
}
var bO, v8;
function e5e() {
  if (v8) return bO;
  v8 = 1;
  var e = Q4e(), t = bz(), n = t(function(r, o) {
    return r == null ? {} : e(r, o);
  });
  return bO = n, bO;
}
var t5e = e5e();
const k9e = /* @__PURE__ */ jn(t5e);
var xO, y8;
function vH() {
  if (y8) return xO;
  y8 = 1;
  var e = TE(), t = vz(), n = yz();
  function r(o, i) {
    return n(t(o, i, e), o + "");
  }
  return xO = r, xO;
}
var wO, b8;
function n5e() {
  if (b8) return wO;
  b8 = 1;
  var e = Lp(), t = Fp(), n = Iv(), r = Za();
  function o(i, a, c) {
    if (!r(c))
      return !1;
    var l = typeof a;
    return (l == "number" ? t(c) && n(a, c.length) : l == "string" && a in c) ? e(c[a], i) : !1;
  }
  return wO = o, wO;
}
var $O, x8;
function r5e() {
  if (x8) return $O;
  x8 = 1;
  var e = vH(), t = Lp(), n = n5e(), r = Nv(), o = Object.prototype, i = o.hasOwnProperty, a = e(function(c, l) {
    c = Object(c);
    var u = -1, d = l.length, f = d > 2 ? l[2] : void 0;
    for (f && n(l[0], l[1], f) && (d = 1); ++u < d; )
      for (var h = l[u], v = r(h), y = -1, g = v.length; ++y < g; ) {
        var b = v[y], x = c[b];
        (x === void 0 || t(x, o[b]) && !i.call(c, b)) && (c[b] = h[b]);
      }
    return c;
  });
  return $O = a, $O;
}
var o5e = r5e();
const R9e = /* @__PURE__ */ jn(o5e);
var ff = /* @__PURE__ */ ((e) => (e.Mouse = "mouse", e.Touch = "touch", e.Pointer = "pointer", e))(ff || {}), pf = /* @__PURE__ */ ((e) => (e.CancelledByMovement = "cancelled-by-movement", e.CancelledByRelease = "cancelled-by-release", e.CancelledOutsideElement = "cancelled-outside-element", e))(pf || {});
const yH = () => typeof window == "object" ? (window == null ? void 0 : window.PointerEvent) ?? null : null, i5e = () => typeof window == "object" ? (window == null ? void 0 : window.TouchEvent) ?? null : null;
function bH(e) {
  const { nativeEvent: t } = e, n = i5e();
  return n && t instanceof n || "touches" in e;
}
function xH(e) {
  const t = yH();
  return e.nativeEvent instanceof MouseEvent && !(t && e.nativeEvent instanceof t);
}
function wH(e) {
  const { nativeEvent: t } = e;
  if (!t)
    return !1;
  const n = yH();
  return n && t instanceof n || "pointerId" in t;
}
function w8(e) {
  return xH(e) || bH(e) || wH(e);
}
function $8(e) {
  return bH(e) ? {
    x: e.touches[0].pageX,
    y: e.touches[0].pageY
  } : xH(e) || wH(e) ? {
    x: e.pageX,
    y: e.pageY
  } : null;
}
function a5e(e) {
  return {
    target: e.target,
    currentTarget: e.currentTarget,
    nativeEvent: e,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    persist: () => {
    }
  };
}
function P9e(e, {
  threshold: t = 400,
  captureEvent: n = !1,
  detect: r = ff.Pointer,
  cancelOnMovement: o = !1,
  cancelOutsideElement: i = !0,
  filterEvents: a,
  onStart: c,
  onMove: l,
  onFinish: u,
  onCancel: d
} = {}) {
  const f = Gt(!1), h = Gt(!1), v = Gt(), y = Gt(), g = Gt(e), b = Gt(null), x = Rt(
    (C) => (T) => {
      h.current || w8(T) && (a !== void 0 && !a(T) || (n && T.persist(), c == null || c(T, { context: C }), b.current = $8(T), h.current = !0, v.current = T.currentTarget, y.current = setTimeout(() => {
        g.current && (g.current(T, { context: C }), f.current = !0);
      }, t)));
    },
    [n, a, c, t]
  ), $ = Rt(
    (C) => (T, k) => {
      w8(T) && h.current && (b.current = null, n && T.persist(), f.current ? u == null || u(T, { context: C }) : h.current && (d == null || d(T, { context: C, reason: k ?? pf.CancelledByRelease })), f.current = !1, h.current = !1, y.current !== void 0 && clearTimeout(y.current));
    },
    [n, u, d]
  ), S = Rt(
    (C) => (T) => {
      if (l == null || l(T, { context: C }), o !== !1 && b.current) {
        const k = $8(T);
        if (k) {
          const I = o === !0 ? 25 : o, P = {
            x: Math.abs(k.x - b.current.x),
            y: Math.abs(k.y - b.current.y)
          };
          (P.x > I || P.y > I) && $(C)(T, pf.CancelledByMovement);
        }
      }
    },
    [$, o, l]
  ), O = Rt(
    (C) => {
      if (e === null)
        return {};
      switch (r) {
        case ff.Mouse: {
          const T = {
            onMouseDown: x(C),
            onMouseMove: S(C),
            onMouseUp: $(C)
          };
          return i && (T.onMouseLeave = (k) => {
            $(C)(k, pf.CancelledOutsideElement);
          }), T;
        }
        case ff.Touch:
          return {
            onTouchStart: x(C),
            onTouchMove: S(C),
            onTouchEnd: $(C)
          };
        case ff.Pointer: {
          const T = {
            onPointerDown: x(C),
            onPointerMove: S(C),
            onPointerUp: $(C)
          };
          return i && (T.onPointerLeave = (k) => $(C)(k, pf.CancelledOutsideElement)), T;
        }
      }
    },
    [e, $, i, r, S, x]
  );
  return mn(() => {
    if (!window)
      return;
    function C(T) {
      const k = a5e(T);
      $()(k);
    }
    return window.addEventListener("mouseup", C), window.addEventListener("touchend", C), window.addEventListener("pointerup", C), () => {
      window.removeEventListener("mouseup", C), window.removeEventListener("touchend", C), window.removeEventListener("pointerup", C);
    };
  }, [$]), mn(
    () => () => {
      y.current !== void 0 && clearTimeout(y.current);
    },
    []
  ), mn(() => {
    g.current = e;
  }, [e]), O;
}
var OO, O8;
function s5e() {
  if (O8) return OO;
  O8 = 1;
  function e(t, n, r, o) {
    for (var i = -1, a = t == null ? 0 : t.length; ++i < a; ) {
      var c = t[i];
      n(o, c, r(c), t);
    }
    return o;
  }
  return OO = e, OO;
}
var SO, S8;
function c5e() {
  if (S8) return SO;
  S8 = 1;
  function e(t) {
    return function(n, r, o) {
      for (var i = -1, a = Object(n), c = o(n), l = c.length; l--; ) {
        var u = c[t ? l : ++i];
        if (r(a[u], u, a) === !1)
          break;
      }
      return n;
    };
  }
  return SO = e, SO;
}
var CO, C8;
function l5e() {
  if (C8) return CO;
  C8 = 1;
  var e = c5e(), t = e();
  return CO = t, CO;
}
var TO, T8;
function u5e() {
  if (T8) return TO;
  T8 = 1;
  var e = l5e(), t = rd();
  function n(r, o) {
    return r && e(r, o, t);
  }
  return TO = n, TO;
}
var EO, E8;
function d5e() {
  if (E8) return EO;
  E8 = 1;
  var e = Fp();
  function t(n, r) {
    return function(o, i) {
      if (o == null)
        return o;
      if (!e(o))
        return n(o, i);
      for (var a = o.length, c = r ? a : -1, l = Object(o); (r ? c-- : ++c < a) && i(l[c], c, l) !== !1; )
        ;
      return o;
    };
  }
  return EO = t, EO;
}
var _O, _8;
function f5e() {
  if (_8) return _O;
  _8 = 1;
  var e = u5e(), t = d5e(), n = t(e);
  return _O = n, _O;
}
var kO, k8;
function p5e() {
  if (k8) return kO;
  k8 = 1;
  var e = f5e();
  function t(n, r, o, i) {
    return e(n, function(a, c, l) {
      r(i, a, o(a), l);
    }), i;
  }
  return kO = t, kO;
}
var RO, R8;
function h5e() {
  if (R8) return RO;
  R8 = 1;
  var e = s5e(), t = p5e(), n = e3(), r = Ci();
  function o(i, a) {
    return function(c, l) {
      var u = r(c) ? e : t, d = a ? a() : {};
      return u(c, i, n(l, 2), d);
    };
  }
  return RO = o, RO;
}
var PO, P8;
function m5e() {
  if (P8) return PO;
  P8 = 1;
  var e = hE(), t = h5e(), n = Object.prototype, r = n.hasOwnProperty, o = t(function(i, a, c) {
    r.call(i, c) ? i[c].push(a) : e(i, c, [a]);
  });
  return PO = o, PO;
}
var g5e = m5e();
const A9e = /* @__PURE__ */ jn(g5e);
var AO, A8;
function v5e() {
  if (A8) return AO;
  A8 = 1;
  var e = XT(), t = e(function(n, r, o) {
    return n + (o ? "-" : "") + r.toLowerCase();
  });
  return AO = t, AO;
}
var y5e = v5e();
const I9e = /* @__PURE__ */ jn(y5e);
var IO, I8;
function b5e() {
  if (I8) return IO;
  I8 = 1;
  var e = ZE(), t = Gq(), n = Kq(), r = Ap(), o = Mv(), i = JE(), a = Math.min;
  function c(l, u, d) {
    for (var f = d ? n : t, h = l[0].length, v = l.length, y = v, g = Array(v), b = 1 / 0, x = []; y--; ) {
      var $ = l[y];
      y && u && ($ = r($, o(u))), b = a($.length, b), g[y] = !d && (u || h >= 120 && $.length >= 120) ? new e(y && $) : void 0;
    }
    $ = l[0];
    var S = -1, O = g[0];
    e:
      for (; ++S < h && x.length < b; ) {
        var C = $[S], T = u ? u(C) : C;
        if (C = d || C !== 0 ? C : 0, !(O ? i(O, T) : f(x, T, d))) {
          for (y = v; --y; ) {
            var k = g[y];
            if (!(k ? i(k, T) : f(l[y], T, d)))
              continue e;
          }
          O && O.push(T), x.push(C);
        }
      }
    return x;
  }
  return IO = c, IO;
}
var MO, M8;
function x5e() {
  if (M8) return MO;
  M8 = 1;
  var e = Fp(), t = Ka();
  function n(r) {
    return t(r) && e(r);
  }
  return MO = n, MO;
}
var NO, N8;
function w5e() {
  if (N8) return NO;
  N8 = 1;
  var e = x5e();
  function t(n) {
    return e(n) ? n : [];
  }
  return NO = t, NO;
}
var DO, D8;
function $5e() {
  if (D8) return DO;
  D8 = 1;
  var e = Ap(), t = b5e(), n = e3(), r = vH(), o = w5e(), i = gz(), a = r(function(c) {
    var l = i(c), u = e(c, o);
    return l === i(u) ? l = void 0 : u.pop(), u.length && u[0] === c[0] ? t(u, n(l, 2)) : [];
  });
  return DO = a, DO;
}
var O5e = $5e();
const M9e = /* @__PURE__ */ jn(O5e);
var S5e = Hq();
const N9e = /* @__PURE__ */ jn(S5e);
var LO, L8;
function C5e() {
  if (L8) return LO;
  L8 = 1;
  function e(x) {
    this._maxSize = x, this.clear();
  }
  e.prototype.clear = function() {
    this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
  }, e.prototype.get = function(x) {
    return this._values[x];
  }, e.prototype.set = function(x, $) {
    return this._size >= this._maxSize && this.clear(), x in this._values || this._size++, this._values[x] = $;
  };
  var t = /[^.^\]^[]+|(?=\[\]|\.\.)/g, n = /^\d+$/, r = /^\d/, o = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, i = /^\s*(['"]?)(.*?)(\1)\s*$/, a = 512, c = new e(a), l = new e(a), u = new e(a);
  LO = {
    Cache: e,
    split: f,
    normalizePath: d,
    setter: function(x) {
      var $ = d(x);
      return l.get(x) || l.set(x, function(O, C) {
        for (var T = 0, k = $.length, I = O; T < k - 1; ) {
          var P = $[T];
          if (P === "__proto__" || P === "constructor" || P === "prototype")
            return O;
          I = I[$[T++]];
        }
        I[$[T]] = C;
      });
    },
    getter: function(x, $) {
      var S = d(x);
      return u.get(x) || u.set(x, function(C) {
        for (var T = 0, k = S.length; T < k; )
          if (C != null || !$) C = C[S[T++]];
          else return;
        return C;
      });
    },
    join: function(x) {
      return x.reduce(function($, S) {
        return $ + (v(S) || n.test(S) ? "[" + S + "]" : ($ ? "." : "") + S);
      }, "");
    },
    forEach: function(x, $, S) {
      h(Array.isArray(x) ? x : f(x), $, S);
    }
  };
  function d(x) {
    return c.get(x) || c.set(
      x,
      f(x).map(function($) {
        return $.replace(i, "$2");
      })
    );
  }
  function f(x) {
    return x.match(t) || [""];
  }
  function h(x, $, S) {
    var O = x.length, C, T, k, I;
    for (T = 0; T < O; T++)
      C = x[T], C && (b(C) && (C = '"' + C + '"'), I = v(C), k = !I && /^\d+$/.test(C), $.call(S, C, I, k, T, x));
  }
  function v(x) {
    return typeof x == "string" && x && ["'", '"'].indexOf(x.charAt(0)) !== -1;
  }
  function y(x) {
    return x.match(r) && !x.match(n);
  }
  function g(x) {
    return o.test(x);
  }
  function b(x) {
    return !v(x) && (y(x) || g(x));
  }
  return LO;
}
var qc = C5e(), jO, j8;
function T5e() {
  if (j8) return jO;
  j8 = 1;
  const e = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g, t = (d) => d.match(e) || [], n = (d) => d[0].toUpperCase() + d.slice(1), r = (d, f) => t(d).join(f).toLowerCase(), o = (d) => t(d).reduce(
    (f, h) => `${f}${f ? h[0].toUpperCase() + h.slice(1).toLowerCase() : h.toLowerCase()}`,
    ""
  );
  return jO = {
    words: t,
    upperFirst: n,
    camelCase: o,
    pascalCase: (d) => n(o(d)),
    snakeCase: (d) => r(d, "_"),
    kebabCase: (d) => r(d, "-"),
    sentenceCase: (d) => n(r(d, " ")),
    titleCase: (d) => t(d).map(n).join(" ")
  }, jO;
}
var FO = T5e(), Bm = { exports: {} }, F8;
function E5e() {
  if (F8) return Bm.exports;
  F8 = 1, Bm.exports = function(o) {
    return e(t(o), o);
  }, Bm.exports.array = e;
  function e(o, i) {
    var a = o.length, c = new Array(a), l = {}, u = a, d = n(i), f = r(o);
    for (i.forEach(function(v) {
      if (!f.has(v[0]) || !f.has(v[1]))
        throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    }); u--; )
      l[u] || h(o[u], u, /* @__PURE__ */ new Set());
    return c;
    function h(v, y, g) {
      if (g.has(v)) {
        var b;
        try {
          b = ", node was:" + JSON.stringify(v);
        } catch {
          b = "";
        }
        throw new Error("Cyclic dependency" + b);
      }
      if (!f.has(v))
        throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(v));
      if (!l[y]) {
        l[y] = !0;
        var x = d.get(v) || /* @__PURE__ */ new Set();
        if (x = Array.from(x), y = x.length) {
          g.add(v);
          do {
            var $ = x[--y];
            h($, f.get($), g);
          } while (y);
          g.delete(v);
        }
        c[--a] = v;
      }
    }
  }
  function t(o) {
    for (var i = /* @__PURE__ */ new Set(), a = 0, c = o.length; a < c; a++) {
      var l = o[a];
      i.add(l[0]), i.add(l[1]);
    }
    return Array.from(i);
  }
  function n(o) {
    for (var i = /* @__PURE__ */ new Map(), a = 0, c = o.length; a < c; a++) {
      var l = o[a];
      i.has(l[0]) || i.set(l[0], /* @__PURE__ */ new Set()), i.has(l[1]) || i.set(l[1], /* @__PURE__ */ new Set()), i.get(l[0]).add(l[1]);
    }
    return i;
  }
  function r(o) {
    for (var i = /* @__PURE__ */ new Map(), a = 0, c = o.length; a < c; a++)
      i.set(o[a], a);
    return i;
  }
  return Bm.exports;
}
var _5e = E5e();
const k5e = /* @__PURE__ */ jn(_5e), R5e = Object.prototype.toString, P5e = Error.prototype.toString, A5e = RegExp.prototype.toString, I5e = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", M5e = /^Symbol\((.*)\)(.*)$/;
function N5e(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function z8(e, t = !1) {
  if (e == null || e === !0 || e === !1) return "" + e;
  const n = typeof e;
  if (n === "number") return N5e(e);
  if (n === "string") return t ? `"${e}"` : e;
  if (n === "function") return "[Function " + (e.name || "anonymous") + "]";
  if (n === "symbol") return I5e.call(e).replace(M5e, "Symbol($1)");
  const r = R5e.call(e).slice(8, -1);
  return r === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : r === "Error" || e instanceof Error ? "[" + P5e.call(e) + "]" : r === "RegExp" ? A5e.call(e) : null;
}
function Ds(e, t) {
  let n = z8(e, t);
  return n !== null ? n : JSON.stringify(e, function(r, o) {
    let i = z8(this[r], t);
    return i !== null ? i : o;
  }, 2);
}
function $H(e) {
  return e == null ? [] : [].concat(e);
}
let OH, SH, CH, D5e = /\$\{\s*(\w+)\s*\}/g;
OH = Symbol.toStringTag;
class B8 {
  constructor(t, n, r, o) {
    this.name = void 0, this.message = void 0, this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = void 0, this.inner = void 0, this[OH] = "Error", this.name = "ValidationError", this.value = n, this.path = r, this.type = o, this.errors = [], this.inner = [], $H(t).forEach((i) => {
      if (Rr.isError(i)) {
        this.errors.push(...i.errors);
        const a = i.inner.length ? i.inner : [i];
        this.inner.push(...a);
      } else
        this.errors.push(i);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
  }
}
SH = Symbol.hasInstance;
CH = Symbol.toStringTag;
class Rr extends Error {
  static formatError(t, n) {
    const r = n.label || n.path || "this";
    return n = Object.assign({}, n, {
      path: r,
      originalPath: n.path
    }), typeof t == "string" ? t.replace(D5e, (o, i) => Ds(n[i])) : typeof t == "function" ? t(n) : t;
  }
  static isError(t) {
    return t && t.name === "ValidationError";
  }
  constructor(t, n, r, o, i) {
    const a = new B8(t, n, r, o);
    if (i)
      return a;
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = [], this.inner = [], this[CH] = "Error", this.name = a.name, this.message = a.message, this.type = a.type, this.value = a.value, this.path = a.path, this.errors = a.errors, this.inner = a.inner, Error.captureStackTrace && Error.captureStackTrace(this, Rr);
  }
  static [SH](t) {
    return B8[Symbol.hasInstance](t) || super[Symbol.hasInstance](t);
  }
}
let ji = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  defined: "${path} must be defined",
  notNull: "${path} cannot be null",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: t,
    value: n,
    originalValue: r
  }) => {
    const o = r != null && r !== n ? ` (cast from the value \`${Ds(r, !0)}\`).` : ".";
    return t !== "mixed" ? `${e} must be a \`${t}\` type, but the final value was: \`${Ds(n, !0)}\`` + o : `${e} must match the configured type. The validated value was: \`${Ds(n, !0)}\`` + o;
  }
}, Vr = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  datetime: "${path} must be a valid ISO date-time",
  datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
  datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, L5e = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, UC = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, j5e = {
  isValue: "${path} field must be ${value}"
}, xg = {
  noUnknown: "${path} field has unspecified keys: ${unknown}",
  exact: "${path} object contains unknown properties: ${properties}"
}, F5e = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
}, z5e = {
  notType: (e) => {
    const {
      path: t,
      value: n,
      spec: r
    } = e, o = r.types.length;
    if (Array.isArray(n)) {
      if (n.length < o) return `${t} tuple value has too few items, expected a length of ${o} but got ${n.length} for value: \`${Ds(n, !0)}\``;
      if (n.length > o) return `${t} tuple value has too many items, expected a length of ${o} but got ${n.length} for value: \`${Ds(n, !0)}\``;
    }
    return Rr.formatError(ji.notType, e);
  }
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: ji,
  string: Vr,
  number: L5e,
  date: UC,
  object: xg,
  array: F5e,
  boolean: j5e,
  tuple: z5e
});
const Sy = (e) => e && e.__isYupSchema__;
class D0 {
  static fromOptions(t, n) {
    if (!n.then && !n.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: r,
      then: o,
      otherwise: i
    } = n, a = typeof r == "function" ? r : (...c) => c.every((l) => l === r);
    return new D0(t, (c, l) => {
      var u;
      let d = a(...c) ? o : i;
      return (u = d == null ? void 0 : d(l)) != null ? u : l;
    });
  }
  constructor(t, n) {
    this.fn = void 0, this.refs = t, this.refs = t, this.fn = n;
  }
  resolve(t, n) {
    let r = this.refs.map((i) => (
      // TODO: ? operator here?
      i.getValue(n == null ? void 0 : n.value, n == null ? void 0 : n.parent, n == null ? void 0 : n.context)
    )), o = this.fn(r, t, n);
    if (o === void 0 || // @ts-ignore this can be base
    o === t)
      return t;
    if (!Sy(o)) throw new TypeError("conditions must return a schema object");
    return o.resolve(n);
  }
}
const qm = {
  context: "$",
  value: "."
};
class fl {
  constructor(t, n = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof t != "string") throw new TypeError("ref must be a string, got: " + t);
    if (this.key = t.trim(), t === "") throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === qm.context, this.isValue = this.key[0] === qm.value, this.isSibling = !this.isContext && !this.isValue;
    let r = this.isContext ? qm.context : this.isValue ? qm.value : "";
    this.path = this.key.slice(r.length), this.getter = this.path && qc.getter(this.path, !0), this.map = n.map;
  }
  getValue(t, n, r) {
    let o = this.isContext ? r : this.isValue ? t : n;
    return this.getter && (o = this.getter(o || {})), this.map && (o = this.map(o)), o;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(t, n) {
    return this.getValue(t, n == null ? void 0 : n.parent, n == null ? void 0 : n.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(t) {
    return t && t.__isYupRef;
  }
}
fl.prototype.__isYupRef = !0;
const Ic = (e) => e == null;
function Jl(e) {
  function t({
    value: n,
    path: r = "",
    options: o,
    originalValue: i,
    schema: a
  }, c, l) {
    const {
      name: u,
      test: d,
      params: f,
      message: h,
      skipAbsent: v
    } = e;
    let {
      parent: y,
      context: g,
      abortEarly: b = a.spec.abortEarly,
      disableStackTrace: x = a.spec.disableStackTrace
    } = o;
    function $(A) {
      return fl.isRef(A) ? A.getValue(n, y, g) : A;
    }
    function S(A = {}) {
      const D = Object.assign({
        value: n,
        originalValue: i,
        label: a.spec.label,
        path: A.path || r,
        spec: a.spec,
        disableStackTrace: A.disableStackTrace || x
      }, f, A.params);
      for (const N of Object.keys(D)) D[N] = $(D[N]);
      const M = new Rr(Rr.formatError(A.message || h, D), n, D.path, A.type || u, D.disableStackTrace);
      return M.params = D, M;
    }
    const O = b ? c : l;
    let C = {
      path: r,
      parent: y,
      type: u,
      from: o.from,
      createError: S,
      resolve: $,
      options: o,
      originalValue: i,
      schema: a
    };
    const T = (A) => {
      Rr.isError(A) ? O(A) : A ? l(null) : O(S());
    }, k = (A) => {
      Rr.isError(A) ? O(A) : c(A);
    };
    if (v && Ic(n))
      return T(!0);
    let P;
    try {
      var _;
      if (P = d.call(C, n, C), typeof ((_ = P) == null ? void 0 : _.then) == "function") {
        if (o.sync)
          throw new Error(`Validation test of type: "${C.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
        return Promise.resolve(P).then(T, k);
      }
    } catch (A) {
      k(A);
      return;
    }
    T(P);
  }
  return t.OPTIONS = e, t;
}
function B5e(e, t, n, r = n) {
  let o, i, a;
  return t ? (qc.forEach(t, (c, l, u) => {
    let d = l ? c.slice(1, c.length - 1) : c;
    e = e.resolve({
      context: r,
      parent: o,
      value: n
    });
    let f = e.type === "tuple", h = u ? parseInt(d, 10) : 0;
    if (e.innerType || f) {
      if (f && !u) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${a}" must contain an index to the tuple element, e.g. "${a}[0]"`);
      if (n && h >= n.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${c}, in the path: ${t}. because there is no value at that index. `);
      o = n, n = n && n[h], e = f ? e.spec.types[h] : e.innerType;
    }
    if (!u) {
      if (!e.fields || !e.fields[d]) throw new Error(`The schema does not contain the path: ${t}. (failed at: ${a} which is a type: "${e.type}")`);
      o = n, n = n && n[d], e = e.fields[d];
    }
    i = d, a = l ? "[" + c + "]" : "." + c;
  }), {
    schema: e,
    parent: o,
    parentPath: i
  }) : {
    parent: o,
    parentPath: t,
    schema: e
  };
}
class L0 extends Set {
  describe() {
    const t = [];
    for (const n of this.values())
      t.push(fl.isRef(n) ? n.describe() : n);
    return t;
  }
  resolveAll(t) {
    let n = [];
    for (const r of this.values())
      n.push(t(r));
    return n;
  }
  clone() {
    return new L0(this.values());
  }
  merge(t, n) {
    const r = this.clone();
    return t.forEach((o) => r.add(o)), n.forEach((o) => r.delete(o)), r;
  }
}
function cu(e, t = /* @__PURE__ */ new Map()) {
  if (Sy(e) || !e || typeof e != "object") return e;
  if (t.has(e)) return t.get(e);
  let n;
  if (e instanceof Date)
    n = new Date(e.getTime()), t.set(e, n);
  else if (e instanceof RegExp)
    n = new RegExp(e), t.set(e, n);
  else if (Array.isArray(e)) {
    n = new Array(e.length), t.set(e, n);
    for (let r = 0; r < e.length; r++) n[r] = cu(e[r], t);
  } else if (e instanceof Map) {
    n = /* @__PURE__ */ new Map(), t.set(e, n);
    for (const [r, o] of e.entries()) n.set(r, cu(o, t));
  } else if (e instanceof Set) {
    n = /* @__PURE__ */ new Set(), t.set(e, n);
    for (const r of e) n.add(cu(r, t));
  } else if (e instanceof Object) {
    n = {}, t.set(e, n);
    for (const [r, o] of Object.entries(e)) n[r] = cu(o, t);
  } else
    throw Error(`Unable to clone ${e}`);
  return n;
}
class fa {
  constructor(t) {
    this.type = void 0, this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this.internalTests = {}, this._whitelist = new L0(), this._blacklist = new L0(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this._typeCheck = void 0, this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(ji.notType);
    }), this.type = t.type, this._typeCheck = t.check, this.spec = Object.assign({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      disableStackTrace: !1,
      nullable: !1,
      optional: !0,
      coerce: !0
    }, t == null ? void 0 : t.spec), this.withMutation((n) => {
      n.nonNullable();
    });
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(t) {
    if (this._mutate)
      return t && Object.assign(this.spec, t), this;
    const n = Object.create(Object.getPrototypeOf(this));
    return n.type = this.type, n._typeCheck = this._typeCheck, n._whitelist = this._whitelist.clone(), n._blacklist = this._blacklist.clone(), n.internalTests = Object.assign({}, this.internalTests), n.exclusiveTests = Object.assign({}, this.exclusiveTests), n.deps = [...this.deps], n.conditions = [...this.conditions], n.tests = [...this.tests], n.transforms = [...this.transforms], n.spec = cu(Object.assign({}, this.spec, t)), n;
  }
  label(t) {
    let n = this.clone();
    return n.spec.label = t, n;
  }
  meta(...t) {
    if (t.length === 0) return this.spec.meta;
    let n = this.clone();
    return n.spec.meta = Object.assign(n.spec.meta || {}, t[0]), n;
  }
  withMutation(t) {
    let n = this._mutate;
    this._mutate = !0;
    let r = t(this);
    return this._mutate = n, r;
  }
  concat(t) {
    if (!t || t === this) return this;
    if (t.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${t.type}`);
    let n = this, r = t.clone();
    const o = Object.assign({}, n.spec, r.spec);
    return r.spec = o, r.internalTests = Object.assign({}, n.internalTests, r.internalTests), r._whitelist = n._whitelist.merge(t._whitelist, t._blacklist), r._blacklist = n._blacklist.merge(t._blacklist, t._whitelist), r.tests = n.tests, r.exclusiveTests = n.exclusiveTests, r.withMutation((i) => {
      t.tests.forEach((a) => {
        i.test(a.OPTIONS);
      });
    }), r.transforms = [...n.transforms, ...r.transforms], r;
  }
  isType(t) {
    return t == null ? !!(this.spec.nullable && t === null || this.spec.optional && t === void 0) : this._typeCheck(t);
  }
  resolve(t) {
    let n = this;
    if (n.conditions.length) {
      let r = n.conditions;
      n = n.clone(), n.conditions = [], n = r.reduce((o, i) => i.resolve(o, t), n), n = n.resolve(t);
    }
    return n;
  }
  resolveOptions(t) {
    var n, r, o, i;
    return Object.assign({}, t, {
      from: t.from || [],
      strict: (n = t.strict) != null ? n : this.spec.strict,
      abortEarly: (r = t.abortEarly) != null ? r : this.spec.abortEarly,
      recursive: (o = t.recursive) != null ? o : this.spec.recursive,
      disableStackTrace: (i = t.disableStackTrace) != null ? i : this.spec.disableStackTrace
    });
  }
  /**
   * Run the configured transform pipeline over an input value.
   */
  cast(t, n = {}) {
    let r = this.resolve(Object.assign({
      value: t
    }, n)), o = n.assert === "ignore-optionality", i = r._cast(t, n);
    if (n.assert !== !1 && !r.isType(i)) {
      if (o && Ic(i))
        return i;
      let a = Ds(t), c = Ds(i);
      throw new TypeError(`The value of ${n.path || "field"} could not be cast to a value that satisfies the schema type: "${r.type}". 

attempted value: ${a} 
` + (c !== a ? `result of cast: ${c}` : ""));
    }
    return i;
  }
  _cast(t, n) {
    let r = t === void 0 ? t : this.transforms.reduce((o, i) => i.call(this, o, t, this), t);
    return r === void 0 && (r = this.getDefault(n)), r;
  }
  _validate(t, n = {}, r, o) {
    let {
      path: i,
      originalValue: a = t,
      strict: c = this.spec.strict
    } = n, l = t;
    c || (l = this._cast(l, Object.assign({
      assert: !1
    }, n)));
    let u = [];
    for (let d of Object.values(this.internalTests))
      d && u.push(d);
    this.runTests({
      path: i,
      value: l,
      originalValue: a,
      options: n,
      tests: u
    }, r, (d) => {
      if (d.length)
        return o(d, l);
      this.runTests({
        path: i,
        value: l,
        originalValue: a,
        options: n,
        tests: this.tests
      }, r, o);
    });
  }
  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(t, n, r) {
    let o = !1, {
      tests: i,
      value: a,
      originalValue: c,
      path: l,
      options: u
    } = t, d = (g) => {
      o || (o = !0, n(g, a));
    }, f = (g) => {
      o || (o = !0, r(g, a));
    }, h = i.length, v = [];
    if (!h) return f([]);
    let y = {
      value: a,
      originalValue: c,
      path: l,
      options: u,
      schema: this
    };
    for (let g = 0; g < i.length; g++) {
      const b = i[g];
      b(y, d, function($) {
        $ && (Array.isArray($) ? v.push(...$) : v.push($)), --h <= 0 && f(v);
      });
    }
  }
  asNestedTest({
    key: t,
    index: n,
    parent: r,
    parentPath: o,
    originalParent: i,
    options: a
  }) {
    const c = t ?? n;
    if (c == null)
      throw TypeError("Must include `key` or `index` for nested validations");
    const l = typeof c == "number";
    let u = r[c];
    const d = Object.assign({}, a, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: !0,
      parent: r,
      value: u,
      originalValue: i[c],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: void 0,
      // index: undefined,
      [l ? "index" : "key"]: c,
      path: l || c.includes(".") ? `${o || ""}[${l ? c : `"${c}"`}]` : (o ? `${o}.` : "") + t
    });
    return (f, h, v) => this.resolve(d)._validate(u, d, h, v);
  }
  validate(t, n) {
    var r;
    let o = this.resolve(Object.assign({}, n, {
      value: t
    })), i = (r = n == null ? void 0 : n.disableStackTrace) != null ? r : o.spec.disableStackTrace;
    return new Promise((a, c) => o._validate(t, n, (l, u) => {
      Rr.isError(l) && (l.value = u), c(l);
    }, (l, u) => {
      l.length ? c(new Rr(l, u, void 0, void 0, i)) : a(u);
    }));
  }
  validateSync(t, n) {
    var r;
    let o = this.resolve(Object.assign({}, n, {
      value: t
    })), i, a = (r = n == null ? void 0 : n.disableStackTrace) != null ? r : o.spec.disableStackTrace;
    return o._validate(t, Object.assign({}, n, {
      sync: !0
    }), (c, l) => {
      throw Rr.isError(c) && (c.value = l), c;
    }, (c, l) => {
      if (c.length) throw new Rr(c, t, void 0, void 0, a);
      i = l;
    }), i;
  }
  isValid(t, n) {
    return this.validate(t, n).then(() => !0, (r) => {
      if (Rr.isError(r)) return !1;
      throw r;
    });
  }
  isValidSync(t, n) {
    try {
      return this.validateSync(t, n), !0;
    } catch (r) {
      if (Rr.isError(r)) return !1;
      throw r;
    }
  }
  _getDefault(t) {
    let n = this.spec.default;
    return n == null ? n : typeof n == "function" ? n.call(this, t) : cu(n);
  }
  getDefault(t) {
    return this.resolve(t || {})._getDefault(t);
  }
  default(t) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: t
    });
  }
  strict(t = !0) {
    return this.clone({
      strict: t
    });
  }
  nullability(t, n) {
    const r = this.clone({
      nullable: t
    });
    return r.internalTests.nullable = Jl({
      message: n,
      name: "nullable",
      test(o) {
        return o === null ? this.schema.spec.nullable : !0;
      }
    }), r;
  }
  optionality(t, n) {
    const r = this.clone({
      optional: t
    });
    return r.internalTests.optionality = Jl({
      message: n,
      name: "optionality",
      test(o) {
        return o === void 0 ? this.schema.spec.optional : !0;
      }
    }), r;
  }
  optional() {
    return this.optionality(!0);
  }
  defined(t = ji.defined) {
    return this.optionality(!1, t);
  }
  nullable() {
    return this.nullability(!0);
  }
  nonNullable(t = ji.notNull) {
    return this.nullability(!1, t);
  }
  required(t = ji.required) {
    return this.clone().withMutation((n) => n.nonNullable(t).defined(t));
  }
  notRequired() {
    return this.clone().withMutation((t) => t.nullable().optional());
  }
  transform(t) {
    let n = this.clone();
    return n.transforms.push(t), n;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...t) {
    let n;
    if (t.length === 1 ? typeof t[0] == "function" ? n = {
      test: t[0]
    } : n = t[0] : t.length === 2 ? n = {
      name: t[0],
      test: t[1]
    } : n = {
      name: t[0],
      message: t[1],
      test: t[2]
    }, n.message === void 0 && (n.message = ji.default), typeof n.test != "function") throw new TypeError("`test` is a required parameters");
    let r = this.clone(), o = Jl(n), i = n.exclusive || n.name && r.exclusiveTests[n.name] === !0;
    if (n.exclusive && !n.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return n.name && (r.exclusiveTests[n.name] = !!n.exclusive), r.tests = r.tests.filter((a) => !(a.OPTIONS.name === n.name && (i || a.OPTIONS.test === o.OPTIONS.test))), r.tests.push(o), r;
  }
  when(t, n) {
    !Array.isArray(t) && typeof t != "string" && (n = t, t = ".");
    let r = this.clone(), o = $H(t).map((i) => new fl(i));
    return o.forEach((i) => {
      i.isSibling && r.deps.push(i.key);
    }), r.conditions.push(typeof n == "function" ? new D0(o, n) : D0.fromOptions(o, n)), r;
  }
  typeError(t) {
    let n = this.clone();
    return n.internalTests.typeError = Jl({
      message: t,
      name: "typeError",
      skipAbsent: !0,
      test(r) {
        return this.schema._typeCheck(r) ? !0 : this.createError({
          params: {
            type: this.schema.type
          }
        });
      }
    }), n;
  }
  oneOf(t, n = ji.oneOf) {
    let r = this.clone();
    return t.forEach((o) => {
      r._whitelist.add(o), r._blacklist.delete(o);
    }), r.internalTests.whiteList = Jl({
      message: n,
      name: "oneOf",
      skipAbsent: !0,
      test(o) {
        let i = this.schema._whitelist, a = i.resolveAll(this.resolve);
        return a.includes(o) ? !0 : this.createError({
          params: {
            values: Array.from(i).join(", "),
            resolved: a
          }
        });
      }
    }), r;
  }
  notOneOf(t, n = ji.notOneOf) {
    let r = this.clone();
    return t.forEach((o) => {
      r._blacklist.add(o), r._whitelist.delete(o);
    }), r.internalTests.blacklist = Jl({
      message: n,
      name: "notOneOf",
      test(o) {
        let i = this.schema._blacklist, a = i.resolveAll(this.resolve);
        return a.includes(o) ? this.createError({
          params: {
            values: Array.from(i).join(", "),
            resolved: a
          }
        }) : !0;
      }
    }), r;
  }
  strip(t = !0) {
    let n = this.clone();
    return n.spec.strip = t, n;
  }
  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(t) {
    const n = (t ? this.resolve(t) : this).clone(), {
      label: r,
      meta: o,
      optional: i,
      nullable: a
    } = n.spec;
    return {
      meta: o,
      label: r,
      optional: i,
      nullable: a,
      default: n.getDefault(t),
      type: n.type,
      oneOf: n._whitelist.describe(),
      notOneOf: n._blacklist.describe(),
      tests: n.tests.map((l) => ({
        name: l.OPTIONS.name,
        params: l.OPTIONS.params
      })).filter((l, u, d) => d.findIndex((f) => f.name === l.name) === u)
    };
  }
}
fa.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"]) fa.prototype[`${e}At`] = function(t, n, r = {}) {
  const {
    parent: o,
    parentPath: i,
    schema: a
  } = B5e(this, t, n, r.context);
  return a[e](o && o[i], Object.assign({}, r, {
    parent: o,
    path: t
  }));
};
for (const e of ["equals", "is"]) fa.prototype[e] = fa.prototype.oneOf;
for (const e of ["not", "nope"]) fa.prototype[e] = fa.prototype.notOneOf;
const q5e = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function U5e(e) {
  const t = WC(e);
  if (!t) return Date.parse ? Date.parse(e) : Number.NaN;
  if (t.z === void 0 && t.plusMinus === void 0)
    return new Date(t.year, t.month, t.day, t.hour, t.minute, t.second, t.millisecond).valueOf();
  let n = 0;
  return t.z !== "Z" && t.plusMinus !== void 0 && (n = t.hourOffset * 60 + t.minuteOffset, t.plusMinus === "+" && (n = 0 - n)), Date.UTC(t.year, t.month, t.day, t.hour, t.minute + n, t.second, t.millisecond);
}
function WC(e) {
  var t, n;
  const r = q5e.exec(e);
  return r ? {
    year: _a(r[1]),
    month: _a(r[2], 1) - 1,
    day: _a(r[3], 1),
    hour: _a(r[4]),
    minute: _a(r[5]),
    second: _a(r[6]),
    millisecond: r[7] ? (
      // allow arbitrary sub-second precision beyond milliseconds
      _a(r[7].substring(0, 3))
    ) : 0,
    precision: (t = (n = r[7]) == null ? void 0 : n.length) != null ? t : void 0,
    z: r[8] || void 0,
    plusMinus: r[9] || void 0,
    hourOffset: _a(r[10]),
    minuteOffset: _a(r[11])
  } : null;
}
function _a(e, t = 0) {
  return Number(e) || t;
}
let W5e = (
  // eslint-disable-next-line
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
), H5e = (
  // eslint-disable-next-line
  /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i
), V5e = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, Y5e = "^\\d{4}-\\d{2}-\\d{2}", G5e = "\\d{2}:\\d{2}:\\d{2}", K5e = "(([+-]\\d{2}(:?\\d{2})?)|Z)", X5e = new RegExp(`${Y5e}T${G5e}(\\.\\d+)?${K5e}$`), Z5e = (e) => Ic(e) || e === e.trim(), J5e = {}.toString();
function Q5e() {
  return new TH();
}
class TH extends fa {
  constructor() {
    super({
      type: "string",
      check(t) {
        return t instanceof String && (t = t.valueOf()), typeof t == "string";
      }
    }), this.withMutation(() => {
      this.transform((t, n, r) => {
        if (!r.spec.coerce || r.isType(t) || Array.isArray(t)) return t;
        const o = t != null && t.toString ? t.toString() : t;
        return o === J5e ? t : o;
      });
    });
  }
  required(t) {
    return super.required(t).withMutation((n) => n.test({
      message: t || ji.required,
      name: "required",
      skipAbsent: !0,
      test: (r) => !!r.length
    }));
  }
  notRequired() {
    return super.notRequired().withMutation((t) => (t.tests = t.tests.filter((n) => n.OPTIONS.name !== "required"), t));
  }
  length(t, n = Vr.length) {
    return this.test({
      message: n,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      skipAbsent: !0,
      test(r) {
        return r.length === this.resolve(t);
      }
    });
  }
  min(t, n = Vr.min) {
    return this.test({
      message: n,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      skipAbsent: !0,
      test(r) {
        return r.length >= this.resolve(t);
      }
    });
  }
  max(t, n = Vr.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: n,
      params: {
        max: t
      },
      skipAbsent: !0,
      test(r) {
        return r.length <= this.resolve(t);
      }
    });
  }
  matches(t, n) {
    let r = !1, o, i;
    return n && (typeof n == "object" ? {
      excludeEmptyString: r = !1,
      message: o,
      name: i
    } = n : o = n), this.test({
      name: i || "matches",
      message: o || Vr.matches,
      params: {
        regex: t
      },
      skipAbsent: !0,
      test: (a) => a === "" && r || a.search(t) !== -1
    });
  }
  email(t = Vr.email) {
    return this.matches(W5e, {
      name: "email",
      message: t,
      excludeEmptyString: !0
    });
  }
  url(t = Vr.url) {
    return this.matches(H5e, {
      name: "url",
      message: t,
      excludeEmptyString: !0
    });
  }
  uuid(t = Vr.uuid) {
    return this.matches(V5e, {
      name: "uuid",
      message: t,
      excludeEmptyString: !1
    });
  }
  datetime(t) {
    let n = "", r, o;
    return t && (typeof t == "object" ? {
      message: n = "",
      allowOffset: r = !1,
      precision: o = void 0
    } = t : n = t), this.matches(X5e, {
      name: "datetime",
      message: n || Vr.datetime,
      excludeEmptyString: !0
    }).test({
      name: "datetime_offset",
      message: n || Vr.datetime_offset,
      params: {
        allowOffset: r
      },
      skipAbsent: !0,
      test: (i) => {
        if (!i || r) return !0;
        const a = WC(i);
        return a ? !!a.z : !1;
      }
    }).test({
      name: "datetime_precision",
      message: n || Vr.datetime_precision,
      params: {
        precision: o
      },
      skipAbsent: !0,
      test: (i) => {
        if (!i || o == null) return !0;
        const a = WC(i);
        return a ? a.precision === o : !1;
      }
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((t) => t === null ? "" : t);
  }
  trim(t = Vr.trim) {
    return this.transform((n) => n != null ? n.trim() : n).test({
      message: t,
      name: "trim",
      test: Z5e
    });
  }
  lowercase(t = Vr.lowercase) {
    return this.transform((n) => Ic(n) ? n : n.toLowerCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (n) => Ic(n) || n === n.toLowerCase()
    });
  }
  uppercase(t = Vr.uppercase) {
    return this.transform((n) => Ic(n) ? n : n.toUpperCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (n) => Ic(n) || n === n.toUpperCase()
    });
  }
}
Q5e.prototype = TH.prototype;
let eIe = /* @__PURE__ */ new Date(""), tIe = (e) => Object.prototype.toString.call(e) === "[object Date]";
class Cy extends fa {
  constructor() {
    super({
      type: "date",
      check(t) {
        return tIe(t) && !isNaN(t.getTime());
      }
    }), this.withMutation(() => {
      this.transform((t, n, r) => !r.spec.coerce || r.isType(t) || t === null ? t : (t = U5e(t), isNaN(t) ? Cy.INVALID_DATE : new Date(t)));
    });
  }
  prepareParam(t, n) {
    let r;
    if (fl.isRef(t))
      r = t;
    else {
      let o = this.cast(t);
      if (!this._typeCheck(o)) throw new TypeError(`\`${n}\` must be a Date or a value that can be \`cast()\` to a Date`);
      r = o;
    }
    return r;
  }
  min(t, n = UC.min) {
    let r = this.prepareParam(t, "min");
    return this.test({
      message: n,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      skipAbsent: !0,
      test(o) {
        return o >= this.resolve(r);
      }
    });
  }
  max(t, n = UC.max) {
    let r = this.prepareParam(t, "max");
    return this.test({
      message: n,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      skipAbsent: !0,
      test(o) {
        return o <= this.resolve(r);
      }
    });
  }
}
Cy.INVALID_DATE = eIe;
Cy.prototype;
function nIe(e, t = []) {
  let n = [], r = /* @__PURE__ */ new Set(), o = new Set(t.map(([a, c]) => `${a}-${c}`));
  function i(a, c) {
    let l = qc.split(a)[0];
    r.add(l), o.has(`${c}-${l}`) || n.push([c, l]);
  }
  for (const a of Object.keys(e)) {
    let c = e[a];
    r.add(a), fl.isRef(c) && c.isSibling ? i(c.path, a) : Sy(c) && "deps" in c && c.deps.forEach((l) => i(l, a));
  }
  return k5e.array(Array.from(r), n).reverse();
}
function q8(e, t) {
  let n = 1 / 0;
  return e.some((r, o) => {
    var i;
    if ((i = t.path) != null && i.includes(r))
      return n = o, !0;
  }), n;
}
function EH(e) {
  return (t, n) => q8(e, t) - q8(e, n);
}
const rIe = (e, t, n) => {
  if (typeof e != "string")
    return e;
  let r = e;
  try {
    r = JSON.parse(e);
  } catch {
  }
  return n.isType(r) ? r : e;
};
function wg(e) {
  if ("fields" in e) {
    const t = {};
    for (const [n, r] of Object.entries(e.fields))
      t[n] = wg(r);
    return e.setFields(t);
  }
  if (e.type === "array") {
    const t = e.optional();
    return t.innerType && (t.innerType = wg(t.innerType)), t;
  }
  return e.type === "tuple" ? e.optional().clone({
    types: e.spec.types.map(wg)
  }) : "optional" in e ? e.optional() : e;
}
const oIe = (e, t) => {
  const n = [...qc.normalizePath(t)];
  if (n.length === 1) return n[0] in e;
  let r = n.pop(), o = qc.getter(qc.join(n), !0)(e);
  return !!(o && r in o);
};
let U8 = (e) => Object.prototype.toString.call(e) === "[object Object]";
function W8(e, t) {
  let n = Object.keys(e.fields);
  return Object.keys(t).filter((r) => n.indexOf(r) === -1);
}
const iIe = EH([]);
function aIe(e) {
  return new _H(e);
}
class _H extends fa {
  constructor(t) {
    super({
      type: "object",
      check(n) {
        return U8(n) || typeof n == "function";
      }
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = iIe, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      t && this.shape(t);
    });
  }
  _cast(t, n = {}) {
    var r;
    let o = super._cast(t, n);
    if (o === void 0) return this.getDefault(n);
    if (!this._typeCheck(o)) return o;
    let i = this.fields, a = (r = n.stripUnknown) != null ? r : this.spec.noUnknown, c = [].concat(this._nodes, Object.keys(o).filter((f) => !this._nodes.includes(f))), l = {}, u = Object.assign({}, n, {
      parent: l,
      __validating: n.__validating || !1
    }), d = !1;
    for (const f of c) {
      let h = i[f], v = f in o;
      if (h) {
        let y, g = o[f];
        u.path = (n.path ? `${n.path}.` : "") + f, h = h.resolve({
          value: g,
          context: n.context,
          parent: l
        });
        let b = h instanceof fa ? h.spec : void 0, x = b == null ? void 0 : b.strict;
        if (b != null && b.strip) {
          d = d || f in o;
          continue;
        }
        y = !n.__validating || !x ? (
          // TODO: use _cast, this is double resolving
          h.cast(o[f], u)
        ) : o[f], y !== void 0 && (l[f] = y);
      } else v && !a && (l[f] = o[f]);
      (v !== f in l || l[f] !== o[f]) && (d = !0);
    }
    return d ? l : o;
  }
  _validate(t, n = {}, r, o) {
    let {
      from: i = [],
      originalValue: a = t,
      recursive: c = this.spec.recursive
    } = n;
    n.from = [{
      schema: this,
      value: a
    }, ...i], n.__validating = !0, n.originalValue = a, super._validate(t, n, r, (l, u) => {
      if (!c || !U8(u)) {
        o(l, u);
        return;
      }
      a = a || u;
      let d = [];
      for (let f of this._nodes) {
        let h = this.fields[f];
        !h || fl.isRef(h) || d.push(h.asNestedTest({
          options: n,
          key: f,
          parent: u,
          parentPath: n.path,
          originalParent: a
        }));
      }
      this.runTests({
        tests: d,
        value: u,
        originalValue: a,
        options: n
      }, r, (f) => {
        o(f.sort(this._sortErrors).concat(l), u);
      });
    });
  }
  clone(t) {
    const n = super.clone(t);
    return n.fields = Object.assign({}, this.fields), n._nodes = this._nodes, n._excludedEdges = this._excludedEdges, n._sortErrors = this._sortErrors, n;
  }
  concat(t) {
    let n = super.concat(t), r = n.fields;
    for (let [o, i] of Object.entries(this.fields)) {
      const a = r[o];
      r[o] = a === void 0 ? i : a;
    }
    return n.withMutation((o) => (
      // XXX: excludes here is wrong
      o.setFields(r, [...this._excludedEdges, ...t._excludedEdges])
    ));
  }
  _getDefault(t) {
    if ("default" in this.spec)
      return super._getDefault(t);
    if (!this._nodes.length)
      return;
    let n = {};
    return this._nodes.forEach((r) => {
      var o;
      const i = this.fields[r];
      let a = t;
      (o = a) != null && o.value && (a = Object.assign({}, a, {
        parent: a.value,
        value: a.value[r]
      })), n[r] = i && "getDefault" in i ? i.getDefault(a) : void 0;
    }), n;
  }
  setFields(t, n) {
    let r = this.clone();
    return r.fields = t, r._nodes = nIe(t, n), r._sortErrors = EH(Object.keys(t)), n && (r._excludedEdges = n), r;
  }
  shape(t, n = []) {
    return this.clone().withMutation((r) => {
      let o = r._excludedEdges;
      return n.length && (Array.isArray(n[0]) || (n = [n]), o = [...r._excludedEdges, ...n]), r.setFields(Object.assign(r.fields, t), o);
    });
  }
  partial() {
    const t = {};
    for (const [n, r] of Object.entries(this.fields))
      t[n] = "optional" in r && r.optional instanceof Function ? r.optional() : r;
    return this.setFields(t);
  }
  deepPartial() {
    return wg(this);
  }
  pick(t) {
    const n = {};
    for (const r of t)
      this.fields[r] && (n[r] = this.fields[r]);
    return this.setFields(n, this._excludedEdges.filter(([r, o]) => t.includes(r) && t.includes(o)));
  }
  omit(t) {
    const n = [];
    for (const r of Object.keys(this.fields))
      t.includes(r) || n.push(r);
    return this.pick(n);
  }
  from(t, n, r) {
    let o = qc.getter(t, !0);
    return this.transform((i) => {
      if (!i) return i;
      let a = i;
      return oIe(i, t) && (a = Object.assign({}, i), r || delete a[t], a[n] = o(i)), a;
    });
  }
  /** Parse an input JSON string to an object */
  json() {
    return this.transform(rIe);
  }
  /**
   * Similar to `noUnknown` but only validates that an object is the right shape without stripping the unknown keys
   */
  exact(t) {
    return this.test({
      name: "exact",
      exclusive: !0,
      message: t || xg.exact,
      test(n) {
        if (n == null) return !0;
        const r = W8(this.schema, n);
        return r.length === 0 || this.createError({
          params: {
            properties: r.join(", ")
          }
        });
      }
    });
  }
  stripUnknown() {
    return this.clone({
      noUnknown: !0
    });
  }
  noUnknown(t = !0, n = xg.noUnknown) {
    typeof t != "boolean" && (n = t, t = !0);
    let r = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: n,
      test(o) {
        if (o == null) return !0;
        const i = W8(this.schema, o);
        return !t || i.length === 0 || this.createError({
          params: {
            unknown: i.join(", ")
          }
        });
      }
    });
    return r.spec.noUnknown = t, r;
  }
  unknown(t = !0, n = xg.noUnknown) {
    return this.noUnknown(!t, n);
  }
  transformKeys(t) {
    return this.transform((n) => {
      if (!n) return n;
      const r = {};
      for (const o of Object.keys(n)) r[t(o)] = n[o];
      return r;
    });
  }
  camelCase() {
    return this.transformKeys(FO.camelCase);
  }
  snakeCase() {
    return this.transformKeys(FO.snakeCase);
  }
  constantCase() {
    return this.transformKeys((t) => FO.snakeCase(t).toUpperCase());
  }
  describe(t) {
    const n = (t ? this.resolve(t) : this).clone(), r = super.describe(t);
    r.fields = {};
    for (const [i, a] of Object.entries(n.fields)) {
      var o;
      let c = t;
      (o = c) != null && o.value && (c = Object.assign({}, c, {
        parent: c.value,
        value: c.value[i]
      })), r.fields[i] = a.describe(c);
    }
    return r;
  }
}
aIe.prototype = _H.prototype;
function D9e(e) {
  return new X3(e);
}
function H8(e) {
  try {
    return e();
  } catch (t) {
    if (Rr.isError(t)) return Promise.reject(t);
    throw t;
  }
}
class X3 {
  constructor(t) {
    this.type = "lazy", this.__isYupSchema__ = !0, this.spec = void 0, this._resolve = (n, r = {}) => {
      let o = this.builder(n, r);
      if (!Sy(o)) throw new TypeError("lazy() functions must return a valid schema");
      return this.spec.optional && (o = o.optional()), o.resolve(r);
    }, this.builder = t, this.spec = {
      meta: void 0,
      optional: !1
    };
  }
  clone(t) {
    const n = new X3(this.builder);
    return n.spec = Object.assign({}, this.spec, t), n;
  }
  optionality(t) {
    return this.clone({
      optional: t
    });
  }
  optional() {
    return this.optionality(!0);
  }
  resolve(t) {
    return this._resolve(t.value, t);
  }
  cast(t, n) {
    return this._resolve(t, n).cast(t, n);
  }
  asNestedTest(t) {
    let {
      key: n,
      index: r,
      parent: o,
      options: i
    } = t, a = o[r ?? n];
    return this._resolve(a, Object.assign({}, i, {
      value: a,
      parent: o
    })).asNestedTest(t);
  }
  validate(t, n) {
    return H8(() => this._resolve(t, n).validate(t, n));
  }
  validateSync(t, n) {
    return this._resolve(t, n).validateSync(t, n);
  }
  validateAt(t, n, r) {
    return H8(() => this._resolve(n, r).validateAt(t, n, r));
  }
  validateSyncAt(t, n, r) {
    return this._resolve(n, r).validateSyncAt(t, n, r);
  }
  isValid(t, n) {
    try {
      return this._resolve(t, n).isValid(t, n);
    } catch (r) {
      if (Rr.isError(r))
        return Promise.resolve(!1);
      throw r;
    }
  }
  isValidSync(t, n) {
    return this._resolve(t, n).isValidSync(t, n);
  }
  describe(t) {
    return t ? this.resolve(t).describe(t) : {
      type: "lazy",
      meta: this.spec.meta,
      label: void 0
    };
  }
  meta(...t) {
    if (t.length === 0) return this.spec.meta;
    let n = this.clone();
    return n.spec.meta = Object.assign(n.spec.meta || {}, t[0]), n;
  }
}
export {
  g9e as $,
  a9e as A,
  use as B,
  Wse as C,
  FIe as D,
  bv as E,
  ZIe as F,
  $L as G,
  BIe as H,
  xT as I,
  UT as J,
  p9e as K,
  c0e as L,
  h9e as M,
  Bj as N,
  ig as O,
  ihe as P,
  qj as Q,
  Ile as R,
  gue as S,
  TIe as T,
  Wj as U,
  og as V,
  ome as W,
  nbe as X,
  ebe as Y,
  iF as Z,
  Txe as _,
  EIe as a,
  LIe as a$,
  v9e as a0,
  ZS as a1,
  _p as a2,
  XL as a3,
  dS as a4,
  qae as a5,
  que as a6,
  b9e as a7,
  Zce as a8,
  xce as a9,
  r9e as aA,
  QIe as aB,
  KIe as aC,
  HIe as aD,
  YIe as aE,
  VIe as aF,
  GIe as aG,
  WIe as aH,
  T9e as aI,
  BL as aJ,
  oa as aK,
  E9e as aL,
  nl as aM,
  xv as aN,
  DIe as aO,
  eme as aP,
  jIe as aQ,
  qT as aR,
  Vc as aS,
  zIe as aT,
  Xpe as aU,
  _9e as aV,
  P4e as aW,
  X4e as aX,
  k9e as aY,
  R9e as aZ,
  hr as a_,
  lS as aa,
  Kle as ab,
  x9e as ac,
  Lue as ad,
  vj as ae,
  xue as af,
  w9e as ag,
  $9e as ah,
  Tp as ai,
  OIe as aj,
  O9e as ak,
  S9e as al,
  C9e as am,
  oj as an,
  IT as ao,
  fle as ap,
  mue as aq,
  aj as ar,
  Qc as as,
  t9e as at,
  JIe as au,
  XIe as av,
  n9e as aw,
  e9e as ax,
  o9e as ay,
  i9e as az,
  jse as b,
  P9e as b0,
  I9e as b1,
  A9e as b2,
  M9e as b3,
  cme as b4,
  sme as b5,
  ime as b6,
  AIe as b7,
  N9e as b8,
  sS as b9,
  Rr as ba,
  aIe as bb,
  Q5e as bc,
  D9e as bd,
  m9e as be,
  $Ie as bf,
  AQ as bg,
  wIe as bh,
  PIe as bi,
  kIe as bj,
  IIe as bk,
  QL as bl,
  RIe as bm,
  mT as c,
  Jm as d,
  gse as e,
  c9e as f,
  Rse as g,
  LL as h,
  Xae as i,
  F as j,
  UIe as k,
  s9e as l,
  MIe as m,
  sse as n,
  l9e as o,
  Xj as p,
  u9e as q,
  d9e as r,
  qIe as s,
  Yfe as t,
  Fr as u,
  f9e as v,
  oF as w,
  nhe as x,
  ohe as y,
  zp as z
};
